
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire121f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire121f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jWQW9"));

});
parcelRegister("jWQW9", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e85c7f443c64506d$export$ffb0004e005737fa, (v) => $e85c7f443c64506d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $e85c7f443c64506d$export$5f8d39834fd61797, (v) => $e85c7f443c64506d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $e85c7f443c64506d$export$e2c29f18771995cb, (v) => $e85c7f443c64506d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $e85c7f443c64506d$export$74bf444e3cd11ea5, (v) => $e85c7f443c64506d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $e85c7f443c64506d$export$dca3b0875bd9a954, (v) => $e85c7f443c64506d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $e85c7f443c64506d$export$16fa2f45be04daa8, (v) => $e85c7f443c64506d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $e85c7f443c64506d$export$221d75b3f55bb0bd, (v) => $e85c7f443c64506d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $e85c7f443c64506d$export$ae55be85d98224ed, (v) => $e85c7f443c64506d$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $e85c7f443c64506d$export$e530037191fcd5d7, (v) => $e85c7f443c64506d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $e85c7f443c64506d$export$fd42f52fd3ae1109, (v) => $e85c7f443c64506d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $e85c7f443c64506d$export$c8a8987d4410bf2d, (v) => $e85c7f443c64506d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $e85c7f443c64506d$export$d38cd72104c1f0e9, (v) => $e85c7f443c64506d$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $e85c7f443c64506d$export$7d1e3a5e95ceca43, (v) => $e85c7f443c64506d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $e85c7f443c64506d$export$257a8862b851cb5b, (v) => $e85c7f443c64506d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $e85c7f443c64506d$export$a8257692ac88316c, (v) => $e85c7f443c64506d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $e85c7f443c64506d$export$488013bae63b21da, (v) => $e85c7f443c64506d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $e85c7f443c64506d$export$7c73462e0d25e514, (v) => $e85c7f443c64506d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $e85c7f443c64506d$export$35808ee640e87ca7, (v) => $e85c7f443c64506d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $e85c7f443c64506d$export$fae74005e78b1a27, (v) => $e85c7f443c64506d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $e85c7f443c64506d$export$dc8fbce3eb94dc1e, (v) => $e85c7f443c64506d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $e85c7f443c64506d$export$6d9c69b0de29b591, (v) => $e85c7f443c64506d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $e85c7f443c64506d$export$d5a552a76deda3c2, (v) => $e85c7f443c64506d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $e85c7f443c64506d$export$e5c5a5f917a5871c, (v) => $e85c7f443c64506d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $e85c7f443c64506d$export$1538c33de8887b59, (v) => $e85c7f443c64506d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $e85c7f443c64506d$export$13e3392192263954, (v) => $e85c7f443c64506d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $e85c7f443c64506d$export$b8f5890fc79d6aca, (v) => $e85c7f443c64506d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $e85c7f443c64506d$export$60241385465d0a34, (v) => $e85c7f443c64506d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $e85c7f443c64506d$export$83d89fbfd8236492, (v) => $e85c7f443c64506d$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e85c7f443c64506d$export$ffb0004e005737fa;
var $e85c7f443c64506d$export$5f8d39834fd61797;
var $e85c7f443c64506d$export$e2c29f18771995cb;
var $e85c7f443c64506d$export$74bf444e3cd11ea5;
var $e85c7f443c64506d$export$dca3b0875bd9a954;
var $e85c7f443c64506d$export$16fa2f45be04daa8;
var $e85c7f443c64506d$export$221d75b3f55bb0bd;
var $e85c7f443c64506d$export$ae55be85d98224ed;
var $e85c7f443c64506d$export$e530037191fcd5d7;
var $e85c7f443c64506d$export$fd42f52fd3ae1109;
var $e85c7f443c64506d$export$c8a8987d4410bf2d;
var $e85c7f443c64506d$export$d38cd72104c1f0e9;
var $e85c7f443c64506d$export$7d1e3a5e95ceca43;
var $e85c7f443c64506d$export$257a8862b851cb5b;
var $e85c7f443c64506d$export$a8257692ac88316c;
var $e85c7f443c64506d$export$488013bae63b21da;
var $e85c7f443c64506d$export$7c73462e0d25e514;
var $e85c7f443c64506d$export$35808ee640e87ca7;
var $e85c7f443c64506d$export$fae74005e78b1a27;
var $e85c7f443c64506d$export$dc8fbce3eb94dc1e;
var $e85c7f443c64506d$export$6d9c69b0de29b591;
var $e85c7f443c64506d$export$d5a552a76deda3c2;
var $e85c7f443c64506d$export$e5c5a5f917a5871c;
var $e85c7f443c64506d$export$1538c33de8887b59;
var $e85c7f443c64506d$export$13e3392192263954;
var $e85c7f443c64506d$export$b8f5890fc79d6aca;
var $e85c7f443c64506d$export$60241385465d0a34;
var $e85c7f443c64506d$export$83d89fbfd8236492;
'use strict';

(function() {
    'use strict';
    var _assign = (parcelRequire("8coUR"));
    // TODO: this is special because it gets imported during build.
    var ReactVersion = '17.0.2';
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    $e85c7f443c64506d$export$ffb0004e005737fa = 0xeacb;
    $e85c7f443c64506d$export$5f8d39834fd61797 = 0xeacc;
    $e85c7f443c64506d$export$e2c29f18771995cb = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    $e85c7f443c64506d$export$74bf444e3cd11ea5 = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        $e85c7f443c64506d$export$ffb0004e005737fa = symbolFor('react.fragment');
        $e85c7f443c64506d$export$5f8d39834fd61797 = symbolFor('react.strict_mode');
        $e85c7f443c64506d$export$e2c29f18771995cb = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        $e85c7f443c64506d$export$74bf444e3cd11ea5 = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: 0
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ''; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || '';
        return stack;
    };
    /**
 * Used by act() to track whether you're inside an act() scope.
 */ var IsSomeRendererActing = {
        current: false
    };
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner,
        IsSomeRendererActing: IsSomeRendererActing,
        // Used by renderers to avoid bundling object-assign twice in UMD bundles:
        assign: _assign
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, 'forceUpdate');
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, 'replaceState');
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, 'setState');
        }
    };
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, 'setState');
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
    };
    var deprecatedAPIs = {
        isMounted: [
            'isMounted',
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            'replaceState',
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    _assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case $e85c7f443c64506d$export$ffb0004e005737fa:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case $e85c7f443c64506d$export$e2c29f18771995cb:
                return 'Profiler';
            case $e85c7f443c64506d$export$5f8d39834fd61797:
                return 'StrictMode';
            case $e85c7f443c64506d$export$74bf444e3cd11ea5:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, 'ref')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, 'key')) {
            var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, 'key', {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, 'ref', {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentName(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, 'validated', {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, '_self', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, '_source', {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) key = '' + config.key;
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (!!(element === null || element === undefined)) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = _assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) key = '' + config.key;
             // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = '.';
    var SUBSEPARATOR = ':';
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            '=': '=0',
            ':': '=2'
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return '$' + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, '$&/');
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === 'object' && element !== null && element.key != null) // Explicit key
        return escape('' + element.key);
         // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === 'undefined' || type === 'boolean') // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case 'string':
            case 'number':
                invokeCallback = true;
                break;
            case 'object':
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (Array.isArray(mappedChild)) {
                var escapedChildKey = '';
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + '/';
                mapIntoArray(mappedChild, array, escapedChildKey, '', function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === 'function') {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === 'object') {
                var childrenString = '' + children;
                throw Error("Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, '', '', function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue, calculateChangedBits) {
        if (calculateChangedBits === undefined) calculateChangedBits = null;
        else if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') error("createContext: Expected the optional second argument to be a function. Instead received: %s", calculateChangedBits);
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            _calculateChangedBits: calculateChangedBits,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context,
            _calculateChangedBits: context._calculateChangedBits
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            var pending = payload;
            pending._status = Pending;
            pending._result = thenable;
            thenable.then(function(moduleObject) {
                if (payload._status === Pending) {
                    var defaultExport = moduleObject.default;
                    if (defaultExport === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = defaultExport;
                }
            }, function(error) {
                if (payload._status === Pending) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
        }
        if (payload._status === Resolved) return payload._result;
        else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: -1,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'defaultProps', {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, 'propTypes', {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== 'function') error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
        else if (render.length !== 0 && render.length !== 2) error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (render.displayName == null) render.displayName = name;
            }
        });
        return elementType;
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    function isValidElementType(type) {
        if (typeof type === 'string' || typeof type === 'function') return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === $e85c7f443c64506d$export$ffb0004e005737fa || type === $e85c7f443c64506d$export$e2c29f18771995cb || type === REACT_DEBUG_TRACING_MODE_TYPE || type === $e85c7f443c64506d$export$5f8d39834fd61797 || type === $e85c7f443c64506d$export$74bf444e3cd11ea5 || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) return true;
        if (typeof type === 'object' && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? 'null' : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, 'displayName', {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name;
                if (type.displayName == null) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (!(dispatcher !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        return dispatcher;
    }
    function useContext(Context, unstable_observedBits) {
        var dispatcher = resolveDispatcher();
        if (unstable_observedBits !== undefined) error("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? "\n\nDid you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks" : '');
         // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context, unstable_observedBits);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case $e85c7f443c64506d$export$74bf444e3cd11ea5:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentName(ReactCurrentOwner.current.type);
            if (name) return '\n\nCheck the render method of `' + name + '`.';
        }
        return '';
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, '');
            var lineNumber = source.lineNumber;
            return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
        }
        return '';
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return '';
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = '';
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== 'object') return;
        if (Array.isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === 'function') // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === 'string') return;
        var propTypes;
        if (typeof type === 'function') propTypes = type.propTypes;
        else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentName(type);
            checkPropTypes(propTypes, element.props, 'prop', name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentName(type);
            error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
        }
        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== 'children' && key !== 'key') {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error('Invalid attribute `ref` supplied to `React.Fragment`.');
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = '';
            if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = 'null';
            else if (Array.isArray(type)) typeString = 'array';
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
                info = ' Did you accidentally export a JSX literal instead of a component?';
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === $e85c7f443c64506d$export$ffb0004e005737fa) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, 'type', {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, 'type', {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    try {
        var frozenObject = Object.freeze({});
        /* eslint-disable no-new */ new Map([
            [
                frozenObject,
                null
            ]
        ]);
        new Set([
            frozenObject
        ]);
    /* eslint-enable no-new */ } catch (e) {}
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    $e85c7f443c64506d$export$dca3b0875bd9a954 = Children;
    $e85c7f443c64506d$export$16fa2f45be04daa8 = Component;
    $e85c7f443c64506d$export$221d75b3f55bb0bd = PureComponent;
    $e85c7f443c64506d$export$ae55be85d98224ed = ReactSharedInternals;
    $e85c7f443c64506d$export$e530037191fcd5d7 = cloneElement$1;
    $e85c7f443c64506d$export$fd42f52fd3ae1109 = createContext;
    $e85c7f443c64506d$export$c8a8987d4410bf2d = createElement$1;
    $e85c7f443c64506d$export$d38cd72104c1f0e9 = createFactory;
    $e85c7f443c64506d$export$7d1e3a5e95ceca43 = createRef;
    $e85c7f443c64506d$export$257a8862b851cb5b = forwardRef;
    $e85c7f443c64506d$export$a8257692ac88316c = isValidElement;
    $e85c7f443c64506d$export$488013bae63b21da = lazy;
    $e85c7f443c64506d$export$7c73462e0d25e514 = memo;
    $e85c7f443c64506d$export$35808ee640e87ca7 = useCallback;
    $e85c7f443c64506d$export$fae74005e78b1a27 = useContext;
    $e85c7f443c64506d$export$dc8fbce3eb94dc1e = useDebugValue;
    $e85c7f443c64506d$export$6d9c69b0de29b591 = useEffect;
    $e85c7f443c64506d$export$d5a552a76deda3c2 = useImperativeHandle;
    $e85c7f443c64506d$export$e5c5a5f917a5871c = useLayoutEffect;
    $e85c7f443c64506d$export$1538c33de8887b59 = useMemo;
    $e85c7f443c64506d$export$13e3392192263954 = useReducer;
    $e85c7f443c64506d$export$b8f5890fc79d6aca = useRef;
    $e85c7f443c64506d$export$60241385465d0a34 = useState;
    $e85c7f443c64506d$export$83d89fbfd8236492 = ReactVersion;
})();

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRegister("ipi6j", function(module, exports) {
module.exports = $parcel$import("8WL3B").then(()=>parcelRequire('aDaS8'));

});

parcelRegister("N7Lcz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
var $093a98c17cb6b6b8$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $093a98c17cb6b6b8$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$093a98c17cb6b6b8$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($093a98c17cb6b6b8$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($093a98c17cb6b6b8$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($093a98c17cb6b6b8$var$isNull(x) || !$093a98c17cb6b6b8$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $093a98c17cb6b6b8$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($hPtJY.throwDeprecation) throw new Error(msg);
            else if ($hPtJY.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $093a98c17cb6b6b8$var$debugs = {};
var $093a98c17cb6b6b8$var$debugEnvRegex = /^$/;
var $093a98c17cb6b6b8$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$093a98c17cb6b6b8$var$debugs[set]) {
        if ($093a98c17cb6b6b8$var$debugEnvRegex.test(set)) {
            var pid = $hPtJY.pid;
            $093a98c17cb6b6b8$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $093a98c17cb6b6b8$var$debugs[set] = function() {};
    }
    return $093a98c17cb6b6b8$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $093a98c17cb6b6b8$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $093a98c17cb6b6b8$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($093a98c17cb6b6b8$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($093a98c17cb6b6b8$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $093a98c17cb6b6b8$var$stylizeWithColor;
    return $093a98c17cb6b6b8$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $093a98c17cb6b6b8$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$093a98c17cb6b6b8$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$093a98c17cb6b6b8$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $093a98c17cb6b6b8$var$stylizeWithColor(str, styleType) {
    var style = $093a98c17cb6b6b8$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $093a98c17cb6b6b8$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $093a98c17cb6b6b8$var$stylizeNoColor(str, styleType) {
    return str;
}
function $093a98c17cb6b6b8$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $093a98c17cb6b6b8$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $093a98c17cb6b6b8$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$093a98c17cb6b6b8$var$isString(ret)) ret = $093a98c17cb6b6b8$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $093a98c17cb6b6b8$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $093a98c17cb6b6b8$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($093a98c17cb6b6b8$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $093a98c17cb6b6b8$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($093a98c17cb6b6b8$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($093a98c17cb6b6b8$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($093a98c17cb6b6b8$var$isError(value)) return $093a98c17cb6b6b8$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($093a98c17cb6b6b8$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($093a98c17cb6b6b8$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($093a98c17cb6b6b8$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($093a98c17cb6b6b8$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($093a98c17cb6b6b8$var$isError(value)) base = ' ' + $093a98c17cb6b6b8$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($093a98c17cb6b6b8$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces);
}
function $093a98c17cb6b6b8$var$formatPrimitive(ctx, value) {
    if ($093a98c17cb6b6b8$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($093a98c17cb6b6b8$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($093a98c17cb6b6b8$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($093a98c17cb6b6b8$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($093a98c17cb6b6b8$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $093a98c17cb6b6b8$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $093a98c17cb6b6b8$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($093a98c17cb6b6b8$var$hasOwnProperty(value, String(i))) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $093a98c17cb6b6b8$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$093a98c17cb6b6b8$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($093a98c17cb6b6b8$var$isNull(recurseTimes)) str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, null);
            else str = $093a98c17cb6b6b8$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($093a98c17cb6b6b8$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $093a98c17cb6b6b8$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("7He6T"));
function $093a98c17cb6b6b8$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $093a98c17cb6b6b8$var$isArray;
function $093a98c17cb6b6b8$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $093a98c17cb6b6b8$var$isBoolean;
function $093a98c17cb6b6b8$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $093a98c17cb6b6b8$var$isNull;
function $093a98c17cb6b6b8$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $093a98c17cb6b6b8$var$isNullOrUndefined;
function $093a98c17cb6b6b8$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $093a98c17cb6b6b8$var$isNumber;
function $093a98c17cb6b6b8$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $093a98c17cb6b6b8$var$isString;
function $093a98c17cb6b6b8$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $093a98c17cb6b6b8$var$isSymbol;
function $093a98c17cb6b6b8$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $093a98c17cb6b6b8$var$isUndefined;
function $093a98c17cb6b6b8$var$isRegExp(re) {
    return $093a98c17cb6b6b8$var$isObject(re) && $093a98c17cb6b6b8$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
module.exports.types.isRegExp = $093a98c17cb6b6b8$var$isRegExp;
function $093a98c17cb6b6b8$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $093a98c17cb6b6b8$var$isObject;
function $093a98c17cb6b6b8$var$isDate(d) {
    return $093a98c17cb6b6b8$var$isObject(d) && $093a98c17cb6b6b8$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $093a98c17cb6b6b8$var$isDate;
module.exports.types.isDate = $093a98c17cb6b6b8$var$isDate;
function $093a98c17cb6b6b8$var$isError(e) {
    return $093a98c17cb6b6b8$var$isObject(e) && ($093a98c17cb6b6b8$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $093a98c17cb6b6b8$var$isError;
module.exports.types.isNativeError = $093a98c17cb6b6b8$var$isError;
function $093a98c17cb6b6b8$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $093a98c17cb6b6b8$var$isFunction;
function $093a98c17cb6b6b8$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $093a98c17cb6b6b8$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kotBY"));
function $093a98c17cb6b6b8$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $093a98c17cb6b6b8$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $093a98c17cb6b6b8$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $093a98c17cb6b6b8$var$timestamp() {
    var d = new Date();
    var time = [
        $093a98c17cb6b6b8$var$pad(d.getHours()),
        $093a98c17cb6b6b8$var$pad(d.getMinutes()),
        $093a98c17cb6b6b8$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $093a98c17cb6b6b8$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $093a98c17cb6b6b8$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dlqwk"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$093a98c17cb6b6b8$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $093a98c17cb6b6b8$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol && original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol]) {
        var fn = original[$093a98c17cb6b6b8$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($093a98c17cb6b6b8$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $093a98c17cb6b6b8$var$kCustomPromisifiedSymbol;
function $093a98c17cb6b6b8$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $093a98c17cb6b6b8$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $hPtJY.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $hPtJY.nextTick($093a98c17cb6b6b8$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $093a98c17cb6b6b8$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $093a98c17cb6b6b8$var$callbackify;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("7He6T", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $f4HGZ = parcelRequire("f4HGZ");

var $5WnCa = parcelRequire("5WnCa");

var $gJrpv = parcelRequire("gJrpv");

var $hN833 = parcelRequire("hN833");
function $59a77e8886024a57$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $59a77e8886024a57$var$BigIntSupported = typeof BigInt !== 'undefined';
var $59a77e8886024a57$var$SymbolSupported = typeof Symbol !== 'undefined';
var $59a77e8886024a57$var$ObjectToString = $59a77e8886024a57$var$uncurryThis(Object.prototype.toString);
var $59a77e8886024a57$var$numberValue = $59a77e8886024a57$var$uncurryThis(Number.prototype.valueOf);
var $59a77e8886024a57$var$stringValue = $59a77e8886024a57$var$uncurryThis(String.prototype.valueOf);
var $59a77e8886024a57$var$booleanValue = $59a77e8886024a57$var$uncurryThis(Boolean.prototype.valueOf);
if ($59a77e8886024a57$var$BigIntSupported) var $59a77e8886024a57$var$bigIntValue = $59a77e8886024a57$var$uncurryThis(BigInt.prototype.valueOf);
if ($59a77e8886024a57$var$SymbolSupported) var $59a77e8886024a57$var$symbolValue = $59a77e8886024a57$var$uncurryThis(Symbol.prototype.valueOf);
function $59a77e8886024a57$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $f4HGZ;
module.exports.isGeneratorFunction = $5WnCa;
module.exports.isTypedArray = $hN833;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $59a77e8886024a57$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $59a77e8886024a57$var$isPromise;
function $59a77e8886024a57$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $hN833(value) || $59a77e8886024a57$var$isDataView(value);
}
module.exports.isArrayBufferView = $59a77e8886024a57$var$isArrayBufferView;
function $59a77e8886024a57$var$isUint8Array(value) {
    return $gJrpv(value) === 'Uint8Array';
}
module.exports.isUint8Array = $59a77e8886024a57$var$isUint8Array;
function $59a77e8886024a57$var$isUint8ClampedArray(value) {
    return $gJrpv(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $59a77e8886024a57$var$isUint8ClampedArray;
function $59a77e8886024a57$var$isUint16Array(value) {
    return $gJrpv(value) === 'Uint16Array';
}
module.exports.isUint16Array = $59a77e8886024a57$var$isUint16Array;
function $59a77e8886024a57$var$isUint32Array(value) {
    return $gJrpv(value) === 'Uint32Array';
}
module.exports.isUint32Array = $59a77e8886024a57$var$isUint32Array;
function $59a77e8886024a57$var$isInt8Array(value) {
    return $gJrpv(value) === 'Int8Array';
}
module.exports.isInt8Array = $59a77e8886024a57$var$isInt8Array;
function $59a77e8886024a57$var$isInt16Array(value) {
    return $gJrpv(value) === 'Int16Array';
}
module.exports.isInt16Array = $59a77e8886024a57$var$isInt16Array;
function $59a77e8886024a57$var$isInt32Array(value) {
    return $gJrpv(value) === 'Int32Array';
}
module.exports.isInt32Array = $59a77e8886024a57$var$isInt32Array;
function $59a77e8886024a57$var$isFloat32Array(value) {
    return $gJrpv(value) === 'Float32Array';
}
module.exports.isFloat32Array = $59a77e8886024a57$var$isFloat32Array;
function $59a77e8886024a57$var$isFloat64Array(value) {
    return $gJrpv(value) === 'Float64Array';
}
module.exports.isFloat64Array = $59a77e8886024a57$var$isFloat64Array;
function $59a77e8886024a57$var$isBigInt64Array(value) {
    return $gJrpv(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $59a77e8886024a57$var$isBigInt64Array;
function $59a77e8886024a57$var$isBigUint64Array(value) {
    return $gJrpv(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $59a77e8886024a57$var$isBigUint64Array;
function $59a77e8886024a57$var$isMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map]';
}
$59a77e8886024a57$var$isMapToString.working = typeof Map !== 'undefined' && $59a77e8886024a57$var$isMapToString(new Map());
function $59a77e8886024a57$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $59a77e8886024a57$var$isMapToString.working ? $59a77e8886024a57$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $59a77e8886024a57$var$isMap;
function $59a77e8886024a57$var$isSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set]';
}
$59a77e8886024a57$var$isSetToString.working = typeof Set !== 'undefined' && $59a77e8886024a57$var$isSetToString(new Set());
function $59a77e8886024a57$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $59a77e8886024a57$var$isSetToString.working ? $59a77e8886024a57$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $59a77e8886024a57$var$isSet;
function $59a77e8886024a57$var$isWeakMapToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakMap]';
}
$59a77e8886024a57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $59a77e8886024a57$var$isWeakMapToString(new WeakMap());
function $59a77e8886024a57$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $59a77e8886024a57$var$isWeakMapToString.working ? $59a77e8886024a57$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $59a77e8886024a57$var$isWeakMap;
function $59a77e8886024a57$var$isWeakSetToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WeakSet]';
}
$59a77e8886024a57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $59a77e8886024a57$var$isWeakSetToString(new WeakSet());
function $59a77e8886024a57$var$isWeakSet(value) {
    return $59a77e8886024a57$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $59a77e8886024a57$var$isWeakSet;
function $59a77e8886024a57$var$isArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$59a77e8886024a57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $59a77e8886024a57$var$isArrayBufferToString(new ArrayBuffer());
function $59a77e8886024a57$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $59a77e8886024a57$var$isArrayBufferToString.working ? $59a77e8886024a57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $59a77e8886024a57$var$isArrayBuffer;
function $59a77e8886024a57$var$isDataViewToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object DataView]';
}
$59a77e8886024a57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $59a77e8886024a57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $59a77e8886024a57$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $59a77e8886024a57$var$isDataViewToString.working ? $59a77e8886024a57$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $59a77e8886024a57$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $59a77e8886024a57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $59a77e8886024a57$var$isSharedArrayBufferToString(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $59a77e8886024a57$var$isSharedArrayBuffer(value) {
    if (typeof $59a77e8886024a57$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $59a77e8886024a57$var$isSharedArrayBufferToString.working === 'undefined') $59a77e8886024a57$var$isSharedArrayBufferToString.working = $59a77e8886024a57$var$isSharedArrayBufferToString(new $59a77e8886024a57$var$SharedArrayBufferCopy());
    return $59a77e8886024a57$var$isSharedArrayBufferToString.working ? $59a77e8886024a57$var$isSharedArrayBufferToString(value) : value instanceof $59a77e8886024a57$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $59a77e8886024a57$var$isSharedArrayBuffer;
function $59a77e8886024a57$var$isAsyncFunction(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $59a77e8886024a57$var$isAsyncFunction;
function $59a77e8886024a57$var$isMapIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $59a77e8886024a57$var$isMapIterator;
function $59a77e8886024a57$var$isSetIterator(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $59a77e8886024a57$var$isSetIterator;
function $59a77e8886024a57$var$isGeneratorObject(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $59a77e8886024a57$var$isGeneratorObject;
function $59a77e8886024a57$var$isWebAssemblyCompiledModule(value) {
    return $59a77e8886024a57$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $59a77e8886024a57$var$isWebAssemblyCompiledModule;
function $59a77e8886024a57$var$isNumberObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$numberValue);
}
module.exports.isNumberObject = $59a77e8886024a57$var$isNumberObject;
function $59a77e8886024a57$var$isStringObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$stringValue);
}
module.exports.isStringObject = $59a77e8886024a57$var$isStringObject;
function $59a77e8886024a57$var$isBooleanObject(value) {
    return $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$booleanValue);
}
module.exports.isBooleanObject = $59a77e8886024a57$var$isBooleanObject;
function $59a77e8886024a57$var$isBigIntObject(value) {
    return $59a77e8886024a57$var$BigIntSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$bigIntValue);
}
module.exports.isBigIntObject = $59a77e8886024a57$var$isBigIntObject;
function $59a77e8886024a57$var$isSymbolObject(value) {
    return $59a77e8886024a57$var$SymbolSupported && $59a77e8886024a57$var$checkBoxedPrimitive(value, $59a77e8886024a57$var$symbolValue);
}
module.exports.isSymbolObject = $59a77e8886024a57$var$isSymbolObject;
function $59a77e8886024a57$var$isBoxedPrimitive(value) {
    return $59a77e8886024a57$var$isNumberObject(value) || $59a77e8886024a57$var$isStringObject(value) || $59a77e8886024a57$var$isBooleanObject(value) || $59a77e8886024a57$var$isBigIntObject(value) || $59a77e8886024a57$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $59a77e8886024a57$var$isBoxedPrimitive;
function $59a77e8886024a57$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($59a77e8886024a57$var$isArrayBuffer(value) || $59a77e8886024a57$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $59a77e8886024a57$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("f4HGZ", function(module, exports) {
'use strict';

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $eW390 = parcelRequire("eW390");
var $af991f1d6c80f097$var$$toString = $eW390('Object.prototype.toString');
/** @type {import('.')} */ var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== '[object Array]' && 'callee' in value && $af991f1d6c80f097$var$$toString(value.callee) === '[object Function]';
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
'use strict';

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eW390", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $jyxCz = parcelRequire("jyxCz");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $adf8ebd7229df60a$var$$indexOf = $jyxCz([
    $1zENl('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $adf8ebd7229df60a$var$$indexOf(name, '.prototype.') > -1) return $jyxCz(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
'use strict';
var $1258b452ecf218a1$var$undefined1;

var $90JBs = parcelRequire("90JBs");

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");

var $bdePV = parcelRequire("bdePV");

var $dK8VM = parcelRequire("dK8VM");

var $7F9c3 = parcelRequire("7F9c3");

var $4l7TM = parcelRequire("4l7TM");

var $brYbP = parcelRequire("brYbP");

var $1rWQg = parcelRequire("1rWQg");

var $4J7z9 = parcelRequire("4J7z9");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $dYOee = parcelRequire("dYOee");

var $jAy3M = parcelRequire("jAy3M");
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $dYOee ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $dYOee(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $3ERI6 = parcelRequire("3ERI6");

var $eim86 = parcelRequire("eim86");

var $TxOUG = parcelRequire("TxOUG");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === 'undefined' || !$3ERI6 ? undefined : $3ERI6(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGenerator%': $1258b452ecf218a1$var$needsEval,
    '%AsyncGeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%AsyncIteratorPrototype%': $1258b452ecf218a1$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $5A49f,
    '%eval%': eval,
    '%EvalError%': $hDtVy,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $1258b452ecf218a1$var$$Function,
    '%GeneratorFunction%': $1258b452ecf218a1$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6($3ERI6([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $90JBs,
    '%Object.getOwnPropertyDescriptor%': $dYOee,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $9RC8m,
    '%ReferenceError%': $2BaZq,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$1258b452ecf218a1$var$hasSymbols || !$3ERI6 ? undefined : $3ERI6(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $1258b452ecf218a1$var$hasSymbols && $3ERI6 ? $3ERI6(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5Ox6r,
    '%ThrowTypeError%': $1258b452ecf218a1$var$ThrowTypeError,
    '%TypedArray%': $1258b452ecf218a1$var$TypedArray,
    '%TypeError%': $eEkyn,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $hFSMY,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9pzbV,
    '%Function.prototype.apply%': $xMvSJ,
    '%Object.defineProperty%': $jAy3M,
    '%Object.getPrototypeOf%': $eim86,
    '%Math.abs%': $bdePV,
    '%Math.floor%': $dK8VM,
    '%Math.max%': $7F9c3,
    '%Math.min%': $4l7TM,
    '%Math.pow%': $brYbP,
    '%Math.round%': $1rWQg,
    '%Math.sign%': $4J7z9,
    '%Reflect.getPrototypeOf%': $TxOUG
};
if ($3ERI6) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $3ERI6($3ERI6(e));
    $1258b452ecf218a1$var$INTRINSICS['%Error.prototype%'] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $1258b452ecf218a1$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3ERI6) value = $3ERI6(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call($9pzbV, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call($xMvSJ, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call($9pzbV, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call($9pzbV, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call($9pzbV, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5Ox6r('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $eEkyn('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $eEkyn('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5Ox6r('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($dYOee && i + 1 >= parts.length) {
                var desc = $dYOee(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("90JBs", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("5A49f", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("bdePV", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("dK8VM", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("7F9c3", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4l7TM", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("brYbP", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("1rWQg", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4J7z9", function(module, exports) {
'use strict';

var $4oiz9 = parcelRequire("4oiz9");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($4oiz9(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("4oiz9", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("dYOee", function(module, exports) {
'use strict';

var $d4L75 = parcelRequire("d4L75");
var $a2d7d74e83f6c3ed$require$$gOPD = $d4L75;
if ($a2d7d74e83f6c3ed$require$$gOPD) try {
    $a2d7d74e83f6c3ed$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$require$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$require$$gOPD;

});
parcelRegister("d4L75", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("jAy3M", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = Object.defineProperty || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("24qIq", function(module, exports) {
'use strict';
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $1820ada193f67aeb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $7YWkK();
};

});

parcelRegister("3ERI6", function(module, exports) {
'use strict';

var $TxOUG = parcelRequire("TxOUG");

var $eim86 = parcelRequire("eim86");

var $7kfw3 = parcelRequire("7kfw3");
/** @type {import('.')} */ module.exports = $TxOUG ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $TxOUG(O);
} : $eim86 ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eim86(O);
} : $7kfw3 ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $7kfw3(O);
} : null;

});
parcelRegister("TxOUG", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("eim86", function(module, exports) {
'use strict';

var $90JBs = parcelRequire("90JBs");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $90JBs.getPrototypeOf || null;

});

parcelRegister("7kfw3", function(module, exports) {
'use strict';

var $jyxCz = parcelRequire("jyxCz");

var $dYOee = parcelRequire("dYOee");
var $55566fcac2c38fe4$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $55566fcac2c38fe4$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $55566fcac2c38fe4$var$desc = !!$55566fcac2c38fe4$var$hasProtoAccessor && $dYOee && $dYOee(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $55566fcac2c38fe4$var$$Object = Object;
var $55566fcac2c38fe4$var$$getPrototypeOf = $55566fcac2c38fe4$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $55566fcac2c38fe4$var$desc && typeof $55566fcac2c38fe4$var$desc.get === 'function' ? $jyxCz([
    $55566fcac2c38fe4$var$desc.get
]) : typeof $55566fcac2c38fe4$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $55566fcac2c38fe4$var$$getPrototypeOf(value == null ? value : $55566fcac2c38fe4$var$$Object(value));
} : false;

});
parcelRegister("jyxCz", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $eEkyn = parcelRequire("eEkyn");

var $9pzbV = parcelRequire("9pzbV");

var $3YvJT = parcelRequire("3YvJT");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $eEkyn('a function is required');
    return $3YvJT($gvair, $9pzbV, args);
};

});
parcelRegister("gvair", function(module, exports) {
'use strict';

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = '[object Function]';
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $efd80b1d7fbb2850$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9pzbV", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("3YvJT", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $9pzbV = parcelRequire("9pzbV");

var $8qWPV = parcelRequire("8qWPV");
/** @type {import('./actualApply')} */ module.exports = $8qWPV || $gvair.call($9pzbV, $xMvSJ);

});
parcelRegister("xMvSJ", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("8qWPV", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("4c4Ky", function(module, exports) {
'use strict';
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});




parcelRegister("5WnCa", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $2xf7f = parcelRequire("2xf7f");
var $4534afe844d627e4$var$isFnRegex = $2xf7f(/^\s*(?:function)?\*/);

var $4534afe844d627e4$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $3ERI6 = parcelRequire("3ERI6");
var $4534afe844d627e4$var$toStr = $eW390('Object.prototype.toString');
var $4534afe844d627e4$var$fnToStr = $eW390('Function.prototype.toString');

var $1xINW = parcelRequire("1xINW");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4534afe844d627e4$var$isFnRegex($4534afe844d627e4$var$fnToStr(fn))) return true;
    if (!$4534afe844d627e4$var$hasToStringTag) {
        var str = $4534afe844d627e4$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$3ERI6) return false;
    var GeneratorFunction = $1xINW();
    return GeneratorFunction && $3ERI6(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("2xf7f", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $l37Ky = parcelRequire("l37Ky");
var $1d8a638ce4bfc95c$var$$exec = $eW390('RegExp.prototype.exec');

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$l37Ky(regex)) throw new $eEkyn('`regex` must be a RegExp');
    return function test(s) {
        return $1d8a638ce4bfc95c$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("l37Ky", function(module, exports) {
'use strict';

var $eW390 = parcelRequire("eW390");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $4c4Ky = parcelRequire("4c4Ky");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ var $f52fe3bd41a86f17$var$fn;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $f52fe3bd41a86f17$var$$exec = $eW390('RegExp.prototype.exec');
    /** @type {object} */ var $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $dYOee(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $4c4Ky(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $f52fe3bd41a86f17$var$$exec(value, /** @type {unknown} */ $f52fe3bd41a86f17$var$badStringifier);
        } catch (e) {
            return e === $f52fe3bd41a86f17$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $f52fe3bd41a86f17$var$$toString = $eW390('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $f52fe3bd41a86f17$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $f52fe3bd41a86f17$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
    };
}
module.exports = $f52fe3bd41a86f17$var$fn;

});


parcelRegister("1xINW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8c988d2af4ba1e07$export$2e2bcd8739ae039);

var $aN8bA = parcelRequire("aN8bA");
var /** @type {import('./index.d.mts').default} */ $8c988d2af4ba1e07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aN8bA)));

});
parcelRegister("aN8bA", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $7db4d48993eb4086$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$7db4d48993eb4086$var$cached;

});



parcelRegister("gJrpv", function(module, exports) {
'use strict';

var $gFhA7 = parcelRequire("gFhA7");

var $8yXCr = parcelRequire("8yXCr");

var $cOB0F = parcelRequire("cOB0F");

var $eW390 = parcelRequire("eW390");

var $dYOee = parcelRequire("dYOee");

var $3ERI6 = parcelRequire("3ERI6");
var $c2e61c703a2c9ae0$var$$toString = $eW390('Object.prototype.toString');

var $c2e61c703a2c9ae0$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $c2e61c703a2c9ae0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $c2e61c703a2c9ae0$var$typedArrays = $8yXCr();
var $c2e61c703a2c9ae0$var$$slice = $eW390('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $c2e61c703a2c9ae0$var$$indexOf = $eW390('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $c2e61c703a2c9ae0$var$cache = {
    __proto__: null
};
if ($c2e61c703a2c9ae0$var$hasToStringTag && $dYOee && $3ERI6) $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $3ERI6) {
        var proto = $3ERI6(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $dYOee(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $3ERI6(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $dYOee(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $cOB0F(descriptor.get);
            $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $gFhA7($c2e61c703a2c9ae0$var$typedArrays, function(typedArray) {
    var arr = new $c2e61c703a2c9ae0$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $cOB0F(fn);
        $c2e61c703a2c9ae0$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $c2e61c703a2c9ae0$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gFhA7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $c2e61c703a2c9ae0$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $c2e61c703a2c9ae0$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$c2e61c703a2c9ae0$var$hasToStringTag) {
        /** @type {string} */ var tag = $c2e61c703a2c9ae0$var$$slice($c2e61c703a2c9ae0$var$$toString(value), 8, -1);
        if ($c2e61c703a2c9ae0$var$$indexOf($c2e61c703a2c9ae0$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $c2e61c703a2c9ae0$var$trySlices(value);
    }
    if (!$dYOee) return null;
     // unknown engine
    return $c2e61c703a2c9ae0$var$tryTypedArrays(value);
};

});
parcelRegister("gFhA7", function(module, exports) {
'use strict';

var $63RD0 = parcelRequire("63RD0");
var $c21e1d005400ef2a$var$toStr = Object.prototype.toString;
var $c21e1d005400ef2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c21e1d005400ef2a$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c21e1d005400ef2a$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c21e1d005400ef2a$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c21e1d005400ef2a$var$isArray(x) {
    return $c21e1d005400ef2a$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$63RD0(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c21e1d005400ef2a$var$isArray(list)) $c21e1d005400ef2a$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c21e1d005400ef2a$var$forEachString(list, iterator, receiver);
    else $c21e1d005400ef2a$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("63RD0", function(module, exports) {
'use strict';
var $469c9f4bd3a650de$var$fnToStr = Function.prototype.toString;
var $469c9f4bd3a650de$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $469c9f4bd3a650de$var$badArrayLike;
var $469c9f4bd3a650de$var$isCallableMarker;
if (typeof $469c9f4bd3a650de$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $469c9f4bd3a650de$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $469c9f4bd3a650de$var$isCallableMarker;
        }
    });
    $469c9f4bd3a650de$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $469c9f4bd3a650de$var$reflectApply(function() {
        throw 42;
    }, null, $469c9f4bd3a650de$var$badArrayLike);
} catch (_) {
    if (_ !== $469c9f4bd3a650de$var$isCallableMarker) $469c9f4bd3a650de$var$reflectApply = null;
}
else $469c9f4bd3a650de$var$reflectApply = null;
var $469c9f4bd3a650de$var$constructorRegex = /^\s*class\b/;
var $469c9f4bd3a650de$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $469c9f4bd3a650de$var$fnToStr.call(value);
        return $469c9f4bd3a650de$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $469c9f4bd3a650de$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
        $469c9f4bd3a650de$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $469c9f4bd3a650de$var$toStr = Object.prototype.toString;
var $469c9f4bd3a650de$var$objectClass = '[object Object]';
var $469c9f4bd3a650de$var$fnClass = '[object Function]';
var $469c9f4bd3a650de$var$genClass = '[object GeneratorFunction]';
var $469c9f4bd3a650de$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $469c9f4bd3a650de$var$ddaClass2 = '[object HTML document.all class]';
var $469c9f4bd3a650de$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $469c9f4bd3a650de$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $469c9f4bd3a650de$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $469c9f4bd3a650de$var$all = document.all;
    if ($469c9f4bd3a650de$var$toStr.call($469c9f4bd3a650de$var$all) === $469c9f4bd3a650de$var$toStr.call(document.all)) $469c9f4bd3a650de$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($469c9f4bd3a650de$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $469c9f4bd3a650de$var$toStr.call(value);
            return (str === $469c9f4bd3a650de$var$ddaClass || str === $469c9f4bd3a650de$var$ddaClass2 || str === $469c9f4bd3a650de$var$ddaClass3 // opera 12.16
             || str === $469c9f4bd3a650de$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $469c9f4bd3a650de$var$reflectApply ? function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $469c9f4bd3a650de$var$reflectApply(value, null, $469c9f4bd3a650de$var$badArrayLike);
    } catch (e) {
        if (e !== $469c9f4bd3a650de$var$isCallableMarker) return false;
    }
    return !$469c9f4bd3a650de$var$isES6ClassFn(value) && $469c9f4bd3a650de$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($469c9f4bd3a650de$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($469c9f4bd3a650de$var$hasToStringTag) return $469c9f4bd3a650de$var$tryFunctionObject(value);
    if ($469c9f4bd3a650de$var$isES6ClassFn(value)) return false;
    var strClass = $469c9f4bd3a650de$var$toStr.call(value);
    if (strClass !== $469c9f4bd3a650de$var$fnClass && strClass !== $469c9f4bd3a650de$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $469c9f4bd3a650de$var$tryFunctionObject(value);
};

});


parcelRegister("8yXCr", function(module, exports) {
'use strict';

var $epJrh = parcelRequire("epJrh");
var $63bfbecf41903c8f$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $epJrh.length; i++)if (typeof $63bfbecf41903c8f$var$g[$epJrh[i]] === 'function') // @ts-expect-error
    out[out.length] = $epJrh[i];
    return out;
};

});
parcelRegister("epJrh", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("cOB0F", function(module, exports) {
'use strict';

var $BPe9e = parcelRequire("BPe9e");

var $jAy3M = parcelRequire("jAy3M");

var $jyxCz = parcelRequire("jyxCz");

var $1uOip = parcelRequire("1uOip");
module.exports = function callBind(originalFunction) {
    var func = $jyxCz(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $BPe9e(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($jAy3M) $jAy3M(module.exports, 'apply', {
    value: $1uOip
});
else module.exports.apply = $1uOip;

});
parcelRegister("BPe9e", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $eEkyn('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $dYOee) {
        var desc = $dYOee(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $eEkyn('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $eEkyn('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $eEkyn('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $eEkyn('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $eEkyn('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $eEkyn('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("i16wS", function(module, exports) {
'use strict';

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});


parcelRegister("1uOip", function(module, exports) {
'use strict';

var $gvair = parcelRequire("gvair");

var $xMvSJ = parcelRequire("xMvSJ");

var $3YvJT = parcelRequire("3YvJT");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $3YvJT($gvair, $xMvSJ, arguments);
};

});



parcelRegister("hN833", function(module, exports) {
'use strict';

var $gJrpv = parcelRequire("gJrpv");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$gJrpv(value);
};

});


parcelRegister("kotBY", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("aLUwE", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $7d7a23f7babfddb7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7d7a23f7babfddb7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7d7a23f7babfddb7$var$_typeof(o);
}
function $7d7a23f7babfddb7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d7a23f7babfddb7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d7a23f7babfddb7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d7a23f7babfddb7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d7a23f7babfddb7$var$_toPropertyKey(arg) {
    var key = $7d7a23f7babfddb7$var$_toPrimitive(arg, "string");
    return $7d7a23f7babfddb7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7d7a23f7babfddb7$var$_toPrimitive(input, hint) {
    if ($7d7a23f7babfddb7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7d7a23f7babfddb7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7d7a23f7babfddb7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $cCihK = parcelRequire("cCihK");
var $7d7a23f7babfddb7$var$_require$codes = $cCihK.codes, $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT = $7d7a23f7babfddb7$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_TYPE, $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_ARG_VALUE, $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE = $7d7a23f7babfddb7$var$_require$codes.ERR_INVALID_RETURN_VALUE, $7d7a23f7babfddb7$var$ERR_MISSING_ARGS = $7d7a23f7babfddb7$var$_require$codes.ERR_MISSING_ARGS;

var $8pS6q = parcelRequire("8pS6q");

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$var$inspect = $N7Lcz.inspect;

var $N7Lcz = parcelRequire("N7Lcz");
var $7d7a23f7babfddb7$require$_require$types = $N7Lcz.types;
var $7d7a23f7babfddb7$var$isPromise = $7d7a23f7babfddb7$require$_require$types.isPromise, $7d7a23f7babfddb7$var$isRegExp = $7d7a23f7babfddb7$require$_require$types.isRegExp;

var $7d7a23f7babfddb7$var$objectAssign = (parcelRequire("boX8x"))();

var $7d7a23f7babfddb7$var$objectIs = (parcelRequire("5SxoI"))();

var $7d7a23f7babfddb7$var$RegExpPrototypeTest = (parcelRequire("hXu6F"))('RegExp.prototype.test');
var $7d7a23f7babfddb7$var$errorCache = new Map();
var $7d7a23f7babfddb7$var$isDeepEqual;
var $7d7a23f7babfddb7$var$isDeepStrictEqual;
var $7d7a23f7babfddb7$var$parseExpressionAt;
var $7d7a23f7babfddb7$var$findNodeAround;
var $7d7a23f7babfddb7$var$decoder;

function $7d7a23f7babfddb7$var$lazyLoadComparison() {
    var comparison = (parcelRequire("3LKhK"));
    $7d7a23f7babfddb7$var$isDeepEqual = comparison.isDeepEqual;
    $7d7a23f7babfddb7$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $7d7a23f7babfddb7$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $7d7a23f7babfddb7$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $7d7a23f7babfddb7$var$escapeFn = function escapeFn(str) {
    return $7d7a23f7babfddb7$var$meta[str.charCodeAt(0)];
};
var $7d7a23f7babfddb7$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $7d7a23f7babfddb7$var$assert = module.exports = $7d7a23f7babfddb7$var$ok;
var $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $7d7a23f7babfddb7$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $8pS6q(obj);
}
function $7d7a23f7babfddb7$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($7d7a23f7babfddb7$var$warned === false) {
            $7d7a23f7babfddb7$var$warned = true;
            var warn = $hPtJY.emitWarning ? $hPtJY.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $7d7a23f7babfddb7$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $8pS6q(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$7d7a23f7babfddb7$var$assert.fail = $7d7a23f7babfddb7$var$fail;
// The AssertionError is defined in internal/error.
$7d7a23f7babfddb7$var$assert.AssertionError = $8pS6q;
function $7d7a23f7babfddb7$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $8pS6q({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $7d7a23f7babfddb7$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$ok,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.ok = $7d7a23f7babfddb7$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $7d7a23f7babfddb7$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$7d7a23f7babfddb7$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$7d7a23f7babfddb7$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$7d7a23f7babfddb7$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $7d7a23f7babfddb7$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if (!$7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notDeepStrictEqual = $7d7a23f7babfddb7$var$notDeepStrictEqual;
function $7d7a23f7babfddb7$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
    if ($7d7a23f7babfddb7$var$isDeepStrictEqual(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $7d7a23f7babfddb7$var$notDeepStrictEqual
    });
}
$7d7a23f7babfddb7$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$7d7a23f7babfddb7$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $7d7a23f7babfddb7$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($7d7a23f7babfddb7$var$objectIs(actual, expected)) $7d7a23f7babfddb7$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $7d7a23f7babfddb7$var$Comparison = /*#__PURE__*/ $7d7a23f7babfddb7$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $7d7a23f7babfddb7$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(obj[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$7d7a23f7babfddb7$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $7d7a23f7babfddb7$var$Comparison(actual, keys);
            var b = new $7d7a23f7babfddb7$var$Comparison(expected, keys, actual);
            var err = new $8pS6q({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $7d7a23f7babfddb7$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($7d7a23f7babfddb7$var$isRegExp(expected)) return $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($7d7a23f7babfddb7$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $8pS6q({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($7d7a23f7babfddb7$var$isDeepEqual === undefined) $7d7a23f7babfddb7$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $7d7a23f7babfddb7$var$isRegExp(expected[key]) && $7d7a23f7babfddb7$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $7d7a23f7babfddb7$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $7d7a23f7babfddb7$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
}
function $7d7a23f7babfddb7$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $7d7a23f7babfddb7$var$isPromise(obj) || obj !== null && $7d7a23f7babfddb7$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $7d7a23f7babfddb7$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$7d7a23f7babfddb7$var$checkIsPromise(resultPromise)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($7d7a23f7babfddb7$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $7d7a23f7babfddb7$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($7d7a23f7babfddb7$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $7d7a23f7babfddb7$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $7d7a23f7babfddb7$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$7d7a23f7babfddb7$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $7d7a23f7babfddb7$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $7d7a23f7babfddb7$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $7d7a23f7babfddb7$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $7d7a23f7babfddb7$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$7d7a23f7babfddb7$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
        throws,
        $7d7a23f7babfddb7$var$getActual(promiseFn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $7d7a23f7babfddb7$var$waitForActual(promiseFn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $7d7a23f7babfddb7$var$getActual(fn)
    ].concat(args));
};
$7d7a23f7babfddb7$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $7d7a23f7babfddb7$var$waitForActual(fn).then(function(result) {
        return $7d7a23f7babfddb7$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$7d7a23f7babfddb7$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($7d7a23f7babfddb7$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $7d7a23f7babfddb7$var$inspect(err);
        var newErr = new $8pS6q({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$7d7a23f7babfddb7$var$isRegExp(regexp)) throw new $7d7a23f7babfddb7$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $7d7a23f7babfddb7$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($7d7a23f7babfddb7$var$_typeof(string), " (").concat($7d7a23f7babfddb7$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($7d7a23f7babfddb7$var$inspect(regexp), ". Input:\n\n").concat($7d7a23f7babfddb7$var$inspect(string), "\n"));
        var err = new $8pS6q({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$7d7a23f7babfddb7$var$assert.match = function match(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, match, 'match');
};
$7d7a23f7babfddb7$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $7d7a23f7babfddb7$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $7d7a23f7babfddb7$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $7d7a23f7babfddb7$var$innerOk.apply(void 0, [
        $7d7a23f7babfddb7$var$strict,
        args.length
    ].concat(args));
}
$7d7a23f7babfddb7$var$assert.strict = $7d7a23f7babfddb7$var$objectAssign($7d7a23f7babfddb7$var$strict, $7d7a23f7babfddb7$var$assert, {
    equal: $7d7a23f7babfddb7$var$assert.strictEqual,
    deepEqual: $7d7a23f7babfddb7$var$assert.deepStrictEqual,
    notEqual: $7d7a23f7babfddb7$var$assert.notStrictEqual,
    notDeepEqual: $7d7a23f7babfddb7$var$assert.notDeepStrictEqual
});
$7d7a23f7babfddb7$var$assert.strict.strict = $7d7a23f7babfddb7$var$assert.strict;

});
parcelRegister("cCihK", function(module, exports) {

$parcel$export(module.exports, "codes", () => $92f737b1c63f6b54$export$e45cb6485273080e, (v) => $92f737b1c63f6b54$export$e45cb6485273080e = v);
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $92f737b1c63f6b54$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $92f737b1c63f6b54$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $92f737b1c63f6b54$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $92f737b1c63f6b54$var$_typeof(o);
}
function $92f737b1c63f6b54$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $92f737b1c63f6b54$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $92f737b1c63f6b54$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $92f737b1c63f6b54$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $92f737b1c63f6b54$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $92f737b1c63f6b54$var$_toPropertyKey(arg) {
    var key = $92f737b1c63f6b54$var$_toPrimitive(arg, "string");
    return $92f737b1c63f6b54$var$_typeof(key) === "symbol" ? key : String(key);
}
function $92f737b1c63f6b54$var$_toPrimitive(input, hint) {
    if ($92f737b1c63f6b54$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($92f737b1c63f6b54$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $92f737b1c63f6b54$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $92f737b1c63f6b54$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $92f737b1c63f6b54$var$_setPrototypeOf(subClass, superClass);
}
function $92f737b1c63f6b54$var$_setPrototypeOf(o, p) {
    $92f737b1c63f6b54$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $92f737b1c63f6b54$var$_setPrototypeOf(o, p);
}
function $92f737b1c63f6b54$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $92f737b1c63f6b54$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $92f737b1c63f6b54$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $92f737b1c63f6b54$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $92f737b1c63f6b54$var$_possibleConstructorReturn(this, result);
    };
}
function $92f737b1c63f6b54$var$_possibleConstructorReturn(self, call) {
    if (call && ($92f737b1c63f6b54$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $92f737b1c63f6b54$var$_assertThisInitialized(self);
}
function $92f737b1c63f6b54$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $92f737b1c63f6b54$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $92f737b1c63f6b54$var$_getPrototypeOf(o) {
    $92f737b1c63f6b54$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $92f737b1c63f6b54$var$_getPrototypeOf(o);
}
var $92f737b1c63f6b54$var$codes = {};
// Lazy loaded
var $92f737b1c63f6b54$var$assert;
var $92f737b1c63f6b54$var$util;
function $92f737b1c63f6b54$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $92f737b1c63f6b54$var$_inherits(NodeError, _Base);
        var _super = $92f737b1c63f6b54$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $92f737b1c63f6b54$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $92f737b1c63f6b54$var$_createClass(NodeError);
    }(Base);
    $92f737b1c63f6b54$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $92f737b1c63f6b54$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $92f737b1c63f6b54$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $92f737b1c63f6b54$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $92f737b1c63f6b54$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$92f737b1c63f6b54$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $92f737b1c63f6b54$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($92f737b1c63f6b54$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    else {
        var type = $92f737b1c63f6b54$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($92f737b1c63f6b54$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($92f737b1c63f6b54$var$_typeof(actual));
    return msg;
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($92f737b1c63f6b54$var$util === undefined) $92f737b1c63f6b54$var$util = (parcelRequire("N7Lcz"));
    var inspected = $92f737b1c63f6b54$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$92f737b1c63f6b54$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($92f737b1c63f6b54$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$92f737b1c63f6b54$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($92f737b1c63f6b54$var$assert === undefined) $92f737b1c63f6b54$var$assert = (parcelRequire("aLUwE"));
    $92f737b1c63f6b54$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$92f737b1c63f6b54$export$e45cb6485273080e = $92f737b1c63f6b54$var$codes;

});

parcelRegister("8pS6q", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $hPtJY = parcelRequire("hPtJY");
'use strict';
function $620aa032cca82da4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $620aa032cca82da4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $620aa032cca82da4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $620aa032cca82da4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $620aa032cca82da4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $620aa032cca82da4$var$_defineProperty(obj, key, value) {
    key = $620aa032cca82da4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620aa032cca82da4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $620aa032cca82da4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $620aa032cca82da4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $620aa032cca82da4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $620aa032cca82da4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $620aa032cca82da4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $620aa032cca82da4$var$_toPropertyKey(arg) {
    var key = $620aa032cca82da4$var$_toPrimitive(arg, "string");
    return $620aa032cca82da4$var$_typeof(key) === "symbol" ? key : String(key);
}
function $620aa032cca82da4$var$_toPrimitive(input, hint) {
    if ($620aa032cca82da4$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($620aa032cca82da4$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $620aa032cca82da4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $620aa032cca82da4$var$_setPrototypeOf(subClass, superClass);
}
function $620aa032cca82da4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $620aa032cca82da4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $620aa032cca82da4$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $620aa032cca82da4$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $620aa032cca82da4$var$_possibleConstructorReturn(this, result);
    };
}
function $620aa032cca82da4$var$_possibleConstructorReturn(self, call) {
    if (call && ($620aa032cca82da4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $620aa032cca82da4$var$_assertThisInitialized(self);
}
function $620aa032cca82da4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $620aa032cca82da4$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $620aa032cca82da4$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$620aa032cca82da4$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $620aa032cca82da4$var$_construct(Class, arguments, $620aa032cca82da4$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $620aa032cca82da4$var$_setPrototypeOf(Wrapper, Class);
    };
    return $620aa032cca82da4$var$_wrapNativeSuper(Class);
}
function $620aa032cca82da4$var$_construct(Parent, args, Class) {
    if ($620aa032cca82da4$var$_isNativeReflectConstruct()) $620aa032cca82da4$var$_construct = Reflect.construct.bind();
    else $620aa032cca82da4$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $620aa032cca82da4$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $620aa032cca82da4$var$_construct.apply(null, arguments);
}
function $620aa032cca82da4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $620aa032cca82da4$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $620aa032cca82da4$var$_setPrototypeOf(o, p) {
    $620aa032cca82da4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $620aa032cca82da4$var$_setPrototypeOf(o, p);
}
function $620aa032cca82da4$var$_getPrototypeOf(o) {
    $620aa032cca82da4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $620aa032cca82da4$var$_getPrototypeOf(o);
}
function $620aa032cca82da4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $620aa032cca82da4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620aa032cca82da4$var$_typeof(o);
}

var $N7Lcz = parcelRequire("N7Lcz");
var $620aa032cca82da4$var$inspect = $N7Lcz.inspect;

var $cCihK = parcelRequire("cCihK");
var $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE = $cCihK.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $620aa032cca82da4$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $620aa032cca82da4$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $620aa032cca82da4$var$blue = '';
var $620aa032cca82da4$var$green = '';
var $620aa032cca82da4$var$red = '';
var $620aa032cca82da4$var$white = '';
var $620aa032cca82da4$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $620aa032cca82da4$var$kMaxShortLength = 10;
function $620aa032cca82da4$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $620aa032cca82da4$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $620aa032cca82da4$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $620aa032cca82da4$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $620aa032cca82da4$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $620aa032cca82da4$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && $620aa032cca82da4$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $620aa032cca82da4$var$kMaxShortLength) {
            if (($620aa032cca82da4$var$_typeof(actual) !== 'object' || actual === null) && ($620aa032cca82da4$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $hPtJY.stderr && $hPtJY.stderr.isTTY ? $hPtJY.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($620aa032cca82da4$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($620aa032cca82da4$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $620aa032cca82da4$var$kReadableOperator[operator] + "\n".concat($620aa032cca82da4$var$green, "+ actual").concat($620aa032cca82da4$var$white, " ").concat($620aa032cca82da4$var$red, "- expected").concat($620aa032cca82da4$var$white);
    var skippedMsg = " ".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$620aa032cca82da4$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $620aa032cca82da4$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($620aa032cca82da4$var$green, "+").concat($620aa032cca82da4$var$white, " ").concat(actualLine);
                other += "\n".concat($620aa032cca82da4$var$red, "-").concat($620aa032cca82da4$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white).concat(other, "\n") + "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $620aa032cca82da4$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $620aa032cca82da4$var$_inherits(AssertionError, _Error);
    var _super = $620aa032cca82da4$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $620aa032cca82da4$var$_classCallCheck(this, AssertionError);
        if ($620aa032cca82da4$var$_typeof(options) !== 'object' || options === null) throw new $620aa032cca82da4$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($hPtJY.stderr && $hPtJY.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($hPtJY.stderr && $hPtJY.stderr.getColorDepth && $hPtJY.stderr.getColorDepth() !== 1) {
                    $620aa032cca82da4$var$blue = "\x1B[34m";
                    $620aa032cca82da4$var$green = "\x1B[32m";
                    $620aa032cca82da4$var$white = "\x1B[39m";
                    $620aa032cca82da4$var$red = "\x1B[31m";
                } else {
                    $620aa032cca82da4$var$blue = '';
                    $620aa032cca82da4$var$green = '';
                    $620aa032cca82da4$var$white = '';
                    $620aa032cca82da4$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null && $620aa032cca82da4$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $620aa032cca82da4$var$copyError(actual);
                expected = $620aa032cca82da4$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $620aa032cca82da4$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $620aa032cca82da4$var$kReadableOperator[operator];
                var res = $620aa032cca82da4$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $620aa032cca82da4$var$_typeof(actual) === 'object' && actual !== null) base = $620aa032cca82da4$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($620aa032cca82da4$var$blue, "...").concat($620aa032cca82da4$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $620aa032cca82da4$var$inspectValue(actual);
                var other = '';
                var knownOperators = $620aa032cca82da4$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($620aa032cca82da4$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($620aa032cca82da4$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($620aa032cca82da4$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($620aa032cca82da4$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $620aa032cca82da4$var$_possibleConstructorReturn(_this);
    }
    $620aa032cca82da4$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $620aa032cca82da4$var$inspect(this, $620aa032cca82da4$var$_objectSpread($620aa032cca82da4$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $620aa032cca82da4$var$_wrapNativeSuper(Error), $620aa032cca82da4$var$inspect.custom);
module.exports = $620aa032cca82da4$var$AssertionError;

});

parcelRegister("boX8x", function(module, exports) {
'use strict';

var $aHVV7 = parcelRequire("aHVV7");
var $84cfceeae7d9941c$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $84cfceeae7d9941c$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $aHVV7;
    if ($84cfceeae7d9941c$var$lacksProperEnumerationOrder()) return $aHVV7;
    if ($84cfceeae7d9941c$var$assignHasPendingExceptions()) return $aHVV7;
    return Object.assign;
};

});
parcelRegister("aHVV7", function(module, exports) {
'use strict';

var $81enX = parcelRequire("81enX");

var $7cbad94b4017a2be$var$hasSymbols = (parcelRequire("7YWkK"))();

var $eW390 = parcelRequire("eW390");

var $90JBs = parcelRequire("90JBs");
var $7cbad94b4017a2be$var$$push = $eW390('Array.prototype.push');
var $7cbad94b4017a2be$var$$propIsEnumerable = $eW390('Object.prototype.propertyIsEnumerable');
var $7cbad94b4017a2be$var$originalGetSymbols = $7cbad94b4017a2be$var$hasSymbols ? $90JBs.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $90JBs(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $90JBs(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $81enX(from);
        var getSymbols = $7cbad94b4017a2be$var$hasSymbols && ($90JBs.getOwnPropertySymbols || $7cbad94b4017a2be$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7cbad94b4017a2be$var$$propIsEnumerable(from, key)) $7cbad94b4017a2be$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7cbad94b4017a2be$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("81enX", function(module, exports) {
'use strict';
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
'use strict';
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
'use strict';
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, 'prototype');
    var $330998a67e44345d$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys['$' + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $330998a67e44345d$var$toStr.call(object) === '[object Function]';
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === 'constructor') && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});




parcelRegister("5SxoI", function(module, exports) {
'use strict';

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $6wuPW;
};

});
parcelRegister("6wuPW", function(module, exports) {
'use strict';
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("hXu6F", function(module, exports) {
'use strict';

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $d12f4cdcd6b10506$var$$indexOf(name, '.prototype.') > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});

parcelRegister("3LKhK", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $2be9aa30bff457b9$var$_slicedToArray(arr, i) {
    return $2be9aa30bff457b9$var$_arrayWithHoles(arr) || $2be9aa30bff457b9$var$_iterableToArrayLimit(arr, i) || $2be9aa30bff457b9$var$_unsupportedIterableToArray(arr, i) || $2be9aa30bff457b9$var$_nonIterableRest();
}
function $2be9aa30bff457b9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2be9aa30bff457b9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2be9aa30bff457b9$var$_arrayLikeToArray(o, minLen);
}
function $2be9aa30bff457b9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2be9aa30bff457b9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2be9aa30bff457b9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2be9aa30bff457b9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2be9aa30bff457b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2be9aa30bff457b9$var$_typeof(o);
}
var $2be9aa30bff457b9$var$regexFlagsSupported = /a/g.flags !== undefined;
var $2be9aa30bff457b9$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $2be9aa30bff457b9$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $2be9aa30bff457b9$var$objectIs = Object.is ? Object.is : (parcelRequire("eT9RM"));
var $2be9aa30bff457b9$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $2be9aa30bff457b9$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("c8Cyq"));
function $2be9aa30bff457b9$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $2be9aa30bff457b9$var$hasOwnProperty = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.hasOwnProperty);
var $2be9aa30bff457b9$var$propertyIsEnumerable = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $2be9aa30bff457b9$var$objectToString = $2be9aa30bff457b9$var$uncurryThis(Object.prototype.toString);

var $N7Lcz = parcelRequire("N7Lcz");
var $2be9aa30bff457b9$require$_require$types = $N7Lcz.types;
var $2be9aa30bff457b9$var$isAnyArrayBuffer = $2be9aa30bff457b9$require$_require$types.isAnyArrayBuffer, $2be9aa30bff457b9$var$isArrayBufferView = $2be9aa30bff457b9$require$_require$types.isArrayBufferView, $2be9aa30bff457b9$var$isDate = $2be9aa30bff457b9$require$_require$types.isDate, $2be9aa30bff457b9$var$isMap = $2be9aa30bff457b9$require$_require$types.isMap, $2be9aa30bff457b9$var$isRegExp = $2be9aa30bff457b9$require$_require$types.isRegExp, $2be9aa30bff457b9$var$isSet = $2be9aa30bff457b9$require$_require$types.isSet, $2be9aa30bff457b9$var$isNativeError = $2be9aa30bff457b9$require$_require$types.isNativeError, $2be9aa30bff457b9$var$isBoxedPrimitive = $2be9aa30bff457b9$require$_require$types.isBoxedPrimitive, $2be9aa30bff457b9$var$isNumberObject = $2be9aa30bff457b9$require$_require$types.isNumberObject, $2be9aa30bff457b9$var$isStringObject = $2be9aa30bff457b9$require$_require$types.isStringObject, $2be9aa30bff457b9$var$isBooleanObject = $2be9aa30bff457b9$require$_require$types.isBooleanObject, $2be9aa30bff457b9$var$isBigIntObject = $2be9aa30bff457b9$require$_require$types.isBigIntObject, $2be9aa30bff457b9$var$isSymbolObject = $2be9aa30bff457b9$require$_require$types.isSymbolObject, $2be9aa30bff457b9$var$isFloat32Array = $2be9aa30bff457b9$require$_require$types.isFloat32Array, $2be9aa30bff457b9$var$isFloat64Array = $2be9aa30bff457b9$require$_require$types.isFloat64Array;
function $2be9aa30bff457b9$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $2be9aa30bff457b9$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($2be9aa30bff457b9$var$isNonIndex).concat($2be9aa30bff457b9$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $2be9aa30bff457b9$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $2be9aa30bff457b9$var$ONLY_ENUMERABLE = undefined;
var $2be9aa30bff457b9$var$kStrict = true;
var $2be9aa30bff457b9$var$kLoose = false;
var $2be9aa30bff457b9$var$kNoIterator = 0;
var $2be9aa30bff457b9$var$kIsArray = 1;
var $2be9aa30bff457b9$var$kIsSet = 2;
var $2be9aa30bff457b9$var$kIsMap = 3;
// Check if they have the same source and flags
function $2be9aa30bff457b9$var$areSimilarRegExps(a, b) {
    return $2be9aa30bff457b9$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $2be9aa30bff457b9$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $2be9aa30bff457b9$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $2be9aa30bff457b9$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $2be9aa30bff457b9$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2) {
    if ($2be9aa30bff457b9$var$isNumberObject(val1)) return $2be9aa30bff457b9$var$isNumberObject(val2) && $2be9aa30bff457b9$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($2be9aa30bff457b9$var$isStringObject(val1)) return $2be9aa30bff457b9$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBooleanObject(val1)) return $2be9aa30bff457b9$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($2be9aa30bff457b9$var$isBigIntObject(val1)) return $2be9aa30bff457b9$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $2be9aa30bff457b9$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $2be9aa30bff457b9$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($2be9aa30bff457b9$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $2be9aa30bff457b9$var$numberIsNaN(val1) && $2be9aa30bff457b9$var$numberIsNaN(val2);
        if ($2be9aa30bff457b9$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $2be9aa30bff457b9$var$_typeof(val1) !== 'object') {
            if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $2be9aa30bff457b9$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $2be9aa30bff457b9$var$objectToString(val1);
    var val2Tag = $2be9aa30bff457b9$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$2be9aa30bff457b9$var$isMap(val1) && $2be9aa30bff457b9$var$isMap(val2) || !$2be9aa30bff457b9$var$isSet(val1) && $2be9aa30bff457b9$var$isSet(val2)) return false;
    }
    if ($2be9aa30bff457b9$var$isDate(val1)) {
        if (!$2be9aa30bff457b9$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($2be9aa30bff457b9$var$isRegExp(val1)) {
        if (!$2be9aa30bff457b9$var$isRegExp(val2) || !$2be9aa30bff457b9$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($2be9aa30bff457b9$var$isArrayBufferView(val1)) {
        if (!strict && ($2be9aa30bff457b9$var$isFloat32Array(val1) || $2be9aa30bff457b9$var$isFloat64Array(val1))) {
            if (!$2be9aa30bff457b9$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$2be9aa30bff457b9$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val1, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        var _keys2 = $2be9aa30bff457b9$var$getOwnNonIndexProperties(val2, $2be9aa30bff457b9$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator, _keys);
    } else if ($2be9aa30bff457b9$var$isSet(val1)) {
        if (!$2be9aa30bff457b9$var$isSet(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsSet);
    } else if ($2be9aa30bff457b9$var$isMap(val1)) {
        if (!$2be9aa30bff457b9$var$isMap(val2) || val1.size !== val2.size) return false;
        return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kIsMap);
    } else if ($2be9aa30bff457b9$var$isAnyArrayBuffer(val1)) {
        if (!$2be9aa30bff457b9$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($2be9aa30bff457b9$var$isBoxedPrimitive(val1) && !$2be9aa30bff457b9$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, $2be9aa30bff457b9$var$kNoIterator);
}
function $2be9aa30bff457b9$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $2be9aa30bff457b9$var$propertyIsEnumerable(val, k);
    });
}
function $2be9aa30bff457b9$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$2be9aa30bff457b9$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($2be9aa30bff457b9$var$propertyIsEnumerable(val1, key)) {
                    if (!$2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($2be9aa30bff457b9$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $2be9aa30bff457b9$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $2be9aa30bff457b9$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $2be9aa30bff457b9$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $2be9aa30bff457b9$var$kNoIterator || iterationType === $2be9aa30bff457b9$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $2be9aa30bff457b9$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $2be9aa30bff457b9$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim) {
    switch($2be9aa30bff457b9$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($2be9aa30bff457b9$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $2be9aa30bff457b9$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $2be9aa30bff457b9$var$innerDeepEqual(item, curB, false, memo);
}
function $2be9aa30bff457b9$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $2be9aa30bff457b9$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($2be9aa30bff457b9$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$2be9aa30bff457b9$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $2be9aa30bff457b9$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($2be9aa30bff457b9$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$2be9aa30bff457b9$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $2be9aa30bff457b9$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($2be9aa30bff457b9$var$innerDeepEqual(key1, key2, strict, memo) && $2be9aa30bff457b9$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $2be9aa30bff457b9$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $2be9aa30bff457b9$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $2be9aa30bff457b9$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($2be9aa30bff457b9$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$2be9aa30bff457b9$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$2be9aa30bff457b9$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $2be9aa30bff457b9$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $2be9aa30bff457b9$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($2be9aa30bff457b9$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$2be9aa30bff457b9$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$2be9aa30bff457b9$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $2be9aa30bff457b9$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $2be9aa30bff457b9$var$kIsSet) {
        if (!$2be9aa30bff457b9$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsMap) {
        if (!$2be9aa30bff457b9$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $2be9aa30bff457b9$var$kIsArray) for(; i < a.length; i++){
        if ($2be9aa30bff457b9$var$hasOwnProperty(a, i)) {
            if (!$2be9aa30bff457b9$var$hasOwnProperty(b, i) || !$2be9aa30bff457b9$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($2be9aa30bff457b9$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$2be9aa30bff457b9$var$hasOwnProperty(b, key) || !$2be9aa30bff457b9$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$2be9aa30bff457b9$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $2be9aa30bff457b9$var$isDeepEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kLoose);
}
function $2be9aa30bff457b9$var$isDeepStrictEqual(val1, val2) {
    return $2be9aa30bff457b9$var$innerDeepEqual(val1, val2, $2be9aa30bff457b9$var$kStrict);
}
module.exports = {
    isDeepEqual: $2be9aa30bff457b9$var$isDeepEqual,
    isDeepStrictEqual: $2be9aa30bff457b9$var$isDeepStrictEqual
};

});
parcelRegister("eT9RM", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
'use strict';

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === 'function' && $16343f2546a69e4c$var$toStr.call(fn) === '[object Function]';
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});

parcelRegister("bNbuK", function(module, exports) {
'use strict';

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("c8Cyq", function(module, exports) {
'use strict';

var $cOB0F = parcelRequire("cOB0F");

var $1UbTr = parcelRequire("1UbTr");

var $8sYH2 = parcelRequire("8sYH2");

var $91M8b = parcelRequire("91M8b");

var $hCf9I = parcelRequire("hCf9I");
var $8d642377f5822430$var$polyfill = $cOB0F($91M8b(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $1UbTr($8d642377f5822430$var$polyfill, {
    getPolyfill: $91M8b,
    implementation: $8sYH2,
    shim: $hCf9I
});
module.exports = $8d642377f5822430$var$polyfill;

});
parcelRegister("8sYH2", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("91M8b", function(module, exports) {
'use strict';

var $8sYH2 = parcelRequire("8sYH2");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $8sYH2;
};

});

parcelRegister("hCf9I", function(module, exports) {
'use strict';

var $1UbTr = parcelRequire("1UbTr");

var $91M8b = parcelRequire("91M8b");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $91M8b();
    $1UbTr(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $4jPKB = parcelRequire("4jPKB");
// By explicitly using `prop-types` you are opting into new development behavior.
// http://fb.me/prop-types-in-prod
var $8da5bfbbed271cd7$var$throwOnDirectAccess = true;

module.exports = (parcelRequire("eGxWZ"))($4jPKB.isElement, $8da5bfbbed271cd7$var$throwOnDirectAccess);

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkVY4"));

});
parcelRegister("hkVY4", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $c9f145267881427c$export$2b8d127b894957b9, (v) => $c9f145267881427c$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $c9f145267881427c$export$cea3a54a6425200c, (v) => $c9f145267881427c$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $c9f145267881427c$export$a7c73072b1a182ae, (v) => $c9f145267881427c$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $c9f145267881427c$export$9f27bc3417b4524d, (v) => $c9f145267881427c$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $c9f145267881427c$export$db77ccec0bb4ccac, (v) => $c9f145267881427c$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $c9f145267881427c$export$8392c0c9d3dcbd35, (v) => $c9f145267881427c$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $c9f145267881427c$export$ffb0004e005737fa, (v) => $c9f145267881427c$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $c9f145267881427c$export$b624eff549462981, (v) => $c9f145267881427c$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $c9f145267881427c$export$7897aa7841a5380c, (v) => $c9f145267881427c$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $c9f145267881427c$export$602eac185826482c, (v) => $c9f145267881427c$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $c9f145267881427c$export$e2c29f18771995cb, (v) => $c9f145267881427c$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $c9f145267881427c$export$5f8d39834fd61797, (v) => $c9f145267881427c$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $c9f145267881427c$export$74bf444e3cd11ea5, (v) => $c9f145267881427c$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $c9f145267881427c$export$92387174baf9b227, (v) => $c9f145267881427c$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $c9f145267881427c$export$ec112efeb987d9c6, (v) => $c9f145267881427c$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $c9f145267881427c$export$b706b080d889d2c9, (v) => $c9f145267881427c$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $c9f145267881427c$export$5be5a87408f70ddc, (v) => $c9f145267881427c$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $c9f145267881427c$export$45a5e7f76e0caa8d, (v) => $c9f145267881427c$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $c9f145267881427c$export$455c2e768291efa6, (v) => $c9f145267881427c$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $c9f145267881427c$export$9522e17588c12572, (v) => $c9f145267881427c$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $c9f145267881427c$export$2110ac352bb060b9, (v) => $c9f145267881427c$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $c9f145267881427c$export$56885ab8b9c456ab, (v) => $c9f145267881427c$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $c9f145267881427c$export$d927fcb6adf8f9de, (v) => $c9f145267881427c$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $c9f145267881427c$export$b82d16f27459e05a, (v) => $c9f145267881427c$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $c9f145267881427c$export$522c17b4f5e123e8, (v) => $c9f145267881427c$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $c9f145267881427c$export$1aabd8a0274ecfd6, (v) => $c9f145267881427c$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $c9f145267881427c$export$9b621391a187a31a, (v) => $c9f145267881427c$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $c9f145267881427c$export$f5bbd400c2f4426f, (v) => $c9f145267881427c$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9f145267881427c$export$2b8d127b894957b9;
var $c9f145267881427c$export$cea3a54a6425200c;
var $c9f145267881427c$export$a7c73072b1a182ae;
var $c9f145267881427c$export$9f27bc3417b4524d;
var $c9f145267881427c$export$db77ccec0bb4ccac;
var $c9f145267881427c$export$8392c0c9d3dcbd35;
var $c9f145267881427c$export$ffb0004e005737fa;
var $c9f145267881427c$export$b624eff549462981;
var $c9f145267881427c$export$7897aa7841a5380c;
var $c9f145267881427c$export$602eac185826482c;
var $c9f145267881427c$export$e2c29f18771995cb;
var $c9f145267881427c$export$5f8d39834fd61797;
var $c9f145267881427c$export$74bf444e3cd11ea5;
var $c9f145267881427c$export$92387174baf9b227;
var $c9f145267881427c$export$ec112efeb987d9c6;
var $c9f145267881427c$export$b706b080d889d2c9;
var $c9f145267881427c$export$5be5a87408f70ddc;
var $c9f145267881427c$export$45a5e7f76e0caa8d;
var $c9f145267881427c$export$455c2e768291efa6;
var $c9f145267881427c$export$9522e17588c12572;
var $c9f145267881427c$export$2110ac352bb060b9;
var $c9f145267881427c$export$56885ab8b9c456ab;
var $c9f145267881427c$export$d927fcb6adf8f9de;
var $c9f145267881427c$export$b82d16f27459e05a;
var $c9f145267881427c$export$522c17b4f5e123e8;
var $c9f145267881427c$export$1aabd8a0274ecfd6;
var $c9f145267881427c$export$9b621391a187a31a;
var $c9f145267881427c$export$f5bbd400c2f4426f;
'use strict';
(function() {
    'use strict';
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;
    function isValidElementType(type) {
        return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === 'object' && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console['warn']("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $c9f145267881427c$export$2b8d127b894957b9 = AsyncMode;
    $c9f145267881427c$export$cea3a54a6425200c = ConcurrentMode;
    $c9f145267881427c$export$a7c73072b1a182ae = ContextConsumer;
    $c9f145267881427c$export$9f27bc3417b4524d = ContextProvider;
    $c9f145267881427c$export$db77ccec0bb4ccac = Element;
    $c9f145267881427c$export$8392c0c9d3dcbd35 = ForwardRef;
    $c9f145267881427c$export$ffb0004e005737fa = Fragment;
    $c9f145267881427c$export$b624eff549462981 = Lazy;
    $c9f145267881427c$export$7897aa7841a5380c = Memo;
    $c9f145267881427c$export$602eac185826482c = Portal;
    $c9f145267881427c$export$e2c29f18771995cb = Profiler;
    $c9f145267881427c$export$5f8d39834fd61797 = StrictMode;
    $c9f145267881427c$export$74bf444e3cd11ea5 = Suspense;
    $c9f145267881427c$export$92387174baf9b227 = isAsyncMode;
    $c9f145267881427c$export$ec112efeb987d9c6 = isConcurrentMode;
    $c9f145267881427c$export$b706b080d889d2c9 = isContextConsumer;
    $c9f145267881427c$export$5be5a87408f70ddc = isContextProvider;
    $c9f145267881427c$export$45a5e7f76e0caa8d = isElement;
    $c9f145267881427c$export$455c2e768291efa6 = isForwardRef;
    $c9f145267881427c$export$9522e17588c12572 = isFragment;
    $c9f145267881427c$export$2110ac352bb060b9 = isLazy;
    $c9f145267881427c$export$56885ab8b9c456ab = isMemo;
    $c9f145267881427c$export$d927fcb6adf8f9de = isPortal;
    $c9f145267881427c$export$b82d16f27459e05a = isProfiler;
    $c9f145267881427c$export$522c17b4f5e123e8 = isStrictMode;
    $c9f145267881427c$export$1aabd8a0274ecfd6 = isSuspense;
    $c9f145267881427c$export$9b621391a187a31a = isValidElementType;
    $c9f145267881427c$export$f5bbd400c2f4426f = typeOf;
})();

});


parcelRegister("eGxWZ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $4jPKB = parcelRequire("4jPKB");

var $8coUR = parcelRequire("8coUR");

var $kZO5c = parcelRequire("kZO5c");

var $fQsEq = parcelRequire("fQsEq");

var $gwROR = parcelRequire("gwROR");
var $ab0f52c9db6f842e$var$printWarning = function() {};
$ab0f52c9db6f842e$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
function $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull() {
    return null;
}
module.exports = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */ var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
    /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */ function getIteratorFn(maybeIterable) {
        var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
        if (typeof iteratorFn === 'function') return iteratorFn;
    }
    /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */ var ANONYMOUS = '<<anonymous>>';
    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
        array: createPrimitiveTypeChecker('array'),
        bigint: createPrimitiveTypeChecker('bigint'),
        bool: createPrimitiveTypeChecker('boolean'),
        func: createPrimitiveTypeChecker('function'),
        number: createPrimitiveTypeChecker('number'),
        object: createPrimitiveTypeChecker('object'),
        string: createPrimitiveTypeChecker('string'),
        symbol: createPrimitiveTypeChecker('symbol'),
        any: createAnyTypeChecker(),
        arrayOf: createArrayOfTypeChecker,
        element: createElementTypeChecker(),
        elementType: createElementTypeTypeChecker(),
        instanceOf: createInstanceTypeChecker,
        node: createNodeChecker(),
        objectOf: createObjectOfTypeChecker,
        oneOf: createEnumTypeChecker,
        oneOfType: createUnionTypeChecker,
        shape: createShapeTypeChecker,
        exact: createStrictShapeTypeChecker
    };
    /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */ /*eslint-disable no-self-compare*/ function is(x, y) {
        // SameValue algorithm
        if (x === y) // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
        else // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
    /*eslint-enable no-self-compare*/ /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */ function PropTypeError(message, data) {
        this.message = message;
        this.data = data && typeof data === 'object' ? data : {};
        this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;
    function createChainableTypeChecker(validate) {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
        function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
            componentName = componentName || ANONYMOUS;
            propFullName = propFullName || propName;
            if (secret !== $kZO5c) {
                if (throwOnDirectAccess) {
                    // New behavior only for users of `prop-types` package
                    var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                    err.name = 'Invariant Violation';
                    throw err;
                } else if (typeof console !== 'undefined') {
                    // Old behavior for people using React.PropTypes
                    var cacheKey = componentName + ':' + propName;
                    if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
                    manualPropTypeWarningCount < 3) {
                        $ab0f52c9db6f842e$var$printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
                        manualPropTypeCallCache[cacheKey] = true;
                        manualPropTypeWarningCount++;
                    }
                }
            }
            if (props[propName] == null) {
                if (isRequired) {
                    if (props[propName] === null) return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
                    return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
                }
                return null;
            } else return validate(props, propName, componentName, location, propFullName);
        }
        var chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    }
    function createPrimitiveTypeChecker(expectedType) {
        function validate(props, propName, componentName, location, propFullName, secret) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== expectedType) {
                // `propValue` being instance of, say, date/regexp, pass the 'object'
                // check, but we can offer a more precise error message here rather than
                // 'of type `object`'.
                var preciseType = getPreciseType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
                    expectedType: expectedType
                });
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createAnyTypeChecker() {
        return createChainableTypeChecker($ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull);
    }
    function createArrayOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
            var propValue = props[propName];
            if (!Array.isArray(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
            }
            for(var i = 0; i < propValue.length; i++){
                var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!isValidElement(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createElementTypeTypeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            if (!$4jPKB.isValidElementType(propValue)) {
                var propType = getPropType(propValue);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createInstanceTypeChecker(expectedClass) {
        function validate(props, propName, componentName, location, propFullName) {
            if (!(props[propName] instanceof expectedClass)) {
                var expectedClassName = expectedClass.name || ANONYMOUS;
                var actualClassName = getClassName(props[propName]);
                return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createEnumTypeChecker(expectedValues) {
        if (!Array.isArray(expectedValues)) {
            {
                if (arguments.length > 1) $ab0f52c9db6f842e$var$printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
                else $ab0f52c9db6f842e$var$printWarning('Invalid argument supplied to oneOf, expected an array.');
            }
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            for(var i = 0; i < expectedValues.length; i++){
                if (is(propValue, expectedValues[i])) return null;
            }
            var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
                var type = getPreciseType(value);
                if (type === 'symbol') return String(value);
                return value;
            });
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createObjectOfTypeChecker(typeChecker) {
        function validate(props, propName, componentName, location, propFullName) {
            if (typeof typeChecker !== 'function') return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
            for(var key in propValue)if ($fQsEq(propValue, key)) {
                var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error instanceof Error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createUnionTypeChecker(arrayOfTypeCheckers) {
        if (!Array.isArray(arrayOfTypeCheckers)) {
            $ab0f52c9db6f842e$var$printWarning('Invalid argument supplied to oneOfType, expected an instance of array.');
            return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
        }
        for(var i = 0; i < arrayOfTypeCheckers.length; i++){
            var checker = arrayOfTypeCheckers[i];
            if (typeof checker !== 'function') {
                $ab0f52c9db6f842e$var$printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
                return $ab0f52c9db6f842e$var$emptyFunctionThatReturnsNull;
            }
        }
        function validate(props, propName, componentName, location, propFullName) {
            var expectedTypes = [];
            for(var i = 0; i < arrayOfTypeCheckers.length; i++){
                var checker = arrayOfTypeCheckers[i];
                var checkerResult = checker(props, propName, componentName, location, propFullName, $kZO5c);
                if (checkerResult == null) return null;
                if (checkerResult.data && $fQsEq(checkerResult.data, 'expectedType')) expectedTypes.push(checkerResult.data.expectedType);
            }
            var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
            return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
        }
        return createChainableTypeChecker(validate);
    }
    function createNodeChecker() {
        function validate(props, propName, componentName, location, propFullName) {
            if (!isNode(props[propName])) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function invalidValidatorError(componentName, location, propFullName, key, type) {
        return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
    }
    function createShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            for(var key in shapeTypes){
                var checker = shapeTypes[key];
                if (typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function createStrictShapeTypeChecker(shapeTypes) {
        function validate(props, propName, componentName, location, propFullName) {
            var propValue = props[propName];
            var propType = getPropType(propValue);
            if (propType !== 'object') return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
            // We need to check all keys in case some are required but missing from props.
            var allKeys = $8coUR({}, props[propName], shapeTypes);
            for(var key in allKeys){
                var checker = shapeTypes[key];
                if ($fQsEq(shapeTypes, key) && typeof checker !== 'function') return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
                if (!checker) return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
                var error = checker(propValue, key, componentName, location, propFullName + '.' + key, $kZO5c);
                if (error) return error;
            }
            return null;
        }
        return createChainableTypeChecker(validate);
    }
    function isNode(propValue) {
        switch(typeof propValue){
            case 'number':
            case 'string':
            case 'undefined':
                return true;
            case 'boolean':
                return !propValue;
            case 'object':
                if (Array.isArray(propValue)) return propValue.every(isNode);
                if (propValue === null || isValidElement(propValue)) return true;
                var iteratorFn = getIteratorFn(propValue);
                if (iteratorFn) {
                    var iterator = iteratorFn.call(propValue);
                    var step;
                    if (iteratorFn !== propValue.entries) while(!(step = iterator.next()).done){
                        if (!isNode(step.value)) return false;
                    }
                    else // Iterator will provide entry [k,v] tuples rather than values.
                    while(!(step = iterator.next()).done){
                        var entry = step.value;
                        if (entry) {
                            if (!isNode(entry[1])) return false;
                        }
                    }
                } else return false;
                return true;
            default:
                return false;
        }
    }
    function isSymbol(propType, propValue) {
        // Native Symbol.
        if (propType === 'symbol') return true;
        // falsy value can't be a Symbol
        if (!propValue) return false;
        // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
        if (propValue['@@toStringTag'] === 'Symbol') return true;
        // Fallback for non-spec compliant Symbols which are polyfilled.
        if (typeof Symbol === 'function' && propValue instanceof Symbol) return true;
        return false;
    }
    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
        var propType = typeof propValue;
        if (Array.isArray(propValue)) return 'array';
        if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
        if (isSymbol(propType, propValue)) return 'symbol';
        return propType;
    }
    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
        if (typeof propValue === 'undefined' || propValue === null) return '' + propValue;
        var propType = getPropType(propValue);
        if (propType === 'object') {
            if (propValue instanceof Date) return 'date';
            else if (propValue instanceof RegExp) return 'regexp';
        }
        return propType;
    }
    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
        var type = getPreciseType(value);
        switch(type){
            case 'array':
            case 'object':
                return 'an ' + type;
            case 'boolean':
            case 'date':
            case 'regexp':
                return 'a ' + type;
            default:
                return type;
        }
    }
    // Returns class name of the object, if any.
    function getClassName(propValue) {
        if (!propValue.constructor || !propValue.constructor.name) return ANONYMOUS;
        return propValue.constructor.name;
    }
    ReactPropTypes.checkPropTypes = $gwROR;
    ReactPropTypes.resetWarningCache = $gwROR.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});

parcelRegister("fQsEq", function(module, exports) {
module.exports = Function.call.bind(Object.prototype.hasOwnProperty);

});

parcelRegister("gwROR", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $c08961ea4c03f601$var$printWarning = function() {};

var $kZO5c = parcelRequire("kZO5c");
var $c08961ea4c03f601$var$loggedTypeFailures = {};

var $fQsEq = parcelRequire("fQsEq");
$c08961ea4c03f601$var$printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
};
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */ function $c08961ea4c03f601$var$checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    for(var typeSpecName in typeSpecs)if ($fQsEq(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                err.name = 'Invariant Violation';
                throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, $kZO5c);
        } catch (ex) {
            error = ex;
        }
        if (error && !(error instanceof Error)) $c08961ea4c03f601$var$printWarning((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        if (error instanceof Error && !(error.message in $c08961ea4c03f601$var$loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            $c08961ea4c03f601$var$loggedTypeFailures[error.message] = true;
            var stack = getStack ? getStack() : '';
            $c08961ea4c03f601$var$printWarning('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
    }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */ $c08961ea4c03f601$var$checkPropTypes.resetWarningCache = function() {
    $c08961ea4c03f601$var$loggedTypeFailures = {};
};
module.exports = $c08961ea4c03f601$var$checkPropTypes;

});



parcelRegister("9slIK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e5b639a4b64488d4$export$2e2bcd8739ae039);
/*!
 * Signature Pad v2.3.2
 * https://github.com/szimek/signature_pad
 *
 * Copyright 2017 Szymon Nowak
 * Released under the MIT license
 *
 * The main idea and some parts of the code (e.g. drawing variable width Bézier curve) are taken from:
 * http://corner.squareup.com/2012/07/smoother-signatures.html
 *
 * Implementation of interpolation using cubic Bézier curves is taken from:
 * http://benknowscode.wordpress.com/2012/09/14/path-interpolation-using-cubic-bezier-and-control-point-estimation-in-javascript
 *
 * Algorithm for approximated length of a Bézier curve is taken from:
 * http://www.lemoda.net/maths/bezier-length/index.html
 *
 */ function $e5b639a4b64488d4$var$Point(x, y, time) {
    this.x = x;
    this.y = y;
    this.time = time || new Date().getTime();
}
$e5b639a4b64488d4$var$Point.prototype.velocityFrom = function(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
};
$e5b639a4b64488d4$var$Point.prototype.distanceTo = function(start) {
    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
};
$e5b639a4b64488d4$var$Point.prototype.equals = function(other) {
    return this.x === other.x && this.y === other.y && this.time === other.time;
};
function $e5b639a4b64488d4$var$Bezier(startPoint, control1, control2, endPoint) {
    this.startPoint = startPoint;
    this.control1 = control1;
    this.control2 = control2;
    this.endPoint = endPoint;
}
// Returns approximated length.
$e5b639a4b64488d4$var$Bezier.prototype.length = function() {
    var steps = 10;
    var length = 0;
    var px = void 0;
    var py = void 0;
    for(var i = 0; i <= steps; i += 1){
        var t = i / steps;
        var cx = this._point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
        var cy = this._point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
        if (i > 0) {
            var xdiff = cx - px;
            var ydiff = cy - py;
            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
        }
        px = cx;
        py = cy;
    }
    return length;
};
/* eslint-disable no-multi-spaces, space-in-parens */ $e5b639a4b64488d4$var$Bezier.prototype._point = function(t, start, c1, c2, end) {
    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
};
/* eslint-disable */ // http://stackoverflow.com/a/27078401/815507
function $e5b639a4b64488d4$var$throttle(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    return function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
}
function $e5b639a4b64488d4$var$SignaturePad(canvas, options) {
    var self = this;
    var opts = options || {};
    this.velocityFilterWeight = opts.velocityFilterWeight || 0.7;
    this.minWidth = opts.minWidth || 0.5;
    this.maxWidth = opts.maxWidth || 2.5;
    this.throttle = 'throttle' in opts ? opts.throttle : 16; // in miliseconds
    this.minDistance = 'minDistance' in opts ? opts.minDistance : 5;
    if (this.throttle) this._strokeMoveUpdate = $e5b639a4b64488d4$var$throttle($e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate, this.throttle);
    else this._strokeMoveUpdate = $e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate;
    this.dotSize = opts.dotSize || function() {
        return (this.minWidth + this.maxWidth) / 2;
    };
    this.penColor = opts.penColor || 'black';
    this.backgroundColor = opts.backgroundColor || 'rgba(0,0,0,0)';
    this.onBegin = opts.onBegin;
    this.onEnd = opts.onEnd;
    this._canvas = canvas;
    this._ctx = canvas.getContext('2d');
    this.clear();
    // We need add these inline so they are available to unbind while still having
    // access to 'self' we could use _.bind but it's not worth adding a dependency.
    this._handleMouseDown = function(event) {
        if (event.which === 1) {
            self._mouseButtonDown = true;
            self._strokeBegin(event);
        }
    };
    this._handleMouseMove = function(event) {
        if (self._mouseButtonDown) self._strokeMoveUpdate(event);
    };
    this._handleMouseUp = function(event) {
        if (event.which === 1 && self._mouseButtonDown) {
            self._mouseButtonDown = false;
            self._strokeEnd(event);
        }
    };
    this._handleTouchStart = function(event) {
        if (event.targetTouches.length === 1) {
            var touch = event.changedTouches[0];
            self._strokeBegin(touch);
        }
    };
    this._handleTouchMove = function(event) {
        // Prevent scrolling.
        event.preventDefault();
        var touch = event.targetTouches[0];
        self._strokeMoveUpdate(touch);
    };
    this._handleTouchEnd = function(event) {
        var wasCanvasTouched = event.target === self._canvas;
        if (wasCanvasTouched) {
            event.preventDefault();
            self._strokeEnd(event);
        }
    };
    // Enable mouse and touch event handlers
    this.on();
}
// Public methods
$e5b639a4b64488d4$var$SignaturePad.prototype.clear = function() {
    var ctx = this._ctx;
    var canvas = this._canvas;
    ctx.fillStyle = this.backgroundColor;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this._data = [];
    this._reset();
    this._isEmpty = true;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.fromDataURL = function(dataUrl) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var image = new Image();
    var ratio = options.ratio || window.devicePixelRatio || 1;
    var width = options.width || this._canvas.width / ratio;
    var height = options.height || this._canvas.height / ratio;
    this._reset();
    image.src = dataUrl;
    image.onload = function() {
        _this._ctx.drawImage(image, 0, 0, width, height);
    };
    this._isEmpty = false;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.toDataURL = function(type) {
    var _canvas;
    switch(type){
        case 'image/svg+xml':
            return this._toSVG();
        default:
            for(var _len = arguments.length, options = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)options[_key - 1] = arguments[_key];
            return (_canvas = this._canvas).toDataURL.apply(_canvas, [
                type
            ].concat(options));
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype.on = function() {
    this._handleMouseEvents();
    this._handleTouchEvents();
};
$e5b639a4b64488d4$var$SignaturePad.prototype.off = function() {
    this._canvas.removeEventListener('mousedown', this._handleMouseDown);
    this._canvas.removeEventListener('mousemove', this._handleMouseMove);
    document.removeEventListener('mouseup', this._handleMouseUp);
    this._canvas.removeEventListener('touchstart', this._handleTouchStart);
    this._canvas.removeEventListener('touchmove', this._handleTouchMove);
    this._canvas.removeEventListener('touchend', this._handleTouchEnd);
};
$e5b639a4b64488d4$var$SignaturePad.prototype.isEmpty = function() {
    return this._isEmpty;
};
// Private methods
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeBegin = function(event) {
    this._data.push([]);
    this._reset();
    this._strokeUpdate(event);
    if (typeof this.onBegin === 'function') this.onBegin(event);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeUpdate = function(event) {
    var x = event.clientX;
    var y = event.clientY;
    var point = this._createPoint(x, y);
    var lastPointGroup = this._data[this._data.length - 1];
    var lastPoint = lastPointGroup && lastPointGroup[lastPointGroup.length - 1];
    var isLastPointTooClose = lastPoint && point.distanceTo(lastPoint) < this.minDistance;
    // Skip this point if it's too close to the previous one
    if (!(lastPoint && isLastPointTooClose)) {
        var _addPoint = this._addPoint(point), curve = _addPoint.curve, widths = _addPoint.widths;
        if (curve && widths) this._drawCurve(curve, widths.start, widths.end);
        this._data[this._data.length - 1].push({
            x: point.x,
            y: point.y,
            time: point.time,
            color: this.penColor
        });
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeEnd = function(event) {
    var canDrawCurve = this.points.length > 2;
    var point = this.points[0]; // Point instance
    if (!canDrawCurve && point) this._drawDot(point);
    if (point) {
        var lastPointGroup = this._data[this._data.length - 1];
        var lastPoint = lastPointGroup[lastPointGroup.length - 1]; // plain object
        // When drawing a dot, there's only one point in a group, so without this check
        // such group would end up with exactly the same 2 points.
        if (!point.equals(lastPoint)) lastPointGroup.push({
            x: point.x,
            y: point.y,
            time: point.time,
            color: this.penColor
        });
    }
    if (typeof this.onEnd === 'function') this.onEnd(event);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._handleMouseEvents = function() {
    this._mouseButtonDown = false;
    this._canvas.addEventListener('mousedown', this._handleMouseDown);
    this._canvas.addEventListener('mousemove', this._handleMouseMove);
    document.addEventListener('mouseup', this._handleMouseUp);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._handleTouchEvents = function() {
    // Pass touch events to canvas element on mobile IE11 and Edge.
    this._canvas.style.msTouchAction = 'none';
    this._canvas.style.touchAction = 'none';
    this._canvas.addEventListener('touchstart', this._handleTouchStart);
    this._canvas.addEventListener('touchmove', this._handleTouchMove);
    this._canvas.addEventListener('touchend', this._handleTouchEnd);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._reset = function() {
    this.points = [];
    this._lastVelocity = 0;
    this._lastWidth = (this.minWidth + this.maxWidth) / 2;
    this._ctx.fillStyle = this.penColor;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._createPoint = function(x, y, time) {
    var rect = this._canvas.getBoundingClientRect();
    return new $e5b639a4b64488d4$var$Point(x - rect.left, y - rect.top, time || new Date().getTime());
};
$e5b639a4b64488d4$var$SignaturePad.prototype._addPoint = function(point) {
    var points = this.points;
    var tmp = void 0;
    points.push(point);
    if (points.length > 2) {
        // To reduce the initial lag make it work with 3 points
        // by copying the first point to the beginning.
        if (points.length === 3) points.unshift(points[0]);
        tmp = this._calculateCurveControlPoints(points[0], points[1], points[2]);
        var c2 = tmp.c2;
        tmp = this._calculateCurveControlPoints(points[1], points[2], points[3]);
        var c3 = tmp.c1;
        var curve = new $e5b639a4b64488d4$var$Bezier(points[1], c2, c3, points[2]);
        var widths = this._calculateCurveWidths(curve);
        // Remove the first element from the list,
        // so that we always have no more than 4 points in points array.
        points.shift();
        return {
            curve: curve,
            widths: widths
        };
    }
    return {};
};
$e5b639a4b64488d4$var$SignaturePad.prototype._calculateCurveControlPoints = function(s1, s2, s3) {
    var dx1 = s1.x - s2.x;
    var dy1 = s1.y - s2.y;
    var dx2 = s2.x - s3.x;
    var dy2 = s2.y - s3.y;
    var m1 = {
        x: (s1.x + s2.x) / 2.0,
        y: (s1.y + s2.y) / 2.0
    };
    var m2 = {
        x: (s2.x + s3.x) / 2.0,
        y: (s2.y + s3.y) / 2.0
    };
    var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    var dxm = m1.x - m2.x;
    var dym = m1.y - m2.y;
    var k = l2 / (l1 + l2);
    var cm = {
        x: m2.x + dxm * k,
        y: m2.y + dym * k
    };
    var tx = s2.x - cm.x;
    var ty = s2.y - cm.y;
    return {
        c1: new $e5b639a4b64488d4$var$Point(m1.x + tx, m1.y + ty),
        c2: new $e5b639a4b64488d4$var$Point(m2.x + tx, m2.y + ty)
    };
};
$e5b639a4b64488d4$var$SignaturePad.prototype._calculateCurveWidths = function(curve) {
    var startPoint = curve.startPoint;
    var endPoint = curve.endPoint;
    var widths = {
        start: null,
        end: null
    };
    var velocity = this.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - this.velocityFilterWeight) * this._lastVelocity;
    var newWidth = this._strokeWidth(velocity);
    widths.start = this._lastWidth;
    widths.end = newWidth;
    this._lastVelocity = velocity;
    this._lastWidth = newWidth;
    return widths;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._strokeWidth = function(velocity) {
    return Math.max(this.maxWidth / (velocity + 1), this.minWidth);
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawPoint = function(x, y, size) {
    var ctx = this._ctx;
    ctx.moveTo(x, y);
    ctx.arc(x, y, size, 0, 2 * Math.PI, false);
    this._isEmpty = false;
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawCurve = function(curve, startWidth, endWidth) {
    var ctx = this._ctx;
    var widthDelta = endWidth - startWidth;
    var drawSteps = Math.floor(curve.length());
    ctx.beginPath();
    for(var i = 0; i < drawSteps; i += 1){
        // Calculate the Bezier (x, y) coordinate for this step.
        var t = i / drawSteps;
        var tt = t * t;
        var ttt = tt * t;
        var u = 1 - t;
        var uu = u * u;
        var uuu = uu * u;
        var x = uuu * curve.startPoint.x;
        x += 3 * uu * t * curve.control1.x;
        x += 3 * u * tt * curve.control2.x;
        x += ttt * curve.endPoint.x;
        var y = uuu * curve.startPoint.y;
        y += 3 * uu * t * curve.control1.y;
        y += 3 * u * tt * curve.control2.y;
        y += ttt * curve.endPoint.y;
        var width = startWidth + ttt * widthDelta;
        this._drawPoint(x, y, width);
    }
    ctx.closePath();
    ctx.fill();
};
$e5b639a4b64488d4$var$SignaturePad.prototype._drawDot = function(point) {
    var ctx = this._ctx;
    var width = typeof this.dotSize === 'function' ? this.dotSize() : this.dotSize;
    ctx.beginPath();
    this._drawPoint(point.x, point.y, width);
    ctx.closePath();
    ctx.fill();
};
$e5b639a4b64488d4$var$SignaturePad.prototype._fromData = function(pointGroups, drawCurve, drawDot) {
    for(var i = 0; i < pointGroups.length; i += 1){
        var group = pointGroups[i];
        if (group.length > 1) for(var j = 0; j < group.length; j += 1){
            var rawPoint = group[j];
            var point = new $e5b639a4b64488d4$var$Point(rawPoint.x, rawPoint.y, rawPoint.time);
            var color = rawPoint.color;
            if (j === 0) {
                // First point in a group. Nothing to draw yet.
                // All points in the group have the same color, so it's enough to set
                // penColor just at the beginning.
                this.penColor = color;
                this._reset();
                this._addPoint(point);
            } else if (j !== group.length - 1) {
                // Middle point in a group.
                var _addPoint2 = this._addPoint(point), curve = _addPoint2.curve, widths = _addPoint2.widths;
                if (curve && widths) drawCurve(curve, widths, color);
            }
        }
        else {
            this._reset();
            var _rawPoint = group[0];
            drawDot(_rawPoint);
        }
    }
};
$e5b639a4b64488d4$var$SignaturePad.prototype._toSVG = function() {
    var _this2 = this;
    var pointGroups = this._data;
    var canvas = this._canvas;
    var ratio = Math.max(window.devicePixelRatio || 1, 1);
    var minX = 0;
    var minY = 0;
    var maxX = canvas.width / ratio;
    var maxY = canvas.height / ratio;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttributeNS(null, 'width', canvas.width);
    svg.setAttributeNS(null, 'height', canvas.height);
    this._fromData(pointGroups, function(curve, widths, color) {
        var path = document.createElement('path');
        // Need to check curve for NaN values, these pop up when drawing
        // lines on the canvas that are not continuous. E.g. Sharp corners
        // or stopping mid-stroke and than continuing without lifting mouse.
        if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
            var attr = 'M ' + curve.startPoint.x.toFixed(3) + ',' + curve.startPoint.y.toFixed(3) + ' ' + ('C ' + curve.control1.x.toFixed(3) + ',' + curve.control1.y.toFixed(3) + ' ') + (curve.control2.x.toFixed(3) + ',' + curve.control2.y.toFixed(3) + ' ') + (curve.endPoint.x.toFixed(3) + ',' + curve.endPoint.y.toFixed(3));
            path.setAttribute('d', attr);
            path.setAttribute('stroke-width', (widths.end * 2.25).toFixed(3));
            path.setAttribute('stroke', color);
            path.setAttribute('fill', 'none');
            path.setAttribute('stroke-linecap', 'round');
            svg.appendChild(path);
        }
    }, function(rawPoint) {
        var circle = document.createElement('circle');
        var dotSize = typeof _this2.dotSize === 'function' ? _this2.dotSize() : _this2.dotSize;
        circle.setAttribute('r', dotSize);
        circle.setAttribute('cx', rawPoint.x);
        circle.setAttribute('cy', rawPoint.y);
        circle.setAttribute('fill', rawPoint.color);
        svg.appendChild(circle);
    });
    var prefix = 'data:image/svg+xml;base64,';
    var header = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"' + (' viewBox="' + minX + ' ' + minY + ' ' + maxX + ' ' + maxY + '"') + (' width="' + maxX + '"') + (' height="' + maxY + '"') + '>';
    var body = svg.innerHTML;
    // IE hack for missing innerHTML property on SVGElement
    if (body === undefined) {
        var dummy = document.createElement('dummy');
        var nodes = svg.childNodes;
        dummy.innerHTML = '';
        for(var i = 0; i < nodes.length; i += 1)dummy.appendChild(nodes[i].cloneNode(true));
        body = dummy.innerHTML;
    }
    var footer = '</svg>';
    var data = header + body + footer;
    return prefix + btoa(data);
};
$e5b639a4b64488d4$var$SignaturePad.prototype.fromData = function(pointGroups) {
    var _this3 = this;
    this.clear();
    this._fromData(pointGroups, function(curve, widths) {
        return _this3._drawCurve(curve, widths.start, widths.end);
    }, function(rawPoint) {
        return _this3._drawDot(rawPoint);
    });
    this._data = pointGroups;
};
$e5b639a4b64488d4$var$SignaturePad.prototype.toData = function() {
    return this._data;
};
var $e5b639a4b64488d4$export$2e2bcd8739ae039 = $e5b639a4b64488d4$var$SignaturePad;

});

parcelRegister("7G0GL", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        function t(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.p = "", t(0);
    }([
        function(e, t) {
            "use strict";
            function r(e) {
                var t = e.getContext("2d"), r = e.width, n = e.height, o = t.getImageData(0, 0, r, n).data, f = a(!0, r, n, o), i = a(!1, r, n, o), c = u(!0, r, n, o), d = u(!1, r, n, o), p = d - c + 1, l = i - f + 1, s = t.getImageData(c, f, p, l);
                return e.width = p, e.height = l, t.clearRect(0, 0, p, l), t.putImageData(s, 0, 0), e;
            }
            function n(e, t, r, n) {
                return {
                    red: n[4 * (r * t + e)],
                    green: n[4 * (r * t + e) + 1],
                    blue: n[4 * (r * t + e) + 2],
                    alpha: n[4 * (r * t + e) + 3]
                };
            }
            function o(e, t, r, o) {
                return n(e, t, r, o).alpha;
            }
            function a(e, t, r, n) {
                for(var a = e ? 1 : -1, u = e ? 0 : r - 1, f = u; e ? f < r : f > -1; f += a)for(var i = 0; i < t; i++)if (o(i, f, t, n)) return f;
                return null;
            }
            function u(e, t, r, n) {
                for(var a = e ? 1 : -1, u = e ? 0 : t - 1, f = u; e ? f < t : f > -1; f += a)for(var i = 0; i < r; i++)if (o(f, i, t, n)) return f;
                return null;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = r;
        }
    ]);
});

});

parcelRegister("3y30c", function(module, exports) {
/** @license React v17.0.2
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';




(function() {
    'use strict';
    var React = (parcelRequire("acw62"));
    var _assign = (parcelRequire("8coUR"));
    var Scheduler = (parcelRequire("fO90s"));
    var tracing = (parcelRequire("eXC0v"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    if (!React) throw Error("ReactDOM was loaded before React. Make sure you load the React package before loading ReactDOM.");
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var FundamentalComponent = 20;
    var ScopeComponent = 21;
    var Block = 22;
    var OffscreenComponent = 23;
    var LegacyHiddenComponent = 24;
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableFundamentalAPI = false; // Experimental Scope support.
    var enableNewReconciler = false; // Errors that are thrown while unmounting (or after in the case of passive effects)
    var warnAboutStringRefs = false;
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + 'Capture', dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === 'onDoubleClick') possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            sanitizeURL('' + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === '') return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                    if (value === '' + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue;
            else if (stringValue === '' + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected) {
        if (!isAttributeNameSafe(name)) return;
         // If the object is an opaque reference ID, it's expected that
        // the next prop is different than the server value, so just return
        // expected
        if (isOpaqueHydratingObject(expected)) return expected;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        if (value === '' + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
         // If the prop isn't in the special list, treat it as a simple attribute.
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else node.setAttribute(_attributeName, '' + value);
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : '';
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = '';
            else {
                attributeValue = '' + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator';
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== 'object') return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === 'function') return maybeIterator;
        return null;
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame('Lazy');
            case SuspenseComponent:
                return describeBuiltInComponentFrame('Suspense');
            case SuspenseListComponent:
                return describeBuiltInComponentFrame('SuspenseList');
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case Block:
                return describeFunctionComponentFrame(fiber.type._render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return '';
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = '';
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return '\nError generating stack: ' + x.message + '\n' + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== 'undefined') return getComponentName(owner.type);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return '';
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    function getIsRendering() {
        return isRendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        return '' + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case 'boolean':
            case 'number':
            case 'object':
            case 'string':
            case 'undefined':
                return value;
            default:
                // function, symbol are assigned as empty strings
                return '';
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = '';
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? 'true' : 'false';
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? 'checked' : 'value';
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        var currentValue = '' + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === 'undefined' || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = '' + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = '' + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== 'undefined' ? document : undefined);
        if (typeof doc === 'undefined') return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === 'checkbox' || props.type === 'radio';
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = _assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps('input', props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component', props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? '' : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, 'checked', checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === 'number') {
                if (value === 0 && node.value === '' || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === 'submit' || type === 'reset') {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute('value');
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty('value')) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty('defaultValue')) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty('value') || props.hasOwnProperty('defaultValue')) {
            var type = props.type;
            var isButton = type === 'submit' || type === 'reset'; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== '') node.name = '';
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== '') node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === 'radio' && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            // but that sometimes behaves strangely in IE8. We could also try using
            // `form.getElementsByName`, but that will only return direct children
            // and won't include inputs that use the HTML5 `form=` attribute. Since
            // the input might not even be in a form. It might not even be in the
            // document. Let's just use the local `querySelectorAll` to ensure we don't
            // miss anything.
            var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== 'number' || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    function flattenChildren(children) {
        var content = ''; // Flatten children. We'll warn if they are invalid
        // during validateProps() which runs for hydration too.
        // Note that this would throw on non-element objects.
        // Elements are stringified (which is normally irrelevant
        // but matters for <fbt>).
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child; // Note: we don't warn about invalid children here.
        // Instead, this is done separately below so that
        // it happens during the hydration code path too.
        });
        return content;
    }
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // This mirrors the code path above, but runs for hydration too.
        // Warn about invalid children here so that client and hydration are consistent.
        // TODO: this seems like it could cause a DEV-only throw for hydration
        // if children contains a non-element object. We should try to avoid that.
        if (typeof props.children === 'object' && props.children !== null) React.Children.forEach(props.children, function(child) {
            if (child == null) return;
            if (typeof child === 'string' || typeof child === 'number') return;
            if (typeof child.type !== 'string') return;
            if (!didWarnInvalidChild) {
                didWarnInvalidChild = true;
                error('Only strings and numbers are supported as <option> children.');
            }
        });
         // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute('value', toString(getToStringValue(props.value)));
    }
    function getHostProps$1(element, props) {
        var hostProps = _assign({
            children: undefined
        }, props);
        var content = flattenChildren(props.children);
        if (content) hostProps.children = content;
        return hostProps;
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return '\n\nCheck the render method of `' + ownerName + '`.';
        return '';
    }
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps('select', props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var isArray = Array.isArray(props[propName]);
            if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue['$' + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty('$' + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$2(element, props) {
        return _assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : '', false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$3(element, props) {
        var node = element;
        if (!(props.dangerouslySetInnerHTML == null)) throw Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = _assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps('textarea', props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || 'A component');
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (Array.isArray(children)) {
                    if (!(children.length <= 1)) throw Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = '';
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== '' && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === Namespaces.svg) {
            if (!('innerHTML' in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement('div');
                reusableSVGContainer.innerHTML = '<svg>' + html.valueOf().toString() + '</svg>';
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            'animationDelay',
            'animationDirection',
            'animationDuration',
            'animationFillMode',
            'animationIterationCount',
            'animationName',
            'animationPlayState',
            'animationTimingFunction'
        ],
        background: [
            'backgroundAttachment',
            'backgroundClip',
            'backgroundColor',
            'backgroundImage',
            'backgroundOrigin',
            'backgroundPositionX',
            'backgroundPositionY',
            'backgroundRepeat',
            'backgroundSize'
        ],
        backgroundPosition: [
            'backgroundPositionX',
            'backgroundPositionY'
        ],
        border: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth',
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth',
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth',
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth',
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderBlockEnd: [
            'borderBlockEndColor',
            'borderBlockEndStyle',
            'borderBlockEndWidth'
        ],
        borderBlockStart: [
            'borderBlockStartColor',
            'borderBlockStartStyle',
            'borderBlockStartWidth'
        ],
        borderBottom: [
            'borderBottomColor',
            'borderBottomStyle',
            'borderBottomWidth'
        ],
        borderColor: [
            'borderBottomColor',
            'borderLeftColor',
            'borderRightColor',
            'borderTopColor'
        ],
        borderImage: [
            'borderImageOutset',
            'borderImageRepeat',
            'borderImageSlice',
            'borderImageSource',
            'borderImageWidth'
        ],
        borderInlineEnd: [
            'borderInlineEndColor',
            'borderInlineEndStyle',
            'borderInlineEndWidth'
        ],
        borderInlineStart: [
            'borderInlineStartColor',
            'borderInlineStartStyle',
            'borderInlineStartWidth'
        ],
        borderLeft: [
            'borderLeftColor',
            'borderLeftStyle',
            'borderLeftWidth'
        ],
        borderRadius: [
            'borderBottomLeftRadius',
            'borderBottomRightRadius',
            'borderTopLeftRadius',
            'borderTopRightRadius'
        ],
        borderRight: [
            'borderRightColor',
            'borderRightStyle',
            'borderRightWidth'
        ],
        borderStyle: [
            'borderBottomStyle',
            'borderLeftStyle',
            'borderRightStyle',
            'borderTopStyle'
        ],
        borderTop: [
            'borderTopColor',
            'borderTopStyle',
            'borderTopWidth'
        ],
        borderWidth: [
            'borderBottomWidth',
            'borderLeftWidth',
            'borderRightWidth',
            'borderTopWidth'
        ],
        columnRule: [
            'columnRuleColor',
            'columnRuleStyle',
            'columnRuleWidth'
        ],
        columns: [
            'columnCount',
            'columnWidth'
        ],
        flex: [
            'flexBasis',
            'flexGrow',
            'flexShrink'
        ],
        flexFlow: [
            'flexDirection',
            'flexWrap'
        ],
        font: [
            'fontFamily',
            'fontFeatureSettings',
            'fontKerning',
            'fontLanguageOverride',
            'fontSize',
            'fontSizeAdjust',
            'fontStretch',
            'fontStyle',
            'fontVariant',
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition',
            'fontWeight',
            'lineHeight'
        ],
        fontVariant: [
            'fontVariantAlternates',
            'fontVariantCaps',
            'fontVariantEastAsian',
            'fontVariantLigatures',
            'fontVariantNumeric',
            'fontVariantPosition'
        ],
        gap: [
            'columnGap',
            'rowGap'
        ],
        grid: [
            'gridAutoColumns',
            'gridAutoFlow',
            'gridAutoRows',
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        gridArea: [
            'gridColumnEnd',
            'gridColumnStart',
            'gridRowEnd',
            'gridRowStart'
        ],
        gridColumn: [
            'gridColumnEnd',
            'gridColumnStart'
        ],
        gridColumnGap: [
            'columnGap'
        ],
        gridGap: [
            'columnGap',
            'rowGap'
        ],
        gridRow: [
            'gridRowEnd',
            'gridRowStart'
        ],
        gridRowGap: [
            'rowGap'
        ],
        gridTemplate: [
            'gridTemplateAreas',
            'gridTemplateColumns',
            'gridTemplateRows'
        ],
        listStyle: [
            'listStyleImage',
            'listStylePosition',
            'listStyleType'
        ],
        margin: [
            'marginBottom',
            'marginLeft',
            'marginRight',
            'marginTop'
        ],
        marker: [
            'markerEnd',
            'markerMid',
            'markerStart'
        ],
        mask: [
            'maskClip',
            'maskComposite',
            'maskImage',
            'maskMode',
            'maskOrigin',
            'maskPositionX',
            'maskPositionY',
            'maskRepeat',
            'maskSize'
        ],
        maskPosition: [
            'maskPositionX',
            'maskPositionY'
        ],
        outline: [
            'outlineColor',
            'outlineStyle',
            'outlineWidth'
        ],
        overflow: [
            'overflowX',
            'overflowY'
        ],
        padding: [
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'paddingTop'
        ],
        placeContent: [
            'alignContent',
            'justifyContent'
        ],
        placeItems: [
            'alignItems',
            'justifyItems'
        ],
        placeSelf: [
            'alignSelf',
            'justifySelf'
        ],
        textDecoration: [
            'textDecorationColor',
            'textDecorationLine',
            'textDecorationStyle'
        ],
        textEmphasis: [
            'textEmphasisColor',
            'textEmphasisStyle'
        ],
        transition: [
            'transitionDelay',
            'transitionDuration',
            'transitionProperty',
            'transitionTimingFunction'
        ],
        wordWrap: [
            'overflowWrap'
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf('--') === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === 'float') styleName = 'cssFloat';
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === 'boolean' || value === '';
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + ',' + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? 'Removing' : 'Updating', originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === 'object')) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    var IS_REPLAYED = 16;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (!(typeof restoreImpl === 'function')) throw Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var discreteUpdatesImpl = function(fn, a, b, c, d) {
        return fn(a, b, c, d);
    };
    var flushDiscreteUpdatesImpl = function() {};
    var batchedEventUpdatesImpl = batchedUpdatesImpl;
    var isInsideEventHandler = false;
    var isBatchingEventUpdates = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            flushDiscreteUpdatesImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, bookkeeping) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(bookkeeping);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, bookkeeping);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    }
    function batchedEventUpdates(fn, a, b) {
        if (isBatchingEventUpdates) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isBatchingEventUpdates = true;
        try {
            return batchedEventUpdatesImpl(fn, a, b);
        } finally{
            isBatchingEventUpdates = false;
            finishEventHandler();
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var prevIsInsideEventHandler = isInsideEventHandler;
        isInsideEventHandler = true;
        try {
            return discreteUpdatesImpl(fn, a, b, c, d);
        } finally{
            isInsideEventHandler = prevIsInsideEventHandler;
            if (!isInsideEventHandler) finishEventHandler();
        }
    }
    function flushDiscreteUpdatesIfNeeded(timeStamp) {
        if (!isInsideEventHandler) flushDiscreteUpdatesImpl();
    }
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushDiscreteUpdatesImpl, _batchedEventUpdatesImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        discreteUpdatesImpl = _discreteUpdatesImpl;
        flushDiscreteUpdatesImpl = _flushDiscreteUpdatesImpl;
        batchedEventUpdatesImpl = _batchedEventUpdatesImpl;
    }
    function isInteractive(tag) {
        return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case 'onClick':
            case 'onClickCapture':
            case 'onDoubleClick':
            case 'onDoubleClickCapture':
            case 'onMouseDown':
            case 'onMouseDownCapture':
            case 'onMouseMove':
            case 'onMouseMoveCapture':
            case 'onMouseUp':
            case 'onMouseUpCapture':
            case 'onMouseEnter':
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (!(!listener || typeof listener === 'function')) throw Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, 'passive', {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener('test', options, options);
        window.removeEventListener('test', options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
        var fakeNode = document.createElement('react');
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebookincubator/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (!(typeof document !== 'undefined')) throw Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent('Event');
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, 'event');
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== 'undefined' && window.hasOwnProperty('event')) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === 'object') try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : 'invokeguardedcallback'); // Attach our event handlers
            window.addEventListener('error', handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, 'event', windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener('error', handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var PlacementAndUpdate = /*           */ 6;
    var Deletion = /*                     */ 8;
    var ContentReset = /*                 */ 16;
    var Callback = /*                     */ 32;
    var DidCapture = /*                   */ 64;
    var Ref = /*                          */ 128;
    var Snapshot = /*                     */ 256;
    var Passive = /*                      */ 512; // TODO (effects) Remove this bit once the new reconciler is synced to the old.
    var PassiveUnmountPendingDev = /*     */ 8192;
    var Hydrating = /*                    */ 1024;
    var HydratingAndUpdate = /*           */ 1028; // Passive & Update & Callback & Ref & Snapshot
    var LifecycleEffectMask = /*          */ 932; // Union of all host effects
    var HostEffectMask = /*               */ 2047; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 2048;
    var ShouldCapture = /*                */ 4096;
    var ForceUpdateForLegacySuspense = /* */ 16384; // Static tags describe aspects of a fiber that are not specific to a render,
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(ownerFiber.type) || 'A component');
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (!(getNearestMountedFiber(fiber) === fiber)) throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (!(nearestMounted !== null)) throw Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                throw Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (!(a.alternate === b)) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (!(a.tag === HostRoot)) throw Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText) return node;
            else if (node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        if (!currentParent) return null;
         // Next we'll drill down this component to find the first HostComponent/Text.
        var node = currentParent;
        while(true){
            if (node.tag === HostComponent || node.tag === HostText || enableFundamentalAPI) return node;
            else if (node.child && node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === currentParent) return null;
            while(!node.sibling){
                if (!node.return || node.return === currentParent) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow needs the return null here, but ESLint complains about it.
        // eslint-disable-next-line no-unreachable
        return null;
    }
    function doesFiberContain(parentFiber, childFiber) {
        var node = childFiber;
        var parentFiberAlternate = parentFiber.alternate;
        while(node !== null){
            if (node === parentFiber || node === parentFiberAlternate) return true;
            node = node.return;
        }
        return false;
    }
    var attemptUserBlockingHydration;
    function setAttemptUserBlockingHydration(fn) {
        attemptUserBlockingHydration = fn;
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    function hasQueuedDiscreteEvents() {
        return queuedDiscreteEvents.length > 0;
    }
    var discreteReplayableEvents = [
        'mousedown',
        'mouseup',
        'touchcancel',
        'touchend',
        'touchstart',
        'auxclick',
        'dblclick',
        'pointercancel',
        'pointerdown',
        'pointerup',
        'dragend',
        'dragstart',
        'drop',
        'compositionend',
        'compositionstart',
        'keydown',
        'keypress',
        'keyup',
        'input',
        'textInput',
        'copy',
        'cut',
        'paste',
        'click',
        'change',
        'contextmenu',
        'reset',
        'submit'
    ];
    function isReplayableDiscreteEvent(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags | IS_REPLAYED,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
        queuedDiscreteEvents.push(queuedEvent);
    } // Resets the replaying for this type of continuous event to no event.
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case 'focusin':
            case 'focusout':
                queuedFocus = null;
                break;
            case 'dragenter':
            case 'dragleave':
                queuedDrag = null;
                break;
            case 'mouseover':
            case 'mouseout':
                queuedMouse = null;
                break;
            case 'pointerover':
            case 'pointerout':
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case 'focusin':
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case 'dragenter':
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case 'mouseover':
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case 'pointerover':
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case 'gotpointercapture':
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with attemptToDispatchEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.lanePriority, function() {
                            Scheduler.unstable_runWithPriority(queuedTarget.priority, function() {
                                attemptHydrationAtCurrentPriority(nearestMounted);
                            });
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = attemptToDispatchEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn !== null) {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false; // First replay discrete events.
        while(queuedDiscreteEvents.length > 0){
            var nextDiscreteEvent = queuedDiscreteEvents[0];
            if (nextDiscreteEvent.blockedOn !== null) {
                // We're still blocked.
                // Increase the priority of this boundary to unblock
                // the next discrete event.
                var _fiber4 = getInstanceFromNode(nextDiscreteEvent.blockedOn);
                if (_fiber4 !== null) attemptUserBlockingHydration(_fiber4);
                break;
            }
            var targetContainers = nextDiscreteEvent.targetContainers;
            while(targetContainers.length > 0){
                var targetContainer = targetContainers[0];
                var nextBlockedOn = attemptToDispatchEvent(nextDiscreteEvent.domEventName, nextDiscreteEvent.eventSystemFlags, targetContainer, nextDiscreteEvent.nativeEvent);
                if (nextBlockedOn !== null) {
                    // We're still blocked. Try again later.
                    nextDiscreteEvent.blockedOn = nextBlockedOn;
                    break;
                } // This target container was successfully dispatched. Try the next.
                targetContainers.shift();
            }
            if (nextDiscreteEvent.blockedOn === null) // We've successfully replayed the first event. Let's try the next one.
            queuedDiscreteEvents.shift();
        } // Next replay any continuous events.
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var DiscreteEvent = 0;
    var UserBlockingEvent = 1;
    var ContinuousEvent = 2;
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes['Webkit' + styleProp] = 'webkit' + eventName;
        prefixes['Moz' + styleProp] = 'moz' + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
        animationstart: makePrefixMap('Animation', 'AnimationStart'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement('div').style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!('AnimationEvent' in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!('TransitionEvent' in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName('animationend');
    var ANIMATION_ITERATION = getVendorPrefixedEventName('animationiteration');
    var ANIMATION_START = getVendorPrefixedEventName('animationstart');
    var TRANSITION_END = getVendorPrefixedEventName('transitionend');
    var topLevelEventsToReactNames = new Map();
    var eventPriorities = new Map(); // We store most of the events in this module in pairs of two strings so we can re-use
    // the code required to apply the same logic for event prioritization and that of the
    // SimpleEventPlugin. This complicates things slightly, but the aim is to reduce code
    // duplication (for which there would be quite a bit). For the events that are not needed
    // for the SimpleEventPlugin (otherDiscreteEvents) we process them separately as an
    // array of top level events.
    // Lastly, we ignore prettier so we can keep the formatting sane.
    // prettier-ignore
    var discreteEventPairsForSimpleEventPlugin = [
        'cancel',
        'cancel',
        'click',
        'click',
        'close',
        'close',
        'contextmenu',
        'contextMenu',
        'copy',
        'copy',
        'cut',
        'cut',
        'auxclick',
        'auxClick',
        'dblclick',
        'doubleClick',
        'dragend',
        'dragEnd',
        'dragstart',
        'dragStart',
        'drop',
        'drop',
        'focusin',
        'focus',
        'focusout',
        'blur',
        'input',
        'input',
        'invalid',
        'invalid',
        'keydown',
        'keyDown',
        'keypress',
        'keyPress',
        'keyup',
        'keyUp',
        'mousedown',
        'mouseDown',
        'mouseup',
        'mouseUp',
        'paste',
        'paste',
        'pause',
        'pause',
        'play',
        'play',
        'pointercancel',
        'pointerCancel',
        'pointerdown',
        'pointerDown',
        'pointerup',
        'pointerUp',
        'ratechange',
        'rateChange',
        'reset',
        'reset',
        'seeked',
        'seeked',
        'submit',
        'submit',
        'touchcancel',
        'touchCancel',
        'touchend',
        'touchEnd',
        'touchstart',
        'touchStart',
        'volumechange',
        'volumeChange'
    ];
    var otherDiscreteEvents = [
        'change',
        'selectionchange',
        'textInput',
        'compositionstart',
        'compositionend',
        'compositionupdate'
    ];
    var userBlockingPairsForSimpleEventPlugin = [
        'drag',
        'drag',
        'dragenter',
        'dragEnter',
        'dragexit',
        'dragExit',
        'dragleave',
        'dragLeave',
        'dragover',
        'dragOver',
        'mousemove',
        'mouseMove',
        'mouseout',
        'mouseOut',
        'mouseover',
        'mouseOver',
        'pointermove',
        'pointerMove',
        'pointerout',
        'pointerOut',
        'pointerover',
        'pointerOver',
        'scroll',
        'scroll',
        'toggle',
        'toggle',
        'touchmove',
        'touchMove',
        'wheel',
        'wheel'
    ]; // prettier-ignore
    var continuousPairsForSimpleEventPlugin = [
        'abort',
        'abort',
        ANIMATION_END,
        'animationEnd',
        ANIMATION_ITERATION,
        'animationIteration',
        ANIMATION_START,
        'animationStart',
        'canplay',
        'canPlay',
        'canplaythrough',
        'canPlayThrough',
        'durationchange',
        'durationChange',
        'emptied',
        'emptied',
        'encrypted',
        'encrypted',
        'ended',
        'ended',
        'error',
        'error',
        'gotpointercapture',
        'gotPointerCapture',
        'load',
        'load',
        'loadeddata',
        'loadedData',
        'loadedmetadata',
        'loadedMetadata',
        'loadstart',
        'loadStart',
        'lostpointercapture',
        'lostPointerCapture',
        'playing',
        'playing',
        'progress',
        'progress',
        'seeking',
        'seeking',
        'stalled',
        'stalled',
        'suspend',
        'suspend',
        'timeupdate',
        'timeUpdate',
        TRANSITION_END,
        'transitionEnd',
        'waiting',
        'waiting'
    ];
    /**
 * Turns
 * ['abort', ...]
 *
 * into
 *
 * topLevelEventsToReactNames = new Map([
 *   ['abort', 'onAbort'],
 * ]);
 *
 * and registers them.
 */ function registerSimplePluginEventsAndSetTheirPriorities(eventTypes, priority) {
        // As the event types are in pairs of two, we need to iterate
        // through in twos. The events are in pairs of two to save code
        // and improve init perf of processing this array, as it will
        // result in far fewer object allocations and property accesses
        // if we only use three arrays to process all the categories of
        // instead of tuples.
        for(var i = 0; i < eventTypes.length; i += 2){
            var topEvent = eventTypes[i];
            var event = eventTypes[i + 1];
            var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
            var reactName = 'on' + capitalizedEvent;
            eventPriorities.set(topEvent, priority);
            topLevelEventsToReactNames.set(topEvent, reactName);
            registerTwoPhaseEvent(reactName, [
                topEvent
            ]);
        }
    }
    function setEventPriorities(eventTypes, priority) {
        for(var i = 0; i < eventTypes.length; i++)eventPriorities.set(eventTypes[i], priority);
    }
    function getEventPriorityForPluginSystem(domEventName) {
        var priority = eventPriorities.get(domEventName); // Default to a ContinuousEvent. Note: we might
        // want to warn if we can't detect the priority
        // for the event.
        return priority === undefined ? ContinuousEvent : priority;
    }
    function registerSimpleEvents() {
        registerSimplePluginEventsAndSetTheirPriorities(discreteEventPairsForSimpleEventPlugin, DiscreteEvent);
        registerSimplePluginEventsAndSetTheirPriorities(userBlockingPairsForSimpleEventPlugin, UserBlockingEvent);
        registerSimplePluginEventsAndSetTheirPriorities(continuousPairsForSimpleEventPlugin, ContinuousEvent);
        setEventPriorities(otherDiscreteEvents, DiscreteEvent);
    }
    var Scheduler_now = Scheduler.unstable_now;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority = 99;
    var UserBlockingPriority = 98;
    var NormalPriority = 97;
    var LowPriority = 96;
    var IdlePriority = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority = 90;
    var initialTimeMs = Scheduler_now(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    var SyncLanePriority = 15;
    var SyncBatchedLanePriority = 14;
    var InputDiscreteHydrationLanePriority = 13;
    var InputDiscreteLanePriority = 12;
    var InputContinuousHydrationLanePriority = 11;
    var InputContinuousLanePriority = 10;
    var DefaultHydrationLanePriority = 9;
    var DefaultLanePriority = 8;
    var TransitionHydrationPriority = 7;
    var TransitionPriority = 6;
    var RetryLanePriority = 5;
    var SelectiveHydrationLanePriority = 4;
    var IdleHydrationLanePriority = 3;
    var IdleLanePriority = 2;
    var OffscreenLanePriority = 1;
    var NoLanePriority = 0;
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var SyncBatchedLane = /*                 */ 2;
    var InputDiscreteHydrationLane = /*      */ 4;
    var InputDiscreteLanes = /*                    */ 24;
    var InputContinuousHydrationLane = /*           */ 32;
    var InputContinuousLanes = /*                  */ 192;
    var DefaultHydrationLane = /*            */ 256;
    var DefaultLanes = /*                   */ 3584;
    var TransitionHydrationLane = /*                */ 4096;
    var TransitionLanes = /*                       */ 4186112;
    var RetryLanes = /*                            */ 62914560;
    var SomeRetryLane = /*                  */ 33554432;
    var SelectiveHydrationLane = /*          */ 67108864;
    var NonIdleLanes = /*                                 */ 134217727;
    var IdleHydrationLane = /*               */ 134217728;
    var IdleLanes = /*                             */ 805306368;
    var OffscreenLane = /*                   */ 1073741824;
    var NoTimestamp = -1;
    function setCurrentUpdateLanePriority(newLanePriority) {} // "Registers" used to "return" multiple values
    // Used by getHighestPriorityLanes and getNextLanes:
    var return_highestLanePriority = DefaultLanePriority;
    function getHighestPriorityLanes(lanes) {
        if ((SyncLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncLanePriority;
            return SyncLane;
        }
        if ((SyncBatchedLane & lanes) !== NoLanes) {
            return_highestLanePriority = SyncBatchedLanePriority;
            return SyncBatchedLane;
        }
        if ((InputDiscreteHydrationLane & lanes) !== NoLanes) {
            return_highestLanePriority = InputDiscreteHydrationLanePriority;
            return InputDiscreteHydrationLane;
        }
        var inputDiscreteLanes = InputDiscreteLanes & lanes;
        if (inputDiscreteLanes !== NoLanes) {
            return_highestLanePriority = InputDiscreteLanePriority;
            return inputDiscreteLanes;
        }
        if ((lanes & InputContinuousHydrationLane) !== NoLanes) {
            return_highestLanePriority = InputContinuousHydrationLanePriority;
            return InputContinuousHydrationLane;
        }
        var inputContinuousLanes = InputContinuousLanes & lanes;
        if (inputContinuousLanes !== NoLanes) {
            return_highestLanePriority = InputContinuousLanePriority;
            return inputContinuousLanes;
        }
        if ((lanes & DefaultHydrationLane) !== NoLanes) {
            return_highestLanePriority = DefaultHydrationLanePriority;
            return DefaultHydrationLane;
        }
        var defaultLanes = DefaultLanes & lanes;
        if (defaultLanes !== NoLanes) {
            return_highestLanePriority = DefaultLanePriority;
            return defaultLanes;
        }
        if ((lanes & TransitionHydrationLane) !== NoLanes) {
            return_highestLanePriority = TransitionHydrationPriority;
            return TransitionHydrationLane;
        }
        var transitionLanes = TransitionLanes & lanes;
        if (transitionLanes !== NoLanes) {
            return_highestLanePriority = TransitionPriority;
            return transitionLanes;
        }
        var retryLanes = RetryLanes & lanes;
        if (retryLanes !== NoLanes) {
            return_highestLanePriority = RetryLanePriority;
            return retryLanes;
        }
        if (lanes & SelectiveHydrationLane) {
            return_highestLanePriority = SelectiveHydrationLanePriority;
            return SelectiveHydrationLane;
        }
        if ((lanes & IdleHydrationLane) !== NoLanes) {
            return_highestLanePriority = IdleHydrationLanePriority;
            return IdleHydrationLane;
        }
        var idleLanes = IdleLanes & lanes;
        if (idleLanes !== NoLanes) {
            return_highestLanePriority = IdleLanePriority;
            return idleLanes;
        }
        if ((OffscreenLane & lanes) !== NoLanes) {
            return_highestLanePriority = OffscreenLanePriority;
            return OffscreenLane;
        }
        error('Should have found matching lanes. This is a bug in React.');
        return_highestLanePriority = DefaultLanePriority;
        return lanes;
    }
    function schedulerPriorityToLanePriority(schedulerPriorityLevel) {
        switch(schedulerPriorityLevel){
            case ImmediatePriority:
                return SyncLanePriority;
            case UserBlockingPriority:
                return InputContinuousLanePriority;
            case NormalPriority:
            case LowPriority:
                // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                return DefaultLanePriority;
            case IdlePriority:
                return IdleLanePriority;
            default:
                return NoLanePriority;
        }
    }
    function lanePriorityToSchedulerPriority(lanePriority) {
        switch(lanePriority){
            case SyncLanePriority:
            case SyncBatchedLanePriority:
                return ImmediatePriority;
            case InputDiscreteHydrationLanePriority:
            case InputDiscreteLanePriority:
            case InputContinuousHydrationLanePriority:
            case InputContinuousLanePriority:
                return UserBlockingPriority;
            case DefaultHydrationLanePriority:
            case DefaultLanePriority:
            case TransitionHydrationPriority:
            case TransitionPriority:
            case SelectiveHydrationLanePriority:
            case RetryLanePriority:
                return NormalPriority;
            case IdleHydrationLanePriority:
            case IdleLanePriority:
            case OffscreenLanePriority:
                return IdlePriority;
            case NoLanePriority:
                return NoPriority;
            default:
                throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) {
            return_highestLanePriority = NoLanePriority;
            return NoLanes;
        }
        var nextLanes = NoLanes;
        var nextLanePriority = NoLanePriority;
        var expiredLanes = root.expiredLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Check if any work has expired.
        if (expiredLanes !== NoLanes) {
            nextLanes = expiredLanes;
            nextLanePriority = return_highestLanePriority = SyncLanePriority;
        } else {
            // Do not work on any idle work until all the non-idle work has finished,
            // even if the work is suspended.
            var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
            if (nonIdlePendingLanes !== NoLanes) {
                var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
                if (nonIdleUnblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else {
                    var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                    if (nonIdlePingedLanes !== NoLanes) {
                        nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
                        nextLanePriority = return_highestLanePriority;
                    }
                }
            } else {
                // The only remaining work is Idle.
                var unblockedLanes = pendingLanes & ~suspendedLanes;
                if (unblockedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(unblockedLanes);
                    nextLanePriority = return_highestLanePriority;
                } else if (pingedLanes !== NoLanes) {
                    nextLanes = getHighestPriorityLanes(pingedLanes);
                    nextLanePriority = return_highestLanePriority;
                }
            }
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If there are higher priority lanes, we'll include them even if they
        // are suspended.
        nextLanes = pendingLanes & getEqualOrHigherPriorityLanes(nextLanes); // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            getHighestPriorityLanes(wipLanes);
            var wipLanePriority = return_highestLanePriority;
            if (nextLanePriority <= wipLanePriority) return wipLanes;
            else return_highestLanePriority = nextLanePriority;
        } // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        // TODO: Expiration heuristic is constant per lane, so could use a map.
        getHighestPriorityLanes(lane);
        var priority = return_highestLanePriority;
        if (priority >= InputContinuousLanePriority) // User interactions should expire slightly more quickly.
        //
        // NOTE: This is set to the corresponding constant as in Scheduler.js. When
        // we made it larger, a product metric in www regressed, suggesting there's
        // a user interaction that's being starved by a series of synchronous
        // updates. If that theory is correct, the proper solution is to fix the
        // starvation. However, this scenario supports the idea that expiration
        // times are an important safeguard when starvation does happen.
        //
        // Also note that, in the case of user input specifically, this will soon no
        // longer be an issue because we plan to make user input synchronous by
        // default (until you enter `startTransition`, of course.)
        //
        // If weren't planning to make these updates synchronous soon anyway, I
        // would probably make this number a configurable parameter.
        return currentTime + 250;
        else if (priority >= TransitionPriority) return currentTime + 5000;
        else // Anything idle priority or lower should never expire.
        return NoTimestamp;
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function returnNextLanesPriority() {
        return return_highestLanePriority;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    } // To ensure consistency across multiple updates in the same event, this should
    // be a pure function, so that it always returns the same lane for given inputs.
    function findUpdateLane(lanePriority, wipLanes) {
        switch(lanePriority){
            case NoLanePriority:
                break;
            case SyncLanePriority:
                return SyncLane;
            case SyncBatchedLanePriority:
                return SyncBatchedLane;
            case InputDiscreteLanePriority:
                var _lane = pickArbitraryLane(InputDiscreteLanes & ~wipLanes);
                if (_lane === NoLane) // Shift to the next priority level
                return findUpdateLane(InputContinuousLanePriority, wipLanes);
                return _lane;
            case InputContinuousLanePriority:
                var _lane2 = pickArbitraryLane(InputContinuousLanes & ~wipLanes);
                if (_lane2 === NoLane) // Shift to the next priority level
                return findUpdateLane(DefaultLanePriority, wipLanes);
                return _lane2;
            case DefaultLanePriority:
                var _lane3 = pickArbitraryLane(DefaultLanes & ~wipLanes);
                if (_lane3 === NoLane) {
                    // If all the default lanes are already being worked on, look for a
                    // lane in the transition range.
                    _lane3 = pickArbitraryLane(TransitionLanes & ~wipLanes);
                    if (_lane3 === NoLane) // All the transition lanes are taken, too. This should be very
                    // rare, but as a last resort, pick a default lane. This will have
                    // the effect of interrupting the current work-in-progress render.
                    _lane3 = pickArbitraryLane(DefaultLanes);
                }
                return _lane3;
            case TransitionPriority:
            case RetryLanePriority:
                break;
            case IdleLanePriority:
                var lane = pickArbitraryLane(IdleLanes & ~wipLanes);
                if (lane === NoLane) lane = pickArbitraryLane(IdleLanes);
                return lane;
        }
        throw Error("Invalid update priority: " + lanePriority + ". This is a bug in React.");
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findTransitionLane(wipLanes, pendingLanes) {
        // First look for lanes that are completely unclaimed, i.e. have no
        // pending work.
        var lane = pickArbitraryLane(TransitionLanes & ~pendingLanes);
        if (lane === NoLane) {
            // If all lanes have pending work, look for a lane that isn't currently
            // being worked on.
            lane = pickArbitraryLane(TransitionLanes & ~wipLanes);
            if (lane === NoLane) // If everything is being worked on, pick any lane. This has the
            // effect of interrupting the current work-in-progress.
            lane = pickArbitraryLane(TransitionLanes);
        }
        return lane;
    } // To ensure consistency across multiple updates in the same event, this should
    // be pure function, so that it always returns the same lane for given inputs.
    function findRetryLane(wipLanes) {
        // This is a fork of `findUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        var lane = pickArbitraryLane(RetryLanes & ~wipLanes);
        if (lane === NoLane) lane = pickArbitraryLane(RetryLanes);
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function getLowestPriorityLane(lanes) {
        // This finds the most significant non-zero bit.
        var index = 31 - clz32(lanes);
        return index < 0 ? NoLanes : 1 << index;
    }
    function getEqualOrHigherPriorityLanes(lanes) {
        return (getLowestPriorityLane(lanes) << 1) - 1;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // TODO: Theoretically, any update to any lane can unblock any other lane. But
        // it's not practical to try every single possible combination. We need a
        // heuristic to decide which lanes to attempt to render, and in which batches.
        // For now, we use the same heuristic as in the old ExpirationTimes model:
        // retry any lane at equal or lower priority, but don't try updates at higher
        // priority without also including the lower priority updates. This works well
        // when considering updates across different priority levels, but isn't
        // sufficient for updates within the same priority, since we want to treat
        // those updates as parallel.
        // Unsuspend any update at equal or lower priority.
        var higherPriorityLanes = updateLane - 1; // Turns 0b1000 into 0b0111
        root.suspendedLanes &= higherPriorityLanes;
        root.pingedLanes &= higherPriorityLanes;
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markDiscreteUpdatesExpired(root) {
        root.expiredLanes |= InputDiscreteLanes & root.pendingLanes;
    }
    function hasDiscreteLanes(lanes) {
        return (lanes & InputDiscreteLanes) !== NoLanes;
    }
    function markRootMutableRead(root, updateLane) {
        root.mutableReadLanes |= updateLane & root.pendingLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = entangledLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros. Only used on lanes, so assume input is an integer.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(lanes) {
        if (lanes === 0) return 32;
        return 31 - (log(lanes) / LN2 | 0) | 0;
    }
    // Intentionally not named imports because Rollup would use dynamic dispatch for
    var UserBlockingPriority$1 = Scheduler.unstable_UserBlockingPriority, runWithPriority = Scheduler.unstable_runWithPriority; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriorityForPluginSystem(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEvent:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case UserBlockingEvent:
                listenerWrapper = dispatchUserBlockingUpdate;
                break;
            case ContinuousEvent:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        flushDiscreteUpdatesIfNeeded(nativeEvent.timeStamp);
        discreteUpdates(dispatchEvent, domEventName, eventSystemFlags, container, nativeEvent);
    }
    function dispatchUserBlockingUpdate(domEventName, eventSystemFlags, container, nativeEvent) {
        runWithPriority(UserBlockingPriority$1, dispatchEvent.bind(null, domEventName, eventSystemFlags, container, nativeEvent));
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        var allowReplay = true;
        // TODO: replaying capture phase events is currently broken
        // because we used to do it during top-level native bubble handlers
        // but now we use different bubble and capture handlers.
        // In eager mode, we attach capture listeners early, so we need
        // to filter them out until we fix the logic to handle them correctly.
        // This could've been outside the flag but I put it inside to reduce risk.
        allowReplay = (eventSystemFlags & IS_CAPTURE_PHASE) === 0;
        if (allowReplay && hasQueuedDiscreteEvents() && isReplayableDiscreteEvent(domEventName)) {
            // If we already have a queue of discrete events, and this is another discrete
            // event, then we can't dispatch it regardless of its target, since they
            // need to dispatch in order.
            queueDiscreteEvent(null, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            return;
        }
        var blockedOn = attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            // We successfully dispatched this event.
            if (allowReplay) clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (allowReplay) {
            if (isReplayableDiscreteEvent(domEventName)) {
                // This this to be replayed later once the target is available.
                queueDiscreteEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
                return;
            }
            if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) return;
             // We need to clear only if we didn't queue because
            // queueing is accummulative.
            clearIfContinuousEvent(domEventName, nativeEvent);
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    } // Attempt dispatching an event. Returns a SuspenseInstance or Container if it's blocked.
    function attemptToDispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (root.hydrate) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer); // We're not blocked on anything.
        return null;
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ('value' in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ('charCode' in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        _assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== 'unknown') event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== 'unknown') // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = _assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === 'mousemove') {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = _assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ('movementX' in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ('movementY' in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = _assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = _assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = _assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = _assign({}, EventInterface, {
        clipboardData: function(event) {
            return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = _assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: 'Escape',
        Spacebar: ' ',
        Left: 'ArrowLeft',
        Up: 'ArrowUp',
        Right: 'ArrowRight',
        Down: 'ArrowDown',
        Del: 'Delete',
        Win: 'OS',
        Menu: 'ContextMenu',
        Apps: 'ContextMenu',
        Scroll: 'ScrollLock',
        MozPrintableKey: 'Unidentified'
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        '8': 'Backspace',
        '9': 'Tab',
        '12': 'Clear',
        '13': 'Enter',
        '16': 'Shift',
        '17': 'Control',
        '18': 'Alt',
        '19': 'Pause',
        '20': 'CapsLock',
        '27': 'Escape',
        '32': ' ',
        '33': 'PageUp',
        '34': 'PageDown',
        '35': 'End',
        '36': 'Home',
        '37': 'ArrowLeft',
        '38': 'ArrowUp',
        '39': 'ArrowRight',
        '40': 'ArrowDown',
        '45': 'Insert',
        '46': 'Delete',
        '112': 'F1',
        '113': 'F2',
        '114': 'F3',
        '115': 'F4',
        '116': 'F5',
        '117': 'F6',
        '118': 'F7',
        '119': 'F8',
        '120': 'F9',
        '121': 'F10',
        '122': 'F11',
        '123': 'F12',
        '144': 'NumLock',
        '145': 'ScrollLock',
        '224': 'Meta'
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== 'Unidentified') return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === 'keypress') {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || 'Unidentified';
        return '';
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: 'altKey',
        Control: 'ctrlKey',
        Meta: 'metaKey',
        Shift: 'shiftKey'
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = _assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === 'keypress') return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === 'keypress') return getEventCharCode(event);
            if (event.type === 'keydown' || event.type === 'keyup') return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = _assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = _assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = _assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = _assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return 'deltaX' in event ? event.deltaX : 'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return 'deltaY' in event ? event.deltaY : 'wheelDeltaY' in event ? -event.wheelDeltaY : 'wheelDelta' in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && 'CompositionEvent' in window;
    var documentMode = null;
    if (canUseDOM && 'documentMode' in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && 'TextEvent' in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent('onBeforeInput', [
            'compositionend',
            'keypress',
            'textInput',
            'paste'
        ]);
        registerTwoPhaseEvent('onCompositionEnd', [
            'compositionend',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionStart', [
            'compositionstart',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
        registerTwoPhaseEvent('onCompositionUpdate', [
            'compositionupdate',
            'focusout',
            'keydown',
            'keypress',
            'keyup',
            'mousedown'
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case 'compositionstart':
                return 'onCompositionStart';
            case 'compositionend':
                return 'onCompositionEnd';
            case 'compositionupdate':
                return 'onCompositionUpdate';
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === 'keydown' && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case 'keyup':
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case 'keydown':
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case 'keypress':
            case 'mousedown':
            case 'focusout':
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === 'object' && 'data' in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === 'ko';
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = 'onCompositionStart';
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = 'onCompositionEnd';
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === 'onCompositionStart') isComposing = initialize(nativeEventTarget);
            else if (eventType === 'onCompositionEnd') {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case 'compositionend':
                return getDataFromCustomEvent(nativeEvent);
            case 'keypress':
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case 'textInput':
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === 'compositionend' || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case 'paste':
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case 'keypress':
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case 'compositionend':
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, 'onBeforeInput');
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent('onBeforeInput', 'beforeinput', null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === 'input') return !!supportedInputTypes[elem.type];
        if (nodeName === 'textarea') return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = 'on' + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement('div');
            element.setAttribute(eventName, 'return;');
            isSupported = typeof element[eventName] === 'function';
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent('onChange', [
            'change',
            'click',
            'focusin',
            'focusout',
            'input',
            'keydown',
            'keyup',
            'selectionchange'
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, 'onChange');
        if (listeners.length > 0) {
            var event = new SyntheticEvent('onChange', 'change', null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === 'change') return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent('onpropertychange', handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent('onpropertychange', handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== 'value') return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === 'focusin') {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === 'focusout') stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === 'selectionchange' || domEventName === 'keyup' || domEventName === 'keydown') // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === 'click') return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === 'input' || domEventName === 'change') return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== 'number') return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, 'number', node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === 'focusout') handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent('onMouseEnter', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onMouseLeave', [
            'mouseout',
            'mouseover'
        ]);
        registerDirectEvent('onPointerEnter', [
            'pointerout',
            'pointerover'
        ]);
        registerDirectEvent('onPointerLeave', [
            'pointerout',
            'pointerover'
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === 'mouseover' || domEventName === 'pointerover';
        var isOutEvent = domEventName === 'mouseout' || domEventName === 'pointerout';
        if (isOverEvent && (eventSystemFlags & IS_REPLAYED) === 0) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = 'onMouseLeave';
        var enterEventType = 'onMouseEnter';
        var eventTypePrefix = 'mouse';
        if (domEventName === 'pointerout' || domEventName === 'pointerover') {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = 'onPointerLeave';
            enterEventType = 'onPointerEnter';
            eventTypePrefix = 'pointer';
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + 'leave', from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + 'enter', to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            if (!hasOwnProperty$2.call(objB, keysA[i]) || !objectIs(objA[keysA[i]], objB[keysA[i]])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ('contains' in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === 'string';
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === 'input' && (elem.type === 'text' || elem.type === 'search' || elem.type === 'tel' || elem.type === 'url' || elem.type === 'password') || nodeName === 'textarea' || elem.contentEditable === 'true');
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === 'function') priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ('selectionStart' in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ('selectionStart' in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && 'documentMode' in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent('onSelect', [
            'focusout',
            'contextmenu',
            'dragend',
            'focusin',
            'keydown',
            'keyup',
            'mousedown',
            'mouseup',
            'selectionchange'
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ('selectionStart' in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, 'onSelect');
            if (listeners.length > 0) {
                var event = new SyntheticEvent('onSelect', 'select', null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case 'focusin':
                if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case 'focusout':
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case 'mousedown':
                mouseDown = true;
                break;
            case 'contextmenu':
            case 'mouseup':
            case 'dragend':
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case 'selectionchange':
                if (skipSelectionChangeEvent) break;
            // falls through
            case 'keydown':
            case 'keyup':
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case 'keypress':
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case 'keydown':
            case 'keyup':
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case 'focusin':
                reactEventType = 'focus';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'focusout':
                reactEventType = 'blur';
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'beforeblur':
            case 'afterblur':
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case 'click':
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case 'auxclick':
            case 'dblclick':
            case 'mousedown':
            case 'mousemove':
            case 'mouseup':
            /* falls through */ case 'mouseout':
            case 'mouseover':
            case 'contextmenu':
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case 'drag':
            case 'dragend':
            case 'dragenter':
            case 'dragexit':
            case 'dragleave':
            case 'dragover':
            case 'dragstart':
            case 'drop':
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case 'touchcancel':
            case 'touchend':
            case 'touchmove':
            case 'touchstart':
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case 'scroll':
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case 'wheel':
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case 'copy':
            case 'cut':
            case 'paste':
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case 'gotpointercapture':
            case 'lostpointercapture':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerup':
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === 'scroll';
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't forsee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        'abort',
        'canplay',
        'canplaythrough',
        'durationchange',
        'emptied',
        'encrypted',
        'ended',
        'error',
        'loadeddata',
        'loadedmetadata',
        'loadstart',
        'pause',
        'play',
        'playing',
        'progress',
        'ratechange',
        'seeked',
        'seeking',
        'stalled',
        'suspend',
        'timeupdate',
        'volumechange',
        'waiting'
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        'cancel',
        'close',
        'invalid',
        'load',
        'scroll',
        'toggle'
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || 'unknown-event';
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    var listeningMarker = '_reactListening' + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (rootContainerElement[listeningMarker]) // Performance optimization: don't iterate through events
        // for the same portal container or root node more than once.
        // TODO: once we remove the flag, we may be able to also
        // remove some of the bookkeeping maps used for laziness.
        return;
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
            if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement, null);
            listenToNativeEvent(domEventName, true, rootContainerElement, null);
        });
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, rootContainerElement, targetElement) {
        var eventSystemFlags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
        var target = rootContainerElement; // selectionchange needs to be attached to the document
        // otherwise it won't capture incoming events that are only
        // triggered on the document directly.
        if (domEventName === 'selectionchange' && rootContainerElement.nodeType !== DOCUMENT_NODE) target = rootContainerElement.ownerDocument;
         // If the event can be delegated (or is capture phase), we can
        // register it to the root container. Otherwise, we should
        // register the event to the target element and mark it as
        // a non-delegated event.
        if (targetElement !== null && !isCapturePhaseListener && nonDelegatedEvents.has(domEventName)) {
            // For all non-delegated events, apart from scroll, we attach
            // their event listeners to the respective elements that their
            // events fire on. That means we can skip this step, as event
            // listener has already been added previously. However, we
            // special case the scroll event because the reality is that any
            // element can scroll.
            // TODO: ideally, we'd eventually apply the same logic to all
            // events from the nonDelegatedEvents list. Then we can remove
            // this special case and use the same logic for all events.
            if (domEventName !== 'scroll') return;
            eventSystemFlags |= IS_NON_DELEGATED;
            target = targetElement;
        }
        var listenerSet = getEventListenerSet(target);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener); // If the listener entry is empty or we should upgrade, then
        // we need to trap an event listener onto the target.
        if (!listenerSet.has(listenerSetKey)) {
            if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
            addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === 'touchstart' || domEventName === 'touchmove' || domEventName === 'wheel') isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedEventUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly) {
        var captureName = reactName !== null ? reactName + 'Capture' : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + 'Capture';
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? 'capture' : 'bubble');
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = 'dangerouslySetInnerHTML';
    var SUPPRESS_CONTENT_EDITABLE_WARNING = 'suppressContentEditableWarning';
    var SUPPRESS_HYDRATION_WARNING = 'suppressHydrationWarning';
    var AUTOFOCUS = 'autoFocus';
    var CHILDREN = 'children';
    var STYLE = 'style';
    var HTML$1 = '__html';
    var HTML_NAMESPACE$1 = Namespaces.html;
    var warnedUnknownTags;
    var suppressHydrationWarning;
    var validatePropertiesInDevelopment;
    var warnForTextDifference;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeMarkupForTextOrAttribute;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode; // HTML parsing normalizes CR and CRLF to LF.
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    normalizeMarkupForTextOrAttribute = function(markup) {
        var markupString = typeof markup === 'string' ? markup : '' + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, '\n').replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, '');
    };
    warnForTextDifference = function(serverText, clientText) {
        if (didWarnInvalidHydration) return;
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        didWarnInvalidHydration = true;
        error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
    };
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error('Prop `%s` did not match. Server: %s Client: %s', propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error('Extra attributes from the server: %s', names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error('Expected `%s` listener to be a function, instead got a value of `%s` type.', registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE$1 ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string') {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== 'textarea' || nextProp !== '';
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === 'number') setTextContent(domElement, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE$1) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === 'script') {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement('div');
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === 'string') // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === 'select') {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE$1) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === '[object HTMLUnknownElement]' && !Object.prototype.hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                props = rawProps;
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                props = rawProps;
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                props = rawProps;
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                props = rawProps;
                break;
            case 'input':
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$3(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'option':
                postMountWrapper$1(domElement, rawProps);
                break;
            case 'select':
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case 'input':
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'option':
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'select':
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            case 'textarea':
                lastProps = getHostProps$3(domElement, lastRawProps);
                nextProps = getHostProps$3(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== 'function' && typeof nextProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = '';
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = '';
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === 'string' || typeof nextProp === 'number') (updatePayload = updatePayload || []).push(propKey, '' + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else if (typeof nextProp === 'object' && nextProp !== null && nextProp.$$typeof === REACT_OPAQUE_ID_TYPE) // If we encounter useOpaqueReference's opaque object, this means we are hydrating.
            // In this case, call the opaque object's toString function which generates a new client
            // ID so client and server IDs match and throws to rerender.
            nextProp.toString();
            else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === 'input' && nextRawProps.type === 'radio' && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case 'input':
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case 'textarea':
                updateWrapper$1(domElement, nextRawProps);
                break;
            case 'select':
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement) {
        var isCustomComponentTag;
        var extraAttributeNames;
        suppressHydrationWarning = rawProps[SUPPRESS_HYDRATION_WARNING] === true;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case 'dialog':
                listenToNonDelegatedEvent('cancel', domElement);
                listenToNonDelegatedEvent('close', domElement);
                break;
            case 'iframe':
            case 'object':
            case 'embed':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'video':
            case 'audio':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case 'source':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent('error', domElement);
                break;
            case 'img':
            case 'image':
            case 'link':
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent('error', domElement);
                listenToNonDelegatedEvent('load', domElement);
                break;
            case 'details':
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent('toggle', domElement);
                break;
            case 'input':
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'option':
                validateProps(domElement, rawProps);
                break;
            case 'select':
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
            case 'textarea':
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent('invalid', domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Built-in SSR attribute is allowed
                case 'data-reactroot':
                    break;
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case 'value':
                    break;
                case 'checked':
                    break;
                case 'selected':
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === 'string') {
                    if (domElement.textContent !== nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === 'number') {
                    if (domElement.textContent !== '' + nextProp) {
                        if (!suppressHydrationWarning) warnForTextDifference(domElement.textContent, nextProp);
                        updatePayload = [
                            CHILDREN,
                            '' + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== 'function') warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === 'onScroll') listenToNonDelegatedEvent('scroll', domElement);
                }
            } else if (typeof isCustomComponentTag === 'boolean') {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = getPropertyInfo(propKey);
                if (suppressHydrationWarning) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === 'value' || propKey === 'checked' || propKey === 'selected') ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute('style');
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE$1) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE$1) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    if (nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        // $FlowFixMe - Should be inferred as not undefined.
        if (extraAttributeNames.size > 0 && !suppressHydrationWarning) // $FlowFixMe - Should be inferred as not undefined.
        warnForExtraAttributes(extraAttributeNames);
        switch(tag){
            case 'input':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case 'textarea':
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case 'select':
            case 'option':
                break;
            default:
                if (typeof rawProps.onClick === 'function') // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForUnmatchedText(textNode, text) {
        warnForTextDifference(textNode.nodeValue, text);
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain a <%s> in <%s>.', child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching <%s> in <%s>.', tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === '') // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case 'input':
                restoreControlledState(domElement, props);
                return;
            case 'textarea':
                restoreControlledState$2(domElement, props);
                return;
            case 'select':
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        'address',
        'applet',
        'area',
        'article',
        'aside',
        'base',
        'basefont',
        'bgsound',
        'blockquote',
        'body',
        'br',
        'button',
        'caption',
        'center',
        'col',
        'colgroup',
        'dd',
        'details',
        'dir',
        'div',
        'dl',
        'dt',
        'embed',
        'fieldset',
        'figcaption',
        'figure',
        'footer',
        'form',
        'frame',
        'frameset',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'iframe',
        'img',
        'input',
        'isindex',
        'li',
        'link',
        'listing',
        'main',
        'marquee',
        'menu',
        'menuitem',
        'meta',
        'nav',
        'noembed',
        'noframes',
        'noscript',
        'object',
        'ol',
        'p',
        'param',
        'plaintext',
        'pre',
        'script',
        'section',
        'select',
        'source',
        'style',
        'summary',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'title',
        'tr',
        'track',
        'ul',
        'wbr',
        'xmp'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        'applet',
        'caption',
        'html',
        'table',
        'td',
        'th',
        'marquee',
        'object',
        'template',
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        'foreignObject',
        'desc',
        'title'
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        'button'
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        'dd',
        'dt',
        'li',
        'option',
        'optgroup',
        'p',
        'rp',
        'rt'
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === 'form') ancestorInfo.formTag = info;
        if (tag === 'a') ancestorInfo.aTagInScope = info;
        if (tag === 'button') ancestorInfo.buttonTagInScope = info;
        if (tag === 'nobr') ancestorInfo.nobrTagInScope = info;
        if (tag === 'p') ancestorInfo.pTagInButtonScope = info;
        if (tag === 'li') ancestorInfo.listItemTagAutoclosing = info;
        if (tag === 'dd' || tag === 'dt') ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case 'select':
                return tag === 'option' || tag === 'optgroup' || tag === '#text';
            case 'optgroup':
                return tag === 'option' || tag === '#text';
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case 'option':
                return tag === '#text';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case 'tr':
                return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case 'tbody':
            case 'thead':
            case 'tfoot':
                return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case 'colgroup':
                return tag === 'col' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case 'table':
                return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case 'head':
                return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case 'html':
                return tag === 'head' || tag === 'body' || tag === 'frameset';
            case 'frameset':
                return tag === 'frame';
            case '#document':
                return tag === 'html';
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
            case 'rp':
            case 'rt':
                return impliedEndTags.indexOf(parentTag) === -1;
            case 'body':
            case 'caption':
            case 'col':
            case 'colgroup':
            case 'frameset':
            case 'frame':
            case 'head':
            case 'html':
            case 'tbody':
            case 'td':
            case 'tfoot':
            case 'th':
            case 'thead':
            case 'tr':
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case 'address':
            case 'article':
            case 'aside':
            case 'blockquote':
            case 'center':
            case 'details':
            case 'dialog':
            case 'dir':
            case 'div':
            case 'dl':
            case 'fieldset':
            case 'figcaption':
            case 'figure':
            case 'footer':
            case 'header':
            case 'hgroup':
            case 'main':
            case 'menu':
            case 'nav':
            case 'ol':
            case 'p':
            case 'section':
            case 'summary':
            case 'ul':
            case 'pre':
            case 'listing':
            case 'table':
            case 'hr':
            case 'xmp':
            case 'h1':
            case 'h2':
            case 'h3':
            case 'h4':
            case 'h5':
            case 'h6':
                return ancestorInfo.pTagInButtonScope;
            case 'form':
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case 'li':
                return ancestorInfo.listItemTagAutoclosing;
            case 'dd':
            case 'dt':
                return ancestorInfo.dlItemTagAutoclosing;
            case 'button':
                return ancestorInfo.buttonTagInScope;
            case 'a':
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case 'nobr':
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error('validateDOMNesting: when childText is passed, childTag should be null');
            childTag = '#text';
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = '';
        if (childTag === '#text') {
            if (/\S/.test(childText)) tagDisplayName = 'Text nodes';
            else {
                tagDisplayName = 'Whitespace text nodes';
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = '<' + childTag + '>';
        if (invalidParent) {
            var info = '';
            if (ancestorTag === 'table' && childTag === 'tr') info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error('validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s', tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1;
    SUPPRESS_HYDRATION_WARNING$1 = 'suppressHydrationWarning';
    var SUSPENSE_START_DATA = '$';
    var SUSPENSE_END_DATA = '/$';
    var SUSPENSE_PENDING_START_DATA = '$?';
    var SUSPENSE_FALLBACK_START_DATA = '$!';
    var STYLE$1 = 'style';
    var eventsEnabled = null;
    var selectionInformation = null;
    function shouldAutoFocusHostComponent(type, props) {
        switch(type){
            case 'button':
            case 'input':
            case 'select':
            case 'textarea':
                return !!props.autoFocus;
        }
        return false;
    }
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? '#document' : '#fragment';
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, '');
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === 'string' || typeof props.children === 'number') {
            var string = '' + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        return shouldAutoFocusHostComponent(type, props);
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === 'string' || typeof newProps.children === 'number')) {
            var string = '' + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === 'textarea' || type === 'option' || type === 'noscript' || typeof props.children === 'string' || typeof props.children === 'number' || typeof props.dangerouslySetInnerHTML === 'object' && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === 'function' ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === 'function' ? clearTimeout : undefined;
    var noTimeout = -1; // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        if (shouldAutoFocusHostComponent(type, newProps)) domElement.focus();
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps); // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, '');
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === 'function') style.setProperty('display', 'none', 'important');
        else style.display = 'none';
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = '';
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty('display') ? styleProp.display : null;
        instance.style.display = dangerousStyleValue('display', display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = '';
        else if (container.nodeType === DOCUMENT_NODE) {
            var body = container.body;
            if (body != null) body.textContent = '';
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === '' || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        return diffHydratedProperties(instance, type, props, parentNamespace);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, textInstance);
        return diffHydratedText(textInstance, text);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text) {
        warnForUnmatchedText(textInstance, text);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForUnmatchedText(textInstance, text);
    }
    function didNotHydrateContainerInstance(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableContainerInstance(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableContainerTextInstance(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function didNotFindHydratableSuspenseInstance(parentType, parentProps, parentInstance) {
        parentProps[SUPPRESS_HYDRATION_WARNING$1];
    }
    var clientId = 0;
    function makeClientIdInDEV(warnOnAccessInDEV) {
        var id = 'r:' + (clientId++).toString(36);
        return {
            toString: function() {
                warnOnAccessInDEV();
                return id;
            },
            valueOf: function() {
                warnOnAccessInDEV();
                return id;
            }
        };
    }
    function isOpaqueHydratingObject(value) {
        return value !== null && typeof value === 'object' && value.$$typeof === REACT_OPAQUE_ID_TYPE;
    }
    function makeOpaqueHydratingObject(attemptToReadValue) {
        return {
            $$typeof: REACT_OPAQUE_ID_TYPE,
            toString: attemptToReadValue,
            valueOf: attemptToReadValue
        };
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = '__reactFiber$' + randomKey;
    var internalPropsKey = '__reactProps$' + randomKey;
    var internalContainerInstanceKey = '__reactContainer$' + randomKey;
    var internalEventHandlersKey = '__reactEvents$' + randomKey;
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error('Unexpected pop.');
            return;
        }
        if (fiber !== fiberStack[index]) error('Unexpected Fiber popped.');
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(contextTypes, context, 'context', name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (!(contextStackCursor.current === emptyContextObject)) throw Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== 'function') {
            var componentName = getComponentName(type) || 'Unknown';
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw Error((getComponentName(type) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
        }
        var name = getComponentName(type) || 'Unknown';
        checkPropTypes(childContextTypes, childContext, 'child context', name);
        return _assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!(isFiberMounted(fiber) && fiber.tag === ClassComponent)) throw Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var BlockingRoot = 1;
    var ConcurrentRoot = 2;
    var rendererID = null;
    var injectedHook = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined';
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error('React instrumentation encountered an error: %s.', err);
        } // DevTools exists
        return true;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === 'function') try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitRoot(root, priorityLevel) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === 'function') try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) injectedHook.onCommitFiberRoot(rendererID, root, priorityLevel, didError);
            else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === 'function') try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error('React instrumentation encountered an error: %s', err);
            }
        }
    }
    var Scheduler_runWithPriority = Scheduler.unstable_runWithPriority, Scheduler_scheduleCallback = Scheduler.unstable_scheduleCallback, Scheduler_cancelCallback = Scheduler.unstable_cancelCallback, Scheduler_shouldYield = Scheduler.unstable_shouldYield, Scheduler_requestPaint = Scheduler.unstable_requestPaint, Scheduler_now$1 = Scheduler.unstable_now, Scheduler_getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, Scheduler_ImmediatePriority = Scheduler.unstable_ImmediatePriority, Scheduler_UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, Scheduler_NormalPriority = Scheduler.unstable_NormalPriority, Scheduler_LowPriority = Scheduler.unstable_LowPriority, Scheduler_IdlePriority = Scheduler.unstable_IdlePriority;
    // Provide explicit error message when production+profiling bundle of e.g.
    // react-dom is used with production (non-profiling) bundle of
    // scheduler/tracing
    if (!(tracing.__interactionsRef != null && tracing.__interactionsRef.current != null)) throw Error("It is not supported to run the profiling version of a renderer (for example, `react-dom/profiling`) without also replacing the `scheduler/tracing` module with `scheduler/tracing-profiling`. Your bundler might have a setting for aliasing both modules. Learn more at https://reactjs.org/link/profiling");
    var fakeCallbackNode = {}; // Except for NoPriority, these correspond to Scheduler priorities. We use
    // ascending numbers so we can compare them like numbers. They start at 90 to
    // avoid clashing with Scheduler's priorities.
    var ImmediatePriority$1 = 99;
    var UserBlockingPriority$2 = 98;
    var NormalPriority$1 = 97;
    var LowPriority$1 = 96;
    var IdlePriority$1 = 95; // NoPriority is the absence of priority. Also React-only.
    var NoPriority$1 = 90;
    var shouldYield = Scheduler_shouldYield;
    var requestPaint = Scheduler_requestPaint !== undefined ? Scheduler_requestPaint : function() {};
    var syncQueue = null;
    var immediateQueueCallbackNode = null;
    var isFlushingSyncQueue = false;
    var initialTimeMs$1 = Scheduler_now$1(); // If the initial timestamp is reasonably small, use Scheduler's `now` directly.
    // This will be the case for modern browsers that support `performance.now`. In
    // older browsers, Scheduler falls back to `Date.now`, which returns a Unix
    // timestamp. In that case, subtract the module initialization time to simulate
    // the behavior of performance.now and keep our times small enough to fit
    // within 32 bits.
    // TODO: Consider lifting this into Scheduler.
    var now = initialTimeMs$1 < 10000 ? Scheduler_now$1 : function() {
        return Scheduler_now$1() - initialTimeMs$1;
    };
    function getCurrentPriorityLevel() {
        switch(Scheduler_getCurrentPriorityLevel()){
            case Scheduler_ImmediatePriority:
                return ImmediatePriority$1;
            case Scheduler_UserBlockingPriority:
                return UserBlockingPriority$2;
            case Scheduler_NormalPriority:
                return NormalPriority$1;
            case Scheduler_LowPriority:
                return LowPriority$1;
            case Scheduler_IdlePriority:
                return IdlePriority$1;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function reactPriorityToSchedulerPriority(reactPriorityLevel) {
        switch(reactPriorityLevel){
            case ImmediatePriority$1:
                return Scheduler_ImmediatePriority;
            case UserBlockingPriority$2:
                return Scheduler_UserBlockingPriority;
            case NormalPriority$1:
                return Scheduler_NormalPriority;
            case LowPriority$1:
                return Scheduler_LowPriority;
            case IdlePriority$1:
                return Scheduler_IdlePriority;
            default:
                throw Error("Unknown priority level.");
        }
    }
    function runWithPriority$1(reactPriorityLevel, fn) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_runWithPriority(priorityLevel, fn);
    }
    function scheduleCallback(reactPriorityLevel, callback, options) {
        var priorityLevel = reactPriorityToSchedulerPriority(reactPriorityLevel);
        return Scheduler_scheduleCallback(priorityLevel, callback, options);
    }
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) {
            syncQueue = [
                callback
            ]; // Flush the queue in the next tick, at the earliest.
            immediateQueueCallbackNode = Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueueImpl);
        } else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
        return fakeCallbackNode;
    }
    function cancelCallback(callbackNode) {
        if (callbackNode !== fakeCallbackNode) Scheduler_cancelCallback(callbackNode);
    }
    function flushSyncCallbackQueue() {
        if (immediateQueueCallbackNode !== null) {
            var node = immediateQueueCallbackNode;
            immediateQueueCallbackNode = null;
            Scheduler_cancelCallback(node);
        }
        flushSyncCallbackQueueImpl();
    }
    function flushSyncCallbackQueueImpl() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrancy.
            isFlushingSyncQueue = true;
            var i = 0;
            try {
                var _isSync2 = true;
                var _queue = syncQueue;
                runWithPriority$1(ImmediatePriority$1, function() {
                    for(; i < _queue.length; i++){
                        var callback = _queue[i];
                        do callback = callback(_isSync2);
                        while (callback !== null);
                    }
                });
                syncQueue = null;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                Scheduler_scheduleCallback(Scheduler_ImmediatePriority, flushSyncCallbackQueue);
                throw error;
            } finally{
                isFlushingSyncQueue = false;
            }
        }
    }
    // TODO: this is special because it gets imported during build.
    var ReactVersion = '17.0.2';
    var NoMode = 0;
    var StrictMode = 1; // TODO: Remove BlockingMode and ConcurrentMode by reading from the root
    // tag instead
    var BlockingMode = 2;
    var ConcurrentMode = 4;
    var ProfileMode = 8;
    var DebugTracingMode = 16;
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = 0;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(', ');
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedup strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === 'function' && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillMount === 'function') pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillReceiveProps === 'function') pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictMode && typeof instance.UNSAFE_componentWillUpdate === 'function') pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === 'function') {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentName(fiber.type) || 'Component');
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = _assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var MAX_SIGNED_31_BIT_INT = 1073741823;
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastContextWithAllBitsObserved = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, nextValue) {
        var context = providerFiber.type._context;
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        var context = providerFiber.type._context;
        context._currentValue = currentValue;
    }
    function calculateChangedBits(context, newValue, oldValue) {
        if (objectIs(oldValue, newValue)) // No change
        return 0;
        else {
            var changedBits = typeof context._calculateChangedBits === 'function' ? context._calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
            if ((changedBits & MAX_SIGNED_31_BIT_INT) !== changedBits) error("calculateChangedBits: Expected the return value to be a 31-bit integer. Instead received: %s", changedBits);
            return changedBits | 0;
        }
    }
    function scheduleWorkOnParentPath(parent, renderLanes) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            else break;
            node = node.return;
        }
    }
    function propagateContextChange(workInProgress, context, changedBits, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context && (dependency.observedBits & changedBits) !== 0) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var update = createUpdate(NoTimestamp, pickArbitraryLane(renderLanes));
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            enqueueUpdate(fiber, update);
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleWorkOnParentPath(fiber.return, renderLanes); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastContextWithAllBitsObserved = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context, observedBits) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        if (lastContextWithAllBitsObserved === context) ;
        else if (observedBits === false || observedBits === 0) ;
        else {
            var resolvedObservedBits; // Avoid deopting on observable arguments or heterogeneous types.
            if (typeof observedBits !== 'number' || observedBits === MAX_SIGNED_31_BIT_INT) {
                // Observe all updates.
                lastContextWithAllBitsObserved = context;
                resolvedObservedBits = MAX_SIGNED_31_BIT_INT;
            } else resolvedObservedBits = observedBits;
            var contextItem = {
                context: context,
                observedBits: resolvedObservedBits,
                next: null
            };
            if (lastContextDependency === null) {
                if (!(currentlyRenderingFiber !== null)) throw Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem,
                    responders: null
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return context._currentValue;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        var pending = sharedQueue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        sharedQueue.pending = update;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === 'function') {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictMode) {
                        disableLogs();
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            reenableLogs();
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return _assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (!(typeof callback === 'function')) throw Error("Invalid argument passed as callback. Expected a function. Instead received: " + callback);
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var fakeInternalInstance = {};
    var isArray = Array.isArray; // React.Component uses a shared frozen object by default.
    // We'll use it to determine whether we need to initialize legacy refs.
    var emptyRefsObject = new React.Component().refs;
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === 'function') return;
        var key = callerName + '_' + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentName(type) || 'Component';
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, '_processChildContext', {
        enumerable: false,
        value: function() {
            throw Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                // Invoke the function an extra time to help detect side-effects.
                getDerivedStateFromProps(nextProps, prevState);
            } finally{
                reenableLogs();
            }
        }
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : _assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'setState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'replaceState');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, 'forceUpdate');
                update.callback = callback;
            }
            enqueueUpdate(fiber, update);
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === 'function') {
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    reenableLogs();
                }
            }
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentName(ctor) || 'Component');
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentName(ctor) || 'Component';
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === 'function') error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === 'function') error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== 'undefined') error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentName(ctor) || 'A pure component');
        if (typeof instance.componentDidUnmount === 'function') error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === 'function') error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === 'function') error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === 'function') error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === 'function' && typeof instance.componentDidUpdate !== 'function' && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentName(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === 'function') error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === 'function') error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === 'function') error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== 'object' || isArray(_state))) error('%s.state: must be set to an object or null', name);
        if (typeof instance.getChildContext === 'function' && typeof ctor.childContextTypes !== 'object') error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ('contextType' in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = '';
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = ' Did you accidentally pass the Context.Consumer instead?';
                else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(ctor) || 'Component', addendum);
            }
        }
        if (typeof contextType === 'object' && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        } // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                new ctor(props, context); // eslint-disable-line no-new
            } finally{
                reenableLogs();
            }
        }
        var instance = new ctor(props, context);
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === 'function' && state === null) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? 'null' : 'undefined', componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function') {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === 'function' && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = 'componentWillMount';
            else if (typeof instance.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
            if (typeof instance.componentWillReceiveProps === 'function' && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = 'componentWillReceiveProps';
            else if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
            if (typeof instance.componentWillUpdate === 'function' && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = 'componentWillUpdate';
            else if (typeof instance.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentName(ctor) || 'Component';
                var newApiName = typeof ctor.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : '', foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : '', foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : '');
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentName(workInProgress.type) || 'Component');
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === 'function') instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === 'function') instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentName(workInProgress.type) || 'Component';
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = emptyRefsObject;
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === 'object' && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentName(ctor) || 'Component';
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== 'function' && typeof instance.getSnapshotBeforeUpdate !== 'function' && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === 'function' || typeof instance.componentWillMount === 'function')) {
                if (typeof instance.componentWillMount === 'function') instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === 'function') instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === 'function') workInProgress.flags |= Update;
             // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === 'object' && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === 'function' || typeof instance.getSnapshotBeforeUpdate === 'function'; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === 'function' || typeof instance.componentWillReceiveProps === 'function')) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === 'function') {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === 'function' || typeof instance.componentWillUpdate === 'function')) {
                if (typeof instance.componentWillUpdate === 'function') instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === 'function') instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === 'function') workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === 'function') workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === 'function') {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== 'object') return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (!(typeof child._store === 'object')) throw Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentName(returnFiber.type) || 'Component';
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    var isArray$1 = Array.isArray;
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== 'function' && typeof mixedRef !== 'object') {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self)) {
                var componentName = getComponentName(returnFiber.type) || 'Component';
                if (!didWarnAboutStringRefs[componentName]) {
                    error('A string ref, "%s", has been found within a strict mode tree. String refs are a source of potential bugs and should be avoided. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (!(ownerFiber.tag === ClassComponent)) throw Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a bug in React. Please file an issue.");
                var stringRef = '' + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === 'function' && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = inst.refs;
                    if (refs === emptyRefsObject) // This is a lazy pooled frozen object, so we need to initialize.
                    refs = inst.refs = {};
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (!(typeof mixedRef === 'string')) throw Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of the following reasons:\n1. You may be adding a ref to a function component\n2. You may be adding a ref to a component that was not created inside a component's render method\n3. You have multiple copies of React loaded\nSee https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (returnFiber.type !== 'textarea') throw Error("Objects are not valid as a React child (found: " + (Object.prototype.toString.call(newChild) === '[object Object]' ? 'object with keys {' + Object.keys(newChild).join(', ') + '}' : newChild) + "). If you meant to render a collection of children, use an array instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentName(returnFiber.type) || 'Component';
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    } // We avoid inlining this to avoid potential deopts from using try/catch.
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
             // Deletions are added in reversed order so we add it to the front.
            // At this point, the return fiber's effect list is empty except for
            // deletions, so we can just append the deletion to the list. The remaining
            // effects aren't added until the complete phase. Once we implement
            // resuming, this may not be true.
            var last = returnFiber.lastEffect;
            if (last !== null) {
                last.nextEffect = childToDelete;
                returnFiber.lastEffect = childToDelete;
            } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
            childToDelete.nextEffect = null;
            childToDelete.flags = Deletion;
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) // Noop.
            return lastPlacedIndex;
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags = Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags = Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags = Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            if (current !== null) {
                if (current.elementType === element.type || isCompatibleFamilyForHotReloading(current, element)) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText('' + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) {
                            if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, oldFiber, newChild.props.children, lanes, key);
                            return updateElement(returnFiber, oldFiber, newChild, lanes);
                        } else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === 'string' || typeof newChild === 'number') {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, '' + newChild, lanes);
            }
            if (typeof newChild === 'object' && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        if (newChild.type === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, _matchedFiber, newChild.props.children, lanes, newChild.key);
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                }
                if (isArray$1(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== 'object' || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== 'string') break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (!(typeof iteratorFn === 'function')) throw Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === 'function' && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === 'Generator') {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (!(newChildren != null)) throw Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    switch(child.tag){
                        case Fragment:
                            if (element.type === REACT_FRAGMENT_TYPE) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var existing = useFiber(child, element.props.children);
                                existing.return = returnFiber;
                                existing._debugSource = element._source;
                                existing._debugOwner = element._owner;
                                return existing;
                            }
                            break;
                        case Block:
                        // We intentionally fallthrough here if enableBlocksAPI is not on.
                        // eslint-disable-next-lined no-fallthrough
                        default:
                            if (child.elementType === element.type || isCompatibleFamilyForHotReloading(child, element)) {
                                deleteRemainingChildren(returnFiber, child.sibling);
                                var _existing3 = useFiber(child, element.props);
                                _existing3.ref = coerceRef(returnFiber, child, element);
                                _existing3.return = returnFiber;
                                _existing3._debugSource = element._source;
                                _existing3._debugOwner = element._owner;
                                return _existing3;
                            }
                            break;
                    } // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === 'object' && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            var isObject = typeof newChild === 'object' && newChild !== null;
            if (isObject) switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                case REACT_PORTAL_TYPE:
                    return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
            }
            if (typeof newChild === 'string' || typeof newChild === 'number') return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, '' + newChild, lanes));
            if (isArray$1(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            if (isObject) throwOnInvalidObjectType(returnFiber, newChild);
            if (typeof newChild === 'function') warnOnFunctionType(returnFiber);
            if (typeof newChild === 'undefined' && !isUnkeyedTopLevelFragment) // If the new child is undefined, and the return fiber is a composite
            // component, throw an error. If Fiber return types are disabled,
            // we already threw above.
            switch(returnFiber.tag){
                case ClassComponent:
                    var instance = returnFiber.stateNode;
                    if (instance.render._isMockFunction) break;
                // Intentionally fall through to the next case, which handles both
                // functions and classes
                // eslint-disable-next-lined no-fallthrough
                case Block:
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    throw Error((getComponentName(returnFiber.type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
            }
             // Remaining cases are all treated as empty.
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (!(current === null || workInProgress.child === current.child)) throw Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (!(c !== NO_CONTEXT)) throw Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // In order to capture, the Suspense component must have a fallback prop.
        if (props.fallback === undefined) return false;
         // Regular boundaries always capture.
        if (props.unstable_avoidThisFallback !== true) return true;
         // If it's a boundary we should avoid, then we prefer to bubble up to the
        // parent boundary if it is currently invisible.
        if (hasInvisibleParent) return false;
         // If the parent is not able to handle it, we must handle it.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*  */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Layout = /*    */ 2;
    var Passive$1 = /*   */ 4;
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false;
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChild(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        return true;
    }
    function deleteHydratableInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateContainerInstance(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance);
                break;
        }
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        childToDelete.flags = Deletion; // This might seem like it belongs on progressedFirstDeletion. However,
        // these children are not part of the reconciliation list of children.
        // Even if we abort and rereconcile the children, that will try to hydrate
        // again and the nodes are still in the host tree so these will be
        // recreated.
        if (returnFiber.lastEffect !== null) {
            returnFiber.lastEffect.nextEffect = childToDelete;
            returnFiber.lastEffect = childToDelete;
        } else returnFiber.firstEffect = returnFiber.lastEffect = childToDelete;
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableContainerInstance(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableContainerTextInstance(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text);
                        break;
                    case SuspenseComponent:
                        didNotFindHydratableSuspenseInstance(parentType, parentProps);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    return true;
                }
                return false;
            case SuspenseComponent:
                return false;
            default:
                return false;
        }
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(hydrationParentFiber, firstAttemptedInstance);
        }
        hydrationParentFiber = fiber;
        nextHydratableInstance = getFirstHydratableChild(nextInstance);
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent);
                    break;
            }
        }
        return shouldUpdate;
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        }
        var type = fiber.type; // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them.
        // TODO: Better heuristic.
        if (fiber.tag !== HostComponent || type !== 'head' && type !== 'body' && !shouldSetTextContent(type, fiber.memoizedProps)) {
            var nextInstance = nextHydratableInstance;
            while(nextInstance){
                deleteHydratableInstance(fiber, nextInstance);
                nextInstance = getNextHydratableSibling(nextInstance);
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
    }
    function getIsHydrating() {
        return isHydrating;
    }
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    var rendererSigil$1;
    // Used to detect multiple renderers using the same mutable source.
    rendererSigil$1 = {};
    function markSourceAsDirty(mutableSource) {
        workInProgressSources.push(mutableSource);
    }
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    function getWorkInProgressVersion(mutableSource) {
        return mutableSource._workInProgressVersionPrimary;
    }
    function setWorkInProgressVersion(mutableSource, version) {
        mutableSource._workInProgressVersionPrimary = version;
        workInProgressSources.push(mutableSource);
    }
    function warnAboutMultipleRenderersDEV(mutableSource) {
        if (mutableSource._currentPrimaryRenderer == null) mutableSource._currentPrimaryRenderer = rendererSigil$1;
        else if (mutableSource._currentPrimaryRenderer !== rendererSigil$1) error("Detected multiple renderers concurrently rendering the same mutable source. This is currently unsupported.");
    } // Eager reads the version of a mutable source and stores it on the root.
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnAboutUseOpaqueIdentifier;
    didWarnAboutUseOpaqueIdentifier = {};
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !Array.isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentName(currentlyRenderingFiber$1.type);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = '';
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += ' ';
                    row += newHookName + '\n';
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(', ') + "]", "[" + nextDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        didScheduleRenderPhaseUpdate = false;
        if (!!didRenderTooFewHooks) throw Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrancy.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (!(nextCurrentHook !== null)) throw Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        eagerReducer: update.eagerReducer,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            eagerReducer: update.eagerReducer,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.eagerReducer === reducer) // If this update was processed eagerly, and its reducer matches the
                    // current reducer, we can use the eagerly computed state.
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        }
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (!(queue !== null)) throw Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function readFromUnsubcribedMutableSource(root, source, getSnapshot) {
        warnAboutMultipleRenderersDEV(source);
        var getVersion = source._getVersion;
        var version = getVersion(source._source); // Is it safe for this component to read from this source during the current render?
        var isSafeToReadFromSource = false; // Check the version first.
        // If this render has already been started with a specific version,
        // we can use it alone to determine if we can safely read from the source.
        var currentRenderVersion = getWorkInProgressVersion(source);
        if (currentRenderVersion !== null) // It's safe to read if the store hasn't been mutated since the last time
        // we read something.
        isSafeToReadFromSource = currentRenderVersion === version;
        else {
            // If there's no version, then this is the first time we've read from the
            // source during the current render pass, so we need to do a bit more work.
            // What we need to determine is if there are any hooks that already
            // subscribed to the source, and if so, whether there are any pending
            // mutations that haven't been synchronized yet.
            //
            // If there are no pending mutations, then `root.mutableReadLanes` will be
            // empty, and we know we can safely read.
            //
            // If there *are* pending mutations, we may still be able to safely read
            // if the currently rendering lanes are inclusive of the pending mutation
            // lanes, since that guarantees that the value we're about to read from
            // the source is consistent with the values that we read during the most
            // recent mutation.
            isSafeToReadFromSource = isSubsetOfLanes(renderLanes, root.mutableReadLanes);
            if (isSafeToReadFromSource) // If it's safe to read from this source during the current render,
            // store the version in case other components read from it.
            // A changed version number will let those components know to throw and restart the render.
            setWorkInProgressVersion(source, version);
        }
        if (isSafeToReadFromSource) {
            var snapshot = getSnapshot(source._source);
            if (typeof snapshot === 'function') error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
            return snapshot;
        } else {
            // This handles the special case of a mutable source being shared between renderers.
            // In that case, if the source is mutated between the first and second renderer,
            // The second renderer don't know that it needs to reset the WIP version during unwind,
            // (because the hook only marks sources as dirty if it's written to their WIP version).
            // That would cause this tear check to throw again and eventually be visible to the user.
            // We can avoid this infinite loop by explicitly marking the source as dirty.
            //
            // This can lead to tearing in the first renderer when it resumes,
            // but there's nothing we can do about that (short of throwing here and refusing to continue the render).
            markSourceAsDirty(source);
            throw Error("Cannot read from mutable source during the current render without tearing. This is a bug in React. Please file an issue.");
        }
    }
    function useMutableSource(hook, source, getSnapshot, subscribe) {
        var root = getWorkInProgressRoot();
        if (!(root !== null)) throw Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        var getVersion = source._getVersion;
        var version = getVersion(source._source);
        var dispatcher = ReactCurrentDispatcher$1.current; // eslint-disable-next-line prefer-const
        var _dispatcher$useState = dispatcher.useState(function() {
            return readFromUnsubcribedMutableSource(root, source, getSnapshot);
        }), currentSnapshot = _dispatcher$useState[0], setSnapshot = _dispatcher$useState[1];
        var snapshot = currentSnapshot; // Grab a handle to the state hook as well.
        // We use it to clear the pending update queue if we have a new source.
        var stateHook = workInProgressHook;
        var memoizedState = hook.memoizedState;
        var refs = memoizedState.refs;
        var prevGetSnapshot = refs.getSnapshot;
        var prevSource = memoizedState.source;
        var prevSubscribe = memoizedState.subscribe;
        var fiber = currentlyRenderingFiber$1;
        hook.memoizedState = {
            refs: refs,
            source: source,
            subscribe: subscribe
        }; // Sync the values needed by our subscription handler after each commit.
        dispatcher.useEffect(function() {
            refs.getSnapshot = getSnapshot; // Normally the dispatch function for a state hook never changes,
            // but this hook recreates the queue in certain cases  to avoid updates from stale sources.
            // handleChange() below needs to reference the dispatch function without re-subscribing,
            // so we use a ref to ensure that it always has the latest version.
            refs.setSnapshot = setSnapshot; // Check for a possible change between when we last rendered now.
            var maybeNewVersion = getVersion(source._source);
            if (!objectIs(version, maybeNewVersion)) {
                var maybeNewSnapshot = getSnapshot(source._source);
                if (typeof maybeNewSnapshot === 'function') error("Mutable source should not return a function as the snapshot value. Functions may close over mutable values and cause tearing.");
                if (!objectIs(snapshot, maybeNewSnapshot)) {
                    setSnapshot(maybeNewSnapshot);
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } // If the source mutated between render and now,
                // there may be state updates already scheduled from the old source.
                // Entangle the updates so that they render in the same batch.
                markRootEntangled(root, root.mutableReadLanes);
            }
        }, [
            getSnapshot,
            source,
            subscribe
        ]); // If we got a new source or subscribe function, re-subscribe in a passive effect.
        dispatcher.useEffect(function() {
            var handleChange = function() {
                var latestGetSnapshot = refs.getSnapshot;
                var latestSetSnapshot = refs.setSnapshot;
                try {
                    latestSetSnapshot(latestGetSnapshot(source._source)); // Record a pending mutable source update with the same expiration time.
                    var lane = requestUpdateLane(fiber);
                    markRootMutableRead(root, lane);
                } catch (error) {
                    // A selector might throw after a source mutation.
                    // e.g. it might try to read from a part of the store that no longer exists.
                    // In this case we should still schedule an update with React.
                    // Worst case the selector will throw again and then an error boundary will handle it.
                    latestSetSnapshot(function() {
                        throw error;
                    });
                }
            };
            var unsubscribe = subscribe(source._source, handleChange);
            if (typeof unsubscribe !== 'function') error('Mutable source subscribe function must return an unsubscribe function.');
            return unsubscribe;
        }, [
            source,
            subscribe
        ]); // If any of the inputs to useMutableSource change, reading is potentially unsafe.
        //
        // If either the source or the subscription have changed we can't can't trust the update queue.
        // Maybe the source changed in a way that the old subscription ignored but the new one depends on.
        //
        // If the getSnapshot function changed, we also shouldn't rely on the update queue.
        // It's possible that the underlying source was mutated between the when the last "change" event fired,
        // and when the current render (with the new getSnapshot function) is processed.
        //
        // In both cases, we need to throw away pending updates (since they are no longer relevant)
        // and treat reading from the source as we do in the mount case.
        if (!objectIs(prevGetSnapshot, getSnapshot) || !objectIs(prevSource, source) || !objectIs(prevSubscribe, subscribe)) {
            // Create a new queue and setState method,
            // So if there are interleaved updates, they get pushed to the older queue.
            // When this becomes current, the previous queue and dispatch method will be discarded,
            // including any interleaving updates that occur.
            var newQueue = {
                pending: null,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: snapshot
            };
            newQueue.dispatch = setSnapshot = dispatchAction.bind(null, currentlyRenderingFiber$1, newQueue);
            stateHook.queue = newQueue;
            stateHook.baseQueue = null;
            snapshot = readFromUnsubcribedMutableSource(root, source, getSnapshot);
            stateHook.memoizedState = stateHook.baseState = snapshot;
        }
        return snapshot;
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = {
            refs: {
                getSnapshot: getSnapshot,
                setSnapshot: null
            },
            source: source,
            subscribe: subscribe
        };
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        var hook = updateWorkInProgressHook();
        return useMutableSource(hook, source, getSnapshot, subscribe);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === 'function') // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = hook.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        var dispatch = queue.dispatch = dispatchAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var ref = {
            current: initialValue
        };
        Object.seal(ref);
        hook.memoizedState = ref;
        return ref;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return mountEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) warnIfNotCurrentlyActingEffectsInDEV(currentlyRenderingFiber$1);
        return updateEffectImpl(Update | Passive, Passive$1, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        return mountEffectImpl(Update, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === 'function') {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty('current')) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", 'an object with keys {' + Object.keys(refObject).join(', ') + '}');
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return mountEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== 'function') error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : 'null');
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var _mountState = mountState(value), prevValue = _mountState[0], setValue = _mountState[1];
        mountEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function updateDeferredValue(value) {
        var _updateState = updateState(), prevValue = _updateState[0], setValue = _updateState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function rerenderDeferredValue(value) {
        var _rerenderState = rerenderState(), prevValue = _rerenderState[0], setValue = _rerenderState[1];
        updateEffect(function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setValue(value);
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        }, [
            value
        ]);
        return prevValue;
    }
    function startTransition(setPending, callback) {
        var priorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(priorityLevel < UserBlockingPriority$2 ? UserBlockingPriority$2 : priorityLevel, function() {
            setPending(true);
        });
        runWithPriority$1(priorityLevel > NormalPriority$1 ? NormalPriority$1 : priorityLevel, function() {
            var prevTransition = ReactCurrentBatchConfig$1.transition;
            ReactCurrentBatchConfig$1.transition = 1;
            try {
                setPending(false);
                callback();
            } finally{
                ReactCurrentBatchConfig$1.transition = prevTransition;
            }
        });
    }
    function mountTransition() {
        var _mountState2 = mountState(false), isPending = _mountState2[0], setPending = _mountState2[1]; // The `start` method can be stored on a ref, since `setPending`
        // never changes.
        var start = startTransition.bind(null, setPending);
        mountRef(start);
        return [
            start,
            isPending
        ];
    }
    function updateTransition() {
        var _updateState2 = updateState(), isPending = _updateState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    function rerenderTransition() {
        var _rerenderState2 = rerenderState(), isPending = _rerenderState2[0];
        var startRef = updateRef();
        var start = startRef.current;
        return [
            start,
            isPending
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function warnOnOpaqueIdentifierAccessInDEV(fiber) {
        // TODO: Should warn in effects and callbacks, too
        var name = getComponentName(fiber.type) || 'Unknown';
        if (getIsRendering() && !didWarnAboutUseOpaqueIdentifier[name]) {
            error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            didWarnAboutUseOpaqueIdentifier[name] = true;
        }
    }
    function mountOpaqueIdentifier() {
        var makeId = makeClientIdInDEV.bind(null, warnOnOpaqueIdentifierAccessInDEV.bind(null, currentlyRenderingFiber$1));
        if (getIsHydrating()) {
            var didUpgrade = false;
            var fiber = currentlyRenderingFiber$1;
            var readValue = function() {
                if (!didUpgrade) {
                    // Only upgrade once. This works even inside the render phase because
                    // the update is added to a shared queue, which outlasts the
                    // in-progress render.
                    didUpgrade = true;
                    isUpdatingOpaqueValueInRenderPhase = true;
                    setId(makeId());
                    isUpdatingOpaqueValueInRenderPhase = false;
                    warnOnOpaqueIdentifierAccessInDEV(fiber);
                }
                throw Error("The object passed back from useOpaqueIdentifier is meant to be passed through to attributes only. Do not read the value directly.");
            };
            var id = makeOpaqueHydratingObject(readValue);
            var setId = mountState(id)[1];
            if ((currentlyRenderingFiber$1.mode & BlockingMode) === NoMode) {
                currentlyRenderingFiber$1.flags |= Update | Passive;
                pushEffect(HasEffect | Passive$1, function() {
                    setId(makeId());
                }, undefined, null);
            }
            return id;
        } else {
            var _id = makeId();
            mountState(_id);
            return _id;
        }
    }
    function updateOpaqueIdentifier() {
        var id = updateState()[0];
        return id;
    }
    function rerenderOpaqueIdentifier() {
        var id = rerenderState()[0];
        return id;
    }
    function dispatchAction(fiber, queue, action) {
        if (typeof arguments[3] === 'function') error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            eagerReducer: null,
            eagerState: null,
            next: null
        }; // Append the update to the end of the list.
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
        var alternate = fiber.alternate;
        if (fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1) // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        else {
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.eagerReducer = lastRenderedReducer;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) // Fast path. We can bail out without scheduling React to re-render.
                        // It's still possible that we'll need to rebase this update later,
                        // if the component re-renders for a different reason and by that
                        // time the reducer has changed.
                        return;
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
            if ('undefined' !== typeof jest) {
                warnIfNotScopedWithMatchingAct(fiber);
                warnIfNotCurrentlyActingUpdatesInDev(fiber);
            }
            scheduleUpdateOnFiber(fiber, lane, eventTime);
        }
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useOpaqueIdentifier: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context, observedBits) {
            warnInvalidContextAccess();
            return readContext(context, observedBits);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = 'useCallback';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context, observedBits) {
            currentHookNameInDev = 'useContext';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context, observedBits);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = 'useEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = 'useImperativeHandle';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = 'useLayoutEffect';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = 'useMemo';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = 'useReducer';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = 'useRef';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = 'useState';
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = 'useDebugValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = 'useDeferredValue';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = 'useTransition';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = 'useMutableSource';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource(source, getSnapshot, subscribe);
        },
        useOpaqueIdentifier: function() {
            currentHookNameInDev = 'useOpaqueIdentifier';
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderOpaqueIdentifier();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var profilerStartTime = -1;
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, updateLanes, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(type));
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, 'prop', getComponentName(_type));
        var currentChild = current.child; // This is always exactly one child
        if (!includesSomeLane(updateLanes, renderLanes)) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, updateLanes, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, 'prop', getComponentName(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false;
                if (!includesSomeLane(renderLanes, updateLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumlated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === 'hidden' || nextProps.mode === 'unstable-defer-without-hiding') {
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Figure out what we should do in Blocking mode.
                var nextState = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                markSpawnedWork(OffscreenLane);
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes
                };
                workInProgress.memoizedState = _nextState; // We're about to bail out, but we need to push this to the stack anyway
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            var _subtreeRenderLanes;
            if (prevState !== null) {
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes); // Since we're not hidden anymore, reset the state
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    // ourselves to this constraint, though. If the behavior diverges, we should
    // fork the function.
    var updateLegacyHiddenComponent = updateOffscreenComponent;
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update; // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) // Schedule a Ref effect
        workInProgress.flags |= Ref;
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        prepareToReadContext(workInProgress, renderLanes);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        if (workInProgress.mode & StrictMode) {
            disableLogs();
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
            } finally{
                reenableLogs();
            }
        }
        setIsRendering(false);
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, 'prop', getComponentName(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            if (current !== null) {
                // A class component without an instance only mounts if it suspended
                // inside a non-concurrent tree, in an inconsistent state. We want to
                // treat it like a new mount, even though an empty version of it already
                // committed. Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            } // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentName(workInProgress.type) || 'a component');
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== 'function') {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    instance.render();
                } finally{
                    reenableLogs();
                }
            }
            setIsRendering(false);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        var updateQueue = workInProgress.updateQueue;
        if (!(current !== null && updateQueue !== null)) throw Error("If the root does not have an updateQueue, we should have already bailed out. This error is likely caused by a bug in React. Please file an issue.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState !== null ? prevState.element : null;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState; // Caution: React DevTools currently depends on this property
        // being called "element".
        var nextChildren = nextState.element;
        if (nextChildren === prevChildren) {
            resetHydrationState();
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var root = workInProgress.stateNode;
        if (root.hydrate && enterHydrationState(workInProgress)) {
            var mutableSourceEagerHydrationData = root.mutableSourceEagerHydrationData;
            if (mutableSourceEagerHydrationData != null) for(var i = 0; i < mutableSourceEagerHydrationData.length; i += 2){
                var mutableSource = mutableSourceEagerHydrationData[i];
                var version = mutableSourceEagerHydrationData[i + 1];
                setWorkInProgressVersion(mutableSource, version);
            }
            var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
            workInProgress.child = child;
            var node = child;
            while(node){
                // Mark each child as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                node.flags = node.flags & ~Placement | Hydrating;
                node = node.sibling;
            }
        } else {
            // Otherwise reset hydration state in case we aborted and resumed another
            // root.
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
            resetHydrationState();
        }
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, updateLanes, renderLanes) {
        if (_current !== null) {
            // A lazy component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, 'prop', getComponentName(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), updateLanes, renderLanes);
                return child;
        }
        var hint = '';
        if (Component !== null && typeof Component === 'object' && Component.$$typeof === REACT_LAZY_TYPE) hint = ' Did you wrap a component in React.lazy() more than once?';
        throw Error("Element type is invalid. Received a promise that resolves to: " + Component + ". Lazy element type must resolve to a class or function." + hint);
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        if (_current !== null) {
            // An incomplete component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        } // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        if (_current !== null) {
            // An indeterminate component only mounts if it suspended inside a non-
            // concurrent tree, in an inconsistent state. We want to treat it like
            // a new mount, even though an empty version of it already committed.
            // Disconnect the alternate pointers.
            _current.alternate = null;
            workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
            workInProgress.flags |= Placement;
        }
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        if (Component.prototype && typeof Component.prototype.render === 'function') {
            var componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === 'object' && value !== null && typeof value.render === 'function' && value.$$typeof === undefined) {
            var _componentName2 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            if (typeof getDerivedStateFromProps === 'function') applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, props);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictMode) {
                disableLogs();
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                } finally{
                    reenableLogs();
                }
            }
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error('%s(...): childContextTypes cannot be defined on a function component.', Component.displayName || Component.name || 'Component');
        }
        if (workInProgress.ref !== null) {
            var info = '';
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
            var warningKey = ownerName || workInProgress._debugID || '';
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ':' + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (typeof Component.getDerivedStateFromProps === 'function') {
            var _componentName3 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error('%s: Function components do not support getDerivedStateFromProps.', _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === 'object' && Component.contextType !== null) {
            var _componentName4 = getComponentName(Component) || 'Unknown';
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error('%s: Function components do not support contextType.', _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes)
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallack
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else {
            // Attempting the main content
            if (current === null || current.memoizedState !== null) // This is a new mount or this boundary is already showing a fallback state.
            // Mark this subtree context as having at least one invisible parent that could
            // handle the fallback state.
            // Boundaries without fallbacks or should be avoided are not considered since
            // they cannot handle preferred fallback states.
            {
                if (nextProps.fallback !== undefined && nextProps.unstable_avoidThisFallback !== true) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
            }
        }
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconcilation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // If we're currently hydrating, try to hydrate this boundary.
            // But only if this has a fallback.
            if (nextProps.fallback !== undefined) tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else if (typeof nextProps.unstable_expectedLoadTime === 'number') {
                // This is a CPU-bound tree. Skip this tree and show a placeholder to
                // unblock the surrounding content. Then immediately retry after the
                // initial commit.
                var _fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment = workInProgress.child;
                _primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER; // Since nothing actually suspended, there will nothing to ping this to
                // get it started back up to attempt the next item. While in terms of
                // priority this work has the same priority as this current render, it's
                // not part of the same transition once the transition has committed. If
                // it's sync, we still want to yield so that it can be painted.
                // Conceptually, this is really the same as pinging. We can use any
                // RetryLane even if it's the one currently rendering since we're leaving
                // it behind on this node.
                workInProgress.lanes = SomeRetryLane;
                markSpawnedWork(SomeRetryLane);
                return _fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren, renderLanes);
        } else {
            // This is an update.
            // If the current fiber has a SuspenseState, that means it's already showing
            // a fallback.
            var prevState = current.memoizedState;
            if (prevState !== null) {
                if (showFallback) {
                    var _nextFallbackChildren2 = nextProps.fallback;
                    var _nextPrimaryChildren2 = nextProps.children;
                    var _fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren2, _nextFallbackChildren2, renderLanes);
                    var _primaryChildFragment3 = workInProgress.child;
                    var prevOffscreenState = current.child.memoizedState;
                    _primaryChildFragment3.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                    _primaryChildFragment3.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                    workInProgress.memoizedState = SUSPENDED_MARKER;
                    return _fallbackChildFragment;
                } else {
                    var _nextPrimaryChildren3 = nextProps.children;
                    var _primaryChildFragment4 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren3, renderLanes);
                    workInProgress.memoizedState = null;
                    return _primaryChildFragment4;
                }
            } else // The current tree is not already showing a fallback.
            if (showFallback) {
                // Timed out.
                var _nextFallbackChildren3 = nextProps.fallback;
                var _nextPrimaryChildren4 = nextProps.children;
                var _fallbackChildFragment2 = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren4, _nextFallbackChildren3, renderLanes);
                var _primaryChildFragment5 = workInProgress.child;
                var _prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment5.memoizedState = _prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(_prevOffscreenState, renderLanes);
                _primaryChildFragment5.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes); // Skip the primary children, and continue working on the
                // fallback children.
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return _fallbackChildFragment2;
            } else {
                // Still haven't timed out. Continue rendering the children, like we
                // normally do.
                var _nextPrimaryChildren5 = nextProps.children;
                var _primaryChildFragment6 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren5, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment6;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: 'visible',
            children: primaryChildren
        };
        var primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, renderLanes, null);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & BlockingMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = createFiberFromOffscreen(primaryChildProps, mode, NoLanes, null);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function createWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: 'visible',
            children: primaryChildren
        });
        if ((workInProgress.mode & BlockingMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            currentFallbackChildFragment.nextEffect = null;
            currentFallbackChildFragment.flags = Deletion;
            workInProgress.firstEffect = workInProgress.lastEffect = currentFallbackChildFragment;
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: 'hidden',
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & BlockingMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion effect during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it. So we need to remove it from the list. Deletions are stored
            // on the same list as effects. We want to keep the effects from the primary
            // tree. So we copy the primary child fragment's effect list, which does not
            // include the fallback deletion effect.
            var progressedLastEffect = primaryChildFragment.lastEffect;
            if (progressedLastEffect !== null) {
                workInProgress.firstEffect = primaryChildFragment.firstEffect;
                workInProgress.lastEffect = progressedLastEffect;
                progressedLastEffect.nextEffect = null;
            } else // TODO: Reset this somewhere else? Lol legacy mode is so weird.
            workInProgress.firstEffect = workInProgress.lastEffect = null;
        } else primaryChildFragment = createWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps);
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function scheduleWorkOnFiber(fiber, renderLanes) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleWorkOnParentPath(fiber.return, renderLanes);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleWorkOnFiber(node, renderLanes);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleWorkOnFiber(node, renderLanes);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== 'forwards' && revealOrder !== 'backwards' && revealOrder !== 'together' && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === 'string') switch(revealOrder.toLowerCase()){
                case 'together':
                case 'forwards':
                case 'backwards':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case 'forward':
                case 'backward':
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== 'collapsed' && tailMode !== 'hidden') {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== 'forwards' && revealOrder !== 'backwards') {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isArray = Array.isArray(childSlot);
        var isIterable = !isArray && typeof getIteratorFn(childSlot) === 'function';
        if (isArray || isIterable) {
            var type = isArray ? 'array' : 'iterable';
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === 'forwards' || revealOrder === 'backwards') && children !== undefined && children !== null && children !== false) {
            if (Array.isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === 'function') {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, lastEffectBeforeRendering) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode,
            lastEffect: lastEffectBeforeRendering
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
            renderState.lastEffect = lastEffectBeforeRendering;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & BlockingMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case 'forwards':
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode, workInProgress.lastEffect);
                break;
            case 'backwards':
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode, workInProgress.lastEffect);
                break;
            case 'together':
                initSuspenseListRenderState(workInProgress, false, null, null, undefined, workInProgress.lastEffect);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!('value' in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error('The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?');
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, 'prop', 'Context.Provider');
        pushProvider(workInProgress, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            var changedBits = calculateChangedBits(context, newValue, oldValue);
            if (changedBits === 0) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, changedBits, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== 'function') error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context, newProps.unstable_observedBits);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) // The children don't have any work either. We can skip them.
        // TODO: Once we add back resuming, we should check if the children are
        // a work-in-progress set. If so, we need to transfer their effects.
        return null;
        else {
            // This fiber doesn't have work, but its subtree does. Clone the child
            // fibers and continue.
            cloneChildFibers(current, workInProgress);
            return workInProgress.child;
        }
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) throw new Error('Cannot swap the root fiber.');
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) throw new Error('Expected parent to have a child.');
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) throw new Error('Expected to find the previous sibling.');
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var last = returnFiber.lastEffect;
        if (last !== null) {
            last.nextEffect = current;
            returnFiber.lastEffect = current;
        } else returnFiber.firstEffect = returnFiber.lastEffect = current;
        current.nextEffect = null;
        current.flags = Deletion;
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function beginWork(current, workInProgress, renderLanes) {
        var updateLanes = workInProgress.lanes;
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else if (!includesSomeLane(renderLanes, updateLanes)) {
                didReceiveUpdate = false; // This fiber does not have any pending work. Bailout without entering
                // the begin phase. There's still some bookkeeping we that needs to be done
                // in this optimized path, mostly pushing stuff onto the stack.
                switch(workInProgress.tag){
                    case HostRoot:
                        pushHostRootContext(workInProgress);
                        resetHydrationState();
                        break;
                    case HostComponent:
                        pushHostContext(workInProgress);
                        break;
                    case ClassComponent:
                        var Component = workInProgress.type;
                        if (isContextProvider(Component)) pushContextProvider(workInProgress);
                        break;
                    case HostPortal:
                        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                        break;
                    case ContextProvider:
                        var newValue = workInProgress.memoizedProps.value;
                        pushProvider(workInProgress, newValue);
                        break;
                    case Profiler:
                        // Profiler should only call onRender when one of its descendants actually rendered.
                        var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (hasChildWork) workInProgress.flags |= Update;
                         // Reset effect durations for the next eventual effect phase.
                        // These are reset during render to allow the DevTools commit hook a chance to read them,
                        var stateNode = workInProgress.stateNode;
                        stateNode.effectDuration = 0;
                        stateNode.passiveEffectDuration = 0;
                        break;
                    case SuspenseComponent:
                        var state = workInProgress.memoizedState;
                        if (state !== null) {
                            // whether to retry the primary children, or to skip over it and
                            // go straight to the fallback. Check the priority of the primary
                            // child fragment.
                            var primaryChildFragment = workInProgress.child;
                            var primaryChildLanes = primaryChildFragment.childLanes;
                            if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                            // to attempt to render the primary children again.
                            return updateSuspenseComponent(current, workInProgress, renderLanes);
                            else {
                                // The primary child fragment does not have pending work marked
                                // on it
                                pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                                // priority. Bailout.
                                var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                                if (child !== null) // The fallback children have pending work. Skip over the
                                // primary children and work on the fallback.
                                return child.sibling;
                                else return null;
                            }
                        } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                        break;
                    case SuspenseListComponent:
                        var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                        var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                        if (didSuspendBefore) {
                            if (_hasChildWork) // If something was in fallback state last time, and we have all the
                            // same children then we're still in progressive loading state.
                            // Something might get unblocked by state updates or retries in the
                            // tree which will affect the tail. So we need to use the normal
                            // path to compute the correct tail.
                            return updateSuspenseListComponent(current, workInProgress, renderLanes);
                             // If none of the children had any work, that means that none of
                            // them got retried so they'll still be blocked in the same way
                            // as before. We can fast bail out.
                            workInProgress.flags |= DidCapture;
                        } // If nothing suspended before and we're rendering the same children,
                        // then the tail doesn't matter. Anything new that suspends will work
                        // in the "together" mode, so we can continue from the state we had.
                        var renderState = workInProgress.memoizedState;
                        if (renderState !== null) {
                            // Reset to the "together" mode in case we've started a different
                            // update in the past but didn't complete it.
                            renderState.rendering = null;
                            renderState.tail = null;
                            renderState.lastEffect = null;
                        }
                        pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                        if (_hasChildWork) break;
                        else // If none of the children had any work, that means that none of
                        // them got retried so they'll still be blocked in the same way
                        // as before. We can fast bail out.
                        return null;
                    case OffscreenComponent:
                    case LegacyHiddenComponent:
                        // Need to check if the tree still needs to be deferred. This is
                        // almost identical to the logic used in the normal update path,
                        // so we'll just enter that. The only difference is we'll bail out
                        // at the next level instead of this one, because the child props
                        // have not changed. Which is fine.
                        // TODO: Probably should refactor `beginWork` to split the bailout
                        // path from the normal path. I'm tempted to do a labeled break here
                        // but I won't :)
                        workInProgress.lanes = NoLanes;
                        return updateOffscreenComponent(current, workInProgress, renderLanes);
                }
                return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
            // See https://github.com/facebook/react/pull/19216.
            didReceiveUpdate = true;
            else // An update was scheduled on this fiber, but there are no new props
            // nor legacy context. Set this to false. If an update queue or context
            // consumer produces a changed value, it will set this to true. Otherwise,
            // the component will assume the children have not changed and bail out.
            didReceiveUpdate = false;
        } else didReceiveUpdate = false;
         // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, updateLanes, renderLanes);
            case FunctionComponent:
                var _Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === _Component ? unresolvedProps : resolveDefaultProps(_Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, _Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component2 ? _unresolvedProps : resolveDefaultProps(_Component2, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component2, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, 'prop', getComponentName(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, updateLanes, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, updateLanes, renderLanes);
            case IncompleteClassComponent:
                var _Component3 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component3 ? _unresolvedProps4 : resolveDefaultProps(_Component3, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component3, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
            case LegacyHiddenComponent:
                return updateLegacyHiddenComponent(current, workInProgress, renderLanes);
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case 'hidden':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case 'collapsed':
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var fiberRoot = workInProgress.stateNode;
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (!fiberRoot.hydrate) // Schedule an effect to clear this container at the start of the next commit.
                    // This handles the case of React rendering into a container with previous children.
                    // It's also safe to do for updates too, because current.child would only be null
                    // if the previous render was null (so the the container would already be empty).
                    workInProgress.flags |= Snapshot;
                }
                updateHostContainer(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== 'string') {
                        if (!(workInProgress.stateNode !== null)) throw Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState;
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = false;
                if (current === null) {
                    if (workInProgress.memoizedProps.fallback !== undefined) popHydrationState(workInProgress);
                } else {
                    var prevState = current.memoizedState;
                    prevDidTimeout = prevState !== null;
                }
                if (nextDidTimeout && !prevDidTimeout) // If this subtreee is running in blocking mode we can suspend,
                // otherwise we won't suspend.
                // TODO: This will still suspend a synchronous tree if anything
                // in the concurrent tree already suspended during this render.
                // This is a known bug.
                {
                    if ((workInProgress.mode & BlockingMode) !== NoMode) {
                        // TODO: Move this back to throwException because this is too late
                        // if this is a large tree which is common for initial loads. We
                        // don't know if we should restart a render or not until we get
                        // this marker, and this is too late.
                        // If this render already had a ping or lower pri updates,
                        // and this is the first time we know we're going to suspend we
                        // should be able to immediately restart from within throwException.
                        var hasInvisibleChildContext = current === null && workInProgress.memoizedProps.unstable_avoidThisFallback !== true;
                        if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                        // this boundary is ok.
                        renderDidSuspend();
                        else // Otherwise, we're going to have to hide content so we should
                        // suspend for longer if possible.
                        renderDidSuspendDelayIfPossible();
                    }
                }
                // TODO: Only schedule updates if these values are non equal, i.e. it changed.
                if (nextDidTimeout || prevDidTimeout) // If this boundary just timed out, schedule an effect to attach a
                // retry listener to the promise. This flag is also used to hide the
                // primary children. In mutation mode, we also need the flag to
                // *unhide* children that were previously hidden, so check if this
                // is currently timed out, too.
                workInProgress.flags |= Update;
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                return null;
            case ContextProvider:
                // Pop provider fiber
                popProvider(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) // We're running in the default, "independent" mode.
                // We don't do anything in this mode.
                return null;
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thennables. Instead, we'll transfer its thennables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThennables = suspended.updateQueue;
                                    if (newThennables !== null) {
                                        workInProgress.updateQueue = newThennables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect list before doing the second pass since that's now invalid.
                                    if (renderState.lastEffect === null) workInProgress.firstEffect = null;
                                    workInProgress.lastEffect = renderState.lastEffect; // Reset the child fibers to their original state.
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback));
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThennables = _suspended.updateQueue;
                            if (_newThennables !== null) {
                                workInProgress.updateQueue = _newThennables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === 'hidden' && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We need to delete the row we just rendered.
                                // Reset the effect list to what it was before we rendered this
                                // child. The nested children have already appended themselves.
                                var lastEffect = workInProgress.lastEffect = renderState.lastEffect; // Remove any effects that were appended after this point.
                                if (lastEffect !== null) lastEffect.nextEffect = null;
                                 // We're done.
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                            markSpawnedWork(SomeRetryLane);
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.lastEffect = workInProgress.lastEffect;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    return next;
                }
                return null;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case Block:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                if (current !== null) {
                    var _nextState = workInProgress.memoizedState;
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    var nextIsHidden = _nextState !== null;
                    if (prevIsHidden !== nextIsHidden && newProps.mode !== 'unstable-defer-without-hiding') workInProgress.flags |= Update;
                }
                return null;
        }
        throw Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function unwindWork(workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if (!((_flags & DidCapture) === NoFlags)) throw Error("The root failed to unmount after an error. This is likely a bug in React. Please file an issue.");
                workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                return workInProgress;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                popProvider(workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(interruptedWork) {
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                popProvider(interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    function createCapturedValue(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ''; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console['error'](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentName(source.type) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : 'The above error occurred in one of your React components:';
            var errorBoundaryMessage;
            var errorBoundaryName = getComponentName(boundary.type);
            if (errorBoundaryName) errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            else errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console['error'](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === 'function' ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === 'function') {
            var error$1 = errorInfo.value;
            update.payload = function() {
                logCapturedError(fiber, errorInfo);
                return getDerivedStateFromError(error$1);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === 'function') update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            if (typeof getDerivedStateFromError !== 'function') {
                // To preserve the preexisting retry behavior of error boundaries,
                // we keep track of which ones already failed during this batch.
                // This gets reset before we yield back to the browser.
                // TODO: Warn in strict mode if getDerivedStateFromError is
                // not defined.
                markLegacyErrorBoundaryAsFailed(this); // Only log here if componentDidCatch is the only error boundary method defined
                logCapturedError(fiber, errorInfo);
            }
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ''
            });
            if (typeof getDerivedStateFromError !== 'function') // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentName(fiber.type) || 'Unknown');
            }
        };
        else update.callback = function() {
            markFailedErrorBoundaryForHotReloading(fiber);
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a listener to the promise to "ping" the root and retry. But only if
        // one does not already exist for the lanes we're currently rendering (which
        // acts like a "thread ID" here).
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            wakeable.then(ping, ping);
        }
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete; // Its effect list is no longer valid.
        sourceFiber.firstEffect = sourceFiber.lastEffect = null;
        if (value !== null && typeof value === 'object' && typeof value.then === 'function') {
            // This is a wakeable.
            var wakeable = value;
            if ((sourceFiber.mode & BlockingMode) === NoMode) {
                // Reset the memoizedState to what it was before we attempted
                // to render it.
                var currentSource = sourceFiber.alternate;
                if (currentSource) {
                    sourceFiber.updateQueue = currentSource.updateQueue;
                    sourceFiber.memoizedState = currentSource.memoizedState;
                    sourceFiber.lanes = currentSource.lanes;
                } else {
                    sourceFiber.updateQueue = null;
                    sourceFiber.memoizedState = null;
                }
            }
            var hasInvisibleParentBoundary = hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext); // Schedule the nearest Suspense to re-render the timed out view.
            var _workInProgress = returnFiber;
            do {
                if (_workInProgress.tag === SuspenseComponent && shouldCaptureSuspense(_workInProgress, hasInvisibleParentBoundary)) {
                    // Found the nearest boundary.
                    // Stash the promise on the boundary fiber. If the boundary times out, we'll
                    // attach another listener to flip the boundary back to its normal state.
                    var wakeables = _workInProgress.updateQueue;
                    if (wakeables === null) {
                        var updateQueue = new Set();
                        updateQueue.add(wakeable);
                        _workInProgress.updateQueue = updateQueue;
                    } else wakeables.add(wakeable);
                     // If the boundary is outside of blocking mode, we should *not*
                    // suspend the commit. Pretend as if the suspended component rendered
                    // null and keep rendering. In the commit phase, we'll schedule a
                    // subsequent synchronous update to re-render the Suspense.
                    //
                    // Note: It doesn't matter whether the component that suspended was
                    // inside a blocking mode tree. If the Suspense is outside of it, we
                    // should *not* suspend the commit.
                    if ((_workInProgress.mode & BlockingMode) === NoMode) {
                        _workInProgress.flags |= DidCapture;
                        sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                        // But we shouldn't call any lifecycle methods or callbacks. Remove
                        // all lifecycle effect tags.
                        sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                        if (sourceFiber.tag === ClassComponent) {
                            var currentSourceFiber = sourceFiber.alternate;
                            if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                            // completed class component. For example, we should not call
                            // componentWillUnmount if it is deleted.
                            sourceFiber.tag = IncompleteClassComponent;
                            else {
                                // When we try rendering again, we should not reuse the current fiber,
                                // since it's known to be in an inconsistent state. Use a force update to
                                // prevent a bail out.
                                var update = createUpdate(NoTimestamp, SyncLane);
                                update.tag = ForceUpdate;
                                enqueueUpdate(sourceFiber, update);
                            }
                        } // The source fiber did not complete. Mark it with Sync priority to
                        // indicate that it still has pending work.
                        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane); // Exit without suspending.
                        return;
                    } // Confirmed that the boundary is in a concurrent mode tree. Continue
                    // with the normal suspend path.
                    //
                    // After this we'll use a set of heuristics to determine whether this
                    // render pass will run to completion or restart or "suspend" the commit.
                    // The actual logic for this is spread out in different places.
                    //
                    // This first principle is that if we're going to suspend when we complete
                    // a root, then we should also restart if we get an update or ping that
                    // might unsuspend it, and vice versa. The only reason to suspend is
                    // because you think you might want to restart before committing. However,
                    // it doesn't make sense to restart only while in the period we're suspended.
                    //
                    // Restarting too aggressively is also not good because it starves out any
                    // intermediate loading state. So we use heuristics to determine when.
                    // Suspense Heuristics
                    //
                    // If nothing threw a Promise or all the same fallbacks are already showing,
                    // then don't suspend/restart.
                    //
                    // If this is an initial render of a new tree of Suspense boundaries and
                    // those trigger a fallback, then don't suspend/restart. We want to ensure
                    // that we can show the initial loading state as quickly as possible.
                    //
                    // If we hit a "Delayed" case, such as when we'd switch from content back into
                    // a fallback, then we should always suspend/restart. Transitions apply
                    // to this case. If none is defined, JND is used instead.
                    //
                    // If we're already showing a fallback and it gets "retried", allowing us to show
                    // another level, but there's still an inner boundary that would show a fallback,
                    // then we suspend/restart for 500ms since the last time we showed a fallback
                    // anywhere in the tree. This effectively throttles progressive loading into a
                    // consistent train of commits. This also gives us an opportunity to restart to
                    // get to the completed state slightly earlier.
                    //
                    // If there's ambiguity due to batching it's resolved in preference of:
                    // 1) "delayed", 2) "initial render", 3) "retry".
                    //
                    // We want to ensure that a "busy" state doesn't get force committed. We want to
                    // ensure that new initial loading states can commit as soon as possible.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    _workInProgress.flags |= ShouldCapture;
                    _workInProgress.lanes = rootRenderLanes;
                    return;
                } // This boundary already captured during this render. Continue to the next
                // boundary.
                _workInProgress = _workInProgress.return;
            }while (_workInProgress !== null); // No boundary was found. Fallthrough to error mode.
            // TODO: Use invariant so the message is stripped in prod?
            value = new Error((getComponentName(sourceFiber.type) || 'A React component') + ' suspended while rendering, but no fallback UI was specified.\n' + '\n' + 'Add a <Suspense fallback=...> component higher in the tree to ' + 'provide a loading indicator or placeholder to display.');
        } // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        renderDidError();
        value = createCapturedValue(value, sourceFiber);
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var _update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, _update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === 'function' || instance !== null && typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update2 = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update2);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    var PossiblyWeakSet = typeof WeakSet === 'function' ? WeakSet : Set;
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, instance) {
        invokeGuardedCallback(null, callComponentWillUnmountWithTimer, null, current, instance);
        if (hasCaughtError()) {
            var unmountError = clearCaughtError();
            captureCommitPhaseError(current, unmountError);
        }
    }
    function safelyDetachRef(current) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === 'function') {
                invokeGuardedCallback(null, ref, null, null);
                if (hasCaughtError()) {
                    var refError = clearCaughtError();
                    captureCommitPhaseError(current, refError);
                }
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, destroy) {
        invokeGuardedCallback(null, destroy, null);
        if (hasCaughtError()) {
            var error = clearCaughtError();
            captureCommitPhaseError(current, error);
        }
    }
    function commitBeforeMutationLifeCycles(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                return;
            case ClassComponent:
                if (finishedWork.flags & Snapshot) {
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentName(finishedWork.type));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                }
                return;
            case HostRoot:
                if (finishedWork.flags & Snapshot) {
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                }
                return;
            case HostComponent:
            case HostText:
            case HostPortal:
            case IncompleteClassComponent:
                // Nothing to do for these component types
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitHookEffectListUnmount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) destroy();
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(tag, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & tag) === tag) {
                    // Mount
                    var create = effect.create;
                    effect.destroy = create();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== 'function') {
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === 'function') addendum = "\n\nIt looks like you wrote useEffect(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\nuseEffect(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = ' You returned: ' + destroy;
                        error("An effect function must not return anything besides a function, which is used for clean-up.%s", addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function schedulePassiveEffects(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                var _effect = effect, next = _effect.next, tag = _effect.tag;
                if ((tag & Passive$1) !== NoFlags$1 && (tag & HasEffect) !== NoFlags$1) {
                    enqueuePendingPassiveHookEffectUnmount(finishedWork, effect);
                    enqueuePendingPassiveHookEffectMount(finishedWork, effect);
                }
                effect = next;
            }while (effect !== firstEffect);
        }
    }
    function commitLifeCycles(finishedRoot, current, finishedWork, committedLanes) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListMount(Layout | HasEffect, finishedWork);
                schedulePassiveEffects(finishedWork);
                return;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (current === null) {
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidMount();
                    } else {
                        var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                        var prevState = current.memoizedState; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        }
                        instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentName(finishedWork.type) || 'instance');
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                return;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                return;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                return;
            case HostText:
                // We have no life-cycles associated with text.
                return;
            case HostPortal:
                // We have no life-cycles associated with portals.
                return;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                if (typeof onRender === 'function') onRender(finishedWork.memoizedProps.id, current === null ? 'mount' : 'update', finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime, finishedRoot.memoizedInteractions);
                return;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                return;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case FundamentalComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                var instance = node.stateNode;
                if (isHidden) hideInstance(instance);
                else unhideInstance(node.stateNode, node.memoizedProps);
            } else if (node.tag === HostText) {
                var _instance3 = node.stateNode;
                if (isHidden) hideTextInstance(_instance3);
                else unhideTextInstance(_instance3, node.memoizedProps);
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === 'function') ref(instanceToUse);
            else {
                if (!ref.hasOwnProperty('current')) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentName(finishedWork.type));
                ref.current = instanceToUse;
            }
        }
    }
    function commitDetachRef(current) {
        var currentRef = current.ref;
        if (currentRef !== null) {
            if (typeof currentRef === 'function') currentRef(null);
            else currentRef.current = null;
        }
    } // User-originating errors (lifecycles and refs) should not interrupt
    // deletion, so don't let them throw. Host-originating errors should
    // interrupt deletion, so it's okay
    function commitUnmount(finishedRoot, current, renderPriorityLevel) {
        onCommitUnmount(current);
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                var updateQueue = current.updateQueue;
                if (updateQueue !== null) {
                    var lastEffect = updateQueue.lastEffect;
                    if (lastEffect !== null) {
                        var firstEffect = lastEffect.next;
                        var effect = firstEffect;
                        do {
                            var _effect2 = effect, destroy = _effect2.destroy, tag = _effect2.tag;
                            if (destroy !== undefined) {
                                if ((tag & Passive$1) !== NoFlags$1) enqueuePendingPassiveHookEffectUnmount(current, effect);
                                else safelyCallDestroy(current, destroy);
                            }
                            effect = effect.next;
                        }while (effect !== firstEffect);
                    }
                }
                return;
            case ClassComponent:
                safelyDetachRef(current);
                var instance = current.stateNode;
                if (typeof instance.componentWillUnmount === 'function') safelyCallComponentWillUnmount(current, instance);
                return;
            case HostComponent:
                safelyDetachRef(current);
                return;
            case HostPortal:
                unmountHostComponents(finishedRoot, current);
                return;
            case FundamentalComponent:
                return;
            case DehydratedFragment:
                return;
            case ScopeComponent:
                return;
        }
    }
    function commitNestedUnmounts(finishedRoot, root, renderPriorityLevel) {
        // While we're inside a removed host node we don't want to call
        // removeChild on the inner nodes because they're removed by the top
        // call anyway. We also want to call componentWillUnmount on all
        // composites before this host node is removed from the tree. Therefore
        // we do an inner loop while we're still inside the host node.
        var node = root;
        while(true){
            commitUnmount(finishedRoot, node); // Visit children because they may contain more composite or host nodes.
            // Skip portals because commitUnmount() currently visits them recursively.
            if (node.child !== null && // If we don't use mutation we drill down into portals here instead.
            node.tag !== HostPortal) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === root) return;
            while(node.sibling === null){
                if (node.return === null || node.return === root) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointers to disconnect it from the tree. Ideally, we
        // should clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child. This child
        // itself will be GC:ed when the parent updates the next time.
        // Note: we cannot null out sibling here, otherwise it can cause issues
        // with findDOMNode and how it requires the sibling field to carry out
        // traversal in a later effect. See PR #16820. We now clear the sibling
        // field after effects, see: detachFiberAfterEffects.
        //
        // Don't disconnect stateNode now; it will be detached in detachFiberAfterEffects.
        // It may be required if the current component is an error boundary,
        // and one of its descendants throws while unmounting a passive effect.
        fiber.alternate = null;
        fiber.child = null;
        fiber.dependencies = null;
        fiber.firstEffect = null;
        fiber.lastEffect = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.return = null;
        fiber.updateQueue = null;
        fiber._debugOwner = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        var parent;
        var isContainer;
        var parentStateNode = parentFiber.stateNode;
        switch(parentFiber.tag){
            case HostComponent:
                parent = parentStateNode;
                isContainer = false;
                break;
            case HostRoot:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case HostPortal:
                parent = parentStateNode.containerInfo;
                isContainer = true;
                break;
            case FundamentalComponent:
            // eslint-disable-next-line-no-fallthrough
            default:
                throw Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (parentFiber.flags & ContentReset) {
            // Reset the text content of the parent before doing any insertions
            resetTextContent(parent); // Clear ContentReset from the effect tag
            parentFiber.flags &= ~ContentReset;
        }
        var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        if (isContainer) insertOrAppendPlacementNodeIntoContainer(finishedWork, before, parent);
        else insertOrAppendPlacementNode(finishedWork, before, parent);
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost || enableFundamentalAPI) {
            var stateNode = isHost ? node.stateNode : node.stateNode.instance;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function unmountHostComponents(finishedRoot, current, renderPriorityLevel) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = current; // Each iteration, currentParent is populated with node's host parent if not
        // currentParentIsValid.
        var currentParentIsValid = false; // Note: these two variables *must* always be updated together.
        var currentParent;
        var currentParentIsContainer;
        while(true){
            if (!currentParentIsValid) {
                var parent = node.return;
                findParent: while(true){
                    if (!(parent !== null)) throw Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
                    var parentStateNode = parent.stateNode;
                    switch(parent.tag){
                        case HostComponent:
                            currentParent = parentStateNode;
                            currentParentIsContainer = false;
                            break findParent;
                        case HostRoot:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                        case HostPortal:
                            currentParent = parentStateNode.containerInfo;
                            currentParentIsContainer = true;
                            break findParent;
                    }
                    parent = parent.return;
                }
                currentParentIsValid = true;
            }
            if (node.tag === HostComponent || node.tag === HostText) {
                commitNestedUnmounts(finishedRoot, node); // After all the children have unmounted, it is now safe to remove the
                // node from the tree.
                if (currentParentIsContainer) removeChildFromContainer(currentParent, node.stateNode);
                else removeChild(currentParent, node.stateNode);
                 // Don't visit children because we already visited them.
            } else if (node.tag === HostPortal) {
                if (node.child !== null) {
                    // When we go into a portal, it becomes the parent to remove from.
                    // We will reassign it back when we pop the portal on the way up.
                    currentParent = node.stateNode.containerInfo;
                    currentParentIsContainer = true; // Visit children because portals might contain host components.
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            } else {
                commitUnmount(finishedRoot, node); // Visit children because we may find more host components below.
                if (node.child !== null) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === current) return;
            while(node.sibling === null){
                if (node.return === null || node.return === current) return;
                node = node.return;
                if (node.tag === HostPortal) // When we go out of the portal, we need to restore the parent.
                // Since we don't keep a stack of them, we will search for it.
                currentParentIsValid = false;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitDeletion(finishedRoot, current, renderPriorityLevel) {
        // Recursively delete all host nodes from the parent.
        // Detach refs and call componentWillUnmount() on the whole subtree.
        unmountHostComponents(finishedRoot, current);
        var alternate = current.alternate;
        detachFiberMutation(current);
        if (alternate !== null) detachFiberMutation(alternate);
    }
    function commitWork(current, finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
            case Block:
                commitHookEffectListUnmount(Layout | HasEffect, finishedWork);
                return;
            case ClassComponent:
                return;
            case HostComponent:
                var instance = finishedWork.stateNode;
                if (instance != null) {
                    // Commit the work prepared earlier.
                    var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldProps = current !== null ? current.memoizedProps : newProps;
                    var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                    var updatePayload = finishedWork.updateQueue;
                    finishedWork.updateQueue = null;
                    if (updatePayload !== null) commitUpdate(instance, updatePayload, type, oldProps, newProps);
                }
                return;
            case HostText:
                if (!(finishedWork.stateNode !== null)) throw Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                var textInstance = finishedWork.stateNode;
                var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                // as the newProps. The updatePayload will contain the real change in
                // this case.
                var oldText = current !== null ? current.memoizedProps : newText;
                commitTextUpdate(textInstance, oldText, newText);
                return;
            case HostRoot:
                var _root = finishedWork.stateNode;
                if (_root.hydrate) {
                    // We've just hydrated. No need to hydrate again.
                    _root.hydrate = false;
                    commitHydratedContainer(_root.containerInfo);
                }
                return;
            case Profiler:
                return;
            case SuspenseComponent:
                commitSuspenseComponent(finishedWork);
                attachSuspenseRetryListeners(finishedWork);
                return;
            case SuspenseListComponent:
                attachSuspenseRetryListeners(finishedWork);
                return;
            case IncompleteClassComponent:
                return;
            case FundamentalComponent:
                break;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                var newState = finishedWork.memoizedState;
                var isHidden = newState !== null;
                hideOrUnhideAllChildren(finishedWork, isHidden);
                return;
        }
        throw Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
    }
    function commitSuspenseComponent(finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState !== null) {
            markCommitTimeOfFallback();
            // Hide the Offscreen component that contains the primary children. TODO:
            // Ideally, this effect would have been scheduled on the Offscreen fiber
            // itself. That's how unhiding works: the Offscreen component schedules an
            // effect on itself. However, in this case, the component didn't complete,
            // so the fiber was never added to the effect list in the normal path. We
            // could have appended it to the effect list in the Suspense component's
            // second pass, but doing it this way is less complicated. This would be
            // simpler if we got rid of the effect list and traversed the tree, like
            // we're planning to do.
            var primaryChildParent = finishedWork.child;
            hideOrUnhideAllChildren(primaryChildParent, true);
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    if (wakeable.__reactDoNotTraceInteractions !== true) retry = tracing.unstable_wrap(retry);
                    retryCache.add(wakeable);
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    // It returns false if the boundary is already hidden.
    // TODO: Use an effect tag.
    function isSuspenseBoundaryBeingHidden(current, finishedWork) {
        if (current !== null) {
            var oldState = current.memoizedState;
            if (oldState === null || oldState.dehydrated !== null) {
                var newState = finishedWork.memoizedState;
                return newState !== null && newState.dehydrated === null;
            }
        }
        return false;
    }
    function commitResetTextContent(current) {
        resetTextContent(current.stateNode);
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor$1 = Symbol.for;
        COMPONENT_TYPE = symbolFor$1('selector.component');
        HAS_PSEUDO_CLASS_TYPE = symbolFor$1('selector.has_pseudo_class');
        ROLE_TYPE = symbolFor$1('selector.role');
        TEST_NAME_TYPE = symbolFor$1('selector.test_id');
        TEXT_TYPE = symbolFor$1('selector.text');
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, IsSomeRendererActing = ReactSharedInternals.IsSomeRendererActing;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var EventContext = /*                 */ 2;
    var DiscreteEventContext = /*         */ 4;
    var LegacyUnbatchedContext = /*       */ 8;
    var RenderContext = /*                */ 16;
    var CommitContext = /*                */ 32;
    var RetryAfterError = /*       */ 64;
    var RootIncomplete = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootIncomplete; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootUpdatedLanes = NoLanes; // Lanes that were pinged (in an interleaved event) during this render.
    var workInProgressRootPingedLanes = NoLanes;
    var mostRecentlyUpdatedRoot = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var nextEffect = null;
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsRenderPriority = NoPriority$1;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveHookEffectsMount = [];
    var pendingPassiveHookEffectsUnmount = [];
    var rootsWithPendingDiscreteUpdates = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0; // Marks the need to reschedule pending interactions at these lanes
    // during the commit phase. This enables them to be traced across components
    // that spawn new work during render. E.g. hidden boundaries, suspended SSR
    // hydration or SuspenseList.
    // TODO: Can use a bitmask instead of an array
    var spawnedWorkDuringRender = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventWipLanes = NoLanes;
    var currentEventPendingLanes = NoLanes; // Dev only flag that tracks if passive effects are currently being flushed.
    // We warn about state updates for unmounted components differently in this case.
    var isFlushingPassiveEffects = false;
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // The algorithm for assigning an update to a lane should be stable for all
        // updates at the same priority within the same event. To do this, the inputs
        // to the algorithm must be the same. For example, we use the `renderLanes`
        // to avoid choosing a lane that is already in the middle of rendering.
        //
        // However, the "included" lanes could be mutated in between updates in the
        // same event, like if you perform an update inside `flushSync`. Or any other
        // code path that might call `prepareFreshStack`.
        //
        // The trick we use is to cache the first of each of these inputs within an
        // event. Then reset the cached values once we can be sure the event is over.
        // Our heuristic for that is whenever we enter a concurrent work loop.
        //
        // We'll do the same for `currentEventPendingLanes` below.
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (currentEventPendingLanes !== NoLanes) currentEventPendingLanes = mostRecentlyUpdatedRoot !== null ? mostRecentlyUpdatedRoot.pendingLanes : NoLanes;
            return findTransitionLane(currentEventWipLanes, currentEventPendingLanes);
        } // TODO: Remove this dependency on the Scheduler priority.
        // To do that, we're replacing it with an update lane priority.
        var schedulerPriority = getCurrentPriorityLevel(); // The old behavior was using the priority level of the Scheduler.
        // This couples React to the Scheduler internals, so we're replacing it
        // with the currentUpdateLanePriority above. As an example of how this
        // could be problematic, if we're not inside `Scheduler.runWithPriority`,
        // then we'll get the priority of the current running Scheduler task,
        // which is probably not what we want.
        var lane;
        if ((executionContext & DiscreteEventContext) !== NoContext && schedulerPriority === UserBlockingPriority$2) lane = findUpdateLane(InputDiscreteLanePriority, currentEventWipLanes);
        else {
            var schedulerLanePriority = schedulerPriorityToLanePriority(schedulerPriority);
            lane = findUpdateLane(schedulerLanePriority, currentEventWipLanes);
        }
        return lane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & BlockingMode) === NoMode) return SyncLane;
        else if ((mode & ConcurrentMode) === NoMode) return getCurrentPriorityLevel() === ImmediatePriority$1 ? SyncLane : SyncBatchedLane;
         // See `requestUpdateLane` for explanation of `currentEventWipLanes`
        if (currentEventWipLanes === NoLanes) currentEventWipLanes = workInProgressRootIncludedLanes;
        return findRetryLane(currentEventWipLanes);
    }
    function scheduleUpdateOnFiber(fiber, lane, eventTime) {
        checkForNestedUpdates();
        warnAboutRenderPhaseUpdatesInDEV(fiber);
        var root = markUpdateLaneFromFiberToRoot(fiber, lane);
        if (root === null) {
            warnAboutUpdateOnUnmountedFiberInDEV(fiber);
            return null;
        } // Mark that the root has a pending update.
        markRootUpdated(root, lane, eventTime);
        if (root === workInProgressRoot) {
            workInProgressRootUpdatedLanes = mergeLanes(workInProgressRootUpdatedLanes, lane);
            if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
            // definitely won't finish. Since we have a new update, let's mark it as
            // suspended now, right before marking the incoming update. This has the
            // effect of interrupting the current render and switching to the update.
            // TODO: Make sure this doesn't override pings that happen while we've
            // already started rendering.
            markRootSuspended$1(root, workInProgressRootRenderLanes);
        } // TODO: requestUpdateLanePriority also reads the priority. Pass the
        // priority as an argument to that function and this one.
        var priorityLevel = getCurrentPriorityLevel();
        if (lane === SyncLane) {
            if ((executionContext & LegacyUnbatchedContext) !== NoContext && // Check if we're not already rendering
            (executionContext & (RenderContext | CommitContext)) === NoContext) {
                // Register pending interactions on the root to avoid losing traced interaction data.
                schedulePendingInteractions(root, lane); // This is a legacy edge case. The initial mount of a ReactDOM.render-ed
                // root inside of batchedUpdates should be synchronous, but layout updates
                // should be deferred until the end of the batch.
                performSyncWorkOnRoot(root);
            } else {
                ensureRootIsScheduled(root, eventTime);
                schedulePendingInteractions(root, lane);
                if (executionContext === NoContext) {
                    // Flush the synchronous work now, unless we're already working or inside
                    // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                    // scheduleCallbackForFiber to preserve the ability to schedule a callback
                    // without immediately flushing it. We only do this for user-initiated
                    // updates, to preserve historical behavior of legacy mode.
                    resetRenderTimer();
                    flushSyncCallbackQueue();
                }
            }
        } else {
            // Schedule a discrete update but only if it's not Sync.
            if ((executionContext & DiscreteEventContext) !== NoContext && // discrete, even inside a discrete event.
            (priorityLevel === UserBlockingPriority$2 || priorityLevel === ImmediatePriority$1)) {
                // This is the result of a discrete event. Track the lowest priority
                // discrete update per root so we can flush them early, if needed.
                if (rootsWithPendingDiscreteUpdates === null) rootsWithPendingDiscreteUpdates = new Set([
                    root
                ]);
                else rootsWithPendingDiscreteUpdates.add(root);
            } // Schedule other updates after in case the callback is sync.
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, lane);
        } // We use this when assigning a lane for a transition inside
        // `requestUpdateLane`. We assume it's the same as the root being updated,
        // since in the common case of a single root app it probably is. If it's not
        // the same root, then it's not a huge deal, we just might batch more stuff
        // together more than necessary.
        mostRecentlyUpdatedRoot = root;
    } // This is split into a separate function so we can mark a fiber with pending
    // work without treating it as a typical update that originates from an event;
    // e.g. retrying a Suspense boundary isn't an update, but it does schedule work
    // on a fiber.
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes); // This returns the priority level computed during the `getNextLanes` call.
        var newCallbackPriority = returnNextLanesPriority();
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) {
                cancelCallback(existingCallbackNode);
                root.callbackNode = null;
                root.callbackPriority = NoLanePriority;
            }
            return;
        } // Check if there's an existing task. We may be able to reuse it.
        if (existingCallbackNode !== null) {
            var existingCallbackPriority = root.callbackPriority;
            if (existingCallbackPriority === newCallbackPriority) // The priority hasn't changed. We can reuse the existing task. Exit.
            return;
             // The priority changed. Cancel the existing callback. We'll schedule a new
            // one below.
            cancelCallback(existingCallbackNode);
        } // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLanePriority) // Special case: Sync React callbacks are scheduled on a special
        // internal queue
        newCallbackNode = scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
        else if (newCallbackPriority === SyncBatchedLanePriority) newCallbackNode = scheduleCallback(ImmediatePriority$1, performSyncWorkOnRoot.bind(null, root));
        else {
            var schedulerPriorityLevel = lanePriorityToSchedulerPriority(newCallbackPriority);
            newCallbackNode = scheduleCallback(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root) {
        // Since we know we're in a React event, we can clear the current
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventWipLanes = NoLanes;
        currentEventPendingLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next expiration time to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
        var exitStatus = renderRootConcurrent(root, lanes);
        if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) // The render included lanes that were updated during the render phase.
        // For example, when unhiding a hidden tree, we include all the lanes
        // that were previously skipped when the tree was hidden. That set of
        // lanes is a superset of the lanes we started rendering with.
        //
        // So we'll throw out the current work and restart.
        prepareFreshStack(root, NoLanes);
        else if (exitStatus !== RootIncomplete) {
            if (exitStatus === RootErrored) {
                executionContext |= RetryAfterError; // If an error occurred during hydration,
                // discard server response and fall back to client side render.
                if (root.hydrate) {
                    root.hydrate = false;
                    clearContainer(root.containerInfo);
                } // If something threw an error, try rendering one more time. We'll render
                // synchronously to block concurrent data mutations, and we'll includes
                // all pending updates are included. If it still fails after the second
                // attempt, we'll give up and commit the resulting tree.
                lanes = getLanesToRetrySynchronouslyOnError(root);
                if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            } // We now have a consistent tree. The next step is either to commit it,
            // or, if something suspended, wait to commit it after a timeout.
            var finishedWork = root.current.alternate;
            root.finishedWork = finishedWork;
            root.finishedLanes = lanes;
            finishConcurrentRender(root, exitStatus, lanes);
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootIncomplete:
            case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root);
                break;
            default:
                throw Error("Unknown root exit status.");
        }
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        flushPassiveEffects();
        var lanes;
        var exitStatus;
        if (root === workInProgressRoot && includesSomeLane(root.expiredLanes, workInProgressRootRenderLanes)) {
            // There's a partial tree, and at least one of its lanes has expired. Finish
            // rendering it before rendering the rest of the expired work.
            lanes = workInProgressRootRenderLanes;
            exitStatus = renderRootSync(root, lanes);
            if (includesSomeLane(workInProgressRootIncludedLanes, workInProgressRootUpdatedLanes)) {
                // The render included lanes that were updated during the render phase.
                // For example, when unhiding a hidden tree, we include all the lanes
                // that were previously skipped when the tree was hidden. That set of
                // lanes is a superset of the lanes we started rendering with.
                //
                // Note that this only happens when part of the tree is rendered
                // concurrently. If the whole tree is rendered synchronously, then there
                // are no interleaved events.
                lanes = getNextLanes(root, lanes);
                exitStatus = renderRootSync(root, lanes);
            }
        } else {
            lanes = getNextLanes(root, NoLanes);
            exitStatus = renderRootSync(root, lanes);
        }
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            executionContext |= RetryAfterError; // If an error occurred during hydration,
            // discard server response and fall back to client side render.
            if (root.hydrate) {
                root.hydrate = false;
                clearContainer(root.containerInfo);
            } // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            lanes = getLanesToRetrySynchronouslyOnError(root);
            if (lanes !== NoLanes) exitStatus = renderRootSync(root, lanes);
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        } // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushDiscreteUpdates() {
        // TODO: Should be able to flush inside batchedUpdates, but not inside `act`.
        // However, `act` uses `batchedUpdates`, so there's no way to distinguish
        // those two cases. Need to fix this before exposing flushDiscreteUpdates
        // as a public API.
        if ((executionContext & (BatchedContext | RenderContext | CommitContext)) !== NoContext) {
            if ((executionContext & RenderContext) !== NoContext) error("unstable_flushDiscreteUpdates: Cannot flush updates when React is already rendering.");
            // This is probably a nested event dispatch triggered by a lifecycle/effect,
            // like `el.focus()`. Exit.
            return;
        }
        flushPendingDiscreteUpdates(); // If the discrete updates scheduled passive effects, flush them now so that
        // they fire before the next serial event.
        flushPassiveEffects();
    }
    function flushPendingDiscreteUpdates() {
        if (rootsWithPendingDiscreteUpdates !== null) {
            // For each root with pending discrete updates, schedule a callback to
            // immediately flush them.
            var roots = rootsWithPendingDiscreteUpdates;
            rootsWithPendingDiscreteUpdates = null;
            roots.forEach(function(root) {
                markDiscreteUpdatesExpired(root);
                ensureRootIsScheduled(root, now());
            });
        } // Now flush the immediate queue.
        flushSyncCallbackQueue();
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function batchedEventUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= EventContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function discreteUpdates$1(fn, a, b, c, d) {
        var prevExecutionContext = executionContext;
        executionContext |= DiscreteEventContext;
        try {
            return runWithPriority$1(UserBlockingPriority$2, fn.bind(null, a, b, c, d));
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function unbatchedUpdates(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext &= ~BatchedContext;
        executionContext |= LegacyUnbatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext;
            if (executionContext === NoContext) {
                // Flush the immediate callbacks that were scheduled during this batch
                resetRenderTimer();
                flushSyncCallbackQueue();
            }
        }
    }
    function flushSync(fn, a) {
        var prevExecutionContext = executionContext;
        if ((prevExecutionContext & (RenderContext | CommitContext)) !== NoContext) {
            error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
            return fn(a);
        }
        executionContext |= BatchedContext;
        try {
            if (fn) return runWithPriority$1(ImmediatePriority$1, fn.bind(null, a));
            else return undefined;
        } finally{
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            flushSyncCallbackQueue();
        }
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                unwindInterruptedWork(interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        workInProgress = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootIncomplete;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        spawnedWorkDuringRender = null;
        ReactStrictModeWarnings.discardPendingWarnings();
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function pushInteractions(root) {
        var prevInteractions = tracing.__interactionsRef.current;
        tracing.__interactionsRef.current = root.memoizedInteractions;
        return prevInteractions;
    }
    function popInteractions(prevInteractions) {
        tracing.__interactionsRef.current = prevInteractions;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootIncomplete || workInProgressRootExitStatus === RootSuspended) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError() {
        if (workInProgressRootExitStatus !== RootCompleted) workInProgressRootExitStatus = RootErrored;
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootIncomplete;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) throw Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            resetRenderTimer();
            prepareFreshStack(root, lanes);
            startWorkOnPendingInteractions(root, lanes);
        }
        var prevInteractions = pushInteractions(root);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popInteractions(prevInteractions);
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) return RootIncomplete;
        else {
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
                resetChildLanes(completedWork);
                if (returnFiber !== null && // Do not append effects to parents if a sibling failed to complete
                (returnFiber.flags & Incomplete) === NoFlags) {
                    // Append all the effects of the subtree and this fiber onto the effect
                    // list of the parent. The completion order of the children affects the
                    // side-effect order.
                    if (returnFiber.firstEffect === null) returnFiber.firstEffect = completedWork.firstEffect;
                    if (completedWork.lastEffect !== null) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork.firstEffect;
                        returnFiber.lastEffect = completedWork.lastEffect;
                    } // If this fiber had side-effects, we append it AFTER the children's
                    // side-effects. We can perform certain side-effects earlier if needed,
                    // by doing multiple passes over the effect list. We don't want to
                    // schedule our own side-effect on our own list because if end up
                    // reusing children we'll schedule this effect onto itself since we're
                    // at the end.
                    var flags = completedWork.flags; // Skip both NoWork and PerformedWork tags when creating the effect
                    // list. PerformedWork effect is read by React DevTools but shouldn't be
                    // committed.
                    if (flags > PerformedWork) {
                        if (returnFiber.lastEffect !== null) returnFiber.lastEffect.nextEffect = completedWork;
                        else returnFiber.firstEffect = completedWork;
                        returnFiber.lastEffect = completedWork;
                    }
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(completedWork); // Because this fiber did not complete, don't reset its expiration time.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its effect list.
                    returnFiber.firstEffect = returnFiber.lastEffect = null;
                    returnFiber.flags |= Incomplete;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootIncomplete) workInProgressRootExitStatus = RootCompleted;
    }
    function resetChildLanes(completedWork) {
        if (// to switch statement in `completeWork`.
        (completedWork.tag === LegacyHiddenComponent || completedWork.tag === OffscreenComponent) && completedWork.memoizedState !== null && !includesSomeLane(subtreeRenderLanes, OffscreenLane) && (completedWork.mode & ConcurrentMode) !== NoLanes) // The children of this component are hidden. Don't bubble their
        // expiration times.
        return;
        var newChildLanes = NoLanes; // Bubble up the earliest expiration time.
        if ((completedWork.mode & ProfileMode) !== NoMode) {
            // In profiling mode, resetChildExpirationTime is also used to reset
            // profiler durations.
            var actualDuration = completedWork.actualDuration;
            var treeBaseDuration = completedWork.selfBaseDuration; // When a fiber is cloned, its actualDuration is reset to 0. This value will
            // only be updated if work is done on the fiber (i.e. it doesn't bailout).
            // When work is done, it should bubble to the parent's actualDuration. If
            // the fiber has not been cloned though, (meaning no work was done), then
            // this value will reflect the amount of time spent working on a previous
            // render. In that case it should not bubble. We determine whether it was
            // cloned by comparing the child pointer.
            var shouldBubbleActualDurations = completedWork.alternate === null || completedWork.child !== completedWork.alternate.child;
            var child = completedWork.child;
            while(child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                if (shouldBubbleActualDurations) actualDuration += child.actualDuration;
                treeBaseDuration += child.treeBaseDuration;
                child = child.sibling;
            }
            var isTimedOutSuspense = completedWork.tag === SuspenseComponent && completedWork.memoizedState !== null;
            if (isTimedOutSuspense) {
                // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                var primaryChildFragment = completedWork.child;
                if (primaryChildFragment !== null) treeBaseDuration -= primaryChildFragment.treeBaseDuration;
            }
            completedWork.actualDuration = actualDuration;
            completedWork.treeBaseDuration = treeBaseDuration;
        } else {
            var _child = completedWork.child;
            while(_child !== null){
                newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                _child = _child.sibling;
            }
        }
        completedWork.childLanes = newChildLanes;
    }
    function commitRoot(root) {
        var renderPriorityLevel = getCurrentPriorityLevel();
        runWithPriority$1(ImmediatePriority$1, commitRootImpl.bind(null, root, renderPriorityLevel));
        return null;
    }
    function commitRootImpl(root, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        if (finishedWork === null) return null;
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (!(finishedWork !== root.current)) throw Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes); // Clear already finished discrete updates in case that a later call of
        // `flushDiscreteUpdates` starts a useless render pass which may cancels
        // a scheduled timeout.
        if (rootsWithPendingDiscreteUpdates !== null) {
            if (!hasDiscreteLanes(remainingLanes) && rootsWithPendingDiscreteUpdates.has(root)) rootsWithPendingDiscreteUpdates.delete(root);
        }
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // Get the list of effects.
        var firstEffect;
        if (finishedWork.flags > PerformedWork) {
            // A fiber's effect list consists only of its children, not itself. So if
            // the root has an effect, we need to add it to the end of the list. The
            // resulting list is the set that would belong to the root's parent, if it
            // had one; that is, all the effects in the tree including the root.
            if (finishedWork.lastEffect !== null) {
                finishedWork.lastEffect.nextEffect = finishedWork;
                firstEffect = finishedWork.firstEffect;
            } else firstEffect = finishedWork;
        } else // There is no effect on the root.
        firstEffect = finishedWork.firstEffect;
        if (firstEffect !== null) {
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext;
            var prevInteractions = pushInteractions(root); // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            focusedInstanceHandle = prepareForCommit(root.containerInfo);
            shouldFireAfterActiveInstanceBlur = false;
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitBeforeMutationEffects, null);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null); // We no longer need to track the active instance fiber
            focusedInstanceHandle = null;
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitMutationEffects, null, root, renderPriorityLevel);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            // the host tree after it's been mutated. The idiomatic use case for this is
            // layout, but class component lifecycles also fire here for legacy reasons.
            nextEffect = firstEffect;
            do {
                invokeGuardedCallback(null, commitLayoutEffects, null, root, lanes);
                if (hasCaughtError()) {
                    if (!(nextEffect !== null)) throw Error("Should be working on an effect.");
                    var _error2 = clearCaughtError();
                    captureCommitPhaseError(nextEffect, _error2);
                    nextEffect = nextEffect.nextEffect;
                }
            }while (nextEffect !== null);
            nextEffect = null; // Tell Scheduler to yield at the end of the frame, so the browser has an
            // opportunity to paint.
            requestPaint();
            popInteractions(prevInteractions);
            executionContext = prevExecutionContext;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
            pendingPassiveEffectsRenderPriority = renderPriorityLevel;
        } else {
            // We are done with the effect chain at this point so let's clear the
            // nextEffect pointers to assist with GC. If we have passive effects, we'll
            // clear this in flushPassiveEffects.
            nextEffect = firstEffect;
            while(nextEffect !== null){
                var nextNextEffect = nextEffect.nextEffect;
                nextEffect.nextEffect = null;
                if (nextEffect.flags & Deletion) detachFiberAfterEffects(nextEffect);
                nextEffect = nextNextEffect;
            }
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        if (remainingLanes !== NoLanes) {
            if (spawnedWorkDuringRender !== null) {
                var expirationTimes = spawnedWorkDuringRender;
                spawnedWorkDuringRender = null;
                for(var i = 0; i < expirationTimes.length; i++)scheduleInteractions(root, expirationTimes[i], root.memoizedInteractions);
            }
            schedulePendingInteractions(root, remainingLanes);
        } else // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) // If there are no passive effects, then we can complete the pending interactions.
        // Otherwise, we'll wait until after the passive effects are flushed.
        // Wait to do this until after remaining work has been scheduled,
        // so that we don't prematurely signal complete for interactions when there's e.g. hidden work.
        finishPendingInteractions(root, lanes);
        if (remainingLanes === SyncLane) {
            // Count the number of times the root synchronously re-renders without
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var _error3 = firstUncaughtError;
            firstUncaughtError = null;
            throw _error3;
        }
        if ((executionContext & LegacyUnbatchedContext) !== NoContext) // a ReactDOM.render-ed root inside of batchedUpdates. The commit fired
        // synchronously, but layout updates should be deferred until the end
        // of the batch.
        return null;
         // If layout work was scheduled, flush it now.
        flushSyncCallbackQueue();
        return null;
    }
    function commitBeforeMutationEffects() {
        while(nextEffect !== null){
            var current = nextEffect.alternate;
            if (!shouldFireAfterActiveInstanceBlur && focusedInstanceHandle !== null) {
                if ((nextEffect.flags & Deletion) !== NoFlags) {
                    if (doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
                } else // TODO: Move this out of the hot path using a dedicated effect tag.
                if (nextEffect.tag === SuspenseComponent && isSuspenseBoundaryBeingHidden(current, nextEffect) && doesFiberContain(nextEffect, focusedInstanceHandle)) shouldFireAfterActiveInstanceBlur = true;
            }
            var flags = nextEffect.flags;
            if ((flags & Snapshot) !== NoFlags) {
                setCurrentFiber(nextEffect);
                commitBeforeMutationLifeCycles(current, nextEffect);
                resetCurrentFiber();
            }
            if ((flags & Passive) !== NoFlags) // If there are passive effects, schedule a callback to flush at
            // the earliest opportunity.
            {
                if (!rootDoesHavePassiveEffects) {
                    rootDoesHavePassiveEffects = true;
                    scheduleCallback(NormalPriority$1, function() {
                        flushPassiveEffects();
                        return null;
                    });
                }
            }
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitMutationEffects(root, renderPriorityLevel) {
        // TODO: Should probably move the bulk of this function to commitWork.
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & ContentReset) commitResetTextContent(nextEffect);
            if (flags & Ref) {
                var current = nextEffect.alternate;
                if (current !== null) commitDetachRef(current);
            } // The following switch statement is only concerned about placement,
            // updates, and deletions. To avoid needing to add a case for every possible
            // bitmap value, we remove the secondary effects from the effect tag and
            // switch on that value.
            var primaryFlags = flags & (Placement | Update | Deletion | Hydrating);
            switch(primaryFlags){
                case Placement:
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    // TODO: findDOMNode doesn't rely on this any more but isMounted does
                    // and isMounted is deprecated anyway so we should be able to kill this.
                    nextEffect.flags &= ~Placement;
                    break;
                case PlacementAndUpdate:
                    // Placement
                    commitPlacement(nextEffect); // Clear the "placement" from effect tag so that we know that this is
                    // inserted, before any life-cycles like componentDidMount gets called.
                    nextEffect.flags &= ~Placement; // Update
                    var _current = nextEffect.alternate;
                    commitWork(_current, nextEffect);
                    break;
                case Hydrating:
                    nextEffect.flags &= ~Hydrating;
                    break;
                case HydratingAndUpdate:
                    nextEffect.flags &= ~Hydrating; // Update
                    var _current2 = nextEffect.alternate;
                    commitWork(_current2, nextEffect);
                    break;
                case Update:
                    var _current3 = nextEffect.alternate;
                    commitWork(_current3, nextEffect);
                    break;
                case Deletion:
                    commitDeletion(root, nextEffect);
                    break;
            }
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function commitLayoutEffects(root, committedLanes) {
        while(nextEffect !== null){
            setCurrentFiber(nextEffect);
            var flags = nextEffect.flags;
            if (flags & (Update | Callback)) {
                var current = nextEffect.alternate;
                commitLifeCycles(root, current, nextEffect);
            }
            if (flags & Ref) commitAttachRef(nextEffect);
            resetCurrentFiber();
            nextEffect = nextEffect.nextEffect;
        }
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        if (pendingPassiveEffectsRenderPriority !== NoPriority$1) {
            var priorityLevel = pendingPassiveEffectsRenderPriority > NormalPriority$1 ? NormalPriority$1 : pendingPassiveEffectsRenderPriority;
            pendingPassiveEffectsRenderPriority = NoPriority$1;
            return runWithPriority$1(priorityLevel, flushPassiveEffectsImpl);
        }
        return false;
    }
    function enqueuePendingPassiveHookEffectMount(fiber, effect) {
        pendingPassiveHookEffectsMount.push(effect, fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function enqueuePendingPassiveHookEffectUnmount(fiber, effect) {
        pendingPassiveHookEffectsUnmount.push(effect, fiber);
        fiber.flags |= PassiveUnmountPendingDev;
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.flags |= PassiveUnmountPendingDev;
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback(NormalPriority$1, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function invokePassiveEffectCreate(effect) {
        var create = effect.create;
        effect.destroy = create();
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null;
        pendingPassiveEffectsLanes = NoLanes;
        if (!((executionContext & (RenderContext | CommitContext)) === NoContext)) throw Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        var prevInteractions = pushInteractions(root); // It's important that ALL pending passive effect destroy functions are called
        // before ANY passive effect create functions are called.
        // Otherwise effects in sibling components might interfere with each other.
        // e.g. a destroy function in one component may unintentionally override a ref
        // value set by a create function in another component.
        // Layout effects have the same constraint.
        // First pass: Destroy stale passive effects.
        var unmountEffects = pendingPassiveHookEffectsUnmount;
        pendingPassiveHookEffectsUnmount = [];
        for(var i = 0; i < unmountEffects.length; i += 2){
            var _effect = unmountEffects[i];
            var fiber = unmountEffects[i + 1];
            var destroy = _effect.destroy;
            _effect.destroy = undefined;
            fiber.flags &= ~PassiveUnmountPendingDev;
            var alternate = fiber.alternate;
            if (alternate !== null) alternate.flags &= ~PassiveUnmountPendingDev;
            if (typeof destroy === 'function') {
                setCurrentFiber(fiber);
                invokeGuardedCallback(null, destroy, null);
                if (hasCaughtError()) {
                    if (!(fiber !== null)) throw Error("Should be working on an effect.");
                    var error = clearCaughtError();
                    captureCommitPhaseError(fiber, error);
                }
                resetCurrentFiber();
            }
        } // Second pass: Create new passive effects.
        var mountEffects = pendingPassiveHookEffectsMount;
        pendingPassiveHookEffectsMount = [];
        for(var _i = 0; _i < mountEffects.length; _i += 2){
            var _effect2 = mountEffects[_i];
            var _fiber = mountEffects[_i + 1];
            setCurrentFiber(_fiber);
            invokeGuardedCallback(null, invokePassiveEffectCreate, null, _effect2);
            if (hasCaughtError()) {
                if (!(_fiber !== null)) throw Error("Should be working on an effect.");
                var _error4 = clearCaughtError();
                captureCommitPhaseError(_fiber, _error4);
            }
            resetCurrentFiber();
        } // Note: This currently assumes there are no passive effects on the root fiber
        // because the root is not part of its own effect list.
        // This could change in the future.
        var effect = root.current.firstEffect;
        while(effect !== null){
            var nextNextEffect = effect.nextEffect; // Remove nextEffect pointer to assist GC
            effect.nextEffect = null;
            if (effect.flags & Deletion) detachFiberAfterEffects(effect);
            effect = nextNextEffect;
        }
        popInteractions(prevInteractions);
        finishPendingInteractions(root, lanes);
        isFlushingPassiveEffects = false;
        executionContext = prevExecutionContext;
        flushSyncCallbackQueue(); // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        nestedPassiveUpdateCount = rootWithPendingPassiveEffects === null ? 0 : nestedPassiveUpdateCount + 1;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValue(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        enqueueUpdate(rootFiber, update);
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(rootFiber, SyncLane);
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, SyncLane);
        }
    }
    function captureCommitPhaseError(sourceFiber, error) {
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
            return;
        }
        var fiber = sourceFiber.return;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === 'function' || typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValue(error, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    enqueueUpdate(fiber, update);
                    var eventTime = requestEventTime();
                    var root = markUpdateLaneFromFiberToRoot(fiber, SyncLane);
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                        schedulePendingInteractions(root, SyncLane);
                    } else {
                        // This component has already been unmounted.
                        // We can't schedule any follow up work for the root because the fiber is already unmounted,
                        // but we can still call the log-only boundary so the error isn't swallowed.
                        //
                        // TODO This is only a temporary bandaid for the old reconciler fork.
                        // We can delete this special case once the new fork is merged.
                        if (typeof instance.componentDidCatch === 'function' && !isAlreadyFailedLegacyErrorBoundary(instance)) try {
                            instance.componentDidCatch(error, errorInfo);
                        } catch (errorToIgnore) {
                        // This is kind of an edge case.
                        }
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
        schedulePendingInteractions(root, pingedLanes);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new expiration time.
        if (retryLane === NoLane) retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = markUpdateLaneFromFiberToRoot(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
            schedulePendingInteractions(root, retryLane);
        }
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        retryCache = boundaryFiber.stateNode;
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & (BlockingMode | ConcurrentMode))) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var didWarnStateUpdateForUnmountedComponent = null;
    function warnAboutUpdateOnUnmountedFiberInDEV(fiber) {
        var tag = fiber.tag;
        if (tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent && tag !== Block) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // If there are pending passive effects unmounts for this Fiber,
        // we can assume that they would have prevented this update.
        if ((fiber.flags & PassiveUnmountPendingDev) !== NoFlags) return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentName(fiber.type) || 'ReactComponent';
        if (didWarnStateUpdateForUnmountedComponent !== null) {
            if (didWarnStateUpdateForUnmountedComponent.has(componentName)) return;
            didWarnStateUpdateForUnmountedComponent.add(componentName);
        } else didWarnStateUpdateForUnmountedComponent = new Set([
            componentName
        ]);
        if (isFlushingPassiveEffects) ;
        else {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("Can't perform a React state update on an unmounted component. This is a no-op, but it indicates a memory leak in your application. To fix, cancel all subscriptions and asynchronous tasks in %s.", tag === ClassComponent ? 'the componentWillUnmount method' : 'a useEffect cleanup function');
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (originalError !== null && typeof originalError === 'object' && typeof originalError.then === 'function') // Don't replay promises. Treat everything else like an error.
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError(); // `invokeGuardedCallback` sometimes sets an expando `_suppressLogging`.
                // Rethrow this error instead of the original one.
                throw replayError;
            } else // This branch is reachable if the render phase is impure.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && (executionContext & RenderContext) !== NoContext && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentName(workInProgress.type) || 'Unknown'; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentName(fiber.type) || 'Unknown';
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    } // a 'shared' variable that changes when act() opens/closes in tests.
    var IsThisRendererActing = {
        current: false
    };
    function warnIfNotScopedWithMatchingAct(fiber) {
        if (IsSomeRendererActing.current === true && IsThisRendererActing.current !== true) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("It looks like you're using the wrong act() around your test interactions.\nBe sure to use the matching version of act() corresponding to your renderer:\n\n// for react-dom:\nimport {act} from 'react-dom/test-utils';\n// ...\nact(() => ...);\n\n// for react-test-renderer:\nimport TestRenderer from react-test-renderer';\nconst {act} = TestRenderer;\n// ...\nact(() => ...);");
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfNotCurrentlyActingEffectsInDEV(fiber) {
        if ((fiber.mode & StrictMode) !== NoMode && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) error("An update to %s ran an effect, but was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
    }
    function warnIfNotCurrentlyActingUpdatesInDEV(fiber) {
        if (executionContext === NoContext && IsSomeRendererActing.current === false && IsThisRendererActing.current === false) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentName(fiber.type));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    var warnIfNotCurrentlyActingUpdatesInDev = warnIfNotCurrentlyActingUpdatesInDEV; // In tests, we want to enforce a mocked scheduler.
    var didWarnAboutUnmockedScheduler = false; // TODO Before we release concurrent mode, revisit this and decide whether a mocked
    // scheduler is the actual recommendation. The alternative could be a testing build,
    // a new lib, or whatever; we dunno just yet. This message is for early adopters
    // to get their tests right.
    function warnIfUnmockedScheduler(fiber) {
        if (didWarnAboutUnmockedScheduler === false && Scheduler.unstable_flushAllWithoutAsserting === undefined) {
            if (fiber.mode & BlockingMode || fiber.mode & ConcurrentMode) {
                didWarnAboutUnmockedScheduler = true;
                error("In Concurrent or Sync modes, the \"scheduler\" module needs to be mocked to guarantee consistent behaviour across tests and browsers. For example, with jest: \njest.mock('scheduler', () => require('scheduler/unstable_mock'));\n\nFor more info, visit https://reactjs.org/link/mock-scheduler");
            }
        }
    }
    function computeThreadID(root, lane) {
        // Interaction threads are unique per root and expiration time.
        // NOTE: Intentionally unsound cast. All that matters is that it's a number
        // and it represents a batch of work. Could make a helper function instead,
        // but meh this is fine for now.
        return lane * 1000 + root.interactionThreadID;
    }
    function markSpawnedWork(lane) {
        if (spawnedWorkDuringRender === null) spawnedWorkDuringRender = [
            lane
        ];
        else spawnedWorkDuringRender.push(lane);
    }
    function scheduleInteractions(root, lane, interactions) {
        if (interactions.size > 0) {
            var pendingInteractionMap = root.pendingInteractionMap;
            var pendingInteractions = pendingInteractionMap.get(lane);
            if (pendingInteractions != null) interactions.forEach(function(interaction) {
                if (!pendingInteractions.has(interaction)) // Update the pending async work count for previously unscheduled interaction.
                interaction.__count++;
                pendingInteractions.add(interaction);
            });
            else {
                pendingInteractionMap.set(lane, new Set(interactions)); // Update the pending async work count for the current interactions.
                interactions.forEach(function(interaction) {
                    interaction.__count++;
                });
            }
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lane);
                subscriber.onWorkScheduled(interactions, threadID);
            }
        }
    }
    function schedulePendingInteractions(root, lane) {
        scheduleInteractions(root, lane, tracing.__interactionsRef.current);
    }
    function startWorkOnPendingInteractions(root, lanes) {
        // we can accurately attribute time spent working on it, And so that cascading
        // work triggered during the render phase will be associated with it.
        var interactions = new Set();
        root.pendingInteractionMap.forEach(function(scheduledInteractions, scheduledLane) {
            if (includesSomeLane(lanes, scheduledLane)) scheduledInteractions.forEach(function(interaction) {
                return interactions.add(interaction);
            });
        }); // Store the current set of interactions on the FiberRoot for a few reasons:
        // We can re-use it in hot functions like performConcurrentWorkOnRoot()
        // without having to recalculate it. We will also use it in commitWork() to
        // pass to any Profiler onRender() hooks. This also provides DevTools with a
        // way to access it when the onCommitRoot() hook is called.
        root.memoizedInteractions = interactions;
        if (interactions.size > 0) {
            var subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null) {
                var threadID = computeThreadID(root, lanes);
                try {
                    subscriber.onWorkStarted(interactions, threadID);
                } catch (error) {
                    // If the subscriber throws, rethrow it in a separate task
                    scheduleCallback(ImmediatePriority$1, function() {
                        throw error;
                    });
                }
            }
        }
    }
    function finishPendingInteractions(root, committedLanes) {
        var remainingLanesAfterCommit = root.pendingLanes;
        var subscriber;
        try {
            subscriber = tracing.__subscriberRef.current;
            if (subscriber !== null && root.memoizedInteractions.size > 0) {
                // FIXME: More than one lane can finish in a single commit.
                var threadID = computeThreadID(root, committedLanes);
                subscriber.onWorkStopped(root.memoizedInteractions, threadID);
            }
        } catch (error) {
            // If the subscriber throws, rethrow it in a separate task
            scheduleCallback(ImmediatePriority$1, function() {
                throw error;
            });
        } finally{
            // Clear completed interactions from the pending Map.
            // Unless the render was suspended or cascading work was scheduled,
            // In which case– leave pending interactions until the subsequent render.
            var pendingInteractionMap = root.pendingInteractionMap;
            pendingInteractionMap.forEach(function(scheduledInteractions, lane) {
                // Only decrement the pending interaction count if we're done.
                // If there's still work at the current priority,
                // That indicates that we are waiting for suspense data.
                if (!includesSomeLane(remainingLanesAfterCommit, lane)) {
                    pendingInteractionMap.delete(lane);
                    scheduledInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) try {
                            subscriber.onInteractionScheduledWorkCompleted(interaction);
                        } catch (error) {
                            // If the subscriber throws, rethrow it in a separate task
                            scheduleCallback(ImmediatePriority$1, function() {
                                throw error;
                            });
                        }
                    });
                }
            });
        }
    } // `act` testing API
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return actingUpdatesScopeDepth > 0;
    }
    // so we can tell if any async act() calls try to run in parallel.
    var actingUpdatesScopeDepth = 0;
    function detachFiberAfterEffects(fiber) {
        fiber.sibling = null;
        fiber.stateNode = null;
    }
    var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === 'function') {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === 'object' && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === 'function') needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== 'function') return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error('Expected resolveFamily to be set during hot reload.');
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error('Expected to reach root first.');
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    var debugCounter = 1;
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.nextEffect = null;
        this.firstEffect = null;
        this.lastEffect = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugID = debugCounter++;
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === 'function') Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === 'function' && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === 'function') return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugID = current._debugID;
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effect list is no longer valid.
            workInProgress.nextEffect = null;
            workInProgress.firstEffect = null;
            workInProgress.lastEffect = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        }
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect tag but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= Placement; // The effect list is no longer valid.
        workInProgress.nextEffect = null;
        workInProgress.firstEffect = null;
        workInProgress.lastEffect = null;
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag) {
        var mode;
        if (tag === ConcurrentRoot) mode = ConcurrentMode | BlockingMode | StrictMode;
        else if (tag === BlockingRoot) mode = BlockingMode | StrictMode;
        else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === 'function') {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === 'string') fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_DEBUG_TRACING_MODE_TYPE:
                fiberTag = Mode;
                mode |= DebugTracingMode;
                break;
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
                return createFiberFromLegacyHidden(pendingProps, mode, lanes, key);
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === 'object' && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                    case REACT_BLOCK_TYPE:
                        fiberTag = Block;
                        break getTag;
                }
                var info = '';
                if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner.type) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (type == null ? type : typeof type) + "." + info);
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== 'string') error('Profiler must specify an "id" as a prop');
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode); // TODO: The Profiler fiber shouldn't have a type. It has a tag.
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.type = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode); // TODO: The SuspenseComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_TYPE;
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        // TODO: The SuspenseListComponent fiber shouldn't have a type. It has a tag.
        // This needs to be fixed in getComponentName so that it relies on the tag
        // instead.
        fiber.type = REACT_SUSPENSE_LIST_TYPE;
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode); // TODO: The OffscreenComponent fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_OFFSCREEN_TYPE;
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromLegacyHidden(pendingProps, mode, lanes, key) {
        var fiber = createFiber(LegacyHiddenComponent, pendingProps, key, mode); // TODO: The LegacyHidden fiber shouldn't have a type. It has a tag.
        fiber.type = REACT_LEGACY_HIDDEN_TYPE;
        fiber.elementType = REACT_LEGACY_HIDDEN_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode); // TODO: These should not need a type.
        fiber.elementType = 'DELETED';
        fiber.type = 'DELETED';
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.nextEffect = source.nextEffect;
        target.firstEffect = source.firstEffect;
        target.lastEffect = source.lastEffect;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugID = source._debugID;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.hydrate = hydrate;
        this.callbackNode = null;
        this.callbackPriority = NoLanePriority;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.mutableSourceEagerHydrationData = null;
        this.interactionThreadID = tracing.unstable_getThreadID();
        this.memoizedInteractions = new Set();
        this.pendingInteractionMap = new Map();
        switch(tag){
            case BlockingRoot:
                this._debugRootType = 'createBlockingRoot()';
                break;
            case ConcurrentRoot:
                this._debugRootType = 'createRoot()';
                break;
            case LegacyRoot:
                this._debugRootType = 'createLegacyRoot()';
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, hydrationCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : '' + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === 'function') throw Error("Unable to find node on an unmounted component.");
            else throw Error("Argument appears to not be a ReactComponent. Keys: " + Object.keys(component));
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictMode) {
            var componentName = getComponentName(fiber.type) || 'Component';
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrate, hydrationCallbacks) {
        return createFiberRoot(containerInfo, tag, hydrate);
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        // $FlowExpectedError - jest isn't a global, and isn't recognized outside of tests
        if ('undefined' !== typeof jest) {
            warnIfUnmockedScheduler(current$1);
            warnIfNotScopedWithMatchingAct(current$1);
        }
        var lane = requestUpdateLane(current$1);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentName(current.type) || 'Unknown');
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== 'function') error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        enqueueUpdate(current$1, update);
        scheduleUpdateOnFiber(current$1, lane, eventTime);
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thennables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptUserBlockingHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = InputDiscreteHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var eventTime = requestEventTime();
        var lane = SelectiveHydrationLane;
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(fiber);
        scheduleUpdateOnFiber(fiber, lane, eventTime);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function runWithPriority$2(priority, fn) {
        setCurrentUpdateLanePriority(priority);
        return fn();
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.tag === FundamentalComponent) return hostFiber.stateNode.instance;
        return hostFiber.stateNode;
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === path.length) {
            if (Array.isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (Array.isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn('copyWithRename() expects paths of the same length');
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn('copyWithRename() expects paths to be the same except for the deepest key');
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = Array.isArray(obj) ? obj.slice() : _assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = _assign({}, fiber.memoizedProps);
            scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        scheduleUpdateOnFiber(fiber, SyncLane, NoTimestamp);
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools
        });
    }
    function ReactDOMRoot(container, options) {
        this._internalRoot = createRootImpl(container, ConcurrentRoot, options);
    }
    function ReactDOMBlockingRoot(container, tag, options) {
        this._internalRoot = createRootImpl(container, tag, options);
    }
    ReactDOMRoot.prototype.render = ReactDOMBlockingRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (typeof arguments[1] === 'function') error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMRoot.prototype.unmount = ReactDOMBlockingRoot.prototype.unmount = function() {
        if (typeof arguments[0] === 'function') error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        var container = root.containerInfo;
        updateContainer(null, root, null, function() {
            unmarkContainerAsRoot(container);
        });
    };
    function createRootImpl(container, tag, options) {
        // Tag is either LegacyRoot or Concurrent Root
        var hydrate = options != null && options.hydrate === true;
        var hydrationCallbacks = options != null && options.hydrationOptions || null;
        var mutableSources = options != null && options.hydrationOptions != null && options.hydrationOptions.mutableSources || null;
        var root = createContainer(container, tag, hydrate);
        markContainerAsRoot(root.current, container);
        var containerNodeType = container.nodeType;
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return root;
    }
    function createLegacyRoot(container, options) {
        return new ReactDOMBlockingRoot(container, LegacyRoot, options);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === ' react-mount-point-unstable '));
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    var warnedAboutHydrateAPI = false;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer._internalRoot.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === 'BODY') error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function shouldHydrateDueToLegacyHeuristic(container) {
        var rootElement = getReactRootElementInContainer(container);
        return !!(rootElement && rootElement.nodeType === ELEMENT_NODE && rootElement.hasAttribute(ROOT_ATTRIBUTE_NAME));
    }
    function legacyCreateRootFromDOMContainer(container, forceHydrate) {
        var shouldHydrate = forceHydrate || shouldHydrateDueToLegacyHeuristic(container); // First clear any existing content.
        if (!shouldHydrate) {
            var warned = false;
            var rootSibling;
            while(rootSibling = container.lastChild){
                if (!warned && rootSibling.nodeType === ELEMENT_NODE && rootSibling.hasAttribute(ROOT_ATTRIBUTE_NAME)) {
                    warned = true;
                    error("render(): Target node has markup rendered by React, but there are unrelated nodes as well. This is most commonly caused by white-space inserted around server-rendered markup.");
                }
                container.removeChild(rootSibling);
            }
        }
        if (shouldHydrate && !forceHydrate && !warnedAboutHydrateAPI) {
            warnedAboutHydrateAPI = true;
            warn("render(): Calling ReactDOM.render() to hydrate server-rendered markup will stop working in React v18. Replace the ReactDOM.render() call with ReactDOM.hydrate() if you want React to attach to the server HTML.");
        }
        return createLegacyRoot(container, shouldHydrate ? {
            hydrate: true
        } : undefined);
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== 'function') error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, 'render');
        // member of intersection type." Whyyyyyy.
        var root = container._reactRootContainer;
        var fiberRoot;
        if (!root) {
            // Initial mount
            root = container._reactRootContainer = legacyCreateRootFromDOMContainer(container, forceHydrate);
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    originalCallback.call(instance);
                };
            } // Initial mount should not be batched.
            unbatchedUpdates(function() {
                updateContainer(children, fiberRoot, parentComponent, callback);
            });
        } else {
            fiberRoot = root._internalRoot;
            if (typeof callback === 'function') {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(fiberRoot);
                    _originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, fiberRoot, parentComponent, callback);
        }
        return getPublicRootInstance(fiberRoot);
    }
    function findDOMNode(componentOrElement) {
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentName(owner.type) || 'A component');
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, 'findDOMNode');
    }
    function hydrate(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call createRoot(container, {hydrate: true}).render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        if (!isValidContainer(containerNode)) throw Error("Target container is not a DOM element.");
        if (!(parentComponent != null && has(parentComponent))) throw Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    function unmountComponentAtNode(container) {
        if (!isValidContainer(container)) throw Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOM.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            unbatchedUpdates(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainer(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptUserBlockingHydration(attemptUserBlockingHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setAttemptHydrationAtPriority(runWithPriority$2);
    var didWarnAboutUnstableCreatePortal = false;
    if (typeof Map !== 'function' || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== 'function' || typeof Set !== 'function' || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== 'function' || typeof Set.prototype.forEach !== 'function') error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates$1, flushDiscreteUpdates, batchedEventUpdates$1);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    function unstable_createPortal(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!didWarnAboutUnstableCreatePortal) {
            didWarnAboutUnstableCreatePortal = true;
            warn('The ReactDOM.unstable_createPortal() alias has been deprecated, and will be removed in React 18+. Update your code to use ReactDOM.createPortal() instead. It has the exact same API, but without the "unstable_" prefix.');
        }
        return createPortal$1(children, container, key);
    }
    var Internals = {
        // Keep in sync with ReactTestUtils.js, and ReactTestUtilsAct.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            flushPassiveEffects,
            IsThisRendererActing
        ]
    };
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: 'react-dom'
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === 'file:' ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ''), 'font-weight:bold');
        }
    }
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Internals;
    exports.createPortal = createPortal$1;
    exports.findDOMNode = findDOMNode;
    exports.flushSync = flushSync;
    exports.hydrate = hydrate;
    exports.render = render;
    exports.unmountComponentAtNode = unmountComponentAtNode;
    exports.unstable_batchedUpdates = batchedUpdates$1;
    exports.unstable_createPortal = unstable_createPortal;
    exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
    exports.version = ReactVersion;
})();

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7jGsX"));

});
parcelRegister("7jGsX", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $553b3f9a1c62156e$export$c4744153514ff05d, (v) => $553b3f9a1c62156e$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $553b3f9a1c62156e$export$b5836b71941fa3ed, (v) => $553b3f9a1c62156e$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $553b3f9a1c62156e$export$d66a1c1c77bd778b, (v) => $553b3f9a1c62156e$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7, (v) => $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $553b3f9a1c62156e$export$e26fe2ed2fa76875, (v) => $553b3f9a1c62156e$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $553b3f9a1c62156e$export$502329bbf4b505b1, (v) => $553b3f9a1c62156e$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $553b3f9a1c62156e$export$6e3807111c4874c4, (v) => $553b3f9a1c62156e$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $553b3f9a1c62156e$export$c27134553091fb3a, (v) => $553b3f9a1c62156e$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $553b3f9a1c62156e$export$33ee1acdc04fd2a2, (v) => $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $553b3f9a1c62156e$export$b00a404bbd5edef2, (v) => $553b3f9a1c62156e$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $553b3f9a1c62156e$export$8352ce38b91d0c62, (v) => $553b3f9a1c62156e$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $553b3f9a1c62156e$export$d3dfb8e4810cb555, (v) => $553b3f9a1c62156e$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $553b3f9a1c62156e$export$839f9183b0465a69, (v) => $553b3f9a1c62156e$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $553b3f9a1c62156e$export$72fdf0e06517287b, (v) => $553b3f9a1c62156e$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $553b3f9a1c62156e$export$4b844e58a3e414b4, (v) => $553b3f9a1c62156e$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $553b3f9a1c62156e$export$816d2913ae6b83b1, (v) => $553b3f9a1c62156e$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $553b3f9a1c62156e$export$61bcfe829111a1d0, (v) => $553b3f9a1c62156e$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $553b3f9a1c62156e$export$7ee8c9beb337bc3f, (v) => $553b3f9a1c62156e$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $553b3f9a1c62156e$export$cf845f2c119da08a, (v) => $553b3f9a1c62156e$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $553b3f9a1c62156e$export$c4744153514ff05d;
var $553b3f9a1c62156e$export$b5836b71941fa3ed;
var $553b3f9a1c62156e$export$d66a1c1c77bd778b;
var $553b3f9a1c62156e$export$3e506c1ccc9cc1a7;
var $553b3f9a1c62156e$export$e26fe2ed2fa76875;
var $553b3f9a1c62156e$export$502329bbf4b505b1;
var $553b3f9a1c62156e$export$6e3807111c4874c4;
var $553b3f9a1c62156e$export$c27134553091fb3a;
var $553b3f9a1c62156e$export$33ee1acdc04fd2a2;
var $553b3f9a1c62156e$export$b00a404bbd5edef2;
var $553b3f9a1c62156e$export$8352ce38b91d0c62;
var $553b3f9a1c62156e$export$d3dfb8e4810cb555;
var $553b3f9a1c62156e$export$839f9183b0465a69;
var $553b3f9a1c62156e$export$72fdf0e06517287b;
var $553b3f9a1c62156e$export$4b844e58a3e414b4;
var $553b3f9a1c62156e$export$816d2913ae6b83b1;
var $553b3f9a1c62156e$export$61bcfe829111a1d0;
var $553b3f9a1c62156e$export$7ee8c9beb337bc3f;
var $553b3f9a1c62156e$export$cf845f2c119da08a;
'use strict';
(function() {
    'use strict';
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var requestHostCallback;
    var requestHostTimeout;
    var cancelHostTimeout;
    var requestPaint;
    var hasPerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $553b3f9a1c62156e$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    }
    if (// implementation using setTimeout.
    typeof window === 'undefined' || // Check if MessageChannel is supported, too.
    typeof MessageChannel !== 'function') {
        // If this accidentally gets imported in a non-browser environment, e.g. JavaScriptCore,
        // fallback to a naive implementation.
        var _callback = null;
        var _timeoutID = null;
        var _flushCallback = function() {
            if (_callback !== null) try {
                var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                var hasRemainingTime = true;
                _callback(hasRemainingTime, currentTime);
                _callback = null;
            } catch (e) {
                setTimeout(_flushCallback, 0);
                throw e;
            }
        };
        requestHostCallback = function(cb) {
            if (_callback !== null) // Protect against re-entrancy.
            setTimeout(requestHostCallback, 0, cb);
            else {
                _callback = cb;
                setTimeout(_flushCallback, 0);
            }
        };
        requestHostTimeout = function(cb, ms) {
            _timeoutID = setTimeout(cb, ms);
        };
        cancelHostTimeout = function() {
            clearTimeout(_timeoutID);
        };
        $553b3f9a1c62156e$export$b5836b71941fa3ed = function() {
            return false;
        };
        requestPaint = $553b3f9a1c62156e$export$d66a1c1c77bd778b = function() {};
    } else {
        // Capture local references to native APIs, in case a polyfill overrides them.
        var _setTimeout = window.setTimeout;
        var _clearTimeout = window.clearTimeout;
        if (typeof console !== 'undefined') {
            // TODO: Scheduler no longer requires these methods to be polyfilled. But
            // maybe we want to continue warning if they don't exist, to preserve the
            // option to rely on it in the future?
            var requestAnimationFrame = window.requestAnimationFrame;
            var cancelAnimationFrame = window.cancelAnimationFrame;
            if (typeof requestAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
            if (typeof cancelAnimationFrame !== 'function') // Using console['error'] to evade Babel and ESLint
            console['error']("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        }
        var isMessageLoopRunning = false;
        var scheduledHostCallback = null;
        var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
        // thread, like user events. By default, it yields multiple times per frame.
        // It does not attempt to align with frame boundaries, since most tasks don't
        // need to be frame aligned; for those that do, use requestAnimationFrame.
        var yieldInterval = 5;
        var deadline = 0; // TODO: Make this configurable
        // `isInputPending` is not available. Since we have no way of knowing if
        // there's pending input, always yield at the end of the frame.
        $553b3f9a1c62156e$export$b5836b71941fa3ed = function() {
            return $553b3f9a1c62156e$export$c4744153514ff05d() >= deadline;
        }; // Since we yield every frame regardless, `requestPaint` has no effect.
        requestPaint = function() {};
        $553b3f9a1c62156e$export$d66a1c1c77bd778b = function(fps) {
            if (fps < 0 || fps > 125) {
                // Using console['error'] to evade Babel and ESLint
                console['error']("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
                return;
            }
            if (fps > 0) yieldInterval = Math.floor(1000 / fps);
            else // reset the framerate
            yieldInterval = 5;
        };
        var performWorkUntilDeadline = function() {
            if (scheduledHostCallback !== null) {
                var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d(); // Yield after `yieldInterval` ms, regardless of where we are in the vsync
                // cycle. This means there's always time remaining at the beginning of
                // the message event.
                deadline = currentTime + yieldInterval;
                var hasTimeRemaining = true;
                try {
                    var hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
                    if (!hasMoreWork) {
                        isMessageLoopRunning = false;
                        scheduledHostCallback = null;
                    } else // If there's more work, schedule the next message event at the end
                    // of the preceding one.
                    port.postMessage(null);
                } catch (error) {
                    // If a scheduler task throws, exit the current browser task so the
                    // error can be observed.
                    port.postMessage(null);
                    throw error;
                }
            } else isMessageLoopRunning = false;
             // Yielding to the browser will give it a chance to paint, so we can
        };
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        requestHostCallback = function(callback) {
            scheduledHostCallback = callback;
            if (!isMessageLoopRunning) {
                isMessageLoopRunning = true;
                port.postMessage(null);
            }
        };
        requestHostTimeout = function(callback, ms) {
            taskTimeoutID = _setTimeout(function() {
                callback($553b3f9a1c62156e$export$c4744153514ff05d());
            }, ms);
        };
        cancelHostTimeout = function() {
            _clearTimeout(taskTimeoutID);
            taskTimeoutID = -1;
        };
    }
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        var first = heap[0];
        return first === undefined ? null : first;
    }
    function pop(heap) {
        var first = heap[0];
        if (first !== undefined) {
            var last = heap.pop();
            if (last !== first) {
                heap[0] = last;
                siftDown(heap, last, 0);
            }
            return first;
        } else return null;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(true){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (parent !== undefined && compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        while(index < length){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (left !== undefined && compare(left, node) < 0) {
                if (right !== undefined && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (right !== undefined && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrancy.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || $553b3f9a1c62156e$export$b5836b71941fa3ed())) break;
            var callback = currentTask.callback;
            if (typeof callback === 'function') {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
                if (typeof continuationCallback === 'function') currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $553b3f9a1c62156e$export$c4744153514ff05d();
        var startTime;
        if (typeof options === 'object' && options !== null) {
            var delay = options.delay;
            if (typeof delay === 'number' && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $553b3f9a1c62156e$export$3e506c1ccc9cc1a7 = IdlePriority;
    $553b3f9a1c62156e$export$e26fe2ed2fa76875 = ImmediatePriority;
    $553b3f9a1c62156e$export$502329bbf4b505b1 = LowPriority;
    $553b3f9a1c62156e$export$6e3807111c4874c4 = NormalPriority;
    $553b3f9a1c62156e$export$c27134553091fb3a = unstable_Profiling;
    $553b3f9a1c62156e$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $553b3f9a1c62156e$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $553b3f9a1c62156e$export$8352ce38b91d0c62 = unstable_continueExecution;
    $553b3f9a1c62156e$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $553b3f9a1c62156e$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $553b3f9a1c62156e$export$72fdf0e06517287b = unstable_next;
    $553b3f9a1c62156e$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $553b3f9a1c62156e$export$816d2913ae6b83b1 = unstable_requestPaint;
    $553b3f9a1c62156e$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $553b3f9a1c62156e$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $553b3f9a1c62156e$export$cf845f2c119da08a = unstable_wrapCallback;
})();

});


parcelRegister("eXC0v", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eVxOk"));

});
parcelRegister("eVxOk", function(module, exports) {

$parcel$export(module.exports, "__interactionsRef", () => $ade09da924dc3e35$export$236303149b061964, (v) => $ade09da924dc3e35$export$236303149b061964 = v);
$parcel$export(module.exports, "__subscriberRef", () => $ade09da924dc3e35$export$d8c36835f54f0a3b, (v) => $ade09da924dc3e35$export$d8c36835f54f0a3b = v);
$parcel$export(module.exports, "unstable_clear", () => $ade09da924dc3e35$export$4a908c8bc96de6cd, (v) => $ade09da924dc3e35$export$4a908c8bc96de6cd = v);
$parcel$export(module.exports, "unstable_getCurrent", () => $ade09da924dc3e35$export$49d8199c8144c803, (v) => $ade09da924dc3e35$export$49d8199c8144c803 = v);
$parcel$export(module.exports, "unstable_getThreadID", () => $ade09da924dc3e35$export$c7d3dd8712817dbc, (v) => $ade09da924dc3e35$export$c7d3dd8712817dbc = v);
$parcel$export(module.exports, "unstable_subscribe", () => $ade09da924dc3e35$export$932a6d6a24b633a5, (v) => $ade09da924dc3e35$export$932a6d6a24b633a5 = v);
$parcel$export(module.exports, "unstable_trace", () => $ade09da924dc3e35$export$8405cb466bd0a1f1, (v) => $ade09da924dc3e35$export$8405cb466bd0a1f1 = v);
$parcel$export(module.exports, "unstable_unsubscribe", () => $ade09da924dc3e35$export$4fd753a282912317, (v) => $ade09da924dc3e35$export$4fd753a282912317 = v);
$parcel$export(module.exports, "unstable_wrap", () => $ade09da924dc3e35$export$230d7bceee602808, (v) => $ade09da924dc3e35$export$230d7bceee602808 = v);
/** @license React v0.20.2
 * scheduler-tracing.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Interactions "stack"–
// Meaning that newly traced interactions are appended to the previously active set.
// When an interaction goes out of scope, the previous set (if any) is restored.
var $ade09da924dc3e35$export$236303149b061964;
var $ade09da924dc3e35$export$d8c36835f54f0a3b;
var $ade09da924dc3e35$export$4a908c8bc96de6cd;
var $ade09da924dc3e35$export$49d8199c8144c803;
var $ade09da924dc3e35$export$c7d3dd8712817dbc;
var $ade09da924dc3e35$export$932a6d6a24b633a5;
var $ade09da924dc3e35$export$8405cb466bd0a1f1;
var $ade09da924dc3e35$export$4fd753a282912317;
var $ade09da924dc3e35$export$230d7bceee602808;
'use strict';
(function() {
    'use strict';
    var DEFAULT_THREAD_ID = 0; // Counters used to generate unique IDs.
    var interactionIDCounter = 0;
    var threadIDCounter = 0; // Set of currently traced interactions.
    $ade09da924dc3e35$export$236303149b061964 = null; // Listener(s) to notify when interactions begin and end.
    $ade09da924dc3e35$export$d8c36835f54f0a3b = null;
    $ade09da924dc3e35$export$236303149b061964 = {
        current: new Set()
    };
    $ade09da924dc3e35$export$d8c36835f54f0a3b = {
        current: null
    };
    function unstable_clear(callback) {
        var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current;
        $ade09da924dc3e35$export$236303149b061964.current = new Set();
        try {
            return callback();
        } finally{
            $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
        }
    }
    function unstable_getCurrent() {
        return $ade09da924dc3e35$export$236303149b061964.current;
    }
    function unstable_getThreadID() {
        return ++threadIDCounter;
    }
    function unstable_trace(name, timestamp, callback) {
        var threadID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_THREAD_ID;
        var interaction = {
            __count: 1,
            id: interactionIDCounter++,
            name: name,
            timestamp: timestamp
        };
        var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current; // Traced interactions should stack/accumulate.
        // To do that, clone the current interactions.
        // The previous set will be restored upon completion.
        var interactions = new Set(prevInteractions);
        interactions.add(interaction);
        $ade09da924dc3e35$export$236303149b061964.current = interactions;
        var subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
        var returnValue;
        try {
            if (subscriber !== null) subscriber.onInteractionTraced(interaction);
        } finally{
            try {
                if (subscriber !== null) subscriber.onWorkStarted(interactions, threadID);
            } finally{
                try {
                    returnValue = callback();
                } finally{
                    $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
                    try {
                        if (subscriber !== null) subscriber.onWorkStopped(interactions, threadID);
                    } finally{
                        interaction.__count--; // If no async work was scheduled for this interaction,
                        // Notify subscribers that it's completed.
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    }
                }
            }
        }
        return returnValue;
    }
    function unstable_wrap(callback) {
        var threadID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_THREAD_ID;
        var wrappedInteractions = $ade09da924dc3e35$export$236303149b061964.current;
        var subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
        if (subscriber !== null) subscriber.onWorkScheduled(wrappedInteractions, threadID);
         // Update the pending async work count for the current interactions.
        // Update after calling subscribers in case of error.
        wrappedInteractions.forEach(function(interaction) {
            interaction.__count++;
        });
        var hasRun = false;
        function wrapped() {
            var prevInteractions = $ade09da924dc3e35$export$236303149b061964.current;
            $ade09da924dc3e35$export$236303149b061964.current = wrappedInteractions;
            subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
            try {
                var returnValue;
                try {
                    if (subscriber !== null) subscriber.onWorkStarted(wrappedInteractions, threadID);
                } finally{
                    try {
                        returnValue = callback.apply(undefined, arguments);
                    } finally{
                        $ade09da924dc3e35$export$236303149b061964.current = prevInteractions;
                        if (subscriber !== null) subscriber.onWorkStopped(wrappedInteractions, threadID);
                    }
                }
                return returnValue;
            } finally{
                if (!hasRun) {
                    // We only expect a wrapped function to be executed once,
                    // But in the event that it's executed more than once–
                    // Only decrement the outstanding interaction counts once.
                    hasRun = true; // Update pending async counts for all wrapped interactions.
                    // If this was the last scheduled async work for any of them,
                    // Mark them as completed.
                    wrappedInteractions.forEach(function(interaction) {
                        interaction.__count--;
                        if (subscriber !== null && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                    });
                }
            }
        }
        wrapped.cancel = function cancel() {
            subscriber = $ade09da924dc3e35$export$d8c36835f54f0a3b.current;
            try {
                if (subscriber !== null) subscriber.onWorkCanceled(wrappedInteractions, threadID);
            } finally{
                // Update pending async counts for all wrapped interactions.
                // If this was the last scheduled async work for any of them,
                // Mark them as completed.
                wrappedInteractions.forEach(function(interaction) {
                    interaction.__count--;
                    if (subscriber && interaction.__count === 0) subscriber.onInteractionScheduledWorkCompleted(interaction);
                });
            }
        };
        return wrapped;
    }
    var subscribers = null;
    subscribers = new Set();
    function unstable_subscribe(subscriber) {
        subscribers.add(subscriber);
        if (subscribers.size === 1) $ade09da924dc3e35$export$d8c36835f54f0a3b.current = {
            onInteractionScheduledWorkCompleted: onInteractionScheduledWorkCompleted,
            onInteractionTraced: onInteractionTraced,
            onWorkCanceled: onWorkCanceled,
            onWorkScheduled: onWorkScheduled,
            onWorkStarted: onWorkStarted,
            onWorkStopped: onWorkStopped
        };
    }
    function unstable_unsubscribe(subscriber) {
        subscribers.delete(subscriber);
        if (subscribers.size === 0) $ade09da924dc3e35$export$d8c36835f54f0a3b.current = null;
    }
    function onInteractionTraced(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionTraced(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onInteractionScheduledWorkCompleted(interaction) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onInteractionScheduledWorkCompleted(interaction);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkScheduled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkScheduled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStarted(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStarted(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkStopped(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkStopped(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    function onWorkCanceled(interactions, threadID) {
        var didCatchError = false;
        var caughtError = null;
        subscribers.forEach(function(subscriber) {
            try {
                subscriber.onWorkCanceled(interactions, threadID);
            } catch (error) {
                if (!didCatchError) {
                    didCatchError = true;
                    caughtError = error;
                }
            }
        });
        if (didCatchError) throw caughtError;
    }
    $ade09da924dc3e35$export$4a908c8bc96de6cd = unstable_clear;
    $ade09da924dc3e35$export$49d8199c8144c803 = unstable_getCurrent;
    $ade09da924dc3e35$export$c7d3dd8712817dbc = unstable_getThreadID;
    $ade09da924dc3e35$export$932a6d6a24b633a5 = unstable_subscribe;
    $ade09da924dc3e35$export$8405cb466bd0a1f1 = unstable_trace;
    $ade09da924dc3e35$export$4fd753a282912317 = unstable_unsubscribe;
    $ade09da924dc3e35$export$230d7bceee602808 = unstable_wrap;
})();

});



parcelRegister("2jGA3", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $1afe62ba3a7403ae$export$307591e98609eddd, (v) => $1afe62ba3a7403ae$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $1afe62ba3a7403ae$export$eb3a06aef9e6ee51, (v) => $1afe62ba3a7403ae$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $1afe62ba3a7403ae$export$b23711c915539651, (v) => $1afe62ba3a7403ae$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $1afe62ba3a7403ae$export$80e7718417253a51, (v) => $1afe62ba3a7403ae$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $1afe62ba3a7403ae$export$83d89fbfd8236492, (v) => $1afe62ba3a7403ae$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1afe62ba3a7403ae$export$307591e98609eddd;
var $1afe62ba3a7403ae$export$eb3a06aef9e6ee51;
var $1afe62ba3a7403ae$export$b23711c915539651;
var $1afe62ba3a7403ae$export$80e7718417253a51;
var $1afe62ba3a7403ae$export$83d89fbfd8236492;
'use strict';


(function() {
    'use strict';
    var React = (parcelRequire("acw62"));
    var _assign = (parcelRequire("8coUR"));
    // Do not require this module directly! Use normal `invariant` calls with
    // template literal strings. The messages will be replaced with error codes
    // during build.
    function formatProdErrorMessage(code) {
        var url = 'https://reactjs.org/docs/error-decoder.html?invariant=' + code;
        for(var i = 1; i < arguments.length; i++)url += '&args[]=' + encodeURIComponent(arguments[i]);
        return "Minified React error #" + code + "; visit " + url + " for the full message or " + 'use the non-minified dev environment for full errors and additional ' + 'helpful warnings.';
    }
    // TODO: this is special because it gets imported during build.
    var ReactVersion = '17.0.2';
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning('warn', format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning('error', format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== '') {
            format += '%s';
            args = args.concat([
                stack
            ]);
        }
        var argsWithFormat = args.map(function(item) {
            return '' + item;
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var REACT_ELEMENT_TYPE = 0xeac7;
    var REACT_PORTAL_TYPE = 0xeaca;
    var REACT_FRAGMENT_TYPE = 0xeacb;
    var REACT_STRICT_MODE_TYPE = 0xeacc;
    var REACT_PROFILER_TYPE = 0xead2;
    var REACT_PROVIDER_TYPE = 0xeacd;
    var REACT_CONTEXT_TYPE = 0xeace;
    var REACT_FORWARD_REF_TYPE = 0xead0;
    var REACT_SUSPENSE_TYPE = 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
    var REACT_MEMO_TYPE = 0xead3;
    var REACT_LAZY_TYPE = 0xead4;
    var REACT_BLOCK_TYPE = 0xead9;
    var REACT_SERVER_BLOCK_TYPE = 0xeada;
    var REACT_FUNDAMENTAL_TYPE = 0xead5;
    var REACT_SCOPE_TYPE = 0xead7;
    var REACT_OPAQUE_ID_TYPE = 0xeae0;
    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
    var REACT_OFFSCREEN_TYPE = 0xeae2;
    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
    if (typeof Symbol === 'function' && Symbol.for) {
        var symbolFor = Symbol.for;
        REACT_ELEMENT_TYPE = symbolFor('react.element');
        REACT_PORTAL_TYPE = symbolFor('react.portal');
        REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
        REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
        REACT_PROFILER_TYPE = symbolFor('react.profiler');
        REACT_PROVIDER_TYPE = symbolFor('react.provider');
        REACT_CONTEXT_TYPE = symbolFor('react.context');
        REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
        REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
        REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
        REACT_MEMO_TYPE = symbolFor('react.memo');
        REACT_LAZY_TYPE = symbolFor('react.lazy');
        REACT_BLOCK_TYPE = symbolFor('react.block');
        REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
        REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
        REACT_SCOPE_TYPE = symbolFor('react.scope');
        REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
        REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
        REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
        REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || '';
        return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
    }
    function getContextName(type) {
        return type.displayName || 'Context';
    }
    function getComponentName(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === 'number') error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
        if (typeof type === 'function') return type.displayName || type.name || null;
        if (typeof type === 'string') return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return 'Fragment';
            case REACT_PORTAL_TYPE:
                return 'Portal';
            case REACT_PROFILER_TYPE:
                return 'Profiler';
            case REACT_STRICT_MODE_TYPE:
                return 'StrictMode';
            case REACT_SUSPENSE_TYPE:
                return 'Suspense';
            case REACT_SUSPENSE_LIST_TYPE:
                return 'SuspenseList';
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + '.Consumer';
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + '.Provider';
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, 'ForwardRef');
            case REACT_MEMO_TYPE:
                return getComponentName(type.type);
            case REACT_BLOCK_TYPE:
                return getComponentName(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentName(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
    var enableSuspenseServerRenderer = false;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: _assign({}, props, {
                    value: prevLog
                }),
                info: _assign({}, props, {
                    value: prevInfo
                }),
                warn: _assign({}, props, {
                    value: prevWarn
                }),
                error: _assign({}, props, {
                    value: prevError
                }),
                group: _assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: _assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: _assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || '';
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return '\n' + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return '';
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, 'props', {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === 'object' && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === 'string') {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split('\n');
                var controlLines = control.stack.split('\n');
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
                            if (typeof fn === 'function') componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : '';
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
        if (typeof fn === 'function') componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return '';
        if (typeof type === 'function') return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === 'string') return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame('Suspense');
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame('SuspenseList');
        }
        if (typeof type === 'object') switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_BLOCK_TYPE:
                return describeFunctionComponentFrame(type._render);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return '';
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(Object.prototype.hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== 'function') {
                    var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
                    err.name = 'Invariant Violation';
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || 'React class', location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error('Failed %s type: %s', location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var didWarnAboutInvalidateContextType;
    didWarnAboutInvalidateContextType = new Set();
    var emptyObject = {};
    Object.freeze(emptyObject);
    function maskContext(type, context) {
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyObject;
        var maskedContext = {};
        for(var contextName in contextTypes)maskedContext[contextName] = context[contextName];
        return maskedContext;
    }
    function checkContextTypes(typeSpecs, values, location) {
        checkPropTypes(typeSpecs, values, location, 'Component');
    }
    function validateContextBounds(context, threadID) {
        // If we don't have enough slots in this context to store this threadID,
        // fill it in without leaving any holes to ensure that the VM optimizes
        // this as non-holey index properties.
        // (Note: If `react` package is < 16.6, _threadCount is undefined.)
        for(var i = context._threadCount | 0; i <= threadID; i++){
            // We assume that this is the same as the defaultValue which might not be
            // true if we're rendering inside a secondary renderer but they are
            // secondary because these use cases are very rare.
            context[i] = context._currentValue2;
            context._threadCount = i + 1;
        }
    }
    function processContext(type, context, threadID, isClass) {
        if (isClass) {
            var contextType = type.contextType;
            if ('contextType' in type) {
                var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
                if (!isValid && !didWarnAboutInvalidateContextType.has(type)) {
                    didWarnAboutInvalidateContextType.add(type);
                    var addendum = '';
                    if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                    else if (typeof contextType !== 'object') addendum = ' However, it is set to a ' + typeof contextType + '.';
                    else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = ' Did you accidentally pass the Context.Provider instead?';
                    else if (contextType._context !== undefined) // <Context.Consumer>
                    addendum = ' Did you accidentally pass the Context.Consumer instead?';
                    else addendum = ' However, it is set to an object with keys {' + Object.keys(contextType).join(', ') + '}.';
                    error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentName(type) || 'Component', addendum);
                }
            }
            if (typeof contextType === 'object' && contextType !== null) {
                validateContextBounds(contextType, threadID);
                return contextType[threadID];
            }
            var maskedContext = maskContext(type, context);
            if (type.contextTypes) checkContextTypes(type.contextTypes, maskedContext, 'context');
            return maskedContext;
        } else {
            var _maskedContext = maskContext(type, context);
            if (type.contextTypes) checkContextTypes(type.contextTypes, _maskedContext, 'context');
            return _maskedContext;
        }
    }
    var nextAvailableThreadIDs = new Uint16Array(16);
    for(var i = 0; i < 15; i++)nextAvailableThreadIDs[i] = i + 1;
    nextAvailableThreadIDs[15] = 0;
    function growThreadCountAndReturnNextAvailable() {
        var oldArray = nextAvailableThreadIDs;
        var oldSize = oldArray.length;
        var newSize = oldSize * 2;
        if (!(newSize <= 0x10000)) throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
        var newArray = new Uint16Array(newSize);
        newArray.set(oldArray);
        nextAvailableThreadIDs = newArray;
        nextAvailableThreadIDs[0] = oldSize + 1;
        for(var _i = oldSize; _i < newSize - 1; _i++)nextAvailableThreadIDs[_i] = _i + 1;
        nextAvailableThreadIDs[newSize - 1] = 0;
        return oldSize;
    }
    function allocThreadID() {
        var nextID = nextAvailableThreadIDs[0];
        if (nextID === 0) return growThreadCountAndReturnNextAvailable();
        nextAvailableThreadIDs[0] = nextAvailableThreadIDs[nextID];
        return nextID;
    }
    function freeThreadID(id) {
        nextAvailableThreadIDs[id] = nextAvailableThreadIDs[0];
        nextAvailableThreadIDs[0] = id;
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var ROOT_ATTRIBUTE_NAME = 'data-reactroot';
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + ATTRIBUTE_NAME_START_CHAR + '][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error('Invalid attribute name: `%s`', attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === 'o' || name[0] === 'O') && (name[1] === 'n' || name[1] === 'N')) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case 'function':
            case 'symbol':
                // eslint-disable-line
                return true;
            case 'boolean':
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== 'data-' && prefix !== 'aria-';
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === 'undefined') return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        'children',
        'dangerouslySetInnerHTML',
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        'defaultValue',
        'defaultChecked',
        'innerHTML',
        'suppressContentEditableWarning',
        'suppressHydrationWarning',
        'style'
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            'acceptCharset',
            'accept-charset'
        ],
        [
            'className',
            'class'
        ],
        [
            'htmlFor',
            'for'
        ],
        [
            'httpEquiv',
            'http-equiv'
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        'contentEditable',
        'draggable',
        'spellCheck',
        'value'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        'autoReverse',
        'externalResourcesRequired',
        'focusable',
        'preserveAlpha'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        'allowFullScreen',
        'async',
        // on the client side because the browsers are inconsistent. Instead we call focus().
        'autoFocus',
        'autoPlay',
        'controls',
        'default',
        'defer',
        'disabled',
        'disablePictureInPicture',
        'disableRemotePlayback',
        'formNoValidate',
        'hidden',
        'loop',
        'noModule',
        'noValidate',
        'open',
        'playsInline',
        'readOnly',
        'required',
        'reversed',
        'scoped',
        'seamless',
        'itemScope'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        'checked',
        // disabled with `removeAttribute`. We have special logic for handling this.
        'multiple',
        'muted',
        'selected' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        'capture',
        'download' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        'cols',
        'rows',
        'size',
        'span' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        'rowSpan',
        'start'
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        'accent-height',
        'alignment-baseline',
        'arabic-form',
        'baseline-shift',
        'cap-height',
        'clip-path',
        'clip-rule',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'dominant-baseline',
        'enable-background',
        'fill-opacity',
        'fill-rule',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'glyph-name',
        'glyph-orientation-horizontal',
        'glyph-orientation-vertical',
        'horiz-adv-x',
        'horiz-origin-x',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'overline-position',
        'overline-thickness',
        'paint-order',
        'panose-1',
        'pointer-events',
        'rendering-intent',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'strikethrough-position',
        'strikethrough-thickness',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'underline-position',
        'underline-thickness',
        'unicode-bidi',
        'unicode-range',
        'units-per-em',
        'v-alphabetic',
        'v-hanging',
        'v-ideographic',
        'v-mathematical',
        'vector-effect',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'word-spacing',
        'writing-mode',
        'xmlns:xlink',
        'x-height' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        'xlink:actuate',
        'xlink:arcrole',
        'xlink:role',
        'xlink:show',
        'xlink:title',
        'xlink:type' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/1999/xlink', false, false);
    }); // String SVG attributes with the xml namespace.
    [
        'xml:base',
        'xml:lang',
        'xml:space' // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, 'http://www.w3.org/XML/1998/namespace', false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        'tabIndex',
        'crossOrigin'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = 'xlinkHref';
    properties[xlinkHref] = new PropertyInfoRecord('xlinkHref', STRING, false, 'xlink:href', 'http://www.w3.org/1999/xlink', true, false);
    [
        'src',
        'href',
        'action',
        'formAction'
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    // code copied and modified from escape-html
    /**
 * Module variables.
 * @private
 */ var matchHtmlRegExp = /["'&<>]/;
    /**
 * Escapes special characters and HTML entities in a given html string.
 *
 * @param  {string} string HTML string to escape for later insertion
 * @return {string}
 * @public
 */ function escapeHtml(string) {
        var str = '' + string;
        var match = matchHtmlRegExp.exec(str);
        if (!match) return str;
        var escape;
        var html = '';
        var index;
        var lastIndex = 0;
        for(index = match.index; index < str.length; index++){
            switch(str.charCodeAt(index)){
                case 34:
                    // "
                    escape = '&quot;';
                    break;
                case 38:
                    // &
                    escape = '&amp;';
                    break;
                case 39:
                    // '
                    escape = '&#x27;'; // modified from escape-html; used to be '&#39'
                    break;
                case 60:
                    // <
                    escape = '&lt;';
                    break;
                case 62:
                    // >
                    escape = '&gt;';
                    break;
                default:
                    continue;
            }
            if (lastIndex !== index) html += str.substring(lastIndex, index);
            lastIndex = index + 1;
            html += escape;
        }
        return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
    } // end code copied and modified from escape-html
    /**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */ function escapeTextForBrowser(text) {
        if (typeof text === 'boolean' || typeof text === 'number') // this shortcircuit helps perf for types that we know will never have
        // special characters, especially given that this function is used often
        // for numeric dom ids.
        return '' + text;
        return escapeHtml(text);
    }
    /**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */ function quoteAttributeValueForBrowser(value) {
        return '"' + escapeTextForBrowser(value) + '"';
    }
    function createMarkupForRoot() {
        return ROOT_ATTRIBUTE_NAME + '=""';
    }
    /**
 * Creates markup for a property.
 *
 * @param {string} name
 * @param {*} value
 * @return {?string} Markup string, or null if the property was invalid.
 */ function createMarkupForProperty(name, value) {
        var propertyInfo = getPropertyInfo(name);
        if (name !== 'style' && shouldIgnoreAttribute(name, propertyInfo, false)) return '';
        if (shouldRemoveAttribute(name, value, propertyInfo, false)) return '';
        if (propertyInfo !== null) {
            var attributeName = propertyInfo.attributeName;
            var type = propertyInfo.type;
            if (type === BOOLEAN || type === OVERLOADED_BOOLEAN && value === true) return attributeName + '=""';
            else {
                if (propertyInfo.sanitizeURL) {
                    value = '' + value;
                    sanitizeURL(value);
                }
                return attributeName + '=' + quoteAttributeValueForBrowser(value);
            }
        } else if (isAttributeNameSafe(name)) return name + '=' + quoteAttributeValueForBrowser(value);
        return '';
    }
    /**
 * Creates markup for a custom property.
 *
 * @param {string} name
 * @param {*} value
 * @return {string} Markup string, or empty string if the property was invalid.
 */ function createMarkupForCustomAttribute(name, value) {
        if (!isAttributeNameSafe(name) || value == null) return '';
        return name + '=' + quoteAttributeValueForBrowser(value);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === 'function' ? Object.is : is;
    var currentlyRenderingComponent = null;
    var firstWorkInProgressHook = null;
    var workInProgressHook = null; // Whether the work-in-progress hook is a re-rendered hook
    var isReRender = false; // Whether an update was scheduled during the currently executing render pass.
    var didScheduleRenderPhaseUpdate = false; // Lazily created map of render-phase updates
    var renderPhaseUpdates = null; // Counter to prevent infinite loops.
    var numberOfReRenders = 0;
    var RE_RENDER_LIMIT = 25;
    var isInHookUserCodeInDev = false; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev;
    function resolveCurrentlyRenderingComponent() {
        if (!(currentlyRenderingComponent !== null)) throw Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        if (isInHookUserCodeInDev) error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        return currentlyRenderingComponent;
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + nextDeps.join(', ') + "]", "[" + prevDeps.join(', ') + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function createHook() {
        if (numberOfReRenders > 0) throw Error("Rendered more hooks than during the previous render");
        return {
            memoizedState: null,
            queue: null,
            next: null
        };
    }
    function createWorkInProgressHook() {
        if (workInProgressHook === null) {
            // This is the first hook in the list
            if (firstWorkInProgressHook === null) {
                isReRender = false;
                firstWorkInProgressHook = workInProgressHook = createHook();
            } else {
                // There's already a work-in-progress. Reuse it.
                isReRender = true;
                workInProgressHook = firstWorkInProgressHook;
            }
        } else if (workInProgressHook.next === null) {
            isReRender = false; // Append to the end of the list
            workInProgressHook = workInProgressHook.next = createHook();
        } else {
            // There's already a work-in-progress. Reuse it.
            isReRender = true;
            workInProgressHook = workInProgressHook.next;
        }
        return workInProgressHook;
    }
    function prepareToUseHooks(componentIdentity) {
        currentlyRenderingComponent = componentIdentity;
        isInHookUserCodeInDev = false;
    // didScheduleRenderPhaseUpdate = false;
    // firstWorkInProgressHook = null;
    // numberOfReRenders = 0;
    // renderPhaseUpdates = null;
    // workInProgressHook = null;
    }
    function finishHooks(Component, props, children, refOrContext) {
        // This must be called after every function component to prevent hooks from
        // being used in classes.
        while(didScheduleRenderPhaseUpdate){
            // Updates were scheduled during the render phase. They are stored in
            // the `renderPhaseUpdates` map. Call the component again, reusing the
            // work-in-progress hooks and applying the additional updates on top. Keep
            // restarting until no more updates are scheduled.
            didScheduleRenderPhaseUpdate = false;
            numberOfReRenders += 1; // Start over from the beginning of the list
            workInProgressHook = null;
            children = Component(props, refOrContext);
        }
        resetHooksState();
        return children;
    } // Reset the internal hooks state if an error occurs while rendering a component
    function resetHooksState() {
        isInHookUserCodeInDev = false;
        currentlyRenderingComponent = null;
        didScheduleRenderPhaseUpdate = false;
        firstWorkInProgressHook = null;
        numberOfReRenders = 0;
        renderPhaseUpdates = null;
        workInProgressHook = null;
    }
    function readContext(context, observedBits) {
        var threadID = currentPartialRenderer.threadID;
        validateContextBounds(context, threadID);
        if (isInHookUserCodeInDev) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        return context[threadID];
    }
    function useContext(context, observedBits) {
        currentHookNameInDev = 'useContext';
        resolveCurrentlyRenderingComponent();
        var threadID = currentPartialRenderer.threadID;
        validateContextBounds(context, threadID);
        return context[threadID];
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === 'function' ? action(state) : action;
    }
    function useState(initialState) {
        currentHookNameInDev = 'useState';
        return useReducer(basicStateReducer, initialState);
    }
    function useReducer(reducer, initialArg, init) {
        if (reducer !== basicStateReducer) currentHookNameInDev = 'useReducer';
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        if (isReRender) {
            // This is a re-render. Apply the new render phase updates to the previous
            // current hook.
            var queue = workInProgressHook.queue;
            var dispatch = queue.dispatch;
            if (renderPhaseUpdates !== null) {
                // Render phase updates are stored in a map of queue -> linked list
                var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
                if (firstRenderPhaseUpdate !== undefined) {
                    renderPhaseUpdates.delete(queue);
                    var newState = workInProgressHook.memoizedState;
                    var update = firstRenderPhaseUpdate;
                    do {
                        // Process this render phase update. We don't have to check the
                        // priority because it will always be the same as the current
                        // render's.
                        var action = update.action;
                        isInHookUserCodeInDev = true;
                        newState = reducer(newState, action);
                        isInHookUserCodeInDev = false;
                        update = update.next;
                    }while (update !== null);
                    workInProgressHook.memoizedState = newState;
                    return [
                        newState,
                        dispatch
                    ];
                }
            }
            return [
                workInProgressHook.memoizedState,
                dispatch
            ];
        } else {
            isInHookUserCodeInDev = true;
            var initialState;
            if (reducer === basicStateReducer) // Special case for `useState`.
            initialState = typeof initialArg === 'function' ? initialArg() : initialArg;
            else initialState = init !== undefined ? init(initialArg) : initialArg;
            isInHookUserCodeInDev = false;
            workInProgressHook.memoizedState = initialState;
            var _queue = workInProgressHook.queue = {
                last: null,
                dispatch: null
            };
            var _dispatch = _queue.dispatch = dispatchAction.bind(null, currentlyRenderingComponent, _queue);
            return [
                workInProgressHook.memoizedState,
                _dispatch
            ];
        }
    }
    function useMemo(nextCreate, deps) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        if (workInProgressHook !== null) {
            var prevState = workInProgressHook.memoizedState;
            if (prevState !== null) {
                if (nextDeps !== null) {
                    var prevDeps = prevState[1];
                    if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
                }
            }
        }
        isInHookUserCodeInDev = true;
        var nextValue = nextCreate();
        isInHookUserCodeInDev = false;
        workInProgressHook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function useRef(initialValue) {
        currentlyRenderingComponent = resolveCurrentlyRenderingComponent();
        workInProgressHook = createWorkInProgressHook();
        var previousRef = workInProgressHook.memoizedState;
        if (previousRef === null) {
            var ref = {
                current: initialValue
            };
            Object.seal(ref);
            workInProgressHook.memoizedState = ref;
            return ref;
        } else return previousRef;
    }
    function useLayoutEffect(create, inputs) {
        currentHookNameInDev = 'useLayoutEffect';
        error("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function dispatchAction(componentIdentity, queue, action) {
        if (!(numberOfReRenders < RE_RENDER_LIMIT)) throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
        if (componentIdentity === currentlyRenderingComponent) {
            // This is a render phase update. Stash it in a lazily-created map of
            // queue -> linked list of updates. After this render pass, we'll restart
            // and apply the stashed updates on top of the work-in-progress hook.
            didScheduleRenderPhaseUpdate = true;
            var update = {
                action: action,
                next: null
            };
            if (renderPhaseUpdates === null) renderPhaseUpdates = new Map();
            var firstRenderPhaseUpdate = renderPhaseUpdates.get(queue);
            if (firstRenderPhaseUpdate === undefined) renderPhaseUpdates.set(queue, update);
            else {
                // Append the update to the end of the list.
                var lastRenderPhaseUpdate = firstRenderPhaseUpdate;
                while(lastRenderPhaseUpdate.next !== null)lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
                lastRenderPhaseUpdate.next = update;
            }
        }
    }
    function useCallback(callback, deps) {
        return useMemo(function() {
            return callback;
        }, deps);
    } // TODO Decide on how to implement this hook for server rendering.
    // If a mutation occurs during render, consider triggering a Suspense boundary
    // and falling back to client rendering.
    function useMutableSource(source, getSnapshot, subscribe) {
        resolveCurrentlyRenderingComponent();
        return getSnapshot(source._source);
    }
    function useDeferredValue(value) {
        resolveCurrentlyRenderingComponent();
        return value;
    }
    function useTransition() {
        resolveCurrentlyRenderingComponent();
        var startTransition = function(callback) {
            callback();
        };
        return [
            startTransition,
            false
        ];
    }
    function useOpaqueIdentifier() {
        return (currentPartialRenderer.identifierPrefix || '') + 'R:' + (currentPartialRenderer.uniqueID++).toString(36);
    }
    function noop() {}
    var currentPartialRenderer = null;
    function setCurrentPartialRenderer(renderer) {
        currentPartialRenderer = renderer;
    }
    var Dispatcher = {
        readContext: readContext,
        useContext: useContext,
        useMemo: useMemo,
        useReducer: useReducer,
        useRef: useRef,
        useState: useState,
        useLayoutEffect: useLayoutEffect,
        useCallback: useCallback,
        // useImperativeHandle is not run in the server environment
        useImperativeHandle: noop,
        // Effects are not run in the server environment.
        useEffect: noop,
        // Debugging effect
        useDebugValue: noop,
        useDeferredValue: useDeferredValue,
        useTransition: useTransition,
        useOpaqueIdentifier: useOpaqueIdentifier,
        // Subscriptions are not setup in a server environment.
        useMutableSource: useMutableSource
    };
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    var MATH_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var Namespaces = {
        html: HTML_NAMESPACE,
        mathml: MATH_NAMESPACE,
        svg: SVG_NAMESPACE
    }; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case 'svg':
                return SVG_NAMESPACE;
            case 'math':
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === 'foreignObject') // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = _assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = '__html';
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (!(props.children == null && props.dangerouslySetInnerHTML == null)) throw Error(tag + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (!(props.children == null)) throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (!(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML)) throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (!(props.style == null || typeof props.style === 'object')) throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        'Webkit',
        'ms',
        'Moz',
        'O'
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === 'boolean' || value === '';
        if (isEmpty) return '';
        if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
        return ('' + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf('-') === -1) return typeof props.is === 'string';
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case 'annotation-xml':
            case 'color-profile':
            case 'font-face':
            case 'font-face-src':
            case 'font-face-uri':
            case 'font-face-format':
            case 'font-face-name':
            case 'missing-glyph':
                return false;
            default:
                return true;
        }
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported style property %s. Did you mean %s?', name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, 'ms-')));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error('Unsupported vendor-prefixed style property %s. Did you mean %s?', name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ''));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error('`NaN` is an invalid value for the `%s` css style property.', name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error('`Infinity` is an invalid value for the `%s` css style property.', name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf('-') > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === 'number') {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    var ariaProperties = {
        'aria-current': 0,
        // state
        'aria-details': 0,
        'aria-disabled': 0,
        // state
        'aria-hidden': 0,
        // state
        'aria-invalid': 0,
        // state
        'aria-keyshortcuts': 0,
        'aria-label': 0,
        'aria-roledescription': 0,
        // Widget Attributes
        'aria-autocomplete': 0,
        'aria-checked': 0,
        'aria-expanded': 0,
        'aria-haspopup': 0,
        'aria-level': 0,
        'aria-modal': 0,
        'aria-multiline': 0,
        'aria-multiselectable': 0,
        'aria-orientation': 0,
        'aria-placeholder': 0,
        'aria-pressed': 0,
        'aria-readonly': 0,
        'aria-required': 0,
        'aria-selected': 0,
        'aria-sort': 0,
        'aria-valuemax': 0,
        'aria-valuemin': 0,
        'aria-valuenow': 0,
        'aria-valuetext': 0,
        // Live Region Attributes
        'aria-atomic': 0,
        'aria-busy': 0,
        'aria-live': 0,
        'aria-relevant': 0,
        // Drag-and-Drop Attributes
        'aria-dropeffect': 0,
        'aria-grabbed': 0,
        // Relationship Attributes
        'aria-activedescendant': 0,
        'aria-colcount': 0,
        'aria-colindex': 0,
        'aria-colspan': 0,
        'aria-controls': 0,
        'aria-describedby': 0,
        'aria-errormessage': 0,
        'aria-flowto': 0,
        'aria-labelledby': 0,
        'aria-owns': 0,
        'aria-posinset': 0,
        'aria-rowcount': 0,
        'aria-rowindex': 0,
        'aria-rowspan': 0,
        'aria-setsize': 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
    function validateProperty(tagName, name) {
        if (hasOwnProperty$1.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = 'aria-' + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error('Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.', name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error('Invalid ARIA attribute `%s`. Did you mean `%s`?', name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error('Unknown ARIA attribute `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== 'input' && type !== 'textarea' && type !== 'select') return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === 'select' && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: 'accept',
        acceptcharset: 'acceptCharset',
        'accept-charset': 'acceptCharset',
        accesskey: 'accessKey',
        action: 'action',
        allowfullscreen: 'allowFullScreen',
        alt: 'alt',
        as: 'as',
        async: 'async',
        autocapitalize: 'autoCapitalize',
        autocomplete: 'autoComplete',
        autocorrect: 'autoCorrect',
        autofocus: 'autoFocus',
        autoplay: 'autoPlay',
        autosave: 'autoSave',
        capture: 'capture',
        cellpadding: 'cellPadding',
        cellspacing: 'cellSpacing',
        challenge: 'challenge',
        charset: 'charSet',
        checked: 'checked',
        children: 'children',
        cite: 'cite',
        class: 'className',
        classid: 'classID',
        classname: 'className',
        cols: 'cols',
        colspan: 'colSpan',
        content: 'content',
        contenteditable: 'contentEditable',
        contextmenu: 'contextMenu',
        controls: 'controls',
        controlslist: 'controlsList',
        coords: 'coords',
        crossorigin: 'crossOrigin',
        dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
        data: 'data',
        datetime: 'dateTime',
        default: 'default',
        defaultchecked: 'defaultChecked',
        defaultvalue: 'defaultValue',
        defer: 'defer',
        dir: 'dir',
        disabled: 'disabled',
        disablepictureinpicture: 'disablePictureInPicture',
        disableremoteplayback: 'disableRemotePlayback',
        download: 'download',
        draggable: 'draggable',
        enctype: 'encType',
        enterkeyhint: 'enterKeyHint',
        for: 'htmlFor',
        form: 'form',
        formmethod: 'formMethod',
        formaction: 'formAction',
        formenctype: 'formEncType',
        formnovalidate: 'formNoValidate',
        formtarget: 'formTarget',
        frameborder: 'frameBorder',
        headers: 'headers',
        height: 'height',
        hidden: 'hidden',
        high: 'high',
        href: 'href',
        hreflang: 'hrefLang',
        htmlfor: 'htmlFor',
        httpequiv: 'httpEquiv',
        'http-equiv': 'httpEquiv',
        icon: 'icon',
        id: 'id',
        innerhtml: 'innerHTML',
        inputmode: 'inputMode',
        integrity: 'integrity',
        is: 'is',
        itemid: 'itemID',
        itemprop: 'itemProp',
        itemref: 'itemRef',
        itemscope: 'itemScope',
        itemtype: 'itemType',
        keyparams: 'keyParams',
        keytype: 'keyType',
        kind: 'kind',
        label: 'label',
        lang: 'lang',
        list: 'list',
        loop: 'loop',
        low: 'low',
        manifest: 'manifest',
        marginwidth: 'marginWidth',
        marginheight: 'marginHeight',
        max: 'max',
        maxlength: 'maxLength',
        media: 'media',
        mediagroup: 'mediaGroup',
        method: 'method',
        min: 'min',
        minlength: 'minLength',
        multiple: 'multiple',
        muted: 'muted',
        name: 'name',
        nomodule: 'noModule',
        nonce: 'nonce',
        novalidate: 'noValidate',
        open: 'open',
        optimum: 'optimum',
        pattern: 'pattern',
        placeholder: 'placeholder',
        playsinline: 'playsInline',
        poster: 'poster',
        preload: 'preload',
        profile: 'profile',
        radiogroup: 'radioGroup',
        readonly: 'readOnly',
        referrerpolicy: 'referrerPolicy',
        rel: 'rel',
        required: 'required',
        reversed: 'reversed',
        role: 'role',
        rows: 'rows',
        rowspan: 'rowSpan',
        sandbox: 'sandbox',
        scope: 'scope',
        scoped: 'scoped',
        scrolling: 'scrolling',
        seamless: 'seamless',
        selected: 'selected',
        shape: 'shape',
        size: 'size',
        sizes: 'sizes',
        span: 'span',
        spellcheck: 'spellCheck',
        src: 'src',
        srcdoc: 'srcDoc',
        srclang: 'srcLang',
        srcset: 'srcSet',
        start: 'start',
        step: 'step',
        style: 'style',
        summary: 'summary',
        tabindex: 'tabIndex',
        target: 'target',
        title: 'title',
        type: 'type',
        usemap: 'useMap',
        value: 'value',
        width: 'width',
        wmode: 'wmode',
        wrap: 'wrap',
        // SVG
        about: 'about',
        accentheight: 'accentHeight',
        'accent-height': 'accentHeight',
        accumulate: 'accumulate',
        additive: 'additive',
        alignmentbaseline: 'alignmentBaseline',
        'alignment-baseline': 'alignmentBaseline',
        allowreorder: 'allowReorder',
        alphabetic: 'alphabetic',
        amplitude: 'amplitude',
        arabicform: 'arabicForm',
        'arabic-form': 'arabicForm',
        ascent: 'ascent',
        attributename: 'attributeName',
        attributetype: 'attributeType',
        autoreverse: 'autoReverse',
        azimuth: 'azimuth',
        basefrequency: 'baseFrequency',
        baselineshift: 'baselineShift',
        'baseline-shift': 'baselineShift',
        baseprofile: 'baseProfile',
        bbox: 'bbox',
        begin: 'begin',
        bias: 'bias',
        by: 'by',
        calcmode: 'calcMode',
        capheight: 'capHeight',
        'cap-height': 'capHeight',
        clip: 'clip',
        clippath: 'clipPath',
        'clip-path': 'clipPath',
        clippathunits: 'clipPathUnits',
        cliprule: 'clipRule',
        'clip-rule': 'clipRule',
        color: 'color',
        colorinterpolation: 'colorInterpolation',
        'color-interpolation': 'colorInterpolation',
        colorinterpolationfilters: 'colorInterpolationFilters',
        'color-interpolation-filters': 'colorInterpolationFilters',
        colorprofile: 'colorProfile',
        'color-profile': 'colorProfile',
        colorrendering: 'colorRendering',
        'color-rendering': 'colorRendering',
        contentscripttype: 'contentScriptType',
        contentstyletype: 'contentStyleType',
        cursor: 'cursor',
        cx: 'cx',
        cy: 'cy',
        d: 'd',
        datatype: 'datatype',
        decelerate: 'decelerate',
        descent: 'descent',
        diffuseconstant: 'diffuseConstant',
        direction: 'direction',
        display: 'display',
        divisor: 'divisor',
        dominantbaseline: 'dominantBaseline',
        'dominant-baseline': 'dominantBaseline',
        dur: 'dur',
        dx: 'dx',
        dy: 'dy',
        edgemode: 'edgeMode',
        elevation: 'elevation',
        enablebackground: 'enableBackground',
        'enable-background': 'enableBackground',
        end: 'end',
        exponent: 'exponent',
        externalresourcesrequired: 'externalResourcesRequired',
        fill: 'fill',
        fillopacity: 'fillOpacity',
        'fill-opacity': 'fillOpacity',
        fillrule: 'fillRule',
        'fill-rule': 'fillRule',
        filter: 'filter',
        filterres: 'filterRes',
        filterunits: 'filterUnits',
        floodopacity: 'floodOpacity',
        'flood-opacity': 'floodOpacity',
        floodcolor: 'floodColor',
        'flood-color': 'floodColor',
        focusable: 'focusable',
        fontfamily: 'fontFamily',
        'font-family': 'fontFamily',
        fontsize: 'fontSize',
        'font-size': 'fontSize',
        fontsizeadjust: 'fontSizeAdjust',
        'font-size-adjust': 'fontSizeAdjust',
        fontstretch: 'fontStretch',
        'font-stretch': 'fontStretch',
        fontstyle: 'fontStyle',
        'font-style': 'fontStyle',
        fontvariant: 'fontVariant',
        'font-variant': 'fontVariant',
        fontweight: 'fontWeight',
        'font-weight': 'fontWeight',
        format: 'format',
        from: 'from',
        fx: 'fx',
        fy: 'fy',
        g1: 'g1',
        g2: 'g2',
        glyphname: 'glyphName',
        'glyph-name': 'glyphName',
        glyphorientationhorizontal: 'glyphOrientationHorizontal',
        'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
        glyphorientationvertical: 'glyphOrientationVertical',
        'glyph-orientation-vertical': 'glyphOrientationVertical',
        glyphref: 'glyphRef',
        gradienttransform: 'gradientTransform',
        gradientunits: 'gradientUnits',
        hanging: 'hanging',
        horizadvx: 'horizAdvX',
        'horiz-adv-x': 'horizAdvX',
        horizoriginx: 'horizOriginX',
        'horiz-origin-x': 'horizOriginX',
        ideographic: 'ideographic',
        imagerendering: 'imageRendering',
        'image-rendering': 'imageRendering',
        in2: 'in2',
        in: 'in',
        inlist: 'inlist',
        intercept: 'intercept',
        k1: 'k1',
        k2: 'k2',
        k3: 'k3',
        k4: 'k4',
        k: 'k',
        kernelmatrix: 'kernelMatrix',
        kernelunitlength: 'kernelUnitLength',
        kerning: 'kerning',
        keypoints: 'keyPoints',
        keysplines: 'keySplines',
        keytimes: 'keyTimes',
        lengthadjust: 'lengthAdjust',
        letterspacing: 'letterSpacing',
        'letter-spacing': 'letterSpacing',
        lightingcolor: 'lightingColor',
        'lighting-color': 'lightingColor',
        limitingconeangle: 'limitingConeAngle',
        local: 'local',
        markerend: 'markerEnd',
        'marker-end': 'markerEnd',
        markerheight: 'markerHeight',
        markermid: 'markerMid',
        'marker-mid': 'markerMid',
        markerstart: 'markerStart',
        'marker-start': 'markerStart',
        markerunits: 'markerUnits',
        markerwidth: 'markerWidth',
        mask: 'mask',
        maskcontentunits: 'maskContentUnits',
        maskunits: 'maskUnits',
        mathematical: 'mathematical',
        mode: 'mode',
        numoctaves: 'numOctaves',
        offset: 'offset',
        opacity: 'opacity',
        operator: 'operator',
        order: 'order',
        orient: 'orient',
        orientation: 'orientation',
        origin: 'origin',
        overflow: 'overflow',
        overlineposition: 'overlinePosition',
        'overline-position': 'overlinePosition',
        overlinethickness: 'overlineThickness',
        'overline-thickness': 'overlineThickness',
        paintorder: 'paintOrder',
        'paint-order': 'paintOrder',
        panose1: 'panose1',
        'panose-1': 'panose1',
        pathlength: 'pathLength',
        patterncontentunits: 'patternContentUnits',
        patterntransform: 'patternTransform',
        patternunits: 'patternUnits',
        pointerevents: 'pointerEvents',
        'pointer-events': 'pointerEvents',
        points: 'points',
        pointsatx: 'pointsAtX',
        pointsaty: 'pointsAtY',
        pointsatz: 'pointsAtZ',
        prefix: 'prefix',
        preservealpha: 'preserveAlpha',
        preserveaspectratio: 'preserveAspectRatio',
        primitiveunits: 'primitiveUnits',
        property: 'property',
        r: 'r',
        radius: 'radius',
        refx: 'refX',
        refy: 'refY',
        renderingintent: 'renderingIntent',
        'rendering-intent': 'renderingIntent',
        repeatcount: 'repeatCount',
        repeatdur: 'repeatDur',
        requiredextensions: 'requiredExtensions',
        requiredfeatures: 'requiredFeatures',
        resource: 'resource',
        restart: 'restart',
        result: 'result',
        results: 'results',
        rotate: 'rotate',
        rx: 'rx',
        ry: 'ry',
        scale: 'scale',
        security: 'security',
        seed: 'seed',
        shaperendering: 'shapeRendering',
        'shape-rendering': 'shapeRendering',
        slope: 'slope',
        spacing: 'spacing',
        specularconstant: 'specularConstant',
        specularexponent: 'specularExponent',
        speed: 'speed',
        spreadmethod: 'spreadMethod',
        startoffset: 'startOffset',
        stddeviation: 'stdDeviation',
        stemh: 'stemh',
        stemv: 'stemv',
        stitchtiles: 'stitchTiles',
        stopcolor: 'stopColor',
        'stop-color': 'stopColor',
        stopopacity: 'stopOpacity',
        'stop-opacity': 'stopOpacity',
        strikethroughposition: 'strikethroughPosition',
        'strikethrough-position': 'strikethroughPosition',
        strikethroughthickness: 'strikethroughThickness',
        'strikethrough-thickness': 'strikethroughThickness',
        string: 'string',
        stroke: 'stroke',
        strokedasharray: 'strokeDasharray',
        'stroke-dasharray': 'strokeDasharray',
        strokedashoffset: 'strokeDashoffset',
        'stroke-dashoffset': 'strokeDashoffset',
        strokelinecap: 'strokeLinecap',
        'stroke-linecap': 'strokeLinecap',
        strokelinejoin: 'strokeLinejoin',
        'stroke-linejoin': 'strokeLinejoin',
        strokemiterlimit: 'strokeMiterlimit',
        'stroke-miterlimit': 'strokeMiterlimit',
        strokewidth: 'strokeWidth',
        'stroke-width': 'strokeWidth',
        strokeopacity: 'strokeOpacity',
        'stroke-opacity': 'strokeOpacity',
        suppresscontenteditablewarning: 'suppressContentEditableWarning',
        suppresshydrationwarning: 'suppressHydrationWarning',
        surfacescale: 'surfaceScale',
        systemlanguage: 'systemLanguage',
        tablevalues: 'tableValues',
        targetx: 'targetX',
        targety: 'targetY',
        textanchor: 'textAnchor',
        'text-anchor': 'textAnchor',
        textdecoration: 'textDecoration',
        'text-decoration': 'textDecoration',
        textlength: 'textLength',
        textrendering: 'textRendering',
        'text-rendering': 'textRendering',
        to: 'to',
        transform: 'transform',
        typeof: 'typeof',
        u1: 'u1',
        u2: 'u2',
        underlineposition: 'underlinePosition',
        'underline-position': 'underlinePosition',
        underlinethickness: 'underlineThickness',
        'underline-thickness': 'underlineThickness',
        unicode: 'unicode',
        unicodebidi: 'unicodeBidi',
        'unicode-bidi': 'unicodeBidi',
        unicoderange: 'unicodeRange',
        'unicode-range': 'unicodeRange',
        unitsperem: 'unitsPerEm',
        'units-per-em': 'unitsPerEm',
        unselectable: 'unselectable',
        valphabetic: 'vAlphabetic',
        'v-alphabetic': 'vAlphabetic',
        values: 'values',
        vectoreffect: 'vectorEffect',
        'vector-effect': 'vectorEffect',
        version: 'version',
        vertadvy: 'vertAdvY',
        'vert-adv-y': 'vertAdvY',
        vertoriginx: 'vertOriginX',
        'vert-origin-x': 'vertOriginX',
        vertoriginy: 'vertOriginY',
        'vert-origin-y': 'vertOriginY',
        vhanging: 'vHanging',
        'v-hanging': 'vHanging',
        videographic: 'vIdeographic',
        'v-ideographic': 'vIdeographic',
        viewbox: 'viewBox',
        viewtarget: 'viewTarget',
        visibility: 'visibility',
        vmathematical: 'vMathematical',
        'v-mathematical': 'vMathematical',
        vocab: 'vocab',
        widths: 'widths',
        wordspacing: 'wordSpacing',
        'word-spacing': 'wordSpacing',
        writingmode: 'writingMode',
        'writing-mode': 'writingMode',
        x1: 'x1',
        x2: 'x2',
        x: 'x',
        xchannelselector: 'xChannelSelector',
        xheight: 'xHeight',
        'x-height': 'xHeight',
        xlinkactuate: 'xlinkActuate',
        'xlink:actuate': 'xlinkActuate',
        xlinkarcrole: 'xlinkArcrole',
        'xlink:arcrole': 'xlinkArcrole',
        xlinkhref: 'xlinkHref',
        'xlink:href': 'xlinkHref',
        xlinkrole: 'xlinkRole',
        'xlink:role': 'xlinkRole',
        xlinkshow: 'xlinkShow',
        'xlink:show': 'xlinkShow',
        xlinktitle: 'xlinkTitle',
        'xlink:title': 'xlinkTitle',
        xlinktype: 'xlinkType',
        'xlink:type': 'xlinkType',
        xmlbase: 'xmlBase',
        'xml:base': 'xmlBase',
        xmllang: 'xmlLang',
        'xml:lang': 'xmlLang',
        xmlns: 'xmlns',
        'xml:space': 'xmlSpace',
        xmlnsxlink: 'xmlnsXlink',
        'xmlns:xlink': 'xmlnsXlink',
        xmlspace: 'xmlSpace',
        y1: 'y1',
        y2: 'y2',
        y: 'y',
        ychannelselector: 'yChannelSelector',
        z: 'z',
        zoomandpan: 'zoomAndPan'
    };
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var _hasOwnProperty = Object.prototype.hasOwnProperty;
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp('^(aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$');
    var rARIACamel$1 = new RegExp('^(aria)[A-Z][' + ATTRIBUTE_NAME_CHAR + ']*$');
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (_hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === 'onfocusin' || lowerCasedName === 'onfocusout') {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error('Invalid event handler property `%s`. Did you mean `%s`?', name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error('Unknown event handler property `%s`. It will be ignored.', name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === 'innerhtml') {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'aria') {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === 'is' && value !== null && value !== undefined && typeof value !== 'string') {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'number' && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error('Invalid DOM property `%s`. Did you mean `%s`?', name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === 'boolean' && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === 'false' || value === 'true') && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === 'false' ? 'The browser will interpret it as a truthy value.' : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return '`' + prop + '`';
        }).join(', ');
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var toArray = React.Children.toArray; // This is only used in DEV.
    // Each entry is `this.stack` from a currently executing renderer instance.
    // (There may be more than one because ReactDOMServer is reentrant).
    // Each stack is an array of frames which may contain nested stacks of elements.
    var currentDebugStacks = [];
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var ReactDebugCurrentFrame$1;
    var prevGetCurrentStackImpl = null;
    var getCurrentServerStackImpl = function() {
        return '';
    };
    var describeStackFrame = function(element) {
        return '';
    };
    var validatePropertiesInDevelopment = function(type, props) {};
    var pushCurrentDebugStack = function(stack) {};
    var pushElementToDebugStack = function(element) {};
    var popCurrentDebugStack = function() {};
    var hasWarnedAboutUsingContextAsConsumer = false;
    ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, null);
    };
    describeStackFrame = function(element) {
        return describeUnknownElementTypeFrameInDEV(element.type, element._source, null);
    };
    pushCurrentDebugStack = function(stack) {
        currentDebugStacks.push(stack);
        if (currentDebugStacks.length === 1) {
            // We are entering a server renderer.
            // Remember the previous (e.g. client) global stack implementation.
            prevGetCurrentStackImpl = ReactDebugCurrentFrame$1.getCurrentStack;
            ReactDebugCurrentFrame$1.getCurrentStack = getCurrentServerStackImpl;
        }
    };
    pushElementToDebugStack = function(element) {
        // For the innermost executing ReactDOMServer call,
        var stack = currentDebugStacks[currentDebugStacks.length - 1]; // Take the innermost executing frame (e.g. <Foo>),
        var frame = stack[stack.length - 1]; // and record that it has one more element associated with it.
        frame.debugElementStack.push(element); // We only need this because we tail-optimize single-element
    // children and directly handle them in an inner loop instead of
    // creating separate frames for them.
    };
    popCurrentDebugStack = function() {
        currentDebugStacks.pop();
        if (currentDebugStacks.length === 0) {
            // We are exiting the server renderer.
            // Restore the previous (e.g. client) global stack implementation.
            ReactDebugCurrentFrame$1.getCurrentStack = prevGetCurrentStackImpl;
            prevGetCurrentStackImpl = null;
        }
    };
    getCurrentServerStackImpl = function() {
        if (currentDebugStacks.length === 0) // Nothing is currently rendering.
        return '';
         // ReactDOMServer is reentrant so there may be multiple calls at the same time.
        // Take the frames from the innermost call which is the last in the array.
        var frames = currentDebugStacks[currentDebugStacks.length - 1];
        var stack = ''; // Go through every frame in the stack from the innermost one.
        for(var i = frames.length - 1; i >= 0; i--){
            var frame = frames[i]; // Every frame might have more than one debug element stack entry associated with it.
            // This is because single-child nesting doesn't create materialized frames.
            // Instead it would push them through `pushElementToDebugStack()`.
            var debugElementStack = frame.debugElementStack;
            for(var ii = debugElementStack.length - 1; ii >= 0; ii--)stack += describeStackFrame(debugElementStack[ii]);
        }
        return stack;
    };
    var didWarnDefaultInputValue = false;
    var didWarnDefaultChecked = false;
    var didWarnDefaultSelectValue = false;
    var didWarnDefaultTextareaValue = false;
    var didWarnInvalidOptionChildren = false;
    var didWarnAboutNoopUpdateForComponent = {};
    var didWarnAboutBadClass = {};
    var didWarnAboutModulePatternComponent = {};
    var didWarnAboutDeprecatedWillMount = {};
    var didWarnAboutUndefinedDerivedState = {};
    var didWarnAboutUninitializedState = {};
    var valuePropNames = [
        'value',
        'defaultValue'
    ];
    var newlineEatingTags = {
        listing: true,
        pre: true,
        textarea: true
    }; // We accept any tag to be rendered but since this gets injected into arbitrary
    // HTML, we want to make sure that it's a safe tag.
    // http://www.w3.org/TR/REC-xml/#NT-Name
    var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
    var validatedTagCache = {};
    function validateDangerousTag(tag) {
        if (!validatedTagCache.hasOwnProperty(tag)) {
            if (!VALID_TAG_REGEX.test(tag)) throw Error("Invalid tag: " + tag);
            validatedTagCache[tag] = true;
        }
    }
    var styleNameCache = {};
    var processStyleName = function(styleName) {
        if (styleNameCache.hasOwnProperty(styleName)) return styleNameCache[styleName];
        var result = hyphenateStyleName(styleName);
        styleNameCache[styleName] = result;
        return result;
    };
    function createMarkupForStyles(styles) {
        var serialized = '';
        var delimiter = '';
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf('--') === 0;
            var styleValue = styles[styleName];
            if (!isCustomProperty) warnValidStyle$1(styleName, styleValue);
            if (styleValue != null) {
                serialized += delimiter + (isCustomProperty ? styleName : processStyleName(styleName)) + ':';
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ';';
            }
        }
        return serialized || null;
    }
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && getComponentName(_constructor) || 'ReactClass';
        var warningKey = componentName + '.' + callerName;
        if (didWarnAboutNoopUpdateForComponent[warningKey]) return;
        error("%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.\n\nPlease check the code for the %s component.", callerName, callerName, componentName);
        didWarnAboutNoopUpdateForComponent[warningKey] = true;
    }
    function shouldConstruct$1(Component) {
        return Component.prototype && Component.prototype.isReactComponent;
    }
    function getNonChildrenInnerMarkup(props) {
        var innerHTML = props.dangerouslySetInnerHTML;
        if (innerHTML != null) {
            if (innerHTML.__html != null) return innerHTML.__html;
        } else {
            var content = props.children;
            if (typeof content === 'string' || typeof content === 'number') return escapeTextForBrowser(content);
        }
        return null;
    }
    function flattenTopLevelChildren(children) {
        if (!React.isValidElement(children)) return toArray(children);
        var element = children;
        if (element.type !== REACT_FRAGMENT_TYPE) return [
            element
        ];
        var fragmentChildren = element.props.children;
        if (!React.isValidElement(fragmentChildren)) return toArray(fragmentChildren);
        var fragmentChildElement = fragmentChildren;
        return [
            fragmentChildElement
        ];
    }
    function flattenOptionChildren(children) {
        if (children === undefined || children === null) return children;
        var content = ''; // Flatten children and warn if they aren't strings or numbers;
        // invalid types are ignored.
        React.Children.forEach(children, function(child) {
            if (child == null) return;
            content += child;
            if (!didWarnInvalidOptionChildren && typeof child !== 'string' && typeof child !== 'number') {
                didWarnInvalidOptionChildren = true;
                error('Only strings and numbers are supported as <option> children.');
            }
        });
        return content;
    }
    var hasOwnProperty$2 = Object.prototype.hasOwnProperty;
    var STYLE = 'style';
    var RESERVED_PROPS = {
        children: null,
        dangerouslySetInnerHTML: null,
        suppressContentEditableWarning: null,
        suppressHydrationWarning: null
    };
    function createOpenTagMarkup(tagVerbatim, tagLowercase, props, namespace, makeStaticMarkup, isRootElement) {
        var ret = '<' + tagVerbatim;
        var isCustomComponent$1 = isCustomComponent(tagLowercase, props);
        for(var propKey in props){
            if (!hasOwnProperty$2.call(props, propKey)) continue;
            var propValue = props[propKey];
            if (propValue == null) continue;
            if (propKey === STYLE) propValue = createMarkupForStyles(propValue);
            var markup = null;
            if (isCustomComponent$1) {
                if (!RESERVED_PROPS.hasOwnProperty(propKey)) markup = createMarkupForCustomAttribute(propKey, propValue);
            } else markup = createMarkupForProperty(propKey, propValue);
            if (markup) ret += ' ' + markup;
        } // For static pages, no need to put React ID and checksum. Saves lots of
        // bytes.
        if (makeStaticMarkup) return ret;
        if (isRootElement) ret += ' ' + createMarkupForRoot();
        return ret;
    }
    function validateRenderResult(child, type) {
        if (child === undefined) throw Error((getComponentName(type) || 'Component') + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function resolve(child, context, threadID) {
        while(React.isValidElement(child)){
            // Safe because we just checked it's an element.
            var element = child;
            var Component = element.type;
            pushElementToDebugStack(element);
            if (typeof Component !== 'function') break;
            processChild(element, Component);
        } // Extra closure so queue and replace can be captured properly
        function processChild(element, Component) {
            var isClass = shouldConstruct$1(Component);
            var publicContext = processContext(Component, context, threadID, isClass);
            var queue = [];
            var replace = false;
            var updater = {
                isMounted: function(publicInstance) {
                    return false;
                },
                enqueueForceUpdate: function(publicInstance) {
                    if (queue === null) {
                        warnNoop(publicInstance, 'forceUpdate');
                        return null;
                    }
                },
                enqueueReplaceState: function(publicInstance, completeState) {
                    replace = true;
                    queue = [
                        completeState
                    ];
                },
                enqueueSetState: function(publicInstance, currentPartialState) {
                    if (queue === null) {
                        warnNoop(publicInstance, 'setState');
                        return null;
                    }
                    queue.push(currentPartialState);
                }
            };
            var inst;
            if (isClass) {
                inst = new Component(element.props, publicContext, updater);
                if (typeof Component.getDerivedStateFromProps === 'function') {
                    if (inst.state === null || inst.state === undefined) {
                        var componentName = getComponentName(Component) || 'Unknown';
                        if (!didWarnAboutUninitializedState[componentName]) {
                            error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, inst.state === null ? 'null' : 'undefined', componentName);
                            didWarnAboutUninitializedState[componentName] = true;
                        }
                    }
                    var partialState = Component.getDerivedStateFromProps.call(null, element.props, inst.state);
                    if (partialState === undefined) {
                        var _componentName = getComponentName(Component) || 'Unknown';
                        if (!didWarnAboutUndefinedDerivedState[_componentName]) {
                            error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", _componentName);
                            didWarnAboutUndefinedDerivedState[_componentName] = true;
                        }
                    }
                    if (partialState != null) inst.state = _assign({}, inst.state, partialState);
                }
            } else {
                if (Component.prototype && typeof Component.prototype.render === 'function') {
                    var _componentName2 = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutBadClass[_componentName2]) {
                        error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", _componentName2, _componentName2);
                        didWarnAboutBadClass[_componentName2] = true;
                    }
                }
                var componentIdentity = {};
                prepareToUseHooks(componentIdentity);
                inst = Component(element.props, publicContext, updater);
                inst = finishHooks(Component, element.props, inst, publicContext);
                // Support for module components is deprecated and is removed behind a flag.
                // Whether or not it would crash later, we want to show a good message in DEV first.
                if (inst != null && inst.render != null) {
                    var _componentName3 = getComponentName(Component) || 'Unknown';
                    if (!didWarnAboutModulePatternComponent[_componentName3]) {
                        error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName3, _componentName3, _componentName3);
                        didWarnAboutModulePatternComponent[_componentName3] = true;
                    }
                }
                // Otherwise, we also do the unfortunate dynamic checks.
                if (inst == null || inst.render == null) {
                    child = inst;
                    validateRenderResult(child, Component);
                    return;
                }
            }
            inst.props = element.props;
            inst.context = publicContext;
            inst.updater = updater;
            var initialState = inst.state;
            if (initialState === undefined) inst.state = initialState = null;
            if (typeof inst.UNSAFE_componentWillMount === 'function' || typeof inst.componentWillMount === 'function') {
                if (typeof inst.componentWillMount === 'function') {
                    if (inst.componentWillMount.__suppressDeprecationWarning !== true) {
                        var _componentName4 = getComponentName(Component) || 'Unknown';
                        if (!didWarnAboutDeprecatedWillMount[_componentName4]) {
                            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.\n\nPlease update the following components: %s", _componentName4);
                            didWarnAboutDeprecatedWillMount[_componentName4] = true;
                        }
                    }
                    // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
                    if (typeof Component.getDerivedStateFromProps !== 'function') inst.componentWillMount();
                }
                if (typeof inst.UNSAFE_componentWillMount === 'function' && typeof Component.getDerivedStateFromProps !== 'function') // In order to support react-lifecycles-compat polyfilled components,
                // Unsafe lifecycles should not be invoked for any component with the new gDSFP.
                inst.UNSAFE_componentWillMount();
                if (queue.length) {
                    var oldQueue = queue;
                    var oldReplace = replace;
                    queue = null;
                    replace = false;
                    if (oldReplace && oldQueue.length === 1) inst.state = oldQueue[0];
                    else {
                        var nextState = oldReplace ? oldQueue[0] : inst.state;
                        var dontMutate = true;
                        for(var i = oldReplace ? 1 : 0; i < oldQueue.length; i++){
                            var partial = oldQueue[i];
                            var _partialState = typeof partial === 'function' ? partial.call(inst, nextState, element.props, publicContext) : partial;
                            if (_partialState != null) {
                                if (dontMutate) {
                                    dontMutate = false;
                                    nextState = _assign({}, nextState, _partialState);
                                } else _assign(nextState, _partialState);
                            }
                        }
                        inst.state = nextState;
                    }
                } else queue = null;
            }
            child = inst.render();
            if (child === undefined && inst.render._isMockFunction) // This is probably bad practice. Consider warning here and
            // deprecating this convenience.
            child = null;
            validateRenderResult(child, Component);
            var childContext;
            if (typeof inst.getChildContext === 'function') {
                var _childContextTypes = Component.childContextTypes;
                if (typeof _childContextTypes === 'object') {
                    childContext = inst.getChildContext();
                    for(var contextKey in childContext){
                        if (!(contextKey in _childContextTypes)) throw Error((getComponentName(Component) || 'Unknown') + ".getChildContext(): key \"" + contextKey + "\" is not defined in childContextTypes.");
                    }
                } else error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", getComponentName(Component) || 'Unknown');
            }
            if (childContext) context = _assign({}, context, childContext);
        }
        return {
            child: child,
            context: context
        };
    }
    var ReactDOMServerRenderer = /*#__PURE__*/ function() {
        // TODO: type this more strictly:
        // DEV-only
        function ReactDOMServerRenderer(children, makeStaticMarkup, options) {
            var flatChildren = flattenTopLevelChildren(children);
            var topFrame = {
                type: null,
                // Assume all trees start in the HTML namespace (not totally true, but
                // this is what we did historically)
                domNamespace: Namespaces.html,
                children: flatChildren,
                childIndex: 0,
                context: emptyObject,
                footer: ''
            };
            topFrame.debugElementStack = [];
            this.threadID = allocThreadID();
            this.stack = [
                topFrame
            ];
            this.exhausted = false;
            this.currentSelectValue = null;
            this.previousWasTextNode = false;
            this.makeStaticMarkup = makeStaticMarkup;
            this.suspenseDepth = 0; // Context (new API)
            this.contextIndex = -1;
            this.contextStack = [];
            this.contextValueStack = []; // useOpaqueIdentifier ID
            this.uniqueID = 0;
            this.identifierPrefix = options && options.identifierPrefix || '';
            this.contextProviderStack = [];
        }
        var _proto = ReactDOMServerRenderer.prototype;
        _proto.destroy = function destroy() {
            if (!this.exhausted) {
                this.exhausted = true;
                this.clearProviders();
                freeThreadID(this.threadID);
            }
        };
        _proto.pushProvider = function pushProvider(provider) {
            var index = ++this.contextIndex;
            var context = provider.type._context;
            var threadID = this.threadID;
            validateContextBounds(context, threadID);
            var previousValue = context[threadID]; // Remember which value to restore this context to on our way up.
            this.contextStack[index] = context;
            this.contextValueStack[index] = previousValue;
            // Only used for push/pop mismatch warnings.
            this.contextProviderStack[index] = provider;
            context[threadID] = provider.props.value;
        };
        _proto.popProvider = function popProvider(provider) {
            var index = this.contextIndex;
            if (index < 0 || provider !== this.contextProviderStack[index]) error('Unexpected pop.');
            var context = this.contextStack[index];
            var previousValue = this.contextValueStack[index]; // "Hide" these null assignments from Flow by using `any`
            // because conceptually they are deletions--as long as we
            // promise to never access values beyond `this.contextIndex`.
            this.contextStack[index] = null;
            this.contextValueStack[index] = null;
            this.contextProviderStack[index] = null;
            this.contextIndex--; // Restore to the previous value we stored as we were walking down.
            // We've already verified that this context has been expanded to accommodate
            // this thread id, so we don't need to do it again.
            context[this.threadID] = previousValue;
        };
        _proto.clearProviders = function clearProviders() {
            // Restore any remaining providers on the stack to previous values
            for(var index = this.contextIndex; index >= 0; index--){
                var context = this.contextStack[index];
                var previousValue = this.contextValueStack[index];
                context[this.threadID] = previousValue;
            }
        };
        _proto.read = function read(bytes) {
            if (this.exhausted) return null;
            var prevPartialRenderer = currentPartialRenderer;
            setCurrentPartialRenderer(this);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = Dispatcher;
            try {
                // Markup generated within <Suspense> ends up buffered until we know
                // nothing in that boundary suspended
                var out = [
                    ''
                ];
                var suspended = false;
                while(out[0].length < bytes){
                    if (this.stack.length === 0) {
                        this.exhausted = true;
                        freeThreadID(this.threadID);
                        break;
                    }
                    var frame = this.stack[this.stack.length - 1];
                    if (suspended || frame.childIndex >= frame.children.length) {
                        var footer = frame.footer;
                        if (footer !== '') this.previousWasTextNode = false;
                        this.stack.pop();
                        if (frame.type === 'select') this.currentSelectValue = null;
                        else if (frame.type != null && frame.type.type != null && frame.type.type.$$typeof === REACT_PROVIDER_TYPE) {
                            var provider = frame.type;
                            this.popProvider(provider);
                        } else if (frame.type === REACT_SUSPENSE_TYPE) {
                            this.suspenseDepth--;
                            var buffered = out.pop();
                            if (suspended) {
                                suspended = false; // If rendering was suspended at this boundary, render the fallbackFrame
                                var fallbackFrame = frame.fallbackFrame;
                                if (!fallbackFrame) throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                                this.stack.push(fallbackFrame);
                                out[this.suspenseDepth] += '<!--$!-->'; // Skip flushing output since we're switching to the fallback
                                continue;
                            } else out[this.suspenseDepth] += buffered;
                        } // Flush output
                        out[this.suspenseDepth] += footer;
                        continue;
                    }
                    var child = frame.children[frame.childIndex++];
                    var outBuffer = '';
                    pushCurrentDebugStack(this.stack); // We're starting work on this frame, so reset its inner stack.
                    frame.debugElementStack.length = 0;
                    try {
                        outBuffer += this.render(child, frame.context, frame.domNamespace);
                    } catch (err) {
                        if (err != null && typeof err.then === 'function') {
                            if (enableSuspenseServerRenderer) {
                                if (!(this.suspenseDepth > 0)) throw Error("A React component suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                                suspended = true;
                            } else throw Error("ReactDOMServer does not yet support Suspense.");
                        } else throw err;
                    } finally{
                        popCurrentDebugStack();
                    }
                    if (out.length <= this.suspenseDepth) out.push('');
                    out[this.suspenseDepth] += outBuffer;
                }
                return out[0];
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
                setCurrentPartialRenderer(prevPartialRenderer);
                resetHooksState();
            }
        };
        _proto.render = function render(child, context, parentNamespace) {
            if (typeof child === 'string' || typeof child === 'number') {
                var text = '' + child;
                if (text === '') return '';
                if (this.makeStaticMarkup) return escapeTextForBrowser(text);
                if (this.previousWasTextNode) return '<!-- -->' + escapeTextForBrowser(text);
                this.previousWasTextNode = true;
                return escapeTextForBrowser(text);
            } else {
                var nextChild;
                var _resolve = resolve(child, context, this.threadID);
                nextChild = _resolve.child;
                context = _resolve.context;
                if (nextChild === null || nextChild === false) return '';
                else if (!React.isValidElement(nextChild)) {
                    if (nextChild != null && nextChild.$$typeof != null) {
                        // Catch unexpected special types early.
                        var $$typeof = nextChild.$$typeof;
                        if (!($$typeof !== REACT_PORTAL_TYPE)) throw Error("Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render.");
                         // Catch-all to prevent an infinite loop if React.Children.toArray() supports some new type.
                        throw Error("Unknown element-like object type: " + $$typeof.toString() + ". This is likely a bug in React. Please file an issue.");
                    }
                    var nextChildren = toArray(nextChild);
                    var frame = {
                        type: null,
                        domNamespace: parentNamespace,
                        children: nextChildren,
                        childIndex: 0,
                        context: context,
                        footer: ''
                    };
                    frame.debugElementStack = [];
                    this.stack.push(frame);
                    return '';
                } // Safe because we just checked it's an element.
                var nextElement = nextChild;
                var elementType = nextElement.type;
                if (typeof elementType === 'string') return this.renderDOM(nextElement, context, parentNamespace);
                switch(elementType){
                    // TODO: LegacyHidden acts the same as a fragment. This only works
                    // because we currently assume that every instance of LegacyHidden is
                    // accompanied by a host component wrapper. In the hidden mode, the host
                    // component is given a `hidden` attribute, which ensures that the
                    // initial HTML is not visible. To support the use of LegacyHidden as a
                    // true fragment, without an extra DOM node, we would have to hide the
                    // initial HTML in some other way.
                    case REACT_LEGACY_HIDDEN_TYPE:
                    case REACT_DEBUG_TRACING_MODE_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_FRAGMENT_TYPE:
                        var _nextChildren = toArray(nextChild.props.children);
                        var _frame = {
                            type: null,
                            domNamespace: parentNamespace,
                            children: _nextChildren,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame.debugElementStack = [];
                        this.stack.push(_frame);
                        return '';
                    case REACT_SUSPENSE_TYPE:
                        throw Error("ReactDOMServer does not yet support Suspense.");
                    // eslint-disable-next-line-no-fallthrough
                    case REACT_SCOPE_TYPE:
                        throw Error("ReactDOMServer does not yet support scope components.");
                }
                if (typeof elementType === 'object' && elementType !== null) switch(elementType.$$typeof){
                    case REACT_FORWARD_REF_TYPE:
                        var element = nextChild;
                        var _nextChildren5;
                        var componentIdentity = {};
                        prepareToUseHooks(componentIdentity);
                        _nextChildren5 = elementType.render(element.props, element.ref);
                        _nextChildren5 = finishHooks(elementType.render, element.props, _nextChildren5, element.ref);
                        _nextChildren5 = toArray(_nextChildren5);
                        var _frame5 = {
                            type: null,
                            domNamespace: parentNamespace,
                            children: _nextChildren5,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame5.debugElementStack = [];
                        this.stack.push(_frame5);
                        return '';
                    case REACT_MEMO_TYPE:
                        var _element = nextChild;
                        var _nextChildren6 = [
                            React.createElement(elementType.type, _assign({
                                ref: _element.ref
                            }, _element.props))
                        ];
                        var _frame6 = {
                            type: null,
                            domNamespace: parentNamespace,
                            children: _nextChildren6,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame6.debugElementStack = [];
                        this.stack.push(_frame6);
                        return '';
                    case REACT_PROVIDER_TYPE:
                        var provider = nextChild;
                        var nextProps = provider.props;
                        var _nextChildren7 = toArray(nextProps.children);
                        var _frame7 = {
                            type: provider,
                            domNamespace: parentNamespace,
                            children: _nextChildren7,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame7.debugElementStack = [];
                        this.pushProvider(provider);
                        this.stack.push(_frame7);
                        return '';
                    case REACT_CONTEXT_TYPE:
                        var reactContext = nextChild.type; // The logic below for Context differs depending on PROD or DEV mode. In
                        if (reactContext._context === undefined) {
                            // This may be because it's a Context (rather than a Consumer).
                            // Or it may be because it's older React where they're the same thing.
                            // We only want to warn if we're sure it's a new React.
                            if (reactContext !== reactContext.Consumer) {
                                if (!hasWarnedAboutUsingContextAsConsumer) {
                                    hasWarnedAboutUsingContextAsConsumer = true;
                                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                                }
                            }
                        } else reactContext = reactContext._context;
                        var _nextProps = nextChild.props;
                        var threadID = this.threadID;
                        validateContextBounds(reactContext, threadID);
                        var nextValue = reactContext[threadID];
                        var _nextChildren8 = toArray(_nextProps.children(nextValue));
                        var _frame8 = {
                            type: nextChild,
                            domNamespace: parentNamespace,
                            children: _nextChildren8,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame8.debugElementStack = [];
                        this.stack.push(_frame8);
                        return '';
                    // eslint-disable-next-line-no-fallthrough
                    case REACT_FUNDAMENTAL_TYPE:
                        throw Error("ReactDOMServer does not yet support the fundamental API.");
                    // eslint-disable-next-line-no-fallthrough
                    case REACT_LAZY_TYPE:
                        var _element2 = nextChild;
                        var lazyComponent = nextChild.type; // Attempt to initialize lazy component regardless of whether the
                        // suspense server-side renderer is enabled so synchronously
                        // resolved constructors are supported.
                        var payload = lazyComponent._payload;
                        var init = lazyComponent._init;
                        var result = init(payload);
                        var _nextChildren10 = [
                            React.createElement(result, _assign({
                                ref: _element2.ref
                            }, _element2.props))
                        ];
                        var _frame10 = {
                            type: null,
                            domNamespace: parentNamespace,
                            children: _nextChildren10,
                            childIndex: 0,
                            context: context,
                            footer: ''
                        };
                        _frame10.debugElementStack = [];
                        this.stack.push(_frame10);
                        return '';
                }
                var info = '';
                var owner = nextElement._owner;
                if (elementType === undefined || typeof elementType === 'object' && elementType !== null && Object.keys(elementType).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentName(owner) : null;
                if (ownerName) info += '\n\nCheck the render method of `' + ownerName + '`.';
                throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (elementType == null ? elementType : typeof elementType) + "." + info);
            }
        };
        _proto.renderDOM = function renderDOM(element, context, parentNamespace) {
            var tag = element.type.toLowerCase();
            var namespace = parentNamespace;
            if (parentNamespace === Namespaces.html) namespace = getIntrinsicNamespace(tag);
            if (namespace === Namespaces.html) // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            {
                if (tag !== element.type) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", element.type);
            }
            validateDangerousTag(tag);
            var props = element.props;
            if (tag === 'input') {
                checkControlledValueProps('input', props);
                if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnDefaultChecked) {
                    error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", 'A component', props.type);
                    didWarnDefaultChecked = true;
                }
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultInputValue) {
                    error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", 'A component', props.type);
                    didWarnDefaultInputValue = true;
                }
                props = _assign({
                    type: undefined
                }, props, {
                    defaultChecked: undefined,
                    defaultValue: undefined,
                    value: props.value != null ? props.value : props.defaultValue,
                    checked: props.checked != null ? props.checked : props.defaultChecked
                });
            } else if (tag === 'textarea') {
                checkControlledValueProps('textarea', props);
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultTextareaValue) {
                    error("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components");
                    didWarnDefaultTextareaValue = true;
                }
                var initialValue = props.value;
                if (initialValue == null) {
                    var defaultValue = props.defaultValue; // TODO (yungsters): Remove support for children content in <textarea>.
                    var textareaChildren = props.children;
                    if (textareaChildren != null) {
                        error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                        if (!(defaultValue == null)) throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                        if (Array.isArray(textareaChildren)) {
                            if (!(textareaChildren.length <= 1)) throw Error("<textarea> can only have at most one child.");
                            textareaChildren = textareaChildren[0];
                        }
                        defaultValue = '' + textareaChildren;
                    }
                    if (defaultValue == null) defaultValue = '';
                    initialValue = defaultValue;
                }
                props = _assign({}, props, {
                    value: undefined,
                    children: '' + initialValue
                });
            } else if (tag === 'select') {
                checkControlledValueProps('select', props);
                for(var i = 0; i < valuePropNames.length; i++){
                    var propName = valuePropNames[i];
                    if (props[propName] == null) continue;
                    var isArray = Array.isArray(props[propName]);
                    if (props.multiple && !isArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.", propName);
                    else if (!props.multiple && isArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", propName);
                }
                if (props.value !== undefined && props.defaultValue !== undefined && !didWarnDefaultSelectValue) {
                    error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
                    didWarnDefaultSelectValue = true;
                }
                this.currentSelectValue = props.value != null ? props.value : props.defaultValue;
                props = _assign({}, props, {
                    value: undefined
                });
            } else if (tag === 'option') {
                var selected = null;
                var selectValue = this.currentSelectValue;
                var optionChildren = flattenOptionChildren(props.children);
                if (selectValue != null) {
                    var value;
                    if (props.value != null) value = props.value + '';
                    else value = optionChildren;
                    selected = false;
                    if (Array.isArray(selectValue)) {
                        // multiple
                        for(var j = 0; j < selectValue.length; j++)if ('' + selectValue[j] === value) {
                            selected = true;
                            break;
                        }
                    } else selected = '' + selectValue === value;
                    props = _assign({
                        selected: undefined,
                        children: undefined
                    }, props, {
                        selected: selected,
                        children: optionChildren
                    });
                }
            }
            validatePropertiesInDevelopment(tag, props);
            assertValidProps(tag, props);
            var out = createOpenTagMarkup(element.type, tag, props, namespace, this.makeStaticMarkup, this.stack.length === 1);
            var footer = '';
            if (omittedCloseTags.hasOwnProperty(tag)) out += '/>';
            else {
                out += '>';
                footer = '</' + element.type + '>';
            }
            var children;
            var innerMarkup = getNonChildrenInnerMarkup(props);
            if (innerMarkup != null) {
                children = [];
                if (newlineEatingTags.hasOwnProperty(tag) && innerMarkup.charAt(0) === '\n') // text/html ignores the first character in these tags if it's a newline
                // Prefer to break application/xml over text/html (for now) by adding
                // a newline specifically to get eaten by the parser. (Alternately for
                // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
                // \r is normalized out by HTMLTextAreaElement#value.)
                // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
                // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
                // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
                // See: Parsing of "textarea" "listing" and "pre" elements
                //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
                out += '\n';
                out += innerMarkup;
            } else children = toArray(props.children);
            var frame = {
                domNamespace: getChildNamespace(parentNamespace, element.type),
                type: tag,
                children: children,
                childIndex: 0,
                context: context,
                footer: footer
            };
            frame.debugElementStack = [];
            this.stack.push(frame);
            this.previousWasTextNode = false;
            return out;
        };
        return ReactDOMServerRenderer;
    }();
    /**
 * Render a ReactElement to its initial HTML. This should only be used on the
 * server.
 * See https://reactjs.org/docs/react-dom-server.html#rendertostring
 */ function renderToString(element, options) {
        var renderer = new ReactDOMServerRenderer(element, false, options);
        try {
            var markup = renderer.read(Infinity);
            return markup;
        } finally{
            renderer.destroy();
        }
    }
    /**
 * Similar to renderToString, except this doesn't create extra DOM attributes
 * such as data-react-id that React uses internally.
 * See https://reactjs.org/docs/react-dom-server.html#rendertostaticmarkup
 */ function renderToStaticMarkup(element, options) {
        var renderer = new ReactDOMServerRenderer(element, true, options);
        try {
            var markup = renderer.read(Infinity);
            return markup;
        } finally{
            renderer.destroy();
        }
    }
    function renderToNodeStream() {
        throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function renderToStaticNodeStream() {
        throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    $1afe62ba3a7403ae$export$307591e98609eddd = renderToNodeStream;
    $1afe62ba3a7403ae$export$eb3a06aef9e6ee51 = renderToStaticMarkup;
    $1afe62ba3a7403ae$export$b23711c915539651 = renderToStaticNodeStream;
    $1afe62ba3a7403ae$export$80e7718417253a51 = renderToString;
    $1afe62ba3a7403ae$export$83d89fbfd8236492 = ReactVersion;
})();

});

var $146fac884086ae27$exports = {};
$parcel$extendImportMap({
    "8WL3B": "esm.afa24070.js"
});

// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
var $994495db3cff0a67$export$317e7082611cb548 = /* #__PURE__ */ function() {
    function Step1() {}
    Step1.value = new Step1();
    return Step1;
}();
var $994495db3cff0a67$export$d02ce3ec9b5b8f12 = /* #__PURE__ */ function() {
    function Step2A() {}
    Step2A.value = new Step2A();
    return Step2A;
}();
var $994495db3cff0a67$export$d80ca78eabef93e4 = /* #__PURE__ */ function() {
    function Step2B() {}
    Step2B.value = new Step2B();
    return Step2B;
}();
var $994495db3cff0a67$export$d8ccc25b3be9c9d7 = /* #__PURE__ */ function() {
    function Step3() {}
    Step3.value = new Step3();
    return Step3;
}();
var $994495db3cff0a67$export$db36463848ed68bd = /* #__PURE__ */ function() {
    function Step3Doc(value0) {
        this.value0 = value0;
    }
    Step3Doc.create = function(value0) {
        return new Step3Doc(value0);
    };
    return Step3Doc;
}();
var $994495db3cff0a67$export$ebff56b4c8ba0e39 = /* #__PURE__ */ function() {
    function Step4() {}
    Step4.value = new Step4();
    return Step4;
}();
var $994495db3cff0a67$export$133773870222880f = /* #__PURE__ */ function() {
    function Preview(value0) {
        this.value0 = value0;
    }
    Preview.create = function(value0) {
        return new Preview(value0);
    };
    return Preview;
}();
var $994495db3cff0a67$export$e3f45034ca213b36 = /* #__PURE__ */ function() {
    function TestForm() {}
    TestForm.value = new TestForm();
    return TestForm;
}();
var $994495db3cff0a67$export$9807628a98dc6165 = /* #__PURE__ */ function() {
    function NavNext() {}
    NavNext.value = new NavNext();
    return NavNext;
}();
var $994495db3cff0a67$export$635e3e065a143ae6 = /* #__PURE__ */ function() {
    function NavCancel() {}
    NavCancel.value = new NavCancel();
    return NavCancel;
}();
var $994495db3cff0a67$export$d0b167d54f100778 = /* #__PURE__ */ function() {
    function NavJump(value0) {
        this.value0 = value0;
    }
    NavJump.create = function(value0) {
        return new NavJump(value0);
    };
    return NavJump;
}();


// Generated by purs version 0.15.16
"use strict";
const $77724a2c53318d12$var$buildTimeHrUrlPrefix = "forms-ps";
function $77724a2c53318d12$var$runtimePrefix() {
    if (typeof globalThis === "undefined") return undefined;
    if (typeof globalThis.HR_URL_PREFIX === "string") return globalThis.HR_URL_PREFIX;
    return globalThis.process?.env?.HR_URL_PREFIX;
}
const $77724a2c53318d12$export$25ab18eae308f101 = $77724a2c53318d12$var$runtimePrefix() ?? $77724a2c53318d12$var$buildTimeHrUrlPrefix ?? "";




// Generated by purs version 0.15.16
const $e001a8e6e4264547$export$4d853d3353098e5a = typeof Array.prototype.flatMap === "function" ? function(arr) {
    return function(f) {
        return arr.flatMap(f);
    };
} : function(arr) {
    return function(f) {
        var result = [];
        var l = arr.length;
        for(var i = 0; i < l; i++){
            var xs = f(arr[i]);
            var k = xs.length;
            for(var j = 0; j < k; j++)result.push(xs[j]);
        }
        return result;
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
const $0d4b25392f45f74c$export$4add775dfee37121 = function(fs) {
    return function(xs) {
        var l = fs.length;
        var k = xs.length;
        var result = new Array(l * k);
        var n = 0;
        for(var i = 0; i < l; i++){
            var f = fs[i];
            for(var j = 0; j < k; j++)result[n++] = f(xs[j]);
        }
        return result;
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
var $5807467a73465f3c$export$3af17640bddf7212 = {
    compose: function(f) {
        return function(g) {
            return function(x) {
                return f(g(x));
            };
        };
    }
};
var $5807467a73465f3c$export$f672e0b6f7222cd7 = function(dict) {
    return dict.compose;
};
var $5807467a73465f3c$export$b5a9558a7176e41b = function(dictSemigroupoid) {
    var compose1 = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return function(f) {
        return function(g) {
            return compose1(g)(f);
        };
    };
};


var $5be483788e0e6f04$export$f0954fd7d5368655 = function(dict) {
    return dict.identity;
};
var $5be483788e0e6f04$export$7037e3b2ba3bd7aa = {
    identity: function(x) {
        return x;
    },
    Semigroupoid0: function() {
        return $5807467a73465f3c$export$3af17640bddf7212;
    }
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16
var $5089f43af3d55e5d$export$4bed41887d8c5096 = true;


var $f57f4b701aa7b66e$export$af631764ddc44097 = function(f) {
    return function(g) {
        return function(x) {
            return function(y) {
                return f(g(x))(g(y));
            };
        };
    };
};
var $f57f4b701aa7b66e$export$8a83211c878a3f1f = function(f) {
    return function(b) {
        return function(a) {
            return f(a)(b);
        };
    };
};
var $f57f4b701aa7b66e$export$5b38a098e5a9e7ca = function(a) {
    return function(v) {
        return a;
    };
};
var $f57f4b701aa7b66e$export$32c25ff0a0410173 = function(f) {
    var go = function($copy_n) {
        return function($copy_acc) {
            var $tco_var_n = $copy_n;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(n, acc) {
                if (n <= 0) {
                    $tco_done = true;
                    return acc;
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $tco_var_n = n - 1 | 0;
                    $copy_acc = f(acc);
                    return;
                }
                throw new Error("Failed pattern match at Data.Function (line 107, column 3 - line 109, column 37): " + [
                    n.constructor.name,
                    acc.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_acc);
            return $tco_result;
        };
    };
    return go;
};
var $f57f4b701aa7b66e$export$5f9c390da86b6e49 = function(x) {
    return function(f) {
        return f(x);
    };
};
var $f57f4b701aa7b66e$export$5635d7ef4b8fee1c = function(f) {
    return function(x) {
        return f(x);
    };
};


// Generated by purs version 0.15.16
const $889a8f7c70c4a41c$export$dc30017ac4432edc = function(f) {
    return function(arr) {
        var l = arr.length;
        var result = new Array(l);
        for(var i = 0; i < l; i++)result[i] = f(arr[i]);
        return result;
    };
};




// Generated by purs version 0.15.16
const $05149ea687d6b460$export$523c0b569236b342 = undefined;




// Generated by purs version 0.15.16
var $c6a0478cbb9b5a21$export$accffb5fb4579e0d = /* #__PURE__ */ function() {
    function $$Proxy() {}
    $$Proxy.value = new $$Proxy();
    return $$Proxy;
}();


var $f4b2eb11fc32ed34$export$871de8747c9eaa88 = function(dict) {
    return dict.map;
};
var $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(fa) {
        return function(f) {
            return map1(f)(fa);
        };
    };
};
var $f4b2eb11fc32ed34$export$490e536ee7389aeb = function(dictFunctor) {
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
};
var $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(x) {
            return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x))(f);
        };
    };
};
var $f4b2eb11fc32ed34$export$b818c54ed8d3e90a = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(x) {
        return map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(x));
    };
};
var $f4b2eb11fc32ed34$export$816e5e05deb8955e = {
    map: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $f4b2eb11fc32ed34$export$11c8d16a3c15d11b = {
    map: /* #__PURE__ */ $5807467a73465f3c$export$f672e0b6f7222cd7($5807467a73465f3c$export$3af17640bddf7212)
};
var $f4b2eb11fc32ed34$export$2330f868b62ed546 = {
    map: $889a8f7c70c4a41c$export$dc30017ac4432edc
};
var $f4b2eb11fc32ed34$export$18c957606d8bdf09 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(ff) {
        return function(x) {
            return map1(function(f) {
                return f(x);
            })(ff);
        };
    };
};



var $7576d3a958d66ab0$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7576d3a958d66ab0$export$e24166bf2f1a6c73 = {
    apply: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$816e5e05deb8955e;
    }
};
var $7576d3a958d66ab0$export$2f68caa5c730775d = {
    apply: function(f) {
        return function(g) {
            return function(x) {
                return f(x)(g(x));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $7576d3a958d66ab0$export$60d7bd9d686a5521 = {
    apply: $0d4b25392f45f74c$export$4add775dfee37121,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $7576d3a958d66ab0$export$5635d7ef4b8fee1c = function(dict) {
    return dict.apply;
};
var $7576d3a958d66ab0$export$e48e2da4536c2eea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca)(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$3d5d566a030a20fc = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(a) {
        return function(b) {
            return apply1(map($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7576d3a958d66ab0$var$identity))(a))(b);
        };
    };
};
var $7576d3a958d66ab0$export$f016650e64b51e7d = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return apply1(map(f)(a))(b);
            };
        };
    };
};
var $7576d3a958d66ab0$export$30190e46300cc996 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return apply1(apply1(map(f)(a))(b))(c);
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6659660f0e855aea = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return apply1(apply1(apply1(map(f)(a))(b))(c))(d);
                    };
                };
            };
        };
    };
};
var $7576d3a958d66ab0$export$6c80f2f7f1ad8105 = function(dictApply) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return function(d) {
                        return function(e) {
                            return apply1(apply1(apply1(apply1(map(f)(a))(b))(c))(d))(e);
                        };
                    };
                };
            };
        };
    };
};





var $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557 = function(dict) {
    return dict.pure;
};
var $c50cfdb0b9e8fa31$export$6f0673371501d6b6 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (!v) return v1;
            if (v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 68, column 1 - line 68, column 65): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$a55877ca9db47377 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return pure1($05149ea687d6b460$export$523c0b569236b342);
            throw new Error("Failed pattern match at Control.Applicative (line 63, column 1 - line 63, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $c50cfdb0b9e8fa31$export$53544bd8de5a7427 = function(dictApplicative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApplicative.Apply0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return function(a) {
            return apply(pure1(f))(a);
        };
    };
};
var $c50cfdb0b9e8fa31$export$598532d07e20ffc2 = {
    pure: function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $c50cfdb0b9e8fa31$export$e68c32b2a06f106c = {
    pure: function(x) {
        return function(v) {
            return x;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e = {
    pure: function(x) {
        return [
            x
        ];
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};







var $70cd3177464e7915$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $70cd3177464e7915$export$584af591d945b55a = function(dict) {
    return dict.discard;
};
var $70cd3177464e7915$export$6dbdf4766af04452 = {
    bind: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$e24166bf2f1a6c73;
    }
};
var $70cd3177464e7915$export$2c348afe2becdb4f = {
    bind: function(m) {
        return function(f) {
            return function(x) {
                return f(m(x))(x);
            };
        };
    },
    Apply0: function() {
        return $7576d3a958d66ab0$export$2f68caa5c730775d;
    }
};
var $70cd3177464e7915$export$794f9574ca20b986 = {
    bind: $e001a8e6e4264547$export$4d853d3353098e5a,
    Apply0: function() {
        return $7576d3a958d66ab0$export$60d7bd9d686a5521;
    }
};
var $70cd3177464e7915$export$2385a24977818dd0 = function(dict) {
    return dict.bind;
};
var $70cd3177464e7915$export$f2077a1c19a006d9 = function(dictBind) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($70cd3177464e7915$export$2385a24977818dd0(dictBind));
};
var $70cd3177464e7915$export$ea9fbbe247ef8e50 = function(dictBind) {
    var bindFlipped1 = $70cd3177464e7915$export$f2077a1c19a006d9(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bindFlipped1(f)(g(a));
            };
        };
    };
};
var $70cd3177464e7915$export$61a2047e1b1e0d3e = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(f) {
        return function(g) {
            return function(a) {
                return bind1(f(a))(g);
            };
        };
    };
};
var $70cd3177464e7915$export$9a012077684d4c76 = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$f73711e565ded7e = {
    discard: function(dictBind) {
        return $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    }
};
var $70cd3177464e7915$export$2937bb6ffdfdda28 = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(cond) {
        return function(t) {
            return function(f) {
                return bind1(cond)(function(cond$prime) {
                    if (cond$prime) return t;
                    return f;
                });
            };
        };
    };
};
var $70cd3177464e7915$export$f7e2c8231c57a8bd = function(dictBind) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return function(m) {
        return bind1(m)($70cd3177464e7915$var$identity);
    };
};


// Generated by purs version 0.15.16
//------------------------------------------------------------------------------
// Array creation --------------------------------------------------------------
//------------------------------------------------------------------------------
const $fc8c1182ec2aefec$export$3561205b7dff20bf = function(start, end) {
    var step = start > end ? -1 : 1;
    var result = new Array(step * (end - start) + 1);
    var i = start, n = 0;
    while(i !== end){
        result[n++] = i;
        i += step;
    }
    result[n] = i;
    return result;
};
var $fc8c1182ec2aefec$var$replicateFill = function(count, value) {
    if (count < 1) return [];
    var result = new Array(count);
    return result.fill(value);
};
var $fc8c1182ec2aefec$var$replicatePolyfill = function(count, value) {
    var result = [];
    var n = 0;
    for(var i = 0; i < count; i++)result[n++] = value;
    return result;
};
const $fc8c1182ec2aefec$export$86a7d437bed76c03 = typeof Array.prototype.fill === "function" ? $fc8c1182ec2aefec$var$replicateFill : $fc8c1182ec2aefec$var$replicatePolyfill;
const $fc8c1182ec2aefec$export$7de5ece11b723a44 = function() {
    function Cons(head, tail) {
        this.head = head;
        this.tail = tail;
    }
    var emptyList = {};
    function curryCons(head) {
        return function(tail) {
            return new Cons(head, tail);
        };
    }
    function listToArray(list) {
        var result = [];
        var count = 0;
        var xs = list;
        while(xs !== emptyList){
            result[count++] = xs.head;
            xs = xs.tail;
        }
        return result;
    }
    return function(foldr, xs) {
        return listToArray(foldr(curryCons)(emptyList)(xs));
    };
}();
const $fc8c1182ec2aefec$export$f24224f1c91d8156 = function(xs) {
    return xs.length;
};
const $fc8c1182ec2aefec$export$99063656965a82f5 = function(empty, next, xs) {
    return xs.length === 0 ? empty({}) : next(xs[0])(xs.slice(1));
};
const $fc8c1182ec2aefec$export$fe8606c16d7ceed6 = function(just, nothing, xs, i) {
    return i < 0 || i >= xs.length ? nothing : just(xs[i]);
};
const $fc8c1182ec2aefec$export$7ad327e9a65b0147 = function(nothing, isJust, f, xs) {
    for(var i = 0; i < xs.length; i++){
        var result = f(xs[i]);
        if (isJust(result)) return result;
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$885b84ba169666c7 = function(just, nothing, f, xs) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$32bcb9f71841245e = function(just, nothing, f, xs) {
    for(var i = xs.length - 1; i >= 0; i--){
        if (f(xs[i])) return just(i);
    }
    return nothing;
};
const $fc8c1182ec2aefec$export$d553b0efc2008003 = function(just, nothing, i, a, l) {
    if (i < 0 || i > l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 0, a);
    return just(l1);
};
const $fc8c1182ec2aefec$export$e83371a4d1b4407c = function(just, nothing, i, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1.splice(i, 1);
    return just(l1);
};
const $fc8c1182ec2aefec$export$4bc13c05b5f586d5 = function(just, nothing, i, a, l) {
    if (i < 0 || i >= l.length) return nothing;
    var l1 = l.slice();
    l1[i] = a;
    return just(l1);
};
const $fc8c1182ec2aefec$export$66c1ae025e96b4bc = function(l) {
    return l.slice().reverse();
};
const $fc8c1182ec2aefec$export$ee1b3e54f0441b22 = function(xss) {
    if (xss.length <= 10000) // This method is faster, but it crashes on big arrays.
    // So we use it when can and fallback to simple variant otherwise.
    return Array.prototype.concat.apply([], xss);
    var result = [];
    for(var i = 0, l = xss.length; i < l; i++){
        var xs = xss[i];
        for(var j = 0, m = xs.length; j < m; j++)result.push(xs[j]);
    }
    return result;
};
const $fc8c1182ec2aefec$export$e85b5b674fbfff84 = function(f, xs) {
    return xs.filter(f);
};
const $fc8c1182ec2aefec$export$25718970d830661a = function(f, xs) {
    var yes = [];
    var no = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        if (f(x)) yes.push(x);
        else no.push(x);
    }
    return {
        yes: yes,
        no: no
    };
};
const $fc8c1182ec2aefec$export$53974fb866918d71 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = 0; i < len; i++){
        acc = f(acc)(xs[i]);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$771bbc3bb9be46c2 = function(f, b, xs) {
    var len = xs.length;
    var acc = b;
    var out = new Array(len);
    for(var i = len - 1; i >= 0; i--){
        acc = f(xs[i])(acc);
        out[i] = acc;
    }
    return out;
};
const $fc8c1182ec2aefec$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        var out;
        if (xs.length < 2) return xs;
        out = xs.slice(0);
        mergeFromTo(compare, fromOrdering, out, xs.slice(0), 0, xs.length);
        return out;
    };
}();
const $fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a = function(s, e, l) {
    return l.slice(s, e);
};
const $fc8c1182ec2aefec$export$67fd4cff6f1e6bc = function(f, xs, ys) {
    var l = xs.length < ys.length ? xs.length : ys.length;
    var result = new Array(l);
    for(var i = 0; i < l; i++)result[i] = f(xs[i])(ys[i]);
    return result;
};
const $fc8c1182ec2aefec$export$b98f41a67d1483f3 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (p(xs[i])) return true;
    }
    return false;
};
const $fc8c1182ec2aefec$export$739e1ef870df7d82 = function(p, xs) {
    var len = xs.length;
    for(var i = 0; i < len; i++){
        if (!p(xs[i])) return false;
    }
    return true;
};
const $fc8c1182ec2aefec$export$4459d383cf3fd31d = function(xs, n) {
    return xs[n];
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16
const $b693645c2c75f222$export$171e7edd26203a84 = function(s1) {
    return function(s2) {
        return s1 + s2;
    };
};
const $b693645c2c75f222$export$4fd8af2c48c43416 = function(xs) {
    return function(ys) {
        if (xs.length === 0) return ys;
        if (ys.length === 0) return xs;
        return xs.concat(ys);
    };
};


// Generated by purs version 0.15.16
// module Data.Symbol
const $bb08fe6cef393d6b$export$401372c57776dc = function(arg) {
    return arg;
};



var $1f7f00687c3959c5$export$340e995c37375b7a = function(s) {
    return function(f) {
        return $bb08fe6cef393d6b$export$401372c57776dc(function(dictIsSymbol) {
            return f(dictIsSymbol);
        })({
            reflectSymbol: function(v) {
                return s;
            }
        })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
    };
};
var $1f7f00687c3959c5$export$e5ed8a20a1c4d576 = function(dict) {
    return dict.reflectSymbol;
};



// Generated by purs version 0.15.16
var $58f3cdfbfe212d20$var$Void = function(x) {
    return x;
};
var $58f3cdfbfe212d20$export$f172309911142386 = function(a) {
    var spin = function($copy_v) {
        var $tco_result;
        function $tco_loop(v) {
            $copy_v = v;
            return;
        }
        while(true)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return spin(a);
};


// Generated by purs version 0.15.16
const $d2fadbdf02925823$export$12c1b2b255bc527d = function(label) {
    return function(rec) {
        return ({}).hasOwnProperty.call(rec, label);
    };
};
const $d2fadbdf02925823$export$1d94535d2cda4eda = function(label) {
    return function(rec) {
        return rec[label];
    };
};
const $d2fadbdf02925823$export$444262986932b766 = function(label) {
    return function(value) {
        return function(rec) {
            var copy = {};
            for(var key in rec)if (({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
            copy[label] = value;
            return copy;
        };
    };
};
const $d2fadbdf02925823$export$14b6a75b3eb38458 = function(label) {
    return function(rec) {
        var copy = {};
        for(var key in rec)if (key !== label && ({}).hasOwnProperty.call(rec, key)) copy[key] = rec[key];
        return copy;
    };
};





var $d7bf9817a417d4ae$export$36aabcd6b6e45f3b = {
    append: function(v) {
        return $58f3cdfbfe212d20$export$f172309911142386;
    }
};
var $d7bf9817a417d4ae$export$824c37c4afd77b1 = {
    append: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    }
};
var $d7bf9817a417d4ae$export$d9b7100b101f2c5b = {
    append: $b693645c2c75f222$export$171e7edd26203a84
};
var $d7bf9817a417d4ae$export$955753116dc9242c = {
    appendRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    }
};
var $d7bf9817a417d4ae$export$af5ddea0c4d23f3c = {
    append: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    }
};
var $d7bf9817a417d4ae$export$d082f07d0a8e9909 = {
    append: $b693645c2c75f222$export$4fd8af2c48c43416
};
var $d7bf9817a417d4ae$export$1e8e5e81637c934d = function(dict) {
    return dict.appendRecord;
};
var $d7bf9817a417d4ae$export$dbfe6b321632d7c9 = function() {
    return function(dictSemigroupRecord) {
        return {
            append: $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $d7bf9817a417d4ae$export$10d8903dec122b9d = function(dict) {
    return dict.append;
};
var $d7bf9817a417d4ae$export$49c9dc4575956c55 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(f) {
            return function(g) {
                return function(x) {
                    return append1(f(x))(g(x));
                };
            };
        }
    };
};
var $d7bf9817a417d4ae$export$74eae24c3d2a7535 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemigroupRecord) {
            var appendRecord1 = $d7bf9817a417d4ae$export$1e8e5e81637c934d(dictSemigroupRecord);
            return function(dictSemigroup) {
                var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
                return {
                    appendRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = appendRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(append1(get(ra))(get(rb)))(tail);
                            };
                        };
                    }
                };
            };
        };
    };
};


var $75e93a4111e80214$export$186d613bb872946c = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909),
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $75e93a4111e80214$export$228be17d80722ab = function(dict) {
    return dict.alt;
};






// Generated by purs version 0.15.16

var $a1e0a82f0b162743$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $a1e0a82f0b162743$export$15718d19459d1753 = {
    defer: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $a1e0a82f0b162743$export$5dc1db391e531241 = {
    defer: function(f) {
        return function(x) {
            return f($05149ea687d6b460$export$523c0b569236b342)(x);
        };
    }
};
var $a1e0a82f0b162743$export$260e5c0943f31606 = function(dict) {
    return dict.defer;
};
var $a1e0a82f0b162743$export$d838837eb5b184e3 = function(dictLazy) {
    var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(f) {
        var $lazy_go = $a1e0a82f0b162743$var$$runtime_lazy("go", "Control.Lazy", function() {
            return defer1(function(v) {
                return f($lazy_go(25));
            });
        });
        var go = $lazy_go(25);
        return go;
    };
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16




var $d3d065da31679be1$export$7e7b1df9f5185791 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var when = $c50cfdb0b9e8fa31$export$a55877ca9db47377(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return when(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$551dd5524146e426 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var unless = $c50cfdb0b9e8fa31$export$6f0673371501d6b6(dictMonad.Applicative0());
    return function(mb) {
        return function(m) {
            return bind(mb)(function(b) {
                return unless(b)(m);
            });
        };
    };
};
var $d3d065da31679be1$export$d34b9ad93b1f095a = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$598532d07e20ffc2;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$6dbdf4766af04452;
    }
};
var $d3d065da31679be1$export$513f938006a06509 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$e68c32b2a06f106c;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$2c348afe2becdb4f;
    }
};
var $d3d065da31679be1$export$68aea3a98a23c265 = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Bind1: function() {
        return $70cd3177464e7915$export$794f9574ca20b986;
    }
};
var $d3d065da31679be1$export$167848c32e61a4d4 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(a)(function(a$prime) {
                return pure(f(a$prime));
            });
        };
    };
};
var $d3d065da31679be1$export$2f6ca3d3b1f80bf5 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(a) {
            return bind(f)(function(f$prime) {
                return bind(a)(function(a$prime) {
                    return pure(f$prime(a$prime));
                });
            });
        };
    };
};


// Generated by purs version 0.15.16


// Generated by purs version 0.15.16
const $cd1cb347a48b7ff0$export$afdd678689eb299 = 2147483647;
const $cd1cb347a48b7ff0$export$4a17ba08fd82d88b = -2147483648;
const $cd1cb347a48b7ff0$export$4ffd3705721c8b5b = String.fromCharCode(65535);
const $cd1cb347a48b7ff0$export$d6be889e229abd84 = String.fromCharCode(0);
const $cd1cb347a48b7ff0$export$ef55dfccfe3a15b = Number.POSITIVE_INFINITY;
const $cd1cb347a48b7ff0$export$d1edf35dfee544b5 = Number.NEGATIVE_INFINITY;


// Generated by purs version 0.15.16
var $e07f6ef164bf0728$var$unsafeCompareImpl = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(x) {
                return function(y) {
                    return x < y ? lt : x === y ? eq : gt;
                };
            };
        };
    };
};
const $e07f6ef164bf0728$export$fcb09e9654c4896a = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$654933317498633e = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$a509696eaf723ed7 = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$bfcbb0304ffa620f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$5a20025607cdef3f = $e07f6ef164bf0728$var$unsafeCompareImpl;
const $e07f6ef164bf0728$export$6d083685ddc7682f = function(f) {
    return function(xs) {
        return function(ys) {
            var i = 0;
            var xlen = xs.length;
            var ylen = ys.length;
            while(i < xlen && i < ylen){
                var x = xs[i];
                var y = ys[i];
                var o = f(x)(y);
                if (o !== 0) return o;
                i++;
            }
            if (xlen === ylen) return 0;
            else if (xlen > ylen) return -1;
            else return 1;
        };
    };
};


// Generated by purs version 0.15.16
var $f4eec6a416d226bf$var$refEq = function(r1) {
    return function(r2) {
        return r1 === r2;
    };
};
const $f4eec6a416d226bf$export$373f9c52154d3177 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$123e3cb4a5e139f4 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$9fc9964c874ac58 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$b056fd0da0447ba9 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$bb9bce33bd088a97 = $f4eec6a416d226bf$var$refEq;
const $f4eec6a416d226bf$export$e89e5efeb0be06bc = function(f) {
    return function(xs) {
        return function(ys) {
            if (xs.length !== ys.length) return false;
            for(var i = 0; i < xs.length; i++){
                if (!f(xs[i])(ys[i])) return false;
            }
            return true;
        };
    };
};





var $37b880af5f4991bd$export$2965418ef5ae9704 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$671c8820f3b36bad = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$fa624555ca2acbc8 = {
    eq: $f4eec6a416d226bf$export$bb9bce33bd088a97
};
var $37b880af5f4991bd$export$d12253326f924cb1 = {
    eqRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $37b880af5f4991bd$export$14e60b8fdd01f41c = function(dict) {
    return dict.eqRecord;
};
var $37b880af5f4991bd$export$691c0e424728509e = function() {
    return function(dictEqRecord) {
        return {
            eq: $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $37b880af5f4991bd$export$db5a78c472a81a32 = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $37b880af5f4991bd$export$e24978670be1e4f3 = {
    eq: $f4eec6a416d226bf$export$9fc9964c874ac58
};
var $37b880af5f4991bd$export$e65788c6d4494539 = {
    eq: $f4eec6a416d226bf$export$123e3cb4a5e139f4
};
var $37b880af5f4991bd$export$bcd79f9321394c38 = {
    eq: $f4eec6a416d226bf$export$b056fd0da0447ba9
};
var $37b880af5f4991bd$export$d7927e8ffc1afb48 = {
    eq: $f4eec6a416d226bf$export$373f9c52154d3177
};
var $37b880af5f4991bd$export$96fd6c73d03c9dd2 = function(dict) {
    return dict.eq1;
};
var $37b880af5f4991bd$export$9663ddc1cf085b32 = function(dict) {
    return dict.eq;
};
var $37b880af5f4991bd$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$d7927e8ffc1afb48);
var $37b880af5f4991bd$export$159e06dc5ec60b00 = function(dictEq) {
    return {
        eq: $f4eec6a416d226bf$export$e89e5efeb0be06bc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq))
    };
};
var $37b880af5f4991bd$export$861eb926e0b8ea5b = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$159e06dc5ec60b00(dictEq));
    }
};
var $37b880af5f4991bd$export$730b16b2c839caa0 = function(dictEqRecord) {
    var eqRecord1 = $37b880af5f4991bd$export$14e60b8fdd01f41c(dictEqRecord);
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            return function(dictEq) {
                var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
                return {
                    eqRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = eqRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return eq3(get(ra))(get(rb)) && tail;
                            };
                        };
                    }
                };
            };
        };
    };
};
var $37b880af5f4991bd$export$5475dfc31a65c2cd = function(dictEq) {
    var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return function(y) {
            return $37b880af5f4991bd$var$eq2(eq3(x)(y))(false);
        };
    };
};
var $37b880af5f4991bd$export$d0aa07ff560ecb = function(dictEq1) {
    var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq12 = eq11(dictEq);
        return function(x) {
            return function(y) {
                return $37b880af5f4991bd$var$eq2(eq12(x)(y))(false);
            };
        };
    };
};


// Generated by purs version 0.15.16
var $5026be88823ef1f4$export$7158f0ceb70f54c7 = /* #__PURE__ */ function() {
    function LT() {}
    LT.value = new LT();
    return LT;
}();
var $5026be88823ef1f4$export$b023c82b48e70453 = /* #__PURE__ */ function() {
    function GT() {}
    GT.value = new GT();
    return GT;
}();
var $5026be88823ef1f4$export$1c0a5d05eb3f6e18 = /* #__PURE__ */ function() {
    function EQ() {}
    EQ.value = new EQ();
    return EQ;
}();
var $5026be88823ef1f4$export$c1dd7b0030d4618e = {
    show: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return "LT";
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return "GT";
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return "EQ";
        throw new Error("Failed pattern match at Data.Ordering (line 26, column 1 - line 29, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $5026be88823ef1f4$export$d04ea36c3e51a408 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return v1;
            throw new Error("Failed pattern match at Data.Ordering (line 21, column 1 - line 24, column 18): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $5026be88823ef1f4$export$6897c284b6f9f4dc = function(v) {
    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
    throw new Error("Failed pattern match at Data.Ordering (line 33, column 1 - line 33, column 31): " + [
        v.constructor.name
    ]);
};
var $5026be88823ef1f4$export$82d306ead3b703cd = {
    eq: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return true;
            return false;
        };
    }
};


// Generated by purs version 0.15.16
const $6997dff57b67dccd$export$8964faf538cd4472 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x - y | 0;
    };
};
const $6997dff57b67dccd$export$592dc8db1291fc5e = function(n1) {
    return function(n2) {
        return n1 - n2;
    };
};


// Generated by purs version 0.15.16
const $d134be8d1f9fbf5c$export$3493e4651621d0b = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x + y | 0;
    };
};
const $d134be8d1f9fbf5c$export$9961c9313a91a4c2 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x * y | 0;
    };
};
const $d134be8d1f9fbf5c$export$7851ca78a7fd68e5 = function(n1) {
    return function(n2) {
        return n1 + n2;
    };
};
const $d134be8d1f9fbf5c$export$3c84e2814d77f9f0 = function(n1) {
    return function(n2) {
        return n1 * n2;
    };
};






var $c0e822be92afc4df$export$2fbd183cf91e4d96 = function(dict) {
    return dict.zeroRecord;
};
var $c0e822be92afc4df$export$7f9972325ebfd559 = function(dict) {
    return dict.zero;
};
var $c0e822be92afc4df$export$348dab40c63d4f3e = {
    add: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    zero: $05149ea687d6b460$export$523c0b569236b342,
    mul: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    one: $05149ea687d6b460$export$523c0b569236b342
};
var $c0e822be92afc4df$export$5f825cdfc30c8d7a = {
    addRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    mulRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    oneRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    zeroRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $c0e822be92afc4df$export$28b7adff71d7e2f2 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        mul: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        one: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        zero: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $c0e822be92afc4df$export$f48694d6539477b9 = {
    add: $d134be8d1f9fbf5c$export$7851ca78a7fd68e5,
    zero: 0.0,
    mul: $d134be8d1f9fbf5c$export$3c84e2814d77f9f0,
    one: 1.0
};
var $c0e822be92afc4df$export$7e80d6910c05bd77 = {
    add: $d134be8d1f9fbf5c$export$3493e4651621d0b,
    zero: 0,
    mul: $d134be8d1f9fbf5c$export$9961c9313a91a4c2,
    one: 1
};
var $c0e822be92afc4df$export$e9e5a13b3096dd62 = function(dict) {
    return dict.oneRecord;
};
var $c0e822be92afc4df$export$80bf7733f1207381 = function(dict) {
    return dict.one;
};
var $c0e822be92afc4df$export$ff4422e298afd4cc = function(dict) {
    return dict.mulRecord;
};
var $c0e822be92afc4df$export$6e3a27864ab166fe = function(dict) {
    return dict.mul;
};
var $c0e822be92afc4df$export$ab0ab92b3cb31c66 = function(dict) {
    return dict.addRecord;
};
var $c0e822be92afc4df$export$93af3fe715165fc8 = function() {
    return function(dictSemiringRecord) {
        return {
            add: $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            mul: $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            one: $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            zero: $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $c0e822be92afc4df$export$e16d8520af44a096 = function(dict) {
    return dict.add;
};
var $c0e822be92afc4df$export$4946f164d066bdc5 = function(dictSemiring) {
    var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(f) {
            return function(g) {
                return function(x) {
                    return add1(f(x))(g(x));
                };
            };
        },
        zero: function(v) {
            return zero1;
        },
        mul: function(f) {
            return function(g) {
                return function(x) {
                    return mul1(f(x))(g(x));
                };
            };
        },
        one: function(v) {
            return one1;
        }
    };
};
var $c0e822be92afc4df$export$8d7f5ae13d42a4f9 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictSemiringRecord) {
            var addRecord1 = $c0e822be92afc4df$export$ab0ab92b3cb31c66(dictSemiringRecord);
            var mulRecord1 = $c0e822be92afc4df$export$ff4422e298afd4cc(dictSemiringRecord);
            var oneRecord1 = $c0e822be92afc4df$export$e9e5a13b3096dd62(dictSemiringRecord);
            var zeroRecord1 = $c0e822be92afc4df$export$2fbd183cf91e4d96(dictSemiringRecord);
            return function(dictSemiring) {
                var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
                var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
                var one1 = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
                var zero1 = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
                return {
                    addRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = addRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(add1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    mulRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = mulRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(mul1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    oneRecord: function(v) {
                        return function(v1) {
                            var tail = oneRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(one1)(tail);
                        };
                    },
                    zeroRecord: function(v) {
                        return function(v1) {
                            var tail = zeroRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(zero1)(tail);
                        };
                    }
                };
            };
        };
    };
};






var $d061555d3b2c84b2$var$semiringRecord = /* #__PURE__ */ $c0e822be92afc4df$export$93af3fe715165fc8();
var $d061555d3b2c84b2$export$11a6fe76b07a0 = function(dict) {
    return dict.subRecord;
};
var $d061555d3b2c84b2$export$f93b5905241a7cca = function(dict) {
    return dict.sub;
};
var $d061555d3b2c84b2$export$e2da189c845067f9 = {
    sub: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$348dab40c63d4f3e;
    }
};
var $d061555d3b2c84b2$export$38dc985ea1e564cd = {
    subRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    SemiringRecord0: function() {
        return $c0e822be92afc4df$export$5f825cdfc30c8d7a;
    }
};
var $d061555d3b2c84b2$export$857cf13a2f74264d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semiringRecordCons = $c0e822be92afc4df$export$8d7f5ae13d42a4f9(dictIsSymbol)();
    return function() {
        return function(dictRingRecord) {
            var subRecord1 = $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord);
            var semiringRecordCons1 = semiringRecordCons(dictRingRecord.SemiringRecord0());
            return function(dictRing) {
                var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
                var semiringRecordCons2 = semiringRecordCons1(dictRing.Semiring0());
                return {
                    subRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = subRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(sub1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    SemiringRecord0: function() {
                        return semiringRecordCons2;
                    }
                };
            };
        };
    };
};
var $d061555d3b2c84b2$export$492fe4fa507ea6ad = function() {
    return function(dictRingRecord) {
        var semiringRecord1 = $d061555d3b2c84b2$var$semiringRecord(dictRingRecord.SemiringRecord0());
        return {
            sub: $d061555d3b2c84b2$export$11a6fe76b07a0(dictRingRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semiring0: function() {
                return semiringRecord1;
            }
        };
    };
};
var $d061555d3b2c84b2$export$948aff48831eff14 = {
    sub: function(v) {
        return function(v1) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        };
    },
    Semiring0: function() {
        return $c0e822be92afc4df$export$28b7adff71d7e2f2;
    }
};
var $d061555d3b2c84b2$export$194f4464e73e7816 = {
    sub: $6997dff57b67dccd$export$592dc8db1291fc5e,
    Semiring0: function() {
        return $c0e822be92afc4df$export$f48694d6539477b9;
    }
};
var $d061555d3b2c84b2$export$d40e27c88e22a303 = {
    sub: $6997dff57b67dccd$export$8964faf538cd4472,
    Semiring0: function() {
        return $c0e822be92afc4df$export$7e80d6910c05bd77;
    }
};
var $d061555d3b2c84b2$export$9f43d8c61dde305d = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringFn = $c0e822be92afc4df$export$4946f164d066bdc5(dictRing.Semiring0());
    return {
        sub: function(f) {
            return function(g) {
                return function(x) {
                    return sub1(f(x))(g(x));
                };
            };
        },
        Semiring0: function() {
            return semiringFn;
        }
    };
};
var $d061555d3b2c84b2$export$aef51622e549b8b0 = function(dictRing) {
    var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
    return function(a) {
        return sub1(zero)(a);
    };
};






var $97937c29f879e68e$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $97937c29f879e68e$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $97937c29f879e68e$export$752cdd067643c910 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$2965418ef5ae9704;
    }
};
var $97937c29f879e68e$export$f6b429625e3530b0 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$671c8820f3b36bad;
    }
};
var $97937c29f879e68e$export$c5f2758e49b2b86a = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$bfcbb0304ffa620f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$fa624555ca2acbc8;
        }
    };
}();
var $97937c29f879e68e$export$927f7db8ecc0069f = {
    compareRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            };
        };
    },
    EqRecord0: function() {
        return $37b880af5f4991bd$export$d12253326f924cb1;
    }
};
var $97937c29f879e68e$export$55c25d215527e8e8 = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $37b880af5f4991bd$export$db5a78c472a81a32;
    }
};
var $97937c29f879e68e$export$dcb5533042a37f3c = {
    compare: function(v) {
        return function(v1) {
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18 && v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            throw new Error("Failed pattern match at Data.Ord (line 126, column 1 - line 133, column 20): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $5026be88823ef1f4$export$82d306ead3b703cd;
    }
};
var $97937c29f879e68e$export$5ed021ff2336715c = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$a509696eaf723ed7($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e24978670be1e4f3;
        }
    };
}();
var $97937c29f879e68e$export$ff461bf68e7dd332 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$654933317498633e($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$e65788c6d4494539;
        }
    };
}();
var $97937c29f879e68e$export$3abd12c96be3b09b = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$5a20025607cdef3f($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$bcd79f9321394c38;
        }
    };
}();
var $97937c29f879e68e$export$ef759d57a4e44836 = /* #__PURE__ */ function() {
    return {
        compare: $e07f6ef164bf0728$export$fcb09e9654c4896a($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value),
        Eq0: function() {
            return $37b880af5f4991bd$export$d7927e8ffc1afb48;
        }
    };
}();
var $97937c29f879e68e$export$f595b73424c1647a = function(dict) {
    return dict.compareRecord;
};
var $97937c29f879e68e$export$ebb7a7956d139174 = function() {
    return function(dictOrdRecord) {
        var eqRec1 = $97937c29f879e68e$var$eqRec(dictOrdRecord.EqRecord0());
        return {
            compare: $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Eq0: function() {
                return eqRec1;
            }
        };
    };
};
var $97937c29f879e68e$export$693feb0c3c484b70 = function(dict) {
    return dict.compare1;
};
var $97937c29f879e68e$export$398604a469f7de9a = function(dict) {
    return dict.compare;
};
var $97937c29f879e68e$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $97937c29f879e68e$export$e9509a298f6befc2 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(x) {
            return function(y) {
                return compare3(f(x))(f(y));
            };
        };
    };
};
var $97937c29f879e68e$export$f517ea36c68d4644 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$4be320a4fd1ac499 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$9b050841a3a1b328 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return true;
            return false;
        };
    };
};
var $97937c29f879e68e$export$23e3e2011c250f0f = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(dictRing) {
        var Semiring0 = dictRing.Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(Semiring0);
        return function(x) {
            var $89 = lessThan1(x)(zero);
            if ($89) return negate1(one);
            var $90 = greaterThan1(x)(zero);
            if ($90) return one;
            return x;
        };
    };
};
var $97937c29f879e68e$export$f0c1dc893917aeba = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(a1) {
        return function(a2) {
            var v = compare3(a1)(a2);
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return false;
            return true;
        };
    };
};
var $97937c29f879e68e$export$8960430cfd85939f = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return y;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return x;
            throw new Error("Failed pattern match at Data.Ord (line 181, column 3 - line 184, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$96ec731ed4dcb222 = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(x) {
        return function(y) {
            var v = compare3(x)(y);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return x;
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return x;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return y;
            throw new Error("Failed pattern match at Data.Ord (line 172, column 3 - line 175, column 12): " + [
                v.constructor.name
            ]);
        };
    };
};
var $97937c29f879e68e$export$6ace7ea8ac01a75e = function(dictOrd) {
    var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqArray = $37b880af5f4991bd$export$159e06dc5ec60b00(dictOrd.Eq0());
    return {
        compare: function() {
            var toDelta = function(x) {
                return function(y) {
                    var v = compare3(x)(y);
                    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 1;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return -1;
                    throw new Error("Failed pattern match at Data.Ord (line 79, column 7 - line 82, column 17): " + [
                        v.constructor.name
                    ]);
                };
            };
            return function(xs) {
                return function(ys) {
                    return $97937c29f879e68e$var$compare2(0)($e07f6ef164bf0728$export$6d083685ddc7682f(toDelta)(xs)(ys));
                };
            };
        }(),
        Eq0: function() {
            return eqArray;
        }
    };
};
var $97937c29f879e68e$export$8e34cc59438cf1bf = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd));
    },
    Eq10: function() {
        return $37b880af5f4991bd$export$861eb926e0b8ea5b;
    }
};
var $97937c29f879e68e$export$a9b387b18fb85611 = function(dictOrdRecord) {
    var compareRecord1 = $97937c29f879e68e$export$f595b73424c1647a(dictOrdRecord);
    var eqRowCons = $37b880af5f4991bd$export$730b16b2c839caa0(dictOrdRecord.EqRecord0())();
    return function() {
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var eqRowCons1 = eqRowCons(dictIsSymbol);
            return function(dictOrd) {
                var compare3 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
                var eqRowCons2 = eqRowCons1(dictOrd.Eq0());
                return {
                    compareRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var left = compare3($d2fadbdf02925823$export$1d94535d2cda4eda(key)(ra))($d2fadbdf02925823$export$1d94535d2cda4eda(key)(rb));
                                var $95 = $97937c29f879e68e$var$notEq(left)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
                                if ($95) return left;
                                return compareRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                            };
                        };
                    },
                    EqRecord0: function() {
                        return eqRowCons2;
                    }
                };
            };
        };
    };
};
var $97937c29f879e68e$export$7d15b64cf5a3a4c4 = function(dictOrd) {
    var min1 = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    var max1 = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                return min1(hi)(max1(low)(x));
            };
        };
    };
};
var $97937c29f879e68e$export$cf95c51b03f10bae = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    return function(low) {
        return function(hi) {
            return function(x) {
                if (lessThan1(x)(low)) return false;
                if (greaterThan1(x)(hi)) return false;
                return true;
            };
        };
    };
};
var $97937c29f879e68e$export$2335f513bbd82c6d = function(dictOrd) {
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(dictOrd);
    return function(dictRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictRing.Semiring0());
        var negate1 = $d061555d3b2c84b2$export$aef51622e549b8b0(dictRing);
        return function(x) {
            var $99 = greaterThanOrEq1(x)(zero);
            if ($99) return x;
            return negate1(x);
        };
    };
};







var $69d0e3dbb12088d2$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174();
var $69d0e3dbb12088d2$export$407dd25a598bb432 = function(dict) {
    return dict.topRecord;
};
var $69d0e3dbb12088d2$export$1e95b668f3b82d = function(dict) {
    return dict.top;
};
var $69d0e3dbb12088d2$export$48259b86288d7b58 = {
    top: $05149ea687d6b460$export$523c0b569236b342,
    bottom: $05149ea687d6b460$export$523c0b569236b342,
    Ord0: function() {
        return $97937c29f879e68e$export$f6b429625e3530b0;
    }
};
var $69d0e3dbb12088d2$export$8978fddf7d98bede = {
    topRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    bottomRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    OrdRecord0: function() {
        return $97937c29f879e68e$export$927f7db8ecc0069f;
    }
};
var $69d0e3dbb12088d2$export$6001ef8e188ae2f5 = /* #__PURE__ */ function() {
    return {
        bottom: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        top: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        Ord0: function() {
            return $97937c29f879e68e$export$55c25d215527e8e8;
        }
    };
}();
var $69d0e3dbb12088d2$export$2e0fd44408d4861 = /* #__PURE__ */ function() {
    return {
        top: $5026be88823ef1f4$export$b023c82b48e70453.value,
        bottom: $5026be88823ef1f4$export$7158f0ceb70f54c7.value,
        Ord0: function() {
            return $97937c29f879e68e$export$dcb5533042a37f3c;
        }
    };
}();
var $69d0e3dbb12088d2$export$5acaecf0b0cd5fa9 = {
    top: $cd1cb347a48b7ff0$export$ef55dfccfe3a15b,
    bottom: $cd1cb347a48b7ff0$export$d1edf35dfee544b5,
    Ord0: function() {
        return $97937c29f879e68e$export$5ed021ff2336715c;
    }
};
var $69d0e3dbb12088d2$export$c84fa7e5ca2385dd = {
    top: $cd1cb347a48b7ff0$export$afdd678689eb299,
    bottom: $cd1cb347a48b7ff0$export$4a17ba08fd82d88b,
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79 = {
    top: $cd1cb347a48b7ff0$export$4ffd3705721c8b5b,
    bottom: $cd1cb347a48b7ff0$export$d6be889e229abd84,
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $69d0e3dbb12088d2$export$b6c012947af8ebbc = {
    top: true,
    bottom: false,
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $69d0e3dbb12088d2$export$72232990c70f5e82 = function(dict) {
    return dict.bottomRecord;
};
var $69d0e3dbb12088d2$export$8d7db335b27db939 = function() {
    return function(dictBoundedRecord) {
        var ordRecord1 = $69d0e3dbb12088d2$var$ordRecord(dictBoundedRecord.OrdRecord0());
        return {
            top: $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            bottom: $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Ord0: function() {
                return ordRecord1;
            }
        };
    };
};
var $69d0e3dbb12088d2$export$40e543e69a8b3fbb = function(dict) {
    return dict.bottom;
};
var $69d0e3dbb12088d2$export$53fc630a84ecc59b = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictBounded) {
        var top1 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom1 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        var Ord0 = dictBounded.Ord0();
        return function() {
            return function() {
                return function(dictBoundedRecord) {
                    var topRecord1 = $69d0e3dbb12088d2$export$407dd25a598bb432(dictBoundedRecord);
                    var bottomRecord1 = $69d0e3dbb12088d2$export$72232990c70f5e82(dictBoundedRecord);
                    var ordRecordCons = $97937c29f879e68e$export$a9b387b18fb85611(dictBoundedRecord.OrdRecord0())()(dictIsSymbol)(Ord0);
                    return {
                        topRecord: function(v) {
                            return function(rowProxy) {
                                var tail = topRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(top1)(tail);
                            };
                        },
                        bottomRecord: function(v) {
                            return function(rowProxy) {
                                var tail = bottomRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rowProxy);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                return insert(bottom1)(tail);
                            };
                        },
                        OrdRecord0: function() {
                            return ordRecordCons;
                        }
                    };
                };
            };
        };
    };
};





// Generated by purs version 0.15.16

var $3d82dffba933b011$export$e8c9127d2f50172d = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$8824a2bea4c1012c = {
    imap: function(ab) {
        return function(ba) {
            return function(v) {
                return function($42) {
                    return ab(v(ba($42)));
                };
            };
        };
    }
};
var $3d82dffba933b011$export$1c6d49d5878078c3 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$ef56ebe0e8112a3f = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$562bca5a8a46bf61 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$bf44d3d4196f3d53 = {
    imap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};
var $3d82dffba933b011$export$eb38b1c8c5f72ca8 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map(f);
        };
    };
};
var $3d82dffba933b011$export$c469d4e9c6f65eae = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$2330f868b62ed546)
};
var $3d82dffba933b011$export$993789ec90a91854 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($f4b2eb11fc32ed34$export$11c8d16a3c15d11b)
};
var $3d82dffba933b011$export$b2517b0ab3a58435 = function(dict) {
    return dict.imap;
};
var $3d82dffba933b011$export$6e542772b026aecb = function(dictInvariant) {
    var imap1 = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    return imap1(f)(g)(v);
                };
            };
        }
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
const $41dd51408824a8aa$export$c7cd64a71178c531 = function(n) {
    return n.toString();
};
const $41dd51408824a8aa$export$e43176eac712254a = function(n) {
    var str = n.toString();
    return isNaN(str + ".0") ? str : str + ".0";
};
const $41dd51408824a8aa$export$91f9c7a21f1f86c8 = function(c) {
    var code = c.charCodeAt(0);
    if (code < 0x20 || code === 0x7F) {
        switch(c){
            case "\x07":
                return "'\\a'";
            case "\b":
                return "'\\b'";
            case "\f":
                return "'\\f'";
            case "\n":
                return "'\\n'";
            case "\r":
                return "'\\r'";
            case "\t":
                return "'\\t'";
            case "\v":
                return "'\\v'";
        }
        return "'\\" + code.toString(10) + "'";
    }
    return c === "'" || c === "\\" ? "'\\" + c + "'" : "'" + c + "'";
};
const $41dd51408824a8aa$export$336c8e5b2153cec7 = function(s) {
    var l = s.length;
    return "\"" + s.replace(/[\0-\x1F\x7F"\\]/g, function(c, i) {
        switch(c){
            case "\"":
            case "\\":
                return "\\" + c;
            case "\x07":
                return "\\a";
            case "\b":
                return "\\b";
            case "\f":
                return "\\f";
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case "\t":
                return "\\t";
            case "\v":
                return "\\v";
        }
        var k = i + 1;
        var empty = k < l && s[k] >= "0" && s[k] <= "9" ? "\\&" : "";
        return "\\" + c.charCodeAt(0).toString(10) + empty;
    }) + "\"";
};
const $41dd51408824a8aa$export$a23154580f12ac67 = function(f) {
    return function(xs) {
        var ss = [];
        for(var i = 0, l = xs.length; i < l; i++)ss[i] = f(xs[i]);
        return "[" + ss.join(",") + "]";
    };
};






var $2c6b3d51d10471a7$export$2052789f27d4993d = {
    show: $58f3cdfbfe212d20$export$f172309911142386
};
var $2c6b3d51d10471a7$export$5a8c7efb782a6055 = {
    show: function(v) {
        return "unit";
    }
};
var $2c6b3d51d10471a7$export$e4b6cd05df3043f6 = {
    show: $41dd51408824a8aa$export$336c8e5b2153cec7
};
var $2c6b3d51d10471a7$export$a673323aec880979 = {
    showRecordFields: function(v) {
        return function(v1) {
            return "";
        };
    }
};
var $2c6b3d51d10471a7$export$2633f2b0f857f544 = function(dict) {
    return dict.showRecordFields;
};
var $2c6b3d51d10471a7$export$28b0be767d2bc2c2 = function() {
    return function() {
        return function(dictShowRecordFields) {
            var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
            return {
                show: function(record) {
                    return "{" + (showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record) + "}");
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$3805d09d172f9aca = {
    show: function(v) {
        return "Proxy";
    }
};
var $2c6b3d51d10471a7$export$e5aa470f8f97c3fe = {
    show: $41dd51408824a8aa$export$e43176eac712254a
};
var $2c6b3d51d10471a7$export$3d7cf516d27998a0 = {
    show: $41dd51408824a8aa$export$c7cd64a71178c531
};
var $2c6b3d51d10471a7$export$def6059c21714f2a = {
    show: $41dd51408824a8aa$export$91f9c7a21f1f86c8
};
var $2c6b3d51d10471a7$export$ad55f318773e3cd5 = {
    show: function(v) {
        if (v) return "true";
        if (!v) return "false";
        throw new Error("Failed pattern match at Data.Show (line 29, column 1 - line 31, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $2c6b3d51d10471a7$export$57bf213be019eeb0 = function(dict) {
    return dict.show;
};
var $2c6b3d51d10471a7$export$5bda33a3389a7225 = function(dictShow) {
    return {
        show: $41dd51408824a8aa$export$a23154580f12ac67($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow))
    };
};
var $2c6b3d51d10471a7$export$70f8f8693d114c9d = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShowRecordFields) {
        var showRecordFields1 = $2c6b3d51d10471a7$export$2633f2b0f857f544(dictShowRecordFields);
        return function(dictShow) {
            var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
            return {
                showRecordFields: function(v) {
                    return function(record) {
                        var tail = showRecordFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(record);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                        return " " + (key + (": " + (show1(focus) + ("," + tail))));
                    };
                }
            };
        };
    };
};
var $2c6b3d51d10471a7$export$d57593979a3bd7f3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            showRecordFields: function(v) {
                return function(record) {
                    var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var focus = $d2fadbdf02925823$export$1d94535d2cda4eda(key)(record);
                    return " " + (key + (": " + (show1(focus) + " ")));
                };
            }
        };
    };
};




var $91c996e9c07e3b3f$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $91c996e9c07e3b3f$export$dd5fad028b7772cd = /* #__PURE__ */ function() {
    function Inl(value0) {
        this.value0 = value0;
    }
    Inl.create = function(value0) {
        return new Inl(value0);
    };
    return Inl;
}();
var $91c996e9c07e3b3f$export$df71ca4577dbdff6 = /* #__PURE__ */ function() {
    function Inr(value0) {
        this.value0 = value0;
    }
    Inr.create = function(value0) {
        return new Inr(value0);
    };
    return Inr;
}();
var $91c996e9c07e3b3f$export$264ad599d7cef668 = /* #__PURE__ */ function() {
    function Product(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Product.create = function(value0) {
        return function(value1) {
            return new Product(value0, value1);
        };
    };
    return Product;
}();
var $91c996e9c07e3b3f$var$NoConstructors = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$928c7f2d618c070b = /* #__PURE__ */ function() {
    function NoArguments() {}
    NoArguments.value = new NoArguments();
    return NoArguments;
}();
var $91c996e9c07e3b3f$export$8bfc33963ccbb2a = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$84637ea037d2e218 = function(x) {
    return x;
};
var $91c996e9c07e3b3f$export$2c618a4308a30424 = function(dict) {
    return dict.to;
};
var $91c996e9c07e3b3f$export$a76fa7ac9b018069 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return "(Inl " + (show1(v.value0) + ")");
                if (v instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return "(Inr " + (show2(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Generic.Rep (line 32, column 1 - line 34, column 42): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $91c996e9c07e3b3f$export$821c121fea76e4f5 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Product " + (show1(v.value0) + (" " + (show2(v.value1) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$1275f813f7f7622c = {
    show: function(v) {
        return "NoArguments";
    }
};
var $91c996e9c07e3b3f$export$4133b31869b937df = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            show: function(v) {
                return "(Constructor @" + ($91c996e9c07e3b3f$var$show(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)) + (" " + (show1(v) + ")")));
            }
        };
    };
};
var $91c996e9c07e3b3f$export$b1716375e6f06e2d = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Argument " + (show1(v) + ")");
        }
    };
};
var $91c996e9c07e3b3f$export$3d0c2c94453de4b8 = function(dictGeneric) {
    return function(v) {
        return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
    };
};
var $91c996e9c07e3b3f$export$6788812c4e6611e6 = function(dict) {
    return dict.from;
};


// Generated by purs version 0.15.16
















var $06733ae99ed4f534$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $06733ae99ed4f534$export$bebe9059409a0d04 = /* #__PURE__ */ function() {
    function Nothing() {}
    Nothing.value = new Nothing();
    return Nothing;
}();
var $06733ae99ed4f534$export$8a67b48435b5d073 = /* #__PURE__ */ function() {
    function Just(value0) {
        this.value0 = value0;
    }
    Just.create = function(value0) {
        return new Just(value0);
    };
    return Just;
}();
var $06733ae99ed4f534$export$9b814e760fdd264a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "(Just " + (show(v.value0) + ")");
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Nothing";
            throw new Error("Failed pattern match at Data.Maybe (line 223, column 1 - line 225, column 28): " + [
                v.constructor.name
            ]);
        }
    };
};
var $06733ae99ed4f534$export$fb85b8a3a6158141 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(append1(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 182, column 1 - line 185, column 43): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        }
    };
};
var $06733ae99ed4f534$export$516e28dec6a4b6d4 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(a) {
            return alt(map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(a))(pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
        };
    };
};
var $06733ae99ed4f534$export$89fc9eb1adf8ed28 = function(dictSemigroup) {
    var semigroupMaybe1 = $06733ae99ed4f534$export$fb85b8a3a6158141(dictSemigroup);
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return semigroupMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$76f250758a65e763 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v($05149ea687d6b460$export$523c0b569236b342);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 250, column 1 - line 250, column 62): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$f8b8b9ce72e9ccbf = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Maybe (line 237, column 1 - line 237, column 51): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $06733ae99ed4f534$export$4967676db1b89293 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(true)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $06733ae99ed4f534$export$c15bd07a493e1236 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $06733ae99ed4f534$export$a1265319b56c5090 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $06733ae99ed4f534$export$8a67b48435b5d073(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value);
        if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Maybe (line 227, column 1 - line 227, column 52): " + [
            x.constructor.name
        ]);
    }
};
var $06733ae99ed4f534$export$fdd2427f0e60fd66 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1.value0));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    }
};
var $06733ae99ed4f534$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $06733ae99ed4f534$export$62eda6ff839a0571 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($06733ae99ed4f534$export$fdd2427f0e60fd66)
};
var $06733ae99ed4f534$export$770f48d991b0f2a2 = function(a) {
    return $06733ae99ed4f534$export$76f250758a65e763(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$43db023a260c5e9f = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a)($06733ae99ed4f534$var$identity);
};
var $06733ae99ed4f534$export$2506262575dd10a7 = function() {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
        throw new Error("Failed pattern match at Data.Maybe (line 288, column 1 - line 288, column 46): " + [
            v.constructor.name
        ]);
    };
};
var $06733ae99ed4f534$export$cb6d304dbd10aa95 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v(v1));
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$8f45bb76abf9699e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return true;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq(x.value0)(y.value0);
                return false;
            };
        }
    };
};
var $06733ae99ed4f534$export$e35c29f98d259c46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMaybe1 = $06733ae99ed4f534$export$8f45bb76abf9699e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                if (x instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (y instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                if (x instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && y instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return compare(x.value0)(y.value0);
                throw new Error("Failed pattern match at Data.Maybe (line 0, column 0 - line 0, column 0): " + [
                    x.constructor.name,
                    y.constructor.name
                ]);
            };
        },
        Eq0: function() {
            return eqMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$b59095d05faa8cf6 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq));
    }
};
var $06733ae99ed4f534$export$c82772423d5de0b = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd));
    },
    Eq10: function() {
        return $06733ae99ed4f534$export$b59095d05faa8cf6;
    }
};
var $06733ae99ed4f534$export$158982e65b249847 = function(dictBounded) {
    var ordMaybe1 = $06733ae99ed4f534$export$e35c29f98d259c46(dictBounded.Ord0());
    return {
        top: new $06733ae99ed4f534$export$8a67b48435b5d073($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded)),
        bottom: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Ord0: function() {
            return ordMaybe1;
        }
    };
};
var $06733ae99ed4f534$export$22d9917da16590e7 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$var$map(v.value0)(v1);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 67, column 1 - line 69, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $06733ae99ed4f534$export$e5fea5661dee377 = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Maybe (line 125, column 1 - line 127, column 28): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $06733ae99ed4f534$export$22d9917da16590e7;
    }
};
var $06733ae99ed4f534$export$9e0396ae96a86801 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        zero: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        one: new $06733ae99ed4f534$export$8a67b48435b5d073($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring)),
        add: function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(add(v.value0)(v1.value0));
                throw new Error("Failed pattern match at Data.Maybe (line 190, column 1 - line 198, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        mul: function(x) {
            return function(y) {
                return $06733ae99ed4f534$var$apply($06733ae99ed4f534$var$map(mul)(x))(y);
            };
        }
    };
};
var $06733ae99ed4f534$export$b203ef4465f15037 = /* #__PURE__ */ function() {
    return {
        pure: $06733ae99ed4f534$export$8a67b48435b5d073.create,
        Apply0: function() {
            return $06733ae99ed4f534$export$22d9917da16590e7;
        }
    };
}();
var $06733ae99ed4f534$export$f78a1c2d38efcc13 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Bind1: function() {
        return $06733ae99ed4f534$export$e5fea5661dee377;
    }
};
var $06733ae99ed4f534$export$a22c94fdeac581ff = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $06733ae99ed4f534$export$164e6bcbae9cfdd0 = /* #__PURE__ */ function() {
    return {
        empty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Alt0: function() {
            return $06733ae99ed4f534$export$a22c94fdeac581ff;
        }
    };
}();
var $06733ae99ed4f534$export$92d23d3d8fa78a80 = {
    Applicative0: function() {
        return $06733ae99ed4f534$export$b203ef4465f15037;
    },
    Plus1: function() {
        return $06733ae99ed4f534$export$164e6bcbae9cfdd0;
    }
};







var $7d4cccdf062a2261$export$37c4d04eafdc5515 = /* #__PURE__ */ function() {
    function Left(value0) {
        this.value0 = value0;
    }
    Left.create = function(value0) {
        return new Left(value0);
    };
    return Left;
}();
var $7d4cccdf062a2261$export$19db0165690c701a = /* #__PURE__ */ function() {
    function Right(value0) {
        this.value0 = value0;
    }
    Right.create = function(value0) {
        return new Right(value0);
    };
    return Right;
}();
var $7d4cccdf062a2261$export$37ab35e89b41eda = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(Left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(Right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Either (line 173, column 1 - line 175, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $7d4cccdf062a2261$export$e29cdc8bc2cafc59 = function(f) {
    return $06733ae99ed4f534$export$76f250758a65e763(function($138) {
        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(f($138));
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$a92e4c44d367d0af = function(a) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a))($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $7d4cccdf062a2261$export$72a1c23d752d2155 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return new $7d4cccdf062a2261$export$19db0165690c701a(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(x.value0);
        throw new Error("Failed pattern match at Data.Either (line 33, column 1 - line 33, column 56): " + [
            x.constructor.name
        ]);
    }
};
var $7d4cccdf062a2261$export$f0a413d3d6075601 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(m.value0);
            if (m instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(f(m.value0));
            throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $7d4cccdf062a2261$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $7d4cccdf062a2261$export$26473b852950cc9f = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($7d4cccdf062a2261$export$f0a413d3d6075601)
};
var $7d4cccdf062a2261$export$f41f6e6ed5e42617 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$27d3ca2b5d864fdd = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$a6bf632a63e8a255 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $7d4cccdf062a2261$export$ed20f362be8f8b52 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1.value0;
        return v;
    };
};
var $7d4cccdf062a2261$export$d6a44bcd37031227 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            return new $7d4cccdf062a2261$export$19db0165690c701a(v(v1));
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$export$bde8fea66b0f9f9a = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq1(x.value0)(y.value0);
                    return false;
                };
            }
        };
    };
};
var $7d4cccdf062a2261$export$f105364bfbaa033b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqEither2 = eqEither1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare(x.value0)(y.value0);
                    if (x instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (y instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    if (x instanceof $7d4cccdf062a2261$export$19db0165690c701a && y instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare1(x.value0)(y.value0);
                    throw new Error("Failed pattern match at Data.Either (line 0, column 0 - line 0, column 0): " + [
                        x.constructor.name,
                        y.constructor.name
                    ]);
                };
            },
            Eq0: function() {
                return eqEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$551ea40f4c230981 = function(dictEq) {
    var eqEither1 = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqEither1(dictEq1));
        }
    };
};
var $7d4cccdf062a2261$export$f4a01dc57c45522b = function(dictOrd) {
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictOrd);
    var eq1Either1 = $7d4cccdf062a2261$export$551ea40f4c230981(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordEither1(dictOrd1));
        },
        Eq10: function() {
            return eq1Either1;
        }
    };
};
var $7d4cccdf062a2261$export$5f5be1bb6cd1fded = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Either (line 208, column 1 - line 208, column 64): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7d4cccdf062a2261$export$3a6c138b8d0f3874 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $7d4cccdf062a2261$export$d649b6842e09f2b = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false));
var $7d4cccdf062a2261$export$a9d71693f0c1a85d = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false))(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $7d4cccdf062a2261$export$7877a478dd30fd3d = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(a) {
        return function(b) {
            return alt(map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(a))(map1($7d4cccdf062a2261$export$19db0165690c701a.create)(b));
        };
    };
};
var $7d4cccdf062a2261$export$39ea3c8fac814734 = function(dictBounded) {
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordEither1 = $7d4cccdf062a2261$export$f105364bfbaa033b(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordEither2 = ordEither1(dictBounded1.Ord0());
        return {
            top: new $7d4cccdf062a2261$export$19db0165690c701a($69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $7d4cccdf062a2261$export$37c4d04eafdc5515(bottom),
            Ord0: function() {
                return ordEither2;
            }
        };
    };
};
var $7d4cccdf062a2261$export$521d8864384143c6 = /* #__PURE__ */ function() {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($06733ae99ed4f534$export$8a67b48435b5d073.create)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value));
}();
var $7d4cccdf062a2261$export$d5df7cb019d08f04 = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7d4cccdf062a2261$var$map(v.value0)(v1);
            throw new Error("Failed pattern match at Data.Either (line 70, column 1 - line 72, column 30): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $7d4cccdf062a2261$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $7d4cccdf062a2261$export$3806e10d0c441ac5 = {
    bind: /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(e) {
        return function(v) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(e);
        };
    })(function(a) {
        return function(f) {
            return f(a);
        };
    }),
    Apply0: function() {
        return $7d4cccdf062a2261$export$d5df7cb019d08f04;
    }
};
var $7d4cccdf062a2261$export$56cf4be43732c31d = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(x) {
            return function(y) {
                return $7d4cccdf062a2261$var$apply($7d4cccdf062a2261$var$map(append1)(x))(y);
            };
        }
    };
};
var $7d4cccdf062a2261$export$400f1ef3f3ec304d = /* #__PURE__ */ function() {
    return {
        pure: $7d4cccdf062a2261$export$19db0165690c701a.create,
        Apply0: function() {
            return $7d4cccdf062a2261$export$d5df7cb019d08f04;
        }
    };
}();
var $7d4cccdf062a2261$export$b3b4ecb28e3a8df3 = {
    Applicative0: function() {
        return $7d4cccdf062a2261$export$400f1ef3f3ec304d;
    },
    Bind1: function() {
        return $7d4cccdf062a2261$export$3806e10d0c441ac5;
    }
};
var $7d4cccdf062a2261$export$79ac44fe35dcf650 = {
    alt: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
            return v;
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};



// Generated by purs version 0.15.16




var $50c50d1f444e5fa4$export$544bf02140fa9a77 = function(x) {
    return x;
};
var $50c50d1f444e5fa4$export$7af8a265c45f06a6 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Identity " + (show(v) + ")");
        }
    };
};
var $50c50d1f444e5fa4$export$de6e130f3067e173 = function(dictSemiring) {
    return dictSemiring;
};
var $50c50d1f444e5fa4$export$fbd9f08ec652d5d9 = function(dictSemigroup) {
    return dictSemigroup;
};
var $50c50d1f444e5fa4$export$7f1a4089c064b339 = function(dictRing) {
    return dictRing;
};
var $50c50d1f444e5fa4$export$af307155aba4d997 = function(dictOrd) {
    return dictOrd;
};
var $50c50d1f444e5fa4$export$4e4e6c89b10840f9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $50c50d1f444e5fa4$export$2f07791950174d24 = function(dictMonoid) {
    return dictMonoid;
};
var $50c50d1f444e5fa4$export$c7656c1a42d43140 = function(dictLazy) {
    return dictLazy;
};
var $50c50d1f444e5fa4$export$7e3f9626786077f7 = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $50c50d1f444e5fa4$export$dc85e8383eafbd81 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $50c50d1f444e5fa4$export$ace4d1c3770c9591 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($50c50d1f444e5fa4$export$dc85e8383eafbd81)
};
var $50c50d1f444e5fa4$export$a04fa6f5a41919d9 = {
    extend: function(f) {
        return function(m) {
            return f(m);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$4d1b13d40da4cff7 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $50c50d1f444e5fa4$export$b3449ff235884fd4 = function(dictEq) {
    return dictEq;
};
var $50c50d1f444e5fa4$export$43b3c8db16b4e7b8 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($50c50d1f444e5fa4$export$b3449ff235884fd4(dictEq));
    }
};
var $50c50d1f444e5fa4$export$982c033a83dfd7d3 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($50c50d1f444e5fa4$export$af307155aba4d997(dictOrd));
    },
    Eq10: function() {
        return $50c50d1f444e5fa4$export$43b3c8db16b4e7b8;
    }
};
var $50c50d1f444e5fa4$export$aac6efd7b2eac4c4 = {
    extract: function(v) {
        return v;
    },
    Extend0: function() {
        return $50c50d1f444e5fa4$export$a04fa6f5a41919d9;
    }
};
var $50c50d1f444e5fa4$export$133f9093a008dc4d = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $50c50d1f444e5fa4$export$5be407eed81cb759 = function(dictBounded) {
    return dictBounded;
};
var $50c50d1f444e5fa4$export$c3b024d9c40a32df = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $50c50d1f444e5fa4$export$c7d2c62721e92954 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $50c50d1f444e5fa4$export$91e759983456b85e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$fd3b2458e55fc503 = {
    pure: $50c50d1f444e5fa4$export$544bf02140fa9a77,
    Apply0: function() {
        return $50c50d1f444e5fa4$export$c7d2c62721e92954;
    }
};
var $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0 = {
    Applicative0: function() {
        return $50c50d1f444e5fa4$export$fd3b2458e55fc503;
    },
    Bind1: function() {
        return $50c50d1f444e5fa4$export$91e759983456b85e;
    }
};
var $50c50d1f444e5fa4$export$1cd7ff14f6a7fcef = {
    alt: function(x) {
        return function(v) {
            return x;
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};



// Generated by purs version 0.15.16

// Generated by purs version 0.15.16
const $9f3b30719c815f93$export$748d824f642f540d = function(x) {
    return Math.min(Math.abs(x), 2147483647);
};
const $9f3b30719c815f93$export$baf7824ae32165f5 = function(x) {
    return function(y) {
        if (y === 0) return 0;
        return y > 0 ? Math.floor(x / y) : -Math.floor(x / -y);
    };
};
const $9f3b30719c815f93$export$faa51fbcd7b05d8f = function(x) {
    return function(y) {
        if (y === 0) return 0;
        var yy = Math.abs(y);
        return (x % yy + yy) % yy;
    };
};
const $9f3b30719c815f93$export$6db30f2997f70499 = function(n1) {
    return function(n2) {
        return n1 / n2;
    };
};


// Generated by purs version 0.15.16


var $a64f08f726dec5e9$var$ringRecord = /* #__PURE__ */ $d061555d3b2c84b2$export$492fe4fa507ea6ad();
var $a64f08f726dec5e9$export$4fcc4024c8011653 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$e2da189c845067f9;
    }
};
var $a64f08f726dec5e9$export$a2ce2b4503316dcc = {
    RingRecord0: function() {
        return $d061555d3b2c84b2$export$38dc985ea1e564cd;
    }
};
var $a64f08f726dec5e9$export$dc394faf01ed3f4e = function(dictIsSymbol) {
    var ringRecordCons = $d061555d3b2c84b2$export$857cf13a2f74264d(dictIsSymbol)();
    return function() {
        return function(dictCommutativeRingRecord) {
            var ringRecordCons1 = ringRecordCons(dictCommutativeRingRecord.RingRecord0());
            return function(dictCommutativeRing) {
                var ringRecordCons2 = ringRecordCons1(dictCommutativeRing.Ring0());
                return {
                    RingRecord0: function() {
                        return ringRecordCons2;
                    }
                };
            };
        };
    };
};
var $a64f08f726dec5e9$export$d4bbb7afedb09bfd = function() {
    return function(dictCommutativeRingRecord) {
        var ringRecord1 = $a64f08f726dec5e9$var$ringRecord(dictCommutativeRingRecord.RingRecord0());
        return {
            Ring0: function() {
                return ringRecord1;
            }
        };
    };
};
var $a64f08f726dec5e9$export$7f39ee449b822938 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$948aff48831eff14;
    }
};
var $a64f08f726dec5e9$export$ed11bb9ee1d36807 = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$194f4464e73e7816;
    }
};
var $a64f08f726dec5e9$export$5745e05f6b169cee = {
    Ring0: function() {
        return $d061555d3b2c84b2$export$d40e27c88e22a303;
    }
};
var $a64f08f726dec5e9$export$bdad616b79aca10 = function(dictCommutativeRing) {
    var ringFn = $d061555d3b2c84b2$export$9f43d8c61dde305d(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringFn;
        }
    };
};





var $b0cd729514c2504e$export$842a2cf37af977e1 = function(dict) {
    return dict.mod;
};
var $b0cd729514c2504e$export$f81847884871263e = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEuclideanRing) {
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictEuclideanRing.CommutativeRing0().Ring0().Semiring0());
        var mod1 = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $24 = eq(b)(zero);
                if ($24) return a;
                return $b0cd729514c2504e$export$f81847884871263e(dictEq)(dictEuclideanRing)(b)(mod1(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$ea62662521882766 = {
    degree: function(v) {
        return 1;
    },
    div: $9f3b30719c815f93$export$6db30f2997f70499,
    mod: function(v) {
        return function(v1) {
            return 0.0;
        };
    },
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$ed11bb9ee1d36807;
    }
};
var $b0cd729514c2504e$export$437776face1858ae = {
    degree: $9f3b30719c815f93$export$748d824f642f540d,
    div: $9f3b30719c815f93$export$baf7824ae32165f5,
    mod: $9f3b30719c815f93$export$faa51fbcd7b05d8f,
    CommutativeRing0: function() {
        return $a64f08f726dec5e9$export$5745e05f6b169cee;
    }
};
var $b0cd729514c2504e$export$159d9494db57879b = function(dict) {
    return dict.div;
};
var $b0cd729514c2504e$export$f686d97e407ec4ef = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var gcd1 = $b0cd729514c2504e$export$f81847884871263e(dictEq);
    return function(dictEuclideanRing) {
        var Semiring0 = dictEuclideanRing.CommutativeRing0().Ring0().Semiring0();
        var zero = $c0e822be92afc4df$export$7f9972325ebfd559(Semiring0);
        var div1 = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(Semiring0);
        var gcd2 = gcd1(dictEuclideanRing);
        return function(a) {
            return function(b) {
                var $26 = eq(a)(zero) || eq(b)(zero);
                if ($26) return zero;
                return div1(mul(a)(b))(gcd2(a)(b));
            };
        };
    };
};
var $b0cd729514c2504e$export$a23b7da4bc008930 = function(dict) {
    return dict.degree;
};








var $784e1bd3d26d71da$var$semigroupRecord = /* #__PURE__ */ $d7bf9817a417d4ae$export$dbfe6b321632d7c9();
var $784e1bd3d26d71da$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $784e1bd3d26d71da$export$852b4040eee6c6ba = {
    mempty: $05149ea687d6b460$export$523c0b569236b342,
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$824c37c4afd77b1;
    }
};
var $784e1bd3d26d71da$export$fc39f3d77fa2e58a = {
    mempty: "",
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
    }
};
var $784e1bd3d26d71da$export$254fca207e30c208 = {
    memptyRecord: function(v) {
        return {};
    },
    SemigroupRecord0: function() {
        return $d7bf9817a417d4ae$export$955753116dc9242c;
    }
};
var $784e1bd3d26d71da$export$84dd8432d2bb1dc3 = /* #__PURE__ */ function() {
    return {
        mempty: $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value,
        Semigroup0: function() {
            return $5026be88823ef1f4$export$d04ea36c3e51a408;
        }
    };
}();
var $784e1bd3d26d71da$export$db307f59121ffcc4 = {
    mempty: [],
    Semigroup0: function() {
        return $d7bf9817a417d4ae$export$d082f07d0a8e9909;
    }
};
var $784e1bd3d26d71da$export$ae16212c99887b7f = function(dict) {
    return dict.memptyRecord;
};
var $784e1bd3d26d71da$export$b6526a2ab5064058 = function() {
    return function(dictMonoidRecord) {
        var semigroupRecord1 = $784e1bd3d26d71da$var$semigroupRecord(dictMonoidRecord.SemigroupRecord0());
        return {
            mempty: $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            Semigroup0: function() {
                return semigroupRecord1;
            }
        };
    };
};
var $784e1bd3d26d71da$export$9a7d64bc1d75357 = function(dict) {
    return dict.mempty;
};
var $784e1bd3d26d71da$export$192e81b9fe7e4abe = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupFn = $d7bf9817a417d4ae$export$49c9dc4575956c55(dictMonoid.Semigroup0());
    return {
        mempty: function(v) {
            return mempty1;
        },
        Semigroup0: function() {
            return semigroupFn;
        }
    };
};
var $784e1bd3d26d71da$export$d672019c76a5af4a = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    var semigroupRecordCons = $d7bf9817a417d4ae$export$74eae24c3d2a7535(dictIsSymbol)();
    return function(dictMonoid) {
        var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var Semigroup0 = dictMonoid.Semigroup0();
        return function() {
            return function(dictMonoidRecord) {
                var memptyRecord1 = $784e1bd3d26d71da$export$ae16212c99887b7f(dictMonoidRecord);
                var semigroupRecordCons1 = semigroupRecordCons(dictMonoidRecord.SemigroupRecord0())(Semigroup0);
                return {
                    memptyRecord: function(v) {
                        var tail = memptyRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var insert = $d2fadbdf02925823$export$444262986932b766(key);
                        return insert(mempty1)(tail);
                    },
                    SemigroupRecord0: function() {
                        return semigroupRecordCons1;
                    }
                };
            };
        };
    };
};
var $784e1bd3d26d71da$export$836601bcef5ff40 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(x) {
        var go = function(p) {
            if (p <= 0) return mempty1;
            if (p === 1) return x;
            if ($784e1bd3d26d71da$var$mod(p)(2) === 0) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(x$prime);
            }
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var x$prime = go($784e1bd3d26d71da$var$div(p)(2));
                return append(x$prime)(append(x$prime)(x));
            }
            throw new Error("Failed pattern match at Data.Monoid (line 88, column 3 - line 88, column 17): " + [
                p.constructor.name
            ]);
        };
        return go;
    };
};
var $784e1bd3d26d71da$export$864d727b48066337 = function(dictMonoid) {
    var mempty1 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(v) {
        return function(v1) {
            if (v) return v1;
            if (!v) return mempty1;
            throw new Error("Failed pattern match at Data.Monoid (line 96, column 1 - line 96, column 49): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};




// Generated by purs version 0.15.16
const $01fd16aefb19fd56$export$f6d4f01ca39c2fe = function(a) {
    return function() {
        return a;
    };
};
const $01fd16aefb19fd56$export$b771a24b80e4c766 = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $01fd16aefb19fd56$export$161ebd47ed3ced60 = function(f) {
    return function() {
        while(!f());
    };
};
const $01fd16aefb19fd56$export$27334490557f84d2 = function(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
};
const $01fd16aefb19fd56$export$3dfbdd78bf0090db = function(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
};
const $01fd16aefb19fd56$export$eff012ca4e6ded0b = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};







var $6c2f8951ecf9531e$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $6c2f8951ecf9531e$export$7e900d895707a1af = {
    Applicative0: function() {
        return $6c2f8951ecf9531e$export$89bf999217d3022a;
    },
    Bind1: function() {
        return $6c2f8951ecf9531e$export$855330f8a2a9f2e8;
    }
};
var $6c2f8951ecf9531e$export$855330f8a2a9f2e8 = {
    bind: $01fd16aefb19fd56$export$b771a24b80e4c766,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$export$89bf999217d3022a = {
    pure: $01fd16aefb19fd56$export$f6d4f01ca39c2fe,
    Apply0: function() {
        return $6c2f8951ecf9531e$var$$lazy_applyEffect(0);
    }
};
var $6c2f8951ecf9531e$var$$lazy_functorEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("functorEffect", "Effect", function() {
    return {
        map: $c50cfdb0b9e8fa31$export$53544bd8de5a7427($6c2f8951ecf9531e$export$89bf999217d3022a)
    };
});
var $6c2f8951ecf9531e$var$$lazy_applyEffect = /* #__PURE__ */ $6c2f8951ecf9531e$var$$runtime_lazy("applyEffect", "Effect", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($6c2f8951ecf9531e$export$7e900d895707a1af),
        Functor0: function() {
            return $6c2f8951ecf9531e$var$$lazy_functorEffect(0);
        }
    };
});
var $6c2f8951ecf9531e$export$91fce01ecf0438e1 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_functorEffect(20);
var $6c2f8951ecf9531e$export$59a7b217c53300d2 = /* #__PURE__ */ $6c2f8951ecf9531e$var$$lazy_applyEffect(23);
var $6c2f8951ecf9531e$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $6c2f8951ecf9531e$export$58139e981c60cf43 = function(dictSemigroup) {
    return {
        append: $6c2f8951ecf9531e$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $6c2f8951ecf9531e$export$2d8226ee4b2722f7 = function(dictMonoid) {
    var semigroupEffect1 = $6c2f8951ecf9531e$export$58139e981c60cf43(dictMonoid.Semigroup0());
    return {
        mempty: $01fd16aefb19fd56$export$f6d4f01ca39c2fe($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupEffect1;
        }
    };
};


// Generated by purs version 0.15.16
const $e521936ea118867a$export$339fb7f00efd6941 = function(val) {
    return function() {
        return {
            value: val
        };
    };
};
const $e521936ea118867a$export$d23276e97b1411ef = function(f) {
    return function() {
        var ref = {
            value: null
        };
        ref.value = f(ref);
        return ref;
    };
};
const $e521936ea118867a$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $e521936ea118867a$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $e521936ea118867a$export$68d8715fc104d294 = function(val) {
    return function(ref) {
        return function() {
            ref.value = val;
        };
    };
};




var $90327512d8280b8d$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $90327512d8280b8d$export$b8cb59497041ffe4 = $e521936ea118867a$export$339fb7f00efd6941;
var $90327512d8280b8d$export$4d5401161a900ce1 = $e521936ea118867a$export$cc2488c59b3f757;
var $90327512d8280b8d$export$3ff57735a52b8713 = function(f) {
    return $90327512d8280b8d$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $90327512d8280b8d$export$45b91115a89d6020 = function(f) {
    return function(s) {
        return $90327512d8280b8d$var$$$void($90327512d8280b8d$export$3ff57735a52b8713(f)(s));
    };
};


var $f93520de2fa37b44$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $f93520de2fa37b44$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f93520de2fa37b44$export$550acbd06a1f5a6a = /* #__PURE__ */ function() {
    function Loop(value0) {
        this.value0 = value0;
    }
    Loop.create = function(value0) {
        return new Loop(value0);
    };
    return Loop;
}();
var $f93520de2fa37b44$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done(value0) {
        this.value0 = value0;
    }
    Done.create = function(value0) {
        return new Done(value0);
    };
    return Done;
}();
var $f93520de2fa37b44$export$c025cfd4cc93300b = function(dict) {
    return dict.tailRecM;
};
var $f93520de2fa37b44$export$9056a6bb308e8c79 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return tailRecM1(function(o) {
                    return f(o.a)(o.b);
                })({
                    a: a,
                    b: b
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$db5fda1cbdfd94f2 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(f) {
        return function(a) {
            return function(b) {
                return function(c) {
                    return tailRecM1(function(o) {
                        return f(o.a)(o.b)(o.c);
                    })({
                        a: a,
                        b: b,
                        c: c
                    });
                };
            };
        };
    };
};
var $f93520de2fa37b44$export$f216db41e265325c = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(m) {
        return tailRecM1(function(v) {
            return mapFlipped(m)(function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$550acbd06a1f5a6a($05149ea687d6b460$export$523c0b569236b342);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1.value0);
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 179, column 43 - line 181, column 19): " + [
                    v1.constructor.name
                ]);
            });
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$4f7c5e075dda46f7 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(dictMonadRec) {
        var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
        return function(m) {
            return tailRecM1(function(v) {
                return mapFlipped(m)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(append(v)(v1.value0));
                    throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 172, column 45 - line 174, column 26): " + [
                        v1.constructor.name
                    ]);
                });
            })(mempty);
        };
    };
};
var $f93520de2fa37b44$export$2e586eaa876dd2fd = function(f) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                $copy_v = f(v.value0);
                return;
            }
            if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) {
                $tco_done = true;
                return v.value0;
            }
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 103, column 3 - line 103, column 25): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return function($85) {
        return go(f($85));
    };
};
var $f93520de2fa37b44$export$1a33088d59e37d84 = function(f) {
    return function(a) {
        return function(b) {
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                return f(o.a)(o.b);
            })({
                a: a,
                b: b
            });
        };
    };
};
var $f93520de2fa37b44$export$6866e5a95a71aa68 = function(f) {
    return function(a) {
        return function(b) {
            return function(c) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(o) {
                    return f(o.a)(o.b)(o.c);
                })({
                    a: a,
                    b: b,
                    c: c
                });
            };
        };
    };
};
var $f93520de2fa37b44$export$6a06149683d26749 = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 153, column 7 - line 153, column 31): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $06733ae99ed4f534$export$f78a1c2d38efcc13;
    }
};
var $f93520de2fa37b44$export$ef692454cdd8c2ba = {
    tailRecM: function(f) {
        var runIdentity = function(v) {
            return v;
        };
        var $86 = $f93520de2fa37b44$export$2e586eaa876dd2fd(function($88) {
            return runIdentity(f($88));
        });
        return function($87) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($86($87));
        };
    },
    Monad0: function() {
        return $50c50d1f444e5fa4$export$9a2f2fd6148bc6d0;
    }
};
var $f93520de2fa37b44$export$6871d929a8e135b0 = {
    tailRecM: function(f) {
        return function(a0) {
            return function(e) {
                return $f93520de2fa37b44$export$2e586eaa876dd2fd(function(a) {
                    return f(a)(e);
                })(a0);
            };
        };
    },
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $f93520de2fa37b44$export$ddd28c989be5e46c = {
    tailRecM: function(f) {
        return function(a0) {
            var g = function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(f(v.value0.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(v.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 145, column 7 - line 145, column 33): " + [
                    v.constructor.name
                ]);
            };
            return $f93520de2fa37b44$export$2e586eaa876dd2fd(g)(f(a0));
        };
    },
    Monad0: function() {
        return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
    }
};
var $f93520de2fa37b44$export$c2472dc015e90d28 = {
    tailRecM: function(f) {
        return function(a) {
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 137, column 30 - line 137, column 44): " + [
                    v.constructor.name
                ]);
            };
            return function __do() {
                var r = $f93520de2fa37b44$var$bindFlipped($90327512d8280b8d$export$b8cb59497041ffe4)(f(a))();
                (function() {
                    while(!function __do() {
                        var v = $e521936ea118867a$export$aafa59e2e03f2942(r)();
                        if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) {
                            var e = f(v.value0)();
                            $e521936ea118867a$export$68d8715fc104d294(e)(r)();
                            return false;
                        }
                        if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return true;
                        throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 128, column 22 - line 133, column 28): " + [
                            v.constructor.name
                        ]);
                    }());
                    return {};
                })();
                return $f93520de2fa37b44$var$map(fromDone)($e521936ea118867a$export$aafa59e2e03f2942(r))();
            };
        };
    },
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f93520de2fa37b44$export$432fdf8e79663288 = function(a) {
    return function(b) {
        return function(c) {
            return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                a: a,
                b: b,
                c: c
            });
        };
    };
};
var $f93520de2fa37b44$export$e10d15f285e25594 = function(a) {
    return function(b) {
        return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
            a: a,
            b: b
        });
    };
};
var $f93520de2fa37b44$export$ff1ade7cb067ac12 = {
    map: function(f) {
        return function(m) {
            if (m instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m.value0);
            if (m instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(f(m.value0));
            throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 0, column 0 - line 0, column 0): " + [
                m.constructor.name
            ]);
        };
    }
};
var $f93520de2fa37b44$export$116a0f7f2303acd8 = function(dictMonadRec) {
    var tailRecM1 = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
    return function(ma) {
        return tailRecM1(function(u) {
            return voidRight(new $f93520de2fa37b44$export$550acbd06a1f5a6a(u))(ma);
        })($05149ea687d6b460$export$523c0b569236b342);
    };
};
var $f93520de2fa37b44$export$61e43214bca7f031 = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(v(v2.value0));
                if (v2 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v1(v2.value0));
                throw new Error("Failed pattern match at Control.Monad.Rec.Class (line 33, column 1 - line 35, column 34): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};


// Generated by purs version 0.15.16
const $f11e5cd39add8df2$export$aca8cce159e578de = function(f) {
    return function(a) {
        return function() {
            return f(a());
        };
    };
};
const $f11e5cd39add8df2$export$3bbfc465dcacc7f4 = function(a) {
    return function() {
        return a;
    };
};
const $f11e5cd39add8df2$export$b25ab69b10c0d17b = function(a) {
    return function(f) {
        return function() {
            return f(a())();
        };
    };
};
const $f11e5cd39add8df2$export$889ea624f2cb2c57 = function(f) {
    return f();
};
function $f11e5cd39add8df2$export$f021a974ad8da35c(f) {
    return function(a) {
        return function() {
            while(f())a();
        };
    };
}
function $f11e5cd39add8df2$export$f89de2e5bf57e5e6(lo) {
    return function(hi) {
        return function(f) {
            return function() {
                for(var i = lo; i < hi; i++)f(i)();
            };
        };
    };
}
const $f11e5cd39add8df2$export$8802485f9deae94f = function(as) {
    return function(f) {
        return function() {
            for(var i = 0, l = as.length; i < l; i++)f(as[i])();
        };
    };
};
function $f11e5cd39add8df2$export$b8cb59497041ffe4(val) {
    return function() {
        return {
            value: val
        };
    };
}
const $f11e5cd39add8df2$export$aafa59e2e03f2942 = function(ref) {
    return function() {
        return ref.value;
    };
};
const $f11e5cd39add8df2$export$cc2488c59b3f757 = function(f) {
    return function(ref) {
        return function() {
            var t = f(ref.value);
            ref.value = t.state;
            return t.value;
        };
    };
};
const $f11e5cd39add8df2$export$68d8715fc104d294 = function(a) {
    return function(ref) {
        return function() {
            return ref.value = a; // eslint-disable-line no-return-assign
        };
    };
};











var $08944f7287e2704c$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $08944f7287e2704c$export$4d5401161a900ce1 = $f11e5cd39add8df2$export$cc2488c59b3f757;
var $08944f7287e2704c$export$3ff57735a52b8713 = function(f) {
    return $08944f7287e2704c$export$4d5401161a900ce1(function(s) {
        var s$prime = f(s);
        return {
            state: s$prime,
            value: s$prime
        };
    });
};
var $08944f7287e2704c$export$a47991927f51461e = {
    map: $f11e5cd39add8df2$export$aca8cce159e578de
};
var $08944f7287e2704c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $08944f7287e2704c$export$962073314682c2c = {
    Applicative0: function() {
        return $08944f7287e2704c$export$603d84e49041d7b2;
    },
    Bind1: function() {
        return $08944f7287e2704c$export$14049c9ff5b55fb3;
    }
};
var $08944f7287e2704c$export$14049c9ff5b55fb3 = {
    bind: $f11e5cd39add8df2$export$b25ab69b10c0d17b,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$export$603d84e49041d7b2 = {
    pure: $f11e5cd39add8df2$export$3bbfc465dcacc7f4,
    Apply0: function() {
        return $08944f7287e2704c$var$$lazy_applyST(0);
    }
};
var $08944f7287e2704c$var$$lazy_applyST = /* #__PURE__ */ $08944f7287e2704c$var$$runtime_lazy("applyST", "Control.Monad.ST.Internal", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($08944f7287e2704c$export$962073314682c2c),
        Functor0: function() {
            return $08944f7287e2704c$export$a47991927f51461e;
        }
    };
});
var $08944f7287e2704c$export$65915895b3a8faeb = /* #__PURE__ */ $08944f7287e2704c$var$$lazy_applyST(47);
var $08944f7287e2704c$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($08944f7287e2704c$export$65915895b3a8faeb);
var $08944f7287e2704c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($08944f7287e2704c$export$14049c9ff5b55fb3);
var $08944f7287e2704c$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $08944f7287e2704c$export$56941e1c622ade00 = function(dictSemigroup) {
    return {
        append: $08944f7287e2704c$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $08944f7287e2704c$export$24025a1415d0847d = {
    tailRecM: function(f) {
        return function(a) {
            var isLooping = function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return true;
                return false;
            };
            var fromDone = function(v) {
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return v.value0;
                throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 70, column 32 - line 70, column 46): " + [
                    v.constructor.name
                ]);
            };
            return $08944f7287e2704c$var$bind($08944f7287e2704c$var$bindFlipped($f11e5cd39add8df2$export$b8cb59497041ffe4)(f(a)))(function(r) {
                return $08944f7287e2704c$var$discard($f11e5cd39add8df2$export$f021a974ad8da35c($08944f7287e2704c$var$map(isLooping)($f11e5cd39add8df2$export$aafa59e2e03f2942(r)))($08944f7287e2704c$var$bind($f11e5cd39add8df2$export$aafa59e2e03f2942(r))(function(v) {
                    if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $08944f7287e2704c$var$bind(f(v.value0))(function(e) {
                        return $08944f7287e2704c$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(e)(r));
                    });
                    if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $08944f7287e2704c$var$pure($05149ea687d6b460$export$523c0b569236b342);
                    throw new Error("Failed pattern match at Control.Monad.ST.Internal (line 62, column 18 - line 66, column 28): " + [
                        v.constructor.name
                    ]);
                })))(function() {
                    return $08944f7287e2704c$var$map(fromDone)($f11e5cd39add8df2$export$aafa59e2e03f2942(r));
                });
            });
        };
    },
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $08944f7287e2704c$export$85c55a7e282bbb67 = function(dictMonoid) {
    var semigroupST1 = $08944f7287e2704c$export$56941e1c622ade00(dictMonoid.Semigroup0());
    return {
        mempty: $08944f7287e2704c$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupST1;
        }
    };
};


// Generated by purs version 0.15.16
function $0dbe0c7353bd68b1$export$b8cb59497041ffe4() {
    return [];
}
const $0dbe0c7353bd68b1$export$6dc5f95d8548a16a = function(just, nothing, i, xs) {
    return i >= 0 && i < xs.length ? just(xs[i]) : nothing;
};
const $0dbe0c7353bd68b1$export$284bbde9874b0917 = function(i, a, xs) {
    var ret = i >= 0 && i < xs.length;
    if (ret) xs[i] = a;
    return ret;
};
const $0dbe0c7353bd68b1$export$b0d1de20d482ef7d = function(xs) {
    return xs.length;
};
const $0dbe0c7353bd68b1$export$636ddc1660dd1285 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.pop()) : nothing;
};
const $0dbe0c7353bd68b1$export$f8b776ba78ff4419 = function(as, xs) {
    return xs.push.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$8a1b3b221575bba8 = function(just, nothing, xs) {
    return xs.length > 0 ? just(xs.shift()) : nothing;
};
const $0dbe0c7353bd68b1$export$23e87bb70af50c39 = function(as, xs) {
    return xs.unshift.apply(xs, as);
};
const $0dbe0c7353bd68b1$export$b05cd45ffb08c41e = function(i, howMany, bs, xs) {
    return xs.splice.apply(xs, [
        i,
        howMany
    ].concat(bs));
};
function $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl(xs) {
    return xs;
}
const $0dbe0c7353bd68b1$export$f2963aff015afecf = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
const $0dbe0c7353bd68b1$export$601e856cb1838137 = $0dbe0c7353bd68b1$var$unsafeFreezeThawImpl;
function $0dbe0c7353bd68b1$var$copyImpl(xs) {
    return xs.slice();
}
const $0dbe0c7353bd68b1$export$2109af1090f5f6b7 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$cd8ba9f9707c2718 = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$57a1a2542c1220dc = $0dbe0c7353bd68b1$var$copyImpl;
const $0dbe0c7353bd68b1$export$ea0922e78a1b008a = function() {
    function mergeFromTo(compare, fromOrdering, xs1, xs2, from, to) {
        var mid;
        var i;
        var j;
        var k;
        var x;
        var y;
        var c;
        mid = from + (to - from >> 1);
        if (mid - from > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, from, mid);
        if (to - mid > 1) mergeFromTo(compare, fromOrdering, xs2, xs1, mid, to);
        i = from;
        j = mid;
        k = from;
        while(i < mid && j < to){
            x = xs2[i];
            y = xs2[j];
            c = fromOrdering(compare(x)(y));
            if (c > 0) {
                xs1[k++] = y;
                ++j;
            } else {
                xs1[k++] = x;
                ++i;
            }
        }
        while(i < mid)xs1[k++] = xs2[i++];
        while(j < to)xs1[k++] = xs2[j++];
    }
    return function(compare, fromOrdering, xs) {
        if (xs.length < 2) return xs;
        mergeFromTo(compare, fromOrdering, xs, xs.slice(0), 0, xs.length);
        return xs;
    };
}();
const $0dbe0c7353bd68b1$export$66323db02f2496b6 = function(xs) {
    var n = xs.length;
    var as = new Array(n);
    for(var i = 0; i < n; i++)as[i] = {
        value: xs[i],
        index: i
    };
    return as;
};
const $0dbe0c7353bd68b1$export$80f4edbb06ec8379 = function(a, xs) {
    return xs.push(a);
};




// Generated by purs version 0.15.16
const $cc20365e325869f4$export$d092af9ac17843bc = function mkSTFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $cc20365e325869f4$export$6a3a9c423c2be31e = function mkSTFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $cc20365e325869f4$export$20b99d064a00c9ee = function mkSTFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $cc20365e325869f4$export$88b7720b4d616633 = function mkSTFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $cc20365e325869f4$export$ff210326ba56123c = function mkSTFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $cc20365e325869f4$export$1df8279312f4490c = function mkSTFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $cc20365e325869f4$export$c438f7da82a827de = function mkSTFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $cc20365e325869f4$export$8016275d609fc2cf = function mkSTFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $cc20365e325869f4$export$85672cd282a38b9f = function mkSTFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $cc20365e325869f4$export$1e8732a765f7f6a9 = function mkSTFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $cc20365e325869f4$export$16973cca6f004709 = function runSTFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $cc20365e325869f4$export$67ab494f009454e2 = function runSTFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $cc20365e325869f4$export$d02c4697b083e08e = function runSTFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $cc20365e325869f4$export$38a1b097838c69d7 = function runSTFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$df815fcba9ace1f4 = function runSTFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$18e87184adad44fe = function runSTFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$e282c4050f6499d3 = function runSTFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$1d03302402d80b8a = function runSTFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$9671bb34351fe15d = function runSTFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $cc20365e325869f4$export$54118f4544b4eca2 = function runSTFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};







var $784e144d56146b5c$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($08944f7287e2704c$export$14049c9ff5b55fb3);
var $784e144d56146b5c$export$8ff712f7409e81c7 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39);
var $784e144d56146b5c$export$37cdb546b806ae87 = function(a) {
    return $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$23e87bb70af50c39)([
        a
    ]);
};
var $784e144d56146b5c$export$cc9b8725eef9c137 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$601e856cb1838137);
var $784e144d56146b5c$export$7c850c5af9b9983e = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$f2963aff015afecf);
var $784e144d56146b5c$export$a8793e37025aca3d = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$66323db02f2496b6);
var $784e144d56146b5c$export$80340c06f76ce783 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$cd8ba9f9707c2718);
var $784e144d56146b5c$export$fd51609fe570ea92 = function(f) {
    return function(xs) {
        return function __do() {
            var result = $784e144d56146b5c$export$80340c06f76ce783(xs)();
            f(result)();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        };
    };
};
var $784e144d56146b5c$export$869882364835d202 = /* #__PURE__ */ $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$b05cd45ffb08c41e);
var $784e144d56146b5c$export$b035e44d7bb4278f = function(comp) {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array.ST (line 129, column 40 - line 132, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $784e144d56146b5c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $784e144d56146b5c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $784e144d56146b5c$export$97db5808d8f88186 = function(dictOrd) {
    return $784e144d56146b5c$export$b035e44d7bb4278f($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $784e144d56146b5c$export$fba63a578e423eb = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$8a1b3b221575bba8)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$889ea624f2cb2c57 = function(st) {
    return $784e144d56146b5c$var$bind(st)($784e144d56146b5c$export$7c850c5af9b9983e)();
};
var $784e144d56146b5c$export$907644183e99da16 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$f8b776ba78ff4419);
var $784e144d56146b5c$export$4cbf152802aa238 = /* #__PURE__ */ $cc20365e325869f4$export$67ab494f009454e2($0dbe0c7353bd68b1$export$80f4edbb06ec8379);
var $784e144d56146b5c$export$3e41007ebfff0e64 = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$636ddc1660dd1285)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$dc13bdd74c909d26 = /* #__PURE__ */ $cc20365e325869f4$export$d02c4697b083e08e($0dbe0c7353bd68b1$export$284bbde9874b0917);
var $784e144d56146b5c$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $cc20365e325869f4$export$38a1b097838c69d7($0dbe0c7353bd68b1$export$6dc5f95d8548a16a)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $784e144d56146b5c$export$3ff57735a52b8713 = function(i) {
    return function(f) {
        return function(xs) {
            return function __do() {
                var entry = $784e144d56146b5c$export$4d3fb11e950abb9e(i)(xs)();
                if (entry instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $784e144d56146b5c$export$dc13bdd74c909d26(i)(f(entry.value0))(xs)();
                if (entry instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                throw new Error("Failed pattern match at Data.Array.ST (line 234, column 3 - line 236, column 26): " + [
                    entry.constructor.name
                ]);
            };
        };
    };
};
var $784e144d56146b5c$export$f24224f1c91d8156 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$b0d1de20d482ef7d);
var $784e144d56146b5c$export$792f3d81ea979f55 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$2109af1090f5f6b7);
var $784e144d56146b5c$export$9cd59f9826255e47 = /* #__PURE__ */ $cc20365e325869f4$export$16973cca6f004709($0dbe0c7353bd68b1$export$57a1a2542c1220dc);


// Generated by purs version 0.15.16




// Generated by purs version 0.15.16
const $083bebfcbf303ad1$export$e5682d87e23bb875 = function(b1) {
    return function(b2) {
        return b1 && b2;
    };
};
const $083bebfcbf303ad1$export$4edd36328926db3d = function(b1) {
    return function(b2) {
        return b1 || b2;
    };
};
const $083bebfcbf303ad1$export$856531720ce57da6 = function(b) {
    return !b;
};






var $f8fc227945eb179e$export$4c5e47bb71c07b6a = function(dict) {
    return dict.ttRecord;
};
var $f8fc227945eb179e$export$80bf595f9d9a1157 = function(dict) {
    return dict.tt;
};
var $f8fc227945eb179e$export$242da53d3ad27a73 = function(dict) {
    return dict.notRecord;
};
var $f8fc227945eb179e$export$6003a5f097c73977 = function(dict) {
    return dict.not;
};
var $f8fc227945eb179e$export$30918bdfe7eba090 = function(dict) {
    return dict.impliesRecord;
};
var $f8fc227945eb179e$export$6c53455e54f455ef = function(dict) {
    return dict.implies;
};
var $f8fc227945eb179e$export$960158ea2ad21b8d = {
    ff: $05149ea687d6b460$export$523c0b569236b342,
    tt: $05149ea687d6b460$export$523c0b569236b342,
    implies: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    conj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    disj: function(v) {
        return function(v1) {
            return $05149ea687d6b460$export$523c0b569236b342;
        };
    },
    not: function(v) {
        return $05149ea687d6b460$export$523c0b569236b342;
    }
};
var $f8fc227945eb179e$export$456c60aba1aeaaa = {
    conjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    disjRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    ffRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    impliesRecord: function(v) {
        return function(v1) {
            return function(v2) {
                return {};
            };
        };
    },
    notRecord: function(v) {
        return function(v1) {
            return {};
        };
    },
    ttRecord: function(v) {
        return function(v1) {
            return {};
        };
    }
};
var $f8fc227945eb179e$export$7347fefc6a9ef6b6 = /* #__PURE__ */ function() {
    return {
        conj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        disj: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        implies: function(v) {
            return function(v1) {
                return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
            };
        },
        ff: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value,
        not: function(v) {
            return $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value;
        },
        tt: $c6a0478cbb9b5a21$export$accffb5fb4579e0d.value
    };
}();
var $f8fc227945eb179e$export$1b03126bff237ceb = function(dict) {
    return dict.ffRecord;
};
var $f8fc227945eb179e$export$f59495b1b7502b33 = function(dict) {
    return dict.ff;
};
var $f8fc227945eb179e$export$84e5fab3d833d7a2 = function(dict) {
    return dict.disjRecord;
};
var $f8fc227945eb179e$export$9bd7ee00e37438db = function(dict) {
    return dict.disj;
};
var $f8fc227945eb179e$export$d7d9283ee84f4c3f = {
    ff: false,
    tt: true,
    implies: function(a) {
        return function(b) {
            return $f8fc227945eb179e$export$9bd7ee00e37438db($f8fc227945eb179e$export$d7d9283ee84f4c3f)($f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f)(a))(b);
        };
    },
    conj: $083bebfcbf303ad1$export$e5682d87e23bb875,
    disj: $083bebfcbf303ad1$export$4edd36328926db3d,
    not: $083bebfcbf303ad1$export$856531720ce57da6
};
var $f8fc227945eb179e$export$49ae8d06200d7fce = function(dict) {
    return dict.conjRecord;
};
var $f8fc227945eb179e$export$7f2b975cf624805f = function() {
    return function(dictHeytingAlgebraRecord) {
        return {
            ff: $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            tt: $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            conj: $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            disj: $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            implies: $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
            not: $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
        };
    };
};
var $f8fc227945eb179e$export$fb254c661fe9c0db = function(dict) {
    return dict.conj;
};
var $f8fc227945eb179e$export$e9ae480d80dfc592 = function(dictHeytingAlgebra) {
    var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: function(v) {
            return ff1;
        },
        tt: function(v) {
            return tt1;
        },
        implies: function(f) {
            return function(g) {
                return function(a) {
                    return implies1(f(a))(g(a));
                };
            };
        },
        conj: function(f) {
            return function(g) {
                return function(a) {
                    return conj1(f(a))(g(a));
                };
            };
        },
        disj: function(f) {
            return function(g) {
                return function(a) {
                    return disj1(f(a))(g(a));
                };
            };
        },
        not: function(f) {
            return function(a) {
                return not1(f(a));
            };
        }
    };
};
var $f8fc227945eb179e$export$8b20a52b1d1213a4 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(dictHeytingAlgebraRecord) {
            var conjRecord1 = $f8fc227945eb179e$export$49ae8d06200d7fce(dictHeytingAlgebraRecord);
            var disjRecord1 = $f8fc227945eb179e$export$84e5fab3d833d7a2(dictHeytingAlgebraRecord);
            var impliesRecord1 = $f8fc227945eb179e$export$30918bdfe7eba090(dictHeytingAlgebraRecord);
            var ffRecord1 = $f8fc227945eb179e$export$1b03126bff237ceb(dictHeytingAlgebraRecord);
            var notRecord1 = $f8fc227945eb179e$export$242da53d3ad27a73(dictHeytingAlgebraRecord);
            var ttRecord1 = $f8fc227945eb179e$export$4c5e47bb71c07b6a(dictHeytingAlgebraRecord);
            return function(dictHeytingAlgebra) {
                var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
                var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
                var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
                var ff1 = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
                var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
                var tt1 = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
                return {
                    conjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = conjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(conj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    disjRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = disjRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(disj1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    impliesRecord: function(v) {
                        return function(ra) {
                            return function(rb) {
                                var tail = impliesRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(ra)(rb);
                                var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var insert = $d2fadbdf02925823$export$444262986932b766(key);
                                var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                                return insert(implies1(get(ra))(get(rb)))(tail);
                            };
                        };
                    },
                    ffRecord: function(v) {
                        return function(row) {
                            var tail = ffRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(ff1)(tail);
                        };
                    },
                    notRecord: function(v) {
                        return function(row) {
                            var tail = notRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            var get = $d2fadbdf02925823$export$1d94535d2cda4eda(key);
                            return insert(not1(get(row)))(tail);
                        };
                    },
                    ttRecord: function(v) {
                        return function(row) {
                            var tail = ttRecord1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row);
                            var key = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var insert = $d2fadbdf02925823$export$444262986932b766(key);
                            return insert(tt1)(tail);
                        };
                    }
                };
            };
        };
    };
};



var $8dd172f1ebfb42af$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $8dd172f1ebfb42af$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $8dd172f1ebfb42af$var$Iterator = /* #__PURE__ */ function() {
    function Iterator(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Iterator.create = function(value0) {
        return function(value1) {
            return new Iterator(value0, value1);
        };
    };
    return Iterator;
}();
var $8dd172f1ebfb42af$export$4d3fb11e950abb9e = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$48cfd1e771a65c4f = function(v) {
    return function __do() {
        var i = $f11e5cd39add8df2$export$aafa59e2e03f2942(v.value1)();
        $08944f7287e2704c$export$3ff57735a52b8713(function(v1) {
            return v1 + 1 | 0;
        })(v.value1)();
        return v.value0(i);
    };
};
var $8dd172f1ebfb42af$export$f458d78453dee163 = function(p) {
    return function(iter) {
        return function(array) {
            return function __do() {
                var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
                while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                    var mx = $8dd172f1ebfb42af$export$4d3fb11e950abb9e(iter)();
                    if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && p(mx.value0)) {
                        $784e144d56146b5c$export$4cbf152802aa238(mx.value0)(array)();
                        return $8dd172f1ebfb42af$var$$$void($8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter))();
                    }
                    return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                })();
                return {};
            };
        };
    };
};
var $8dd172f1ebfb42af$export$907644183e99da16 = /* #__PURE__ */ $8dd172f1ebfb42af$export$f458d78453dee163(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $8dd172f1ebfb42af$export$6f58e2338da23f4d = function(f) {
    return $8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$Iterator.create(f))($f11e5cd39add8df2$export$b8cb59497041ffe4(0));
};
var $8dd172f1ebfb42af$export$c1a059043cc9c119 = function(iter) {
    return function(f) {
        return function __do() {
            var $$break = $f11e5cd39add8df2$export$b8cb59497041ffe4(false)();
            while($8dd172f1ebfb42af$var$map($8dd172f1ebfb42af$var$not)($f11e5cd39add8df2$export$aafa59e2e03f2942($$break))())(function __do() {
                var mx = $8dd172f1ebfb42af$export$48cfd1e771a65c4f(iter)();
                if (mx instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return f(mx.value0)();
                if (mx instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $8dd172f1ebfb42af$var$$$void($f11e5cd39add8df2$export$68d8715fc104d294(true)($$break))();
                throw new Error("Failed pattern match at Data.Array.ST.Iterator (line 42, column 5 - line 44, column 47): " + [
                    mx.constructor.name
                ]);
            })();
            return {};
        };
    };
};
var $8dd172f1ebfb42af$export$dc4133c4d1844d49 = /* #__PURE__ */ function() {
    var $20 = $8dd172f1ebfb42af$var$map($06733ae99ed4f534$export$4967676db1b89293);
    return function($21) {
        return $20($8dd172f1ebfb42af$export$4d3fb11e950abb9e($21));
    };
}();




// Generated by purs version 0.15.16
const $44c597fdc38e7b03$export$6332150c6d01d807 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = len - 1; i >= 0; i--)acc = f(xs[i])(acc);
            return acc;
        };
    };
};
const $44c597fdc38e7b03$export$6b86e13802001a00 = function(f) {
    return function(init) {
        return function(xs) {
            var acc = init;
            var len = xs.length;
            for(var i = 0; i < len; i++)acc = f(acc)(xs[i]);
            return acc;
        };
    };
};







// Generated by purs version 0.15.16


var $7abe8fbe97ebda87$export$b7c99dd4fc96d90e = {
    empty: [],
    Alt0: function() {
        return $75e93a4111e80214$export$186d613bb872946c;
    }
};
var $7abe8fbe97ebda87$export$6e22c362a0406a2c = function(dict) {
    return dict.empty;
};





// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
const $87f783ef0843fa28$export$2ed6d41c398ed712 = function(f) {
    return function(xs) {
        return xs.map(function(_, i, xs) {
            return f(xs.slice(i));
        });
    };
};





var $c8f9cdd14046b503$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c8f9cdd14046b503$export$cd01f0fbd2ca8bd6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        extend: function(f) {
            return function(g) {
                return function(w) {
                    return f(function(w$prime) {
                        return g(append(w)(w$prime));
                    });
                };
            };
        },
        Functor0: function() {
            return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
        }
    };
};
var $c8f9cdd14046b503$export$a321b0e45770af43 = {
    extend: $87f783ef0843fa28$export$2ed6d41c398ed712,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $c8f9cdd14046b503$export$8b58be045bf06082 = function(dict) {
    return dict.extend;
};
var $c8f9cdd14046b503$export$285c6f9556cd75fc = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(w) {
        return function(f) {
            return extend1(f)(w);
        };
    };
};
var $c8f9cdd14046b503$export$ecd5e8ace626722c = function(dictExtend) {
    return $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend)($c8f9cdd14046b503$var$identity);
};
var $c8f9cdd14046b503$export$fbe89af2ce156300 = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return f(extend1(g)(w));
            };
        };
    };
};
var $c8f9cdd14046b503$export$a868f0c7fe15a03f = function(dictExtend) {
    var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    return function(f) {
        return function(g) {
            return function(w) {
                return g(extend1(f)(w));
            };
        };
    };
};



var $b3e944c79ac8b935$export$f9380c9a627682d3 = function(dict) {
    return dict.extract;
};



// Generated by purs version 0.15.16



// Generated by purs version 0.15.16














var $71f2e2e9476163f8$export$1908877435b1d5e9 = /* #__PURE__ */ function() {
    function Tuple(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Tuple.create = function(value0) {
        return function(value1) {
            return new Tuple(value0, value1);
        };
    };
    return Tuple;
}();
var $71f2e2e9476163f8$export$7864d59d01b6d6bf = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $71f2e2e9476163f8$export$b0e76d9850c64156 = function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value0);
};
var $71f2e2e9476163f8$export$6f71268a1666ab58 = function(v) {
    return v.value1;
};
var $71f2e2e9476163f8$export$c29279d1dfdefb95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(Tuple " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $71f2e2e9476163f8$export$a55548456e48767 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    return function(dictSemiring1) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring1);
        var mul1 = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring1);
        return {
            add: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(add(v.value0)(v1.value0), add1(v.value1)(v1.value1));
                };
            },
            one: new $71f2e2e9476163f8$export$1908877435b1d5e9(one, $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring1)),
            mul: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(mul(v.value0)(v1.value0), mul1(v.value1)(v1.value1));
                };
            },
            zero: new $71f2e2e9476163f8$export$1908877435b1d5e9(zero, $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring1))
        };
    };
};
var $71f2e2e9476163f8$export$ab2b4b200e457b99 = {
    compose: function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1);
        };
    }
};
var $71f2e2e9476163f8$export$1f8404c41aab4117 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictSemigroup1) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1);
        return {
            append: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), append2(v.value1)(v1.value1));
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$9ba4b2debe474100 = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringTuple1 = $71f2e2e9476163f8$export$a55548456e48767(dictRing.Semiring0());
    return function(dictRing1) {
        var sub1 = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing1);
        var semiringTuple2 = semiringTuple1(dictRing1.Semiring0());
        return {
            sub: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(sub(v.value0)(v1.value0), sub1(v.value1)(v1.value1));
                };
            },
            Semiring0: function() {
                return semiringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$a9eaa17b3ab5a78d = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupTuple1 = $71f2e2e9476163f8$export$1f8404c41aab4117(dictMonoid.Semigroup0());
    return function(dictMonoid1) {
        var semigroupTuple2 = semigroupTuple1(dictMonoid1.Semigroup0());
        return {
            mempty: new $71f2e2e9476163f8$export$1908877435b1d5e9(mempty, $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
            Semigroup0: function() {
                return semigroupTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$47e10f15d8f6e8d8 = function(dictHeytingAlgebra) {
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj1 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return function(dictHeytingAlgebra1) {
        var implies1 = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra1);
        var conj2 = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra1);
        var disj1 = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra1);
        var not1 = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra1);
        return {
            tt: new $71f2e2e9476163f8$export$1908877435b1d5e9(tt, $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra1)),
            ff: new $71f2e2e9476163f8$export$1908877435b1d5e9(ff, $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra1)),
            implies: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(implies(v.value0)(v1.value0), implies1(v.value1)(v1.value1));
                };
            },
            conj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(conj1(v.value0)(v1.value0), conj2(v.value1)(v1.value1));
                };
            },
            disj: function(v) {
                return function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(disj(v.value0)(v1.value0), disj1(v.value1)(v1.value1));
                };
            },
            not: function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(not(v.value0), not1(v.value1));
            }
        };
    };
};
var $71f2e2e9476163f8$export$8b71b9e63ea20f7b = {
    to: function(x) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(x.value0, x.value1);
    },
    from: function(x) {
        return new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1);
    }
};
var $71f2e2e9476163f8$export$19ab04734dcb0ff0 = {
    map: function(f) {
        return function(m) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(m.value0, f(m.value1));
        };
    }
};
var $71f2e2e9476163f8$export$9801206bd382aee0 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($71f2e2e9476163f8$export$19ab04734dcb0ff0)
};
var $71f2e2e9476163f8$export$9e770fa6ce19a9d6 = function(v) {
    return v.value0;
};
var $71f2e2e9476163f8$export$28de2725b8db0d42 = function(dictLazy) {
    var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
    return function(dictLazy1) {
        var defer1 = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy1);
        return {
            defer: function(f) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(defer(function(v) {
                    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6(f($05149ea687d6b460$export$523c0b569236b342));
                }), defer1(function(v) {
                    return $71f2e2e9476163f8$export$6f71268a1666ab58(f($05149ea687d6b460$export$523c0b569236b342));
                }));
            }
        };
    };
};
var $71f2e2e9476163f8$export$1d78bbb1aca8569c = {
    extend: function(f) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v));
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $71f2e2e9476163f8$export$d625e8a97ba36bd6 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq1(x.value1)(y.value1);
                };
            }
        };
    };
};
var $71f2e2e9476163f8$export$8f11eb03746a66e2 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqTuple2 = eqTuple1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare1(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$11462014c11c050e = function(dictEq) {
    var eqTuple1 = $71f2e2e9476163f8$export$d625e8a97ba36bd6(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqTuple1(dictEq1));
        }
    };
};
var $71f2e2e9476163f8$export$2c05c340f808b07c = function(dictOrd) {
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictOrd);
    var eq1Tuple1 = $71f2e2e9476163f8$export$11462014c11c050e(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordTuple1(dictOrd1));
        },
        Eq10: function() {
            return eq1Tuple1;
        }
    };
};
var $71f2e2e9476163f8$export$c3095a23b368d1f2 = function(f) {
    return function(a) {
        return function(b) {
            return f(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, b));
        };
    };
};
var $71f2e2e9476163f8$export$8e995acc5599767e = {
    extract: $71f2e2e9476163f8$export$6f71268a1666ab58,
    Extend0: function() {
        return $71f2e2e9476163f8$export$1d78bbb1aca8569c;
    }
};
var $71f2e2e9476163f8$export$4b53a8a87c01bf43 = function(dictCommutativeRing) {
    var ringTuple1 = $71f2e2e9476163f8$export$9ba4b2debe474100(dictCommutativeRing.Ring0());
    return function(dictCommutativeRing1) {
        var ringTuple2 = ringTuple1(dictCommutativeRing1.Ring0());
        return {
            Ring0: function() {
                return ringTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$f1ad4da5028a9f5f = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordTuple1 = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictBounded.Ord0());
    return function(dictBounded1) {
        var ordTuple2 = ordTuple1(dictBounded1.Ord0());
        return {
            top: new $71f2e2e9476163f8$export$1908877435b1d5e9(top, $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded1)),
            bottom: new $71f2e2e9476163f8$export$1908877435b1d5e9(bottom, $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded1)),
            Ord0: function() {
                return ordTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$cc556dd69d46ad4 = function(dictBooleanAlgebra) {
    var heytingAlgebraTuple1 = $71f2e2e9476163f8$export$47e10f15d8f6e8d8(dictBooleanAlgebra.HeytingAlgebra0());
    return function(dictBooleanAlgebra1) {
        var heytingAlgebraTuple2 = heytingAlgebraTuple1(dictBooleanAlgebra1.HeytingAlgebra0());
        return {
            HeytingAlgebra0: function() {
                return heytingAlgebraTuple2;
            }
        };
    };
};
var $71f2e2e9476163f8$export$c87751c00e30fc9e = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v.value1(v1.value1));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $71f2e2e9476163f8$export$5266c91ec2409601 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictSemigroup);
    return {
        bind: function(v) {
            return function(f) {
                var v1 = f(v.value1);
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(append1(v.value0)(v1.value0), v1.value1);
            };
        },
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$2f2c2cdaef7b685e = function(dictMonoid) {
    var applyTuple1 = $71f2e2e9476163f8$export$c87751c00e30fc9e(dictMonoid.Semigroup0());
    return {
        pure: $71f2e2e9476163f8$export$1908877435b1d5e9.create($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Apply0: function() {
            return applyTuple1;
        }
    };
};
var $71f2e2e9476163f8$export$d5a06b0f6aa5b11a = function(dictMonoid) {
    var applicativeTuple1 = $71f2e2e9476163f8$export$2f2c2cdaef7b685e(dictMonoid);
    var bindTuple1 = $71f2e2e9476163f8$export$5266c91ec2409601(dictMonoid.Semigroup0());
    return {
        Applicative0: function() {
            return applicativeTuple1;
        },
        Bind1: function() {
            return bindTuple1;
        }
    };
};



var $20615e99b278adf5$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $20615e99b278adf5$export$eb54baf0b342cb1d = function(dict) {
    return dict.bimap;
};
var $20615e99b278adf5$export$4ec4986d7b23d5a5 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
};
var $20615e99b278adf5$export$2ad466be2e2b0196 = function(dictBifunctor) {
    var bimap1 = $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor);
    return function(f) {
        return bimap1(f)($20615e99b278adf5$var$identity);
    };
};
var $20615e99b278adf5$export$6630987c9d273301 = function(dictBifunctor) {
    return $20615e99b278adf5$export$eb54baf0b342cb1d(dictBifunctor)($20615e99b278adf5$var$identity);
};
var $20615e99b278adf5$export$34a2521cb7920188 = {
    bimap: function(f) {
        return function(g) {
            return function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), g(v.value1));
            };
        };
    }
};
var $20615e99b278adf5$export$9b66d4861c364eff = {
    bimap: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v2.value0));
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1(v2.value0));
                throw new Error("Failed pattern match at Data.Bifunctor (line 38, column 1 - line 40, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    }
};
var $20615e99b278adf5$export$52f77c2cc8ef8f31 = {
    bimap: function(f) {
        return function(v) {
            return function(v1) {
                return f(v1);
            };
        };
    }
};








var $490ec114b4138e6d$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $490ec114b4138e6d$export$a7f096464cca5f3a = function(x) {
    return x;
};
var $490ec114b4138e6d$export$593e0c14cbf7732e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "(left " + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "(right " + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Functor.Coproduct (line 63, column 1 - line 65, column 60): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $490ec114b4138e6d$export$79ffe56a765070d2 = function(ga) {
    return new $7d4cccdf062a2261$export$19db0165690c701a(ga);
};
var $490ec114b4138e6d$export$7fc1e26c1ee5b3a4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $490ec114b4138e6d$export$eabcd2c8791e7bf4 = function(fa) {
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(fa);
};
var $490ec114b4138e6d$export$e192c0fa89a291cb = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $490ec114b4138e6d$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$30aaa5110153edc1 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq13(v.value0)(v1.value0);
                        return false;
                    };
                };
            }
        };
    };
};
var $490ec114b4138e6d$export$4f54a72d7417da7c = function(dictEq1) {
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Coproduct1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $490ec114b4138e6d$export$ec3d1f0587fb15ed = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Coproduct1 = $490ec114b4138e6d$export$30aaa5110153edc1(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Coproduct2 = eq1Coproduct1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare12(v.value0)(v1.value0);
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare13(v.value0)(v1.value0);
                        throw new Error("Failed pattern match at Data.Functor.Coproduct (line 57, column 5 - line 61, column 43): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    };
                };
            },
            Eq10: function() {
                return eq1Coproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$f437f5dfb3faee67 = function(dictOrd1) {
    var ord1Coproduct1 = $490ec114b4138e6d$export$ec3d1f0587fb15ed(dictOrd1);
    var eqCoproduct1 = $490ec114b4138e6d$export$4f54a72d7417da7c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Coproduct1(dictOrd11));
        var eqCoproduct2 = eqCoproduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqCoproduct3 = eqCoproduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqCoproduct3;
                }
            };
        };
    };
};
var $490ec114b4138e6d$export$ab04af7daecb905f = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Functor.Coproduct (line 27, column 1 - line 27, column 78): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $490ec114b4138e6d$export$7ce1af5f45fd6777 = function(dictExtend) {
    var extend = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend);
    var functorCoproduct1 = $490ec114b4138e6d$export$e192c0fa89a291cb(dictExtend.Functor0());
    return function(dictExtend1) {
        var extend1 = $c8f9cdd14046b503$export$8b58be045bf06082(dictExtend1);
        var functorCoproduct2 = functorCoproduct1(dictExtend1.Functor0());
        return {
            extend: function(f) {
                var $106 = $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $108 = extend(function($110) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($110)));
                    });
                    return function($109) {
                        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($108($109));
                    };
                }())(function() {
                    var $111 = extend1(function($113) {
                        return f($490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($113)));
                    });
                    return function($112) {
                        return $7d4cccdf062a2261$export$19db0165690c701a.create($111($112));
                    };
                }());
                return function($107) {
                    return $490ec114b4138e6d$export$a7f096464cca5f3a($106($107));
                };
            },
            Functor0: function() {
                return functorCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$2f16914668ceb808 = function(dictComonad) {
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var extendCoproduct1 = $490ec114b4138e6d$export$7ce1af5f45fd6777(dictComonad.Extend0());
    return function(dictComonad1) {
        var extendCoproduct2 = extendCoproduct1(dictComonad1.Extend0());
        return {
            extract: $490ec114b4138e6d$export$ab04af7daecb905f(extract)($b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad1)),
            Extend0: function() {
                return extendCoproduct2;
            }
        };
    };
};
var $490ec114b4138e6d$export$c1a518500c2ed5de = function(natF) {
    return function(natG) {
        return function(v) {
            return $490ec114b4138e6d$var$bimap(natF)(natG)(v);
        };
    };
};




// Generated by purs version 0.15.16




var $92016ca92c497156$export$b25abba66f7be210 = function(x) {
    return x;
};
var $92016ca92c497156$export$20f833961f1940c8 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "First (" + (show(v) + ")");
        }
    };
};
var $92016ca92c497156$export$53ff158b23f5d382 = {
    append: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v;
            return v1;
        };
    }
};
var $92016ca92c497156$export$4d7d8eedf770f0 = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $92016ca92c497156$export$f6a5e365037ccf9a = $06733ae99ed4f534$export$c82772423d5de0b;
var $92016ca92c497156$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $92016ca92c497156$export$db2423f7434b7a30 = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $92016ca92c497156$export$53ff158b23f5d382;
        }
    };
}();
var $92016ca92c497156$export$e17b0506de713d2e = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $92016ca92c497156$export$6f62e1511455cb87 = $06733ae99ed4f534$export$62eda6ff839a0571;
var $92016ca92c497156$export$98d9d13e8b5bfe4d = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $92016ca92c497156$export$590ee69b33ca98b4 = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $92016ca92c497156$export$8232f15b0b41395c = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $92016ca92c497156$export$1a969f11cd8a353e = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $92016ca92c497156$export$315f32b6f78e2785 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $92016ca92c497156$export$456f8570baa6024f = $06733ae99ed4f534$export$e5fea5661dee377;
var $92016ca92c497156$export$e48e2da4536c2eea = $06733ae99ed4f534$export$22d9917da16590e7;
var $92016ca92c497156$export$178f5831973b2ff8 = $06733ae99ed4f534$export$b203ef4465f15037;
var $92016ca92c497156$export$5cfe42f95bdf312b = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($92016ca92c497156$export$53ff158b23f5d382),
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $92016ca92c497156$export$e3c1997b7c0ee480 = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($92016ca92c497156$export$db2423f7434b7a30),
    Alt0: function() {
        return $92016ca92c497156$export$5cfe42f95bdf312b;
    }
};
var $92016ca92c497156$export$92398121afed1258 = {
    Applicative0: function() {
        return $92016ca92c497156$export$178f5831973b2ff8;
    },
    Plus1: function() {
        return $92016ca92c497156$export$e3c1997b7c0ee480;
    }
};



// Generated by purs version 0.15.16




var $65ae0a43a0950bac$export$c688766eb4789b8c = function(x) {
    return x;
};
var $65ae0a43a0950bac$export$3e00b8f10f0f4e39 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Conj " + (show(v) + ")");
        }
    };
};
var $65ae0a43a0950bac$export$b71164e0e6b84c70 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$91e0ef53a9c72523 = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $65ae0a43a0950bac$export$74eade9f2b920d02 = function(dictOrd) {
    return dictOrd;
};
var $65ae0a43a0950bac$export$4f2b093ea8408d89 = function(dictHeytingAlgebra) {
    var semigroupConj1 = $65ae0a43a0950bac$export$91e0ef53a9c72523(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupConj1;
        }
    };
};
var $65ae0a43a0950bac$export$48b7cf0194537bca = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $65ae0a43a0950bac$export$2d4ce045d5165d6f = function(dictEq) {
    return dictEq;
};
var $65ae0a43a0950bac$export$43823c09e8843bf5 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($65ae0a43a0950bac$export$2d4ce045d5165d6f(dictEq));
    }
};
var $65ae0a43a0950bac$export$a6a01ce014de97e1 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($65ae0a43a0950bac$export$74eade9f2b920d02(dictOrd));
    },
    Eq10: function() {
        return $65ae0a43a0950bac$export$43823c09e8843bf5;
    }
};
var $65ae0a43a0950bac$export$a4102daba18ffc08 = function(dictBounded) {
    return dictBounded;
};
var $65ae0a43a0950bac$export$a163c218e9f2482b = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $65ae0a43a0950bac$export$b79fdb9ffe29876e = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$af9c11f53d676ebc = {
    pure: $65ae0a43a0950bac$export$c688766eb4789b8c,
    Apply0: function() {
        return $65ae0a43a0950bac$export$a163c218e9f2482b;
    }
};
var $65ae0a43a0950bac$export$7c7cf1e6ee225e25 = {
    Applicative0: function() {
        return $65ae0a43a0950bac$export$af9c11f53d676ebc;
    },
    Bind1: function() {
        return $65ae0a43a0950bac$export$b79fdb9ffe29876e;
    }
};


// Generated by purs version 0.15.16




var $1242d110ab1edcd9$export$286e7113895e33ef = function(x) {
    return x;
};
var $1242d110ab1edcd9$export$84ed1543fc941c9a = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Disj " + (show(v) + ")");
        }
    };
};
var $1242d110ab1edcd9$export$5b0a7c2f35d7a492 = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return {
        zero: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        one: $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra),
        add: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        },
        mul: function(v) {
            return function(v1) {
                return conj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$f23e3b19aa9e04ea = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return {
        append: function(v) {
            return function(v1) {
                return disj(v)(v1);
            };
        }
    };
};
var $1242d110ab1edcd9$export$5f1629868b2a8f7a = function(dictOrd) {
    return dictOrd;
};
var $1242d110ab1edcd9$export$e1c73e5b30670500 = function(dictHeytingAlgebra) {
    var semigroupDisj1 = $1242d110ab1edcd9$export$f23e3b19aa9e04ea(dictHeytingAlgebra);
    return {
        mempty: $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra),
        Semigroup0: function() {
            return semigroupDisj1;
        }
    };
};
var $1242d110ab1edcd9$export$410cd7ab647069e5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $1242d110ab1edcd9$export$3f2868cf248cd7c5 = function(dictEq) {
    return dictEq;
};
var $1242d110ab1edcd9$export$8ab894b15d39baff = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($1242d110ab1edcd9$export$3f2868cf248cd7c5(dictEq));
    }
};
var $1242d110ab1edcd9$export$b2df6a05be54d5b7 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($1242d110ab1edcd9$export$5f1629868b2a8f7a(dictOrd));
    },
    Eq10: function() {
        return $1242d110ab1edcd9$export$8ab894b15d39baff;
    }
};
var $1242d110ab1edcd9$export$fcd058ea94ebee31 = function(dictBounded) {
    return dictBounded;
};
var $1242d110ab1edcd9$export$6e64deb0714631e6 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $1242d110ab1edcd9$export$997bc439fd07ce0b = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$a5d698d68d7ba6f5 = {
    pure: $1242d110ab1edcd9$export$286e7113895e33ef,
    Apply0: function() {
        return $1242d110ab1edcd9$export$6e64deb0714631e6;
    }
};
var $1242d110ab1edcd9$export$15ab4d3c125d7ac0 = {
    Applicative0: function() {
        return $1242d110ab1edcd9$export$a5d698d68d7ba6f5;
    },
    Bind1: function() {
        return $1242d110ab1edcd9$export$997bc439fd07ce0b;
    }
};


// Generated by purs version 0.15.16





var $8257f7a36ab9f9cd$export$c26a72e8d91adeec = function(x) {
    return x;
};
var $8257f7a36ab9f9cd$export$367774d50e2e283e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Dual " + (show(v) + ")");
        }
    };
};
var $8257f7a36ab9f9cd$export$dc7d4cd4865fc48 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return append1(v1)(v);
            };
        }
    };
};
var $8257f7a36ab9f9cd$export$baedc2c70a4ae2b1 = function(dictOrd) {
    return dictOrd;
};
var $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb = function(dictMonoid) {
    var semigroupDual1 = $8257f7a36ab9f9cd$export$dc7d4cd4865fc48(dictMonoid.Semigroup0());
    return {
        mempty: $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid),
        Semigroup0: function() {
            return semigroupDual1;
        }
    };
};
var $8257f7a36ab9f9cd$export$916a3957c09e9ed5 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $8257f7a36ab9f9cd$export$2b6bf0b2b79b7623 = function(dictEq) {
    return dictEq;
};
var $8257f7a36ab9f9cd$export$334c9b177d56941 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($8257f7a36ab9f9cd$export$2b6bf0b2b79b7623(dictEq));
    }
};
var $8257f7a36ab9f9cd$export$f00e1ac1e19e7381 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($8257f7a36ab9f9cd$export$baedc2c70a4ae2b1(dictOrd));
    },
    Eq10: function() {
        return $8257f7a36ab9f9cd$export$334c9b177d56941;
    }
};
var $8257f7a36ab9f9cd$export$5a3916bf05e599b0 = function(dictBounded) {
    return dictBounded;
};
var $8257f7a36ab9f9cd$export$9e642462d19ab815 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $8257f7a36ab9f9cd$export$307a1784edb0cbc9 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$f853c12137409deb = {
    pure: $8257f7a36ab9f9cd$export$c26a72e8d91adeec,
    Apply0: function() {
        return $8257f7a36ab9f9cd$export$9e642462d19ab815;
    }
};
var $8257f7a36ab9f9cd$export$965738b694a4882b = {
    Applicative0: function() {
        return $8257f7a36ab9f9cd$export$f853c12137409deb;
    },
    Bind1: function() {
        return $8257f7a36ab9f9cd$export$307a1784edb0cbc9;
    }
};


// Generated by purs version 0.15.16



var $57b8542ac3131c5d$export$6aef3ff797629bec = function(x) {
    return x;
};
var $57b8542ac3131c5d$export$e6887fe542fcbae3 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Endo " + (show(v) + ")");
        }
    };
};
var $57b8542ac3131c5d$export$5f7c224ff60452b9 = function(dictSemigroupoid) {
    var compose = $5807467a73465f3c$export$f672e0b6f7222cd7(dictSemigroupoid);
    return {
        append: function(v) {
            return function(v1) {
                return compose(v)(v1);
            };
        }
    };
};
var $57b8542ac3131c5d$export$5f95a5e6b940187f = function(dictOrd) {
    return dictOrd;
};
var $57b8542ac3131c5d$export$947ca1a8eed6111 = function(dictCategory) {
    var semigroupEndo1 = $57b8542ac3131c5d$export$5f7c224ff60452b9(dictCategory.Semigroupoid0());
    return {
        mempty: $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory),
        Semigroup0: function() {
            return semigroupEndo1;
        }
    };
};
var $57b8542ac3131c5d$export$ee65626e0479baec = function(dictEq) {
    return dictEq;
};
var $57b8542ac3131c5d$export$35b120d2f621b3e2 = function(dictBounded) {
    return dictBounded;
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
// module Unsafe.Coerce
const $ac8b3532514ac019$export$401372c57776dc = function(x) {
    return x;
};




var $a4e6c090e9e673b6$export$8c14e57e778d3873 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};


var $4fa4836228a192cc$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $4fa4836228a192cc$export$4997ffc0176396a6 = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$wrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $4fa4836228a192cc$export$debb760848ca95a = function() {
    return $4fa4836228a192cc$var$coerce;
};
var $4fa4836228a192cc$var$unwrap1 = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fa4836228a192cc$export$5ac000a3404ef088 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$18fe6ced65b9d3a7 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$9824f93a497ba98e = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$3b98aa7d576b2b80 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$a2a39c9747f0e54a = function() {
    return function(v) {
        return $4fa4836228a192cc$var$unwrap1;
    };
};
var $4fa4836228a192cc$export$df3f009e3d155b20 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$f2787354896befb9 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$d0d3897f12fa9d17 = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$e8dd23d7349f1a08 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$fb4902fd9e525693 = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$cbef643c6d6f42c2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$130c32806db3fdc8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$bae63404e9252557 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$940059b52273aa56 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$b77ba17f6321a9fb = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$59af3bbd6a00f6a9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$78c87ff68dcb8da2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4fa4836228a192cc$export$3ff57735a52b8713 = function() {
    return function(fn) {
        return function(t) {
            return $4fa4836228a192cc$var$wrap1(fn($4fa4836228a192cc$var$unwrap1(t)));
        };
    };
};
var $4fa4836228a192cc$export$bb44f104e3c54dae = function() {
    return function() {
        return function(v) {
            return $4fa4836228a192cc$var$coerce;
        };
    };
};
var $4fa4836228a192cc$export$b533eaec53aab18a = function() {
    return function() {
        return function() {
            return function() {
                return function(v) {
                    return $4fa4836228a192cc$var$coerce;
                };
            };
        };
    };
};
var $4fa4836228a192cc$export$7317c19c5df48291 = function() {
    return function() {
        return function() {
            return function(v) {
                return function(f) {
                    return $4fa4836228a192cc$var$coerce(f($4fa4836228a192cc$var$wrap1));
                };
            };
        };
    };
};







var $4fe7b6acfba7f29f$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $4fe7b6acfba7f29f$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4fe7b6acfba7f29f$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4fe7b6acfba7f29f$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($4fe7b6acfba7f29f$var$monoidEndo);
var $4fe7b6acfba7f29f$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf = function(dict) {
    return dict.foldr;
};
var $4fe7b6acfba7f29f$export$f14ab6cb4b8e359c = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(idx) {
        var go = function(a) {
            return function(cursor) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $292 = cursor.pos === idx;
                if ($292) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $451 = foldr2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($452) {
            return function(v) {
                return v.elem;
            }($451($452));
        };
    };
};
var $4fe7b6acfba7f29f$export$7b1b591b262c240 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)(function(v) {
        return function(v1) {
            return false;
        };
    })(true);
};
var $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        return foldr2($75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0()))($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus));
    };
};
var $4fe7b6acfba7f29f$export$79f3cac53daaaae6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictPlus) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0());
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        return function(f) {
            return foldr2(function($453) {
                return alt(f($453));
            })(empty);
        };
    };
};
var $4fe7b6acfba7f29f$export$33f63ccdb08d8723 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldable) {
        var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return function(f) {
            return foldr2(function($454) {
                return applySecond(f($454));
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $4fe7b6acfba7f29f$export$9747ee7caa0b40b1 = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse_1(dictFoldable));
    };
};
var $4fe7b6acfba7f29f$export$4426b9bff8b7b6fb = function(dictApplicative) {
    var traverse_1 = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
    return function(dictFoldable) {
        return traverse_1(dictFoldable)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$50ae948ca12cdcbc = function(dict) {
    return dict.foldl;
};
var $4fe7b6acfba7f29f$export$fe35754984712af1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(idx) {
        var go = function(cursor) {
            return function(a) {
                if (cursor.elem instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cursor;
                var $296 = cursor.pos === idx;
                if ($296) return {
                    elem: new $06733ae99ed4f534$export$8a67b48435b5d073(a),
                    pos: cursor.pos
                };
                return {
                    pos: cursor.pos + 1 | 0,
                    elem: cursor.elem
                };
            };
        };
        var $455 = foldl2(go)({
            elem: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            pos: 0
        });
        return function($456) {
            return function(v) {
                return v.elem;
            }($455($456));
        };
    };
};
var $4fe7b6acfba7f29f$export$739ec22334c44788 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(sep) {
            return function(xs) {
                var go = function(v) {
                    return function(v1) {
                        if (v.init) return {
                            init: false,
                            acc: v1
                        };
                        return {
                            init: false,
                            acc: append(v.acc)(append(sep)(v1))
                        };
                    };
                };
                return foldl2(go)({
                    init: true,
                    acc: mempty
                })(xs).acc;
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$f24224f1c91d8156 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        var add1 = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
        var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
        return foldl2(function(c) {
            return function(v) {
                return add1(one)(c);
            };
        })($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$c42fa06aba2a552c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var max$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $303 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$b023c82b48e70453.value);
                    if ($303) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 441, column 3 - line 441, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(max$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$b25e0be55f42c9a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$c42fa06aba2a552c(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$b65392d958998255 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(cmp) {
        var min$prime = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    var $307 = $4fe7b6acfba7f29f$var$eq1(cmp(v.value0)(v1))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                    if ($307) return v.value0;
                    return v1;
                }());
                throw new Error("Failed pattern match at Data.Foldable (line 454, column 3 - line 454, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        return foldl2(min$prime)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$916782c1f0ddb132 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$b65392d958998255(dictFoldable)(compare);
    };
};
var $4fe7b6acfba7f29f$export$dbd0f18357df1ddd = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring))($c0e822be92afc4df$export$80bf7733f1207381(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$8a63f25cc62965f1 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictSemiring) {
        return foldl2($c0e822be92afc4df$export$e16d8520af44a096(dictSemiring))($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring));
    };
};
var $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v.value1)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v.value1);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$9519b6731ae6781c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$ff97dbee91e727b6 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return mempty;
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 138, column 1 - line 144, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$3c076fb5bbc5428f = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6a194eaac00c1ff4 = {
    foldr: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldl: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(v1.value0);
                throw new Error("Failed pattern match at Data.Foldable (line 181, column 1 - line 187, column 28): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$fbf8f11f9a917de3 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$6857d056e9f0762d = {
    foldr: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldl: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$b0c90191a04a5815 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a3b6f6613d3d5767 = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return f(v)(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return f(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$edac6f86a9ee0bec = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldr2(function(x) {
                return function(acc) {
                    return append(f(x))(acc);
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$e97014618a7eb593 = {
    foldr: $44c597fdc38e7b03$export$6332150c6d01d807,
    foldl: $44c597fdc38e7b03$export$6b86e13802001a00,
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$edac6f86a9ee0bec($4fe7b6acfba7f29f$export$e97014618a7eb593)(dictMonoid);
    }
};
var $4fe7b6acfba7f29f$export$1131b47d09454899 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldl2(function(acc) {
                return function(x) {
                    return append(acc)(f(x));
                };
            })(mempty);
        };
    };
};
var $4fe7b6acfba7f29f$export$b66cdc0497d8a99a = function(dict) {
    return dict.foldMap;
};
var $4fe7b6acfba7f29f$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            return function(i) {
                return function(v) {
                    return foldr2(f)(i)(v);
                };
            };
        },
        foldl: function(f) {
            return function(i) {
                return function(v) {
                    return foldl2(f)(i)(v);
                };
            };
        },
        foldMap: function(dictMonoid) {
            var foldMap3 = foldMap2(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMap3(f)(v);
                };
            };
        }
    };
};
var $4fe7b6acfba7f29f$export$5677464b2ea4179d = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(i) {
                    return function(v) {
                        return foldr2($f57f4b701aa7b66e$export$8a83211c878a3f1f(foldr3(f)))(i)(v);
                    };
                };
            },
            foldl: function(f) {
                return function(i) {
                    return function(v) {
                        return foldl2(foldl3(f))(i)(v);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMap4(foldMap5(f))(v);
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$5c9c2b827ab84341 = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldr2(f)(z))(foldr3(f)(z));
                };
            },
            foldl: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldl2(f)(z))(foldl3(f)(z));
                };
            },
            foldMap: function(dictMonoid) {
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMap4(f))(foldMap5(f));
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$d127e049f7f9d81c = {
    foldr: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldr1(f)(z)(v);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(v) {
                return $4fe7b6acfba7f29f$var$foldl1(f)(z)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap2 = $4fe7b6acfba7f29f$var$foldMap1(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMap2(f)(v);
            };
        };
    }
};
var $4fe7b6acfba7f29f$export$a013322ac1f6d3aa = function(dictFoldable) {
    var foldr2 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictFoldable1) {
        var foldr3 = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable1);
        var foldl3 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable1);
        var foldMap3 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable1);
        return {
            foldr: function(f) {
                return function(z) {
                    return function(v) {
                        return foldr2(f)(foldr3(f)(z)(v.value1))(v.value0);
                    };
                };
            },
            foldl: function(f) {
                return function(z) {
                    return function(v) {
                        return foldl3(f)(foldl2(f)(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMap: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMap4 = foldMap2(dictMonoid);
                var foldMap5 = foldMap3(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMap4(f)(v.value0))(foldMap5(f)(v.value1));
                    };
                };
            }
        };
    };
};
var $4fe7b6acfba7f29f$export$e623e8bf74059b22 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap($4fe7b6acfba7f29f$var$unwrap(foldMap2(function() {
                    var $457 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c);
                    return function($458) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($457($458)));
                    };
                }())(xs)))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$9b986141719153e = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $4fe7b6acfba7f29f$var$unwrap(foldMap2(function($459) {
                    return $57b8542ac3131c5d$export$6aef3ff797629bec(c($459));
                })(xs))(u);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$dfc7155ac0343b8 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($92016ca92c497156$export$db2423f7434b7a30);
    return function(dictEq) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(a) {
            var $460 = foldMap2(function(v) {
                var $444 = eq2(a)(v.value0);
                if ($444) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            });
            return function($461) {
                return $4fe7b6acfba7f29f$var$unwrap($460($461));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$7606e2cbf4afaea2 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($4fe7b6acfba7f29f$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(a) {
                        return function(m) {
                            return append(d)(append(t(a))(m));
                        };
                    };
                    return $4fe7b6acfba7f29f$var$unwrap(foldMap2(joined)(f))(d);
                };
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$5a27709e8737ce25 = function(dictFoldable) {
    var surroundMap1 = $4fe7b6acfba7f29f$export$7606e2cbf4afaea2(dictFoldable);
    return function(dictSemigroup) {
        var surroundMap2 = surroundMap1(dictSemigroup);
        return function(d) {
            return surroundMap2(d)($4fe7b6acfba7f29f$var$identity);
        };
    };
};
var $4fe7b6acfba7f29f$export$7a067f9280ad8af0 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(b0) {
                return foldl2(function(b) {
                    return function(a) {
                        return bind(b)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f)(a));
                    };
                })(pure(b0));
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$93e2b83da34ff82a = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictMonoid) {
        return foldMap2(dictMonoid)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$23e5dcedfce4509c = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return p(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$71aa6c912b956294 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v1)) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
                return v;
            };
        };
        return foldl2(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4fe7b6acfba7f29f$export$4154a199d7d90455 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($1242d110ab1edcd9$export$286e7113895e33ef)(foldMap2($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$5bf96401662340b7 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
    return function(dictEq) {
        var $462 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function($463) {
            return any1($462($463));
        };
    };
};
var $4fe7b6acfba7f29f$export$63faa62a0284a4a6 = function(dictFoldable) {
    var elem1 = $4fe7b6acfba7f29f$export$5bf96401662340b7(dictFoldable);
    return function(dictEq) {
        var elem2 = elem1(dictEq);
        return function(x) {
            var $464 = elem2(x);
            return function($465) {
                return !$464($465);
            };
        };
    };
};
var $4fe7b6acfba7f29f$export$252bb8b3bbdf6749 = function(dictFoldable) {
    var any1 = $4fe7b6acfba7f29f$export$4154a199d7d90455(dictFoldable);
    return function(dictHeytingAlgebra) {
        return any1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};
var $4fe7b6acfba7f29f$export$84bf76cd7afc7469 = function(dictFoldable) {
    var foldMap2 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return function(dictHeytingAlgebra) {
        return $4fe7b6acfba7f29f$var$alaF($65ae0a43a0950bac$export$c688766eb4789b8c)(foldMap2($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra)));
    };
};
var $4fe7b6acfba7f29f$export$21c0ac7fe1cef1b8 = function(dictFoldable) {
    var all1 = $4fe7b6acfba7f29f$export$84bf76cd7afc7469(dictFoldable);
    return function(dictHeytingAlgebra) {
        return all1(dictHeytingAlgebra)($4fe7b6acfba7f29f$var$identity);
    };
};



// Generated by purs version 0.15.16
// module Data.Function.Uncurried
const $8f2697950ee155e1$export$c12d67bac152a4ed = function(fn) {
    return function() {
        return fn();
    };
};
const $8f2697950ee155e1$export$b12d5f1f5e196716 = function(fn) {
    /* jshint maxparams: 2 */ return function(a, b) {
        return fn(a)(b);
    };
};
const $8f2697950ee155e1$export$7c6645ed044f896a = function(fn) {
    /* jshint maxparams: 3 */ return function(a, b, c) {
        return fn(a)(b)(c);
    };
};
const $8f2697950ee155e1$export$f9fcbfb8cc9a5d08 = function(fn) {
    /* jshint maxparams: 4 */ return function(a, b, c, d) {
        return fn(a)(b)(c)(d);
    };
};
const $8f2697950ee155e1$export$253781be9f84fbc = function(fn) {
    /* jshint maxparams: 5 */ return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e);
    };
};
const $8f2697950ee155e1$export$5a7e13c76f011743 = function(fn) {
    /* jshint maxparams: 6 */ return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f);
    };
};
const $8f2697950ee155e1$export$72dc4a47844c2067 = function(fn) {
    /* jshint maxparams: 7 */ return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g);
    };
};
const $8f2697950ee155e1$export$f3e23d6db0ceb902 = function(fn) {
    /* jshint maxparams: 8 */ return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h);
    };
};
const $8f2697950ee155e1$export$d6fc3733d257ba4b = function(fn) {
    /* jshint maxparams: 9 */ return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i);
    };
};
const $8f2697950ee155e1$export$55270393dfa2c83f = function(fn) {
    /* jshint maxparams: 10 */ return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j);
    };
};
const $8f2697950ee155e1$export$6114565cacc4a539 = function(fn) {
    return fn();
};
const $8f2697950ee155e1$export$b3f66664347b6e8d = function(fn) {
    return function(a) {
        return function(b) {
            return fn(a, b);
        };
    };
};
const $8f2697950ee155e1$export$dd8987cb9f63b77e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return fn(a, b, c);
            };
        };
    };
};
const $8f2697950ee155e1$export$c4d34fab9eba1901 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return fn(a, b, c, d);
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$ce6386a175247406 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return fn(a, b, c, d, e);
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$6764cfc4c1bcc63e = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return fn(a, b, c, d, e, f);
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$27ec8d6a229d5fae = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return fn(a, b, c, d, e, f, g);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$8a7620e07ee87dd2 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return fn(a, b, c, d, e, f, g, h);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$a68eb29a6e51700a = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return fn(a, b, c, d, e, f, g, h, i);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $8f2697950ee155e1$export$182286db78b54e73 = function(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return fn(a, b, c, d, e, f, g, h, i, j);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};


var $d587cad88c02b1d0$export$44d12d4204be2f8c = function(f) {
    return f;
};
var $d587cad88c02b1d0$export$31aab8bc8543af98 = function(f) {
    return f;
};



// Generated by purs version 0.15.16
const $63ebef0b12494a84$export$e1e714991b6c2aba = function(f) {
    return function(xs) {
        var l = xs.length;
        var result = Array(l);
        for(var i = 0; i < l; i++)result[i] = f(i)(xs[i]);
        return result;
    };
};



// Generated by purs version 0.15.16






var $10ae0394c8c3139a$export$8ad5d15375e29446 = function(x) {
    return x;
};
var $10ae0394c8c3139a$export$698fc26f8c8bb631 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Const " + (show(v) + ")");
        }
    };
};
var $10ae0394c8c3139a$export$8e644eba3b05046b = function(dictSemiring) {
    return dictSemiring;
};
var $10ae0394c8c3139a$export$8f2711bf2f3160c6 = {
    compose: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $10ae0394c8c3139a$export$6eaf1848e07ae857 = function(dictSemigroup) {
    return dictSemigroup;
};
var $10ae0394c8c3139a$export$e21edfc60fb6207c = function(dictRing) {
    return dictRing;
};
var $10ae0394c8c3139a$export$2dc639aba34e0026 = function(dictOrd) {
    return dictOrd;
};
var $10ae0394c8c3139a$export$ea93befd55cd9816 = {
    Coercible0: function() {
        return undefined;
    }
};
var $10ae0394c8c3139a$export$d484d0b1dc07b605 = function(dictMonoid) {
    return dictMonoid;
};
var $10ae0394c8c3139a$export$208a79db5ecd5bbf = function(dictHeytingAlgebra) {
    return dictHeytingAlgebra;
};
var $10ae0394c8c3139a$export$c03820c48bf31fc8 = {
    map: function(f) {
        return function(m) {
            return m;
        };
    }
};
var $10ae0394c8c3139a$export$30c2a66ea46ad17b = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($10ae0394c8c3139a$export$c03820c48bf31fc8)
};
var $10ae0394c8c3139a$export$aa81c0060845253 = function(dictEuclideanRing) {
    return dictEuclideanRing;
};
var $10ae0394c8c3139a$export$1688a037b5b692da = function(dictEq) {
    return dictEq;
};
var $10ae0394c8c3139a$export$bdb9acf61703c804 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($10ae0394c8c3139a$export$1688a037b5b692da(dictEq));
    return {
        eq1: function(dictEq1) {
            return eq;
        }
    };
};
var $10ae0394c8c3139a$export$87702177ef8adff4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($10ae0394c8c3139a$export$2dc639aba34e0026(dictOrd));
    var eq1Const1 = $10ae0394c8c3139a$export$bdb9acf61703c804(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return compare;
        },
        Eq10: function() {
            return eq1Const1;
        }
    };
};
var $10ae0394c8c3139a$export$c708f2c7ab030e40 = function(dictCommutativeRing) {
    return dictCommutativeRing;
};
var $10ae0394c8c3139a$export$9ca7ce64fd99d2e3 = function(dictBounded) {
    return dictBounded;
};
var $10ae0394c8c3139a$export$b7df7e3b07273a9c = function(dictBooleanAlgebra) {
    return dictBooleanAlgebra;
};
var $10ae0394c8c3139a$export$17ba89632b46bf87 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        apply: function(v) {
            return function(v1) {
                return append1(v)(v1);
            };
        },
        Functor0: function() {
            return $10ae0394c8c3139a$export$c03820c48bf31fc8;
        }
    };
};
var $10ae0394c8c3139a$export$38647a91a5af2717 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyConst1 = $10ae0394c8c3139a$export$17ba89632b46bf87(dictMonoid.Semigroup0());
    return {
        pure: function(v) {
            return mempty;
        },
        Apply0: function() {
            return applyConst1;
        }
    };
};





// Generated by purs version 0.15.16








var $60e028b2ef4ceb5f$export$86fbec116b87613f = function(x) {
    return x;
};
var $60e028b2ef4ceb5f$export$993a94e8f319ddca = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(App " + (show(v) + ")");
        }
    };
};
var $60e028b2ef4ceb5f$export$25412483a1d87cf9 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return lift2(append1)(v)(v1);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$ca15fc0ee645d5ca = function(dictPlus) {
    return dictPlus;
};
var $60e028b2ef4ceb5f$export$d6896dcb1200915c = {
    Coercible0: function() {
        return undefined;
    }
};
var $60e028b2ef4ceb5f$export$4d0b678caa24727 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var semigroupApp1 = $60e028b2ef4ceb5f$export$25412483a1d87cf9(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupApp2 = semigroupApp1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$5dee9c05ece04940 = function(dictMonadPlus) {
    return dictMonadPlus;
};
var $60e028b2ef4ceb5f$export$6a01a2292278ad36 = function(dictMonad) {
    return dictMonad;
};
var $60e028b2ef4ceb5f$export$aef3f1b3df1ccc91 = function(dictLazy) {
    return dictLazy;
};
var $60e028b2ef4ceb5f$export$74e988bb94b714ec = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$d26bca0552b37bb6 = $ac8b3532514ac019$export$401372c57776dc;
var $60e028b2ef4ceb5f$export$e5247fd078351cb8 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $60e028b2ef4ceb5f$export$79ab389dc7ad1e04 = function(dictFunctor) {
    return dictFunctor;
};
var $60e028b2ef4ceb5f$export$4392ba23127b7f7e = function(dictExtend) {
    return dictExtend;
};
var $60e028b2ef4ceb5f$export$ca57ebaecdc7d318 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq11(x)(y);
                };
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$f5438903fac97fd7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare11 = compare1(dictOrd);
        var eqApp2 = eqApp1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare11(x)(y);
                };
            },
            Eq0: function() {
                return eqApp2;
            }
        };
    };
};
var $60e028b2ef4ceb5f$export$878272f7ccf91d14 = function(dictEq1) {
    var eqApp1 = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqApp1(dictEq));
        }
    };
};
var $60e028b2ef4ceb5f$export$594a740e645fec3d = function(dictOrd1) {
    var ordApp1 = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd1);
    var eq1App1 = $60e028b2ef4ceb5f$export$878272f7ccf91d14(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordApp1(dictOrd));
        },
        Eq10: function() {
            return eq1App1;
        }
    };
};
var $60e028b2ef4ceb5f$export$7470af1a1433fe40 = function(dictComonad) {
    return dictComonad;
};
var $60e028b2ef4ceb5f$export$a9edb76092ee7d6f = function(dictBind) {
    return dictBind;
};
var $60e028b2ef4ceb5f$export$e73125860a07eff3 = function(dictApply) {
    return dictApply;
};
var $60e028b2ef4ceb5f$export$3550db4068efefdd = function(dictApplicative) {
    return dictApplicative;
};
var $60e028b2ef4ceb5f$export$afc0b729746e2971 = function(dictAlternative) {
    return dictAlternative;
};
var $60e028b2ef4ceb5f$export$69ee13496a90cde5 = function(dictAlt) {
    return dictAlt;
};


// Generated by purs version 0.15.16









var $6051f44ece6b7171$export$5a3a146e358e1bcf = function(x) {
    return x;
};
var $6051f44ece6b7171$export$48988665210796c9 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Compose " + (show(v) + ")");
        }
    };
};
var $6051f44ece6b7171$export$db82d32400573da6 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6051f44ece6b7171$export$4e14cb014c72d19c = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return map(map1(f))(v);
                };
            }
        };
    };
};
var $6051f44ece6b7171$export$861bef6ec455b19c = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eqApp = $60e028b2ef4ceb5f$export$ca57ebaecdc7d318(dictEq11);
        return function(dictEq) {
            var eq11 = eq1(eqApp(dictEq));
            return {
                eq: function(v) {
                    return function(v1) {
                        return eq11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$71b54a761b111692 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordApp = $60e028b2ef4ceb5f$export$f5438903fac97fd7(dictOrd11);
        var eqCompose2 = eqCompose1(dictOrd11.Eq10());
        return function(dictOrd) {
            var compare11 = compare1(ordApp(dictOrd));
            var eqCompose3 = eqCompose2(dictOrd.Eq0());
            return {
                compare: function(v) {
                    return function(v1) {
                        return compare11($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v))($60e028b2ef4ceb5f$export$d26bca0552b37bb6(v1));
                    };
                },
                Eq0: function() {
                    return eqCompose3;
                }
            };
        };
    };
};
var $6051f44ece6b7171$export$cbe2b7f63279884c = function(dictEq1) {
    var eqCompose1 = $6051f44ece6b7171$export$861bef6ec455b19c(dictEq1);
    return function(dictEq11) {
        var eqCompose2 = eqCompose1(dictEq11);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCompose2(dictEq));
            }
        };
    };
};
var $6051f44ece6b7171$export$d435219eb92d4b50 = function(dictOrd1) {
    var ordCompose1 = $6051f44ece6b7171$export$71b54a761b111692(dictOrd1);
    var eq1Compose1 = $6051f44ece6b7171$export$cbe2b7f63279884c(dictOrd1.Eq10());
    return function(dictOrd11) {
        var ordCompose2 = ordCompose1(dictOrd11);
        var eq1Compose2 = eq1Compose1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordCompose2(dictOrd));
            },
            Eq10: function() {
                return eq1Compose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$6ac747c53920df53 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(natF) {
        return function(natG) {
            return function(v) {
                return natF(map(natG)(v));
            };
        };
    };
};
var $6051f44ece6b7171$export$6b631277dc31d20d = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var Functor0 = dictApply.Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(Functor0);
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorCompose2 = functorCompose1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return apply(map(apply1)(v))(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$ce6787b8eb4a9f48 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyCompose1 = $6051f44ece6b7171$export$6b631277dc31d20d(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var applyCompose2 = applyCompose1(dictApplicative1.Apply0());
        return {
            pure: function() {
                var $112 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
                return function($113) {
                    return $6051f44ece6b7171$export$5a3a146e358e1bcf(pure($112($113)));
                };
            }(),
            Apply0: function() {
                return applyCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$b9fb31044795461 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorCompose1 = $6051f44ece6b7171$export$4e14cb014c72d19c(dictAlt.Functor0());
    return function(dictFunctor) {
        var functorCompose2 = functorCompose1(dictFunctor);
        return {
            alt: function(v) {
                return function(v1) {
                    return alt(v)(v1);
                };
            },
            Functor0: function() {
                return functorCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$2f025d423e425357 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altCompose1 = $6051f44ece6b7171$export$b9fb31044795461(dictPlus.Alt0());
    return function(dictFunctor) {
        var altCompose2 = altCompose1(dictFunctor);
        return {
            empty: empty,
            Alt0: function() {
                return altCompose2;
            }
        };
    };
};
var $6051f44ece6b7171$export$3bf64fe887e680d3 = function(dictAlternative) {
    var applicativeCompose1 = $6051f44ece6b7171$export$ce6787b8eb4a9f48(dictAlternative.Applicative0());
    var plusCompose1 = $6051f44ece6b7171$export$2f025d423e425357(dictAlternative.Plus1());
    return function(dictApplicative) {
        var applicativeCompose2 = applicativeCompose1(dictApplicative);
        var plusCompose2 = plusCompose1(dictApplicative.Apply0().Functor0());
        return {
            Applicative0: function() {
                return applicativeCompose2;
            },
            Plus1: function() {
                return plusCompose2;
            }
        };
    };
};



// Generated by purs version 0.15.16











var $a2051f9edf3d1db6$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $a2051f9edf3d1db6$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $a2051f9edf3d1db6$export$264ad599d7cef668 = function(x) {
    return x;
};
var $a2051f9edf3d1db6$export$821c121fea76e4f5 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(product " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $a2051f9edf3d1db6$export$dbd0f18357df1ddd = function(fa) {
    return function(ga) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fa, ga);
    };
};
var $a2051f9edf3d1db6$export$7ea85e95f1a9febc = {
    Coercible0: function() {
        return undefined;
    }
};
var $a2051f9edf3d1db6$export$e5b52224642d1f48 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFunctor1) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
        return {
            map: function(f) {
                return function(v) {
                    return $a2051f9edf3d1db6$var$bimap(map(f))(map1(f))(v);
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$df541bd41566d1a7 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq11) {
        var eq11 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq11);
        return {
            eq1: function(dictEq) {
                var eq12 = eq1(dictEq);
                var eq13 = eq11(dictEq);
                return function(v) {
                    return function(v1) {
                        return eq12(v.value0)(v1.value0) && eq13(v.value1)(v1.value1);
                    };
                };
            }
        };
    };
};
var $a2051f9edf3d1db6$export$e82658b20fc49a26 = function(dictEq1) {
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictEq1);
    return function(dictEq11) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(eq1Product1(dictEq11));
        return function(dictEq) {
            return {
                eq: eq1(dictEq)
            };
        };
    };
};
var $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eq1Product1 = $a2051f9edf3d1db6$export$df541bd41566d1a7(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare11 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd11);
        var eq1Product2 = eq1Product1(dictOrd11.Eq10());
        return {
            compare1: function(dictOrd) {
                var compare12 = compare1(dictOrd);
                var compare13 = compare11(dictOrd);
                return function(v) {
                    return function(v1) {
                        var v2 = compare12(v.value0)(v1.value0);
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return compare13(v.value1)(v1.value1);
                        return v2;
                    };
                };
            },
            Eq10: function() {
                return eq1Product2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$96856f3fc4c91454 = function(dictOrd1) {
    var ord1Product1 = $a2051f9edf3d1db6$export$b9dd7b4b85c7c1b7(dictOrd1);
    var eqProduct1 = $a2051f9edf3d1db6$export$e82658b20fc49a26(dictOrd1.Eq10());
    return function(dictOrd11) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(ord1Product1(dictOrd11));
        var eqProduct2 = eqProduct1(dictOrd11.Eq10());
        return function(dictOrd) {
            var eqProduct3 = eqProduct2(dictOrd.Eq0());
            return {
                compare: compare1(dictOrd),
                Eq0: function() {
                    return eqProduct3;
                }
            };
        };
    };
};
var $a2051f9edf3d1db6$export$a3738445608c58d6 = function(natF) {
    return function(natG) {
        return function(v) {
            return $a2051f9edf3d1db6$var$bimap(natF)(natG)(v);
        };
    };
};
var $a2051f9edf3d1db6$export$893d0f454e6dfaee = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorProduct1 = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictApply.Functor0());
    return function(dictApply1) {
        var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply1);
        var functorProduct2 = functorProduct1(dictApply1.Functor0());
        return {
            apply: function(v) {
                return function(v1) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(apply(v.value0)(v1.value0))(apply1(v.value1)(v1.value1));
                };
            },
            Functor0: function() {
                return functorProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$5990c3ca6a566877 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictBind.Apply0());
    return function(dictBind1) {
        var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictBind1);
        var applyProduct2 = applyProduct1(dictBind1.Apply0());
        return {
            bind: function(v) {
                return function(f) {
                    return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(bind(v.value0)(function($128) {
                        return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($a2051f9edf3d1db6$var$unwrap(f($128)));
                    }))(bind1(v.value1)(function($129) {
                        return $71f2e2e9476163f8$export$6f71268a1666ab58($a2051f9edf3d1db6$var$unwrap(f($129)));
                    }));
                };
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2034ae3acf01a9af = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyProduct1 = $a2051f9edf3d1db6$export$893d0f454e6dfaee(dictApplicative.Apply0());
    return function(dictApplicative1) {
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative1);
        var applyProduct2 = applyProduct1(dictApplicative1.Apply0());
        return {
            pure: function(a) {
                return $a2051f9edf3d1db6$export$dbd0f18357df1ddd(pure(a))(pure1(a));
            },
            Apply0: function() {
                return applyProduct2;
            }
        };
    };
};
var $a2051f9edf3d1db6$export$2dfe129c60aea5cb = function(dictMonad) {
    var applicativeProduct1 = $a2051f9edf3d1db6$export$2034ae3acf01a9af(dictMonad.Applicative0());
    var bindProduct1 = $a2051f9edf3d1db6$export$5990c3ca6a566877(dictMonad.Bind1());
    return function(dictMonad1) {
        var applicativeProduct2 = applicativeProduct1(dictMonad1.Applicative0());
        var bindProduct2 = bindProduct1(dictMonad1.Bind1());
        return {
            Applicative0: function() {
                return applicativeProduct2;
            },
            Bind1: function() {
                return bindProduct2;
            }
        };
    };
};





// Generated by purs version 0.15.16




var $1b4bd570fcdcddf2$export$bed9238d8933c9a8 = function(x) {
    return x;
};
var $1b4bd570fcdcddf2$export$1e0d830d3054d46d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($06733ae99ed4f534$export$9b814e760fdd264a(dictShow));
    return {
        show: function(v) {
            return "(Last " + (show(v) + ")");
        }
    };
};
var $1b4bd570fcdcddf2$export$6d3c4648150c5bae = {
    append: function(v) {
        return function(v1) {
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v1;
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
            throw new Error("Failed pattern match at Data.Maybe.Last (line 54, column 1 - line 56, column 36): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $1b4bd570fcdcddf2$export$4ded69d4b0c99b7b = function(dictOrd) {
    return $06733ae99ed4f534$export$e35c29f98d259c46(dictOrd);
};
var $1b4bd570fcdcddf2$export$64bd44ceff2f4638 = $06733ae99ed4f534$export$c82772423d5de0b;
var $1b4bd570fcdcddf2$export$ccaccac244187f64 = {
    Coercible0: function() {
        return undefined;
    }
};
var $1b4bd570fcdcddf2$export$862bb074dbe2690f = /* #__PURE__ */ function() {
    return {
        mempty: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        Semigroup0: function() {
            return $1b4bd570fcdcddf2$export$6d3c4648150c5bae;
        }
    };
}();
var $1b4bd570fcdcddf2$export$25d122cd3cbaf721 = $06733ae99ed4f534$export$f78a1c2d38efcc13;
var $1b4bd570fcdcddf2$export$21558e167578c47d = $06733ae99ed4f534$export$62eda6ff839a0571;
var $1b4bd570fcdcddf2$export$74aba74241121413 = $06733ae99ed4f534$export$fdd2427f0e60fd66;
var $1b4bd570fcdcddf2$export$7f096d1e61d1725f = $06733ae99ed4f534$export$cb6d304dbd10aa95;
var $1b4bd570fcdcddf2$export$4dd70ef4fbe4d1f3 = function(dictEq) {
    return $06733ae99ed4f534$export$8f45bb76abf9699e(dictEq);
};
var $1b4bd570fcdcddf2$export$634a54207b73ac14 = $06733ae99ed4f534$export$b59095d05faa8cf6;
var $1b4bd570fcdcddf2$export$835f68c2f339b021 = function(dictBounded) {
    return $06733ae99ed4f534$export$158982e65b249847(dictBounded);
};
var $1b4bd570fcdcddf2$export$f2b93d1f1ac78d51 = $06733ae99ed4f534$export$e5fea5661dee377;
var $1b4bd570fcdcddf2$export$dcd798c84777f95 = $06733ae99ed4f534$export$22d9917da16590e7;
var $1b4bd570fcdcddf2$export$5b4de68c5dd33934 = $06733ae99ed4f534$export$b203ef4465f15037;
var $1b4bd570fcdcddf2$export$a0374697fe7c8648 = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($1b4bd570fcdcddf2$export$6d3c4648150c5bae),
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $1b4bd570fcdcddf2$export$1bb9770eb80691dd = {
    empty: /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($1b4bd570fcdcddf2$export$862bb074dbe2690f),
    Alt0: function() {
        return $1b4bd570fcdcddf2$export$a0374697fe7c8648;
    }
};
var $1b4bd570fcdcddf2$export$bc87013f8f3da20e = {
    Applicative0: function() {
        return $1b4bd570fcdcddf2$export$5b4de68c5dd33934;
    },
    Plus1: function() {
        return $1b4bd570fcdcddf2$export$1bb9770eb80691dd;
    }
};


// Generated by purs version 0.15.16




var $e48f2e41a907ae60$export$14f8ce08180a98e1 = function(x) {
    return x;
};
var $e48f2e41a907ae60$export$d0709814982cbf95 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Additive " + (show(v) + ")");
        }
    };
};
var $e48f2e41a907ae60$export$8adb2de2291fe34 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return add(v)(v1);
            };
        }
    };
};
var $e48f2e41a907ae60$export$45e15fb7ca2189d8 = function(dictOrd) {
    return dictOrd;
};
var $e48f2e41a907ae60$export$c38b62d29991685f = function(dictSemiring) {
    var semigroupAdditive1 = $e48f2e41a907ae60$export$8adb2de2291fe34(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring),
        Semigroup0: function() {
            return semigroupAdditive1;
        }
    };
};
var $e48f2e41a907ae60$export$ba106ed6ee21ba26 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $e48f2e41a907ae60$export$7e0cae55dbdaa6a6 = function(dictEq) {
    return dictEq;
};
var $e48f2e41a907ae60$export$3bc4d3e676a5f3ba = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($e48f2e41a907ae60$export$7e0cae55dbdaa6a6(dictEq));
    }
};
var $e48f2e41a907ae60$export$bf0109c88461ccc9 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($e48f2e41a907ae60$export$45e15fb7ca2189d8(dictOrd));
    },
    Eq10: function() {
        return $e48f2e41a907ae60$export$3bc4d3e676a5f3ba;
    }
};
var $e48f2e41a907ae60$export$ac1ed4a2f2107898 = function(dictBounded) {
    return dictBounded;
};
var $e48f2e41a907ae60$export$9ed13d4e91f74d66 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};
var $e48f2e41a907ae60$export$3c0293aa90d839fe = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$3f78fbeb96209a2 = {
    pure: $e48f2e41a907ae60$export$14f8ce08180a98e1,
    Apply0: function() {
        return $e48f2e41a907ae60$export$9ed13d4e91f74d66;
    }
};
var $e48f2e41a907ae60$export$50439d128d692efb = {
    Applicative0: function() {
        return $e48f2e41a907ae60$export$3f78fbeb96209a2;
    },
    Bind1: function() {
        return $e48f2e41a907ae60$export$3c0293aa90d839fe;
    }
};





// Generated by purs version 0.15.16




var $665413393090e9d0$export$d0198c9c86fc2be1 = function(x) {
    return x;
};
var $665413393090e9d0$export$27987c20bfe6da1c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Multiplicative " + (show(v) + ")");
        }
    };
};
var $665413393090e9d0$export$879165283e0876da = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        append: function(v) {
            return function(v1) {
                return mul(v)(v1);
            };
        }
    };
};
var $665413393090e9d0$export$a745aa1873a0c2a6 = function(dictOrd) {
    return dictOrd;
};
var $665413393090e9d0$export$b1fd47ce92821578 = function(dictSemiring) {
    var semigroupMultiplicative1 = $665413393090e9d0$export$879165283e0876da(dictSemiring);
    return {
        mempty: $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring),
        Semigroup0: function() {
            return semigroupMultiplicative1;
        }
    };
};
var $665413393090e9d0$export$fb489b392661d391 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $665413393090e9d0$export$d7079d8ae90b8bb4 = function(dictEq) {
    return dictEq;
};
var $665413393090e9d0$export$989c1e5544f0c166 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($665413393090e9d0$export$d7079d8ae90b8bb4(dictEq));
    }
};
var $665413393090e9d0$export$fecaa24314ae6d78 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($665413393090e9d0$export$a745aa1873a0c2a6(dictOrd));
    },
    Eq10: function() {
        return $665413393090e9d0$export$989c1e5544f0c166;
    }
};
var $665413393090e9d0$export$bbf6fde3198eeb4e = function(dictBounded) {
    return dictBounded;
};
var $665413393090e9d0$export$4270b48d12c8e2c9 = {
    apply: function(v) {
        return function(v1) {
            return v(v1);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $665413393090e9d0$export$b787e2c352a5d886 = {
    bind: function(v) {
        return function(f) {
            return f(v);
        };
    },
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$98fc700c14e70ff0 = {
    pure: $665413393090e9d0$export$d0198c9c86fc2be1,
    Apply0: function() {
        return $665413393090e9d0$export$4270b48d12c8e2c9;
    }
};
var $665413393090e9d0$export$8980d206f063bc12 = {
    Applicative0: function() {
        return $665413393090e9d0$export$98fc700c14e70ff0;
    },
    Bind1: function() {
        return $665413393090e9d0$export$b787e2c352a5d886;
    }
};




var $334541180b4ef18c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $334541180b4ef18c$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188);
var $334541180b4ef18c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($665413393090e9d0$export$fb489b392661d391);
var $334541180b4ef18c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $334541180b4ef18c$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1b4bd570fcdcddf2$export$74aba74241121413);
var $334541180b4ef18c$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($92016ca92c497156$export$98d9d13e8b5bfe4d);
var $334541180b4ef18c$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $334541180b4ef18c$var$map6 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8257f7a36ab9f9cd$export$916a3957c09e9ed5);
var $334541180b4ef18c$var$map7 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($1242d110ab1edcd9$export$410cd7ab647069e5);
var $334541180b4ef18c$var$bimap1 = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$9b66d4861c364eff);
var $334541180b4ef18c$var$map8 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($65ae0a43a0950bac$export$48b7cf0194537bca);
var $334541180b4ef18c$var$map9 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($e48f2e41a907ae60$export$ba106ed6ee21ba26);
var $334541180b4ef18c$export$8f07ddce13659f50 = function(dict) {
    return dict.mapWithIndex;
};
var $334541180b4ef18c$export$6942612de3ba9e09 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    return function(f) {
        return mapWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $334541180b4ef18c$export$98b99a3e5a5c2768 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    }
};
var $334541180b4ef18c$export$341bcd9812b20e54 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorProduct1 = functorProduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap(mapWithIndex1(function($63) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($63));
                    }))(mapWithIndex2(function($64) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($64));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorProduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$3f7256b7802d7d35 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    }
};
var $334541180b4ef18c$export$ff6e9b408c0f1d0a = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    }
};
var $334541180b4ef18c$export$67874b1834c6566b = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    }
};
var $334541180b4ef18c$export$26258e29c904633d = {
    mapWithIndex: function(f) {
        return function(v) {
            return f($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $334541180b4ef18c$export$707dfb58df7f6e4f = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    }
};
var $334541180b4ef18c$export$381e44b6c18f93d6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    }
};
var $334541180b4ef18c$export$50b3765d14980fc = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    }
};
var $334541180b4ef18c$export$b6070cf53db1d339 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    }
};
var $334541180b4ef18c$export$6f7aa172554aa552 = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCoproduct1 = functorCoproduct(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return $334541180b4ef18c$var$bimap1(mapWithIndex1(function($65) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($65));
                    }))(mapWithIndex2(function($66) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($66));
                    }))(v);
                };
            },
            Functor0: function() {
                return functorCoproduct1;
            }
        };
    };
};
var $334541180b4ef18c$export$dba6a24121753c2b = {
    mapWithIndex: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    }
};
var $334541180b4ef18c$export$8ba1941ba7d99c6 = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map8(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    }
};
var $334541180b4ef18c$export$7935f2d7643e66ce = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictFunctorWithIndex.Functor0());
    return function(dictFunctorWithIndex1) {
        var mapWithIndex2 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex1);
        var functorCompose1 = functorCompose(dictFunctorWithIndex1.Functor0());
        return {
            mapWithIndex: function(f) {
                return function(v) {
                    return mapWithIndex1(function() {
                        var $67 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                        return function($68) {
                            return mapWithIndex2($67($68));
                        };
                    }())(v);
                };
            },
            Functor0: function() {
                return functorCompose1;
            }
        };
    };
};
var $334541180b4ef18c$export$f10d51ea0aa3da42 = {
    mapWithIndex: $63ebef0b12494a84$export$e1e714991b6c2aba,
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    }
};
var $334541180b4ef18c$export$ffe1008ccae78edc = function(dictFunctorWithIndex) {
    var mapWithIndex1 = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return mapWithIndex1(f)(v);
            };
        },
        Functor0: function() {
            return functorApp;
        }
    };
};
var $334541180b4ef18c$export$eee3f4036a1ebada = {
    mapWithIndex: function(f) {
        return $334541180b4ef18c$var$map9(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    }
};






// Generated by purs version 0.15.16
// jshint maxparams: 3
const $e2e7171b55349aa8$export$778bf95e3da1fa51 = function() {
    function array1(a) {
        return [
            a
        ];
    }
    function array2(a) {
        return function(b) {
            return [
                a,
                b
            ];
        };
    }
    function array3(a) {
        return function(b) {
            return function(c) {
                return [
                    a,
                    b,
                    c
                ];
            };
        };
    }
    function concat2(xs) {
        return function(ys) {
            return xs.concat(ys);
        };
    }
    return function(apply) {
        return function(map) {
            return function(pure) {
                return function(f) {
                    return function(array) {
                        function go(bot, top) {
                            switch(top - bot){
                                case 0:
                                    return pure([]);
                                case 1:
                                    return map(array1)(f(array[bot]));
                                case 2:
                                    return apply(map(array2)(f(array[bot])))(f(array[bot + 1]));
                                case 3:
                                    return apply(apply(map(array3)(f(array[bot])))(f(array[bot + 1])))(f(array[bot + 2]));
                                default:
                                    // This slightly tricky pivot selection aims to produce two
                                    // even-length partitions where possible.
                                    var pivot = bot + Math.floor((top - bot) / 4) * 2;
                                    return apply(map(concat2)(go(bot, pivot)))(go(pivot, top));
                            }
                        }
                        return go(0, array.length);
                    };
                };
            };
        };
    };
}();






















// Generated by purs version 0.15.16


// Generated by purs version 0.15.16
var $b5a91a6cc4fccdbd$export$e55c55b7b44ad601 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$28dda4bfb631a565 = function(x) {
    return x;
};
var $b5a91a6cc4fccdbd$export$8c9fed8401f25951 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$25c41c6231a79e25 = function(v) {
    return v;
};
var $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$b9d5be898ea82056 = {
    map: function(f) {
        return function(k) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(k)(s);
                return {
                    accum: v.accum,
                    value: f(v.value)
                };
            };
        };
    }
};
var $b5a91a6cc4fccdbd$export$68347817ab3710ea = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(x)(s);
                var v1 = $b5a91a6cc4fccdbd$export$8c9fed8401f25951(f)(v.accum);
                return {
                    accum: v1.accum,
                    value: v1.value(v.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$c9b79b3c57c3d6cd;
    }
};
var $b5a91a6cc4fccdbd$export$d997dc0aadd0b300 = {
    apply: function(f) {
        return function(x) {
            return function(s) {
                var v = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(f)(s);
                var v1 = $b5a91a6cc4fccdbd$export$25c41c6231a79e25(x)(v.accum);
                return {
                    accum: v1.accum,
                    value: v.value(v1.value)
                };
            };
        };
    },
    Functor0: function() {
        return $b5a91a6cc4fccdbd$export$b9d5be898ea82056;
    }
};
var $b5a91a6cc4fccdbd$export$c4ee441de2fba0d9 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$68347817ab3710ea;
    }
};
var $b5a91a6cc4fccdbd$export$9fd2229713491b84 = {
    pure: function(a) {
        return function(s) {
            return {
                accum: s,
                value: a
            };
        };
    },
    Apply0: function() {
        return $b5a91a6cc4fccdbd$export$d997dc0aadd0b300;
    }
};



var $11d1e86de605dfc6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $11d1e86de605dfc6$export$df3f009e3d155b20 = function(dict) {
    return dict.traverse;
};
var $11d1e86de605dfc6$export$d35878ee42638401 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Functor0: function() {
        return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $11d1e86de605dfc6$export$b86a2d00788e21b6 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($665413393090e9d0$export$d0198c9c86fc2be1)(v);
        };
    },
    Functor0: function() {
        return $665413393090e9d0$export$fb489b392661d391;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $11d1e86de605dfc6$export$80f6258c17467741 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map($06733ae99ed4f534$export$8a67b48435b5d073.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 115, column 1 - line 119, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $06733ae99ed4f534$export$fdd2427f0e60fd66;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $11d1e86de605dfc6$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$63e84f34fb558532 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $11d1e86de605dfc6$export$29eea1300519490d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v(v1.value0));
                throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0));
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value0);
            throw new Error("Failed pattern match at Data.Traversable (line 149, column 1 - line 153, column 36): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $7d4cccdf062a2261$export$f0a413d3d6075601;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $11d1e86de605dfc6$export$54df524caf88dbea = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(v);
        };
    },
    Functor0: function() {
        return $8257f7a36ab9f9cd$export$916a3957c09e9ed5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $11d1e86de605dfc6$export$a73c18000a1a08d7 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($1242d110ab1edcd9$export$286e7113895e33ef)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($1242d110ab1edcd9$export$286e7113895e33ef)(v);
        };
    },
    Functor0: function() {
        return $1242d110ab1edcd9$export$410cd7ab647069e5;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $11d1e86de605dfc6$export$e6d8402c3fd7d14d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return pure(v);
        };
    },
    Functor0: function() {
        return $10ae0394c8c3139a$export$c03820c48bf31fc8;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $11d1e86de605dfc6$export$ecbf0d941e1ac029 = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($65ae0a43a0950bac$export$c688766eb4789b8c)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($65ae0a43a0950bac$export$c688766eb4789b8c)(v);
        };
    },
    Functor0: function() {
        return $65ae0a43a0950bac$export$48b7cf0194537bca;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $11d1e86de605dfc6$export$8c91a5391205dbe = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorCompose = $6051f44ece6b7171$export$4e14cb014c72d19c(dictTraversable.Functor0());
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var functorCompose1 = functorCompose(dictTraversable1.Functor0());
        var foldableCompose1 = foldableCompose(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverse4(traverse5(f))(v));
                    };
                };
            },
            sequence: function(dictApplicative) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversable)(dictTraversable1))(dictApplicative)($11d1e86de605dfc6$var$identity);
            },
            Functor0: function() {
                return functorCompose1;
            },
            Foldable1: function() {
                return foldableCompose1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$617ac6e03fd9951c = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(f(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($e48f2e41a907ae60$export$14f8ce08180a98e1)(v);
        };
    },
    Functor0: function() {
        return $e48f2e41a907ae60$export$ba106ed6ee21ba26;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $11d1e86de605dfc6$export$417d88f64c497aed = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    return function(dictApplicative) {
        return traverse2(dictApplicative)($11d1e86de605dfc6$var$identity);
    };
};
var $11d1e86de605dfc6$export$9e4a28683e28e26a = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        return $e2e7171b55349aa8$export$778bf95e3da1fa51($7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0))($f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0()))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative));
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($11d1e86de605dfc6$export$9e4a28683e28e26a)(dictApplicative);
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$2330f868b62ed546;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $11d1e86de605dfc6$export$49bb65c2ea163039 = function(dict) {
    return dict.sequence;
};
var $11d1e86de605dfc6$var$sequence1 = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$80f6258c17467741);
var $11d1e86de605dfc6$export$744e1c7707f1991f = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorApp = $60e028b2ef4ceb5f$export$79ab389dc7ad1e04(dictTraversable.Functor0());
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse3 = traverse2(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverse3(f)(v));
                };
            };
        },
        sequence: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var sequence3 = sequence2(dictApplicative);
            return function(v) {
                return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(sequence3(v));
            };
        },
        Functor0: function() {
            return functorApp;
        },
        Foldable1: function() {
            return foldableApp;
        }
    };
};
var $11d1e86de605dfc6$export$78124b32135c203a = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorCoproduct = $490ec114b4138e6d$export$e192c0fa89a291cb(dictTraversable.Functor0());
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorCoproduct1 = functorCoproduct(dictTraversable1.Functor0());
        var foldableCoproduct1 = foldableCoproduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $313 = map(function($316) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($316));
                        });
                        var $314 = traverse4(f);
                        return function($315) {
                            return $313($314($315));
                        };
                    }())(function() {
                        var $317 = map(function($320) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($320));
                        });
                        var $318 = traverse5(f);
                        return function($319) {
                            return $317($318($319));
                        };
                    }());
                };
            },
            sequence: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                    var $321 = map(function($324) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($324));
                    });
                    var $322 = sequence2(dictApplicative);
                    return function($323) {
                        return $321($322($323));
                    };
                }())(function() {
                    var $325 = map(function($328) {
                        return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($328));
                    });
                    var $326 = sequence3(dictApplicative);
                    return function($327) {
                        return $325($326($327));
                    };
                }());
            },
            Functor0: function() {
                return functorCoproduct1;
            },
            Foldable1: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$1cee23aad9b21cdc = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($92016ca92c497156$export$b25abba66f7be210)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($92016ca92c497156$export$b25abba66f7be210)(sequence2(v));
        };
    },
    Functor0: function() {
        return $92016ca92c497156$export$98d9d13e8b5bfe4d;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $11d1e86de605dfc6$export$f5923975fb28337f = {
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverse2 = $11d1e86de605dfc6$var$traverse1(dictApplicative);
        return function(f) {
            return function(v) {
                return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(traverse2(f)(v));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence2 = $11d1e86de605dfc6$var$sequence1(dictApplicative);
        return function(v) {
            return map($1b4bd570fcdcddf2$export$bed9238d8933c9a8)(sequence2(v));
        };
    },
    Functor0: function() {
        return $1b4bd570fcdcddf2$export$74aba74241121413;
    },
    Foldable1: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $11d1e86de605dfc6$export$261d8d87b1749d17 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var functorProduct = $a2051f9edf3d1db6$export$e5b52224642d1f48(dictTraversable.Functor0());
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictTraversable.Foldable1());
    return function(dictTraversable1) {
        var traverse3 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable1);
        var sequence3 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable1);
        var functorProduct1 = functorProduct(dictTraversable1.Functor0());
        var foldableProduct1 = foldableProduct(dictTraversable1.Foldable1());
        return {
            traverse: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverse4 = traverse2(dictApplicative);
                var traverse5 = traverse3(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverse4(f)(v.value0))(traverse5(f)(v.value1));
                    };
                };
            },
            sequence: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var sequence4 = sequence2(dictApplicative);
                var sequence5 = sequence3(dictApplicative);
                return function(v) {
                    return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(sequence4(v.value0))(sequence5(v.value1));
                };
            },
            Functor0: function() {
                return functorProduct1;
            },
            Foldable1: function() {
                return foldableProduct1;
            }
        };
    };
};
var $11d1e86de605dfc6$export$d50a9c31d69ee13c = function(dictTraversable) {
    var sequence2 = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable.Functor0());
    return function(dictApplicative) {
        var sequence3 = sequence2(dictApplicative);
        return function(f) {
            return function(ta) {
                return sequence3(map(f)(ta));
            };
        };
    };
};
var $11d1e86de605dfc6$export$d54b12b778292b35 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$64df51ac031d4ad2 = function(dictTraversable) {
    var mapAccumR1 = $11d1e86de605dfc6$export$d54b12b778292b35(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumR1(function(b) {
                    return function(a) {
                        var b$prime = f(a)(b);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$d5f444bb5e0f233 = function(dictTraversable) {
    var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverse2(function(a) {
                    return function(s) {
                        return f(s)(a);
                    };
                })(xs))(s0);
            };
        };
    };
};
var $11d1e86de605dfc6$export$65f513eaf3c582b8 = function(dictTraversable) {
    var mapAccumL1 = $11d1e86de605dfc6$export$d5f444bb5e0f233(dictTraversable);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumL1(function(b) {
                    return function(a) {
                        var b$prime = f(b)(a);
                        return {
                            accum: b$prime,
                            value: b$prime
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $11d1e86de605dfc6$export$f89de2e5bf57e5e6 = function(dictApplicative) {
    return function(dictTraversable) {
        var traverse2 = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
        return function(x) {
            return function(f) {
                return traverse2(f)(x);
            };
        };
    };
};



// Generated by purs version 0.15.16
const $6c33ca7d98a534e5$export$6368c6d238d348f0 = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var maybe = f(value);
                            if (isNothing(maybe)) return result;
                            var tuple = fromJust(maybe);
                            result.push(fst(tuple));
                            value = snd(tuple);
                        }
                    };
                };
            };
        };
    };
};







// Generated by purs version 0.15.16
const $b1275140774187c9$export$e3753a19e82ccedc = function(isNothing) {
    return function(fromJust) {
        return function(fst) {
            return function(snd) {
                return function(f) {
                    return function(b) {
                        var result = [];
                        var value = b;
                        while(true){
                            var tuple = f(value);
                            result.push(fst(tuple));
                            var maybe = snd(tuple);
                            if (isNothing(maybe)) return result;
                            value = fromJust(maybe);
                        }
                    };
                };
            };
        };
    };
};




// Generated by purs version 0.15.16





// Generated by purs version 0.15.16








// Generated by purs version 0.15.16



var $baee932cbcb11133$export$d36c09e5d02927e7 = function(x) {
    return x;
};
var $baee932cbcb11133$export$cbb92fe0a8d77a01 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Max " + (show(v) + ")");
        }
    };
};
var $baee932cbcb11133$export$a132d56c46b55689 = function(dictOrd) {
    var max = $97937c29f879e68e$export$8960430cfd85939f(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return max(v)(v1);
            };
        }
    };
};
var $baee932cbcb11133$export$1c8bde74ed3994f3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $baee932cbcb11133$export$1f74115b8967ed30 = function(dictBounded) {
    var semigroupMax1 = $baee932cbcb11133$export$a132d56c46b55689(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded),
        Semigroup0: function() {
            return semigroupMax1;
        }
    };
};
var $baee932cbcb11133$export$2d291ba9538dc344 = function(dictEq) {
    return dictEq;
};
var $baee932cbcb11133$export$9193f18dc6b98d96 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMax1 = $baee932cbcb11133$export$2d291ba9538dc344(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMax1;
        }
    };
};


// Generated by purs version 0.15.16



var $78eaf69ebdcfa03a$export$dfed19fabc75a31d = function(x) {
    return x;
};
var $78eaf69ebdcfa03a$export$7b461170c443f592 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            return "(Min " + (show(v) + ")");
        }
    };
};
var $78eaf69ebdcfa03a$export$7a307765ab1cd61e = function(dictOrd) {
    var min = $97937c29f879e68e$export$96ec731ed4dcb222(dictOrd);
    return {
        append: function(v) {
            return function(v1) {
                return min(v)(v1);
            };
        }
    };
};
var $78eaf69ebdcfa03a$export$1aba8bd40545d1a0 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78eaf69ebdcfa03a$export$6c7bc156e3eb9786 = function(dictBounded) {
    var semigroupMin1 = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictBounded.Ord0());
    return {
        mempty: $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded),
        Semigroup0: function() {
            return semigroupMin1;
        }
    };
};
var $78eaf69ebdcfa03a$export$aa006854d430a332 = function(dictEq) {
    return dictEq;
};
var $78eaf69ebdcfa03a$export$ea9a45890a65660 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMin1 = $78eaf69ebdcfa03a$export$aa006854d430a332(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqMin1;
        }
    };
};





var $086486679aa806fa$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $086486679aa806fa$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $086486679aa806fa$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $086486679aa806fa$var$ala = /* #__PURE__ */ $4fa4836228a192cc$export$7317c19c5df48291()()();
var $086486679aa806fa$var$JoinWith = function(x) {
    return x;
};
var $086486679aa806fa$var$FoldRight1 = /* #__PURE__ */ function() {
    function FoldRight1(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    FoldRight1.create = function(value0) {
        return function(value1) {
            return new FoldRight1(value0, value1);
        };
    };
    return FoldRight1;
}();
var $086486679aa806fa$var$Act = function(x) {
    return x;
};
var $086486679aa806fa$var$semigroupJoinWith = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(v) {
            return function(v1) {
                return function(j) {
                    return append(v(j))(append(j)(v1(j)));
                };
            };
        }
    };
};
var $086486679aa806fa$var$semigroupAct = function(dictApply) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApply);
    return {
        append: function(v) {
            return function(v1) {
                return applySecond(v)(v1);
            };
        }
    };
};
var $086486679aa806fa$var$runFoldRight1 = function(v) {
    return v.value0(v.value1);
};
var $086486679aa806fa$var$mkFoldRight1 = /* #__PURE__ */ function() {
    return $086486679aa806fa$var$FoldRight1.create($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
}();
var $086486679aa806fa$var$joinee = function(v) {
    return v;
};
var $086486679aa806fa$var$getAct = function(v) {
    return v;
};
var $086486679aa806fa$export$c8b99533c112636f = function(dict) {
    return dict.foldr1;
};
var $086486679aa806fa$export$eb5e1ef4ea2eca3d = function(dict) {
    return dict.foldl1;
};
var $086486679aa806fa$export$c42fa06aba2a552c = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $120 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
                if ($120) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$b65392d958998255 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(cmp) {
        return foldl11(function(x) {
            return function(y) {
                var $121 = $086486679aa806fa$var$eq(cmp(x)(y))($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
                if ($121) return x;
                return y;
            };
        });
    };
};
var $086486679aa806fa$export$ffb07d5442a5d6a6 = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v.value1);
            };
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1.value1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $086486679aa806fa$export$9519b6731ae6781c = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $086486679aa806fa$export$3c076fb5bbc5428f = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $086486679aa806fa$export$1f8d30ddb0a4c229 = {
    foldr1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldl1: function(v) {
        return function(v1) {
            return v1;
        };
    },
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $086486679aa806fa$var$foldRight1Semigroup = {
    append: function(v) {
        return function(v1) {
            return new $086486679aa806fa$var$FoldRight1(function(a) {
                return function(f) {
                    return v.value0(f(v.value1)(v1.value0(a)(f)))(f);
                };
            }, v1.value1);
        };
    }
};
var $086486679aa806fa$var$semigroupDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$dc7d4cd4865fc48($086486679aa806fa$var$foldRight1Semigroup);
var $086486679aa806fa$export$4a5b2f24b03cc38b = function(dictFoldable1) {
    var foldr11 = $086486679aa806fa$export$c8b99533c112636f(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $159 = foldr11(append);
                var $160 = map(f);
                return function($161) {
                    return $159($160($161));
                };
            };
        };
    };
};
var $086486679aa806fa$export$3341743d361f5644 = function(dictFoldable1) {
    var foldl11 = $086486679aa806fa$export$eb5e1ef4ea2eca3d(dictFoldable1);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictSemigroup) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                var $162 = foldl11(append);
                var $163 = map(f);
                return function($164) {
                    return $162($163($164));
                };
            };
        };
    };
};
var $086486679aa806fa$export$b50c31bb8aebd2a7 = function(dict) {
    return dict.foldMap1;
};
var $086486679aa806fa$export$8dd52a2a23ae4dc4 = function(dictFoldable1) {
    var $165 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $167 = $086486679aa806fa$var$alaF($8257f7a36ab9f9cd$export$c26a72e8d91adeec)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$semigroupDual))($086486679aa806fa$var$mkFoldRight1);
        return function($168) {
            return $086486679aa806fa$var$runFoldRight1($167($168));
        };
    }());
    return function($166) {
        return $165($f57f4b701aa7b66e$export$8a83211c878a3f1f($166));
    };
};
var $086486679aa806fa$export$8af34898c082e678 = function(dictFoldable1) {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f(function() {
        var $169 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)($086486679aa806fa$var$foldRight1Semigroup)($086486679aa806fa$var$mkFoldRight1);
        return function($170) {
            return $086486679aa806fa$var$runFoldRight1($169($170));
        };
    }());
};
var $086486679aa806fa$export$a91e4d9c87e70eae = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupJoinWith(dictSemigroup));
        return function(j) {
            return function(f) {
                return function(foldable) {
                    return $086486679aa806fa$var$joinee(foldMap12(function($171) {
                        return $086486679aa806fa$var$JoinWith($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f($171)));
                    })(foldable))(j);
                };
            };
        };
    };
};
var $086486679aa806fa$export$739ec22334c44788 = function(dictFoldable1) {
    var intercalateMap1 = $086486679aa806fa$export$a91e4d9c87e70eae(dictFoldable1);
    return function(dictSemigroup) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(intercalateMap1(dictSemigroup))($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$b25e0be55f42c9a = function(dictOrd) {
    var semigroupMax = $baee932cbcb11133$export$a132d56c46b55689(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($baee932cbcb11133$export$d36c09e5d02927e7)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMax));
    };
};
var $086486679aa806fa$export$916782c1f0ddb132 = function(dictOrd) {
    var semigroupMin = $78eaf69ebdcfa03a$export$7a307765ab1cd61e(dictOrd);
    return function(dictFoldable1) {
        return $086486679aa806fa$var$ala($78eaf69ebdcfa03a$export$dfed19fabc75a31d)($086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1)(semigroupMin));
    };
};
var $086486679aa806fa$export$4d892265b7b103bf = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictApply) {
        var voidRight = $f4b2eb11fc32ed34$export$b818c54ed8d3e90a(dictApply.Functor0());
        var foldMap12 = foldMap11($086486679aa806fa$var$semigroupAct(dictApply));
        return function(f) {
            return function(t) {
                return voidRight($05149ea687d6b460$export$523c0b569236b342)($086486679aa806fa$var$getAct(foldMap12(function($172) {
                    return $086486679aa806fa$var$Act(f($172));
                })(t)));
            };
        };
    };
};
var $086486679aa806fa$export$f339179a581d1957 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverse1_1(dictApply));
    };
};
var $086486679aa806fa$export$1e2962bbf3c67125 = function(dictFoldable1) {
    var traverse1_1 = $086486679aa806fa$export$4d892265b7b103bf(dictFoldable1);
    return function(dictApply) {
        return traverse1_1(dictApply)($086486679aa806fa$var$identity);
    };
};
var $086486679aa806fa$export$2e430a6d03f6ee23 = function(dictFoldable1) {
    var foldMap11 = $086486679aa806fa$export$b50c31bb8aebd2a7(dictFoldable1);
    return function(dictSemigroup) {
        return foldMap11(dictSemigroup)($086486679aa806fa$var$identity);
    };
};




var $e4fb66202bb8a4f4$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $e4fb66202bb8a4f4$export$d2990bb35e0a3e00 = function(dict) {
    return dict.traverse1;
};
var $e4fb66202bb8a4f4$export$d35878ee42638401 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f(v.value1));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(v.value1);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$ffb07d5442a5d6a6;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $e4fb66202bb8a4f4$export$63e84f34fb558532 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(v) {
            return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(v);
        };
    },
    Foldable10: function() {
        return $086486679aa806fa$export$3c076fb5bbc5428f;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $e4fb66202bb8a4f4$export$c8ca5446ba1698 = function(dictTraversable1) {
    var traverse11 = $e4fb66202bb8a4f4$export$d2990bb35e0a3e00(dictTraversable1);
    return function(dictApply) {
        return traverse11(dictApply)($e4fb66202bb8a4f4$var$identity);
    };
};
var $e4fb66202bb8a4f4$export$54df524caf88dbea = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($8257f7a36ab9f9cd$export$c26a72e8d91adeec)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$54df524caf88dbea)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$1f8d30ddb0a4c229;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $e4fb66202bb8a4f4$export$b86a2d00788e21b6 = {
    traverse1: function(dictApply) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(v) {
                return map($665413393090e9d0$export$d0198c9c86fc2be1)(f(v));
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($e4fb66202bb8a4f4$export$b86a2d00788e21b6)(dictApply);
    },
    Foldable10: function() {
        return $086486679aa806fa$export$9519b6731ae6781c;
    },
    Traversable1: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $e4fb66202bb8a4f4$export$6deffb29affc84c6 = function(dict) {
    return dict.sequence1;
};
var $e4fb66202bb8a4f4$export$61888596d46ec879 = function(dictTraversable1) {
    var sequence11 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1);
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictTraversable1.Traversable1().Functor0());
    return function(dictApply) {
        var sequence12 = sequence11(dictApply);
        return function(f) {
            return function(ta) {
                return sequence12(map(f)(ta));
            };
        };
    };
};



var $cf5af1199a495394$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cf5af1199a495394$export$158c052536266a97 = function(dict) {
    return dict.unfoldr1;
};
var $cf5af1199a495394$export$b5ac0a9881e433c3 = {
    unfoldr1: function(f) {
        return function(b) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073($71f2e2e9476163f8$export$9e770fa6ce19a9d6(f(b)));
        };
    }
};
var $cf5af1199a495394$export$587ba9a9bf3cf8b4 = {
    unfoldr1: /* #__PURE__ */ $b1275140774187c9$export$e3753a19e82ccedc($06733ae99ed4f534$export$4967676db1b89293)($cf5af1199a495394$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58)
};
var $cf5af1199a495394$export$dcb5d70039e504cd = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(v) {
            var step = function(i) {
                if (i <= 0) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, $06733ae99ed4f534$export$bebe9059409a0d04.value);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $71f2e2e9476163f8$export$1908877435b1d5e9(v, new $06733ae99ed4f534$export$8a67b48435b5d073(i - 1 | 0));
                throw new Error("Failed pattern match at Data.Unfoldable1 (line 68, column 5 - line 68, column 39): " + [
                    i.constructor.name
                ]);
            };
            return unfoldr11(step)(n - 1 | 0);
        };
    };
};
var $cf5af1199a495394$export$d2a13fab7d8f2b56 = function(dictApply) {
    return function(dictUnfoldable1) {
        var replicate11 = $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1);
        return function(dictTraversable1) {
            var sequence1 = $e4fb66202bb8a4f4$export$6deffb29affc84c6(dictTraversable1)(dictApply);
            return function(n) {
                return function(m) {
                    return sequence1(replicate11(n)(m));
                };
            };
        };
    };
};
var $cf5af1199a495394$export$439306a4dcaafbb9 = function(dictUnfoldable1) {
    return $cf5af1199a495394$export$dcb5d70039e504cd(dictUnfoldable1)(1);
};
var $cf5af1199a495394$export$d02631cccf789723 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(start) {
        return function(end) {
            var go = function(delta) {
                return function(i) {
                    var i$prime = i + delta | 0;
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(i, function() {
                        var $25 = i === end;
                        if ($25) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(i$prime);
                    }());
                };
            };
            var delta = function() {
                var $26 = end >= start;
                if ($26) return 1;
                return -1;
            }();
            return unfoldr11(go(delta))(start);
        };
    };
};
var $cf5af1199a495394$export$f1977d76a1a6e399 = function(dictUnfoldable1) {
    var unfoldr11 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(n) {
        return function(f) {
            return function(s) {
                var go = function(v) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
                        var $28 = v.value1 > 0;
                        if ($28) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1 - 1 | 0));
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    }());
                };
                return unfoldr11(go)(new $71f2e2e9476163f8$export$1908877435b1d5e9(s, n - 1 | 0));
            };
        };
    };
};



var $cb5fedc2c4837e1c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $cb5fedc2c4837e1c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $cb5fedc2c4837e1c$export$df2b8ee1690308ae = function(dict) {
    return dict.unfoldr;
};
var $cb5fedc2c4837e1c$export$b5169c61b27df85a = {
    unfoldr: function(f) {
        return function(b) {
            return $cb5fedc2c4837e1c$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(f(b));
        };
    },
    Unfoldable10: function() {
        return $cf5af1199a495394$export$b5ac0a9881e433c3;
    }
};
var $cb5fedc2c4837e1c$export$2b90ca20b4b58da5 = {
    unfoldr: /* #__PURE__ */ $6c33ca7d98a534e5$export$6368c6d238d348f0($06733ae99ed4f534$export$4967676db1b89293)($cb5fedc2c4837e1c$var$fromJust)($71f2e2e9476163f8$export$9e770fa6ce19a9d6)($71f2e2e9476163f8$export$6f71268a1666ab58),
    Unfoldable10: function() {
        return $cf5af1199a495394$export$587ba9a9bf3cf8b4;
    }
};
var $cb5fedc2c4837e1c$export$606959e7ccb797f0 = function(dictUnfoldable) {
    var unfoldr1 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(n) {
        return function(v) {
            var step = function(i) {
                var $17 = i <= 0;
                if ($17) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v, i - 1 | 0));
            };
            return unfoldr1(step)(n);
        };
    };
};
var $cb5fedc2c4837e1c$export$1e1bbcb33c108a24 = function(dictApplicative) {
    return function(dictUnfoldable) {
        var replicate1 = $cb5fedc2c4837e1c$export$606959e7ccb797f0(dictUnfoldable);
        return function(dictTraversable) {
            var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable)(dictApplicative);
            return function(n) {
                return function(m) {
                    return sequence(replicate1(n)(m));
                };
            };
        };
    };
};
var $cb5fedc2c4837e1c$export$f883a24d5edde77c = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($05149ea687d6b460$export$523c0b569236b342);
};
var $cb5fedc2c4837e1c$export$43db023a260c5e9f = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(b) {
        return $cb5fedc2c4837e1c$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)($06733ae99ed4f534$export$bebe9059409a0d04.value))(b);
    });
};


var $396c4c3d9e7fae3c$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$intercalate1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $396c4c3d9e7fae3c$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $396c4c3d9e7fae3c$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $396c4c3d9e7fae3c$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($08944f7287e2704c$export$a47991927f51461e);
var $396c4c3d9e7fae3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $396c4c3d9e7fae3c$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($08944f7287e2704c$export$603d84e49041d7b2);
var $396c4c3d9e7fae3c$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $396c4c3d9e7fae3c$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$fold1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $396c4c3d9e7fae3c$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a);
var $396c4c3d9e7fae3c$export$b634740ce272acb5 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$67fd4cff6f1e6bc);
var $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $396c4c3d9e7fae3c$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($396c4c3d9e7fae3c$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $396c4c3d9e7fae3c$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(us) {
        return function(xs) {
            return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                return traverse_1(function(v) {
                    return $784e144d56146b5c$export$dc13bdd74c909d26(v.value0)(v.value1)(res);
                })(us);
            })(xs)();
        };
    };
};
var $396c4c3d9e7fae3c$export$b6d8713d53419d4c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$4bc13c05b5f586d5)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$90bcd20c17ae578e = function() {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$4459d383cf3fd31d);
};
var $396c4c3d9e7fae3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $396c4c3d9e7fae3c$export$b446f6baa3bb1430 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(x) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                head: x,
                tail: xs
            });
        };
    });
}();
var $396c4c3d9e7fae3c$export$823be24f8766da23 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(xs) {
        var len = $fc8c1182ec2aefec$export$f24224f1c91d8156(xs);
        var f = function(i) {
            if (i < len) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9($396c4c3d9e7fae3c$var$unsafeIndex1(xs)(i), i + 1 | 0));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.Array (line 163, column 3 - line 165, column 26): " + [
                i.constructor.name
            ]);
        };
        return unfoldr(f)(0);
    };
};
var $396c4c3d9e7fae3c$export$c01875f616615628 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(v) {
        return function(xs) {
            return new $06733ae99ed4f534$export$8a67b48435b5d073(xs);
        };
    });
}();
var $396c4c3d9e7fae3c$export$b035e44d7bb4278f = function(comp) {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$ea0922e78a1b008a)(comp)(function(v) {
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 1;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 0;
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return -1;
        throw new Error("Failed pattern match at Data.Array (line 897, column 38 - line 900, column 11): " + [
            v.constructor.name
        ]);
    });
};
var $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var comparing = $97937c29f879e68e$export$e9509a298f6befc2(dictOrd);
    return function(f) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(comparing(f));
    };
};
var $396c4c3d9e7fae3c$var$sortWith1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$ff461bf68e7dd332);
var $396c4c3d9e7fae3c$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $396c4c3d9e7fae3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $784e144d56146b5c$export$fd51609fe570ea92($784e144d56146b5c$export$4cbf152802aa238(x))(xs)();
    };
};
var $396c4c3d9e7fae3c$export$58adb3bec8346d0f = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$4bdf1ac3fa5d3d6a);
var $396c4c3d9e7fae3c$export$b0d75975ac0be0e1 = function(v) {
    return function(v1) {
        if (v <= 0) return {
            before: [],
            after: v1
        };
        return {
            before: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(v)(v1),
            after: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(v)($fc8c1182ec2aefec$export$f24224f1c91d8156(v1))(v1)
        };
    };
};
var $396c4c3d9e7fae3c$export$b7df5d561049483a = function(n) {
    return function(xs) {
        var $152 = n < 1;
        if ($152) return [];
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(n)(xs);
    };
};
var $396c4c3d9e7fae3c$export$439306a4dcaafbb9 = function(a) {
    return [
        a
    ];
};
var $396c4c3d9e7fae3c$export$64df51ac031d4ad2 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$771bbc3bb9be46c2);
var $396c4c3d9e7fae3c$export$65f513eaf3c582b8 = /* #__PURE__ */ $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$53974fb866918d71);
var $396c4c3d9e7fae3c$export$606959e7ccb797f0 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$86a7d437bed76c03);
var $396c4c3d9e7fae3c$export$d02631cccf789723 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$3561205b7dff20bf);
var $396c4c3d9e7fae3c$export$b29f828819edca8d = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$25718970d830661a);
var $396c4c3d9e7fae3c$export$7b1b591b262c240 = function(xs) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156(xs) === 0;
};
var $396c4c3d9e7fae3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var traverse_1 = $396c4c3d9e7fae3c$var$traverse_(dictFoldable);
    return function(is) {
        return function(f) {
            return function(xs) {
                return $784e144d56146b5c$export$fd51609fe570ea92(function(res) {
                    return traverse_1(function(i) {
                        return $784e144d56146b5c$export$3ff57735a52b8713(i)(f)(res);
                    })(is);
                })(xs)();
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$8f07ddce13659f50 = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $396c4c3d9e7fae3c$export$af200dcf8b7cb5de = function(a) {
    return function(arr) {
        var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(arr);
        if (v < 2) return arr;
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $784e144d56146b5c$export$889ea624f2cb2c57(function() {
            var unsafeGetElem = function(idx) {
                return $396c4c3d9e7fae3c$var$unsafeIndex1(arr)(idx);
            };
            return function __do() {
                var out = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                $784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(0))(out)();
                $f11e5cd39add8df2$export$f89de2e5bf57e5e6(1)(v)(function(idx) {
                    return function __do() {
                        $784e144d56146b5c$export$4cbf152802aa238(a)(out)();
                        return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(unsafeGetElem(idx))(out))();
                    };
                })();
                return out;
            };
        }());
        throw new Error("Failed pattern match at Data.Array (line 623, column 21 - line 633, column 17): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$739ec22334c44788 = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$intercalate1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$9f200c4466975173 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$ce6386a175247406($fc8c1182ec2aefec$export$d553b0efc2008003)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$2cd8252107eb640b = function(xs) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(xs)) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $06733ae99ed4f534$export$8a67b48435b5d073($396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0)(xs));
    throw new Error("Failed pattern match at Data.Array (line 351, column 1 - line 351, column 45): " + [
        xs.constructor.name
    ]);
};
var $396c4c3d9e7fae3c$export$b610b8812bbcded9 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$fe8606c16d7ceed6)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$4c7897fafd92b108 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - 1 | 0);
};
var $396c4c3d9e7fae3c$export$712962e076096ed4 = function(xs) {
    return $396c4c3d9e7fae3c$var$apply($396c4c3d9e7fae3c$var$map(function(v) {
        return function(v1) {
            return {
                init: v,
                last: v1
            };
        };
    })($396c4c3d9e7fae3c$export$2cd8252107eb640b(xs)))($396c4c3d9e7fae3c$export$4c7897fafd92b108(xs));
};
var $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(f(x))(xs);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$afc1bfabebaf28a2 = function(p) {
    return function(arr) {
        var go = function($copy_i) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i) {
                var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(arr)(i);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $156 = p(v.value0);
                    if ($156) {
                        $copy_i = i + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(i);
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.Array (line 1035, column 5 - line 1037, column 25): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_i);
            return $tco_result;
        };
        var breakIndex = go(0);
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && breakIndex.value0 === 0) return {
            init: [],
            rest: arr
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            init: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(0)(breakIndex.value0)(arr),
            rest: $396c4c3d9e7fae3c$export$58adb3bec8346d0f(breakIndex.value0)($fc8c1182ec2aefec$export$f24224f1c91d8156(arr))(arr)
        };
        if (breakIndex instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
            init: arr,
            rest: []
        };
        throw new Error("Failed pattern match at Data.Array (line 1022, column 3 - line 1028, column 30): " + [
            breakIndex.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$9384c7afe4015e42 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).init;
    };
};
var $396c4c3d9e7fae3c$export$23c8d3f8757cab88 = function(xs) {
    return function __do() {
        var fsts = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var snds = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
        var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
            return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
        })();
        $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(v) {
            return function __do() {
                $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value0)(fsts))();
                return $396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v.value1)(snds))();
            };
        })();
        var fsts$prime = $784e144d56146b5c$export$7c850c5af9b9983e(fsts)();
        var snds$prime = $784e144d56146b5c$export$7c850c5af9b9983e(snds)();
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(fsts$prime, snds$prime);
    }();
};
var $396c4c3d9e7fae3c$export$5fd5031fecdacec3 = function(xs) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(0);
};
var $396c4c3d9e7fae3c$export$18f77a3bafa759b9 = function(comp) {
    return function(xs) {
        var indexedAndSorted = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(function(x) {
            return function(y) {
                return comp($71f2e2e9476163f8$export$6f71268a1666ab58(x))($71f2e2e9476163f8$export$6f71268a1666ab58(y));
            };
        })($396c4c3d9e7fae3c$export$8f07ddce13659f50($71f2e2e9476163f8$export$1908877435b1d5e9.create)(xs));
        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(indexedAndSorted);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)($396c4c3d9e7fae3c$var$sortWith1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(function __do() {
            var result = $784e144d56146b5c$export$cc9b8725eef9c137($396c4c3d9e7fae3c$export$439306a4dcaafbb9(v.value0))();
            $f11e5cd39add8df2$export$8802485f9deae94f(indexedAndSorted)(function(v1) {
                return function __do() {
                    var lst = $396c4c3d9e7fae3c$var$map2(function() {
                        var $183 = function($185) {
                            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$4c7897fafd92b108($185));
                        };
                        return function($184) {
                            return $71f2e2e9476163f8$export$6f71268a1666ab58($183($184));
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(result))();
                    return $396c4c3d9e7fae3c$var$when($396c4c3d9e7fae3c$var$notEq(comp(lst)(v1.value1))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value))($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(v1)(result)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }()));
        throw new Error("Failed pattern match at Data.Array (line 1115, column 17 - line 1123, column 28): " + [
            v.constructor.name
        ]);
    };
};
var $396c4c3d9e7fae3c$export$94f4066a75b10404 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$3f063810d7bf01bd = function(op) {
    return function(xs) {
        return function __do() {
            var result = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            var iter = $8dd172f1ebfb42af$export$6f58e2338da23f4d(function(v) {
                return $396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(v);
            })();
            $8dd172f1ebfb42af$export$c1a059043cc9c119(iter)(function(x) {
                return $396c4c3d9e7fae3c$var$$$void(function __do() {
                    var sub1 = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
                    $784e144d56146b5c$export$4cbf152802aa238(x)(sub1)();
                    $8dd172f1ebfb42af$export$f458d78453dee163(op(x))(iter)(sub1)();
                    var grp = $784e144d56146b5c$export$7c850c5af9b9983e(sub1)();
                    return $784e144d56146b5c$export$4cbf152802aa238(grp)(result)();
                });
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(result)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$1f7a5bf12caafbd = function(cmp) {
    var $186 = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $187 = $396c4c3d9e7fae3c$export$b035e44d7bb4278f(cmp);
    return function($188) {
        return $186($187($188));
    };
};
var $396c4c3d9e7fae3c$export$361434b95a7d965 = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$e5e25fbcc1f7affe = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(xs) {
        return $396c4c3d9e7fae3c$export$3f063810d7bf01bd(eq2)(xs);
    };
};
var $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$7de5ece11b723a44)($4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable));
};
var $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$50ae948ca12cdcbc = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $396c4c3d9e7fae3c$export$9cb09a71b7d66923 = function(xs) {
    var buildNext = function(idx) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$50ae948ca12cdcbc)($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(acc) {
            return function(nextArr) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(el) {
                    return new $06733ae99ed4f534$export$8a67b48435b5d073($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([
                        el
                    ])($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$c40cf5aab899f397)(el))(acc));
                })($396c4c3d9e7fae3c$export$b610b8812bbcded9(nextArr)(idx));
            };
        })(xs);
    };
    var go = function($copy_idx) {
        return function($copy_allArrays) {
            var $tco_var_idx = $copy_idx;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(idx, allArrays) {
                var v = buildNext(idx);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return allArrays;
                }
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_idx = idx + 1 | 0;
                    $copy_allArrays = $396c4c3d9e7fae3c$export$c40cf5aab899f397(allArrays)(v.value0);
                    return;
                }
                throw new Error("Failed pattern match at Data.Array (line 837, column 22 - line 839, column 52): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_idx, $copy_allArrays);
            return $tco_result;
        };
    };
    return go(0)([]);
};
var $396c4c3d9e7fae3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        return function(b) {
            return function(array) {
                var go = function(res) {
                    return function(i) {
                        if (i >= $fc8c1182ec2aefec$export$f24224f1c91d8156(array)) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(res));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return bind1(f(res)($396c4c3d9e7fae3c$var$unsafeIndex1(array)(i)))(function(res$prime) {
                            return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                                a: res$prime,
                                b: i + 1 | 0
                            }));
                        });
                        throw new Error("Failed pattern match at Data.Array (line 1349, column 3 - line 1353, column 42): " + [
                            res.constructor.name,
                            i.constructor.name
                        ]);
                    };
                };
                return tailRecM2(go)(b)(0);
            };
        };
    };
};
var $396c4c3d9e7fae3c$export$b66cdc0497d8a99a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$foldMap1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(f) {
        return function(b) {
            return $8f2697950ee155e1$export$dd8987cb9f63b77e($fc8c1182ec2aefec$export$99063656965a82f5)(function(v) {
                return pure1(b);
            })(function(a) {
                return function(as) {
                    return bind1(f(b)(a))(function(b$prime) {
                        return $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad)(f)(b$prime)(as);
                    });
                };
            });
        };
    };
};
var $396c4c3d9e7fae3c$export$93e2b83da34ff82a = function(dictMonoid) {
    return $396c4c3d9e7fae3c$var$fold1(dictMonoid);
};
var $396c4c3d9e7fae3c$export$23e5dcedfce4509c = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$7ad327e9a65b0147)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$c15bd07a493e1236);
}();
var $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$32bcb9f71841245e)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$b8bc901090d2b1d4 = function(cmp) {
    return function(x) {
        return function(ys) {
            var i = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)(function(v) {
                return v + 1 | 0;
            })($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(y) {
                return $396c4c3d9e7fae3c$var$eq1(cmp(x)(y))($5026be88823ef1f4$export$b023c82b48e70453.value);
            })(ys));
            return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$9f200c4466975173(i)(x)(ys));
        };
    };
};
var $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $396c4c3d9e7fae3c$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $396c4c3d9e7fae3c$export$de3a4d4a0d731119 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$885b84ba169666c7)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$71aa6c912b956294 = function(f) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$map($396c4c3d9e7fae3c$var$unsafeIndex1(xs))($396c4c3d9e7fae3c$export$de3a4d4a0d731119(f)(xs));
    };
};
var $396c4c3d9e7fae3c$export$3dea766d36a8935f = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$e85b5b674fbfff84);
var $396c4c3d9e7fae3c$export$f161f39e9c06ab2d = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(x) {
                return $06733ae99ed4f534$export$c15bd07a493e1236($396c4c3d9e7fae3c$export$de3a4d4a0d731119(eq2(x))(ys));
            })(xs);
        };
    };
};
var $396c4c3d9e7fae3c$export$1f4807a235930d45 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $396c4c3d9e7fae3c$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $396c4c3d9e7fae3c$export$63faa62a0284a4a6 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$4967676db1b89293(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$5bf96401662340b7 = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(a) {
        return function(arr) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(elemIndex1(a)(arr));
        };
    };
};
var $396c4c3d9e7fae3c$export$533af5c8cd6afa16 = function(p) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$afc1bfabebaf28a2(p)(xs).rest;
    };
};
var $396c4c3d9e7fae3c$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b7df5d561049483a($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$663103110d94aac9 = function(n) {
    return function(xs) {
        var $173 = n < 1;
        if ($173) return xs;
        return $396c4c3d9e7fae3c$export$58adb3bec8346d0f(n)($fc8c1182ec2aefec$export$f24224f1c91d8156(xs))(xs);
    };
};
var $396c4c3d9e7fae3c$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$663103110d94aac9($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $396c4c3d9e7fae3c$export$90f9093465da3136 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($fc8c1182ec2aefec$export$e83371a4d1b4407c)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.length === 0) return [];
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v2)(function(i) {
                return $396c4c3d9e7fae3c$var$fromJust($396c4c3d9e7fae3c$export$90f9093465da3136(i)(v2));
            })($396c4c3d9e7fae3c$export$de3a4d4a0d731119(v(v1))(v2));
        };
    };
};
var $396c4c3d9e7fae3c$export$1822828d790e23ee = function(dictEq) {
    return $396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$acaf96a27438246b = function(dictEq) {
    return $396c4c3d9e7fae3c$export$a11cb61c36c4a4cf($396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq));
};
var $396c4c3d9e7fae3c$export$8327ebbef2a0ba76 = function(x) {
    return function(xs) {
        return $396c4c3d9e7fae3c$var$append([
            x
        ])(xs);
    };
};
var $396c4c3d9e7fae3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply1 = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply1(map3($396c4c3d9e7fae3c$export$8327ebbef2a0ba76)(v))(defer(function(v1) {
                return $396c4c3d9e7fae3c$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $396c4c3d9e7fae3c$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure1([]));
        };
    };
};
var $396c4c3d9e7fae3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($70cd3177464e7915$export$794f9574ca20b986));
var $396c4c3d9e7fae3c$export$e70771d2e7e590a = function(f) {
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function() {
        var $189 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])($396c4c3d9e7fae3c$export$439306a4dcaafbb9);
        return function($190) {
            return $189(f($190));
        };
    }());
};
var $396c4c3d9e7fae3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var traverse1 = $396c4c3d9e7fae3c$var$traverse(dictApplicative);
    var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    return function(p) {
        var $191 = map3($396c4c3d9e7fae3c$export$e70771d2e7e590a(function(v) {
            if (v.value1) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }));
        var $192 = traverse1(function(x) {
            return map3($71f2e2e9476163f8$export$1908877435b1d5e9.create(x))(p(x));
        });
        return function($193) {
            return $191($192($193));
        };
    };
};
var $396c4c3d9e7fae3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $396c4c3d9e7fae3c$export$e70771d2e7e590a(/* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa));
var $396c4c3d9e7fae3c$export$4154a199d7d90455 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$b98f41a67d1483f3);
var $396c4c3d9e7fae3c$export$45273896c792ff3b = function(eq2) {
    return function(xs) {
        return function __do() {
            var arr = $0dbe0c7353bd68b1$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(xs)(function(x) {
                return function __do() {
                    var e = $396c4c3d9e7fae3c$var$map2(function() {
                        var $194 = $396c4c3d9e7fae3c$export$4154a199d7d90455(function(v) {
                            return eq2(v)(x);
                        });
                        return function($195) {
                            return !$194($195);
                        };
                    }())($784e144d56146b5c$export$7c850c5af9b9983e(arr))();
                    return $396c4c3d9e7fae3c$var$when(e)($396c4c3d9e7fae3c$var$$$void($784e144d56146b5c$export$4cbf152802aa238(x)(arr)))();
                };
            })();
            return $784e144d56146b5c$export$7c850c5af9b9983e(arr)();
        }();
    };
};
var $396c4c3d9e7fae3c$export$edce5881c815871 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $396c4c3d9e7fae3c$var$append(xs)($396c4c3d9e7fae3c$export$50ae948ca12cdcbc($f57f4b701aa7b66e$export$8a83211c878a3f1f($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(eq2)))($396c4c3d9e7fae3c$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $396c4c3d9e7fae3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $396c4c3d9e7fae3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $396c4c3d9e7fae3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        return function(xs) {
            var go = function(x) {
                var v = f(x);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $396c4c3d9e7fae3c$export$90f9093465da3136(i)(xs);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(v.value0)(xs);
                throw new Error("Failed pattern match at Data.Array (line 601, column 10 - line 603, column 32): " + [
                    v.constructor.name
                ]);
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(go)($396c4c3d9e7fae3c$export$b610b8812bbcded9(xs)(i));
        };
    };
};
var $396c4c3d9e7fae3c$export$84bf76cd7afc7469 = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($fc8c1182ec2aefec$export$739e1ef870df7d82);




// Generated by purs version 0.15.16
const $4ab74a20512cef04$export$5b3229f64c38e483 = function(just) {
    return function(nothing) {
        return function(n) {
            /* jshint bitwise: false */ return (n | 0) === n ? just(n) : nothing;
        };
    };
};
const $4ab74a20512cef04$export$a0a81dc3380ce7d3 = function(n) {
    return n;
};
const $4ab74a20512cef04$export$221b4f162df9878c = function(just) {
    return function(nothing) {
        return function(radix) {
            var digits;
            if (radix < 11) digits = "[0-" + (radix - 1).toString() + "]";
            else if (radix === 11) digits = "[0-9a]";
            else digits = "[0-9a-" + String.fromCharCode(86 + radix) + "]";
            var pattern = new RegExp("^[\\+\\-]?" + digits + "+$", "i");
            return function(s) {
                /* jshint bitwise: false */ if (pattern.test(s)) {
                    var i = parseInt(s, radix);
                    return (i | 0) === i ? just(i) : nothing;
                } else return nothing;
            };
        };
    };
};
const $4ab74a20512cef04$export$f601457c5ee3082f = function(radix) {
    return function(i) {
        return i.toString(radix);
    };
};
const $4ab74a20512cef04$export$dcbbe75d5a67af21 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return x / y | 0;
    };
};
const $4ab74a20512cef04$export$fb1897a40d146f7f = function(x) {
    return function(y) {
        return x % y;
    };
};
const $4ab74a20512cef04$export$9c297f60e22e3389 = function(x) {
    return function(y) {
        /* jshint bitwise: false */ return Math.pow(x, y) | 0;
    };
};







// Generated by purs version 0.15.16
/* globals exports */ const $9a14cd925227149d$export$9e06de0973666692 = NaN;
const $9a14cd925227149d$export$c9f5652083b8129d = isNaN;
const $9a14cd925227149d$export$a0978488bc4efbee = Infinity;
const $9a14cd925227149d$export$65f0b13f2f82375a = isFinite;
function $9a14cd925227149d$export$3ffe08ccbe76f69e(str, isFinite1, just, nothing) {
    var num = parseFloat(str);
    if (isFinite1(num)) return just(num);
    else return nothing;
}
const $9a14cd925227149d$export$2335f513bbd82c6d = Math.abs;
const $9a14cd925227149d$export$fd6306be3fde5b04 = Math.acos;
const $9a14cd925227149d$export$41726bdb1fc63f = Math.asin;
const $9a14cd925227149d$export$628dc4eed22b0fbd = Math.atan;
const $9a14cd925227149d$export$b8b770ee6a0d9760 = function(y) {
    return function(x) {
        return Math.atan2(y, x);
    };
};
const $9a14cd925227149d$export$803ce6b71a0a94b2 = Math.ceil;
const $9a14cd925227149d$export$50d414a77b60d802 = Math.cos;
const $9a14cd925227149d$export$b310ec824aaee37f = Math.exp;
const $9a14cd925227149d$export$a3fe094919f356fd = Math.floor;
const $9a14cd925227149d$export$bef1f36f5486a6a3 = Math.log;
const $9a14cd925227149d$export$8960430cfd85939f = function(n1) {
    return function(n2) {
        return Math.max(n1, n2);
    };
};
const $9a14cd925227149d$export$96ec731ed4dcb222 = function(n1) {
    return function(n2) {
        return Math.min(n1, n2);
    };
};
const $9a14cd925227149d$export$9c297f60e22e3389 = function(n) {
    return function(p) {
        return Math.pow(n, p);
    };
};
const $9a14cd925227149d$export$159037f780d3415c = function(n) {
    return function(m) {
        return n % m;
    };
};
const $9a14cd925227149d$export$2077e0241d6afd3c = Math.round;
const $9a14cd925227149d$export$c5552dfdbc7cec71 = Math.sign ? Math.sign : function(x) {
    return x === 0 || x !== x ? x : x < 0 ? -1 : 1;
};
const $9a14cd925227149d$export$5de3937cb4b592ed = Math.sin;
const $9a14cd925227149d$export$eba8049fb5020b81 = Math.sqrt;
const $9a14cd925227149d$export$fcdd3b0b3246a325 = Math.tan;
const $9a14cd925227149d$export$1fe87bd59b089f0 = Math.trunc ? Math.trunc : function(x) {
    return x < 0 ? Math.ceil(x) : Math.floor(x);
};



var $052de1c85deb22bf$export$a4b4b4d4d776fe92 = 6.283185307179586;
var $052de1c85deb22bf$export$2fa35f36c870f3b7 = 1.4142135623730951;
var $052de1c85deb22bf$export$9eaf1e6179158e34 = 0.7071067811865476;
var $052de1c85deb22bf$export$18c7bea995a110f = 3.141592653589793;
var $052de1c85deb22bf$export$4d03748825f009b9 = 1.4426950408889634;
var $052de1c85deb22bf$export$4ca92b5d1d793bd5 = 0.4342944819032518;
var $052de1c85deb22bf$export$27692bafabcf0fdc = 0.6931471805599453;
var $052de1c85deb22bf$export$e1abf6863d05a89e = 2.302585092994046;
var $052de1c85deb22bf$export$3004f64547af360e = function(str) {
    return $9a14cd925227149d$export$3ffe08ccbe76f69e(str, $9a14cd925227149d$export$65f0b13f2f82375a, $06733ae99ed4f534$export$8a67b48435b5d073.create, $06733ae99ed4f534$export$bebe9059409a0d04.value);
};
var $052de1c85deb22bf$export$f1e1789686576879 = 2.718281828459045;




var $8d5664f12212b23e$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $8d5664f12212b23e$var$Radix = function(x) {
    return x;
};
var $8d5664f12212b23e$export$33ca3b017f2e3089 = /* #__PURE__ */ function() {
    function Even() {}
    Even.value = new Even();
    return Even;
}();
var $8d5664f12212b23e$export$6bbc73627dceae86 = /* #__PURE__ */ function() {
    function Odd() {}
    Odd.value = new Odd();
    return Odd;
}();
var $8d5664f12212b23e$export$9f422d81718beff7 = {
    show: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return "Even";
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return "Odd";
        throw new Error("Failed pattern match at Data.Int (line 117, column 1 - line 119, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $8d5664f12212b23e$export$1db3e511bfb04803 = function(n) {
    if (n >= 2 && n <= 36) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Int (line 198, column 1 - line 198, column 28): " + [
        n.constructor.name
    ]);
};
var $8d5664f12212b23e$export$74b48c691cc42eb1 = function(x) {
    return (x & 1) !== 0;
};
var $8d5664f12212b23e$export$90d8fbb029b06afc = 8;
var $8d5664f12212b23e$export$9c12a48020146abe = 16;
var $8d5664f12212b23e$export$d7a050b0311540b9 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$221b4f162df9878c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$export$3004f64547af360e = /* #__PURE__ */ $8d5664f12212b23e$export$d7a050b0311540b9(10);
var $8d5664f12212b23e$export$7bbb4164c9a77bc2 = /* #__PURE__ */ function() {
    return $4ab74a20512cef04$export$5b3229f64c38e483($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $8d5664f12212b23e$var$unsafeClamp = function(x) {
    if (!$9a14cd925227149d$export$65f0b13f2f82375a(x)) return 0;
    if (x >= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$top)) return $8d5664f12212b23e$var$top;
    if (x <= $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$var$bottom)) return $8d5664f12212b23e$var$bottom;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$43db023a260c5e9f(0)($8d5664f12212b23e$export$7bbb4164c9a77bc2(x));
    throw new Error("Failed pattern match at Data.Int (line 72, column 1 - line 72, column 29): " + [
        x.constructor.name
    ]);
};
var $8d5664f12212b23e$export$2077e0241d6afd3c = function($37) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$2077e0241d6afd3c($37));
};
var $8d5664f12212b23e$export$1fe87bd59b089f0 = function($38) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$1fe87bd59b089f0($38));
};
var $8d5664f12212b23e$export$a3fe094919f356fd = function($39) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$a3fe094919f356fd($39));
};
var $8d5664f12212b23e$export$df5fefc55a4eba3c = function(x) {
    return (x & 1) === 0;
};
var $8d5664f12212b23e$export$efe353078db02e10 = function(n) {
    var $28 = $8d5664f12212b23e$export$df5fefc55a4eba3c(n);
    if ($28) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
    return $8d5664f12212b23e$export$6bbc73627dceae86.value;
};
var $8d5664f12212b23e$export$8424267183f54e9d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return true;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return true;
            return false;
        };
    }
};
var $8d5664f12212b23e$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($8d5664f12212b23e$export$8424267183f54e9d);
var $8d5664f12212b23e$export$8b12bf30fdd3264f = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089 && y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && y instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Int (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $8d5664f12212b23e$export$8424267183f54e9d;
    }
};
var $8d5664f12212b23e$export$39d55cbe74216cbe = /* #__PURE__ */ function() {
    return {
        zero: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        add: function(x) {
            return function(y) {
                var $33 = $8d5664f12212b23e$var$eq1(x)(y);
                if ($33) return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
                return $8d5664f12212b23e$export$6bbc73627dceae86.value;
            };
        },
        one: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        mul: function(v) {
            return function(v1) {
                if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86 && v1 instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return $8d5664f12212b23e$export$6bbc73627dceae86.value;
                return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
            };
        }
    };
}();
var $8d5664f12212b23e$export$e741c28ebd8a3552 = {
    sub: /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($8d5664f12212b23e$export$39d55cbe74216cbe),
    Semiring0: function() {
        return $8d5664f12212b23e$export$39d55cbe74216cbe;
    }
};
var $8d5664f12212b23e$export$5bd06fe87b344eef = {
    recip: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$78a48a3d1e5dbe89 = 10;
var $8d5664f12212b23e$export$cf50720682a32a87 = {
    Ring0: function() {
        return $8d5664f12212b23e$export$e741c28ebd8a3552;
    }
};
var $8d5664f12212b23e$export$965db879d0c14bc1 = {
    degree: function(v) {
        if (v instanceof $8d5664f12212b23e$export$33ca3b017f2e3089) return 0;
        if (v instanceof $8d5664f12212b23e$export$6bbc73627dceae86) return 1;
        throw new Error("Failed pattern match at Data.Int (line 137, column 1 - line 141, column 17): " + [
            v.constructor.name
        ]);
    },
    div: function(x) {
        return function(v) {
            return x;
        };
    },
    mod: function(v) {
        return function(v1) {
            return $8d5664f12212b23e$export$33ca3b017f2e3089.value;
        };
    },
    CommutativeRing0: function() {
        return $8d5664f12212b23e$export$cf50720682a32a87;
    }
};
var $8d5664f12212b23e$export$803ce6b71a0a94b2 = function($40) {
    return $8d5664f12212b23e$var$unsafeClamp($9a14cd925227149d$export$803ce6b71a0a94b2($40));
};
var $8d5664f12212b23e$export$fc5d11f6ca2bf4fc = /* #__PURE__ */ function() {
    return {
        bottom: $8d5664f12212b23e$export$33ca3b017f2e3089.value,
        top: $8d5664f12212b23e$export$6bbc73627dceae86.value,
        Ord0: function() {
            return $8d5664f12212b23e$export$8b12bf30fdd3264f;
        }
    };
}();
var $8d5664f12212b23e$export$33902b7329277358 = 2;
var $8d5664f12212b23e$export$95b61e7c39ae893a = 36;


// Generated by purs version 0.15.16






// Generated by purs version 0.15.16



















var $519ef1967f17d101$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$9519b6731ae6781c);
var $519ef1967f17d101$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldMap1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $519ef1967f17d101$var$foldr2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldl2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldMap2 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$d127e049f7f9d81c);
var $519ef1967f17d101$var$foldr3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldl3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldMap3 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e);
var $519ef1967f17d101$var$foldr4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldl4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldMap4 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$1f8d30ddb0a4c229);
var $519ef1967f17d101$var$foldr5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldl5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldMap5 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$fbf8f11f9a917de3);
var $519ef1967f17d101$var$foldr6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldl6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldMap6 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$b0c90191a04a5815);
var $519ef1967f17d101$var$foldr7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldl7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldMap7 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($4fe7b6acfba7f29f$export$a3b6f6613d3d5767);
var $519ef1967f17d101$var$foldr8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $519ef1967f17d101$var$foldl8 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $519ef1967f17d101$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $519ef1967f17d101$var$monoidEndo = /* #__PURE__ */ $57b8542ac3131c5d$export$947ca1a8eed6111($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $519ef1967f17d101$var$monoidDual = /* #__PURE__ */ $8257f7a36ab9f9cd$export$b54c1e48d4afa3cb($519ef1967f17d101$var$monoidEndo);
var $519ef1967f17d101$export$d859ed9adfa064ca = function(dict) {
    return dict.foldrWithIndex;
};
var $519ef1967f17d101$export$d13ff16378fefe83 = function(dictApplicative) {
    var applySecond = $7576d3a958d66ab0$export$3d5d566a030a20fc(dictApplicative.Apply0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictFoldableWithIndex) {
        var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
        return function(f) {
            return foldrWithIndex1(function(i) {
                var $289 = f(i);
                return function($290) {
                    return applySecond($289($290));
                };
            })(pure($05149ea687d6b460$export$523c0b569236b342));
        };
    };
};
var $519ef1967f17d101$export$f441c83f81b7710f = function(dictApplicative) {
    var traverseWithIndex_1 = $519ef1967f17d101$export$d13ff16378fefe83(dictApplicative);
    return function(dictFoldableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f(traverseWithIndex_1(dictFoldableWithIndex));
    };
};
var $519ef1967f17d101$export$9b986141719153e = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(f) {
        return foldrWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$2d70b9efb960f478 = function(dict) {
    return dict.foldlWithIndex;
};
var $519ef1967f17d101$export$e623e8bf74059b22 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        return foldlWithIndex1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
    };
};
var $519ef1967f17d101$export$a0208fa03195d5a3 = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v.value1);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v.value1);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ffb07d5442a5d6a6;
    }
};
var $519ef1967f17d101$export$e07746a44d4d0673 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$9519b6731ae6781c;
    }
};
var $519ef1967f17d101$export$db675654cef60b9a = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl1(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap1(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$ff97dbee91e727b6;
    }
};
var $519ef1967f17d101$export$3a92905df29453fa = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl2(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap2(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$d127e049f7f9d81c;
    }
};
var $519ef1967f17d101$export$92c42163dd2c46ce = {
    foldrWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v)(z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(z)(v);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f($05149ea687d6b460$export$523c0b569236b342)(v);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$3c076fb5bbc5428f;
    }
};
var $519ef1967f17d101$export$328d1f7f0045c999 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl3(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap3(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$f52a7d3e80f7fd5e;
    }
};
var $519ef1967f17d101$export$617fc130b23797ca = {
    foldrWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v2.value0)(v1);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1)(v2.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return mempty;
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v($05149ea687d6b460$export$523c0b569236b342)(v1.value0);
                throw new Error("Failed pattern match at Data.FoldableWithIndex (line 164, column 1 - line 170, column 42): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6a194eaac00c1ff4;
    }
};
var $519ef1967f17d101$export$dc8026a24f95d0a9 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl4(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap4(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$1f8d30ddb0a4c229;
    }
};
var $519ef1967f17d101$export$a77c731c3b37cfd = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl5(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap5(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$fbf8f11f9a917de3;
    }
};
var $519ef1967f17d101$export$1add8b24fb58b747 = {
    foldrWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldlWithIndex: function(v) {
        return function(z) {
            return function(v1) {
                return z;
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(v) {
            return function(v1) {
                return mempty;
            };
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$6857d056e9f0762d;
    }
};
var $519ef1967f17d101$export$707470fe74326665 = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl6(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap6(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$b0c90191a04a5815;
    }
};
var $519ef1967f17d101$export$f9ed9b5a8131479e = {
    foldrWithIndex: function(f) {
        return $519ef1967f17d101$var$foldr7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $519ef1967f17d101$var$foldl7(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap8 = $519ef1967f17d101$var$foldMap7(dictMonoid);
        return function(f) {
            return foldMap8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$a3b6f6613d3d5767;
    }
};
var $519ef1967f17d101$export$ca16238ae0303ef0 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(f) {
            return function(a0) {
                return foldlWithIndex1(function(i) {
                    return function(ma) {
                        return function(b) {
                            return bind(ma)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f(i))(b));
                        };
                    };
                })(pure(a0));
            };
        };
    };
};
var $519ef1967f17d101$export$998b3d14abdd8136 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldrWithIndex1(function(i) {
                return function(x) {
                    return function(acc) {
                        return append(f(i)(x))(acc);
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$e728f47f20b1eb28 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $291 = $519ef1967f17d101$var$foldr8(function(v) {
                return function(y) {
                    return f(v.value0)(v.value1)(y);
                };
            })(z);
            var $292 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($293) {
                return $291($292($293));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $294 = $519ef1967f17d101$var$foldl8(function(y) {
                return function(v) {
                    return f(v.value0)(y)(v.value1);
                };
            })(z);
            var $295 = $519ef1967f17d101$var$mapWithIndex($71f2e2e9476163f8$export$1908877435b1d5e9.create);
            return function($296) {
                return $294($295($296));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $519ef1967f17d101$export$998b3d14abdd8136($519ef1967f17d101$export$e728f47f20b1eb28)(dictMonoid);
    },
    Foldable0: function() {
        return $4fe7b6acfba7f29f$export$e97014618a7eb593;
    }
};
var $519ef1967f17d101$export$d58f3ffea0efd404 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return foldlWithIndex1(function(i) {
                return function(acc) {
                    return function(x) {
                        return append(acc)(f(i)(x));
                    };
                };
            })(mempty);
        };
    };
};
var $519ef1967f17d101$export$18153bb1181268e5 = function(dict) {
    return dict.foldMapWithIndex;
};
var $519ef1967f17d101$export$ca1485f10f9ca9ee = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableApp = $4fe7b6acfba7f29f$export$1e1b0f55a49f1dc6(dictFoldableWithIndex.Foldable0());
    return {
        foldrWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldrWithIndex1(f)(z)(v);
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(z) {
                return function(v) {
                    return foldlWithIndex1(f)(z)(v);
                };
            };
        },
        foldMapWithIndex: function(dictMonoid) {
            var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
            return function(f) {
                return function(v) {
                    return foldMapWithIndex2(f)(v);
                };
            };
        },
        Foldable0: function() {
            return foldableApp;
        }
    };
};
var $519ef1967f17d101$export$ed9dddd4d2a66e4d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCompose = $4fe7b6acfba7f29f$export$5677464b2ea4179d(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCompose1 = foldableCompose(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldrWithIndex1(function(a) {
                            return $f57f4b701aa7b66e$export$8a83211c878a3f1f(foldrWithIndex2($71f2e2e9476163f8$export$c3095a23b368d1f2(f)(a)));
                        })(i)(v);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(i) {
                    return function(v) {
                        return foldlWithIndex1(function() {
                            var $297 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($298) {
                                return foldlWithIndex2($297($298));
                            };
                        }())(i)(v);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return foldMapWithIndex3(function() {
                            var $299 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($300) {
                                return foldMapWithIndex4($299($300));
                            };
                        }())(v);
                    };
                };
            },
            Foldable0: function() {
                return foldableCompose1;
            }
        };
    };
};
var $519ef1967f17d101$export$c8998bd70c04c75d = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableCoproduct = $4fe7b6acfba7f29f$export$5c9c2b827ab84341(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableCoproduct1 = foldableCoproduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldrWithIndex1(function($301) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($301));
                    })(z))(foldrWithIndex2(function($302) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($302));
                    })(z));
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldlWithIndex1(function($303) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($303));
                    })(z))(foldlWithIndex2(function($304) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($304));
                    })(z));
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(foldMapWithIndex3(function($305) {
                        return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($305));
                    }))(foldMapWithIndex4(function($306) {
                        return f($7d4cccdf062a2261$export$19db0165690c701a.create($306));
                    }));
                };
            },
            Foldable0: function() {
                return foldableCoproduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$e0fd1e7d0cab0fb2 = function(dictFoldableWithIndex) {
    var foldrWithIndex1 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldableProduct = $4fe7b6acfba7f29f$export$a013322ac1f6d3aa(dictFoldableWithIndex.Foldable0());
    return function(dictFoldableWithIndex1) {
        var foldrWithIndex2 = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex1);
        var foldlWithIndex2 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex1);
        var foldMapWithIndex2 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex1);
        var foldableProduct1 = foldableProduct(dictFoldableWithIndex1.Foldable0());
        return {
            foldrWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldrWithIndex1(function($307) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($307));
                        })(foldrWithIndex2(function($308) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($308));
                        })(z)(v.value1))(v.value0);
                    };
                };
            },
            foldlWithIndex: function(f) {
                return function(z) {
                    return function(v) {
                        return foldlWithIndex2(function($309) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($309));
                        })(foldlWithIndex1(function($310) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($310));
                        })(z)(v.value0))(v.value1);
                    };
                };
            },
            foldMapWithIndex: function(dictMonoid) {
                var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
                var foldMapWithIndex3 = foldMapWithIndex1(dictMonoid);
                var foldMapWithIndex4 = foldMapWithIndex2(dictMonoid);
                return function(f) {
                    return function(v) {
                        return append(foldMapWithIndex3(function($311) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($311));
                        })(v.value0))(foldMapWithIndex4(function($312) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($312));
                        })(v.value1));
                    };
                };
            },
            Foldable0: function() {
                return foldableProduct1;
            }
        };
    };
};
var $519ef1967f17d101$export$a2a2be54aa786fa = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidDual);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap($519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $313 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(c(i));
                    return function($314) {
                        return $8257f7a36ab9f9cd$export$c26a72e8d91adeec($57b8542ac3131c5d$export$6aef3ff797629bec($313($314)));
                    };
                })(xs)))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$f48decfd8b6d8740 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(c) {
        return function(u) {
            return function(xs) {
                return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(function(i) {
                    var $315 = c(i);
                    return function($316) {
                        return $57b8542ac3131c5d$export$6aef3ff797629bec($315($316));
                    };
                })(xs))(u);
            };
        };
    };
};
var $519ef1967f17d101$export$9f81331332e444a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex)($519ef1967f17d101$var$monoidEndo);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(d) {
            return function(t) {
                return function(f) {
                    var joined = function(i) {
                        return function(a) {
                            return function(m) {
                                return append(d)(append(t(i)(a))(m));
                            };
                        };
                    };
                    return $519ef1967f17d101$var$unwrap(foldMapWithIndex1(joined)(f))(d);
                };
            };
        };
    };
};
var $519ef1967f17d101$export$222b6fd2bc53ca7a = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictMonoid) {
        var foldMapWithIndex2 = foldMapWithIndex1(dictMonoid);
        return function(f) {
            return foldMapWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $519ef1967f17d101$export$d803998e74b07aa8 = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(p) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && p(v)(v2)) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        index: v,
                        value: v2
                    });
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$c34ce7d3b9a0e = function(dictFoldableWithIndex) {
    var foldlWithIndex1 = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    return function(f) {
        var go = function(v) {
            return function(v1) {
                return function(v2) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return f(v)(v2);
                    return v1;
                };
            };
        };
        return foldlWithIndex1(go)($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $519ef1967f17d101$export$6d3978b14e304a71 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($1242d110ab1edcd9$export$e1c73e5b30670500(dictHeytingAlgebra));
        return function(t) {
            var $317 = foldMapWithIndex2(function(i) {
                var $319 = t(i);
                return function($320) {
                    return $1242d110ab1edcd9$export$286e7113895e33ef($319($320));
                };
            });
            return function($318) {
                return $519ef1967f17d101$var$unwrap($317($318));
            };
        };
    };
};
var $519ef1967f17d101$export$5dc11e929c02e763 = function(dictFoldableWithIndex) {
    var foldMapWithIndex1 = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    return function(dictHeytingAlgebra) {
        var foldMapWithIndex2 = foldMapWithIndex1($65ae0a43a0950bac$export$4f2b093ea8408d89(dictHeytingAlgebra));
        return function(t) {
            var $321 = foldMapWithIndex2(function(i) {
                var $323 = t(i);
                return function($324) {
                    return $65ae0a43a0950bac$export$c688766eb4789b8c($323($324));
                };
            });
            return function($322) {
                return $519ef1967f17d101$var$unwrap($321($322));
            };
        };
    };
};







// Generated by purs version 0.15.16
















// Generated by purs version 0.15.16

















var $2c7a64ff78781336$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$b86a2d00788e21b6);
var $2c7a64ff78781336$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$80f6258c17467741);
var $2c7a64ff78781336$var$traverse2 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$f5923975fb28337f);
var $2c7a64ff78781336$var$traverse3 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$1cee23aad9b21cdc);
var $2c7a64ff78781336$var$traverse4 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$54df524caf88dbea);
var $2c7a64ff78781336$var$traverse5 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$a73c18000a1a08d7);
var $2c7a64ff78781336$var$traverse6 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$ecbf0d941e1ac029);
var $2c7a64ff78781336$var$traverse7 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$617ac6e03fd9951c);
var $2c7a64ff78781336$export$37034f8d74d84f8b = function(dictTraversableWithIndex) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversableWithIndex.Traversable2());
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictTraversableWithIndex.FunctorWithIndex0());
    return function(dictApplicative) {
        var sequence1 = sequence(dictApplicative);
        return function(f) {
            var $174 = mapWithIndex(f);
            return function($175) {
                return sequence1($174($175));
            };
        };
    };
};
var $2c7a64ff78781336$export$955fdc0d24efa249 = function(dict) {
    return dict.traverseWithIndex;
};
var $2c7a64ff78781336$export$d50a9c31d69ee13c = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    return function(dictApplicative) {
        var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
        return function(f) {
            return traverseWithIndex2($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    };
};
var $2c7a64ff78781336$export$649571d878667376 = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0))(f($05149ea687d6b460$export$523c0b569236b342)(v.value1));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$98b99a3e5a5c2768;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a0208fa03195d5a3;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$d35878ee42638401;
    }
};
var $2c7a64ff78781336$export$f5fab9ea43775499 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexProduct = $334541180b4ef18c$export$341bcd9812b20e54(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexProduct = $519ef1967f17d101$export$e0fd1e7d0cab0fb2(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableProduct = $11d1e86de605dfc6$export$261d8d87b1749d17(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexProduct1 = functorWithIndexProduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexProduct1 = foldableWithIndexProduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableProduct1 = traversableProduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApplicative.Apply0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return lift2($a2051f9edf3d1db6$export$dbd0f18357df1ddd)(traverseWithIndex3(function($176) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($176));
                        })(v.value0))(traverseWithIndex4(function($177) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($177));
                        })(v.value1));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexProduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexProduct1;
            },
            Traversable2: function() {
                return traversableProduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$340ca064331c9524 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$3f7256b7802d7d35;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e07746a44d4d0673;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$b86a2d00788e21b6;
    }
};
var $2c7a64ff78781336$export$971c834447f08858 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse1(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$ff6e9b408c0f1d0a;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$db675654cef60b9a;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$80f6258c17467741;
    }
};
var $2c7a64ff78781336$export$82bf3aff27014955 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse2(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$67874b1834c6566b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$3a92905df29453fa;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$f5923975fb28337f;
    }
};
var $2c7a64ff78781336$export$e4fe4683618a40ff = {
    traverseWithIndex: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($50c50d1f444e5fa4$export$544bf02140fa9a77)(f($05149ea687d6b460$export$523c0b569236b342)(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$26258e29c904633d;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$92c42163dd2c46ce;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$63e84f34fb558532;
    }
};
var $2c7a64ff78781336$export$c0565467517236ee = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse3(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$707dfb58df7f6e4f;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$328d1f7f0045c999;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$1cee23aad9b21cdc;
    }
};
var $2c7a64ff78781336$export$c5842444d22f461a = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
                if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map($7d4cccdf062a2261$export$19db0165690c701a.create)(v($05149ea687d6b460$export$523c0b569236b342)(v1.value0));
                throw new Error("Failed pattern match at Data.TraversableWithIndex (line 95, column 1 - line 97, column 53): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$381e44b6c18f93d6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$617fc130b23797ca;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$29eea1300519490d;
    }
};
var $2c7a64ff78781336$export$f81f0b3aaf5918a5 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse4(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$50b3765d14980fc;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$dc8026a24f95d0a9;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$54df524caf88dbea;
    }
};
var $2c7a64ff78781336$export$298c1e0a7ee97588 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse5(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$b6070cf53db1d339;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$a77c731c3b37cfd;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$a73c18000a1a08d7;
    }
};
var $2c7a64ff78781336$export$fad1c006f410e5e2 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCoproduct = $334541180b4ef18c$export$6f7aa172554aa552(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCoproduct = $519ef1967f17d101$export$c8998bd70c04c75d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCoproduct = $11d1e86de605dfc6$export$78124b32135c203a(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCoproduct1 = functorWithIndexCoproduct(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCoproduct1 = foldableWithIndexCoproduct(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCoproduct1 = traversableCoproduct(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return $490ec114b4138e6d$export$ab04af7daecb905f(function() {
                        var $178 = map(function($181) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$37c4d04eafdc5515.create($181));
                        });
                        var $179 = traverseWithIndex3(function($182) {
                            return f($7d4cccdf062a2261$export$37c4d04eafdc5515.create($182));
                        });
                        return function($180) {
                            return $178($179($180));
                        };
                    }())(function() {
                        var $183 = map(function($186) {
                            return $490ec114b4138e6d$export$a7f096464cca5f3a($7d4cccdf062a2261$export$19db0165690c701a.create($186));
                        });
                        var $184 = traverseWithIndex4(function($187) {
                            return f($7d4cccdf062a2261$export$19db0165690c701a.create($187));
                        });
                        return function($185) {
                            return $183($184($185));
                        };
                    }());
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCoproduct1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCoproduct1;
            },
            Traversable2: function() {
                return traversableCoproduct1;
            }
        };
    };
};
var $2c7a64ff78781336$export$8270215089848547 = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(v) {
            return function(v1) {
                return pure(v1);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$dba6a24121753c2b;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$1add8b24fb58b747;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$e6d8402c3fd7d14d;
    }
};
var $2c7a64ff78781336$export$b78ffb8a06781844 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse6(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$8ba1941ba7d99c6;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$707470fe74326665;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$ecbf0d941e1ac029;
    }
};
var $2c7a64ff78781336$export$e1331c7aac1da04e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexCompose = $334541180b4ef18c$export$7935f2d7643e66ce(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexCompose = $519ef1967f17d101$export$ed9dddd4d2a66e4d(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableCompose = $11d1e86de605dfc6$export$8c91a5391205dbe(dictTraversableWithIndex.Traversable2());
    return function(dictTraversableWithIndex1) {
        var traverseWithIndex2 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex1);
        var functorWithIndexCompose1 = functorWithIndexCompose(dictTraversableWithIndex1.FunctorWithIndex0());
        var foldableWithIndexCompose1 = foldableWithIndexCompose(dictTraversableWithIndex1.FoldableWithIndex1());
        var traversableCompose1 = traversableCompose(dictTraversableWithIndex1.Traversable2());
        return {
            traverseWithIndex: function(dictApplicative) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
                var traverseWithIndex3 = traverseWithIndex1(dictApplicative);
                var traverseWithIndex4 = traverseWithIndex2(dictApplicative);
                return function(f) {
                    return function(v) {
                        return map($6051f44ece6b7171$export$5a3a146e358e1bcf)(traverseWithIndex3(function() {
                            var $188 = $71f2e2e9476163f8$export$c3095a23b368d1f2(f);
                            return function($189) {
                                return traverseWithIndex4($188($189));
                            };
                        }())(v));
                    };
                };
            },
            FunctorWithIndex0: function() {
                return functorWithIndexCompose1;
            },
            FoldableWithIndex1: function() {
                return foldableWithIndexCompose1;
            },
            Traversable2: function() {
                return traversableCompose1;
            }
        };
    };
};
var $2c7a64ff78781336$export$96888504550934b5 = {
    traverseWithIndex: function(dictApplicative) {
        return $2c7a64ff78781336$export$37034f8d74d84f8b($2c7a64ff78781336$export$96888504550934b5)(dictApplicative);
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$f10d51ea0aa3da42;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$e728f47f20b1eb28;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$9e4a28683e28e26a;
    }
};
var $2c7a64ff78781336$export$fc84432b7fe0f34e = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndexApp = $334541180b4ef18c$export$ffe1008ccae78edc(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexApp = $519ef1967f17d101$export$ca1485f10f9ca9ee(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableApp = $11d1e86de605dfc6$export$744e1c7707f1991f(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverseWithIndex2 = traverseWithIndex1(dictApplicative);
            return function(f) {
                return function(v) {
                    return map($60e028b2ef4ceb5f$export$86fbec116b87613f)(traverseWithIndex2(f)(v));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexApp;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexApp;
        },
        Traversable2: function() {
            return traversableApp;
        }
    };
};
var $2c7a64ff78781336$export$3d12857a1613dde6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse8 = $2c7a64ff78781336$var$traverse7(dictApplicative);
        return function(f) {
            return traverse8(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $334541180b4ef18c$export$eee3f4036a1ebada;
    },
    FoldableWithIndex1: function() {
        return $519ef1967f17d101$export$f9ed9b5a8131479e;
    },
    Traversable2: function() {
        return $11d1e86de605dfc6$export$617ac6e03fd9951c;
    }
};
var $2c7a64ff78781336$export$34e92304ce7da557 = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$c4ee441de2fba0d9);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$8c9fed8401f25951(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$6062de19d97bcfe7 = function(dictTraversableWithIndex) {
    var mapAccumRWithIndex1 = $2c7a64ff78781336$export$34e92304ce7da557(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumRWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(a)(b);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$2594b6cb66070a = function(dictTraversableWithIndex) {
    var traverseWithIndex1 = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)($b5a91a6cc4fccdbd$export$9fd2229713491b84);
    return function(f) {
        return function(s0) {
            return function(xs) {
                return $b5a91a6cc4fccdbd$export$25c41c6231a79e25(traverseWithIndex1(function(i) {
                    return function(a) {
                        return function(s) {
                            return f(i)(s)(a);
                        };
                    };
                })(xs))(s0);
            };
        };
    };
};
var $2c7a64ff78781336$export$2aa973d5e57cdb6b = function(dictTraversableWithIndex) {
    var mapAccumLWithIndex1 = $2c7a64ff78781336$export$2594b6cb66070a(dictTraversableWithIndex);
    return function(f) {
        return function(b0) {
            return function(xs) {
                return mapAccumLWithIndex1(function(i) {
                    return function(b) {
                        return function(a) {
                            var b$prime = f(i)(b)(a);
                            return {
                                accum: b$prime,
                                value: b$prime
                            };
                        };
                    };
                })(b0)(xs).value;
            };
        };
    };
};
var $2c7a64ff78781336$export$363f6bf7e04ec632 = function(dictApplicative) {
    return function(dictTraversableWithIndex) {
        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex)(dictApplicative));
    };
};




var $1f1c3fb67e79b37f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $1f1c3fb67e79b37f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $1f1c3fb67e79b37f$export$d8deaab87a4e223a = /* #__PURE__ */ function() {
    function NonEmpty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    NonEmpty.create = function(value0) {
        return function(value1) {
            return new NonEmpty(value0, value1);
        };
    };
    return NonEmpty;
}();
var $1f1c3fb67e79b37f$export$3d29df45c3f8cf54 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return {
        unfoldr1: function(f) {
            return function(b) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)($1f1c3fb67e79b37f$var$map(unfoldr($1f1c3fb67e79b37f$var$map1(f)))(f(b)));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $1f1c3fb67e79b37f$export$439306a4dcaafbb9 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    return function(a) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, empty);
    };
};
var $1f1c3fb67e79b37f$export$ffafc93d2cc87798 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                return "(NonEmpty " + (show(v.value0) + (" " + (show1(v.value1) + ")")));
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$d0a7bd743ccb8d67 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(dictSemigroup) {
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, append1(v.value1)(append1(pure(v1.value0))(v1.value1)));
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$a9a18ae5ba42aeab = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(v) {
        return alt(pure(v.value0))(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(m) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(m.value0), map2(f)(m.value1));
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$cdee60b0fe4303fd = function(dictFunctorWithIndex) {
    var mapWithIndex = $334541180b4ef18c$export$8f07ddce13659f50(dictFunctorWithIndex);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictFunctorWithIndex.Functor0());
    return {
        mapWithIndex: function(f) {
            return function(v) {
                return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0), mapWithIndex(function($245) {
                    return f($06733ae99ed4f534$export$8a67b48435b5d073.create($245));
                })(v.value1));
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$1d4c49925323035a = function(f) {
    return function(v) {
        return f(v.value0)(v.value1);
    };
};
var $1f1c3fb67e79b37f$export$20ebd08132411556 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    return {
        foldMap: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f(v.value0))(foldMap1(f)(v.value1));
                };
            };
        },
        foldl: function(f) {
            return function(b) {
                return function(v) {
                    return foldl(f)(f(b)(v.value0))(v.value1);
                };
            };
        },
        foldr: function(f) {
            return function(b) {
                return function(v) {
                    return f(v.value0)(foldr(f)(b)(v.value1));
                };
            };
        }
    };
};
var $1f1c3fb67e79b37f$export$9a79a74e355c28b1 = function(dictFoldableWithIndex) {
    var foldMapWithIndex = $519ef1967f17d101$export$18153bb1181268e5(dictFoldableWithIndex);
    var foldlWithIndex = $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex);
    var foldrWithIndex = $519ef1967f17d101$export$d859ed9adfa064ca(dictFoldableWithIndex);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldableWithIndex.Foldable0());
    return {
        foldMapWithIndex: function(dictMonoid) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMapWithIndex1 = foldMapWithIndex(dictMonoid);
            return function(f) {
                return function(v) {
                    return append1(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0))(foldMapWithIndex1(function($246) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($246));
                    })(v.value1));
                };
            };
        },
        foldlWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return foldlWithIndex(function($247) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($247));
                    })(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(b)(v.value0))(v.value1);
                };
            };
        },
        foldrWithIndex: function(f) {
            return function(b) {
                return function(v) {
                    return f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)(foldrWithIndex(function($248) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($248));
                    })(b)(v.value1));
                };
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$dbb721137b3f0cf6 = function(dictTraversable) {
    var sequence = $11d1e86de605dfc6$export$49bb65c2ea163039(dictTraversable);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorNonEmpty1 = $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0(dictTraversable.Functor0());
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var sequence1 = sequence(dictApplicative);
            return function(v) {
                return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(v.value0))(sequence1(v.value1));
            };
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f(v.value0)))(traverse1(f)(v.value1));
                };
            };
        },
        Functor0: function() {
            return functorNonEmpty1;
        },
        Foldable1: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$6e693a2e8188a772 = function(dictTraversableWithIndex) {
    var traverseWithIndex = $2c7a64ff78781336$export$955fdc0d24efa249(dictTraversableWithIndex);
    var functorWithIndex1 = $1f1c3fb67e79b37f$export$cdee60b0fe4303fd(dictTraversableWithIndex.FunctorWithIndex0());
    var foldableWithIndexNonEmpty1 = $1f1c3fb67e79b37f$export$9a79a74e355c28b1(dictTraversableWithIndex.FoldableWithIndex1());
    var traversableNonEmpty1 = $1f1c3fb67e79b37f$export$dbb721137b3f0cf6(dictTraversableWithIndex.Traversable2());
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverseWithIndex1 = traverseWithIndex(dictApplicative);
            return function(f) {
                return function(v) {
                    return apply(map2($1f1c3fb67e79b37f$export$d8deaab87a4e223a.create)(f($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value0)))(traverseWithIndex1(function($249) {
                        return f($06733ae99ed4f534$export$8a67b48435b5d073.create($249));
                    })(v.value1));
                };
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndex1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexNonEmpty1;
        },
        Traversable2: function() {
            return traversableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$ca19152d833c8d01 = function(dictFoldable) {
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldableNonEmpty1 = $1f1c3fb67e79b37f$export$20ebd08132411556(dictFoldable);
    return {
        foldMap1: function(dictSemigroup) {
            var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
            return function(f) {
                return function(v) {
                    return foldl(function(s) {
                        return function(a1) {
                            return append1(s)(f(a1));
                        };
                    })(f(v.value0))(v.value1);
                };
            };
        },
        foldr1: function(f) {
            return function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(v.value0)(f(v.value0))(foldr(function(a1) {
                    var $250 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(a1)(f(a1));
                    return function($251) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($250($251));
                    };
                })($06733ae99ed4f534$export$bebe9059409a0d04.value)(v.value1));
            };
        },
        foldl1: function(f) {
            return function(v) {
                return foldl(f)(v.value0)(v.value1);
            };
        },
        Foldable0: function() {
            return foldableNonEmpty1;
        }
    };
};
var $1f1c3fb67e79b37f$export$eb5e1ef4ea2eca3d = function(dictFoldable) {
    return $086486679aa806fa$export$eb5e1ef4ea2eca3d($1f1c3fb67e79b37f$export$ca19152d833c8d01(dictFoldable));
};
var $1f1c3fb67e79b37f$export$460809894af54b0a = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var eq11 = eq1(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x.value0)(y.value0) && eq11(x.value1)(y.value1);
                };
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$ec32b9103f985218 = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        var compare11 = compare1(dictOrd);
        var eqNonEmpty2 = eqNonEmpty1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare(x.value0)(y.value0);
                    if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare11(x.value1)(y.value1);
                };
            },
            Eq0: function() {
                return eqNonEmpty2;
            }
        };
    };
};
var $1f1c3fb67e79b37f$export$6a8b366193197b51 = function(dictEq1) {
    var eqNonEmpty1 = $1f1c3fb67e79b37f$export$460809894af54b0a(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqNonEmpty1(dictEq));
        }
    };
};
var $1f1c3fb67e79b37f$export$de0dd6c052e29447 = function(dictOrd1) {
    var ordNonEmpty1 = $1f1c3fb67e79b37f$export$ec32b9103f985218(dictOrd1);
    var eq1NonEmpty1 = $1f1c3fb67e79b37f$export$6a8b366193197b51(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordNonEmpty1(dictOrd));
        },
        Eq10: function() {
            return eq1NonEmpty1;
        }
    };
};











var $78c799cba34fcb8d$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $78c799cba34fcb8d$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $78c799cba34fcb8d$export$c1bed610ade55e1c = /* #__PURE__ */ function() {
    function Nil() {}
    Nil.value = new Nil();
    return Nil;
}();
var $78c799cba34fcb8d$export$74c44e616647f5c0 = /* #__PURE__ */ function() {
    function Cons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Cons.create = function(value0) {
        return function(value1) {
            return new Cons(value0, value1);
        };
    };
    return Cons;
}();
var $78c799cba34fcb8d$export$ab241a3582569781 = function(x) {
    return x;
};
var $78c799cba34fcb8d$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $78c799cba34fcb8d$export$e1330f0deced5836 = {
    Coercible0: function() {
        return undefined;
    }
};
var $78c799cba34fcb8d$export$4fa915e2865b1814 = function(a) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $78c799cba34fcb8d$var$listMap = function(f) {
    var chunkedRevMap = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v);
                    $copy_v1 = v1.value1.value1.value1;
                    return;
                }
                var unrolledMap = function(v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value1.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
                    return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
                };
                var reverseUnrolledMap = function($copy_v2) {
                    return function($copy_v3) {
                        var $tco_var_v2 = $copy_v2;
                        var $tco_done1 = false;
                        var $tco_result;
                        function $tco_loop(v2, v3) {
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value0.value1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v2 = v2.value1;
                                $copy_v3 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v2.value0.value1.value1.value0), v3)));
                                return;
                            }
                            $tco_done1 = true;
                            return v3;
                        }
                        while(!$tco_done1)$tco_result = $tco_loop($tco_var_v2, $copy_v3);
                        return $tco_result;
                    };
                };
                $tco_done = true;
                return reverseUnrolledMap(v)(unrolledMap(v1));
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return chunkedRevMap($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $78c799cba34fcb8d$export$40b9e4330ffd17e3 = {
    map: $78c799cba34fcb8d$var$listMap
};
var $78c799cba34fcb8d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$3c979cc7d75b024c = /* #__PURE__ */ $1f1c3fb67e79b37f$export$a6ffbf6bde05f5c0($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $78c799cba34fcb8d$export$92659ee1fc91a075 = {
    foldr: function(f) {
        return function(b) {
            var rev = function() {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                                $copy_v1 = v1.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 107, column 7 - line 107, column 23): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            }();
            var $284 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)($f57f4b701aa7b66e$export$8a83211c878a3f1f(f))(b);
            return function($285) {
                return $284(rev($285));
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_b) {
            return function($copy_v) {
                var $tco_var_b = $copy_b;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(b, v) {
                    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done1 = true;
                        return b;
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_b = f(b)(v.value0);
                        $copy_v = v.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List.Types (line 111, column 12 - line 113, column 30): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_b, $copy_v);
                return $tco_result;
            };
        };
        return go;
    },
    foldMap: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075)(function(acc) {
                var $286 = append2(acc);
                return function($287) {
                    return $286(f($287));
                };
            })(mempty);
        };
    }
};
var $78c799cba34fcb8d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($78c799cba34fcb8d$export$92659ee1fc91a075)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $78c799cba34fcb8d$export$604c31769a93bbe0 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$20ebd08132411556($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$465bfc9894c20a50 = {
    foldrWithIndex: function(f) {
        return function(b) {
            return function(xs) {
                var v = function() {
                    var rev = $78c799cba34fcb8d$var$foldl(function(v1) {
                        return function(a) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 + 1 | 0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.value1));
                        };
                    });
                    return rev(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
                }();
                return $71f2e2e9476163f8$export$6f71268a1666ab58($78c799cba34fcb8d$var$foldl(function(v1) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0 - 1 | 0, f(v1.value0 - 1 | 0)(a)(v1.value1));
                    };
                })(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, b))(v.value1));
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(acc) {
            var $288 = $78c799cba34fcb8d$var$foldl(function(v) {
                return function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0 + 1 | 0, f(v.value0)(v.value1)(a));
                };
            })(new $71f2e2e9476163f8$export$1908877435b1d5e9(0, acc));
            return function($289) {
                return $71f2e2e9476163f8$export$6f71268a1666ab58($288($289));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        return function(f) {
            return $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50)(function(i) {
                return function(acc) {
                    var $290 = append2(acc);
                    var $291 = f(i);
                    return function($292) {
                        return $290($291($292));
                    };
                };
            })(mempty);
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$var$foldableWithIndexNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$9a79a74e355c28b1($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldMapWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$18153bb1181268e5($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldlWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$var$foldableWithIndexNonEmpty);
var $78c799cba34fcb8d$var$foldrWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$d859ed9adfa064ca($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$var$foldlWithIndex1 = /* #__PURE__ */ $519ef1967f17d101$export$2d70b9efb960f478($78c799cba34fcb8d$export$465bfc9894c20a50);
var $78c799cba34fcb8d$export$181d5b43cf38a79a = {
    foldMapWithIndex: function(dictMonoid) {
        var foldMapWithIndex1 = $78c799cba34fcb8d$var$foldMapWithIndex(dictMonoid);
        return function(f) {
            return function(v) {
                return foldMapWithIndex1(function() {
                    var $293 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($294) {
                        return f($293($294));
                    };
                }())(v);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldlWithIndex(function() {
                    var $295 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($296) {
                        return f($295($296));
                    };
                }())(b)(v);
            };
        };
    },
    foldrWithIndex: function(f) {
        return function(b) {
            return function(v) {
                return $78c799cba34fcb8d$var$foldrWithIndex(function() {
                    var $297 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($298) {
                        return f($297($298));
                    };
                }())(b)(v);
            };
        };
    },
    Foldable0: function() {
        return $78c799cba34fcb8d$export$604c31769a93bbe0;
    }
};
var $78c799cba34fcb8d$export$3951fb12c9649f2b = {
    mapWithIndex: function(f) {
        return $78c799cba34fcb8d$var$foldrWithIndex1(function(i) {
            return function(x) {
                return function(acc) {
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(f(i)(x), acc);
                };
            };
        })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50(/* #__PURE__ */ $1f1c3fb67e79b37f$export$cdee60b0fe4303fd($78c799cba34fcb8d$export$3951fb12c9649f2b));
var $78c799cba34fcb8d$export$116ff457f4ca2f6a = {
    mapWithIndex: function(fn) {
        return function(v) {
            return $78c799cba34fcb8d$var$mapWithIndex(function() {
                var $299 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                return function($300) {
                    return fn($299($300));
                };
            }())(v);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$11cb7909a85856b = {
    append: function(xs) {
        return function(ys) {
            return $78c799cba34fcb8d$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(ys)(xs);
        };
    }
};
var $78c799cba34fcb8d$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $78c799cba34fcb8d$export$14584e231e9c63ca = /* #__PURE__ */ function() {
    return {
        mempty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Semigroup0: function() {
            return $78c799cba34fcb8d$export$11cb7909a85856b;
        }
    };
}();
var $78c799cba34fcb8d$export$a8cfc3dfdfca72cf = {
    append: function(v) {
        return function(as$prime) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $78c799cba34fcb8d$var$append1(v.value1)($78c799cba34fcb8d$export$effcdbd76139450(as$prime)));
        };
    }
};
var $78c799cba34fcb8d$export$36831384a74c4427 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return "Nil";
            return "(" + ($78c799cba34fcb8d$var$intercalate(" : ")($78c799cba34fcb8d$var$map(show)(v)) + " : Nil)");
        }
    };
};
var $78c799cba34fcb8d$export$3a5290e21dfc0ad7 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($1f1c3fb67e79b37f$export$ffafc93d2cc87798(dictShow)($78c799cba34fcb8d$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(NonEmptyList " + (show(v) + ")");
        }
    };
};
var $78c799cba34fcb8d$export$99c2ce29c0ead637 = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $301 = map1($78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            var $302 = $78c799cba34fcb8d$var$foldl(function(acc) {
                var $304 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                return function($305) {
                    return $304(f($305));
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($303) {
                return $301($302($303));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$99c2ce29c0ead637)(dictApplicative)($78c799cba34fcb8d$var$identity);
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    },
    Foldable1: function() {
        return $78c799cba34fcb8d$export$92659ee1fc91a075;
    }
};
var $78c799cba34fcb8d$export$d0a0d45336d2d3e3 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $78c799cba34fcb8d$export$aed77e3b7bbfc02d = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var rev = $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            var $306 = map1(rev);
            var $307 = $78c799cba34fcb8d$var$foldlWithIndex1(function(i) {
                return function(acc) {
                    var $309 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))(acc);
                    var $310 = f(i);
                    return function($311) {
                        return $309($310($311));
                    };
                };
            })(pure1($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
            return function($308) {
                return $306($307($308));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$3951fb12c9649f2b;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$465bfc9894c20a50;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$99c2ce29c0ead637;
    }
};
var $78c799cba34fcb8d$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249(/* #__PURE__ */ $1f1c3fb67e79b37f$export$6e693a2e8188a772($78c799cba34fcb8d$export$aed77e3b7bbfc02d));
var $78c799cba34fcb8d$export$29974dc3d1d7196b = {
    traverseWithIndex: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var traverseWithIndex1 = $78c799cba34fcb8d$var$traverseWithIndex(dictApplicative);
        return function(f) {
            return function(v) {
                return map1($78c799cba34fcb8d$export$ab241a3582569781)(traverseWithIndex1(function() {
                    var $312 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(0)($78c799cba34fcb8d$var$add(1));
                    return function($313) {
                        return f($312($313));
                    };
                }())(v));
            };
        };
    },
    FunctorWithIndex0: function() {
        return $78c799cba34fcb8d$export$116ff457f4ca2f6a;
    },
    FoldableWithIndex1: function() {
        return $78c799cba34fcb8d$export$181d5b43cf38a79a;
    },
    Traversable2: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};
var $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo);
                            return;
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, memo));
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 135, column 22 - line 137, column 61): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    }
};
var $78c799cba34fcb8d$export$1d41caf0a0a6a680 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$74c44e616647f5c0.create))($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(memo);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, memo);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Types (line 142, column 22 - line 144, column 52): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    },
    Unfoldable10: function() {
        return $78c799cba34fcb8d$export$c7fe2ca4bf0cb8df;
    }
};
var $78c799cba34fcb8d$export$6907256bb4275b5b = /* #__PURE__ */ $1f1c3fb67e79b37f$export$3d29df45c3f8cf54($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $78c799cba34fcb8d$export$b16c60cd2a91c938 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ca19152d833c8d01($78c799cba34fcb8d$export$92659ee1fc91a075);
var $78c799cba34fcb8d$export$44a6d15320cfc4c5 = {
    extend: function(f) {
        return function(v) {
            var go = function(a) {
                return function(v1) {
                    return {
                        val: new $78c799cba34fcb8d$export$74c44e616647f5c0(f(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v1.acc)), v1.val),
                        acc: new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v1.acc)
                    };
                };
            };
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v), $78c799cba34fcb8d$var$foldr(go)({
                val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            })(v.value1).val);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$a2b02e086d468c06 = {
    extend: function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var go = function(a$prime) {
                    return function(v2) {
                        var acc$prime = new $78c799cba34fcb8d$export$74c44e616647f5c0(a$prime, v2.acc);
                        return {
                            val: new $78c799cba34fcb8d$export$74c44e616647f5c0(v(acc$prime), v2.val),
                            acc: acc$prime
                        };
                    };
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v(v1), $78c799cba34fcb8d$var$foldr(go)({
                    val: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
                    acc: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                })(v1.value1).val);
            }
            throw new Error("Failed pattern match at Data.List.Types (line 180, column 1 - line 187, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$b7e705972f3b8317 = {
    eq1: function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        return function($copy_v2) {
                            var $tco_var_v = $copy_v;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(v, v1, v2) {
                                if (!v2) {
                                    $tco_done = true;
                                    return false;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                    $tco_done = true;
                                    return v2;
                                }
                                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_var_v = v.value1;
                                    $tco_var_v1 = v1.value1;
                                    $copy_v2 = v2 && eq(v1.value0)(v.value0);
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                            return $tco_result;
                        };
                    };
                };
                return go(xs)(ys)(true);
            };
        };
    }
};
var $78c799cba34fcb8d$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$96fd6c73d03c9dd2($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$var$eqNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$460809894af54b0a($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$80901a10e94c964a = /* #__PURE__ */ $1f1c3fb67e79b37f$export$6a8b366193197b51($78c799cba34fcb8d$export$b7e705972f3b8317);
var $78c799cba34fcb8d$export$1ae88a7f3c5f59ef = function(dictEq) {
    return {
        eq: $78c799cba34fcb8d$var$eq1(dictEq)
    };
};
var $78c799cba34fcb8d$export$25985b0447eac39b = function(dictEq) {
    return $78c799cba34fcb8d$var$eqNonEmpty(dictEq);
};
var $78c799cba34fcb8d$export$a37dd417b96243af = {
    compare1: function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return function(xs) {
            return function(ys) {
                var go = function($copy_v) {
                    return function($copy_v1) {
                        var $tco_var_v = $copy_v;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                var v2 = compare(v.value0)(v1.value0);
                                if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    $tco_var_v = v.value1;
                                    $copy_v1 = v1.value1;
                                    return;
                                }
                                $tco_done = true;
                                return v2;
                            }
                            throw new Error("Failed pattern match at Data.List.Types (line 60, column 5 - line 60, column 20): " + [
                                v.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                        return $tco_result;
                    };
                };
                return go(xs)(ys);
            };
        };
    },
    Eq10: function() {
        return $78c799cba34fcb8d$export$b7e705972f3b8317;
    }
};
var $78c799cba34fcb8d$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$693feb0c3c484b70($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$var$ordNonEmpty = /* #__PURE__ */ $1f1c3fb67e79b37f$export$ec32b9103f985218($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$bf20701e75931fe8 = /* #__PURE__ */ $1f1c3fb67e79b37f$export$de0dd6c052e29447($78c799cba34fcb8d$export$a37dd417b96243af);
var $78c799cba34fcb8d$export$86359cd4476084f8 = function(dictOrd) {
    var eqList1 = $78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictOrd.Eq0());
    return {
        compare: $78c799cba34fcb8d$var$compare1(dictOrd),
        Eq0: function() {
            return eqList1;
        }
    };
};
var $78c799cba34fcb8d$export$783a13ebf5a1203d = function(dictOrd) {
    return $78c799cba34fcb8d$var$ordNonEmpty(dictOrd);
};
var $78c799cba34fcb8d$export$7bc4d4de9c57db1f = {
    extract: function(v) {
        return v.value0;
    },
    Extend0: function() {
        return $78c799cba34fcb8d$export$44a6d15320cfc4c5;
    }
};
var $78c799cba34fcb8d$export$7e49f2fa1ca16fbc = {
    apply: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$map(v.value0)(v1))($7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 157, column 1 - line 159, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc);
var $78c799cba34fcb8d$export$18f1a42667f2921e = {
    apply: function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0(v1.value0), $78c799cba34fcb8d$var$append1($78c799cba34fcb8d$var$apply(v.value1)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $78c799cba34fcb8d$export$c1bed610ade55e1c.value)))($78c799cba34fcb8d$var$apply(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(v1.value1)));
        };
    },
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$497dcf96eb2383ec = {
    bind: function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $78c799cba34fcb8d$var$append1(v1(v.value0))($70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec)(v.value1)(v1));
            throw new Error("Failed pattern match at Data.List.Types (line 164, column 1 - line 166, column 37): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $78c799cba34fcb8d$export$12e3398ee6f4a417 = {
    bind: function(v) {
        return function(f) {
            var v1 = f(v.value0);
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, $78c799cba34fcb8d$var$append1(v1.value1)($78c799cba34fcb8d$var$bind(v.value1)(function($314) {
                return $78c799cba34fcb8d$export$effcdbd76139450(f($314));
            })));
        };
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$export$25cda6d3e08b28fe = {
    pure: function(a) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    },
    Apply0: function() {
        return $78c799cba34fcb8d$export$7e49f2fa1ca16fbc;
    }
};
var $78c799cba34fcb8d$export$7c78e86b21f51881 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$497dcf96eb2383ec;
    }
};
var $78c799cba34fcb8d$export$852a754cd45a1ed = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$a8cfc3dfdfca72cf),
    Functor0: function() {
        return $78c799cba34fcb8d$export$3c979cc7d75b024c;
    }
};
var $78c799cba34fcb8d$export$97980ce7ea95015b = {
    alt: $78c799cba34fcb8d$var$append1,
    Functor0: function() {
        return $78c799cba34fcb8d$export$40b9e4330ffd17e3;
    }
};
var $78c799cba34fcb8d$export$55d622505c452dcb = /* #__PURE__ */ function() {
    return {
        empty: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        Alt0: function() {
            return $78c799cba34fcb8d$export$97980ce7ea95015b;
        }
    };
}();
var $78c799cba34fcb8d$export$503ce72759d93980 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$25cda6d3e08b28fe;
    },
    Plus1: function() {
        return $78c799cba34fcb8d$export$55d622505c452dcb;
    }
};
var $78c799cba34fcb8d$export$9ea554ee3c75e458 = {
    Monad0: function() {
        return $78c799cba34fcb8d$export$7c78e86b21f51881;
    },
    Alternative1: function() {
        return $78c799cba34fcb8d$export$503ce72759d93980;
    }
};
var $78c799cba34fcb8d$export$e5d0ed5dac805e10 = {
    pure: /* #__PURE__ */ function() {
        var $315 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
        return function($316) {
            return $78c799cba34fcb8d$export$ab241a3582569781($315($316));
        };
    }(),
    Apply0: function() {
        return $78c799cba34fcb8d$export$18f1a42667f2921e;
    }
};
var $78c799cba34fcb8d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$e5d0ed5dac805e10);
var $78c799cba34fcb8d$export$f444cc7484072e62 = {
    Applicative0: function() {
        return $78c799cba34fcb8d$export$e5d0ed5dac805e10;
    },
    Bind1: function() {
        return $78c799cba34fcb8d$export$12e3398ee6f4a417;
    }
};
var $78c799cba34fcb8d$export$fac1bbd0707bc766 = {
    traverse1: function(dictApply) {
        var Functor0 = dictApply.Functor0();
        var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(dictApply);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        return function(f) {
            return function(v) {
                return mapFlipped($78c799cba34fcb8d$var$foldl(function(acc) {
                    var $317 = lift2($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))(acc);
                    return function($318) {
                        return $317(f($318));
                    };
                })(map1($78c799cba34fcb8d$var$pure)(f(v.value0)))(v.value1))(function(v1) {
                    return $78c799cba34fcb8d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($78c799cba34fcb8d$export$4fa915e2865b1814))($78c799cba34fcb8d$var$pure(v1.value0))(v1.value1);
                });
            };
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$d2990bb35e0a3e00($78c799cba34fcb8d$export$fac1bbd0707bc766)(dictApply)($78c799cba34fcb8d$var$identity);
    },
    Foldable10: function() {
        return $78c799cba34fcb8d$export$b16c60cd2a91c938;
    },
    Traversable1: function() {
        return $78c799cba34fcb8d$export$d0a0d45336d2d3e3;
    }
};






// Generated by purs version 0.15.16
const $092fe44bc0883be6$export$709e3b51bf2e2249 = function(a) {
    return a.join("");
};
const $092fe44bc0883be6$export$f718f38b069557c4 = function(s) {
    return s.split("");
};
const $092fe44bc0883be6$export$439306a4dcaafbb9 = function(c) {
    return c;
};
const $092fe44bc0883be6$export$f23b62aaf3f3dcce = function(just) {
    return function(nothing) {
        return function(i) {
            return function(s) {
                return i >= 0 && i < s.length ? just(s.charAt(i)) : nothing;
            };
        };
    };
};
const $092fe44bc0883be6$export$dc80a44c5e0495a = function(just) {
    return function(nothing) {
        return function(s) {
            return s.length === 1 ? just(s) : nothing;
        };
    };
};
const $092fe44bc0883be6$export$f24224f1c91d8156 = function(s) {
    return s.length;
};
const $092fe44bc0883be6$export$29a68f758c141c85 = function(p) {
    return function(s) {
        var i = 0;
        while(i < s.length && p(s.charAt(i)))i++;
        return i;
    };
};
const $092fe44bc0883be6$export$7e78e83ef6946ae3 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.indexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$dbaa25b6da818165 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    if (startAt < 0 || startAt > s.length) return nothing;
                    var i = s.indexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$a83518545dfc0fc1 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(s) {
                var i = s.lastIndexOf(x);
                return i === -1 ? nothing : just(i);
            };
        };
    };
};
const $092fe44bc0883be6$export$12738dfb878f3de0 = function(just) {
    return function(nothing) {
        return function(x) {
            return function(startAt) {
                return function(s) {
                    var i = s.lastIndexOf(x, startAt);
                    return i === -1 ? nothing : just(i);
                };
            };
        };
    };
};
const $092fe44bc0883be6$export$b7df5d561049483a = function(n) {
    return function(s) {
        return s.substr(0, n);
    };
};
const $092fe44bc0883be6$export$663103110d94aac9 = function(n) {
    return function(s) {
        return s.substring(n);
    };
};
const $092fe44bc0883be6$export$58adb3bec8346d0f = function(b) {
    return function(e) {
        return function(s) {
            return s.slice(b, e);
        };
    };
};
const $092fe44bc0883be6$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        return {
            before: s.substring(0, i),
            after: s.substring(i)
        };
    };
};



// Generated by purs version 0.15.16
const $3296d29fc7ea4822$export$bbcf894add1d392c = function(i) {
    return function(s) {
        if (i >= 0 && i < s.length) return s.charAt(i);
        throw new Error("Data.String.Unsafe.charAt: Invalid index.");
    };
};
const $3296d29fc7ea4822$export$eba6f6f03b0a92e7 = function(s) {
    if (s.length === 1) return s.charAt(0);
    throw new Error("Data.String.Unsafe.char: Expected string of length 1.");
};




var $1a77d6934b592676$export$b446f6baa3bb1430 = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3296d29fc7ea4822$export$bbcf894add1d392c(0)(v),
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(v)
    });
};
var $1a77d6934b592676$export$bafb3da1554990db = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dc80a44c5e0495a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$1bbc425ddca7f2c6 = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$cc5663efaab5bcf6 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(str) - $092fe44bc0883be6$export$f24224f1c91d8156(v) | 0)(str);
        var $14 = v1.after === v;
        if ($14) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.before);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$71c2a1babd78d286 = function(v) {
    return function(str) {
        var v1 = $092fe44bc0883be6$export$b0d75975ac0be0e1($092fe44bc0883be6$export$f24224f1c91d8156(v))(str);
        var $20 = v1.before === v;
        if ($20) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.after);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $1a77d6934b592676$export$9dc3eed83bb14216 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$12738dfb878f3de0($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$557cfb7ed375eeb7 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$a83518545dfc0fc1($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$7f0e23922170149a = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$dbaa25b6da818165($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$305f7d4e9d4624f2 = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$7e78e83ef6946ae3($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $1a77d6934b592676$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$29a68f758c141c85(p)(s))(s);
    };
};
var $1a77d6934b592676$export$6ba801e3e123536e = function(i) {
    return function(s) {
        return $092fe44bc0883be6$export$b7df5d561049483a($092fe44bc0883be6$export$f24224f1c91d8156(s) - i | 0)(s);
    };
};
var $1a77d6934b592676$export$2344b14b097df817 = function(pat) {
    var $23 = $1a77d6934b592676$export$305f7d4e9d4624f2(pat);
    return function($24) {
        return $06733ae99ed4f534$export$c15bd07a493e1236($23($24));
    };
};
var $1a77d6934b592676$export$bbcf894add1d392c = /* #__PURE__ */ function() {
    return $092fe44bc0883be6$export$f23b62aaf3f3dcce($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();


// Generated by purs version 0.15.16
const $5b07e36f812dd04b$export$3ece336175b57f19 = function(lt) {
    return function(eq) {
        return function(gt) {
            return function(s1) {
                return function(s2) {
                    var result = s1.localeCompare(s2);
                    return result < 0 ? lt : result > 0 ? gt : eq;
                };
            };
        };
    };
};
const $5b07e36f812dd04b$export$77ad94ebf1c2b9ed = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(s1, s2);
        };
    };
};
const $5b07e36f812dd04b$export$b8b3234b4edfc4c2 = function(s1) {
    return function(s2) {
        return function(s3) {
            return s3.replace(new RegExp(s1.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"), s2); // eslint-disable-line no-useless-escape
        };
    };
};
const $5b07e36f812dd04b$export$65980d18b75784e2 = function(sep) {
    return function(s) {
        return s.split(sep);
    };
};
const $5b07e36f812dd04b$export$b1ceac3893cbda6b = function(s) {
    return s.toLowerCase();
};
const $5b07e36f812dd04b$export$43df7fc17cca38a4 = function(s) {
    return s.toUpperCase();
};
const $5b07e36f812dd04b$export$87c2784dc9fc4ab = function(s) {
    return s.trim();
};
const $5b07e36f812dd04b$export$ec1dc8fbeea3467e = function(s) {
    return function(xs) {
        return xs.join(s);
    };
};



var $22d4f8ab6946d33a$export$7b1b591b262c240 = function(s) {
    return s === "";
};
var $22d4f8ab6946d33a$export$35652c12e6caefdf = /* #__PURE__ */ function() {
    return $5b07e36f812dd04b$export$3ece336175b57f19($5026be88823ef1f4$export$7158f0ceb70f54c7.value)($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value)($5026be88823ef1f4$export$b023c82b48e70453.value);
}();



// Generated by purs version 0.15.16
// Generated by purs version 0.15.16

// Generated by purs version 0.15.16
/* eslint-disable no-eq-null, eqeqeq */ function $0e031af7428ef07d$export$dbafa4424a806c15(x) {
    return x;
}
const $0e031af7428ef07d$export$63ea9a5410ee0cef = null;
function $0e031af7428ef07d$export$fac44ee5b035f737(j) {
    return JSON.stringify(j);
}
function $0e031af7428ef07d$export$de66f4fa6860548(i) {
    return function(j) {
        return JSON.stringify(j, null, i);
    };
}
function $0e031af7428ef07d$var$isArray(a) {
    return Object.prototype.toString.call(a) === "[object Array]";
}
function $0e031af7428ef07d$export$8e91e9560ac84224(isNull, isBool, isNum, isStr, isArr, isObj, j) {
    if (j == null) return isNull();
    else if (typeof j === "boolean") return isBool(j);
    else if (typeof j === "number") return isNum(j);
    else if (typeof j === "string") return isStr(j);
    else if (Object.prototype.toString.call(j) === "[object Array]") return isArr(j);
    else return isObj(j);
}
function $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a, b) {
    if (a == null) {
        if (b == null) return EQ;
        else return LT;
    } else if (typeof a === "boolean") {
        if (typeof b === "boolean") {
            // boolean / boolean
            if (a === b) return EQ;
            else if (a === false) return LT;
            else return GT;
        } else if (b == null) return GT;
        else return LT;
    } else if (typeof a === "number") {
        if (typeof b === "number") {
            if (a === b) return EQ;
            else if (a < b) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else return LT;
    } else if (typeof a === "string") {
        if (typeof b === "string") {
            if (a === b) return EQ;
            else if (a < b) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else return LT;
    } else if ($0e031af7428ef07d$var$isArray(a)) {
        if ($0e031af7428ef07d$var$isArray(b)) {
            for(var i = 0; i < Math.min(a.length, b.length); i++){
                var ca = $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a[i], b[i]);
                if (ca !== EQ) return ca;
            }
            if (a.length === b.length) return EQ;
            else if (a.length < b.length) return LT;
            else return GT;
        } else if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else if (typeof b === "string") return GT;
        else return LT;
    } else {
        if (b == null) return GT;
        else if (typeof b === "boolean") return GT;
        else if (typeof b === "number") return GT;
        else if (typeof b === "string") return GT;
        else if ($0e031af7428ef07d$var$isArray(b)) return GT;
        else {
            var akeys = Object.keys(a);
            var bkeys = Object.keys(b);
            if (akeys.length < bkeys.length) return LT;
            else if (akeys.length > bkeys.length) return GT;
            var keys = akeys.concat(bkeys).sort();
            for(var j = 0; j < keys.length; j++){
                var k = keys[j];
                if (a[k] === undefined) return LT;
                else if (b[k] === undefined) return GT;
                var ck = $0e031af7428ef07d$export$6b486fc7358c5fa4(EQ, GT, LT, a[k], b[k]);
                if (ck !== EQ) return ck;
            }
            return EQ;
        }
    }
}







// Generated by purs version 0.15.16
function $03b6b966974423fe$export$86b08f6436aa565c(m) {
    return function() {
        var r = {};
        for(var k in m)if (hasOwnProperty.call(m, k)) r[k] = m[k];
        return r;
    };
}
const $03b6b966974423fe$export$6e22c362a0406a2c = {};
function $03b6b966974423fe$export$c764c4f4747e1972(f) {
    return f();
}
function $03b6b966974423fe$export$7c3aa937ffdd4482(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(m0[k]);
    return m;
}
function $03b6b966974423fe$export$b583322487d15176(m0, f) {
    var m = {};
    for(var k in m0)if (hasOwnProperty.call(m0, k)) m[k] = f(k)(m0[k]);
    return m;
}
function $03b6b966974423fe$export$882f367473bfeff9(bind) {
    return function(f) {
        return function(mz) {
            return function(m) {
                var acc = mz;
                function g(k) {
                    return function(z) {
                        return f(z)(k)(m[k]);
                    };
                }
                for(var k in m)if (hasOwnProperty.call(m, k)) acc = bind(acc)(g(k));
                return acc;
            };
        };
    };
}
function $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, fromMaybe) {
    var acc = z;
    for(var k in m)if (hasOwnProperty.call(m, k)) {
        var maybeR = f(acc)(k)(m[k]);
        var r = fromMaybe(null)(maybeR);
        if (r === null) return acc;
        else acc = r;
    }
    return acc;
}
function $03b6b966974423fe$export$84bf76cd7afc7469(f) {
    return function(m) {
        for(var k in m){
            if (hasOwnProperty.call(m, k) && !f(k)(m[k])) return false;
        }
        return true;
    };
}
function $03b6b966974423fe$export$346677f925de839c(m) {
    var s = 0;
    for(var k in m)if (hasOwnProperty.call(m, k)) ++s;
    return s;
}
function $03b6b966974423fe$export$75b750e7d0325364(no, yes, k, m) {
    return k in m ? yes(m[k]) : no;
}
function $03b6b966974423fe$export$d947399a194fcef2(no, yes, k, m) {
    return function() {
        return k in m ? yes(m[k]) : no;
    };
}
function $03b6b966974423fe$export$4b1360bff9337362(f) {
    return function(m) {
        var r = [];
        for(var k in m)if (hasOwnProperty.call(m, k)) r.push(f(k)(m[k]));
        return r;
    };
}
const $03b6b966974423fe$export$ed97f33186d4b816 = Object.keys || $03b6b966974423fe$export$4b1360bff9337362(function(k) {
    return function() {
        return k;
    };
});























// Generated by purs version 0.15.16
const $0061661dcaa2328e$export$b8cb59497041ffe4 = function() {
    return {};
};
function $0061661dcaa2328e$export$6dc5f95d8548a16a(just) {
    return function(nothing) {
        return function(k) {
            return function(m) {
                return function() {
                    return ({}).hasOwnProperty.call(m, k) ? just(m[k]) : nothing;
                };
            };
        };
    };
}
function $0061661dcaa2328e$export$dc13bdd74c909d26(k) {
    return function(v) {
        return function(m) {
            return function() {
                m[k] = v;
                return m;
            };
        };
    };
}
const $0061661dcaa2328e$export$1822828d790e23ee = function(k) {
    return function(m) {
        return function() {
            delete m[k];
            return m;
        };
    };
};



var $47b38aa8c72308f2$export$4d3fb11e950abb9e = /* #__PURE__ */ function() {
    return $0061661dcaa2328e$export$6dc5f95d8548a16a($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();



var $c045ea5df33bba60$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($08944f7287e2704c$export$14049c9ff5b55fb3);
var $c045ea5df33bba60$var$showTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c045ea5df33bba60$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$forWithIndex_ = /* #__PURE__ */ $519ef1967f17d101$export$f441c83f81b7710f($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($08944f7287e2704c$export$603d84e49041d7b2);
var $c045ea5df33bba60$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($08944f7287e2704c$export$a47991927f51461e);
var $c045ea5df33bba60$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $c045ea5df33bba60$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c045ea5df33bba60$var$ordTuple = /* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c045ea5df33bba60$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c045ea5df33bba60$export$68c286be0e7e55b7 = /* #__PURE__ */ $03b6b966974423fe$export$4b1360bff9337362(function(v) {
    return function(v1) {
        return v1;
    };
});
var $c045ea5df33bba60$export$823be24f8766da23 = function(dictUnfoldable) {
    var $89 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $90 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($91) {
        return $89($90($91));
    };
};
var $c045ea5df33bba60$export$930399be55d0753b = function(dictUnfoldable) {
    var $92 = $396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable);
    var $93 = $c045ea5df33bba60$var$sortWith($71f2e2e9476163f8$export$9e770fa6ce19a9d6);
    var $94 = $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
    return function($95) {
        return $92($93($94($95)));
    };
};
var $c045ea5df33bba60$var$toAscArray = /* #__PURE__ */ $c045ea5df33bba60$export$930399be55d0753b($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $c045ea5df33bba60$var$toArray = /* #__PURE__ */ function() {
    return $03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $c045ea5df33bba60$export$170df9728335f27d = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return $03b6b966974423fe$export$c764c4f4747e1972($c045ea5df33bba60$var$bindFlipped($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v))($0061661dcaa2328e$export$b8cb59497041ffe4));
    };
};
var $c045ea5df33bba60$export$4cfa48b10b7cd72d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225($c045ea5df33bba60$var$showTuple(dictShow)));
    return {
        show: function(m) {
            return "(fromFoldable " + (show($c045ea5df33bba60$var$toArray(m)) + ")");
        }
    };
};
var $c045ea5df33bba60$var$mutate = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $c045ea5df33bba60$export$170df9728335f27d(m)();
            f(s)();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$6a0d13241802fe80 = /* #__PURE__ */ $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $c045ea5df33bba60$export$1292458786b96e98 = function(f) {
    return function(m) {
        return $03b6b966974423fe$export$b583322487d15176(m, f);
    };
};
var $c045ea5df33bba60$export$dfc7155ac0343b8 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$c4d34fab9eba1901($03b6b966974423fe$export$75b750e7d0325364)($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $c045ea5df33bba60$export$35d0420a84c5d3ae = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(m1) {
        return function(m2) {
            var f = function(k) {
                return function(v) {
                    return $03b6b966974423fe$export$75b750e7d0325364(false, eq(v), k, m2);
                };
            };
            return $03b6b966974423fe$export$84bf76cd7afc7469(f)(m1);
        };
    };
};
var $c045ea5df33bba60$export$dd1bc94b04021eeb = /* #__PURE__ */ $03b6b966974423fe$export$84bf76cd7afc7469(function(v) {
    return function(v1) {
        return false;
    };
});
var $c045ea5df33bba60$export$21a5ca8aa77d35ff = function(k) {
    return function(v) {
        return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$dc13bdd74c909d26(k)(v));
    };
};
var $c045ea5df33bba60$export$b7bb4265e2e489e0 = {
    map: function(f) {
        return function(m) {
            return $03b6b966974423fe$export$7c3aa937ffdd4482(m, f);
        };
    }
};
var $c045ea5df33bba60$export$9c938d99ebec5017 = {
    mapWithIndex: $c045ea5df33bba60$export$1292458786b96e98,
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    }
};
var $c045ea5df33bba60$export$a47a4d0fc4d6b25 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $c045ea5df33bba60$export$78cfe3464e7eb77b = function(dictFoldableWithIndex) {
    var forWithIndex_1 = $c045ea5df33bba60$var$forWithIndex_(dictFoldableWithIndex);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            forWithIndex_1(l)(function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s);
                };
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$690be49d504fc7f = function(dictFoldable) {
    var for_1 = $c045ea5df33bba60$var$for_(dictFoldable);
    return function(f) {
        return function(l) {
            return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
                var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
                for_1(l)(function(v) {
                    return function __do() {
                        var v$prime = $03b6b966974423fe$export$d947399a194fcef2(v.value1, f(v.value1), v.value0, s)();
                        return $0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v$prime)(s)();
                    };
                })();
                return s;
            });
        };
    };
};
var $c045ea5df33bba60$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var fromFoldable1 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function(l) {
        return $03b6b966974423fe$export$c764c4f4747e1972(function __do() {
            var s = $0061661dcaa2328e$export$b8cb59497041ffe4();
            $f11e5cd39add8df2$export$8802485f9deae94f(fromFoldable1(l))(function(v) {
                return $c045ea5df33bba60$var$$$void($0061661dcaa2328e$export$dc13bdd74c909d26(v.value0)(v.value1)(s));
            })();
            return s;
        });
    };
};
var $c045ea5df33bba60$export$a153ee4522d3545b = $03b6b966974423fe$export$86b08f6436aa565c;
var $c045ea5df33bba60$export$a769d86e5b325bcf = function(f) {
    return function(z) {
        return function(m) {
            return $03b6b966974423fe$export$b807e7b34437e8a6(m, z, f, $06733ae99ed4f534$export$43db023a260c5e9f);
        };
    };
};
var $c045ea5df33bba60$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(z) {
            return $03b6b966974423fe$export$882f367473bfeff9(bind1)(f)(pure1(z));
        };
    };
};
var $c045ea5df33bba60$var$foldM1 = /* #__PURE__ */ $c045ea5df33bba60$export$7a067f9280ad8af0($08944f7287e2704c$export$962073314682c2c);
var $c045ea5df33bba60$export$971dd5b0dfd021b6 = function(m) {
    return $c045ea5df33bba60$var$mutate(function(s) {
        return $c045ea5df33bba60$var$foldM1(function(s$prime) {
            return function(k) {
                return function(v) {
                    return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(s$prime);
                };
            };
        })(s)(m);
    });
};
var $c045ea5df33bba60$export$30b2db2f7030f6cf = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)($c045ea5df33bba60$export$971dd5b0dfd021b6)($03b6b966974423fe$export$6e22c362a0406a2c);
};
var $c045ea5df33bba60$export$ed1b4f34a0e8b0cc = function(f) {
    return function(m1) {
        return function(m2) {
            return $c045ea5df33bba60$var$mutate(function(s1) {
                return $c045ea5df33bba60$var$foldM1(function(s2) {
                    return function(k) {
                        return function(v1) {
                            return $0061661dcaa2328e$export$dc13bdd74c909d26(k)($03b6b966974423fe$export$75b750e7d0325364(v1, function(v2) {
                                return f(v1)(v2);
                            }, k, m2))(s2);
                        };
                    };
                })(s1)(m1);
            })(m2);
        };
    };
};
var $c045ea5df33bba60$export$7d0c6e9c5931d4de = function(dictSemigroup) {
    return {
        append: $c045ea5df33bba60$export$ed1b4f34a0e8b0cc($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $c045ea5df33bba60$export$cd8dd1e1b4d46833 = function(dictSemigroup) {
    var semigroupObject1 = $c045ea5df33bba60$export$7d0c6e9c5931d4de(dictSemigroup);
    return {
        mempty: $03b6b966974423fe$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupObject1;
        }
    };
};
var $c045ea5df33bba60$export$93e2b83da34ff82a = /* #__PURE__ */ $03b6b966974423fe$export$882f367473bfeff9($f57f4b701aa7b66e$export$5f9c390da86b6e49);
var $c045ea5df33bba60$export$b66cdc0497d8a99a = function(dictMonoid) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
            return function(k) {
                return function(v) {
                    return append1(acc)(f(k)(v));
                };
            };
        })(mempty);
    };
};
var $c045ea5df33bba60$export$fb5657e12344d3bf = {
    foldl: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a(function(z) {
            return function(v) {
                return f(z);
            };
        });
    },
    foldr: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr(f)(z)($c045ea5df33bba60$export$68c286be0e7e55b7(m));
            };
        };
    },
    foldMap: function(dictMonoid) {
        var foldMap1 = $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
        return function(f) {
            return foldMap1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(f));
        };
    }
};
var $c045ea5df33bba60$export$341deb6f42c48978 = {
    foldlWithIndex: function(f) {
        return $c045ea5df33bba60$export$93e2b83da34ff82a($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
    },
    foldrWithIndex: function(f) {
        return function(z) {
            return function(m) {
                return $c045ea5df33bba60$var$foldr($71f2e2e9476163f8$export$7864d59d01b6d6bf(f))(z)($03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create)(m));
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        return $c045ea5df33bba60$export$b66cdc0497d8a99a(dictMonoid);
    },
    Foldable0: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$cffdb9059fc42749 = {
    traverseWithIndex: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            return function(ms) {
                return $c045ea5df33bba60$export$93e2b83da34ff82a(function(acc) {
                    return function(k) {
                        return function(v) {
                            return apply(map($f57f4b701aa7b66e$export$8a83211c878a3f1f($c045ea5df33bba60$export$21a5ca8aa77d35ff(k)))(acc))(f(k)(v));
                        };
                    };
                })(pure1($03b6b966974423fe$export$6e22c362a0406a2c))(ms);
            };
        };
    },
    FunctorWithIndex0: function() {
        return $c045ea5df33bba60$export$9c938d99ebec5017;
    },
    FoldableWithIndex1: function() {
        return $c045ea5df33bba60$export$341deb6f42c48978;
    },
    Traversable2: function() {
        return $c045ea5df33bba60$export$aeab5e284d2f12ed;
    }
};
var $c045ea5df33bba60$export$aeab5e284d2f12ed = {
    traverse: function(dictApplicative) {
        var $96 = $2c7a64ff78781336$export$955fdc0d24efa249($c045ea5df33bba60$export$cffdb9059fc42749)(dictApplicative);
        return function($97) {
            return $96($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($97));
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)(dictApplicative)($c045ea5df33bba60$var$identity);
    },
    Functor0: function() {
        return $c045ea5df33bba60$export$b7bb4265e2e489e0;
    },
    Foldable1: function() {
        return $c045ea5df33bba60$export$fb5657e12344d3bf;
    }
};
var $c045ea5df33bba60$export$d7a60370122a9ab0 = function(predicate) {
    return function(m) {
        var go = function() {
            var step = function(acc) {
                return function(k) {
                    return function(v) {
                        var $86 = predicate(k)(v);
                        if ($86) return $0061661dcaa2328e$export$dc13bdd74c909d26(k)(v)(acc);
                        return $c045ea5df33bba60$var$pure(acc);
                    };
                };
            };
            return function __do() {
                var m$prime = $0061661dcaa2328e$export$b8cb59497041ffe4();
                return $c045ea5df33bba60$var$foldM1(step)(m$prime)(m)();
            };
        }();
        return $03b6b966974423fe$export$c764c4f4747e1972(go);
    };
};
var $c045ea5df33bba60$export$151f9a87a7fd5652 = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0(function($98) {
        return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate($98));
    });
};
var $c045ea5df33bba60$export$3dea766d36a8935f = function(predicate) {
    return $c045ea5df33bba60$export$d7a60370122a9ab0($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(predicate));
};
var $c045ea5df33bba60$export$fddc1e6ca29dc4b4 = function(dictEq) {
    var isSubmap1 = $c045ea5df33bba60$export$35d0420a84c5d3ae(dictEq);
    return {
        eq: function(m1) {
            return function(m2) {
                return isSubmap1(m1)(m2) && isSubmap1(m2)(m1);
            };
        }
    };
};
var $c045ea5df33bba60$export$6393680ec5f1a42e = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$6ace7ea8ac01a75e($c045ea5df33bba60$var$ordTuple(dictOrd)));
    var eqObject1 = $c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictOrd.Eq0());
    return {
        compare: function(m1) {
            return function(m2) {
                return compare($c045ea5df33bba60$var$toAscArray(m1))($c045ea5df33bba60$var$toAscArray(m2));
            };
        },
        Eq0: function() {
            return eqObject1;
        }
    };
};
var $c045ea5df33bba60$export$11e732c5af6e2d9f = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($c045ea5df33bba60$export$fddc1e6ca29dc4b4(dictEq));
    }
};
var $c045ea5df33bba60$export$1822828d790e23ee = function(k) {
    return $c045ea5df33bba60$var$mutate($0061661dcaa2328e$export$1822828d790e23ee(k));
};
var $c045ea5df33bba60$export$3e41007ebfff0e64 = function(k) {
    return function(m) {
        return $c045ea5df33bba60$var$mapFlipped($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m))(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $c045ea5df33bba60$export$1822828d790e23ee(k)(m));
        });
    };
};
var $c045ea5df33bba60$export$22a7378e1d3307a4 = function(f) {
    return function(k) {
        return function(m) {
            var v = f($c045ea5df33bba60$export$dfc7155ac0343b8(k)(m));
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c045ea5df33bba60$export$1822828d790e23ee(k)(m);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c045ea5df33bba60$export$21a5ca8aa77d35ff(k)(v.value0)(m);
            throw new Error("Failed pattern match at Foreign.Object (line 210, column 15 - line 212, column 25): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c045ea5df33bba60$export$722fbec263ad908a = function(f) {
    return function(k) {
        return function(m) {
            return $c045ea5df33bba60$export$22a7378e1d3307a4($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(f))(k)(m);
        };
    };
};


var $2a035e92dc768ac1$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $2a035e92dc768ac1$var$verbJsonType = function(def) {
    return function(f) {
        return function(g) {
            return g(def)(f);
        };
    };
};
var $2a035e92dc768ac1$var$toJsonType = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$var$verbJsonType($06733ae99ed4f534$export$bebe9059409a0d04.value)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $2a035e92dc768ac1$export$c36def4669cfa602 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(0.0);
var $2a035e92dc768ac1$export$9024d20d7989ccd8 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(true);
var $2a035e92dc768ac1$export$ecfbf588917514aa = function(key) {
    return function(val) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($c045ea5df33bba60$export$439306a4dcaafbb9(key)(val));
    };
};
var $2a035e92dc768ac1$export$4f9a0f50606bc43c = function(j) {
    return $0e031af7428ef07d$export$dbafa4424a806c15([
        j
    ]);
};
var $2a035e92dc768ac1$export$29860be44d1074fa = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15(false);
var $2a035e92dc768ac1$export$d2aabff522f82ec3 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15("");
var $2a035e92dc768ac1$export$d0304b893d105187 = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15($03b6b966974423fe$export$6e22c362a0406a2c);
var $2a035e92dc768ac1$export$108d15c9b507bd0b = /* #__PURE__ */ $0e031af7428ef07d$export$dbafa4424a806c15([]);
var $2a035e92dc768ac1$var$isJsonType = /* #__PURE__ */ $2a035e92dc768ac1$var$verbJsonType(false)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true));
var $2a035e92dc768ac1$export$d2871cfbf3cbd4f2 = {
    compare: function(a) {
        return function(b) {
            return $0e031af7428ef07d$export$6b486fc7358c5fa4($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value, $5026be88823ef1f4$export$b023c82b48e70453.value, $5026be88823ef1f4$export$7158f0ceb70f54c7.value, a, b);
        };
    },
    Eq0: function() {
        return $2a035e92dc768ac1$export$e8f903c542fcf2a5;
    }
};
var $2a035e92dc768ac1$export$e8f903c542fcf2a5 = {
    eq: function(j1) {
        return function(j2) {
            return $2a035e92dc768ac1$var$eq($97937c29f879e68e$export$398604a469f7de9a($2a035e92dc768ac1$export$d2871cfbf3cbd4f2)(j1)(j2))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    }
};
var $2a035e92dc768ac1$var$eqJNull = {
    eq: function(v) {
        return function(v1) {
            return true;
        };
    }
};
var $2a035e92dc768ac1$var$ordJNull = {
    compare: function(v) {
        return function(v1) {
            return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
        };
    },
    Eq0: function() {
        return $2a035e92dc768ac1$var$eqJNull;
    }
};
var $2a035e92dc768ac1$export$1532fd4f75be8b9c = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$844ec244b1367d54 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$1532fd4f75be8b9c);
var $2a035e92dc768ac1$export$f84e8e69fd4488a5 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$1532fd4f75be8b9c);
var $2a035e92dc768ac1$export$d4dde8795f959ed3 = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, j);
        };
    };
};
var $2a035e92dc768ac1$export$a6cdc56e425d0d0a = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$d4dde8795f959ed3);
var $2a035e92dc768ac1$export$697e4a1b90752ce2 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$d4dde8795f959ed3);
var $2a035e92dc768ac1$export$ec3647fa336ee4ac = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$7e4aa119212bc614 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$ec3647fa336ee4ac);
var $2a035e92dc768ac1$export$a0a81dc3380ce7d3 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$ec3647fa336ee4ac);
var $2a035e92dc768ac1$export$4d5744f54c133204 = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224(f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$630801d484da15df = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$4d5744f54c133204);
var $2a035e92dc768ac1$export$f0aa72cd87f2bde5 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$4d5744f54c133204);
var $2a035e92dc768ac1$export$fff3b6519135a62b = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$f9ce7b637dfbe238 = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$fff3b6519135a62b);
var $2a035e92dc768ac1$export$3c2e6d1b7583eee6 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$fff3b6519135a62b);
var $2a035e92dc768ac1$export$d7ae7d568ec9dc3c = function(d) {
    return function(f) {
        return function(j) {
            return $0e031af7428ef07d$export$8e91e9560ac84224($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), f, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(d), j);
        };
    };
};
var $2a035e92dc768ac1$export$43bee75e5e14138e = /* #__PURE__ */ $2a035e92dc768ac1$var$isJsonType($2a035e92dc768ac1$export$d7ae7d568ec9dc3c);
var $2a035e92dc768ac1$export$45b10814cc054894 = /* #__PURE__ */ $2a035e92dc768ac1$var$toJsonType($2a035e92dc768ac1$export$d7ae7d568ec9dc3c);
var $2a035e92dc768ac1$export$cda231bc8c57ca4 = function(a) {
    return function(b) {
        return function(c) {
            return function(d) {
                return function(e) {
                    return function(f) {
                        return function(json) {
                            return $0e031af7428ef07d$export$8e91e9560ac84224(a, b, c, d, e, f, json);
                        };
                    };
                };
            };
        };
    };
};


// Generated by purs version 0.15.16




// Generated by purs version 0.15.16






var $826fbbc6c8d1e9e2$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $826fbbc6c8d1e9e2$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $826fbbc6c8d1e9e2$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $826fbbc6c8d1e9e2$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $826fbbc6c8d1e9e2$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($2a035e92dc768ac1$export$d2871cfbf3cbd4f2);
var $826fbbc6c8d1e9e2$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $826fbbc6c8d1e9e2$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0) {
        this.value0 = value0;
    }
    TypeMismatch.create = function(value0) {
        return new TypeMismatch(value0);
    };
    return TypeMismatch;
}();
var $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 = /* #__PURE__ */ function() {
    function UnexpectedValue(value0) {
        this.value0 = value0;
    }
    UnexpectedValue.create = function(value0) {
        return new UnexpectedValue(value0);
    };
    return UnexpectedValue;
}();
var $826fbbc6c8d1e9e2$export$d58b23382c8562e = /* #__PURE__ */ function() {
    function AtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtIndex.create = function(value0) {
        return function(value1) {
            return new AtIndex(value0, value1);
        };
    };
    return AtIndex;
}();
var $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 = /* #__PURE__ */ function() {
    function AtKey(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AtKey.create = function(value0) {
        return function(value1) {
            return new AtKey(value0, value1);
        };
    };
    return AtKey;
}();
var $826fbbc6c8d1e9e2$export$4e021928efe6b6bd = /* #__PURE__ */ function() {
    function Named(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Named.create = function(value0) {
        return function(value1) {
            return new Named(value0, value1);
        };
    };
    return Named;
}();
var $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 = /* #__PURE__ */ function() {
    function MissingValue() {}
    MissingValue.value = new MissingValue();
    return MissingValue;
}();
var $826fbbc6c8d1e9e2$export$d3ac27ab5a0173d = {
    show: function(v) {
        if (v instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return "(TypeMismatch " + ($826fbbc6c8d1e9e2$var$show(v.value0) + ")");
        if (v instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return "(UnexpectedValue " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ")");
        if (v instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return "(AtIndex " + ($826fbbc6c8d1e9e2$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return "(AtKey " + ($826fbbc6c8d1e9e2$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return "(Named " + ($826fbbc6c8d1e9e2$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($826fbbc6c8d1e9e2$export$d3ac27ab5a0173d)(v.value1) + ")")));
        if (v instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return "MissingValue";
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 24, column 10 - line 30, column 35): " + [
            v.constructor.name
        ]);
    }
};
var $826fbbc6c8d1e9e2$export$f0345d087708be2e = function(err) {
    var go = function(v) {
        if (v instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return "  Expected value of type '" + (v.value0 + "'.");
        if (v instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return "  Unexpected value " + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value0) + ".");
        if (v instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return "  At array index " + ($826fbbc6c8d1e9e2$var$show1(v.value0) + (":\x0a" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return "  At object key '" + (v.value0 + ("':\x0a" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return "  Under '" + (v.value0 + ("':\x0a" + go(v.value1)));
        if (v instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return "  No value was found.";
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 37, column 8 - line 43, column 44): " + [
            v.constructor.name
        ]);
    };
    return "An error occurred while decoding a JSON value:\x0a" + go(err);
};
var $826fbbc6c8d1e9e2$export$57ecdac35deb6f24 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$168e2d3b16829a(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(x.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$d58b23382c8562e(x.value0.value0.value0.value0, x.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(x.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value;
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 21, column 1 - line 21, column 68): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0));
        if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))));
        if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1)))));
        if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(new $91c996e9c07e3b3f$export$264ad599d7cef668(x.value0, x.value1))))));
        if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))));
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 21, column 1 - line 21, column 68): " + [
            x.constructor.name
        ]);
    }
};
var $826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a && y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return x.value0 === y.value0;
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 && y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $826fbbc6c8d1e9e2$var$eq1(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e && y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 && y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd && y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa)(x.value1)(y.value1);
            if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 && y instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return true;
            return false;
        };
    }
};
var $826fbbc6c8d1e9e2$export$e25e82e4962e5280 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a && y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2 && y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $826fbbc6c8d1e9e2$var$compare1(x.value0)(y.value0);
            if (x instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$35fbad60f29e98f2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e && y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) {
                var v = $826fbbc6c8d1e9e2$var$compare2(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$d58b23382c8562e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8 && y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) {
                var v = $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd && y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) {
                var v = $826fbbc6c8d1e9e2$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($826fbbc6c8d1e9e2$export$e25e82e4962e5280)(x.value1)(y.value1);
            }
            if (x instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $826fbbc6c8d1e9e2$export$4e021928efe6b6bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0 && y instanceof $826fbbc6c8d1e9e2$export$d171f9c68f3539d0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Error (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $826fbbc6c8d1e9e2$export$39ab000ce9c1c5aa;
    }
};



// Generated by purs version 0.15.16


// Generated by purs version 0.15.16
const $b54742048bb717e1$export$2e94f3cfb1cd0b3b = function(f, xs) {
    var acc = xs[xs.length - 1];
    for(var i = xs.length - 2; i >= 0; i--)acc = f(xs[i])(acc);
    return acc;
};
const $b54742048bb717e1$export$a723804e3f3d0e95 = function(f, xs) {
    var acc = xs[0];
    var len = xs.length;
    for(var i = 1; i < len; i++)acc = f(acc)(xs[i]);
    return acc;
};
const $b54742048bb717e1$export$c510f955a36e0bd4 = function() {
    function Cont(fn) {
        this.fn = fn;
    }
    var emptyList = {};
    var ConsCell = function(head, tail) {
        this.head = head;
        this.tail = tail;
    };
    function finalCell(head) {
        return new ConsCell(head, emptyList);
    }
    function consList(x) {
        return function(xs) {
            return new ConsCell(x, xs);
        };
    }
    function listToArray(list) {
        var arr = [];
        var xs = list;
        while(xs !== emptyList){
            arr.push(xs.head);
            xs = xs.tail;
        }
        return arr;
    }
    return function(apply, map, f) {
        var buildFrom = function(x, ys) {
            return apply(map(consList)(f(x)))(ys);
        };
        var go = function(acc, currentLen, xs) {
            if (currentLen === 0) return acc;
            else {
                var last = xs[currentLen - 1];
                return new Cont(function() {
                    var built = go(buildFrom(last, acc), currentLen - 1, xs);
                    return built;
                });
            }
        };
        return function(array) {
            var acc = map(finalCell)(f(array[array.length - 1]));
            var result = go(acc, array.length - 1, array);
            while(result instanceof Cont)result = result.fn();
            return map(listToArray)(result);
        };
    };
}();





















var $91ee3359f6bcea22$export$f2d78e4bd16a0737 = function(x) {
    return x;
};
var $91ee3359f6bcea22$export$5cc19ce746f40583 = $cf5af1199a495394$export$587ba9a9bf3cf8b4;
var $91ee3359f6bcea22$export$24956e78dc18af4a = $2c7a64ff78781336$export$96888504550934b5;
var $91ee3359f6bcea22$export$81b6a4240b5ed5ff = $11d1e86de605dfc6$export$9e4a28683e28e26a;
var $91ee3359f6bcea22$export$58eaac0549d62906 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(v) {
            return "(NonEmptyArray " + (show(v) + ")");
        }
    };
};
var $91ee3359f6bcea22$export$7e27c982686236c = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $91ee3359f6bcea22$export$ba5ac798a83b9940 = function(dictOrd) {
    return $97937c29f879e68e$export$6ace7ea8ac01a75e(dictOrd);
};
var $91ee3359f6bcea22$export$576ea700d31dfbbe = $97937c29f879e68e$export$8e34cc59438cf1bf;
var $91ee3359f6bcea22$export$b6607029fd0e1ebc = $d3d065da31679be1$export$68aea3a98a23c265;
var $91ee3359f6bcea22$export$e1a7484e8d239345 = $334541180b4ef18c$export$f10d51ea0aa3da42;
var $91ee3359f6bcea22$export$cf42eb1af12f469e = $f4b2eb11fc32ed34$export$2330f868b62ed546;
var $91ee3359f6bcea22$export$277d8f0716691388 = $519ef1967f17d101$export$e728f47f20b1eb28;
var $91ee3359f6bcea22$export$7090c31be3a1e8ea = $4fe7b6acfba7f29f$export$e97014618a7eb593;
var $91ee3359f6bcea22$export$33591d20dac5147e = {
    foldMap1: function(dictSemigroup) {
        return $086486679aa806fa$export$3341743d361f5644($91ee3359f6bcea22$export$33591d20dac5147e)($91ee3359f6bcea22$export$cf42eb1af12f469e)(dictSemigroup);
    },
    foldr1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$2e94f3cfb1cd0b3b),
    foldl1: /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($b54742048bb717e1$export$a723804e3f3d0e95),
    Foldable0: function() {
        return $91ee3359f6bcea22$export$7090c31be3a1e8ea;
    }
};
var $91ee3359f6bcea22$export$a72b8d310e29f00f = {
    traverse1: function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return $b54742048bb717e1$export$c510f955a36e0bd4(apply, map, f);
        };
    },
    sequence1: function(dictApply) {
        return $e4fb66202bb8a4f4$export$c8ca5446ba1698($91ee3359f6bcea22$export$a72b8d310e29f00f)(dictApply);
    },
    Foldable10: function() {
        return $91ee3359f6bcea22$export$33591d20dac5147e;
    },
    Traversable1: function() {
        return $91ee3359f6bcea22$export$81b6a4240b5ed5ff;
    }
};
var $91ee3359f6bcea22$export$e2c877c9efbd93a4 = function(dictEq) {
    return $37b880af5f4991bd$export$159e06dc5ec60b00(dictEq);
};
var $91ee3359f6bcea22$export$5f4f90502fd988f7 = $37b880af5f4991bd$export$861eb926e0b8ea5b;
var $91ee3359f6bcea22$export$4b9e170bb3e49bd0 = $70cd3177464e7915$export$794f9574ca20b986;
var $91ee3359f6bcea22$export$8f8661c5387016c3 = $7576d3a958d66ab0$export$60d7bd9d686a5521;
var $91ee3359f6bcea22$export$df94f54a91732973 = $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
var $91ee3359f6bcea22$export$4d39f82ee37f3a51 = $75e93a4111e80214$export$186d613bb872946c;
















var $e39dfcf102cdca3c$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $e39dfcf102cdca3c$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $e39dfcf102cdca3c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $e39dfcf102cdca3c$var$intercalate1 = /* #__PURE__ */ $086486679aa806fa$export$739ec22334c44788($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$foldMap11 = /* #__PURE__ */ $086486679aa806fa$export$b50c31bb8aebd2a7($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fold11 = /* #__PURE__ */ $086486679aa806fa$export$2e430a6d03f6ee23($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $e39dfcf102cdca3c$var$unsafeIndex1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$var$unsafeFromArrayF = $ac8b3532514ac019$export$401372c57776dc;
var $e39dfcf102cdca3c$var$unsafeFromArray = $91ee3359f6bcea22$export$f2d78e4bd16a0737;
var $e39dfcf102cdca3c$export$9cb09a71b7d66923 = function($99) {
    return $e39dfcf102cdca3c$var$coerce($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($99)));
};
var $e39dfcf102cdca3c$export$45b10814cc054894 = function(v) {
    return v;
};
var $e39dfcf102cdca3c$export$c2d77a2584a0f97e = function(eq) {
    return function(xs) {
        var $100 = $396c4c3d9e7fae3c$export$ef1d06dc4d91d507(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
        return function($101) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($100($101));
        };
    };
};
var $e39dfcf102cdca3c$export$437026b4e0b5fcf6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$c2d77a2584a0f97e($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$ef1d06dc4d91d507 = function(eq) {
    return function(xs) {
        var $102 = $e39dfcf102cdca3c$export$c2d77a2584a0f97e(eq)(xs);
        return function($103) {
            return $102($e39dfcf102cdca3c$export$45b10814cc054894($103));
        };
    };
};
var $e39dfcf102cdca3c$export$971dd5b0dfd021b6 = function(dictEq) {
    return $e39dfcf102cdca3c$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    var $104 = $20615e99b278adf5$export$eb54baf0b342cb1d($20615e99b278adf5$export$34a2521cb7920188)($e39dfcf102cdca3c$var$unsafeFromArray)($e39dfcf102cdca3c$var$unsafeFromArray);
    return function($105) {
        return $104($396c4c3d9e7fae3c$export$23c8d3f8757cab88($e39dfcf102cdca3c$export$45b10814cc054894($105)));
    };
}();
var $e39dfcf102cdca3c$export$b6d8713d53419d4c = function(i) {
    return function(x) {
        var $106 = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(x);
        return function($107) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($106($e39dfcf102cdca3c$export$45b10814cc054894($107)));
        };
    };
};
var $e39dfcf102cdca3c$export$8901015135f2fb22 = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8901015135f2fb22($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$b634740ce272acb5(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
        };
    };
};
var $e39dfcf102cdca3c$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var zipWithA1 = $396c4c3d9e7fae3c$export$e00c1e5c5a2b1ad7(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return $e39dfcf102cdca3c$var$unsafeFromArrayF(zipWithA1(f)($e39dfcf102cdca3c$export$45b10814cc054894(xs))($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
            };
        };
    };
};
var $e39dfcf102cdca3c$export$b0d75975ac0be0e1 = function(i) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$b0d75975ac0be0e1(i)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$ad14ef4001db2bcd = function(dictAlternative) {
    var some1 = $396c4c3d9e7fae3c$export$ad14ef4001db2bcd(dictAlternative);
    return function(dictLazy) {
        var $108 = some1(dictLazy);
        return function($109) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($108($109));
        };
    };
};
var $e39dfcf102cdca3c$export$5b6d1d165591a48c = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397(xs)(x));
    };
};
var $e39dfcf102cdca3c$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$c40cf5aab899f397($e39dfcf102cdca3c$export$45b10814cc054894(xs))(x));
    };
};
var $e39dfcf102cdca3c$export$439306a4dcaafbb9 = function($110) {
    return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$439306a4dcaafbb9($110));
};
var $e39dfcf102cdca3c$export$606959e7ccb797f0 = function(i) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$606959e7ccb797f0($e39dfcf102cdca3c$var$max(1)(i))(x));
    };
};
var $e39dfcf102cdca3c$export$d02631cccf789723 = function(x) {
    return function(y) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$d02631cccf789723(x)(y));
    };
};
var $e39dfcf102cdca3c$export$25b721c466a8ec4a = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append(xs)($e39dfcf102cdca3c$export$45b10814cc054894(ys)));
    };
};
var $e39dfcf102cdca3c$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        var $111 = $396c4c3d9e7fae3c$export$cba09f9e3d3e58eb(i)(f);
        return function($112) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($111($e39dfcf102cdca3c$export$45b10814cc054894($112)));
        };
    };
};
var $e39dfcf102cdca3c$export$df22145cad61b1dc = function(eq) {
    return function(xs) {
        return $396c4c3d9e7fae3c$export$f161f39e9c06ab2d(eq)($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$f161f39e9c06ab2d = function(eq) {
    return function(xs) {
        var $113 = $e39dfcf102cdca3c$export$df22145cad61b1dc(eq)(xs);
        return function($114) {
            return $113($e39dfcf102cdca3c$export$45b10814cc054894($114));
        };
    };
};
var $e39dfcf102cdca3c$export$5c3f7b482f544831 = function(dictEq) {
    return $e39dfcf102cdca3c$export$df22145cad61b1dc($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$1f4807a235930d45 = function(dictEq) {
    return $e39dfcf102cdca3c$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $e39dfcf102cdca3c$export$739ec22334c44788 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$intercalate1(dictSemigroup);
};
var $e39dfcf102cdca3c$export$9f200c4466975173 = function(i) {
    return function(x) {
        var $115 = $396c4c3d9e7fae3c$export$9f200c4466975173(i)(x);
        return function($116) {
            return $e39dfcf102cdca3c$var$unsafeFromArrayF($115($e39dfcf102cdca3c$export$45b10814cc054894($116)));
        };
    };
};
var $e39dfcf102cdca3c$export$95b95426129653f6 = function(dictFoldable1) {
    var $117 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable1.Foldable0());
    return function($118) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($117($118));
    };
};
var $e39dfcf102cdca3c$export$571d59b505e6bb4e = function(xs) {
    if ($fc8c1182ec2aefec$export$f24224f1c91d8156(xs) > 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e39dfcf102cdca3c$var$unsafeFromArray(xs));
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.Array.NonEmpty (line 161, column 1 - line 161, column 58): " + [
        xs.constructor.name
    ]);
};
var $e39dfcf102cdca3c$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $119 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
    return function($120) {
        return $e39dfcf102cdca3c$export$571d59b505e6bb4e($119($120));
    };
};
var $e39dfcf102cdca3c$export$55f57584ad1f8cc9 = function($121) {
    return $e39dfcf102cdca3c$export$571d59b505e6bb4e($396c4c3d9e7fae3c$export$9cb09a71b7d66923($e39dfcf102cdca3c$var$coerce($121)));
};
var $e39dfcf102cdca3c$export$c8b99533c112636f = /* #__PURE__ */ $086486679aa806fa$export$c8b99533c112636f($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$eb5e1ef4ea2eca3d = /* #__PURE__ */ $086486679aa806fa$export$eb5e1ef4ea2eca3d($91ee3359f6bcea22$export$33591d20dac5147e);
var $e39dfcf102cdca3c$export$b50c31bb8aebd2a7 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$foldMap11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$2e430a6d03f6ee23 = function(dictSemigroup) {
    return $e39dfcf102cdca3c$var$fold11(dictSemigroup);
};
var $e39dfcf102cdca3c$export$244bb8babc536271 = function(dictEq) {
    var difference1 = $396c4c3d9e7fae3c$export$acaf96a27438246b(dictEq);
    return function(xs) {
        return difference1($e39dfcf102cdca3c$export$45b10814cc054894(xs));
    };
};
var $e39dfcf102cdca3c$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x)(xs));
    };
};
var $e39dfcf102cdca3c$export$1d4c49925323035a = function(v) {
    return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(v.value0)(v.value1);
};
var $e39dfcf102cdca3c$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($91ee3359f6bcea22$export$4b9e170bb3e49bd0));
var $e39dfcf102cdca3c$export$ee1b3e54f0441b22 = /* #__PURE__ */ function() {
    var $122 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e)($e39dfcf102cdca3c$export$45b10814cc054894);
    return function($123) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($fc8c1182ec2aefec$export$ee1b3e54f0441b22($e39dfcf102cdca3c$export$45b10814cc054894($122($123))));
    };
}();
var $e39dfcf102cdca3c$export$caf8a2f37e9533e = function(xs) {
    return function(ys) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($e39dfcf102cdca3c$var$append($e39dfcf102cdca3c$export$45b10814cc054894(xs))(ys));
    };
};
var $e39dfcf102cdca3c$export$2dd9d44f93be5e22 = function(i) {
    return function(f) {
        var $124 = $396c4c3d9e7fae3c$export$2dd9d44f93be5e22(i)(f);
        return function($125) {
            return $124($e39dfcf102cdca3c$export$45b10814cc054894($125));
        };
    };
};
var $e39dfcf102cdca3c$var$adaptMaybe = function(f) {
    return function($126) {
        return $e39dfcf102cdca3c$var$fromJust(f($e39dfcf102cdca3c$export$45b10814cc054894($126)));
    };
};
var $e39dfcf102cdca3c$export$5fd5031fecdacec3 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$5fd5031fecdacec3);
var $e39dfcf102cdca3c$export$2cd8252107eb640b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$2cd8252107eb640b);
var $e39dfcf102cdca3c$export$4c7897fafd92b108 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$4c7897fafd92b108);
var $e39dfcf102cdca3c$export$c01875f616615628 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$c01875f616615628);
var $e39dfcf102cdca3c$export$b446f6baa3bb1430 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$b446f6baa3bb1430);
var $e39dfcf102cdca3c$export$bdf81af0000aaf5a = function($127) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.head, v.tail);
    }($e39dfcf102cdca3c$export$b446f6baa3bb1430($127));
};
var $e39dfcf102cdca3c$export$712962e076096ed4 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptMaybe($396c4c3d9e7fae3c$export$712962e076096ed4);
var $e39dfcf102cdca3c$var$adaptAny = function(f) {
    return function($128) {
        return f($e39dfcf102cdca3c$export$45b10814cc054894($128));
    };
};
var $e39dfcf102cdca3c$export$84bf76cd7afc7469 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$84bf76cd7afc7469(p));
};
var $e39dfcf102cdca3c$export$4154a199d7d90455 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$4154a199d7d90455(p));
};
var $e39dfcf102cdca3c$export$986c2bbe7a34be0b = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$986c2bbe7a34be0b);
var $e39dfcf102cdca3c$export$1822828d790e23ee = function(dictEq) {
    var delete1 = $396c4c3d9e7fae3c$export$1822828d790e23ee(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(delete1(x));
    };
};
var $e39dfcf102cdca3c$export$90f9093465da3136 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$90f9093465da3136(i));
};
var $e39dfcf102cdca3c$export$9ea2b6c3fae093d8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$acaf96a27438246b = function(dictEq) {
    var difference$prime1 = $e39dfcf102cdca3c$export$244bb8babc536271(dictEq);
    return function(xs) {
        return $e39dfcf102cdca3c$var$adaptAny(difference$prime1(xs));
    };
};
var $e39dfcf102cdca3c$export$663103110d94aac9 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$663103110d94aac9(i));
};
var $e39dfcf102cdca3c$export$2b3b686e33c80c56 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$2b3b686e33c80c56(i));
};
var $e39dfcf102cdca3c$export$533af5c8cd6afa16 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$533af5c8cd6afa16(f));
};
var $e39dfcf102cdca3c$export$5bf96401662340b7 = function(dictEq) {
    var elem1 = $396c4c3d9e7fae3c$export$5bf96401662340b7(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elem1(x));
    };
};
var $e39dfcf102cdca3c$export$f444781b0adb7e4d = function(dictEq) {
    var elemIndex1 = $396c4c3d9e7fae3c$export$f444781b0adb7e4d(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$c19d79386f4ed99a = function(dictEq) {
    var elemLastIndex1 = $396c4c3d9e7fae3c$export$c19d79386f4ed99a(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(elemLastIndex1(x));
    };
};
var $e39dfcf102cdca3c$export$3dea766d36a8935f = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$3dea766d36a8935f(f));
};
var $e39dfcf102cdca3c$export$e6e803076c284bc5 = function(dictApplicative) {
    var filterA1 = $396c4c3d9e7fae3c$export$e6e803076c284bc5(dictApplicative);
    return function(f) {
        return $e39dfcf102cdca3c$var$adaptAny(filterA1(f));
    };
};
var $e39dfcf102cdca3c$export$71aa6c912b956294 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$71aa6c912b956294(p));
};
var $e39dfcf102cdca3c$export$de3a4d4a0d731119 = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$de3a4d4a0d731119(p));
};
var $e39dfcf102cdca3c$export$8855a8be7bd3e9f8 = function(x) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$8855a8be7bd3e9f8(x));
};
var $e39dfcf102cdca3c$export$23e5dcedfce4509c = function(p) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$23e5dcedfce4509c(p));
};
var $e39dfcf102cdca3c$export$7a067f9280ad8af0 = function(dictMonad) {
    var foldM1 = $396c4c3d9e7fae3c$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$61b0588efceffce4 = function(dictMonadRec) {
    var foldRecM1 = $396c4c3d9e7fae3c$export$61b0588efceffce4(dictMonadRec);
    return function(f) {
        return function(acc) {
            return $e39dfcf102cdca3c$var$adaptAny(foldRecM1(f)(acc));
        };
    };
};
var $e39dfcf102cdca3c$export$b610b8812bbcded9 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b610b8812bbcded9);
var $e39dfcf102cdca3c$export$f24224f1c91d8156 = /* #__PURE__ */ $e39dfcf102cdca3c$var$adaptAny($fc8c1182ec2aefec$export$f24224f1c91d8156);
var $e39dfcf102cdca3c$export$e70771d2e7e590a = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$e70771d2e7e590a(f));
};
var $e39dfcf102cdca3c$export$63faa62a0284a4a6 = function(dictEq) {
    var notElem1 = $396c4c3d9e7fae3c$export$63faa62a0284a4a6(dictEq);
    return function(x) {
        return $e39dfcf102cdca3c$var$adaptAny(notElem1(x));
    };
};
var $e39dfcf102cdca3c$export$b29f828819edca8d = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b29f828819edca8d(f));
};
var $e39dfcf102cdca3c$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$58adb3bec8346d0f(start)(end));
    };
};
var $e39dfcf102cdca3c$export$afc1bfabebaf28a2 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$afc1bfabebaf28a2(f));
};
var $e39dfcf102cdca3c$export$b7df5d561049483a = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$b7df5d561049483a(i));
};
var $e39dfcf102cdca3c$export$9100289823a975b0 = function(i) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9100289823a975b0(i));
};
var $e39dfcf102cdca3c$export$9384c7afe4015e42 = function(f) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$9384c7afe4015e42(f));
};
var $e39dfcf102cdca3c$export$823be24f8766da23 = function(dictUnfoldable) {
    return $e39dfcf102cdca3c$var$adaptAny($396c4c3d9e7fae3c$export$823be24f8766da23(dictUnfoldable));
};
var $e39dfcf102cdca3c$var$unsafeAdapt = function(f) {
    var $129 = $e39dfcf102cdca3c$var$adaptAny(f);
    return function($130) {
        return $e39dfcf102cdca3c$var$unsafeFromArray($129($130));
    };
};
var $e39dfcf102cdca3c$export$8327ebbef2a0ba76 = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(x));
};
var $e39dfcf102cdca3c$export$e5e25fbcc1f7affe = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$e5e25fbcc1f7affe(dictEq));
};
var $e39dfcf102cdca3c$export$1f7a5bf12caafbd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$1f7a5bf12caafbd(op));
};
var $e39dfcf102cdca3c$export$361434b95a7d965 = function(dictOrd) {
    return $e39dfcf102cdca3c$export$1f7a5bf12caafbd($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $e39dfcf102cdca3c$export$3f063810d7bf01bd = function(op) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$3f063810d7bf01bd(op));
};
var $e39dfcf102cdca3c$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $396c4c3d9e7fae3c$export$21a5ca8aa77d35ff(dictOrd);
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(insert1(x));
    };
};
var $e39dfcf102cdca3c$export$b8bc901090d2b1d4 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b8bc901090d2b1d4(f)(x));
    };
};
var $e39dfcf102cdca3c$export$af200dcf8b7cb5de = function(x) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$af200dcf8b7cb5de(x));
};
var $e39dfcf102cdca3c$export$8f07ddce13659f50 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$8f07ddce13659f50(f));
};
var $e39dfcf102cdca3c$export$7fd3d81fba5daa58 = function(dictFoldable) {
    var modifyAtIndices1 = $396c4c3d9e7fae3c$export$7fd3d81fba5daa58(dictFoldable);
    return function(is) {
        return function(f) {
            return $e39dfcf102cdca3c$var$unsafeAdapt(modifyAtIndices1(is)(f));
        };
    };
};
var $e39dfcf102cdca3c$export$94f4066a75b10404 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$94f4066a75b10404(dictOrd));
};
var $e39dfcf102cdca3c$export$18f77a3bafa759b9 = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$18f77a3bafa759b9(f));
};
var $e39dfcf102cdca3c$export$45273896c792ff3b = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$45273896c792ff3b(f));
};
var $e39dfcf102cdca3c$export$edce5881c815871 = function(dictEq) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$edce5881c815871(dictEq));
};
var $e39dfcf102cdca3c$export$66c1ae025e96b4bc = /* #__PURE__ */ $e39dfcf102cdca3c$var$unsafeAdapt($fc8c1182ec2aefec$export$66c1ae025e96b4bc);
var $e39dfcf102cdca3c$export$65f513eaf3c582b8 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$65f513eaf3c582b8(f)(x));
    };
};
var $e39dfcf102cdca3c$export$64df51ac031d4ad2 = function(f) {
    return function(x) {
        return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$64df51ac031d4ad2(f)(x));
    };
};
var $e39dfcf102cdca3c$export$97db5808d8f88186 = function(dictOrd) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$97db5808d8f88186(dictOrd));
};
var $e39dfcf102cdca3c$export$b035e44d7bb4278f = function(f) {
    return $e39dfcf102cdca3c$var$unsafeAdapt($396c4c3d9e7fae3c$export$b035e44d7bb4278f(f));
};
var $e39dfcf102cdca3c$export$a9e7d1a6fdcfefde = function(dictOrd) {
    var sortWith1 = $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde(dictOrd);
    return function(f) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(sortWith1(f));
    };
};
var $e39dfcf102cdca3c$export$f2a09b3ef2c0e257 = function(dictFoldable) {
    var updateAtIndices1 = $396c4c3d9e7fae3c$export$f2a09b3ef2c0e257(dictFoldable);
    return function(pairs) {
        return $e39dfcf102cdca3c$var$unsafeAdapt(updateAtIndices1(pairs));
    };
};
var $e39dfcf102cdca3c$export$90bcd20c17ae578e = function() {
    return $e39dfcf102cdca3c$var$adaptAny($e39dfcf102cdca3c$var$unsafeIndex1);
};
var $e39dfcf102cdca3c$var$unsafeIndex2 = /* #__PURE__ */ $e39dfcf102cdca3c$export$90bcd20c17ae578e();
var $e39dfcf102cdca3c$export$d1f81bca2a8c7b07 = function(dictUnfoldable1) {
    var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
    return function(xs) {
        var len = $e39dfcf102cdca3c$export$f24224f1c91d8156(xs);
        var f = function(i) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($e39dfcf102cdca3c$var$unsafeIndex2(xs)(i), function() {
                var $98 = i < (len - 1 | 0);
                if ($98) return new $06733ae99ed4f534$export$8a67b48435b5d073(i + 1 | 0);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }());
        };
        return unfoldr1(f)(0);
    };
};











// Generated by purs version 0.15.16














// Generated by purs version 0.15.16


var $5ce356b15dd97b57$var$Leaf = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $5ce356b15dd97b57$var$Two = /* #__PURE__ */ function() {
    function Two(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Two.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Two(value0, value1, value2);
            };
        };
    };
    return Two;
}();
var $5ce356b15dd97b57$var$Three = /* #__PURE__ */ function() {
    function Three(value0, value1, value2, value3, value4) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
    }
    Three.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return new Three(value0, value1, value2, value3, value4);
                    };
                };
            };
        };
    };
    return Three;
}();
var $5ce356b15dd97b57$var$TwoLeft = /* #__PURE__ */ function() {
    function TwoLeft(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoLeft.create = function(value0) {
        return function(value1) {
            return new TwoLeft(value0, value1);
        };
    };
    return TwoLeft;
}();
var $5ce356b15dd97b57$var$TwoRight = /* #__PURE__ */ function() {
    function TwoRight(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TwoRight.create = function(value0) {
        return function(value1) {
            return new TwoRight(value0, value1);
        };
    };
    return TwoRight;
}();
var $5ce356b15dd97b57$var$ThreeLeft = /* #__PURE__ */ function() {
    function ThreeLeft(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeLeft.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeLeft(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeLeft;
}();
var $5ce356b15dd97b57$var$ThreeMiddle = /* #__PURE__ */ function() {
    function ThreeMiddle(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeMiddle.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeMiddle(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeMiddle;
}();
var $5ce356b15dd97b57$var$ThreeRight = /* #__PURE__ */ function() {
    function ThreeRight(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    ThreeRight.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new ThreeRight(value0, value1, value2, value3);
                };
            };
        };
    };
    return ThreeRight;
}();
var $5ce356b15dd97b57$var$KickUp = /* #__PURE__ */ function() {
    function KickUp(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    KickUp.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new KickUp(value0, value1, value2);
            };
        };
    };
    return KickUp;
}();
var $5ce356b15dd97b57$var$fromZipper = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v1;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v1, v.value0.value0, v.value0.value1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v1, v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1, v.value0.value2, v.value0.value3);
                    return;
                }
                if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v.value0.value2, v.value0.value3, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List.Internal (line 25, column 3 - line 30, column 76): " + [
                    v.value0.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.List.Internal (line 22, column 1 - line 22, column 63): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $5ce356b15dd97b57$export$b5a179e49e0f2907 = function(comp) {
    return function(k) {
        return function(orig) {
            var up = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                            $tco_done = true;
                            return new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2);
                        }
                        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoLeft) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v1.value0, v1.value1, v1.value2, v.value0.value0, v.value0.value1));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$TwoRight) {
                                $tco_done = true;
                                return $5ce356b15dd97b57$var$fromZipper(v.value1)(new $5ce356b15dd97b57$var$Three(v.value0.value0, v.value0.value1, v1.value0, v1.value1, v1.value2));
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeLeft) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2), v.value0.value0, new $5ce356b15dd97b57$var$Two(v.value0.value1, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeMiddle) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v1.value0), v1.value1, new $5ce356b15dd97b57$var$Two(v1.value2, v.value0.value2, v.value0.value3));
                                return;
                            }
                            if (v.value0 instanceof $5ce356b15dd97b57$var$ThreeRight) {
                                $tco_var_v = v.value1;
                                $copy_v1 = new $5ce356b15dd97b57$var$KickUp(new $5ce356b15dd97b57$var$Two(v.value0.value0, v.value0.value1, v.value0.value2), v.value0.value3, new $5ce356b15dd97b57$var$Two(v1.value0, v1.value1, v1.value2));
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List.Internal (line 58, column 5 - line 63, column 90): " + [
                                v.value0.constructor.name,
                                v1.constructor.name
                            ]);
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 55, column 3 - line 55, column 50): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            var down = function($copy_v) {
                return function($copy_v1) {
                    var $tco_var_v = $copy_v;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(v, v1) {
                        if (v1 instanceof $5ce356b15dd97b57$var$Leaf) {
                            $tco_done1 = true;
                            return {
                                found: false,
                                result: up(v)(new $5ce356b15dd97b57$var$KickUp($5ce356b15dd97b57$var$Leaf.value, k, $5ce356b15dd97b57$var$Leaf.value))
                            };
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Two) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoLeft(v1.value1, v1.value2), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$TwoRight(v1.value0, v1.value1), v);
                            $copy_v1 = v1.value2;
                            return;
                        }
                        if (v1 instanceof $5ce356b15dd97b57$var$Three) {
                            var v2 = comp(k)(v1.value1);
                            if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            var v3 = comp(k)(v1.value3);
                            if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                $tco_done1 = true;
                                return {
                                    found: true,
                                    result: orig
                                };
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeLeft(v1.value1, v1.value2, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value0;
                                return;
                            }
                            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453 && v3 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                                $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeMiddle(v1.value0, v1.value1, v1.value3, v1.value4), v);
                                $copy_v1 = v1.value2;
                                return;
                            }
                            $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(new $5ce356b15dd97b57$var$ThreeRight(v1.value0, v1.value1, v1.value2, v1.value3), v);
                            $copy_v1 = v1.value4;
                            return;
                        }
                        throw new Error("Failed pattern match at Data.List.Internal (line 38, column 3 - line 38, column 81): " + [
                            v.constructor.name,
                            v1.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                    return $tco_result;
                };
            };
            return down($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(orig);
        };
    };
};
var $5ce356b15dd97b57$export$4e5bc754a9c955a = /* #__PURE__ */ function() {
    return $5ce356b15dd97b57$var$Leaf.value;
}();













var $3d4fd987da5242ff$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3d4fd987da5242ff$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$tailRecM2 = /* #__PURE__ */ $f93520de2fa37b44$export$9056a6bb308e8c79($f93520de2fa37b44$export$6a06149683d26749);
var $3d4fd987da5242ff$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($5026be88823ef1f4$export$82d306ead3b703cd);
var $3d4fd987da5242ff$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $3d4fd987da5242ff$var$bimap = /* #__PURE__ */ $20615e99b278adf5$export$eb54baf0b342cb1d($f93520de2fa37b44$export$61e43214bca7f031);
var $3d4fd987da5242ff$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $3d4fd987da5242ff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($78c799cba34fcb8d$export$92659ee1fc91a075)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $3d4fd987da5242ff$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $3d4fd987da5242ff$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $3d4fd987da5242ff$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3d4fd987da5242ff$export$47606a6ae3eaed8e = function(x) {
    return x;
};
var $3d4fd987da5242ff$export$b6d8713d53419d4c = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2.value1));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$23c8d3f8757cab88 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$var$foldr(function(v) {
        return function(v1) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0), new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value1, v1.value1));
        };
    })(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value));
}();
var $3d4fd987da5242ff$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: v.value0,
        tail: v.value1
    });
    throw new Error("Failed pattern match at Data.List (line 259, column 1 - line 259, column 66): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$823be24f8766da23 = function(dictUnfoldable) {
    return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $3d4fd987da5242ff$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
};
var $3d4fd987da5242ff$export$c01875f616615628 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1);
    throw new Error("Failed pattern match at Data.List (line 245, column 1 - line 245, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$71c2a1babd78d286 = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(v) {
        return function(s) {
            var go = function(prefix) {
                return function(input) {
                    if (prefix instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && input instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && eq2(prefix.value0)(input.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: prefix.value1,
                        b: input.value1
                    }));
                    if (prefix instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $f93520de2fa37b44$export$7fe28cb29e71bf10(input));
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                };
            };
            return $3d4fd987da5242ff$var$tailRecM2(go)(v)(s);
        };
    };
};
var $3d4fd987da5242ff$export$afc1bfabebaf28a2 = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1.value0)) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v)(v1.value1);
            return {
                init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2.init),
                rest: v2.rest
            };
        }
        return {
            init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            rest: v1
        };
    };
};
var $3d4fd987da5242ff$export$c40cf5aab899f397 = function(xs) {
    return function(x) {
        return $3d4fd987da5242ff$var$foldr($78c799cba34fcb8d$export$74c44e616647f5c0.create)(new $78c799cba34fcb8d$export$74c44e616647f5c0(x, $78c799cba34fcb8d$export$c1bed610ade55e1c.value))(xs);
    };
};
var $3d4fd987da5242ff$export$439306a4dcaafbb9 = function(a) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(a, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$b035e44d7bb4278f = function(cmp) {
    var merge = function(v) {
        return function(v1) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, merge(v)(v1.value1));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, merge(v.value1)(v1));
            }
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v1;
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return v;
            throw new Error("Failed pattern match at Data.List (line 466, column 3 - line 466, column 38): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var mergePairs = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(merge(v.value0)(v.value1.value0), mergePairs(v.value1.value1));
        return v;
    };
    var mergeAll = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return v.value0;
            }
            $copy_v = mergePairs(v);
            return;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    var sequences = function(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            if ($3d4fd987da5242ff$var$eq(cmp(v.value0)(v.value1.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) return descending(v.value1.value0)($3d4fd987da5242ff$export$439306a4dcaafbb9(v.value0))(v.value1.value1);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return ascending(v.value1.value0)(function(v1) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
            })(v.value1.value1);
        }
        return $3d4fd987da5242ff$export$439306a4dcaafbb9(v);
    };
    var descending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done1 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$eq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done1 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, v1), sequences(v2));
                }
                while(!$tco_done1)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var ascending = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done2 = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && $3d4fd987da5242ff$var$notEq(cmp(v)(v2.value0))($5026be88823ef1f4$export$b023c82b48e70453.value)) {
                        $tco_var_v = v2.value0;
                        $tco_var_v1 = function(ys) {
                            return v1(new $78c799cba34fcb8d$export$74c44e616647f5c0(v, ys));
                        };
                        $copy_v2 = v2.value1;
                        return;
                    }
                    $tco_done2 = true;
                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1($3d4fd987da5242ff$export$439306a4dcaafbb9(v)), sequences(v2));
                }
                while(!$tco_done2)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return function($444) {
        return mergeAll(sequences($444));
    };
};
var $3d4fd987da5242ff$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $3d4fd987da5242ff$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $3d4fd987da5242ff$var$tails = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, $3d4fd987da5242ff$var$tails(v.value1));
    throw new Error("Failed pattern match at Data.List (line 641, column 1 - line 641, column 43): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$b5c655b9d1f9203e = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(Pattern " + (show(v) + ")");
        }
    };
};
var $3d4fd987da5242ff$export$66c1ae025e96b4bc = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return v;
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 368, column 3 - line 368, column 19): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$b7df5d561049483a = /* #__PURE__ */ function() {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v1 < 1) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $tco_var_v1 = v1 - 1 | 0;
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 513, column 3 - line 513, column 35): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $3d4fd987da5242ff$export$9384c7afe4015e42 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v1.value0)) {
                    $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                    $copy_v1 = v1.value1;
                    return;
                }
                $tco_done = true;
                return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$712962e076096ed4 = function(lst) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        revInit: v1,
                        last: v.value0
                    });
                }
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_v = v.value1;
                    $copy_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
                    return;
                }
                throw new Error("Failed pattern match at Data.List (line 270, column 3 - line 270, column 21): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return $3d4fd987da5242ff$var$map(function(h) {
        return {
            init: $3d4fd987da5242ff$export$66c1ae025e96b4bc(h.revInit),
            last: h.last
        };
    })(go(lst)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
};
var $3d4fd987da5242ff$export$b634740ce272acb5 = function(f) {
    return function(xs) {
        return function(ys) {
            var go = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v2;
                            }
                            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v.value1;
                                $tco_var_v1 = v1.value1;
                                $copy_v2 = new $78c799cba34fcb8d$export$74c44e616647f5c0(f(v.value0)(v1.value0), v2);
                                return;
                            }
                            throw new Error("Failed pattern match at Data.List (line 779, column 3 - line 779, column 21): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            return $3d4fd987da5242ff$export$66c1ae025e96b4bc(go(xs)(ys)($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $3d4fd987da5242ff$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $3d4fd987da5242ff$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence1 = $3d4fd987da5242ff$var$sequence(dictApplicative);
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence1($3d4fd987da5242ff$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $3d4fd987da5242ff$export$d02631cccf789723 = function(start) {
    return function(end) {
        if (start === end) return $3d4fd987da5242ff$export$439306a4dcaafbb9(start);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var go = function($copy_s) {
                return function($copy_e) {
                    return function($copy_step) {
                        return function($copy_rest) {
                            var $tco_var_s = $copy_s;
                            var $tco_var_e = $copy_e;
                            var $tco_var_step = $copy_step;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(s, e, step, rest) {
                                if (s === e) {
                                    $tco_done = true;
                                    return new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                }
                                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                    $tco_var_s = s + step | 0;
                                    $tco_var_e = e;
                                    $tco_var_step = step;
                                    $copy_rest = new $78c799cba34fcb8d$export$74c44e616647f5c0(s, rest);
                                    return;
                                }
                                throw new Error("Failed pattern match at Data.List (line 148, column 3 - line 149, column 65): " + [
                                    s.constructor.name,
                                    e.constructor.name,
                                    step.constructor.name,
                                    rest.constructor.name
                                ]);
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_s, $tco_var_e, $tco_var_step, $copy_rest);
                            return $tco_result;
                        };
                    };
                };
            };
            return go(end)(start)(function() {
                var $325 = start > end;
                if ($325) return 1;
                return -1;
            }())($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        }
        throw new Error("Failed pattern match at Data.List (line 144, column 1 - line 144, column 32): " + [
            start.constructor.name,
            end.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$b29f828819edca8d = function(p) {
    return function(xs) {
        var select = function(x) {
            return function(v) {
                var $328 = p(x);
                if ($328) return {
                    no: v.no,
                    yes: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.yes)
                };
                return {
                    no: new $78c799cba34fcb8d$export$74c44e616647f5c0(x, v.no),
                    yes: v.yes
                };
            };
        };
        return $3d4fd987da5242ff$var$foldr(select)({
            no: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
            yes: $78c799cba34fcb8d$export$c1bed610ade55e1c.value
        })(xs);
    };
};
var $3d4fd987da5242ff$export$7b1b591b262c240 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $3d4fd987da5242ff$export$18f77a3bafa759b9 = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_v = $copy_v;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1, v2) {
                    if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return v1;
                    }
                    if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        var v3 = $5ce356b15dd97b57$export$b5a179e49e0f2907(p)(v2.value0)(v);
                        if (v3.found) {
                            $tco_var_v = v3.result;
                            $tco_var_v1 = v1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                        $tco_var_v = v3.result;
                        $tco_var_v1 = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v1);
                        $copy_v2 = v2.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 673, column 5 - line 673, column 23): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    var $445 = go($5ce356b15dd97b57$export$4e5bc754a9c955a)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
    return function($446) {
        return $3d4fd987da5242ff$export$66c1ae025e96b4bc($445($446));
    };
};
var $3d4fd987da5242ff$export$94f4066a75b10404 = function(dictOrd) {
    return $3d4fd987da5242ff$export$18f77a3bafa759b9($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$86c9b635481112b7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3d4fd987da5242ff$export$e70771d2e7e590a = function(f) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var v2 = f(v1.value0);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    throw new Error("Failed pattern match at Data.List (line 419, column 5 - line 421, column 32): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.List (line 417, column 3 - line 417, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$17771a97d85ba7eb = function(dictMonadRec) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonadRec.Monad0().Bind1());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(dictAlternative) {
        var Alt0 = dictAlternative.Plus1().Alt0();
        var alt = $75e93a4111e80214$export$228be17d80722ab(Alt0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Alt0.Functor0());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
        return function(p) {
            var go = function(acc) {
                return bind1(alt(map1($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(p))(pure(new $f93520de2fa37b44$export$7fe28cb29e71bf10($05149ea687d6b460$export$523c0b569236b342))))(function(aa) {
                    return pure($3d4fd987da5242ff$var$bimap(function(v) {
                        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v, acc);
                    })(function(v) {
                        return $3d4fd987da5242ff$export$66c1ae025e96b4bc(acc);
                    })(aa));
                });
            };
            return tailRecM(go)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $3d4fd987da5242ff$export$934820ddadec516f = function(dictMonadRec) {
    var manyRec1 = $3d4fd987da5242ff$export$17771a97d85ba7eb(dictMonadRec);
    return function(dictAlternative) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
        var manyRec2 = manyRec1(dictAlternative);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(manyRec2(v));
        };
    };
};
var $3d4fd987da5242ff$export$ad14ef4001db2bcd = function(dictAlternative) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictAlternative.Applicative0().Apply0());
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlternative.Plus1().Alt0().Functor0());
    return function(dictLazy) {
        var defer = $a1e0a82f0b162743$export$260e5c0943f31606(dictLazy);
        return function(v) {
            return apply(map1($78c799cba34fcb8d$export$74c44e616647f5c0.create)(v))(defer(function(v1) {
                return $3d4fd987da5242ff$export$14badfee79ea396f(dictAlternative)(dictLazy)(v);
            }));
        };
    };
};
var $3d4fd987da5242ff$export$14badfee79ea396f = function(dictAlternative) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlternative.Plus1().Alt0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    return function(dictLazy) {
        return function(v) {
            return alt($3d4fd987da5242ff$export$ad14ef4001db2bcd(dictAlternative)(dictLazy)(v))(pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value));
        };
    };
};
var $3d4fd987da5242ff$export$f24224f1c91d8156 = /* #__PURE__ */ $3d4fd987da5242ff$var$foldl(function(acc) {
    return function(v) {
        return acc + 1 | 0;
    };
})(0);
var $3d4fd987da5242ff$export$4c7897fafd92b108 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $3d4fd987da5242ff$export$b8bc901090d2b1d4 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$439306a4dcaafbb9(v1);
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var v3 = v(v1)(v2.value0);
                if (v3 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$b8bc901090d2b1d4(v)(v1)(v2.value1));
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2);
            }
            throw new Error("Failed pattern match at Data.List (line 216, column 1 - line 216, column 68): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$9f200c4466975173 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1, v2));
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$9f200c4466975173(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$21a5ca8aa77d35ff = function(dictOrd) {
    return $3d4fd987da5242ff$export$b8bc901090d2b1d4($97937c29f879e68e$export$398604a469f7de9a(dictOrd));
};
var $3d4fd987da5242ff$export$2cd8252107eb640b = function(lst) {
    return $3d4fd987da5242ff$var$map(function(v) {
        return v.init;
    })($3d4fd987da5242ff$export$712962e076096ed4(lst));
};
var $3d4fd987da5242ff$export$b610b8812bbcded9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 === 0) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            }
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v.value1;
                $copy_v1 = v1 - 1 | 0;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 281, column 1 - line 281, column 44): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$5fd5031fecdacec3 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    throw new Error("Failed pattern match at Data.List (line 230, column 1 - line 230, column 22): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$9cb09a71b7d66923 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $3d4fd987da5242ff$export$9cb09a71b7d66923(v.value1);
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value0, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$5fd5031fecdacec3)(v.value1)), $3d4fd987da5242ff$export$9cb09a71b7d66923(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0.value1, $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$export$c01875f616615628)(v.value1))));
    throw new Error("Failed pattern match at Data.List (line 813, column 1 - line 813, column 54): " + [
        v.constructor.name
    ]);
};
var $3d4fd987da5242ff$export$3f063810d7bf01bd = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            var v2 = $3d4fd987da5242ff$export$afc1bfabebaf28a2(v(v1.value0))(v1.value1);
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v2.init), $3d4fd987da5242ff$export$3f063810d7bf01bd(v)(v2.rest));
        }
        throw new Error("Failed pattern match at Data.List (line 609, column 1 - line 609, column 80): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$1f7a5bf12caafbd = function(p) {
    var $447 = $3d4fd987da5242ff$export$3f063810d7bf01bd(function(x) {
        return function(y) {
            return $3d4fd987da5242ff$var$eq(p(x)(y))($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        };
    });
    var $448 = $3d4fd987da5242ff$export$b035e44d7bb4278f(p);
    return function($449) {
        return $447($448($449));
    };
};
var $3d4fd987da5242ff$export$e5e25fbcc1f7affe = function(dictEq) {
    return $3d4fd987da5242ff$export$3f063810d7bf01bd($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$361434b95a7d965 = function(dictOrd) {
    var $450 = $3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictOrd.Eq0());
    var $451 = $3d4fd987da5242ff$export$97db5808d8f88186(dictOrd);
    return function($452) {
        return $450($451($452));
    };
};
var $3d4fd987da5242ff$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$7a067f9280ad8af0 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure(v1);
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1)(v2.value0))(function(b$prime) {
                    return $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad)(v)(b$prime)(v2.value1);
                });
                throw new Error("Failed pattern match at Data.List (line 824, column 1 - line 824, column 72): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $3d4fd987da5242ff$export$de3a4d4a0d731119 = function(fn) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (fn(v1.value0)) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v + 1 | 0;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                throw new Error("Failed pattern match at Data.List (line 301, column 3 - line 301, column 35): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go(0);
};
var $3d4fd987da5242ff$export$8855a8be7bd3e9f8 = function(fn) {
    return function(xs) {
        return $3d4fd987da5242ff$var$map(function(v) {
            return ($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - 1 | 0) - v | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(fn)($3d4fd987da5242ff$export$66c1ae025e96b4bc(xs)));
    };
};
var $3d4fd987da5242ff$export$20098ecb074a31e6 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return pure($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return bind1(v(v1.value0))(function(b) {
                return bind1($3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad)(v)(v1.value1))(function(xs$prime) {
                    return pure(function() {
                        if (b) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, xs$prime);
                        return xs$prime;
                    }());
                });
            });
            throw new Error("Failed pattern match at Data.List (line 403, column 1 - line 403, column 75): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$3dea766d36a8935f = function(p) {
    var go = function($copy_v) {
        return function($copy_v1) {
            var $tco_var_v = $copy_v;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1) {
                if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return $3d4fd987da5242ff$export$66c1ae025e96b4bc(v);
                }
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (p(v1.value0)) {
                        $tco_var_v = new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v);
                        $copy_v1 = v1.value1;
                        return;
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                        $tco_var_v = v;
                        $copy_v1 = v1.value1;
                        return;
                    }
                }
                throw new Error("Failed pattern match at Data.List (line 390, column 3 - line 390, column 27): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
            return $tco_result;
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $3d4fd987da5242ff$export$f161f39e9c06ab2d = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            return $3d4fd987da5242ff$export$3dea766d36a8935f(function(x) {
                return $3d4fd987da5242ff$var$any(v(x))(v2);
            })(v1);
        };
    };
};
var $3d4fd987da5242ff$export$1f4807a235930d45 = function(dictEq) {
    return $3d4fd987da5242ff$export$f161f39e9c06ab2d($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$45273896c792ff3b = function(v) {
    return function(v1) {
        if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, $3d4fd987da5242ff$export$45273896c792ff3b(v)($3d4fd987da5242ff$export$3dea766d36a8935f(function(y) {
            return !v(v1.value0)(y);
        })(v1.value1)));
        throw new Error("Failed pattern match at Data.List (line 705, column 1 - line 705, column 61): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $3d4fd987da5242ff$export$edce5881c815871 = function(dictEq) {
    return $3d4fd987da5242ff$export$45273896c792ff3b($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$3c57592525e2b27e = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32($78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictEq));
    return {
        eq: function(x) {
            return function(y) {
                return eq2(x)(y);
            };
        }
    };
};
var $3d4fd987da5242ff$export$21c206d752eba296 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqPattern1 = $3d4fd987da5242ff$export$3c57592525e2b27e(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqPattern1;
        }
    };
};
var $3d4fd987da5242ff$export$c19d79386f4ed99a = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$8855a8be7bd3e9f8(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$f444781b0adb7e4d = function(dictEq) {
    var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $3d4fd987da5242ff$export$de3a4d4a0d731119(function(v) {
            return eq2(v)(x);
        });
    };
};
var $3d4fd987da5242ff$export$533af5c8cd6afa16 = function(p) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && p(v.value0)) {
                $copy_v = v.value1;
                return;
            }
            $tco_done = true;
            return v;
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $3d4fd987da5242ff$export$2b3b686e33c80c56 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$b7df5d561049483a($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$663103110d94aac9 = function($copy_v) {
    return function($copy_v1) {
        var $tco_var_v = $copy_v;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v, v1) {
            if (v < 1) {
                $tco_done = true;
                return v1;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            }
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                $tco_var_v = v - 1 | 0;
                $copy_v1 = v1.value1;
                return;
            }
            throw new Error("Failed pattern match at Data.List (line 536, column 1 - line 536, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
        return $tco_result;
    };
};
var $3d4fd987da5242ff$export$58adb3bec8346d0f = function(start) {
    return function(end) {
        return function(xs) {
            return $3d4fd987da5242ff$export$b7df5d561049483a(end - start | 0)($3d4fd987da5242ff$export$663103110d94aac9(start)(xs));
        };
    };
};
var $3d4fd987da5242ff$export$9100289823a975b0 = function(n) {
    return function(xs) {
        return $3d4fd987da5242ff$export$663103110d94aac9($3d4fd987da5242ff$export$f24224f1c91d8156(xs) - n | 0)(xs);
    };
};
var $3d4fd987da5242ff$export$9ea2b6c3fae093d8 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v(v1)(v2.value0)) return v2.value1;
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, $3d4fd987da5242ff$export$9ea2b6c3fae093d8(v)(v1)(v2.value1));
            throw new Error("Failed pattern match at Data.List (line 732, column 1 - line 732, column 67): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4fd987da5242ff$export$ef1d06dc4d91d507 = function(eq2) {
    return function(xs) {
        return function(ys) {
            return $3d4fd987da5242ff$var$append1(xs)($3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$9ea2b6c3fae093d8(eq2)))($3d4fd987da5242ff$export$45273896c792ff3b(eq2)(ys))(xs));
        };
    };
};
var $3d4fd987da5242ff$export$971dd5b0dfd021b6 = function(dictEq) {
    return $3d4fd987da5242ff$export$ef1d06dc4d91d507($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$90f9093465da3136 = function(v) {
    return function(v1) {
        if (v === 0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value1);
        if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v2) {
            return new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v2);
        })($3d4fd987da5242ff$export$90f9093465da3136(v - 1 | 0)(v1.value1));
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
};
var $3d4fd987da5242ff$export$1822828d790e23ee = function(dictEq) {
    return $3d4fd987da5242ff$export$9ea2b6c3fae093d8($37b880af5f4991bd$export$9663ddc1cf085b32(dictEq));
};
var $3d4fd987da5242ff$export$acaf96a27438246b = function(dictEq) {
    return $3d4fd987da5242ff$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$export$1822828d790e23ee(dictEq)));
};
var $3d4fd987da5242ff$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($3d4fd987da5242ff$var$bind);
var $3d4fd987da5242ff$export$ee1b3e54f0441b22 = function(v) {
    return $3d4fd987da5242ff$var$bind(v)($3d4fd987da5242ff$var$identity);
};
var $3d4fd987da5242ff$export$986c2bbe7a34be0b = /* #__PURE__ */ $3d4fd987da5242ff$export$e70771d2e7e590a($3d4fd987da5242ff$var$identity);
var $3d4fd987da5242ff$export$2dd9d44f93be5e22 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                var v3 = v1(v2.value0);
                if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v2.value1;
                if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $78c799cba34fcb8d$export$74c44e616647f5c0(v3.value0, v2.value1);
                throw new Error("Failed pattern match at Data.List (line 352, column 3 - line 354, column 23): " + [
                    v3.constructor.name
                ]);
            }());
            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return $3d4fd987da5242ff$var$map(function(v3) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(v2.value0, v3);
            })($3d4fd987da5242ff$export$2dd9d44f93be5e22(v - 1 | 0)(v1)(v2.value1));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $3d4fd987da5242ff$export$cba09f9e3d3e58eb = function(n) {
    return function(f) {
        return $3d4fd987da5242ff$export$2dd9d44f93be5e22(n)(function($453) {
            return $06733ae99ed4f534$export$8a67b48435b5d073.create(f($453));
        });
    };
};


// Generated by purs version 0.15.16


















// Generated by purs version 0.15.16
// module Partial.Unsafe
const $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81 = function(f) {
    return f();
};


// Generated by purs version 0.15.16
// module Partial
const $d8f9d43a2c2b18d5$export$b479f9f69f916b6a = function(msg) {
    throw new Error(msg);
};


var $dcd3eefef707675c$export$ddf616d7646fcc8e = function() {
    return $d8f9d43a2c2b18d5$export$b479f9f69f916b6a;
};
var $dcd3eefef707675c$var$crashWith1 = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $dcd3eefef707675c$export$dcc9d38dbc7992eb = function() {
    return $dcd3eefef707675c$var$crashWith1("Partial.crash: partial function");
};


var $8bcde8f642a64c7d$var$crashWith = /* #__PURE__ */ $dcd3eefef707675c$export$ddf616d7646fcc8e();
var $8bcde8f642a64c7d$export$cb50937af21de128 = $1ea5ae3d66e02fe1$export$3e8f060a4c73ba81;
var $8bcde8f642a64c7d$export$51b220bae4359b72 = function(msg) {
    return $8bcde8f642a64c7d$export$cb50937af21de128(function() {
        return $8bcde8f642a64c7d$var$crashWith(msg);
    });
};


var $ba51d599f79a6310$var$sequence1 = /* #__PURE__ */ $e4fb66202bb8a4f4$export$6deffb29affc84c6($78c799cba34fcb8d$export$fac1bbd0707bc766);
var $ba51d599f79a6310$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ba51d599f79a6310$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$3c979cc7d75b024c);
var $ba51d599f79a6310$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$12e3398ee6f4a417);
var $ba51d599f79a6310$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ba51d599f79a6310$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $ba51d599f79a6310$export$b634740ce272acb5 = function(f) {
    return function(v) {
        return function(v1) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0)(v1.value0), $3d4fd987da5242ff$export$b634740ce272acb5(f)(v.value1)(v1.value1));
        };
    };
};
var $ba51d599f79a6310$export$e00c1e5c5a2b1ad7 = function(dictApplicative) {
    var sequence11 = $ba51d599f79a6310$var$sequence1(dictApplicative.Apply0());
    return function(f) {
        return function(xs) {
            return function(ys) {
                return sequence11($ba51d599f79a6310$export$b634740ce272acb5(f)(xs)(ys));
            };
        };
    };
};
var $ba51d599f79a6310$export$8901015135f2fb22 = /* #__PURE__ */ function() {
    return $ba51d599f79a6310$export$b634740ce272acb5($71f2e2e9476163f8$export$1908877435b1d5e9.create);
}();
var $ba51d599f79a6310$var$wrappedOperation2 = function(name) {
    return function(f) {
        return function(v) {
            return function(v1) {
                var v2 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1))(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value0, v1.value1));
                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v2.value0, v2.value1);
                if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
                throw new Error("Failed pattern match at Data.List.NonEmpty (line 105, column 3 - line 107, column 81): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ba51d599f79a6310$var$wrappedOperation = function(name) {
    return function(f) {
        return function(v) {
            var v1 = f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
            if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v1.value0, v1.value1);
            if (v1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $8bcde8f642a64c7d$export$51b220bae4359b72("Impossible: empty list in NonEmptyList " + name);
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 92, column 3 - line 94, column 81): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$b6d8713d53419d4c = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($193) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($193));
            })($3d4fd987da5242ff$export$b6d8713d53419d4c(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 198, column 1 - line 198, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$23c8d3f8757cab88 = function(ts) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9($ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(ts), $ba51d599f79a6310$var$map1($71f2e2e9476163f8$export$6f71268a1666ab58)(ts));
};
var $ba51d599f79a6310$export$712962e076096ed4 = function(v) {
    var v1 = $3d4fd987da5242ff$export$712962e076096ed4(v.value1);
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
        init: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        last: v.value0
    };
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
        init: new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1.value0.init),
        last: v1.value0.last
    };
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 160, column 35 - line 162, column 50): " + [
        v1.constructor.name
    ]);
};
var $ba51d599f79a6310$export$ef1d06dc4d91d507 = /* #__PURE__ */ function() {
    var $194 = $ba51d599f79a6310$var$wrappedOperation2("unionBy");
    return function($195) {
        return $194($3d4fd987da5242ff$export$ef1d06dc4d91d507($195));
    };
}();
var $ba51d599f79a6310$export$971dd5b0dfd021b6 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("union")($3d4fd987da5242ff$export$971dd5b0dfd021b6(dictEq));
};
var $ba51d599f79a6310$export$b446f6baa3bb1430 = function(v) {
    return {
        head: v.value0,
        tail: v.value1
    };
};
var $ba51d599f79a6310$export$effcdbd76139450 = function(v) {
    return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1);
};
var $ba51d599f79a6310$export$823be24f8766da23 = function(dictUnfoldable) {
    var $196 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function(xs) {
        return $ba51d599f79a6310$var$map(function(rec) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(rec.head, rec.tail);
        })($3d4fd987da5242ff$export$b446f6baa3bb1430(xs));
    });
    return function($197) {
        return $196($ba51d599f79a6310$export$effcdbd76139450($197));
    };
};
var $ba51d599f79a6310$export$c01875f616615628 = function(v) {
    return v.value1;
};
var $ba51d599f79a6310$export$b035e44d7bb4278f = /* #__PURE__ */ function() {
    var $198 = $ba51d599f79a6310$var$wrappedOperation("sortBy");
    return function($199) {
        return $198($3d4fd987da5242ff$export$b035e44d7bb4278f($199));
    };
}();
var $ba51d599f79a6310$export$97db5808d8f88186 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(xs) {
        return $ba51d599f79a6310$export$b035e44d7bb4278f(compare)(xs);
    };
};
var $ba51d599f79a6310$export$c40cf5aab899f397 = function(v) {
    return function(y) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(y));
    };
};
var $ba51d599f79a6310$export$439306a4dcaafbb9 = /* #__PURE__ */ function() {
    var $200 = $1f1c3fb67e79b37f$export$439306a4dcaafbb9($78c799cba34fcb8d$export$55d622505c452dcb);
    return function($201) {
        return $78c799cba34fcb8d$export$ab241a3582569781($200($201));
    };
}();
var $ba51d599f79a6310$export$5b6d1d165591a48c = function(v) {
    return function(v1) {
        if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $3d4fd987da5242ff$export$c40cf5aab899f397(v.value1)(v1));
        if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $ba51d599f79a6310$export$439306a4dcaafbb9(v1);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 140, column 1 - line 140, column 51): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$66c1ae025e96b4bc = /* #__PURE__ */ $ba51d599f79a6310$var$wrappedOperation("reverse")($3d4fd987da5242ff$export$66c1ae025e96b4bc);
var $ba51d599f79a6310$export$edce5881c815871 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("nubEq")($3d4fd987da5242ff$export$edce5881c815871(dictEq));
};
var $ba51d599f79a6310$export$45273896c792ff3b = /* #__PURE__ */ function() {
    var $202 = $ba51d599f79a6310$var$wrappedOperation("nubByEq");
    return function($203) {
        return $202($3d4fd987da5242ff$export$45273896c792ff3b($203));
    };
}();
var $ba51d599f79a6310$export$18f77a3bafa759b9 = /* #__PURE__ */ function() {
    var $204 = $ba51d599f79a6310$var$wrappedOperation("nubBy");
    return function($205) {
        return $204($3d4fd987da5242ff$export$18f77a3bafa759b9($205));
    };
}();
var $ba51d599f79a6310$export$94f4066a75b10404 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("nub")($3d4fd987da5242ff$export$94f4066a75b10404(dictOrd));
};
var $ba51d599f79a6310$export$cba09f9e3d3e58eb = function(i) {
    return function(f) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(f(v.value0), v.value1));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($206) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($206));
            })($3d4fd987da5242ff$export$cba09f9e3d3e58eb(i - 1 | 0)(f)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 203, column 1 - line 203, column 82): " + [
                i.constructor.name,
                f.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$var$lift = function(f) {
    return function(v) {
        return f(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$e70771d2e7e590a = function($207) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$e70771d2e7e590a($207));
};
var $ba51d599f79a6310$export$b29f828819edca8d = function($208) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b29f828819edca8d($208));
};
var $ba51d599f79a6310$export$afc1bfabebaf28a2 = function($209) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$afc1bfabebaf28a2($209));
};
var $ba51d599f79a6310$export$b7df5d561049483a = function($210) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$b7df5d561049483a($210));
};
var $ba51d599f79a6310$export$9384c7afe4015e42 = function($211) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$9384c7afe4015e42($211));
};
var $ba51d599f79a6310$export$f24224f1c91d8156 = function(v) {
    return 1 + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $ba51d599f79a6310$export$4c7897fafd92b108 = function(v) {
    return $06733ae99ed4f534$export$43db023a260c5e9f(v.value0)($3d4fd987da5242ff$export$4c7897fafd92b108(v.value1));
};
var $ba51d599f79a6310$export$f161f39e9c06ab2d = /* #__PURE__ */ function() {
    var $212 = $ba51d599f79a6310$var$wrappedOperation2("intersectBy");
    return function($213) {
        return $212($3d4fd987da5242ff$export$f161f39e9c06ab2d($213));
    };
}();
var $ba51d599f79a6310$export$1f4807a235930d45 = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation2("intersect")($3d4fd987da5242ff$export$1f4807a235930d45(dictEq));
};
var $ba51d599f79a6310$export$9f200c4466975173 = function(i) {
    return function(a) {
        return function(v) {
            if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(a, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1)));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function($214) {
                return $78c799cba34fcb8d$export$ab241a3582569781(function(v1) {
                    return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v1);
                }($214));
            })($3d4fd987da5242ff$export$9f200c4466975173(i - 1 | 0)(a)(v.value1));
            throw new Error("Failed pattern match at Data.List.NonEmpty (line 193, column 1 - line 193, column 75): " + [
                i.constructor.name,
                a.constructor.name,
                v.constructor.name
            ]);
        };
    };
};
var $ba51d599f79a6310$export$2cd8252107eb640b = function(v) {
    return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($78c799cba34fcb8d$export$c1bed610ade55e1c.value)(function(v1) {
        return new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v1);
    })($3d4fd987da5242ff$export$2cd8252107eb640b(v.value1));
};
var $ba51d599f79a6310$export$b610b8812bbcded9 = function(v) {
    return function(i) {
        if (i === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $3d4fd987da5242ff$export$b610b8812bbcded9(v.value1)(i - 1 | 0);
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 167, column 1 - line 167, column 52): " + [
            v.constructor.name,
            i.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$5fd5031fecdacec3 = function(v) {
    return v.value0;
};
var $ba51d599f79a6310$export$3f063810d7bf01bd = /* #__PURE__ */ function() {
    var $215 = $ba51d599f79a6310$var$wrappedOperation("groupBy");
    return function($216) {
        return $215($3d4fd987da5242ff$export$3f063810d7bf01bd($216));
    };
}();
var $ba51d599f79a6310$export$1f7a5bf12caafbd = /* #__PURE__ */ function() {
    var $217 = $ba51d599f79a6310$var$wrappedOperation("groupAllBy");
    return function($218) {
        return $217($3d4fd987da5242ff$export$1f7a5bf12caafbd($218));
    };
}();
var $ba51d599f79a6310$export$361434b95a7d965 = function(dictOrd) {
    return $ba51d599f79a6310$var$wrappedOperation("groupAll")($3d4fd987da5242ff$export$361434b95a7d965(dictOrd));
};
var $ba51d599f79a6310$export$e5e25fbcc1f7affe = function(dictEq) {
    return $ba51d599f79a6310$var$wrappedOperation("group")($3d4fd987da5242ff$export$e5e25fbcc1f7affe(dictEq));
};
var $ba51d599f79a6310$export$88e0dae599377b39 = function(v) {
    if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, v.value1));
    throw new Error("Failed pattern match at Data.List.NonEmpty (line 121, column 1 - line 121, column 57): " + [
        v.constructor.name
    ]);
};
var $ba51d599f79a6310$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var $219 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function($220) {
        return $ba51d599f79a6310$export$88e0dae599377b39($219($220));
    };
};
var $ba51d599f79a6310$export$7a067f9280ad8af0 = function(dictMonad) {
    var bind1 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var foldM1 = $3d4fd987da5242ff$export$7a067f9280ad8af0(dictMonad);
    return function(f) {
        return function(b) {
            return function(v) {
                return bind1(f(b)(v.value0))(function(b$prime) {
                    return foldM1(f)(b$prime)(v.value1);
                });
            };
        };
    };
};
var $ba51d599f79a6310$export$8855a8be7bd3e9f8 = function(f) {
    return function(v) {
        var v1 = $3d4fd987da5242ff$export$8855a8be7bd3e9f8(f)(v.value1);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0 + 1 | 0);
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 187, column 3 - line 191, column 29): " + [
            v1.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$de3a4d4a0d731119 = function(f) {
    return function(v) {
        if (f(v.value0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ba51d599f79a6310$var$map(function(v1) {
            return v1 + 1 | 0;
        })($3d4fd987da5242ff$export$de3a4d4a0d731119(f)(v.value1));
        throw new Error("Failed pattern match at Data.List.NonEmpty (line 180, column 1 - line 180, column 69): " + [
            f.constructor.name,
            v.constructor.name
        ]);
    };
};
var $ba51d599f79a6310$export$20098ecb074a31e6 = function(dictMonad) {
    var $221 = $3d4fd987da5242ff$export$20098ecb074a31e6(dictMonad);
    return function($222) {
        return $ba51d599f79a6310$var$lift($221($222));
    };
};
var $ba51d599f79a6310$export$3dea766d36a8935f = function($223) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$3dea766d36a8935f($223));
};
var $ba51d599f79a6310$export$c19d79386f4ed99a = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$8855a8be7bd3e9f8(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$f444781b0adb7e4d = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(x) {
        return $ba51d599f79a6310$export$de3a4d4a0d731119(function(v) {
            return eq1(v)(x);
        });
    };
};
var $ba51d599f79a6310$export$533af5c8cd6afa16 = function($224) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$533af5c8cd6afa16($224));
};
var $ba51d599f79a6310$export$663103110d94aac9 = function($225) {
    return $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$663103110d94aac9($225));
};
var $ba51d599f79a6310$export$cc3b5f3f66225fbe = function(x) {
    return function(xs) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x, xs);
    };
};
var $ba51d599f79a6310$export$8327ebbef2a0ba76 = function(y) {
    return function(v) {
        return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(y, new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $ba51d599f79a6310$export$c28c8388be0ab31a = /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ba51d599f79a6310$var$bind);
var $ba51d599f79a6310$export$ee1b3e54f0441b22 = function(v) {
    return $ba51d599f79a6310$var$bind(v)($ba51d599f79a6310$var$identity);
};
var $ba51d599f79a6310$export$986c2bbe7a34be0b = /* #__PURE__ */ $ba51d599f79a6310$var$lift($3d4fd987da5242ff$export$986c2bbe7a34be0b);
var $ba51d599f79a6310$export$89c5a0ebe497f8c7 = function(dictFoldable) {
    var fromFoldable1 = $3d4fd987da5242ff$export$b7d5d9bb9ff52072(dictFoldable);
    return function(v) {
        return function(ys) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(v.value0, $ba51d599f79a6310$var$append1(v.value1)(fromFoldable1(ys)));
        };
    };
};



// Generated by purs version 0.15.16





















var $ea3eb84de0acf574$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $ea3eb84de0acf574$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $ea3eb84de0acf574$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $ea3eb84de0acf574$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $ea3eb84de0acf574$var$abs = /* #__PURE__ */ $97937c29f879e68e$export$2335f513bbd82c6d($97937c29f879e68e$export$ff461bf68e7dd332)($d061555d3b2c84b2$export$d40e27c88e22a303);
var $ea3eb84de0acf574$export$3024f3bfb62054a3 = /* #__PURE__ */ function() {
    function Leaf() {}
    Leaf.value = new Leaf();
    return Leaf;
}();
var $ea3eb84de0acf574$export$85c928794f8d04d4 = /* #__PURE__ */ function() {
    function Node(value0, value1, value2, value3, value4, value5) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
        this.value4 = value4;
        this.value5 = value5;
    }
    Node.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return function(value4) {
                        return function(value5) {
                            return new Node(value0, value1, value2, value3, value4, value5);
                        };
                    };
                };
            };
        };
    };
    return Node;
}();
var $ea3eb84de0acf574$var$IterLeaf = /* #__PURE__ */ function() {
    function IterLeaf() {}
    IterLeaf.value = new IterLeaf();
    return IterLeaf;
}();
var $ea3eb84de0acf574$var$IterEmit = /* #__PURE__ */ function() {
    function IterEmit(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterEmit.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterEmit(value0, value1, value2);
            };
        };
    };
    return IterEmit;
}();
var $ea3eb84de0acf574$var$IterNode = /* #__PURE__ */ function() {
    function IterNode(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    IterNode.create = function(value0) {
        return function(value1) {
            return new IterNode(value0, value1);
        };
    };
    return IterNode;
}();
var $ea3eb84de0acf574$export$4546c67049b8e195 = /* #__PURE__ */ function() {
    function IterDone() {}
    IterDone.value = new IterDone();
    return IterDone;
}();
var $ea3eb84de0acf574$export$e512af67edd28ac0 = /* #__PURE__ */ function() {
    function IterNext(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    IterNext.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new IterNext(value0, value1, value2);
            };
        };
    };
    return IterNext;
}();
var $ea3eb84de0acf574$export$f836382419f64c98 = /* #__PURE__ */ function() {
    function Split(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Split.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Split(value0, value1, value2);
            };
        };
    };
    return Split;
}();
var $ea3eb84de0acf574$var$SplitLast = /* #__PURE__ */ function() {
    function SplitLast(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SplitLast.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SplitLast(value0, value1, value2);
            };
        };
    };
    return SplitLast;
}();
var $ea3eb84de0acf574$export$8cd737e72cfcb4cd = function(k, v, l, r) {
    if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + r.value0 | 0, 1 + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 702, column 5 - line 706, column 39): " + [
            r.constructor.name
        ]);
    }
    if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + l.value0 | 0, 1 + l.value1 | 0, k, v, l, r);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(1 + function() {
            var $280 = l.value0 > r.value0;
            if ($280) return l.value0;
            return r.value0;
        }() | 0, (1 + l.value1 | 0) + r.value1 | 0, k, v, l, r);
        throw new Error("Failed pattern match at Data.Map.Internal (line 708, column 5 - line 712, column 68): " + [
            r.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 700, column 32 - line 712, column 68): " + [
        l.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$a07cd7d770cb0fb3 = /* #__PURE__ */ function() {
    return $f57f4b701aa7b66e$export$8a83211c878a3f1f($ea3eb84de0acf574$var$IterNode.create)($ea3eb84de0acf574$var$IterLeaf.value);
}();
var $ea3eb84de0acf574$var$stepWith = function(f) {
    return function(next) {
        return function(done) {
            var go = function($copy_v) {
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v) {
                    if (v instanceof $ea3eb84de0acf574$var$IterLeaf) {
                        $tco_done = true;
                        return done($05149ea687d6b460$export$523c0b569236b342);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterEmit) {
                        $tco_done = true;
                        return next(v.value0, v.value1, v.value2);
                    }
                    if (v instanceof $ea3eb84de0acf574$var$IterNode) {
                        $copy_v = f(v.value1)(v.value0);
                        return;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 940, column 8 - line 946, column 20): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($copy_v);
                return $tco_result;
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$346677f925de839c = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value1;
    throw new Error("Failed pattern match at Data.Map.Internal (line 618, column 8 - line 620, column 24): " + [
        v.constructor.name
    ]);
};
var $ea3eb84de0acf574$export$439306a4dcaafbb9 = function(k) {
    return function(v) {
        return new $ea3eb84de0acf574$export$85c928794f8d04d4(1, 1, k, v, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
    };
};
var $ea3eb84de0acf574$export$807b724170e609fd = /* #__PURE__ */ function() {
    var height = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return 0;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0;
        throw new Error("Failed pattern match at Data.Map.Internal (line 757, column 12 - line 759, column 26): " + [
            v.constructor.name
        ]);
    };
    var rotateLeft = function(k, v, l, rk, rv, rl, rr) {
        if (rl instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && rl.value0 > height(rr)) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rl.value2, rl.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, rl.value5, rr));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(rk, rv, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, rl), rr);
    };
    var rotateRight = function(k, v, lk, lv, ll, lr, r) {
        if (lr instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && height(ll) <= lr.value0) return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lr.value2, lr.value3, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, lr.value4), $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr.value5, r));
        return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(lk, lv, ll, $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, lr, r));
    };
    return function(k, v, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && r.value0 > 1) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        if (l instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (r.value0 > (l.value0 + 1 | 0)) return rotateLeft(k, v, l, r.value2, r.value3, r.value4, r.value5);
                if (l.value0 > (r.value0 + 1 | 0)) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            }
            if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3 && l.value0 > 1) return rotateRight(k, v, l.value2, l.value3, l.value4, l.value5, r);
            return $ea3eb84de0acf574$export$8cd737e72cfcb4cd(k, v, l, r);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 717, column 40 - line 738, column 34): " + [
            l.constructor.name
        ]);
    };
}();
var $ea3eb84de0acf574$var$$lazy_unsafeSplit = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplit", "Data.Map.Internal", function() {
    return function(comp, k, m) {
        if (m instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$export$f836382419f64c98($06733ae99ed4f534$export$bebe9059409a0d04.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value, $ea3eb84de0acf574$export$3024f3bfb62054a3.value);
        if (m instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = comp(k)(m.value2);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(793)(comp, k, m.value4);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, v1.value2, m.value5));
            }
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplit(796)(comp, k, m.value5);
                return new $ea3eb84de0acf574$export$f836382419f64c98(v1.value0, $ea3eb84de0acf574$export$807b724170e609fd(m.value2, m.value3, m.value4, v1.value1), v1.value2);
            }
            if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$f836382419f64c98(new $06733ae99ed4f534$export$8a67b48435b5d073(m.value3), m.value4, m.value5);
            throw new Error("Failed pattern match at Data.Map.Internal (line 791, column 5 - line 799, column 30): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 787, column 34 - line 799, column 30): " + [
            m.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$export$9827c6ff7b07c8a4 = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplit(786);
var $ea3eb84de0acf574$var$$lazy_unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeSplitLast", "Data.Map.Internal", function() {
    return function(k, v, l, r) {
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$SplitLast(k, v, l);
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v1 = $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(779)(r.value2, r.value3, r.value4, r.value5);
            return new $ea3eb84de0acf574$var$SplitLast(v1.value0, v1.value1, $ea3eb84de0acf574$export$807b724170e609fd(k, v, l, v1.value2));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 776, column 37 - line 780, column 57): " + [
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeSplitLast = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeSplitLast(775);
var $ea3eb84de0acf574$export$76d750f4290aa12 = function(v, v1) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v1;
    if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
        var v2 = $ea3eb84de0acf574$var$unsafeSplitLast(v.value2, v.value3, v.value4, v.value5);
        return $ea3eb84de0acf574$export$807b724170e609fd(v2.value0, v2.value1, v2.value2, v1);
    }
    throw new Error("Failed pattern match at Data.Map.Internal (line 764, column 25 - line 768, column 38): " + [
        v.constructor.name,
        v1.constructor.name
    ]);
};
var $ea3eb84de0acf574$var$$lazy_unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeDifference", "Data.Map.Internal", function() {
    return function(comp, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(841)(comp, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeDifference(842)(comp, v.value2, r.value5);
            return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 836, column 39 - line 843, column 33): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeDifference = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeDifference(835);
var $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeIntersectionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(825)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(826)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 827, column 5 - line 831, column 37): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 820, column 49 - line 831, column 37): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeIntersectionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeIntersectionWith(819);
var $ea3eb84de0acf574$var$$lazy_unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$runtime_lazy("unsafeUnionWith", "Data.Map.Internal", function() {
    return function(comp, app, l, r) {
        if (l instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return r;
        if (r instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return l;
        if (r instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(comp, r.value2, l);
            var l$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(809)(comp, app, v.value1, r.value4);
            var r$prime = $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(810)(comp, app, v.value2, r.value5);
            if (v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, app(v.value0.value0)(r.value3), l$prime, r$prime);
            if (v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$807b724170e609fd(r.value2, r.value3, l$prime, r$prime);
            throw new Error("Failed pattern match at Data.Map.Internal (line 811, column 5 - line 815, column 46): " + [
                v.value0.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 804, column 42 - line 815, column 46): " + [
            l.constructor.name,
            r.constructor.name
        ]);
    };
});
var $ea3eb84de0acf574$var$unsafeUnionWith = /* #__PURE__ */ $ea3eb84de0acf574$var$$lazy_unsafeUnionWith(803);
var $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeUnionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$722fbec263ad908a = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        var v2 = f(v.value3);
                        if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v2.value0, v.value4, v.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 531, column 11 - line 535, column 38): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 527, column 7 - line 535, column 38): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 524, column 8 - line 535, column 38): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$b072eafdc1d506c3 = function(dictShow) {
    var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show2 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        var go = function(ind) {
            return function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return ind + "Leaf";
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return ind + ("[" + ($ea3eb84de0acf574$var$show(v.value0) + ("] " + (show1(v.value2) + (" => " + (show2(v.value3) + "\x0a")))))) + (go(ind + "    ")(v.value4) + "\x0a" + go(ind + "    ")(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 233, column 12 - line 238, column 34): " + [
                    v.constructor.name
                ]);
            };
        };
        return go("");
    };
};
var $ea3eb84de0acf574$export$12ebb66e272c23f3 = function() {
    return function(dictOrd) {
        var unionWith1 = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
        return function(dictSemigroup) {
            return {
                append: unionWith1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $ea3eb84de0acf574$var$semigroupMap1 = /* #__PURE__ */ $ea3eb84de0acf574$export$12ebb66e272c23f3();
var $ea3eb84de0acf574$export$3e41007ebfff0e64 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(m) {
            var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
            return $ea3eb84de0acf574$var$map(function(a) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2));
            })(v.value0);
        };
    };
};
var $ea3eb84de0acf574$export$6a0d13241802fe80 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return false;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return true;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 459, column 7 - line 462, column 19): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 456, column 8 - line 462, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6be5ce76a5140a15 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v2 = f(v.value2)(v.value3);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v2.value0, go(v.value4), go(v.value5));
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 661, column 7 - line 665, column 47): " + [
                    v2.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 658, column 8 - line 665, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$e70771d2e7e590a = function(dictOrd) {
    var $780 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    return function($781) {
        return $780($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($781));
    };
};
var $ea3eb84de0acf574$export$6c45e13560e32a55 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 295, column 7 - line 302, column 38): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 292, column 8 - line 302, column 38): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$7b26f9c4323be72 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
                throw new Error("Failed pattern match at Data.Map.Internal (line 327, column 7 - line 333, column 42): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 324, column 8 - line 333, column 42): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dfc7155ac0343b8 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function($copy_v) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = compare(k)(v.value2);
                    if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                        $copy_v = v.value4;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                        $copy_v = v.value5;
                        return;
                    }
                    if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_done = true;
                        return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value3);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 283, column 7 - line 286, column 22): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 280, column 8 - line 286, column 22): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_v);
            return $tco_result;
        };
        return go;
    };
};
var $ea3eb84de0acf574$var$iterMapU = function(iter) {
    return function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return iter;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
            }
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
            return new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, new $ea3eb84de0acf574$var$IterNode(v.value5, iter)));
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 973, column 17 - line 988, column 56): " + [
            v.constructor.name
        ]);
    };
};
var $ea3eb84de0acf574$export$882785ec79906152 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapU);
var $ea3eb84de0acf574$var$stepUnfoldrUnordered = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$882785ec79906152(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$4e1300b52a76ba3a = function(dictUnfoldable) {
    var $782 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldrUnordered);
    return function($783) {
        return $782($ea3eb84de0acf574$export$a07cd7d770cb0fb3($783));
    };
};
var $ea3eb84de0acf574$export$b60b523eeb066dbd = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$882785ec79906152(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapR = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value4, iter));
                    $copy_v = v.value5;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 963, column 13 - line 970, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$dc5b2553d8583b72 = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapR);
var $ea3eb84de0acf574$export$cdc6b87d9fb979 = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$dc5b2553d8583b72(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$var$iterMapL = /* #__PURE__ */ function() {
    var go = function($copy_iter) {
        return function($copy_v) {
            var $tco_var_iter = $copy_iter;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(iter, v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                    $tco_done = true;
                    return iter;
                }
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, iter);
                        $copy_v = v.value4;
                        return;
                    }
                    $tco_var_iter = new $ea3eb84de0acf574$var$IterEmit(v.value2, v.value3, new $ea3eb84de0acf574$var$IterNode(v.value5, iter));
                    $copy_v = v.value4;
                    return;
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 951, column 13 - line 958, column 48): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_iter, $copy_v);
            return $tco_result;
        };
    };
    return go;
}();
var $ea3eb84de0acf574$export$273c44542cac8efe = /* #__PURE__ */ $ea3eb84de0acf574$var$stepWith($ea3eb84de0acf574$var$iterMapL);
var $ea3eb84de0acf574$export$3b67892037786a5b = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$273c44542cac8efe(function(k, v, next) {
        return new $ea3eb84de0acf574$export$e512af67edd28ac0(k, v, next);
    })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($ea3eb84de0acf574$export$4546c67049b8e195.value));
}();
var $ea3eb84de0acf574$export$4719e5aa2706059f = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(dictEq1) {
        var eq2 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq1);
        return {
            eq: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v2 = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                                if (v2 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && eq1(v.value0)(v2.value0) && eq2(v.value1)(v2.value1)) {
                                    $tco_var_a = v.value2;
                                    $copy_b = v2.value2;
                                    return;
                                }
                                $tco_done = true;
                                return false;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return true;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 859, column 14 - line 868, column 13): " + [
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }()
        };
    };
};
var $ea3eb84de0acf574$export$2b627c4f0ac5579b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$398604a469f7de9a(dictOrd1);
        var eqMapIter2 = eqMapIter1(dictOrd1.Eq0());
        return {
            compare: function() {
                var go = function($copy_a) {
                    return function($copy_b) {
                        var $tco_var_a = $copy_a;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(a, b) {
                            var v = $ea3eb84de0acf574$export$3b67892037786a5b(b);
                            var v1 = $ea3eb84de0acf574$export$3b67892037786a5b(a);
                            if (v1 instanceof $ea3eb84de0acf574$export$e512af67edd28ac0 && v instanceof $ea3eb84de0acf574$export$e512af67edd28ac0) {
                                var v3 = compare(v1.value0)(v.value0);
                                if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                    var v4 = compare1(v1.value1)(v.value1);
                                    if (v4 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                                        $tco_var_a = v1.value2;
                                        $copy_b = v.value2;
                                        return;
                                    }
                                    $tco_done = true;
                                    return v4;
                                }
                                $tco_done = true;
                                return v3;
                            }
                            if (v1 instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                    $tco_done = true;
                                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                                }
                                $tco_done = true;
                                return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                            }
                            if (v instanceof $ea3eb84de0acf574$export$4546c67049b8e195) {
                                $tco_done = true;
                                return $5026be88823ef1f4$export$b023c82b48e70453.value;
                            }
                            throw new Error("Failed pattern match at Data.Map.Internal (line 873, column 14 - line 891, column 11): " + [
                                v1.constructor.name,
                                v.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_a, $copy_b);
                        return $tco_result;
                    };
                };
                return go;
            }(),
            Eq0: function() {
                return eqMapIter2;
            }
        };
    };
};
var $ea3eb84de0acf574$var$stepUnfoldr = /* #__PURE__ */ function() {
    var step = function(k, v, next) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(k, v), next));
    };
    return $ea3eb84de0acf574$export$273c44542cac8efe(step)(function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
}();
var $ea3eb84de0acf574$export$823be24f8766da23 = function(dictUnfoldable) {
    var $784 = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)($ea3eb84de0acf574$var$stepUnfoldr);
    return function($785) {
        return $784($ea3eb84de0acf574$export$a07cd7d770cb0fb3($785));
    };
};
var $ea3eb84de0acf574$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $ea3eb84de0acf574$export$c448526daa762015 = function(dictShow) {
    var showTuple = $71f2e2e9476163f8$export$c29279d1dfdefb95(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(showTuple(dictShow1)));
        return {
            show: function(as) {
                return "(fromFoldable " + (show1($ea3eb84de0acf574$var$toUnfoldable1(as)) + ")");
            }
        };
    };
};
var $ea3eb84de0acf574$export$35d0420a84c5d3ae = function(dictOrd) {
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    return function(dictEq) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        var go = function(m1) {
            return function(m2) {
                if (m1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (m1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v1 = lookup1(m1.value2)(m2);
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return eq1(m1.value3)(v1.value0) && go(m1.value4)(m2) && go(m1.value5)(m2);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 611, column 7 - line 614, column 40): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 608, column 14 - line 614, column 40): " + [
                    m1.constructor.name
                ]);
            };
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$dd1bc94b04021eeb = function(v) {
    if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
    return false;
};
var $ea3eb84de0acf574$export$a6c74cde0675b326 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(m1) {
            return function(m2) {
                return $ea3eb84de0acf574$var$unsafeIntersectionWith(compare, app, m1, m2);
            };
        };
    };
};
var $ea3eb84de0acf574$export$bc86dfbf7795668c = function(dictOrd) {
    return $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca);
};
var $ea3eb84de0acf574$export$435aa68287e449bf = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(app) {
        return function(k) {
            return function(v) {
                var go = function(v1) {
                    if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                    if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        var v2 = compare(k)(v1.value2);
                        if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                        if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                        if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, app(v1.value3)(v), v1.value4, v1.value5);
                        throw new Error("Failed pattern match at Data.Map.Internal (line 486, column 7 - line 489, column 44): " + [
                            v2.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 483, column 8 - line 489, column 44): " + [
                        v1.constructor.name
                    ]);
                };
                return go;
            };
        };
    };
};
var $ea3eb84de0acf574$export$21a5ca8aa77d35ff = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        return function(v) {
            var go = function(v1) {
                if (v1 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$439306a4dcaafbb9(k)(v);
                if (v1 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                    var v2 = compare(k)(v1.value2);
                    if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, go(v1.value4), v1.value5);
                    if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v1.value2, v1.value3, v1.value4, go(v1.value5));
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v1.value0, v1.value1, k, v, v1.value4, v1.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 471, column 7 - line 474, column 35): " + [
                        v2.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Data.Map.Internal (line 468, column 8 - line 474, column 35): " + [
                    v1.constructor.name
                ]);
            };
            return go;
        };
    };
};
var $ea3eb84de0acf574$export$3930f636962ed944 = {
    map: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 147, column 10 - line 150, column 39): " + [
                v.constructor.name
            ]);
        };
        return go;
    }
};
var $ea3eb84de0acf574$export$d7c684e0b3e84e77 = {
    mapWithIndex: function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, f(v.value2)(v.value3), go(v.value4), go(v.value5));
            throw new Error("Failed pattern match at Data.Map.Internal (line 155, column 10 - line 158, column 41): " + [
                v.constructor.name
            ]);
        };
        return go;
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    }
};
var $ea3eb84de0acf574$export$4295a0c2ad7aa544 = {
    foldr: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(172)(m$prime.value4, f(m$prime.value3)($lazy_go(172)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 169, column 26 - line 172, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(169);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(178)(f($lazy_go(178)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 175, column 26 - line 178, column 43): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(175);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 181, column 10 - line 184, column 28): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    }
};
var $ea3eb84de0acf574$export$91e1c50dfb7225a6 = {
    foldrWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(m$prime, z$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(192)(m$prime.value4, f(m$prime.value2)(m$prime.value3)($lazy_go(192)(m$prime.value5, z$prime)));
                    throw new Error("Failed pattern match at Data.Map.Internal (line 189, column 26 - line 192, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(189);
            return function(m) {
                return go(m, z);
            };
        };
    },
    foldlWithIndex: function(f) {
        return function(z) {
            var $lazy_go = $ea3eb84de0acf574$var$$runtime_lazy("go", "Data.Map.Internal", function() {
                return function(z$prime, m$prime) {
                    if (m$prime instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return z$prime;
                    if (m$prime instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return $lazy_go(198)(f(m$prime.value2)($lazy_go(198)(z$prime, m$prime.value4))(m$prime.value3), m$prime.value5);
                    throw new Error("Failed pattern match at Data.Map.Internal (line 195, column 26 - line 198, column 45): " + [
                        m$prime.constructor.name
                    ]);
                };
            });
            var go = $lazy_go(195);
            return function(m) {
                return go(z, m);
            };
        };
    },
    foldMapWithIndex: function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return mempty;
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return append1(go(v.value4))(append1(f(v.value2)(v.value3))(go(v.value5)));
                throw new Error("Failed pattern match at Data.Map.Internal (line 201, column 10 - line 204, column 30): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    Foldable0: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    return $519ef1967f17d101$export$d859ed9adfa064ca($ea3eb84de0acf574$export$91e1c50dfb7225a6)(function(k) {
        return function(v) {
            return function(acc) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(k, acc);
            };
        };
    })($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$export$78146089411e393d = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 209, column 10 - line 215, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$df3f009e3d155b20($ea3eb84de0acf574$export$78146089411e393d)(dictApplicative)($ea3eb84de0acf574$var$identity);
    },
    Functor0: function() {
        return $ea3eb84de0acf574$export$3930f636962ed944;
    },
    Foldable1: function() {
        return $ea3eb84de0acf574$export$4295a0c2ad7aa544;
    }
};
var $ea3eb84de0acf574$export$8999febf5cd85b5c = {
    traverseWithIndex: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(f) {
            var go = function(v) {
                if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return pure($ea3eb84de0acf574$export$3024f3bfb62054a3.value);
                if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return apply(apply(map1(function(l$prime) {
                    return function(v$prime) {
                        return function(r$prime) {
                            return new $ea3eb84de0acf574$export$85c928794f8d04d4(v.value0, v.value1, v.value2, v$prime, l$prime, r$prime);
                        };
                    };
                })(go(v.value4)))(f(v.value2)(v.value3)))(go(v.value5));
                throw new Error("Failed pattern match at Data.Map.Internal (line 221, column 10 - line 227, column 19): " + [
                    v.constructor.name
                ]);
            };
            return go;
        };
    },
    FunctorWithIndex0: function() {
        return $ea3eb84de0acf574$export$d7c684e0b3e84e77;
    },
    FoldableWithIndex1: function() {
        return $ea3eb84de0acf574$export$91e1c50dfb7225a6;
    },
    Traversable2: function() {
        return $ea3eb84de0acf574$export$78146089411e393d;
    }
};
var $ea3eb84de0acf574$export$68c286be0e7e55b7 = /* #__PURE__ */ function() {
    return $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($ea3eb84de0acf574$export$4295a0c2ad7aa544)($78c799cba34fcb8d$export$74c44e616647f5c0.create)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $ea3eb84de0acf574$var$foldSubmapBy = function(dictOrd) {
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(dictOrd);
    return function(appendFn) {
        return function(memptyValue) {
            return function(kmin) {
                return function(kmax) {
                    return function(f) {
                        var tooSmall = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThan1(k)(kmin.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 389, column 7 - line 393, column 22): " + [
                                kmin.constructor.name
                            ]);
                        }();
                        var tooLarge = function() {
                            if (kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return greaterThan1(k)(kmax.value0);
                            };
                            if (kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(false);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 396, column 7 - line 400, column 22): " + [
                                kmax.constructor.name
                            ]);
                        }();
                        var inBounds = function() {
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k) && lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return function(k) {
                                return lessThanOrEq1(kmin.value0)(k);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return function(k) {
                                return lessThanOrEq1(k)(kmax.value0);
                            };
                            if (kmin instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && kmax instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(true);
                            throw new Error("Failed pattern match at Data.Map.Internal (line 403, column 7 - line 411, column 21): " + [
                                kmin.constructor.name,
                                kmax.constructor.name
                            ]);
                        }();
                        var go = function(v) {
                            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return memptyValue;
                            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return appendFn(appendFn(function() {
                                var $643 = tooSmall(v.value2);
                                if ($643) return memptyValue;
                                return go(v.value4);
                            }())(function() {
                                var $644 = inBounds(v.value2);
                                if ($644) return f(v.value2)(v.value3);
                                return memptyValue;
                            }()))(function() {
                                var $645 = tooLarge(v.value2);
                                if ($645) return memptyValue;
                                return go(v.value5);
                            }());
                            throw new Error("Failed pattern match at Data.Map.Internal (line 413, column 10 - line 419, column 66): " + [
                                v.constructor.name
                            ]);
                        };
                        return go;
                    };
                };
            };
        };
    };
};
var $ea3eb84de0acf574$export$3f9a381f67a51fcd = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    return function(dictMonoid) {
        return foldSubmapBy1($d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0()))($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid));
    };
};
var $ea3eb84de0acf574$export$3c39a95b7a4d5e28 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value4;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 361, column 11 - line 366, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$211c88c643c40f46 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) {
                    var v2 = go(v.value4);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return go(v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$3c39a95b7a4d5e28(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 342, column 7 - line 348, column 25): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 339, column 8 - line 348, column 25): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$35f577b3da447d17 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                $tco_done = true;
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    key: v.value2,
                    value: v.value3
                });
            }
            $copy_v = v.value5;
            return;
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 352, column 11 - line 357, column 21): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $ea3eb84de0acf574$export$9318a1f920537b0d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return go(v.value4);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) {
                    var v2 = go(v.value5);
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        key: v.value2,
                        value: v.value3
                    });
                    return v2;
                }
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$35f577b3da447d17(v.value4);
                throw new Error("Failed pattern match at Data.Map.Internal (line 311, column 7 - line 318, column 21): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 308, column 8 - line 318, column 21): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$d7a60370122a9ab0 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)(v.value3)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 627, column 8 - line 633, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$151f9a87a7fd5652 = function(dictOrd) {
    return function(f) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (f(v.value2)) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), go(v.value5));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $ea3eb84de0acf574$export$76d750f4290aa12(go(v.value4), go(v.value5));
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 640, column 8 - line 646, column 47): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$3dea766d36a8935f = function(dictOrd) {
    var $786 = $ea3eb84de0acf574$export$d7a60370122a9ab0(dictOrd);
    return function($787) {
        return $786($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($787));
    };
};
var $ea3eb84de0acf574$export$85aac4508ff70b8 = function(dictEq) {
    var eqMapIter1 = $ea3eb84de0acf574$export$4719e5aa2706059f(dictEq);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(eqMapIter1(dictEq1));
        return {
            eq: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                        return false;
                    }
                    if (xs instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                        if (ys instanceof $ea3eb84de0acf574$export$85c928794f8d04d4 && xs.value1 === ys.value1) return eq1($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                        return false;
                    }
                    throw new Error("Failed pattern match at Data.Map.Internal (line 94, column 14 - line 105, column 16): " + [
                        xs.constructor.name
                    ]);
                };
            }
        };
    };
};
var $ea3eb84de0acf574$export$3d0d4caf881d6855 = function(dictOrd) {
    var ordMapIter1 = $ea3eb84de0acf574$export$2b627c4f0ac5579b(dictOrd);
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(ordMapIter1(dictOrd1));
        var eqMap2 = eqMap1(dictOrd1.Eq0());
        return {
            compare: function(xs) {
                return function(ys) {
                    if (xs instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                        if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                        return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                    }
                    if (ys instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                    return compare($ea3eb84de0acf574$export$a07cd7d770cb0fb3(xs))($ea3eb84de0acf574$export$a07cd7d770cb0fb3(ys));
                };
            },
            Eq0: function() {
                return eqMap2;
            }
        };
    };
};
var $ea3eb84de0acf574$export$e321b34a2787dc8d = function(dictEq) {
    var eqMap1 = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqMap1(dictEq1));
        }
    };
};
var $ea3eb84de0acf574$export$e2f3c1862bab1bff = function(dictOrd) {
    var ordMap1 = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    var eq1Map1 = $ea3eb84de0acf574$export$e321b34a2787dc8d(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordMap1(dictOrd1));
        },
        Eq10: function() {
            return eq1Map1;
        }
    };
};
var $ea3eb84de0acf574$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
}();
var $ea3eb84de0acf574$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(function(m) {
            return function(v) {
                return insert1(v.value0)(v.value1)(m);
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$690be49d504fc7f = function(dictOrd) {
    var insertWith1 = $ea3eb84de0acf574$export$435aa68287e449bf(dictOrd);
    return function(dictFoldable) {
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        return function(f) {
            var f$prime = insertWith1($f57f4b701aa7b66e$export$8a83211c878a3f1f(f));
            return foldl(function(m) {
                return function(v) {
                    return f$prime(v.value0)(v.value1)(m);
                };
            })($ea3eb84de0acf574$export$6e22c362a0406a2c);
        };
    };
};
var $ea3eb84de0acf574$export$78cfe3464e7eb77b = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(dictFoldableWithIndex) {
        return $519ef1967f17d101$export$2d70b9efb960f478(dictFoldableWithIndex)(function(k) {
            return function(m) {
                return function(v) {
                    return insert1(k)(v)(m);
                };
            };
        })($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$546d2468bc9efbc6 = function() {
    return function(dictOrd) {
        var semigroupMap2 = $ea3eb84de0acf574$var$semigroupMap1(dictOrd);
        return function(dictSemigroup) {
            var semigroupMap3 = semigroupMap2(dictSemigroup);
            return {
                mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                Semigroup0: function() {
                    return semigroupMap3;
                }
            };
        };
    };
};
var $ea3eb84de0acf574$export$d6b4f308683e59db = function(dictOrd) {
    var foldSubmapBy1 = $ea3eb84de0acf574$var$foldSubmapBy(dictOrd);
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(kmin) {
        return function(kmax) {
            return foldSubmapBy1(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c)(kmin)(kmax)($ea3eb84de0acf574$export$439306a4dcaafbb9);
        };
    };
};
var $ea3eb84de0acf574$export$30b2db2f7030f6cf = function(dictOrd) {
    var union1 = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    return function(dictFoldable) {
        return $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable)(union1)($ea3eb84de0acf574$export$6e22c362a0406a2c);
    };
};
var $ea3eb84de0acf574$export$acaf96a27438246b = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(m1) {
        return function(m2) {
            return $ea3eb84de0acf574$var$unsafeDifference(compare, m1, m2);
        };
    };
};
var $ea3eb84de0acf574$export$1822828d790e23ee = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(k) {
        var go = function(v) {
            if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return $ea3eb84de0acf574$export$3024f3bfb62054a3.value;
            if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                var v1 = compare(k)(v.value2);
                if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, go(v.value4), v.value5);
                if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $ea3eb84de0acf574$export$807b724170e609fd(v.value2, v.value3, v.value4, go(v.value5));
                if (v1 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value4, v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 498, column 7 - line 501, column 43): " + [
                    v1.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 495, column 8 - line 501, column 43): " + [
                v.constructor.name
            ]);
        };
        return go;
    };
};
var $ea3eb84de0acf574$export$6583e3e95cb5e9d1 = function(dictOrd) {
    var greaterThan1 = $97937c29f879e68e$export$f517ea36c68d4644(dictOrd);
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(dictOrd);
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
            if (v.value4 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return true;
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 === 2 && v.value5.value0 === 1 && v.value1 > v.value5.value1 && greaterThan1(v.value5.value2)(v.value2) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 264, column 11 - line 268, column 60): " + [
                    v.value5.constructor.name
                ]);
            }
            if (v.value4 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) {
                if (v.value5 instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return v.value0 === 2 && v.value4.value0 === 1 && v.value1 > v.value4.value1 && lessThan1(v.value4.value2)(v.value2) && go(v.value4);
                if (v.value5 instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return v.value0 > v.value5.value0 && greaterThan1(v.value5.value2)(v.value2) && v.value0 > v.value4.value0 && lessThan1(v.value4.value2)(v.value2) && $ea3eb84de0acf574$var$abs(v.value5.value0 - v.value4.value0 | 0) < 2 && ((v.value5.value1 + v.value4.value1 | 0) + 1 | 0) === v.value1 && go(v.value4) && go(v.value5);
                throw new Error("Failed pattern match at Data.Map.Internal (line 270, column 11 - line 274, column 108): " + [
                    v.value5.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Data.Map.Internal (line 262, column 7 - line 274, column 108): " + [
                v.value4.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Data.Map.Internal (line 259, column 8 - line 274, column 108): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$986c2bbe7a34be0b = function(dictOrd) {
    return $ea3eb84de0acf574$export$e70771d2e7e590a(dictOrd)($ea3eb84de0acf574$var$identity);
};
var $ea3eb84de0acf574$export$8952a3dc6f3cd264 = function(dictOrd) {
    return {
        apply: $ea3eb84de0acf574$export$a6c74cde0675b326(dictOrd)($ea3eb84de0acf574$var$identity),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$886591aa0ffe34d5 = function(dictOrd) {
    var mapMaybeWithKey1 = $ea3eb84de0acf574$export$6be5ce76a5140a15(dictOrd);
    var lookup1 = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    var applyMap1 = $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
    return {
        bind: function(m) {
            return function(f) {
                return mapMaybeWithKey1(function(k) {
                    var $788 = lookup1(k);
                    return function($789) {
                        return $788(f($789));
                    };
                })(m);
            };
        },
        Apply0: function() {
            return applyMap1;
        }
    };
};
var $ea3eb84de0acf574$export$2fa1dac9e337f670 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value2)(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 693, column 8 - line 695, column 62): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$4154a199d7d90455 = function(predicate) {
    var go = function(v) {
        if (v instanceof $ea3eb84de0acf574$export$3024f3bfb62054a3) return false;
        if (v instanceof $ea3eb84de0acf574$export$85c928794f8d04d4) return predicate(v.value3) || go(v.value4) || go(v.value5);
        throw new Error("Failed pattern match at Data.Map.Internal (line 683, column 8 - line 685, column 58): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $ea3eb84de0acf574$export$22a7378e1d3307a4 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    return function(f) {
        return function(k) {
            return function(m) {
                var v = $ea3eb84de0acf574$export$9827c6ff7b07c8a4(compare, k, m);
                var v2 = f(v.value0);
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $ea3eb84de0acf574$export$76d750f4290aa12(v.value1, v.value2);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $ea3eb84de0acf574$export$807b724170e609fd(k, v2.value0, v.value1, v.value2);
                throw new Error("Failed pattern match at Data.Map.Internal (line 514, column 3 - line 518, column 41): " + [
                    v2.constructor.name
                ]);
            };
        };
    };
};
var $ea3eb84de0acf574$export$9030392ec4d635ff = function(dictOrd) {
    return {
        alt: $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd),
        Functor0: function() {
            return $ea3eb84de0acf574$export$3930f636962ed944;
        }
    };
};
var $ea3eb84de0acf574$export$4c085c510196daa3 = function(dictOrd) {
    var altMap1 = $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
    return {
        empty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        Alt0: function() {
            return altMap1;
        }
    };
};




// Generated by purs version 0.15.16













var $a393155e52307a24$var$coerce = /* #__PURE__ */ $a4e6c090e9e673b6$export$8c14e57e778d3873();
var $a393155e52307a24$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $a393155e52307a24$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $a393155e52307a24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $a393155e52307a24$var$$$Set = function(x) {
    return x;
};
var $a393155e52307a24$export$971dd5b0dfd021b6 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd));
};
var $a393155e52307a24$export$e03c1c3201ee8bb7 = function(dictOrd) {
    var alter = $ea3eb84de0acf574$export$22a7378e1d3307a4(dictOrd);
    return function(a) {
        return function(v) {
            return alter($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342))(function(v1) {
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }))(a)(v);
        };
    };
};
var $a393155e52307a24$export$e98af36a72b77685 = function(v) {
    return v;
};
var $a393155e52307a24$var$toList = function(v) {
    return $ea3eb84de0acf574$export$ed97f33186d4b816(v);
};
var $a393155e52307a24$export$823be24f8766da23 = function(dictUnfoldable) {
    var $96 = $3d4fd987da5242ff$export$823be24f8766da23(dictUnfoldable);
    return function($97) {
        return $96($a393155e52307a24$var$toList($97));
    };
};
var $a393155e52307a24$var$toUnfoldable1 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $a393155e52307a24$export$346677f925de839c = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$346677f925de839c);
var $a393155e52307a24$export$439306a4dcaafbb9 = function(a) {
    return $ea3eb84de0acf574$export$439306a4dcaafbb9(a)($05149ea687d6b460$export$523c0b569236b342);
};
var $a393155e52307a24$export$10430edbe04e7f5c = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$5bda33a3389a7225(dictShow));
    return {
        show: function(s) {
            return "(fromFoldable " + (show($a393155e52307a24$var$toUnfoldable1(s)) + ")");
        }
    };
};
var $a393155e52307a24$export$7c6a06df4f9b9fb3 = function(dictOrd) {
    return {
        append: $a393155e52307a24$export$971dd5b0dfd021b6(dictOrd)
    };
};
var $a393155e52307a24$export$6a0d13241802fe80 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6a0d13241802fe80(dictOrd));
};
var $a393155e52307a24$export$dd1bc94b04021eeb = /* #__PURE__ */ $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$dd1bc94b04021eeb);
var $a393155e52307a24$export$bc86dfbf7795668c = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$bc86dfbf7795668c(dictOrd));
};
var $a393155e52307a24$export$21a5ca8aa77d35ff = function(dictOrd) {
    var insert1 = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(a) {
        return function(v) {
            return insert1(a)($05149ea687d6b460$export$523c0b569236b342)(v);
        };
    };
};
var $a393155e52307a24$export$d81aa96f14f987cc = $a393155e52307a24$var$$$Set;
var $a393155e52307a24$export$fd19c21b7e75dff0 = {
    foldMap: function(dictMonoid) {
        var foldMap1 = $a393155e52307a24$var$foldMap(dictMonoid);
        return function(f) {
            var $98 = foldMap1(f);
            return function($99) {
                return $98($a393155e52307a24$var$toList($99));
            };
        };
    },
    foldl: function(f) {
        return function(x) {
            var $100 = $a393155e52307a24$var$foldl(f)(x);
            return function($101) {
                return $100($a393155e52307a24$var$toList($101));
            };
        };
    },
    foldr: function(f) {
        return function(x) {
            var $102 = $a393155e52307a24$var$foldr(f)(x);
            return function($103) {
                return $102($a393155e52307a24$var$toList($103));
            };
        };
    }
};
var $a393155e52307a24$var$foldl1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$var$foldr1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($a393155e52307a24$export$fd19c21b7e75dff0);
var $a393155e52307a24$export$3c39a95b7a4d5e28 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$3c39a95b7a4d5e28(v));
};
var $a393155e52307a24$export$35f577b3da447d17 = function(v) {
    return $a393155e52307a24$var$map1(function(v1) {
        return v1.key;
    })($ea3eb84de0acf574$export$35f577b3da447d17(v));
};
var $a393155e52307a24$export$3dea766d36a8935f = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$151f9a87a7fd5652(dictOrd));
};
var $a393155e52307a24$export$15038a5bf6277d57 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($ea3eb84de0acf574$export$85aac4508ff70b8(dictEq)($37b880af5f4991bd$export$671c8820f3b36bad));
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v)(v1);
            };
        }
    };
};
var $a393155e52307a24$export$273c875222ee923d = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd));
    var eqSet1 = $a393155e52307a24$export$15038a5bf6277d57(dictOrd.Eq0());
    return {
        compare: function(s1) {
            return function(s2) {
                return compare($a393155e52307a24$var$toList(s1))($a393155e52307a24$var$toList(s2));
            };
        },
        Eq0: function() {
            return eqSet1;
        }
    };
};
var $a393155e52307a24$export$886f72205c1e73dc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($a393155e52307a24$export$15038a5bf6277d57(dictEq));
    }
};
var $a393155e52307a24$export$3f209a28ab615424 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($a393155e52307a24$export$273c875222ee923d(dictOrd));
    },
    Eq10: function() {
        return $a393155e52307a24$export$886f72205c1e73dc;
    }
};
var $a393155e52307a24$export$6e22c362a0406a2c = $ea3eb84de0acf574$export$6e22c362a0406a2c;
var $a393155e52307a24$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
        return foldl2(function(m) {
            return function(a) {
                return insert1(a)(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$871de8747c9eaa88 = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldl1(function(m) {
            return function(a) {
                return insert1(f(a))(m);
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$e70771d2e7e590a = function(dictOrd) {
    var insert1 = $a393155e52307a24$export$21a5ca8aa77d35ff(dictOrd);
    return function(f) {
        return $a393155e52307a24$var$foldr1(function(a) {
            return function(acc) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(acc)(function(b) {
                    return insert1(b)(acc);
                })(f(a));
            };
        })($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$30c0d87180d1a2c7 = function(dictOrd) {
    var semigroupSet1 = $a393155e52307a24$export$7c6a06df4f9b9fb3(dictOrd);
    return {
        mempty: $a393155e52307a24$export$6e22c362a0406a2c,
        Semigroup0: function() {
            return semigroupSet1;
        }
    };
};
var $a393155e52307a24$export$30b2db2f7030f6cf = function(dictFoldable) {
    var foldl2 = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    return function(dictOrd) {
        return foldl2($a393155e52307a24$export$971dd5b0dfd021b6(dictOrd))($a393155e52307a24$export$6e22c362a0406a2c);
    };
};
var $a393155e52307a24$export$acaf96a27438246b = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$acaf96a27438246b(dictOrd));
};
var $a393155e52307a24$export$e06bd7b1ab877a71 = function(dictOrd) {
    var difference1 = $a393155e52307a24$export$acaf96a27438246b(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$dd1bc94b04021eeb(difference1(s1)(s2));
        };
    };
};
var $a393155e52307a24$export$fed8bbb04775a01f = function(dictOrd) {
    var subset1 = $a393155e52307a24$export$e06bd7b1ab877a71(dictOrd);
    return function(s1) {
        return function(s2) {
            return $a393155e52307a24$export$346677f925de839c(s1) !== $a393155e52307a24$export$346677f925de839c(s2) && subset1(s1)(s2);
        };
    };
};
var $a393155e52307a24$export$1822828d790e23ee = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$1822828d790e23ee(dictOrd));
};
var $a393155e52307a24$export$6583e3e95cb5e9d1 = function(dictOrd) {
    return $a393155e52307a24$var$coerce($ea3eb84de0acf574$export$6583e3e95cb5e9d1(dictOrd));
};
var $a393155e52307a24$export$986c2bbe7a34be0b = function(dictOrd) {
    return $a393155e52307a24$export$e70771d2e7e590a(dictOrd)($a393155e52307a24$var$identity);
};


// Generated by purs version 0.15.16
/* global Symbol */ var $bfc50dc5547207b7$var$hasArrayFrom = typeof Array.from === "function";
var $bfc50dc5547207b7$var$hasStringIterator = typeof Symbol !== "undefined" && Symbol != null && typeof Symbol.iterator !== "undefined" && typeof String.prototype[Symbol.iterator] === "function";
var $bfc50dc5547207b7$var$hasFromCodePoint = typeof String.prototype.fromCodePoint === "function";
var $bfc50dc5547207b7$var$hasCodePointAt = typeof String.prototype.codePointAt === "function";
const $bfc50dc5547207b7$export$81daff3801c9c982 = function(fallback) {
    return $bfc50dc5547207b7$var$hasCodePointAt ? function(str) {
        return str.codePointAt(0);
    } : fallback;
};
const $bfc50dc5547207b7$export$5f0398d7608003c3 = function(fallback) {
    return function(Just) {
        return function(Nothing) {
            return function(unsafeCodePointAt0) {
                return function(index) {
                    return function(str) {
                        var length = str.length;
                        if (index < 0 || index >= length) return Nothing;
                        if ($bfc50dc5547207b7$var$hasStringIterator) {
                            var iter = str[Symbol.iterator]();
                            for(var i = index;; --i){
                                var o = iter.next();
                                if (o.done) return Nothing;
                                if (i === 0) return Just(unsafeCodePointAt0(o.value));
                            }
                        }
                        return fallback(index)(str);
                    };
                };
            };
        };
    };
};
const $bfc50dc5547207b7$export$2964bc4d0a1ede06 = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(pred) {
            return function(str) {
                var iter = str[Symbol.iterator]();
                for(var cpCount = 0;; ++cpCount){
                    var o = iter.next();
                    if (o.done) return cpCount;
                    var cp = unsafeCodePointAt0(o.value);
                    if (!pred(cp)) return cpCount;
                }
            };
        };
        return fallback;
    };
};
const $bfc50dc5547207b7$export$c41b441de25e3d55 = function(singleton) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? function(cps) {
        // Function.prototype.apply will fail for very large second parameters,
        // so we don't use it for arrays with 10,000 or more entries.
        if (cps.length < 10e3) return String.fromCodePoint.apply(String, cps);
        return cps.map(singleton).join("");
    } : function(cps) {
        return cps.map(singleton).join("");
    };
};
const $bfc50dc5547207b7$export$ecb7b38eca4fe9ff = function(fallback) {
    return $bfc50dc5547207b7$var$hasFromCodePoint ? String.fromCodePoint : fallback;
};
const $bfc50dc5547207b7$export$6d9af221d75dd06f = function(fallback) {
    return function(n) {
        if ($bfc50dc5547207b7$var$hasStringIterator) return function(str) {
            var accum = "";
            var iter = str[Symbol.iterator]();
            for(var i = 0; i < n; ++i){
                var o = iter.next();
                if (o.done) return accum;
                accum += o.value;
            }
            return accum;
        };
        return fallback(n);
    };
};
const $bfc50dc5547207b7$export$c61d72f8b05641be = function(fallback) {
    return function(unsafeCodePointAt0) {
        if ($bfc50dc5547207b7$var$hasArrayFrom) return function(str) {
            return Array.from(str, unsafeCodePointAt0);
        };
        return fallback;
    };
};





// Generated by purs version 0.15.16
function $1cf1b1293ed20ecf$export$d90166409dd04e85(c) {
    return c.charCodeAt(0);
}
function $1cf1b1293ed20ecf$export$30216c0101da0ee0(c) {
    return String.fromCharCode(c);
}


// Generated by purs version 0.15.16






var $f1992c51575cdea6$export$864d727b48066337 = function(dictAlternative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
    return function(v) {
        if (v) return pure($05149ea687d6b460$export$523c0b569236b342);
        if (!v) return empty;
        throw new Error("Failed pattern match at Control.Alternative (line 48, column 1 - line 48, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $f1992c51575cdea6$export$5e87c78e215371ee = {
    Applicative0: function() {
        return $c50cfdb0b9e8fa31$export$8f0ac76856b1d87e;
    },
    Plus1: function() {
        return $7abe8fbe97ebda87$export$b7c99dd4fc96d90e;
    }
};


















var $f935a9866e211c00$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7576d3a958d66ab0$export$2f68caa5c730775d);
var $f935a9866e211c00$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $f935a9866e211c00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$top = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$c84fa7e5ca2385dd);
var $f935a9866e211c00$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $f935a9866e211c00$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $f935a9866e211c00$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($06733ae99ed4f534$export$92d23d3d8fa78a80);
var $f935a9866e211c00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $f935a9866e211c00$var$bottom1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$var$top1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79);
var $f935a9866e211c00$export$a3fdfde49d86b899 = function(x) {
    return x;
};
var $f935a9866e211c00$export$45328c01562fb205 = function(dict) {
    return dict.toEnum;
};
var $f935a9866e211c00$export$61d85e1612867711 = function(dict) {
    return dict.succ;
};
var $f935a9866e211c00$export$f55455e25c350f35 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(succ1));
    };
};
var $f935a9866e211c00$export$3d0bc2efe492e4f7 = {
    show: function(v) {
        return "(Cardinality " + ($f935a9866e211c00$var$show(v) + ")");
    }
};
var $f935a9866e211c00$export$c238ae40a8cccc17 = function(dict) {
    return dict.pred;
};
var $f935a9866e211c00$export$68d5f1a472f8251a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $f935a9866e211c00$export$d3d8047a35329ac2 = {
    Coercible0: function() {
        return undefined;
    }
};
var $f935a9866e211c00$export$b385cb642735011f = function(dict) {
    return dict.fromEnum;
};
var $f935a9866e211c00$export$1e2c188a485bdeae = function(dictBoundedEnum) {
    var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
    var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    return function(low) {
        return function(high) {
            return function(x) {
                var v = toEnum1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    var $140 = x < fromEnum1(bottom2);
                    if ($140) return low;
                    return high;
                }
                throw new Error("Failed pattern match at Data.Enum (line 158, column 33 - line 160, column 62): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$63b732e1f89f043e = $37b880af5f4991bd$export$e65788c6d4494539;
var $f935a9866e211c00$export$c0a99362196d7617 = /* #__PURE__ */ function() {
    return {
        succ: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        pred: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Ord0: function() {
            return $97937c29f879e68e$export$f6b429625e3530b0;
        }
    };
}();
var $f935a9866e211c00$export$51ea709069e9f759 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var ordTuple = $71f2e2e9476163f8$export$8f11eb03746a66e2(dictEnum.Ord0());
    return function(dictBoundedEnum) {
        var Bounded0 = dictBoundedEnum.Bounded0();
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(Bounded0);
        var Enum1 = dictBoundedEnum.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(Bounded0);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var ordTuple1 = ordTuple(Enum1.Ord0());
        return {
            succ: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(bottom2))(succ1(v.value0)))(function() {
                    var $183 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($184) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($183($184));
                    };
                }())(succ2(v.value1));
            },
            pred: function(v) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($f935a9866e211c00$var$map($f57f4b701aa7b66e$export$8a83211c878a3f1f($71f2e2e9476163f8$export$1908877435b1d5e9.create)(top2))(pred1(v.value0)))(function() {
                    var $185 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v.value0);
                    return function($186) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create($185($186));
                    };
                }())(pred2(v.value1));
            },
            Ord0: function() {
                return ordTuple1;
            }
        };
    };
};
var $f935a9866e211c00$export$94be50e509bf721a = {
    succ: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    pred: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        throw new Error("Failed pattern match at Data.Enum (line 72, column 1 - line 78, column 20): " + [
            v.constructor.name
        ]);
    },
    Ord0: function() {
        return $97937c29f879e68e$export$dcb5533042a37f3c;
    }
};
var $f935a9866e211c00$export$4d9047d2b06c2498 = function(dictBoundedEnum) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum.Bounded0());
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var ordMaybe = $06733ae99ed4f534$export$e35c29f98d259c46(Enum1.Ord0());
    return {
        succ: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $06733ae99ed4f534$export$8a67b48435b5d073(bottom2));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $f935a9866e211c00$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(succ1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        pred: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(pred1(v.value0));
            throw new Error("Failed pattern match at Data.Enum (line 80, column 1 - line 84, column 32): " + [
                v.constructor.name
            ]);
        },
        Ord0: function() {
            return ordMaybe;
        }
    };
};
var $f935a9866e211c00$export$f8cd1ff55b5d915b = {
    succ: function(n) {
        var $153 = n < $f935a9866e211c00$var$top;
        if ($153) return new $06733ae99ed4f534$export$8a67b48435b5d073(n + 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(n) {
        var $154 = n > $f935a9866e211c00$var$bottom;
        if ($154) return new $06733ae99ed4f534$export$8a67b48435b5d073(n - 1 | 0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ff461bf68e7dd332;
    }
};
var $f935a9866e211c00$export$51bf4ec4e9fd2fba = function(dictEnum) {
    var Ord0 = dictEnum.Ord0();
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(Ord0.Eq0());
    var lessThan1 = $97937c29f879e68e$export$9b050841a3a1b328(Ord0);
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    var lessThanOrEq1 = $97937c29f879e68e$export$f0c1dc893917aeba(Ord0);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var greaterThanOrEq1 = $97937c29f879e68e$export$4be320a4fd1ac499(Ord0);
    return function(dictUnfoldable1) {
        var singleton = $cf5af1199a495394$export$439306a4dcaafbb9(dictUnfoldable1);
        var unfoldr1 = $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1);
        var go = function(step) {
            return function(op) {
                return function(to) {
                    return function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, $f935a9866e211c00$var$bind(step(a))(function(a$prime) {
                            return $f935a9866e211c00$var$voidLeft($f935a9866e211c00$var$guard(op(a$prime)(to)))(a$prime);
                        }));
                    };
                };
            };
        };
        return function(v) {
            return function(v1) {
                if (eq1(v)(v1)) return singleton(v);
                if (lessThan1(v)(v1)) return unfoldr1(go(succ1)(lessThanOrEq1)(v1))(v);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return unfoldr1(go(pred1)(greaterThanOrEq1)(v1))(v);
                throw new Error("Failed pattern match at Data.Enum (line 186, column 14 - line 190, column 51): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $f935a9866e211c00$export$c023000aca534be0 = function(dictUnfoldable) {
    var unfoldr = $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable);
    return function(dictFunctor) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictBoundedEnum) {
            var fromEnum1 = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
            var toEnum1 = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
            var go = function(step) {
                return function(to) {
                    return function(e) {
                        if (e <= to) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(e, e + step | 0));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Data.Enum (line 217, column 5 - line 219, column 28): " + [
                            step.constructor.name,
                            to.constructor.name,
                            e.constructor.name
                        ]);
                    };
                };
            };
            return function(a) {
                return function(b) {
                    return function(c) {
                        var c$prime = fromEnum1(c);
                        var b$prime = fromEnum1(b);
                        var a$prime = fromEnum1(a);
                        return map1(function($187) {
                            return $f935a9866e211c00$var$fromJust(toEnum1($187));
                        })(unfoldr(go(b$prime - a$prime | 0)(c$prime))(a$prime));
                    };
                };
            };
        };
    };
};
var $f935a9866e211c00$export$3733bec825dc17c = function(dictBoundedEnum) {
    var Enum1 = dictBoundedEnum.Enum1();
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(Enum1);
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
    var top2 = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBoundedEnum.Bounded0());
    var ordEither = $7d4cccdf062a2261$export$f105364bfbaa033b(Enum1.Ord0());
    return function(dictBoundedEnum1) {
        var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBoundedEnum1.Bounded0());
        var Enum11 = dictBoundedEnum1.Enum1();
        var succ2 = $f935a9866e211c00$export$61d85e1612867711(Enum11);
        var pred2 = $f935a9866e211c00$export$c238ae40a8cccc17(Enum11);
        var ordEither1 = ordEither(Enum11.Ord0());
        return {
            succ: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$19db0165690c701a(bottom2)))(function($188) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($188));
                })(succ1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($189) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($189));
                })(succ2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            pred: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($06733ae99ed4f534$export$bebe9059409a0d04.value)(function($190) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($190));
                })(pred1(v.value0));
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$37c4d04eafdc5515(top2)))(function($191) {
                    return $06733ae99ed4f534$export$8a67b48435b5d073.create($7d4cccdf062a2261$export$19db0165690c701a.create($191));
                })(pred2(v.value0));
                throw new Error("Failed pattern match at Data.Enum (line 86, column 1 - line 90, column 69): " + [
                    v.constructor.name
                ]);
            },
            Ord0: function() {
                return ordEither1;
            }
        };
    };
};
var $f935a9866e211c00$export$6670eb63482acbe8 = {
    succ: function(v) {
        if (!v) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    pred: function(v) {
        if (v) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    Ord0: function() {
        return $97937c29f879e68e$export$ef759d57a4e44836;
    }
};
var $f935a9866e211c00$export$ab0f40ba1313e2bb = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable1) {
        return $cf5af1199a495394$export$158c052536266a97(dictUnfoldable1)($f935a9866e211c00$var$apply($71f2e2e9476163f8$export$1908877435b1d5e9.create)(pred1));
    };
};
var $f935a9866e211c00$var$diag = function(a) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, a);
};
var $f935a9866e211c00$export$c0c53cc9a0565905 = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $192 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($193) {
                return $192(pred1($193));
            };
        }());
    };
};
var $f935a9866e211c00$export$556edd6c9fb1e655 = function(dictEnum) {
    var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
    return function(dictUnfoldable) {
        return $cb5fedc2c4837e1c$export$df2b8ee1690308ae(dictUnfoldable)(function() {
            var $194 = $f935a9866e211c00$var$map($f935a9866e211c00$var$diag);
            return function($195) {
                return $194(succ1($195));
            };
        }());
    };
};
var $f935a9866e211c00$export$9263b51426343c61 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        return function(i$prime) {
            var go = function($copy_i) {
                return function($copy_x) {
                    var $tco_var_i = $copy_i;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(i, x) {
                        var $168 = i === 0;
                        if ($168) {
                            $tco_done = true;
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(x);
                        }
                        var v = succ1(x);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_i = i - 1 | 0;
                            $copy_x = v.value0;
                            return;
                        }
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        }
                        throw new Error("Failed pattern match at Data.Enum (line 296, column 12 - line 298, column 33): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                    return $tco_result;
                };
            };
            var $171 = i$prime < 0;
            if ($171) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return go(i$prime)(bottom2);
        };
    };
};
var $f935a9866e211c00$export$11e799785deb08e4 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) + 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$dc42af8461b24233 = function(toEnum$prime) {
    return function(fromEnum$prime) {
        return function(a) {
            return toEnum$prime(fromEnum$prime(a) - 1 | 0);
        };
    };
};
var $f935a9866e211c00$export$21fa49008ecbb00a = function(dictEnum) {
    var pred1 = $f935a9866e211c00$export$c238ae40a8cccc17(dictEnum);
    var go = function($copy_i) {
        return function($copy_x) {
            var $tco_var_i = $copy_i;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(i, x) {
                var v = pred1(x);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_var_i = i + 1 | 0;
                    $copy_x = v.value0;
                    return;
                }
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return i;
                }
                throw new Error("Failed pattern match at Data.Enum (line 309, column 5 - line 311, column 19): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
            return $tco_result;
        };
    };
    return go(0);
};
var $f935a9866e211c00$export$18eeb03d5b80a339 = function(dictBounded) {
    var bottom2 = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    return function(dictEnum) {
        var succ1 = $f935a9866e211c00$export$61d85e1612867711(dictEnum);
        var go = function($copy_i) {
            return function($copy_x) {
                var $tco_var_i = $copy_i;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(i, x) {
                    var v = succ1(x);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_i = i + 1 | 0;
                        $copy_x = v.value0;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return i;
                    }
                    throw new Error("Failed pattern match at Data.Enum (line 276, column 5 - line 278, column 19): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_i, $copy_x);
                return $tco_result;
            };
        };
        return go(1)(bottom2);
    };
};
var $f935a9866e211c00$var$charToEnum = function(v) {
    if (v >= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) && v <= $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1)) return new $06733ae99ed4f534$export$8a67b48435b5d073($1cf1b1293ed20ecf$export$30216c0101da0ee0(v));
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $f935a9866e211c00$export$8ff57056df5ff58e = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$var$charToEnum)($1cf1b1293ed20ecf$export$d90166409dd04e85),
    Ord0: function() {
        return $97937c29f879e68e$export$3abd12c96be3b09b;
    }
};
var $f935a9866e211c00$export$9e9949f96c411257 = function(dict) {
    return dict.cardinality;
};
var $f935a9866e211c00$export$670c12fc7b01c16 = {
    cardinality: 1,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($05149ea687d6b460$export$523c0b569236b342);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(0),
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$48259b86288d7b58;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$c0a99362196d7617;
    }
};
var $f935a9866e211c00$export$fe7add2041208ec9 = {
    cardinality: 3,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$7158f0ceb70f54c7.value);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$1c0a5d05eb3f6e18.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($5026be88823ef1f4$export$b023c82b48e70453.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return 0;
        if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return 1;
        if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return 2;
        throw new Error("Failed pattern match at Data.Enum (line 137, column 1 - line 145, column 18): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$2e0fd44408d4861;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$94be50e509bf721a;
    }
};
var $f935a9866e211c00$export$be1f07c3580164c = /* #__PURE__ */ function() {
    return {
        cardinality: $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$top1) - $1cf1b1293ed20ecf$export$d90166409dd04e85($f935a9866e211c00$var$bottom1) | 0,
        toEnum: $f935a9866e211c00$var$charToEnum,
        fromEnum: $1cf1b1293ed20ecf$export$d90166409dd04e85,
        Bounded0: function() {
            return $69d0e3dbb12088d2$export$7cd7c97ac7ec5b79;
        },
        Enum1: function() {
            return $f935a9866e211c00$export$8ff57056df5ff58e;
        }
    };
}();
var $f935a9866e211c00$export$3d0fa7de09d15272 = {
    cardinality: 2,
    toEnum: function(v) {
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(false);
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073(true);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (!v) return 0;
        if (v) return 1;
        throw new Error("Failed pattern match at Data.Enum (line 118, column 1 - line 124, column 20): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $69d0e3dbb12088d2$export$b6c012947af8ebbc;
    },
    Enum1: function() {
        return $f935a9866e211c00$export$6670eb63482acbe8;
    }
};












var $3ee2158c14339cc9$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $3ee2158c14339cc9$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($f935a9866e211c00$export$be1f07c3580164c);
var $3ee2158c14339cc9$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3ee2158c14339cc9$var$unfoldr = /* #__PURE__ */ $cb5fedc2c4837e1c$export$df2b8ee1690308ae($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $3ee2158c14339cc9$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $3ee2158c14339cc9$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $3ee2158c14339cc9$var$CodePoint = function(x) {
    return x;
};
var $3ee2158c14339cc9$var$unsurrogate = function(lead) {
    return function(trail) {
        return (((lead - 55296 | 0) * 1024 | 0) + (trail - 56320 | 0) | 0) + 65536 | 0;
    };
};
var $3ee2158c14339cc9$export$1e278a1fb25ff338 = {
    show: function(v) {
        return "(CodePoint 0x" + ($5b07e36f812dd04b$export$43df7fc17cca38a4($4ab74a20512cef04$export$f601457c5ee3082f($8d5664f12212b23e$export$9c12a48020146abe)(v)) + ")");
    }
};
var $3ee2158c14339cc9$var$isTrail = function(cu) {
    return 56320 <= cu && cu <= 57343;
};
var $3ee2158c14339cc9$var$isLead = function(cu) {
    return 55296 <= cu && cu <= 56319;
};
var $3ee2158c14339cc9$export$b446f6baa3bb1430 = function(s) {
    var v = $092fe44bc0883be6$export$f24224f1c91d8156(s);
    if (v === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s)),
        tail: ""
    });
    var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $43 = $3ee2158c14339cc9$var$isLead(cu0) && $3ee2158c14339cc9$var$isTrail(cu1);
    if ($43) return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1),
        tail: $092fe44bc0883be6$export$663103110d94aac9(2)(s)
    });
    return new $06733ae99ed4f534$export$8a67b48435b5d073({
        head: cu0,
        tail: $092fe44bc0883be6$export$663103110d94aac9(1)(s)
    });
};
var $3ee2158c14339cc9$var$unconsButWithTuple = function(s) {
    return $3ee2158c14339cc9$var$map(function(v) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.head, v.tail);
    })($3ee2158c14339cc9$export$b446f6baa3bb1430(s));
};
var $3ee2158c14339cc9$var$toCodePointArrayFallback = function(s) {
    return $3ee2158c14339cc9$var$unfoldr($3ee2158c14339cc9$var$unconsButWithTuple)(s);
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0Fallback = function(s) {
    var cu0 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(0)(s));
    var $47 = $3ee2158c14339cc9$var$isLead(cu0) && $092fe44bc0883be6$export$f24224f1c91d8156(s) > 1;
    if ($47) {
        var cu1 = $3ee2158c14339cc9$var$fromEnum($3296d29fc7ea4822$export$bbcf894add1d392c(1)(s));
        var $48 = $3ee2158c14339cc9$var$isTrail(cu1);
        if ($48) return $3ee2158c14339cc9$var$unsurrogate(cu0)(cu1);
        return cu0;
    }
    return cu0;
};
var $3ee2158c14339cc9$var$unsafeCodePointAt0 = /* #__PURE__ */ $bfc50dc5547207b7$export$81daff3801c9c982($3ee2158c14339cc9$var$unsafeCodePointAt0Fallback);
var $3ee2158c14339cc9$export$50a427d3c041e0d2 = /* #__PURE__ */ $bfc50dc5547207b7$export$c61d72f8b05641be($3ee2158c14339cc9$var$toCodePointArrayFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$f24224f1c91d8156 = function($74) {
    return $fc8c1182ec2aefec$export$f24224f1c91d8156($3ee2158c14339cc9$export$50a427d3c041e0d2($74));
};
var $3ee2158c14339cc9$export$557cfb7ed375eeb7 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$557cfb7ed375eeb7(p)(s));
    };
};
var $3ee2158c14339cc9$export$305f7d4e9d4624f2 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$map(function(i) {
            return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(i)(s));
        })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s));
    };
};
var $3ee2158c14339cc9$var$fromCharCode = /* #__PURE__ */ function() {
    var $75 = $f935a9866e211c00$export$1e2c188a485bdeae($f935a9866e211c00$export$be1f07c3580164c)($69d0e3dbb12088d2$export$40e543e69a8b3fbb($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79))($69d0e3dbb12088d2$export$1e95b668f3b82d($69d0e3dbb12088d2$export$7cd7c97ac7ec5b79));
    return function($76) {
        return $092fe44bc0883be6$export$439306a4dcaafbb9($75($76));
    };
}();
var $3ee2158c14339cc9$var$singletonFallback = function(v) {
    if (v <= 65535) return $3ee2158c14339cc9$var$fromCharCode(v);
    var lead = $3ee2158c14339cc9$var$div(v - 65536 | 0)(1024) + 55296 | 0;
    var trail = $3ee2158c14339cc9$var$mod(v - 65536 | 0)(1024) + 56320 | 0;
    return $3ee2158c14339cc9$var$fromCharCode(lead) + $3ee2158c14339cc9$var$fromCharCode(trail);
};
var $3ee2158c14339cc9$export$6fadda5ad927586c = /* #__PURE__ */ $bfc50dc5547207b7$export$c41b441de25e3d55($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$export$439306a4dcaafbb9 = /* #__PURE__ */ $bfc50dc5547207b7$export$ecb7b38eca4fe9ff($3ee2158c14339cc9$var$singletonFallback);
var $3ee2158c14339cc9$var$takeFallback = function(v) {
    return function(v1) {
        if (v < 1) return "";
        var v2 = $3ee2158c14339cc9$export$b446f6baa3bb1430(v1);
        if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $3ee2158c14339cc9$export$439306a4dcaafbb9(v2.value0.head) + $3ee2158c14339cc9$var$takeFallback(v - 1 | 0)(v2.value0.tail);
        return v1;
    };
};
var $3ee2158c14339cc9$export$b7df5d561049483a = /* #__PURE__ */ $bfc50dc5547207b7$export$6d9af221d75dd06f($3ee2158c14339cc9$var$takeFallback);
var $3ee2158c14339cc9$export$9dc3eed83bb14216 = function(p) {
    return function(i) {
        return function(s) {
            var i$prime = $092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(i)(s));
            return $3ee2158c14339cc9$var$map(function(k) {
                return $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s));
            })($1a77d6934b592676$export$9dc3eed83bb14216(p)(i$prime)(s));
        };
    };
};
var $3ee2158c14339cc9$export$b0d75975ac0be0e1 = function(i) {
    return function(s) {
        var before = $3ee2158c14339cc9$export$b7df5d561049483a(i)(s);
        return {
            before: before,
            after: $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156(before))(s)
        };
    };
};
var $3ee2158c14339cc9$export$e200a5917becef04 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $3ee2158c14339cc9$export$b08a820ff2b5847d = {
    compare: function(x) {
        return function(y) {
            return $3ee2158c14339cc9$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $3ee2158c14339cc9$export$e200a5917becef04;
    }
};
var $3ee2158c14339cc9$export$663103110d94aac9 = function(n) {
    return function(s) {
        return $092fe44bc0883be6$export$663103110d94aac9($092fe44bc0883be6$export$f24224f1c91d8156($3ee2158c14339cc9$export$b7df5d561049483a(n)(s)))(s);
    };
};
var $3ee2158c14339cc9$export$7f0e23922170149a = function(p) {
    return function(i) {
        return function(s) {
            var s$prime = $3ee2158c14339cc9$export$663103110d94aac9(i)(s);
            return $3ee2158c14339cc9$var$map(function(k) {
                return i + $3ee2158c14339cc9$export$f24224f1c91d8156($092fe44bc0883be6$export$b7df5d561049483a(k)(s$prime)) | 0;
            })($1a77d6934b592676$export$305f7d4e9d4624f2(p)(s$prime));
        };
    };
};
var $3ee2158c14339cc9$var$countTail = function($copy_p) {
    return function($copy_s) {
        return function($copy_accum) {
            var $tco_var_p = $copy_p;
            var $tco_var_s = $copy_s;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(p, s, accum) {
                var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var $61 = p(v.value0.head);
                    if ($61) {
                        $tco_var_p = p;
                        $tco_var_s = v.value0.tail;
                        $copy_accum = accum + 1 | 0;
                        return;
                    }
                    $tco_done = true;
                    return accum;
                }
                $tco_done = true;
                return accum;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_p, $tco_var_s, $copy_accum);
            return $tco_result;
        };
    };
};
var $3ee2158c14339cc9$var$countFallback = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$var$countTail(p)(s)(0);
    };
};
var $3ee2158c14339cc9$export$29a68f758c141c85 = /* #__PURE__ */ $bfc50dc5547207b7$export$2964bc4d0a1ede06($3ee2158c14339cc9$var$countFallback)($3ee2158c14339cc9$var$unsafeCodePointAt0);
var $3ee2158c14339cc9$export$533af5c8cd6afa16 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$663103110d94aac9($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$9384c7afe4015e42 = function(p) {
    return function(s) {
        return $3ee2158c14339cc9$export$b7df5d561049483a($3ee2158c14339cc9$export$29a68f758c141c85(p)(s))(s);
    };
};
var $3ee2158c14339cc9$export$dd1029f96c3dd62a = function($77) {
    return $3ee2158c14339cc9$var$CodePoint($3ee2158c14339cc9$var$fromEnum($77));
};
var $3ee2158c14339cc9$var$codePointAtFallback = function($copy_n) {
    return function($copy_s) {
        var $tco_var_n = $copy_n;
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(n, s) {
            var v = $3ee2158c14339cc9$export$b446f6baa3bb1430(s);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var $66 = n === 0;
                if ($66) {
                    $tco_done = true;
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.head);
                }
                $tco_var_n = n - 1 | 0;
                $copy_s = v.value0.tail;
                return;
            }
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        while(!$tco_done)$tco_result = $tco_loop($tco_var_n, $copy_s);
        return $tco_result;
    };
};
var $3ee2158c14339cc9$export$42977f40461e1360 = function(v) {
    return function(v1) {
        if (v < 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0 && v1 === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($3ee2158c14339cc9$var$unsafeCodePointAt0(v1));
        return $bfc50dc5547207b7$export$5f0398d7608003c3($3ee2158c14339cc9$var$codePointAtFallback)($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value)($3ee2158c14339cc9$var$unsafeCodePointAt0)(v)(v1);
    };
};
var $3ee2158c14339cc9$export$1c2b30ab4636bf91 = {
    bottom: 0,
    top: 1114111,
    Ord0: function() {
        return $3ee2158c14339cc9$export$b08a820ff2b5847d;
    }
};
var $3ee2158c14339cc9$export$2a3400c6862992c1 = /* #__PURE__ */ function() {
    return {
        cardinality: 1114112,
        fromEnum: function(v) {
            return v;
        },
        toEnum: function(n) {
            if (n >= 0 && n <= 1114111) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Data.String.CodePoints (line 63, column 1 - line 68, column 26): " + [
                n.constructor.name
            ]);
        },
        Bounded0: function() {
            return $3ee2158c14339cc9$export$1c2b30ab4636bf91;
        },
        Enum1: function() {
            return $3ee2158c14339cc9$var$$lazy_enumCodePoint(0);
        }
    };
}();
var $3ee2158c14339cc9$var$$lazy_enumCodePoint = /* #__PURE__ */ $3ee2158c14339cc9$var$$runtime_lazy("enumCodePoint", "Data.String.CodePoints", function() {
    return {
        succ: $f935a9866e211c00$export$11e799785deb08e4($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        pred: $f935a9866e211c00$export$dc42af8461b24233($f935a9866e211c00$export$45328c01562fb205($3ee2158c14339cc9$export$2a3400c6862992c1))($f935a9866e211c00$export$b385cb642735011f($3ee2158c14339cc9$export$2a3400c6862992c1)),
        Ord0: function() {
            return $3ee2158c14339cc9$export$b08a820ff2b5847d;
        }
    };
});
var $3ee2158c14339cc9$export$4bc346dd2fb559f7 = /* #__PURE__ */ $3ee2158c14339cc9$var$$lazy_enumCodePoint(59);


// Generated by purs version 0.15.16











var $5505a3400147efbd$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $5505a3400147efbd$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377);
var $5505a3400147efbd$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $5505a3400147efbd$export$5e0a9ee3d3833c14 = function(x) {
    return x;
};
var $5505a3400147efbd$export$b6a781e0c851762d = function(x) {
    return x;
};
var $5505a3400147efbd$export$43df7fc17cca38a4 = function(v) {
    return $5b07e36f812dd04b$export$43df7fc17cca38a4(v);
};
var $5505a3400147efbd$export$f84e8e69fd4488a5 = function(v) {
    return v;
};
var $5505a3400147efbd$export$b1ceac3893cbda6b = function(v) {
    return $5b07e36f812dd04b$export$b1ceac3893cbda6b(v);
};
var $5505a3400147efbd$export$9c23a244a4c30cab = {
    show: function(v) {
        return "(NonEmptyString.unsafeFromString " + ($5505a3400147efbd$var$show(v) + ")");
    }
};
var $5505a3400147efbd$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($5505a3400147efbd$export$9c23a244a4c30cab);
var $5505a3400147efbd$export$744c07e924c63a64 = {
    show: function(v) {
        return "(NonEmptyReplacement " + ($5505a3400147efbd$var$show1(v) + ")");
    }
};
var $5505a3400147efbd$export$d35c69c74cf52f2a = $d7bf9817a417d4ae$export$d9b7100b101f2c5b;
var $5505a3400147efbd$export$f2627aa412761e90 = $5505a3400147efbd$export$d35c69c74cf52f2a;
var $5505a3400147efbd$export$b8b3234b4edfc4c2 = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$b8b3234b4edfc4c2(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$77ad94ebf1c2b9ed = function(pat) {
    return function(v) {
        return function(v1) {
            return $5b07e36f812dd04b$export$77ad94ebf1c2b9ed(pat)(v)(v1);
        };
    };
};
var $5505a3400147efbd$export$8e478561c4b63c72 = function(s1) {
    return function(v) {
        return s1 + v;
    };
};
var $5505a3400147efbd$export$5dc47cd73bc6c69d = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $5505a3400147efbd$export$c5ad7bed4061c986 = $5505a3400147efbd$export$5dc47cd73bc6c69d;
var $5505a3400147efbd$export$17c9b383a1071b74 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return {
        nes: function(p) {
            return reflectSymbol(p);
        }
    };
};
var $5505a3400147efbd$export$1a8016356aadf775 = function(dict) {
    return dict.nes;
};
var $5505a3400147efbd$export$632efc9d6c44380 = function() {
    return {
        nes: function(v) {
            return "";
        }
    };
};
var $5505a3400147efbd$export$35652c12e6caefdf = function(v) {
    return function(v1) {
        return $22d4f8ab6946d33a$export$35652c12e6caefdf(v)(v1);
    };
};
var $5505a3400147efbd$export$d4df5207b384f835 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $5505a3400147efbd$export$9e6c3fdf667ac5ae = function(dictFoldable1) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable1.Foldable0())($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(v) {
        var $59 = intercalate(v);
        return function($60) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($59($60));
        };
    };
};
var $5505a3400147efbd$export$ec1dc8fbeea3467e = function(dictFoldable) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(splice) {
        var $61 = intercalate(splice);
        return function($62) {
            return $61($62);
        };
    };
};
var $5505a3400147efbd$export$f542ede54c0f0952 = function(dictFoldable1) {
    var joinWith2 = $5505a3400147efbd$export$ec1dc8fbeea3467e(dictFoldable1.Foldable0());
    return function(splice) {
        var $63 = joinWith2(splice);
        return function($64) {
            return $5505a3400147efbd$export$5e0a9ee3d3833c14($63($64));
        };
    };
};
var $5505a3400147efbd$export$3004f64547af360e = function(v) {
    if (v === "") return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
};
var $5505a3400147efbd$export$71c2a1babd78d286 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$71c2a1babd78d286(pat)));
};
var $5505a3400147efbd$export$cc5663efaab5bcf6 = function(pat) {
    return $5505a3400147efbd$var$composeKleisliFlipped($5505a3400147efbd$export$3004f64547af360e)($5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$cc5663efaab5bcf6(pat)));
};
var $5505a3400147efbd$export$87c2784dc9fc4ab = function(v) {
    return $5505a3400147efbd$export$3004f64547af360e($5b07e36f812dd04b$export$87c2784dc9fc4ab(v));
};
var $5505a3400147efbd$export$6c65599023ae894b = function() {
    return function($65) {
        return $5505a3400147efbd$var$fromJust($5505a3400147efbd$export$3004f64547af360e($65));
    };
};
var $5505a3400147efbd$export$5982362881026796 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $5505a3400147efbd$export$db52a218b305ccab = $5505a3400147efbd$export$5982362881026796;
var $5505a3400147efbd$export$2344b14b097df817 = function($66) {
    return $5505a3400147efbd$export$d4df5207b384f835($1a77d6934b592676$export$2344b14b097df817($66));
};
var $5505a3400147efbd$export$8c3d57ec79c4009e = function(v) {
    return function(s2) {
        return v + s2;
    };
};







var $160716589b57c4ec$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $160716589b57c4ec$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $160716589b57c4ec$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$99c2ce29c0ead637)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $160716589b57c4ec$var$fromFoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $160716589b57c4ec$var$fromFoldable1 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $160716589b57c4ec$var$traverse1 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($91ee3359f6bcea22$export$81b6a4240b5ed5ff)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse2 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($78c799cba34fcb8d$export$d0a0d45336d2d3e3)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse3 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20(/* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($11d1e86de605dfc6$export$9e4a28683e28e26a))($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse4 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20(/* #__PURE__ */ $1f1c3fb67e79b37f$export$dbb721137b3f0cf6($78c799cba34fcb8d$export$99c2ce29c0ead637))($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$traverse5 = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($c045ea5df33bba60$export$aeab5e284d2f12ed)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $160716589b57c4ec$var$traverseWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$955fdc0d24efa249($2c7a64ff78781336$export$96888504550934b5)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $160716589b57c4ec$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($7d4cccdf062a2261$export$d5df7cb019d08f04);
var $160716589b57c4ec$export$a752bd756a1ddd62 = function(decoder) {
    return function(obj) {
        return function(str) {
            var decode = function(json) {
                var $35 = $2a035e92dc768ac1$export$630801d484da15df(json);
                if ($35) return $160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                return $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)($160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str))(decoder(json)));
            };
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value))(decode)($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$65e8cd53bb7e3167 = function(decoder) {
    return function(obj) {
        return function(str) {
            var decode = function() {
                var $44 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str));
                return function($45) {
                    return $44(decoder($45));
                };
            }();
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value))(function() {
                var $46 = $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create);
                return function($47) {
                    return $46(decode($47));
                };
            }())($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$2c9b3f539cb25b05 = function(decoder) {
    return function(obj) {
        return function(str) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(str, $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value)))(function() {
                var $48 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(str));
                return function($49) {
                    return $48(decoder($49));
                };
            }())($c045ea5df33bba60$export$dfc7155ac0343b8(str)(obj));
        };
    };
};
var $160716589b57c4ec$export$c576f0bf806d7130 = function(v) {
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($0e031af7428ef07d$export$dbafa4424a806c15("Value cannot be Void")));
};
var $160716589b57c4ec$export$a0fb664af7d0cc44 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$1532fd4f75be8b9c(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("String")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$874d75d651b25595 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$ec3647fa336ee4ac(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Number")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$d6ce7784e89e4f30 = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$4d5744f54c133204(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("null")))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342)));
}();
var $160716589b57c4ec$export$30ea34212b8dfba3 = function(json) {
    return $160716589b57c4ec$var$bindFlipped($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd("NonEmptyString", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json))))($160716589b57c4ec$var$map($5505a3400147efbd$export$3004f64547af360e)($160716589b57c4ec$export$a0fb664af7d0cc44(json)));
};
var $160716589b57c4ec$export$2ebe793352894353 = function(decoder) {
    return function(json) {
        if ($2a035e92dc768ac1$export$630801d484da15df(json)) return $160716589b57c4ec$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $160716589b57c4ec$var$map($06733ae99ed4f534$export$8a67b48435b5d073.create)(decoder(json));
        throw new Error("Failed pattern match at Data.Argonaut.Decode.Decoders (line 37, column 1 - line 41, column 38): " + [
            decoder.constructor.name,
            json.constructor.name
        ]);
    };
};
var $160716589b57c4ec$export$10fbded63f740d7b = /* #__PURE__ */ function() {
    var $50 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Object"));
    return function($51) {
        return $50($2a035e92dc768ac1$export$697e4a1b90752ce2($51));
    };
}();
var $160716589b57c4ec$export$9443fc6f73bb4af5 = /* #__PURE__ */ function() {
    var $52 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Array"));
    return function($53) {
        return $52($2a035e92dc768ac1$export$45b10814cc054894($53));
    };
}();
var $160716589b57c4ec$export$81a8dc2369cfa9c9 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $54 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("List"));
        var $55 = $160716589b57c4ec$var$traverse(decoder);
        return function($56) {
            return $54($55($56));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$856c6a7d662218dc = function(dictOrd) {
    var fromFoldable2 = $160716589b57c4ec$var$fromFoldable1(dictOrd);
    return function(decoder) {
        var $57 = $160716589b57c4ec$var$map(fromFoldable2);
        var $58 = $160716589b57c4ec$export$81a8dc2369cfa9c9(decoder);
        return function($59) {
            return $57($58($59));
        };
    };
};
var $160716589b57c4ec$export$616fc2952a7ddd7e = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $60 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmptyArray"));
        var $61 = $160716589b57c4ec$var$traverse1(decoder);
        return function($62) {
            return $60($61($62));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $63 = $160716589b57c4ec$var$map(function(x) {
            return $e39dfcf102cdca3c$export$cc3b5f3f66225fbe(x.head)(x.tail);
        });
        var $64 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmptyArray"));
        return function($65) {
            return $63($64($396c4c3d9e7fae3c$export$b446f6baa3bb1430($65)));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$6e075b5db6f456bc = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $66 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmptyList"));
        var $67 = $160716589b57c4ec$var$traverse2(decoder);
        return function($68) {
            return $66($67($68));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $69 = $160716589b57c4ec$var$map(function(x) {
            return $ba51d599f79a6310$export$cc3b5f3f66225fbe(x.head)(x.tail);
        });
        var $70 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmptyList"));
        return function($71) {
            return $69($70($3d4fd987da5242ff$export$b446f6baa3bb1430($71)));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5)));
};
var $160716589b57c4ec$export$5223c50aad43e366 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $72 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmpty Array"));
        var $73 = $160716589b57c4ec$var$traverse3(decoder);
        return function($74) {
            return $72($73($74));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $75 = $160716589b57c4ec$var$map(function(x) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x.head, x.tail);
        });
        var $76 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmpty Array"));
        return function($77) {
            return $75($76($396c4c3d9e7fae3c$export$b446f6baa3bb1430($77)));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5));
};
var $160716589b57c4ec$export$cc44286d42597985 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $78 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("NonEmpty List"));
        var $79 = $160716589b57c4ec$var$traverse4(decoder);
        return function($80) {
            return $78($79($80));
        };
    }())($160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $81 = $160716589b57c4ec$var$map(function(x) {
            return new $1f1c3fb67e79b37f$export$d8deaab87a4e223a(x.head, x.tail);
        });
        var $82 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("NonEmpty List"));
        return function($83) {
            return $81($82($3d4fd987da5242ff$export$b446f6baa3bb1430($83)));
        };
    }())($160716589b57c4ec$var$map1($160716589b57c4ec$var$map($160716589b57c4ec$var$fromFoldable))($160716589b57c4ec$export$9443fc6f73bb4af5)));
};
var $160716589b57c4ec$export$2046d9d5fd83c6e2 = /* #__PURE__ */ $160716589b57c4ec$var$composeKleisliFlipped(/* #__PURE__ */ function() {
    var $84 = $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Integer"));
    return function($85) {
        return $84($8d5664f12212b23e$export$7bbb4164c9a77bc2($85));
    };
}())($160716589b57c4ec$export$874d75d651b25595);
var $160716589b57c4ec$export$96fc93a77504a477 = function(decoder) {
    return function(json) {
        return $160716589b57c4ec$var$map($50c50d1f444e5fa4$export$544bf02140fa9a77)(decoder(json));
    };
};
var $160716589b57c4ec$export$5501dc3a72754845 = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $86 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("ForeignObject"));
        var $87 = $160716589b57c4ec$var$traverse5(decoder);
        return function($88) {
            return $86($87($88));
        };
    }())($160716589b57c4ec$export$10fbded63f740d7b);
};
var $160716589b57c4ec$export$ca42b39dda7b755 = function(decoderA) {
    return function(decoderB) {
        return function(json) {
            return $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("Either"))($160716589b57c4ec$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(obj) {
                return $160716589b57c4ec$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("tag", $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value))($c045ea5df33bba60$export$dfc7155ac0343b8("tag")(obj)))(function(tag) {
                    return $160716589b57c4ec$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("value", $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value))($c045ea5df33bba60$export$dfc7155ac0343b8("value")(obj)))(function(val) {
                        var v = $2a035e92dc768ac1$export$f84e8e69fd4488a5(tag);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "Right") return $160716589b57c4ec$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(decoderB(val));
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "Left") return $160716589b57c4ec$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(decoderA(val));
                        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("tag", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(tag)));
                    });
                });
            }));
        };
    };
};
var $160716589b57c4ec$export$1f5a05ca6191a69a = function(json) {
    return $160716589b57c4ec$var$bindFlipped($7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$4e021928efe6b6bd("CodePoint", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json))))($160716589b57c4ec$var$map($3ee2158c14339cc9$export$42977f40461e1360(0))($160716589b57c4ec$export$a0fb664af7d0cc44(json)));
};
var $160716589b57c4ec$export$7e6b1898d6f2947e = /* #__PURE__ */ function() {
    return $2a035e92dc768ac1$export$fff3b6519135a62b(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Boolean")))($7d4cccdf062a2261$export$19db0165690c701a.create);
}();
var $160716589b57c4ec$export$81879b02e9646afe = function(decoder) {
    return $160716589b57c4ec$var$composeKleisliFlipped(function() {
        var $89 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$4e021928efe6b6bd.create("Array"));
        var $90 = $160716589b57c4ec$var$traverseWithIndex(function(i) {
            var $92 = $160716589b57c4ec$var$lmap($826fbbc6c8d1e9e2$export$d58b23382c8562e.create(i));
            return function($93) {
                return $92(decoder($93));
            };
        });
        return function($91) {
            return $89($90($91));
        };
    }())($160716589b57c4ec$export$9443fc6f73bb4af5);
};
var $160716589b57c4ec$export$f388ba5c0507726 = function(decoderA) {
    return function(decoderB) {
        return function(json) {
            var f = function(v) {
                if (v.length === 2) return $160716589b57c4ec$var$apply($160716589b57c4ec$var$map($71f2e2e9476163f8$export$1908877435b1d5e9.create)(decoderA(v[0])))(decoderB(v[1]));
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Tuple"));
            };
            return $160716589b57c4ec$var$bind($160716589b57c4ec$export$81879b02e9646afe($7d4cccdf062a2261$export$19db0165690c701a.create)(json))(f);
        };
    };
};
var $160716589b57c4ec$export$55fc690486870f87 = function(dictOrd) {
    var fromFoldable2 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072(dictOrd)($78c799cba34fcb8d$export$92659ee1fc91a075);
    return function(decoderA) {
        return function(decoderB) {
            var $94 = $160716589b57c4ec$var$map(fromFoldable2);
            var $95 = $160716589b57c4ec$export$81a8dc2369cfa9c9($160716589b57c4ec$export$f388ba5c0507726(decoderA)(decoderB));
            return function($96) {
                return $94($95($96));
            };
        };
    };
};









// Generated by purs version 0.15.16



// Generated by purs version 0.15.16
function $e624b6ee0b54010c$export$92a1542aa06c886(r1, r2) {
    var copy = {};
    for(var k1 in r2)if (({}).hasOwnProperty.call(r2, k1)) copy[k1] = r2[k1];
    for(var k2 in r1)if (({}).hasOwnProperty.call(r1, k2)) copy[k2] = r1[k2];
    return copy;
}



var $7839e24eedf166a9$export$b2a4c822ec4216bb = /* #__PURE__ */ $8f2697950ee155e1$export$b3f66664347b6e8d($e624b6ee0b54010c$export$92a1542aa06c886);




var $15e8567e7c31ba30$export$971dd5b0dfd021b6 = function() {
    return function(l) {
        return function(r) {
            return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
        };
    };
};
var $15e8567e7c31ba30$export$adaa4cf7ef1b65be = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(b) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(b)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$94f4066a75b10404 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $15e8567e7c31ba30$export$4950aa0f605343fb = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$21a5ca8aa77d35ff = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(a) {
                    return function(r) {
                        return $d2fadbdf02925823$export$444262986932b766(reflectSymbol(l))(a)(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$3988ae62b71be9a3 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function(l) {
            return function(r) {
                return $d2fadbdf02925823$export$1d94535d2cda4eda(reflectSymbol(l))(r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$3ff57735a52b8713 = function(dictIsSymbol) {
    var set1 = $15e8567e7c31ba30$export$adaa4cf7ef1b65be(dictIsSymbol)()();
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function() {
        return function() {
            return function(l) {
                return function(f) {
                    return function(r) {
                        return set1(l)(f(get1(l)(r)))(r);
                    };
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$db0231a0f4325b7b = {
    equalFields: function(v) {
        return function(v1) {
            return function(v2) {
                return true;
            };
        };
    }
};
var $15e8567e7c31ba30$export$91610c87b78a6ed5 = function(dict) {
    return dict.equalFields;
};
var $15e8567e7c31ba30$export$772630fbd62849b4 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return function() {
            return function(dictEqualFields) {
                var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
                return {
                    equalFields: function(v) {
                        return function(a) {
                            return function(b) {
                                var get$prime = get1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var equalRest = equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                return eq(get$prime(a))(get$prime(b)) && equalRest(a)(b);
                            };
                        };
                    }
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$411ce8e5a71e3069 = function() {
    return function(dictEqualFields) {
        var equalFields1 = $15e8567e7c31ba30$export$91610c87b78a6ed5(dictEqualFields);
        return function(a) {
            return function(b) {
                return equalFields1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(a)(b);
            };
        };
    };
};
var $15e8567e7c31ba30$export$812eab5d580a29df = function() {
    return function() {
        return function(l) {
            return function(r) {
                return $e624b6ee0b54010c$export$92a1542aa06c886(l, r);
            };
        };
    };
};
var $15e8567e7c31ba30$export$1822828d790e23ee = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return function() {
        return function() {
            return function(l) {
                return function(r) {
                    return $d2fadbdf02925823$export$14b6a75b3eb38458(reflectSymbol(l))(r);
                };
            };
        };
    };
};
var $15e8567e7c31ba30$export$7ac989ec0c9c279 = function(dictIsSymbol) {
    var get1 = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
    var delete1 = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
    return function(dictIsSymbol1) {
        var insert1 = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol1)()();
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(prev) {
                            return function(next) {
                                return function(record) {
                                    return insert1(next)(get1(prev)(record))(delete1(prev)(record));
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};



var $e2b1be82a5e6d14f$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $e2b1be82a5e6d14f$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $e2b1be82a5e6d14f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $e2b1be82a5e6d14f$export$355fe3e8bf1b90ac = {
    gDecodeJson: function(v) {
        return function(v1) {
            return new $7d4cccdf062a2261$export$19db0165690c701a({});
        };
    }
};
var $e2b1be82a5e6d14f$export$84d469437cbcf120 = function(dict) {
    return dict.gDecodeJson;
};
var $e2b1be82a5e6d14f$export$c576f0bf806d7130 = {
    decodeJson: $160716589b57c4ec$export$c576f0bf806d7130
};
var $e2b1be82a5e6d14f$export$b423891985836fe9 = function(dictGDecodeJson) {
    var gDecodeJson1 = $e2b1be82a5e6d14f$export$84d469437cbcf120(dictGDecodeJson);
    return function() {
        return {
            decodeJson: function(json) {
                var v = $2a035e92dc768ac1$export$697e4a1b90752ce2(json);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return gDecodeJson1(v.value0)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Object"));
                throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 103, column 5 - line 105, column 46): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $e2b1be82a5e6d14f$export$12808118396f3c8d = {
    decodeJson: $160716589b57c4ec$export$a0fb664af7d0cc44
};
var $e2b1be82a5e6d14f$export$2b11fc8bd46f4a11 = {
    decodeJson: $160716589b57c4ec$export$874d75d651b25595
};
var $e2b1be82a5e6d14f$export$15d491fcb9f2da43 = {
    decodeJson: $160716589b57c4ec$export$d6ce7784e89e4f30
};
var $e2b1be82a5e6d14f$export$809268d4a5d588e2 = {
    decodeJson: $160716589b57c4ec$export$30ea34212b8dfba3
};
var $e2b1be82a5e6d14f$export$c2f7b8312539f0ea = /* #__PURE__ */ function() {
    return {
        decodeJson: $7d4cccdf062a2261$export$19db0165690c701a.create
    };
}();
var $e2b1be82a5e6d14f$export$fee2d5446387c54f = {
    decodeJson: $160716589b57c4ec$export$2046d9d5fd83c6e2
};
var $e2b1be82a5e6d14f$export$c337bc5569ed68fc = function(dict) {
    return dict.decodeJsonField;
};
var $e2b1be82a5e6d14f$export$44d61a05912ad881 = function(dictDecodeJsonField) {
    var decodeJsonField1 = $e2b1be82a5e6d14f$export$c337bc5569ed68fc(dictDecodeJsonField);
    return function(dictGDecodeJson) {
        var gDecodeJson1 = $e2b1be82a5e6d14f$export$84d469437cbcf120(dictGDecodeJson);
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
            return function() {
                return function() {
                    return {
                        gDecodeJson: function(object) {
                            return function(v) {
                                var fieldName = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var fieldValue = $c045ea5df33bba60$export$dfc7155ac0343b8(fieldName)(object);
                                var v1 = decodeJsonField1(fieldValue);
                                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e2b1be82a5e6d14f$var$bind($e2b1be82a5e6d14f$var$lmap($826fbbc6c8d1e9e2$export$26ae1106fd92d0a8.create(fieldName))(v1.value0))(function(val) {
                                    return $e2b1be82a5e6d14f$var$bind(gDecodeJson1(object)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(function(rest) {
                                        return new $7d4cccdf062a2261$export$19db0165690c701a(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(val)(rest));
                                    });
                                });
                                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8(fieldName, $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value));
                                throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 127, column 5 - line 134, column 44): " + [
                                    v1.constructor.name
                                ]);
                            };
                        }
                    };
                };
            };
        };
    };
};
var $e2b1be82a5e6d14f$export$f35b91d6928b8f9a = {
    decodeJson: $160716589b57c4ec$export$1f5a05ca6191a69a
};
var $e2b1be82a5e6d14f$export$5a21fe33ecda3e76 = {
    decodeJson: $160716589b57c4ec$export$7e6b1898d6f2947e
};
var $e2b1be82a5e6d14f$export$cd9ded616c0cfb91 = function(dict) {
    return dict.decodeJson;
};
var $e2b1be82a5e6d14f$export$48f40a6bda333d72 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictDecodeJson1) {
        return {
            decodeJson: $160716589b57c4ec$export$ca42b39dda7b755(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
        };
    };
};
var $e2b1be82a5e6d14f$export$6c5207b40709ea3b = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$2ebe793352894353($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$a13e2a25697f85d0 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$616fc2952a7ddd7e($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$af80faa854f5e9f2 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$6e075b5db6f456bc($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$66d3e413e47dd1c8 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$5223c50aad43e366($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$d4dc80ba4c20e110 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$cc44286d42597985($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$269e6545e7001224 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictDecodeJson1) {
        return {
            decodeJson: $160716589b57c4ec$export$f388ba5c0507726(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
        };
    };
};
var $e2b1be82a5e6d14f$export$81a8dc2369cfa9c9 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$81a8dc2369cfa9c9($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$55fc690486870f87 = function(dictOrd) {
    var decodeMap1 = $160716589b57c4ec$export$55fc690486870f87(dictOrd);
    return function(dictDecodeJson) {
        var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
        return function(dictDecodeJson1) {
            return {
                decodeJson: decodeMap1(decodeJson1)($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson1))
            };
        };
    };
};
var $e2b1be82a5e6d14f$export$856c6a7d662218dc = function(dictOrd) {
    var decodeSet1 = $160716589b57c4ec$export$856c6a7d662218dc(dictOrd);
    return function(dictDecodeJson) {
        return {
            decodeJson: decodeSet1($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
        };
    };
};
var $e2b1be82a5e6d14f$export$96fc93a77504a477 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$96fc93a77504a477($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$5501dc3a72754845 = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$5501dc3a72754845($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};
var $e2b1be82a5e6d14f$export$5be2ed97e7605dc7 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91($e2b1be82a5e6d14f$export$6c5207b40709ea3b(dictDecodeJson));
    return {
        decodeJsonField: function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $7d4cccdf062a2261$export$19db0165690c701a($06733ae99ed4f534$export$bebe9059409a0d04.value));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(decodeJson1(v.value0));
            throw new Error("Failed pattern match at Data.Argonaut.Decode.Class (line 139, column 1 - line 143, column 49): " + [
                v.constructor.name
            ]);
        }
    };
};
var $e2b1be82a5e6d14f$export$d94c139f6fec2f7f = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return {
        decodeJsonField: function(j) {
            return $e2b1be82a5e6d14f$var$map(decodeJson1)(j);
        }
    };
};
var $e2b1be82a5e6d14f$export$81879b02e9646afe = function(dictDecodeJson) {
    return {
        decodeJson: $160716589b57c4ec$export$81879b02e9646afe($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson))
    };
};


// Generated by purs version 0.15.16


// Generated by purs version 0.15.16




















var $13459527b23e3834$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $13459527b23e3834$var$toUnfoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $13459527b23e3834$var$toUnfoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $13459527b23e3834$var$toUnfoldable2 = /* #__PURE__ */ $a393155e52307a24$export$823be24f8766da23($78c799cba34fcb8d$export$1d41caf0a0a6a680);
var $13459527b23e3834$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($c045ea5df33bba60$export$b7bb4265e2e489e0);
var $13459527b23e3834$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $13459527b23e3834$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $13459527b23e3834$export$8b58be045bf06082 = function(encoder) {
    return function(v) {
        var $40 = $2a035e92dc768ac1$export$d4dde8795f959ed3($2a035e92dc768ac1$export$ecfbf588917514aa(v.value0)(v.value1))(function() {
            var $42 = $c045ea5df33bba60$export$21a5ca8aa77d35ff(v.value0)(v.value1);
            return function($43) {
                return $0e031af7428ef07d$export$dbafa4424a806c15($42($43));
            };
        }());
        return function($41) {
            return $40(encoder($41));
        };
    };
};
var $13459527b23e3834$export$1b7bab5c5d935cc2 = function(encoder) {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $13459527b23e3834$export$8b58be045bf06082(encoder)(v.value0);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return encoder;
        throw new Error("Failed pattern match at Data.Argonaut.Encode.Encoders (line 121, column 26 - line 123, column 21): " + [
            v.constructor.name
        ]);
    };
};
var $13459527b23e3834$export$51606c257d29b318 = $58f3cdfbfe212d20$export$f172309911142386;
var $13459527b23e3834$export$1e1028966b5c7065 = /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($0e031af7428ef07d$export$63ea9a5410ee0cef);
var $13459527b23e3834$export$1990b7ba8cf7db93 = function(encoderA) {
    return function(encoderB) {
        return function(v) {
            return $0e031af7428ef07d$export$dbafa4424a806c15([
                encoderA(v.value0),
                encoderB(v.value1)
            ]);
        };
    };
};
var $13459527b23e3834$export$8146d2e653b87d6a = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$ed41c27e89606957 = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$c29c3caf25da2814 = function($44) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($5505a3400147efbd$export$f84e8e69fd4488a5($44));
};
var $13459527b23e3834$export$640dd262b265c9a9 = function(encoder) {
    return function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $0e031af7428ef07d$export$63ea9a5410ee0cef;
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return encoder(v.value0);
        throw new Error("Failed pattern match at Data.Argonaut.Encode.Encoders (line 31, column 23 - line 33, column 22): " + [
            v.constructor.name
        ]);
    };
};
var $13459527b23e3834$export$7e4c09a944a44110 = function(encoder) {
    var $45 = $13459527b23e3834$var$map(encoder);
    return function($46) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($45($13459527b23e3834$var$toUnfoldable($46)));
    };
};
var $13459527b23e3834$export$200318d1f3aaee40 = function(dictOrd) {
    return function(encoderA) {
        return function(encoderB) {
            var $47 = $13459527b23e3834$export$7e4c09a944a44110($13459527b23e3834$export$1990b7ba8cf7db93(encoderA)(encoderB));
            return function($48) {
                return $47($13459527b23e3834$var$toUnfoldable1($48));
            };
        };
    };
};
var $13459527b23e3834$export$36a027b7379a8473 = function(encoder) {
    var $49 = $13459527b23e3834$export$7e4c09a944a44110(encoder);
    return function($50) {
        return $49($ba51d599f79a6310$export$effcdbd76139450($50));
    };
};
var $13459527b23e3834$export$9973f50fa8b005f0 = function(encoder) {
    return function(v) {
        return $13459527b23e3834$export$7e4c09a944a44110(encoder)(new $78c799cba34fcb8d$export$74c44e616647f5c0(v.value0, v.value1));
    };
};
var $13459527b23e3834$export$24396ced56124c99 = function(dictOrd) {
    return function(encoder) {
        var $51 = $13459527b23e3834$export$7e4c09a944a44110(encoder);
        return function($52) {
            return $51($13459527b23e3834$var$toUnfoldable2($52));
        };
    };
};
var $13459527b23e3834$export$28bc1625998ce845 = function($53) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($4ab74a20512cef04$export$a0a81dc3380ce7d3($53));
};
var $13459527b23e3834$export$e3b86e35b7509c0f = function(encoder) {
    return function(v) {
        return encoder(v);
    };
};
var $13459527b23e3834$export$4acff49b3f5661ea = function(encoder) {
    var $54 = $13459527b23e3834$var$map1(encoder);
    return function($55) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($54($55));
    };
};
var $13459527b23e3834$export$4abd2b0a026f89b4 = function(encoderA) {
    return function(encoderB) {
        var obj = function(encoder) {
            return function(tag) {
                return function(x) {
                    return $0e031af7428ef07d$export$dbafa4424a806c15($13459527b23e3834$var$fromFoldable(new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9("tag", $0e031af7428ef07d$export$dbafa4424a806c15(tag)), new $78c799cba34fcb8d$export$74c44e616647f5c0(new $71f2e2e9476163f8$export$1908877435b1d5e9("value", encoder(x)), $78c799cba34fcb8d$export$c1bed610ade55e1c.value))));
                };
            };
        };
        return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(obj(encoderA)("Left"))(obj(encoderB)("Right"));
    };
};
var $13459527b23e3834$export$3c427c24c389d273 = function($56) {
    return $13459527b23e3834$export$8146d2e653b87d6a($3ee2158c14339cc9$export$439306a4dcaafbb9($56));
};
var $13459527b23e3834$export$dbc5a334ff3f5549 = function($57) {
    return $13459527b23e3834$export$8146d2e653b87d6a($092fe44bc0883be6$export$439306a4dcaafbb9($57));
};
var $13459527b23e3834$export$1b0ad99313e5e2c6 = $0e031af7428ef07d$export$dbafa4424a806c15;
var $13459527b23e3834$export$5953f05715bb15e3 = function(encoder) {
    var $58 = $13459527b23e3834$var$map(encoder);
    return function($59) {
        return $0e031af7428ef07d$export$dbafa4424a806c15($58($59));
    };
};
var $13459527b23e3834$export$91d9dd2dfe32db48 = function(encoder) {
    var $60 = $13459527b23e3834$export$5953f05715bb15e3(encoder);
    return function($61) {
        return $60($e39dfcf102cdca3c$export$45b10814cc054894($61));
    };
};
var $13459527b23e3834$export$6ec85285b5083458 = function(encoder) {
    return function(v) {
        return $13459527b23e3834$export$5953f05715bb15e3(encoder)($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(v.value0)(v.value1));
    };
};
var $13459527b23e3834$export$64c3bd3785fd1b3d = function(encoder) {
    return function(k) {
        return $13459527b23e3834$var$map2(function() {
            var $62 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(k);
            return function($63) {
                return $62(encoder($63));
            };
        }());
    };
};
var $13459527b23e3834$export$3f4996019e520711 = function(encoder) {
    return function(k) {
        var $64 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(k);
        return function($65) {
            return $64(encoder($65));
        };
    };
};






var $eb7399d322077fcf$export$12b4d820b2ffc726 = {
    gEncodeJson: function(v) {
        return function(v1) {
            return $03b6b966974423fe$export$6e22c362a0406a2c;
        };
    }
};
var $eb7399d322077fcf$export$71d5229e5fea6423 = function(dict) {
    return dict.gEncodeJson;
};
var $eb7399d322077fcf$export$51606c257d29b318 = {
    encodeJson: $13459527b23e3834$export$51606c257d29b318
};
var $eb7399d322077fcf$export$2aa47014064a90c3 = function(dictGEncodeJson) {
    var gEncodeJson1 = $eb7399d322077fcf$export$71d5229e5fea6423(dictGEncodeJson);
    return function() {
        return {
            encodeJson: function(rec) {
                return $0e031af7428ef07d$export$dbafa4424a806c15(gEncodeJson1(rec)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $eb7399d322077fcf$export$c29c3caf25da2814 = {
    encodeJson: $13459527b23e3834$export$c29c3caf25da2814
};
var $eb7399d322077fcf$export$107c2db3e23b569f = {
    encodeJson: $13459527b23e3834$export$1e1028966b5c7065
};
var $eb7399d322077fcf$export$35d3004eff90f123 = {
    encodeJson: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa)
};
var $eb7399d322077fcf$export$188ec67d44674d4b = {
    encodeJson: $13459527b23e3834$export$8146d2e653b87d6a
};
var $eb7399d322077fcf$export$ff344db3ed099c93 = {
    encodeJson: $13459527b23e3834$export$ed41c27e89606957
};
var $eb7399d322077fcf$export$7f2886916ce99188 = {
    encodeJson: $13459527b23e3834$export$1b0ad99313e5e2c6
};
var $eb7399d322077fcf$export$b198596427f378ab = {
    encodeJson: $13459527b23e3834$export$28bc1625998ce845
};
var $eb7399d322077fcf$export$54792ca0aed9ef3e = {
    encodeJson: $13459527b23e3834$export$3c427c24c389d273
};
var $eb7399d322077fcf$export$4c18328fed860aaf = {
    encodeJson: $13459527b23e3834$export$dbc5a334ff3f5549
};
var $eb7399d322077fcf$export$a865279d3b7b5f70 = function(dict) {
    return dict.encodeJson;
};
var $eb7399d322077fcf$export$7d680688dffcbf51 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$5953f05715bb15e3($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$4db564460363add2 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictEncodeJson1) {
        return {
            encodeJson: $13459527b23e3834$export$4abd2b0a026f89b4(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
        };
    };
};
var $eb7399d322077fcf$export$9586dd179e1b28a2 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$7e4c09a944a44110($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$7c8b8b15a35b2ba2 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$640dd262b265c9a9($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$f6c72b1e53ea64f6 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$91d9dd2dfe32db48($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$7097ab98fad5367 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$36a027b7379a8473($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$78e6cf694b290b54 = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$6ec85285b5083458($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$23073eb3fb9ac1be = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$9973f50fa8b005f0($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$ff58b39dae45faec = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictEncodeJson1) {
        return {
            encodeJson: $13459527b23e3834$export$1990b7ba8cf7db93(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
        };
    };
};
var $eb7399d322077fcf$export$200318d1f3aaee40 = function(dictOrd) {
    var encodeMap1 = $13459527b23e3834$export$200318d1f3aaee40(dictOrd);
    return function(dictEncodeJson) {
        var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
        return function(dictEncodeJson1) {
            return {
                encodeJson: encodeMap1(encodeJson1)($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson1))
            };
        };
    };
};
var $eb7399d322077fcf$export$24396ced56124c99 = function(dictOrd) {
    var encodeSet1 = $13459527b23e3834$export$24396ced56124c99(dictOrd);
    return function(dictEncodeJson) {
        return {
            encodeJson: encodeSet1($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
        };
    };
};
var $eb7399d322077fcf$export$cc2f530f06b3b8c8 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(dictGEncodeJson) {
        var gEncodeJson1 = $eb7399d322077fcf$export$71d5229e5fea6423(dictGEncodeJson);
        return function(dictIsSymbol) {
            var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
            var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
            return function() {
                return {
                    gEncodeJson: function(row) {
                        return function(v) {
                            return $c045ea5df33bba60$export$21a5ca8aa77d35ff(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(encodeJson1(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(row)))(gEncodeJson1(row)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
                        };
                    }
                };
            };
        };
    };
};
var $eb7399d322077fcf$export$e3b86e35b7509c0f = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$e3b86e35b7509c0f($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};
var $eb7399d322077fcf$export$4acff49b3f5661ea = function(dictEncodeJson) {
    return {
        encodeJson: $13459527b23e3834$export$4acff49b3f5661ea($eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson))
    };
};









var $308f9765feb7633d$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
var $308f9765feb7633d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $308f9765feb7633d$export$d64ca3aab0d523a3 = /* #__PURE__ */ function() {
    function RenamedType(value0) {
        this.value0 = value0;
    }
    RenamedType.create = function(value0) {
        return new RenamedType(value0);
    };
    return RenamedType;
}();
var $308f9765feb7633d$export$c76991cd6baf9718 = /* #__PURE__ */ function() {
    function QType(value0) {
        this.value0 = value0;
    }
    QType.create = function(value0) {
        return new QType(value0);
    };
    return QType;
}();
var $308f9765feb7633d$export$a9668a4ddbf1d475 = /* #__PURE__ */ function() {
    function Nullable(value0) {
        this.value0 = value0;
    }
    Nullable.create = function(value0) {
        return new Nullable(value0);
    };
    return Nullable;
}();
var $308f9765feb7633d$export$be01c6bffeb93e87 = /* #__PURE__ */ function() {
    function ArrayOf(value0) {
        this.value0 = value0;
    }
    ArrayOf.create = function(value0) {
        return new ArrayOf(value0);
    };
    return ArrayOf;
}();
var $308f9765feb7633d$export$95d18696cb32267f = /* #__PURE__ */ function() {
    function QID(value0) {
        this.value0 = value0;
    }
    QID.create = function(value0) {
        return new QID(value0);
    };
    return QID;
}();
var $308f9765feb7633d$export$18913c2ada77a9df = /* #__PURE__ */ function() {
    function DyNamedType(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DyNamedType.create = function(value0) {
        return function(value1) {
            return new DyNamedType(value0, value1);
        };
    };
    return DyNamedType;
}();
var $308f9765feb7633d$export$dbc5ae105da62354 = /* #__PURE__ */ function() {
    return $308f9765feb7633d$export$d64ca3aab0d523a3.create;
}();
var $308f9765feb7633d$export$a7f53fa461221c79 = /* #__PURE__ */ function() {
    return $308f9765feb7633d$export$d64ca3aab0d523a3.create;
}();
var $308f9765feb7633d$export$2654b1b656d9a957 = function(v) {
    if (v instanceof $308f9765feb7633d$export$a9668a4ddbf1d475 && v.value0 instanceof $308f9765feb7633d$export$c76991cd6baf9718) return v.value0.value0;
    if (v instanceof $308f9765feb7633d$export$c76991cd6baf9718) return v.value0 + "!";
    if (v instanceof $308f9765feb7633d$export$a9668a4ddbf1d475 && v.value0 instanceof $308f9765feb7633d$export$be01c6bffeb93e87) return "[" + ($308f9765feb7633d$export$2654b1b656d9a957(v.value0.value0) + "]");
    if (v instanceof $308f9765feb7633d$export$be01c6bffeb93e87) return "[" + ($308f9765feb7633d$export$2654b1b656d9a957(v.value0) + "]!");
    if (v instanceof $308f9765feb7633d$export$a9668a4ddbf1d475 && v.value0 instanceof $308f9765feb7633d$export$a9668a4ddbf1d475) return $308f9765feb7633d$export$2654b1b656d9a957(v.value0);
    throw new Error("Failed pattern match at GraphQL.Type (line 13, column 1 - line 13, column 32): " + [
        v.constructor.name
    ]);
};
var $308f9765feb7633d$export$d421f47a1b0c8424 = function(dictIsSymbol) {
    var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
    return {
        gqlType: function(v) {
            return new $308f9765feb7633d$export$c76991cd6baf9718(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
        }
    };
};
var $308f9765feb7633d$export$eb1b128a19ff6c25 = /* #__PURE__ */ function() {
    return $308f9765feb7633d$export$d64ca3aab0d523a3.create;
}();
var $308f9765feb7633d$export$2a8f441cfb8aac76 = function(v) {
    return v.value0;
};
var $308f9765feb7633d$export$84864e2081a33895 = function(v) {
    return v.value0;
};
var $308f9765feb7633d$export$a1b0f5347d2470b = function(v) {
    return v.value0;
};
var $308f9765feb7633d$export$7fbebe4a88ae10b0 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("String");
    }
};
var $308f9765feb7633d$export$6d0edca6525afdd8 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("Int");
    }
};
var $308f9765feb7633d$export$f4150079df24c8b9 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("ID");
    }
};
var $308f9765feb7633d$export$bf0d17565ddf5b30 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("Float");
    }
};
var $308f9765feb7633d$export$69fadc0d160dfd2e = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("Boolean");
    }
};
var $308f9765feb7633d$export$48536db2648307e4 = function(dict) {
    return dict.gqlType;
};
var $308f9765feb7633d$export$7cf8ddfc8d49148b = function(dictHasQType) {
    var gqlType1 = $308f9765feb7633d$export$48536db2648307e4(dictHasQType);
    return {
        gqlType: function(v) {
            return new $308f9765feb7633d$export$be01c6bffeb93e87(gqlType1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
        }
    };
};
var $308f9765feb7633d$export$9040d00d71e77b23 = function(dictHasQType) {
    var gqlType1 = $308f9765feb7633d$export$48536db2648307e4(dictHasQType);
    return {
        gqlType: function(v) {
            return new $308f9765feb7633d$export$a9668a4ddbf1d475(gqlType1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
        }
    };
};
var $308f9765feb7633d$export$b59da214efe27c07 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v.value0)(v1.value0);
            };
        }
    };
};
var $308f9765feb7633d$export$96ef298e3487e095 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqRNTY1 = $308f9765feb7633d$export$b59da214efe27c07(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v.value0)(v1.value0);
            };
        },
        Eq0: function() {
            return eqRNTY1;
        }
    };
};
var $308f9765feb7633d$export$1a7d8152a562d8fa = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v.value1)(v1.value1);
            };
        }
    };
};
var $308f9765feb7633d$export$e52c972e76e0a419 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqDYNT1 = $308f9765feb7633d$export$1a7d8152a562d8fa(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v.value1)(v1.value1);
            };
        },
        Eq0: function() {
            return eqDYNT1;
        }
    };
};
var $308f9765feb7633d$export$5acd5bea71910131 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return {
        encodeJson: function(v) {
            return encodeJson1(v.value0);
        }
    };
};
var $308f9765feb7633d$export$65249653a9a6562 = {
    encodeJson: function(v) {
        return $308f9765feb7633d$var$encodeJson(v.value0);
    }
};
var $308f9765feb7633d$export$39dc6bc3b041eb70 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return {
        encodeJson: function(v) {
            return encodeJson1(v.value1);
        }
    };
};
var $308f9765feb7633d$export$f5ab442a98b1cecf = /* #__PURE__ */ function() {
    return new $308f9765feb7633d$export$d64ca3aab0d523a3("-1");
}();
var $308f9765feb7633d$export$87708d888b4bc8a6 = function(v) {
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $308f9765feb7633d$export$f5ab442a98b1cecf;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.value0;
    throw new Error("Failed pattern match at GraphQL.Type (line 75, column 1 - line 75, column 58): " + [
        v.constructor.name
    ]);
};
var $308f9765feb7633d$export$3fdd9d25d69a77ef = function(dictDecodeJson) {
    var decodeJson = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return {
        decodeJson: function(json) {
            return $308f9765feb7633d$var$map($308f9765feb7633d$export$d64ca3aab0d523a3.create)(decodeJson(json));
        }
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16






// Generated by purs version 0.15.16

// Generated by purs version 0.15.16





// Generated by purs version 0.15.16
var $67e1952ff57566f7$export$bb801a161a3121f0 = function(dict) {
    return dict.callCC;
};


// Generated by purs version 0.15.16








// Generated by purs version 0.15.16
function $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c(err) {
    return err.stack || err.toString();
}
function $ad2cf6904bca3ba1$export$a3bc9b8ed74fc(msg) {
    return new Error(msg);
}
function $ad2cf6904bca3ba1$export$d010f7d0d0793465(msg) {
    return function(cause) {
        return new Error(msg, {
            cause: cause
        });
    };
}
function $ad2cf6904bca3ba1$export$afd88dc4d34c0903(msg) {
    return function(name) {
        const e = new Error(msg);
        e.name = name;
        return e;
    };
}
function $ad2cf6904bca3ba1$export$a8ecead220dd38a6(e) {
    return e.message;
}
function $ad2cf6904bca3ba1$export$a8ff84c12d48cfa6(e) {
    return e.name || "Error";
}
function $ad2cf6904bca3ba1$export$c159e25936a96837(just) {
    return function(nothing) {
        return function(e) {
            return e.stack ? just(e.stack) : nothing;
        };
    };
}
function $ad2cf6904bca3ba1$export$de0c4a986b439e52(e) {
    return function() {
        throw e;
    };
}
function $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(c) {
    return function(t) {
        return function() {
            try {
                return t();
            } catch (e) {
                if (e instanceof Error || Object.prototype.toString.call(e) === "[object Error]") return c(e)();
                else return c(new Error(e.toString()))();
            }
        };
    };
}







var $4e52402d7134c8bb$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $4e52402d7134c8bb$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $4e52402d7134c8bb$export$410a452afcd48948 = function(action) {
    return $ad2cf6904bca3ba1$export$d49c1c6bf2cedce5(function($3) {
        return $4e52402d7134c8bb$var$pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($3));
    })($4e52402d7134c8bb$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(action));
};
var $4e52402d7134c8bb$export$7b1a37e4f0fe815 = function($4) {
    return $ad2cf6904bca3ba1$export$de0c4a986b439e52($ad2cf6904bca3ba1$export$a3bc9b8ed74fc($4));
};
var $4e52402d7134c8bb$export$a57ab32f40f83ea9 = /* #__PURE__ */ function() {
    return $ad2cf6904bca3ba1$export$c159e25936a96837($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $4e52402d7134c8bb$export$3879b24e8245693d = {
    show: $ad2cf6904bca3ba1$export$e49cfe3e3ab3c67c
};


var $5dfefa023749ded0$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $5dfefa023749ded0$export$8bf7aba4a9e09055 = function(dict) {
    return dict.throwError;
};
var $5dfefa023749ded0$export$fff877a725e9aba1 = /* #__PURE__ */ function() {
    return {
        throwError: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Monad0: function() {
            return $06733ae99ed4f534$export$f78a1c2d38efcc13;
        }
    };
}();
var $5dfefa023749ded0$export$390154ec55cffb04 = /* #__PURE__ */ function() {
    return {
        throwError: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        Monad0: function() {
            return $7d4cccdf062a2261$export$b3b4ecb28e3a8df3;
        }
    };
}();
var $5dfefa023749ded0$export$e4992fc673e7b027 = {
    throwError: $ad2cf6904bca3ba1$export$de0c4a986b439e52,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $5dfefa023749ded0$export$438e6a8af9a8a22d = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1($05149ea687d6b460$export$523c0b569236b342);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 79, column 1 - line 81, column 33): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$fff877a725e9aba1;
    }
};
var $5dfefa023749ded0$export$abb16404f142771a = {
    catchError: function(v) {
        return function(v1) {
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1(v.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
            throw new Error("Failed pattern match at Control.Monad.Error.Class (line 72, column 1 - line 74, column 35): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$390154ec55cffb04;
    }
};
var $5dfefa023749ded0$export$434b8bb3cd954f77 = {
    catchError: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f($ad2cf6904bca3ba1$export$d49c1c6bf2cedce5),
    MonadThrow0: function() {
        return $5dfefa023749ded0$export$e4992fc673e7b027;
    }
};
var $5dfefa023749ded0$export$1cf01ae67112be7b = function(dictMonadThrow) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0());
    return function(error) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(throwError1(error))(pure);
    };
};
var $5dfefa023749ded0$export$bd6bd7bb5418f998 = function(dictMonadThrow) {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow))($c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadThrow.Monad0().Applicative0()));
};
var $5dfefa023749ded0$export$3dede90624df3ba9 = function(dict) {
    return dict.catchError;
};
var $5dfefa023749ded0$export$b726b0cdf642257a = function(dictMonadError) {
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadError.MonadThrow0());
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    return function(p) {
        return function(act) {
            return function(handler) {
                var handle = function(e) {
                    var v = p(e);
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return throwError1(e);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return handler(v.value0);
                    throw new Error("Failed pattern match at Control.Monad.Error.Class (line 57, column 5 - line 59, column 26): " + [
                        v.constructor.name
                    ]);
                };
                return catchError1(act)(handle);
            };
        };
    };
};
var $5dfefa023749ded0$export$410a452afcd48948 = function(dictMonadError) {
    var catchError1 = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var Monad0 = dictMonadError.MonadThrow0().Monad0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(a) {
        return catchError1(map($7d4cccdf062a2261$export$19db0165690c701a.create)(a))(function($52) {
            return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($52));
        });
    };
};
var $5dfefa023749ded0$export$8f240c41514f3a3e = function(dictMonadError) {
    var MonadThrow0 = dictMonadError.MonadThrow0();
    var Monad0 = MonadThrow0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var try1 = $5dfefa023749ded0$export$410a452afcd48948(dictMonadError);
    var discard1 = $5dfefa023749ded0$var$discard(Bind1);
    var throwError1 = $5dfefa023749ded0$export$8bf7aba4a9e09055(MonadThrow0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(acquire) {
        return function(release) {
            return function(kleisli) {
                return bind(acquire)(function(resource) {
                    return bind(try1(kleisli(resource)))(function(result) {
                        return discard1(release(resource))(function() {
                            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(throwError1)(pure)(result);
                        });
                    });
                });
            };
        };
    };
};


// Generated by purs version 0.15.16




var $74738728c27df511$export$97f42efbb325fef6 = {
    ask: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $d3d065da31679be1$export$513f938006a06509;
    }
};
var $74738728c27df511$export$487d42cd354774ee = {
    local: /* #__PURE__ */ $5807467a73465f3c$export$b5a9558a7176e41b($5807467a73465f3c$export$3af17640bddf7212),
    MonadAsk0: function() {
        return $74738728c27df511$export$97f42efbb325fef6;
    }
};
var $74738728c27df511$export$3bf5078b16209b91 = function(dict) {
    return dict.local;
};
var $74738728c27df511$export$1b4aee0b51c3def8 = function(dict) {
    return dict.ask;
};
var $74738728c27df511$export$5551e829c4b2a916 = function(dictMonadAsk) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonadAsk.Monad0().Bind1().Apply0().Functor0());
    var ask1 = $74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk);
    return function(f) {
        return map(f)(ask1);
    };
};



// Generated by purs version 0.15.16

// Generated by purs version 0.15.16

var $2b857e558a2a0921$export$2bf63e57346d9602 = $ac8b3532514ac019$export$401372c57776dc;




var $dd1bd2cc217b6a6d$export$162690b6fa074d8b = {
    liftST: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $08944f7287e2704c$export$962073314682c2c;
    }
};
var $dd1bd2cc217b6a6d$export$d1b56b21630310a5 = {
    liftST: $2b857e558a2a0921$export$2bf63e57346d9602,
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $dd1bd2cc217b6a6d$export$90556654c9c47d5f = function(dict) {
    return dict.liftST;
};


// Generated by purs version 0.15.16


var $f2d5035ce6148af6$export$ca000e230c0caa3e = function(dict) {
    return dict.state;
};
var $f2d5035ce6148af6$export$327f7b26ebf455db = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(s) {
        return state1(function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, s);
        });
    };
};
var $f2d5035ce6148af6$export$45b91115a89d6020 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($05149ea687d6b460$export$523c0b569236b342, f(s));
        });
    };
};
var $f2d5035ce6148af6$export$3ff57735a52b8713 = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            var s$prime = f(s);
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(s$prime, s$prime);
        });
    };
};
var $f2d5035ce6148af6$export$49487f6cbb79019d = function(dictMonadState) {
    var state1 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    return function(f) {
        return state1(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(s), s);
        });
    };
};
var $f2d5035ce6148af6$export$3988ae62b71be9a3 = function(dictMonadState) {
    return $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState)(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(s, s);
    });
};


// Generated by purs version 0.15.16
var $384c24655e07f36c$export$590e8b2c435046d9 = function(dict) {
    return dict.lift;
};


// Generated by purs version 0.15.16



var $2c4a247071255d7e$export$de3113ed932c61ab = function(dict) {
    return dict.tell;
};
var $2c4a247071255d7e$export$167b0ad523238611 = function(dict) {
    return dict.pass;
};
var $2c4a247071255d7e$export$63174c828edd6ff8 = function(dict) {
    return dict.listen;
};
var $2c4a247071255d7e$export$e63807bfd37abcc0 = function(dictMonadWriter) {
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen1 = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return bind(listen1(m))(function(v) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, f(v.value1)));
            });
        };
    };
};
var $2c4a247071255d7e$export$b0a417369eddf9f2 = function(dictMonadWriter) {
    var pass1 = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monad1 = dictMonadWriter.MonadTell1().Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    return function(f) {
        return function(m) {
            return pass1(bind(m)(function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, f));
            }));
        };
    };
};







// Generated by purs version 0.15.16


var $f2c9b767d25cfbb9$export$86a2e24932ca2aa0 = {
    liftEffect: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    Monad0: function() {
        return $6c2f8951ecf9531e$export$7e900d895707a1af;
    }
};
var $f2c9b767d25cfbb9$export$34255e15eb56d2b3 = function(dict) {
    return dict.liftEffect;
};


var $d2284b2d3e1b6f87$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $d2284b2d3e1b6f87$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d2284b2d3e1b6f87$export$2e7afd25df37516b = function(x) {
    return x;
};
var $d2284b2d3e1b6f87$export$998a9a780731dd5b = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            var mapLeft = function(v1) {
                return function(v2) {
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0);
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1(v2.value0));
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 43, column 3 - line 43, column 32): " + [
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
            return map1(mapLeft(f))(v);
        };
    };
};
var $d2284b2d3e1b6f87$export$8291c2122093ac93 = function(v) {
    return v;
};
var $d2284b2d3e1b6f87$export$779e60e46c1e0f8b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d2284b2d3e1b6f87$export$fa93accd6d6dc1d2 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return bind(m)(function(a) {
                return pure(new $7d4cccdf062a2261$export$19db0165690c701a(a));
            });
        };
    }
};
var $d2284b2d3e1b6f87$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d2284b2d3e1b6f87$export$d684c62fe584fcfa = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map1($d2284b2d3e1b6f87$var$map(f)));
        }
    };
};
var $d2284b2d3e1b6f87$export$67aba9fb222c5e1d = function(dictApplicative) {
    var $191 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function($192) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($191($192));
    };
};
var $d2284b2d3e1b6f87$export$5a198347e9244c74 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        },
        Bind1: function() {
            return $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($193) {
                    return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($193));
                })(function(a) {
                    var v1 = k(a);
                    return v1;
                }));
            };
        },
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$581feac922061bf0 = function(dictMonad) {
    var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad)),
        Functor0: function() {
            return functorExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$963960a96c103d2f = function(dictMonad) {
    return {
        pure: function() {
            var $194 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($195) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($194($7d4cccdf062a2261$export$19db0165690c701a.create($195)));
            };
        }(),
        Apply0: function() {
            return $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        }
    };
};
var $d2284b2d3e1b6f87$export$3539db811b3307bc = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $d2284b2d3e1b6f87$export$90c373eb83297b8e = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        ask: $d2284b2d3e1b6f87$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fb6edd8453289893 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskExceptT1 = $d2284b2d3e1b6f87$export$90c373eb83297b8e(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(local(f));
        },
        MonadAsk0: function() {
            return monadAskExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$aed911633663c3d8 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $7d4cccdf062a2261$export$19db0165690c701a(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$14ff7e4e497a86b1 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftEffect: function() {
            var $196 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $197 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($198) {
                return $196($197($198));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$fed8f4223a283613 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        tailRecM: function(f) {
            var $199 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$37c4d04eafdc5515(m$prime.value0));
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $7d4cccdf062a2261$export$19db0165690c701a && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $7d4cccdf062a2261$export$19db0165690c701a(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 75, column 14 - line 78, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($200) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($199($200));
            };
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$e8228b6b505171fd = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $d2284b2d3e1b6f87$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad1);
    return {
        tell: function() {
            var $201 = $d2284b2d3e1b6f87$var$lift(Monad1);
            var $202 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($203) {
                return $201($202($203));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$a9c9aad9aca5566b = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellExceptT1 = $d2284b2d3e1b6f87$export$7a7c2ab3eaa0a3e9(MonadTell1);
    return {
        listen: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return bind(listen(m))(function(v) {
                return pure($d2284b2d3e1b6f87$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$37c4d04eafdc5515(a.value0), $d2284b2d3e1b6f87$var$identity);
                    if (a instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $7d4cccdf062a2261$export$19db0165690c701a(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 135, column 10 - line 137, column 45): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$75f89ba5e7a712b0 = function(dictMonad) {
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
    return {
        throwError: function() {
            var $204 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($205) {
                return $d2284b2d3e1b6f87$export$2e7afd25df37516b($204($7d4cccdf062a2261$export$37c4d04eafdc5515.create($205)));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$78c1353d784c47dd = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadThrowExceptT1 = $d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad);
    return {
        catchError: function(v) {
            return function(k) {
                return bind(v)($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(a) {
                    var v1 = k(a);
                    return v1;
                })(function($206) {
                    return pure($7d4cccdf062a2261$export$19db0165690c701a.create($206));
                }));
            };
        },
        MonadThrow0: function() {
            return monadThrowExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$5b1239aace2566fd = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(Monad0);
    return {
        liftST: function() {
            var $207 = $d2284b2d3e1b6f87$var$lift(Monad0);
            var $208 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Monad0: function() {
            return monadExceptT1;
        }
    };
};
var $d2284b2d3e1b6f87$export$9a16ccee20eb55ce = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var semigroupExceptT1 = $d2284b2d3e1b6f87$export$3539db811b3307bc(dictMonad);
    return function(dictMonoid) {
        var semigroupExceptT2 = semigroupExceptT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictMonad) {
        var Bind1 = dictMonad.Bind1();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var functorExceptT1 = $d2284b2d3e1b6f87$export$d684c62fe584fcfa(Bind1.Apply0().Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return bind(v)(function(rm) {
                        if (rm instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rm.value0));
                        if (rm instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return bind(v1)(function(rn) {
                            if (rn instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure(new $7d4cccdf062a2261$export$19db0165690c701a(rn.value0));
                            if (rn instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(append(rm.value0)(rn.value0)));
                            throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 87, column 9 - line 89, column 49): " + [
                                rn.constructor.name
                            ]);
                        });
                        throw new Error("Failed pattern match at Control.Monad.Except.Trans (line 83, column 5 - line 89, column 49): " + [
                            rm.constructor.name
                        ]);
                    });
                };
            },
            Functor0: function() {
                return functorExceptT1;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var altExceptT1 = $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var altExceptT2 = altExceptT1(dictMonad);
        return {
            empty: $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad))(mempty),
            Alt0: function() {
                return altExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$bfd291e36e6170e5 = function(dictMonoid) {
    var plusExceptT1 = $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMonad) {
        var applicativeExceptT1 = $d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad);
        var plusExceptT2 = plusExceptT1(dictMonad);
        return {
            Applicative0: function() {
                return applicativeExceptT1;
            },
            Plus1: function() {
                return plusExceptT2;
            }
        };
    };
};
var $d2284b2d3e1b6f87$export$2b1e74d8588fcb7c = function(dictMonoid) {
    var alternativeExceptT1 = $d2284b2d3e1b6f87$export$bfd291e36e6170e5(dictMonoid);
    return function(dictMonad) {
        var monadExceptT1 = $d2284b2d3e1b6f87$export$5a198347e9244c74(dictMonad);
        var alternativeExceptT2 = alternativeExceptT1(dictMonad);
        return {
            Monad0: function() {
                return monadExceptT1;
            },
            Alternative1: function() {
                return alternativeExceptT2;
            }
        };
    };
};


// Generated by purs version 0.15.16















var $712b2df71ce372f8$export$6950f537d8cb5965 = /* #__PURE__ */ function() {
    function RWSResult(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RWSResult.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RWSResult(value0, value1, value2);
            };
        };
    };
    return RWSResult;
}();
var $712b2df71ce372f8$export$f3fc26d039f92fdf = function(x) {
    return x;
};
var $712b2df71ce372f8$export$82c3159babd6b403 = function(f) {
    return function(m) {
        return function(r) {
            return function(s) {
                return $71f2e2e9476163f8$export$7864d59d01b6d6bf(m)(f(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$4c8676657688a1cd = function(v) {
    return v;
};
var $712b2df71ce372f8$export$7bded133c80fee1b = {
    Coercible0: function() {
        return undefined;
    }
};
var $712b2df71ce372f8$export$1d2bc64ff0e647b4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return function(v) {
                    return function(s) {
                        return bind(m)(function(a) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        });
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$b3b7a52c4baabcad = function(f) {
    return function(v) {
        return function(r) {
            return function(s) {
                return f(v(r)(s));
            };
        };
    };
};
var $712b2df71ce372f8$export$ab4be9af97c7111d = {
    defer: function(f) {
        return function(r) {
            return function(s) {
                var v = f($05149ea687d6b460$export$523c0b569236b342);
                return v(r)(s);
            };
        };
    }
};
var $712b2df71ce372f8$export$799f7a47278c4ab2 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return map(function(v1) {
                            return new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value0, f(v1.value1), v1.value2);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $712b2df71ce372f8$export$8f895b27f6bea35a = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$9492f7142a7c6dda = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(v) {
        return function(r) {
            return function(s) {
                return bind(v(r)(s))(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1, v1.value2));
                });
            };
        };
    };
};
var $712b2df71ce372f8$export$3f72b7b9b643060e = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var Functor0 = dictBind.Apply0().Functor0();
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(Functor0);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(Functor0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        return {
            apply: function(v) {
                return function(v1) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v2) {
                                return mapFlipped(v1(r)(v2.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v2.value1(v3.value1), append(v2.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Functor0: function() {
                return functorRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$ecf0616f2cad1379 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictBind.Apply0().Functor0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            bind: function(v) {
                return function(f) {
                    return function(r) {
                        return function(s) {
                            return bind(v(r)(s))(function(v1) {
                                var v2 = f(v1.value1);
                                return mapFlipped(v2(r)(v1.value0))(function(v3) {
                                    return new $712b2df71ce372f8$export$6950f537d8cb5965(v3.value0, v3.value1, append(v1.value2)(v3.value2));
                                });
                            });
                        };
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$863b3ca33677d9b2 = function(dictBind) {
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictBind);
    return function(dictMonoid) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(applyRWST1(dictMonoid));
        return function(dictSemigroup) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
            };
        };
    };
};
var $712b2df71ce372f8$export$b7ffaf6687c91068 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var applyRWST1 = $712b2df71ce372f8$export$3f72b7b9b643060e(dictMonad.Bind1());
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var applyRWST2 = applyRWST1(dictMonoid);
        return {
            pure: function(a) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                    };
                };
            },
            Apply0: function() {
                return applyRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$3addf8bc39ac949f = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var bindRWST1 = $712b2df71ce372f8$export$ecf0616f2cad1379(dictMonad.Bind1());
    return function(dictMonoid) {
        var applicativeRWST2 = applicativeRWST1(dictMonoid);
        var bindRWST2 = bindRWST1(dictMonoid);
        return {
            Applicative0: function() {
                return applicativeRWST2;
            },
            Bind1: function() {
                return bindRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$b3a6ad9a80cd89aa = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            ask: function(r) {
                return function(s) {
                    return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, r, mempty));
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$149b7da9e90e1eac = function(dictMonad) {
    var monadAskRWST1 = $712b2df71ce372f8$export$b3a6ad9a80cd89aa(dictMonad);
    return function(dictMonoid) {
        var monadAskRWST2 = monadAskRWST1(dictMonoid);
        return {
            local: function(f) {
                return function(m) {
                    return function(r) {
                        return function(s) {
                            return m(f(r))(s);
                        };
                    };
                };
            },
            MonadAsk0: function() {
                return monadAskRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$1947b5c08efdf68f = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftEffect: function() {
                var $284 = lift(Monad0);
                var $285 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($286) {
                    return $284($285($286));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$858b449733703d7f = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tailRecM: function(k) {
                return function(a) {
                    var k$prime = function(r) {
                        return function(v) {
                            var v1 = k(v.value1);
                            return bind(v1(r)(v.value0))(function(v2) {
                                return pure(function() {
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    if (v2.value1 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $712b2df71ce372f8$export$6950f537d8cb5965(v2.value0, v2.value1.value0, append(v.value2)(v2.value2)));
                                    throw new Error("Failed pattern match at Control.Monad.RWS.Trans (line 129, column 16 - line 131, column 68): " + [
                                        v2.value1.constructor.name
                                    ]);
                                }());
                            });
                        };
                    };
                    return function(r) {
                        return function(s) {
                            return tailRecM(k$prime(r))(new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty));
                        };
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$c835aca1626da706 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            state: function(f) {
                return function(v) {
                    return function(s) {
                        var v1 = f(s);
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v1.value1, v1.value0, mempty));
                    };
                };
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$5538632dd3cd70cc = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(dictMonad);
    return function(dictMonoid) {
        var Semigroup0 = dictMonoid.Semigroup0();
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            tell: function(w) {
                return function(v) {
                    return function(s) {
                        return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(s, $05149ea687d6b460$export$523c0b569236b342, w));
                    };
                };
            },
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$d26d81ccbf9cc981 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadTellRWST1 = $712b2df71ce372f8$export$5538632dd3cd70cc(dictMonad);
    return function(dictMonoid) {
        var monadTellRWST2 = monadTellRWST1(dictMonoid);
        return {
            listen: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1, v.value2), v.value2));
                        });
                    };
                };
            },
            pass: function(m) {
                return function(r) {
                    return function(s) {
                        return bind(m(r)(s))(function(v) {
                            return pure(new $712b2df71ce372f8$export$6950f537d8cb5965(v.value0, v.value1.value0, v.value1.value1(v.value2)));
                        });
                    };
                };
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$9d857fb7268a3f42 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0);
    return function(dictMonoid) {
        var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
        var monadRWST2 = monadRWST1(dictMonoid);
        return {
            throwError: function(e) {
                return lift(throwError(e));
            },
            Monad0: function() {
                return monadRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$f1aa4e7ce0e20856 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowRWST1 = $712b2df71ce372f8$export$9d857fb7268a3f42(dictMonadError.MonadThrow0());
    return function(dictMonoid) {
        var monadThrowRWST2 = monadThrowRWST1(dictMonoid);
        return {
            catchError: function(m) {
                return function(h) {
                    return function(r) {
                        return function(s) {
                            return catchError(m(r)(s))(function(e) {
                                var v = h(e);
                                return v(r)(s);
                            });
                        };
                    };
                };
            },
            MonadThrow0: function() {
                return monadThrowRWST2;
            }
        };
    };
};
var $712b2df71ce372f8$export$fa98ca5d27201430 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadRWST1 = $712b2df71ce372f8$export$3addf8bc39ac949f(Monad0)(dictMonoid);
        return {
            liftST: function() {
                var $287 = lift(Monad0);
                var $288 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($289) {
                    return $287($288($289));
                };
            }(),
            Monad0: function() {
                return monadRWST1;
            }
        };
    };
};
var $712b2df71ce372f8$export$83c8cfee0365f931 = function(dictMonad) {
    var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad);
    var semigroupRWST1 = $712b2df71ce372f8$export$863b3ca33677d9b2(dictMonad.Bind1());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(applicativeRWST1(dictMonoid));
        var semigroupRWST2 = semigroupRWST1(dictMonoid);
        return function(dictMonoid1) {
            var semigroupRWST3 = semigroupRWST2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupRWST3;
                }
            };
        };
    };
};
var $712b2df71ce372f8$export$cfb751420c588279 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorRWST1 = $712b2df71ce372f8$export$799f7a47278c4ab2(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return function(s) {
                        return alt(v(r)(s))(v1(r)(s));
                    };
                };
            };
        },
        Functor0: function() {
            return functorRWST1;
        }
    };
};
var $712b2df71ce372f8$export$6179beba56f1d9b2 = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altRWST1 = $712b2df71ce372f8$export$cfb751420c588279(dictPlus.Alt0());
    return {
        empty: function(v) {
            return function(v1) {
                return empty;
            };
        },
        Alt0: function() {
            return altRWST1;
        }
    };
};
var $712b2df71ce372f8$export$26aad7e9ffabe87b = function(dictMonoid) {
    return function(dictAlternative) {
        var plusRWST1 = $712b2df71ce372f8$export$6179beba56f1d9b2(dictAlternative.Plus1());
        return function(dictMonad) {
            var applicativeRWST1 = $712b2df71ce372f8$export$b7ffaf6687c91068(dictMonad)(dictMonoid);
            return {
                Applicative0: function() {
                    return applicativeRWST1;
                },
                Plus1: function() {
                    return plusRWST1;
                }
            };
        };
    };
};


// Generated by purs version 0.15.16













// Generated by purs version 0.15.16






// Generated by purs version 0.15.16
var $ae8714ffa2598cf8$var$To = function(x) {
    return x;
};
var $ae8714ffa2598cf8$var$From = function(x) {
    return x;
};
var $ae8714ffa2598cf8$export$9fc2f52ae8ba6578 = {
    proof: function(a) {
        return a;
    },
    Coercible0: function() {
        return undefined;
    }
};
var $ae8714ffa2598cf8$export$3d466392f5188420 = function(dict) {
    return dict.proof;
};
var $ae8714ffa2598cf8$export$2c618a4308a30424 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};
var $ae8714ffa2598cf8$export$6788812c4e6611e6 = function(dictTypeEquals) {
    var v = $ae8714ffa2598cf8$export$3d466392f5188420(dictTypeEquals)(function(a) {
        return a;
    });
    return v;
};


var $3ce830dde03d3389$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $3ce830dde03d3389$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3ce830dde03d3389$export$c2a69422949c6b5c = {
    distribute: function(dictFunctor) {
        var $34 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($3ce830dde03d3389$var$unwrap);
        return function($35) {
            return $50c50d1f444e5fa4$export$544bf02140fa9a77($34($35));
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $36 = map(function($38) {
                return $3ce830dde03d3389$var$unwrap(f($38));
            });
            return function($37) {
                return $50c50d1f444e5fa4$export$544bf02140fa9a77($36($37));
            };
        };
    },
    Functor0: function() {
        return $50c50d1f444e5fa4$export$dc85e8383eafbd81;
    }
};
var $3ce830dde03d3389$export$f02a9ddbe4480f19 = function(dict) {
    return dict.distribute;
};
var $3ce830dde03d3389$export$31ac6c2237b1bf1b = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return function(e) {
                return map(function(v) {
                    return v(e);
                })(a);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $39 = $3ce830dde03d3389$export$f02a9ddbe4480f19($3ce830dde03d3389$export$31ac6c2237b1bf1b)(dictFunctor);
            var $40 = map(f);
            return function($41) {
                return $39($40($41));
            };
        };
    },
    Functor0: function() {
        return $f4b2eb11fc32ed34$export$11c8d16a3c15d11b;
    }
};
var $3ce830dde03d3389$export$e6005abdfe1aac80 = function(dictDistributive) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictDistributive.Functor0());
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        return function(f) {
            var $42 = map(f);
            return function($43) {
                return $42(distribute2($43));
            };
        };
    };
};
var $3ce830dde03d3389$export$2d5a930f1676b9b7 = function(dictDistributive) {
    var distribute1 = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive);
    return function(dictFunctor) {
        var distribute2 = distribute1(dictFunctor);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $44 = map(f);
            return function($45) {
                return distribute2($44($45));
            };
        };
    };
};
var $3ce830dde03d3389$export$76df48f9f3fb8eb1 = function(dictTypeEquals) {
    var from = $ae8714ffa2598cf8$export$6788812c4e6611e6(dictTypeEquals);
    return {
        collect: function(dictFunctor) {
            return $3ce830dde03d3389$export$2d5a930f1676b9b7($3ce830dde03d3389$export$76df48f9f3fb8eb1(dictTypeEquals))(dictFunctor);
        },
        distribute: function(dictFunctor) {
            var $46 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(from($05149ea687d6b460$export$523c0b569236b342));
            var $47 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor)($71f2e2e9476163f8$export$6f71268a1666ab58);
            return function($48) {
                return $46($47($48));
            };
        },
        Functor0: function() {
            return $71f2e2e9476163f8$export$19ab04734dcb0ff0;
        }
    };
};
var $3ce830dde03d3389$export$bb44f104e3c54dae = function(dict) {
    return dict.collect;
};
var $3ce830dde03d3389$export$f13cbf7f76d41467 = function(dictDistributive) {
    var collect1 = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    return function(dictFunctor) {
        return collect1(dictFunctor)($3ce830dde03d3389$var$identity);
    };
};







var $848780da1bf26d9d$export$ea3c61b219e01d1e = function(x) {
    return x;
};
var $848780da1bf26d9d$export$36ee99cc8d1d67c9 = function(f) {
    return function(v) {
        return function($152) {
            return v(f($152));
        };
    };
};
var $848780da1bf26d9d$export$f356de2c51baae29 = function(v) {
    return v;
};
var $848780da1bf26d9d$export$f52dceb6bbe9cc1f = {
    Coercible0: function() {
        return undefined;
    }
};
var $848780da1bf26d9d$export$95510d0cd7e6e7eb = {
    lift: function(dictMonad) {
        return function($153) {
            return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($153));
        };
    }
};
var $848780da1bf26d9d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $848780da1bf26d9d$export$1b8048a192a96779 = function(f) {
    return function(v) {
        return function($154) {
            return f(v($154));
        };
    };
};
var $848780da1bf26d9d$export$9ef8da126720992c = function(dictFunctor) {
    return {
        map: function() {
            var $155 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function($156) {
                return $848780da1bf26d9d$export$1b8048a192a96779($155($156));
            };
        }()
    };
};
var $848780da1bf26d9d$export$4b73f9411376f1b4 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(a) {
                return function(e) {
                    return collect1(function(r) {
                        return r(e);
                    })(a);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $157 = $3ce830dde03d3389$export$f02a9ddbe4480f19($848780da1bf26d9d$export$4b73f9411376f1b4(dictDistributive))(dictFunctor);
                var $158 = map(f);
                return function($159) {
                    return $157($158($159));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$fee188993a7996b7 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(r) {
                    return apply(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$4255fb962d7d3c76 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(r) {
                    return bind(v(r))(function(a) {
                        var v1 = k(a);
                        return v1(r);
                    });
                };
            };
        },
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$12572275428491c2 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($848780da1bf26d9d$export$fee188993a7996b7(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $848780da1bf26d9d$export$aef633589549fee0 = function(dictApplicative) {
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictApplicative.Apply0());
    return {
        pure: function() {
            var $160 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($161) {
                return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($160($161)));
            };
        }(),
        Apply0: function() {
            return applyReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$6f721f6865c71dd2 = function(dictMonad) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictMonad.Applicative0());
    var bindReaderT1 = $848780da1bf26d9d$export$4255fb962d7d3c76(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Bind1: function() {
            return bindReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1fc6951fa9cc0730 = function(dictMonad) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonad);
    return {
        ask: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$202df576a32d0b15 = function(dictMonad) {
    var monadAskReaderT1 = $848780da1bf26d9d$export$1fc6951fa9cc0730(dictMonad);
    return {
        local: $848780da1bf26d9d$export$36ee99cc8d1d67c9,
        MonadAsk0: function() {
            return monadAskReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$9f6c922afb6673fe = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(r) {
                return callCC(function(c) {
                    var v = f(function($162) {
                        return $848780da1bf26d9d$export$ea3c61b219e01d1e($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(c($162)));
                    });
                    return v(r);
                });
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$a554ebf369a3f56d = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftEffect: function() {
            var $163 = $848780da1bf26d9d$var$lift(Monad0);
            var $164 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($165) {
                return $163($164($165));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$b063aaccf75fba13 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bindFlipped = $70cd3177464e7915$export$f2077a1c19a006d9(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        tailRecM: function(k) {
            return function(a) {
                var k$prime = function(r) {
                    return function(a$prime) {
                        var v = k(a$prime);
                        return bindFlipped(pure)(v(r));
                    };
                };
                return function(r) {
                    return tailRecM(k$prime(r))(a);
                };
            };
        },
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$48d7aff14d826a4f = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        state: function() {
            var $166 = $848780da1bf26d9d$var$lift(Monad0);
            var $167 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($168) {
                return $166($167($168));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$ab1235cf7f047d07 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad1);
    return {
        tell: function() {
            var $169 = $848780da1bf26d9d$var$lift(Monad1);
            var $170 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($171) {
                return $169($170($171));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$662fa4b34fb6720c = function(dictMonadWriter) {
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellReaderT1 = $848780da1bf26d9d$export$ab1235cf7f047d07(dictMonadWriter.MonadTell1());
    return {
        listen: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter)),
        pass: $848780da1bf26d9d$export$1b8048a192a96779($2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter)),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$1b067e2856bff729 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        throwError: function() {
            var $172 = $848780da1bf26d9d$var$lift(Monad0);
            var $173 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$484cd3c856ffc7 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowReaderT1 = $848780da1bf26d9d$export$1b067e2856bff729(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(r) {
                    return catchError(v(r))(function(e) {
                        var v1 = h(e);
                        return v1(r);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$162b6a611607bf69 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(Monad0);
    return {
        liftST: function() {
            var $175 = $848780da1bf26d9d$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$df55f2197442fd9 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($848780da1bf26d9d$export$aef633589549fee0(dictApplicative));
    var semigroupReaderT1 = $848780da1bf26d9d$export$12572275428491c2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupReaderT2 = semigroupReaderT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupReaderT2;
            }
        };
    };
};
var $848780da1bf26d9d$export$32cadcb66dd98ef3 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorReaderT1 = $848780da1bf26d9d$export$9ef8da126720992c(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(r) {
                    return alt(v(r))(v1(r));
                };
            };
        },
        Functor0: function() {
            return functorReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$97f8c30f9c69a13c = function(dictPlus) {
    var altReaderT1 = $848780da1bf26d9d$export$32cadcb66dd98ef3(dictPlus.Alt0());
    return {
        empty: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus)),
        Alt0: function() {
            return altReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$8bebb77f5bc043a9 = function(dictAlternative) {
    var applicativeReaderT1 = $848780da1bf26d9d$export$aef633589549fee0(dictAlternative.Applicative0());
    var plusReaderT1 = $848780da1bf26d9d$export$97f8c30f9c69a13c(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeReaderT1;
        },
        Plus1: function() {
            return plusReaderT1;
        }
    };
};
var $848780da1bf26d9d$export$3772d6c9d5f8e735 = function(dictMonadPlus) {
    var monadReaderT1 = $848780da1bf26d9d$export$6f721f6865c71dd2(dictMonadPlus.Monad0());
    var alternativeReaderT1 = $848780da1bf26d9d$export$8bebb77f5bc043a9(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadReaderT1;
        },
        Alternative1: function() {
            return alternativeReaderT1;
        }
    };
};


// Generated by purs version 0.15.16




















var $e9bda291f4ec10ec$export$73ce73bddfe2800a = function(x) {
    return x;
};
var $e9bda291f4ec10ec$export$72aea7109e8312dd = function(f) {
    return function(v) {
        return function($199) {
            return v(f($199));
        };
    };
};
var $e9bda291f4ec10ec$export$c5ba8a89d9140c32 = function(v) {
    return v;
};
var $e9bda291f4ec10ec$export$dce35699eedd4739 = {
    Coercible0: function() {
        return undefined;
    }
};
var $e9bda291f4ec10ec$export$5e0a9e9fea50cb88 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        return function(m) {
            return function(s) {
                return bind(m)(function(x) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(x, s));
                });
            };
        };
    }
};
var $e9bda291f4ec10ec$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $e9bda291f4ec10ec$export$8342df5ddac360cd = function(f) {
    return function(v) {
        return function($200) {
            return f(v($200));
        };
    };
};
var $e9bda291f4ec10ec$export$dce43013fc3a5fe1 = {
    defer: function(f) {
        return function(s) {
            var v = f($05149ea687d6b460$export$523c0b569236b342);
            return v(s);
        };
    }
};
var $e9bda291f4ec10ec$export$d5449d946db19e3a = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return function(s) {
                    return map(function(v1) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v1.value0), v1.value1);
                    })(v(s));
                };
            };
        }
    };
};
var $e9bda291f4ec10ec$export$193956ba360b7728 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$99aa49a66d7c0535 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return function(s) {
            return map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(v(s));
        };
    };
};
var $e9bda291f4ec10ec$export$345b4840c14ff10f = function(dictMonad) {
    return {
        Applicative0: function() {
            return $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
        },
        Bind1: function() {
            return $e9bda291f4ec10ec$export$f28534bdc7259c7(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$f28534bdc7259c7 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(s) {
                    return bind(v(s))(function(v1) {
                        var v3 = f(v1.value0);
                        return v3(v1.value1);
                    });
                };
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef = function(dictMonad) {
    var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad)),
        Functor0: function() {
            return functorStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$5cbc630d6fbe2e14 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        pure: function(a) {
            return function(s) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
            };
        },
        Apply0: function() {
            return $e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad);
        }
    };
};
var $e9bda291f4ec10ec$export$726f0b075e4f5d8b = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($e9bda291f4ec10ec$export$2ea3d0ecd25a5eef(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $e9bda291f4ec10ec$export$45bacc938270e8f5 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        ask: $e9bda291f4ec10ec$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$20f71c563c2e6d49 = function(dictMonadReader) {
    var monadAskStateT1 = $e9bda291f4ec10ec$export$45bacc938270e8f5(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $201 = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
            return function($202) {
                return $e9bda291f4ec10ec$export$8342df5ddac360cd($201($202));
            };
        }(),
        MonadAsk0: function() {
            return monadAskStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$2e498a385f8c30f1 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return function(s) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return function(s$prime) {
                            return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s$prime));
                        };
                    });
                    return v(s);
                });
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$cba9856135198781 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftEffect: function() {
            var $203 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $204 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($205) {
                return $203($204($205));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$ade5de830b656137 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        tailRecM: function(f) {
            return function(a) {
                var f$prime = function(v) {
                    var v1 = f(v.value0);
                    return bind(v1(v.value1))(function(v2) {
                        return pure(function() {
                            if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, v2.value1));
                            throw new Error("Failed pattern match at Control.Monad.State.Trans (line 88, column 16 - line 90, column 40): " + [
                                v2.value0.constructor.name
                            ]);
                        }());
                    });
                };
                return function(s) {
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s));
                };
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$fc3b89a546fa5c5c = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(dictMonad);
    return {
        state: function(f) {
            return function($206) {
                return pure(f($206));
            };
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$7fdbbf63ca644aa6 = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad1);
    return {
        tell: function() {
            var $207 = $e9bda291f4ec10ec$var$lift(Monad1);
            var $208 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($209) {
                return $207($208($209));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$f97520cd68688e2d = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellStateT1 = $e9bda291f4ec10ec$export$7fdbbf63ca644aa6(MonadTell1);
    return {
        listen: function(m) {
            return function(s) {
                return bind(listen(m(s)))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                });
            };
        },
        pass: function(m) {
            return function(s) {
                return pass(bind(m(s))(function(v) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, v.value1), v.value0.value1));
                }));
            };
        },
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$89cac97299cfdec2 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $e9bda291f4ec10ec$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$c2a2ecf63b1e47e2 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowStateT1 = $e9bda291f4ec10ec$export$89cac97299cfdec2(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(s) {
                    return catchError(v(s))(function(e) {
                        var v1 = h(e);
                        return v1(s);
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$e7c6f10a88f3ca17 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    return {
        liftST: function() {
            var $210 = $e9bda291f4ec10ec$var$lift(Monad0);
            var $211 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($212) {
                return $210($211($212));
            };
        }(),
        Monad0: function() {
            return monadStateT1;
        }
    };
};
var $e9bda291f4ec10ec$export$9d9b8c7bcee971bf = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad));
    var semigroupStateT1 = $e9bda291f4ec10ec$export$726f0b075e4f5d8b(dictMonad);
    return function(dictMonoid) {
        var semigroupStateT2 = semigroupStateT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d5bde0fdc0bca75b = function(dictMonad) {
    return function(dictAlt) {
        var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
        var functorStateT1 = $e9bda291f4ec10ec$export$d5449d946db19e3a(dictAlt.Functor0());
        return {
            alt: function(v) {
                return function(v1) {
                    return function(s) {
                        return alt(v(s))(v1(s));
                    };
                };
            },
            Functor0: function() {
                return functorStateT1;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$300a7627bf7b0e65 = function(dictMonad) {
    var altStateT1 = $e9bda291f4ec10ec$export$d5bde0fdc0bca75b(dictMonad);
    return function(dictPlus) {
        var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
        var altStateT2 = altStateT1(dictPlus.Alt0());
        return {
            empty: function(v) {
                return empty;
            },
            Alt0: function() {
                return altStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$d31747194ff6662e = function(dictMonad) {
    var applicativeStateT1 = $e9bda291f4ec10ec$export$5cbc630d6fbe2e14(dictMonad);
    var plusStateT1 = $e9bda291f4ec10ec$export$300a7627bf7b0e65(dictMonad);
    return function(dictAlternative) {
        var plusStateT2 = plusStateT1(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeStateT1;
            },
            Plus1: function() {
                return plusStateT2;
            }
        };
    };
};
var $e9bda291f4ec10ec$export$b08eeaf68c7005d9 = function(dictMonadPlus) {
    var Monad0 = dictMonadPlus.Monad0();
    var monadStateT1 = $e9bda291f4ec10ec$export$345b4840c14ff10f(Monad0);
    var alternativeStateT1 = $e9bda291f4ec10ec$export$d31747194ff6662e(Monad0)(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStateT1;
        },
        Alternative1: function() {
            return alternativeStateT1;
        }
    };
};


// Generated by purs version 0.15.16



















var $d9ef009191ddae40$export$6bef9d59f22e8880 = function(x) {
    return x;
};
var $d9ef009191ddae40$export$973e92d98e897dbf = function(v) {
    return v;
};
var $d9ef009191ddae40$export$d5b925da5ee69c31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d9ef009191ddae40$export$6b749a3db2c2aac6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        lift: function(dictMonad) {
            var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function(m) {
                return bind(m)(function(a) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                });
            };
        }
    };
};
var $d9ef009191ddae40$export$c950a71321ef1ffc = function(f) {
    return function(v) {
        return f(v);
    };
};
var $d9ef009191ddae40$export$502115c714790859 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return $d9ef009191ddae40$export$c950a71321ef1ffc(map(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v.value0), v.value1);
            }));
        }
    };
};
var $d9ef009191ddae40$export$730fbe746bee115d = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map($71f2e2e9476163f8$export$6f71268a1666ab58)(v);
    };
};
var $d9ef009191ddae40$export$2f46a8de9e2e0acc = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(dictApply) {
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
        var Functor0 = dictApply.Functor0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
        var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(Functor0);
        return {
            apply: function(v) {
                return function(v1) {
                    var k = function(v3) {
                        return function(v4) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0(v4.value0), append(v3.value1)(v4.value1));
                        };
                    };
                    return apply(map(k)(v))(v1);
                };
            },
            Functor0: function() {
                return functorWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$4483e5256f36d121 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup);
    return function(dictBind) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
        var Apply0 = dictBind.Apply0();
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var applyWriterT2 = applyWriterT1(Apply0);
        return {
            bind: function(v) {
                return function(k) {
                    return bind(v)(function(v1) {
                        var v2 = k(v1.value0);
                        return map(function(v3) {
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0, append(v1.value1)(v3.value1));
                        })(v2);
                    });
                };
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8c475e05f959fff2 = function(dictApply) {
    return function(dictSemigroup) {
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($d9ef009191ddae40$export$2f46a8de9e2e0acc(dictSemigroup)(dictApply));
        return function(dictSemigroup1) {
            return {
                append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup1))
            };
        };
    };
};
var $d9ef009191ddae40$export$c3b0a193a5475c40 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var applyWriterT1 = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var applyWriterT2 = applyWriterT1(dictApplicative.Apply0());
        return {
            pure: function(a) {
                return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
            },
            Apply0: function() {
                return applyWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$a45df43c41b778a = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    var bindWriterT1 = $d9ef009191ddae40$export$4483e5256f36d121(dictMonoid.Semigroup0());
    return function(dictMonad) {
        var applicativeWriterT2 = applicativeWriterT1(dictMonad.Applicative0());
        var bindWriterT2 = bindWriterT1(dictMonad.Bind1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Bind1: function() {
                return bindWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$2b88d21fdbd23b84 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadAsk) {
        var Monad0 = dictMonadAsk.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            ask: lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$1e8e23b27bf4b6eb = function(dictMonoid) {
    var monadAskWriterT1 = $d9ef009191ddae40$export$2b88d21fdbd23b84(dictMonoid);
    return function(dictMonadReader) {
        var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
        var monadAskWriterT2 = monadAskWriterT1(dictMonadReader.MonadAsk0());
        return {
            local: function(f) {
                return $d9ef009191ddae40$export$c950a71321ef1ffc(local(f));
            },
            MonadAsk0: function() {
                return monadAskWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$7520b5391c6ad7c7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadCont) {
        var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
        var monadWriterT2 = monadWriterT1(dictMonadCont.Monad0());
        return {
            callCC: function(f) {
                return callCC(function(c) {
                    var v = f(function(a) {
                        return c(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                    });
                    return v;
                });
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$29fece65832b4369 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftEffect: function() {
                var $259 = lift(Monad0);
                var $260 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
                return function($261) {
                    return $259($260($261));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$36179168852a11d0 = function(dictMonoid) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            tailRecM: function(f) {
                return function(a) {
                    var f$prime = function(v) {
                        var v1 = f(v.value0);
                        return bind(v1)(function(v2) {
                            return pure(function() {
                                if (v2.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                if (v2.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $71f2e2e9476163f8$export$1908877435b1d5e9(v2.value0.value0, append(v.value1)(v2.value1)));
                                throw new Error("Failed pattern match at Control.Monad.Writer.Trans (line 84, column 16 - line 86, column 47): " + [
                                    v2.value0.constructor.name
                                ]);
                            }());
                        });
                    };
                    return tailRecM(f$prime)(new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty));
                };
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$6594c621b12bf0b9 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadState) {
        var Monad0 = dictMonadState.Monad0();
        var lift1 = lift(Monad0);
        var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            state: function(f) {
                return lift1(state(f));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$b022f808a9791225 = function(dictMonoid) {
    var Semigroup0 = dictMonoid.Semigroup0();
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonad) {
        var monadWriterT2 = monadWriterT1(dictMonad);
        return {
            tell: function() {
                var $262 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
                var $263 = $71f2e2e9476163f8$export$1908877435b1d5e9.create($05149ea687d6b460$export$523c0b569236b342);
                return function($264) {
                    return $d9ef009191ddae40$export$6bef9d59f22e8880($262($263($264)));
                };
            }(),
            Semigroup0: function() {
                return Semigroup0;
            },
            Monad1: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f2385bf9afd45c19 = function(dictMonoid) {
    var monadTellWriterT1 = $d9ef009191ddae40$export$b022f808a9791225(dictMonoid);
    return function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
        var monadTellWriterT2 = monadTellWriterT1(dictMonad);
        return {
            listen: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1), v1.value1));
                });
            },
            pass: function(v) {
                return bind(v)(function(v1) {
                    return pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0.value0, v1.value0.value1(v1.value1)));
                });
            },
            Monoid0: function() {
                return dictMonoid;
            },
            MonadTell1: function() {
                return monadTellWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8fbe11284b53cf18 = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadThrow) {
        var Monad0 = dictMonadThrow.Monad0();
        var lift1 = lift(Monad0);
        var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            throwError: function(e) {
                return lift1(throwError(e));
            },
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$f7d1d5bacfa0742c = function(dictMonoid) {
    var monadThrowWriterT1 = $d9ef009191ddae40$export$8fbe11284b53cf18(dictMonoid);
    return function(dictMonadError) {
        var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
        var monadThrowWriterT2 = monadThrowWriterT1(dictMonadError.MonadThrow0());
        return {
            catchError: function(v) {
                return function(h) {
                    return catchError(v)(function(e) {
                        var v1 = h(e);
                        return v1;
                    });
                };
            },
            MonadThrow0: function() {
                return monadThrowWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$3e5fc362694e79bf = function(dictMonoid) {
    var lift = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    return function(dictMonadST) {
        var Monad0 = dictMonadST.Monad0();
        var monadWriterT2 = monadWriterT1(Monad0);
        return {
            liftST: function() {
                var $265 = lift(Monad0);
                var $266 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
                return function($267) {
                    return $265($266($267));
                };
            }(),
            Monad0: function() {
                return monadWriterT2;
            }
        };
    };
};
var $d9ef009191ddae40$export$8a353f8c5b798525 = function(dictApplicative) {
    var semigroupWriterT1 = $d9ef009191ddae40$export$8c475e05f959fff2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid)(dictApplicative));
        var semigroupWriterT2 = semigroupWriterT1(dictMonoid.Semigroup0());
        return function(dictMonoid1) {
            var semigroupWriterT3 = semigroupWriterT2(dictMonoid1.Semigroup0());
            return {
                mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid1)),
                Semigroup0: function() {
                    return semigroupWriterT3;
                }
            };
        };
    };
};
var $d9ef009191ddae40$export$6f6793d950011736 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorWriterT1 = $d9ef009191ddae40$export$502115c714790859(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return alt(v)(v1);
            };
        },
        Functor0: function() {
            return functorWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$a57a36ca2cee11fb = function(dictPlus) {
    var altWriterT1 = $d9ef009191ddae40$export$6f6793d950011736(dictPlus.Alt0());
    return {
        empty: $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus),
        Alt0: function() {
            return altWriterT1;
        }
    };
};
var $d9ef009191ddae40$export$c91ecc30f23c76ec = function(dictMonoid) {
    var applicativeWriterT1 = $d9ef009191ddae40$export$c3b0a193a5475c40(dictMonoid);
    return function(dictAlternative) {
        var applicativeWriterT2 = applicativeWriterT1(dictAlternative.Applicative0());
        var plusWriterT1 = $d9ef009191ddae40$export$a57a36ca2cee11fb(dictAlternative.Plus1());
        return {
            Applicative0: function() {
                return applicativeWriterT2;
            },
            Plus1: function() {
                return plusWriterT1;
            }
        };
    };
};
var $d9ef009191ddae40$export$1c68552a87a434af = function(dictMonoid) {
    var monadWriterT1 = $d9ef009191ddae40$export$a45df43c41b778a(dictMonoid);
    var alternativeWriterT1 = $d9ef009191ddae40$export$c91ecc30f23c76ec(dictMonoid);
    return function(dictMonadPlus) {
        var monadWriterT2 = monadWriterT1(dictMonadPlus.Monad0());
        var alternativeWriterT2 = alternativeWriterT1(dictMonadPlus.Alternative1());
        return {
            Monad0: function() {
                return monadWriterT2;
            },
            Alternative1: function() {
                return alternativeWriterT2;
            }
        };
    };
};






var $45c91529080709fa$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $45c91529080709fa$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $45c91529080709fa$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $45c91529080709fa$export$ab4aa096a1f048e7 = function(dict) {
    return dict.orr;
};
var $45c91529080709fa$export$4c82c3ac2df3f8f3 = function(dictMultiAlternative) {
    var orr1 = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
    var plusReaderT = $848780da1bf26d9d$export$97f8c30f9c69a13c(dictMultiAlternative.Plus0());
    return {
        orr: function(rs) {
            return function(r) {
                return orr1($45c91529080709fa$var$map(function(m) {
                    return $45c91529080709fa$var$unwrap(m)(r);
                })(rs));
            };
        },
        Plus0: function() {
            return plusReaderT;
        }
    };
};
var $45c91529080709fa$export$cddea5809cfe6369 = function(dictMultiAlternative) {
    var orr1 = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
    var plusRWST = $712b2df71ce372f8$export$6179beba56f1d9b2(dictMultiAlternative.Plus0());
    return {
        orr: function(rs) {
            return function(r) {
                return function(s) {
                    return orr1($45c91529080709fa$var$map(function(m) {
                        return $45c91529080709fa$var$unwrap(m)(r)(s);
                    })(rs));
                };
            };
        },
        Plus0: function() {
            return plusRWST;
        }
    };
};
var $45c91529080709fa$export$e497c64f8f0dc33 = function(dictMultiAlternative) {
    var orr1 = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
    var Plus0 = dictMultiAlternative.Plus0();
    return function(dictMonad) {
        var plusStateT = $e9bda291f4ec10ec$export$300a7627bf7b0e65(dictMonad)(Plus0);
        return {
            orr: function(rs) {
                return function(s) {
                    return orr1($45c91529080709fa$var$map(function(m) {
                        return $45c91529080709fa$var$unwrap(m)(s);
                    })(rs));
                };
            },
            Plus0: function() {
                return plusStateT;
            }
        };
    };
};
var $45c91529080709fa$export$b4359aa03caf7cda = function(dictMultiAlternative) {
    var orr1 = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
    var plusWriterT = $d9ef009191ddae40$export$a57a36ca2cee11fb(dictMultiAlternative.Plus0());
    return {
        orr: function(rs) {
            return orr1($45c91529080709fa$var$map($45c91529080709fa$var$unwrap)(rs));
        },
        Plus0: function() {
            return plusWriterT;
        }
    };
};
var $45c91529080709fa$export$ada9c0df6a477778 = function(dictPlus) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictPlus.Alt0());
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    return function(xs) {
        return $45c91529080709fa$var$foldl(alt)(empty)(xs);
    };
};
var $45c91529080709fa$export$81fb2ea5d82d1413 = function(dictMonoid) {
    var plusExceptT = $d2284b2d3e1b6f87$export$c5d1f65b4da4d62f(dictMonoid);
    return function(dictMultiAlternative) {
        return function(dictMonad) {
            var plusExceptT1 = plusExceptT(dictMonad);
            return {
                orr: $45c91529080709fa$export$ada9c0df6a477778(plusExceptT1),
                Plus0: function() {
                    return plusExceptT1;
                }
            };
        };
    };
};














var $fe1781b0b9eaad64$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $fe1781b0b9eaad64$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $fe1781b0b9eaad64$var$monoidEffect = /* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($784e1bd3d26d71da$export$852b4040eee6c6ba);
var $fe1781b0b9eaad64$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $fe1781b0b9eaad64$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $fe1781b0b9eaad64$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($fe1781b0b9eaad64$var$monoidEffect);
var $fe1781b0b9eaad64$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $fe1781b0b9eaad64$var$voidLeft = /* #__PURE__ */ $f4b2eb11fc32ed34$export$6775eb02dd4c5e2a($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $fe1781b0b9eaad64$var$mempty1 = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($784e1bd3d26d71da$export$852b4040eee6c6ba);
var $fe1781b0b9eaad64$var$forWithIndex = /* #__PURE__ */ $2c7a64ff78781336$export$363f6bf7e04ec632($6c2f8951ecf9531e$export$89bf999217d3022a)($2c7a64ff78781336$export$96888504550934b5);
var $fe1781b0b9eaad64$var$fold = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $fe1781b0b9eaad64$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($6c2f8951ecf9531e$export$59a7b217c53300d2);
var $fe1781b0b9eaad64$export$27a5bd065ad55220 = /* #__PURE__ */ function() {
    function View(value0) {
        this.value0 = value0;
    }
    View.create = function(value0) {
        return new View(value0);
    };
    return View;
}();
var $fe1781b0b9eaad64$export$d2a72f000c4be67b = /* #__PURE__ */ function() {
    function Completed(value0) {
        this.value0 = value0;
    }
    Completed.create = function(value0) {
        return new Completed(value0);
    };
    return Completed;
}();
var $fe1781b0b9eaad64$export$1ec73929ea9dc2b9 = /* #__PURE__ */ function() {
    function Initialising() {}
    Initialising.value = new Initialising();
    return Initialising;
}();
var $fe1781b0b9eaad64$export$3503e4455fc91a64 = /* #__PURE__ */ function() {
    function Aborted() {}
    Aborted.value = new Aborted();
    return Aborted;
}();
var $fe1781b0b9eaad64$export$77faa7af480a2ca = /* #__PURE__ */ function() {
    function Initialised() {}
    Initialised.value = new Initialised();
    return Initialised;
}();
var $fe1781b0b9eaad64$export$78f58e2a70333412 = function(x) {
    return x;
};
var $fe1781b0b9eaad64$export$a829527ff4e4114a = function(x) {
    return x;
};
var $fe1781b0b9eaad64$export$c5fde4e7aaeb46c5 = {
    shiftMap: function(f) {
        return f($fe1781b0b9eaad64$var$identity);
    }
};
var $fe1781b0b9eaad64$export$51de678daac32c4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fe1781b0b9eaad64$export$c009136c9d6568c = {
    Coercible0: function() {
        return undefined;
    }
};
var $fe1781b0b9eaad64$export$9b15a67838858b93 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return new $fe1781b0b9eaad64$export$27a5bd065ad55220(v1.value0);
            if (v1 instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return new $fe1781b0b9eaad64$export$d2a72f000c4be67b(v(v1.value0));
            throw new Error("Failed pattern match at Concur.Core.Types (line 41, column 1 - line 43, column 40): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $fe1781b0b9eaad64$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$9b15a67838858b93);
var $fe1781b0b9eaad64$export$a5f153112de6759d = function(v) {
    return v;
};
var $fe1781b0b9eaad64$export$d1c2d6405dcf3619 = function(v) {
    return v;
};
var $fe1781b0b9eaad64$export$556542c7a3df5d47 = function(v) {
    return v;
};
var $fe1781b0b9eaad64$export$aaf36426b5008f7a = function(f) {
    return function(g) {
        return function(v) {
            if (v instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return f(v.value0);
            if (v instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return g(v.value0);
            throw new Error("Failed pattern match at Concur.Core.Types (line 37, column 14 - line 39, column 21): " + [
                v.constructor.name
            ]);
        };
    };
};
var $fe1781b0b9eaad64$export$eddc205e0ec8c15 = function(e) {
    return e;
};
var $fe1781b0b9eaad64$export$6d7de605fc6f24f3 = $fe1781b0b9eaad64$export$78f58e2a70333412;
var $fe1781b0b9eaad64$export$b3e22bcfd64c1022 = /* #__PURE__ */ $fe1781b0b9eaad64$export$6d7de605fc6f24f3(/* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $784e1bd3d26d71da$export$192e81b9fe7e4abe(/* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($fe1781b0b9eaad64$var$monoidEffect))));
var $fe1781b0b9eaad64$export$43835d8517edb2f9 = function(w) {
    return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(_cb) {
        return $fe1781b0b9eaad64$export$d1c2d6405dcf3619(w)(function(_res) {
            return $fe1781b0b9eaad64$var$$$void($fe1781b0b9eaad64$var$pure($fe1781b0b9eaad64$export$b3e22bcfd64c1022));
        });
    });
};
var $fe1781b0b9eaad64$export$43eceaac1fe04305 = {
    map: function(f) {
        return function(c) {
            return $fe1781b0b9eaad64$export$6d7de605fc6f24f3(function(cb) {
                return $fe1781b0b9eaad64$export$556542c7a3df5d47(c)(function($104) {
                    return cb(f($104));
                });
            });
        };
    }
};
var $fe1781b0b9eaad64$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$43eceaac1fe04305);
var $fe1781b0b9eaad64$export$b8cebcb08812ae27 = {
    map: function(f) {
        return function(m) {
            return $fe1781b0b9eaad64$var$map1($fe1781b0b9eaad64$var$map(f))(m);
        };
    }
};
var $fe1781b0b9eaad64$export$d23735986c0beb69 = {
    Applicative0: function() {
        return $fe1781b0b9eaad64$export$797cc7e2e9848af;
    },
    Bind1: function() {
        return $fe1781b0b9eaad64$export$5f15f35c03bac00f;
    }
};
var $fe1781b0b9eaad64$export$5f15f35c03bac00f = {
    bind: function(m) {
        return function(f) {
            return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
                return function __do() {
                    var cancelerRef = $90327512d8280b8d$export$b8cb59497041ffe4($fe1781b0b9eaad64$var$mempty)();
                    var runCancelers = $fe1781b0b9eaad64$var$join($e521936ea118867a$export$aafa59e2e03f2942(cancelerRef));
                    var cancelerA = $fe1781b0b9eaad64$export$d1c2d6405dcf3619(m)(function(res) {
                        if (res instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(res.value0));
                        if (res instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return function __do() {
                            runCancelers();
                            var cancelerB = $fe1781b0b9eaad64$export$d1c2d6405dcf3619(f(res.value0))(cb)();
                            return $e521936ea118867a$export$68d8715fc104d294(cancelerB)(cancelerRef)();
                        };
                        throw new Error("Failed pattern match at Concur.Core.Types (line 107, column 7 - line 112, column 42): " + [
                            res.constructor.name
                        ]);
                    })();
                    $e521936ea118867a$export$68d8715fc104d294(cancelerA)(cancelerRef)();
                    return runCancelers;
                };
            });
        };
    },
    Apply0: function() {
        return $fe1781b0b9eaad64$var$$lazy_applyWidget(0);
    }
};
var $fe1781b0b9eaad64$export$797cc7e2e9848af = {
    pure: function(a) {
        return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
            return $fe1781b0b9eaad64$var$voidLeft(cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(a)))($fe1781b0b9eaad64$var$pure($fe1781b0b9eaad64$var$mempty1));
        });
    },
    Apply0: function() {
        return $fe1781b0b9eaad64$var$$lazy_applyWidget(0);
    }
};
var $fe1781b0b9eaad64$var$$lazy_applyWidget = /* #__PURE__ */ $fe1781b0b9eaad64$var$$runtime_lazy("applyWidget", "Concur.Core.Types", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($fe1781b0b9eaad64$export$d23735986c0beb69),
        Functor0: function() {
            return $fe1781b0b9eaad64$export$b8cebcb08812ae27;
        }
    };
});
var $fe1781b0b9eaad64$export$d0bf720f69e19cbd = /* #__PURE__ */ $fe1781b0b9eaad64$var$$lazy_applyWidget(88);
var $fe1781b0b9eaad64$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $fe1781b0b9eaad64$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $fe1781b0b9eaad64$export$4e1ce6d609307a39 = function(dictMonoid) {
    return {
        liftEffect: function(eff) {
            return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
                return function __do() {
                    var a = eff();
                    cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(a))();
                    return $fe1781b0b9eaad64$var$mempty;
                };
            });
        },
        Monad0: function() {
            return $fe1781b0b9eaad64$export$d23735986c0beb69;
        }
    };
};
var $fe1781b0b9eaad64$export$c226fd9c818b243 = {
    tailRecM: function(k) {
        return function(a) {
            return $fe1781b0b9eaad64$var$bind1(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($fe1781b0b9eaad64$export$c226fd9c818b243)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $fe1781b0b9eaad64$var$pure1(v.value0);
                throw new Error("Failed pattern match at Concur.Core.Types (line 97, column 26 - line 99, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $fe1781b0b9eaad64$export$d23735986c0beb69;
    }
};
var $fe1781b0b9eaad64$export$d2ef7f1b3bacfcf9 = function(f) {
    return function(v) {
        if (v instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return new $fe1781b0b9eaad64$export$27a5bd065ad55220(f(v.value0));
        if (v instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return new $fe1781b0b9eaad64$export$d2a72f000c4be67b(v.value0);
        throw new Error("Failed pattern match at Concur.Core.Types (line 46, column 19 - line 48, column 29): " + [
            v.constructor.name
        ]);
    };
};
var $fe1781b0b9eaad64$export$5aa39647623d5354 = function(f) {
    return function(v) {
        return $fe1781b0b9eaad64$var$map1($fe1781b0b9eaad64$export$d2ef7f1b3bacfcf9(f))(v);
    };
};
var $fe1781b0b9eaad64$export$606fb6c2d76bfafb = function(v) {
    if (v instanceof $fe1781b0b9eaad64$export$1ec73929ea9dc2b9) return $fe1781b0b9eaad64$export$77faa7af480a2ca.value;
    return v;
};
var $fe1781b0b9eaad64$export$71481940c7f619d4 = function(v) {
    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
    throw new Error("Failed pattern match at Concur.Core.Types (line 128, column 1 - line 128, column 51): " + [
        v.constructor.name
    ]);
};
var $fe1781b0b9eaad64$export$79693fdaa4661ff2 = function(v) {
    return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
        return function __do() {
            cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(v))();
            return $fe1781b0b9eaad64$var$mempty;
        };
    });
};
var $fe1781b0b9eaad64$export$3c06564581f3c8ce = function(dictMonoid) {
    return {
        append: function(w1) {
            return function(w2) {
                return $45c91529080709fa$export$ab4aa096a1f048e7($fe1781b0b9eaad64$export$21a5b9b566490c41(dictMonoid))([
                    w1,
                    w2
                ]);
            };
        }
    };
};
var $fe1781b0b9eaad64$export$8625a629debdcb0c = function(dictMonoid) {
    return {
        empty: $fe1781b0b9eaad64$export$79693fdaa4661ff2($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Alt0: function() {
            return $fe1781b0b9eaad64$export$7341a4054968fa7c(dictMonoid);
        }
    };
};
var $fe1781b0b9eaad64$export$21a5b9b566490c41 = function(dictMonoid) {
    var mempty2 = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var fold1 = $fe1781b0b9eaad64$var$fold(dictMonoid);
    return {
        orr: function(widgets) {
            return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
                return function __do() {
                    var viewsRef = $90327512d8280b8d$export$b8cb59497041ffe4($396c4c3d9e7fae3c$export$606959e7ccb797f0($fc8c1182ec2aefec$export$f24224f1c91d8156(widgets))(mempty2))();
                    var cancelerRef = $90327512d8280b8d$export$b8cb59497041ffe4($fe1781b0b9eaad64$var$mempty)();
                    var renderStateRef = $90327512d8280b8d$export$b8cb59497041ffe4($fe1781b0b9eaad64$export$1ec73929ea9dc2b9.value)();
                    var runCancelers = $fe1781b0b9eaad64$var$join($e521936ea118867a$export$aafa59e2e03f2942(cancelerRef));
                    $fe1781b0b9eaad64$var$forWithIndex(widgets)(function(i) {
                        return function(w) {
                            return function __do() {
                                var c = $fe1781b0b9eaad64$export$d1c2d6405dcf3619(w)(function(res) {
                                    if (res instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return function __do() {
                                        var views = $e521936ea118867a$export$aafa59e2e03f2942(viewsRef)();
                                        var v1 = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(res.value0)(views);
                                        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $05149ea687d6b460$export$523c0b569236b342;
                                        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                            $e521936ea118867a$export$68d8715fc104d294(v1.value0)(viewsRef)();
                                            var renderState = $e521936ea118867a$export$aafa59e2e03f2942(renderStateRef)();
                                            if (renderState instanceof $fe1781b0b9eaad64$export$77faa7af480a2ca) return cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(fold1(v1.value0)))();
                                            return $05149ea687d6b460$export$523c0b569236b342;
                                        }
                                        throw new Error("Failed pattern match at Concur.Core.Types (line 153, column 11 - line 160, column 31): " + [
                                            v1.constructor.name
                                        ]);
                                    };
                                    if (res instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return function __do() {
                                        $e521936ea118867a$export$68d8715fc104d294($fe1781b0b9eaad64$export$3503e4455fc91a64.value)(renderStateRef)();
                                        runCancelers();
                                        return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(res.value0))();
                                    };
                                    throw new Error("Failed pattern match at Concur.Core.Types (line 150, column 32 - line 164, column 27): " + [
                                        res.constructor.name
                                    ]);
                                })();
                                return $90327512d8280b8d$export$3ff57735a52b8713(function(v) {
                                    return $fe1781b0b9eaad64$var$applySecond(v)(c);
                                })(cancelerRef)();
                            };
                        };
                    })();
                    $90327512d8280b8d$export$45b91115a89d6020($fe1781b0b9eaad64$export$606fb6c2d76bfafb)(renderStateRef)();
                    var views = $e521936ea118867a$export$aafa59e2e03f2942(viewsRef)();
                    cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(fold1(views)))();
                    return runCancelers;
                };
            });
        },
        Plus0: function() {
            return $fe1781b0b9eaad64$export$8625a629debdcb0c(dictMonoid);
        }
    };
};
var $fe1781b0b9eaad64$export$7341a4054968fa7c = function(dictMonoid) {
    return {
        alt: $d7bf9817a417d4ae$export$10d8903dec122b9d($fe1781b0b9eaad64$export$3c06564581f3c8ce(dictMonoid)),
        Functor0: function() {
            return $fe1781b0b9eaad64$export$b8cebcb08812ae27;
        }
    };
};
var $fe1781b0b9eaad64$export$669627df9a2dc90f = function(dictMonoid) {
    var plusWidget1 = $fe1781b0b9eaad64$export$8625a629debdcb0c(dictMonoid);
    return {
        Applicative0: function() {
            return $fe1781b0b9eaad64$export$797cc7e2e9848af;
        },
        Plus1: function() {
            return plusWidget1;
        }
    };
};
var $fe1781b0b9eaad64$export$b27d540d052ce331 = function(dictMonoid) {
    var semigroupWidget1 = $fe1781b0b9eaad64$export$3c06564581f3c8ce(dictMonoid);
    return {
        mempty: $7abe8fbe97ebda87$export$6e22c362a0406a2c($fe1781b0b9eaad64$export$8625a629debdcb0c(dictMonoid)),
        Semigroup0: function() {
            return semigroupWidget1;
        }
    };
};







// Generated by purs version 0.15.16
// Generated by purs version 0.15.16


var $d4ad4a12c540b680$export$5d6626409df85f18 = {
    liftWidget: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa)
};
var $d4ad4a12c540b680$export$747a071fbf00b73f = function(dict) {
    return dict.liftWidget;
};
var $d4ad4a12c540b680$export$acfabfd62912cf70 = function(dictMonad) {
    return function(dictMonadTrans) {
        var lift = $384c24655e07f36c$export$590e8b2c435046d9(dictMonadTrans)(dictMonad);
        return function(dictLiftWidget) {
            return {
                liftWidget: function() {
                    var $11 = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
                    return function($12) {
                        return lift($11($12));
                    };
                }()
            };
        };
    };
};



// Generated by purs version 0.15.16
// Generated by purs version 0.15.16




var $8cc8e71d6c274566$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($784e1bd3d26d71da$export$852b4040eee6c6ba));
var $8cc8e71d6c274566$export$4dce3967a90035b0 = function(mkView) {
    return function(w) {
        return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
            return $fe1781b0b9eaad64$export$d1c2d6405dcf3619(w)(function(v) {
                if (v instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(mkView(function(a) {
                    return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(a));
                })(v.value0)));
                if (v instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(v.value0));
                throw new Error("Failed pattern match at Concur.Core (line 20, column 17 - line 22, column 36): " + [
                    v.constructor.name
                ]);
            });
        });
    };
};
var $8cc8e71d6c274566$export$5941a660d81d0673 = function(mkView) {
    var v = function(cb) {
        return mkView(function(a) {
            return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(a));
        });
    };
    return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
        return function __do() {
            cb(new $fe1781b0b9eaad64$export$27a5bd065ad55220(v(cb)))();
            return $8cc8e71d6c274566$var$mempty;
        };
    });
};


// Generated by purs version 0.15.16



// Generated by purs version 0.15.16





var $c06eda136610a859$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c06eda136610a859$export$61b43c401688cd77 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        shiftMap: function(f) {
            return function(v) {
                return f(function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, mempty);
                })(v);
            };
        }
    };
};
var $c06eda136610a859$export$aea33055593552fa = function(dictMonad) {
    return {
        shiftMap: function(f) {
            return function(v) {
                return function(s) {
                    return f(function(a) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, s);
                    })(v(s));
                };
            };
        }
    };
};
var $c06eda136610a859$export$5b0e29bbd67c4c87 = {
    shiftMap: function(f) {
        return function(v) {
            return function(r) {
                return f($c06eda136610a859$var$identity)(v(r));
            };
        };
    }
};
var $c06eda136610a859$export$30b8f4f44d50957e = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    return {
        shiftMap: function(f) {
            return function(v) {
                return function(r) {
                    return function(s) {
                        return f(function(a) {
                            return new $712b2df71ce372f8$export$6950f537d8cb5965(s, a, mempty);
                        })(v(r)(s));
                    };
                };
            };
        }
    };
};
var $c06eda136610a859$export$be20dd01b65a671 = {
    shiftMap: function(f) {
        return function(v) {
            return f($7d4cccdf062a2261$export$19db0165690c701a.create)(v);
        };
    }
};
var $c06eda136610a859$export$298cc4ef816733b = function(dict) {
    return dict.shiftMap;
};



var $65a231f2469e9513$export$719bfe54e9eb6d53 = function(f) {
    return function(ps) {
        return function(vs) {
            return [
                f(ps)(vs)
            ];
        };
    };
};
var $65a231f2469e9513$export$1960acb671597625 = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFunctor1) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
            return function(e) {
                return function(props) {
                    return liftWidget($8cc8e71d6c274566$export$5941a660d81d0673(function(h) {
                        return [
                            e(map(map1(h))(props))
                        ];
                    }));
                };
            };
        };
    };
};
var $65a231f2469e9513$export$77b86f7f8703d1de = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFunctor1) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
            return function(e) {
                return function(props) {
                    return liftWidget($8cc8e71d6c274566$export$5941a660d81d0673(function(h) {
                        return e(map(map1(h))(props));
                    }));
                };
            };
        };
    };
};
var $65a231f2469e9513$export$16c4786ffa1934a1 = function(dictShiftMap) {
    var shiftMap = $c06eda136610a859$export$298cc4ef816733b(dictShiftMap);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFunctor1) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
            return function(e) {
                return function(props) {
                    return shiftMap(function(f) {
                        return function(w) {
                            return $8cc8e71d6c274566$export$4dce3967a90035b0(function(h) {
                                return function(v) {
                                    return $65a231f2469e9513$export$719bfe54e9eb6d53(e)(map(map1(function($41) {
                                        return h(f($41));
                                    }))(props))(v);
                                };
                            })(w);
                        };
                    });
                };
            };
        };
    };
};
var $65a231f2469e9513$export$c3da0dad1b44eea9 = function(dictShiftMap) {
    var shiftMap = $c06eda136610a859$export$298cc4ef816733b(dictShiftMap);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFunctor1) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor1);
            return function(e) {
                return function(props) {
                    return shiftMap(function(f) {
                        return function(w) {
                            return $8cc8e71d6c274566$export$4dce3967a90035b0(function(h) {
                                return function(v) {
                                    return e(map(map1(function($42) {
                                        return h(f($42));
                                    }))(props))(v);
                                };
                            })(w);
                        };
                    });
                };
            };
        };
    };
};
var $65a231f2469e9513$export$ad9e3aaa79fdf6 = function(dictShiftMap) {
    var el1 = $65a231f2469e9513$export$c3da0dad1b44eea9(dictShiftMap);
    return function(dictMultiAlternative) {
        var orr = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
        return function(dictFunctor) {
            var el2 = el1(dictFunctor);
            return function(dictFunctor1) {
                var el3 = el2(dictFunctor1);
                return function(e) {
                    return function(props) {
                        var $43 = el3(e)(props);
                        return function($44) {
                            return $43(orr($44));
                        };
                    };
                };
            };
        };
    };
};
var $65a231f2469e9513$export$e929e4044f497c9c = function(dictShiftMap) {
    var el1 = $65a231f2469e9513$export$c3da0dad1b44eea9(dictShiftMap);
    return function(dictMultiAlternative) {
        var orr = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
        return function(dictFunctor) {
            var el2 = el1(dictFunctor);
            return function(dictFunctor1) {
                var el3 = el2(dictFunctor1);
                return function(e) {
                    return function(props) {
                        var $45 = el3($65a231f2469e9513$export$719bfe54e9eb6d53(e))(props);
                        return function($46) {
                            return $45(orr($46));
                        };
                    };
                };
            };
        };
    };
};




// Generated by purs version 0.15.16
"use strict";
const $e55bfe0c1fd19afa$export$a9e510a238239c2b = function(s) {
    return function(event) {
        return function() {
            event.target.value = s;
        };
    };
};
const $e55bfe0c1fd19afa$export$1b58b299a5c07a6f = {};








// Generated by purs version 0.15.16
const $28d793bcad7b6401$export$33e695b1da6bf8ce = function mkEffectFn1(fn) {
    return function(x) {
        return fn(x)();
    };
};
const $28d793bcad7b6401$export$d349e7010d9e4f18 = function mkEffectFn2(fn) {
    return function(a, b) {
        return fn(a)(b)();
    };
};
const $28d793bcad7b6401$export$1329fa30c595aae1 = function mkEffectFn3(fn) {
    return function(a, b, c) {
        return fn(a)(b)(c)();
    };
};
const $28d793bcad7b6401$export$745d51d1abc5cd82 = function mkEffectFn4(fn) {
    return function(a, b, c, d) {
        return fn(a)(b)(c)(d)();
    };
};
const $28d793bcad7b6401$export$b3413456c3617180 = function mkEffectFn5(fn) {
    return function(a, b, c, d, e) {
        return fn(a)(b)(c)(d)(e)();
    };
};
const $28d793bcad7b6401$export$becea21a68009b07 = function mkEffectFn6(fn) {
    return function(a, b, c, d, e, f) {
        return fn(a)(b)(c)(d)(e)(f)();
    };
};
const $28d793bcad7b6401$export$83674e2607660e0f = function mkEffectFn7(fn) {
    return function(a, b, c, d, e, f, g) {
        return fn(a)(b)(c)(d)(e)(f)(g)();
    };
};
const $28d793bcad7b6401$export$c7f26c65f1b8e3 = function mkEffectFn8(fn) {
    return function(a, b, c, d, e, f, g, h) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)();
    };
};
const $28d793bcad7b6401$export$5d4846e0dbe026fa = function mkEffectFn9(fn) {
    return function(a, b, c, d, e, f, g, h, i) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)();
    };
};
const $28d793bcad7b6401$export$ac08820aca1c1ebc = function mkEffectFn10(fn) {
    return function(a, b, c, d, e, f, g, h, i, j) {
        return fn(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)();
    };
};
const $28d793bcad7b6401$export$84baa7a1ea5377fd = function runEffectFn1(fn) {
    return function(a) {
        return function() {
            return fn(a);
        };
    };
};
const $28d793bcad7b6401$export$6a301f847372dca1 = function runEffectFn2(fn) {
    return function(a) {
        return function(b) {
            return function() {
                return fn(a, b);
            };
        };
    };
};
const $28d793bcad7b6401$export$40df0ea470e346f0 = function runEffectFn3(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function() {
                    return fn(a, b, c);
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$ec3c5c8caae58867 = function runEffectFn4(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function() {
                        return fn(a, b, c, d);
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$5b882d1088aa8dc9 = function runEffectFn5(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function() {
                            return fn(a, b, c, d, e);
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$53e477d88d18e854 = function runEffectFn6(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function() {
                                return fn(a, b, c, d, e, f);
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$2d0fb35e82261b8d = function runEffectFn7(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function() {
                                    return fn(a, b, c, d, e, f, g);
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$801a85b4a2b405ac = function runEffectFn8(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function() {
                                        return fn(a, b, c, d, e, f, g, h);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$326863f2889caa23 = function runEffectFn9(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function() {
                                            return fn(a, b, c, d, e, f, g, h, i);
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
const $28d793bcad7b6401$export$8fc2053a354b81aa = function runEffectFn10(fn) {
    return function(a) {
        return function(b) {
            return function(c) {
                return function(d) {
                    return function(e) {
                        return function(f) {
                            return function(g) {
                                return function(h) {
                                    return function(i) {
                                        return function(j) {
                                            return function() {
                                                return fn(a, b, c, d, e, f, g, h, i, j);
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};





var $252b49eb63e60f04$export$6b33adf3a8e3f704 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$5d4846e0dbe026fa(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return append($28d793bcad7b6401$export$326863f2889caa23(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i))($28d793bcad7b6401$export$326863f2889caa23(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i));
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1b434506fc11421 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$c7f26c65f1b8e3(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return append($28d793bcad7b6401$export$801a85b4a2b405ac(f1)(a)(b)(c)(d)(e)(f)(g)(h))($28d793bcad7b6401$export$801a85b4a2b405ac(f2)(a)(b)(c)(d)(e)(f)(g)(h));
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$f9d62e28920765a6 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$83674e2607660e0f(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return append($28d793bcad7b6401$export$2d0fb35e82261b8d(f1)(a)(b)(c)(d)(e)(f)(g))($28d793bcad7b6401$export$2d0fb35e82261b8d(f2)(a)(b)(c)(d)(e)(f)(g));
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$1cdb6e5a843aefe2 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$becea21a68009b07(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return append($28d793bcad7b6401$export$53e477d88d18e854(f1)(a)(b)(c)(d)(e)(f))($28d793bcad7b6401$export$53e477d88d18e854(f2)(a)(b)(c)(d)(e)(f));
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$99aa837ed31887aa = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$b3413456c3617180(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return append($28d793bcad7b6401$export$5b882d1088aa8dc9(f1)(a)(b)(c)(d)(e))($28d793bcad7b6401$export$5b882d1088aa8dc9(f2)(a)(b)(c)(d)(e));
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$8cb019b91258e3b9 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$745d51d1abc5cd82(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return append($28d793bcad7b6401$export$ec3c5c8caae58867(f1)(a)(b)(c)(d))($28d793bcad7b6401$export$ec3c5c8caae58867(f2)(a)(b)(c)(d));
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$fb0bdf58ff0a6426 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$1329fa30c595aae1(function(a) {
                    return function(b) {
                        return function(c) {
                            return append($28d793bcad7b6401$export$40df0ea470e346f0(f1)(a)(b)(c))($28d793bcad7b6401$export$40df0ea470e346f0(f2)(a)(b)(c));
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$9bf195cde6bca966 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$d349e7010d9e4f18(function(a) {
                    return function(b) {
                        return append($28d793bcad7b6401$export$6a301f847372dca1(f1)(a)(b))($28d793bcad7b6401$export$6a301f847372dca1(f2)(a)(b));
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$39f0bfa3de9c8ca1 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$ac08820aca1c1ebc(function(a) {
                    return function(b) {
                        return function(c) {
                            return function(d) {
                                return function(e) {
                                    return function(f) {
                                        return function(g) {
                                            return function(h) {
                                                return function(i) {
                                                    return function(j) {
                                                        return append($28d793bcad7b6401$export$8fc2053a354b81aa(f1)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j))($28d793bcad7b6401$export$8fc2053a354b81aa(f2)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j));
                                                    };
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$d15c5b9160f5bf5 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($6c2f8951ecf9531e$export$58139e981c60cf43(dictSemigroup));
    return {
        append: function(f1) {
            return function(f2) {
                return $28d793bcad7b6401$export$33e695b1da6bf8ce(function(a) {
                    return append($28d793bcad7b6401$export$84baa7a1ea5377fd(f1)(a))($28d793bcad7b6401$export$84baa7a1ea5377fd(f2)(a));
                });
            };
        }
    };
};
var $252b49eb63e60f04$export$951567719e338e25 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn91 = $252b49eb63e60f04$export$6b33adf3a8e3f704(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$5d4846e0dbe026fa(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return mempty;
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn91;
        }
    };
};
var $252b49eb63e60f04$export$60b4106c40599be6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn81 = $252b49eb63e60f04$export$1b434506fc11421(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$c7f26c65f1b8e3(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return mempty;
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn81;
        }
    };
};
var $252b49eb63e60f04$export$63d6254dd5b47db1 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn71 = $252b49eb63e60f04$export$f9d62e28920765a6(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$83674e2607660e0f(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return mempty;
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn71;
        }
    };
};
var $252b49eb63e60f04$export$80d58e93d1dd53e4 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn61 = $252b49eb63e60f04$export$1cdb6e5a843aefe2(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$becea21a68009b07(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return mempty;
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn61;
        }
    };
};
var $252b49eb63e60f04$export$c346a9c2957c12e8 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn51 = $252b49eb63e60f04$export$99aa837ed31887aa(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$b3413456c3617180(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return mempty;
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn51;
        }
    };
};
var $252b49eb63e60f04$export$fd6b07fef28d22de = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn41 = $252b49eb63e60f04$export$8cb019b91258e3b9(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$745d51d1abc5cd82(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return mempty;
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn41;
        }
    };
};
var $252b49eb63e60f04$export$f091af598ee150a6 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn31 = $252b49eb63e60f04$export$fb0bdf58ff0a6426(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$1329fa30c595aae1(function(v) {
            return function(v1) {
                return function(v2) {
                    return mempty;
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn31;
        }
    };
};
var $252b49eb63e60f04$export$6294c3a3ece87949 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn21 = $252b49eb63e60f04$export$9bf195cde6bca966(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$d349e7010d9e4f18(function(v) {
            return function(v1) {
                return mempty;
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn21;
        }
    };
};
var $252b49eb63e60f04$export$c62e1ced10b8c8b0 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn101 = $252b49eb63e60f04$export$39f0bfa3de9c8ca1(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$ac08820aca1c1ebc(function(v) {
            return function(v1) {
                return function(v2) {
                    return function(v3) {
                        return function(v4) {
                            return function(v5) {
                                return function(v6) {
                                    return function(v7) {
                                        return function(v8) {
                                            return function(v9) {
                                                return mempty;
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        }),
        Semigroup0: function() {
            return semigroupEffectFn101;
        }
    };
};
var $252b49eb63e60f04$export$333b269eda63e7a7 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($6c2f8951ecf9531e$export$2d8226ee4b2722f7(dictMonoid));
    var semigroupEffectFn11 = $252b49eb63e60f04$export$d15c5b9160f5bf5(dictMonoid.Semigroup0());
    return {
        mempty: $28d793bcad7b6401$export$33e695b1da6bf8ce(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupEffectFn11;
        }
    };
};


// Generated by purs version 0.15.16
function $1ac7a3b24b863c5b$export$1c24cb68eef06a2d(key) {
    return function(value) {
        var result = {};
        result[key] = value;
        return result;
    };
}
function $1ac7a3b24b863c5b$export$9d897906f771f662(key) {
    return function(value) {
        var result = {};
        var props = {};
        props[key] = result;
        for(var subprop in value)if (Object.hasOwnProperty.apply(value, [
            subprop
        ])) result[subprop] = value[subprop];
        return props;
    };
}
function $1ac7a3b24b863c5b$export$a69d530489679a43(prefix) {
    return function(value) {
        var result = {};
        for(var prop in value)if (Object.hasOwnProperty.apply(value, [
            prop
        ])) result[prefix + prop] = value[prop];
        return result;
    };
}
function $1ac7a3b24b863c5b$export$3fe23fdec027b2e3(props) {
    var result = {};
    for(var i = 0, len = props.length; i < len; i++){
        var prop = props[i];
        for(var key in prop)if (Object.hasOwnProperty.apply(prop, [
            key
        ])) result[key] = prop[key];
    }
    return result;
}



var $40e1ee3c5e8e95c2$export$4a5767248b18ef41 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("y");
var $40e1ee3c5e8e95c2$export$d141bba7fdc215a3 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("x");
var $40e1ee3c5e8e95c2$export$4997ffc0176396a6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("wrap");
var $40e1ee3c5e8e95c2$export$bcd91a8cae39e6cc = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("wmode");
var $40e1ee3c5e8e95c2$export$7e3df82ee760448c = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("width");
var $40e1ee3c5e8e95c2$export$9a0d1dab6a5902f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("vocab");
var $40e1ee3c5e8e95c2$export$a179c88182cb9d56 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("viewBox");
var $40e1ee3c5e8e95c2$export$f003bc8843ece81 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("value");
var $40e1ee3c5e8e95c2$export$2ab9a8f9f1186f14 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("value");
var $40e1ee3c5e8e95c2$export$86f8f9f08863e403 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("useMap");
var $40e1ee3c5e8e95c2$export$e82bbdeee75fc1dc = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("unselectable");
var $40e1ee3c5e8e95c2$export$1d10ed712457dec2 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("typeof");
var $40e1ee3c5e8e95c2$export$fb184b623420d9be = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("title");
var $40e1ee3c5e8e95c2$export$44271b4f0c6a3563 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("target");
var $40e1ee3c5e8e95c2$export$9a625f9de50bf0b7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("tabIndex");
var $40e1ee3c5e8e95c2$export$1a3835b7c98a6c9e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("suppressContentEditableWarning");
var $40e1ee3c5e8e95c2$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("summary");
var $40e1ee3c5e8e95c2$export$1d567c320f4763bc = /* #__PURE__ */ $1ac7a3b24b863c5b$export$9d897906f771f662("style");
var $40e1ee3c5e8e95c2$export$579295bc0236e309 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("strokeWidth");
var $40e1ee3c5e8e95c2$export$d9b706f8d0a70aef = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("stroke");
var $40e1ee3c5e8e95c2$export$35d34bc0ed591a92 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("step");
var $40e1ee3c5e8e95c2$export$b3571188c770cc5a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("start");
var $40e1ee3c5e8e95c2$export$9a915d08f01c161a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("srcSet");
var $40e1ee3c5e8e95c2$export$f9fcc51506c42a8f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("srcLang");
var $40e1ee3c5e8e95c2$export$1c5fb2289a93dd05 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("srcDoc");
var $40e1ee3c5e8e95c2$export$2e40c9e35e9506f4 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("src");
var $40e1ee3c5e8e95c2$export$18817be2b8135eea = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("spellCheck");
var $40e1ee3c5e8e95c2$export$afc1bfabebaf28a2 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("span");
var $40e1ee3c5e8e95c2$export$c647cb0ee6e282fe = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("sizes");
var $40e1ee3c5e8e95c2$export$346677f925de839c = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("size");
var $40e1ee3c5e8e95c2$export$98bada23690e67eb = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("shape");
var $40e1ee3c5e8e95c2$export$d90250155de6d7e7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("selected");
var $40e1ee3c5e8e95c2$export$cdb96f27dc28cf43 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("security");
var $40e1ee3c5e8e95c2$export$5f4ba619a5f51bd2 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("seamless");
var $40e1ee3c5e8e95c2$export$77825fa6f4ae045f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("scrolling");
var $40e1ee3c5e8e95c2$export$6387ff77edd805b9 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("scoped");
var $40e1ee3c5e8e95c2$export$5cff813ca8e50db9 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("scope");
var $40e1ee3c5e8e95c2$export$f020670913e851a6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("sandbox");
var $40e1ee3c5e8e95c2$export$2dd197b55cf13440 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("rows");
var $40e1ee3c5e8e95c2$export$a5ce0649174d616e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("rowSpan");
var $40e1ee3c5e8e95c2$export$3100efae45e879 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("role");
var $40e1ee3c5e8e95c2$export$e2239770db970295 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("reversed");
var $40e1ee3c5e8e95c2$export$5be82eb8d376fece = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("results");
var $40e1ee3c5e8e95c2$export$23e0665cffcf8918 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("resource");
var $40e1ee3c5e8e95c2$export$a7a0278c004aac3f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("required");
var $40e1ee3c5e8e95c2$export$bad408f43b005bc8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("rel");
var $40e1ee3c5e8e95c2$export$eff4d24c3ff7876e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("ref");
var $40e1ee3c5e8e95c2$export$b2cbc93d4da94977 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("readOnly");
var $40e1ee3c5e8e95c2$export$7246d22ab0922ede = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("radioGroup");
var $40e1ee3c5e8e95c2$export$43caf9889c228507 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("r");
var $40e1ee3c5e8e95c2$export$d541bacb2bda4494 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("property");
var $40e1ee3c5e8e95c2$export$4882ae973e0491e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("profile");
var $40e1ee3c5e8e95c2$export$513ccb98c53b8039 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("preload");
var $40e1ee3c5e8e95c2$export$82e9f45cca5ba907 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("prefix");
var $40e1ee3c5e8e95c2$export$b840e55573b2d2e7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("poster");
var $40e1ee3c5e8e95c2$export$9f048bf86ee2e9d2 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("points");
var $40e1ee3c5e8e95c2$export$c7187bbd1a7a9244 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("placeholder");
var $40e1ee3c5e8e95c2$export$24f82734ea047e6f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("pattern");
var $40e1ee3c5e8e95c2$export$49f2954c623150dd = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("optimum");
var $40e1ee3c5e8e95c2$export$3ce6949f20cea765 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("open");
var $40e1ee3c5e8e95c2$export$c17a3be1057836e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("opacity");
var $40e1ee3c5e8e95c2$export$9c41c6aa5463df6c = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onWheelCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$65ea24ac132a9be9 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onWheel")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$b2d283ef4399072a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onWaitingCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$433c8ace949db4d0 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onWaiting")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$cf2fc22360bd1c1f = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onVolumeChangeCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f4786ad4c2750c66 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onVolumeChange")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$b2f0402dd1c70df9 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTransitionEndCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e967ac7bdb3c237c = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTransitionEnd")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5ad67c4a93e1d0c3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchStartCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$37cbf11924865552 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchStart")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$479ded11150d76a0 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchMoveCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$42c53271760d4595 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchMove")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$7347a4a302e2a86b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchEndCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$79b4bc20f2630414 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchEnd")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ba0d3640fb9ec9c1 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchCancelCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$931f312019b226f2 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTouchCancel")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$197d28649b5d58b4 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onToggleCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$9b74f80012185590 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onToggle")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e07ee915b4190531 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTimeUpdateCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f3bd975a281e5852 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onTimeUpdate")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$15cc0b38068f93e3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSuspendCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$df2126966cc1c06b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSuspend")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$603a22af4740963d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSubmitCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$307d29742c654737 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSubmit")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$67a049a85258db10 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onStalledCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$44b00009b572ac28 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onStalled")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$faa61b2616c9789d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSelectCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2cc8197d6ae5570 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSelect")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4945ad5cde249a83 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSeekingCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$496615019362196d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSeeking")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$b8bfa60acf78611c = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSeekedCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e993ebdd863d5ffa = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onSeeked")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$bcf66c395889afe3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onScrollCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$d4d89fd61e5416ee = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onScroll")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2e888a5085fb0446 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onRateChangeCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$9a2c2bc12df434f6 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onRateChange")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f11a32795aa2de56 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onProgressCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ebabfef4a68900da = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onProgress")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1981395931987789 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPlayingCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$750809158ef981f7 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPlaying")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1cbca9547fbf00ac = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPlayCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1e3b2f48068fd04f = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPlay")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2ef73a3c732882b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPauseCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$cfa985a9cecdb0d4 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPause")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4c7505a16bccdf0f = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPasteCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$48aae1120b60938a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onPaste")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$82bd7d547863552a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseUpCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$3df825bff4f0a835 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseUp")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$33e83ae183e41d86 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseOverCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$afc474fdab5e8a8e = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseOver")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$9903764da2e26850 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseOutCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$65a11040da641544 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseOut")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$973bc0112e607f66 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseMoveCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4e8e585ca96adf5d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseMove")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5995eb9f00f5508a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseLeaveCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f06e70624327ed63 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseLeave")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$259dffc70a0affaf = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseEnterCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$7c562fbb06b8dec3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseEnter")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$89690746459d8a0a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseDownCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$6b09a96aed3f5178 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onMouseDown")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2fcf06bb02752096 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadedMetadataCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$53fd4e98f60f4dcc = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadedMetadata")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$8f17da60d629e29a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadedDataCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$24374354f7c57bc9 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadedData")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e4973941d7087a48 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadStartCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$a34dceb3b47a82e8 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadStart")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2cd15c2174338ff0 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoadCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4e4d8b287d028b6b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onLoad")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$67e8ed65c683f57d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyUpCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f144bbb6e186b14b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyUp")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$3b479757aaa5e0 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyPressCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$8b51387c2ca0f477 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyPress")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$6ca2dac1f56d16bc = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyDownCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$de8e1b1372cdb41b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onKeyDown")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$6c597759837f6bcf = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onInvalidCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ea9576bc99d1b7dd = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onInvalid")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$91768e28f48821ec = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onInputCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$7fbc06d7c1beb512 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onInput")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$3e57298b708a3dbe = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onFocusCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ecf9bf35ad97eb74 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onFocus")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c7fb494ab08a31c8 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onErrorCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2288787135a8f66e = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onError")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$db5a7478a4cdcef7 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEndedCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f7e233a2008165c1 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEnded")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$2ca1942e080d8772 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEncryptedCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c89f6671c4b8a29f = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEncrypted")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$63c23e41a680e891 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEmptiedCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1d56e2bd2ae14c61 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onEmptied")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$eb69fb1757891928 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDurationChangeCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4ae41a1b2479579a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDurationChange")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$719c3e40f15f3db3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDropCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c052d596304c05ec = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDrop")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$9a497bc80c25a2a1 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragStartCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$b00174fdb6a6ab8f = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragStart")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$775d30f027c4f3e2 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragOverCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$caca362e3b7795bf = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragOver")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e0bf4d25d5610a9b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragLeaveCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5280b1a9a538737a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragLeave")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$fa6ab1d1407567cd = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragExitCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5d99689eba023667 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragExit")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$435837a5ef4b00ba = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragEnterCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$e2ce2d097d95a991 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragEnter")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$287b5ac3147e31e1 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragEndCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$8566066e92caa8a = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragEnd")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$6d0afe97770453c9 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDragCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$11a07b18d6f8f6d2 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDrag")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5f41476ffcb13969 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDoubleClickCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$12204e800775a4e0 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onDoubleClick")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$4d44b5f949715801 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCutCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$330ca67a316b532c = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCut")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$63d7b33088fa42cc = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCopyCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$f7fe233856e3c643 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCopy")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ff2b6053aee03e95 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onContextMenuCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c7ff9ccd26e6312b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onContextMenu")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$26985b3bccb942bb = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionUpdateCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$74250ad2fa11f3f5 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionUpdate")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$38af0dc6d00b6566 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionStartCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$88088485e0d81193 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionStart")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$a86909667c1a4812 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionEndCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$ec2aa26499ec74c3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCompositionEnd")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$6f7e12241c0e0dcc = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onClickCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1d5a917feb871989 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onClick")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c0751149ef8e32f6 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onChangeCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$bd913411069e59d3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onChange")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$9e1ece3973f89f6d = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCanPlayThroughCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$cd07b0ff74b0231b = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCanPlayThrough")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$87cbcda06018541c = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCanPlayCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1cb09bab8fae7878 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onCanPlay")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$36be56b9d7c38124 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onBlurCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$5e446bc31724fca4 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onBlur")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$8a49f087756cf2fd = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationStartCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$1569ef336f556fb3 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationStart")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$703d905cc670a615 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationIterationCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$a900cfe6dcb1e282 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationIteration")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$81adeab4d86e78a8 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationEndCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$19ed89f4c7f36de4 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAnimationEnd")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$c5b87804d157d6aa = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAbortCapture")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$d36091e57812e07 = function(f) {
    return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("onAbort")($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
};
var $40e1ee3c5e8e95c2$export$d49828ec737de1f8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("nonce");
var $40e1ee3c5e8e95c2$export$f50297589147f25e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("noValidate");
var $40e1ee3c5e8e95c2$export$a8ff84c12d48cfa6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("name");
var $40e1ee3c5e8e95c2$export$987a4e3838aef8c6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("muted");
var $40e1ee3c5e8e95c2$export$939ddaa3205df08e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("multiple");
var $40e1ee3c5e8e95c2$export$8fe860a115a1e636 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("minLength");
var $40e1ee3c5e8e95c2$export$96ec731ed4dcb222 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("min");
var $40e1ee3c5e8e95c2$export$26f73335cc2e7868 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("method");
var $40e1ee3c5e8e95c2$export$2855e964765eac9 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("mediaGroup");
var $40e1ee3c5e8e95c2$export$987d49ffe1b0900f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("media");
var $40e1ee3c5e8e95c2$export$c9f461152c658a8b = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("maxLength");
var $40e1ee3c5e8e95c2$export$8960430cfd85939f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("max");
var $40e1ee3c5e8e95c2$export$b96a5d3d0bdb59ab = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("marginWidth");
var $40e1ee3c5e8e95c2$export$36de2ae1ef76c14 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("marginHeight");
var $40e1ee3c5e8e95c2$export$e538f94cc8cf4db8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("manifest");
var $40e1ee3c5e8e95c2$export$e81601c80b4e876e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("low");
var $40e1ee3c5e8e95c2$export$f9ef67375ddc185 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("loop");
var $40e1ee3c5e8e95c2$export$8837f4fc672e936d = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("list");
var $40e1ee3c5e8e95c2$export$9a771d6906431624 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("lang");
var $40e1ee3c5e8e95c2$export$1237798dc640739a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("label");
var $40e1ee3c5e8e95c2$export$78062f36b16ed2f8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("kind");
var $40e1ee3c5e8e95c2$export$849673e7f55bd5df = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("keyType");
var $40e1ee3c5e8e95c2$export$aa2dddef617d96d8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("keyParams");
var $40e1ee3c5e8e95c2$export$df61b30b684217c0 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("key");
var $40e1ee3c5e8e95c2$export$dc5555821983395c = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("itemType");
var $40e1ee3c5e8e95c2$export$7c508ebbe439b993 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("itemScope");
var $40e1ee3c5e8e95c2$export$f8ff082287e84956 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("itemRef");
var $40e1ee3c5e8e95c2$export$ba2da0f2221fbca9 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("itemProp");
var $40e1ee3c5e8e95c2$export$cb2dd37115b1cdf = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("itemID");
var $40e1ee3c5e8e95c2$export$226b3eccf92c9ed9 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("is");
var $40e1ee3c5e8e95c2$export$499bb390199f0627 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("integrity");
var $40e1ee3c5e8e95c2$export$e66a2da78d94e729 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("inputMode");
var $40e1ee3c5e8e95c2$export$ad380c2e75e99b5e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("inlist");
var $40e1ee3c5e8e95c2$export$1ca1ec8b29a4ce27 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("icon");
var $40e1ee3c5e8e95c2$export$725a8790b31857c5 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("httpEquiv");
var $40e1ee3c5e8e95c2$export$35d9e1c947946090 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("htmlFor");
var $40e1ee3c5e8e95c2$export$efb303580fe92495 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("hrefLang");
var $40e1ee3c5e8e95c2$export$8f51af5840e0602a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("href");
var $40e1ee3c5e8e95c2$export$7cb505ef3217a5c4 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("high");
var $40e1ee3c5e8e95c2$export$73920f18ca706874 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("hidden");
var $40e1ee3c5e8e95c2$export$ac607276a8fe9f0a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("height");
var $40e1ee3c5e8e95c2$export$838e2a576d4d6ff6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("headers");
var $40e1ee3c5e8e95c2$export$f17e388c4c951a22 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("frameBorder");
var $40e1ee3c5e8e95c2$export$497949a0ae76184f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("formTarget");
var $40e1ee3c5e8e95c2$export$87c857905fcc4a84 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("formNoValidate");
var $40e1ee3c5e8e95c2$export$3f1ffee261a00124 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("formMethod");
var $40e1ee3c5e8e95c2$export$46c446d479ef18ed = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("formEncType");
var $40e1ee3c5e8e95c2$export$7e4d70bab1b5c4a0 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("formAction");
var $40e1ee3c5e8e95c2$export$6210fa4921d2a466 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("form");
var $40e1ee3c5e8e95c2$export$7854e733f445decb = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("fillOpacity");
var $40e1ee3c5e8e95c2$export$9563e054e6f787fb = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("fill");
var $40e1ee3c5e8e95c2$export$163fbd98bd364314 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("encType");
var $40e1ee3c5e8e95c2$export$c746a5152d4ba26c = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("draggable");
var $40e1ee3c5e8e95c2$export$24422be91ad4011f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("download");
var $40e1ee3c5e8e95c2$export$683472f6198a076e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("disabled");
var $40e1ee3c5e8e95c2$export$147ec2801e896265 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("dir");
var $40e1ee3c5e8e95c2$export$260e5c0943f31606 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("defer");
var $40e1ee3c5e8e95c2$export$1a01ae0705bafd37 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("defaultValue");
var $40e1ee3c5e8e95c2$export$8f49a7e9e3141ccc = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("defaultChecked");
var $40e1ee3c5e8e95c2$export$2e2bcd8739ae039 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("default");
var $40e1ee3c5e8e95c2$export$3a17bddce263fba0 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("dateTime");
var $40e1ee3c5e8e95c2$export$f10f508557b85035 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("datatype");
var $40e1ee3c5e8e95c2$export$8331f8c46716f919 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("dangerouslySetInnerHTML");
var $40e1ee3c5e8e95c2$export$4368d992c4eafac0 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("d");
var $40e1ee3c5e8e95c2$export$aea64bc1b6f8f415 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cy");
var $40e1ee3c5e8e95c2$export$a274e22fb40f762e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cx");
var $40e1ee3c5e8e95c2$export$c47cb7c63271266e = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("crossOrigin");
var $40e1ee3c5e8e95c2$export$5bf93b4680474bd = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("coords");
var $40e1ee3c5e8e95c2$export$cc1adf6fb659c762 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("controls");
var $40e1ee3c5e8e95c2$export$218b899e1d476006 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("contextMenu");
var $40e1ee3c5e8e95c2$export$d9d317b4285c34e7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("contentEditable");
var $40e1ee3c5e8e95c2$export$a7db06668cad9adb = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("content");
var $40e1ee3c5e8e95c2$export$1eebcb1e706ab348 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cols");
var $40e1ee3c5e8e95c2$export$35e9368ef982300f = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("color");
var $40e1ee3c5e8e95c2$export$47be69ffacd0da98 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("colSpan");
var $40e1ee3c5e8e95c2$export$2913c0c0b5623090 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("className");
var $40e1ee3c5e8e95c2$export$ea328f854c03be5b = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("classID");
var $40e1ee3c5e8e95c2$export$3035df57df42c31a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cite");
var $40e1ee3c5e8e95c2$export$b96bb35bc88d6fa = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("checked");
var $40e1ee3c5e8e95c2$export$28057450ee2d4673 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("charSet");
var $40e1ee3c5e8e95c2$export$1cb6aab4c63c6c51 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("checked");
var $40e1ee3c5e8e95c2$export$83c732e5f2278749 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cellSpacing");
var $40e1ee3c5e8e95c2$export$31ac27096ec70d75 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("cellPadding");
var $40e1ee3c5e8e95c2$export$6f6534ba0edb1cf4 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("capture");
var $40e1ee3c5e8e95c2$export$fe5d31a2d1bc3747 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoSave");
var $40e1ee3c5e8e95c2$export$3ce976189ac304b7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoPlay");
var $40e1ee3c5e8e95c2$export$caf00a4585999643 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoFocus");
var $40e1ee3c5e8e95c2$export$6a1d8829b816b7a3 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoCorrect");
var $40e1ee3c5e8e95c2$export$d88a383e7d5eee04 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoComplete");
var $40e1ee3c5e8e95c2$export$42034d56c6651516 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("autoCapitalize");
var $40e1ee3c5e8e95c2$export$12af436354f1a4f7 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("async");
var $40e1ee3c5e8e95c2$export$4d2d26490572750a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$a69d530489679a43("aria-");
var $40e1ee3c5e8e95c2$export$228be17d80722ab = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("alt");
var $40e1ee3c5e8e95c2$export$a396e51e3abc9b1c = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("allowTransparency");
var $40e1ee3c5e8e95c2$export$b68dab8e7e8b5909 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("allowFullScreen");
var $40e1ee3c5e8e95c2$export$31eb53bd5b582a97 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("action");
var $40e1ee3c5e8e95c2$export$1113a6923fc2e342 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("accessKey");
var $40e1ee3c5e8e95c2$export$7e2eca70ed294fb = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("acceptCharset");
var $40e1ee3c5e8e95c2$export$73f57eecff448cc8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("accept");
var $40e1ee3c5e8e95c2$export$e86d578d3f4f42b6 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("about");
var $40e1ee3c5e8e95c2$export$1741e49665a9c8e8 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("type");
var $40e1ee3c5e8e95c2$export$9c7ae676ac45430a = /* #__PURE__ */ $1ac7a3b24b863c5b$export$1c24cb68eef06a2d("id");
var $40e1ee3c5e8e95c2$export$bd25e24024963319 = /* #__PURE__ */ $1ac7a3b24b863c5b$export$a69d530489679a43("data-");


// Generated by purs version 0.15.16
function $dbcf9655740e50d9$export$fa3b29edae795ef4(event) {
    return function() {
        return event.preventDefault();
    };
}
function $dbcf9655740e50d9$export$1ace64c8bf34ac99(event) {
    return function() {
        return event.isDefaultPrevented();
    };
}
function $dbcf9655740e50d9$export$51134cce184326b9(event) {
    return function() {
        return event.stopPropagation();
    };
}
function $dbcf9655740e50d9$export$8d6d6472146de265(event) {
    return function() {
        return event.isPropagationStopped();
    };
}
function $dbcf9655740e50d9$export$9a6132153fba2e0(event) {
    return function() {
        return event.persist();
    };
}
function $dbcf9655740e50d9$export$2ca6d30ac9cf718b(key) {
    return function(event) {
        return function() {
            return event.getModifierState(key);
        };
    };
}
function $dbcf9655740e50d9$export$1d94535d2cda4eda(key) {
    return function(event) {
        return function() {
            return event[key];
        };
    };
}




var $b7b39e79f5bb1b42$var$get = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(l) {
            return function(r) {
                return $dbcf9655740e50d9$export$1d94535d2cda4eda(reflectSymbol(l))(r);
            };
        };
    };
};
var $b7b39e79f5bb1b42$var$get1 = /* #__PURE__ */ $b7b39e79f5bb1b42$var$get();
var $b7b39e79f5bb1b42$export$c25a01320cf5f818 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "isTrusted";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$df61b30b684217c0 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "key";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$5ad5b11ec46384fb = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "keyCode";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$162ce11d62a1ca51 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "locale";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$17b07c660794dc13 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "location";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$a00c4774ca8bd5f6 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "metaKey";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$b73fb223874ca0fb = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "nativeEvent";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$d3b6e4285a853fca = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "pageX";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$91edef672b1bff5a = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "pageY";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$b832c5defe6a5d86 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "propertyName";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$ac01533c049286b7 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "pseudoElement";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$f545ae46046873e = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "relatedTarget";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$76d90c956114f2c2 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "repeat";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$daeacaab2dbcebdc = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "screenX";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$51b695a8750464db = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "screenY";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$7bcab82bb0a7284e = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "shiftKey";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$44271b4f0c6a3563 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "target";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$3dbecd8f8dce4f3e = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "targetTouches";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$c0dbb1ea68a069d3 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "timeStamp";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$a1912f4eb118cd0e = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "touches";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$d4a6a4db5b31e621 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "type";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$c4ddc81c7b2c8d7a = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "view";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$ffd0c0f5f633030f = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "which";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$adaf9bfc2029072d = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "eventPhase";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$1ea91570c695dfb2 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "elapsedTime";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$13a2d28b88853ef2 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "detail";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$bc27cb6881d4c041 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "deltaZ";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$15d22eb2bdb57158 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "deltaY";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$cbaa4cde49042758 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "deltaX";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$7213cc77c53badec = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "deltaMode";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$6add31d873bb7f97 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "defaultPrevented";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$70ac1efc5b13b551 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "data";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$28b27b1605aa05ad = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "currentTarget";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$37876086932f98b6 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "ctrlKey";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$787e2f0717fa5309 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "clipboardData";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$7b6d395a5f6775a3 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "clientY";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$7deb501ab1332e7e = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "clientX";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$caf4e1df1c801ab3 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "charCode";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$42a6fe4025303814 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "changedTouches";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$95ff25b64c2b7c9d = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "cancelable";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$bbea856fdb3e3c5f = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "buttons";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$2ba01fb71ed41cb6 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "button";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$a0e54c3daa7db493 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "bubbles";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$3661f43c23499d48 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "animationName";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();
var $b7b39e79f5bb1b42$export$b3cce955e7350d33 = /* #__PURE__ */ function() {
    return $b7b39e79f5bb1b42$var$get1({
        reflectSymbol: function() {
            return "altKey";
        }
    })($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
}();


var $fc1df90f0e252058$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $fc1df90f0e252058$export$48cfee2de6d81dfa = /* #__PURE__ */ function() {
    function PrimProp(value0) {
        this.value0 = value0;
    }
    PrimProp.create = function(value0) {
        return new PrimProp(value0);
    };
    return PrimProp;
}();
var $fc1df90f0e252058$export$a428cd33b25d5283 = /* #__PURE__ */ function() {
    function Handler(value0) {
        this.value0 = value0;
    }
    Handler.create = function(value0) {
        return new Handler(value0);
    };
    return Handler;
}();
var $fc1df90f0e252058$export$4a5767248b18ef41 = function($36) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$4a5767248b18ef41($36));
};
var $fc1df90f0e252058$export$d141bba7fdc215a3 = function($37) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d141bba7fdc215a3($37));
};
var $fc1df90f0e252058$export$4997ffc0176396a6 = function($38) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$4997ffc0176396a6($38));
};
var $fc1df90f0e252058$export$bcd91a8cae39e6cc = function($39) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$bcd91a8cae39e6cc($39));
};
var $fc1df90f0e252058$export$7e3df82ee760448c = function($40) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7e3df82ee760448c($40));
};
var $fc1df90f0e252058$export$9a0d1dab6a5902f = function($41) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9a0d1dab6a5902f($41));
};
var $fc1df90f0e252058$export$a179c88182cb9d56 = function($42) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a179c88182cb9d56($42));
};
var $fc1df90f0e252058$export$f003bc8843ece81 = function($43) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f003bc8843ece81($43));
};
var $fc1df90f0e252058$export$2ab9a8f9f1186f14 = function($44) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2ab9a8f9f1186f14($44));
};
var $fc1df90f0e252058$export$86f8f9f08863e403 = function($45) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$86f8f9f08863e403($45));
};
var $fc1df90f0e252058$export$e82bbdeee75fc1dc = function($46) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e82bbdeee75fc1dc($46));
};
var $fc1df90f0e252058$export$b79fd9f386367d78 = function(e) {
    return e.target.value;
};
var $fc1df90f0e252058$export$e2861d7590063d72 = function(s) {
    return new $fc1df90f0e252058$export$a428cd33b25d5283(function(f) {
        return $1ac7a3b24b863c5b$export$1c24cb68eef06a2d(s)($28d793bcad7b6401$export$33e695b1da6bf8ce(f));
    });
};
var $fc1df90f0e252058$export$d59e470a669dbbf6 = function(s) {
    return function(v) {
        return new $fc1df90f0e252058$export$48cfee2de6d81dfa($1ac7a3b24b863c5b$export$1c24cb68eef06a2d(s)(v));
    };
};
var $fc1df90f0e252058$export$1d10ed712457dec2 = function($47) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1d10ed712457dec2($47));
};
var $fc1df90f0e252058$export$fb184b623420d9be = function($48) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$fb184b623420d9be($48));
};
var $fc1df90f0e252058$export$44271b4f0c6a3563 = function($49) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$44271b4f0c6a3563($49));
};
var $fc1df90f0e252058$export$9a625f9de50bf0b7 = function($50) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9a625f9de50bf0b7($50));
};
var $fc1df90f0e252058$export$1a3835b7c98a6c9e = function($51) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1a3835b7c98a6c9e($51));
};
var $fc1df90f0e252058$export$9a2dbef7a17e2e58 = function($52) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9a2dbef7a17e2e58($52));
};
var $fc1df90f0e252058$export$1d567c320f4763bc = function($53) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1d567c320f4763bc($53));
};
var $fc1df90f0e252058$export$579295bc0236e309 = function($54) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$579295bc0236e309($54));
};
var $fc1df90f0e252058$export$d9b706f8d0a70aef = function($55) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d9b706f8d0a70aef($55));
};
var $fc1df90f0e252058$export$35d34bc0ed591a92 = function($56) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$35d34bc0ed591a92($56));
};
var $fc1df90f0e252058$export$b3571188c770cc5a = function($57) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b3571188c770cc5a($57));
};
var $fc1df90f0e252058$export$9a915d08f01c161a = function($58) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9a915d08f01c161a($58));
};
var $fc1df90f0e252058$export$f9fcc51506c42a8f = function($59) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f9fcc51506c42a8f($59));
};
var $fc1df90f0e252058$export$1c5fb2289a93dd05 = function($60) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1c5fb2289a93dd05($60));
};
var $fc1df90f0e252058$export$2e40c9e35e9506f4 = function($61) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2e40c9e35e9506f4($61));
};
var $fc1df90f0e252058$export$18817be2b8135eea = function($62) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$18817be2b8135eea($62));
};
var $fc1df90f0e252058$export$afc1bfabebaf28a2 = function($63) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$afc1bfabebaf28a2($63));
};
var $fc1df90f0e252058$export$c647cb0ee6e282fe = function($64) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c647cb0ee6e282fe($64));
};
var $fc1df90f0e252058$export$346677f925de839c = function($65) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$346677f925de839c($65));
};
var $fc1df90f0e252058$export$98bada23690e67eb = function($66) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$98bada23690e67eb($66));
};
var $fc1df90f0e252058$export$d90250155de6d7e7 = function($67) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d90250155de6d7e7($67));
};
var $fc1df90f0e252058$export$cdb96f27dc28cf43 = function($68) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$cdb96f27dc28cf43($68));
};
var $fc1df90f0e252058$export$5f4ba619a5f51bd2 = function($69) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$5f4ba619a5f51bd2($69));
};
var $fc1df90f0e252058$export$77825fa6f4ae045f = function($70) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$77825fa6f4ae045f($70));
};
var $fc1df90f0e252058$export$6387ff77edd805b9 = function($71) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$6387ff77edd805b9($71));
};
var $fc1df90f0e252058$export$5cff813ca8e50db9 = function($72) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$5cff813ca8e50db9($72));
};
var $fc1df90f0e252058$export$f020670913e851a6 = function($73) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f020670913e851a6($73));
};
var $fc1df90f0e252058$export$2dd197b55cf13440 = function($74) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2dd197b55cf13440($74));
};
var $fc1df90f0e252058$export$a5ce0649174d616e = function($75) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a5ce0649174d616e($75));
};
var $fc1df90f0e252058$export$3100efae45e879 = function($76) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3100efae45e879($76));
};
var $fc1df90f0e252058$export$e2239770db970295 = function($77) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e2239770db970295($77));
};
var $fc1df90f0e252058$export$5be82eb8d376fece = function($78) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$5be82eb8d376fece($78));
};
var $fc1df90f0e252058$export$23e0665cffcf8918 = function($79) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$23e0665cffcf8918($79));
};
var $fc1df90f0e252058$export$a7a0278c004aac3f = function($80) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a7a0278c004aac3f($80));
};
var $fc1df90f0e252058$export$bad408f43b005bc8 = function($81) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$bad408f43b005bc8($81));
};
var $fc1df90f0e252058$export$eff4d24c3ff7876e = function($82) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$eff4d24c3ff7876e($82));
};
var $fc1df90f0e252058$export$b2cbc93d4da94977 = function($83) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b2cbc93d4da94977($83));
};
var $fc1df90f0e252058$export$7246d22ab0922ede = function($84) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7246d22ab0922ede($84));
};
var $fc1df90f0e252058$export$43caf9889c228507 = function($85) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$43caf9889c228507($85));
};
var $fc1df90f0e252058$export$d541bacb2bda4494 = function($86) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d541bacb2bda4494($86));
};
var $fc1df90f0e252058$export$4882ae973e0491e = function($87) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$4882ae973e0491e($87));
};
var $fc1df90f0e252058$export$513ccb98c53b8039 = function($88) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$513ccb98c53b8039($88));
};
var $fc1df90f0e252058$export$82e9f45cca5ba907 = function($89) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$82e9f45cca5ba907($89));
};
var $fc1df90f0e252058$export$b840e55573b2d2e7 = function($90) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b840e55573b2d2e7($90));
};
var $fc1df90f0e252058$export$9f048bf86ee2e9d2 = function($91) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9f048bf86ee2e9d2($91));
};
var $fc1df90f0e252058$export$c7187bbd1a7a9244 = function($92) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c7187bbd1a7a9244($92));
};
var $fc1df90f0e252058$export$9a6132153fba2e0 = function(v) {
    if (v instanceof $fc1df90f0e252058$export$a428cd33b25d5283) return new $fc1df90f0e252058$export$a428cd33b25d5283(function(hdlr) {
        return v.value0(function(e) {
            return function __do() {
                var v1 = $dbcf9655740e50d9$export$9a6132153fba2e0(e)();
                return hdlr(e)();
            };
        });
    });
    if (v instanceof $fc1df90f0e252058$export$48cfee2de6d81dfa) return new $fc1df90f0e252058$export$48cfee2de6d81dfa(v.value0);
    throw new Error("Failed pattern match at Concur.React.Props (line 109, column 1 - line 111, column 36): " + [
        v.constructor.name
    ]);
};
var $fc1df90f0e252058$export$24f82734ea047e6f = function($93) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$24f82734ea047e6f($93));
};
var $fc1df90f0e252058$export$49f2954c623150dd = function($94) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$49f2954c623150dd($94));
};
var $fc1df90f0e252058$export$3ce6949f20cea765 = function($95) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3ce6949f20cea765($95));
};
var $fc1df90f0e252058$export$c17a3be1057836e = function($96) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c17a3be1057836e($96));
};
var $fc1df90f0e252058$export$9c41c6aa5463df6c = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9c41c6aa5463df6c);
}();
var $fc1df90f0e252058$export$65ea24ac132a9be9 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$65ea24ac132a9be9);
}();
var $fc1df90f0e252058$export$b2d283ef4399072a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$b2d283ef4399072a);
}();
var $fc1df90f0e252058$export$433c8ace949db4d0 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$433c8ace949db4d0);
}();
var $fc1df90f0e252058$export$cf2fc22360bd1c1f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$cf2fc22360bd1c1f);
}();
var $fc1df90f0e252058$export$f4786ad4c2750c66 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f4786ad4c2750c66);
}();
var $fc1df90f0e252058$export$b2f0402dd1c70df9 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$b2f0402dd1c70df9);
}();
var $fc1df90f0e252058$export$e967ac7bdb3c237c = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e967ac7bdb3c237c);
}();
var $fc1df90f0e252058$export$5ad67c4a93e1d0c3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5ad67c4a93e1d0c3);
}();
var $fc1df90f0e252058$export$37cbf11924865552 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$37cbf11924865552);
}();
var $fc1df90f0e252058$export$479ded11150d76a0 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$479ded11150d76a0);
}();
var $fc1df90f0e252058$export$42c53271760d4595 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$42c53271760d4595);
}();
var $fc1df90f0e252058$export$7347a4a302e2a86b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$7347a4a302e2a86b);
}();
var $fc1df90f0e252058$export$79b4bc20f2630414 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$79b4bc20f2630414);
}();
var $fc1df90f0e252058$export$ba0d3640fb9ec9c1 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ba0d3640fb9ec9c1);
}();
var $fc1df90f0e252058$export$931f312019b226f2 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$931f312019b226f2);
}();
var $fc1df90f0e252058$export$197d28649b5d58b4 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$197d28649b5d58b4);
}();
var $fc1df90f0e252058$export$9b74f80012185590 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9b74f80012185590);
}();
var $fc1df90f0e252058$export$e07ee915b4190531 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e07ee915b4190531);
}();
var $fc1df90f0e252058$export$f3bd975a281e5852 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f3bd975a281e5852);
}();
var $fc1df90f0e252058$export$15cc0b38068f93e3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$15cc0b38068f93e3);
}();
var $fc1df90f0e252058$export$df2126966cc1c06b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$df2126966cc1c06b);
}();
var $fc1df90f0e252058$export$603a22af4740963d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$603a22af4740963d);
}();
var $fc1df90f0e252058$export$307d29742c654737 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$307d29742c654737);
}();
var $fc1df90f0e252058$export$67a049a85258db10 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$67a049a85258db10);
}();
var $fc1df90f0e252058$export$44b00009b572ac28 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$44b00009b572ac28);
}();
var $fc1df90f0e252058$export$faa61b2616c9789d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$faa61b2616c9789d);
}();
var $fc1df90f0e252058$export$2cc8197d6ae5570 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2cc8197d6ae5570);
}();
var $fc1df90f0e252058$export$4945ad5cde249a83 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4945ad5cde249a83);
}();
var $fc1df90f0e252058$export$496615019362196d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$496615019362196d);
}();
var $fc1df90f0e252058$export$b8bfa60acf78611c = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$b8bfa60acf78611c);
}();
var $fc1df90f0e252058$export$e993ebdd863d5ffa = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e993ebdd863d5ffa);
}();
var $fc1df90f0e252058$export$bcf66c395889afe3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$bcf66c395889afe3);
}();
var $fc1df90f0e252058$export$d4d89fd61e5416ee = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$d4d89fd61e5416ee);
}();
var $fc1df90f0e252058$export$2e888a5085fb0446 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2e888a5085fb0446);
}();
var $fc1df90f0e252058$export$9a2c2bc12df434f6 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9a2c2bc12df434f6);
}();
var $fc1df90f0e252058$export$f11a32795aa2de56 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f11a32795aa2de56);
}();
var $fc1df90f0e252058$export$ebabfef4a68900da = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ebabfef4a68900da);
}();
var $fc1df90f0e252058$export$1981395931987789 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1981395931987789);
}();
var $fc1df90f0e252058$export$750809158ef981f7 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$750809158ef981f7);
}();
var $fc1df90f0e252058$export$1cbca9547fbf00ac = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1cbca9547fbf00ac);
}();
var $fc1df90f0e252058$export$1e3b2f48068fd04f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1e3b2f48068fd04f);
}();
var $fc1df90f0e252058$export$2ef73a3c732882b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2ef73a3c732882b);
}();
var $fc1df90f0e252058$export$cfa985a9cecdb0d4 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$cfa985a9cecdb0d4);
}();
var $fc1df90f0e252058$export$4c7505a16bccdf0f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4c7505a16bccdf0f);
}();
var $fc1df90f0e252058$export$48aae1120b60938a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$48aae1120b60938a);
}();
var $fc1df90f0e252058$export$82bd7d547863552a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$82bd7d547863552a);
}();
var $fc1df90f0e252058$export$3df825bff4f0a835 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$3df825bff4f0a835);
}();
var $fc1df90f0e252058$export$33e83ae183e41d86 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$33e83ae183e41d86);
}();
var $fc1df90f0e252058$export$afc474fdab5e8a8e = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$afc474fdab5e8a8e);
}();
var $fc1df90f0e252058$export$9903764da2e26850 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9903764da2e26850);
}();
var $fc1df90f0e252058$export$65a11040da641544 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$65a11040da641544);
}();
var $fc1df90f0e252058$export$973bc0112e607f66 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$973bc0112e607f66);
}();
var $fc1df90f0e252058$export$4e8e585ca96adf5d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4e8e585ca96adf5d);
}();
var $fc1df90f0e252058$export$5995eb9f00f5508a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5995eb9f00f5508a);
}();
var $fc1df90f0e252058$export$f06e70624327ed63 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f06e70624327ed63);
}();
var $fc1df90f0e252058$export$259dffc70a0affaf = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$259dffc70a0affaf);
}();
var $fc1df90f0e252058$export$7c562fbb06b8dec3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$7c562fbb06b8dec3);
}();
var $fc1df90f0e252058$export$89690746459d8a0a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$89690746459d8a0a);
}();
var $fc1df90f0e252058$export$6b09a96aed3f5178 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$6b09a96aed3f5178);
}();
var $fc1df90f0e252058$export$2fcf06bb02752096 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2fcf06bb02752096);
}();
var $fc1df90f0e252058$export$53fd4e98f60f4dcc = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$53fd4e98f60f4dcc);
}();
var $fc1df90f0e252058$export$8f17da60d629e29a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$8f17da60d629e29a);
}();
var $fc1df90f0e252058$export$24374354f7c57bc9 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$24374354f7c57bc9);
}();
var $fc1df90f0e252058$export$e4973941d7087a48 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e4973941d7087a48);
}();
var $fc1df90f0e252058$export$a34dceb3b47a82e8 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$a34dceb3b47a82e8);
}();
var $fc1df90f0e252058$export$2cd15c2174338ff0 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2cd15c2174338ff0);
}();
var $fc1df90f0e252058$export$4e4d8b287d028b6b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4e4d8b287d028b6b);
}();
var $fc1df90f0e252058$export$67e8ed65c683f57d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$67e8ed65c683f57d);
}();
var $fc1df90f0e252058$export$f144bbb6e186b14b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f144bbb6e186b14b);
}();
var $fc1df90f0e252058$export$3b479757aaa5e0 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$3b479757aaa5e0);
}();
var $fc1df90f0e252058$export$8b51387c2ca0f477 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$8b51387c2ca0f477);
}();
var $fc1df90f0e252058$export$6ca2dac1f56d16bc = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$6ca2dac1f56d16bc);
}();
var $fc1df90f0e252058$export$de8e1b1372cdb41b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$de8e1b1372cdb41b);
}();
var $fc1df90f0e252058$export$6c597759837f6bcf = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$6c597759837f6bcf);
}();
var $fc1df90f0e252058$export$ea9576bc99d1b7dd = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ea9576bc99d1b7dd);
}();
var $fc1df90f0e252058$export$91768e28f48821ec = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$91768e28f48821ec);
}();
var $fc1df90f0e252058$export$7fbc06d7c1beb512 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$7fbc06d7c1beb512);
}();
var $fc1df90f0e252058$export$3e57298b708a3dbe = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$3e57298b708a3dbe);
}();
var $fc1df90f0e252058$export$ecf9bf35ad97eb74 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ecf9bf35ad97eb74);
}();
var $fc1df90f0e252058$export$c7fb494ab08a31c8 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c7fb494ab08a31c8);
}();
var $fc1df90f0e252058$export$2288787135a8f66e = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2288787135a8f66e);
}();
var $fc1df90f0e252058$export$db5a7478a4cdcef7 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$db5a7478a4cdcef7);
}();
var $fc1df90f0e252058$export$f7e233a2008165c1 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f7e233a2008165c1);
}();
var $fc1df90f0e252058$export$2ca1942e080d8772 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$2ca1942e080d8772);
}();
var $fc1df90f0e252058$export$c89f6671c4b8a29f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c89f6671c4b8a29f);
}();
var $fc1df90f0e252058$export$63c23e41a680e891 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$63c23e41a680e891);
}();
var $fc1df90f0e252058$export$1d56e2bd2ae14c61 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1d56e2bd2ae14c61);
}();
var $fc1df90f0e252058$export$eb69fb1757891928 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$eb69fb1757891928);
}();
var $fc1df90f0e252058$export$4ae41a1b2479579a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4ae41a1b2479579a);
}();
var $fc1df90f0e252058$export$719c3e40f15f3db3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$719c3e40f15f3db3);
}();
var $fc1df90f0e252058$export$c052d596304c05ec = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c052d596304c05ec);
}();
var $fc1df90f0e252058$export$9a497bc80c25a2a1 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9a497bc80c25a2a1);
}();
var $fc1df90f0e252058$export$b00174fdb6a6ab8f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$b00174fdb6a6ab8f);
}();
var $fc1df90f0e252058$export$775d30f027c4f3e2 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$775d30f027c4f3e2);
}();
var $fc1df90f0e252058$export$caca362e3b7795bf = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$caca362e3b7795bf);
}();
var $fc1df90f0e252058$export$e0bf4d25d5610a9b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e0bf4d25d5610a9b);
}();
var $fc1df90f0e252058$export$5280b1a9a538737a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5280b1a9a538737a);
}();
var $fc1df90f0e252058$export$fa6ab1d1407567cd = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$fa6ab1d1407567cd);
}();
var $fc1df90f0e252058$export$5d99689eba023667 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5d99689eba023667);
}();
var $fc1df90f0e252058$export$435837a5ef4b00ba = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$435837a5ef4b00ba);
}();
var $fc1df90f0e252058$export$e2ce2d097d95a991 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$e2ce2d097d95a991);
}();
var $fc1df90f0e252058$export$287b5ac3147e31e1 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$287b5ac3147e31e1);
}();
var $fc1df90f0e252058$export$8566066e92caa8a = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$8566066e92caa8a);
}();
var $fc1df90f0e252058$export$6d0afe97770453c9 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$6d0afe97770453c9);
}();
var $fc1df90f0e252058$export$11a07b18d6f8f6d2 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$11a07b18d6f8f6d2);
}();
var $fc1df90f0e252058$export$5f41476ffcb13969 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5f41476ffcb13969);
}();
var $fc1df90f0e252058$export$12204e800775a4e0 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$12204e800775a4e0);
}();
var $fc1df90f0e252058$export$4d44b5f949715801 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$4d44b5f949715801);
}();
var $fc1df90f0e252058$export$330ca67a316b532c = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$330ca67a316b532c);
}();
var $fc1df90f0e252058$export$63d7b33088fa42cc = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$63d7b33088fa42cc);
}();
var $fc1df90f0e252058$export$f7fe233856e3c643 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$f7fe233856e3c643);
}();
var $fc1df90f0e252058$export$ff2b6053aee03e95 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ff2b6053aee03e95);
}();
var $fc1df90f0e252058$export$c7ff9ccd26e6312b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c7ff9ccd26e6312b);
}();
var $fc1df90f0e252058$export$26985b3bccb942bb = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$26985b3bccb942bb);
}();
var $fc1df90f0e252058$export$74250ad2fa11f3f5 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$74250ad2fa11f3f5);
}();
var $fc1df90f0e252058$export$38af0dc6d00b6566 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$38af0dc6d00b6566);
}();
var $fc1df90f0e252058$export$88088485e0d81193 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$88088485e0d81193);
}();
var $fc1df90f0e252058$export$a86909667c1a4812 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$a86909667c1a4812);
}();
var $fc1df90f0e252058$export$ec2aa26499ec74c3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$ec2aa26499ec74c3);
}();
var $fc1df90f0e252058$export$6f7e12241c0e0dcc = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$6f7e12241c0e0dcc);
}();
var $fc1df90f0e252058$export$1d5a917feb871989 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1d5a917feb871989);
}();
var $fc1df90f0e252058$export$c0751149ef8e32f6 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c0751149ef8e32f6);
}();
var $fc1df90f0e252058$export$bd913411069e59d3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$bd913411069e59d3);
}();
var $fc1df90f0e252058$export$9e1ece3973f89f6d = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$9e1ece3973f89f6d);
}();
var $fc1df90f0e252058$export$cd07b0ff74b0231b = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$cd07b0ff74b0231b);
}();
var $fc1df90f0e252058$export$87cbcda06018541c = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$87cbcda06018541c);
}();
var $fc1df90f0e252058$export$1cb09bab8fae7878 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1cb09bab8fae7878);
}();
var $fc1df90f0e252058$export$36be56b9d7c38124 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$36be56b9d7c38124);
}();
var $fc1df90f0e252058$export$5e446bc31724fca4 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$5e446bc31724fca4);
}();
var $fc1df90f0e252058$export$8a49f087756cf2fd = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$8a49f087756cf2fd);
}();
var $fc1df90f0e252058$export$1569ef336f556fb3 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$1569ef336f556fb3);
}();
var $fc1df90f0e252058$export$703d905cc670a615 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$703d905cc670a615);
}();
var $fc1df90f0e252058$export$a900cfe6dcb1e282 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$a900cfe6dcb1e282);
}();
var $fc1df90f0e252058$export$81adeab4d86e78a8 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$81adeab4d86e78a8);
}();
var $fc1df90f0e252058$export$19ed89f4c7f36de4 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$19ed89f4c7f36de4);
}();
var $fc1df90f0e252058$export$c5b87804d157d6aa = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$c5b87804d157d6aa);
}();
var $fc1df90f0e252058$export$d36091e57812e07 = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$a428cd33b25d5283($40e1ee3c5e8e95c2$export$d36091e57812e07);
}();
var $fc1df90f0e252058$export$d49828ec737de1f8 = function($97) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d49828ec737de1f8($97));
};
var $fc1df90f0e252058$export$f50297589147f25e = function($98) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f50297589147f25e($98));
};
var $fc1df90f0e252058$export$a8ff84c12d48cfa6 = function($99) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a8ff84c12d48cfa6($99));
};
var $fc1df90f0e252058$export$987a4e3838aef8c6 = function($100) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$987a4e3838aef8c6($100));
};
var $fc1df90f0e252058$export$939ddaa3205df08e = function($101) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$939ddaa3205df08e($101));
};
var $fc1df90f0e252058$export$d80ecae684ef7a9 = function(v) {
    return function(v1) {
        if (v1 instanceof $fc1df90f0e252058$export$48cfee2de6d81dfa) return v1.value0;
        if (v1 instanceof $fc1df90f0e252058$export$a428cd33b25d5283) return v1.value0(v);
        throw new Error("Failed pattern match at Concur.React.Props (line 24, column 1 - line 28, column 7): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $fc1df90f0e252058$export$8fe860a115a1e636 = function($102) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8fe860a115a1e636($102));
};
var $fc1df90f0e252058$export$96ec731ed4dcb222 = function($103) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$96ec731ed4dcb222($103));
};
var $fc1df90f0e252058$export$26f73335cc2e7868 = function($104) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$26f73335cc2e7868($104));
};
var $fc1df90f0e252058$export$2855e964765eac9 = function($105) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2855e964765eac9($105));
};
var $fc1df90f0e252058$export$987d49ffe1b0900f = function($106) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$987d49ffe1b0900f($106));
};
var $fc1df90f0e252058$export$c9f461152c658a8b = function($107) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c9f461152c658a8b($107));
};
var $fc1df90f0e252058$export$8960430cfd85939f = function($108) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8960430cfd85939f($108));
};
var $fc1df90f0e252058$export$b96a5d3d0bdb59ab = function($109) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b96a5d3d0bdb59ab($109));
};
var $fc1df90f0e252058$export$36de2ae1ef76c14 = function($110) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$36de2ae1ef76c14($110));
};
var $fc1df90f0e252058$export$e538f94cc8cf4db8 = function($111) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e538f94cc8cf4db8($111));
};
var $fc1df90f0e252058$export$e81601c80b4e876e = function($112) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e81601c80b4e876e($112));
};
var $fc1df90f0e252058$export$f9ef67375ddc185 = function($113) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f9ef67375ddc185($113));
};
var $fc1df90f0e252058$export$8837f4fc672e936d = function($114) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8837f4fc672e936d($114));
};
var $fc1df90f0e252058$export$9a771d6906431624 = function($115) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9a771d6906431624($115));
};
var $fc1df90f0e252058$export$1237798dc640739a = function($116) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1237798dc640739a($116));
};
var $fc1df90f0e252058$export$78062f36b16ed2f8 = function($117) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$78062f36b16ed2f8($117));
};
var $fc1df90f0e252058$export$849673e7f55bd5df = function($118) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$849673e7f55bd5df($118));
};
var $fc1df90f0e252058$export$aa2dddef617d96d8 = function($119) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$aa2dddef617d96d8($119));
};
var $fc1df90f0e252058$export$df61b30b684217c0 = function($120) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$df61b30b684217c0($120));
};
var $fc1df90f0e252058$export$dc5555821983395c = function($121) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$dc5555821983395c($121));
};
var $fc1df90f0e252058$export$7c508ebbe439b993 = function($122) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7c508ebbe439b993($122));
};
var $fc1df90f0e252058$export$f8ff082287e84956 = function($123) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f8ff082287e84956($123));
};
var $fc1df90f0e252058$export$ba2da0f2221fbca9 = function($124) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$ba2da0f2221fbca9($124));
};
var $fc1df90f0e252058$export$cb2dd37115b1cdf = function($125) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$cb2dd37115b1cdf($125));
};
var $fc1df90f0e252058$export$edd1eb89fbbc58a4 = function(e) {
    return e.which === 13 || e.keyCode === 13;
};
var $fc1df90f0e252058$export$226b3eccf92c9ed9 = function($126) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$226b3eccf92c9ed9($126));
};
var $fc1df90f0e252058$export$499bb390199f0627 = function($127) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$499bb390199f0627($127));
};
var $fc1df90f0e252058$export$e66a2da78d94e729 = function($128) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e66a2da78d94e729($128));
};
var $fc1df90f0e252058$export$ad380c2e75e99b5e = function($129) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$ad380c2e75e99b5e($129));
};
var $fc1df90f0e252058$export$1ca1ec8b29a4ce27 = function($130) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1ca1ec8b29a4ce27($130));
};
var $fc1df90f0e252058$export$725a8790b31857c5 = function($131) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$725a8790b31857c5($131));
};
var $fc1df90f0e252058$export$35d9e1c947946090 = function($132) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$35d9e1c947946090($132));
};
var $fc1df90f0e252058$export$efb303580fe92495 = function($133) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$efb303580fe92495($133));
};
var $fc1df90f0e252058$export$8f51af5840e0602a = function($134) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8f51af5840e0602a($134));
};
var $fc1df90f0e252058$export$7cb505ef3217a5c4 = function($135) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7cb505ef3217a5c4($135));
};
var $fc1df90f0e252058$export$73920f18ca706874 = function($136) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$73920f18ca706874($136));
};
var $fc1df90f0e252058$export$ac607276a8fe9f0a = function($137) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$ac607276a8fe9f0a($137));
};
var $fc1df90f0e252058$export$838e2a576d4d6ff6 = function($138) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$838e2a576d4d6ff6($138));
};
var $fc1df90f0e252058$export$d3f9a66fb0942724 = function(v) {
    return function(v1) {
        if (v1 instanceof $fc1df90f0e252058$export$48cfee2de6d81dfa) return new $fc1df90f0e252058$export$48cfee2de6d81dfa(v1.value0);
        if (v1 instanceof $fc1df90f0e252058$export$a428cd33b25d5283) return new $fc1df90f0e252058$export$48cfee2de6d81dfa(v1.value0(v));
        throw new Error("Failed pattern match at Concur.React.Props (line 33, column 1 - line 37, column 15): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $fc1df90f0e252058$export$1b20d35107c3eb06 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $fc1df90f0e252058$export$48cfee2de6d81dfa) return new $fc1df90f0e252058$export$48cfee2de6d81dfa(v1.value0);
            if (v1 instanceof $fc1df90f0e252058$export$a428cd33b25d5283) return new $fc1df90f0e252058$export$a428cd33b25d5283(function(k) {
                return v1.value0(function($139) {
                    return k(v($139));
                });
            });
            throw new Error("Failed pattern match at Concur.React.Props (line 19, column 1 - line 21, column 48): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $fc1df90f0e252058$export$f17e388c4c951a22 = function($140) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f17e388c4c951a22($140));
};
var $fc1df90f0e252058$export$497949a0ae76184f = function($141) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$497949a0ae76184f($141));
};
var $fc1df90f0e252058$export$87c857905fcc4a84 = function($142) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$87c857905fcc4a84($142));
};
var $fc1df90f0e252058$export$3f1ffee261a00124 = function($143) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3f1ffee261a00124($143));
};
var $fc1df90f0e252058$export$46c446d479ef18ed = function($144) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$46c446d479ef18ed($144));
};
var $fc1df90f0e252058$export$7e4d70bab1b5c4a0 = function($145) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7e4d70bab1b5c4a0($145));
};
var $fc1df90f0e252058$export$6210fa4921d2a466 = function($146) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$6210fa4921d2a466($146));
};
var $fc1df90f0e252058$export$f28dd611770f1573 = function(v) {
    return function(v1) {
        if (v1 instanceof $fc1df90f0e252058$export$48cfee2de6d81dfa) return v1;
        if (v1 instanceof $fc1df90f0e252058$export$a428cd33b25d5283) return new $fc1df90f0e252058$export$a428cd33b25d5283(function(h) {
            return v1.value0(function(a) {
                var $34 = v(a);
                if ($34) return h(a);
                return $fc1df90f0e252058$var$pure($05149ea687d6b460$export$523c0b569236b342);
            });
        });
        throw new Error("Failed pattern match at Concur.React.Props (line 43, column 1 - line 47, column 15): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $fc1df90f0e252058$export$3c65564123ec97aa = /* #__PURE__ */ $fc1df90f0e252058$export$f28dd611770f1573($fc1df90f0e252058$export$edd1eb89fbbc58a4)($fc1df90f0e252058$export$de8e1b1372cdb41b);
var $fc1df90f0e252058$export$7854e733f445decb = function($147) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7854e733f445decb($147));
};
var $fc1df90f0e252058$export$9563e054e6f787fb = function($148) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9563e054e6f787fb($148));
};
var $fc1df90f0e252058$export$163fbd98bd364314 = function($149) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$163fbd98bd364314($149));
};
var $fc1df90f0e252058$export$f55bee699d443c2f = /* #__PURE__ */ function() {
    return new $fc1df90f0e252058$export$48cfee2de6d81dfa($e55bfe0c1fd19afa$export$1b58b299a5c07a6f);
}();
var $fc1df90f0e252058$export$c746a5152d4ba26c = function($150) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c746a5152d4ba26c($150));
};
var $fc1df90f0e252058$export$24422be91ad4011f = function($151) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$24422be91ad4011f($151));
};
var $fc1df90f0e252058$export$683472f6198a076e = function($152) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$683472f6198a076e($152));
};
var $fc1df90f0e252058$export$147ec2801e896265 = function($153) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$147ec2801e896265($153));
};
var $fc1df90f0e252058$export$260e5c0943f31606 = function($154) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$260e5c0943f31606($154));
};
var $fc1df90f0e252058$export$1a01ae0705bafd37 = function($155) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1a01ae0705bafd37($155));
};
var $fc1df90f0e252058$export$8f49a7e9e3141ccc = function($156) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8f49a7e9e3141ccc($156));
};
var $fc1df90f0e252058$export$2e2bcd8739ae039 = function($157) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2e2bcd8739ae039($157));
};
var $fc1df90f0e252058$export$3a17bddce263fba0 = function($158) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3a17bddce263fba0($158));
};
var $fc1df90f0e252058$export$f10f508557b85035 = function($159) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$f10f508557b85035($159));
};
var $fc1df90f0e252058$export$8331f8c46716f919 = function($160) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$8331f8c46716f919($160));
};
var $fc1df90f0e252058$export$4368d992c4eafac0 = function($161) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$4368d992c4eafac0($161));
};
var $fc1df90f0e252058$export$aea64bc1b6f8f415 = function($162) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$aea64bc1b6f8f415($162));
};
var $fc1df90f0e252058$export$a274e22fb40f762e = function($163) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a274e22fb40f762e($163));
};
var $fc1df90f0e252058$export$c47cb7c63271266e = function($164) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$c47cb7c63271266e($164));
};
var $fc1df90f0e252058$export$5bf93b4680474bd = function($165) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$5bf93b4680474bd($165));
};
var $fc1df90f0e252058$export$cc1adf6fb659c762 = function($166) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$cc1adf6fb659c762($166));
};
var $fc1df90f0e252058$export$218b899e1d476006 = function($167) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$218b899e1d476006($167));
};
var $fc1df90f0e252058$export$d9d317b4285c34e7 = function($168) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d9d317b4285c34e7($168));
};
var $fc1df90f0e252058$export$a7db06668cad9adb = function($169) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a7db06668cad9adb($169));
};
var $fc1df90f0e252058$export$1eebcb1e706ab348 = function($170) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1eebcb1e706ab348($170));
};
var $fc1df90f0e252058$export$35e9368ef982300f = function($171) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$35e9368ef982300f($171));
};
var $fc1df90f0e252058$export$47be69ffacd0da98 = function($172) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$47be69ffacd0da98($172));
};
var $fc1df90f0e252058$export$2913c0c0b5623090 = function($173) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$2913c0c0b5623090($173));
};
var $fc1df90f0e252058$export$11c615ce16f87241 = /* #__PURE__ */ function() {
    var $174 = $396c4c3d9e7fae3c$export$739ec22334c44788($784e1bd3d26d71da$export$fc39f3d77fa2e58a)(" ");
    var $175 = $396c4c3d9e7fae3c$export$c28c8388be0ab31a($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])(function(s) {
        return [
            s
        ];
    }));
    return function($176) {
        return $fc1df90f0e252058$export$2913c0c0b5623090($174($175($176)));
    };
}();
var $fc1df90f0e252058$export$ea328f854c03be5b = function($177) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$ea328f854c03be5b($177));
};
var $fc1df90f0e252058$export$3035df57df42c31a = function($178) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3035df57df42c31a($178));
};
var $fc1df90f0e252058$export$b96bb35bc88d6fa = function($179) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b96bb35bc88d6fa($179));
};
var $fc1df90f0e252058$export$28057450ee2d4673 = function($180) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$28057450ee2d4673($180));
};
var $fc1df90f0e252058$export$1cb6aab4c63c6c51 = function($181) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1cb6aab4c63c6c51($181));
};
var $fc1df90f0e252058$export$83c732e5f2278749 = function($182) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$83c732e5f2278749($182));
};
var $fc1df90f0e252058$export$31ac27096ec70d75 = function($183) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$31ac27096ec70d75($183));
};
var $fc1df90f0e252058$export$6f6534ba0edb1cf4 = function($184) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$6f6534ba0edb1cf4($184));
};
var $fc1df90f0e252058$export$fe5d31a2d1bc3747 = function($185) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$fe5d31a2d1bc3747($185));
};
var $fc1df90f0e252058$export$3ce976189ac304b7 = function($186) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$3ce976189ac304b7($186));
};
var $fc1df90f0e252058$export$caf00a4585999643 = function($187) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$caf00a4585999643($187));
};
var $fc1df90f0e252058$export$6a1d8829b816b7a3 = function($188) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$6a1d8829b816b7a3($188));
};
var $fc1df90f0e252058$export$d88a383e7d5eee04 = function($189) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$d88a383e7d5eee04($189));
};
var $fc1df90f0e252058$export$42034d56c6651516 = function($190) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$42034d56c6651516($190));
};
var $fc1df90f0e252058$export$12af436354f1a4f7 = function($191) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$12af436354f1a4f7($191));
};
var $fc1df90f0e252058$export$4d2d26490572750a = function($192) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$4d2d26490572750a($192));
};
var $fc1df90f0e252058$export$228be17d80722ab = function($193) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$228be17d80722ab($193));
};
var $fc1df90f0e252058$export$a396e51e3abc9b1c = function($194) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$a396e51e3abc9b1c($194));
};
var $fc1df90f0e252058$export$b68dab8e7e8b5909 = function($195) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$b68dab8e7e8b5909($195));
};
var $fc1df90f0e252058$export$31eb53bd5b582a97 = function($196) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$31eb53bd5b582a97($196));
};
var $fc1df90f0e252058$export$1113a6923fc2e342 = function($197) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1113a6923fc2e342($197));
};
var $fc1df90f0e252058$export$7e2eca70ed294fb = function($198) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$7e2eca70ed294fb($198));
};
var $fc1df90f0e252058$export$73f57eecff448cc8 = function($199) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$73f57eecff448cc8($199));
};
var $fc1df90f0e252058$export$e86d578d3f4f42b6 = function($200) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$e86d578d3f4f42b6($200));
};
var $fc1df90f0e252058$export$1741e49665a9c8e8 = function($201) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$1741e49665a9c8e8($201));
};
var $fc1df90f0e252058$export$9c7ae676ac45430a = function($202) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$9c7ae676ac45430a($202));
};
var $fc1df90f0e252058$export$bd25e24024963319 = function($203) {
    return $fc1df90f0e252058$export$48cfee2de6d81dfa.create($40e1ee3c5e8e95c2$export$bd25e24024963319($203));
};





// Generated by purs version 0.15.16
// Generated by purs version 0.15.16

var $acw62 = parcelRequire("acw62");
function $947a65af5aa39c2c$var$createClass(baseClass) {
    function invoke1(f) {
        return f === undefined ? f : function(a) {
            return f(a)();
        };
    }
    function invoke2(f) {
        return f === undefined ? f : function(a, b) {
            return f(a)(b)();
        };
    }
    function invoke3(f) {
        return f === undefined ? f : function(a, b, c) {
            return f(a)(b)(c)();
        };
    }
    return function(displayName) {
        return function(ctrFn) {
            var Constructor = function(props) {
                baseClass.call(this, props);
                var spec = ctrFn(this)();
                this.state = spec.state;
                this.render = spec.render;
                this.componentDidMount = spec.componentDidMount;
                this.componentWillUnmount = spec.componentWillUnmount;
                this.componentDidCatch = invoke2(spec.componentDidCatch);
                this.componentWillUpdate = invoke2(spec.componentWillUpdate);
                this.shouldComponentUpdate = invoke2(spec.shouldComponentUpdate);
                this.getSnapshotBeforeUpdate = invoke2(spec.getSnapshotBeforeUpdate);
                this.componentDidUpdate = invoke3(spec.componentDidUpdate);
                this.UNSAFE_componentWillMount = spec.unsafeComponentWillMount;
                this.UNSAFE_componentWillReceiveProps = invoke1(spec.unsafeComponentWillReceiveProps);
                this.UNSAFE_componentWillUpdate = invoke2(spec.unsafeComponentWillUpdate);
            };
            Constructor.displayName = displayName;
            Constructor.prototype = Object.create(baseClass.prototype);
            Constructor.prototype.constructor = Constructor;
            return Constructor;
        };
    };
}
var $947a65af5aa39c2c$export$fed69d03165efff3 = $947a65af5aa39c2c$var$createClass((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
// eslint-disable-next-line no-unused-vars
function $947a65af5aa39c2c$var$createClassWithDerivedState(classCtr) {
    return function(displayName) {
        return function(getDerivedStateFromProps) {
            return function(ctrFn) {
                var Constructor = $947a65af5aa39c2c$export$fed69d03165efff3(displayName)(ctrFn);
                Constructor.getDerivedStateFromProps = function(a, b) {
                    return getDerivedStateFromProps(a)(b);
                };
                return Constructor;
            };
        };
    };
}
const $947a65af5aa39c2c$export$911caf2d12eea8cb = $947a65af5aa39c2c$var$createClassWithDerivedState($947a65af5aa39c2c$export$fed69d03165efff3);
var $947a65af5aa39c2c$export$25c75d79b7921ccc = $947a65af5aa39c2c$var$createClass((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).PureComponent);
const $947a65af5aa39c2c$export$deb7f22f0235417e = $947a65af5aa39c2c$var$createClassWithDerivedState($947a65af5aa39c2c$export$25c75d79b7921ccc);
function $947a65af5aa39c2c$export$68e374fa6ae55f1b(x) {
    return x;
}
const $947a65af5aa39c2c$export$f00aeb236b6f05af = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment;
function $947a65af5aa39c2c$export$75fe5f91d452f94b(this_) {
    return function() {
        return this_.props;
    };
}
const $947a65af5aa39c2c$export$7032ae6d9d98bedd = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray;
const $947a65af5aa39c2c$export$ee61209492a3d04d = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count;
function $947a65af5aa39c2c$export$57d65a56f238691d(this_) {
    return function(state) {
        return function() {
            this_.setState(state);
        };
    };
}
function $947a65af5aa39c2c$export$a724c9d5285856df(this_) {
    return function(state) {
        return function(cb) {
            return function() {
                this_.setState(state, cb);
            };
        };
    };
}
function $947a65af5aa39c2c$export$50fdfeece43146fd(this_) {
    return function() {
        if (!this_.state) throw new Error("[purescript-react] Cannot get state within constructor");
        return this_.state;
    };
}
function $947a65af5aa39c2c$export$3865a3e33f9c397e(this_) {
    return function(cb) {
        return function() {
            this_.forceUpdate(cb);
        };
    };
}
function $947a65af5aa39c2c$export$93db4738633a0339(class_) {
    return function(props) {
        return function(children) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement.apply((0, (/*@__PURE__*/$parcel$interopDefault($acw62))), [
                class_,
                props
            ].concat(children));
        };
    };
}
function $947a65af5aa39c2c$export$6eb8b28a7a01f89f(class_) {
    return function(props) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(class_, props);
    };
}
function $947a65af5aa39c2c$export$9eaeebfdbd18fdb0(class_) {
    return function(props) {
        return function(children) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(class_, props, children);
        };
    };
}
function $947a65af5aa39c2c$export$fd42f52fd3ae1109(defaultValue) {
    var context = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(defaultValue);
    return {
        consumer: context.Consumer,
        provider: context.Provider
    };
}
var $947a65af5aa39c2c$export$28f255effb441d2b = null;
function $947a65af5aa39c2c$export$3d0218699894ffaa(a) {
    return a === $947a65af5aa39c2c$export$28f255effb441d2b;
}









var $6500c29ba0ac3395$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $6500c29ba0ac3395$export$169a89ec3fae5667 = $947a65af5aa39c2c$export$a724c9d5285856df;
var $6500c29ba0ac3395$export$aaf25bf2d74e9515 = $947a65af5aa39c2c$export$57d65a56f238691d;
var $6500c29ba0ac3395$export$f684561de770fa00 = $947a65af5aa39c2c$export$6eb8b28a7a01f89f;
var $6500c29ba0ac3395$export$8c51a24c432dffbf = $947a65af5aa39c2c$export$9eaeebfdbd18fdb0;
var $6500c29ba0ac3395$export$610acb4e9d1b3217 = $947a65af5aa39c2c$export$93db4738633a0339;
var $6500c29ba0ac3395$export$8d51e3db1a844094 = function(dict) {
    return dict.toElement;
};
var $6500c29ba0ac3395$export$4668480d040e3e69 = function() {
    return $947a65af5aa39c2c$export$a724c9d5285856df;
};
var $6500c29ba0ac3395$export$42fffed799c298bb = function() {
    return $947a65af5aa39c2c$export$57d65a56f238691d;
};
var $6500c29ba0ac3395$export$cbe0f5ac85f23b32 = function() {
    return function() {
        return {};
    };
};
var $6500c29ba0ac3395$export$9559a4f4edfe9430 = function() {
    return function() {
        return {};
    };
};
var $6500c29ba0ac3395$export$e3e94eef18782d33 = function() {
    return function() {
        return {};
    };
};
var $6500c29ba0ac3395$export$13c99d4d01a9e3a8 = function() {
    return $947a65af5aa39c2c$export$911caf2d12eea8cb;
};
var $6500c29ba0ac3395$export$6bcef1b7cc69c425 = function() {
    return $947a65af5aa39c2c$export$25c75d79b7921ccc;
};
var $6500c29ba0ac3395$export$56919119e80fd5ce = $947a65af5aa39c2c$export$a724c9d5285856df;
var $6500c29ba0ac3395$export$1b7123fafbe4cfd2 = $947a65af5aa39c2c$export$57d65a56f238691d;
var $6500c29ba0ac3395$export$21a1d964a29cdcb5 = {
    toElement: $ac8b3532514ac019$export$401372c57776dc
};
var $6500c29ba0ac3395$export$b549a35556e82bbd = {
    toElement: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa)
};
var $6500c29ba0ac3395$export$ebf9d87e9f018bdd = {
    toElement: $ac8b3532514ac019$export$401372c57776dc
};
var $6500c29ba0ac3395$export$16734f9597559d74 = {
    toElement: $ac8b3532514ac019$export$401372c57776dc
};
var $6500c29ba0ac3395$export$c013fbe7de12293d = {
    toElement: $ac8b3532514ac019$export$401372c57776dc
};
var $6500c29ba0ac3395$export$98c7f8edae68c30f = function($$this) {
    return $947a65af5aa39c2c$export$3865a3e33f9c397e($$this)($6500c29ba0ac3395$var$pure($05149ea687d6b460$export$523c0b569236b342));
};
var $6500c29ba0ac3395$export$5a5fe77d944fbeed = function() {
    return $947a65af5aa39c2c$export$6eb8b28a7a01f89f;
};
var $6500c29ba0ac3395$export$df585a9c2ccf1a13 = function() {
    return $947a65af5aa39c2c$export$9eaeebfdbd18fdb0;
};
var $6500c29ba0ac3395$export$c8a8987d4410bf2d = function() {
    return $947a65af5aa39c2c$export$93db4738633a0339;
};
var $6500c29ba0ac3395$var$createElement1 = /* #__PURE__ */ $6500c29ba0ac3395$export$c8a8987d4410bf2d();
var $6500c29ba0ac3395$export$b09ad4ddaacece26 = /* #__PURE__ */ function() {
    var $10 = $6500c29ba0ac3395$var$createElement1($947a65af5aa39c2c$export$f00aeb236b6f05af);
    return function($11) {
        return $10(function(v) {
            return {
                key: v
            };
        }($11));
    };
}();
var $6500c29ba0ac3395$export$3571dacacaf17bf = {
    append: function(a) {
        return function(b) {
            if ($947a65af5aa39c2c$export$3d0218699894ffaa(a)) return b;
            if ($947a65af5aa39c2c$export$3d0218699894ffaa(b)) return a;
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $6500c29ba0ac3395$export$8d51e3db1a844094($6500c29ba0ac3395$export$1bf591d4b1bc94be)([
                a,
                b
            ]);
            throw new Error("Failed pattern match at React (line 88, column 1 - line 92, column 37): " + [
                a.constructor.name,
                b.constructor.name
            ]);
        };
    }
};
var $6500c29ba0ac3395$export$6a1b7e61b7c06c0f = {
    mempty: $947a65af5aa39c2c$export$28f255effb441d2b,
    Semigroup0: function() {
        return $6500c29ba0ac3395$export$3571dacacaf17bf;
    }
};
var $6500c29ba0ac3395$export$1bf591d4b1bc94be = {
    toElement: function(v) {
        if (v.length === 0) return $784e1bd3d26d71da$export$9a7d64bc1d75357($6500c29ba0ac3395$export$6a1b7e61b7c06c0f);
        return $6500c29ba0ac3395$var$createElement1($947a65af5aa39c2c$export$f00aeb236b6f05af)({})(v);
    }
};
var $6500c29ba0ac3395$export$7fad56cead083f6e = function() {
    return $947a65af5aa39c2c$export$911caf2d12eea8cb;
};
var $6500c29ba0ac3395$export$d8556a2a8f973135 = function() {
    return $947a65af5aa39c2c$export$fed69d03165efff3;
};




var $7e9637001c296a92$export$6b702979f33d153f = function(x) {
    return x;
};
var $7e9637001c296a92$export$6f093cfa640b7166 = $ac8b3532514ac019$export$401372c57776dc;
var $7e9637001c296a92$export$98e628dec113755e = $ac8b3532514ac019$export$401372c57776dc;
var $7e9637001c296a92$export$1ac1623f62b36acb = function(dynamic) {
    return function(tag) {
        return function(props) {
            var createElement = function() {
                if (!dynamic) return $947a65af5aa39c2c$export$93db4738633a0339;
                if (dynamic) return $947a65af5aa39c2c$export$9eaeebfdbd18fdb0;
                throw new Error("Failed pattern match at React.DOM (line 14, column 5 - line 16, column 52): " + [
                    dynamic.constructor.name
                ]);
            }();
            return createElement(tag)($1ac7a3b24b863c5b$export$3fe23fdec027b2e3(props));
        };
    };
};
var $7e9637001c296a92$export$80e4b313e5e6b30d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("nav");
var $7e9637001c296a92$export$a9cd8dd9221a5e05 = /* #__PURE__ */ $7e9637001c296a92$export$80e4b313e5e6b30d([]);
var $7e9637001c296a92$export$528ba0e6da49e146 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("noscript");
var $7e9637001c296a92$export$a55b6dc9290354ad = /* #__PURE__ */ $7e9637001c296a92$export$528ba0e6da49e146([]);
var $7e9637001c296a92$export$be5493f9613cbbe = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("object");
var $7e9637001c296a92$export$2372fa35676c79a9 = /* #__PURE__ */ $7e9637001c296a92$export$be5493f9613cbbe([]);
var $7e9637001c296a92$export$b2235297ee22a6fe = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("ol");
var $7e9637001c296a92$export$9b5c0739560cca0a = /* #__PURE__ */ $7e9637001c296a92$export$b2235297ee22a6fe([]);
var $7e9637001c296a92$export$b9d336f245a516e8 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("optgroup");
var $7e9637001c296a92$export$ab0c0fbf80e41eeb = /* #__PURE__ */ $7e9637001c296a92$export$b9d336f245a516e8([]);
var $7e9637001c296a92$export$a75d1723e6bda2ec = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("option");
var $7e9637001c296a92$export$801594ff2d678603 = /* #__PURE__ */ $7e9637001c296a92$export$a75d1723e6bda2ec([]);
var $7e9637001c296a92$export$c789db2c85949867 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("output");
var $7e9637001c296a92$export$e4c5b5b8ca5f5a8f = /* #__PURE__ */ $7e9637001c296a92$export$c789db2c85949867([]);
var $7e9637001c296a92$export$ffb5f4729a158638 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("p");
var $7e9637001c296a92$export$3cf7d23e34405d00 = /* #__PURE__ */ $7e9637001c296a92$export$ffb5f4729a158638([]);
var $7e9637001c296a92$export$6f7d1d9d04558207 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("param")(props)([]);
};
var $7e9637001c296a92$export$ae3ba61eedc635b7 = /* #__PURE__ */ $7e9637001c296a92$export$6f7d1d9d04558207([]);
var $7e9637001c296a92$export$1188214e9d38144e = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("picture");
var $7e9637001c296a92$export$accd57f3700f6211 = /* #__PURE__ */ $7e9637001c296a92$export$1188214e9d38144e([]);
var $7e9637001c296a92$export$2af2ac64526e2aa9 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("pre");
var $7e9637001c296a92$export$31f7d7ffe82c4c23 = /* #__PURE__ */ $7e9637001c296a92$export$2af2ac64526e2aa9([]);
var $7e9637001c296a92$export$504d7abb21fa8c9 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("progress");
var $7e9637001c296a92$export$6fd22782efc8fe1f = /* #__PURE__ */ $7e9637001c296a92$export$504d7abb21fa8c9([]);
var $7e9637001c296a92$export$9e5f44173e64f162 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("q");
var $7e9637001c296a92$export$b222a598fa42b197 = /* #__PURE__ */ $7e9637001c296a92$export$9e5f44173e64f162([]);
var $7e9637001c296a92$export$6d4c73e3ddf8818b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("rp");
var $7e9637001c296a92$export$2f605997cc5faf5f = /* #__PURE__ */ $7e9637001c296a92$export$6d4c73e3ddf8818b([]);
var $7e9637001c296a92$export$f08282231bb71285 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("rt");
var $7e9637001c296a92$export$d6164f6a3f663bf = /* #__PURE__ */ $7e9637001c296a92$export$f08282231bb71285([]);
var $7e9637001c296a92$export$f2b283820b448b35 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("ruby");
var $7e9637001c296a92$export$34faf91949064752 = /* #__PURE__ */ $7e9637001c296a92$export$f2b283820b448b35([]);
var $7e9637001c296a92$export$2408f22a0fab9ae5 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("s");
var $7e9637001c296a92$export$2d18448ab5df9ebd = /* #__PURE__ */ $7e9637001c296a92$export$2408f22a0fab9ae5([]);
var $7e9637001c296a92$export$8c1cb8fb6818c292 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("samp");
var $7e9637001c296a92$export$a2d43502358a9716 = /* #__PURE__ */ $7e9637001c296a92$export$8c1cb8fb6818c292([]);
var $7e9637001c296a92$export$bc237d627614fc48 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("script");
var $7e9637001c296a92$export$5c866d2f7e90e8f2 = /* #__PURE__ */ $7e9637001c296a92$export$bc237d627614fc48([]);
var $7e9637001c296a92$export$fe2e36411d703b3d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("section");
var $7e9637001c296a92$export$438606398c5544c0 = /* #__PURE__ */ $7e9637001c296a92$export$fe2e36411d703b3d([]);
var $7e9637001c296a92$export$2e6c959c16ff56b8 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("select");
var $7e9637001c296a92$export$8b371b7a43624610 = /* #__PURE__ */ $7e9637001c296a92$export$2e6c959c16ff56b8([]);
var $7e9637001c296a92$export$3c17b0e969a90510 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("small");
var $7e9637001c296a92$export$7f4b82997bee17e7 = /* #__PURE__ */ $7e9637001c296a92$export$3c17b0e969a90510([]);
var $7e9637001c296a92$export$b4d5da5f34fb77ad = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("source")(props)([]);
};
var $7e9637001c296a92$export$63ff6ad969e501f9 = /* #__PURE__ */ $7e9637001c296a92$export$b4d5da5f34fb77ad([]);
var $7e9637001c296a92$export$afc1bfabebaf28a2 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("span");
var $7e9637001c296a92$export$e78712c0da02b27f = /* #__PURE__ */ $7e9637001c296a92$export$afc1bfabebaf28a2([]);
var $7e9637001c296a92$export$59ae2c325a998f89 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("strong");
var $7e9637001c296a92$export$5b8a4b09ec0e9d3d = /* #__PURE__ */ $7e9637001c296a92$export$59ae2c325a998f89([]);
var $7e9637001c296a92$export$1d567c320f4763bc = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("style");
var $7e9637001c296a92$export$c7c1969d2f77035a = /* #__PURE__ */ $7e9637001c296a92$export$1d567c320f4763bc([]);
var $7e9637001c296a92$export$f93b5905241a7cca = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("sub");
var $7e9637001c296a92$export$53f202276e71b729 = /* #__PURE__ */ $7e9637001c296a92$export$f93b5905241a7cca([]);
var $7e9637001c296a92$export$9a2dbef7a17e2e58 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("summary");
var $7e9637001c296a92$export$43870e7484b30e9b = /* #__PURE__ */ $7e9637001c296a92$export$9a2dbef7a17e2e58([]);
var $7e9637001c296a92$export$abe1cd54efe9b9cd = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("sup");
var $7e9637001c296a92$export$37c42177a281241f = /* #__PURE__ */ $7e9637001c296a92$export$abe1cd54efe9b9cd([]);
var $7e9637001c296a92$export$9852986a3ec5f6a0 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("table");
var $7e9637001c296a92$export$acb98eed4b312a6f = /* #__PURE__ */ $7e9637001c296a92$export$9852986a3ec5f6a0([]);
var $7e9637001c296a92$export$7cdd536eaa8f163c = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("tbody");
var $7e9637001c296a92$export$d42611f94eedae0c = /* #__PURE__ */ $7e9637001c296a92$export$7cdd536eaa8f163c([]);
var $7e9637001c296a92$export$2beef8af2014e5c6 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("td");
var $7e9637001c296a92$export$37e945cf8445363a = /* #__PURE__ */ $7e9637001c296a92$export$2beef8af2014e5c6([]);
var $7e9637001c296a92$export$a3574df893ffa88d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("textarea");
var $7e9637001c296a92$export$2cffb7f8107df36d = /* #__PURE__ */ $7e9637001c296a92$export$a3574df893ffa88d([]);
var $7e9637001c296a92$export$9396b2f97a03ad14 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("tfoot");
var $7e9637001c296a92$export$9c54b3d8bf18b975 = /* #__PURE__ */ $7e9637001c296a92$export$9396b2f97a03ad14([]);
var $7e9637001c296a92$export$d657bc098992a431 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("th");
var $7e9637001c296a92$export$9fe0934bf37101f9 = /* #__PURE__ */ $7e9637001c296a92$export$d657bc098992a431([]);
var $7e9637001c296a92$export$e3f32a5920890b82 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("thead");
var $7e9637001c296a92$export$30acb79f31ecdd33 = /* #__PURE__ */ $7e9637001c296a92$export$e3f32a5920890b82([]);
var $7e9637001c296a92$export$2da9be4cfdb689b1 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("time");
var $7e9637001c296a92$export$54f51cf77c595cf0 = /* #__PURE__ */ $7e9637001c296a92$export$2da9be4cfdb689b1([]);
var $7e9637001c296a92$export$fb184b623420d9be = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("title");
var $7e9637001c296a92$export$254c92738969d8e5 = /* #__PURE__ */ $7e9637001c296a92$export$fb184b623420d9be([]);
var $7e9637001c296a92$export$72451b88a72ad9c2 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("tr");
var $7e9637001c296a92$export$e31f07a47c038498 = /* #__PURE__ */ $7e9637001c296a92$export$72451b88a72ad9c2([]);
var $7e9637001c296a92$export$6b2a7d5132615086 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("track")(props)([]);
};
var $7e9637001c296a92$export$bf9e3dca0cb5d03 = /* #__PURE__ */ $7e9637001c296a92$export$6b2a7d5132615086([]);
var $7e9637001c296a92$export$3b14a55fb2447963 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("u");
var $7e9637001c296a92$export$43a78f8ea64a5c3b = /* #__PURE__ */ $7e9637001c296a92$export$3b14a55fb2447963([]);
var $7e9637001c296a92$export$b5023c870cb34848 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("ul");
var $7e9637001c296a92$export$cc03685c1f5dc816 = /* #__PURE__ */ $7e9637001c296a92$export$b5023c870cb34848([]);
var $7e9637001c296a92$export$4732baac96d948aa = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("var");
var $7e9637001c296a92$export$627e1cd3dcd072da = /* #__PURE__ */ $7e9637001c296a92$export$4732baac96d948aa([]);
var $7e9637001c296a92$export$5f8d3589eb8441ca = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("video");
var $7e9637001c296a92$export$5330372916498f8b = /* #__PURE__ */ $7e9637001c296a92$export$5f8d3589eb8441ca([]);
var $7e9637001c296a92$export$ee8f8f9447a35bdc = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("wbr")(props)([]);
};
var $7e9637001c296a92$export$d30148b530e518be = /* #__PURE__ */ $7e9637001c296a92$export$ee8f8f9447a35bdc([]);
var $7e9637001c296a92$export$82334bbdfcebb57 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("meter");
var $7e9637001c296a92$export$518dbfa7659ccd0b = /* #__PURE__ */ $7e9637001c296a92$export$82334bbdfcebb57([]);
var $7e9637001c296a92$export$6990040ee07315 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("meta")(props)([]);
};
var $7e9637001c296a92$export$b787d2b95ad9eefe = /* #__PURE__ */ $7e9637001c296a92$export$6990040ee07315([]);
var $7e9637001c296a92$export$f68e44d881264486 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("menuitem")(props)([]);
};
var $7e9637001c296a92$export$9105d27728c23c50 = /* #__PURE__ */ $7e9637001c296a92$export$f68e44d881264486([]);
var $7e9637001c296a92$export$b1e5508a851be14d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("menu");
var $7e9637001c296a92$export$1c27e9391c52a0d7 = /* #__PURE__ */ $7e9637001c296a92$export$b1e5508a851be14d([]);
var $7e9637001c296a92$export$bf7f2fce5c1cf636 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("mark");
var $7e9637001c296a92$export$5b0e175cf21adb47 = /* #__PURE__ */ $7e9637001c296a92$export$bf7f2fce5c1cf636([]);
var $7e9637001c296a92$export$871de8747c9eaa88 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("map");
var $7e9637001c296a92$export$d7064337325b229f = /* #__PURE__ */ $7e9637001c296a92$export$871de8747c9eaa88([]);
var $7e9637001c296a92$export$f22da7240b7add18 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("main");
var $7e9637001c296a92$export$7cfb21b3977b154e = /* #__PURE__ */ $7e9637001c296a92$export$f22da7240b7add18([]);
var $7e9637001c296a92$export$9c30223ca0a664fb = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("link")(props)([]);
};
var $7e9637001c296a92$export$4f7bdcc9fc33a897 = /* #__PURE__ */ $7e9637001c296a92$export$9c30223ca0a664fb([]);
var $7e9637001c296a92$export$19caeaf7d9d84644 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("li");
var $7e9637001c296a92$export$819c065a8270721a = /* #__PURE__ */ $7e9637001c296a92$export$19caeaf7d9d84644([]);
var $7e9637001c296a92$export$9a9b59e08de24cef = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("legend");
var $7e9637001c296a92$export$77ffa03f8a30d30a = /* #__PURE__ */ $7e9637001c296a92$export$9a9b59e08de24cef([]);
var $7e9637001c296a92$export$1237798dc640739a = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("label");
var $7e9637001c296a92$export$38f4254fbc84320a = /* #__PURE__ */ $7e9637001c296a92$export$1237798dc640739a([]);
var $7e9637001c296a92$export$30652f55920950b8 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("keygen")(props)([]);
};
var $7e9637001c296a92$export$7d67efcd3320f49a = /* #__PURE__ */ $7e9637001c296a92$export$30652f55920950b8([]);
var $7e9637001c296a92$export$1ed45b69d23c052b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("kbd");
var $7e9637001c296a92$export$16b80b5734c48573 = /* #__PURE__ */ $7e9637001c296a92$export$1ed45b69d23c052b([]);
var $7e9637001c296a92$export$7d260a2a5f8bc19e = $ac8b3532514ac019$export$401372c57776dc;
var $7e9637001c296a92$export$27a48efc044c200a = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("ins");
var $7e9637001c296a92$export$8f03f5b7511beb02 = /* #__PURE__ */ $7e9637001c296a92$export$27a48efc044c200a([]);
var $7e9637001c296a92$export$b7e3ae3d7c15e42e = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("input")(props)([]);
};
var $7e9637001c296a92$export$d7d8a2510d035c73 = /* #__PURE__ */ $7e9637001c296a92$export$b7e3ae3d7c15e42e([]);
var $7e9637001c296a92$export$463b44d9bf3628be = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("img")(props)([]);
};
var $7e9637001c296a92$export$5a7f7f9a77a43420 = /* #__PURE__ */ $7e9637001c296a92$export$463b44d9bf3628be([]);
var $7e9637001c296a92$export$8cde213409fd6377 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("iframe");
var $7e9637001c296a92$export$fa1b0292c71de5dc = /* #__PURE__ */ $7e9637001c296a92$export$8cde213409fd6377([]);
var $7e9637001c296a92$export$23f2a1d2818174ef = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("i");
var $7e9637001c296a92$export$79afb768e9a0500 = /* #__PURE__ */ $7e9637001c296a92$export$23f2a1d2818174ef([]);
var $7e9637001c296a92$export$c0bb0b647f701bb5 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("html");
var $7e9637001c296a92$export$c1ebcbeb4e507a75 = /* #__PURE__ */ $7e9637001c296a92$export$c0bb0b647f701bb5([]);
var $7e9637001c296a92$export$b4adb3f464574dcf = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("hr")(props)([]);
};
var $7e9637001c296a92$export$7d21a5454f81eb3d = /* #__PURE__ */ $7e9637001c296a92$export$b4adb3f464574dcf([]);
var $7e9637001c296a92$export$38e42c68cf43b5d4 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("header");
var $7e9637001c296a92$export$1a3a3678a2cafb1c = /* #__PURE__ */ $7e9637001c296a92$export$38e42c68cf43b5d4([]);
var $7e9637001c296a92$export$5fd5031fecdacec3 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("head");
var $7e9637001c296a92$export$1d23b5ad7b242f43 = /* #__PURE__ */ $7e9637001c296a92$export$5fd5031fecdacec3([]);
var $7e9637001c296a92$export$c9ccd321d64f47e3 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h6");
var $7e9637001c296a92$export$47eaba2e67928dcc = /* #__PURE__ */ $7e9637001c296a92$export$c9ccd321d64f47e3([]);
var $7e9637001c296a92$export$f44841a11990acb2 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h5");
var $7e9637001c296a92$export$181a2386bbb3d3f3 = /* #__PURE__ */ $7e9637001c296a92$export$f44841a11990acb2([]);
var $7e9637001c296a92$export$51a85cc1b68f452c = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h4");
var $7e9637001c296a92$export$f9a110730a38820a = /* #__PURE__ */ $7e9637001c296a92$export$51a85cc1b68f452c([]);
var $7e9637001c296a92$export$7edd4a21fac8ce55 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h3");
var $7e9637001c296a92$export$2ca4b4ad910a1231 = /* #__PURE__ */ $7e9637001c296a92$export$7edd4a21fac8ce55([]);
var $7e9637001c296a92$export$a943aa9a0fca3f0b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h2");
var $7e9637001c296a92$export$1b9b631f8eb73296 = /* #__PURE__ */ $7e9637001c296a92$export$a943aa9a0fca3f0b([]);
var $7e9637001c296a92$export$448e4850cad7c7b0 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("h1");
var $7e9637001c296a92$export$78e024695ac0e4c4 = /* #__PURE__ */ $7e9637001c296a92$export$448e4850cad7c7b0([]);
var $7e9637001c296a92$export$6210fa4921d2a466 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("form");
var $7e9637001c296a92$export$d77c4383739061f6 = /* #__PURE__ */ $7e9637001c296a92$export$6210fa4921d2a466([]);
var $7e9637001c296a92$export$adb608be33961c98 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("footer");
var $7e9637001c296a92$export$da75f9f717b66f0e = /* #__PURE__ */ $7e9637001c296a92$export$adb608be33961c98([]);
var $7e9637001c296a92$export$991dc94f816a1d48 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("figure");
var $7e9637001c296a92$export$b1e62b6f82bf8f10 = /* #__PURE__ */ $7e9637001c296a92$export$991dc94f816a1d48([]);
var $7e9637001c296a92$export$b75acb72a9c69c26 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("figcaption");
var $7e9637001c296a92$export$96d52687e11dc6d1 = /* #__PURE__ */ $7e9637001c296a92$export$b75acb72a9c69c26([]);
var $7e9637001c296a92$export$a38812d1aa1302d9 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("fieldset");
var $7e9637001c296a92$export$3e486131360a1dba = /* #__PURE__ */ $7e9637001c296a92$export$a38812d1aa1302d9([]);
var $7e9637001c296a92$export$2be46bb7e96db87f = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("embed")(props)([]);
};
var $7e9637001c296a92$export$4ee8e86e67d2cdf2 = /* #__PURE__ */ $7e9637001c296a92$export$2be46bb7e96db87f([]);
var $7e9637001c296a92$export$c63c6f932822f543 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("em");
var $7e9637001c296a92$export$88260de3da5dad06 = /* #__PURE__ */ $7e9637001c296a92$export$c63c6f932822f543([]);
var $7e9637001c296a92$export$9198f9466fc833e = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("dt");
var $7e9637001c296a92$export$4af69eaa76260b65 = /* #__PURE__ */ $7e9637001c296a92$export$9198f9466fc833e([]);
var $7e9637001c296a92$export$53d26b7a9a23d594 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("dl");
var $7e9637001c296a92$export$b318aecb52843077 = /* #__PURE__ */ $7e9637001c296a92$export$53d26b7a9a23d594([]);
var $7e9637001c296a92$export$159d9494db57879b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("div");
var $7e9637001c296a92$export$889437a23e4d1fea = /* #__PURE__ */ $7e9637001c296a92$export$159d9494db57879b([]);
var $7e9637001c296a92$export$518824cf31321346 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("dialog");
var $7e9637001c296a92$export$2899670e22fe0814 = /* #__PURE__ */ $7e9637001c296a92$export$518824cf31321346([]);
var $7e9637001c296a92$export$771f54d1a902afc9 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("dfn");
var $7e9637001c296a92$export$804d31bce094f7c2 = /* #__PURE__ */ $7e9637001c296a92$export$771f54d1a902afc9([]);
var $7e9637001c296a92$export$41ee12f6f6f05843 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("details");
var $7e9637001c296a92$export$2cd040ec0beeec1d = /* #__PURE__ */ $7e9637001c296a92$export$41ee12f6f6f05843([]);
var $7e9637001c296a92$export$1d2f21e549771e67 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("del");
var $7e9637001c296a92$export$fdb761dca92c24c5 = /* #__PURE__ */ $7e9637001c296a92$export$1d2f21e549771e67([]);
var $7e9637001c296a92$export$eaaeafa904fe3ddf = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("dd");
var $7e9637001c296a92$export$1ea934364ea74d78 = /* #__PURE__ */ $7e9637001c296a92$export$eaaeafa904fe3ddf([]);
var $7e9637001c296a92$export$d6956b5f6d5ee87d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("datalist");
var $7e9637001c296a92$export$ef8df43f6b17d0b2 = /* #__PURE__ */ $7e9637001c296a92$export$d6956b5f6d5ee87d([]);
var $7e9637001c296a92$export$3db318dd257cd653 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("colgroup");
var $7e9637001c296a92$export$2cc02bdb25c6df6f = /* #__PURE__ */ $7e9637001c296a92$export$3db318dd257cd653([]);
var $7e9637001c296a92$export$aba86695643891f5 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("col")(props)([]);
};
var $7e9637001c296a92$export$178a6a24f22b1dba = /* #__PURE__ */ $7e9637001c296a92$export$aba86695643891f5([]);
var $7e9637001c296a92$export$6565f9f03506010b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("code");
var $7e9637001c296a92$export$e3f5343c56418723 = /* #__PURE__ */ $7e9637001c296a92$export$6565f9f03506010b([]);
var $7e9637001c296a92$export$3035df57df42c31a = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("cite");
var $7e9637001c296a92$export$68fa271d5335ec8f = /* #__PURE__ */ $7e9637001c296a92$export$3035df57df42c31a([]);
var $7e9637001c296a92$export$8e3c2dfdc4f0453d = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("caption");
var $7e9637001c296a92$export$58070f60c9492d78 = /* #__PURE__ */ $7e9637001c296a92$export$8e3c2dfdc4f0453d([]);
var $7e9637001c296a92$export$67ea982130081db = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("canvas");
var $7e9637001c296a92$export$730a63d73e5da9b9 = /* #__PURE__ */ $7e9637001c296a92$export$67ea982130081db([]);
var $7e9637001c296a92$export$2ba01fb71ed41cb6 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("button");
var $7e9637001c296a92$export$b9245ec3a8865533 = /* #__PURE__ */ $7e9637001c296a92$export$2ba01fb71ed41cb6([]);
var $7e9637001c296a92$export$479ac0420f53ed26 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("br")(props)([]);
};
var $7e9637001c296a92$export$e0b7aa9c55ad07d3 = /* #__PURE__ */ $7e9637001c296a92$export$479ac0420f53ed26([]);
var $7e9637001c296a92$export$32180ef41b15b513 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("body");
var $7e9637001c296a92$export$a54973e7c9151311 = /* #__PURE__ */ $7e9637001c296a92$export$32180ef41b15b513([]);
var $7e9637001c296a92$export$67dc04e652a298ca = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("blockquote");
var $7e9637001c296a92$export$d57fe00655b8aeb7 = /* #__PURE__ */ $7e9637001c296a92$export$67dc04e652a298ca([]);
var $7e9637001c296a92$export$cc81a5c85b55e12c = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("big");
var $7e9637001c296a92$export$b614a6a7f6d55127 = /* #__PURE__ */ $7e9637001c296a92$export$cc81a5c85b55e12c([]);
var $7e9637001c296a92$export$fae0db89ef70aab2 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("bdo");
var $7e9637001c296a92$export$daa3061f55e56671 = /* #__PURE__ */ $7e9637001c296a92$export$fae0db89ef70aab2([]);
var $7e9637001c296a92$export$2d20a4e9df674436 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("bdi");
var $7e9637001c296a92$export$a8e387da05a7363a = /* #__PURE__ */ $7e9637001c296a92$export$2d20a4e9df674436([]);
var $7e9637001c296a92$export$e2253033e6e1df16 = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("base")(props)([]);
};
var $7e9637001c296a92$export$1c32ff3b11cfdbdb = /* #__PURE__ */ $7e9637001c296a92$export$e2253033e6e1df16([]);
var $7e9637001c296a92$export$8b22cf2602fb60ce = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("b");
var $7e9637001c296a92$export$73045757eb41c970 = /* #__PURE__ */ $7e9637001c296a92$export$8b22cf2602fb60ce([]);
var $7e9637001c296a92$export$592b77e6034db746 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("audio");
var $7e9637001c296a92$export$9eb60425a95c1b7f = /* #__PURE__ */ $7e9637001c296a92$export$592b77e6034db746([]);
var $7e9637001c296a92$export$64a02cd6422b91be = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("aside");
var $7e9637001c296a92$export$b4c4a5b6a9c26006 = /* #__PURE__ */ $7e9637001c296a92$export$64a02cd6422b91be([]);
var $7e9637001c296a92$export$bba2aacf8566461b = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("article");
var $7e9637001c296a92$export$475f9766e255d102 = /* #__PURE__ */ $7e9637001c296a92$export$bba2aacf8566461b([]);
var $7e9637001c296a92$export$bb3edc44842b5f2e = function(props) {
    return $7e9637001c296a92$export$1ac1623f62b36acb(false)("area")(props)([]);
};
var $7e9637001c296a92$export$52de33da6b864ae3 = /* #__PURE__ */ $7e9637001c296a92$export$bb3edc44842b5f2e([]);
var $7e9637001c296a92$export$f7d3c097ceca6c15 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("address");
var $7e9637001c296a92$export$293fdf0d1153bc9d = /* #__PURE__ */ $7e9637001c296a92$export$f7d3c097ceca6c15([]);
var $7e9637001c296a92$export$2bcb785951133fe5 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("abbr");
var $7e9637001c296a92$export$9eeed0bcbb3f325 = /* #__PURE__ */ $7e9637001c296a92$export$2bcb785951133fe5([]);
var $7e9637001c296a92$export$407448d2b89b1813 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("a");
var $7e9637001c296a92$export$a8a690cfca4daa34 = /* #__PURE__ */ $7e9637001c296a92$export$407448d2b89b1813([]);
var $7e9637001c296a92$export$bd25e24024963319 = /* #__PURE__ */ $7e9637001c296a92$export$1ac1623f62b36acb(false)("data");
var $7e9637001c296a92$export$60f01d91f4c08119 = /* #__PURE__ */ $7e9637001c296a92$export$bd25e24024963319([]);


var $3eadc1b959dd1120$export$6f093cfa640b7166 = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(str) {
        return liftWidget($fe1781b0b9eaad64$export$79693fdaa4661ff2([
            $7e9637001c296a92$export$6f093cfa640b7166(str)
        ]));
    };
};
var $3eadc1b959dd1120$export$98e628dec113755e = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(x) {
        return liftWidget($fe1781b0b9eaad64$export$79693fdaa4661ff2([
            $7e9637001c296a92$export$98e628dec113755e(x)
        ]));
    };
};
var $3eadc1b959dd1120$export$7d260a2a5f8bc19e = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(x) {
        return liftWidget($fe1781b0b9eaad64$export$79693fdaa4661ff2([
            $7e9637001c296a92$export$7d260a2a5f8bc19e(x)
        ]));
    };
};
var $3eadc1b959dd1120$export$77b86f7f8703d1de = function(dictLiftWidget) {
    var liftWidget = $d4ad4a12c540b680$export$747a071fbf00b73f(dictLiftWidget);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(e) {
            return function(props) {
                return liftWidget($8cc8e71d6c274566$export$5941a660d81d0673(function(h) {
                    return [
                        e(map($fc1df90f0e252058$export$d80ecae684ef7a9(h))(props))
                    ];
                }));
            };
        };
    };
};
var $3eadc1b959dd1120$export$2be46bb7e96db87f = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2be46bb7e96db87f);
};
var $3eadc1b959dd1120$export$4ee8e86e67d2cdf2 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$2be46bb7e96db87f(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$b4adb3f464574dcf = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b4adb3f464574dcf);
};
var $3eadc1b959dd1120$export$7d21a5454f81eb3d = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$b4adb3f464574dcf(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$463b44d9bf3628be = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$463b44d9bf3628be);
};
var $3eadc1b959dd1120$export$5a7f7f9a77a43420 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$463b44d9bf3628be(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$b7e3ae3d7c15e42e = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b7e3ae3d7c15e42e);
};
var $3eadc1b959dd1120$export$d7d8a2510d035c73 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$b7e3ae3d7c15e42e(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$30652f55920950b8 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$30652f55920950b8);
};
var $3eadc1b959dd1120$export$7d67efcd3320f49a = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$30652f55920950b8(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$9c30223ca0a664fb = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9c30223ca0a664fb);
};
var $3eadc1b959dd1120$export$4f7bdcc9fc33a897 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$9c30223ca0a664fb(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$f68e44d881264486 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f68e44d881264486);
};
var $3eadc1b959dd1120$export$9105d27728c23c50 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$f68e44d881264486(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$6990040ee07315 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6990040ee07315);
};
var $3eadc1b959dd1120$export$b787d2b95ad9eefe = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$6990040ee07315(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$6f7d1d9d04558207 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6f7d1d9d04558207);
};
var $3eadc1b959dd1120$export$ae3ba61eedc635b7 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$6f7d1d9d04558207(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$b4d5da5f34fb77ad = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b4d5da5f34fb77ad);
};
var $3eadc1b959dd1120$export$63ff6ad969e501f9 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$b4d5da5f34fb77ad(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$6b2a7d5132615086 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6b2a7d5132615086);
};
var $3eadc1b959dd1120$export$bf9e3dca0cb5d03 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$6b2a7d5132615086(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$ee8f8f9447a35bdc = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$ee8f8f9447a35bdc);
};
var $3eadc1b959dd1120$export$d30148b530e518be = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$ee8f8f9447a35bdc(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$c3da0dad1b44eea9 = function(dictShiftMap) {
    var shiftMap = $c06eda136610a859$export$298cc4ef816733b(dictShiftMap);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(e) {
            return function(props) {
                return shiftMap(function(f) {
                    return function(w) {
                        return $8cc8e71d6c274566$export$4dce3967a90035b0(function(h) {
                            return function(v) {
                                return $65a231f2469e9513$export$719bfe54e9eb6d53(e)(map($fc1df90f0e252058$export$d80ecae684ef7a9(function($1253) {
                                    return h(f($1253));
                                }))(props))(v);
                            };
                        })(w);
                    };
                });
            };
        };
    };
};
var $3eadc1b959dd1120$export$ad9e3aaa79fdf6 = function(dictShiftMap) {
    var el1 = $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap);
    return function(dictMultiAlternative) {
        var orr = $45c91529080709fa$export$ab4aa096a1f048e7(dictMultiAlternative);
        return function(dictFunctor) {
            var el2 = el1(dictFunctor);
            return function(e) {
                return function(props) {
                    var $1254 = el2(e)(props);
                    return function($1255) {
                        return $1254(orr($1255));
                    };
                };
            };
        };
    };
};
var $3eadc1b959dd1120$export$c63c6f932822f543 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c63c6f932822f543);
    };
};
var $3eadc1b959dd1120$export$88260de3da5dad06 = function(dictMultiAlternative) {
    var em1 = $3eadc1b959dd1120$export$c63c6f932822f543(dictMultiAlternative);
    return function(dictShiftMap) {
        return em1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a38812d1aa1302d9 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a38812d1aa1302d9);
    };
};
var $3eadc1b959dd1120$export$3e486131360a1dba = function(dictMultiAlternative) {
    var fieldset1 = $3eadc1b959dd1120$export$a38812d1aa1302d9(dictMultiAlternative);
    return function(dictShiftMap) {
        return fieldset1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b75acb72a9c69c26 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b75acb72a9c69c26);
    };
};
var $3eadc1b959dd1120$export$96d52687e11dc6d1 = function(dictMultiAlternative) {
    var figcaption1 = $3eadc1b959dd1120$export$b75acb72a9c69c26(dictMultiAlternative);
    return function(dictShiftMap) {
        return figcaption1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$991dc94f816a1d48 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$991dc94f816a1d48);
    };
};
var $3eadc1b959dd1120$export$b1e62b6f82bf8f10 = function(dictMultiAlternative) {
    var figure1 = $3eadc1b959dd1120$export$991dc94f816a1d48(dictMultiAlternative);
    return function(dictShiftMap) {
        return figure1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$adb608be33961c98 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$adb608be33961c98);
    };
};
var $3eadc1b959dd1120$export$da75f9f717b66f0e = function(dictMultiAlternative) {
    var footer1 = $3eadc1b959dd1120$export$adb608be33961c98(dictMultiAlternative);
    return function(dictShiftMap) {
        return footer1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$6210fa4921d2a466 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6210fa4921d2a466);
    };
};
var $3eadc1b959dd1120$export$d77c4383739061f6 = function(dictMultiAlternative) {
    var form1 = $3eadc1b959dd1120$export$6210fa4921d2a466(dictMultiAlternative);
    return function(dictShiftMap) {
        return form1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$448e4850cad7c7b0 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$448e4850cad7c7b0);
    };
};
var $3eadc1b959dd1120$export$78e024695ac0e4c4 = function(dictMultiAlternative) {
    var h11 = $3eadc1b959dd1120$export$448e4850cad7c7b0(dictMultiAlternative);
    return function(dictShiftMap) {
        return h11(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a943aa9a0fca3f0b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a943aa9a0fca3f0b);
    };
};
var $3eadc1b959dd1120$export$1b9b631f8eb73296 = function(dictMultiAlternative) {
    var h21 = $3eadc1b959dd1120$export$a943aa9a0fca3f0b(dictMultiAlternative);
    return function(dictShiftMap) {
        return h21(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$7edd4a21fac8ce55 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$7edd4a21fac8ce55);
    };
};
var $3eadc1b959dd1120$export$2ca4b4ad910a1231 = function(dictMultiAlternative) {
    var h31 = $3eadc1b959dd1120$export$7edd4a21fac8ce55(dictMultiAlternative);
    return function(dictShiftMap) {
        return h31(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$51a85cc1b68f452c = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$51a85cc1b68f452c);
    };
};
var $3eadc1b959dd1120$export$f9a110730a38820a = function(dictMultiAlternative) {
    var h41 = $3eadc1b959dd1120$export$51a85cc1b68f452c(dictMultiAlternative);
    return function(dictShiftMap) {
        return h41(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f44841a11990acb2 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f44841a11990acb2);
    };
};
var $3eadc1b959dd1120$export$181a2386bbb3d3f3 = function(dictMultiAlternative) {
    var h51 = $3eadc1b959dd1120$export$f44841a11990acb2(dictMultiAlternative);
    return function(dictShiftMap) {
        return h51(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$c9ccd321d64f47e3 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c9ccd321d64f47e3);
    };
};
var $3eadc1b959dd1120$export$47eaba2e67928dcc = function(dictMultiAlternative) {
    var h61 = $3eadc1b959dd1120$export$c9ccd321d64f47e3(dictMultiAlternative);
    return function(dictShiftMap) {
        return h61(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$5fd5031fecdacec3 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$5fd5031fecdacec3);
    };
};
var $3eadc1b959dd1120$export$1d23b5ad7b242f43 = function(dictMultiAlternative) {
    var head1 = $3eadc1b959dd1120$export$5fd5031fecdacec3(dictMultiAlternative);
    return function(dictShiftMap) {
        return head1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$38e42c68cf43b5d4 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$38e42c68cf43b5d4);
    };
};
var $3eadc1b959dd1120$export$1a3a3678a2cafb1c = function(dictMultiAlternative) {
    var header1 = $3eadc1b959dd1120$export$38e42c68cf43b5d4(dictMultiAlternative);
    return function(dictShiftMap) {
        return header1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$c0bb0b647f701bb5 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c0bb0b647f701bb5);
    };
};
var $3eadc1b959dd1120$export$c1ebcbeb4e507a75 = function(dictMultiAlternative) {
    var html1 = $3eadc1b959dd1120$export$c0bb0b647f701bb5(dictMultiAlternative);
    return function(dictShiftMap) {
        return html1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$23f2a1d2818174ef = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$23f2a1d2818174ef);
    };
};
var $3eadc1b959dd1120$export$79afb768e9a0500 = function(dictMultiAlternative) {
    var i1 = $3eadc1b959dd1120$export$23f2a1d2818174ef(dictMultiAlternative);
    return function(dictShiftMap) {
        return i1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$8cde213409fd6377 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8cde213409fd6377);
    };
};
var $3eadc1b959dd1120$export$fa1b0292c71de5dc = function(dictMultiAlternative) {
    var iframe1 = $3eadc1b959dd1120$export$8cde213409fd6377(dictMultiAlternative);
    return function(dictShiftMap) {
        return iframe1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$27a48efc044c200a = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$27a48efc044c200a);
    };
};
var $3eadc1b959dd1120$export$8f03f5b7511beb02 = function(dictMultiAlternative) {
    var ins1 = $3eadc1b959dd1120$export$27a48efc044c200a(dictMultiAlternative);
    return function(dictShiftMap) {
        return ins1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$1ed45b69d23c052b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1ed45b69d23c052b);
    };
};
var $3eadc1b959dd1120$export$16b80b5734c48573 = function(dictMultiAlternative) {
    var kbd1 = $3eadc1b959dd1120$export$1ed45b69d23c052b(dictMultiAlternative);
    return function(dictShiftMap) {
        return kbd1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$1237798dc640739a = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1237798dc640739a);
    };
};
var $3eadc1b959dd1120$export$38f4254fbc84320a = function(dictMultiAlternative) {
    var label1 = $3eadc1b959dd1120$export$1237798dc640739a(dictMultiAlternative);
    return function(dictShiftMap) {
        return label1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9a9b59e08de24cef = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9a9b59e08de24cef);
    };
};
var $3eadc1b959dd1120$export$77ffa03f8a30d30a = function(dictMultiAlternative) {
    var legend1 = $3eadc1b959dd1120$export$9a9b59e08de24cef(dictMultiAlternative);
    return function(dictShiftMap) {
        return legend1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$19caeaf7d9d84644 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$19caeaf7d9d84644);
    };
};
var $3eadc1b959dd1120$export$819c065a8270721a = function(dictMultiAlternative) {
    var li1 = $3eadc1b959dd1120$export$19caeaf7d9d84644(dictMultiAlternative);
    return function(dictShiftMap) {
        return li1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f22da7240b7add18 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f22da7240b7add18);
    };
};
var $3eadc1b959dd1120$export$7cfb21b3977b154e = function(dictMultiAlternative) {
    var main1 = $3eadc1b959dd1120$export$f22da7240b7add18(dictMultiAlternative);
    return function(dictShiftMap) {
        return main1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$bf7f2fce5c1cf636 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bf7f2fce5c1cf636);
    };
};
var $3eadc1b959dd1120$export$5b0e175cf21adb47 = function(dictMultiAlternative) {
    var mark1 = $3eadc1b959dd1120$export$bf7f2fce5c1cf636(dictMultiAlternative);
    return function(dictShiftMap) {
        return mark1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b1e5508a851be14d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b1e5508a851be14d);
    };
};
var $3eadc1b959dd1120$export$1c27e9391c52a0d7 = function(dictMultiAlternative) {
    var menu1 = $3eadc1b959dd1120$export$b1e5508a851be14d(dictMultiAlternative);
    return function(dictShiftMap) {
        return menu1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$82334bbdfcebb57 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$82334bbdfcebb57);
    };
};
var $3eadc1b959dd1120$export$518dbfa7659ccd0b = function(dictMultiAlternative) {
    var meter1 = $3eadc1b959dd1120$export$82334bbdfcebb57(dictMultiAlternative);
    return function(dictShiftMap) {
        return meter1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$80e4b313e5e6b30d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$80e4b313e5e6b30d);
    };
};
var $3eadc1b959dd1120$export$a9cd8dd9221a5e05 = function(dictMultiAlternative) {
    var nav1 = $3eadc1b959dd1120$export$80e4b313e5e6b30d(dictMultiAlternative);
    return function(dictShiftMap) {
        return nav1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$528ba0e6da49e146 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$528ba0e6da49e146);
    };
};
var $3eadc1b959dd1120$export$a55b6dc9290354ad = function(dictMultiAlternative) {
    var noscript1 = $3eadc1b959dd1120$export$528ba0e6da49e146(dictMultiAlternative);
    return function(dictShiftMap) {
        return noscript1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$be5493f9613cbbe = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$be5493f9613cbbe);
    };
};
var $3eadc1b959dd1120$export$2372fa35676c79a9 = function(dictMultiAlternative) {
    var object1 = $3eadc1b959dd1120$export$be5493f9613cbbe(dictMultiAlternative);
    return function(dictShiftMap) {
        return object1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b2235297ee22a6fe = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b2235297ee22a6fe);
    };
};
var $3eadc1b959dd1120$export$9b5c0739560cca0a = function(dictMultiAlternative) {
    var ol1 = $3eadc1b959dd1120$export$b2235297ee22a6fe(dictMultiAlternative);
    return function(dictShiftMap) {
        return ol1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b9d336f245a516e8 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b9d336f245a516e8);
    };
};
var $3eadc1b959dd1120$export$ab0c0fbf80e41eeb = function(dictMultiAlternative) {
    var optgroup1 = $3eadc1b959dd1120$export$b9d336f245a516e8(dictMultiAlternative);
    return function(dictShiftMap) {
        return optgroup1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a75d1723e6bda2ec = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a75d1723e6bda2ec);
    };
};
var $3eadc1b959dd1120$export$801594ff2d678603 = function(dictMultiAlternative) {
    var option1 = $3eadc1b959dd1120$export$a75d1723e6bda2ec(dictMultiAlternative);
    return function(dictShiftMap) {
        return option1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$c789db2c85949867 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c789db2c85949867);
    };
};
var $3eadc1b959dd1120$export$e4c5b5b8ca5f5a8f = function(dictMultiAlternative) {
    var output1 = $3eadc1b959dd1120$export$c789db2c85949867(dictMultiAlternative);
    return function(dictShiftMap) {
        return output1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$ffb5f4729a158638 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$ffb5f4729a158638);
    };
};
var $3eadc1b959dd1120$export$3cf7d23e34405d00 = function(dictMultiAlternative) {
    var p1 = $3eadc1b959dd1120$export$ffb5f4729a158638(dictMultiAlternative);
    return function(dictShiftMap) {
        return p1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$1188214e9d38144e = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1188214e9d38144e);
    };
};
var $3eadc1b959dd1120$export$accd57f3700f6211 = function(dictMultiAlternative) {
    var picture1 = $3eadc1b959dd1120$export$1188214e9d38144e(dictMultiAlternative);
    return function(dictShiftMap) {
        return picture1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$2af2ac64526e2aa9 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2af2ac64526e2aa9);
    };
};
var $3eadc1b959dd1120$export$31f7d7ffe82c4c23 = function(dictMultiAlternative) {
    var pre1 = $3eadc1b959dd1120$export$2af2ac64526e2aa9(dictMultiAlternative);
    return function(dictShiftMap) {
        return pre1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$504d7abb21fa8c9 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$504d7abb21fa8c9);
    };
};
var $3eadc1b959dd1120$export$6fd22782efc8fe1f = function(dictMultiAlternative) {
    var progress1 = $3eadc1b959dd1120$export$504d7abb21fa8c9(dictMultiAlternative);
    return function(dictShiftMap) {
        return progress1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9e5f44173e64f162 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9e5f44173e64f162);
    };
};
var $3eadc1b959dd1120$export$b222a598fa42b197 = function(dictMultiAlternative) {
    var q1 = $3eadc1b959dd1120$export$9e5f44173e64f162(dictMultiAlternative);
    return function(dictShiftMap) {
        return q1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$6d4c73e3ddf8818b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6d4c73e3ddf8818b);
    };
};
var $3eadc1b959dd1120$export$2f605997cc5faf5f = function(dictMultiAlternative) {
    var rp1 = $3eadc1b959dd1120$export$6d4c73e3ddf8818b(dictMultiAlternative);
    return function(dictShiftMap) {
        return rp1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f08282231bb71285 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f08282231bb71285);
    };
};
var $3eadc1b959dd1120$export$d6164f6a3f663bf = function(dictMultiAlternative) {
    var rt1 = $3eadc1b959dd1120$export$f08282231bb71285(dictMultiAlternative);
    return function(dictShiftMap) {
        return rt1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f2b283820b448b35 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f2b283820b448b35);
    };
};
var $3eadc1b959dd1120$export$34faf91949064752 = function(dictMultiAlternative) {
    var ruby1 = $3eadc1b959dd1120$export$f2b283820b448b35(dictMultiAlternative);
    return function(dictShiftMap) {
        return ruby1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$2408f22a0fab9ae5 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2408f22a0fab9ae5);
    };
};
var $3eadc1b959dd1120$export$2d18448ab5df9ebd = function(dictMultiAlternative) {
    var s1 = $3eadc1b959dd1120$export$2408f22a0fab9ae5(dictMultiAlternative);
    return function(dictShiftMap) {
        return s1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$8c1cb8fb6818c292 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8c1cb8fb6818c292);
    };
};
var $3eadc1b959dd1120$export$a2d43502358a9716 = function(dictMultiAlternative) {
    var samp1 = $3eadc1b959dd1120$export$8c1cb8fb6818c292(dictMultiAlternative);
    return function(dictShiftMap) {
        return samp1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$bc237d627614fc48 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bc237d627614fc48);
    };
};
var $3eadc1b959dd1120$export$5c866d2f7e90e8f2 = function(dictMultiAlternative) {
    var script1 = $3eadc1b959dd1120$export$bc237d627614fc48(dictMultiAlternative);
    return function(dictShiftMap) {
        return script1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$fe2e36411d703b3d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fe2e36411d703b3d);
    };
};
var $3eadc1b959dd1120$export$438606398c5544c0 = function(dictMultiAlternative) {
    var section1 = $3eadc1b959dd1120$export$fe2e36411d703b3d(dictMultiAlternative);
    return function(dictShiftMap) {
        return section1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$2e6c959c16ff56b8 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2e6c959c16ff56b8);
    };
};
var $3eadc1b959dd1120$export$8b371b7a43624610 = function(dictMultiAlternative) {
    var select1 = $3eadc1b959dd1120$export$2e6c959c16ff56b8(dictMultiAlternative);
    return function(dictShiftMap) {
        return select1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$3c17b0e969a90510 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3c17b0e969a90510);
    };
};
var $3eadc1b959dd1120$export$7f4b82997bee17e7 = function(dictMultiAlternative) {
    var small1 = $3eadc1b959dd1120$export$3c17b0e969a90510(dictMultiAlternative);
    return function(dictShiftMap) {
        return small1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$afc1bfabebaf28a2 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$afc1bfabebaf28a2);
    };
};
var $3eadc1b959dd1120$export$e78712c0da02b27f = function(dictMultiAlternative) {
    var span1 = $3eadc1b959dd1120$export$afc1bfabebaf28a2(dictMultiAlternative);
    return function(dictShiftMap) {
        return span1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$59ae2c325a998f89 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$59ae2c325a998f89);
    };
};
var $3eadc1b959dd1120$export$5b8a4b09ec0e9d3d = function(dictMultiAlternative) {
    var strong1 = $3eadc1b959dd1120$export$59ae2c325a998f89(dictMultiAlternative);
    return function(dictShiftMap) {
        return strong1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$1d567c320f4763bc = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1d567c320f4763bc);
    };
};
var $3eadc1b959dd1120$export$c7c1969d2f77035a = function(dictMultiAlternative) {
    var style1 = $3eadc1b959dd1120$export$1d567c320f4763bc(dictMultiAlternative);
    return function(dictShiftMap) {
        return style1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f93b5905241a7cca = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f93b5905241a7cca);
    };
};
var $3eadc1b959dd1120$export$53f202276e71b729 = function(dictMultiAlternative) {
    var sub1 = $3eadc1b959dd1120$export$f93b5905241a7cca(dictMultiAlternative);
    return function(dictShiftMap) {
        return sub1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9a2dbef7a17e2e58 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9a2dbef7a17e2e58);
    };
};
var $3eadc1b959dd1120$export$43870e7484b30e9b = function(dictMultiAlternative) {
    var summary1 = $3eadc1b959dd1120$export$9a2dbef7a17e2e58(dictMultiAlternative);
    return function(dictShiftMap) {
        return summary1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$abe1cd54efe9b9cd = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$abe1cd54efe9b9cd);
    };
};
var $3eadc1b959dd1120$export$37c42177a281241f = function(dictMultiAlternative) {
    var sup1 = $3eadc1b959dd1120$export$abe1cd54efe9b9cd(dictMultiAlternative);
    return function(dictShiftMap) {
        return sup1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9852986a3ec5f6a0 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9852986a3ec5f6a0);
    };
};
var $3eadc1b959dd1120$export$acb98eed4b312a6f = function(dictMultiAlternative) {
    var table1 = $3eadc1b959dd1120$export$9852986a3ec5f6a0(dictMultiAlternative);
    return function(dictShiftMap) {
        return table1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$7cdd536eaa8f163c = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$7cdd536eaa8f163c);
    };
};
var $3eadc1b959dd1120$export$d42611f94eedae0c = function(dictMultiAlternative) {
    var tbody1 = $3eadc1b959dd1120$export$7cdd536eaa8f163c(dictMultiAlternative);
    return function(dictShiftMap) {
        return tbody1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$2beef8af2014e5c6 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2beef8af2014e5c6);
    };
};
var $3eadc1b959dd1120$export$37e945cf8445363a = function(dictMultiAlternative) {
    var td1 = $3eadc1b959dd1120$export$2beef8af2014e5c6(dictMultiAlternative);
    return function(dictShiftMap) {
        return td1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a3574df893ffa88d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a3574df893ffa88d);
    };
};
var $3eadc1b959dd1120$export$2cffb7f8107df36d = function(dictMultiAlternative) {
    var textarea1 = $3eadc1b959dd1120$export$a3574df893ffa88d(dictMultiAlternative);
    return function(dictShiftMap) {
        return textarea1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9396b2f97a03ad14 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9396b2f97a03ad14);
    };
};
var $3eadc1b959dd1120$export$9c54b3d8bf18b975 = function(dictMultiAlternative) {
    var tfoot1 = $3eadc1b959dd1120$export$9396b2f97a03ad14(dictMultiAlternative);
    return function(dictShiftMap) {
        return tfoot1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$d657bc098992a431 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$d657bc098992a431);
    };
};
var $3eadc1b959dd1120$export$9fe0934bf37101f9 = function(dictMultiAlternative) {
    var th1 = $3eadc1b959dd1120$export$d657bc098992a431(dictMultiAlternative);
    return function(dictShiftMap) {
        return th1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$e3f32a5920890b82 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$e3f32a5920890b82);
    };
};
var $3eadc1b959dd1120$export$30acb79f31ecdd33 = function(dictMultiAlternative) {
    var thead1 = $3eadc1b959dd1120$export$e3f32a5920890b82(dictMultiAlternative);
    return function(dictShiftMap) {
        return thead1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$2da9be4cfdb689b1 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2da9be4cfdb689b1);
    };
};
var $3eadc1b959dd1120$export$54f51cf77c595cf0 = function(dictMultiAlternative) {
    var time1 = $3eadc1b959dd1120$export$2da9be4cfdb689b1(dictMultiAlternative);
    return function(dictShiftMap) {
        return time1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$fb184b623420d9be = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fb184b623420d9be);
    };
};
var $3eadc1b959dd1120$export$254c92738969d8e5 = function(dictMultiAlternative) {
    var title1 = $3eadc1b959dd1120$export$fb184b623420d9be(dictMultiAlternative);
    return function(dictShiftMap) {
        return title1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$72451b88a72ad9c2 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$72451b88a72ad9c2);
    };
};
var $3eadc1b959dd1120$export$e31f07a47c038498 = function(dictMultiAlternative) {
    var tr1 = $3eadc1b959dd1120$export$72451b88a72ad9c2(dictMultiAlternative);
    return function(dictShiftMap) {
        return tr1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$3b14a55fb2447963 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3b14a55fb2447963);
    };
};
var $3eadc1b959dd1120$export$43a78f8ea64a5c3b = function(dictMultiAlternative) {
    var u1 = $3eadc1b959dd1120$export$3b14a55fb2447963(dictMultiAlternative);
    return function(dictShiftMap) {
        return u1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b5023c870cb34848 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b5023c870cb34848);
    };
};
var $3eadc1b959dd1120$export$cc03685c1f5dc816 = function(dictMultiAlternative) {
    var ul1 = $3eadc1b959dd1120$export$b5023c870cb34848(dictMultiAlternative);
    return function(dictShiftMap) {
        return ul1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$4732baac96d948aa = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$4732baac96d948aa);
    };
};
var $3eadc1b959dd1120$export$627e1cd3dcd072da = function(dictMultiAlternative) {
    var var1 = $3eadc1b959dd1120$export$4732baac96d948aa(dictMultiAlternative);
    return function(dictShiftMap) {
        return var1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$5f8d3589eb8441ca = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$5f8d3589eb8441ca);
    };
};
var $3eadc1b959dd1120$export$5330372916498f8b = function(dictMultiAlternative) {
    var video1 = $3eadc1b959dd1120$export$5f8d3589eb8441ca(dictMultiAlternative);
    return function(dictShiftMap) {
        return video1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a5c38c2752f1223a = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c63c6f932822f543);
};
var $3eadc1b959dd1120$export$2dc1b8d0924efe56 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a38812d1aa1302d9);
};
var $3eadc1b959dd1120$export$60dfbef68b872a19 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b75acb72a9c69c26);
};
var $3eadc1b959dd1120$export$e3500458218031e0 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$991dc94f816a1d48);
};
var $3eadc1b959dd1120$export$70a8ff4564bfd029 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$adb608be33961c98);
};
var $3eadc1b959dd1120$export$1df82cba65ddbdc7 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6210fa4921d2a466);
};
var $3eadc1b959dd1120$export$762b01c17cd5ef84 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$448e4850cad7c7b0);
};
var $3eadc1b959dd1120$export$fb9cd428790d91ac = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a943aa9a0fca3f0b);
};
var $3eadc1b959dd1120$export$d3f2bf86163ce5b1 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$7edd4a21fac8ce55);
};
var $3eadc1b959dd1120$export$44266b9d6c80e925 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$51a85cc1b68f452c);
};
var $3eadc1b959dd1120$export$29e7034271223ef2 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f44841a11990acb2);
};
var $3eadc1b959dd1120$export$454ef0c5c33a2870 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c9ccd321d64f47e3);
};
var $3eadc1b959dd1120$export$1139b773e3687c26 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$5fd5031fecdacec3);
};
var $3eadc1b959dd1120$export$8bf7349458487350 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$38e42c68cf43b5d4);
};
var $3eadc1b959dd1120$export$435678c2016b20e2 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c0bb0b647f701bb5);
};
var $3eadc1b959dd1120$export$3d4cba5f342e903e = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$23f2a1d2818174ef);
};
var $3eadc1b959dd1120$export$8b9be4fb5f79452c = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8cde213409fd6377);
};
var $3eadc1b959dd1120$export$be13014404ffcf2b = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$27a48efc044c200a);
};
var $3eadc1b959dd1120$export$4a6534c938817498 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1ed45b69d23c052b);
};
var $3eadc1b959dd1120$export$71f1ceb3290c95d7 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1237798dc640739a);
};
var $3eadc1b959dd1120$export$d57b7c1bdf9a3bfc = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9a9b59e08de24cef);
};
var $3eadc1b959dd1120$export$867ad32b190d58af = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$19caeaf7d9d84644);
};
var $3eadc1b959dd1120$export$88d8d81b07aa78ac = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f22da7240b7add18);
};
var $3eadc1b959dd1120$export$8e88f701cd5c1522 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bf7f2fce5c1cf636);
};
var $3eadc1b959dd1120$export$d18229b57986002 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b1e5508a851be14d);
};
var $3eadc1b959dd1120$export$86fa78168c2ac21a = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$82334bbdfcebb57);
};
var $3eadc1b959dd1120$export$5c8b9c326353f574 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$80e4b313e5e6b30d);
};
var $3eadc1b959dd1120$export$6d2a3f75abf3cf2f = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$528ba0e6da49e146);
};
var $3eadc1b959dd1120$export$5486b676036981c0 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$be5493f9613cbbe);
};
var $3eadc1b959dd1120$export$ccd58f56d982d30 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b2235297ee22a6fe);
};
var $3eadc1b959dd1120$export$5e41220970d85779 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b9d336f245a516e8);
};
var $3eadc1b959dd1120$export$32e31af4e5fb3144 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a75d1723e6bda2ec);
};
var $3eadc1b959dd1120$export$8874a395de964196 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$c789db2c85949867);
};
var $3eadc1b959dd1120$export$3950a0ab4293f4c0 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$ffb5f4729a158638);
};
var $3eadc1b959dd1120$export$870055eefd17724e = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1188214e9d38144e);
};
var $3eadc1b959dd1120$export$40eb7481a9b1d565 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2af2ac64526e2aa9);
};
var $3eadc1b959dd1120$export$c56c869b2fd24a27 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$504d7abb21fa8c9);
};
var $3eadc1b959dd1120$export$cfeebac18d15c854 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9e5f44173e64f162);
};
var $3eadc1b959dd1120$export$16adec6ab929083f = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6d4c73e3ddf8818b);
};
var $3eadc1b959dd1120$export$512c1f41f1ce606b = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f08282231bb71285);
};
var $3eadc1b959dd1120$export$8e70c3d96e82daa8 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f2b283820b448b35);
};
var $3eadc1b959dd1120$export$85d0ba090670e1d7 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2408f22a0fab9ae5);
};
var $3eadc1b959dd1120$export$6d135438f4b2f058 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8c1cb8fb6818c292);
};
var $3eadc1b959dd1120$export$dc29c33250ef6a12 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bc237d627614fc48);
};
var $3eadc1b959dd1120$export$23973f3de41ad862 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fe2e36411d703b3d);
};
var $3eadc1b959dd1120$export$626530082bbb6846 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2e6c959c16ff56b8);
};
var $3eadc1b959dd1120$export$7c956911267b1bca = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3c17b0e969a90510);
};
var $3eadc1b959dd1120$export$727654ffe296bd78 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$afc1bfabebaf28a2);
};
var $3eadc1b959dd1120$export$e4a9f9f4befb34d3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$59ae2c325a998f89);
};
var $3eadc1b959dd1120$export$91f114121fd8ef96 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1d567c320f4763bc);
};
var $3eadc1b959dd1120$export$1b578d76e1a8b229 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f93b5905241a7cca);
};
var $3eadc1b959dd1120$export$2107ebccf1a0ff3d = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9a2dbef7a17e2e58);
};
var $3eadc1b959dd1120$export$2ed99a076908dcca = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$abe1cd54efe9b9cd);
};
var $3eadc1b959dd1120$export$67d0d859a50d84a3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9852986a3ec5f6a0);
};
var $3eadc1b959dd1120$export$a78509387f11524c = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$7cdd536eaa8f163c);
};
var $3eadc1b959dd1120$export$bf83c8517c04b4f6 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2beef8af2014e5c6);
};
var $3eadc1b959dd1120$export$c851f32bcd5e34e1 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$a3574df893ffa88d);
};
var $3eadc1b959dd1120$export$7f741d66040a80c8 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9396b2f97a03ad14);
};
var $3eadc1b959dd1120$export$5e18a33d145a9a4c = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$d657bc098992a431);
};
var $3eadc1b959dd1120$export$e607565248beba15 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$e3f32a5920890b82);
};
var $3eadc1b959dd1120$export$cf828072303f47a1 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2da9be4cfdb689b1);
};
var $3eadc1b959dd1120$export$913d7d8b8f172930 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fb184b623420d9be);
};
var $3eadc1b959dd1120$export$6645783692722b88 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$72451b88a72ad9c2);
};
var $3eadc1b959dd1120$export$cea9ae7324478a0a = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3b14a55fb2447963);
};
var $3eadc1b959dd1120$export$995bef5d59d32608 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$b5023c870cb34848);
};
var $3eadc1b959dd1120$export$f6567ad6eb928d58 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$4732baac96d948aa);
};
var $3eadc1b959dd1120$export$aeb4f4e4f36fb9d9 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$5f8d3589eb8441ca);
};
var $3eadc1b959dd1120$export$eaec8774df2ce75c = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9198f9466fc833e);
};
var $3eadc1b959dd1120$export$9198f9466fc833e = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$9198f9466fc833e);
    };
};
var $3eadc1b959dd1120$export$4af69eaa76260b65 = function(dictMultiAlternative) {
    var dt1 = $3eadc1b959dd1120$export$9198f9466fc833e(dictMultiAlternative);
    return function(dictShiftMap) {
        return dt1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$e8817a08353617fb = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$53d26b7a9a23d594);
};
var $3eadc1b959dd1120$export$53d26b7a9a23d594 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$53d26b7a9a23d594);
    };
};
var $3eadc1b959dd1120$export$b318aecb52843077 = function(dictMultiAlternative) {
    var dl1 = $3eadc1b959dd1120$export$53d26b7a9a23d594(dictMultiAlternative);
    return function(dictShiftMap) {
        return dl1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$3327f90baeaa2cb3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$159d9494db57879b);
};
var $3eadc1b959dd1120$export$159d9494db57879b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$159d9494db57879b);
    };
};
var $3eadc1b959dd1120$export$889437a23e4d1fea = function(dictMultiAlternative) {
    var div1 = $3eadc1b959dd1120$export$159d9494db57879b(dictMultiAlternative);
    return function(dictShiftMap) {
        return div1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$95cd7f04cb5b4aa5 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$518824cf31321346);
};
var $3eadc1b959dd1120$export$518824cf31321346 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$518824cf31321346);
    };
};
var $3eadc1b959dd1120$export$2899670e22fe0814 = function(dictMultiAlternative) {
    var dialog1 = $3eadc1b959dd1120$export$518824cf31321346(dictMultiAlternative);
    return function(dictShiftMap) {
        return dialog1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$afe13c5e7d9b4a7 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$771f54d1a902afc9);
};
var $3eadc1b959dd1120$export$771f54d1a902afc9 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$771f54d1a902afc9);
    };
};
var $3eadc1b959dd1120$export$804d31bce094f7c2 = function(dictMultiAlternative) {
    var dfn1 = $3eadc1b959dd1120$export$771f54d1a902afc9(dictMultiAlternative);
    return function(dictShiftMap) {
        return dfn1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a47bcbad56ffd401 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$41ee12f6f6f05843);
};
var $3eadc1b959dd1120$export$41ee12f6f6f05843 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$41ee12f6f6f05843);
    };
};
var $3eadc1b959dd1120$export$2cd040ec0beeec1d = function(dictMultiAlternative) {
    var details1 = $3eadc1b959dd1120$export$41ee12f6f6f05843(dictMultiAlternative);
    return function(dictShiftMap) {
        return details1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$965d9e1c56547986 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1d2f21e549771e67);
};
var $3eadc1b959dd1120$export$1d2f21e549771e67 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$1d2f21e549771e67);
    };
};
var $3eadc1b959dd1120$export$fdb761dca92c24c5 = function(dictMultiAlternative) {
    var del1 = $3eadc1b959dd1120$export$1d2f21e549771e67(dictMultiAlternative);
    return function(dictShiftMap) {
        return del1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$333318a39958213e = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$eaaeafa904fe3ddf);
};
var $3eadc1b959dd1120$export$eaaeafa904fe3ddf = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$eaaeafa904fe3ddf);
    };
};
var $3eadc1b959dd1120$export$1ea934364ea74d78 = function(dictMultiAlternative) {
    var dd1 = $3eadc1b959dd1120$export$eaaeafa904fe3ddf(dictMultiAlternative);
    return function(dictShiftMap) {
        return dd1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$4479caebc8699400 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$d6956b5f6d5ee87d);
};
var $3eadc1b959dd1120$export$d6956b5f6d5ee87d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$d6956b5f6d5ee87d);
    };
};
var $3eadc1b959dd1120$export$ef8df43f6b17d0b2 = function(dictMultiAlternative) {
    var datalist1 = $3eadc1b959dd1120$export$d6956b5f6d5ee87d(dictMultiAlternative);
    return function(dictShiftMap) {
        return datalist1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$4d89c25fc3dc3ce6 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3db318dd257cd653);
};
var $3eadc1b959dd1120$export$3db318dd257cd653 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3db318dd257cd653);
    };
};
var $3eadc1b959dd1120$export$2cc02bdb25c6df6f = function(dictMultiAlternative) {
    var colgroup1 = $3eadc1b959dd1120$export$3db318dd257cd653(dictMultiAlternative);
    return function(dictShiftMap) {
        return colgroup1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$aba86695643891f5 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$aba86695643891f5);
};
var $3eadc1b959dd1120$export$178a6a24f22b1dba = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$aba86695643891f5(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$a82e8ec18d45f1e3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6565f9f03506010b);
};
var $3eadc1b959dd1120$export$6565f9f03506010b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$6565f9f03506010b);
    };
};
var $3eadc1b959dd1120$export$e3f5343c56418723 = function(dictMultiAlternative) {
    var code1 = $3eadc1b959dd1120$export$6565f9f03506010b(dictMultiAlternative);
    return function(dictShiftMap) {
        return code1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$4371c8153c03edbd = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3035df57df42c31a);
};
var $3eadc1b959dd1120$export$3035df57df42c31a = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$3035df57df42c31a);
    };
};
var $3eadc1b959dd1120$export$68fa271d5335ec8f = function(dictMultiAlternative) {
    var cite1 = $3eadc1b959dd1120$export$3035df57df42c31a(dictMultiAlternative);
    return function(dictShiftMap) {
        return cite1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$63f9754c9b1fac36 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8e3c2dfdc4f0453d);
};
var $3eadc1b959dd1120$export$8e3c2dfdc4f0453d = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8e3c2dfdc4f0453d);
    };
};
var $3eadc1b959dd1120$export$58070f60c9492d78 = function(dictMultiAlternative) {
    var caption1 = $3eadc1b959dd1120$export$8e3c2dfdc4f0453d(dictMultiAlternative);
    return function(dictShiftMap) {
        return caption1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$ddec10cd7a6434d3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$67ea982130081db);
};
var $3eadc1b959dd1120$export$67ea982130081db = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$67ea982130081db);
    };
};
var $3eadc1b959dd1120$export$730a63d73e5da9b9 = function(dictMultiAlternative) {
    var canvas1 = $3eadc1b959dd1120$export$67ea982130081db(dictMultiAlternative);
    return function(dictShiftMap) {
        return canvas1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$ff362f92cc25e36a = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2ba01fb71ed41cb6);
};
var $3eadc1b959dd1120$export$2ba01fb71ed41cb6 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2ba01fb71ed41cb6);
    };
};
var $3eadc1b959dd1120$export$b9245ec3a8865533 = function(dictMultiAlternative) {
    var button1 = $3eadc1b959dd1120$export$2ba01fb71ed41cb6(dictMultiAlternative);
    return function(dictShiftMap) {
        return button1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$479ac0420f53ed26 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$479ac0420f53ed26);
};
var $3eadc1b959dd1120$export$e0b7aa9c55ad07d3 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$479ac0420f53ed26(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$72fbd758d159fe4b = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$32180ef41b15b513);
};
var $3eadc1b959dd1120$export$32180ef41b15b513 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$32180ef41b15b513);
    };
};
var $3eadc1b959dd1120$export$a54973e7c9151311 = function(dictMultiAlternative) {
    var body1 = $3eadc1b959dd1120$export$32180ef41b15b513(dictMultiAlternative);
    return function(dictShiftMap) {
        return body1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$3b176ffafe2ecb0b = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$67dc04e652a298ca);
};
var $3eadc1b959dd1120$export$67dc04e652a298ca = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$67dc04e652a298ca);
    };
};
var $3eadc1b959dd1120$export$d57fe00655b8aeb7 = function(dictMultiAlternative) {
    var blockquote1 = $3eadc1b959dd1120$export$67dc04e652a298ca(dictMultiAlternative);
    return function(dictShiftMap) {
        return blockquote1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$663c4cec7ba6e54a = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$cc81a5c85b55e12c);
};
var $3eadc1b959dd1120$export$cc81a5c85b55e12c = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$cc81a5c85b55e12c);
    };
};
var $3eadc1b959dd1120$export$b614a6a7f6d55127 = function(dictMultiAlternative) {
    var big1 = $3eadc1b959dd1120$export$cc81a5c85b55e12c(dictMultiAlternative);
    return function(dictShiftMap) {
        return big1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$e57ac2b1cb1a62e1 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fae0db89ef70aab2);
};
var $3eadc1b959dd1120$export$fae0db89ef70aab2 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$fae0db89ef70aab2);
    };
};
var $3eadc1b959dd1120$export$daa3061f55e56671 = function(dictMultiAlternative) {
    var bdo1 = $3eadc1b959dd1120$export$fae0db89ef70aab2(dictMultiAlternative);
    return function(dictShiftMap) {
        return bdo1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$f5459c7588d93378 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2d20a4e9df674436);
};
var $3eadc1b959dd1120$export$2d20a4e9df674436 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2d20a4e9df674436);
    };
};
var $3eadc1b959dd1120$export$a8e387da05a7363a = function(dictMultiAlternative) {
    var bdi1 = $3eadc1b959dd1120$export$2d20a4e9df674436(dictMultiAlternative);
    return function(dictShiftMap) {
        return bdi1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$e2253033e6e1df16 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$e2253033e6e1df16);
};
var $3eadc1b959dd1120$export$1c32ff3b11cfdbdb = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$e2253033e6e1df16(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$c69d65aa55814164 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8b22cf2602fb60ce);
};
var $3eadc1b959dd1120$export$8b22cf2602fb60ce = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$8b22cf2602fb60ce);
    };
};
var $3eadc1b959dd1120$export$73045757eb41c970 = function(dictMultiAlternative) {
    var b1 = $3eadc1b959dd1120$export$8b22cf2602fb60ce(dictMultiAlternative);
    return function(dictShiftMap) {
        return b1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$610b618347792e57 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$592b77e6034db746);
};
var $3eadc1b959dd1120$export$592b77e6034db746 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$592b77e6034db746);
    };
};
var $3eadc1b959dd1120$export$9eb60425a95c1b7f = function(dictMultiAlternative) {
    var audio1 = $3eadc1b959dd1120$export$592b77e6034db746(dictMultiAlternative);
    return function(dictShiftMap) {
        return audio1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a3ab01131aa7ecca = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$64a02cd6422b91be);
};
var $3eadc1b959dd1120$export$64a02cd6422b91be = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$64a02cd6422b91be);
    };
};
var $3eadc1b959dd1120$export$b4c4a5b6a9c26006 = function(dictMultiAlternative) {
    var aside1 = $3eadc1b959dd1120$export$64a02cd6422b91be(dictMultiAlternative);
    return function(dictShiftMap) {
        return aside1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$1cb8fa25968bee4e = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bba2aacf8566461b);
};
var $3eadc1b959dd1120$export$bba2aacf8566461b = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bba2aacf8566461b);
    };
};
var $3eadc1b959dd1120$export$475f9766e255d102 = function(dictMultiAlternative) {
    var article1 = $3eadc1b959dd1120$export$bba2aacf8566461b(dictMultiAlternative);
    return function(dictShiftMap) {
        return article1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$bb3edc44842b5f2e = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$77b86f7f8703d1de(dictLiftWidget)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bb3edc44842b5f2e);
};
var $3eadc1b959dd1120$export$52de33da6b864ae3 = function(dictLiftWidget) {
    return $3eadc1b959dd1120$export$bb3edc44842b5f2e(dictLiftWidget)([]);
};
var $3eadc1b959dd1120$export$acfbe12b190f4a67 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f7d3c097ceca6c15);
};
var $3eadc1b959dd1120$export$f7d3c097ceca6c15 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$f7d3c097ceca6c15);
    };
};
var $3eadc1b959dd1120$export$293fdf0d1153bc9d = function(dictMultiAlternative) {
    var address1 = $3eadc1b959dd1120$export$f7d3c097ceca6c15(dictMultiAlternative);
    return function(dictShiftMap) {
        return address1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$b4f279e367d2ba24 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2bcb785951133fe5);
};
var $3eadc1b959dd1120$export$2bcb785951133fe5 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$2bcb785951133fe5);
    };
};
var $3eadc1b959dd1120$export$9eeed0bcbb3f325 = function(dictMultiAlternative) {
    var abbr1 = $3eadc1b959dd1120$export$2bcb785951133fe5(dictMultiAlternative);
    return function(dictShiftMap) {
        return abbr1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$a17c37559e1db147 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$407448d2b89b1813);
};
var $3eadc1b959dd1120$export$407448d2b89b1813 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$407448d2b89b1813);
    };
};
var $3eadc1b959dd1120$export$a8a690cfca4daa34 = function(dictMultiAlternative) {
    var a1 = $3eadc1b959dd1120$export$407448d2b89b1813(dictMultiAlternative);
    return function(dictShiftMap) {
        return a1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$9419d020ea6df672 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$871de8747c9eaa88);
};
var $3eadc1b959dd1120$export$a0135aecf4a782ab = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$871de8747c9eaa88);
    };
};
var $3eadc1b959dd1120$export$d777f649c7e2a44a = function(dictMultiAlternative) {
    var _map1 = $3eadc1b959dd1120$export$a0135aecf4a782ab(dictMultiAlternative);
    return function(dictShiftMap) {
        return _map1(dictShiftMap)([]);
    };
};
var $3eadc1b959dd1120$export$d57010038a6c20f3 = function(dictShiftMap) {
    return $3eadc1b959dd1120$export$c3da0dad1b44eea9(dictShiftMap)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bd25e24024963319);
};
var $3eadc1b959dd1120$export$bd25e24024963319 = function(dictMultiAlternative) {
    return function(dictShiftMap) {
        return $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap)(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546)($7e9637001c296a92$export$bd25e24024963319);
    };
};
var $3eadc1b959dd1120$export$60f01d91f4c08119 = function(dictMultiAlternative) {
    var _data1 = $3eadc1b959dd1120$export$bd25e24024963319(dictMultiAlternative);
    return function(dictShiftMap) {
        return _data1(dictShiftMap)([]);
    };
};






var $fc8e139dfeeff88c$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $fc8e139dfeeff88c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $fc8e139dfeeff88c$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $fc8e139dfeeff88c$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $fc8e139dfeeff88c$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($fc8e139dfeeff88c$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $fc8e139dfeeff88c$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($fc8e139dfeeff88c$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $fc8e139dfeeff88c$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $fc8e139dfeeff88c$export$b07e517d22efa1ca = function(props) {
    return function(checked) {
        return $fc8e139dfeeff88c$var$input($fc8e139dfeeff88c$var$append([
            $fc1df90f0e252058$export$1741e49665a9c8e8("checkbox"),
            $fc1df90f0e252058$export$b96bb35bc88d6fa(checked),
            $fc8e139dfeeff88c$var$voidRight(!checked)($fc1df90f0e252058$export$bd913411069e59d3)
        ])(props));
    };
};
var $fc8e139dfeeff88c$export$fe5109b9fec6786a = function(cls) {
    return function(id) {
        return function(label1) {
            return function(checked) {
                return $fc8e139dfeeff88c$var$div([
                    $fc1df90f0e252058$export$df61b30b684217c0(id),
                    $fc1df90f0e252058$export$2913c0c0b5623090(cls)
                ])([
                    $fc8e139dfeeff88c$export$b07e517d22efa1ca([
                        $fc1df90f0e252058$export$9c7ae676ac45430a(id)
                    ])(checked),
                    $fc8e139dfeeff88c$var$label([
                        $fc1df90f0e252058$export$35d9e1c947946090(id),
                        $fc1df90f0e252058$export$2913c0c0b5623090("mx-3")
                    ])([
                        $fc8e139dfeeff88c$var$text(label1)
                    ])
                ]);
            };
        };
    };
};
var $fc8e139dfeeff88c$export$344f17102956e4bc = /* #__PURE__ */ $fc8e139dfeeff88c$export$fe5109b9fec6786a("");


var $f264ceec36a478ad$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $f264ceec36a478ad$export$90aca4adda6ff0f5 = function(dictOrd) {
    var union = $ea3eb84de0acf574$export$971dd5b0dfd021b6(dictOrd);
    var fromFoldable1 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072(dictOrd);
    var difference = $ea3eb84de0acf574$export$acaf96a27438246b(dictOrd);
    return function(dictFoldable) {
        var fromFoldable2 = fromFoldable1(dictFoldable);
        return function(v) {
            return function(v1) {
                return function(v2) {
                    if (v2) return {
                        sel: union(v1.sel)(fromFoldable2(v))
                    };
                    if (!v2) return {
                        sel: difference(v1.sel)(fromFoldable2(v))
                    };
                    throw new Error("Failed pattern match at Internal.SelectionMap (line 56, column 1 - line 57, column 71): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name
                    ]);
                };
            };
        };
    };
};
var $f264ceec36a478ad$export$2f60db41f2af055 = function(dictOrd) {
    var selectAll1 = $f264ceec36a478ad$export$90aca4adda6ff0f5(dictOrd);
    return function(dictFunctor) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFoldable) {
            var selectAll2 = selectAll1(dictFoldable);
            return function(vs) {
                return selectAll2(map1(function(v) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.id, v);
                })(vs));
            };
        };
    };
};
var $f264ceec36a478ad$export$2e6c959c16ff56b8 = function(dictOrd) {
    var insert = $ea3eb84de0acf574$export$21a5ca8aa77d35ff(dictOrd);
    return function(k) {
        return function(v) {
            return function(s) {
                return {
                    sel: insert(k)(v)(s.sel)
                };
            };
        };
    };
};
var $f264ceec36a478ad$export$8b371b7a43624610 = function(dictOrd) {
    var select1 = $f264ceec36a478ad$export$2e6c959c16ff56b8(dictOrd);
    return function(v) {
        return select1(v.id)(v);
    };
};
var $f264ceec36a478ad$export$7693e0a1b9351086 = function(v) {
    return $ea3eb84de0acf574$export$68c286be0e7e55b7(v.sel);
};
var $f264ceec36a478ad$export$e4d153b3e021fb47 = function(dictOrd) {
    var member = $ea3eb84de0acf574$export$6a0d13241802fe80(dictOrd);
    return function(k) {
        return function(v) {
            return member(k)(v.sel);
        };
    };
};
var $f264ceec36a478ad$export$dd1bc94b04021eeb = function(dictOrd) {
    return function(v) {
        return $ea3eb84de0acf574$export$dd1bc94b04021eeb(v.sel);
    };
};
var $f264ceec36a478ad$export$f9f1f4119b3df74 = function(dictOrd) {
    var lookup = $ea3eb84de0acf574$export$dfc7155ac0343b8(dictOrd);
    return function(k) {
        return function(v) {
            return lookup(k)(v.sel);
        };
    };
};
var $f264ceec36a478ad$export$b7d5d9bb9ff52072 = function(dictOrd) {
    var fromFoldable1 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072(dictOrd);
    return function(dictFoldable) {
        var fromFoldable2 = fromFoldable1(dictFoldable);
        return function(arr) {
            return {
                sel: fromFoldable2(arr)
            };
        };
    };
};
var $f264ceec36a478ad$export$d782b52044d44562 = function(dictOrd) {
    var fromFoldable1 = $f264ceec36a478ad$export$b7d5d9bb9ff52072(dictOrd);
    return function(dictFunctor) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFoldable) {
            var $100 = fromFoldable1(dictFoldable);
            var $101 = map1(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.id, v);
            });
            return function($102) {
                return $100($101($102));
            };
        };
    };
};
var $f264ceec36a478ad$export$6e22c362a0406a2c = {
    sel: $ea3eb84de0acf574$export$6e22c362a0406a2c
};
var $f264ceec36a478ad$export$5bb86370ea51314a = function(dictOrd) {
    var $$delete = $ea3eb84de0acf574$export$1822828d790e23ee(dictOrd);
    return function(k) {
        return function(s) {
            return {
                sel: $$delete(k)(s.sel)
            };
        };
    };
};
var $f264ceec36a478ad$export$5a4818cec1656a71 = function(dictOrd) {
    var select1 = $f264ceec36a478ad$export$2e6c959c16ff56b8(dictOrd);
    var deselect1 = $f264ceec36a478ad$export$5bb86370ea51314a(dictOrd);
    return function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3) return select1(v)(v1)(v2);
                    if (!v3) return deselect1(v)(v2);
                    throw new Error("Failed pattern match at Internal.SelectionMap (line 40, column 1 - line 40, column 94): " + [
                        v.constructor.name,
                        v1.constructor.name,
                        v2.constructor.name,
                        v3.constructor.name
                    ]);
                };
            };
        };
    };
};
var $f264ceec36a478ad$export$21f1fa92f77cf950 = function(dictOrd) {
    var setSelected1 = $f264ceec36a478ad$export$5a4818cec1656a71(dictOrd);
    var isSelected1 = $f264ceec36a478ad$export$e4d153b3e021fb47(dictOrd);
    return function(k) {
        return function(v) {
            return function(renderCheck) {
                return function(sel) {
                    return $f264ceec36a478ad$var$map(setSelected1(k)(v)(sel))(renderCheck(isSelected1(k)(sel)));
                };
            };
        };
    };
};
var $f264ceec36a478ad$export$117af77010ad01dc = function(dictOrd) {
    var selectionCheckbox1 = $f264ceec36a478ad$export$21f1fa92f77cf950(dictOrd);
    return function(k) {
        return function(v) {
            return function(props) {
                return selectionCheckbox1(k)(v)($fc8e139dfeeff88c$export$b07e517d22efa1ca(props));
            };
        };
    };
};
var $f264ceec36a478ad$export$b52fcdc078a891ae = function(dictOrd) {
    var member = $ea3eb84de0acf574$export$6a0d13241802fe80(dictOrd);
    return function(dictFoldable) {
        var all = $4fe7b6acfba7f29f$export$84bf76cd7afc7469(dictFoldable)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
        return function(ks) {
            return function(v) {
                return all(function(v1) {
                    return member(v1)(v.sel);
                })(ks);
            };
        };
    };
};
var $f264ceec36a478ad$export$a15ad87874fca069 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFoldable) {
        return function(dictOrd) {
            var selectAll1 = $f264ceec36a478ad$export$90aca4adda6ff0f5(dictOrd)(dictFoldable);
            var areAllSelected1 = $f264ceec36a478ad$export$b52fcdc078a891ae(dictOrd)(dictFoldable);
            return function(items) {
                return function(renderCheck) {
                    return function(sel) {
                        var itemKeys = map1($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(items);
                        return $f264ceec36a478ad$var$map(selectAll1(items)(sel))(renderCheck(areAllSelected1(itemKeys)(sel)));
                    };
                };
            };
        };
    };
};
var $f264ceec36a478ad$export$1ee36b6d1ce76362 = function(dictOrd) {
    return function(dictFunctor) {
        var selectAllCheckbox1 = $f264ceec36a478ad$export$a15ad87874fca069(dictFunctor);
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(dictFoldable) {
            var selectAllCheckbox2 = selectAllCheckbox1(dictFoldable)(dictOrd);
            return function(items) {
                return selectAllCheckbox2(map1(function(v) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.id, v);
                })(items));
            };
        };
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16







// Generated by purs version 0.15.16





// Generated by purs version 0.15.16





var $cbbc8ce596810eef$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $cbbc8ce596810eef$export$a752bd756a1ddd62 = function(dictDecodeJson) {
    return $160716589b57c4ec$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson));
};
var $cbbc8ce596810eef$export$65e8cd53bb7e3167 = function(dictDecodeJson) {
    return $160716589b57c4ec$export$65e8cd53bb7e3167($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson));
};
var $cbbc8ce596810eef$export$2c9b3f539cb25b05 = function(dictDecodeJson) {
    return $160716589b57c4ec$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson));
};
var $cbbc8ce596810eef$export$29d9133fafbd5114 = function(parser) {
    return function($$default) {
        return $cbbc8ce596810eef$var$map($06733ae99ed4f534$export$43db023a260c5e9f($$default))(parser);
    };
};














// Generated by purs version 0.15.16
/* globals setImmediate, clearImmediate, setTimeout, clearTimeout */ /* eslint-disable no-unused-vars, no-prototype-builtins, no-use-before-define, no-unused-labels, no-param-reassign */ var $b28443a27438717a$var$Aff = function() {
    // A unique value for empty.
    var EMPTY = {};
    /*

  An awkward approximation. We elide evidence we would otherwise need in PS for
  efficiency sake.

  data Aff eff a
    = Pure a
    | Throw Error
    | Catch (Aff eff a) (Error -> Aff eff a)
    | Sync (Eff eff a)
    | Async ((Either Error a -> Eff eff Unit) -> Eff eff (Canceler eff))
    | forall b. Bind (Aff eff b) (b -> Aff eff a)
    | forall b. Bracket (Aff eff b) (BracketConditions eff b) (b -> Aff eff a)
    | forall b. Fork Boolean (Aff eff b) ?(Fiber eff b -> a)
    | Sequential (ParAff aff a)

  */ var PURE = "Pure";
    var THROW = "Throw";
    var CATCH = "Catch";
    var SYNC = "Sync";
    var ASYNC = "Async";
    var BIND = "Bind";
    var BRACKET = "Bracket";
    var FORK = "Fork";
    var SEQ = "Sequential";
    /*

  data ParAff eff a
    = forall b. Map (b -> a) (ParAff eff b)
    | forall b. Apply (ParAff eff (b -> a)) (ParAff eff b)
    | Alt (ParAff eff a) (ParAff eff a)
    | ?Par (Aff eff a)

  */ var MAP = "Map";
    var APPLY = "Apply";
    var ALT = "Alt";
    // Various constructors used in interpretation
    var CONS = "Cons"; // Cons-list, for stacks
    var RESUME = "Resume"; // Continue indiscriminately
    var RELEASE = "Release"; // Continue with bracket finalizers
    var FINALIZER = "Finalizer"; // A non-interruptible effect
    var FINALIZED = "Finalized"; // Marker for finalization
    var FORKED = "Forked"; // Reference to a forked fiber, with resumption stack
    var FIBER = "Fiber"; // Actual fiber reference
    var THUNK = "Thunk"; // Primed effect, ready to invoke
    function Aff(tag, _1, _2, _3) {
        this.tag = tag;
        this._1 = _1;
        this._2 = _2;
        this._3 = _3;
    }
    function AffCtr(tag) {
        var fn = function(_1, _2, _3) {
            return new Aff(tag, _1, _2, _3);
        };
        fn.tag = tag;
        return fn;
    }
    function nonCanceler(error) {
        return new Aff(PURE, void 0);
    }
    function runEff(eff) {
        try {
            eff();
        } catch (error) {
            setTimeout(function() {
                throw error;
            }, 0);
        }
    }
    function runSync(left, right, eff) {
        try {
            return right(eff());
        } catch (error) {
            return left(error);
        }
    }
    function runAsync(left, eff, k) {
        try {
            return eff(k)();
        } catch (error) {
            k(left(error))();
            return nonCanceler;
        }
    }
    var Scheduler = function() {
        var limit = 1024;
        var size = 0;
        var ix = 0;
        var queue = new Array(limit);
        var draining = false;
        function drain() {
            var thunk;
            draining = true;
            while(size !== 0){
                size--;
                thunk = queue[ix];
                queue[ix] = void 0;
                ix = (ix + 1) % limit;
                thunk();
            }
            draining = false;
        }
        return {
            isDraining: function() {
                return draining;
            },
            enqueue: function(cb) {
                var i, tmp;
                if (size === limit) {
                    tmp = draining;
                    drain();
                    draining = tmp;
                }
                queue[(ix + size) % limit] = cb;
                size++;
                if (!draining) drain();
            }
        };
    }();
    function Supervisor(util) {
        var fibers = {};
        var fiberId = 0;
        var count = 0;
        return {
            register: function(fiber) {
                var fid = fiberId++;
                fiber.onComplete({
                    rethrow: true,
                    handler: function(result) {
                        return function() {
                            count--;
                            delete fibers[fid];
                        };
                    }
                })();
                fibers[fid] = fiber;
                count++;
            },
            isEmpty: function() {
                return count === 0;
            },
            killAll: function(killError, cb) {
                return function() {
                    if (count === 0) return cb();
                    var killCount = 0;
                    var kills = {};
                    function kill(fid) {
                        kills[fid] = fibers[fid].kill(killError, function(result) {
                            return function() {
                                delete kills[fid];
                                killCount--;
                                if (util.isLeft(result) && util.fromLeft(result)) setTimeout(function() {
                                    throw util.fromLeft(result);
                                }, 0);
                                if (killCount === 0) cb();
                            };
                        })();
                    }
                    for(var k in fibers)if (fibers.hasOwnProperty(k)) {
                        killCount++;
                        kill(k);
                    }
                    fibers = {};
                    fiberId = 0;
                    count = 0;
                    return function(error) {
                        return new Aff(SYNC, function() {
                            for(var k in kills)if (kills.hasOwnProperty(k)) kills[k]();
                        });
                    };
                };
            }
        };
    }
    // Fiber state machine
    var SUSPENDED = 0; // Suspended, pending a join.
    var CONTINUE = 1; // Interpret the next instruction.
    var STEP_BIND = 2; // Apply the next bind.
    var STEP_RESULT = 3; // Handle potential failure from a result.
    var PENDING = 4; // An async effect is running.
    var RETURN = 5; // The current stack has returned.
    var COMPLETED = 6; // The entire fiber has completed.
    function Fiber(util, supervisor, aff) {
        // Monotonically increasing tick, increased on each asynchronous turn.
        var runTick = 0;
        // The current branch of the state machine.
        var status = SUSPENDED;
        // The current point of interest for the state machine branch.
        var step = aff; // Successful step
        var fail = null; // Failure step
        var interrupt = null; // Asynchronous interrupt
        // Stack of continuations for the current fiber.
        var bhead = null;
        var btail = null;
        // Stack of attempts and finalizers for error recovery. Every `Cons` is also
        // tagged with current `interrupt` state. We use this to track which items
        // should be ignored or evaluated as a result of a kill.
        var attempts = null;
        // A special state is needed for Bracket, because it cannot be killed. When
        // we enter a bracket acquisition or finalizer, we increment the counter,
        // and then decrement once complete.
        var bracketCount = 0;
        // Each join gets a new id so they can be revoked.
        var joinId = 0;
        var joins = null;
        var rethrow = true;
        // Each invocation of `run` requires a tick. When an asynchronous effect is
        // resolved, we must check that the local tick coincides with the fiber
        // tick before resuming. This prevents multiple async continuations from
        // accidentally resuming the same fiber. A common example may be invoking
        // the provided callback in `makeAff` more than once, but it may also be an
        // async effect resuming after the fiber was already cancelled.
        function run(localRunTick) {
            var tmp, result, attempt;
            while(true){
                tmp = null;
                result = null;
                attempt = null;
                switch(status){
                    case STEP_BIND:
                        status = CONTINUE;
                        try {
                            step = bhead(step);
                            if (btail === null) bhead = null;
                            else {
                                bhead = btail._1;
                                btail = btail._2;
                            }
                        } catch (e) {
                            status = RETURN;
                            fail = util.left(e);
                            step = null;
                        }
                        break;
                    case STEP_RESULT:
                        if (util.isLeft(step)) {
                            status = RETURN;
                            fail = step;
                            step = null;
                        } else if (bhead === null) status = RETURN;
                        else {
                            status = STEP_BIND;
                            step = util.fromRight(step);
                        }
                        break;
                    case CONTINUE:
                        switch(step.tag){
                            case BIND:
                                if (bhead) btail = new Aff(CONS, bhead, btail);
                                bhead = step._2;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case PURE:
                                if (bhead === null) {
                                    status = RETURN;
                                    step = util.right(step._1);
                                } else {
                                    status = STEP_BIND;
                                    step = step._1;
                                }
                                break;
                            case SYNC:
                                status = STEP_RESULT;
                                step = runSync(util.left, util.right, step._1);
                                break;
                            case ASYNC:
                                status = PENDING;
                                step = runAsync(util.left, step._1, function(result) {
                                    return function() {
                                        if (runTick !== localRunTick) return;
                                        runTick++;
                                        Scheduler.enqueue(function() {
                                            // It's possible to interrupt the fiber between enqueuing and
                                            // resuming, so we need to check that the runTick is still
                                            // valid.
                                            if (runTick !== localRunTick + 1) return;
                                            status = STEP_RESULT;
                                            step = result;
                                            run(runTick);
                                        });
                                    };
                                });
                                return;
                            case THROW:
                                status = RETURN;
                                fail = util.left(step._1);
                                step = null;
                                break;
                            // Enqueue the Catch so that we can call the error handler later on
                            // in case of an exception.
                            case CATCH:
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            // Enqueue the Bracket so that we can call the appropriate handlers
                            // after resource acquisition.
                            case BRACKET:
                                bracketCount++;
                                if (bhead === null) attempts = new Aff(CONS, step, attempts, interrupt);
                                else attempts = new Aff(CONS, step, new Aff(CONS, new Aff(RESUME, bhead, btail), attempts, interrupt), interrupt);
                                bhead = null;
                                btail = null;
                                status = CONTINUE;
                                step = step._1;
                                break;
                            case FORK:
                                status = STEP_RESULT;
                                tmp = Fiber(util, supervisor, step._2);
                                if (supervisor) supervisor.register(tmp);
                                if (step._1) tmp.run();
                                step = util.right(tmp);
                                break;
                            case SEQ:
                                status = CONTINUE;
                                step = sequential(util, supervisor, step._1);
                                break;
                        }
                        break;
                    case RETURN:
                        bhead = null;
                        btail = null;
                        // If the current stack has returned, and we have no other stacks to
                        // resume or finalizers to run, the fiber has halted and we can
                        // invoke all join callbacks. Otherwise we need to resume.
                        if (attempts === null) {
                            status = COMPLETED;
                            step = interrupt || fail || step;
                        } else {
                            // The interrupt status for the enqueued item.
                            tmp = attempts._3;
                            attempt = attempts._1;
                            attempts = attempts._2;
                            switch(attempt.tag){
                                // We cannot recover from an unmasked interrupt. Otherwise we should
                                // continue stepping, or run the exception handler if an exception
                                // was raised.
                                case CATCH:
                                    // We should compare the interrupt status as well because we
                                    // only want it to apply if there has been an interrupt since
                                    // enqueuing the catch.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) status = RETURN;
                                    else if (fail) {
                                        status = CONTINUE;
                                        step = attempt._2(util.fromLeft(fail));
                                        fail = null;
                                    }
                                    break;
                                // We cannot resume from an unmasked interrupt or exception.
                                case RESUME:
                                    // As with Catch, we only want to ignore in the case of an
                                    // interrupt since enqueing the item.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0 || fail) status = RETURN;
                                    else {
                                        bhead = attempt._1;
                                        btail = attempt._2;
                                        status = STEP_BIND;
                                        step = util.fromRight(step);
                                    }
                                    break;
                                // If we have a bracket, we should enqueue the handlers,
                                // and continue with the success branch only if the fiber has
                                // not been interrupted. If the bracket acquisition failed, we
                                // should not run either.
                                case BRACKET:
                                    bracketCount--;
                                    if (fail === null) {
                                        result = util.fromRight(step);
                                        // We need to enqueue the Release with the same interrupt
                                        // status as the Bracket that is initiating it.
                                        attempts = new Aff(CONS, new Aff(RELEASE, attempt._2, result), attempts, tmp);
                                        // We should only coninue as long as the interrupt status has not changed or
                                        // we are currently within a non-interruptable finalizer.
                                        if (interrupt === tmp || bracketCount > 0) {
                                            status = CONTINUE;
                                            step = attempt._3(result);
                                        }
                                    }
                                    break;
                                // Enqueue the appropriate handler. We increase the bracket count
                                // because it should not be cancelled.
                                case RELEASE:
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    // It has only been killed if the interrupt status has changed
                                    // since we enqueued the item, and the bracket count is 0. If the
                                    // bracket count is non-zero then we are in a masked state so it's
                                    // impossible to be killed.
                                    if (interrupt && interrupt !== tmp && bracketCount === 0) step = attempt._1.killed(util.fromLeft(interrupt))(attempt._2);
                                    else if (fail) step = attempt._1.failed(util.fromLeft(fail))(attempt._2);
                                    else step = attempt._1.completed(util.fromRight(step))(attempt._2);
                                    fail = null;
                                    bracketCount++;
                                    break;
                                case FINALIZER:
                                    bracketCount++;
                                    attempts = new Aff(CONS, new Aff(FINALIZED, step, fail), attempts, interrupt);
                                    status = CONTINUE;
                                    step = attempt._1;
                                    break;
                                case FINALIZED:
                                    bracketCount--;
                                    status = RETURN;
                                    step = attempt._1;
                                    fail = attempt._2;
                                    break;
                            }
                        }
                        break;
                    case COMPLETED:
                        for(var k in joins)if (joins.hasOwnProperty(k)) {
                            rethrow = rethrow && joins[k].rethrow;
                            runEff(joins[k].handler(step));
                        }
                        joins = null;
                        // If we have an interrupt and a fail, then the thread threw while
                        // running finalizers. This should always rethrow in a fresh stack.
                        if (interrupt && fail) setTimeout(function() {
                            throw util.fromLeft(fail);
                        }, 0);
                        else if (util.isLeft(step) && rethrow) setTimeout(function() {
                            // Guard on reathrow because a completely synchronous fiber can
                            // still have an observer which was added after-the-fact.
                            if (rethrow) throw util.fromLeft(step);
                        }, 0);
                        return;
                    case SUSPENDED:
                        status = CONTINUE;
                        break;
                    case PENDING:
                        return;
                }
            }
        }
        function onComplete(join) {
            return function() {
                if (status === COMPLETED) {
                    rethrow = rethrow && join.rethrow;
                    join.handler(step)();
                    return function() {};
                }
                var jid = joinId++;
                joins = joins || {};
                joins[jid] = join;
                return function() {
                    if (joins !== null) delete joins[jid];
                };
            };
        }
        function kill(error, cb) {
            return function() {
                if (status === COMPLETED) {
                    cb(util.right(void 0))();
                    return function() {};
                }
                var canceler = onComplete({
                    rethrow: false,
                    handler: function() {
                        return cb(util.right(void 0));
                    }
                })();
                switch(status){
                    case SUSPENDED:
                        interrupt = util.left(error);
                        status = COMPLETED;
                        step = interrupt;
                        run(runTick);
                        break;
                    case PENDING:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            if (status === PENDING) attempts = new Aff(CONS, new Aff(FINALIZER, step(error)), attempts, interrupt);
                            status = RETURN;
                            step = null;
                            fail = null;
                            run(++runTick);
                        }
                        break;
                    default:
                        if (interrupt === null) interrupt = util.left(error);
                        if (bracketCount === 0) {
                            status = RETURN;
                            step = null;
                            fail = null;
                        }
                }
                return canceler;
            };
        }
        function join(cb) {
            return function() {
                var canceler = onComplete({
                    rethrow: false,
                    handler: cb
                })();
                if (status === SUSPENDED) run(runTick);
                return canceler;
            };
        }
        return {
            kill: kill,
            join: join,
            onComplete: onComplete,
            isSuspended: function() {
                return status === SUSPENDED;
            },
            run: function() {
                if (status === SUSPENDED) {
                    if (!Scheduler.isDraining()) Scheduler.enqueue(function() {
                        run(runTick);
                    });
                    else run(runTick);
                }
            }
        };
    }
    function runPar(util, supervisor, par, cb) {
        // Table of all forked fibers.
        var fiberId = 0;
        var fibers = {};
        // Table of currently running cancelers, as a product of `Alt` behavior.
        var killId = 0;
        var kills = {};
        // Error used for early cancelation on Alt branches.
        var early = new Error("[ParAff] Early exit");
        // Error used to kill the entire tree.
        var interrupt = null;
        // The root pointer of the tree.
        var root = EMPTY;
        // Walks a tree, invoking all the cancelers. Returns the table of pending
        // cancellation fibers.
        function kill(error, par, cb) {
            var step = par;
            var head = null;
            var tail = null;
            var count = 0;
            var kills = {};
            var tmp, kid;
            loop: while(true){
                tmp = null;
                switch(step.tag){
                    case FORKED:
                        if (step._3 === EMPTY) {
                            tmp = fibers[step._1];
                            kills[count++] = tmp.kill(error, function(result) {
                                return function() {
                                    count--;
                                    if (count === 0) cb(result)();
                                };
                            });
                        }
                        // Terminal case.
                        if (head === null) break loop;
                        // Go down the right side of the tree.
                        step = head._2;
                        if (tail === null) head = null;
                        else {
                            head = tail._1;
                            tail = tail._2;
                        }
                        break;
                    case MAP:
                        step = step._2;
                        break;
                    case APPLY:
                    case ALT:
                        if (head) tail = new Aff(CONS, head, tail);
                        head = step;
                        step = step._1;
                        break;
                }
            }
            if (count === 0) cb(util.right(void 0))();
            else {
                // Run the cancelation effects. We alias `count` because it's mutable.
                kid = 0;
                tmp = count;
                for(; kid < tmp; kid++)kills[kid] = kills[kid]();
            }
            return kills;
        }
        // When a fiber resolves, we need to bubble back up the tree with the
        // result, computing the applicative nodes.
        function join(result, head, tail) {
            var fail, step, lhs, rhs, tmp, kid;
            if (util.isLeft(result)) {
                fail = result;
                step = null;
            } else {
                step = result;
                fail = null;
            }
            loop: while(true){
                lhs = null;
                rhs = null;
                tmp = null;
                kid = null;
                // We should never continue if the entire tree has been interrupted.
                if (interrupt !== null) return;
                // We've made it all the way to the root of the tree, which means
                // the tree has fully evaluated.
                if (head === null) {
                    cb(fail || step)();
                    return;
                }
                // The tree has already been computed, so we shouldn't try to do it
                // again. This should never happen.
                // TODO: Remove this?
                if (head._3 !== EMPTY) return;
                switch(head.tag){
                    case MAP:
                        if (fail === null) {
                            head._3 = util.right(head._1(util.fromRight(step)));
                            step = head._3;
                        } else head._3 = fail;
                        break;
                    case APPLY:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // If we have a failure we should kill the other side because we
                        // can't possible yield a result anymore.
                        if (fail) {
                            head._3 = fail;
                            tmp = true;
                            kid = killId++;
                            kills[kid] = kill(early, fail === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(fail, null, null);
                                    else join(fail, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        } else if (lhs === EMPTY || rhs === EMPTY) // We can only proceed if both sides have resolved.
                        return;
                        else {
                            step = util.right(util.fromRight(lhs)(util.fromRight(rhs)));
                            head._3 = step;
                        }
                        break;
                    case ALT:
                        lhs = head._1._3;
                        rhs = head._2._3;
                        // We can only proceed if both have resolved or we have a success
                        if (lhs === EMPTY && util.isLeft(rhs) || rhs === EMPTY && util.isLeft(lhs)) return;
                        // If both sides resolve with an error, we should continue with the
                        // first error
                        if (lhs !== EMPTY && util.isLeft(lhs) && rhs !== EMPTY && util.isLeft(rhs)) {
                            fail = step === lhs ? rhs : lhs;
                            step = null;
                            head._3 = fail;
                        } else {
                            head._3 = step;
                            tmp = true;
                            kid = killId++;
                            // Once a side has resolved, we need to cancel the side that is still
                            // pending before we can continue.
                            kills[kid] = kill(early, step === lhs ? head._2 : head._1, function() {
                                return function() {
                                    delete kills[kid];
                                    if (tmp) tmp = false;
                                    else if (tail === null) join(step, null, null);
                                    else join(step, tail._1, tail._2);
                                };
                            });
                            if (tmp) {
                                tmp = false;
                                return;
                            }
                        }
                        break;
                }
                if (tail === null) head = null;
                else {
                    head = tail._1;
                    tail = tail._2;
                }
            }
        }
        function resolve(fiber) {
            return function(result) {
                return function() {
                    delete fibers[fiber._1];
                    fiber._3 = result;
                    join(result, fiber._2._1, fiber._2._2);
                };
            };
        }
        // Walks the applicative tree, substituting non-applicative nodes with
        // `FORKED` nodes. In this tree, all applicative nodes use the `_3` slot
        // as a mutable slot for memoization. In an unresolved state, the `_3`
        // slot is `EMPTY`. In the cases of `ALT` and `APPLY`, we always walk
        // the left side first, because both operations are left-associative. As
        // we `RETURN` from those branches, we then walk the right side.
        function run() {
            var status = CONTINUE;
            var step = par;
            var head = null;
            var tail = null;
            var tmp, fid;
            loop: while(true){
                tmp = null;
                fid = null;
                switch(status){
                    case CONTINUE:
                        switch(step.tag){
                            case MAP:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(MAP, step._1, EMPTY, EMPTY);
                                step = step._2;
                                break;
                            case APPLY:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(APPLY, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            case ALT:
                                if (head) tail = new Aff(CONS, head, tail);
                                head = new Aff(ALT, EMPTY, step._2, EMPTY);
                                step = step._1;
                                break;
                            default:
                                // When we hit a leaf value, we suspend the stack in the `FORKED`.
                                // When the fiber resolves, it can bubble back up the tree.
                                fid = fiberId++;
                                status = RETURN;
                                tmp = step;
                                step = new Aff(FORKED, fid, new Aff(CONS, head, tail), EMPTY);
                                tmp = Fiber(util, supervisor, tmp);
                                tmp.onComplete({
                                    rethrow: false,
                                    handler: resolve(step)
                                })();
                                fibers[fid] = tmp;
                                if (supervisor) supervisor.register(tmp);
                        }
                        break;
                    case RETURN:
                        // Terminal case, we are back at the root.
                        if (head === null) break loop;
                        // If we are done with the right side, we need to continue down the
                        // left. Otherwise we should continue up the stack.
                        if (head._1 === EMPTY) {
                            head._1 = step;
                            status = CONTINUE;
                            step = head._2;
                            head._2 = EMPTY;
                        } else {
                            head._2 = step;
                            step = head;
                            if (tail === null) head = null;
                            else {
                                head = tail._1;
                                tail = tail._2;
                            }
                        }
                }
            }
            // Keep a reference to the tree root so it can be cancelled.
            root = step;
            for(fid = 0; fid < fiberId; fid++)fibers[fid].run();
        }
        // Cancels the entire tree. If there are already subtrees being canceled,
        // we need to first cancel those joins. We will then add fresh joins for
        // all pending branches including those that were in the process of being
        // canceled.
        function cancel(error, cb) {
            interrupt = util.left(error);
            var innerKills;
            for(var kid in kills)if (kills.hasOwnProperty(kid)) {
                innerKills = kills[kid];
                for(kid in innerKills)if (innerKills.hasOwnProperty(kid)) innerKills[kid]();
            }
            kills = null;
            var newKills = kill(error, root, cb);
            return function(killError) {
                return new Aff(ASYNC, function(killCb) {
                    return function() {
                        for(var kid in newKills)if (newKills.hasOwnProperty(kid)) newKills[kid]();
                        return nonCanceler;
                    };
                });
            };
        }
        run();
        return function(killError) {
            return new Aff(ASYNC, function(killCb) {
                return function() {
                    return cancel(killError, killCb);
                };
            });
        };
    }
    function sequential(util, supervisor, par) {
        return new Aff(ASYNC, function(cb) {
            return function() {
                return runPar(util, supervisor, par, cb);
            };
        });
    }
    Aff.EMPTY = EMPTY;
    Aff.Pure = AffCtr(PURE);
    Aff.Throw = AffCtr(THROW);
    Aff.Catch = AffCtr(CATCH);
    Aff.Sync = AffCtr(SYNC);
    Aff.Async = AffCtr(ASYNC);
    Aff.Bind = AffCtr(BIND);
    Aff.Bracket = AffCtr(BRACKET);
    Aff.Fork = AffCtr(FORK);
    Aff.Seq = AffCtr(SEQ);
    Aff.ParMap = AffCtr(MAP);
    Aff.ParApply = AffCtr(APPLY);
    Aff.ParAlt = AffCtr(ALT);
    Aff.Fiber = Fiber;
    Aff.Supervisor = Supervisor;
    Aff.Scheduler = Scheduler;
    Aff.nonCanceler = nonCanceler;
    return Aff;
}();
const $b28443a27438717a$export$68c6660df485915b = $b28443a27438717a$var$Aff.Pure;
const $b28443a27438717a$export$520252a01094c36e = $b28443a27438717a$var$Aff.Throw;
function $b28443a27438717a$export$eb5e86cd5464556e(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Catch(aff, k);
    };
}
function $b28443a27438717a$export$a0135aecf4a782ab(f) {
    return function(aff) {
        if (aff.tag === $b28443a27438717a$var$Aff.Pure.tag) return $b28443a27438717a$var$Aff.Pure(f(aff._1));
        else return $b28443a27438717a$var$Aff.Bind(aff, function(value) {
            return $b28443a27438717a$var$Aff.Pure(f(value));
        });
    };
}
function $b28443a27438717a$export$8fe95d71d8c6b6f3(aff) {
    return function(k) {
        return $b28443a27438717a$var$Aff.Bind(aff, k);
    };
}
function $b28443a27438717a$export$f97e7884af471963(immediate) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.Fork(immediate, aff);
    };
}
const $b28443a27438717a$export$3c6532f01a0290eb = $b28443a27438717a$var$Aff.Sync;
function $b28443a27438717a$export$68695d37eb163711(f) {
    return function(aff) {
        return $b28443a27438717a$var$Aff.ParMap(f, aff);
    };
}
function $b28443a27438717a$export$bce00526579b3344(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParApply(aff1, aff2);
    };
}
function $b28443a27438717a$export$6a44b66c7edadaa(aff1) {
    return function(aff2) {
        return $b28443a27438717a$var$Aff.ParAlt(aff1, aff2);
    };
}
const $b28443a27438717a$export$49d5975414e0a979 = $b28443a27438717a$var$Aff.Async;
function $b28443a27438717a$export$9ad792f02752f447(acquire) {
    return function(options) {
        return function(k) {
            return $b28443a27438717a$var$Aff.Bracket(acquire, options, k);
        };
    };
}
function $b28443a27438717a$export$f24188c8fd3f1234(util, aff) {
    return function() {
        return $b28443a27438717a$var$Aff.Fiber(util, null, aff);
    };
}
function $b28443a27438717a$export$7a3baea9562462c7(util, aff) {
    return function() {
        var supervisor = $b28443a27438717a$var$Aff.Supervisor(util);
        return {
            fiber: $b28443a27438717a$var$Aff.Fiber(util, supervisor, aff),
            supervisor: supervisor
        };
    };
}
function $b28443a27438717a$export$a494cc11bfc0c750(error, supervisor, cb) {
    return supervisor.killAll(error, cb);
}
const $b28443a27438717a$export$389c1406f5ae6ae7 = function() {
    function setDelay(n, k) {
        if (n === 0 && typeof setImmediate !== "undefined") return setImmediate(k);
        else return setTimeout(k, n);
    }
    function clearDelay(n, t) {
        if (n === 0 && typeof clearImmediate !== "undefined") return clearImmediate(t);
        else return clearTimeout(t);
    }
    return function(right, ms) {
        return $b28443a27438717a$var$Aff.Async(function(cb) {
            return function() {
                var timer = setDelay(ms, cb(right()));
                return function() {
                    return $b28443a27438717a$var$Aff.Sync(function() {
                        return right(clearDelay(ms, timer));
                    });
                };
            };
        });
    };
}();
const $b28443a27438717a$export$139486a45824a247 = $b28443a27438717a$var$Aff.Seq;









// Generated by purs version 0.15.16


// Generated by purs version 0.15.16


// Generated by purs version 0.15.16












var $fca560e14229da4e$export$14010cd19909b6b = function(x) {
    return x;
};
var $fca560e14229da4e$export$2a106bc5b2e64dce = function(f) {
    return function(v) {
        return function(k) {
            return v(f(k));
        };
    };
};
var $fca560e14229da4e$export$358211fab263c66b = function(v) {
    return function(k) {
        return v(k);
    };
};
var $fca560e14229da4e$export$5419b7e78c76e565 = {
    Coercible0: function() {
        return undefined;
    }
};
var $fca560e14229da4e$export$6a2bb59a0c53ce17 = {
    lift: function(dictMonad) {
        var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
        return function(m) {
            return function(k) {
                return bind(m)(k);
            };
        };
    }
};
var $fca560e14229da4e$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $fca560e14229da4e$export$604f139dbf56bccf = function(f) {
    return function(v) {
        return function(k) {
            return f(v(k));
        };
    };
};
var $fca560e14229da4e$export$232156ef715cfc9b = function(dictFunctor) {
    return {
        map: function(f) {
            return function(v) {
                return function(k) {
                    return v(function(a) {
                        return k(f(a));
                    });
                };
            };
        }
    };
};
var $fca560e14229da4e$export$6b05a2ec606a3559 = function(dictApply) {
    var functorContT1 = $fca560e14229da4e$export$232156ef715cfc9b(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return v(function(g) {
                        return v1(function(a) {
                            return k(g(a));
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorContT1;
        }
    };
};
var $fca560e14229da4e$export$91905d227b995e9d = function(dictBind) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(k) {
                return function(k$prime) {
                    return v(function(a) {
                        var v1 = k(a);
                        return v1(k$prime);
                    });
                };
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$ebd715a8b64afb39 = function(dictApply) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($fca560e14229da4e$export$6b05a2ec606a3559(dictApply));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $fca560e14229da4e$export$d73f0595e894296c = function(dictApplicative) {
    var applyContT1 = $fca560e14229da4e$export$6b05a2ec606a3559(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(k) {
                return k(a);
            };
        },
        Apply0: function() {
            return applyContT1;
        }
    };
};
var $fca560e14229da4e$export$735f43b0215ad39 = function(dictMonad) {
    var applicativeContT1 = $fca560e14229da4e$export$d73f0595e894296c(dictMonad.Applicative0());
    var bindContT1 = $fca560e14229da4e$export$91905d227b995e9d(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeContT1;
        },
        Bind1: function() {
            return bindContT1;
        }
    };
};
var $fca560e14229da4e$export$6062b41302ddcd80 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        ask: $fca560e14229da4e$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$dbf903f187194ce5 = function(dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(MonadAsk0.Monad0().Bind1());
    var ask = $74738728c27df511$export$1b4aee0b51c3def8(MonadAsk0);
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskContT1 = $fca560e14229da4e$export$6062b41302ddcd80(MonadAsk0);
    return {
        local: function(f) {
            return function(v) {
                return function(k) {
                    return bind(ask)(function(r) {
                        return local(f)(v(function() {
                            var $94 = local($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(r));
                            return function($95) {
                                return $94(k($95));
                            };
                        }()));
                    });
                };
            };
        },
        MonadAsk0: function() {
            return monadAskContT1;
        }
    };
};
var $fca560e14229da4e$export$fd982f3f83dedfc9 = function(dictMonad) {
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(dictMonad);
    return {
        callCC: function(f) {
            return function(k) {
                var v = f(function(a) {
                    return function(v1) {
                        return k(a);
                    };
                });
                return v(k);
            };
        },
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$35d988300b9091c9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftEffect: function() {
            var $96 = $fca560e14229da4e$var$lift(Monad0);
            var $97 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($98) {
                return $96($97($98));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$1aa60909d07c5b2d = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        state: function() {
            var $99 = $fca560e14229da4e$var$lift(Monad0);
            var $100 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($101) {
                return $99($100($101));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$845d7a4c5796dca2 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadContT1 = $fca560e14229da4e$export$735f43b0215ad39(Monad0);
    return {
        liftST: function() {
            var $102 = $fca560e14229da4e$var$lift(Monad0);
            var $103 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($104) {
                return $102($103($104));
            };
        }(),
        Monad0: function() {
            return monadContT1;
        }
    };
};
var $fca560e14229da4e$export$e824ef6fc9053d43 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictApplicative));
    var semigroupContT1 = $fca560e14229da4e$export$ebd715a8b64afb39(dictApplicative.Apply0());
    return function(dictMonoid) {
        var semigroupContT2 = semigroupContT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupContT2;
            }
        };
    };
};



// Generated by purs version 0.15.16



















var $7038ccc2f7f5bbce$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7038ccc2f7f5bbce$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $7038ccc2f7f5bbce$export$ad3c05b40854bc17 = function(x) {
    return x;
};
var $7038ccc2f7f5bbce$export$74b507a1130daad6 = function(v) {
    return v;
};
var $7038ccc2f7f5bbce$export$e423059046893ebc = {
    Coercible0: function() {
        return undefined;
    }
};
var $7038ccc2f7f5bbce$export$84eda9cb75492c36 = {
    lift: function(dictMonad) {
        var $163 = $d3d065da31679be1$export$167848c32e61a4d4(dictMonad)($06733ae99ed4f534$export$8a67b48435b5d073.create);
        return function($164) {
            return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($163($164));
        };
    }
};
var $7038ccc2f7f5bbce$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $7038ccc2f7f5bbce$export$d0ac118ccd5cda07 = function(f) {
    return function(v) {
        return f(v);
    };
};
var $7038ccc2f7f5bbce$export$3bf77092340654e0 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                return map1($7038ccc2f7f5bbce$var$map(f))(v);
            };
        }
    };
};
var $7038ccc2f7f5bbce$export$63cf87c0678a1d2c = function(dictMonad) {
    return {
        Applicative0: function() {
            return $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
        },
        Bind1: function() {
            return $7038ccc2f7f5bbce$export$c4ec8f671a263573(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$c4ec8f671a263573 = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return {
        bind: function(v) {
            return function(f) {
                return bind(v)(function(v1) {
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        var v2 = f(v1.value0);
                        return v2;
                    }
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 55, column 11 - line 57, column 42): " + [
                        v1.constructor.name
                    ]);
                });
            };
        },
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e = function(dictMonad) {
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad)),
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4797150488333da1 = function(dictMonad) {
    return {
        pure: function() {
            var $165 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($166) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($165($06733ae99ed4f534$export$8a67b48435b5d073.create($166)));
            };
        }(),
        Apply0: function() {
            return $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        }
    };
};
var $7038ccc2f7f5bbce$export$984e03b79d8c6656 = function(dictMonad) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $7038ccc2f7f5bbce$export$36c6624b0bef0761 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        ask: $7038ccc2f7f5bbce$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d73769631c0edb39 = function(dictMonadReader) {
    var local = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
    var monadAskMaybeT1 = $7038ccc2f7f5bbce$export$36c6624b0bef0761(dictMonadReader.MonadAsk0());
    return {
        local: function(f) {
            return $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(local(f));
        },
        MonadAsk0: function() {
            return monadAskMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$ec6a88a02083ed25 = function(dictMonadCont) {
    var callCC = $67e1952ff57566f7$export$bb801a161a3121f0(dictMonadCont);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonadCont.Monad0());
    return {
        callCC: function(f) {
            return callCC(function(c) {
                var v = f(function(a) {
                    return c(new $06733ae99ed4f534$export$8a67b48435b5d073(a));
                });
                return v;
            });
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$2f876a9cb1e407d9 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftEffect: function() {
            var $167 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $168 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($169) {
                return $167($168($169));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$7b9e3f37a9f7f6b2 = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var Monad0 = dictMonadRec.Monad0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        tailRecM: function(f) {
            var $170 = tailRecM(function(a) {
                var v = f(a);
                return bind(v)(function(m$prime) {
                    return pure(function() {
                        if (m$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $f93520de2fa37b44$export$7fe28cb29e71bf10($06733ae99ed4f534$export$bebe9059409a0d04.value);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return new $f93520de2fa37b44$export$550acbd06a1f5a6a(m$prime.value0.value0);
                        if (m$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && m$prime.value0 instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(new $06733ae99ed4f534$export$8a67b48435b5d073(m$prime.value0.value0));
                        throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 83, column 16 - line 86, column 43): " + [
                            m$prime.constructor.name
                        ]);
                    }());
                });
            });
            return function($171) {
                return $7038ccc2f7f5bbce$export$ad3c05b40854bc17($170($171));
            };
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$99cfcc8edd025934 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var state = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        state: function(f) {
            return lift1(state(f));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$907950ecc201e8fb = function(dictMonadTell) {
    var Monad1 = dictMonadTell.Monad1();
    var Semigroup0 = dictMonadTell.Semigroup0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad1);
    return {
        tell: function() {
            var $172 = $7038ccc2f7f5bbce$var$lift(Monad1);
            var $173 = $2c4a247071255d7e$export$de3113ed932c61ab(dictMonadTell);
            return function($174) {
                return $172($173($174));
            };
        }(),
        Semigroup0: function() {
            return Semigroup0;
        },
        Monad1: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$5afebe755b331e96 = function(dictMonadWriter) {
    var MonadTell1 = dictMonadWriter.MonadTell1();
    var Monad1 = MonadTell1.Monad1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad1.Bind1());
    var listen = $2c4a247071255d7e$export$63174c828edd6ff8(dictMonadWriter);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad1.Applicative0());
    var pass = $2c4a247071255d7e$export$167b0ad523238611(dictMonadWriter);
    var Monoid0 = dictMonadWriter.Monoid0();
    var monadTellMaybeT1 = $7038ccc2f7f5bbce$export$907950ecc201e8fb(MonadTell1);
    return {
        listen: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return bind(listen(m))(function(v) {
                return pure($7038ccc2f7f5bbce$var$map(function(r) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(r, v.value1);
                })(v.value0));
            });
        }),
        pass: $7038ccc2f7f5bbce$export$d0ac118ccd5cda07(function(m) {
            return pass(bind(m)(function(a) {
                return pure(function() {
                    if (a instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $71f2e2e9476163f8$export$1908877435b1d5e9($06733ae99ed4f534$export$bebe9059409a0d04.value, $7038ccc2f7f5bbce$var$identity);
                    if (a instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $06733ae99ed4f534$export$8a67b48435b5d073(a.value0.value0), a.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.Maybe.Trans (line 120, column 10 - line 122, column 43): " + [
                        a.constructor.name
                    ]);
                }());
            }));
        }),
        Monoid0: function() {
            return Monoid0;
        },
        MonadTell1: function() {
            return monadTellMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$8908e8a28a021e1c = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var lift1 = $7038ccc2f7f5bbce$var$lift(Monad0);
    var throwError = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        throwError: function(e) {
            return lift1(throwError(e));
        },
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$f77b055a7835b1d0 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowMaybeT1 = $7038ccc2f7f5bbce$export$8908e8a28a021e1c(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return catchError(v)(function(a) {
                    var v1 = h(a);
                    return v1;
                });
            };
        },
        MonadThrow0: function() {
            return monadThrowMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$4033508ee81d9e59 = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(Monad0);
    return {
        liftST: function() {
            var $175 = $7038ccc2f7f5bbce$var$lift(Monad0);
            var $176 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($177) {
                return $175($176($177));
            };
        }(),
        Monad0: function() {
            return monadMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$20ac3a2d3113d020 = function(dictMonad) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7038ccc2f7f5bbce$export$4797150488333da1(dictMonad));
    var semigroupMaybeT1 = $7038ccc2f7f5bbce$export$984e03b79d8c6656(dictMonad);
    return function(dictMonoid) {
        var semigroupMaybeT2 = semigroupMaybeT1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupMaybeT2;
            }
        };
    };
};
var $7038ccc2f7f5bbce$export$e14125e5a208a0c9 = function(dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var functorMaybeT1 = $7038ccc2f7f5bbce$export$3bf77092340654e0(Bind1.Apply0().Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return bind(v)(function(m) {
                    if (m instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
                    return pure(m);
                });
            };
        },
        Functor0: function() {
            return functorMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$140a10b5716e1900 = function(dictMonad) {
    var altMaybeT1 = $7038ccc2f7f5bbce$export$e14125e5a208a0c9(dictMonad);
    return {
        empty: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0())($06733ae99ed4f534$export$bebe9059409a0d04.value),
        Alt0: function() {
            return altMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$68df7d2debd59865 = function(dictMonad) {
    var applicativeMaybeT1 = $7038ccc2f7f5bbce$export$4797150488333da1(dictMonad);
    var plusMaybeT1 = $7038ccc2f7f5bbce$export$140a10b5716e1900(dictMonad);
    return {
        Applicative0: function() {
            return applicativeMaybeT1;
        },
        Plus1: function() {
            return plusMaybeT1;
        }
    };
};
var $7038ccc2f7f5bbce$export$d4030eff1969644e = function(dictMonad) {
    var monadMaybeT1 = $7038ccc2f7f5bbce$export$63cf87c0678a1d2c(dictMonad);
    var alternativeMaybeT1 = $7038ccc2f7f5bbce$export$68df7d2debd59865(dictMonad);
    return {
        Monad0: function() {
            return monadMaybeT1;
        },
        Alternative1: function() {
            return alternativeMaybeT1;
        }
    };
};







// Generated by purs version 0.15.16




// Generated by purs version 0.15.16


var $d0c5be72120caeb7$export$578ae18717ba10de = {
    cmap: function(v) {
        return function(v1) {
            return v1;
        };
    }
};
var $d0c5be72120caeb7$export$b186cb408b99d7fc = function(dict) {
    return dict.cmap;
};
var $d0c5be72120caeb7$export$d0a699a1379b7fb5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(x) {
        return function(f) {
            return cmap1(f)(x);
        };
    };
};
var $d0c5be72120caeb7$export$8c14e57e778d3873 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(a) {
            return map($58f3cdfbfe212d20$export$f172309911142386)(cmap1($58f3cdfbfe212d20$export$f172309911142386)(a));
        };
    };
};
var $d0c5be72120caeb7$export$dc224e55acb863f5 = function(dictContravariant) {
    var cmap1 = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return function(v) {
        return function(f) {
            return cmap1(f);
        };
    };
};



// Generated by purs version 0.15.16


var $9be1c75e3223ee2e$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $9be1c75e3223ee2e$var$wrap = /* #__PURE__ */ $4fa4836228a192cc$export$4997ffc0176396a6();
var $9be1c75e3223ee2e$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $9be1c75e3223ee2e$export$e10497e40cde5fd3 = {
    dimap: function(a2b) {
        return function(c2d) {
            return function(b2c) {
                return function($18) {
                    return c2d(b2c(a2b($18)));
                };
            };
        };
    }
};
var $9be1c75e3223ee2e$export$7c344215185fc3ac = function(dict) {
    return dict.dimap;
};
var $9be1c75e3223ee2e$export$48f54268254cf7d0 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(a2b) {
        return dimap1(a2b)($9be1c75e3223ee2e$var$identity);
    };
};
var $9be1c75e3223ee2e$export$6630987c9d273301 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function(b2c) {
        return dimap1($9be1c75e3223ee2e$var$identity)(b2c);
    };
};
var $9be1c75e3223ee2e$export$93b4506d26e3367 = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return dimap1($9be1c75e3223ee2e$var$wrap)($9be1c75e3223ee2e$var$unwrap);
    };
};
var $9be1c75e3223ee2e$export$d25bf6793fd4dfcb = function(dictProfunctor) {
    var dimap1 = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return function() {
        return function(v) {
            return dimap1($9be1c75e3223ee2e$var$unwrap)($9be1c75e3223ee2e$var$wrap);
        };
    };
};
var $9be1c75e3223ee2e$export$29d5d0b2414dfc5c = function(dictCategory) {
    var identity1 = $5be483788e0e6f04$export$f0954fd7d5368655(dictCategory);
    return function(dictProfunctor) {
        var rmap1 = $9be1c75e3223ee2e$export$6630987c9d273301(dictProfunctor);
        return function(f) {
            return rmap1(f)(identity1);
        };
    };
};



var $b5fb63758051b147$var$lcmap = /* #__PURE__ */ $9be1c75e3223ee2e$export$48f54268254cf7d0($9be1c75e3223ee2e$export$e10497e40cde5fd3);
var $b5fb63758051b147$export$c8d61c7aefcd2eb9 = function(x) {
    return x;
};
var $b5fb63758051b147$export$4b8724da343f8670 = function(dictExtend) {
    var composeCoKleisliFlipped = $c8f9cdd14046b503$export$fbe89af2ce156300(dictExtend);
    return {
        compose: function(v) {
            return function(v1) {
                return composeCoKleisliFlipped(v)(v1);
            };
        }
    };
};
var $b5fb63758051b147$export$7c2608c347081d34 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $65 = map(f);
                    return function($66) {
                        return g(v($65($66)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$1b28cf6e14cef765 = function(dictComonad) {
    var Functor0 = dictComonad.Extend0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var extract = $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(Functor0);
    return {
        first: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v(map($71f2e2e9476163f8$export$9e770fa6ce19a9d6)(x)), $71f2e2e9476163f8$export$6f71268a1666ab58(extract(x)));
            };
        },
        second: function(v) {
            return function(x) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9($71f2e2e9476163f8$export$9e770fa6ce19a9d6(extract(x)), v(map($71f2e2e9476163f8$export$6f71268a1666ab58)(x)));
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$95b15c3b108c70f1 = {
    Coercible0: function() {
        return undefined;
    }
};
var $b5fb63758051b147$export$538b19297a2c28a0 = function(f) {
    return function(v) {
        return $b5fb63758051b147$var$lcmap(f)(v);
    };
};
var $b5fb63758051b147$export$85082d7f68510c56 = {
    map: function(f) {
        return function(v) {
            return function($67) {
                return f(v($67));
            };
        };
    }
};
var $b5fb63758051b147$export$c2eec9047e1c22f6 = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($b5fb63758051b147$export$85082d7f68510c56)
};
var $b5fb63758051b147$export$6ca61216e8ebd2dc = {
    distribute: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            return function(a) {
                return map(function(v) {
                    return v(a);
                })(f);
            };
        };
    },
    collect: function(dictFunctor) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
        return function(f) {
            var $68 = $3ce830dde03d3389$export$f02a9ddbe4480f19($b5fb63758051b147$export$6ca61216e8ebd2dc)(dictFunctor);
            var $69 = map(f);
            return function($70) {
                return $68($69($70));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$45296f90ce78a5aa = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorCostar1 = $b5fb63758051b147$export$7c2608c347081d34(dictFunctor);
    return {
        closed: function(v) {
            return function(g) {
                return function(x) {
                    return v(map(function(v1) {
                        return v1(x);
                    })(g));
                };
            };
        },
        Profunctor0: function() {
            return profunctorCostar1;
        }
    };
};
var $b5fb63758051b147$export$1b18a904dcda2b6c = function(dictComonad) {
    var semigroupoidCostar1 = $b5fb63758051b147$export$4b8724da343f8670(dictComonad.Extend0());
    return {
        identity: $b3e944c79ac8b935$export$f9380c9a627682d3(dictComonad),
        Semigroupoid0: function() {
            return semigroupoidCostar1;
        }
    };
};
var $b5fb63758051b147$export$12684125bae58283 = function(dictContravariant) {
    var cmap = $d0c5be72120caeb7$export$b186cb408b99d7fc(dictContravariant);
    return {
        bimap: function(f) {
            return function(g) {
                return function(v) {
                    var $71 = cmap(f);
                    return function($72) {
                        return g(v($71($72)));
                    };
                };
            };
        }
    };
};
var $b5fb63758051b147$export$bee433edbc7aed34 = {
    apply: function(v) {
        return function(v1) {
            return function(a) {
                return v(a)(v1(a));
            };
        };
    },
    Functor0: function() {
        return $b5fb63758051b147$export$85082d7f68510c56;
    }
};
var $b5fb63758051b147$export$9af761d291db49ef = {
    bind: function(v) {
        return function(f) {
            return function(x) {
                var v1 = f(v(x));
                return v1(x);
            };
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$ddef3771953a3c3c = {
    pure: function(a) {
        return function(v) {
            return a;
        };
    },
    Apply0: function() {
        return $b5fb63758051b147$export$bee433edbc7aed34;
    }
};
var $b5fb63758051b147$export$88fc0f5d12a9e446 = {
    Applicative0: function() {
        return $b5fb63758051b147$export$ddef3771953a3c3c;
    },
    Bind1: function() {
        return $b5fb63758051b147$export$9af761d291db49ef;
    }
};



// Generated by purs version 0.15.16










var $6f71832c0f0d3a5b$export$1644ba17714857f1 = function(x) {
    return x;
};
var $6f71832c0f0d3a5b$export$5c32215407d0c561 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    return {
        compose: function(v) {
            return function(v1) {
                return function(x) {
                    return bind(v1(x))(v);
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$a1c7b121a12f67f7 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $127 = map(g);
                    return function($128) {
                        return $127(v(f($128)));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$1bd208d997e69566 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictFunctor);
    return {
        first: function(v) {
            return function(v1) {
                return map(function(v2) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v2, v1.value1);
                })(v(v1.value0));
            };
        },
        second: function(v) {
            return function(v1) {
                return map($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0))(v(v1.value1));
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$5646bceeba0ed2e7 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6f71832c0f0d3a5b$export$8ba4b27aef989a18 = function(dictInvariant) {
    var imap = $3d82dffba933b011$export$b2517b0ab3a58435(dictInvariant);
    return {
        imap: function(f) {
            return function(g) {
                return function(v) {
                    var $129 = imap(f)(g);
                    return function($130) {
                        return $129(v($130));
                    };
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$e7b43b239cd8e22a = function(f) {
    return function(v) {
        return function($131) {
            return f(v($131));
        };
    };
};
var $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63 = function(dictFunctor) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            return function(v) {
                var $132 = map(f);
                return function($133) {
                    return $132(v($133));
                };
            };
        }
    };
};
var $6f71832c0f0d3a5b$export$8e00b62431cd4eb7 = function(dictDistributive) {
    var collect = $3ce830dde03d3389$export$bb44f104e3c54dae(dictDistributive);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictDistributive.Functor0());
    return {
        distribute: function(dictFunctor) {
            var collect1 = collect(dictFunctor);
            return function(f) {
                return function(a) {
                    return collect1(function(v) {
                        return v(a);
                    })(f);
                };
            };
        },
        collect: function(dictFunctor) {
            var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(f) {
                var $134 = $3ce830dde03d3389$export$f02a9ddbe4480f19($6f71832c0f0d3a5b$export$8e00b62431cd4eb7(dictDistributive))(dictFunctor);
                var $135 = map(f);
                return function($136) {
                    return $134($135($136));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$ee38dceaf1b0a7c1 = function(dictDistributive) {
    var distribute = $3ce830dde03d3389$export$f02a9ddbe4480f19(dictDistributive)($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(dictDistributive.Functor0());
    return {
        closed: function(v) {
            return function(g) {
                return distribute(function($137) {
                    return v(g($137));
                });
            };
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$9b633f3f90080760 = function(dictApplicative) {
    var Functor0 = dictApplicative.Apply0().Functor0();
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var profunctorStar1 = $6f71832c0f0d3a5b$export$a1c7b121a12f67f7(Functor0);
    return {
        left: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                var $138 = map($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
                return function($139) {
                    return $138(v($139));
                };
            }())(function($140) {
                return pure($7d4cccdf062a2261$export$19db0165690c701a.create($140));
            });
        },
        right: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($141) {
                return pure($7d4cccdf062a2261$export$37c4d04eafdc5515.create($141));
            })(function() {
                var $142 = map($7d4cccdf062a2261$export$19db0165690c701a.create);
                return function($143) {
                    return $142(v($143));
                };
            }());
        },
        Profunctor0: function() {
            return profunctorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$2315b5444b191e9f = function(dictMonad) {
    var semigroupoidStar1 = $6f71832c0f0d3a5b$export$5c32215407d0c561(dictMonad.Bind1());
    return {
        identity: $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0()),
        Semigroupoid0: function() {
            return semigroupoidStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$3a827cf342dc199f = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictApply.Functor0());
    return {
        apply: function(v) {
            return function(v1) {
                return function(a) {
                    return apply(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a9fd453e55672cc4 = function(dictBind) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictBind);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictBind.Apply0());
    return {
        bind: function(v) {
            return function(f) {
                return function(x) {
                    return bind(v(x))(function(a) {
                        var v1 = f(a);
                        return v1(x);
                    });
                };
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7a1642fc72453036 = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictApplicative.Apply0());
    return {
        pure: function(a) {
            return function(v) {
                return pure(a);
            };
        },
        Apply0: function() {
            return applyStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$be30334ea1d81019 = function(dictMonad) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictMonad.Applicative0());
    var bindStar1 = $6f71832c0f0d3a5b$export$a9fd453e55672cc4(dictMonad.Bind1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Bind1: function() {
            return bindStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$35f44c8ce889b889 = function(dictAlt) {
    var alt = $75e93a4111e80214$export$228be17d80722ab(dictAlt);
    var functorStar1 = $6f71832c0f0d3a5b$export$a72d0b1c26a6fe63(dictAlt.Functor0());
    return {
        alt: function(v) {
            return function(v1) {
                return function(a) {
                    return alt(v(a))(v1(a));
                };
            };
        },
        Functor0: function() {
            return functorStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$a37a0eff981675fc = function(dictPlus) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictPlus);
    var altStar1 = $6f71832c0f0d3a5b$export$35f44c8ce889b889(dictPlus.Alt0());
    return {
        empty: function(v) {
            return empty;
        },
        Alt0: function() {
            return altStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$b508333aabf9ba3d = function(dictAlternative) {
    var applicativeStar1 = $6f71832c0f0d3a5b$export$7a1642fc72453036(dictAlternative.Applicative0());
    var plusStar1 = $6f71832c0f0d3a5b$export$a37a0eff981675fc(dictAlternative.Plus1());
    return {
        Applicative0: function() {
            return applicativeStar1;
        },
        Plus1: function() {
            return plusStar1;
        }
    };
};
var $6f71832c0f0d3a5b$export$7fe0d763dfe145d = function(dictMonadPlus) {
    var monadStar1 = $6f71832c0f0d3a5b$export$be30334ea1d81019(dictMonadPlus.Monad0());
    var alternativeStar1 = $6f71832c0f0d3a5b$export$b508333aabf9ba3d(dictMonadPlus.Alternative1());
    return {
        Monad0: function() {
            return monadStar1;
        },
        Alternative1: function() {
            return alternativeStar1;
        }
    };
};





var $86141680556a7436$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $86141680556a7436$export$e97768dcd3ffe6df = function(x) {
    return x;
};
var $86141680556a7436$export$3c7b24ce1c81e349 = function(dict) {
    return dict.sequential;
};
var $86141680556a7436$export$451942af9381149c = function(dict) {
    return dict.parallel;
};
var $86141680556a7436$export$ddc88912bc863338 = {
    Coercible0: function() {
        return undefined;
    }
};
var $86141680556a7436$export$76ad2e05fec13cc8 = function(dictMonoid) {
    var applyWriterT = $d9ef009191ddae40$export$2f46a8de9e2e0acc(dictMonoid.Semigroup0());
    return function(dictParallel) {
        var applyWriterT1 = applyWriterT(dictParallel.Apply0());
        var applyWriterT2 = applyWriterT(dictParallel.Apply1());
        return {
            parallel: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$451942af9381149c(dictParallel)),
            sequential: $d9ef009191ddae40$export$c950a71321ef1ffc($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
            Apply0: function() {
                return applyWriterT1;
            },
            Apply1: function() {
                return applyWriterT2;
            }
        };
    };
};
var $86141680556a7436$export$48c6c5bbf7c98dc9 = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyStar = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply0());
    var applyStar1 = $6f71832c0f0d3a5b$export$3a827cf342dc199f(dictParallel.Apply1());
    return {
        parallel: function(v) {
            return function($124) {
                return parallel1(v($124));
            };
        },
        sequential: function(v) {
            return function($125) {
                return sequential1(v($125));
            };
        },
        Apply0: function() {
            return applyStar;
        },
        Apply1: function() {
            return applyStar1;
        }
    };
};
var $86141680556a7436$export$cfbddc4e0911f419 = function(dictParallel) {
    var applyReaderT = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply0());
    var applyReaderT1 = $848780da1bf26d9d$export$fee188993a7996b7(dictParallel.Apply1());
    return {
        parallel: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$451942af9381149c(dictParallel)),
        sequential: $848780da1bf26d9d$export$1b8048a192a96779($86141680556a7436$export$3c7b24ce1c81e349(dictParallel)),
        Apply0: function() {
            return applyReaderT;
        },
        Apply1: function() {
            return applyReaderT1;
        }
    };
};
var $86141680556a7436$export$31d7210ae04b04da = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($06733ae99ed4f534$export$22d9917da16590e7);
    return function(dictMonad) {
        var applyMaybeT = $7038ccc2f7f5bbce$export$2fa55c29b4f8d86e(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyMaybeT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$29ed81e6361e826b = function(dictParallel) {
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var applyCompose = $6051f44ece6b7171$export$6b631277dc31d20d(dictParallel.Apply1())($7d4cccdf062a2261$export$d5df7cb019d08f04);
    return function(dictMonad) {
        var applyExceptT = $d2284b2d3e1b6f87$export$581feac922061bf0(dictMonad);
        return {
            parallel: function(v) {
                return parallel1(v);
            },
            sequential: function(v) {
                return sequential1(v);
            },
            Apply0: function() {
                return applyExceptT;
            },
            Apply1: function() {
                return applyCompose;
            }
        };
    };
};
var $86141680556a7436$export$36431f0cd2fca0df = function(dictParallel) {
    var sequential1 = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel1 = $86141680556a7436$export$451942af9381149c(dictParallel);
    return {
        parallel: function(v) {
            return function($126) {
                return v(sequential1($126));
            };
        },
        sequential: function(v) {
            return function($127) {
                return v(parallel1($127));
            };
        },
        Apply0: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        },
        Apply1: function() {
            return $b5fb63758051b147$export$bee433edbc7aed34;
        }
    };
};
var $86141680556a7436$export$aecfbd788a6caa47 = function(dictMonadEffect) {
    var applyContT = $fca560e14229da4e$export$6b05a2ec606a3559(dictMonadEffect.Monad0().Bind1().Apply0());
    return {
        parallel: $86141680556a7436$export$e97768dcd3ffe6df,
        sequential: function(v) {
            return v;
        },
        Apply0: function() {
            return applyContT;
        },
        Apply1: function() {
            return $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$bf3675a1b3711367 = function(dictMonadEffect) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88($fca560e14229da4e$export$232156ef715cfc9b(dictMonadEffect.Monad0().Bind1().Apply0().Functor0()));
    return {
        map: function(f) {
            var $128 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $129 = map(f);
            var $130 = $86141680556a7436$export$3c7b24ce1c81e349($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            return function($131) {
                return $128($129($130($131)));
            };
        }
    };
};
var $86141680556a7436$export$803a06b7a7e59726 = function(dictMonadEffect) {
    var Bind1 = dictMonadEffect.Monad0().Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    return {
        apply: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(ra) {
                        return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)))(function(rb) {
                            return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(rb)))(function(mb) {
                                    if (mb instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(a))(ra));
                                    if (mb instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(a(mb.value0));
                                    throw new Error("Failed pattern match at Control.Parallel.Class (line 83, column 7 - line 85, column 26): " + [
                                        mb.constructor.name
                                    ]);
                                });
                            }))(function() {
                                return $fca560e14229da4e$export$358211fab263c66b(v1)(function(b) {
                                    return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ra)))(function(ma) {
                                        if (ma instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return liftEffect($e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(rb));
                                        if (ma instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return k(ma.value0(b));
                                        throw new Error("Failed pattern match at Control.Parallel.Class (line 89, column 7 - line 91, column 26): " + [
                                            ma.constructor.name
                                        ]);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
        }
    };
};
var $86141680556a7436$export$5823fd8d45c99450 = function(dictMonadEffect) {
    var applyParCont1 = $86141680556a7436$export$803a06b7a7e59726(dictMonadEffect);
    return {
        pure: function() {
            var $132 = $86141680556a7436$export$451942af9381149c($86141680556a7436$export$aecfbd788a6caa47(dictMonadEffect));
            var $133 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fca560e14229da4e$export$d73f0595e894296c(dictMonadEffect.Monad0().Applicative0()));
            return function($134) {
                return $132($133($134));
            };
        }(),
        Apply0: function() {
            return applyParCont1;
        }
    };
};
var $86141680556a7436$export$e02ea57753bb8483 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    var discard1 = $86141680556a7436$var$discard(Bind1);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var functorParCont1 = $86141680556a7436$export$bf3675a1b3711367(dictMonadEffect);
    return {
        alt: function(v) {
            return function(v1) {
                return function(k) {
                    return bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(false)))(function(done) {
                        return discard1($fca560e14229da4e$export$358211fab263c66b(v)(function(a) {
                            return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                    return k(a);
                                });
                            });
                        }))(function() {
                            return $fca560e14229da4e$export$358211fab263c66b(v1)(function(a) {
                                return bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(done)))(function(b) {
                                    if (b) return pure($05149ea687d6b460$export$523c0b569236b342);
                                    return discard1(liftEffect($e521936ea118867a$export$68d8715fc104d294(true)(done)))(function() {
                                        return k(a);
                                    });
                                });
                            });
                        });
                    });
                };
            };
        },
        Functor0: function() {
            return functorParCont1;
        }
    };
};
var $86141680556a7436$export$eed929a02bcaa239 = function(dictMonadEffect) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadEffect.Monad0().Applicative0());
    var altParCont1 = $86141680556a7436$export$e02ea57753bb8483(dictMonadEffect);
    return {
        empty: function(v) {
            return pure($05149ea687d6b460$export$523c0b569236b342);
        },
        Alt0: function() {
            return altParCont1;
        }
    };
};
var $86141680556a7436$export$2e55be12f6c16793 = function(dictMonadEffect) {
    var applicativeParCont1 = $86141680556a7436$export$5823fd8d45c99450(dictMonadEffect);
    var plusParCont1 = $86141680556a7436$export$eed929a02bcaa239(dictMonadEffect);
    return {
        Applicative0: function() {
            return applicativeParCont1;
        },
        Plus1: function() {
            return plusParCont1;
        }
    };
};




var $355d9520a1199e68$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $355d9520a1199e68$export$3b8cfe43eb195e1d = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        var traverse_ = $4fe7b6acfba7f29f$export$33f63ccdb08d8723(dictApplicative);
        return function(dictFoldable) {
            var traverse_1 = traverse_(dictFoldable);
            return function(f) {
                var $51 = traverse_1(function($53) {
                    return parallel(f($53));
                });
                return function($52) {
                    return sequential($51($52));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$bb703a54931a70b6 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictApplicative) {
        return function(dictTraversable) {
            var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable)(dictApplicative);
            return function(f) {
                var $54 = traverse(function($56) {
                    return parallel(f($56));
                });
                return function($55) {
                    return sequential($54($55));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$a907a2b4fd85b16b = function(dictParallel) {
    var parTraverse_1 = $355d9520a1199e68$export$3b8cfe43eb195e1d(dictParallel);
    return function(dictApplicative) {
        var parTraverse_2 = parTraverse_1(dictApplicative);
        return function(dictFoldable) {
            return parTraverse_2(dictFoldable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$b9becc45c388432c = function(dictParallel) {
    var parTraverse1 = $355d9520a1199e68$export$bb703a54931a70b6(dictParallel);
    return function(dictApplicative) {
        var parTraverse2 = parTraverse1(dictApplicative);
        return function(dictTraversable) {
            return parTraverse2(dictTraversable)($355d9520a1199e68$var$identity);
        };
    };
};
var $355d9520a1199e68$export$a82aaa9906cdb569 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                return function(f) {
                    var $57 = oneOfMap(function($59) {
                        return parallel(f($59));
                    });
                    return function($58) {
                        return sequential($57($58));
                    };
                };
            };
        };
    };
};
var $355d9520a1199e68$export$70e1ad49970879b5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(dictAlternative) {
        var Plus1 = dictAlternative.Plus1();
        return function(dictFoldable) {
            var oneOfMap = $4fe7b6acfba7f29f$export$79f3cac53daaaae6(dictFoldable)(Plus1);
            return function(dictFunctor) {
                var $60 = oneOfMap(parallel);
                return function($61) {
                    return sequential($60($61));
                };
            };
        };
    };
};
var $355d9520a1199e68$export$3d88e33b68f7b8a5 = function(dictParallel) {
    var sequential = $86141680556a7436$export$3c7b24ce1c81e349(dictParallel);
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictParallel.Apply1());
    var parallel = $86141680556a7436$export$451942af9381149c(dictParallel);
    return function(mf) {
        return function(ma) {
            return sequential(apply(parallel(mf))(parallel(ma)));
        };
    };
};










// Generated by purs version 0.15.16






var $3c54b6e6d30cc3be$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $3c54b6e6d30cc3be$var$over = /* #__PURE__ */ $4fa4836228a192cc$export$fb4902fd9e525693()();
var $3c54b6e6d30cc3be$var$negate = /* #__PURE__ */ $d061555d3b2c84b2$export$aef51622e549b8b0($d061555d3b2c84b2$export$194f4464e73e7816);
var $3c54b6e6d30cc3be$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $3c54b6e6d30cc3be$export$f2a120b78af04023 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$760297a502ec68f7 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$e4eccef8f937a949 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$8c68c012e85c37f4 = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$d3134eff2123aadb = function(x) {
    return x;
};
var $3c54b6e6d30cc3be$export$9eabacebe6624782 = function(dict) {
    return dict.toDuration;
};
var $3c54b6e6d30cc3be$export$358ac052a84a2abd = {
    show: function(v) {
        return "(Seconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$f5f4de8badcbd545 = {
    show: function(v) {
        return "(Minutes " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$1d3b9b5391a72ae7 = {
    show: function(v) {
        return "(Milliseconds " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$c5d3ca6fc3468bcf = {
    show: function(v) {
        return "(Hours " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$de46f7d16350d367 = {
    show: function(v) {
        return "(Days " + ($3c54b6e6d30cc3be$var$show(v) + ")");
    }
};
var $3c54b6e6d30cc3be$export$bccfb43682e4a5e4 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$def67087bd72fdb7 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$5f6754e19ae8b602 = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$e8bb798e27d1673b = {
    append: function(v) {
        return function(v1) {
            return v + v1;
        };
    }
};
var $3c54b6e6d30cc3be$export$34e2a018de95f3d = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$d6d247637e7494c9 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$e0a5c04af6395341 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$4ccf8d6c1ebfa128 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$3ab38ab5accb6ec2 = $97937c29f879e68e$export$5ed021ff2336715c;
var $3c54b6e6d30cc3be$export$321d65ffd9e957ce = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$f5994f75b457cdcc = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$961a021281e4c248 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5ca80b70b64299ae = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$a5ba0a6cacc34910 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3c54b6e6d30cc3be$export$5b5983dc8ed41daa = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$bccfb43682e4a5e4;
    }
};
var $3c54b6e6d30cc3be$export$1857fd2af0af50be = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$d9bc7c6e66ddf272;
    }
};
var $3c54b6e6d30cc3be$export$70200b12758a7a61 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$def67087bd72fdb7;
    }
};
var $3c54b6e6d30cc3be$export$22829380fb9f2b93 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$5f6754e19ae8b602;
    }
};
var $3c54b6e6d30cc3be$export$9bd04d01a6c9ebc2 = {
    mempty: 0.0,
    Semigroup0: function() {
        return $3c54b6e6d30cc3be$export$e8bb798e27d1673b;
    }
};
var $3c54b6e6d30cc3be$export$1a0a2c8fdf902748 = function(dict) {
    return dict.fromDuration;
};
var $3c54b6e6d30cc3be$export$28743521ea1cb8f9 = function(dictDuration) {
    var $57 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    var $58 = $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)($3c54b6e6d30cc3be$var$negate);
    var $59 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function($60) {
        return $57($58($59($60)));
    };
};
var $3c54b6e6d30cc3be$export$980dbec50a957fc7 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$4771a2ee9f50caac = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$699cb56941ecf990 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$fd6d5f49667130a4 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$c66ee96f983a5e21 = $37b880af5f4991bd$export$e24978670be1e4f3;
var $3c54b6e6d30cc3be$export$1791f02d01a6ae8 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$f2a120b78af04023)(function(v) {
        return v * 1000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 1000.0;
    })
};
var $3c54b6e6d30cc3be$export$563c2be46809b74f = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$760297a502ec68f7)(function(v) {
        return v * 60000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 60000.0;
    })
};
var $3c54b6e6d30cc3be$export$44304cbc75c995e8 = {
    fromDuration: $3c54b6e6d30cc3be$var$identity,
    toDuration: $3c54b6e6d30cc3be$var$identity
};
var $3c54b6e6d30cc3be$export$117f08340b9f6c14 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$8c68c012e85c37f4)(function(v) {
        return v * 3600000.0;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 3600000.0;
    })
};
var $3c54b6e6d30cc3be$export$93ad8ffd4576e464 = {
    fromDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$d3134eff2123aadb)(function(v) {
        return v * 8.64e7;
    }),
    toDuration: /* #__PURE__ */ $3c54b6e6d30cc3be$var$over($3c54b6e6d30cc3be$export$e4eccef8f937a949)(function(v) {
        return v / 8.64e7;
    })
};
var $3c54b6e6d30cc3be$export$3082151037402ab5 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(dictDuration1) {
        var $61 = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration1);
        return function($62) {
            return $61(fromDuration1($62));
        };
    };
};






// Generated by purs version 0.15.16
const $c02f07bc0f38e9e9$export$c62839628b30a695 = function(f) {
    return f();
};






var $edf0339512807bee$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $edf0339512807bee$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $edf0339512807bee$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $edf0339512807bee$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $edf0339512807bee$var$Fiber = function(x) {
    return x;
};
var $edf0339512807bee$var$FFIUtil = function(x) {
    return x;
};
var $edf0339512807bee$export$22f79b48f44c15eb = function(x) {
    return x;
};
var $edf0339512807bee$export$4de6f17bc3dfa03 = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(false);
var $edf0339512807bee$export$608d3e3a27b14320 = {
    Coercible0: function() {
        return undefined;
    }
};
var $edf0339512807bee$export$d7f9012ed771d686 = {
    map: $b28443a27438717a$export$68695d37eb163711
};
var $edf0339512807bee$export$e8a7d9b8d7dc616a = {
    map: $b28443a27438717a$export$a0135aecf4a782ab
};
var $edf0339512807bee$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $edf0339512807bee$export$469c8a16c186651e = /* #__PURE__ */ $b28443a27438717a$export$f97e7884af471963(true);
var $edf0339512807bee$var$ffiUtil = /* #__PURE__ */ function() {
    var unsafeFromRight = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromRight: Left");
        throw new Error("Failed pattern match at Effect.Aff (line 412, column 21 - line 414, column 54): " + [
            v.constructor.name
        ]);
    };
    var unsafeFromLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $8bcde8f642a64c7d$export$51b220bae4359b72("unsafeFromLeft: Right");
        throw new Error("Failed pattern match at Effect.Aff (line 407, column 20 - line 409, column 55): " + [
            v.constructor.name
        ]);
    };
    var isLeft = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return true;
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return false;
        throw new Error("Failed pattern match at Effect.Aff (line 402, column 12 - line 404, column 21): " + [
            v.constructor.name
        ]);
    };
    return {
        isLeft: isLeft,
        fromLeft: unsafeFromLeft,
        fromRight: unsafeFromRight,
        left: $7d4cccdf062a2261$export$37c4d04eafdc5515.create,
        right: $7d4cccdf062a2261$export$19db0165690c701a.create
    };
}();
var $edf0339512807bee$var$makeFiber = function(aff) {
    return $b28443a27438717a$export$f24188c8fd3f1234($edf0339512807bee$var$ffiUtil, aff);
};
var $edf0339512807bee$export$30b347ca11a80af4 = function(aff) {
    return function __do() {
        var fiber = $edf0339512807bee$var$makeFiber(aff)();
        fiber.run();
        return fiber;
    };
};
var $edf0339512807bee$export$c8704a1045ed544d = function($75) {
    return $edf0339512807bee$var$$$void($edf0339512807bee$export$30b347ca11a80af4($75));
};
var $edf0339512807bee$export$d133944c527f2403 = $edf0339512807bee$var$makeFiber;
var $edf0339512807bee$export$1391212d75b2ee65 = function(v) {
    return $b28443a27438717a$export$389c1406f5ae6ae7($7d4cccdf062a2261$export$19db0165690c701a.create, v);
};
var $edf0339512807bee$export$df5598cc12b9c8c = function(acquire) {
    return function(completed) {
        return $b28443a27438717a$export$9ad792f02752f447(acquire)({
            killed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(completed)
        });
    };
};
var $edf0339512807bee$export$83901714774e2edc = {
    apply: $b28443a27438717a$export$bce00526579b3344,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$83901714774e2edc);
var $edf0339512807bee$export$fc7e409bd1eae683 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$b147a380fa8fdc0e = {
    Applicative0: function() {
        return $edf0339512807bee$export$9dc0454a98607988;
    },
    Bind1: function() {
        return $edf0339512807bee$export$f885f489dcf38a2d;
    }
};
var $edf0339512807bee$export$f885f489dcf38a2d = {
    bind: $b28443a27438717a$export$8fe95d71d8c6b6f3,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$export$9dc0454a98607988 = {
    pure: $b28443a27438717a$export$68c6660df485915b,
    Apply0: function() {
        return $edf0339512807bee$var$$lazy_applyAff(0);
    }
};
var $edf0339512807bee$var$$lazy_applyAff = /* #__PURE__ */ $edf0339512807bee$var$$runtime_lazy("applyAff", "Effect.Aff", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($edf0339512807bee$export$b147a380fa8fdc0e),
        Functor0: function() {
            return $edf0339512807bee$export$e8a7d9b8d7dc616a;
        }
    };
});
var $edf0339512807bee$export$114a07f1fb466c63 = /* #__PURE__ */ $edf0339512807bee$var$$lazy_applyAff(73);
var $edf0339512807bee$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $edf0339512807bee$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$var$lift21 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($edf0339512807bee$export$114a07f1fb466c63);
var $edf0339512807bee$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($edf0339512807bee$export$f885f489dcf38a2d);
var $edf0339512807bee$export$d0776e69f204de29 = function(aff) {
    return function(v) {
        return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))({
            killed: function(e) {
                return function(v1) {
                    return v(e);
                };
            },
            failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2),
            completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2)
        })($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(aff));
    };
};
var $edf0339512807bee$export$7f8bd3bb7f01e042 = function(fin) {
    return function(a) {
        return $edf0339512807bee$export$df5598cc12b9c8c($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(fin))($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a));
    };
};
var $edf0339512807bee$export$859f4dae848ac0ae = function(a) {
    return $edf0339512807bee$export$df5598cc12b9c8c(a)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342)))($edf0339512807bee$var$pure2);
};
var $edf0339512807bee$export$6c7682db87129472 = {
    defer: function(f) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342))(f);
    }
};
var $edf0339512807bee$export$cb4623454f96d5e0 = {
    parallel: $ac8b3532514ac019$export$401372c57776dc,
    sequential: $b28443a27438717a$export$139486a45824a247,
    Apply0: function() {
        return $edf0339512807bee$export$114a07f1fb466c63;
    },
    Apply1: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$parallel = /* #__PURE__ */ $86141680556a7436$export$451942af9381149c($edf0339512807bee$export$cb4623454f96d5e0);
var $edf0339512807bee$export$389e6cb252ce112f = {
    pure: function($76) {
        return $edf0339512807bee$var$parallel($edf0339512807bee$var$pure2($76));
    },
    Apply0: function() {
        return $edf0339512807bee$export$83901714774e2edc;
    }
};
var $edf0339512807bee$var$pure3 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$389e6cb252ce112f);
var $edf0339512807bee$var$parSequence_ = /* #__PURE__ */ $355d9520a1199e68$export$a907a2b4fd85b16b($edf0339512807bee$export$cb4623454f96d5e0)($edf0339512807bee$export$389e6cb252ce112f)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $edf0339512807bee$export$aa5306b4d3514fa0 = function(dictMonoid) {
    var semigroupParAff1 = $edf0339512807bee$export$fc7e409bd1eae683(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure3($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupParAff1;
        }
    };
};
var $edf0339512807bee$export$1cab8188db0c4c1f = {
    append: function(v) {
        return function(v1) {
            return function(err) {
                return $edf0339512807bee$var$parSequence_([
                    v(err),
                    v1(err)
                ]);
            };
        };
    }
};
var $edf0339512807bee$export$1dbf838572c25e01 = function(dictSemigroup) {
    return {
        append: $edf0339512807bee$var$lift21($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $edf0339512807bee$export$666a030cecdf96c = {
    liftEffect: $b28443a27438717a$export$3c6532f01a0290eb,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $edf0339512807bee$export$952106a975f35ae2 = function($77) {
    return $edf0339512807bee$export$22f79b48f44c15eb($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$liftEffect($77)));
};
var $edf0339512807bee$export$f3d782c2b95165ad = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(k) {
        return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.join(k));
    });
};
var $edf0339512807bee$export$29466a041ff3b3e0 = {
    map: function(f) {
        return function(t) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$map1(f)($edf0339512807bee$export$f3d782c2b95165ad(t))));
        };
    }
};
var $edf0339512807bee$export$4d705d914d07c7a7 = {
    apply: function(t1) {
        return function(t2) {
            return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$apply($edf0339512807bee$export$f3d782c2b95165ad(t1))($edf0339512807bee$export$f3d782c2b95165ad(t2))));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$29466a041ff3b3e0;
    }
};
var $edf0339512807bee$export$6db27cd2d1558d76 = {
    pure: function(a) {
        return $c02f07bc0f38e9e9$export$c62839628b30a695($edf0339512807bee$var$makeFiber($edf0339512807bee$var$pure2(a)));
    },
    Apply0: function() {
        return $edf0339512807bee$export$4d705d914d07c7a7;
    }
};
var $edf0339512807bee$export$c65b2010df1810d = function(e) {
    return function(v) {
        return $edf0339512807bee$var$bind1($edf0339512807bee$var$liftEffect(v.isSuspended))(function(suspended) {
            if (suspended) return $edf0339512807bee$var$liftEffect($edf0339512807bee$var$$$void(v.kill(e, $f57f4b701aa7b66e$export$5b38a098e5a9e7ca($edf0339512807bee$var$pure($05149ea687d6b460$export$523c0b569236b342)))));
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $edf0339512807bee$var$map($edf0339512807bee$export$952106a975f35ae2)(v.kill(e, k));
            });
        });
    };
};
var $edf0339512807bee$export$12fb9217a4d25158 = /* #__PURE__ */ function() {
    var $78 = $f57f4b701aa7b66e$export$8a83211c878a3f1f($edf0339512807bee$export$c65b2010df1810d);
    return function($79) {
        return $edf0339512807bee$export$22f79b48f44c15eb($78($79));
    };
}();
var $edf0339512807bee$export$54b8dc42dcff4ab1 = function(aff) {
    var killError = $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("[Aff] Child fiber outlived parent");
    var killAll = function(err) {
        return function(sup) {
            return $b28443a27438717a$export$49d5975414e0a979(function(k) {
                return $b28443a27438717a$export$a494cc11bfc0c750(err, sup.supervisor, k($edf0339512807bee$var$pure1($05149ea687d6b460$export$523c0b569236b342)));
            });
        };
    };
    var acquire = function __do() {
        var sup = $b28443a27438717a$export$7a3baea9562462c7($edf0339512807bee$var$ffiUtil, aff)();
        sup.fiber.run();
        return sup;
    };
    return $b28443a27438717a$export$9ad792f02752f447($edf0339512807bee$var$liftEffect(acquire))({
        killed: function(err) {
            return function(sup) {
                return $edf0339512807bee$var$parSequence_([
                    $edf0339512807bee$export$c65b2010df1810d(err)(sup.fiber),
                    killAll(err)(sup)
                ]);
            };
        },
        failed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError)),
        completed: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(killAll(killError))
    })(function($80) {
        return $edf0339512807bee$export$f3d782c2b95165ad(function(v) {
            return v.fiber;
        }($80));
    });
};
var $edf0339512807bee$export$d9b2f32f45e29810 = {
    liftST: /* #__PURE__ */ function() {
        var $81 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f($dd1bd2cc217b6a6d$export$d1b56b21630310a5);
        return function($82) {
            return $edf0339512807bee$var$liftEffect($81($82));
        };
    }(),
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$37a9b80154c7d256 = {
    throwError: $b28443a27438717a$export$520252a01094c36e,
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$9efce1646e93cba4 = {
    catchError: $b28443a27438717a$export$eb5e86cd5464556e,
    MonadThrow0: function() {
        return $edf0339512807bee$export$37a9b80154c7d256;
    }
};
var $edf0339512807bee$var$$$try = /* #__PURE__ */ $5dfefa023749ded0$export$410a452afcd48948($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$var$catchError = /* #__PURE__ */ $5dfefa023749ded0$export$3dede90624df3ba9($edf0339512807bee$export$9efce1646e93cba4);
var $edf0339512807bee$export$77f9e426014f6edd = $edf0339512807bee$var$$$try;
var $edf0339512807bee$export$60f50bfed4143f9d = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$30b347ca11a80af4($edf0339512807bee$var$bindFlipped(function($83) {
            return $edf0339512807bee$var$liftEffect(k($83));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$ef62257e6f8a5f8c = function(k) {
    return function(aff) {
        return $edf0339512807bee$var$$$void($edf0339512807bee$export$60f50bfed4143f9d(k)(aff));
    };
};
var $edf0339512807bee$export$52011fb9f1f7b7e2 = function(k) {
    return function(aff) {
        return $edf0339512807bee$export$d133944c527f2403($edf0339512807bee$var$bindFlipped(function($84) {
            return $edf0339512807bee$var$liftEffect(k($84));
        })($edf0339512807bee$var$$$try(aff)));
    };
};
var $edf0339512807bee$export$974f8db4a62dd716 = {
    tailRecM: function(k) {
        var go = function(a) {
            return $edf0339512807bee$var$bind1(k(a))(function(res) {
                if (res instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $edf0339512807bee$var$pure2(res.value0);
                if (res instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return go(res.value0);
                throw new Error("Failed pattern match at Effect.Aff (line 104, column 7 - line 106, column 23): " + [
                    res.constructor.name
                ]);
            });
        };
        return go;
    },
    Monad0: function() {
        return $edf0339512807bee$export$b147a380fa8fdc0e;
    }
};
var $edf0339512807bee$export$b59d1737970253ab = function(dictMonoid) {
    var semigroupAff1 = $edf0339512807bee$export$1dbf838572c25e01(dictMonoid.Semigroup0());
    return {
        mempty: $edf0339512807bee$var$pure2($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupAff1;
        }
    };
};
var $edf0339512807bee$export$8deb6e154ce67af6 = /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $edf0339512807bee$var$pure2($05149ea687d6b460$export$523c0b569236b342));
var $edf0339512807bee$export$800a937b75981c0e = {
    mempty: $edf0339512807bee$export$8deb6e154ce67af6,
    Semigroup0: function() {
        return $edf0339512807bee$export$1cab8188db0c4c1f;
    }
};
var $edf0339512807bee$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($edf0339512807bee$export$800a937b75981c0e);
var $edf0339512807bee$export$b3e22bcfd64c1022 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(v) {
    return $edf0339512807bee$var$pure($edf0339512807bee$var$mempty);
});
var $edf0339512807bee$export$a19cb95a0294477 = /* #__PURE__ */ function() {
    var $85 = $edf0339512807bee$var$map1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($05149ea687d6b460$export$523c0b569236b342));
    return function($86) {
        return $85($edf0339512807bee$export$77f9e426014f6edd($86));
    };
}();
var $edf0339512807bee$export$371c34bc9954b4c6 = {
    alt: $b28443a27438717a$export$6a44b66c7edadaa,
    Functor0: function() {
        return $edf0339512807bee$export$d7f9012ed771d686;
    }
};
var $edf0339512807bee$export$75f84a0612e9fcac = {
    alt: function(a1) {
        return function(a2) {
            return $edf0339512807bee$var$catchError(a1)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(a2));
        };
    },
    Functor0: function() {
        return $edf0339512807bee$export$e8a7d9b8d7dc616a;
    }
};
var $edf0339512807bee$export$982abcb51ccf01ce = {
    empty: /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256)(/* #__PURE__ */ $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Always fails")),
    Alt0: function() {
        return $edf0339512807bee$export$75f84a0612e9fcac;
    }
};
var $edf0339512807bee$export$a77596dfa1aa0c51 = {
    empty: /* #__PURE__ */ $edf0339512807bee$var$parallel(/* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($edf0339512807bee$export$982abcb51ccf01ce)),
    Alt0: function() {
        return $edf0339512807bee$export$371c34bc9954b4c6;
    }
};
var $edf0339512807bee$export$96ad65bdc35fd68a = {
    Applicative0: function() {
        return $edf0339512807bee$export$389e6cb252ce112f;
    },
    Plus1: function() {
        return $edf0339512807bee$export$a77596dfa1aa0c51;
    }
};


// Generated by purs version 0.15.16
"use strict";
let $fecd5c800d519006$var$sentryClient = null;

const $fecd5c800d519006$var$loadSentry = async ()=>{
    if ($fecd5c800d519006$var$sentryClient) return $fecd5c800d519006$var$sentryClient;
    const mod = await (parcelRequire("ipi6j"));
    $fecd5c800d519006$var$sentryClient = mod;
    return mod;
};
const $fecd5c800d519006$export$d3626b236bde6194 = function(json) {
    return JSON.stringify(json, null, 2);
};
const $fecd5c800d519006$export$13633b34445fbb34 = true;
const $fecd5c800d519006$export$f5ae3c4820871661 = function() {
    console.log('Sentry:' + $fecd5c800d519006$export$13633b34445fbb34);
    if ($fecd5c800d519006$export$13633b34445fbb34) $fecd5c800d519006$var$loadSentry().then((Sentry)=>{
        Sentry.init({
            dsn: "https://29d527cea23f4f62831bdac210edb22b@sentry.hourrepublic.com/3",
            environment: "production"
        });
        console.log('Initialized Sentry');
    }).catch((err)=>{
        console.error("Failed to initialize Sentry", err);
    });
};
const $fecd5c800d519006$export$3e205fbb5df021e0 = function(err) {
    return function() {
        var errId = "";
        console.log('Error: ' + err.toString());
        if ($fecd5c800d519006$export$13633b34445fbb34) {
            if ($fecd5c800d519006$var$sentryClient && typeof $fecd5c800d519006$var$sentryClient.captureMessage === "function") {
                errId = $fecd5c800d519006$var$sentryClient.captureMessage(err.message, {
                    contexts: err.contexts
                });
                console.log('Reported to Sentry');
            } else console.warn("Sentry is enabled but not initialized");
        }
        return errId;
    };
};
const $fecd5c800d519006$export$da22d4a5076a7905 = function() {
    console.log("Reloading");
    window.location.reload();
};


// Generated by purs version 0.15.16
function $1f4ad780c651f89e$export$9d38b81df1e4ff(platformSpecificDriver, timeoutErrorMessageIdent, requestFailedMessageIdent, mkHeader, options) {
    return function(errback, callback) {
        var xhr = platformSpecificDriver.newXHR();
        var fixedUrl = platformSpecificDriver.fixupUrl(options.url, xhr);
        xhr.open(options.method || "GET", fixedUrl, true, options.username, options.password);
        if (options.headers) try {
            // eslint-disable-next-line no-eq-null,eqeqeq
            for(var i = 0, header; (header = options.headers[i]) != null; i++)xhr.setRequestHeader(header.field, header.value);
        } catch (e) {
            errback(e);
        }
        var onerror = function(msgIdent) {
            return function() {
                errback(new Error(msgIdent));
            };
        };
        xhr.onerror = onerror(requestFailedMessageIdent);
        xhr.ontimeout = onerror(timeoutErrorMessageIdent);
        xhr.onload = function() {
            callback({
                status: xhr.status,
                statusText: xhr.statusText,
                headers: xhr.getAllResponseHeaders().split("\r\n").filter(function(header) {
                    return header.length > 0;
                }).map(function(header) {
                    var i = header.indexOf(":");
                    return mkHeader(header.substring(0, i))(header.substring(i + 2));
                }),
                body: xhr.response
            });
        };
        xhr.responseType = options.responseType;
        xhr.withCredentials = options.withCredentials;
        xhr.timeout = options.timeout;
        xhr.send(options.content);
        return function(error, cancelErrback, cancelCallback) {
            try {
                xhr.abort();
            } catch (e) {
                return cancelErrback(e);
            }
            return cancelCallback();
        };
    };
}


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16
var $aa56e5edbb68560e$export$530ca42686ee50e7 = "text/xml";
var $aa56e5edbb68560e$export$2f41145206b9f9f7 = "text/plain";
var $aa56e5edbb68560e$export$c3083f63e1ea2b38 = "text/html";
var $aa56e5edbb68560e$export$8dc8d9feea5d979c = "text/csv";
var $aa56e5edbb68560e$export$24b70d93726c4adb = "text/css";
var $aa56e5edbb68560e$export$fafce06ba36b9255 = "multipart/form-data";
var $aa56e5edbb68560e$export$21bcf3835c99f43b = "image/png";
var $aa56e5edbb68560e$export$a62c8cedf817011c = "image/jpeg";
var $aa56e5edbb68560e$export$e9344de2d32713db = "image/gif";
var $aa56e5edbb68560e$export$631c3fb8a394143b = "application/xml";
var $aa56e5edbb68560e$export$4e485c779e35576d = "application/octet-stream";
var $aa56e5edbb68560e$export$25ba185f98df4cf3 = "application/javascript";
var $aa56e5edbb68560e$export$2316f0d99a99ce39 = "application/json";
var $aa56e5edbb68560e$export$af360fa1725483a8 = "application/x-www-form-urlencoded";


var $1bb5df538ea16bd9$export$2369e6c56c47a5bd = /* #__PURE__ */ function() {
    function ArrayView(value0) {
        this.value0 = value0;
    }
    ArrayView.create = function(value0) {
        return new ArrayView(value0);
    };
    return ArrayView;
}();
var $1bb5df538ea16bd9$export$3b660928c86ff55c = /* #__PURE__ */ function() {
    function Blob(value0) {
        this.value0 = value0;
    }
    Blob.create = function(value0) {
        return new Blob(value0);
    };
    return Blob;
}();
var $1bb5df538ea16bd9$export$b34a105447964f9f = /* #__PURE__ */ function() {
    function Document(value0) {
        this.value0 = value0;
    }
    Document.create = function(value0) {
        return new Document(value0);
    };
    return Document;
}();
var $1bb5df538ea16bd9$export$89b8e0fa65f6a914 = /* #__PURE__ */ function() {
    function $$String(value0) {
        this.value0 = value0;
    }
    $$String.create = function(value0) {
        return new $$String(value0);
    };
    return $$String;
}();
var $1bb5df538ea16bd9$export$3963aa24c930693c = /* #__PURE__ */ function() {
    function FormData(value0) {
        this.value0 = value0;
    }
    FormData.create = function(value0) {
        return new FormData(value0);
    };
    return FormData;
}();
var $1bb5df538ea16bd9$export$bcdd6637213a40ec = /* #__PURE__ */ function() {
    function FormURLEncoded(value0) {
        this.value0 = value0;
    }
    FormURLEncoded.create = function(value0) {
        return new FormURLEncoded(value0);
    };
    return FormURLEncoded;
}();
var $1bb5df538ea16bd9$export$48880ac635f47186 = /* #__PURE__ */ function() {
    function Json(value0) {
        this.value0 = value0;
    }
    Json.create = function(value0) {
        return new Json(value0);
    };
    return Json;
}();
var $1bb5df538ea16bd9$export$64f69cdd5524ddeb = function(v) {
    if (v instanceof $1bb5df538ea16bd9$export$bcdd6637213a40ec) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$af360fa1725483a8);
    if (v instanceof $1bb5df538ea16bd9$export$48880ac635f47186) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$2316f0d99a99ce39);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $1bb5df538ea16bd9$export$22b082955e083ec3 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$89b8e0fa65f6a914.create;
}();
var $1bb5df538ea16bd9$export$7b419323e6ed4f31 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$48880ac635f47186.create;
}();
var $1bb5df538ea16bd9$export$6461fd54a649b18e = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$bcdd6637213a40ec.create;
}();
var $1bb5df538ea16bd9$export$c3f886ccd454773d = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$3963aa24c930693c.create;
}();
var $1bb5df538ea16bd9$export$5a7bfc01df82fcd1 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$b34a105447964f9f.create;
}();
var $1bb5df538ea16bd9$export$8cf3c1c9f525ba2 = /* #__PURE__ */ function() {
    return $1bb5df538ea16bd9$export$3b660928c86ff55c.create;
}();
var $1bb5df538ea16bd9$export$ba40bc0510bff334 = function(av) {
    return new $1bb5df538ea16bd9$export$2369e6c56c47a5bd(function(f) {
        return f(av);
    });
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16


var $25a73b5eff39e983$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $25a73b5eff39e983$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $25a73b5eff39e983$export$483c11740a902fcd = function(x) {
    return x;
};
var $25a73b5eff39e983$export$74c0afb45691d798 = {
    show: function(v) {
        return "(MediaType " + ($25a73b5eff39e983$var$show(v) + ")");
    }
};
var $25a73b5eff39e983$export$37246347bfd87552 = {
    Coercible0: function() {
        return undefined;
    }
};
var $25a73b5eff39e983$export$2fed9e13b0c7effc = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $25a73b5eff39e983$export$11071179e210ac75 = {
    compare: function(x) {
        return function(y) {
            return $25a73b5eff39e983$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $25a73b5eff39e983$export$2fed9e13b0c7effc;
    }
};






var $04f1e5e12069f6d8$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $04f1e5e12069f6d8$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($25a73b5eff39e983$export$74c0afb45691d798);
var $04f1e5e12069f6d8$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $04f1e5e12069f6d8$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($25a73b5eff39e983$export$2fed9e13b0c7effc);
var $04f1e5e12069f6d8$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($25a73b5eff39e983$export$11071179e210ac75);
var $04f1e5e12069f6d8$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $04f1e5e12069f6d8$export$5e41db7437457e4f = /* #__PURE__ */ function() {
    function Accept(value0) {
        this.value0 = value0;
    }
    Accept.create = function(value0) {
        return new Accept(value0);
    };
    return Accept;
}();
var $04f1e5e12069f6d8$export$e2e108cbe2e4f865 = /* #__PURE__ */ function() {
    function ContentType(value0) {
        this.value0 = value0;
    }
    ContentType.create = function(value0) {
        return new ContentType(value0);
    };
    return ContentType;
}();
var $04f1e5e12069f6d8$export$21640746b57e4864 = /* #__PURE__ */ function() {
    function RequestHeader(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RequestHeader.create = function(value0) {
        return function(value1) {
            return new RequestHeader(value0, value1);
        };
    };
    return RequestHeader;
}();
var $04f1e5e12069f6d8$export$2ab9a8f9f1186f14 = function(v) {
    if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$unwrap(v.value0);
    if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$unwrap(v.value0);
    if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return v.value1;
    throw new Error("Failed pattern match at Affjax.RequestHeader (line 26, column 1 - line 26, column 33): " + [
        v.constructor.name
    ]);
};
var $04f1e5e12069f6d8$export$1d707710be2d5ee3 = {
    show: function(v) {
        if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return "(Accept " + ($04f1e5e12069f6d8$var$show(v.value0) + ")");
        if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return "(ContentType " + ($04f1e5e12069f6d8$var$show(v.value0) + ")");
        if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return "(RequestHeader " + ($04f1e5e12069f6d8$var$show1(v.value0) + (" " + ($04f1e5e12069f6d8$var$show1(v.value1) + ")")));
        throw new Error("Failed pattern match at Affjax.RequestHeader (line 16, column 1 - line 19, column 81): " + [
            v.constructor.name
        ]);
    }
};
var $04f1e5e12069f6d8$export$a8ff84c12d48cfa6 = function(v) {
    if (v instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return "Accept";
    if (v instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return "Content-Type";
    if (v instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return v.value0;
    throw new Error("Failed pattern match at Affjax.RequestHeader (line 21, column 1 - line 21, column 32): " + [
        v.constructor.name
    ]);
};
var $04f1e5e12069f6d8$export$b220e5ff0b5d2c8d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f && y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$eq(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865 && y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$eq(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$21640746b57e4864 && y instanceof $04f1e5e12069f6d8$export$21640746b57e4864) return x.value0 === y.value0 && x.value1 === y.value1;
            return false;
        };
    }
};
var $04f1e5e12069f6d8$export$eec6d50b1349dc5b = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f && y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $04f1e5e12069f6d8$var$compare(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $04f1e5e12069f6d8$export$5e41db7437457e4f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865 && y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $04f1e5e12069f6d8$var$compare(x.value0)(y.value0);
            if (x instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $04f1e5e12069f6d8$export$e2e108cbe2e4f865) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $04f1e5e12069f6d8$export$21640746b57e4864 && y instanceof $04f1e5e12069f6d8$export$21640746b57e4864) {
                var v = $04f1e5e12069f6d8$var$compare1(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $04f1e5e12069f6d8$var$compare1(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Affjax.RequestHeader (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $04f1e5e12069f6d8$export$b220e5ff0b5d2c8d;
    }
};


// Generated by purs version 0.15.16



var $c02e13aaef170b91$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $c02e13aaef170b91$export$5d43b79a1f53c8d0 = /* #__PURE__ */ function() {
    function $$ArrayBuffer(value0) {
        this.value0 = value0;
    }
    $$ArrayBuffer.create = function(value0) {
        return new $$ArrayBuffer(value0);
    };
    return $$ArrayBuffer;
}();
var $c02e13aaef170b91$export$3b660928c86ff55c = /* #__PURE__ */ function() {
    function Blob(value0) {
        this.value0 = value0;
    }
    Blob.create = function(value0) {
        return new Blob(value0);
    };
    return Blob;
}();
var $c02e13aaef170b91$export$b34a105447964f9f = /* #__PURE__ */ function() {
    function Document(value0) {
        this.value0 = value0;
    }
    Document.create = function(value0) {
        return new Document(value0);
    };
    return Document;
}();
var $c02e13aaef170b91$export$48880ac635f47186 = /* #__PURE__ */ function() {
    function Json(value0) {
        this.value0 = value0;
    }
    Json.create = function(value0) {
        return new Json(value0);
    };
    return Json;
}();
var $c02e13aaef170b91$export$89b8e0fa65f6a914 = /* #__PURE__ */ function() {
    function $$String(value0) {
        this.value0 = value0;
    }
    $$String.create = function(value0) {
        return new $$String(value0);
    };
    return $$String;
}();
var $c02e13aaef170b91$export$e92c65af050aed9a = /* #__PURE__ */ function() {
    function Ignore(value0) {
        this.value0 = value0;
    }
    Ignore.create = function(value0) {
        return new Ignore(value0);
    };
    return Ignore;
}();
var $c02e13aaef170b91$export$17004af5aa52bce6 = function(v) {
    if (v instanceof $c02e13aaef170b91$export$5d43b79a1f53c8d0) return "arraybuffer";
    if (v instanceof $c02e13aaef170b91$export$3b660928c86ff55c) return "blob";
    if (v instanceof $c02e13aaef170b91$export$b34a105447964f9f) return "document";
    if (v instanceof $c02e13aaef170b91$export$48880ac635f47186) return "text";
    if (v instanceof $c02e13aaef170b91$export$89b8e0fa65f6a914) return "text";
    if (v instanceof $c02e13aaef170b91$export$e92c65af050aed9a) return "";
    throw new Error("Failed pattern match at Affjax.ResponseFormat (line 44, column 3 - line 50, column 19): " + [
        v.constructor.name
    ]);
};
var $c02e13aaef170b91$export$64f69cdd5524ddeb = function(v) {
    if (v instanceof $c02e13aaef170b91$export$48880ac635f47186) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa56e5edbb68560e$export$2316f0d99a99ce39);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c02e13aaef170b91$export$22b082955e083ec3 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$89b8e0fa65f6a914($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$7b419323e6ed4f31 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$48880ac635f47186($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$738b109e247a462c = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$e92c65af050aed9a($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$5a7bfc01df82fcd1 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$b34a105447964f9f($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$8cf3c1c9f525ba2 = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$3b660928c86ff55c($c02e13aaef170b91$var$identity);
}();
var $c02e13aaef170b91$export$f57200da856d736b = /* #__PURE__ */ function() {
    return new $c02e13aaef170b91$export$5d43b79a1f53c8d0($c02e13aaef170b91$var$identity);
}();


// Generated by purs version 0.15.16



var $d5f2bbf513cce8c9$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $d5f2bbf513cce8c9$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $d5f2bbf513cce8c9$export$42f186449ccf2a6a = /* #__PURE__ */ function() {
    function ResponseHeader(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ResponseHeader.create = function(value0) {
        return function(value1) {
            return new ResponseHeader(value0, value1);
        };
    };
    return ResponseHeader;
}();
var $d5f2bbf513cce8c9$export$2ab9a8f9f1186f14 = function(v) {
    return v.value1;
};
var $d5f2bbf513cce8c9$export$930aa88cd8251f2f = {
    show: function(v) {
        return "(ResponseHeader " + ($d5f2bbf513cce8c9$var$show(v.value0) + (" " + ($d5f2bbf513cce8c9$var$show(v.value1) + ")")));
    }
};
var $d5f2bbf513cce8c9$export$a8ff84c12d48cfa6 = function(v) {
    return v.value0;
};
var $d5f2bbf513cce8c9$export$5846351b1960bc7e = {
    eq: function(x) {
        return function(y) {
            return x.value0 === y.value0 && x.value1 === y.value1;
        };
    }
};
var $d5f2bbf513cce8c9$export$130cbaa46b01e3bf = {
    compare: function(x) {
        return function(y) {
            var v = $d5f2bbf513cce8c9$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $d5f2bbf513cce8c9$var$compare(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $d5f2bbf513cce8c9$export$5846351b1960bc7e;
    }
};






// Generated by purs version 0.15.16




var $f9f243b94d1fc188$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $f9f243b94d1fc188$export$64f3cd24d850d401 = /* #__PURE__ */ $d2284b2d3e1b6f87$export$998a9a780731dd5b($50c50d1f444e5fa4$export$dc85e8383eafbd81);
var $f9f243b94d1fc188$export$a25b8a8a37f2d1cd = function($3) {
    return $f9f243b94d1fc188$var$unwrap($d2284b2d3e1b6f87$export$8291c2122093ac93($3));
};
var $f9f243b94d1fc188$export$8e638b2c22277c65 = function(f) {
    return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(function($4) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($f9f243b94d1fc188$var$unwrap($4)));
    });
};




// Generated by purs version 0.15.16
function $e2dfac74220fdf7a$export$4d9ac7ad03be5d48(fail, succ, s) {
    try {
        return succ(JSON.parse(s));
    } catch (e) {
        return fail(e.message);
    }
}



var $44e5fdc48745e77c$export$f3a8d475da9d5fc3 = function(j) {
    return $e2dfac74220fdf7a$export$4d9ac7ad03be5d48($7d4cccdf062a2261$export$37c4d04eafdc5515.create, $7d4cccdf062a2261$export$19db0165690c701a.create, j);
};






// Generated by purs version 0.15.16












// Generated by purs version 0.15.16
// A helper which transforms the result of encodeURIComponent to be compliant
// with RFC3986, as described in the MDN documentation here:
//
// https://web.archive.org/web/20201206001047/https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
function $554797afd3ad4541$var$encodeURIComponent_to_RFC3986(input) {
    return input.replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}
// A helper which transforms the result of encodeURI to be compliant
// with RFC3986, as described in the MDN documentation here:
//
// https://web.archive.org/web/20210117175449/https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURI#encoding_for_ipv6
function $554797afd3ad4541$var$encodeURI_to_RFC3986(input) {
    return input.replace(/%5B/g, "[").replace(/%5D/g, "]");
}
function $554797afd3ad4541$export$5aceb7cfc152c7a0(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURIComponent_to_RFC3986(encodeURIComponent(input)));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$737f67b1f296a4c1(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURIComponent_to_RFC3986(encodeURIComponent(input)).replace(/%20/g, "+"));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$5befbc415e45c4d5(fail, succeed, input) {
    try {
        return succeed(decodeURIComponent(input));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$c2133655cc0dfcac(fail, succeed, input) {
    return $554797afd3ad4541$export$5befbc415e45c4d5(fail, succeed, input.replace(/\+/g, " "));
}
function $554797afd3ad4541$export$15690d419f50b5b6(fail, succeed, input) {
    try {
        return succeed($554797afd3ad4541$var$encodeURI_to_RFC3986(encodeURI(input)));
    } catch (err) {
        return fail(err);
    }
}
function $554797afd3ad4541$export$18efed955e3526a8(fail, succeed, input) {
    try {
        return succeed(decodeURI(input));
    } catch (err) {
        return fail(err);
    }
}





var $f9a555fb76059872$export$ab54ccbe87d5558 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$5aceb7cfc152c7a0)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$90c31d5baa78df44 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$15690d419f50b5b6)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$33ec49fcdd8b3995 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$737f67b1f296a4c1)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$8824b4be61b7d619 = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$5befbc415e45c4d5)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$e57f0a7b2f7731fd = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$18efed955e3526a8)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $f9a555fb76059872$export$4704bdfecb34953a = /* #__PURE__ */ function() {
    return $8f2697950ee155e1$export$dd8987cb9f63b77e($554797afd3ad4541$export$c2133655cc0dfcac)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($06733ae99ed4f534$export$bebe9059409a0d04.value))($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();


var $d7072b1f1f4574d6$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $71f2e2e9476163f8$export$c29279d1dfdefb95($2c6b3d51d10471a7$export$e4b6cd05df3043f6)(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6))));
var $d7072b1f1f4574d6$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $d7072b1f1f4574d6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d7072b1f1f4574d6$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($06733ae99ed4f534$export$b203ef4465f15037);
var $d7072b1f1f4574d6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $d7072b1f1f4574d6$export$bcdd6637213a40ec = function(x) {
    return x;
};
var $d7072b1f1f4574d6$export$45b10814cc054894 = function(v) {
    return v;
};
var $d7072b1f1f4574d6$export$2632a4b24e64e691 = {
    show: function(v) {
        return "(FormURLEncoded " + ($d7072b1f1f4574d6$var$show(v) + ")");
    }
};
var $d7072b1f1f4574d6$export$98b361b5782a88c3 = $d7bf9817a417d4ae$export$d082f07d0a8e9909;
var $d7072b1f1f4574d6$export$c82dd5dde548866e = /* #__PURE__ */ $97937c29f879e68e$export$6ace7ea8ac01a75e(/* #__PURE__ */ $71f2e2e9476163f8$export$8f11eb03746a66e2($97937c29f879e68e$export$c5f2758e49b2b86a)(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($97937c29f879e68e$export$c5f2758e49b2b86a)));
var $d7072b1f1f4574d6$export$c7e663b2f165d3c8 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d7072b1f1f4574d6$export$9af01926b7d3c975 = $784e1bd3d26d71da$export$db307f59121ffcc4;
var $d7072b1f1f4574d6$export$571d59b505e6bb4e = $d7072b1f1f4574d6$export$bcdd6637213a40ec;
var $d7072b1f1f4574d6$export$8273fbac6769ef04 = /* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00(/* #__PURE__ */ $71f2e2e9476163f8$export$d625e8a97ba36bd6($37b880af5f4991bd$export$fa624555ca2acbc8)(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $d7072b1f1f4574d6$export$c564cdbbe6da493 = /* #__PURE__ */ function() {
    var encodePart = function(v) {
        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f9a555fb76059872$export$33ec49fcdd8b3995(v.value0);
        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map(function(key) {
            return function(val) {
                return key + ("=" + val);
            };
        })($f9a555fb76059872$export$33ec49fcdd8b3995(v.value0)))($f9a555fb76059872$export$33ec49fcdd8b3995(v.value1.value0));
        throw new Error("Failed pattern match at Data.FormURLEncoded (line 37, column 16 - line 39, column 114): " + [
            v.constructor.name
        ]);
    };
    var $37 = $d7072b1f1f4574d6$var$map($5b07e36f812dd04b$export$ec1dc8fbeea3467e("&"));
    var $38 = $d7072b1f1f4574d6$var$traverse(encodePart);
    return function($39) {
        return $37($38($d7072b1f1f4574d6$export$45b10814cc054894($39)));
    };
}();
var $d7072b1f1f4574d6$export$2f872c0f2117be69 = /* #__PURE__ */ function() {
    var decodePart = function() {
        var $40 = $5b07e36f812dd04b$export$65980d18b75784e2("=");
        return function($41) {
            return function(v) {
                if (v.length === 2) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map(function(key) {
                    return function(val) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(key, new $06733ae99ed4f534$export$8a67b48435b5d073(val));
                    };
                })($f9a555fb76059872$export$4704bdfecb34953a(v[0])))($f9a555fb76059872$export$4704bdfecb34953a(v[1]));
                if (v.length === 1) return $d7072b1f1f4574d6$var$apply($d7072b1f1f4574d6$var$map($71f2e2e9476163f8$export$1908877435b1d5e9.create)($f9a555fb76059872$export$4704bdfecb34953a(v[0])))($d7072b1f1f4574d6$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value));
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }($40($41));
        };
    }();
    var $42 = $d7072b1f1f4574d6$var$map($d7072b1f1f4574d6$export$bcdd6637213a40ec);
    var $43 = $d7072b1f1f4574d6$var$traverse(decodePart);
    var $44 = $5b07e36f812dd04b$export$65980d18b75784e2("&");
    return function($45) {
        return $42($43($44($45)));
    };
}();




// Generated by purs version 0.15.16





var $0279ce8fdb6b506c$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $0279ce8fdb6b506c$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $0279ce8fdb6b506c$export$8eb3892b442747bd = /* #__PURE__ */ function() {
    function OPTIONS() {}
    OPTIONS.value = new OPTIONS();
    return OPTIONS;
}();
var $0279ce8fdb6b506c$export$1bb358554aac31c1 = /* #__PURE__ */ function() {
    function GET() {}
    GET.value = new GET();
    return GET;
}();
var $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa = /* #__PURE__ */ function() {
    function HEAD() {}
    HEAD.value = new HEAD();
    return HEAD;
}();
var $0279ce8fdb6b506c$export$484f3009c2ee32ad = /* #__PURE__ */ function() {
    function POST() {}
    POST.value = new POST();
    return POST;
}();
var $0279ce8fdb6b506c$export$5508c7b57250ebc6 = /* #__PURE__ */ function() {
    function PUT() {}
    PUT.value = new PUT();
    return PUT;
}();
var $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 = /* #__PURE__ */ function() {
    function DELETE() {}
    DELETE.value = new DELETE();
    return DELETE;
}();
var $0279ce8fdb6b506c$export$8754b71dc67cd5d0 = /* #__PURE__ */ function() {
    function TRACE() {}
    TRACE.value = new TRACE();
    return TRACE;
}();
var $0279ce8fdb6b506c$export$df50b52b1548c0dc = /* #__PURE__ */ function() {
    function CONNECT() {}
    CONNECT.value = new CONNECT();
    return CONNECT;
}();
var $0279ce8fdb6b506c$export$673494e2608125f7 = /* #__PURE__ */ function() {
    function PROPFIND() {}
    PROPFIND.value = new PROPFIND();
    return PROPFIND;
}();
var $0279ce8fdb6b506c$export$d16982ce725f2efb = /* #__PURE__ */ function() {
    function PROPPATCH() {}
    PROPPATCH.value = new PROPPATCH();
    return PROPPATCH;
}();
var $0279ce8fdb6b506c$export$36dd893c77c0f7d8 = /* #__PURE__ */ function() {
    function MKCOL() {}
    MKCOL.value = new MKCOL();
    return MKCOL;
}();
var $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 = /* #__PURE__ */ function() {
    function COPY() {}
    COPY.value = new COPY();
    return COPY;
}();
var $0279ce8fdb6b506c$export$346f08c1f0d0fe41 = /* #__PURE__ */ function() {
    function MOVE() {}
    MOVE.value = new MOVE();
    return MOVE;
}();
var $0279ce8fdb6b506c$export$9227a1a65abc0f40 = /* #__PURE__ */ function() {
    function LOCK() {}
    LOCK.value = new LOCK();
    return LOCK;
}();
var $0279ce8fdb6b506c$export$81c5e18fd95994a5 = /* #__PURE__ */ function() {
    function UNLOCK() {}
    UNLOCK.value = new UNLOCK();
    return UNLOCK;
}();
var $0279ce8fdb6b506c$export$54950d96c4d7b0 = /* #__PURE__ */ function() {
    function PATCH() {}
    PATCH.value = new PATCH();
    return PATCH;
}();
var $0279ce8fdb6b506c$var$CustomMethod = function(x) {
    return x;
};
var $0279ce8fdb6b506c$export$7afd0cf4e939f7e8 = function(v) {
    return v;
};
var $0279ce8fdb6b506c$export$9710b60f7f869999 = {
    show: function(v) {
        if (v instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return "OPTIONS";
        if (v instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return "GET";
        if (v instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return "HEAD";
        if (v instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return "POST";
        if (v instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return "PUT";
        if (v instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return "DELETE";
        if (v instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return "TRACE";
        if (v instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return "CONNECT";
        if (v instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return "PROPFIND";
        if (v instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return "PROPPATCH";
        if (v instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return "MKCOL";
        if (v instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return "COPY";
        if (v instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return "MOVE";
        if (v instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return "LOCK";
        if (v instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return "UNLOCK";
        if (v instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return "PATCH";
        throw new Error("Failed pattern match at Data.HTTP.Method (line 43, column 1 - line 59, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $0279ce8fdb6b506c$export$9d28283af741e4f8 = {
    show: function(v) {
        return "(CustomMethod " + ($0279ce8fdb6b506c$var$show(v) + ")");
    }
};
var $0279ce8fdb6b506c$export$c2d084dc44961371 = /* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded(/* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0279ce8fdb6b506c$export$9710b60f7f869999))($0279ce8fdb6b506c$export$7afd0cf4e939f7e8);
var $0279ce8fdb6b506c$var$parse = function(handleMethod) {
    return function(handleUnknown) {
        return function(s) {
            var v = $5b07e36f812dd04b$export$43df7fc17cca38a4(s);
            if (v === "OPTIONS") return handleMethod($0279ce8fdb6b506c$export$8eb3892b442747bd.value);
            if (v === "GET") return handleMethod($0279ce8fdb6b506c$export$1bb358554aac31c1.value);
            if (v === "HEAD") return handleMethod($0279ce8fdb6b506c$export$3cdc0b6c64b90aaa.value);
            if (v === "POST") return handleMethod($0279ce8fdb6b506c$export$484f3009c2ee32ad.value);
            if (v === "PUT") return handleMethod($0279ce8fdb6b506c$export$5508c7b57250ebc6.value);
            if (v === "DELETE") return handleMethod($0279ce8fdb6b506c$export$4bd2facc4a3e6aa1.value);
            if (v === "TRACE") return handleMethod($0279ce8fdb6b506c$export$8754b71dc67cd5d0.value);
            if (v === "CONNECT") return handleMethod($0279ce8fdb6b506c$export$df50b52b1548c0dc.value);
            if (v === "PROPFIND") return handleMethod($0279ce8fdb6b506c$export$673494e2608125f7.value);
            if (v === "PROPPATCH") return handleMethod($0279ce8fdb6b506c$export$d16982ce725f2efb.value);
            if (v === "MKCOL") return handleMethod($0279ce8fdb6b506c$export$36dd893c77c0f7d8.value);
            if (v === "COPY") return handleMethod($0279ce8fdb6b506c$export$92f9e1ed9114d3a6.value);
            if (v === "MOVE") return handleMethod($0279ce8fdb6b506c$export$346f08c1f0d0fe41.value);
            if (v === "LOCK") return handleMethod($0279ce8fdb6b506c$export$9227a1a65abc0f40.value);
            if (v === "UNLOCK") return handleMethod($0279ce8fdb6b506c$export$81c5e18fd95994a5.value);
            if (v === "PATCH") return handleMethod($0279ce8fdb6b506c$export$54950d96c4d7b0.value);
            return handleUnknown(v);
        };
    };
};
var $0279ce8fdb6b506c$export$3004f64547af360e = /* #__PURE__ */ function() {
    return $0279ce8fdb6b506c$var$parse($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function($34) {
        return $7d4cccdf062a2261$export$19db0165690c701a.create($0279ce8fdb6b506c$var$CustomMethod($34));
    });
}();
var $0279ce8fdb6b506c$export$f20e5e4763052386 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd && y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return true;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1 && y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return true;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa && y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return true;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad && y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return true;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6 && y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return true;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 && y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return true;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0 && y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return true;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc && y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return true;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7 && y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return true;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb && y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return true;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8 && y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return true;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 && y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return true;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41 && y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return true;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40 && y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return true;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5 && y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return true;
            if (x instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0 && y instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return true;
            return false;
        };
    }
};
var $0279ce8fdb6b506c$export$87b67b987c5486ec = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd && y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$8eb3892b442747bd) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1 && y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$1bb358554aac31c1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa && y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$3cdc0b6c64b90aaa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad && y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$484f3009c2ee32ad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6 && y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$5508c7b57250ebc6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1 && y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$4bd2facc4a3e6aa1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0 && y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$8754b71dc67cd5d0) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc && y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$df50b52b1548c0dc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7 && y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$673494e2608125f7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb && y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$d16982ce725f2efb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8 && y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$36dd893c77c0f7d8) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6 && y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$92f9e1ed9114d3a6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41 && y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$346f08c1f0d0fe41) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40 && y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$9227a1a65abc0f40) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5 && y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0279ce8fdb6b506c$export$81c5e18fd95994a5) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0 && y instanceof $0279ce8fdb6b506c$export$54950d96c4d7b0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.HTTP.Method (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0279ce8fdb6b506c$export$f20e5e4763052386;
    }
};
var $0279ce8fdb6b506c$export$2ec54f6342f5f5ac = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $0279ce8fdb6b506c$export$c7119fb43836d0ad = {
    compare: function(x) {
        return function(y) {
            return $0279ce8fdb6b506c$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $0279ce8fdb6b506c$export$2ec54f6342f5f5ac;
    }
};







// Generated by purs version 0.15.16
/* eslint-disable no-eq-null, eqeqeq */ const $305519516124a7ff$export$7b1b591b262c240 = null;
function $305519516124a7ff$export$133fc36489ac9add(a, r, f) {
    return a == null ? r : f(a);
}
function $305519516124a7ff$export$9b7835891cf7097a(x) {
    return x;
}







var $0a5aaf95f168428e$export$b187f57ee1822bc5 = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($305519516124a7ff$export$7b1b591b262c240)($305519516124a7ff$export$9b7835891cf7097a);
var $0a5aaf95f168428e$export$1ba013b88f4f21f3 = function(n) {
    return $305519516124a7ff$export$133fc36489ac9add(n, $06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create);
};
var $0a5aaf95f168428e$export$643760463fdd14c1 = function(dictShow) {
    return {
        show: function() {
            var $17 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("null")($2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow));
            return function($18) {
                return $17($0a5aaf95f168428e$export$1ba013b88f4f21f3($18));
            };
        }()
    };
};
var $0a5aaf95f168428e$export$1d97b52fc2e07cdc = function(dictEq) {
    return {
        eq: $f57f4b701aa7b66e$export$af631764ddc44097($37b880af5f4991bd$export$9663ddc1cf085b32($06733ae99ed4f534$export$8f45bb76abf9699e(dictEq)))($0a5aaf95f168428e$export$1ba013b88f4f21f3)
    };
};
var $0a5aaf95f168428e$export$4fb7d8da662af215 = function(dictOrd) {
    var eqNullable1 = $0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictOrd.Eq0());
    return {
        compare: $f57f4b701aa7b66e$export$af631764ddc44097($97937c29f879e68e$export$398604a469f7de9a($06733ae99ed4f534$export$e35c29f98d259c46(dictOrd)))($0a5aaf95f168428e$export$1ba013b88f4f21f3),
        Eq0: function() {
            return eqNullable1;
        }
    };
};
var $0a5aaf95f168428e$export$1b7ecac9aff49fbc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($0a5aaf95f168428e$export$1d97b52fc2e07cdc(dictEq));
    }
};
var $0a5aaf95f168428e$export$46a371b99e80ea42 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($0a5aaf95f168428e$export$4fb7d8da662af215(dictOrd));
    },
    Eq10: function() {
        return $0a5aaf95f168428e$export$1b7ecac9aff49fbc;
    }
};




// Generated by purs version 0.15.16



var $107430d2749bac15$export$9223adb43c31d760 = function(x) {
    return x;
};
var $107430d2749bac15$export$e806838bdd212676 = function(x) {
    return x;
};
var $107430d2749bac15$export$2e3eef4f26ade0f7 = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(k) {
        return function __do() {
            var v1 = v(function($9) {
                return k($7d4cccdf062a2261$export$37c4d04eafdc5515.create($9))();
            }, function($10) {
                return k($7d4cccdf062a2261$export$19db0165690c701a.create($10))();
            });
            return function(e) {
                return $b28443a27438717a$export$49d5975414e0a979(function(k2) {
                    return function __do() {
                        v1(e, function($11) {
                            return k2($7d4cccdf062a2261$export$37c4d04eafdc5515.create($11))();
                        }, function($12) {
                            return k2($7d4cccdf062a2261$export$19db0165690c701a.create($12))();
                        });
                        return $edf0339512807bee$export$8deb6e154ce67af6;
                    };
                });
            };
        };
    });
};



// Generated by purs version 0.15.16
function $c2c5bfcfd98ddabb$export$f5bbd400c2f4426f(value) {
    return typeof value;
}
function $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $c2c5bfcfd98ddabb$export$630801d484da15df(value) {
    return value === null;
}
function $c2c5bfcfd98ddabb$export$fce6876652108ab(value) {
    return value === undefined;
}
const $c2c5bfcfd98ddabb$export$43bee75e5e14138e = Array.isArray || function(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
};


















var $c97d2d0f578f81ad$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $c97d2d0f578f81ad$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $c97d2d0f578f81ad$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $c97d2d0f578f81ad$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c97d2d0f578f81ad$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c97d2d0f578f81ad$export$f6a37cc43a8b8898 = /* #__PURE__ */ function() {
    function ForeignError(value0) {
        this.value0 = value0;
    }
    ForeignError.create = function(value0) {
        return new ForeignError(value0);
    };
    return ForeignError;
}();
var $c97d2d0f578f81ad$export$168e2d3b16829a = /* #__PURE__ */ function() {
    function TypeMismatch(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    TypeMismatch.create = function(value0) {
        return function(value1) {
            return new TypeMismatch(value0, value1);
        };
    };
    return TypeMismatch;
}();
var $c97d2d0f578f81ad$export$20d9a5af040a79f1 = /* #__PURE__ */ function() {
    function ErrorAtIndex(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtIndex.create = function(value0) {
        return function(value1) {
            return new ErrorAtIndex(value0, value1);
        };
    };
    return ErrorAtIndex;
}();
var $c97d2d0f578f81ad$export$92e5795aa905bd26 = /* #__PURE__ */ function() {
    function ErrorAtProperty(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ErrorAtProperty.create = function(value0) {
        return function(value1) {
            return new ErrorAtProperty(value0, value1);
        };
    };
    return ErrorAtProperty;
}();
var $c97d2d0f578f81ad$export$9d82982d31d9d171 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$19df04dfac508e15 = $ac8b3532514ac019$export$401372c57776dc;
var $c97d2d0f578f81ad$export$ca110433ecb89bbf = {
    show: function(v) {
        if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return "(ForeignError " + ($c97d2d0f578f81ad$var$show(v.value0) + ")");
        if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "(ErrorAtIndex " + ($c97d2d0f578f81ad$var$show1(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "(ErrorAtProperty " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($c97d2d0f578f81ad$export$ca110433ecb89bbf)(v.value1) + ")")));
        if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "(TypeMismatch " + ($c97d2d0f578f81ad$var$show(v.value0) + (" " + ($c97d2d0f578f81ad$var$show(v.value1) + ")")));
        throw new Error("Failed pattern match at Foreign (line 69, column 1 - line 73, column 89): " + [
            v.constructor.name
        ]);
    }
};
var $c97d2d0f578f81ad$export$a2293656e769bd56 = function(v) {
    if (v instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return v.value0;
    if (v instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return "Error at array index " + ($c97d2d0f578f81ad$var$show1(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return "Error at property " + ($c97d2d0f578f81ad$var$show(v.value0) + (": " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value1)));
    if (v instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return "Type mismatch: expected " + (v.value0 + (", found " + v.value1));
    throw new Error("Failed pattern match at Foreign (line 78, column 1 - line 78, column 45): " + [
        v.constructor.name
    ]);
};
var $c97d2d0f578f81ad$export$4e0f52105ee4b19b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 174, column 1 - line 174, column 103): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$a540325489296c24 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value) || $c2c5bfcfd98ddabb$export$fce6876652108ab(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 179, column 1 - line 179, column 109): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$62e87727fba30d8d = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$630801d484da15df(value)) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(value));
        throw new Error("Failed pattern match at Foreign (line 169, column 1 - line 169, column 98): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$2b62a06a9fee979c = function(dictMonad) {
    var $153 = $5dfefa023749ded0$export$8bf7aba4a9e09055($d2284b2d3e1b6f87$export$75f89ba5e7a712b0(dictMonad));
    return function($154) {
        return $153($ba51d599f79a6310$export$439306a4dcaafbb9($154));
    };
};
var $c97d2d0f578f81ad$export$d3f4ca0e55363719 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(value) {
        if ($c2c5bfcfd98ddabb$export$43bee75e5e14138e(value)) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a("array", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
        throw new Error("Failed pattern match at Foreign (line 164, column 1 - line 164, column 99): " + [
            value.constructor.name
        ]);
    };
};
var $c97d2d0f578f81ad$export$6190f2182377b437 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d2284b2d3e1b6f87$export$963960a96c103d2f(dictMonad));
    var fail1 = $c97d2d0f578f81ad$export$2b62a06a9fee979c(dictMonad);
    return function(tag) {
        return function(value) {
            if ($c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value) === tag) return pure1($c97d2d0f578f81ad$export$19df04dfac508e15(value));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return fail1(new $c97d2d0f578f81ad$export$168e2d3b16829a(tag, $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value)));
            throw new Error("Failed pattern match at Foreign (line 123, column 1 - line 123, column 104): " + [
                tag.constructor.name,
                value.constructor.name
            ]);
        };
    };
};
var $c97d2d0f578f81ad$export$f9a84177eae95ed5 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Boolean");
};
var $c97d2d0f578f81ad$export$347fd215c36b10be = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("Number");
};
var $c97d2d0f578f81ad$export$ac3747cb00139c63 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readNumber1 = $c97d2d0f578f81ad$export$347fd215c36b10be(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Int", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromNumber = function() {
            var $155 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($156) {
                return $155($8d5664f12212b23e$export$7bbb4164c9a77bc2($156));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromNumber)))(readNumber1(value));
    };
};
var $c97d2d0f578f81ad$export$dda73877cb166cd3 = function(dictMonad) {
    return $c97d2d0f578f81ad$export$6190f2182377b437(dictMonad)("String");
};
var $c97d2d0f578f81ad$export$85b98eeba3f0a3b4 = function(dictMonad) {
    var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var readString1 = $c97d2d0f578f81ad$export$dda73877cb166cd3(dictMonad);
    return function(value) {
        var error = new $7d4cccdf062a2261$export$37c4d04eafdc5515($ba51d599f79a6310$export$439306a4dcaafbb9(new $c97d2d0f578f81ad$export$168e2d3b16829a("Char", $c2c5bfcfd98ddabb$export$348caad1e8d41c5f(value))));
        var fromString = function() {
            var $157 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(error)($c97d2d0f578f81ad$var$pure);
            return function($158) {
                return $157($1a77d6934b592676$export$bafb3da1554990db($158));
            };
        }();
        return $d2284b2d3e1b6f87$export$34cbd9fbda5c1fb2(map($7d4cccdf062a2261$export$5f5be1bb6cd1fded($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(error))(fromString)))(readString1(value));
    };
};
var $c97d2d0f578f81ad$export$29dc7ef345289543 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return x.value0 === y.value0;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return x.value0 === y.value0 && x.value1 === y.value1;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) return x.value0 === y.value0 && $37b880af5f4991bd$export$9663ddc1cf085b32($c97d2d0f578f81ad$export$29dc7ef345289543)(x.value1)(y.value1);
            return false;
        };
    }
};
var $c97d2d0f578f81ad$export$661e78eef4f027af = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898 && y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
            if (x instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$f6a37cc43a8b8898) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a && y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $c97d2d0f578f81ad$var$compare(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$168e2d3b16829a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1 && y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) {
                var v = $c97d2d0f578f81ad$var$compare1(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            if (x instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c97d2d0f578f81ad$export$20d9a5af040a79f1) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26 && y instanceof $c97d2d0f578f81ad$export$92e5795aa905bd26) {
                var v = $c97d2d0f578f81ad$var$compare(x.value0)(y.value0);
                if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                return $97937c29f879e68e$export$398604a469f7de9a($c97d2d0f578f81ad$export$661e78eef4f027af)(x.value1)(y.value1);
            }
            throw new Error("Failed pattern match at Foreign (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c97d2d0f578f81ad$export$29dc7ef345289543;
    }
};


var $3b38984084ed8eff$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$fail = /* #__PURE__ */ $c97d2d0f578f81ad$export$2b62a06a9fee979c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $3b38984084ed8eff$var$unsafeReadTagged = /* #__PURE__ */ $c97d2d0f578f81ad$export$6190f2182377b437($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $3b38984084ed8eff$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $3b38984084ed8eff$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3b38984084ed8eff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $3b38984084ed8eff$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($37b880af5f4991bd$export$fa624555ca2acbc8);
var $3b38984084ed8eff$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $3b38984084ed8eff$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $3b38984084ed8eff$var$mapFlipped = /* #__PURE__ */ $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $3b38984084ed8eff$var$$$try = /* #__PURE__ */ $5dfefa023749ded0$export$410a452afcd48948($edf0339512807bee$export$9efce1646e93cba4);
var $3b38984084ed8eff$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $3b38984084ed8eff$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $3b38984084ed8eff$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($7d4cccdf062a2261$export$f0a413d3d6075601);
var $3b38984084ed8eff$export$b1b4758529f693c0 = /* #__PURE__ */ function() {
    function RequestContentError(value0) {
        this.value0 = value0;
    }
    RequestContentError.create = function(value0) {
        return new RequestContentError(value0);
    };
    return RequestContentError;
}();
var $3b38984084ed8eff$export$10b74a1a57a5fea2 = /* #__PURE__ */ function() {
    function ResponseBodyError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ResponseBodyError.create = function(value0) {
        return function(value1) {
            return new ResponseBodyError(value0, value1);
        };
    };
    return ResponseBodyError;
}();
var $3b38984084ed8eff$export$66d311bf29d5c89c = /* #__PURE__ */ function() {
    function TimeoutError() {}
    TimeoutError.value = new TimeoutError();
    return TimeoutError;
}();
var $3b38984084ed8eff$export$4e8ebf4980bdf90a = /* #__PURE__ */ function() {
    function RequestFailedError() {}
    RequestFailedError.value = new RequestFailedError();
    return RequestFailedError;
}();
var $3b38984084ed8eff$export$b4982b9cefddd7f3 = /* #__PURE__ */ function() {
    function XHROtherError(value0) {
        this.value0 = value0;
    }
    XHROtherError.create = function(value0) {
        return new XHROtherError(value0);
    };
    return XHROtherError;
}();
var $3b38984084ed8eff$export$b5fe3f66a567bec0 = function(driver) {
    return function(req) {
        var parseJSON = function(v) {
            if (v === "") return $3b38984084ed8eff$var$pure($2a035e92dc768ac1$export$d0304b893d105187);
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($74) {
                return $3b38984084ed8eff$var$fail($c97d2d0f578f81ad$export$f6a37cc43a8b8898.create($74));
            })($3b38984084ed8eff$var$pure)($44e5fdc48745e77c$export$f3a8d475da9d5fc3(v));
        };
        var fromResponse = function() {
            if (req.responseFormat instanceof $c02e13aaef170b91$export$5d43b79a1f53c8d0) return $3b38984084ed8eff$var$unsafeReadTagged("ArrayBuffer");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$3b660928c86ff55c) return $3b38984084ed8eff$var$unsafeReadTagged("Blob");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$b34a105447964f9f) return function(x) {
                return $3b38984084ed8eff$var$alt($3b38984084ed8eff$var$unsafeReadTagged("Document")(x))($3b38984084ed8eff$var$alt($3b38984084ed8eff$var$unsafeReadTagged("XMLDocument")(x))($3b38984084ed8eff$var$unsafeReadTagged("HTMLDocument")(x)));
            };
            if (req.responseFormat instanceof $c02e13aaef170b91$export$48880ac635f47186) return $3b38984084ed8eff$var$composeKleisliFlipped(function($75) {
                return req.responseFormat.value0(parseJSON($75));
            })($3b38984084ed8eff$var$unsafeReadTagged("String"));
            if (req.responseFormat instanceof $c02e13aaef170b91$export$89b8e0fa65f6a914) return $3b38984084ed8eff$var$unsafeReadTagged("String");
            if (req.responseFormat instanceof $c02e13aaef170b91$export$e92c65af050aed9a) return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(req.responseFormat.value0($3b38984084ed8eff$var$pure($05149ea687d6b460$export$523c0b569236b342)));
            throw new Error("Failed pattern match at Affjax (line 274, column 18 - line 283, column 57): " + [
                req.responseFormat.constructor.name
            ]);
        }();
        var extractContent = function(v) {
            if (v instanceof $1bb5df538ea16bd9$export$2369e6c56c47a5bd) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0($c97d2d0f578f81ad$export$9d82982d31d9d171));
            if (v instanceof $1bb5df538ea16bd9$export$3b660928c86ff55c) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$b34a105447964f9f) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$89b8e0fa65f6a914) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$3963aa24c930693c) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171(v.value0));
            if (v instanceof $1bb5df538ea16bd9$export$bcdd6637213a40ec) return $7d4cccdf062a2261$export$a92e4c44d367d0af("Body contains values that cannot be encoded as application/x-www-form-urlencoded")($3b38984084ed8eff$var$map($c97d2d0f578f81ad$export$9d82982d31d9d171)($d7072b1f1f4574d6$export$c564cdbbe6da493(v.value0)));
            if (v instanceof $1bb5df538ea16bd9$export$48880ac635f47186) return new $7d4cccdf062a2261$export$19db0165690c701a($c97d2d0f578f81ad$export$9d82982d31d9d171($0e031af7428ef07d$export$fac44ee5b035f737(v.value0)));
            throw new Error("Failed pattern match at Affjax (line 235, column 20 - line 250, column 69): " + [
                v.constructor.name
            ]);
        };
        var addHeader = function(mh) {
            return function(hs) {
                if (mh instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && !$3b38984084ed8eff$var$any($f57f4b701aa7b66e$export$af631764ddc44097($3b38984084ed8eff$var$eq)($04f1e5e12069f6d8$export$a8ff84c12d48cfa6)(mh.value0))(hs)) return $396c4c3d9e7fae3c$export$c40cf5aab899f397(hs)(mh.value0);
                return hs;
            };
        };
        var headers = function(reqContent) {
            return addHeader($3b38984084ed8eff$var$map($04f1e5e12069f6d8$export$e2e108cbe2e4f865.create)($3b38984084ed8eff$var$bindFlipped($1bb5df538ea16bd9$export$64f69cdd5524ddeb)(reqContent)))(addHeader($3b38984084ed8eff$var$map($04f1e5e12069f6d8$export$5e41db7437457e4f.create)($c02e13aaef170b91$export$64f69cdd5524ddeb(req.responseFormat)))(req.headers));
        };
        var ajaxRequest = function(v) {
            return {
                method: $0279ce8fdb6b506c$export$c2d084dc44961371(req.method),
                url: req.url,
                headers: $3b38984084ed8eff$var$map1(function(h) {
                    return {
                        field: $04f1e5e12069f6d8$export$a8ff84c12d48cfa6(h),
                        value: $04f1e5e12069f6d8$export$2ab9a8f9f1186f14(h)
                    };
                })(headers(req.content)),
                content: v,
                responseType: $c02e13aaef170b91$export$17004af5aa52bce6(req.responseFormat),
                username: $0a5aaf95f168428e$export$b187f57ee1822bc5(req.username),
                password: $0a5aaf95f168428e$export$b187f57ee1822bc5(req.password),
                withCredentials: req.withCredentials,
                timeout: $06733ae99ed4f534$export$43db023a260c5e9f(0.0)($3b38984084ed8eff$var$map(function(v1) {
                    return v1;
                })(req.timeout))
            };
        };
        var send = function(content) {
            return $3b38984084ed8eff$var$mapFlipped($3b38984084ed8eff$var$$$try($107430d2749bac15$export$2e3eef4f26ade0f7($1f4ad780c651f89e$export$9d38b81df1e4ff(driver, "AffjaxTimeoutErrorMessageIdent", "AffjaxRequestFailedMessageIdent", $d5f2bbf513cce8c9$export$42f186449ccf2a6a.create, ajaxRequest(content)))))(function(v) {
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    var v1 = $f9f243b94d1fc188$export$a25b8a8a37f2d1cd(fromResponse(v.value0.body));
                    if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $3b38984084ed8eff$export$10b74a1a57a5fea2($ba51d599f79a6310$export$5fd5031fecdacec3(v1.value0), v.value0));
                    if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        headers: v.value0.headers,
                        status: v.value0.status,
                        statusText: v.value0.statusText,
                        body: v1.value0
                    });
                    throw new Error("Failed pattern match at Affjax (line 209, column 9 - line 211, column 52): " + [
                        v1.constructor.name
                    ]);
                }
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(function() {
                    var message = $ad2cf6904bca3ba1$export$a8ecead220dd38a6(v.value0);
                    var $61 = message === "AffjaxTimeoutErrorMessageIdent";
                    if ($61) return $3b38984084ed8eff$export$66d311bf29d5c89c.value;
                    var $62 = message === "AffjaxRequestFailedMessageIdent";
                    if ($62) return $3b38984084ed8eff$export$4e8ebf4980bdf90a.value;
                    return new $3b38984084ed8eff$export$b4982b9cefddd7f3(v.value0);
                }());
                throw new Error("Failed pattern match at Affjax (line 207, column 144 - line 219, column 28): " + [
                    v.constructor.name
                ]);
            });
        };
        if (req.content instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return send($0a5aaf95f168428e$export$b187f57ee1822bc5($06733ae99ed4f534$export$bebe9059409a0d04.value));
        if (req.content instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var v = extractContent(req.content.value0);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return send($0a5aaf95f168428e$export$b187f57ee1822bc5(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)));
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $3b38984084ed8eff$var$pure1(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $3b38984084ed8eff$export$b1b4758529f693c0(v.value0)));
            throw new Error("Failed pattern match at Affjax (line 199, column 7 - line 203, column 48): " + [
                v.constructor.name
            ]);
        }
        throw new Error("Failed pattern match at Affjax (line 195, column 3 - line 203, column 48): " + [
            req.content.constructor.name
        ]);
    };
};
var $3b38984084ed8eff$export$55ee1551a3f962e6 = function(v) {
    if (v instanceof $3b38984084ed8eff$export$b1b4758529f693c0) return "There was a problem with the request content: " + v.value0;
    if (v instanceof $3b38984084ed8eff$export$10b74a1a57a5fea2) return "There was a problem with the response body: " + $c97d2d0f578f81ad$export$a2293656e769bd56(v.value0);
    if (v instanceof $3b38984084ed8eff$export$66d311bf29d5c89c) return "There was a problem making the request: timeout";
    if (v instanceof $3b38984084ed8eff$export$4e8ebf4980bdf90a) return "There was a problem making the request: request failed";
    if (v instanceof $3b38984084ed8eff$export$b4982b9cefddd7f3) return "There was a problem making the request: " + $ad2cf6904bca3ba1$export$a8ecead220dd38a6(v.value0);
    throw new Error("Failed pattern match at Affjax (line 113, column 14 - line 123, column 66): " + [
        v.constructor.name
    ]);
};
var $3b38984084ed8eff$export$de89fc8561ede42f = /* #__PURE__ */ function() {
    return {
        method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$1bb358554aac31c1.value),
        url: "/",
        headers: [],
        content: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        username: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        password: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        withCredentials: false,
        responseFormat: $c02e13aaef170b91$export$738b109e247a462c,
        timeout: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $3b38984084ed8eff$export$1822828d790e23ee = function(driver) {
    return function(rf) {
        return function(u) {
            return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                content: $3b38984084ed8eff$export$de89fc8561ede42f.content,
                username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$4bd2facc4a3e6aa1.value),
                url: u,
                responseFormat: rf
            });
        };
    };
};
var $3b38984084ed8eff$export$38dab5a9fea42f39 = function(driver) {
    var $76 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
    var $77 = $3b38984084ed8eff$export$1822828d790e23ee(driver)($c02e13aaef170b91$export$738b109e247a462c);
    return function($78) {
        return $76($77($78));
    };
};
var $3b38984084ed8eff$export$3988ae62b71be9a3 = function(driver) {
    return function(rf) {
        return function(u) {
            return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                method: $3b38984084ed8eff$export$de89fc8561ede42f.method,
                headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                content: $3b38984084ed8eff$export$de89fc8561ede42f.content,
                username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                url: u,
                responseFormat: rf
            });
        };
    };
};
var $3b38984084ed8eff$export$b76953f99ab2be78 = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$54950d96c4d7b0.value),
                    url: u,
                    content: new $06733ae99ed4f534$export$8a67b48435b5d073(c),
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$3e5572abde0c1b7c = function(driver) {
    return function(url) {
        var $79 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $80 = $3b38984084ed8eff$export$b76953f99ab2be78(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($81) {
            return $79($80($81));
        };
    };
};
var $3b38984084ed8eff$export$299ba2dee77727e9 = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$484f3009c2ee32ad.value),
                    url: u,
                    content: c,
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$a51007acc2c57e79 = function(driver) {
    return function(url) {
        var $82 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $83 = $3b38984084ed8eff$export$299ba2dee77727e9(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($84) {
            return $82($83($84));
        };
    };
};
var $3b38984084ed8eff$export$327f7b26ebf455db = function(driver) {
    return function(rf) {
        return function(u) {
            return function(c) {
                return $3b38984084ed8eff$export$b5fe3f66a567bec0(driver)({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    withCredentials: $3b38984084ed8eff$export$de89fc8561ede42f.withCredentials,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$5508c7b57250ebc6.value),
                    url: u,
                    content: c,
                    responseFormat: rf
                });
            };
        };
    };
};
var $3b38984084ed8eff$export$3ea07e5c3343cd8a = function(driver) {
    return function(url) {
        var $85 = $3b38984084ed8eff$var$map2($3b38984084ed8eff$var$$$void);
        var $86 = $3b38984084ed8eff$export$327f7b26ebf455db(driver)($c02e13aaef170b91$export$738b109e247a462c)(url);
        return function($87) {
            return $85($86($87));
        };
    };
};

























// Generated by purs version 0.15.16


var $9c13a1c3d948adb8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $9c13a1c3d948adb8$export$be9e2feb4e35335b = function(w) {
    return $9c13a1c3d948adb8$var$bind(w)(function() {
        return $9c13a1c3d948adb8$export$be9e2feb4e35335b(w);
    });
};


// Generated by purs version 0.15.16
var $a85b590c259ba128$exports = {};
/*global window, global*/ 
var $N7Lcz = parcelRequire("N7Lcz");

var $aLUwE = parcelRequire("aLUwE");
function $a85b590c259ba128$var$now() {
    return new Date().getTime();
}
var $a85b590c259ba128$var$slice = Array.prototype.slice;
var $a85b590c259ba128$var$console;
var $a85b590c259ba128$var$times = {};
if (typeof $parcel$global !== "undefined" && $parcel$global.console) $a85b590c259ba128$var$console = $parcel$global.console;
else if (typeof window !== "undefined" && window.console) $a85b590c259ba128$var$console = window.console;
else $a85b590c259ba128$var$console = {};
var $a85b590c259ba128$var$functions = [
    [
        $a85b590c259ba128$var$log,
        "log"
    ],
    [
        $a85b590c259ba128$var$info,
        "info"
    ],
    [
        $a85b590c259ba128$var$warn,
        "warn"
    ],
    [
        $a85b590c259ba128$var$error,
        "error"
    ],
    [
        $a85b590c259ba128$var$time,
        "time"
    ],
    [
        $a85b590c259ba128$var$timeEnd,
        "timeEnd"
    ],
    [
        $a85b590c259ba128$var$trace,
        "trace"
    ],
    [
        $a85b590c259ba128$var$dir,
        "dir"
    ],
    [
        $a85b590c259ba128$var$consoleAssert,
        "assert"
    ]
];
for(var $a85b590c259ba128$var$i = 0; $a85b590c259ba128$var$i < $a85b590c259ba128$var$functions.length; $a85b590c259ba128$var$i++){
    var $a85b590c259ba128$var$tuple = $a85b590c259ba128$var$functions[$a85b590c259ba128$var$i];
    var $a85b590c259ba128$var$f = $a85b590c259ba128$var$tuple[0];
    var $a85b590c259ba128$var$name = $a85b590c259ba128$var$tuple[1];
    if (!$a85b590c259ba128$var$console[$a85b590c259ba128$var$name]) $a85b590c259ba128$var$console[$a85b590c259ba128$var$name] = $a85b590c259ba128$var$f;
}
$a85b590c259ba128$exports = $a85b590c259ba128$var$console;
function $a85b590c259ba128$var$log() {}
function $a85b590c259ba128$var$info() {
    $a85b590c259ba128$var$console.log.apply($a85b590c259ba128$var$console, arguments);
}
function $a85b590c259ba128$var$warn() {
    $a85b590c259ba128$var$console.log.apply($a85b590c259ba128$var$console, arguments);
}
function $a85b590c259ba128$var$error() {
    $a85b590c259ba128$var$console.warn.apply($a85b590c259ba128$var$console, arguments);
}
function $a85b590c259ba128$var$time(label) {
    $a85b590c259ba128$var$times[label] = $a85b590c259ba128$var$now();
}
function $a85b590c259ba128$var$timeEnd(label) {
    var time = $a85b590c259ba128$var$times[label];
    if (!time) throw new Error("No such label: " + label);
    delete $a85b590c259ba128$var$times[label];
    var duration = $a85b590c259ba128$var$now() - time;
    $a85b590c259ba128$var$console.log(label + ": " + duration + "ms");
}
function $a85b590c259ba128$var$trace() {
    var err = new Error();
    err.name = "Trace";
    err.message = $N7Lcz.format.apply(null, arguments);
    $a85b590c259ba128$var$console.error(err.stack);
}
function $a85b590c259ba128$var$dir(object) {
    $a85b590c259ba128$var$console.log($N7Lcz.inspect(object) + "\n");
}
function $a85b590c259ba128$var$consoleAssert(expression) {
    if (!expression) {
        var arr = $a85b590c259ba128$var$slice.call(arguments, 1);
        $aLUwE.ok(false, $N7Lcz.format.apply(null, arr));
    }
}


var $5204e82e2e00f99d$exports = {};
$5204e82e2e00f99d$exports = JSON.parse('{"new-form":"New Form","hide-forms":"Hide forms","show-forms":"Show forms","recent-forms":"Recent Forms","recent-forms-empty":"No forms match the filters or current search criteria. CIick\xa0<b>+Create Forms</b>\xa0to get started.","export-all-forms":"Export all forms","show-less":"Show less","show-more":"Show more","re-order":"Re-order","choose-a-student":"Choose a student","choose-a-course":"Choose a course","choose-a-teacher":"Choose a teacher","select-students":"Select students","select-forms":"Select forms","fill-forms":"Fill forms","show-all-semesters":"Show all semesters","could-not-find-student-name":"Could not find student name","could-not-find-placement":"Could not find placement","select-all":"Select all","select-all-unsent":"Select all unsent","selected-count":" selected","lock":"Lock","save-and-lock":"Save and lock","unlock":"Unlock","locked":"Locked","copy":"Copy","delete":"Delete","student":"Student","profile":"Profile","student-profile-icon-alt-text":"student profile icon","tag-imported":"Imported","course":"Course","employer":"Employer","contact":"Contact","position":"Position","select-employer":"Choose an Employer","select-position":"Choose a Position","teacher":"Teacher","search":"Search","search-teacher":"Search by teacher","search-semester":"Search by semester","search-class":"Search by class","search-teacher-all":"All teachers","search-semester-all":"All semesters","search-class-all":"All classes","semester":"Semester","class":"Class","update-semester":"Change Semester","update-teacher":"Change Teacher","update-semester-for":"Change semester for","update-teacher-for":"Change teacher for","forms":"forms","form-details":"Form Details","fewer-fields":"Fewer fields","more-fields":"More fields","form-has-not-been-saved-text":"The form you are working on has not been saved. Do you want to discard the changes?","next":"Next","prev":"Previous","finish":"Finish","cancel":"Cancel","back":"Back","form-save-quit":"Save and exit","form-quit":"Exit","add":"Add","discard-changes":"Discard changes","clear":"Clear","clear-lowercase":"clear","save":"Save","done":"Done","export-pdf":"Save and Export PDF","export":"Export","nothing-here":"There is nothing here!","nothing-here-clearable":"There is nothing here! Try clearing your filters.","clear-filters":"Clear Search Filters","choose-expectations":"Choose expectations","insert-expectation":"Insert expectation","expectation":"Expectation","expectations-all-curriculum":"All Curriculum","expectations-overall":"Overall Expectations","expectations-course-favs":"Course Favorites","expectations-noc":"Occupations (NOC)","expectations-employer-tab":"Employer / Position","expectations-trade":"Trades","employer-choose-expectation":"Choose employer expectations","employer-insert-expectation":"Insert employer expectation","course-choose-expectation":"Choose course expectations","course-insert-expectation":"Insert course expectation","learning-demonstration":"Demonstration of Learning","create-forms":"\uFF0B Create Forms","edit-forms":"Edit Forms","edit":"Edit","course-form-course":"Course","employer-form-employer":"Employer","employer-details":"Employer","employer-student-position":"Student position","employer-contact":"Contact","add-employer":"\uFF0B New Employer","edit-employer":"Edit ","first-name":"First Name","last-name":"Last Name","semester-hidden-select":"Creating form(s) for semester","semester-hidden-select-locked":"Form created for semester","teacher-hidden-select":"and teacher","must-select-teacher-semester":"Please select a teacher and semester (required).","none":"None","preview":"Preview","preview-and-sign":"Preview & Signatures","no-pdf":"There is no PDF for this form.","save-before-preview":"\u2139\uFE0F Please remember to save before previewing.","autofill-form-button":"Re-autofill","autofill-disabled-reason-lock":"Re-autofill is disabled as this form is locked. Unlock the form to re-autofill.","update-forms-disabled-reason-lock":"Teacher and semester updates are disabled because one or more selected forms are locked. Unlock the forms to update them.","form-locked-banner-message":"This form is locked. Unlock it to make changes.","form-locked-banner-message-unprivileged":"This form is locked.","form-locked-banner-message-mutable":"This form is locked, but some fields are still editable. Unlock it to edit all fields.","form-locked-banner-message-mutable-unprivileged":"This form is locked, but some fields are still editable.","email":"Email","email-address":"Email address","email-all":"Email all","signature-comment":"Message","signature-comment-placeholder":"e.g. Please sign this form.","signatures":"Signatures","request-signatures":"Request signatures","request-signatures-for":"Email request for","request-signatures-confirm-btn":"Send","request-signatures-confirm":"Are you sure you want to send these signature requests?","request-signatures-no-sigs":"Selected forms have no e-signatures","request-select-signatures":"Select signatures to request","request-all-signed":"All signature fields on the selected form(s) have been signed.","no-contact-selected":"Contact has not been selected in the form.","sent":"Sent","edit-email-for":"Edit email for ","rel-student":"student","rel-teacher":"teacher","rel-employer":"employer","rel-parent":"parent/guardian","rel-principal":"principal","rel-coordinator":"coordinator","resolve-signature-for":"Choose a signature to request for","will-req-signature-for":"Will request","save-signature":"Save as my signature","save-send":"Save & Send","send-email":"Send","already-emailed":"Request already sent","no-saved-email":"No saved email","sign":"Sign","sign-here":"Tap or click to sign","no-sign-here":"Not signed yet","signed-at":"Signed at","signature":"Signature","created-at":"Created at","updated-at":"Updated at","form-created-at":"Form created on ","form-updated-at":"Form updated on ","signature-add-email":"+ Email","signature-send-email":"Send Email","signature-resend-email":"Re-send Email","student-signature":"Student Signature","teacher-signature":"Teacher Signature","employer-signature":"Employer Signature","parent-signature":"Parent/Guardian Signature","principal-signature":"Principal Signature","coordinator-signature":"Coordinator Signature","student-rel":"Student","teacher-rel":"Teacher","employer-rel":"Employer","parent-rel":"Parent/Guardian","principal-rel":"Principal","coordinator-rel":"Coordinator","student-email":"Student Email","teacher-email":"Teacher Email","employer-email":"Employer Email","parent-email":"Parent/Guardian Email","principal-email":"Principal Email","coordinator-email":"Coordinator Email","confirm-email-title":"Send Email?","confirm-email":"Are you sure you want to email this signature request to","confirm-email-multiple":"Are you sure you want to email these signature requests?","confirm-delete-forms-title":"Really delete forms?","confirm-delete-forms":"Are you sure you want to delete these forms?","confirm-delete-forms-primary-button":"Delete","export-forms":"Export Forms","delete-forms":"Delete Forms","copy-forms":"Copy Forms","copy-forms-select-students":"Select students to copy forms to","select-choose":"Choose...","select-choose-search":"Choose or search...","yes":"Yes","no":"No","ok":"Okay","error-occurred":"An error has occurred","sign-with-saved":"Sign with saved signature","sig-form-sign-with-saved":"Sign with My Signature","email-to-sign":"Request signature via email","add-email":"Add email","edit-email":"Edit email","delete-signature":"Delete signature","email-sent":"Email sent","email-sent-to":"Email sent to","email-sent-at":"on","email-sent-link":"Copy e-signature link","email-sent-link-copied":"Link copied","signature-form-invalid":"Please fill out the name, email, and draw a signature.","loading":"Loading...","legacy-form-label":"Imported","comments":"Comments","comment-section":"Comments","comment-form-placeholder":"Post a Comment","comment-edit-header":"Edit Comment","comment-by":"Comment by ","comment-public-check":"Public (the student can view this comment)","comment-public-indicator":"public","comment-private-indicator":"private","comment-created-at":"posted ","comment-updated-at":"edited ","confirm-delete-comment-title":"Really delete comment?","confirm-delete-comment":"Are you sure you want to delete this comment?","confirm-delete-comment-primary-button":"Delete","post-comment":"Post","edit-comment":"Edit","save-comment":"Save","delete-comment":"Delete","cancel-edit-comment":"Cancel","attachments":"Attachments","attachment-section":"Attachments","attachment-form":"Attach File","attachment-delete":"Delete","attachment-upload":"Upload File","confirm-delete-attachment-title":"Really delete attachment?","confirm-delete-attachment":"Are you sure you want to delete this attachment?","confirm-delete-attachment-primary-button":"Delete","error-page-header":"Oops, something went wrong","error-refcode-text":"When reporting this issue to customer service (info@charityrepublic.com), please use this reference code:","error-button-pre-text":"Click the button below to reload the app.","error-button-text":"Reload","error":"Error","generic-error":"Something went wrong!"}');


"use strict";
var $c3328e54cdf5154c$var$resources = {
    "en": (0, (/*@__PURE__*/$parcel$interopDefault($5204e82e2e00f99d$exports)))
};
var $c3328e54cdf5154c$var$currentLanguage = "en";
const $c3328e54cdf5154c$export$4b6bf64406ec64af = (str)=>{
    $c3328e54cdf5154c$var$currentLanguage = str;
    (0, (/*@__PURE__*/$parcel$interopDefault($a85b590c259ba128$exports))).log('Language has been set to %s', $c3328e54cdf5154c$var$currentLanguage);
};
const $c3328e54cdf5154c$export$5a1a8430df9521e = function(key) {
    if (!($c3328e54cdf5154c$var$currentLanguage in $c3328e54cdf5154c$var$resources)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($a85b590c259ba128$exports))).warn('Language %s was not found in loaded resources', $c3328e54cdf5154c$var$currentLanguage);
        return key;
    }
    const translations = $c3328e54cdf5154c$var$resources[$c3328e54cdf5154c$var$currentLanguage];
    if (!(key in translations)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($a85b590c259ba128$exports))).warn('Key %s was not found in %s resources', key, $c3328e54cdf5154c$var$currentLanguage);
        return key;
    }
    return translations[key];
};


var $7db1899692b72025$var$EN = /* #__PURE__ */ function() {
    function EN() {}
    EN.value = new EN();
    return EN;
}();
var $7db1899692b72025$export$6d095d8f4a190243 = function(lang) {
    return $c3328e54cdf5154c$export$4b6bf64406ec64af("en");
};


var $54dae5ca6a6cd16d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $54dae5ca6a6cd16d$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $54dae5ca6a6cd16d$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $54dae5ca6a6cd16d$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $54dae5ca6a6cd16d$var$pre$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$31f7d7ffe82c4c23($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$details$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$2cd040ec0beeec1d($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$ul$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$cc03685c1f5dc816($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $54dae5ca6a6cd16d$var$li$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$819c065a8270721a($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $54dae5ca6a6cd16d$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $54dae5ca6a6cd16d$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $54dae5ca6a6cd16d$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $54dae5ca6a6cd16d$var$gEncodeJsonCons1 = /* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726);
var $54dae5ca6a6cd16d$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "widget";
    }
})())());
var $54dae5ca6a6cd16d$var$encodeJson1 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "module";
    }
})())());
var $54dae5ca6a6cd16d$var$encodeJson2 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b))(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "name";
    }
})())({
    reflectSymbol: function() {
        return "id";
    }
})())());
var $54dae5ca6a6cd16d$var$encodeJson3 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "vars";
    }
})())({
    reflectSymbol: function() {
        return "query";
    }
})())());
var $54dae5ca6a6cd16d$var$encodeJson4 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "json";
    }
})())({
    reflectSymbol: function() {
        return "description";
    }
})())());
var $54dae5ca6a6cd16d$var$encodeJson5 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $54dae5ca6a6cd16d$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "action";
    }
})())());
var $54dae5ca6a6cd16d$var$h1$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$78e024695ac0e4c4($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $54dae5ca6a6cd16d$var$fromHomogeneous = /* #__PURE__ */ $c045ea5df33bba60$export$a47a4d0fc4d6b25();
var $54dae5ca6a6cd16d$var$encodeJson6 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($eb7399d322077fcf$export$35d3004eff90f123))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "errors";
    }
})())());
var $54dae5ca6a6cd16d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $54dae5ca6a6cd16d$export$4146092e8212e5a6 = /* #__PURE__ */ function() {
    function InFormWidget(value0) {
        this.value0 = value0;
    }
    InFormWidget.create = function(value0) {
        return new InFormWidget(value0);
    };
    return InFormWidget;
}();
var $54dae5ca6a6cd16d$export$7a0047718fb8649d = /* #__PURE__ */ function() {
    function InModule(value0) {
        this.value0 = value0;
    }
    InModule.create = function(value0) {
        return new InModule(value0);
    };
    return InModule;
}();
var $54dae5ca6a6cd16d$export$8acaf7dd4f436a03 = /* #__PURE__ */ function() {
    function InQuery(value0) {
        this.value0 = value0;
    }
    InQuery.create = function(value0) {
        return new InQuery(value0);
    };
    return InQuery;
}();
var $54dae5ca6a6cd16d$export$567b4060ab81ee4f = /* #__PURE__ */ function() {
    function InForm(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    InForm.create = function(value0) {
        return function(value1) {
            return new InForm(value0, value1);
        };
    };
    return InForm;
}();
var $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c = /* #__PURE__ */ function() {
    function LoadingJson(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    LoadingJson.create = function(value0) {
        return function(value1) {
            return new LoadingJson(value0, value1);
        };
    };
    return LoadingJson;
}();
var $54dae5ca6a6cd16d$export$19d787e6e83e848f = /* #__PURE__ */ function() {
    function DuringAction(value0) {
        this.value0 = value0;
    }
    DuringAction.create = function(value0) {
        return new DuringAction(value0);
    };
    return DuringAction;
}();
var $54dae5ca6a6cd16d$export$9ab1d64c21a55caa = /* #__PURE__ */ function() {
    function AffJaxError(value0) {
        this.value0 = value0;
    }
    AffJaxError.create = function(value0) {
        return new AffJaxError(value0);
    };
    return AffJaxError;
}();
var $54dae5ca6a6cd16d$export$ef3eed12d06c0285 = /* #__PURE__ */ function() {
    function DecodeError(value0) {
        this.value0 = value0;
    }
    DecodeError.create = function(value0) {
        return new DecodeError(value0);
    };
    return DecodeError;
}();
var $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17 = /* #__PURE__ */ function() {
    function QueryError(value0) {
        this.value0 = value0;
    }
    QueryError.create = function(value0) {
        return new QueryError(value0);
    };
    return QueryError;
}();
var $54dae5ca6a6cd16d$export$90a530fd5ef57012 = /* #__PURE__ */ function() {
    function StringError(value0) {
        this.value0 = value0;
    }
    StringError.create = function(value0) {
        return new StringError(value0);
    };
    return StringError;
}();
var $54dae5ca6a6cd16d$export$d66a470e50d9b480 = /* #__PURE__ */ function() {
    function WithContext(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    WithContext.create = function(value0) {
        return function(value1) {
            return new WithContext(value0, value1);
        };
    };
    return WithContext;
}();
var $54dae5ca6a6cd16d$export$60e9e0884ce12b55 = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v1.value0));
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
        throw new Error("Failed pattern match at Error (line 183, column 1 - line 183, column 67): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $54dae5ca6a6cd16d$export$62db1f403973a02e = function(dictMonad) {
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(f) {
        return function(ext) {
            return bind2($d2284b2d3e1b6f87$export$8291c2122093ac93(ext))(function(ret) {
                return pure1($54dae5ca6a6cd16d$export$60e9e0884ce12b55(f)(ret));
            });
        };
    };
};
var $54dae5ca6a6cd16d$export$5055e1049c39d225 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v instanceof $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17) {
            var msgM = $54dae5ca6a6cd16d$var$bind($396c4c3d9e7fae3c$export$b610b8812bbcded9(v.value0)(0))(function(json) {
                return $54dae5ca6a6cd16d$var$bind($7d4cccdf062a2261$export$3a6c138b8d0f3874($160716589b57c4ec$export$10fbded63f740d7b(json)))(function(obj) {
                    return $7d4cccdf062a2261$export$3a6c138b8d0f3874($54dae5ca6a6cd16d$var$getField(obj)("message"));
                });
            });
            if (msgM instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                $tco_done = true;
                return msgM.value0;
            }
            if (msgM instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                $tco_done = true;
                return $c3328e54cdf5154c$export$5a1a8430df9521e("generic-error");
            }
            throw new Error("Failed pattern match at Error (line 72, column 5 - line 74, column 53): " + [
                msgM.constructor.name
            ]);
        }
        if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480) {
            $copy_v = v.value1;
            return;
        }
        $tco_done = true;
        return $c3328e54cdf5154c$export$5a1a8430df9521e("generic-error");
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $54dae5ca6a6cd16d$export$7afb3afc90ff096a = function(dictMonad) {
    var withError$prime1 = $54dae5ca6a6cd16d$export$62db1f403973a02e(dictMonad);
    return function(ctx) {
        return withError$prime1($54dae5ca6a6cd16d$export$d66a470e50d9b480.create(ctx));
    };
};
var $54dae5ca6a6cd16d$export$60030d78f255e2a6 = function(ctx) {
    return $54dae5ca6a6cd16d$export$60e9e0884ce12b55($54dae5ca6a6cd16d$export$d66a470e50d9b480.create(ctx));
};
var $54dae5ca6a6cd16d$export$9369204ebde44ca0 = function($192) {
    return $54dae5ca6a6cd16d$export$60030d78f255e2a6($54dae5ca6a6cd16d$export$7a0047718fb8649d.create($192));
};
var $54dae5ca6a6cd16d$export$2b487ea8ea8b1c9b = function($193) {
    return $54dae5ca6a6cd16d$export$60030d78f255e2a6($54dae5ca6a6cd16d$export$4146092e8212e5a6.create($193));
};
var $54dae5ca6a6cd16d$export$226c98f2a504b8e8 = function($194) {
    return $54dae5ca6a6cd16d$export$60030d78f255e2a6($54dae5ca6a6cd16d$export$19d787e6e83e848f.create($194));
};
var $54dae5ca6a6cd16d$export$3f0947e3fa333b61 = {
    show: function(v) {
        if (v instanceof $54dae5ca6a6cd16d$export$4146092e8212e5a6) return "form widget \"" + (v.value0 + "\"");
        if (v instanceof $54dae5ca6a6cd16d$export$7a0047718fb8649d) return "purescript module \"" + (v.value0 + "\"");
        if (v instanceof $54dae5ca6a6cd16d$export$567b4060ab81ee4f) return "form \"" + (v.value1 + ("\" (" + ($308f9765feb7633d$export$a1b0f5347d2470b(v.value0) + ")")));
        if (v instanceof $54dae5ca6a6cd16d$export$8acaf7dd4f436a03) return "query \"" + (v.value0.query + "\"");
        if (v instanceof $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c && v.value0 === "") return "while loading json: \"" + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value1) + "\"");
        if (v instanceof $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c) return "while loading " + (v.value0 + (" json: \"" + ($0e031af7428ef07d$export$fac44ee5b035f737(v.value1) + "\"")));
        if (v instanceof $54dae5ca6a6cd16d$export$19d787e6e83e848f) return "while " + v.value0;
        throw new Error("Failed pattern match at Error (line 165, column 1 - line 172, column 48): " + [
            v.constructor.name
        ]);
    }
};
var $54dae5ca6a6cd16d$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$3f0947e3fa333b61);
var $54dae5ca6a6cd16d$export$54aef60b1a6d6353 = {
    show: function(v) {
        if (v instanceof $54dae5ca6a6cd16d$export$9ab1d64c21a55caa) return $3b38984084ed8eff$export$55ee1551a3f962e6(v.value0);
        if (v instanceof $54dae5ca6a6cd16d$export$ef3eed12d06c0285) return $826fbbc6c8d1e9e2$export$f0345d087708be2e(v.value0);
        if (v instanceof $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17) return "backend rejected query";
        if (v instanceof $54dae5ca6a6cd16d$export$90a530fd5ef57012) return v.value0;
        if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480) return $54dae5ca6a6cd16d$var$show(v.value0) + (": " + $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$54aef60b1a6d6353)(v.value1));
        throw new Error("Failed pattern match at Error (line 62, column 1 - line 67, column 62): " + [
            v.constructor.name
        ]);
    }
};
var $54dae5ca6a6cd16d$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $54dae5ca6a6cd16d$export$ee963cafee2c98f = function(v) {
    if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480 && v.value0 instanceof $54dae5ca6a6cd16d$export$8acaf7dd4f436a03) return $54dae5ca6a6cd16d$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("error-context-wrapper pl-4")
    ])([
        $54dae5ca6a6cd16d$var$p$prime([
            $54dae5ca6a6cd16d$var$text("While executing the following query: ")
        ]),
        $54dae5ca6a6cd16d$var$pre$prime([
            $54dae5ca6a6cd16d$var$text(v.value0.value0.query)
        ]),
        $54dae5ca6a6cd16d$var$details$prime([
            $54dae5ca6a6cd16d$var$summary$prime([
                $54dae5ca6a6cd16d$var$text("Click to show query variables")
            ]),
            $54dae5ca6a6cd16d$var$pre$prime([
                $54dae5ca6a6cd16d$var$text($fecd5c800d519006$export$d3626b236bde6194(v.value0.value0.vars))
            ])
        ]),
        $54dae5ca6a6cd16d$export$ee963cafee2c98f(v.value1)
    ]);
    if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480 && v.value0 instanceof $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c) return $54dae5ca6a6cd16d$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("error-context-wrapper pl-4")
    ])([
        $54dae5ca6a6cd16d$var$details$prime([
            $54dae5ca6a6cd16d$var$summary$prime([
                $54dae5ca6a6cd16d$var$text("While decoding JSON data" + function() {
                    var $153 = v.value0.value0 === "";
                    if ($153) return "";
                    return " for " + v.value0.value0;
                }())
            ]),
            $54dae5ca6a6cd16d$var$pre$prime([
                $54dae5ca6a6cd16d$var$text($fecd5c800d519006$export$d3626b236bde6194(v.value0.value1))
            ])
        ]),
        $54dae5ca6a6cd16d$export$ee963cafee2c98f(v.value1)
    ]);
    if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480) return $54dae5ca6a6cd16d$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("error-context-wrapper pl-4")
    ])([
        $54dae5ca6a6cd16d$var$text("In context: " + $54dae5ca6a6cd16d$var$show(v.value0)),
        $54dae5ca6a6cd16d$export$ee963cafee2c98f(v.value1)
    ]);
    if (v instanceof $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17) return $54dae5ca6a6cd16d$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("error-context-error pl-4")
    ])([
        $54dae5ca6a6cd16d$var$text("The backend rejected the query with the following errors:"),
        $54dae5ca6a6cd16d$var$ul$prime($54dae5ca6a6cd16d$var$map(function(msg) {
            return $54dae5ca6a6cd16d$var$li$prime([
                $54dae5ca6a6cd16d$var$pre$prime([
                    $54dae5ca6a6cd16d$var$text($fecd5c800d519006$export$d3626b236bde6194(msg))
                ])
            ]);
        })(v.value0))
    ]);
    return $54dae5ca6a6cd16d$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("error-context-error pl-4")
    ])([
        $54dae5ca6a6cd16d$var$p$prime([
            $54dae5ca6a6cd16d$var$text("Error: " + $54dae5ca6a6cd16d$var$show1(v))
        ])
    ]);
};
var $54dae5ca6a6cd16d$export$85beb7f97103a98f = function(err) {
    return $54dae5ca6a6cd16d$var$div$prime([
        $54dae5ca6a6cd16d$var$p$prime([
            $54dae5ca6a6cd16d$var$text("More information about this error:")
        ]),
        $54dae5ca6a6cd16d$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("error-details")
        ])([
            $54dae5ca6a6cd16d$export$ee963cafee2c98f(err)
        ])
    ]);
};
var $54dae5ca6a6cd16d$export$d0c9705ad8865b5b = /* #__PURE__ */ $54dae5ca6a6cd16d$var$bind1(/* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($54dae5ca6a6cd16d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5)([
    $fc1df90f0e252058$export$1d5a917feb871989,
    /* #__PURE__ */ $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary")
])([
    /* #__PURE__ */ $54dae5ca6a6cd16d$var$text(/* #__PURE__ */ $c3328e54cdf5154c$export$5a1a8430df9521e("error-button-text"))
]))(function() {
    return $54dae5ca6a6cd16d$var$discard($54dae5ca6a6cd16d$var$liftEffect($fecd5c800d519006$export$da22d4a5076a7905))(function() {
        return $9c13a1c3d948adb8$export$be9e2feb4e35335b($54dae5ca6a6cd16d$var$div$prime([]));
    });
});
var $54dae5ca6a6cd16d$export$89d3cd2224a8f723 = function(fn) {
    return function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(fn(v.value0));
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
        throw new Error("Failed pattern match at Error (line 263, column 13 - line 265, column 23): " + [
            v.constructor.name
        ]);
    };
};
var $54dae5ca6a6cd16d$export$15cc39a7848d0e13 = /* #__PURE__ */ function() {
    return $54dae5ca6a6cd16d$export$89d3cd2224a8f723($54dae5ca6a6cd16d$export$ef3eed12d06c0285.create);
}();
var $54dae5ca6a6cd16d$export$bc0012033e3e059a = function(obj) {
    return $54dae5ca6a6cd16d$export$89d3cd2224a8f723(function() {
        var $195 = $54dae5ca6a6cd16d$export$d66a470e50d9b480.create(new $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c("", obj));
        return function($196) {
            return $195($54dae5ca6a6cd16d$export$ef3eed12d06c0285.create($196));
        };
    }());
};
var $54dae5ca6a6cd16d$export$6ed5c3faa96d8c27 = function(v) {
    if (v instanceof $54dae5ca6a6cd16d$export$4146092e8212e5a6) return new $71f2e2e9476163f8$export$1908877435b1d5e9("form-widget", $54dae5ca6a6cd16d$var$encodeJson({
        widget: v.value0
    }));
    if (v instanceof $54dae5ca6a6cd16d$export$7a0047718fb8649d) return new $71f2e2e9476163f8$export$1908877435b1d5e9("module", $54dae5ca6a6cd16d$var$encodeJson1({
        module: v.value0
    }));
    if (v instanceof $54dae5ca6a6cd16d$export$567b4060ab81ee4f) return new $71f2e2e9476163f8$export$1908877435b1d5e9("form", $54dae5ca6a6cd16d$var$encodeJson2({
        id: v.value0,
        name: v.value1
    }));
    if (v instanceof $54dae5ca6a6cd16d$export$8acaf7dd4f436a03) return new $71f2e2e9476163f8$export$1908877435b1d5e9("query", $54dae5ca6a6cd16d$var$encodeJson3({
        query: v.value0.query,
        vars: $fecd5c800d519006$export$d3626b236bde6194(v.value0.vars)
    }));
    if (v instanceof $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c) return new $71f2e2e9476163f8$export$1908877435b1d5e9("load-json-" + v.value0, $54dae5ca6a6cd16d$var$encodeJson4({
        description: v.value0,
        json: $fecd5c800d519006$export$d3626b236bde6194(v.value1)
    }));
    if (v instanceof $54dae5ca6a6cd16d$export$19d787e6e83e848f) return new $71f2e2e9476163f8$export$1908877435b1d5e9("action", $54dae5ca6a6cd16d$var$encodeJson5({
        action: v.value0
    }));
    throw new Error("Failed pattern match at Error (line 149, column 1 - line 149, column 51): " + [
        v.constructor.name
    ]);
};
var $54dae5ca6a6cd16d$export$e6bdd734f9870f4 = function(errId) {
    return function(btn) {
        return function(inner) {
            return $54dae5ca6a6cd16d$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("error-page")
            ])([
                $54dae5ca6a6cd16d$var$h1$prime([
                    $54dae5ca6a6cd16d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("error-page-header"))
                ]),
                $54dae5ca6a6cd16d$var$p$prime([
                    $54dae5ca6a6cd16d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("error-refcode-text") + (" " + errId))
                ]),
                $54dae5ca6a6cd16d$var$p$prime([
                    $54dae5ca6a6cd16d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("error-button-pre-text"))
                ]),
                btn,
                inner
            ]);
        };
    };
};
var $54dae5ca6a6cd16d$export$7e605cc38c3f1d09 = function(errId) {
    return $54dae5ca6a6cd16d$export$e6bdd734f9870f4(errId)($54dae5ca6a6cd16d$export$d0c9705ad8865b5b);
};
var $54dae5ca6a6cd16d$export$628836688a001f61 = function(v) {
    if (v instanceof $54dae5ca6a6cd16d$export$4146092e8212e5a6) return "in form widget " + (v.value0 + ": ");
    if (v instanceof $54dae5ca6a6cd16d$export$567b4060ab81ee4f) return "form \"" + (v.value1 + ("\" (" + ($308f9765feb7633d$export$a1b0f5347d2470b(v.value0) + "): ")));
    if (v instanceof $54dae5ca6a6cd16d$export$19d787e6e83e848f) return "while " + (v.value0 + ": ");
    return "";
};
var $54dae5ca6a6cd16d$export$85f2cbbfc129c733 = function(v) {
    if (v instanceof $54dae5ca6a6cd16d$export$d66a470e50d9b480) {
        var v1 = $54dae5ca6a6cd16d$export$6ed5c3faa96d8c27(v.value0);
        var inner = $54dae5ca6a6cd16d$export$85f2cbbfc129c733(v.value1);
        var $182 = $c045ea5df33bba60$export$6a0d13241802fe80(v1.value0)(inner.contexts);
        if ($182) return inner;
        return {
            message: $54dae5ca6a6cd16d$export$628836688a001f61(v.value0) + inner.message,
            contexts: $c045ea5df33bba60$export$21a5ca8aa77d35ff(v1.value0)(v1.value1)(inner.contexts)
        };
    }
    if (v instanceof $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17) return {
        message: $54dae5ca6a6cd16d$var$show1(v),
        contexts: $54dae5ca6a6cd16d$var$fromHomogeneous({
            backend_errors: $54dae5ca6a6cd16d$var$encodeJson6({
                errors: v.value0
            })
        })
    };
    return {
        message: $54dae5ca6a6cd16d$var$show1(v),
        contexts: $03b6b966974423fe$export$6e22c362a0406a2c
    };
};
var $54dae5ca6a6cd16d$export$b33b857ad1d9900e = function(error) {
    var serror = $54dae5ca6a6cd16d$export$85f2cbbfc129c733(error);
    return $fecd5c800d519006$export$3e205fbb5df021e0(serror);
};
var $54dae5ca6a6cd16d$export$e14a5bba978ec5e6 = function(err) {
    return $54dae5ca6a6cd16d$var$bind1($54dae5ca6a6cd16d$var$liftEffect($54dae5ca6a6cd16d$export$b33b857ad1d9900e(err)))(function(errId) {
        return $54dae5ca6a6cd16d$export$7e605cc38c3f1d09(errId)(function() {
            if ($fecd5c800d519006$export$13633b34445fbb34) return $54dae5ca6a6cd16d$var$div$prime([]);
            return $54dae5ca6a6cd16d$export$85beb7f97103a98f(err);
        }());
    });
};
var $54dae5ca6a6cd16d$export$b356868cfa7ebfaf = function(v) {
    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $54dae5ca6a6cd16d$export$e14a5bba978ec5e6(v.value0);
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $54dae5ca6a6cd16d$var$pure(v.value0);
    throw new Error("Failed pattern match at Error (line 219, column 1 - line 219, column 65): " + [
        v.constructor.name
    ]);
};



// Generated by purs version 0.15.16
"use strict";
function $b8b5a8fce67f6baf$var$getEndpoint() {
    if (typeof window !== "undefined" && window.graphqlEndpoint !== undefined) return window.graphqlEndpoint;
    return "https://hourrepublic.com/graphql";
}
const $b8b5a8fce67f6baf$export$afd40dda5f2bcea1 = $b8b5a8fce67f6baf$var$getEndpoint();





// Generated by purs version 0.15.16
const $d615f2c6d9bee660$export$7a292f067638ecd6 = {
    newXHR: function() {
        return new XMLHttpRequest();
    },
    fixupUrl: function(url) {
        return url || "/";
    }
};



var $f13553b3f174bc1f$export$b5fe3f66a567bec0 = /* #__PURE__ */ $3b38984084ed8eff$export$b5fe3f66a567bec0($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3ea07e5c3343cd8a = /* #__PURE__ */ $3b38984084ed8eff$export$3ea07e5c3343cd8a($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$327f7b26ebf455db = /* #__PURE__ */ $3b38984084ed8eff$export$327f7b26ebf455db($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$a51007acc2c57e79 = /* #__PURE__ */ $3b38984084ed8eff$export$a51007acc2c57e79($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$299ba2dee77727e9 = /* #__PURE__ */ $3b38984084ed8eff$export$299ba2dee77727e9($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3e5572abde0c1b7c = /* #__PURE__ */ $3b38984084ed8eff$export$3e5572abde0c1b7c($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$b76953f99ab2be78 = /* #__PURE__ */ $3b38984084ed8eff$export$b76953f99ab2be78($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$3988ae62b71be9a3 = /* #__PURE__ */ $3b38984084ed8eff$export$3988ae62b71be9a3($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$38dab5a9fea42f39 = /* #__PURE__ */ $3b38984084ed8eff$export$38dab5a9fea42f39($d615f2c6d9bee660$export$7a292f067638ecd6);
var $f13553b3f174bc1f$export$1822828d790e23ee = /* #__PURE__ */ $3b38984084ed8eff$export$1822828d790e23ee($d615f2c6d9bee660$export$7a292f067638ecd6);



















// Generated by purs version 0.15.16
const $e139d588280c354c$export$b8cb59497041ffe4 = function() {
    return new FormData();
};
function $e139d588280c354c$export$a9d18894d43032e5(form) {
    return new FormData(form);
}
function $e139d588280c354c$export$fa2153fda28fea6d(name, value, fd) {
    fd.append(name, value);
}
function $e139d588280c354c$export$3a5f1f0ee7ea90cb(name, value, filename, fd) {
    fd.append(name, value, filename === null ? undefined : filename);
}
function $e139d588280c354c$export$2fb2ec4781d63dfe(name, fd) {
    fd.delete(name);
}
function $e139d588280c354c$export$a9fc2f851320fb80(name, fd) {
    return fd.has(name);
}
function $e139d588280c354c$export$c37fd9e9b598996d(name, value, fd) {
    fd.set(name, value);
}
function $e139d588280c354c$export$47523a8f6827477c(name, value, filename, fd) {
    fd.set(name, value, filename === null ? undefined : filename);
}





var $4708303b99a0a8e4$export$2a0b83121174119c = function(x) {
    return x;
};
var $4708303b99a0a8e4$export$d73c7dcffc4eb714 = function(x) {
    return x;
};
var $4708303b99a0a8e4$export$a7dc629f8b7f4d34 = function(name) {
    return function(value) {
        return function(filename) {
            return function(fd) {
                return function() {
                    return $e139d588280c354c$export$47523a8f6827477c(name, value, $0a5aaf95f168428e$export$b187f57ee1822bc5(filename), fd);
                };
            };
        };
    };
};
var $4708303b99a0a8e4$export$adaa4cf7ef1b65be = function(name) {
    return function(value) {
        return function(fd) {
            return function() {
                return $e139d588280c354c$export$c37fd9e9b598996d(name, value, fd);
            };
        };
    };
};
var $4708303b99a0a8e4$export$52d4c8d61dd144f3 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $4708303b99a0a8e4$export$ccaef4f03a142ab4 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $4708303b99a0a8e4$export$bc327eed2a891201 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4708303b99a0a8e4$export$7386142afaaf2f78 = {
    Coercible0: function() {
        return undefined;
    }
};
var $4708303b99a0a8e4$export$a4f4bb6b1453fff5 = function(name) {
    return function(fd) {
        return function() {
            return $e139d588280c354c$export$a9fc2f851320fb80(name, fd);
        };
    };
};
var $4708303b99a0a8e4$export$8f88a05061aefa79 = function(formElement) {
    return function() {
        return $e139d588280c354c$export$a9d18894d43032e5(formElement);
    };
};
var $4708303b99a0a8e4$export$73af48faab05dff3 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $4708303b99a0a8e4$export$1cb55df3961dbaea = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $4708303b99a0a8e4$export$1822828d790e23ee = function(name) {
    return function(fd) {
        return function() {
            return $e139d588280c354c$export$2fb2ec4781d63dfe(name, fd);
        };
    };
};
var $4708303b99a0a8e4$export$2324ccddf8ab9738 = function(name) {
    return function(value) {
        return function(filename) {
            return function(fd) {
                return function() {
                    return $e139d588280c354c$export$3a5f1f0ee7ea90cb(name, value, $0a5aaf95f168428e$export$b187f57ee1822bc5(filename), fd);
                };
            };
        };
    };
};
var $4708303b99a0a8e4$export$10d8903dec122b9d = function(name) {
    return function(value) {
        return function(fd) {
            return function() {
                return $e139d588280c354c$export$fa2153fda28fea6d(name, value, fd);
            };
        };
    };
};


var $42ad8b7b0d01e859$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $42ad8b7b0d01e859$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $42ad8b7b0d01e859$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $42ad8b7b0d01e859$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $42ad8b7b0d01e859$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $42ad8b7b0d01e859$var$variablesIsSymbol = {
    reflectSymbol: function() {
        return "variables";
    }
};
var $42ad8b7b0d01e859$var$queryIsSymbol = {
    reflectSymbol: function() {
        return "query";
    }
};
var $42ad8b7b0d01e859$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $42ad8b7b0d01e859$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $42ad8b7b0d01e859$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $42ad8b7b0d01e859$export$a68ddf4221613c1f = function(dictFoldable) {
    var intercalate = $4fe7b6acfba7f29f$export$739ec22334c44788(dictFoldable)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
    return function(params) {
        return "(" + (intercalate(",")(params) + ")");
    };
};
var $42ad8b7b0d01e859$export$ecfd28d30903330f = function(dictDecodeJson) {
    var getField1 = $cbbc8ce596810eef$export$2c9b3f539cb25b05(dictDecodeJson);
    return function(json) {
        return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($42ad8b7b0d01e859$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(obj) {
            return getField1(obj)("data");
        }));
    };
};
var $42ad8b7b0d01e859$export$e16431d9c78704f = function(path) {
    return "{\"0\":[\"" + (path + "\"]}");
};
var $42ad8b7b0d01e859$export$ca3de6e649261490 = function(obj) {
    var collapse = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v.value0;
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$19d787e6e83e848f("gathering information about another error"), v.value0);
        throw new Error("Failed pattern match at GraphQL (line 71, column 5 - line 71, column 65): " + [
            v.constructor.name
        ]);
    };
    return collapse($54dae5ca6a6cd16d$export$bc0012033e3e059a($0e031af7428ef07d$export$dbafa4424a806c15(obj))($42ad8b7b0d01e859$var$bind($42ad8b7b0d01e859$var$getField(obj)("errors"))(function(v) {
        return new $7d4cccdf062a2261$export$19db0165690c701a(new $54dae5ca6a6cd16d$export$83dcbdfe8cbc1e17(v));
    })));
};
var $42ad8b7b0d01e859$export$c21553f382a3af0e = function(result) {
    return $42ad8b7b0d01e859$var$pure(function() {
        if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$9ab1d64c21a55caa(result.value0));
        if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
            var v = $160716589b57c4ec$export$10fbded63f740d7b(result.value0.body);
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && $c045ea5df33bba60$export$6a0d13241802fe80("errors")(v.value0)) return new $7d4cccdf062a2261$export$37c4d04eafdc5515($42ad8b7b0d01e859$export$ca3de6e649261490(v.value0));
            return new $7d4cccdf062a2261$export$19db0165690c701a(result.value0.body);
        }
        throw new Error("Failed pattern match at GraphQL (line 58, column 28 - line 63, column 32): " + [
            result.constructor.name
        ]);
    }());
};
var $42ad8b7b0d01e859$export$2fa187e846a241c4 = function(dictEncodeJson) {
    var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$2aa47014064a90c3($42ad8b7b0d01e859$var$gEncodeJsonCons($eb7399d322077fcf$export$cc2f530f06b3b8c8(dictEncodeJson)($eb7399d322077fcf$export$12b4d820b2ffc726)($42ad8b7b0d01e859$var$variablesIsSymbol)())($42ad8b7b0d01e859$var$queryIsSymbol)())());
    return function(qstr) {
        return function(vars) {
            var queryCtx = new $54dae5ca6a6cd16d$export$8acaf7dd4f436a03({
                query: qstr,
                vars: encodeJson(vars)
            });
            return $42ad8b7b0d01e859$var$map($54dae5ca6a6cd16d$export$60030d78f255e2a6(queryCtx))(function() {
                var content = encodeJson1({
                    query: qstr,
                    variables: vars
                });
                return $42ad8b7b0d01e859$var$bind1($f13553b3f174bc1f$export$b5fe3f66a567bec0({
                    headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
                    username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
                    password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
                    timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
                    method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$484f3009c2ee32ad.value),
                    url: $b8b5a8fce67f6baf$export$afd40dda5f2bcea1,
                    content: new $06733ae99ed4f534$export$8a67b48435b5d073(new $1bb5df538ea16bd9$export$48880ac635f47186(content)),
                    responseFormat: $c02e13aaef170b91$export$7b419323e6ed4f31,
                    withCredentials: true
                }))(function(res) {
                    return $42ad8b7b0d01e859$export$c21553f382a3af0e(res);
                });
            }());
        };
    };
};
var $42ad8b7b0d01e859$export$3c598703d99462f5 = function(dictEncodeJson) {
    var query1 = $42ad8b7b0d01e859$export$2fa187e846a241c4(dictEncodeJson);
    return function(dictDecodeJson) {
        var getResultData1 = $42ad8b7b0d01e859$export$ecfd28d30903330f(dictDecodeJson);
        return function(qstr) {
            return function(vars) {
                return $42ad8b7b0d01e859$var$bind1(query1(qstr)(vars))(function(res) {
                    return $42ad8b7b0d01e859$var$pure($42ad8b7b0d01e859$var$bindFlipped(getResultData1)(res));
                });
            };
        };
    };
};
var $42ad8b7b0d01e859$export$fb86691010426278 = function(formData) {
    return $42ad8b7b0d01e859$var$bind1($f13553b3f174bc1f$export$b5fe3f66a567bec0({
        headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
        username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
        password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
        timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
        method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$484f3009c2ee32ad.value),
        url: $b8b5a8fce67f6baf$export$afd40dda5f2bcea1,
        content: new $06733ae99ed4f534$export$8a67b48435b5d073(new $1bb5df538ea16bd9$export$3963aa24c930693c(formData)),
        responseFormat: $c02e13aaef170b91$export$7b419323e6ed4f31,
        withCredentials: true
    }))(function(res) {
        return $42ad8b7b0d01e859$export$c21553f382a3af0e(res);
    });
};
var $42ad8b7b0d01e859$export$492d5489ce6d03b8 = function(dictEncodeJson) {
    var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$2aa47014064a90c3($42ad8b7b0d01e859$var$gEncodeJsonCons($eb7399d322077fcf$export$cc2f530f06b3b8c8(dictEncodeJson)($eb7399d322077fcf$export$12b4d820b2ffc726)($42ad8b7b0d01e859$var$variablesIsSymbol)())($42ad8b7b0d01e859$var$queryIsSymbol)())());
    return function(qstr) {
        return function(vars) {
            return function(vname) {
                return function(fname) {
                    return function(blob) {
                        var content = encodeJson({
                            query: qstr,
                            variables: vars
                        });
                        return $42ad8b7b0d01e859$var$bind1($42ad8b7b0d01e859$var$liftEffect(function __do() {
                            var fd = $e139d588280c354c$export$b8cb59497041ffe4();
                            $4708303b99a0a8e4$export$10d8903dec122b9d("operations")($0e031af7428ef07d$export$fac44ee5b035f737(content))(fd)();
                            $4708303b99a0a8e4$export$10d8903dec122b9d("map")($42ad8b7b0d01e859$export$e16431d9c78704f("variables." + vname))(fd)();
                            $4708303b99a0a8e4$export$2324ccddf8ab9738("0")(blob)(fname)(fd)();
                            return fd;
                        }))(function(formData) {
                            return $42ad8b7b0d01e859$export$fb86691010426278(formData);
                        });
                    };
                };
            };
        };
    };
};
var $42ad8b7b0d01e859$export$2bd65b6ddc13ad71 = function(dictEncodeJson) {
    var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(operations) {
        return function(filePath) {
            return function(fname) {
                return function(blob) {
                    var content = encodeJson(operations);
                    return $42ad8b7b0d01e859$var$bind1($42ad8b7b0d01e859$var$liftEffect(function __do() {
                        var fd = $e139d588280c354c$export$b8cb59497041ffe4();
                        $4708303b99a0a8e4$export$10d8903dec122b9d("operations")($0e031af7428ef07d$export$fac44ee5b035f737(content))(fd)();
                        $4708303b99a0a8e4$export$10d8903dec122b9d("map")($42ad8b7b0d01e859$export$e16431d9c78704f(filePath))(fd)();
                        $4708303b99a0a8e4$export$2324ccddf8ab9738("0")(blob)(fname)(fd)();
                        return fd;
                    }))(function(formData) {
                        return $42ad8b7b0d01e859$export$fb86691010426278(formData);
                    });
                };
            };
        };
    };
};


// Generated by purs version 0.15.16




















var $7c4f9de9dcfa2f59$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $7c4f9de9dcfa2f59$var$query = /* #__PURE__ */ $42ad8b7b0d01e859$export$2fa187e846a241c4($eb7399d322077fcf$export$35d3004eff90f123);
var $7c4f9de9dcfa2f59$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $7c4f9de9dcfa2f59$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $7c4f9de9dcfa2f59$var$encodeJsonArray = /* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b)(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$35d3004eff90f123)($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "variables";
    }
})())({
    reflectSymbol: function() {
        return "query";
    }
})())());
var $7c4f9de9dcfa2f59$var$batchFileQuery = /* #__PURE__ */ $42ad8b7b0d01e859$export$2bd65b6ddc13ad71($7c4f9de9dcfa2f59$var$encodeJsonArray);
var $7c4f9de9dcfa2f59$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $7c4f9de9dcfa2f59$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $7c4f9de9dcfa2f59$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $7c4f9de9dcfa2f59$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($7c4f9de9dcfa2f59$var$encodeJsonArray);
var $7c4f9de9dcfa2f59$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $7c4f9de9dcfa2f59$var$getField1 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5501dc3a72754845($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $7c4f9de9dcfa2f59$export$d528416aeec74a0f = /* #__PURE__ */ function() {
    function StringQuery(value0) {
        this.value0 = value0;
    }
    StringQuery.create = function(value0) {
        return new StringQuery(value0);
    };
    return StringQuery;
}();
var $7c4f9de9dcfa2f59$export$eac5b5550745e6a0 = {
    runGraphQL: function(v) {
        return $d2284b2d3e1b6f87$export$8291c2122093ac93($7c4f9de9dcfa2f59$var$bind($7c4f9de9dcfa2f59$var$query(v.value0.query.query)(v.value0.query.variables))(function(ret) {
            return $7c4f9de9dcfa2f59$var$except(v.value0.decode(ret));
        }));
    }
};
var $7c4f9de9dcfa2f59$export$48568730318ad8ae = {
    getQuery: function(v) {
        return v.value0.query;
    },
    getDecode: function(v) {
        return v.value0.decode;
    }
};
var $7c4f9de9dcfa2f59$export$88179411103cbcb0 = {
    show: function(v) {
        return "Query: " + v.value0.query.query;
    }
};
var $7c4f9de9dcfa2f59$export$4d82d2d5105d3377 = function(queries) {
    return function(upload) {
        return $7c4f9de9dcfa2f59$var$bind1($7c4f9de9dcfa2f59$var$batchFileQuery(queries)(upload.path)(upload.name)(upload.file))(function(resE) {
            return $7c4f9de9dcfa2f59$var$pure($7c4f9de9dcfa2f59$var$bind2(resE)(function(j) {
                return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($7c4f9de9dcfa2f59$var$decodeJson(j));
            }));
        });
    };
};
var $7c4f9de9dcfa2f59$export$7efd4163d8775bbe = function(queries) {
    var content = $7c4f9de9dcfa2f59$var$encodeJson(queries);
    return $7c4f9de9dcfa2f59$var$bind1($f13553b3f174bc1f$export$b5fe3f66a567bec0({
        headers: $3b38984084ed8eff$export$de89fc8561ede42f.headers,
        username: $3b38984084ed8eff$export$de89fc8561ede42f.username,
        password: $3b38984084ed8eff$export$de89fc8561ede42f.password,
        timeout: $3b38984084ed8eff$export$de89fc8561ede42f.timeout,
        method: new $7d4cccdf062a2261$export$37c4d04eafdc5515($0279ce8fdb6b506c$export$484f3009c2ee32ad.value),
        url: $b8b5a8fce67f6baf$export$afd40dda5f2bcea1,
        content: new $06733ae99ed4f534$export$8a67b48435b5d073(new $1bb5df538ea16bd9$export$48880ac635f47186(content)),
        responseFormat: $c02e13aaef170b91$export$7b419323e6ed4f31,
        withCredentials: true
    }))(function(res) {
        return $7c4f9de9dcfa2f59$var$bind1($42ad8b7b0d01e859$export$c21553f382a3af0e(res))(function(resE) {
            return $7c4f9de9dcfa2f59$var$pure($7c4f9de9dcfa2f59$var$bind2(resE)(function(j) {
                return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($7c4f9de9dcfa2f59$var$decodeJson(j));
            }));
        });
    });
};
var $7c4f9de9dcfa2f59$export$e26636bd8a4321dd = function(dict) {
    return dict.runGraphQL;
};
var $7c4f9de9dcfa2f59$export$d1b23fba9f6872eb = function(dictGraphQL) {
    var $103 = $7c4f9de9dcfa2f59$export$e26636bd8a4321dd(dictGraphQL);
    return function($104) {
        return $d2284b2d3e1b6f87$export$2e7afd25df37516b($103($104));
    };
};
var $7c4f9de9dcfa2f59$export$870efb4db0233841 = function(dict) {
    return dict.jqQueries;
};
var $7c4f9de9dcfa2f59$export$936ce2b08175dfd0 = {
    jqQueries: function(v) {
        return function(v1) {
            return [];
        };
    },
    jqDecode: function(v) {
        return function(v1) {
            return function(v2) {
                return function(v3) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a({});
                };
            };
        };
    }
};
var $7c4f9de9dcfa2f59$export$e7b8282393555416 = function(dict) {
    return dict.jqDecode;
};
var $7c4f9de9dcfa2f59$export$30df5e01129e087c = function() {
    return function(dictJoinQueries) {
        var jqQueries1 = $7c4f9de9dcfa2f59$export$870efb4db0233841(dictJoinQueries);
        var jqDecode1 = $7c4f9de9dcfa2f59$export$e7b8282393555416(dictJoinQueries);
        return function(queries) {
            return $7c4f9de9dcfa2f59$var$bind($7c4f9de9dcfa2f59$export$7efd4163d8775bbe(jqQueries1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries)))(function(ret) {
                return $7c4f9de9dcfa2f59$var$except(jqDecode1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries)(0)(ret));
            });
        };
    };
};
var $7c4f9de9dcfa2f59$var$multiQuery_1 = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$30df5e01129e087c();
var $7c4f9de9dcfa2f59$export$7789435de9307322 = function() {
    return function(dictJoinQueries) {
        var multiQuery_2 = $7c4f9de9dcfa2f59$var$multiQuery_1(dictJoinQueries);
        return function(queries) {
            return $d2284b2d3e1b6f87$export$8291c2122093ac93(multiQuery_2(queries));
        };
    };
};
var $7c4f9de9dcfa2f59$export$d18a3db8d9553503 = function(qstr) {
    return function(vars) {
        return function(decode) {
            return new $7c4f9de9dcfa2f59$export$d528416aeec74a0f({
                query: {
                    query: qstr,
                    variables: vars
                },
                decode: decode
            });
        };
    };
};
var $7c4f9de9dcfa2f59$export$e55fea976989f772 = function(dictEncodeJson) {
    var encodeJson1 = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
    return function(qstr) {
        return function(vars) {
            return function(decode) {
                return $7c4f9de9dcfa2f59$export$d18a3db8d9553503(qstr)(encodeJson1(vars))(decode);
            };
        };
    };
};
var $7c4f9de9dcfa2f59$export$71eec30d9db46a56 = function(dict) {
    return dict.getQuery;
};
var $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c = function(dict) {
    return dict.getDecode;
};
var $7c4f9de9dcfa2f59$export$7cf6fb124ade4099 = function(dictJoinQueries) {
    var jqQueries1 = $7c4f9de9dcfa2f59$export$870efb4db0233841(dictJoinQueries);
    var jqDecode1 = $7c4f9de9dcfa2f59$export$e7b8282393555416(dictJoinQueries);
    return function(dictIsSymbol) {
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        var $$delete = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
        var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(dictJoinableQuery) {
                            var getQuery1 = $7c4f9de9dcfa2f59$export$71eec30d9db46a56(dictJoinableQuery);
                            var getDecode1 = $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c(dictJoinableQuery);
                            return {
                                jqQueries: function(v) {
                                    return function(queries) {
                                        var query1 = getQuery1(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries));
                                        var rest = jqQueries1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries));
                                        return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(query1)(rest);
                                    };
                                },
                                jqDecode: function(v) {
                                    return function(queries) {
                                        return function(idx) {
                                            return function(arr) {
                                                return $7c4f9de9dcfa2f59$var$bind2($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Missing response for multi-query"))($396c4c3d9e7fae3c$export$b610b8812bbcded9(arr)(idx)))(function(json) {
                                                    var query1 = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries);
                                                    return $7c4f9de9dcfa2f59$var$bind2(getDecode1(query1)(json))(function(self) {
                                                        return $7c4f9de9dcfa2f59$var$bind2(jqDecode1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries))(idx + 1 | 0)(arr))(function(rest) {
                                                            return new $7d4cccdf062a2261$export$19db0165690c701a(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(self)(rest));
                                                        });
                                                    });
                                                });
                                            };
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var $7c4f9de9dcfa2f59$export$d1b64fe19a531b80 = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictEncodeJson) {
        var gqlQuery1 = $7c4f9de9dcfa2f59$export$e55fea976989f772(dictEncodeJson);
        return function(qstr) {
            return function(vars) {
                return function(decode$prime) {
                    var decode = function(json) {
                        return $7c4f9de9dcfa2f59$var$bind2(decode$prime(json))(function(json$prime) {
                            return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json$prime)(decodeJson1(json$prime));
                        });
                    };
                    return gqlQuery1(qstr)(vars)(decode);
                };
            };
        };
    };
};
var $7c4f9de9dcfa2f59$export$57b32ff8e362e0f = function(dictDecodeJson) {
    var decodeQuery_1 = $7c4f9de9dcfa2f59$export$d1b64fe19a531b80(dictDecodeJson);
    return function(dictEncodeJson) {
        var decodeQuery_2 = decodeQuery_1(dictEncodeJson);
        return function(qstr) {
            return function(vars) {
                return decodeQuery_2(qstr)(vars)(function(j) {
                    return $54dae5ca6a6cd16d$export$bc0012033e3e059a(j)($7c4f9de9dcfa2f59$var$bind2($160716589b57c4ec$export$10fbded63f740d7b(j))(function(v) {
                        return $7c4f9de9dcfa2f59$var$getField(v)("data");
                    }));
                });
            };
        };
    };
};
var $7c4f9de9dcfa2f59$export$72674312e1156357 = function(dictDecodeJson) {
    var decodeQuery_1 = $7c4f9de9dcfa2f59$export$d1b64fe19a531b80(dictDecodeJson);
    return function(dictEncodeJson) {
        var decodeQuery_2 = decodeQuery_1(dictEncodeJson);
        return function(qname) {
            return function(qstr) {
                return function(vars) {
                    return decodeQuery_2(qstr)(vars)(function(j) {
                        return $54dae5ca6a6cd16d$export$bc0012033e3e059a(j)($7c4f9de9dcfa2f59$var$bind2($7c4f9de9dcfa2f59$var$bind2($160716589b57c4ec$export$10fbded63f740d7b(j))(function(v) {
                            return $7c4f9de9dcfa2f59$var$getField1(v)("data");
                        }))(function(v) {
                            return $7c4f9de9dcfa2f59$var$getField(v)(qname);
                        }));
                    });
                };
            };
        };
    };
};


// Generated by purs version 0.15.16











// Generated by purs version 0.15.16











// Generated by purs version 0.15.16











var $d347d4a6047cfbb7$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $d347d4a6047cfbb7$export$32182de66c0f2dc = function(x) {
    return x;
};
var $d347d4a6047cfbb7$export$6a4f2e5f31d3761c = {};
var $d347d4a6047cfbb7$export$4739cdc7a16124b7 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$6fc9236c71f256a4 = {
    variantTags: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $d347d4a6047cfbb7$export$a263890827176f5b = function(dict) {
    return dict.variantTags;
};
var $d347d4a6047cfbb7$export$3e3102906739bb5 = function(dictVariantTags) {
    var variantTags1 = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return {
            variantTags: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value), variantTags1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $d347d4a6047cfbb7$export$d1aea78948817787 = {};
var $d347d4a6047cfbb7$export$1949f0d69e5abced = function() {
    return function() {
        return function(dictTypeEquals) {
            return {};
        };
    };
};
var $d347d4a6047cfbb7$export$6f0b08b36cbce25a = {};
var $d347d4a6047cfbb7$export$b5757a9808e9530a = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$741d3de26d29fa9f = {};
var $d347d4a6047cfbb7$export$45d721e92c315fa2 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$2b06a6b70b94fb9b = {};
var $d347d4a6047cfbb7$export$a29149e68f9502c0 = function() {
    return function() {
        return function(dictTypeEquals) {
            return {};
        };
    };
};
var $d347d4a6047cfbb7$export$d751f4e16bdd3580 = {};
var $d347d4a6047cfbb7$export$51fd493d6e05a16 = function() {
    return function() {
        return function() {
            return function(dictTypeEquals) {
                return {};
            };
        };
    };
};
var $d347d4a6047cfbb7$export$8c9c13f4abebac02 = /* #__PURE__ */ function() {
    var go = function($copy_ix) {
        return function($copy_v) {
            return function($copy_v1) {
                var $tco_var_ix = $copy_ix;
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(ix, v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0.cardinality > ix) {
                            var v2 = v1.value0.toEnum(ix);
                            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                $tco_done = true;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    type: v.value0,
                                    value: v2.value0
                                });
                            }
                            $tco_done = true;
                            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_ix = ix - v1.value0.cardinality | 0;
                            $tco_var_v = v.value1;
                            $copy_v1 = v1.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_ix, $tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
    };
    return go;
}();
var $d347d4a6047cfbb7$export$9da7ea4590baa01b = function(tag) {
    var go = function($copy_v) {
        var $tco_done = false;
        var $tco_result;
        function $tco_loop(v) {
            if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                if (v.value0 === tag) {
                    $tco_done = true;
                    return true;
                }
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    $copy_v = v.value1;
                    return;
                }
            }
            if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                $tco_done = true;
                return false;
            }
            throw new Error("Failed pattern match at Data.Variant.Internal (line 154, column 8 - line 158, column 18): " + [
                v.constructor.name
            ]);
        }
        while(!$tco_done)$tco_result = $tco_loop($copy_v);
        return $tco_result;
    };
    return go;
};
var $d347d4a6047cfbb7$export$75c8b177a15c9f3a = /* #__PURE__ */ function() {
    var go = function($copy_acc) {
        return function($copy_v) {
            var $tco_var_acc = $copy_acc;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(acc, v) {
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    $tco_var_acc = acc + v.value0.cardinality | 0;
                    $copy_v = v.value1;
                    return;
                }
                if (v instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                    $tco_done = true;
                    return acc;
                }
                throw new Error("Failed pattern match at Data.Variant.Internal (line 276, column 12 - line 278, column 16): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_v);
            return $tco_result;
        };
    };
    return go(0);
}();
var $d347d4a6047cfbb7$export$9562f45d0aad2672 = function(str) {
    return $8bcde8f642a64c7d$export$51b220bae4359b72("Data.Variant: impossible `" + (str + "`"));
};
var $d347d4a6047cfbb7$export$dfc7155ac0343b8 = function(name) {
    return function(tag) {
        var go = function($copy_v) {
            return function($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v.value0 === tag) {
                            $tco_done = true;
                            return v1.value0;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_v = v.value1;
                            $copy_v1 = v1.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$f2569b7ebfd16005 = function(tags) {
    return function(eqs) {
        return function(v) {
            return function(v1) {
                if (v.type === v1.type) return $d347d4a6047cfbb7$export$dfc7155ac0343b8("eq")(v.type)(tags)(eqs)(v.value)(v1.value);
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return false;
                throw new Error("Failed pattern match at Data.Variant.Internal (line 160, column 1 - line 165, column 12): " + [
                    tags.constructor.name,
                    eqs.constructor.name,
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $d347d4a6047cfbb7$export$109702b9a7154017 = function(tags) {
    return function(ords) {
        return function(v) {
            return function(v1) {
                var v3 = $d347d4a6047cfbb7$var$compare(v.type)(v1.type);
                if (v3 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return $d347d4a6047cfbb7$export$dfc7155ac0343b8("compare")(v.type)(tags)(ords)(v.value)(v1.value);
                return v3;
            };
        };
    };
};
var $d347d4a6047cfbb7$export$c21fa4428dbc447f = function(name) {
    return function(f) {
        var go = function(v) {
            return function(v1) {
                if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) return {
                    type: v.value0,
                    value: f(v1.value0)
                };
                return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$3c34dd558a358bbc = function(v) {
    var go = function($copy_acc) {
        return function($copy_v1) {
            return function($copy_v2) {
                var $tco_var_acc = $copy_acc;
                var $tco_var_v1 = $copy_v1;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, v1, v2) {
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0 === v.type) {
                            $tco_done = true;
                            return acc + v2.value0.fromEnum(v.value) | 0;
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_acc = acc + v2.value0.cardinality | 0;
                            $tco_var_v1 = v1.value1;
                            $copy_v2 = v2.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672("fromEnum");
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $tco_var_v1, $copy_v2);
                return $tco_result;
            };
        };
    };
    return go(0);
};
var $d347d4a6047cfbb7$export$53ce69aede1374ee = function(name) {
    return function(f) {
        var go = function($copy_v) {
            return function($copy_v1) {
                var $tco_var_v = $copy_v;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v, v1) {
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                        $tco_done = true;
                        return {
                            type: v.value0,
                            value: f(v1.value0)
                        };
                    }
                    if (v instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        $tco_var_v = v.value1;
                        $copy_v1 = v1.value1;
                        return;
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672(name);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $copy_v1);
                return $tco_result;
            };
        };
        return go;
    };
};
var $d347d4a6047cfbb7$export$5f7558b7e8dd3d2 = function(v) {
    var go2 = function($copy_t1) {
        return function($copy_b1) {
            return function($copy_v1) {
                return function($copy_v2) {
                    return function($copy_v3) {
                        return function($copy_v4) {
                            var $tco_var_t1 = $copy_t1;
                            var $tco_var_b1 = $copy_b1;
                            var $tco_var_v1 = $copy_v1;
                            var $tco_var_v2 = $copy_v2;
                            var $tco_var_v3 = $copy_v3;
                            var $tco_done = false;
                            var $tco_result;
                            function $tco_loop(t1, b1, v1, v2, v3, v4) {
                                if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v4 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    if (v2.value0 === v.type) {
                                        var v5 = v4.value0.pred(v.value);
                                        if (v5 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                            $tco_done = true;
                                            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                                type: t1,
                                                value: b1.top
                                            });
                                        }
                                        if (v5 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                            $tco_done = true;
                                            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                                type: v.type,
                                                value: v5.value0
                                            });
                                        }
                                        throw new Error("Failed pattern match at Data.Variant.Internal (line 244, column 11 - line 246, column 69): " + [
                                            v5.constructor.name
                                        ]);
                                    }
                                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                                        $tco_var_t1 = v2.value0;
                                        $tco_var_b1 = v3.value0;
                                        $tco_var_v1 = v4.value0;
                                        $tco_var_v2 = v2.value1;
                                        $tco_var_v3 = v3.value1;
                                        $copy_v4 = v4.value1;
                                        return;
                                    }
                                }
                                $tco_done = true;
                                return $d347d4a6047cfbb7$export$9562f45d0aad2672("pred");
                            }
                            while(!$tco_done)$tco_result = $tco_loop($tco_var_t1, $tco_var_b1, $tco_var_v1, $tco_var_v2, $tco_var_v3, $copy_v4);
                            return $tco_result;
                        };
                    };
                };
            };
        };
    };
    var go1 = function(v1) {
        return function(v2) {
            return function(v3) {
                if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    if (v1.value0 === v.type) {
                        var v4 = v3.value0.pred(v.value);
                        if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                            type: v.type,
                            value: v4.value0
                        });
                        throw new Error("Failed pattern match at Data.Variant.Internal (line 235, column 11 - line 237, column 69): " + [
                            v4.constructor.name
                        ]);
                    }
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return go2(v1.value0)(v2.value0)(v3.value0)(v1.value1)(v2.value1)(v3.value1);
                }
                return $d347d4a6047cfbb7$export$9562f45d0aad2672("pred");
            };
        };
    };
    return go1;
};
var $d347d4a6047cfbb7$export$df26e2801d56dff3 = function(v) {
    var go = function($copy_v1) {
        return function($copy_v2) {
            return function($copy_v3) {
                var $tco_var_v1 = $copy_v1;
                var $tco_var_v2 = $copy_v2;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(v1, v2, v3) {
                    if (v1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v3 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                        if (v1.value0 === v.type) {
                            var v4 = v3.value0.succ(v.value);
                            if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                $tco_done = true;
                                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    type: v1.value0,
                                    value: v4.value0
                                });
                            }
                            if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                                if (v1.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && v2.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                    $tco_done = true;
                                    return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                        type: v1.value1.value0,
                                        value: v2.value1.value0.bottom
                                    });
                                }
                                $tco_done = true;
                                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            }
                            throw new Error("Failed pattern match at Data.Variant.Internal (line 262, column 11 - line 266, column 29): " + [
                                v4.constructor.name
                            ]);
                        }
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                            $tco_var_v1 = v1.value1;
                            $tco_var_v2 = v2.value1;
                            $copy_v3 = v3.value1;
                            return;
                        }
                    }
                    $tco_done = true;
                    return $d347d4a6047cfbb7$export$9562f45d0aad2672("succ");
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_v1, $tco_var_v2, $copy_v3);
                return $tco_result;
            };
        };
    };
    return go;
};
var $d347d4a6047cfbb7$export$e85cf2e1daa1e0a4 = function() {
    return function() {
        return function(dictVariantTags) {
            var variantTags1 = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
            return {
                contractWith: function(dictAlternative) {
                    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
                    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
                    return function(v) {
                        return function(v1) {
                            return function(tag) {
                                return function(a) {
                                    if ($d347d4a6047cfbb7$export$9da7ea4590baa01b(tag)(variantTags1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))) return pure(a);
                                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return empty;
                                    throw new Error("Failed pattern match at Data.Variant.Internal (line 315, column 1 - line 324, column 24): " + [
                                        v.constructor.name,
                                        v1.constructor.name,
                                        tag.constructor.name,
                                        a.constructor.name
                                    ]);
                                };
                            };
                        };
                    };
                }
            };
        };
    };
};
var $d347d4a6047cfbb7$export$3f68b7f308cef1ff = function(dict) {
    return dict.contractWith;
};






var $a5ccce070b256bc7$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e4b6cd05df3043f6);
var $a5ccce070b256bc7$export$23f56de7015da7e2 = function(x) {
    return x;
};
var $a5ccce070b256bc7$export$38e1d92de9476ba9 = function(dict) {
    return dict.variantShows;
};
var $a5ccce070b256bc7$export$d424ff163a450f59 = function(dict) {
    return dict.variantOrds;
};
var $a5ccce070b256bc7$export$e23cdac3d43a2502 = function(dict) {
    return dict.variantEqs;
};
var $a5ccce070b256bc7$export$ac5da622fbb79b7a = function(dict) {
    return dict.variantBoundedEnums;
};
var $a5ccce070b256bc7$export$4a2422da06e04a63 = function(dict) {
    return dict.variantBounded;
};
var $a5ccce070b256bc7$export$82222823f552eea3 = function(v) {
    return function(f) {
        return (function(dictIsSymbol) {
            var f1 = f(dictIsSymbol)();
            return function() {
                return f1;
            };
        })({
            reflectSymbol: $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v.type)
        })({})($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v.value);
    };
};
var $a5ccce070b256bc7$export$edaed73c040edf0e = function() {
    return function() {
        return function() {
            return function() {
                return function(dictFunctor) {
                    var mapFlipped = $f4b2eb11fc32ed34$export$5c8c64e4bc0bcb7a(dictFunctor);
                    return function(r) {
                        return function(k) {
                            return function(v) {
                                if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return mapFlipped($d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value))(function(value) {
                                    return {
                                        type: v.type,
                                        value: value
                                    };
                                });
                                return k(v);
                            };
                        };
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$traverseSome1 = /* #__PURE__ */ $a5ccce070b256bc7$export$edaed73c040edf0e()()()();
var $a5ccce070b256bc7$export$df3f009e3d155b20 = function() {
    return function() {
        return function() {
            return function() {
                return function(dictApplicative) {
                    var traverseSome2 = $a5ccce070b256bc7$var$traverseSome1(dictApplicative.Apply0().Functor0());
                    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
                    return function(r) {
                        return traverseSome2(r)(function($173) {
                            return pure($173);
                        });
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$ab9a97d5d556e541 = {
    variantShows: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$b0bcf256e53c8ada = function(dictVariantShows) {
    var variantShows1 = $a5ccce070b256bc7$export$38e1d92de9476ba9(dictVariantShows);
    return function(dictShow) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
        return {
            variantShows: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(show1, variantShows1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$e2d6a1adf0a4395e = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        return function(dictVariantShows) {
            var variantShows1 = $a5ccce070b256bc7$export$38e1d92de9476ba9(dictVariantShows);
            return {
                show: function(v1) {
                    var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var shows = variantShows1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                    var body = $d347d4a6047cfbb7$export$dfc7155ac0343b8("show")(v1.type)(tags)(shows)(v1.value);
                    return "(inj @" + ($a5ccce070b256bc7$var$show(v1.type) + (" " + (body + ")")));
                }
            };
        };
    };
};
var $a5ccce070b256bc7$export$87171bfc157a152b = function() {
    return function() {
        return function() {
            return function() {
                return function(r) {
                    return function(k) {
                        return function(v) {
                            if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return {
                                type: v.type,
                                value: $d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value)
                            };
                            return k(v);
                        };
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$overSome1 = /* #__PURE__ */ $a5ccce070b256bc7$export$87171bfc157a152b()()()();
var $a5ccce070b256bc7$export$fb4902fd9e525693 = function() {
    return function() {
        return function() {
            return function() {
                return function(r) {
                    return $a5ccce070b256bc7$var$overSome1(r)($ac8b3532514ac019$export$401372c57776dc);
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$75fb33597d13f1b9 = {
    variantOrds: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$1c5384046479a778 = function(dictVariantOrds) {
    var variantOrds1 = $a5ccce070b256bc7$export$d424ff163a450f59(dictVariantOrds);
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        return {
            variantOrds: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(compare, variantOrds1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$df0655ae5ee3c0a3 = function() {
    return function() {
        return function() {
            return function(r) {
                return function(k) {
                    return function(v) {
                        if ($d2fadbdf02925823$export$12c1b2b255bc527d(v.type)(r)) return $d2fadbdf02925823$export$1d94535d2cda4eda(v.type)(r)(v.value);
                        return k(v);
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$onMatch1 = /* #__PURE__ */ $a5ccce070b256bc7$export$df0655ae5ee3c0a3()()();
var $a5ccce070b256bc7$export$af631764ddc44097 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(p) {
            return function(f) {
                return function(g) {
                    return function(r) {
                        if (r.type === reflectSymbol(p)) return f(r.value);
                        return g(r);
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$on1 = /* #__PURE__ */ $a5ccce070b256bc7$export$af631764ddc44097();
var $a5ccce070b256bc7$export$275cc6de179498bd = function() {
    return function(dictIsSymbol) {
        var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
        return function(dictAlternative) {
            var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictAlternative.Applicative0());
            var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
            return function(p) {
                return on2(p)(pure)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(empty));
            };
        };
    };
};
var $a5ccce070b256bc7$export$38d8e7a5e0c746a7 = function() {
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(p) {
            return function(value) {
                return {
                    type: reflectSymbol(p),
                    value: value
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$inj1 = /* #__PURE__ */ $a5ccce070b256bc7$export$38d8e7a5e0c746a7();
var $a5ccce070b256bc7$export$1723983dbe3de839 = function(dictIsSymbol) {
    var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
    var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
    return function() {
        return function() {
            return function(p) {
                return function(f) {
                    return on2(p)(function() {
                        var $174 = inj2(p);
                        return function($175) {
                            return $174(f($175));
                        };
                    }());
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$a1d302ac1e9eaf3f = function(v) {
    return v(function(dictIsSymbol) {
        var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
        return function() {
            return inj2;
        };
    });
};
var $a5ccce070b256bc7$export$d5e4114ba15d04e1 = function(dictIsSymbol) {
    var on2 = $a5ccce070b256bc7$var$on1(dictIsSymbol);
    var inj2 = $a5ccce070b256bc7$var$inj1(dictIsSymbol);
    return function() {
        return function() {
            return function(dictFunctor) {
                var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
                return function(p) {
                    return function(f) {
                        return on2(p)(function() {
                            var $176 = map(inj2(p));
                            return function($177) {
                                return $176(f($177));
                            };
                        }());
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$export$9f77e0932fb78f72 = function() {
    return $ac8b3532514ac019$export$401372c57776dc;
};
var $a5ccce070b256bc7$export$c2f7c2356dc086a8 = {
    variantEqs: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$335882e181da9bfc = function(dictVariantEqs) {
    var variantEqs1 = $a5ccce070b256bc7$export$e23cdac3d43a2502(dictVariantEqs);
    return function(dictEq) {
        var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return {
            variantEqs: function(v) {
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(eq1, variantEqs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$24934809abce965 = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        return function(dictVariantEqs) {
            var variantEqs1 = $a5ccce070b256bc7$export$e23cdac3d43a2502(dictVariantEqs);
            return {
                eq: function(v1) {
                    return function(v2) {
                        var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        var eqs = variantEqs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                        return $d347d4a6047cfbb7$export$f2569b7ebfd16005(tags)(eqs)(v1)(v2);
                    };
                }
            };
        };
    };
};
var $a5ccce070b256bc7$var$eqVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$24934809abce965();
var $a5ccce070b256bc7$export$15fe5b140c3b0d78 = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var eqVariant2 = $a5ccce070b256bc7$var$eqVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var eqVariant3 = eqVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var variantOrds1 = $a5ccce070b256bc7$export$d424ff163a450f59(dictVariantOrds);
                return {
                    compare: function(v1) {
                        return function(v2) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var ords = variantOrds1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$109702b9a7154017(tags)(ords)(v1)(v2);
                        };
                    },
                    Eq0: function() {
                        return eqVariant3;
                    }
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$ordVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$15fe5b140c3b0d78();
var $a5ccce070b256bc7$export$dc1f78402967431c = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var ordVariant2 = $a5ccce070b256bc7$var$ordVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var ordVariant3 = ordVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var ordVariant4 = ordVariant3(dictVariantOrds);
                return function(dictVariantBoundedEnums) {
                    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
                    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBoundedEnums.VariantBounded0());
                    return {
                        pred: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var bounds = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$5f7558b7e8dd3d2(a)(tags)(bounds)(dicts);
                        },
                        succ: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var bounds = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$df26e2801d56dff3(a)(tags)(bounds)(dicts);
                        },
                        Ord0: function() {
                            return ordVariant4;
                        }
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$enumVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$dc1f78402967431c();
var $a5ccce070b256bc7$export$2e2bcd8739ae039 = function(a) {
    return function(v) {
        return a;
    };
};
var $a5ccce070b256bc7$export$85ad66dc59ec94d8 = function(dictAlternative) {
    return function(dictContractable) {
        var contractWith = $d347d4a6047cfbb7$export$3f68b7f308cef1ff(dictContractable)(dictAlternative);
        return function(v) {
            return contractWith($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v.type)(v);
        };
    };
};
var $a5ccce070b256bc7$export$637cc851f3ae4876 = function(r) {
    return $8bcde8f642a64c7d$export$51b220bae4359b72("Data.Variant: pattern match failure [" + (r.type + "]"));
};
var $a5ccce070b256bc7$export$4659b591c19bdf3d = function() {
    return function() {
        return function() {
            return function(r) {
                return $a5ccce070b256bc7$var$onMatch1(r)($a5ccce070b256bc7$export$637cc851f3ae4876);
            };
        };
    };
};
var $a5ccce070b256bc7$export$68f6414e72b9a165 = {
    variantBounded: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    }
};
var $a5ccce070b256bc7$export$494c99098dfcb7b = {
    variantBoundedEnums: function(v) {
        return $78c799cba34fcb8d$export$c1bed610ade55e1c.value;
    },
    VariantBounded0: function() {
        return $a5ccce070b256bc7$export$68f6414e72b9a165;
    }
};
var $a5ccce070b256bc7$export$95aefd516ed26ef = function(dictVariantBounded) {
    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBounded);
    return function(dictBounded) {
        var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
        var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
        return {
            variantBounded: function(v) {
                var dict = {
                    top: top,
                    bottom: bottom
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(dict, variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $a5ccce070b256bc7$export$f976999753dd7e2 = function(dictVariantBoundedEnums) {
    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
    var boundedVariantCons1 = $a5ccce070b256bc7$export$95aefd516ed26ef(dictVariantBoundedEnums.VariantBounded0());
    return function(dictBoundedEnum) {
        var Enum1 = dictBoundedEnum.Enum1();
        var pred = $f935a9866e211c00$export$c238ae40a8cccc17(Enum1);
        var succ = $f935a9866e211c00$export$61d85e1612867711(Enum1);
        var fromEnum = $f935a9866e211c00$export$b385cb642735011f(dictBoundedEnum);
        var toEnum = $f935a9866e211c00$export$45328c01562fb205(dictBoundedEnum);
        var cardinality = $f935a9866e211c00$export$9e9949f96c411257(dictBoundedEnum);
        var boundedVariantCons2 = boundedVariantCons1(dictBoundedEnum.Bounded0());
        return {
            variantBoundedEnums: function(v) {
                var dict = {
                    pred: pred,
                    succ: succ,
                    fromEnum: fromEnum,
                    toEnum: toEnum,
                    cardinality: cardinality
                };
                return new $78c799cba34fcb8d$export$74c44e616647f5c0(dict, variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            },
            VariantBounded0: function() {
                return boundedVariantCons2;
            }
        };
    };
};
var $a5ccce070b256bc7$export$8b12c85aa9fcb36b = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var ordVariant2 = $a5ccce070b256bc7$var$ordVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var ordVariant3 = ordVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var ordVariant4 = ordVariant3(dictVariantOrds);
                return function(dictVariantBounded) {
                    var variantBounded1 = $a5ccce070b256bc7$export$4a2422da06e04a63(dictVariantBounded);
                    return {
                        top: function() {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$53ce69aede1374ee("top")(function(v) {
                                return v.top;
                            })(tags)(dicts);
                        }(),
                        bottom: function() {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBounded1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$c21fa4428dbc447f("bottom")(function(v) {
                                return v.bottom;
                            })(tags)(dicts);
                        }(),
                        Ord0: function() {
                            return ordVariant4;
                        }
                    };
                };
            };
        };
    };
};
var $a5ccce070b256bc7$var$boundedVariant1 = /* #__PURE__ */ $a5ccce070b256bc7$export$8b12c85aa9fcb36b();
var $a5ccce070b256bc7$export$a1afb46b142304ae = function() {
    return function(dictVariantTags) {
        var variantTags = $d347d4a6047cfbb7$export$a263890827176f5b(dictVariantTags);
        var boundedVariant2 = $a5ccce070b256bc7$var$boundedVariant1(dictVariantTags);
        var enumVariant2 = $a5ccce070b256bc7$var$enumVariant1(dictVariantTags);
        return function(dictVariantEqs) {
            var boundedVariant3 = boundedVariant2(dictVariantEqs);
            var enumVariant3 = enumVariant2(dictVariantEqs);
            return function(dictVariantOrds) {
                var boundedVariant4 = boundedVariant3(dictVariantOrds);
                var enumVariant4 = enumVariant3(dictVariantOrds);
                return function(dictVariantBoundedEnums) {
                    var variantBoundedEnums1 = $a5ccce070b256bc7$export$ac5da622fbb79b7a(dictVariantBoundedEnums);
                    var boundedVariant5 = boundedVariant4(dictVariantBoundedEnums.VariantBounded0());
                    var enumVariant5 = enumVariant4(dictVariantBoundedEnums);
                    return {
                        cardinality: $d347d4a6047cfbb7$export$75c8b177a15c9f3a(variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)),
                        fromEnum: function(a) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$3c34dd558a358bbc(a)(tags)(dicts);
                        },
                        toEnum: function(n) {
                            var tags = variantTags($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            var dicts = variantBoundedEnums1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                            return $d347d4a6047cfbb7$export$8c9c13f4abebac02(n)(tags)(dicts);
                        },
                        Bounded0: function() {
                            return boundedVariant5;
                        },
                        Enum1: function() {
                            return enumVariant5;
                        }
                    };
                };
            };
        };
    };
};



var $266cd1b01131a218$var$$$null = /* #__PURE__ */ $4fe7b6acfba7f29f$export$7b1b591b262c240($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $266cd1b01131a218$var$prj = /* #__PURE__ */ $a5ccce070b256bc7$export$275cc6de179498bd();
var $266cd1b01131a218$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $266cd1b01131a218$var$inj = /* #__PURE__ */ $a5ccce070b256bc7$export$38d8e7a5e0c746a7();
var $266cd1b01131a218$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $266cd1b01131a218$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $266cd1b01131a218$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $266cd1b01131a218$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $266cd1b01131a218$export$6cbb4f8fa0c4c986 = /* #__PURE__ */ function() {
    function Union(value0) {
        this.value0 = value0;
    }
    Union.create = function(value0) {
        return new Union(value0);
    };
    return Union;
}();
var $266cd1b01131a218$export$b5ac84759d4bbcf7 = /* #__PURE__ */ function() {
    function UNoMatch() {}
    UNoMatch.value = new UNoMatch();
    return UNoMatch;
}();
var $266cd1b01131a218$export$cfe7e552098fdf89 = /* #__PURE__ */ function() {
    function QueryArg(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QueryArg.create = function(value0) {
        return function(value1) {
            return new QueryArg(value0, value1);
        };
    };
    return QueryArg;
}();
var $266cd1b01131a218$export$3735341669894528 = /* #__PURE__ */ function() {
    function QScalar(value0) {
        this.value0 = value0;
    }
    QScalar.create = function(value0) {
        return new QScalar(value0);
    };
    return QScalar;
}();
var $266cd1b01131a218$export$c1da5d38077527d7 = /* #__PURE__ */ function() {
    function QObject(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QObject.create = function(value0) {
        return function(value1) {
            return new QObject(value0, value1);
        };
    };
    return QObject;
}();
var $266cd1b01131a218$export$4fd2d9b4a5688f9f = /* #__PURE__ */ function() {
    function QCall(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    QCall.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new QCall(value0, value1, value2);
            };
        };
    };
    return QCall;
}();
var $266cd1b01131a218$export$f275737dbf8a1686 = /* #__PURE__ */ function() {
    function QAlias(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QAlias.create = function(value0) {
        return function(value1) {
            return new QAlias(value0, value1);
        };
    };
    return QAlias;
}();
var $266cd1b01131a218$export$3f578137ff4c8647 = /* #__PURE__ */ function() {
    function QUnion(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QUnion.create = function(value0) {
        return function(value1) {
            return new QUnion(value0, value1);
        };
    };
    return QUnion;
}();
var $266cd1b01131a218$export$750fc123d68a1541 = {
    varShapeOf: function(v) {
        return function(v1) {
            return [];
        };
    }
};
var $266cd1b01131a218$export$c9c95a13a02b7fdf = function(dict) {
    return dict.varShapeOf;
};
var $266cd1b01131a218$export$d1213f059a1aeef8 = function(dictVarHasShape) {
    var varShapeOf1 = $266cd1b01131a218$export$c9c95a13a02b7fdf(dictVarHasShape);
    return function() {
        return {
            shapeOf: function(v) {
                var typename = new $266cd1b01131a218$export$3735341669894528("__typename");
                return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(typename)(varShapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
            }
        };
    };
};
var $266cd1b01131a218$export$10ea8b8b83e08901 = {
    decodeUnion: function(v) {
        return function(v1) {
            return function(v2) {
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            };
        };
    }
};
var $266cd1b01131a218$export$5b88af1c6457fdfe = function(dict) {
    return dict.shapeOf;
};
var $266cd1b01131a218$export$62f20211aacc4215 = function(dictVarHasShape) {
    var varShapeOf1 = $266cd1b01131a218$export$c9c95a13a02b7fdf(dictVarHasShape);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictHasShape) {
            var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
            return function() {
                return function() {
                    return {
                        varShapeOf: function(v) {
                            return function(v1) {
                                var shape = shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var thisVar = new $266cd1b01131a218$export$3f578137ff4c8647(name, shape);
                                return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(thisVar)(varShapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
                            };
                        }
                    };
                };
            };
        };
    };
};
var $266cd1b01131a218$export$eac78e45f453a621 = {
    shapeOf: function(v) {
        return [];
    }
};
var $266cd1b01131a218$export$4ed06b452b0f7d08 = {
    rlShapeOf: function(v) {
        return function(v1) {
            return [];
        };
    }
};
var $266cd1b01131a218$export$176ba9169493b31c = function(dict) {
    return dict.rlShapeOf;
};
var $266cd1b01131a218$export$3a03965a63c09844 = function(dictRLHasShape) {
    var rlShapeOf1 = $266cd1b01131a218$export$176ba9169493b31c(dictRLHasShape);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function(dictHasShape) {
            var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
            return function() {
                return function() {
                    return {
                        rlShapeOf: function(v) {
                            return function(v1) {
                                var shape = shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var thisField = function() {
                                    var $75 = $266cd1b01131a218$var$$$null(shape);
                                    if ($75) return new $266cd1b01131a218$export$3735341669894528(name);
                                    return new $266cd1b01131a218$export$c1da5d38077527d7(name, shape);
                                }();
                                return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(thisField)(rlShapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
                            };
                        }
                    };
                };
            };
        };
    };
};
var $266cd1b01131a218$export$5cdfc842db1bd206 = function(dictRLHasShape) {
    var rlShapeOf1 = $266cd1b01131a218$export$176ba9169493b31c(dictRLHasShape);
    return function() {
        return {
            shapeOf: function(v) {
                return rlShapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
            }
        };
    };
};
var $266cd1b01131a218$export$680ab633d290e349 = function(dictHasShape) {
    var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
    return {
        shapeOf: function(v) {
            return shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        }
    };
};
var $266cd1b01131a218$export$b1354530938ec29c = function(dictHasShape) {
    var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
    return {
        shapeOf: function(v) {
            return shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        }
    };
};
var $266cd1b01131a218$export$af49fdaa8790af7f = function(dictIsSymbol) {
    var prj1 = $266cd1b01131a218$var$prj(dictIsSymbol)($06733ae99ed4f534$export$92d23d3d8fa78a80);
    return function() {
        return function(v) {
            return function(v1) {
                if (v1 instanceof $266cd1b01131a218$export$6cbb4f8fa0c4c986) return prj1(v)(v1.value0);
                if (v1 instanceof $266cd1b01131a218$export$b5ac84759d4bbcf7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                throw new Error("Failed pattern match at GraphQL.Shape (line 124, column 1 - line 124, column 112): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    };
};
var $266cd1b01131a218$export$4fc17d1402aceb7b = function(v) {
    if (v instanceof $266cd1b01131a218$export$6cbb4f8fa0c4c986) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    if (v instanceof $266cd1b01131a218$export$b5ac84759d4bbcf7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at GraphQL.Shape (line 119, column 1 - line 119, column 52): " + [
        v.constructor.name
    ]);
};
var $266cd1b01131a218$export$f2b8793db68e1058 = function(dict) {
    return dict.decodeUnion;
};
var $266cd1b01131a218$export$96d29a771776afc1 = function(dictUnionDecode) {
    var decodeUnion1 = $266cd1b01131a218$export$f2b8793db68e1058(dictUnionDecode);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        var inj1 = $266cd1b01131a218$var$inj(dictIsSymbol);
        return function(dictDecodeJson) {
            var decodeJson = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
            return function() {
                return function() {
                    return {
                        decodeUnion: function(v) {
                            return function(v1) {
                                return function(v2) {
                                    if (v2 === reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)) return new $06733ae99ed4f534$export$8a67b48435b5d073(function(j) {
                                        return $266cd1b01131a218$var$map(inj1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(decodeJson(j));
                                    });
                                    return decodeUnion1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v2);
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var $266cd1b01131a218$export$233e215ca2d72bc7 = function(dictUnionDecode) {
    var decodeUnion1 = $266cd1b01131a218$export$f2b8793db68e1058(dictUnionDecode);
    return function() {
        return {
            decodeJson: function(json) {
                return $266cd1b01131a218$var$bind($266cd1b01131a218$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(v) {
                    return $266cd1b01131a218$var$getField(v)("__typename");
                }))(function(v) {
                    var decode = decodeUnion1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v);
                    if (decode instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $266cd1b01131a218$var$map($266cd1b01131a218$export$6cbb4f8fa0c4c986.create)(decode.value0(json));
                    if (decode instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a($266cd1b01131a218$export$b5ac84759d4bbcf7.value);
                    throw new Error("Failed pattern match at GraphQL.Shape (line 168, column 8 - line 170, column 37): " + [
                        decode.constructor.name
                    ]);
                });
            }
        };
    };
};
var $266cd1b01131a218$export$c6279c3a85890bd5 = function(dictHasShape) {
    var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
    return {
        shapeOf: function(v) {
            return shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        }
    };
};
var $266cd1b01131a218$export$67d21f74bac24ad8 = function(v) {
    return v.value0 + (": $" + v.value1);
};
var $266cd1b01131a218$export$f77d0693d12465c1 = function(args) {
    return $266cd1b01131a218$var$intercalate(", ")($266cd1b01131a218$var$map1($266cd1b01131a218$export$67d21f74bac24ad8)(args));
};
var $266cd1b01131a218$export$55dbabd51ced92f5 = function(fields) {
    var fieldStrs = $266cd1b01131a218$var$map1($266cd1b01131a218$export$90ccce5bf8b31001)(fields);
    return $266cd1b01131a218$var$intercalate(", ")(fieldStrs);
};
var $266cd1b01131a218$export$debe08b0a131ded = function(fields) {
    return "{ " + ($266cd1b01131a218$export$55dbabd51ced92f5(fields) + " }");
};
var $266cd1b01131a218$export$90ccce5bf8b31001 = function(v) {
    if (v instanceof $266cd1b01131a218$export$3735341669894528) return v.value0;
    if (v instanceof $266cd1b01131a218$export$c1da5d38077527d7) return v.value0 + (" " + $266cd1b01131a218$export$debe08b0a131ded(v.value1));
    if (v instanceof $266cd1b01131a218$export$4fd2d9b4a5688f9f && v.value1.length === 0 && v.value2.length === 0) return v.value0;
    if (v instanceof $266cd1b01131a218$export$4fd2d9b4a5688f9f && v.value1.length === 0) return v.value0 + (" " + $266cd1b01131a218$export$debe08b0a131ded(v.value2));
    if (v instanceof $266cd1b01131a218$export$4fd2d9b4a5688f9f && v.value2.length === 0) return v.value0 + ("(" + ($266cd1b01131a218$export$f77d0693d12465c1(v.value1) + ")"));
    if (v instanceof $266cd1b01131a218$export$4fd2d9b4a5688f9f) return v.value0 + ("(" + ($266cd1b01131a218$export$f77d0693d12465c1(v.value1) + (") " + $266cd1b01131a218$export$debe08b0a131ded(v.value2))));
    if (v instanceof $266cd1b01131a218$export$3f578137ff4c8647) return "... on " + (v.value0 + (" " + $266cd1b01131a218$export$debe08b0a131ded(v.value1)));
    if (v instanceof $266cd1b01131a218$export$f275737dbf8a1686 && v.value1 instanceof $266cd1b01131a218$export$f275737dbf8a1686) return $266cd1b01131a218$export$90ccce5bf8b31001(v.value1);
    if (v instanceof $266cd1b01131a218$export$f275737dbf8a1686) return v.value0 + (": " + $266cd1b01131a218$export$90ccce5bf8b31001(v.value1));
    throw new Error("Failed pattern match at GraphQL.Shape (line 46, column 1 - line 46, column 38): " + [
        v.constructor.name
    ]);
};
var $266cd1b01131a218$export$c050e55bf0a6479f = {
    show: $266cd1b01131a218$export$90ccce5bf8b31001
};





// Generated by purs version 0.15.16
function $07a6961825e3071d$export$a8ff84c12d48cfa6(file) {
    return file.name;
}
function $07a6961825e3071d$export$1ed9398999324ec7(file) {
    return file.lastModified;
}



// Generated by purs version 0.15.16
function $602c3526f84c45e4$export$6eeedf4505d3b206(blob) {
    return blob.type;
}
function $602c3526f84c45e4$export$9c6f2cdedf225e28(args) {
    return function(mediaType) {
        return new Blob(args, {
            type: mediaType
        });
    };
}
function $602c3526f84c45e4$export$346677f925de839c(blob) {
    return blob.size;
}
function $602c3526f84c45e4$export$58adb3bec8346d0f(contentType) {
    return function(start) {
        return function(end) {
            return function(blob) {
                return blob.slice(start, end, contentType);
            };
        };
    };
}





var $e1c68652a03c444c$export$fe89d9b4521de005 = function(x) {
    return x;
};
var $e1c68652a03c444c$export$aaa85e26b6a3ff41 = function(x) {
    return x;
};
var $e1c68652a03c444c$export$d4a6a4db5b31e621 = function(blob) {
    var blobType = $602c3526f84c45e4$export$6eeedf4505d3b206(blob);
    var $2 = blobType === "";
    if ($2) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(blobType);
};
var $e1c68652a03c444c$export$c5262b9a8842bc7e = /* #__PURE__ */ $602c3526f84c45e4$export$58adb3bec8346d0f("");
var $e1c68652a03c444c$export$500ffe04051bd5b9 = function($3) {
    return $9a14cd925227149d$export$2077e0241d6afd3c($3);
};
var $e1c68652a03c444c$export$97fd69eb726d96ee = function($4) {
    return $4ab74a20512cef04$export$a0a81dc3380ce7d3($4);
};
var $e1c68652a03c444c$export$3004f64547af360e = function(str) {
    return function(ct) {
        return $602c3526f84c45e4$export$9c6f2cdedf225e28([
            str
        ])(ct);
    };
};
var $e1c68652a03c444c$export$571d59b505e6bb4e = function(args) {
    return function(opts) {
        return $602c3526f84c45e4$export$9c6f2cdedf225e28(args)(opts);
    };
};


var $8b4cb9167abab20f$export$d4a6a4db5b31e621 = function($1) {
    return $e1c68652a03c444c$export$d4a6a4db5b31e621($1);
};
var $8b4cb9167abab20f$export$b20f4ee19ffa0668 = $ac8b3532514ac019$export$401372c57776dc;
var $8b4cb9167abab20f$export$346677f925de839c = function($2) {
    return $602c3526f84c45e4$export$346677f925de839c($2);
};


var $a40b20519abba0fb$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $a40b20519abba0fb$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a40b20519abba0fb$var$$$null = /* #__PURE__ */ $4fe7b6acfba7f29f$export$7b1b591b262c240($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $a40b20519abba0fb$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $a40b20519abba0fb$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $a40b20519abba0fb$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $a40b20519abba0fb$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5501dc3a72754845($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $a40b20519abba0fb$var$getField1 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $a40b20519abba0fb$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $a40b20519abba0fb$var$encodeForeignObject = /* #__PURE__ */ $eb7399d322077fcf$export$4acff49b3f5661ea($eb7399d322077fcf$export$35d3004eff90f123);
var $a40b20519abba0fb$var$query = /* #__PURE__ */ $42ad8b7b0d01e859$export$2fa187e846a241c4($a40b20519abba0fb$var$encodeForeignObject);
var $a40b20519abba0fb$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $a40b20519abba0fb$var$fileQuery = /* #__PURE__ */ $42ad8b7b0d01e859$export$492d5489ce6d03b8($a40b20519abba0fb$var$encodeForeignObject);
var $a40b20519abba0fb$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $a40b20519abba0fb$var$merge = /* #__PURE__ */ $15e8567e7c31ba30$export$4950aa0f605343fb()();
var $a40b20519abba0fb$export$a90c0bb0b625769b = /* #__PURE__ */ function() {
    function QueryVar(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QueryVar.create = function(value0) {
        return function(value1) {
            return new QueryVar(value0, value1);
        };
    };
    return QueryVar;
}();
var $a40b20519abba0fb$export$d92f83d2e295fa99 = /* #__PURE__ */ function() {
    function FileUpload(value0) {
        this.value0 = value0;
    }
    FileUpload.create = function(value0) {
        return new FileUpload(value0);
    };
    return FileUpload;
}();
var $a40b20519abba0fb$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0) {
        this.value0 = value0;
    }
    Query.create = function(value0) {
        return new Query(value0);
    };
    return Query;
}();
var $a40b20519abba0fb$export$dd2f839aaff96dca = function(v) {
    return "$" + (v.value0 + (": " + $308f9765feb7633d$export$2654b1b656d9a957(v.value1)));
};
var $a40b20519abba0fb$export$cc8a8e045c189348 = function(dict) {
    return dict.varFiles;
};
var $a40b20519abba0fb$export$5bc47822dabd2903 = {
    queryResultDecode: function(v) {
        return function(v1) {
            return new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342);
        };
    },
    queryResultShape: function(v) {
        return [];
    },
    queryResultArgs: function(v) {
        return [];
    }
};
var $a40b20519abba0fb$export$bed894b7b2c71cb8 = function(dict) {
    return dict.toVars;
};
var $a40b20519abba0fb$export$fe891b8934c38330 = {
    rlFiles: function(v) {
        return function(v1) {
            return function(v2) {
                return [];
            };
        };
    }
};
var $a40b20519abba0fb$export$bb525b50bfdf2bbc = {
    rlToVars: function(v) {
        return function(v1) {
            return [];
        };
    },
    rlEncodeVars: function(v) {
        return function(v1) {
            return $03b6b966974423fe$export$6e22c362a0406a2c;
        };
    }
};
var $a40b20519abba0fb$export$f5a90bed324d1a6c = function(dict) {
    return dict.rlToVars;
};
var $a40b20519abba0fb$export$557a56b12e6fe31a = function(dict) {
    return dict.rlFiles;
};
var $a40b20519abba0fb$export$f4bf89db99b76e5 = function(dictRLTVFiles) {
    var rlFiles1 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        return function() {
            return {
                rlFiles: function(pfx) {
                    return function(v) {
                        return function(rec) {
                            var thisFile = new $71f2e2e9476163f8$export$1908877435b1d5e9(pfx + reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value), get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec));
                            return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(thisFile)(rlFiles1(pfx)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec));
                        };
                    };
                }
            };
        };
    };
};
var $a40b20519abba0fb$export$f919171f4a5c574f = function(dictRLTVFiles) {
    var rlFiles1 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles);
    return function(dictIsSymbol) {
        return function() {
            return {
                rlFiles: function(pfx) {
                    return function(v) {
                        return function(rec) {
                            return rlFiles1(pfx)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                        };
                    };
                }
            };
        };
    };
};
var $a40b20519abba0fb$export$4db8a34bb8c07ace = function(dictRLTVFiles) {
    var rlFiles1 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles);
    return function(dictIsSymbol) {
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function() {
            return function() {
                return function(dictRLTVFiles1) {
                    var rlFiles2 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles1);
                    return {
                        rlFiles: function(pfx) {
                            return function(v) {
                                return function(rec) {
                                    var irec = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                                    var thisRec = rlFiles2(pfx + (reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value) + "."))($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(irec);
                                    return $a40b20519abba0fb$var$append1(thisRec)(rlFiles1(pfx)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec));
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var $a40b20519abba0fb$export$1dfb011ce07ede8c = function(dictRLTVFiles) {
    var rlFiles1 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles);
    return function(dictIsSymbol) {
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        return function() {
            return function() {
                return function(dictRLTVFiles1) {
                    var rlFiles2 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles1);
                    return {
                        rlFiles: function(pfx) {
                            return function(v) {
                                return function(rec) {
                                    var v1 = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                                    var thisRec = rlFiles2(pfx + (reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value) + "."))($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(v1.value0);
                                    return $a40b20519abba0fb$var$append1(thisRec)(rlFiles1(pfx)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec));
                                };
                            };
                        }
                    };
                };
            };
        };
    };
};
var $a40b20519abba0fb$export$9d51cb209b7e745e = function(dict) {
    return dict.rlEncodeVars;
};
var $a40b20519abba0fb$export$450e3c8f9eaaa96f = function(dictRLToVars) {
    var rlToVars1 = $a40b20519abba0fb$export$f5a90bed324d1a6c(dictRLToVars);
    var rlEncodeVars1 = $a40b20519abba0fb$export$9d51cb209b7e745e(dictRLToVars);
    return function(dictRLTVFiles) {
        var rlFiles1 = $a40b20519abba0fb$export$557a56b12e6fe31a(dictRLTVFiles);
        return function() {
            return {
                toVars: function(rec) {
                    return rlToVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                },
                encodeVars: rlEncodeVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value),
                varFiles: rlFiles1("")($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)
            };
        };
    };
};
var $a40b20519abba0fb$export$f23a440a785b445 = function(dictRLToVars) {
    var rlToVars1 = $a40b20519abba0fb$export$f5a90bed324d1a6c(dictRLToVars);
    var rlEncodeVars1 = $a40b20519abba0fb$export$9d51cb209b7e745e(dictRLToVars);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        var $$delete = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        return function(dictHasQType) {
            var gqlType = $308f9765feb7633d$export$48536db2648307e4(dictHasQType);
            return function(dictEncodeJson) {
                var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
                return function() {
                    return function() {
                        return {
                            rlToVars: function(v) {
                                return function(rec) {
                                    var ty = gqlType($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                    var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                    var thisVar = new $a40b20519abba0fb$export$a90c0bb0b625769b(name, ty);
                                    return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(thisVar)(rlToVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec)));
                                };
                            },
                            rlEncodeVars: function(v) {
                                return function(r) {
                                    var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                    var val = encodeJson(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r));
                                    return $c045ea5df33bba60$export$21a5ca8aa77d35ff(name)(val)(rlEncodeVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r)));
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var $a40b20519abba0fb$export$bbb2424cc61174c = function(dictRLToVars) {
    var rlToVars1 = $a40b20519abba0fb$export$f5a90bed324d1a6c(dictRLToVars);
    var rlEncodeVars1 = $a40b20519abba0fb$export$9d51cb209b7e745e(dictRLToVars);
    return function(dictIsSymbol) {
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        var $$delete = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
        return function(dictEncodeJson) {
            var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70($308f9765feb7633d$export$39dc6bc3b041eb70(dictEncodeJson));
            return function() {
                return function() {
                    return {
                        rlToVars: function(v) {
                            return function(rec) {
                                var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var v1 = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec);
                                var thisVar = new $a40b20519abba0fb$export$a90c0bb0b625769b(name, new $308f9765feb7633d$export$c76991cd6baf9718(v1.value0));
                                return $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(thisVar)(rlToVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rec)));
                            };
                        },
                        rlEncodeVars: function(v) {
                            return function(r) {
                                var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                var val = encodeJson(get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r));
                                return $c045ea5df33bba60$export$21a5ca8aa77d35ff(name)(val)(rlEncodeVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(r)));
                            };
                        }
                    };
                };
            };
        };
    };
};
var $a40b20519abba0fb$export$3fcb16104b0ca20c = function(name) {
    return function(v) {
        return new $a40b20519abba0fb$export$d92f83d2e295fa99({
            file: v.value0.file,
            name: new $06733ae99ed4f534$export$8a67b48435b5d073(name)
        });
    };
};
var $a40b20519abba0fb$export$ce6cc5691dbc7aa5 = function(v) {
    var toUpload = function(v1) {
        return {
            path: v1.value0,
            name: v1.value1.value0.name,
            file: v1.value1.value0.file
        };
    };
    return $a40b20519abba0fb$var$map(toUpload)(v.value0.files);
};
var $a40b20519abba0fb$export$78b7a7f99b2aea2d = function(v) {
    var varstr = function() {
        if ($a40b20519abba0fb$var$$$null(v.args)) return "";
        return "(" + ($a40b20519abba0fb$var$intercalate(", ")($a40b20519abba0fb$var$map($a40b20519abba0fb$export$dd2f839aaff96dca)(v.args)) + ")");
    }();
    var shapestr = function() {
        if ($a40b20519abba0fb$var$$$null(v.shape)) return "";
        return $266cd1b01131a218$export$debe08b0a131ded(v.shape);
    }();
    var qormut = function() {
        if (v.mutation) return "mutation";
        return "query";
    }();
    return qormut + (" " + (v.name + (varstr + (" " + shapestr))));
};
var $a40b20519abba0fb$export$677e6b46b91cb7ed = function(v) {
    return function(f) {
        return new $a40b20519abba0fb$export$62297b13309008b2({
            name: v.value0.name,
            args: v.value0.args,
            files: v.value0.files,
            shape: v.value0.shape,
            mutation: v.value0.mutation,
            vars: v.value0.vars,
            keyName: v.value0.keyName,
            decode: function(r) {
                return $a40b20519abba0fb$var$bind(v.value0.decode(r))(f);
            }
        });
    };
};
var $a40b20519abba0fb$export$b5fb84ac70caa157 = function(dict) {
    return dict.queryResultShape;
};
var $a40b20519abba0fb$export$61d61702ea4e9b1f = function(dict) {
    return dict.queryResultDecode;
};
var $a40b20519abba0fb$export$1494645452713afc = function(dict) {
    return dict.queryResultArgs;
};
var $a40b20519abba0fb$export$932f43bf867a1b5 = {
    map: function(f) {
        return function(v) {
            return new $a40b20519abba0fb$export$62297b13309008b2({
                name: v.value0.name,
                args: v.value0.args,
                files: v.value0.files,
                shape: v.value0.shape,
                mutation: v.value0.mutation,
                vars: v.value0.vars,
                keyName: v.value0.keyName,
                decode: function() {
                    var $220 = $a40b20519abba0fb$var$map1(f);
                    return function($221) {
                        return $220(v.value0.decode($221));
                    };
                }()
            });
        };
    }
};
var $a40b20519abba0fb$export$bc1f9bac519c56f6 = function(name) {
    return function(v) {
        return new $a40b20519abba0fb$export$62297b13309008b2({
            args: v.value0.args,
            files: v.value0.files,
            shape: v.value0.shape,
            mutation: v.value0.mutation,
            decode: v.value0.decode,
            vars: v.value0.vars,
            keyName: v.value0.keyName,
            name: name
        });
    };
};
var $a40b20519abba0fb$export$1cde869cdd796379 = function(dictDecodeJson) {
    var decodeJson = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictHasShape) {
        var shapeOf = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
        return {
            queryResultDecode: function(v) {
                return function(json) {
                    return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json)(decodeJson(json));
                };
            },
            queryResultShape: function(p) {
                return shapeOf(p);
            },
            queryResultArgs: function(v) {
                return [];
            }
        };
    };
};
var $a40b20519abba0fb$export$c6b405b39190b469 = {
    getQuery: function(v) {
        return {
            query: $a40b20519abba0fb$export$78b7a7f99b2aea2d(v.value0),
            variables: $0e031af7428ef07d$export$dbafa4424a806c15(v.value0.vars)
        };
    },
    getDecode: function(v) {
        return function(json) {
            return $a40b20519abba0fb$var$bind($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($a40b20519abba0fb$var$bind($a40b20519abba0fb$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(v1) {
                return $a40b20519abba0fb$var$getField(v1)("data");
            }))(function(v1) {
                return $a40b20519abba0fb$var$getField1(v1)(v.value0.keyName);
            })))(function(inner) {
                return v.value0.decode(inner);
            });
        };
    }
};
var $a40b20519abba0fb$var$getDecode = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($a40b20519abba0fb$export$c6b405b39190b469);
var $a40b20519abba0fb$export$fe526d00b95b6f09 = {
    runGraphQL: function(v) {
        if (v.value0.files.length === 0) return $d2284b2d3e1b6f87$export$8291c2122093ac93($a40b20519abba0fb$var$bind1($a40b20519abba0fb$var$query($a40b20519abba0fb$export$78b7a7f99b2aea2d(v.value0))(v.value0.vars))(function(ret) {
            return $a40b20519abba0fb$var$except($a40b20519abba0fb$var$getDecode(v)(ret));
        }));
        if (v.value0.files.length === 1) return $d2284b2d3e1b6f87$export$8291c2122093ac93($a40b20519abba0fb$var$bind1($a40b20519abba0fb$var$fileQuery($a40b20519abba0fb$export$78b7a7f99b2aea2d(v.value0))(v.value0.vars)(v["value0"]["files"][0].value0)(v["value0"]["files"][0].value1.value0.name)(v["value0"]["files"][0].value1.value0.file))(function(ret) {
            return $a40b20519abba0fb$var$except($a40b20519abba0fb$var$getDecode(v)(ret));
        }));
        return $a40b20519abba0fb$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Multiple file uploads are not currently supported")));
    }
};
var $a40b20519abba0fb$export$8089d535d93360b6 = {
    encodeJson: function(v) {
        return $0e031af7428ef07d$export$63ea9a5410ee0cef;
    }
};
var $a40b20519abba0fb$export$1e228ef26b273807 = function(bq) {
    return function(vars) {
        return function(decode) {
            return $a40b20519abba0fb$var$merge({
                vars: vars,
                decode: decode,
                keyName: bq.name
            })(bq);
        };
    };
};
var $a40b20519abba0fb$export$4a8b657cc4fb4c7f = function(file) {
    return new $a40b20519abba0fb$export$d92f83d2e295fa99({
        name: new $06733ae99ed4f534$export$8a67b48435b5d073($07a6961825e3071d$export$a8ff84c12d48cfa6(file)),
        file: $8b4cb9167abab20f$export$b20f4ee19ffa0668(file)
    });
};
var $a40b20519abba0fb$export$d13998a7e702289c = function(dict) {
    return dict.encodeVars;
};
var $a40b20519abba0fb$export$a3b84696df42e4fa = function(dictToVars) {
    var encodeVars1 = $a40b20519abba0fb$export$d13998a7e702289c(dictToVars);
    var varFiles1 = $a40b20519abba0fb$export$cc8a8e045c189348(dictToVars);
    var toVars1 = $a40b20519abba0fb$export$bed894b7b2c71cb8(dictToVars);
    return function(dictQueryResult) {
        var queryResultArgs1 = $a40b20519abba0fb$export$1494645452713afc(dictQueryResult);
        var queryResultShape1 = $a40b20519abba0fb$export$b5fb84ac70caa157(dictQueryResult);
        var queryResultDecode1 = $a40b20519abba0fb$export$61d61702ea4e9b1f(dictQueryResult);
        return function(mutation) {
            return function(name) {
                return function(vars$prime) {
                    var vars = encodeVars1(vars$prime);
                    var files = varFiles1(vars$prime);
                    var args = $a40b20519abba0fb$var$append1(toVars1(vars$prime))($a40b20519abba0fb$var$map(function(v) {
                        return v.value0;
                    })(queryResultArgs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)));
                    var callArgs = $a40b20519abba0fb$var$map(function(v) {
                        return new $266cd1b01131a218$export$cfe7e552098fdf89(v.value0, v.value0);
                    })(args);
                    var shape = [
                        new $266cd1b01131a218$export$4fd2d9b4a5688f9f(name, callArgs, queryResultShape1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))
                    ];
                    var query1 = {
                        name: name,
                        args: args,
                        files: files,
                        shape: shape,
                        mutation: mutation
                    };
                    var decode = queryResultDecode1({
                        query: query1,
                        qstr: $a40b20519abba0fb$export$78b7a7f99b2aea2d(query1),
                        vars: $0e031af7428ef07d$export$dbafa4424a806c15(vars)
                    });
                    return $a40b20519abba0fb$export$1e228ef26b273807(query1)(vars)(decode);
                };
            };
        };
    };
};
var $a40b20519abba0fb$export$d7b58f10109feb02 = function(dictToVars) {
    var buildQuery_1 = $a40b20519abba0fb$export$a3b84696df42e4fa(dictToVars);
    return function(dictQueryResult) {
        var buildQuery_2 = buildQuery_1(dictQueryResult);
        return function(name) {
            return function(vars) {
                return new $a40b20519abba0fb$export$62297b13309008b2(buildQuery_2(false)(name)(vars));
            };
        };
    };
};
var $a40b20519abba0fb$export$5e1e8025a6c9da45 = function(dictToVars) {
    var buildQuery_1 = $a40b20519abba0fb$export$a3b84696df42e4fa(dictToVars);
    return function(dictQueryResult) {
        var buildQuery_2 = buildQuery_1(dictQueryResult);
        return function(name) {
            return function(vars) {
                return new $a40b20519abba0fb$export$62297b13309008b2(buildQuery_2(true)(name)(vars));
            };
        };
    };
};
var $a40b20519abba0fb$export$c0417fbbb4e0f837 = function(file) {
    return new $a40b20519abba0fb$export$d92f83d2e295fa99({
        name: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        file: file
    });
};
var $a40b20519abba0fb$export$7f9db571c154f4a = function(dictDecodeJson) {
    var decodeJson = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
    return function(dictHasShape) {
        var shapeOf = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
        return {
            queryResultDecode: function(v) {
                return function(json) {
                    return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json)(decodeJson(json));
                };
            },
            queryResultShape: function(p) {
                return shapeOf(p);
            },
            queryResultArgs: function(v) {
                return [];
            }
        };
    };
};




// Generated by purs version 0.15.16
var $63618293c58b5f80$exports = {};
'use strict';
Object.defineProperty($63618293c58b5f80$exports, '__esModule', {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct;
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $63618293c58b5f80$var$_unsupportedIterableToArray(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false
};
/**
 * {@link toLocaleString}; format like '09:30:23 EDT', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false,
    timeZoneName: $63618293c58b5f80$var$s
};
/**
 * {@link toLocaleString}; format like '09:30:23 Eastern Daylight Time', always 24-hour.
 */ var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hour12: false,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
 */ var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
/**
 * {@link toLocaleString}; format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
 */ var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ /**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
} // CAPABILITIES
function $63618293c58b5f80$var$hasIntl() {
    try {
        return typeof Intl !== "undefined" && Intl.DateTimeFormat;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$hasFormatToParts() {
    return !$63618293c58b5f80$var$isUndefined(Intl.DateTimeFormat.prototype.formatToParts);
}
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
} // OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
} // NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
} // x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var minus = input < 0 ? "-" : "";
    var target = minus ? input * -1 : input;
    var result;
    if (target.toString().length < n) result = ("0".repeat(n) + target).slice(-n);
    else result = target.toString();
    return "" + minus + result;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
} // DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
} // covert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond); // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
} // PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = Object.assign({
        timeZoneName: offsetFormat
    }, intlOpts), intl = $63618293c58b5f80$var$hasIntl();
    if (intl && $63618293c58b5f80$var$hasFormatToParts()) {
        var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
        });
        return parsed ? parsed.value : null;
    } else if (intl) {
        // this probably doesn't work for all locales
        var without = new Intl.DateTimeFormat(locale, intlOpts).format(date), included = new Intl.DateTimeFormat(locale, modified).format(date), diffed = included.substring(without.length), trimmed = diffed.replace(/^[, \u200e]+/, "");
        return trimmed;
    } else return null;
} // signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10); // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
} // COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer, nonUnitKeys) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        if (nonUnitKeys.indexOf(u) >= 0) continue;
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(:?\/[A-Za-z_+-]{1,256}(\/[A-Za-z_+-]{1,256})?)?/;
function $63618293c58b5f80$var$stringify(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$formatString(knownFormat) {
    // these all have the offsets removed because we don't have access to them
    // without all the intl stuff this is backfilling
    var filtered = $63618293c58b5f80$var$pick(knownFormat, [
        "weekday",
        "era",
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "timeZoneName",
        "hour12"
    ]), key = $63618293c58b5f80$var$stringify(filtered), dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
    switch(key){
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_SHORT):
            return "M/d/yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_MED):
            return "LLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY):
            return "EEE, LLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_FULL):
            return "LLLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATE_HUGE):
            return "EEEE, LLLL d, yyyy";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_SIMPLE):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_SECONDS):
            return "h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_WITH_LONG_OFFSET):
            return "h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_SIMPLE):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_SECONDS):
            return "HH:mm:ss";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET):
            return "HH:mm";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_SHORT):
            return "M/d/yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED):
            return "LLL d, yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_FULL):
            return "LLLL d, yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_HUGE):
            return dateTimeHuge;
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS):
            return "M/d/yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS):
            return "LLL d, yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY):
            return "EEE, d LLL yyyy, h:mm a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS):
            return "LLLL d, yyyy, h:mm:ss a";
        case $63618293c58b5f80$var$stringify($63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS):
            return "EEEE, LLLL d, yyyy, h:mm:ss a";
        default:
            return dateTimeHuge;
    }
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.formatToParts();
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        if (opts === void 0) opts = {};
        var df = this.loc.dtFormatter(dt, Object.assign({}, this.opts, opts));
        return df.resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = Object.assign({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory" && $63618293c58b5f80$var$hasFormatToParts(), string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hour12: true
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    };
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            /**
     * The type of zone
     * @abstract
     * @type {string}
     */ get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "universal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$LocalZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(LocalZone, _Zone);
    function LocalZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = LocalZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "local";
    };
    $63618293c58b5f80$var$_createClass(LocalZone, [
        {
            key: "type",
            /** @override **/ get: function get() {
                return "local";
            }
        },
        {
            key: "name",
            get: function get() {
                if ($63618293c58b5f80$var$hasIntl()) return new Intl.DateTimeFormat().resolvedOptions().timeZone;
                else return "local";
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            /**
     * Get a singleton instance of the local zone
     * @return {LocalZone}
     */ get: function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new LocalZone();
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return LocalZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$matchingRegex = RegExp("^" + $63618293c58b5f80$var$ianaRegex.source + "$");
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fHour = parsed[4], fMinute = parsed[5], fSecond = parsed[6];
    return [
        fYear,
        fMonth,
        fDay,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date), filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value, pos = $63618293c58b5f80$var$typeToPos[type];
        if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    };
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    };
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return !!(s && s.match($63618293c58b5f80$var$matchingRegex));
    };
    IANAZone.isValidZone = function isValidZone(zone) {
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    } // Etc/GMT+8 -> -480
    ;
    IANAZone.parseGMTOffset = function parseGMTOffset(specifier) {
        if (specifier) {
            var match = specifier.match(/^Etc\/GMT(0|[+-]\d{1,2})$/i);
            if (match) return -60 * parseInt(match[1]);
        }
        return null;
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    };
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name), _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], hour = _ref2[3], minute = _ref2[4], second = _ref2[5], adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    };
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    };
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, null, [
        {
            key: "utcInstance",
            /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ get: function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    };
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    };
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    };
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    };
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "universal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    };
    _proto.formatOffset = function formatOffset() {
        return "";
    };
    _proto.offset = function offset() {
        return NaN;
    };
    _proto.equals = function equals() {
        return false;
    };
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "universal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    var offset;
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "local") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else if ((offset = $63618293c58b5f80$var$IANAZone.parseGMTOffset(input)) != null) // handle Etc/GMT-4, which V8 chokes on
        return $63618293c58b5f80$var$FixedOffsetZone.instance(offset);
        else if ($63618293c58b5f80$var$IANAZone.isValidSpecifier(lowered)) return $63618293c58b5f80$var$IANAZone.create(input);
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || new $63618293c58b5f80$var$InvalidZone(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = null, // not setting this directly to LocalZone.instance bc loading order issues
$63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$throwOnInvalid = false;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ get: function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZoneName",
            get: function get() {
                return Settings.defaultZone.name;
            },
            set: function set(z) {
                if (!z) $63618293c58b5f80$var$defaultZone = null;
                else $63618293c58b5f80$var$defaultZone = $63618293c58b5f80$var$normalizeZone(z);
            }
        },
        {
            key: "defaultZone",
            get: function get() {
                return $63618293c58b5f80$var$defaultZone || $63618293c58b5f80$var$LocalZone.instance;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts, base = _opts.base, cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, [
        "base"
    ]); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else if ($63618293c58b5f80$var$hasIntl()) {
        var computedSys = new Intl.DateTimeFormat().resolvedOptions().locale; // node sometimes defaults to "und". Override that because that is dumb
        $63618293c58b5f80$var$sysLocaleCache = !computedSys || computedSys === "und" ? "en-US" : computedSys;
        return $63618293c58b5f80$var$sysLocaleCache;
    } else {
        $63618293c58b5f80$var$sysLocaleCache = "en-US";
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var smaller = localeStr.substring(0, uIndex);
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar; // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if ($63618293c58b5f80$var$hasIntl()) {
        if (outputCalendar || numberingSystem) {
            localeStr += "-u";
            if (outputCalendar) localeStr += "-ca-" + outputCalendar;
            if (numberingSystem) localeStr += "-nu-" + numberingSystem;
            return localeStr;
        } else return localeStr;
    } else return [];
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    var mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || $63618293c58b5f80$var$hasIntl() && new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        if (!forceSimple && $63618293c58b5f80$var$hasIntl()) {
            var intlOpts = {
                useGrouping: false
            };
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.hasIntl = $63618293c58b5f80$var$hasIntl();
        var z;
        if (dt.zone.universal && this.hasIntl) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            var isOffsetZoneSupported = $63618293c58b5f80$var$IANAZone.isValidZone(offsetZ);
            if (dt.offset !== 0 && isOffsetZoneSupported) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : $63618293c58b5f80$var$DateTime.fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "local") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        if (this.hasIntl) {
            var intlOpts = Object.assign({}, this.opts);
            if (z) intlOpts.timeZone = z;
            this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
        }
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.hasIntl) return this.dtf.format(this.dt.toJSDate());
        else {
            var tokenFormat = $63618293c58b5f80$var$formatString(this.opts), loc = $63618293c58b5f80$var$Locale.create("en-US");
            return $63618293c58b5f80$var$Formatter.create(loc).formatDateTimeFromString(this.dt, tokenFormat);
        }
    };
    _proto2.formatToParts = function formatToParts() {
        if (this.hasIntl && $63618293c58b5f80$var$hasFormatToParts()) return this.dtf.formatToParts(this.dt.toJSDate());
        else // This is kind of a cop out. We actually could do this for English. However, we couldn't do it for intl strings
        // and IMO it's too weird to have an uncanny valley like that
        return [];
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        if (this.hasIntl) return this.dtf.resolvedOptions();
        else return {
            locale: "en-US",
            numberingSystem: "latn",
            outputCalendar: "gregory"
        };
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = Object.assign({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale, // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale()), numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem, outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, outputCalendar = _ref.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode(defaultOK) {
        if (defaultOK === void 0) defaultOK = true;
        var intl = $63618293c58b5f80$var$hasIntl(), hasFTP = intl && $63618293c58b5f80$var$hasFormatToParts(), isActuallyEn = this.isEnglish(), hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        if (!hasFTP && !(isActuallyEn && hasNoWeirdness) && !defaultOK) return "error";
        else if (!hasFTP || isActuallyEn && hasNoWeirdness) return "en";
        else return "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone(Object.assign({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone(Object.assign({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format, defaultOK) {
        var _this = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this.monthsCache[formatStr][length]) _this.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this.extract(dt, intl, "month");
            });
            return _this.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format, defaultOK) {
        var _this2 = this;
        if (format === void 0) format = false;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.weekdaysCache[formatStr][length]) _this2.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this2.extract(dt, intl, "weekday");
            });
            return _this2.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1(defaultOK) {
        var _this3 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, undefined, defaultOK, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this3.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hour12: true
                };
                _this3.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this3.extract(dt, intl, "dayperiod");
                });
            }
            return _this3.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length, defaultOK) {
        var _this4 = this;
        if (defaultOK === void 0) defaultOK = true;
        return $63618293c58b5f80$var$listStuff(this, length, defaultOK, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            }; // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this4.eraCache[length]) _this4.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this4.extract(dt, intl, "era");
            });
            return _this4.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || $63618293c58b5f80$var$hasIntl() && new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                Object.assign(mergedVals, val),
                mergedZone || zone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
} // ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/, $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/, $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$offsetRegex.source + "?"), $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?"), $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/, $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/, $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/, $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay"), $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal"), $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/, // dumbed-down version of the ISO one
$63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?"), $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
} // ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$"); // ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,9})Y)?(?:(-?\d{1,9})M)?(?:(-?\d{1,9})W)?(?:(-?\d{1,9})D)?(?:T(?:(-?\d{1,9})H)?(?:(-?\d{1,9})M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,9}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseInteger(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseInteger(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseInteger(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseInteger(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseInteger(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseInteger(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseInteger(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
} // These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
} // RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
} // http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wedsday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset);
/**
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeOffsetAndIANAZone
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID = "Invalid Duration"; // unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = Object.assign({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = Object.assign({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix); // units ordered by size
var $63618293c58b5f80$var$orderedUnits = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits.slice(0).reverse(); // clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : Object.assign({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
} // NB: mutates parameters
function $63618293c58b5f80$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    var conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $63618293c58b5f80$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
} // NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    $63618293c58b5f80$var$reverseUnits.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) $63618293c58b5f80$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime.plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration.years}, {@link Duration.months}, {@link Duration.weeks}, {@link Duration.days}, {@link Duration.hours}, {@link Duration.minutes}, {@link Duration.seconds}, {@link Duration.milliseconds} accessors.
 * * **Configuration** See  {@link Duration.locale} and {@link Duration.numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration.plus}, {@link Duration.minus}, {@link Duration.normalize}, {@link Duration.set}, {@link Duration.reconfigure}, {@link Duration.shiftTo}, and {@link Duration.negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration.as}, {@link Duration.toISO}, {@link Duration.toFormat}, and {@link Duration.toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject(Object.assign({
            milliseconds: count
        }, opts));
    };
    Duration.fromObject = function fromObject(obj) {
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit, [
                "locale",
                "numberingSystem",
                "conversionAccuracy",
                "zone" // a bit of debt; it's super inconvenient internally not to be able to blindly pass this
            ]),
            loc: $63618293c58b5f80$var$Locale.fromObject(obj),
            conversionAccuracy: obj.conversionAccuracy
        });
    };
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) {
            var obj = Object.assign(parsed, opts);
            return Duration.fromObject(obj);
        } else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) {
            var obj = Object.assign(parsed, opts);
            return Duration.fromObject(obj);
        } else return Duration.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    };
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    };
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    };
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * The duration will be converted to the set of units in the format string using {@link Duration.shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = Object.assign({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = Object.assign({}, this.values);
        if (opts.includeConfig) {
            base.conversionAccuracy = this.conversionAccuracy;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = Object.assign({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        var value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        var fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        var str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toString = function toString() {
        return this.toISO();
    };
    _proto.toMillis = function toMillis() {
        return this.as("milliseconds");
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), result = {};
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step; !(_step = _iterator()).done;){
            var k = _step.value;
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone(this, {
            values: result
        }, true);
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        return this.plus(dur.negate());
    };
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i = 0, _Object$keys = Object.keys(this.values); _i < _Object$keys.length; _i++){
            var k = _Object$keys[_i];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone(this, {
            values: result
        }, true);
    };
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = Object.assign(this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit, []));
        return $63618293c58b5f80$var$clone(this, {
            values: mixed
        });
    };
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $63618293c58b5f80$var$clone(this, opts);
    };
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    };
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone(this, {
            values: vals
        }, true);
    };
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step2; !(_step2 = _iterator2()).done;){
            var k = _step2.value;
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0; // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                } // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = own - i; // we'd like to absorb these fractions in another unit
                // plus anything further down the chain that should be rolled up in to this
                for(var down in vals)if ($63618293c58b5f80$var$orderedUnits.indexOf(down) > $63618293c58b5f80$var$orderedUnits.indexOf(k)) $63618293c58b5f80$var$convert(this.matrix, vals, down, built, k);
                 // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        } // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $63618293c58b5f80$var$clone(this, {
            values: built
        }, true).normalize();
    };
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i2 = 0, _Object$keys2 = Object.keys(this.values); _i2 < _Object$keys2.length; _i2++){
            var k = _Object$keys2[_i2];
            negated[k] = -this.values[k];
        }
        return $63618293c58b5f80$var$clone(this, {
            values: negated
        }, true);
    };
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
function $63618293c58b5f80$var$friendlyDuration(durationish) {
    if ($63618293c58b5f80$var$isNumber(durationish)) return $63618293c58b5f80$var$Duration.fromMillis(durationish);
    else if ($63618293c58b5f80$var$Duration.isDuration(durationish)) return durationish;
    else if (typeof durationish === "object") return $63618293c58b5f80$var$Duration.fromObject(durationish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationish + " of type " + typeof durationish);
}
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval"; // checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link fromDateTimes}, {@link after}, {@link before}, or {@link fromISO}.
 * * **Accessors** Use {@link start} and {@link end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link count}, {@link length}, {@link hasSame}, {@link contains}, {@link isAfter}, or {@link isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link set}, {@link splitAt}, {@link splitBy}, {@link divideEqually}, {@link merge}, {@link xor}, {@link union}, {@link intersection}, or {@link difference}.
 * * **Comparison** To compare this Interval to another one, use {@link equals}, {@link overlaps}, {@link abutsStart}, {@link abutsEnd}, {@link engulfs}.
 * * **Output** To convert the Interval into other representations, see {@link toString}, {@link toISO}, {@link toISODate}, {@link toISOTime}, {@link toFormat}, and {@link toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    };
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    };
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    };
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    };
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", "the input \"" + text + "\" can't be parsed as ISO 8601");
    };
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    };
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    };
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    };
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    };
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    };
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    };
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    };
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    };
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    };
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    };
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    };
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    };
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    };
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    };
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    };
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    };
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    };
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    };
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    };
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    };
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    };
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    };
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " \u2013 " + this.e.toISO() + ")";
    };
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    };
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    };
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    };
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " \u2013 " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    };
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    };
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.universal && proto.offset !== proto.set({
            month: 6
        }).offset;
    };
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidSpecifier(zone) && $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    };
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    };
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    };
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    };
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    };
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    };
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    };
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    };
    Info.features = function features() {
        var intl = false, intlTokens = false, zones = false, relative = false;
        if ($63618293c58b5f80$var$hasIntl()) {
            intl = true;
            intlTokens = $63618293c58b5f80$var$hasFormatToParts();
            relative = $63618293c58b5f80$var$hasRelative();
            try {
                zones = new Intl.DateTimeFormat("en", {
                    timeZone: "America/New_York"
                }).resolvedOptions().timeZone === "America/New_York";
            } catch (e) {
                zones = false;
            }
        }
        return {
            intl: intl,
            intlTokens: intlTokens,
            zones: zones,
            relative: relative
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var lowestOrder, highWater;
    for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            var _cursor$plus;
            lowestOrder = unit;
            var delta = differ(cursor, later);
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[unit] = delta, _cursor$plus));
            if (highWater > later) {
                var _cursor$plus2;
                cursor = cursor.plus((_cursor$plus2 = {}, _cursor$plus2[unit] = delta - 1, _cursor$plus2));
                delta -= 1;
            } else cursor = highWater;
            results[unit] = delta;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus3;
            highWater = cursor.plus((_cursor$plus3 = {}, _cursor$plus3[lowestOrder] = 1, _cursor$plus3));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(Object.assign(results, opts));
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
}; // eslint-disable-next-line
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $63618293c58b5f80$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "( |" + $63618293c58b5f80$var$NBSP + ")";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    // eslint-disable-next-line no-useless-escape
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, locale, formatOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    var style = formatOpts[type];
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone;
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
    else if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    else zone = null;
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var parts = formatter.formatDateTimeParts($63618293c58b5f80$var$getDummyDateTime());
    var tokens = parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, locale, formatOpts);
    });
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $63618293c58b5f80$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $63618293c58b5f80$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $63618293c58b5f80$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
            null,
            null
        ], result = _ref6[0], zone = _ref6[1];
        if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone
        };
    }
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        invalidReason
    ];
}
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var js = new Date(Date.UTC(year, month - 1, day)).getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return Object.assign({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$dayOfWeek(weekYear, 1, 4), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return Object.assign({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return Object.assign({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal, _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return Object.assign({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", "the zone \"" + zone.name + "\" is not supported");
} // we cache week data on the DT object and this intermediates the cache
function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
} // clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone$1(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime(Object.assign({}, current, alts, {
        old: current
    }));
} // find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000; // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess); // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
     // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000; // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
     // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
} // convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
} // convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
} // create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = Object.assign({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd; // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
} // helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(Object.assign(parsed, opts, {
            zone: interpretationZone,
            // setZone is a valid option in the calling methods, but not in fromObject
            setZone: undefined
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", "the input \"" + text + "\" can't be parsed as " + format));
} // if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
} // technical time formats (e.g. the time part of ISO 8601), take some options
// and this commonizes their handling
function $63618293c58b5f80$var$toTechTimeFormat(dt, _ref) {
    var _ref$suppressSeconds = _ref.suppressSeconds, suppressSeconds = _ref$suppressSeconds === void 0 ? false : _ref$suppressSeconds, _ref$suppressMillisec = _ref.suppressMilliseconds, suppressMilliseconds = _ref$suppressMillisec === void 0 ? false : _ref$suppressMillisec, includeOffset = _ref.includeOffset, _ref$includePrefix = _ref.includePrefix, includePrefix = _ref$includePrefix === void 0 ? false : _ref$includePrefix, _ref$includeZone = _ref.includeZone, includeZone = _ref$includeZone === void 0 ? false : _ref$includeZone, _ref$spaceZone = _ref.spaceZone, spaceZone = _ref$spaceZone === void 0 ? false : _ref$spaceZone, _ref$format = _ref.format, format = _ref$format === void 0 ? "extended" : _ref$format;
    var fmt = format === "basic" ? "HHmm" : "HH:mm";
    if (!suppressSeconds || dt.second !== 0 || dt.millisecond !== 0) {
        fmt += format === "basic" ? "ss" : ":ss";
        if (!suppressMilliseconds || dt.millisecond !== 0) fmt += ".SSS";
    }
    if ((includeZone || includeOffset) && spaceZone) fmt += " ";
    if (includeZone) fmt += "z";
    else if (includeOffset) fmt += format === "basic" ? "ZZZ" : "ZZ";
    var str = $63618293c58b5f80$var$toTechFormat(dt, fmt);
    if (includePrefix) str = "T" + str;
    return str;
} // defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}; // Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits$1 = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
]; // standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
} // this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, zone) {
    // assume we have the higher-order units
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$orderedUnits$1), _step; !(_step = _iterator()).done;){
        var u = _step.value;
        if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
    }
    var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
    if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
    var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = zone.offset(tsNow), _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone), ts = _objToTS[0], o = _objToTS[1];
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step2; !(_step2 = _iterator2()).done;){
        var unit = _step2.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link local}, {@link utc}, and (most flexibly) {@link fromObject}. To create one from a standard string format, use {@link fromISO}, {@link fromHTTP}, and {@link fromRFC2822}. To create one from a custom string format, use {@link fromFormat}. To create one from a native JS date, use {@link fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link toObject}), use the {@link year}, {@link month},
 * {@link day}, {@link hour}, {@link minute}, {@link second}, {@link millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link weekYear}, {@link weekNumber}, and {@link weekday} accessors.
 * * **Configuration** See the {@link locale} and {@link numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link set}, {@link reconfigure}, {@link setZone}, {@link setLocale}, {@link plus}, {@link minus}, {@link endOf}, {@link startOf}, {@link toUTC}, and {@link toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link toRelative}, {@link toRelativeCalendar}, {@link toJSON}, {@link toISO}, {@link toHTTP}, {@link toObject}, {@link toRFC2822}, {@link toString}, {@link toLocaleString}, {@link toFormat}, {@link toMillis} and {@link toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref2 = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref2[0];
                o = _ref2[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    } // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    };
    DateTime.local = function local(year, month, day, hour, minute, second, millisecond) {
        if ($63618293c58b5f80$var$isUndefined(year)) return DateTime.now();
        else return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, $63618293c58b5f80$var$Settings.defaultZone);
    };
    DateTime.utc = function utc(year, month, day, hour, minute, second, millisecond) {
        if ($63618293c58b5f80$var$isUndefined(year)) return new DateTime({
            ts: $63618293c58b5f80$var$Settings.now(),
            zone: $63618293c58b5f80$var$FixedOffsetZone.utcInstance
        });
        else return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, $63618293c58b5f80$var$FixedOffsetZone.utcInstance);
    };
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    };
    DateTime.fromObject = function fromObject(obj) {
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(obj.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = zoneToUse.offset(tsNow), normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnit, [
            "zone",
            "locale",
            "outputCalendar",
            "numberingSystem"
        ]), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $63618293c58b5f80$var$Locale.fromObject(obj); // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor; // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits$1;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        } // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator3 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step3; !(_step3 = _iterator3()).done;){
            var u = _step3.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        } // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
         // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        }); // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    };
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    };
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    };
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    };
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], invalid = _parseFromTokens[2];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text);
    };
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    };
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    };
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    };
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } // INFO
    ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    };
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOpts = function resolvedLocaleOpts(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } // TRANSFORM
    ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    };
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    };
    _proto.setZone = function setZone(zone, _temp) {
        var _ref3 = _temp === void 0 ? {} : _temp, _ref3$keepLocalTime = _ref3.keepLocalTime, keepLocalTime = _ref3$keepLocalTime === void 0 ? false : _ref3$keepLocalTime, _ref3$keepCalendarTim = _ref3.keepCalendarTime, keepCalendarTime = _ref3$keepCalendarTim === void 0 ? false : _ref3$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone$1(this, {
                ts: newTS,
                zone: zone
            });
        }
    };
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref4 = _temp2 === void 0 ? {} : _temp2, locale = _ref4.locale, numberingSystem = _ref4.numberingSystem, outputCalendar = _ref4.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone$1(this, {
            loc: loc
        });
    };
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    };
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnit, []), settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian(Object.assign($63618293c58b5f80$var$gregorianToWeek(this.c), normalized));
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian(Object.assign($63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = Object.assign(this.toObject(), normalized); // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone$1(this, {
            ts: ts,
            o: o
        });
    };
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration);
        return $63618293c58b5f80$var$clone$1(this, $63618293c58b5f80$var$adjustTime(this, dur));
    };
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$friendlyDuration(duration).negate();
        return $63618293c58b5f80$var$clone$1(this, $63618293c58b5f80$var$adjustTime(this, dur));
    };
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    };
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } // OUTPUT
    ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.toLocaleString = function toLocaleString(opts) {
        if (opts === void 0) opts = $63618293c58b5f80$var$DATE_SHORT;
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTime(this) : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    };
    _proto.toISO = function toISO(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toISODate(opts) + "T" + this.toISOTime(opts);
    };
    _proto.toISODate = function toISODate(_temp3) {
        var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        var fmt = format === "basic" ? "yyyyMMdd" : "yyyy-MM-dd";
        if (this.year > 9999) fmt = "+" + fmt;
        return $63618293c58b5f80$var$toTechFormat(this, fmt);
    };
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    };
    _proto.toISOTime = function toISOTime(_temp4) {
        var _ref6 = _temp4 === void 0 ? {} : _temp4, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        return $63618293c58b5f80$var$toTechTimeFormat(this, {
            suppressSeconds: suppressSeconds,
            suppressMilliseconds: suppressMilliseconds,
            includeOffset: includeOffset,
            includePrefix: includePrefix,
            format: format
        });
    };
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    };
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    };
    _proto.toSQLDate = function toSQLDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "yyyy-MM-dd");
    };
    _proto.toSQLTime = function toSQLTime(_temp5) {
        var _ref7 = _temp5 === void 0 ? {} : _temp5, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone;
        return $63618293c58b5f80$var$toTechTimeFormat(this, {
            includeOffset: includeOffset,
            includeZone: includeZone,
            spaceZone: true
        });
    };
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    };
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID$2;
    };
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    };
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    };
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    };
    _proto.toJSON = function toJSON() {
        return this.toISO();
    };
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    };
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = Object.assign({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    };
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } // COMPARE
    ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalid || otherDateTime.invalid, "created by diffing an invalid DateTime");
        var durOpts = Object.assign({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    };
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    };
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    };
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var otherZoneDateTime = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return otherZoneDateTime.startOf(unit) <= inputMs && inputMs <= otherZoneDateTime.endOf(unit);
    };
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    };
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), Object.assign(options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    };
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({
            zone: this.zone
        }), this, Object.assign(options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    };
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    };
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } // MISC
    ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    };
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } // FORMAT PRESETS
    ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.universal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "1.28.1";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.LocalZone = $63618293c58b5f80$var$LocalZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;


"use strict";
const $25dcdcde7533cf1d$export$461939dd4422153 = function() {
    return (0, $63618293c58b5f80$exports.DateTime).now();
};
const $25dcdcde7533cf1d$export$151b1e86af400017 = function(just, nothing) {
    return function(str) {
        var dt = (0, $63618293c58b5f80$exports.DateTime).fromISO(str.replace(' ', 'T'));
        if (dt.isValid) return just(dt);
        else return nothing;
    };
};
const $25dcdcde7533cf1d$export$b1bc68b38a4b1ea7 = function(dt) {
    return dt.toISO();
};
const $25dcdcde7533cf1d$export$813805487cd3e191 = function(dt) {
    return dt.toISO({
        includeOffset: false
    });
};
const $25dcdcde7533cf1d$export$68229f54ea42ee8c = function(dt) {
    return dt.toMillis();
};
const $25dcdcde7533cf1d$export$c12d4497c7cc4368 = function(dt) {
    return dt.toRelative();
};
const $25dcdcde7533cf1d$export$67da4c19e99f01f3 = function(fmt) {
    return function(dt) {
        return dt.toFormat(fmt);
    };
};
const $25dcdcde7533cf1d$export$bf6e6ac8a7b3ac76 = (0, $63618293c58b5f80$exports.DateTime).DATETIME_FULL;
const $25dcdcde7533cf1d$export$5f2320d02799e74b = function(fmt) {
    return function(dt) {
        return dt.toLocaleString(fmt);
    };
};
const $25dcdcde7533cf1d$export$b84e6dbdec7469b = function(a) {
    return function(b) {
        return a.equals(b);
    };
};
const $25dcdcde7533cf1d$export$a1af12e21b57795a = function(dt) {
    return dt.toString();
};








var $35e75b0a064776f5$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $35e75b0a064776f5$export$b8d60a56343922f7 = {
    show: $25dcdcde7533cf1d$export$a1af12e21b57795a
};
var $35e75b0a064776f5$export$cde3d1388a9feac3 = /* #__PURE__ */ $25dcdcde7533cf1d$export$67da4c19e99f01f3("LLL dd, yyyy t");
var $35e75b0a064776f5$export$8b724767bfa64e7d = /* #__PURE__ */ function() {
    return $25dcdcde7533cf1d$export$151b1e86af400017($06733ae99ed4f534$export$8a67b48435b5d073.create, $06733ae99ed4f534$export$bebe9059409a0d04.value);
}();
var $35e75b0a064776f5$export$841f751694498c54 = {
    eq: $25dcdcde7533cf1d$export$b84e6dbdec7469b
};
var $35e75b0a064776f5$export$d3fd8e55e9d4c026 = {
    encodeJson: function($2) {
        return $13459527b23e3834$export$8146d2e653b87d6a($25dcdcde7533cf1d$export$b1bc68b38a4b1ea7($2));
    }
};
var $35e75b0a064776f5$export$4fd8c305226c2099 = {
    decodeJson: function(json) {
        return $35e75b0a064776f5$var$bind($160716589b57c4ec$export$a0fb664af7d0cc44(json))(function(str) {
            return $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("DateTime"))($35e75b0a064776f5$export$8b724767bfa64e7d(str));
        });
    }
};



var $02eacf321b2a2128$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $02eacf321b2a2128$var$StudentIsSymbol = {
    reflectSymbol: function() {
        return "Student";
    }
};
var $02eacf321b2a2128$var$fromUnionTag = /* #__PURE__ */ $266cd1b01131a218$export$af49fdaa8790af7f($02eacf321b2a2128$var$StudentIsSymbol)();
var $02eacf321b2a2128$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $02eacf321b2a2128$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $02eacf321b2a2128$var$colorIsSymbol = {
    reflectSymbol: function() {
        return "color";
    }
};
var $02eacf321b2a2128$var$tagsIsSymbol = {
    reflectSymbol: function() {
        return "tags";
    }
};
var $02eacf321b2a2128$var$preferred_nameIsSymbol = {
    reflectSymbol: function() {
        return "preferred_name";
    }
};
var $02eacf321b2a2128$var$last_imported_atIsSymbol = {
    reflectSymbol: function() {
        return "last_imported_at";
    }
};
var $02eacf321b2a2128$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $02eacf321b2a2128$var$account_typeIsSymbol = {
    reflectSymbol: function() {
        return "account_type";
    }
};
var $02eacf321b2a2128$var$accountIsSymbol = {
    reflectSymbol: function() {
        return "account";
    }
};
var $02eacf321b2a2128$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $02eacf321b2a2128$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $02eacf321b2a2128$export$98e21ef3f6f7703b = /* #__PURE__ */ function() {
    function StudentAccount() {}
    StudentAccount.value = new StudentAccount();
    return StudentAccount;
}();
var $02eacf321b2a2128$export$6f3aad56498a7cb9 = /* #__PURE__ */ function() {
    function TeacherAccount() {}
    TeacherAccount.value = new TeacherAccount();
    return TeacherAccount;
}();
var $02eacf321b2a2128$export$ebce5c1c966101a4 = /* #__PURE__ */ function() {
    function BoardAccount() {}
    BoardAccount.value = new BoardAccount();
    return BoardAccount;
}();
var $02eacf321b2a2128$export$5315b7c1b1d9e384 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $02eacf321b2a2128$export$98e21ef3f6f7703b && y instanceof $02eacf321b2a2128$export$98e21ef3f6f7703b) return true;
            if (x instanceof $02eacf321b2a2128$export$6f3aad56498a7cb9 && y instanceof $02eacf321b2a2128$export$6f3aad56498a7cb9) return true;
            if (x instanceof $02eacf321b2a2128$export$ebce5c1c966101a4 && y instanceof $02eacf321b2a2128$export$ebce5c1c966101a4) return true;
            return false;
        };
    }
};
var $02eacf321b2a2128$export$6d98a66c87f86285 = {
    decodeJson: function(json) {
        var v = $2a035e92dc768ac1$export$f84e8e69fd4488a5(json);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "STUDENT") return new $7d4cccdf062a2261$export$19db0165690c701a($02eacf321b2a2128$export$98e21ef3f6f7703b.value);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "TEACHER") return new $7d4cccdf062a2261$export$19db0165690c701a($02eacf321b2a2128$export$6f3aad56498a7cb9.value);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "BOARD_ADMIN") return new $7d4cccdf062a2261$export$19db0165690c701a($02eacf321b2a2128$export$ebce5c1c966101a4.value);
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("AccountType"));
    }
};
var $02eacf321b2a2128$export$e4a393ea5d58ca7a = /* #__PURE__ */ function() {
    var process = function(v) {
        return {
            type: v.account_type,
            student: $02eacf321b2a2128$var$bindFlipped($02eacf321b2a2128$var$fromUnionTag($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))(v.account)
        };
    };
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("AccountInfo")($f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5)(process)($a40b20519abba0fb$export$d7b58f10109feb02($a40b20519abba0fb$export$450e3c8f9eaaa96f($a40b20519abba0fb$export$bb525b50bfdf2bbc)($a40b20519abba0fb$export$fe891b8934c38330)())($a40b20519abba0fb$export$1cde869cdd796379($e2b1be82a5e6d14f$export$b423891985836fe9($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$5be2ed97e7605dc7($266cd1b01131a218$export$233e215ca2d72bc7($266cd1b01131a218$export$96d29a771776afc1($266cd1b01131a218$export$10ea8b8b83e08901)($02eacf321b2a2128$var$StudentIsSymbol)($e2b1be82a5e6d14f$export$b423891985836fe9($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$d94c139f6fec2f7f($308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))($02eacf321b2a2128$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d))($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$81879b02e9646afe($e2b1be82a5e6d14f$export$b423891985836fe9($02eacf321b2a2128$var$gDecodeJsonCons($02eacf321b2a2128$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($02eacf321b2a2128$var$nameIsSymbol)()())($02eacf321b2a2128$var$colorIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($02eacf321b2a2128$var$tagsIsSymbol)()())($02eacf321b2a2128$var$preferred_nameIsSymbol)()())($02eacf321b2a2128$var$nameIsSymbol)()())($02eacf321b2a2128$var$last_imported_atIsSymbol)()())($02eacf321b2a2128$var$idIsSymbol)()())())()())()))($e2b1be82a5e6d14f$export$44d61a05912ad881($e2b1be82a5e6d14f$export$d94c139f6fec2f7f($02eacf321b2a2128$export$6d98a66c87f86285))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($02eacf321b2a2128$var$account_typeIsSymbol)()())($02eacf321b2a2128$var$accountIsSymbol)()())())($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($02eacf321b2a2128$var$rlhsCons($02eacf321b2a2128$var$account_typeIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($02eacf321b2a2128$var$accountIsSymbol)($266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$d1213f059a1aeef8($266cd1b01131a218$export$62f20211aacc4215($266cd1b01131a218$export$750fc123d68a1541)($02eacf321b2a2128$var$StudentIsSymbol)($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($02eacf321b2a2128$var$rlhsCons($02eacf321b2a2128$var$tagsIsSymbol)($266cd1b01131a218$export$c6279c3a85890bd5($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($02eacf321b2a2128$var$rlhsCons($02eacf321b2a2128$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($02eacf321b2a2128$var$colorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($02eacf321b2a2128$var$preferred_nameIsSymbol)($02eacf321b2a2128$var$maybeShape)()())($02eacf321b2a2128$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($02eacf321b2a2128$var$last_imported_atIsSymbol)($02eacf321b2a2128$var$maybeShape)()())($02eacf321b2a2128$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())()))()())()))("me")({})));
}();


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16











var $468ec44be9fa5236$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $468ec44be9fa5236$var$match = /* #__PURE__ */ $a5ccce070b256bc7$export$4659b591c19bdf3d()()();
var $468ec44be9fa5236$var$authorIsSymbol = {
    reflectSymbol: function() {
        return "author";
    }
};
var $468ec44be9fa5236$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $468ec44be9fa5236$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $468ec44be9fa5236$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $468ec44be9fa5236$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $468ec44be9fa5236$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $468ec44be9fa5236$var$rltvCons1 = /* #__PURE__ */ $468ec44be9fa5236$var$rltvCons($468ec44be9fa5236$var$idIsSymbol)($468ec44be9fa5236$var$rntyType)($468ec44be9fa5236$var$encRNTY)()();
var $468ec44be9fa5236$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $468ec44be9fa5236$var$rntyType1 = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "CommentInput";
    }
});
var $468ec44be9fa5236$var$publicIsSymbol = {
    reflectSymbol: function() {
        return "public";
    }
};
var $468ec44be9fa5236$var$commentIsSymbol = {
    reflectSymbol: function() {
        return "comment";
    }
};
var $468ec44be9fa5236$var$encRNTY1 = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b)(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$7f2886916ce99188)($eb7399d322077fcf$export$12b4d820b2ffc726)($468ec44be9fa5236$var$publicIsSymbol)())($468ec44be9fa5236$var$commentIsSymbol)())());
var $468ec44be9fa5236$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $468ec44be9fa5236$var$rltvfConsOther1 = /* #__PURE__ */ $468ec44be9fa5236$var$rltvfConsOther($468ec44be9fa5236$var$idIsSymbol)();
var $468ec44be9fa5236$var$rltvfConsOther2 = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $468ec44be9fa5236$var$rltvfConsOther($468ec44be9fa5236$var$publicIsSymbol)())($468ec44be9fa5236$var$commentIsSymbol)();
var $468ec44be9fa5236$var$TeacherIsSymbol = {
    reflectSymbol: function() {
        return "Teacher";
    }
};
var $468ec44be9fa5236$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $468ec44be9fa5236$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $468ec44be9fa5236$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($468ec44be9fa5236$var$nameIsSymbol)()())();
var $468ec44be9fa5236$var$StudentIsSymbol = {
    reflectSymbol: function() {
        return "Student";
    }
};
var $468ec44be9fa5236$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $468ec44be9fa5236$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $468ec44be9fa5236$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $468ec44be9fa5236$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099));
var $468ec44be9fa5236$var$updated_atIsSymbol = {
    reflectSymbol: function() {
        return "updated_at";
    }
};
var $468ec44be9fa5236$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $468ec44be9fa5236$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $468ec44be9fa5236$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $468ec44be9fa5236$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $468ec44be9fa5236$var$rlhsCons($468ec44be9fa5236$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $468ec44be9fa5236$var$jsonQR = /* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $266cd1b01131a218$export$233e215ca2d72bc7(/* #__PURE__ */ $266cd1b01131a218$export$96d29a771776afc1(/* #__PURE__ */ $266cd1b01131a218$export$96d29a771776afc1($266cd1b01131a218$export$10ea8b8b83e08901)($468ec44be9fa5236$var$TeacherIsSymbol)($468ec44be9fa5236$var$decodeRecord)()())($468ec44be9fa5236$var$StudentIsSymbol)($468ec44be9fa5236$var$decodeRecord)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons1(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($468ec44be9fa5236$var$updateIsSymbol)()())($468ec44be9fa5236$var$deleteIsSymbol)()())()))(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons2(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons1(/* #__PURE__ */ $468ec44be9fa5236$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($468ec44be9fa5236$var$updated_atIsSymbol)()())($468ec44be9fa5236$var$publicIsSymbol)()())($468ec44be9fa5236$var$idIsSymbol)()())($468ec44be9fa5236$var$created_atIsSymbol)()())($468ec44be9fa5236$var$commentIsSymbol)()())($468ec44be9fa5236$var$canIsSymbol)()())($468ec44be9fa5236$var$authorIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $468ec44be9fa5236$var$rlhsCons($468ec44be9fa5236$var$updated_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$publicIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$commentIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $468ec44be9fa5236$var$rlhsCons($468ec44be9fa5236$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($468ec44be9fa5236$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($468ec44be9fa5236$var$authorIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$d1213f059a1aeef8(/* #__PURE__ */ $266cd1b01131a218$export$62f20211aacc4215(/* #__PURE__ */ $266cd1b01131a218$export$62f20211aacc4215($266cd1b01131a218$export$750fc123d68a1541)($468ec44be9fa5236$var$TeacherIsSymbol)($468ec44be9fa5236$var$recShape)()())($468ec44be9fa5236$var$StudentIsSymbol)($468ec44be9fa5236$var$recShape)()())())()())());
var $468ec44be9fa5236$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($468ec44be9fa5236$var$rltvCons1)($468ec44be9fa5236$var$dataIsSymbol)($468ec44be9fa5236$var$rntyType1)($468ec44be9fa5236$var$encRNTY1)()())(/* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c($468ec44be9fa5236$var$rltvfConsOther1)($468ec44be9fa5236$var$dataIsSymbol)()()($468ec44be9fa5236$var$rltvfConsOther2))())($468ec44be9fa5236$var$jsonQR);
var $468ec44be9fa5236$var$parent_typeIsSymbol = {
    reflectSymbol: function() {
        return "parent_type";
    }
};
var $468ec44be9fa5236$var$parent_idIsSymbol = {
    reflectSymbol: function() {
        return "parent_id";
    }
};
var $468ec44be9fa5236$var$buildMutation1 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $468ec44be9fa5236$var$rltvCons($468ec44be9fa5236$var$parent_typeIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "CommentParentType";
    }
}))($468ec44be9fa5236$var$encRNTY)()())($468ec44be9fa5236$var$parent_idIsSymbol)($468ec44be9fa5236$var$rntyType)($468ec44be9fa5236$var$encRNTY)()())($468ec44be9fa5236$var$dataIsSymbol)($468ec44be9fa5236$var$rntyType1)($468ec44be9fa5236$var$encRNTY1)()())(/* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $468ec44be9fa5236$var$rltvfConsOther($468ec44be9fa5236$var$parent_typeIsSymbol)())($468ec44be9fa5236$var$parent_idIsSymbol)())($468ec44be9fa5236$var$dataIsSymbol)()()($468ec44be9fa5236$var$rltvfConsOther2))())($468ec44be9fa5236$var$jsonQR);
var $468ec44be9fa5236$var$buildMutation2 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f($468ec44be9fa5236$var$rltvCons1)($468ec44be9fa5236$var$rltvfConsOther1)())($468ec44be9fa5236$var$jsonQR);
var $468ec44be9fa5236$export$b0bbdc4308f56a81 = /* #__PURE__ */ function() {
    function FormComment(value0) {
        this.value0 = value0;
    }
    FormComment.create = function(value0) {
        return new FormComment(value0);
    };
    return FormComment;
}();
var $468ec44be9fa5236$export$be20e2d7eda534b2 = /* #__PURE__ */ function() {
    var processAuthor = function(au) {
        return $06733ae99ed4f534$export$43db023a260c5e9f({
            name: "No Author"
        })($468ec44be9fa5236$var$map($468ec44be9fa5236$var$match({
            Student: function(s) {
                return {
                    name: s.name
                };
            },
            Teacher: function(s) {
                return {
                    name: s.name
                };
            }
        }))($266cd1b01131a218$export$4fc17d1402aceb7b(au)));
    };
    return $15e8567e7c31ba30$export$3ff57735a52b8713($468ec44be9fa5236$var$authorIsSymbol)()()($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(processAuthor);
}();
var $468ec44be9fa5236$export$5a1cd239009d83a6 = function(id) {
    return function(input) {
        return $468ec44be9fa5236$var$map1($468ec44be9fa5236$export$be20e2d7eda534b2)($468ec44be9fa5236$var$buildMutation("updateComment")({
            id: id,
            data: $308f9765feb7633d$export$eb1b128a19ff6c25(input)
        }));
    };
};
var $468ec44be9fa5236$export$b8fc62ea9b811d23 = function(parent) {
    return function(input) {
        var parent$prime = {
            id: parent.value0,
            type: $308f9765feb7633d$export$eb1b128a19ff6c25("FORM")
        };
        return $468ec44be9fa5236$var$map1($468ec44be9fa5236$export$be20e2d7eda534b2)($468ec44be9fa5236$var$buildMutation1("createComment")({
            parent_id: parent$prime.id,
            parent_type: parent$prime.type,
            data: $308f9765feb7633d$export$eb1b128a19ff6c25(input)
        }));
    };
};
var $468ec44be9fa5236$export$2e6e3ad634e3776 = function(id) {
    return $468ec44be9fa5236$var$map1($468ec44be9fa5236$export$be20e2d7eda534b2)($468ec44be9fa5236$var$buildMutation2("deleteComment")({
        id: id
    }));
};











// Generated by purs version 0.15.16















var $81439e1d9c94314f$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($37b880af5f4991bd$export$fa624555ca2acbc8));
var $81439e1d9c94314f$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $81439e1d9c94314f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $81439e1d9c94314f$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
var $81439e1d9c94314f$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $81439e1d9c94314f$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $81439e1d9c94314f$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $81439e1d9c94314f$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $81439e1d9c94314f$export$22dce776e713bf54 = /* #__PURE__ */ function() {
    function AccessNone() {}
    AccessNone.value = new AccessNone();
    return AccessNone;
}();
var $81439e1d9c94314f$export$3dddd772b5443db6 = /* #__PURE__ */ function() {
    function AccessView() {}
    AccessView.value = new AccessView();
    return AccessView;
}();
var $81439e1d9c94314f$export$cb0693313c0aacc = /* #__PURE__ */ function() {
    function AccessUpdate() {}
    AccessUpdate.value = new AccessUpdate();
    return AccessUpdate;
}();
var $81439e1d9c94314f$export$9effa453a3bcbe67 = {
    show: function(v) {
        if (v instanceof $81439e1d9c94314f$export$22dce776e713bf54) return "NONE";
        if (v instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return "VIEW";
        if (v instanceof $81439e1d9c94314f$export$cb0693313c0aacc) return "UPDATE";
        throw new Error("Failed pattern match at Widgets.Form.Access (line 21, column 1 - line 24, column 33): " + [
            v.constructor.name
        ]);
    }
};
var $81439e1d9c94314f$export$ea93bfe3a74b70f3 = function(prefix) {
    return function(full) {
        return $81439e1d9c94314f$var$eq(prefix)($396c4c3d9e7fae3c$export$b7df5d561049483a($fc8c1182ec2aefec$export$f24224f1c91d8156(prefix))(full));
    };
};
var $81439e1d9c94314f$export$614888590ded97a5 = function(part) {
    return $06733ae99ed4f534$export$c15bd07a493e1236($8d5664f12212b23e$export$3004f64547af360e(part));
};
var $81439e1d9c94314f$export$7b51a412e283855 = /* #__PURE__ */ function() {
    var $50 = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(part) {
        return part !== "" && !$81439e1d9c94314f$export$614888590ded97a5(part);
    });
    var $51 = $5b07e36f812dd04b$export$65980d18b75784e2(".");
    return function($52) {
        return $50($51($52));
    };
}();
var $81439e1d9c94314f$export$7628927e17b1a329 = function(access) {
    return function(path) {
        var pathParts = $81439e1d9c94314f$export$7b51a412e283855(path);
        var matchDepth = function(v) {
            var fieldParts = $81439e1d9c94314f$export$7b51a412e283855(v.field);
            var $31 = $81439e1d9c94314f$export$ea93bfe3a74b70f3(fieldParts)(pathParts);
            if ($31) return new $06733ae99ed4f534$export$8a67b48435b5d073($fc8c1182ec2aefec$export$f24224f1c91d8156(fieldParts));
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var pickBest = function(current) {
            return function(entry) {
                var v = matchDepth(entry);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return current;
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    if (current instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        depth: v.value0,
                        access: entry.access
                    });
                    if (current instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 >= current.value0.depth) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                        depth: v.value0,
                        access: entry.access
                    });
                    if (current instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(current.value0);
                    throw new Error("Failed pattern match at Widgets.Form.Access (line 78, column 23 - line 81, column 35): " + [
                        current.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Widgets.Form.Access (line 76, column 30 - line 81, column 35): " + [
                    v.constructor.name
                ]);
            };
        };
        var best = $81439e1d9c94314f$var$foldl(pickBest)($06733ae99ed4f534$export$bebe9059409a0d04.value)(access.fields);
        return $06733ae99ed4f534$export$43db023a260c5e9f(access["default"])($81439e1d9c94314f$var$map(function(v) {
            return v.access;
        })(best));
    };
};
var $81439e1d9c94314f$export$e3358a95f047f6be = /* #__PURE__ */ function() {
    return {
        "default": $81439e1d9c94314f$export$cb0693313c0aacc.value,
        fields: []
    };
}();
var $81439e1d9c94314f$export$5b6fc71d31f53849 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $81439e1d9c94314f$export$22dce776e713bf54 && y instanceof $81439e1d9c94314f$export$22dce776e713bf54) return true;
            if (x instanceof $81439e1d9c94314f$export$3dddd772b5443db6 && y instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return true;
            if (x instanceof $81439e1d9c94314f$export$cb0693313c0aacc && y instanceof $81439e1d9c94314f$export$cb0693313c0aacc) return true;
            return false;
        };
    }
};
var $81439e1d9c94314f$export$c71b678135f778d5 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $81439e1d9c94314f$export$22dce776e713bf54 && y instanceof $81439e1d9c94314f$export$22dce776e713bf54) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $81439e1d9c94314f$export$22dce776e713bf54) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $81439e1d9c94314f$export$22dce776e713bf54) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $81439e1d9c94314f$export$3dddd772b5443db6 && y instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $81439e1d9c94314f$export$cb0693313c0aacc && y instanceof $81439e1d9c94314f$export$cb0693313c0aacc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Widgets.Form.Access (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $81439e1d9c94314f$export$5b6fc71d31f53849;
    }
};
var $81439e1d9c94314f$export$b7e2b1272211a360 = {
    encodeJson: function(v) {
        if (v instanceof $81439e1d9c94314f$export$22dce776e713bf54) return $81439e1d9c94314f$var$encodeJson("NONE");
        if (v instanceof $81439e1d9c94314f$export$3dddd772b5443db6) return $81439e1d9c94314f$var$encodeJson("VIEW");
        if (v instanceof $81439e1d9c94314f$export$cb0693313c0aacc) return $81439e1d9c94314f$var$encodeJson("UPDATE");
        throw new Error("Failed pattern match at Widgets.Form.Access (line 35, column 1 - line 38, column 50): " + [
            v.constructor.name
        ]);
    }
};
var $81439e1d9c94314f$export$7a3501594e39e6ac = {
    decodeJson: function(json) {
        return $81439e1d9c94314f$var$bind($81439e1d9c94314f$var$decodeJson(json))(function(v) {
            if (v === "NONE") return $81439e1d9c94314f$var$pure($81439e1d9c94314f$export$22dce776e713bf54.value);
            if (v === "VIEW") return $81439e1d9c94314f$var$pure($81439e1d9c94314f$export$3dddd772b5443db6.value);
            if (v === "UPDATE") return $81439e1d9c94314f$var$pure($81439e1d9c94314f$export$cb0693313c0aacc.value);
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json));
        });
    }
};
var $81439e1d9c94314f$export$69918eedfc84398 = function(v) {
    if (v instanceof $81439e1d9c94314f$export$22dce776e713bf54) return false;
    return true;
};
var $81439e1d9c94314f$export$4dcf4ecf95fdafb5 = function(access) {
    return function(path) {
        var pathParts = $81439e1d9c94314f$export$7b51a412e283855(path);
        var isVisibleDescendant = function(v) {
            var fieldParts = $81439e1d9c94314f$export$7b51a412e283855(v.field);
            return $fc8c1182ec2aefec$export$f24224f1c91d8156(fieldParts) > $fc8c1182ec2aefec$export$f24224f1c91d8156(pathParts) && $81439e1d9c94314f$export$ea93bfe3a74b70f3(pathParts)(fieldParts) && $81439e1d9c94314f$export$69918eedfc84398(v.access);
        };
        return $81439e1d9c94314f$var$any(isVisibleDescendant)(access.fields);
    };
};
var $81439e1d9c94314f$export$83c457eff4ed3d7f = function(v) {
    if (v instanceof $81439e1d9c94314f$export$cb0693313c0aacc) return true;
    return false;
};


var $d4a8d5b15f9925c4$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $d4a8d5b15f9925c4$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $d4a8d5b15f9925c4$var$inputIsSymbol = {
    reflectSymbol: function() {
        return "input";
    }
};
var $d4a8d5b15f9925c4$var$rltvCons1 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons($d4a8d5b15f9925c4$var$inputIsSymbol);
var $d4a8d5b15f9925c4$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $d4a8d5b15f9925c4$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($d4a8d5b15f9925c4$var$encRNTY);
var $d4a8d5b15f9925c4$var$form_idIsSymbol = {
    reflectSymbol: function() {
        return "form_id";
    }
};
var $d4a8d5b15f9925c4$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $d4a8d5b15f9925c4$var$rltvfConsOther1 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther($d4a8d5b15f9925c4$var$inputIsSymbol)();
var $d4a8d5b15f9925c4$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($81439e1d9c94314f$export$7a3501594e39e6ac));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons2 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $d4a8d5b15f9925c4$var$fieldIsSymbol = {
    reflectSymbol: function() {
        return "field";
    }
};
var $d4a8d5b15f9925c4$var$accessIsSymbol = {
    reflectSymbol: function() {
        return "access";
    }
};
var $d4a8d5b15f9925c4$var$fieldsIsSymbol = {
    reflectSymbol: function() {
        return "fields";
    }
};
var $d4a8d5b15f9925c4$var$defaultIsSymbol = {
    reflectSymbol: function() {
        return "default";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$fieldIsSymbol)()())($d4a8d5b15f9925c4$var$accessIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$fieldsIsSymbol)()())($d4a8d5b15f9925c4$var$defaultIsSymbol)()())()));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons4 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons5 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $d4a8d5b15f9925c4$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons6 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons5($d4a8d5b15f9925c4$var$updateIsSymbol)()());
var $d4a8d5b15f9925c4$var$lockIsSymbol = {
    reflectSymbol: function() {
        return "lock";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons7 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons8 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099));
var $d4a8d5b15f9925c4$var$useDefaultIsSymbol = {
    reflectSymbol: function() {
        return "useDefault";
    }
};
var $d4a8d5b15f9925c4$var$saveDefaultIsSymbol = {
    reflectSymbol: function() {
        return "saveDefault";
    }
};
var $d4a8d5b15f9925c4$var$requestIsSymbol = {
    reflectSymbol: function() {
        return "request";
    }
};
var $d4a8d5b15f9925c4$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons9 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons10 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $d4a8d5b15f9925c4$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $d4a8d5b15f9925c4$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $d4a8d5b15f9925c4$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $d4a8d5b15f9925c4$var$emailLabelIsSymbol = {
    reflectSymbol: function() {
        return "emailLabel";
    }
};
var $d4a8d5b15f9925c4$var$default_last_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_last_name";
    }
};
var $d4a8d5b15f9925c4$var$default_first_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_first_name";
    }
};
var $d4a8d5b15f9925c4$var$default_emailIsSymbol = {
    reflectSymbol: function() {
        return "default_email";
    }
};
var $d4a8d5b15f9925c4$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons11 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons5($d4a8d5b15f9925c4$var$useDefaultIsSymbol)()())($d4a8d5b15f9925c4$var$updateIsSymbol)()())($d4a8d5b15f9925c4$var$saveDefaultIsSymbol)()())($d4a8d5b15f9925c4$var$requestIsSymbol)()())($d4a8d5b15f9925c4$var$createIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons10($d4a8d5b15f9925c4$var$relationshipIsSymbol)()())($d4a8d5b15f9925c4$var$labelIsSymbol)()())($d4a8d5b15f9925c4$var$keyIsSymbol)()())($d4a8d5b15f9925c4$var$emailLabelIsSymbol)()())($d4a8d5b15f9925c4$var$default_last_nameIsSymbol)()())($d4a8d5b15f9925c4$var$default_first_nameIsSymbol)()())($d4a8d5b15f9925c4$var$default_emailIsSymbol)()())($d4a8d5b15f9925c4$var$canIsSymbol)()())())));
var $d4a8d5b15f9925c4$var$last_nameIsSymbol = {
    reflectSymbol: function() {
        return "last_name";
    }
};
var $d4a8d5b15f9925c4$var$first_nameIsSymbol = {
    reflectSymbol: function() {
        return "first_name";
    }
};
var $d4a8d5b15f9925c4$var$emailIsSymbol = {
    reflectSymbol: function() {
        return "email";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons12 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099));
var $d4a8d5b15f9925c4$var$urlIsSymbol = {
    reflectSymbol: function() {
        return "url";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons13 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$urlIsSymbol)()();
var $d4a8d5b15f9925c4$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $d4a8d5b15f9925c4$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $d4a8d5b15f9925c4$var$contactIsSymbol = {
    reflectSymbol: function() {
        return "contact";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons14 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$last_nameIsSymbol)()())($d4a8d5b15f9925c4$var$first_nameIsSymbol)()())($d4a8d5b15f9925c4$var$emailIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7($d4a8d5b15f9925c4$var$gDecodeJsonCons13)($d4a8d5b15f9925c4$var$relationshipIsSymbol)()())($d4a8d5b15f9925c4$var$keyIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)()())($d4a8d5b15f9925c4$var$contactIsSymbol)()())())));
var $d4a8d5b15f9925c4$var$commentIsSymbol = {
    reflectSymbol: function() {
        return "comment";
    }
};
var $d4a8d5b15f9925c4$var$linkIsSymbol = {
    reflectSymbol: function() {
        return "link";
    }
};
var $d4a8d5b15f9925c4$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $d4a8d5b15f9925c4$var$verificationsIsSymbol = {
    reflectSymbol: function() {
        return "verifications";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons15 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons10($d4a8d5b15f9925c4$var$keyIsSymbol)()())($d4a8d5b15f9925c4$var$emailIsSymbol)()())($d4a8d5b15f9925c4$var$commentIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$linkIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$dataIsSymbol)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$verificationsIsSymbol)()();
var $d4a8d5b15f9925c4$var$signaturesIsSymbol = {
    reflectSymbol: function() {
        return "signatures";
    }
};
var $d4a8d5b15f9925c4$var$signature_fieldsIsSymbol = {
    reflectSymbol: function() {
        return "signature_fields";
    }
};
var $d4a8d5b15f9925c4$var$locked_atIsSymbol = {
    reflectSymbol: function() {
        return "locked_at";
    }
};
var $d4a8d5b15f9925c4$var$formsIsSymbol = {
    reflectSymbol: function() {
        return "forms";
    }
};
var $d4a8d5b15f9925c4$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $d4a8d5b15f9925c4$var$rlhsCons1 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$formsIsSymbol);
var $d4a8d5b15f9925c4$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $d4a8d5b15f9925c4$var$rlhsCons2 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$verificationsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$linkIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$dataIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$emailIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$commentIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())())()())($d4a8d5b15f9925c4$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()());
var $d4a8d5b15f9925c4$var$rlhsCons3 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$urlIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()());
var $d4a8d5b15f9925c4$var$arrayShape = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons3($d4a8d5b15f9925c4$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$contactIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$last_nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$first_nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$emailIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())());
var $d4a8d5b15f9925c4$var$arrayShape1 = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$emailLabelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$default_last_nameIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$default_first_nameIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$default_emailIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$useDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$saveDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$requestIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())());
var $d4a8d5b15f9925c4$var$rlhsCons4 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()());
var $d4a8d5b15f9925c4$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$fieldsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$fieldIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$accessIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($d4a8d5b15f9925c4$var$defaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $d4a8d5b15f9925c4$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons1(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "UpdateFormInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$7f2886916ce99188)($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "locked";
    }
})())($d4a8d5b15f9925c4$var$form_idIsSymbol)())())))()())($d4a8d5b15f9925c4$var$rltvfConsOther1)())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons3(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons6($d4a8d5b15f9925c4$var$lockIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons8(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons11(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons14($d4a8d5b15f9925c4$var$gDecodeJsonCons15)($d4a8d5b15f9925c4$var$signaturesIsSymbol)()())($d4a8d5b15f9925c4$var$signature_fieldsIsSymbol)()())($d4a8d5b15f9925c4$var$locked_atIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$canIsSymbol)()())($d4a8d5b15f9925c4$var$accessIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$formsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons1(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons2($d4a8d5b15f9925c4$var$signaturesIsSymbol)($d4a8d5b15f9925c4$var$arrayShape)()())($d4a8d5b15f9925c4$var$signature_fieldsIsSymbol)($d4a8d5b15f9925c4$var$arrayShape1)()())($d4a8d5b15f9925c4$var$locked_atIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons4($d4a8d5b15f9925c4$var$lockIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($d4a8d5b15f9925c4$var$accessIsSymbol)($d4a8d5b15f9925c4$var$recShape)()())()))()())()));
var $d4a8d5b15f9925c4$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $d4a8d5b15f9925c4$var$merge = /* #__PURE__ */ $15e8567e7c31ba30$export$4950aa0f605343fb()();
var $d4a8d5b15f9925c4$var$typeIsSymbol = {
    reflectSymbol: function() {
        return "type";
    }
};
var $d4a8d5b15f9925c4$var$rename = /* #__PURE__ */ $15e8567e7c31ba30$export$7ac989ec0c9c279($d4a8d5b15f9925c4$var$typeIsSymbol)({
    reflectSymbol: function() {
        return "formName";
    }
})()()()();
var $d4a8d5b15f9925c4$var$rename1 = /* #__PURE__ */ $15e8567e7c31ba30$export$7ac989ec0c9c279($d4a8d5b15f9925c4$var$dataIsSymbol)({
    reflectSymbol: function() {
        return "json";
    }
})()()()();
var $d4a8d5b15f9925c4$var$commentsIsSymbol = {
    reflectSymbol: function() {
        return "comments";
    }
};
var $d4a8d5b15f9925c4$var$modify = /* #__PURE__ */ $15e8567e7c31ba30$export$3ff57735a52b8713($d4a8d5b15f9925c4$var$commentsIsSymbol)()();
var $d4a8d5b15f9925c4$var$teacher_idIsSymbol = {
    reflectSymbol: function() {
        return "teacher_id";
    }
};
var $d4a8d5b15f9925c4$var$rltvCons2 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons($d4a8d5b15f9925c4$var$teacher_idIsSymbol);
var $d4a8d5b15f9925c4$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $d4a8d5b15f9925c4$var$semesterIsSymbol = {
    reflectSymbol: function() {
        return "semester";
    }
};
var $d4a8d5b15f9925c4$var$rltvfConsOther2 = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther($d4a8d5b15f9925c4$var$teacher_idIsSymbol)());
var $d4a8d5b15f9925c4$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $d4a8d5b15f9925c4$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons16 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$nameIsSymbol)()();
var $d4a8d5b15f9925c4$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($d4a8d5b15f9925c4$var$gDecodeJsonCons16)();
var $d4a8d5b15f9925c4$var$userIsSymbol = {
    reflectSymbol: function() {
        return "user";
    }
};
var $d4a8d5b15f9925c4$var$pathIsSymbol = {
    reflectSymbol: function() {
        return "path";
    }
};
var $d4a8d5b15f9925c4$var$descriptionIsSymbol = {
    reflectSymbol: function() {
        return "description";
    }
};
var $d4a8d5b15f9925c4$var$private_commentIsSymbol = {
    reflectSymbol: function() {
        return "private_comment";
    }
};
var $d4a8d5b15f9925c4$var$create_employersIsSymbol = {
    reflectSymbol: function() {
        return "create_employers";
    }
};
var $d4a8d5b15f9925c4$var$copyIsSymbol = {
    reflectSymbol: function() {
        return "copy";
    }
};
var $d4a8d5b15f9925c4$var$attachIsSymbol = {
    reflectSymbol: function() {
        return "attach";
    }
};
var $d4a8d5b15f9925c4$var$TeacherIsSymbol = {
    reflectSymbol: function() {
        return "Teacher";
    }
};
var $d4a8d5b15f9925c4$var$StudentIsSymbol = {
    reflectSymbol: function() {
        return "Student";
    }
};
var $d4a8d5b15f9925c4$var$updated_atIsSymbol = {
    reflectSymbol: function() {
        return "updated_at";
    }
};
var $d4a8d5b15f9925c4$var$publicIsSymbol = {
    reflectSymbol: function() {
        return "public";
    }
};
var $d4a8d5b15f9925c4$var$authorIsSymbol = {
    reflectSymbol: function() {
        return "author";
    }
};
var $d4a8d5b15f9925c4$var$decodeRecord1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7($d4a8d5b15f9925c4$var$gDecodeJsonCons16)($d4a8d5b15f9925c4$var$idIsSymbol)()())();
var $d4a8d5b15f9925c4$var$gDecodeJsonCons17 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($d4a8d5b15f9925c4$var$decodeRecord1));
var $d4a8d5b15f9925c4$var$gDecodeJsonCons18 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1($d4a8d5b15f9925c4$var$gDecodeJsonCons16);
var $d4a8d5b15f9925c4$var$decodeRecord2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$labelIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())();
var $d4a8d5b15f9925c4$var$positionsIsSymbol = {
    reflectSymbol: function() {
        return "positions";
    }
};
var $d4a8d5b15f9925c4$var$deleted_atIsSymbol = {
    reflectSymbol: function() {
        return "deleted_at";
    }
};
var $d4a8d5b15f9925c4$var$contactsIsSymbol = {
    reflectSymbol: function() {
        return "contacts";
    }
};
var $d4a8d5b15f9925c4$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $d4a8d5b15f9925c4$var$formatIsSymbol = {
    reflectSymbol: function() {
        return "format";
    }
};
var $d4a8d5b15f9925c4$var$gDecodeJsonCons19 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1($d4a8d5b15f9925c4$var$gDecodeJsonCons13)($d4a8d5b15f9925c4$var$labelIsSymbol)()())($d4a8d5b15f9925c4$var$formatIsSymbol)()())())));
var $d4a8d5b15f9925c4$var$colorIsSymbol = {
    reflectSymbol: function() {
        return "color";
    }
};
var $d4a8d5b15f9925c4$var$tagsIsSymbol = {
    reflectSymbol: function() {
        return "tags";
    }
};
var $d4a8d5b15f9925c4$var$preferred_nameIsSymbol = {
    reflectSymbol: function() {
        return "preferred_name";
    }
};
var $d4a8d5b15f9925c4$var$last_imported_atIsSymbol = {
    reflectSymbol: function() {
        return "last_imported_at";
    }
};
var $d4a8d5b15f9925c4$var$teacherIsSymbol = {
    reflectSymbol: function() {
        return "teacher";
    }
};
var $d4a8d5b15f9925c4$var$studentIsSymbol = {
    reflectSymbol: function() {
        return "student";
    }
};
var $d4a8d5b15f9925c4$var$positionIsSymbol = {
    reflectSymbol: function() {
        return "position";
    }
};
var $d4a8d5b15f9925c4$var$exportsIsSymbol = {
    reflectSymbol: function() {
        return "exports";
    }
};
var $d4a8d5b15f9925c4$var$employerIsSymbol = {
    reflectSymbol: function() {
        return "employer";
    }
};
var $d4a8d5b15f9925c4$var$coursesIsSymbol = {
    reflectSymbol: function() {
        return "courses";
    }
};
var $d4a8d5b15f9925c4$var$attachmentsIsSymbol = {
    reflectSymbol: function() {
        return "attachments";
    }
};
var $d4a8d5b15f9925c4$var$rlhsCons5 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()();
var $d4a8d5b15f9925c4$var$rlhsCons6 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($d4a8d5b15f9925c4$var$rlhsCons5);
var $d4a8d5b15f9925c4$var$recShape1 = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons6($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $d4a8d5b15f9925c4$var$maybeShape1 = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($d4a8d5b15f9925c4$var$recShape1);
var $d4a8d5b15f9925c4$var$recShape2 = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $d4a8d5b15f9925c4$var$arrayShape2 = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons3($d4a8d5b15f9925c4$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$formatIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())());
var $d4a8d5b15f9925c4$var$recShape3 = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206($d4a8d5b15f9925c4$var$rlhsCons5)();
var $d4a8d5b15f9925c4$var$jsonQR = /* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons3(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons5($d4a8d5b15f9925c4$var$deleteIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($d4a8d5b15f9925c4$var$decodeRecord))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$userIsSymbol)()())($d4a8d5b15f9925c4$var$urlIsSymbol)()())($d4a8d5b15f9925c4$var$pathIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$descriptionIsSymbol)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)()())($d4a8d5b15f9925c4$var$canIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons6($d4a8d5b15f9925c4$var$private_commentIsSymbol)()())($d4a8d5b15f9925c4$var$lockIsSymbol)()())($d4a8d5b15f9925c4$var$deleteIsSymbol)()())($d4a8d5b15f9925c4$var$create_employersIsSymbol)()())($d4a8d5b15f9925c4$var$copyIsSymbol)()())($d4a8d5b15f9925c4$var$commentIsSymbol)()())($d4a8d5b15f9925c4$var$attachIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $266cd1b01131a218$export$233e215ca2d72bc7(/* #__PURE__ */ $266cd1b01131a218$export$96d29a771776afc1(/* #__PURE__ */ $266cd1b01131a218$export$96d29a771776afc1($266cd1b01131a218$export$10ea8b8b83e08901)($d4a8d5b15f9925c4$var$TeacherIsSymbol)($d4a8d5b15f9925c4$var$decodeRecord)()())($d4a8d5b15f9925c4$var$StudentIsSymbol)($d4a8d5b15f9925c4$var$decodeRecord)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons6($d4a8d5b15f9925c4$var$deleteIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons4(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$updated_atIsSymbol)()())($d4a8d5b15f9925c4$var$publicIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)()())($d4a8d5b15f9925c4$var$commentIsSymbol)()())($d4a8d5b15f9925c4$var$canIsSymbol)()())($d4a8d5b15f9925c4$var$authorIsSymbol)()())())))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons17(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons18($d4a8d5b15f9925c4$var$labelIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())())))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$c2f7b8312539f0ea))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($d4a8d5b15f9925c4$var$decodeRecord1)))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons8(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($d4a8d5b15f9925c4$var$decodeRecord2)))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$positionsIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$deleted_atIsSymbol)()())($d4a8d5b15f9925c4$var$contactsIsSymbol)()())($d4a8d5b15f9925c4$var$companyIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons19(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons8(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($d4a8d5b15f9925c4$var$decodeRecord2))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons2($d4a8d5b15f9925c4$var$semesterIsSymbol)()())($d4a8d5b15f9925c4$var$nameIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons11(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons14(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons7(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons8(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons18($d4a8d5b15f9925c4$var$colorIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$tagsIsSymbol)()())($d4a8d5b15f9925c4$var$preferred_nameIsSymbol)()())($d4a8d5b15f9925c4$var$nameIsSymbol)()())($d4a8d5b15f9925c4$var$last_imported_atIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())()))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons17(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons1(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons12($d4a8d5b15f9925c4$var$gDecodeJsonCons15)($d4a8d5b15f9925c4$var$updated_atIsSymbol)()())($d4a8d5b15f9925c4$var$typeIsSymbol)()())($d4a8d5b15f9925c4$var$teacherIsSymbol)()())($d4a8d5b15f9925c4$var$studentIsSymbol)()())($d4a8d5b15f9925c4$var$signaturesIsSymbol)()())($d4a8d5b15f9925c4$var$signature_fieldsIsSymbol)()())($d4a8d5b15f9925c4$var$semesterIsSymbol)()())($d4a8d5b15f9925c4$var$positionIsSymbol)()())($d4a8d5b15f9925c4$var$locked_atIsSymbol)()())($d4a8d5b15f9925c4$var$idIsSymbol)()())($d4a8d5b15f9925c4$var$exportsIsSymbol)()())($d4a8d5b15f9925c4$var$employerIsSymbol)()())($d4a8d5b15f9925c4$var$dataIsSymbol)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)()())($d4a8d5b15f9925c4$var$coursesIsSymbol)()())($d4a8d5b15f9925c4$var$contactIsSymbol)()())($d4a8d5b15f9925c4$var$commentsIsSymbol)()())($d4a8d5b15f9925c4$var$canIsSymbol)()())($d4a8d5b15f9925c4$var$attachmentsIsSymbol)()())($d4a8d5b15f9925c4$var$accessIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons2($d4a8d5b15f9925c4$var$updated_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$typeIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$teacherIsSymbol)($d4a8d5b15f9925c4$var$maybeShape1)()())($d4a8d5b15f9925c4$var$studentIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$tagsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons6($d4a8d5b15f9925c4$var$colorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($d4a8d5b15f9925c4$var$preferred_nameIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$last_imported_atIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($d4a8d5b15f9925c4$var$signaturesIsSymbol)($d4a8d5b15f9925c4$var$arrayShape)()())($d4a8d5b15f9925c4$var$signature_fieldsIsSymbol)($d4a8d5b15f9925c4$var$arrayShape1)()())($d4a8d5b15f9925c4$var$semesterIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$semesterIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($d4a8d5b15f9925c4$var$positionIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($d4a8d5b15f9925c4$var$recShape2))()())($d4a8d5b15f9925c4$var$locked_atIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$exportsIsSymbol)($d4a8d5b15f9925c4$var$arrayShape2)()())($d4a8d5b15f9925c4$var$employerIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$positionsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($d4a8d5b15f9925c4$var$recShape2))()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$deleted_atIsSymbol)($d4a8d5b15f9925c4$var$maybeShape)()())($d4a8d5b15f9925c4$var$contactsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($d4a8d5b15f9925c4$var$recShape1))()())($d4a8d5b15f9925c4$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($d4a8d5b15f9925c4$var$dataIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$coursesIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons6($d4a8d5b15f9925c4$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($d4a8d5b15f9925c4$var$contactIsSymbol)($d4a8d5b15f9925c4$var$maybeShape1)()())($d4a8d5b15f9925c4$var$commentsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$updated_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$publicIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$commentIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons4($d4a8d5b15f9925c4$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($d4a8d5b15f9925c4$var$authorIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$d1213f059a1aeef8(/* #__PURE__ */ $266cd1b01131a218$export$62f20211aacc4215(/* #__PURE__ */ $266cd1b01131a218$export$62f20211aacc4215($266cd1b01131a218$export$750fc123d68a1541)($d4a8d5b15f9925c4$var$TeacherIsSymbol)($d4a8d5b15f9925c4$var$recShape3)()())($d4a8d5b15f9925c4$var$StudentIsSymbol)($d4a8d5b15f9925c4$var$recShape3)()())())()())()))()())($d4a8d5b15f9925c4$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons4($d4a8d5b15f9925c4$var$private_commentIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$lockIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$create_employersIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$copyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$commentIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$attachIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($d4a8d5b15f9925c4$var$attachmentsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$userIsSymbol)($d4a8d5b15f9925c4$var$recShape3)()())($d4a8d5b15f9925c4$var$urlIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$pathIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$descriptionIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($d4a8d5b15f9925c4$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())()))()())($d4a8d5b15f9925c4$var$accessIsSymbol)($d4a8d5b15f9925c4$var$recShape)()())());
var $d4a8d5b15f9925c4$var$buildMutation1 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$bbb2424cc61174c(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons2($d4a8d5b15f9925c4$var$rntyType)($d4a8d5b15f9925c4$var$encRNTY)()())($d4a8d5b15f9925c4$var$semesterIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()())($d4a8d5b15f9925c4$var$idIsSymbol)($d4a8d5b15f9925c4$var$rntyType)($d4a8d5b15f9925c4$var$encRNTY)()())($d4a8d5b15f9925c4$var$dataIsSymbol)($eb7399d322077fcf$export$35d3004eff90f123)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther2($d4a8d5b15f9925c4$var$semesterIsSymbol)())($d4a8d5b15f9925c4$var$idIsSymbol)())($d4a8d5b15f9925c4$var$dataIsSymbol)())())($d4a8d5b15f9925c4$var$jsonQR);
var $d4a8d5b15f9925c4$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons($d4a8d5b15f9925c4$var$idIsSymbol)($d4a8d5b15f9925c4$var$rntyType)($d4a8d5b15f9925c4$var$encRNTY)()())(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther($d4a8d5b15f9925c4$var$idIsSymbol)())())($d4a8d5b15f9925c4$var$jsonQR);
var $d4a8d5b15f9925c4$var$idsIsSymbol = {
    reflectSymbol: function() {
        return "ids";
    }
};
var $d4a8d5b15f9925c4$var$hqtArray = /* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($d4a8d5b15f9925c4$var$rntyType);
var $d4a8d5b15f9925c4$var$encodeJsonArray = /* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($d4a8d5b15f9925c4$var$encRNTY);
var $d4a8d5b15f9925c4$var$jsonQR1 = /* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons19($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$exportsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$exportsIsSymbol)($d4a8d5b15f9925c4$var$arrayShape2)()())());
var $d4a8d5b15f9925c4$var$buildQuery1 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons($d4a8d5b15f9925c4$var$idsIsSymbol)($d4a8d5b15f9925c4$var$hqtArray)($d4a8d5b15f9925c4$var$encodeJsonArray)()())(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther($d4a8d5b15f9925c4$var$idsIsSymbol)())())($d4a8d5b15f9925c4$var$jsonQR1);
var $d4a8d5b15f9925c4$var$buildMutation2 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons($d4a8d5b15f9925c4$var$form_idIsSymbol)($d4a8d5b15f9925c4$var$hqtArray)($d4a8d5b15f9925c4$var$encodeJsonArray)()())(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther($d4a8d5b15f9925c4$var$form_idIsSymbol)())())($a40b20519abba0fb$export$5bc47822dabd2903);
var $d4a8d5b15f9925c4$var$encodeJsonMaybe = /* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($d4a8d5b15f9925c4$var$encRNTY);
var $d4a8d5b15f9925c4$var$student_idIsSymbol = {
    reflectSymbol: function() {
        return "student_id";
    }
};
var $d4a8d5b15f9925c4$var$buildMutation3 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons2(/* #__PURE__ */ $308f9765feb7633d$export$9040d00d71e77b23($d4a8d5b15f9925c4$var$rntyType))($d4a8d5b15f9925c4$var$encodeJsonMaybe)()())($d4a8d5b15f9925c4$var$student_idIsSymbol)($d4a8d5b15f9925c4$var$rntyType)($d4a8d5b15f9925c4$var$encRNTY)()())($d4a8d5b15f9925c4$var$semesterIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvfConsOther2($d4a8d5b15f9925c4$var$student_idIsSymbol)())($d4a8d5b15f9925c4$var$semesterIsSymbol)())())($d4a8d5b15f9925c4$var$jsonQR);
var $d4a8d5b15f9925c4$var$gEncodeJsonCons1 = /* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726);
var $d4a8d5b15f9925c4$var$buildMutation4 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons1(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "CreateFormInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($eb7399d322077fcf$export$188ec67d44674d4b))(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($d4a8d5b15f9925c4$var$encodeJsonMaybe)(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons1({
    reflectSymbol: function() {
        return "type_id";
    }
})())($d4a8d5b15f9925c4$var$teacher_idIsSymbol)())($d4a8d5b15f9925c4$var$student_idIsSymbol)())($d4a8d5b15f9925c4$var$semesterIsSymbol)())())))()())($d4a8d5b15f9925c4$var$rltvfConsOther1)())($d4a8d5b15f9925c4$var$jsonQR1);
var $d4a8d5b15f9925c4$var$buildMutation5 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rltvCons1(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "CopyFormInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gEncodeJsonCons1($d4a8d5b15f9925c4$var$student_idIsSymbol)())($d4a8d5b15f9925c4$var$form_idIsSymbol)())())))()())($d4a8d5b15f9925c4$var$rltvfConsOther1)())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $d4a8d5b15f9925c4$var$gDecodeJsonCons10($d4a8d5b15f9925c4$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($d4a8d5b15f9925c4$var$formsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons1(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $d4a8d5b15f9925c4$var$rlhsCons($d4a8d5b15f9925c4$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())()));
var $d4a8d5b15f9925c4$export$624bca672a5cb2cb = function(inputs) {
    var process = function(v) {
        return v.forms;
    };
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("ToggleDocumentLocks")($d4a8d5b15f9925c4$var$map(process)($d4a8d5b15f9925c4$var$buildMutation("updateForms")({
        input: $d4a8d5b15f9925c4$var$map1($308f9765feb7633d$export$eb1b128a19ff6c25)(inputs)
    })));
};
var $d4a8d5b15f9925c4$export$42e41fd7e402fd20 = function(v) {
    return v.exports;
};
var $d4a8d5b15f9925c4$export$91f0f9b3e77236b7 = function(formId) {
    return function(mutations) {
        var $1506 = $d4a8d5b15f9925c4$var$merge({
            formId: formId,
            mutations: mutations
        });
        var $1507 = $d4a8d5b15f9925c4$var$rename($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        var $1508 = $d4a8d5b15f9925c4$var$rename1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        var $1509 = $d4a8d5b15f9925c4$var$modify($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($d4a8d5b15f9925c4$var$map1($468ec44be9fa5236$export$be20e2d7eda534b2));
        return function($1510) {
            return $1506($1507($1508($1509($1510))));
        };
    };
};
var $d4a8d5b15f9925c4$export$40eade6eb956113a = function(doc) {
    return function(json) {
        return function(v) {
            return $a40b20519abba0fb$export$bc1f9bac519c56f6("UpdateDocument")($d4a8d5b15f9925c4$var$map($d4a8d5b15f9925c4$export$91f0f9b3e77236b7(doc.formId)(doc.mutations))($d4a8d5b15f9925c4$var$buildMutation1(doc.mutations.update)({
                id: doc.id,
                semester: v.semester,
                teacher_id: v.teacher,
                data: new $308f9765feb7633d$export$18913c2ada77a9df(doc.formName + "Input", json)
            })));
        };
    };
};
var $d4a8d5b15f9925c4$export$177dade20c6c5e4f = function(ft) {
    return function(id) {
        return $a40b20519abba0fb$export$bc1f9bac519c56f6("GetDocument")($d4a8d5b15f9925c4$var$map($d4a8d5b15f9925c4$export$91f0f9b3e77236b7(ft.id)(ft.mutations))($d4a8d5b15f9925c4$var$buildQuery("form")({
            id: id
        })));
    };
};
var $d4a8d5b15f9925c4$export$ebc98c8dadc7994c = function(ids) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("ExportDocuments")($d4a8d5b15f9925c4$var$map($d4a8d5b15f9925c4$export$42e41fd7e402fd20)($d4a8d5b15f9925c4$var$buildQuery1("forms")({
        ids: ids
    })));
};
var $d4a8d5b15f9925c4$export$957e53c221e2b1cb = function(ids) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("DeleteDocuments")($d4a8d5b15f9925c4$var$buildMutation2("deleteForms")({
        form_id: ids
    }));
};
var $d4a8d5b15f9925c4$export$37330def6e48b4c9 = function(ft) {
    return function(args) {
        return $a40b20519abba0fb$export$bc1f9bac519c56f6("CreateDocument")($d4a8d5b15f9925c4$var$map($d4a8d5b15f9925c4$export$91f0f9b3e77236b7(ft.id)(ft.mutations))($d4a8d5b15f9925c4$var$buildMutation3(ft.mutations.create)(args)));
    };
};
var $d4a8d5b15f9925c4$export$95e01943223e1dc = function(forms) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("CreateAndExportDocuments")($d4a8d5b15f9925c4$var$map($d4a8d5b15f9925c4$export$42e41fd7e402fd20)($d4a8d5b15f9925c4$var$buildMutation4("createForms")({
        input: $d4a8d5b15f9925c4$var$map1($308f9765feb7633d$export$eb1b128a19ff6c25)(forms)
    })));
};
var $d4a8d5b15f9925c4$export$4cfd7d1c74860312 = function(copies) {
    var process = function(r) {
        return $d4a8d5b15f9925c4$var$map1(function(v) {
            return v.id;
        })(r.forms);
    };
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("CopyDocuments")($d4a8d5b15f9925c4$var$map(process)($d4a8d5b15f9925c4$var$buildMutation5("copyForms")({
        input: $d4a8d5b15f9925c4$var$map1($308f9765feb7633d$export$eb1b128a19ff6c25)(copies)
    })));
};
var $d4a8d5b15f9925c4$export$b33531c26796487b = function(v) {
    return function(record) {
        var $1501 = {};
        for(var $1502 in record)if (({}).hasOwnProperty.call(record, $1502)) $1501[$1502] = record[$1502];
        $1501.locked_at = v.locked_at;
        $1501.can = function() {
            var $1498 = {};
            for(var $1499 in record.can)if (({}).hasOwnProperty.call(record.can, $1499)) $1498[$1499] = record["can"][$1499];
            $1498.lock = v.can.lock;
            $1498.update = v.can.update;
            return $1498;
        }();
        return $1501;
    };
};


// Generated by purs version 0.15.16






















// Generated by purs version 0.15.16
// Generated by purs version 0.15.16






// Generated by purs version 0.15.16






// Generated by purs version 0.15.16



// Generated by purs version 0.15.16
















var $8cad8efed8fc4b93$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $8cad8efed8fc4b93$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8cad8efed8fc4b93$export$a9e3236c55b65445 = /* #__PURE__ */ function() {
    function CatQueue(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatQueue.create = function(value0) {
        return function(value1) {
            return new CatQueue(value0, value1);
        };
    };
    return CatQueue;
}();
var $8cad8efed8fc4b93$export$712962e076096ed4 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value1 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, v.value1.value1)));
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value0));
            return;
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 92, column 1 - line 92, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$b446f6baa3bb1430 = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $tco_done = true;
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
            $copy_v = new $8cad8efed8fc4b93$export$a9e3236c55b65445($3d4fd987da5242ff$export$66c1ae025e96b4bc(v.value1), $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
            return;
        }
        if (v.value0 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
            $tco_done = true;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0.value0, new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0.value1, v.value1)));
        }
        throw new Error("Failed pattern match at Data.CatQueue (line 82, column 1 - line 82, column 63): " + [
            v.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $8cad8efed8fc4b93$export$c40cf5aab899f397 = function(v) {
    return function(a) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(v.value0, new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value1));
    };
};
var $8cad8efed8fc4b93$export$76888aafd695b76f = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427(dictShow));
    return {
        show: function(v) {
            return "(CatQueue " + (show(v.value0) + (" " + (show(v.value1) + ")")));
        }
    };
};
var $8cad8efed8fc4b93$export$7b1b591b262c240 = function(v) {
    if (v.value0 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c && v.value1 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return true;
    return false;
};
var $8cad8efed8fc4b93$export$f24224f1c91d8156 = function(v) {
    return $3d4fd987da5242ff$export$f24224f1c91d8156(v.value0) + $3d4fd987da5242ff$export$f24224f1c91d8156(v.value1) | 0;
};
var $8cad8efed8fc4b93$export$cd9df59029b2f7f5 = {
    map: function(f) {
        return function(v) {
            return new $8cad8efed8fc4b93$export$a9e3236c55b65445($8cad8efed8fc4b93$var$map(f)(v.value0), $8cad8efed8fc4b93$var$map(f)(v.value1));
        };
    }
};
var $8cad8efed8fc4b93$export$2411eb790d3ef577 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($8cad8efed8fc4b93$export$2411eb790d3ef577)(dictMonoid);
    },
    foldr: function(f) {
        return $4fe7b6acfba7f29f$export$9b986141719153e($8cad8efed8fc4b93$export$2411eb790d3ef577)(f);
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatQueue (line 147, column 16 - line 149, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $8cad8efed8fc4b93$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($8cad8efed8fc4b93$export$2411eb790d3ef577);
var $8cad8efed8fc4b93$export$12a82fa16f3fa685 = {
    append: /* #__PURE__ */ $8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)
};
var $8cad8efed8fc4b93$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return new $8cad8efed8fc4b93$export$a9e3236c55b65445($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $78c799cba34fcb8d$export$c1bed610ade55e1c.value);
}();
var $8cad8efed8fc4b93$export$82bbee97f7dffc83 = {
    mempty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Semigroup0: function() {
        return $8cad8efed8fc4b93$export$12a82fa16f3fa685;
    }
};
var $8cad8efed8fc4b93$export$439306a4dcaafbb9 = /* #__PURE__ */ $8cad8efed8fc4b93$export$c40cf5aab899f397($8cad8efed8fc4b93$export$6e22c362a0406a2c);
var $8cad8efed8fc4b93$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($8cad8efed8fc4b93$export$82bbee97f7dffc83);
    return function(f) {
        return foldMap($8cad8efed8fc4b93$export$439306a4dcaafbb9)(f);
    };
};
var $8cad8efed8fc4b93$export$402e17453440564b = {
    traverse: function(dictApplicative) {
        var Apply0 = dictApplicative.Apply0();
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d(Apply0);
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        return function(f) {
            var $123 = map1($8cad8efed8fc4b93$var$foldl($8cad8efed8fc4b93$export$c40cf5aab899f397)($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            var $124 = $8cad8efed8fc4b93$var$foldl(function(acc) {
                var $126 = lift2($8cad8efed8fc4b93$export$c40cf5aab899f397)(acc);
                return function($127) {
                    return $126(f($127));
                };
            })(pure($8cad8efed8fc4b93$export$6e22c362a0406a2c));
            return function($125) {
                return $123($124($125));
            };
        };
    },
    sequence: function(dictApplicative) {
        return $11d1e86de605dfc6$export$417d88f64c497aed($8cad8efed8fc4b93$export$402e17453440564b)(dictApplicative);
    },
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    },
    Foldable1: function() {
        return $8cad8efed8fc4b93$export$2411eb790d3ef577;
    }
};
var $8cad8efed8fc4b93$export$4d02617d29cfe99c = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 154, column 24 - line 156, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    }
};
var $8cad8efed8fc4b93$export$7536d90e702d15a6 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $8cad8efed8fc4b93$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatQueue (line 161, column 24 - line 163, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($8cad8efed8fc4b93$export$6e22c362a0406a2c);
        };
    },
    Unfoldable10: function() {
        return $8cad8efed8fc4b93$export$4d02617d29cfe99c;
    }
};
var $8cad8efed8fc4b93$var$cqEq = function(dictEq) {
    var elemEq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && elemEq(v1.value0.value0)(v.value0.value0)) {
                    $tco_var_xs = v1.value0.value1;
                    $copy_ys = v.value0.value1;
                    return;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return true;
                }
                $tco_done = true;
                return false;
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$8d0b86d96cb644e8 = function(dictEq) {
    return {
        eq: $8cad8efed8fc4b93$var$cqEq(dictEq)
    };
};
var $8cad8efed8fc4b93$var$cqCompare = function(dictOrd) {
    var elemCompare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var go = function($copy_xs) {
        return function($copy_ys) {
            var $tco_var_xs = $copy_xs;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(xs, ys) {
                var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(ys);
                var v1 = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    var v2 = elemCompare(v1.value0.value0)(v.value0.value0);
                    if (v2 instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) {
                        $tco_var_xs = v1.value0.value1;
                        $copy_ys = v.value0.value1;
                        return;
                    }
                    $tco_done = true;
                    return v2;
                }
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$b023c82b48e70453.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                }
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    $tco_done = true;
                    return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
                }
                throw new Error("Failed pattern match at Data.CatQueue (line 117, column 16 - line 124, column 30): " + [
                    v1.constructor.name,
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
            return $tco_result;
        };
    };
    return go;
};
var $8cad8efed8fc4b93$export$cce3b6ca8e6b304d = function(dictOrd) {
    var eqCatQueue1 = $8cad8efed8fc4b93$export$8d0b86d96cb644e8(dictOrd.Eq0());
    return {
        compare: $8cad8efed8fc4b93$var$cqCompare(dictOrd),
        Eq0: function() {
            return eqCatQueue1;
        }
    };
};
var $8cad8efed8fc4b93$export$8327ebbef2a0ba76 = function(a) {
    return function(v) {
        return new $8cad8efed8fc4b93$export$a9e3236c55b65445(new $78c799cba34fcb8d$export$74c44e616647f5c0(a, v.value0), v.value1);
    };
};
var $8cad8efed8fc4b93$export$64857ab1e7904bd4 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Bind1: function() {
        return $8cad8efed8fc4b93$export$5f82bc311535f1fb;
    }
};
var $8cad8efed8fc4b93$export$5f82bc311535f1fb = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($8cad8efed8fc4b93$export$2411eb790d3ef577)($8cad8efed8fc4b93$export$82bbee97f7dffc83)),
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$export$6d9d1867ada2692e = {
    pure: $8cad8efed8fc4b93$export$439306a4dcaafbb9,
    Apply0: function() {
        return $8cad8efed8fc4b93$var$$lazy_applyCatQueue(0);
    }
};
var $8cad8efed8fc4b93$var$$lazy_applyCatQueue = /* #__PURE__ */ $8cad8efed8fc4b93$var$$runtime_lazy("applyCatQueue", "Data.CatQueue", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($8cad8efed8fc4b93$export$64857ab1e7904bd4),
        Functor0: function() {
            return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
        }
    };
});
var $8cad8efed8fc4b93$export$b30f70c26a58b039 = /* #__PURE__ */ $8cad8efed8fc4b93$var$$lazy_applyCatQueue(174);
var $8cad8efed8fc4b93$export$ece98441a77a02d = {
    alt: /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($8cad8efed8fc4b93$export$12a82fa16f3fa685),
    Functor0: function() {
        return $8cad8efed8fc4b93$export$cd9df59029b2f7f5;
    }
};
var $8cad8efed8fc4b93$export$f14c1a5864c2efe5 = {
    empty: $8cad8efed8fc4b93$export$6e22c362a0406a2c,
    Alt0: function() {
        return $8cad8efed8fc4b93$export$ece98441a77a02d;
    }
};
var $8cad8efed8fc4b93$export$6613cb99fa5f98f9 = {
    Applicative0: function() {
        return $8cad8efed8fc4b93$export$6d9d1867ada2692e;
    },
    Plus1: function() {
        return $8cad8efed8fc4b93$export$f14c1a5864c2efe5;
    }
};
var $8cad8efed8fc4b93$export$3e8f97b430646754 = {
    Monad0: function() {
        return $8cad8efed8fc4b93$export$64857ab1e7904bd4;
    },
    Alternative1: function() {
        return $8cad8efed8fc4b93$export$6613cb99fa5f98f9;
    }
};













var $2f87b4fe4d8f7a0f$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $2f87b4fe4d8f7a0f$export$7475bf8196f095ad = /* #__PURE__ */ function() {
    function CatNil() {}
    CatNil.value = new CatNil();
    return CatNil;
}();
var $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e = /* #__PURE__ */ function() {
    function CatCons(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CatCons.create = function(value0) {
        return function(value1) {
            return new CatCons(value0, value1);
        };
    };
    return CatCons;
}();
var $2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return "CatNil";
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return "(CatList " + (show(v.value0) + (" " + ($2c6b3d51d10471a7$export$57bf213be019eeb0($8cad8efed8fc4b93$export$76888aafd695b76f($2f87b4fe4d8f7a0f$export$eb80e9167e4f6b99(dictShow)))(v.value1) + ")")));
            throw new Error("Failed pattern match at Data.CatList (line 147, column 1 - line 149, column 71): " + [
                v.constructor.name
            ]);
        }
    };
};
var $2f87b4fe4d8f7a0f$export$7b1b591b262c240 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return true;
    return false;
};
var $2f87b4fe4d8f7a0f$var$link = function(v) {
    return function(v1) {
        if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v1;
        if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return v;
        if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(v.value0, $8cad8efed8fc4b93$export$c40cf5aab899f397(v.value1)(v1));
        throw new Error("Failed pattern match at Data.CatList (line 108, column 1 - line 108, column 54): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2f87b4fe4d8f7a0f$var$foldr = function(k) {
    return function(b) {
        return function(q) {
            var foldl = function($copy_v) {
                return function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v = $copy_v;
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v, v1, v2) {
                            if (v2 instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) {
                                $tco_done = true;
                                return v1;
                            }
                            if (v2 instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                                $tco_var_v = v;
                                $tco_var_v1 = v(v1)(v2.value0);
                                $copy_v2 = v2.value1;
                                return;
                            }
                            throw new Error("Failed pattern match at Data.CatList (line 124, column 3 - line 124, column 59): " + [
                                v.constructor.name,
                                v1.constructor.name,
                                v2.constructor.name
                            ]);
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
            };
            var go = function($copy_xs) {
                return function($copy_ys) {
                    var $tco_var_xs = $copy_xs;
                    var $tco_done1 = false;
                    var $tco_result;
                    function $tco_loop(xs, ys) {
                        var v = $8cad8efed8fc4b93$export$b446f6baa3bb1430(xs);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done1 = true;
                            return foldl(function(x) {
                                return function(i) {
                                    return i(x);
                                };
                            })(b)(ys);
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_xs = v.value0.value1;
                            $copy_ys = new $78c799cba34fcb8d$export$74c44e616647f5c0(k(v.value0.value0), ys);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 120, column 14 - line 122, column 67): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done1)$tco_result = $tco_loop($tco_var_xs, $copy_ys);
                    return $tco_result;
                };
            };
            return go(q)($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430 = function(v) {
    if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, function() {
        var $66 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
        if ($66) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
    }()));
    throw new Error("Failed pattern match at Data.CatList (line 99, column 1 - line 99, column 61): " + [
        v.constructor.name
    ]);
};
var $2f87b4fe4d8f7a0f$export$9dc212839863b867 = {
    foldMap: function(dictMonoid) {
        return $4fe7b6acfba7f29f$export$1131b47d09454899($2f87b4fe4d8f7a0f$export$9dc212839863b867)(dictMonoid);
    },
    foldr: function(f) {
        return function(s) {
            return function(l) {
                return $4fe7b6acfba7f29f$export$9b986141719153e($2f87b4fe4d8f7a0f$export$9dc212839863b867)(f)(s)(l);
            };
        };
    },
    foldl: function(f) {
        var go = function($copy_acc) {
            return function($copy_q) {
                var $tco_var_acc = $copy_acc;
                var $tco_done = false;
                var $tco_result;
                function $tco_loop(acc, q) {
                    var v = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(q);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        $tco_var_acc = f(acc)(v.value0.value0);
                        $copy_q = v.value0.value1;
                        return;
                    }
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        $tco_done = true;
                        return acc;
                    }
                    throw new Error("Failed pattern match at Data.CatList (line 156, column 16 - line 158, column 22): " + [
                        v.constructor.name
                    ]);
                }
                while(!$tco_done)$tco_result = $tco_loop($tco_var_acc, $copy_q);
                return $tco_result;
            };
        };
        return go;
    }
};
var $2f87b4fe4d8f7a0f$export$f24224f1c91d8156 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($2f87b4fe4d8f7a0f$export$9dc212839863b867)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $2f87b4fe4d8f7a0f$var$foldMap = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var append2 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
    return function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return mempty;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $75 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($75) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return append2(v(v1.value0))($2f87b4fe4d8f7a0f$var$foldMap(dictMonoid)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 134, column 1 - line 134, column 62): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c = /* #__PURE__ */ function() {
    return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
}();
var $2f87b4fe4d8f7a0f$export$10d8903dec122b9d = $2f87b4fe4d8f7a0f$var$link;
var $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76 = function(a) {
    return function(cat) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c))(cat);
    };
};
var $2f87b4fe4d8f7a0f$export$2fa88228892893e6 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
            if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $80 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                    if ($80) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                }();
                return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(v(v1.value0))($f4b2eb11fc32ed34$export$871de8747c9eaa88($2f87b4fe4d8f7a0f$export$2fa88228892893e6)(v)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 184, column 1 - line 188, column 26): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9 = function(a) {
    return $2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76(a)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
};
var $2f87b4fe4d8f7a0f$export$e0c854626a3eddb8 = {
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            return function(v1) {
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
                if (v1 instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                    var d = function() {
                        var $85 = $8cad8efed8fc4b93$export$7b1b591b262c240(v1.value1);
                        if ($85) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                        return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v1.value1);
                    }();
                    return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v(v1.value0)))($11d1e86de605dfc6$export$df3f009e3d155b20($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(v)(d));
                }
                throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
    },
    sequence: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var Apply0 = dictApplicative.Apply0();
        var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
        return function(v) {
            if (v instanceof $2f87b4fe4d8f7a0f$export$7475bf8196f095ad) return pure($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
            if (v instanceof $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e) {
                var d = function() {
                    var $89 = $8cad8efed8fc4b93$export$7b1b591b262c240(v.value1);
                    if ($89) return $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value;
                    return $2f87b4fe4d8f7a0f$var$foldr($2f87b4fe4d8f7a0f$var$link)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value)(v.value1);
                }();
                return apply(map($2f87b4fe4d8f7a0f$export$8327ebbef2a0ba76)(v.value0))($11d1e86de605dfc6$export$49bb65c2ea163039($2f87b4fe4d8f7a0f$export$e0c854626a3eddb8)(dictApplicative)(d));
            }
            throw new Error("Failed pattern match at Data.CatList (line 174, column 1 - line 182, column 33): " + [
                v.constructor.name
            ]);
        };
    },
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    },
    Foldable1: function() {
        return $2f87b4fe4d8f7a0f$export$9dc212839863b867;
    }
};
var $2f87b4fe4d8f7a0f$export$da599a1924f5bf13 = {
    append: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d
};
var $2f87b4fe4d8f7a0f$export$f4b77959e4023828 = /* #__PURE__ */ function() {
    return {
        mempty: $2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value,
        Semigroup0: function() {
            return $2f87b4fe4d8f7a0f$export$da599a1924f5bf13;
        }
    };
}();
var $2f87b4fe4d8f7a0f$export$607c251688bb5f73 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Bind1: function() {
        return $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22;
    }
};
var $2f87b4fe4d8f7a0f$export$23e6c815e87cdf22 = {
    bind: /* #__PURE__ */ $f57f4b701aa7b66e$export$8a83211c878a3f1f(/* #__PURE__ */ $2f87b4fe4d8f7a0f$var$foldMap($2f87b4fe4d8f7a0f$export$f4b77959e4023828)),
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$export$360f55d5496233b2 = {
    pure: $2f87b4fe4d8f7a0f$export$439306a4dcaafbb9,
    Apply0: function() {
        return $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(0);
    }
};
var $2f87b4fe4d8f7a0f$var$$lazy_applyCatList = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$runtime_lazy("applyCatList", "Data.CatList", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($2f87b4fe4d8f7a0f$export$607c251688bb5f73),
        Functor0: function() {
            return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
        }
    };
});
var $2f87b4fe4d8f7a0f$export$6c3a453d31b3c12e = /* #__PURE__ */ $2f87b4fe4d8f7a0f$var$$lazy_applyCatList(190);
var $2f87b4fe4d8f7a0f$export$b7d5d9bb9ff52072 = function(dictFoldable) {
    var foldMap1 = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable)($2f87b4fe4d8f7a0f$export$f4b77959e4023828);
    return function(f) {
        return foldMap1($2f87b4fe4d8f7a0f$export$439306a4dcaafbb9)(f);
    };
};
var $2f87b4fe4d8f7a0f$export$c40cf5aab899f397 = function(cat) {
    return function(a) {
        return $2f87b4fe4d8f7a0f$export$10d8903dec122b9d(cat)(new $2f87b4fe4d8f7a0f$export$4cc9fe8c7ead393e(a, $8cad8efed8fc4b93$export$6e22c362a0406a2c));
    };
};
var $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345 = {
    unfoldr1: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                        }
                        if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value1.value0;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 170, column 24 - line 172, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    }
};
var $2f87b4fe4d8f7a0f$export$6cb6a5647a60bec3 = {
    unfoldr: function(f) {
        return function(b) {
            var go = function($copy_source) {
                return function($copy_memo) {
                    var $tco_var_source = $copy_source;
                    var $tco_done = false;
                    var $tco_result;
                    function $tco_loop(source, memo) {
                        var v = f(source);
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                            $tco_done = true;
                            return memo;
                        }
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            $tco_var_source = v.value0.value1;
                            $copy_memo = $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(memo)(v.value0.value0);
                            return;
                        }
                        throw new Error("Failed pattern match at Data.CatList (line 163, column 24 - line 165, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    while(!$tco_done)$tco_result = $tco_loop($tco_var_source, $copy_memo);
                    return $tco_result;
                };
            };
            return go(b)($2f87b4fe4d8f7a0f$export$7475bf8196f095ad.value);
        };
    },
    Unfoldable10: function() {
        return $2f87b4fe4d8f7a0f$export$bc32e6f55ceec345;
    }
};
var $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad = {
    alt: $2f87b4fe4d8f7a0f$export$10d8903dec122b9d,
    Functor0: function() {
        return $2f87b4fe4d8f7a0f$export$2fa88228892893e6;
    }
};
var $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2 = {
    empty: $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c,
    Alt0: function() {
        return $2f87b4fe4d8f7a0f$export$c5b7cf0f3fda96ad;
    }
};
var $2f87b4fe4d8f7a0f$export$37a37f49d0feb489 = {
    Applicative0: function() {
        return $2f87b4fe4d8f7a0f$export$360f55d5496233b2;
    },
    Plus1: function() {
        return $2f87b4fe4d8f7a0f$export$7790c39ae1bfafa2;
    }
};
var $2f87b4fe4d8f7a0f$export$2074eaaf9933bfe1 = {
    Monad0: function() {
        return $2f87b4fe4d8f7a0f$export$607c251688bb5f73;
    },
    Alternative1: function() {
        return $2f87b4fe4d8f7a0f$export$37a37f49d0feb489;
    }
};














var $d0bd5a116d2d5f24$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $d0bd5a116d2d5f24$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($2f87b4fe4d8f7a0f$export$da599a1924f5bf13);
var $d0bd5a116d2d5f24$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $d0bd5a116d2d5f24$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d0bd5a116d2d5f24$var$ExpF = function(x) {
    return x;
};
var $d0bd5a116d2d5f24$var$Free = /* #__PURE__ */ function() {
    function Free(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Free.create = function(value0) {
        return function(value1) {
            return new Free(value0, value1);
        };
    };
    return Free;
}();
var $d0bd5a116d2d5f24$var$Return = /* #__PURE__ */ function() {
    function Return(value0) {
        this.value0 = value0;
    }
    Return.create = function(value0) {
        return new Return(value0);
    };
    return Return;
}();
var $d0bd5a116d2d5f24$var$Bind = /* #__PURE__ */ function() {
    function Bind(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Bind.create = function(value0) {
        return function(value1) {
            return new Bind(value0, value1);
        };
    };
    return Bind;
}();
var $d0bd5a116d2d5f24$var$toView = function($copy_v) {
    var $tco_done = false;
    var $tco_result;
    function $tco_loop(v) {
        var runExpF = function(v2) {
            return v2;
        };
        var concatF = function(v2) {
            return function(r) {
                return new $d0bd5a116d2d5f24$var$Free(v2.value0, $d0bd5a116d2d5f24$var$append(v2.value1)(r));
            };
        };
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Return) {
            var v2 = $2f87b4fe4d8f7a0f$export$b446f6baa3bb1430(v.value1);
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                $tco_done = true;
                return new $d0bd5a116d2d5f24$var$Return(v.value0.value0);
            }
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                $copy_v = concatF(runExpF(v2.value0.value0)(v.value0.value0))(v2.value0.value1);
                return;
            }
            throw new Error("Failed pattern match at Control.Monad.Free (line 227, column 7 - line 231, column 64): " + [
                v2.constructor.name
            ]);
        }
        if (v.value0 instanceof $d0bd5a116d2d5f24$var$Bind) {
            $tco_done = true;
            return new $d0bd5a116d2d5f24$var$Bind(v.value0.value0, function(a) {
                return concatF(v.value0.value1(a))(v.value1);
            });
        }
        throw new Error("Failed pattern match at Control.Monad.Free (line 225, column 3 - line 233, column 56): " + [
            v.value0.constructor.name
        ]);
    }
    while(!$tco_done)$tco_result = $tco_loop($copy_v);
    return $tco_result;
};
var $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictMonadRec) {
        var Monad0 = dictMonadRec.Monad0();
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
        var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
        return function(k) {
            var go = function(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) return map2($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map2($f93520de2fa37b44$export$550acbd06a1f5a6a.create)(k(map1(v.value1)(v.value0)));
                throw new Error("Failed pattern match at Control.Monad.Free (line 194, column 10 - line 196, column 37): " + [
                    v.constructor.name
                ]);
            };
            return tailRecM(go);
        };
    };
};
var $d0bd5a116d2d5f24$export$39b8ebacf8133f4f = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(k) {
        var go = function($copy_f) {
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(f) {
                var v = $d0bd5a116d2d5f24$var$toView(f);
                if (v instanceof $d0bd5a116d2d5f24$var$Return) {
                    $tco_done = true;
                    return v.value0;
                }
                if (v instanceof $d0bd5a116d2d5f24$var$Bind) {
                    $copy_f = k(map1(v.value1)(v.value0));
                    return;
                }
                throw new Error("Failed pattern match at Control.Monad.Free (line 178, column 10 - line 180, column 33): " + [
                    v.constructor.name
                ]);
            }
            while(!$tco_done)$tco_result = $tco_loop($copy_f);
            return $tco_result;
        };
        return go;
    };
};
var $d0bd5a116d2d5f24$export$a7b5be099b56a644 = function(k) {
    return function(j) {
        return function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return j(v.value0);
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return k(v.value0)(v.value1);
            throw new Error("Failed pattern match at Control.Monad.Free (line 213, column 17 - line 215, column 20): " + [
                v.constructor.name
            ]);
        };
    };
};
var $d0bd5a116d2d5f24$export$fbb4d68fe60c1629 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return $d0bd5a116d2d5f24$export$a7b5be099b56a644(function(g) {
        return function(i) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(map1(i)(g));
        };
    })($7d4cccdf062a2261$export$19db0165690c701a.create);
};
var $d0bd5a116d2d5f24$var$fromView = function(f) {
    return new $d0bd5a116d2d5f24$var$Free(f, $2f87b4fe4d8f7a0f$export$6e22c362a0406a2c);
};
var $d0bd5a116d2d5f24$export$4997ffc0176396a6 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, $ac8b3532514ac019$export$401372c57776dc));
};
var $d0bd5a116d2d5f24$export$7c20f42c1b2b8c79 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(f) {
        return $d0bd5a116d2d5f24$export$4997ffc0176396a6(pure1(f));
    };
};
var $d0bd5a116d2d5f24$export$25ad06f1eebea5a0 = {
    Applicative0: function() {
        return $d0bd5a116d2d5f24$export$b9ce46e7f510eb18;
    },
    Bind1: function() {
        return $d0bd5a116d2d5f24$export$39486fc5c75854c8;
    }
};
var $d0bd5a116d2d5f24$export$245cefec95375d9a = {
    map: function(k) {
        return function(f) {
            return $70cd3177464e7915$export$f2077a1c19a006d9($d0bd5a116d2d5f24$export$39486fc5c75854c8)(function() {
                var $189 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
                return function($190) {
                    return $189(k($190));
                };
            }())(f);
        };
    }
};
var $d0bd5a116d2d5f24$export$39486fc5c75854c8 = {
    bind: function(v) {
        return function(k) {
            return new $d0bd5a116d2d5f24$var$Free(v.value0, $2f87b4fe4d8f7a0f$export$c40cf5aab899f397(v.value1)(k));
        };
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$export$b9ce46e7f510eb18 = {
    pure: function($191) {
        return $d0bd5a116d2d5f24$var$fromView($d0bd5a116d2d5f24$var$Return.create($191));
    },
    Apply0: function() {
        return $d0bd5a116d2d5f24$var$$lazy_freeApply(0);
    }
};
var $d0bd5a116d2d5f24$var$$lazy_freeApply = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$runtime_lazy("freeApply", "Control.Monad.Free", function() {
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d0bd5a116d2d5f24$export$25ad06f1eebea5a0),
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        }
    };
});
var $d0bd5a116d2d5f24$export$2d6a2fb8bce0f112 = /* #__PURE__ */ $d0bd5a116d2d5f24$var$$lazy_freeApply(77);
var $d0bd5a116d2d5f24$var$lift2 = /* #__PURE__ */ $7576d3a958d66ab0$export$f016650e64b51e7d($d0bd5a116d2d5f24$export$2d6a2fb8bce0f112);
var $d0bd5a116d2d5f24$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($d0bd5a116d2d5f24$export$b9ce46e7f510eb18);
var $d0bd5a116d2d5f24$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($d0bd5a116d2d5f24$export$39486fc5c75854c8);
var $d0bd5a116d2d5f24$export$d68567ac4fd5624d = function(dictSemigroup) {
    return {
        append: $d0bd5a116d2d5f24$var$lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
    };
};
var $d0bd5a116d2d5f24$export$b3d357ba4a1dabd2 = {
    tailRecM: function(k) {
        return function(a) {
            return $d0bd5a116d2d5f24$var$bind(k(a))(function(v) {
                if (v instanceof $f93520de2fa37b44$export$550acbd06a1f5a6a) return $f93520de2fa37b44$export$c025cfd4cc93300b($d0bd5a116d2d5f24$export$b3d357ba4a1dabd2)(k)(v.value0);
                if (v instanceof $f93520de2fa37b44$export$7fe28cb29e71bf10) return $d0bd5a116d2d5f24$var$pure(v.value0);
                throw new Error("Failed pattern match at Control.Monad.Free (line 86, column 26 - line 88, column 21): " + [
                    v.constructor.name
                ]);
            });
        };
    },
    Monad0: function() {
        return $d0bd5a116d2d5f24$export$25ad06f1eebea5a0;
    }
};
var $d0bd5a116d2d5f24$export$8040756fd4c77395 = function(f) {
    return $d0bd5a116d2d5f24$var$fromView(new $d0bd5a116d2d5f24$var$Bind(f, function($192) {
        return $d0bd5a116d2d5f24$var$pure($192);
    }));
};
var $d0bd5a116d2d5f24$export$5eeb2de8b5f5121f = {
    lift: function(dictMonad) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395;
    }
};
var $d0bd5a116d2d5f24$export$cb3638ab887278d6 = function(dictMonoid) {
    var semigroupFree1 = $d0bd5a116d2d5f24$export$d68567ac4fd5624d(dictMonoid.Semigroup0());
    return {
        mempty: $d0bd5a116d2d5f24$var$pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
        Semigroup0: function() {
            return semigroupFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$d6dbe5e3073f84e = function(k) {
    var go = function(f) {
        var v = $d0bd5a116d2d5f24$var$toView(f);
        if (v instanceof $d0bd5a116d2d5f24$var$Return) return $d0bd5a116d2d5f24$var$pure(v.value0);
        if (v instanceof $d0bd5a116d2d5f24$var$Bind) return $d0bd5a116d2d5f24$var$bind(k(v.value0))($d0bd5a116d2d5f24$var$map(go)(v.value1));
        throw new Error("Failed pattern match at Control.Monad.Free (line 168, column 10 - line 170, column 33): " + [
            v.constructor.name
        ]);
    };
    return go;
};
var $d0bd5a116d2d5f24$export$9624ed458578c422 = function(k) {
    return $d0bd5a116d2d5f24$export$d6dbe5e3073f84e(function($193) {
        return $d0bd5a116d2d5f24$export$8040756fd4c77395(k($193));
    });
};
var $d0bd5a116d2d5f24$export$7bf6537c73f09eab = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictFoldable) {
        var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
        var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
        var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
        return {
            foldMap: function(dictMonoid) {
                var foldMap1 = foldMap(dictMonoid);
                return function(f) {
                    var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                        return function($194) {
                            return function(v) {
                                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldMap1($lazy_go(94))(v.value0);
                                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0);
                                throw new Error("Failed pattern match at Control.Monad.Free (line 93, column 21 - line 95, column 21): " + [
                                    v.constructor.name
                                ]);
                            }(resume1($194));
                        };
                    });
                    var go = $lazy_go(93);
                    return go;
                };
            },
            foldl: function(f) {
                var go = function(r) {
                    return function($195) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldl(go)(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(r)(v.value0);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 98, column 23 - line 100, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($195));
                    };
                };
                return go;
            },
            foldr: function(f) {
                var go = function(r) {
                    return function($196) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return foldr($f57f4b701aa7b66e$export$8a83211c878a3f1f(go))(r)(v.value0);
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return f(v.value0)(r);
                            throw new Error("Failed pattern match at Control.Monad.Free (line 103, column 23 - line 105, column 23): " + [
                                v.constructor.name
                            ]);
                        }(resume1($196));
                    };
                };
                return go;
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$816b93e586e4c75c = function(dictTraversable) {
    var Functor0 = dictTraversable.Functor0();
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(Functor0);
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var foldableFree1 = $d0bd5a116d2d5f24$export$7bf6537c73f09eab(Functor0)(dictTraversable.Foldable1());
    return {
        traverse: function(dictApplicative) {
            var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var $lazy_go = $d0bd5a116d2d5f24$var$$runtime_lazy("go", "Control.Monad.Free", function() {
                    return function($197) {
                        return function(v) {
                            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return map1(function($198) {
                                return $d0bd5a116d2d5f24$var$join($d0bd5a116d2d5f24$export$8040756fd4c77395($198));
                            })(traverse1($lazy_go(111))(v.value0));
                            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return map1($d0bd5a116d2d5f24$var$pure)(f(v.value0));
                            throw new Error("Failed pattern match at Control.Monad.Free (line 110, column 21 - line 112, column 30): " + [
                                v.constructor.name
                            ]);
                        }(resume1($197));
                    };
                });
                var go = $lazy_go(110);
                return go;
            };
        },
        sequence: function(dictApplicative) {
            return function(tma) {
                return $11d1e86de605dfc6$export$df3f009e3d155b20($d0bd5a116d2d5f24$export$816b93e586e4c75c(dictTraversable))(dictApplicative)($d0bd5a116d2d5f24$var$identity)(tma);
            };
        },
        Functor0: function() {
            return $d0bd5a116d2d5f24$export$245cefec95375d9a;
        },
        Foldable1: function() {
            return foldableFree1;
        }
    };
};
var $d0bd5a116d2d5f24$export$eb0e66a9104d4874 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Monad0.Bind1().Apply0().Functor0());
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    return function(k) {
        var go = function(f) {
            var v = $d0bd5a116d2d5f24$var$toView(f);
            if (v instanceof $d0bd5a116d2d5f24$var$Return) return map1($f93520de2fa37b44$export$7fe28cb29e71bf10.create)(pure1(v.value0));
            if (v instanceof $d0bd5a116d2d5f24$var$Bind) return map1(function($199) {
                return $f93520de2fa37b44$export$550acbd06a1f5a6a.create(v.value1($199));
            })(k(v.value0));
            throw new Error("Failed pattern match at Control.Monad.Free (line 158, column 10 - line 160, column 37): " + [
                v.constructor.name
            ]);
        };
        return tailRecM(go);
    };
};
var $d0bd5a116d2d5f24$export$14742287b71545dd = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    return function(dictEq1) {
        var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
        return function(dictEq) {
            var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
            return {
                eq: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return eq1($d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor)(dictEq1)(dictEq))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return eq(v1.value0)(v.value0);
                        return false;
                    };
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$10be470239ca56c7 = function(dictFunctor) {
    var resume1 = $d0bd5a116d2d5f24$export$fbb4d68fe60c1629(dictFunctor);
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictOrd1) {
        var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
        var eqFree2 = eqFree1(dictOrd1.Eq10());
        return function(dictOrd) {
            var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
            var eqFree3 = eqFree2(dictOrd.Eq0());
            return {
                compare: function(x) {
                    return function(y) {
                        var v = resume1(y);
                        var v1 = resume1(x);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return compare1($d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor)(dictOrd1)(dictOrd))(v1.value0)(v.value0);
                        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
                        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $5026be88823ef1f4$export$b023c82b48e70453.value;
                        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return compare(v1.value0)(v.value0);
                        throw new Error("Failed pattern match at Control.Monad.Free (line 56, column 17 - line 60, column 36): " + [
                            v1.constructor.name,
                            v.constructor.name
                        ]);
                    };
                },
                Eq0: function() {
                    return eqFree3;
                }
            };
        };
    };
};
var $d0bd5a116d2d5f24$export$269c49b8f4785316 = function(dictFunctor) {
    var eqFree1 = $d0bd5a116d2d5f24$export$14742287b71545dd(dictFunctor);
    return function(dictEq1) {
        var eqFree2 = eqFree1(dictEq1);
        return {
            eq1: function(dictEq) {
                return $37b880af5f4991bd$export$9663ddc1cf085b32(eqFree2(dictEq));
            }
        };
    };
};
var $d0bd5a116d2d5f24$export$915c63020dce06b2 = function(dictFunctor) {
    var ordFree1 = $d0bd5a116d2d5f24$export$10be470239ca56c7(dictFunctor);
    var eq1Free1 = $d0bd5a116d2d5f24$export$269c49b8f4785316(dictFunctor);
    return function(dictOrd1) {
        var ordFree2 = ordFree1(dictOrd1);
        var eq1Free2 = eq1Free1(dictOrd1.Eq10());
        return {
            compare1: function(dictOrd) {
                return $97937c29f879e68e$export$398604a469f7de9a(ordFree2(dictOrd));
            },
            Eq10: function() {
                return eq1Free2;
            }
        };
    };
};



// Generated by purs version 0.15.16




var $4a0611d0fc3e3eac$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $4a0611d0fc3e3eac$export$29d22fcef0a54f1b = $e9bda291f4ec10ec$export$72aea7109e8312dd;
var $4a0611d0fc3e3eac$export$4b65631072155b20 = function(v) {
    return function($18) {
        return $4a0611d0fc3e3eac$var$unwrap(v($18));
    };
};
var $4a0611d0fc3e3eac$export$a337c713bdba072 = function(f) {
    return $e9bda291f4ec10ec$export$8342df5ddac360cd(function($19) {
        return $50c50d1f444e5fa4$export$544bf02140fa9a77(f($4a0611d0fc3e3eac$var$unwrap($19)));
    });
};
var $4a0611d0fc3e3eac$export$6feb49085bba08e4 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value1;
    };
};
var $4a0611d0fc3e3eac$export$3f3c20f32c573065 = function(v) {
    return function(s) {
        var v1 = v(s);
        return v1.value0;
    };
};










// Generated by purs version 0.15.16
const $99af8ad7682e39c7$export$260e5c0943f31606 = function(thunk) {
    var v = null;
    return function() {
        if (thunk === undefined) return v;
        v = thunk();
        thunk = undefined; // eslint-disable-line no-param-reassign
        return v;
    };
};
const $99af8ad7682e39c7$export$4d82290515cd0ddb = function(l) {
    return l();
};



















var $73aa5dd1904ebcb7$export$bb0ce398898c1c48 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return {
        show: function(x) {
            return "(defer \\_ -> " + (show($99af8ad7682e39c7$export$4d82290515cd0ddb(x)) + ")");
        }
    };
};
var $73aa5dd1904ebcb7$export$a23c81c7931f53a = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    var zero = $c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring);
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    var one = $c0e822be92afc4df$export$80bf7733f1207381(dictSemiring);
    return {
        add: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return add($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        zero: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return zero;
        }),
        mul: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mul($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        one: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return one;
        })
    };
};
var $73aa5dd1904ebcb7$export$8400f884b0cf16b1 = function(dictSemigroup) {
    var append1 = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return {
        append: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return append1($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$6dfc43186b725e5c = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    var semiringLazy1 = $73aa5dd1904ebcb7$export$a23c81c7931f53a(dictRing.Semiring0());
    return {
        sub: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return sub($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        Semiring0: function() {
            return semiringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$fe3e07ed2de45f8f = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
    var semigroupLazy1 = $73aa5dd1904ebcb7$export$8400f884b0cf16b1(dictMonoid.Semigroup0());
    return {
        mempty: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return mempty;
        }),
        Semigroup0: function() {
            return semigroupLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$56fd27feb83d90f5 = {
    defer: function(f) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($05149ea687d6b460$export$523c0b569236b342));
        });
    }
};
var $73aa5dd1904ebcb7$export$3780b8670d5f24f8 = {
    map: function(f) {
        return function(l) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            });
        };
    }
};
var $73aa5dd1904ebcb7$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $73aa5dd1904ebcb7$export$8f588843775274ce = {
    mapWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$map(f($05149ea687d6b460$export$523c0b569236b342));
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$3bd0a60cfec06f1a = {
    imap: /* #__PURE__ */ $3d82dffba933b011$export$eb38b1c8c5f72ca8($73aa5dd1904ebcb7$export$3780b8670d5f24f8)
};
var $73aa5dd1904ebcb7$export$6ad686e404b9cd02 = {
    foldr: function(f) {
        return function(z) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l))(z);
            };
        };
    },
    foldl: function(f) {
        return function(z) {
            return function(l) {
                return f(z)($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    }
};
var $73aa5dd1904ebcb7$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($73aa5dd1904ebcb7$export$6ad686e404b9cd02);
var $73aa5dd1904ebcb7$export$c99a011ac0d986c7 = {
    foldrWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldr(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldlWithIndex: function(f) {
        return $73aa5dd1904ebcb7$var$foldl(f($05149ea687d6b460$export$523c0b569236b342));
    },
    foldMapWithIndex: function(dictMonoid) {
        var foldMap1 = $73aa5dd1904ebcb7$var$foldMap(dictMonoid);
        return function(f) {
            return foldMap1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$d75b77350c4c9111 = {
    traverse: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(l) {
                return map1(function($103) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($103));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence: function(dictApplicative) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(l) {
            return map1(function($104) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($104));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    },
    Foldable1: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($73aa5dd1904ebcb7$export$d75b77350c4c9111);
var $73aa5dd1904ebcb7$export$1c9f73288a97bff6 = {
    traverseWithIndex: function(dictApplicative) {
        var traverse1 = $73aa5dd1904ebcb7$var$traverse(dictApplicative);
        return function(f) {
            return traverse1(f($05149ea687d6b460$export$523c0b569236b342));
        };
    },
    FunctorWithIndex0: function() {
        return $73aa5dd1904ebcb7$export$8f588843775274ce;
    },
    FoldableWithIndex1: function() {
        return $73aa5dd1904ebcb7$export$c99a011ac0d986c7;
    },
    Traversable2: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$8d84e581926eaeba = {
    foldMap1: function(dictSemigroup) {
        return function(f) {
            return function(l) {
                return f($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
            };
        };
    },
    foldr1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    foldl1: function(v) {
        return function(l) {
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(l);
        };
    },
    Foldable0: function() {
        return $73aa5dd1904ebcb7$export$6ad686e404b9cd02;
    }
};
var $73aa5dd1904ebcb7$export$316fa2792966d831 = {
    traverse1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(f) {
            return function(l) {
                return map1(function($105) {
                    return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($105));
                })(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            };
        };
    },
    sequence1: function(dictApply) {
        var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
        return function(l) {
            return map1(function($106) {
                return $99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($106));
            })($99af8ad7682e39c7$export$4d82290515cd0ddb(l));
        };
    },
    Foldable10: function() {
        return $73aa5dd1904ebcb7$export$8d84e581926eaeba;
    },
    Traversable1: function() {
        return $73aa5dd1904ebcb7$export$d75b77350c4c9111;
    }
};
var $73aa5dd1904ebcb7$export$5db1a0137683eb80 = {
    extend: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return f(x);
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        }
    };
};
var $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqLazy1 = $73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare($99af8ad7682e39c7$export$4d82290515cd0ddb(x))($99af8ad7682e39c7$export$4d82290515cd0ddb(y));
            };
        },
        Eq0: function() {
            return eqLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$4fb3dc255b34fa12 = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($73aa5dd1904ebcb7$export$1c9d1a32b20e91d5(dictEq));
    }
};
var $73aa5dd1904ebcb7$export$d65b504a31b57308 = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictOrd));
    },
    Eq10: function() {
        return $73aa5dd1904ebcb7$export$4fb3dc255b34fa12;
    }
};
var $73aa5dd1904ebcb7$export$544fccaec3eca1d4 = {
    extract: $99af8ad7682e39c7$export$4d82290515cd0ddb,
    Extend0: function() {
        return $73aa5dd1904ebcb7$export$5db1a0137683eb80;
    }
};
var $73aa5dd1904ebcb7$export$b0aa908a8262dbd4 = function(dictCommutativeRing) {
    var ringLazy1 = $73aa5dd1904ebcb7$export$6dfc43186b725e5c(dictCommutativeRing.Ring0());
    return {
        Ring0: function() {
            return ringLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$d150da49d30e2076 = function(dictEuclideanRing) {
    var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
    var mod = $b0cd729514c2504e$export$842a2cf37af977e1(dictEuclideanRing);
    var commutativeRingLazy1 = $73aa5dd1904ebcb7$export$b0aa908a8262dbd4(dictEuclideanRing.CommutativeRing0());
    return {
        degree: function() {
            var $107 = $b0cd729514c2504e$export$a23b7da4bc008930(dictEuclideanRing);
            return function($108) {
                return $107($99af8ad7682e39c7$export$4d82290515cd0ddb($108));
            };
        }(),
        div: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return div($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        mod: function(a) {
            return function(b) {
                return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                    return mod($99af8ad7682e39c7$export$4d82290515cd0ddb(a))($99af8ad7682e39c7$export$4d82290515cd0ddb(b));
                });
            };
        },
        CommutativeRing0: function() {
            return commutativeRingLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$aabc837ad904b190 = function(dictBounded) {
    var top = $69d0e3dbb12088d2$export$1e95b668f3b82d(dictBounded);
    var bottom = $69d0e3dbb12088d2$export$40e543e69a8b3fbb(dictBounded);
    var ordLazy1 = $73aa5dd1904ebcb7$export$cbabaf21b7e8b5db(dictBounded.Ord0());
    return {
        top: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return top;
        }),
        bottom: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return bottom;
        }),
        Ord0: function() {
            return ordLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$c3ec2aebe6109e81 = {
    apply: function(f) {
        return function(x) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f)($99af8ad7682e39c7$export$4d82290515cd0ddb(x));
            });
        };
    },
    Functor0: function() {
        return $73aa5dd1904ebcb7$export$3780b8670d5f24f8;
    }
};
var $73aa5dd1904ebcb7$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($73aa5dd1904ebcb7$export$c3ec2aebe6109e81);
var $73aa5dd1904ebcb7$export$e1a4485e8a67faf2 = {
    bind: function(l) {
        return function(f) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $99af8ad7682e39c7$export$4d82290515cd0ddb(f($99af8ad7682e39c7$export$4d82290515cd0ddb(l)));
            });
        };
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$89956d4f263e939b = function(dictHeytingAlgebra) {
    var ff = $f8fc227945eb179e$export$f59495b1b7502b33(dictHeytingAlgebra);
    var tt = $f8fc227945eb179e$export$80bf595f9d9a1157(dictHeytingAlgebra);
    var implies = $f8fc227945eb179e$export$6c53455e54f455ef(dictHeytingAlgebra);
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    var not = $f8fc227945eb179e$export$6003a5f097c73977(dictHeytingAlgebra);
    return {
        ff: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return ff;
        }),
        tt: $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return tt;
        }),
        implies: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(implies)(a))(b);
            };
        },
        conj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(conj)(a))(b);
            };
        },
        disj: function(a) {
            return function(b) {
                return $73aa5dd1904ebcb7$var$apply($73aa5dd1904ebcb7$var$map(disj)(a))(b);
            };
        },
        not: function(a) {
            return $73aa5dd1904ebcb7$var$map(not)(a);
        }
    };
};
var $73aa5dd1904ebcb7$export$27ff7cba27a505be = function(dictBooleanAlgebra) {
    var heytingAlgebraLazy1 = $73aa5dd1904ebcb7$export$89956d4f263e939b(dictBooleanAlgebra.HeytingAlgebra0());
    return {
        HeytingAlgebra0: function() {
            return heytingAlgebraLazy1;
        }
    };
};
var $73aa5dd1904ebcb7$export$28587442a46d4141 = {
    pure: function(a) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return a;
        });
    },
    Apply0: function() {
        return $73aa5dd1904ebcb7$export$c3ec2aebe6109e81;
    }
};
var $73aa5dd1904ebcb7$export$cfa2e2b570f2d5d3 = {
    Applicative0: function() {
        return $73aa5dd1904ebcb7$export$28587442a46d4141;
    },
    Bind1: function() {
        return $73aa5dd1904ebcb7$export$e1a4485e8a67faf2;
    }
};









var $a7cd7990ff17745a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $a7cd7990ff17745a$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $a7cd7990ff17745a$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $a7cd7990ff17745a$var$state = /* #__PURE__ */ $f2d5035ce6148af6$export$ca000e230c0caa3e(/* #__PURE__ */ $e9bda291f4ec10ec$export$fc3b89a546fa5c5c($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $a7cd7990ff17745a$var$monadRecStateT = /* #__PURE__ */ $e9bda291f4ec10ec$export$ade5de830b656137($f93520de2fa37b44$export$ef692454cdd8c2ba);
var $a7cd7990ff17745a$var$Cofree = function(x) {
    return x;
};
var $a7cd7990ff17745a$export$c01875f616615628 = function(v) {
    return $71f2e2e9476163f8$export$6f71268a1666ab58($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
};
var $a7cd7990ff17745a$export$5d6e20892d59dd4f = function(a) {
    return function(t) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, t);
        });
    };
};
var $a7cd7990ff17745a$export$997c52585a9ceb85 = {
    defer: function(k) {
        return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            var v1 = k($05149ea687d6b460$export$523c0b569236b342);
            return $99af8ad7682e39c7$export$4d82290515cd0ddb(v1);
        });
    }
};
var $a7cd7990ff17745a$export$b74b29e7f282f5ad = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(nat) {
        return function(v) {
            return $a7cd7990ff17745a$var$map($a7cd7990ff17745a$var$map1(function() {
                var $185 = map2($a7cd7990ff17745a$export$b74b29e7f282f5ad(dictFunctor)(nat));
                return function($186) {
                    return nat($185($186));
                };
            }()))(v);
        };
    };
};
var $a7cd7990ff17745a$export$5fd5031fecdacec3 = function(v) {
    return $71f2e2e9476163f8$export$9e770fa6ce19a9d6($99af8ad7682e39c7$export$4d82290515cd0ddb(v));
};
var $a7cd7990ff17745a$export$f880ce3874d12f41 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return {
        map: function(f) {
            var loop = function(v) {
                return $a7cd7990ff17745a$var$map(function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v1.value0), map2(loop)(v1.value1));
                })(v);
            };
            return loop;
        }
    };
};
var $a7cd7990ff17745a$export$d8dbe3dc0fc45337 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictFunctor);
    return {
        mapWithIndex: function(f) {
            var loop = function(n) {
                return function(v) {
                    return $a7cd7990ff17745a$var$map(function(v1) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(n)(v1.value0), map2(loop(n + 1 | 0))(v1.value1));
                    })(v);
                };
            };
            return loop(0);
        },
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$27b554deba9d6cfd = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    return {
        foldr: function(f) {
            var go = function(fa) {
                return function(b) {
                    return f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa))(foldr(go)(b)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                };
            };
            return $f57f4b701aa7b66e$export$8a83211c878a3f1f(go);
        },
        foldl: function(f) {
            var go = function(b) {
                return function(fa) {
                    return foldl(go)(f(b)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))($a7cd7990ff17745a$export$c01875f616615628(fa));
                };
            };
            return go;
        },
        foldMap: function(dictMonoid) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                var go = function(fa) {
                    return append(f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))(foldMap1(go)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                };
                return go;
            };
        }
    };
};
var $a7cd7990ff17745a$export$a4997176d66ab7ef = function(dictFoldable) {
    var foldr = $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf(dictFoldable);
    var foldl = $4fe7b6acfba7f29f$export$50ae948ca12cdcbc(dictFoldable);
    var foldMap = $4fe7b6acfba7f29f$export$b66cdc0497d8a99a(dictFoldable);
    var foldableCofree1 = $a7cd7990ff17745a$export$27b554deba9d6cfd(dictFoldable);
    return {
        foldrWithIndex: function(f) {
            var go = function(ix) {
                return function(b) {
                    return function(fa) {
                        return f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa))(foldr($f57f4b701aa7b66e$export$8a83211c878a3f1f(go(ix + 1 | 0)))(b)($a7cd7990ff17745a$export$c01875f616615628(fa)));
                    };
                };
            };
            return go(0);
        },
        foldlWithIndex: function(f) {
            var go = function(ix) {
                return function(b) {
                    return function(fa) {
                        return foldl(go(ix + 1 | 0))(f(ix)(b)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))($a7cd7990ff17745a$export$c01875f616615628(fa));
                    };
                };
            };
            return go(0);
        },
        foldMapWithIndex: function(dictMonoid) {
            var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictMonoid.Semigroup0());
            var foldMap1 = foldMap(dictMonoid);
            return function(f) {
                var go = function(ix) {
                    return function(fa) {
                        return append(f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(fa)))(foldMap1(go(ix + 1 | 0))($a7cd7990ff17745a$export$c01875f616615628(fa)));
                    };
                };
                return go(0);
            };
        },
        Foldable0: function() {
            return foldableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$afea7a71a27f2ae9 = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictTraversable.Functor0());
    var foldableCofree1 = $a7cd7990ff17745a$export$27b554deba9d6cfd(dictTraversable.Foldable1());
    return {
        sequence: function(dictApplicative) {
            return $11d1e86de605dfc6$export$df3f009e3d155b20($a7cd7990ff17745a$export$afea7a71a27f2ae9(dictTraversable))(dictApplicative)($a7cd7990ff17745a$var$identity);
        },
        traverse: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var loop = function(ta) {
                    return apply(map2($a7cd7990ff17745a$export$5d6e20892d59dd4f)(f($a7cd7990ff17745a$export$5fd5031fecdacec3(ta))))(traverse1(loop)($a7cd7990ff17745a$export$c01875f616615628(ta)));
                };
                return loop;
            };
        },
        Functor0: function() {
            return functorCofree1;
        },
        Foldable1: function() {
            return foldableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$5328eb44a9219841 = function(dictTraversable) {
    var traverse = $11d1e86de605dfc6$export$df3f009e3d155b20(dictTraversable);
    var functorWithIndexCofree1 = $a7cd7990ff17745a$export$d8dbe3dc0fc45337(dictTraversable.Functor0());
    var foldableWithIndexCofree1 = $a7cd7990ff17745a$export$a4997176d66ab7ef(dictTraversable.Foldable1());
    var traversableCofree1 = $a7cd7990ff17745a$export$afea7a71a27f2ae9(dictTraversable);
    return {
        traverseWithIndex: function(dictApplicative) {
            var Apply0 = dictApplicative.Apply0();
            var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(Apply0);
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Apply0.Functor0());
            var traverse1 = traverse(dictApplicative);
            return function(f) {
                var loop = function(ix) {
                    return function(ta) {
                        return apply(map2($a7cd7990ff17745a$export$5d6e20892d59dd4f)(f(ix)($a7cd7990ff17745a$export$5fd5031fecdacec3(ta))))(traverse1(loop(ix + 1 | 0))($a7cd7990ff17745a$export$c01875f616615628(ta)));
                    };
                };
                return loop(0);
            };
        },
        FunctorWithIndex0: function() {
            return functorWithIndexCofree1;
        },
        FoldableWithIndex1: function() {
            return foldableWithIndexCofree1;
        },
        Traversable2: function() {
            return traversableCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$680d116616e6c381 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictFunctor);
    return {
        extend: function(f) {
            var loop = function(v) {
                return $a7cd7990ff17745a$var$map(function(v1) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(f(v), map2(loop)(v1.value1));
                })(v);
            };
            return loop;
        },
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$3186123601b26111 = function(dictEq1) {
    var eq1 = $37b880af5f4991bd$export$96fd6c73d03c9dd2(dictEq1);
    return function(dictEq) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
        return {
            eq: function(x) {
                return function(y) {
                    return eq($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y)) && eq1($a7cd7990ff17745a$export$3186123601b26111(dictEq1)(dictEq))($a7cd7990ff17745a$export$c01875f616615628(x))($a7cd7990ff17745a$export$c01875f616615628(y));
                };
            }
        };
    };
};
var $a7cd7990ff17745a$export$d55c5d3ff285f8ac = function(dictOrd1) {
    var compare1 = $97937c29f879e68e$export$693feb0c3c484b70(dictOrd1);
    var eqCofree1 = $a7cd7990ff17745a$export$3186123601b26111(dictOrd1.Eq10());
    return function(dictOrd) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
        var eqCofree2 = eqCofree1(dictOrd.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    var v = compare($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y));
                    if (v instanceof $5026be88823ef1f4$export$1c0a5d05eb3f6e18) return compare1($a7cd7990ff17745a$export$d55c5d3ff285f8ac(dictOrd1)(dictOrd))($a7cd7990ff17745a$export$c01875f616615628(x))($a7cd7990ff17745a$export$c01875f616615628(y));
                    return v;
                };
            },
            Eq0: function() {
                return eqCofree2;
            }
        };
    };
};
var $a7cd7990ff17745a$export$23960db76f4202fc = function(dictEq1) {
    var eqCofree1 = $a7cd7990ff17745a$export$3186123601b26111(dictEq1);
    return {
        eq1: function(dictEq) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqCofree1(dictEq));
        }
    };
};
var $a7cd7990ff17745a$export$11e95260dbde4518 = function(dictOrd1) {
    var ordCofree1 = $a7cd7990ff17745a$export$d55c5d3ff285f8ac(dictOrd1);
    var eq1Cofree1 = $a7cd7990ff17745a$export$23960db76f4202fc(dictOrd1.Eq10());
    return {
        compare1: function(dictOrd) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordCofree1(dictOrd));
        },
        Eq10: function() {
            return eq1Cofree1;
        }
    };
};
var $a7cd7990ff17745a$export$18736d0fdc79bf66 = function($187) {
    return $a7cd7990ff17745a$var$Cofree($99af8ad7682e39c7$export$260e5c0943f31606($187));
};
var $a7cd7990ff17745a$export$4cd8cee3369393b2 = function(dictApply) {
    var apply = $7576d3a958d66ab0$export$5635d7ef4b8fee1c(dictApply);
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApply.Functor0());
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(x) {
                return function(y) {
                    return $a7cd7990ff17745a$export$18736d0fdc79bf66(function(v) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(append($a7cd7990ff17745a$export$5fd5031fecdacec3(x))($a7cd7990ff17745a$export$5fd5031fecdacec3(y)), apply(map2($d7bf9817a417d4ae$export$10d8903dec122b9d($a7cd7990ff17745a$export$4cd8cee3369393b2(dictApply)(dictSemigroup)))($a7cd7990ff17745a$export$c01875f616615628(x)))($a7cd7990ff17745a$export$c01875f616615628(y)));
                    });
                };
            }
        };
    };
};
var $a7cd7990ff17745a$export$207d9540d6c38a4a = function(dictApplicative) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    var semigroupCofree1 = $a7cd7990ff17745a$export$4cd8cee3369393b2(dictApplicative.Apply0());
    return function(dictMonoid) {
        var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid);
        var semigroupCofree2 = semigroupCofree1(dictMonoid.Semigroup0());
        return {
            mempty: $a7cd7990ff17745a$export$18736d0fdc79bf66(function(v) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(mempty, pure($784e1bd3d26d71da$export$9a7d64bc1d75357($a7cd7990ff17745a$export$207d9540d6c38a4a(dictApplicative)(dictMonoid))));
            }),
            Semigroup0: function() {
                return semigroupCofree2;
            }
        };
    };
};
var $a7cd7990ff17745a$export$3d90a06a91631e50 = function(dictFunctor) {
    var extendCofree1 = $a7cd7990ff17745a$export$680d116616e6c381(dictFunctor);
    return {
        extract: $a7cd7990ff17745a$export$5fd5031fecdacec3,
        Extend0: function() {
            return extendCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$6c6e679936662ba2 = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var runFreeM = $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7(dictFunctor)($a7cd7990ff17745a$var$monadRecStateT);
    return function(dictFunctor1) {
        var extract = $b3e944c79ac8b935$export$f9380c9a627682d3($a7cd7990ff17745a$export$3d90a06a91631e50(dictFunctor1));
        return function(pair) {
            return function(m) {
                return function(w) {
                    var step = function(ff) {
                        return $a7cd7990ff17745a$var$state(function(cof) {
                            return pair(map2($71f2e2e9476163f8$export$1908877435b1d5e9.create)(ff))($a7cd7990ff17745a$export$c01875f616615628(cof));
                        });
                    };
                    var v = $4a0611d0fc3e3eac$export$4b65631072155b20(runFreeM(step)(m))(w);
                    return v.value0(extract(v.value1));
                };
            };
        };
    };
};
var $a7cd7990ff17745a$export$282b56ce68655d1d = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    var runFreeM = $d0bd5a116d2d5f24$export$2bd79f4d19aaa2f7(dictFunctor);
    return function(dictFunctor1) {
        var extract = $b3e944c79ac8b935$export$f9380c9a627682d3($a7cd7990ff17745a$export$3d90a06a91631e50(dictFunctor1));
        return function(dictMonadRec) {
            var map3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonadRec.Monad0().Bind1().Apply0().Functor0());
            var runFreeM1 = runFreeM($e9bda291f4ec10ec$export$ade5de830b656137(dictMonadRec));
            return function(pair) {
                return function(m) {
                    return function(w) {
                        var step = function(ff) {
                            return function(cof) {
                                return pair(map2($71f2e2e9476163f8$export$1908877435b1d5e9.create)(ff))($a7cd7990ff17745a$export$c01875f616615628(cof));
                            };
                        };
                        var $$eval = function(v) {
                            return v.value0(extract(v.value1));
                        };
                        return map3($$eval)($e9bda291f4ec10ec$export$c5ba8a89d9140c32(runFreeM1(step)(m))(w));
                    };
                };
            };
        };
    };
};
var $a7cd7990ff17745a$export$b3bcb4782421e76f = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(k) {
        return function(s) {
            return $99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
                return $a7cd7990ff17745a$var$map1(map2($a7cd7990ff17745a$export$b3bcb4782421e76f(dictFunctor)(k)))(k(s));
            });
        };
    };
};
var $a7cd7990ff17745a$export$822f8cf624bdf75a = function(dictAlternative) {
    return {
        Applicative0: function() {
            return $a7cd7990ff17745a$export$e7f4fbe6660ee944(dictAlternative);
        },
        Bind1: function() {
            return $a7cd7990ff17745a$export$bae78b53de66415b(dictAlternative);
        }
    };
};
var $a7cd7990ff17745a$export$bae78b53de66415b = function(dictAlternative) {
    var Alt0 = dictAlternative.Plus1().Alt0();
    var alt = $75e93a4111e80214$export$228be17d80722ab(Alt0);
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Alt0.Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var loop = function(fa$prime) {
                    var fh = f($a7cd7990ff17745a$export$5fd5031fecdacec3(fa$prime));
                    return $a7cd7990ff17745a$export$5d6e20892d59dd4f($a7cd7990ff17745a$export$5fd5031fecdacec3(fh))(alt($a7cd7990ff17745a$export$c01875f616615628(fh))(map2(loop)($a7cd7990ff17745a$export$c01875f616615628(fa$prime))));
                };
                return loop(fa);
            };
        },
        Apply0: function() {
            return $a7cd7990ff17745a$export$29fadb90ec70ad5(dictAlternative);
        }
    };
};
var $a7cd7990ff17745a$export$29fadb90ec70ad5 = function(dictAlternative) {
    var functorCofree1 = $a7cd7990ff17745a$export$f880ce3874d12f41(dictAlternative.Plus1().Alt0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($a7cd7990ff17745a$export$822f8cf624bdf75a(dictAlternative)),
        Functor0: function() {
            return functorCofree1;
        }
    };
};
var $a7cd7990ff17745a$export$e7f4fbe6660ee944 = function(dictAlternative) {
    var empty = $7abe8fbe97ebda87$export$6e22c362a0406a2c(dictAlternative.Plus1());
    return {
        pure: function(a) {
            return $a7cd7990ff17745a$export$5d6e20892d59dd4f(a)(empty);
        },
        Apply0: function() {
            return $a7cd7990ff17745a$export$29fadb90ec70ad5(dictAlternative);
        }
    };
};








var $d2553f9ef1953d90$var$power = /* #__PURE__ */ $784e1bd3d26d71da$export$836601bcef5ff40($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $d2553f9ef1953d90$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $a7cd7990ff17745a$export$f880ce3874d12f41($78c799cba34fcb8d$export$40b9e4330ffd17e3));
var $d2553f9ef1953d90$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $d2553f9ef1953d90$export$df6212ebae08b450 = function(a) {
    return function(n) {
        return $a7cd7990ff17745a$export$5d6e20892d59dd4f(a)($a7cd7990ff17745a$export$c01875f616615628(n));
    };
};
var $d2553f9ef1953d90$export$8a3f67022d0557a = function(f) {
    return function(b) {
        return function(n) {
            var go = function(v) {
                if (v.current instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v["final"]);
                if (v.current instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var fb$prime = f($a7cd7990ff17745a$export$5fd5031fecdacec3(v.current.value0))(v.b);
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        b: v.b,
                        current: v.current.value1,
                        "final": $3d4fd987da5242ff$export$c40cf5aab899f397(v["final"])($a7cd7990ff17745a$export$5d6e20892d59dd4f(fb$prime.value)($f93520de2fa37b44$export$2e586eaa876dd2fd(go)({
                            b: fb$prime.accum,
                            current: $a7cd7990ff17745a$export$c01875f616615628(v.current.value0),
                            "final": $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                        })))
                    });
                }
                throw new Error("Failed pattern match at Data.Tree (line 87, column 3 - line 87, column 129): " + [
                    v.constructor.name
                ]);
            };
            var fb = f($a7cd7990ff17745a$export$5fd5031fecdacec3(n))(b);
            return $a7cd7990ff17745a$export$5d6e20892d59dd4f(fb.value)($f93520de2fa37b44$export$2e586eaa876dd2fd(go)({
                b: fb.accum,
                current: $a7cd7990ff17745a$export$c01875f616615628(n),
                "final": $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            }));
        };
    };
};
var $d2553f9ef1953d90$export$3b1082aee7c6424 = function(f) {
    return function(b) {
        return function(n) {
            var go = function(v) {
                if (v.current instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v["final"]);
                if (v.current instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                    var fb$prime = f($a7cd7990ff17745a$export$5fd5031fecdacec3(v.current.value0))(v.b);
                    return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        b: v.b,
                        current: v.current.value1,
                        "final": $3d4fd987da5242ff$export$c40cf5aab899f397(v["final"])($a7cd7990ff17745a$export$5d6e20892d59dd4f(fb$prime)($f93520de2fa37b44$export$2e586eaa876dd2fd(go)({
                            b: fb$prime,
                            current: $a7cd7990ff17745a$export$c01875f616615628(v.current.value0),
                            "final": $78c799cba34fcb8d$export$c1bed610ade55e1c.value
                        })))
                    });
                }
                throw new Error("Failed pattern match at Data.Tree (line 72, column 3 - line 72, column 129): " + [
                    v.constructor.name
                ]);
            };
            var fb = f($a7cd7990ff17745a$export$5fd5031fecdacec3(n))(b);
            return $a7cd7990ff17745a$export$5d6e20892d59dd4f(fb)($f93520de2fa37b44$export$2e586eaa876dd2fd(go)({
                b: fb,
                current: $a7cd7990ff17745a$export$c01875f616615628(n),
                "final": $78c799cba34fcb8d$export$c1bed610ade55e1c.value
            }));
        };
    };
};
var $d2553f9ef1953d90$export$2d6d5959394f9e71 = function(f) {
    return function(n) {
        return $a7cd7990ff17745a$export$5d6e20892d59dd4f(f($a7cd7990ff17745a$export$5fd5031fecdacec3(n)))($a7cd7990ff17745a$export$c01875f616615628(n));
    };
};
var $d2553f9ef1953d90$export$24f4fa641021c348 = $a7cd7990ff17745a$export$5d6e20892d59dd4f;
var $d2553f9ef1953d90$export$b229b22f8a719f0d = function(level) {
    return function(t) {
        var treeRoot = $d2553f9ef1953d90$var$power("       ")(level) + ("|----> " + ($a7cd7990ff17745a$export$5fd5031fecdacec3(t) + "\x0a"));
        var treeChildren = $d2553f9ef1953d90$export$30d03df086be0d7c(level + 1 | 0)($a7cd7990ff17745a$export$c01875f616615628(t));
        return treeRoot + treeChildren;
    };
};
var $d2553f9ef1953d90$export$30d03df086be0d7c = function(level) {
    return function(forest) {
        var goForest = function(v) {
            if (v.current instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return new $f93520de2fa37b44$export$7fe28cb29e71bf10(v.drawn);
            if (v.current instanceof $78c799cba34fcb8d$export$74c44e616647f5c0) {
                var drawnTree = $d2553f9ef1953d90$export$b229b22f8a719f0d(v.level)(v.current.value0);
                return new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                    level: v.level,
                    drawn: v.drawn + drawnTree,
                    current: v.current.value1
                });
            }
            throw new Error("Failed pattern match at Data.Tree (line 45, column 3 - line 47, column 79): " + [
                v.constructor.name
            ]);
        };
        return $f93520de2fa37b44$export$2e586eaa876dd2fd(goForest)({
            level: level,
            drawn: "",
            current: forest
        });
    };
};
var $d2553f9ef1953d90$export$f0c40d09987b8e64 = /* #__PURE__ */ $d2553f9ef1953d90$export$b229b22f8a719f0d(0);
var $d2553f9ef1953d90$export$b072eafdc1d506c3 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(tree) {
        return $d2553f9ef1953d90$export$f0c40d09987b8e64($d2553f9ef1953d90$var$map(show)(tree));
    };
};
var $d2553f9ef1953d90$export$73f3cd2147e014dc = /* #__PURE__ */ $d2553f9ef1953d90$export$30d03df086be0d7c(0);
var $d2553f9ef1953d90$export$4a009c6a4574a8a5 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(forest) {
        return $d2553f9ef1953d90$export$73f3cd2147e014dc($d2553f9ef1953d90$var$map1(function(tree) {
            return $d2553f9ef1953d90$var$map(show)(tree);
        })(forest));
    };
};
var $d2553f9ef1953d90$export$1b8e57c9ea42f1d2 = function(c) {
    return function(n) {
        return $a7cd7990ff17745a$export$5d6e20892d59dd4f($a7cd7990ff17745a$export$5fd5031fecdacec3(n))($3d4fd987da5242ff$export$c40cf5aab899f397($a7cd7990ff17745a$export$c01875f616615628(n))(c));
    };
};













// Generated by purs version 0.15.16
















// Generated by purs version 0.15.16

// Generated by purs version 0.15.16









// Generated by purs version 0.15.16



// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
var $704a14067558099e$export$745d998ba62b3184 = /* #__PURE__ */ function() {
    function Exchange(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Exchange.create = function(value0) {
        return function(value1) {
            return new Exchange(value0, value1);
        };
    };
    return Exchange;
}();
var $704a14067558099e$export$3ce281628d36b8a1 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $704a14067558099e$export$745d998ba62b3184(function($12) {
                    return v.value0(f($12));
                }, function($13) {
                    return g(v.value1($13));
                });
            };
        };
    }
};
var $704a14067558099e$export$e5090b67a0fa69cf = {
    map: function(f) {
        return function(v) {
            return new $704a14067558099e$export$745d998ba62b3184(v.value0, function($14) {
                return f(v.value1($14));
            });
        };
    }
};


// Generated by purs version 0.15.16






var $64b04bb6c92110b4$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $64b04bb6c92110b4$export$7999ed7bf07e0908 = function(x) {
    return x;
};
var $64b04bb6c92110b4$export$a6b352dfd8349508 = function(dictSemigroup) {
    return $d7bf9817a417d4ae$export$49c9dc4575956c55(dictSemigroup);
};
var $64b04bb6c92110b4$export$4abec2a7e626a96e = {
    dimap: function(f) {
        return function(v) {
            return function(v1) {
                return function($36) {
                    return v1(f($36));
                };
            };
        };
    }
};
var $64b04bb6c92110b4$export$babcd87d8ce55e9e = {
    first: function(v) {
        return function($37) {
            return v($71f2e2e9476163f8$export$9e770fa6ce19a9d6($37));
        };
    },
    second: function(v) {
        return function($38) {
            return v($71f2e2e9476163f8$export$6f71268a1666ab58($38));
        };
    },
    Profunctor0: function() {
        return $64b04bb6c92110b4$export$4abec2a7e626a96e;
    }
};
var $64b04bb6c92110b4$export$d143b437db5aa20 = {
    Coercible0: function() {
        return undefined;
    }
};
var $64b04bb6c92110b4$export$37677d741fe484a1 = function(dictMonoid) {
    return $784e1bd3d26d71da$export$192e81b9fe7e4abe(dictMonoid);
};
var $64b04bb6c92110b4$export$85ce6f625a0d3bb3 = {
    unleft: function(v) {
        return function($39) {
            return v($7d4cccdf062a2261$export$37c4d04eafdc5515.create($39));
        };
    },
    unright: function(v) {
        return function($40) {
            return v($7d4cccdf062a2261$export$19db0165690c701a.create($40));
        };
    },
    Profunctor0: function() {
        return $64b04bb6c92110b4$export$4abec2a7e626a96e;
    }
};
var $64b04bb6c92110b4$export$b41051971cb8cf21 = function(dictMonoid) {
    var mempty = $784e1bd3d26d71da$export$9a7d64bc1d75357($784e1bd3d26d71da$export$192e81b9fe7e4abe(dictMonoid));
    return {
        left: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(v)(mempty);
        },
        right: function(v) {
            return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(mempty)(v);
        },
        Profunctor0: function() {
            return $64b04bb6c92110b4$export$4abec2a7e626a96e;
        }
    };
};
var $64b04bb6c92110b4$export$b8012e26804f1c03 = function(dictMonoid) {
    var applicativeConst = $10ae0394c8c3139a$export$38647a91a5af2717(dictMonoid);
    var choiceForget1 = $64b04bb6c92110b4$export$b41051971cb8cf21(dictMonoid);
    return {
        wander: function(f) {
            return function(v) {
                return $64b04bb6c92110b4$var$alaF($10ae0394c8c3139a$export$8ad5d15375e29446)(f(applicativeConst))(v);
            };
        },
        Strong0: function() {
            return $64b04bb6c92110b4$export$babcd87d8ce55e9e;
        },
        Choice1: function() {
            return choiceForget1;
        }
    };
};


// Generated by purs version 0.15.16
var $954c5a7609942688$export$494c25d006806a39 = function(x) {
    return x;
};
var $954c5a7609942688$export$87627d8471c3113f = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return function(d) {
                    return g(v(function(k) {
                        return d(function($7) {
                            return k(f($7));
                        });
                    }));
                };
            };
        };
    }
};
var $954c5a7609942688$export$bda6fbf5eb25f0fc = {
    Coercible0: function() {
        return undefined;
    }
};
var $954c5a7609942688$export$62ed8e5ffb5b363d = {
    closed: function(v) {
        return function(f) {
            return function(x) {
                return v(function(k) {
                    return f(function(g) {
                        return k(g(x));
                    });
                });
            };
        };
    },
    Profunctor0: function() {
        return $954c5a7609942688$export$87627d8471c3113f;
    }
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16


// Generated by purs version 0.15.16





var $00137f617725882c$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $00137f617725882c$export$79ffe56a765070d2 = function(dict) {
    return dict.right;
};
var $00137f617725882c$export$eabcd2c8791e7bf4 = function(dict) {
    return dict.left;
};
var $00137f617725882c$export$325b6c2fcdddb4a0 = function(dictSemigroupoid) {
    var composeFlipped = $5807467a73465f3c$export$b5a9558a7176e41b(dictSemigroupoid);
    return function(dictChoice) {
        var left1 = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
        var right1 = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
        return function(l) {
            return function(r) {
                return composeFlipped(left1(l))(right1(r));
            };
        };
    };
};
var $00137f617725882c$export$7de307094d63789d = function(dictSemigroupoid) {
    var splitChoice1 = $00137f617725882c$export$325b6c2fcdddb4a0(dictSemigroupoid);
    return function(dictChoice) {
        var rmap = $9be1c75e3223ee2e$export$6630987c9d273301(dictChoice.Profunctor0());
        var splitChoice2 = splitChoice1(dictChoice);
        return function(l) {
            return function(r) {
                return rmap($7d4cccdf062a2261$export$5f5be1bb6cd1fded($00137f617725882c$var$identity)($00137f617725882c$var$identity))(splitChoice2(l)(r));
            };
        };
    };
};
var $00137f617725882c$export$fc24090daa54e09a = {
    left: function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
            throw new Error("Failed pattern match at Data.Profunctor.Choice (line 32, column 1 - line 35, column 16): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    },
    right: /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601),
    Profunctor0: function() {
        return $9be1c75e3223ee2e$export$e10497e40cde5fd3;
    }
};



// Generated by purs version 0.15.16




var $65bbf210574f301e$export$311dde6ade8133c7 = {
    first: function(a2b) {
        return function(v) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(a2b(v.value0), v.value1);
        };
    },
    second: /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0),
    Profunctor0: function() {
        return $9be1c75e3223ee2e$export$e10497e40cde5fd3;
    }
};
var $65bbf210574f301e$export$3d3c77ce7df7d30d = function(dict) {
    return dict.second;
};
var $65bbf210574f301e$export$43128fadae87b74a = function(dict) {
    return dict.first;
};
var $65bbf210574f301e$export$a66b5a8932fce7e1 = function(dictSemigroupoid) {
    var composeFlipped = $5807467a73465f3c$export$b5a9558a7176e41b(dictSemigroupoid);
    return function(dictStrong) {
        var first1 = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
        var second1 = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
        return function(l) {
            return function(r) {
                return composeFlipped(first1(l))(second1(r));
            };
        };
    };
};
var $65bbf210574f301e$export$296bafc6ffe8d435 = function(dictSemigroupoid) {
    var splitStrong1 = $65bbf210574f301e$export$a66b5a8932fce7e1(dictSemigroupoid);
    return function(dictStrong) {
        var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(dictStrong.Profunctor0());
        var splitStrong2 = splitStrong1(dictStrong);
        return function(l) {
            return function(r) {
                return lcmap(function(a) {
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(a, a);
                })(splitStrong2(l)(r));
            };
        };
    };
};


var $48c79e0fab366ce5$var$alaF = /* #__PURE__ */ $4fa4836228a192cc$export$b533eaec53aab18a()()()();
var $48c79e0fab366ce5$export$da26cf42b4a20975 = function(dictApplicative) {
    var strongStar = $6f71832c0f0d3a5b$export$1bd208d997e69566(dictApplicative.Apply0().Functor0());
    var choiceStar = $6f71832c0f0d3a5b$export$9b633f3f90080760(dictApplicative);
    return {
        wander: function(t) {
            return function(v) {
                return t(dictApplicative)(v);
            };
        },
        Strong0: function() {
            return strongStar;
        },
        Choice1: function() {
            return choiceStar;
        }
    };
};
var $48c79e0fab366ce5$export$3576324867460c38 = {
    wander: function(t) {
        return $48c79e0fab366ce5$var$alaF($50c50d1f444e5fa4$export$544bf02140fa9a77)(t($50c50d1f444e5fa4$export$fd3b2458e55fc503));
    },
    Strong0: function() {
        return $65bbf210574f301e$export$311dde6ade8133c7;
    },
    Choice1: function() {
        return $00137f617725882c$export$fc24090daa54e09a;
    }
};
var $48c79e0fab366ce5$export$cfc1ea1528b06875 = function(dict) {
    return dict.wander;
};






var $6390cf100bf9f6d9$var$second = /* #__PURE__ */ $65bbf210574f301e$export$3d3c77ce7df7d30d($65bbf210574f301e$export$311dde6ade8133c7);
var $6390cf100bf9f6d9$export$8ef99100a3c56f8c = function(x) {
    return x;
};
var $6390cf100bf9f6d9$export$8681e402e0126fd = function(dictProfunctor) {
    var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    return dimap($6390cf100bf9f6d9$var$second(f))(g)(v);
                };
            };
        }
    };
};
var $6390cf100bf9f6d9$export$5e8bf7b4ad0c1b2d = function(dictStrong) {
    var Profunctor0 = dictStrong.Profunctor0();
    var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(Profunctor0);
    var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
    var second1 = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
    var profunctorIndexed1 = $6390cf100bf9f6d9$export$8681e402e0126fd(Profunctor0);
    return {
        first: function(v) {
            return lcmap(function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1.value0), v1.value1.value1);
            })(first(v));
        },
        second: function(v) {
            return lcmap(function(v1) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value1.value0, new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1.value1));
            })(second1(v));
        },
        Profunctor0: function() {
            return profunctorIndexed1;
        }
    };
};
var $6390cf100bf9f6d9$export$84206951dae378d4 = {
    Coercible0: function() {
        return undefined;
    }
};
var $6390cf100bf9f6d9$export$b117f91de9fdbe82 = function(dictChoice) {
    var Profunctor0 = dictChoice.Profunctor0();
    var lcmap = $9be1c75e3223ee2e$export$48f54268254cf7d0(Profunctor0);
    var left = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
    var right = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
    var profunctorIndexed1 = $6390cf100bf9f6d9$export$8681e402e0126fd(Profunctor0);
    return {
        left: function(v) {
            return lcmap(function(v1) {
                return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                    var $63 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                    return function($64) {
                        return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($63($64));
                    };
                }())($7d4cccdf062a2261$export$19db0165690c701a.create)(v1.value1);
            })(left(v));
        },
        right: function(v) {
            return lcmap(function(v1) {
                return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function() {
                    var $65 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                    return function($66) {
                        return $7d4cccdf062a2261$export$19db0165690c701a.create($65($66));
                    };
                }())(v1.value1);
            })(right(v));
        },
        Profunctor0: function() {
            return profunctorIndexed1;
        }
    };
};
var $6390cf100bf9f6d9$export$b6c86e7b404c18c9 = function(dictWander) {
    var wander = $48c79e0fab366ce5$export$cfc1ea1528b06875(dictWander);
    var strongIndexed1 = $6390cf100bf9f6d9$export$5e8bf7b4ad0c1b2d(dictWander.Strong0());
    var choiceIndexed1 = $6390cf100bf9f6d9$export$b117f91de9fdbe82(dictWander.Choice1());
    return {
        wander: function(trav) {
            return function(v) {
                return wander(function(dictApplicative) {
                    var trav2 = trav(dictApplicative);
                    return function(ia2fb) {
                        return function(v1) {
                            return trav2(function() {
                                var $67 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0);
                                return function($68) {
                                    return ia2fb($67($68));
                                };
                            }())(v1.value1);
                        };
                    };
                })(v);
            };
        },
        Strong0: function() {
            return strongIndexed1;
        },
        Choice1: function() {
            return choiceIndexed1;
        }
    };
};


// Generated by purs version 0.15.16


var $f9bc92cc92266955$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $f9bc92cc92266955$export$3db8c5834c5aa726 = /* #__PURE__ */ function() {
    function Market(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Market.create = function(value0) {
        return function(value1) {
            return new Market(value0, value1);
        };
    };
    return Market;
}();
var $f9bc92cc92266955$export$8693aba30958a33d = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($21) {
                    return g(v.value0($21));
                }, function() {
                    var $22 = $f9bc92cc92266955$var$lmap(g);
                    return function($23) {
                        return $22(v.value1(f($23)));
                    };
                }());
            };
        };
    }
};
var $f9bc92cc92266955$export$cd2871f7f716f5c4 = {
    map: function(f) {
        return function(v) {
            return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($24) {
                return f(v.value0($24));
            }, function() {
                var $25 = $f9bc92cc92266955$var$lmap(f);
                return function($26) {
                    return $25(v.value1($26));
                };
            }());
        };
    }
};
var $f9bc92cc92266955$export$eaf0e5cd44be9d3c = {
    left: function(v) {
        return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($27) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(v.value0($27));
        }, $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
            var $28 = $f9bc92cc92266955$var$lmap($7d4cccdf062a2261$export$37c4d04eafdc5515.create);
            return function($29) {
                return $28(v.value1($29));
            };
        }())(function($30) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($7d4cccdf062a2261$export$19db0165690c701a.create($30));
        }));
    },
    right: function(v) {
        return new $f9bc92cc92266955$export$3db8c5834c5aa726(function($31) {
            return $7d4cccdf062a2261$export$19db0165690c701a.create(v.value0($31));
        }, $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($32) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create($7d4cccdf062a2261$export$37c4d04eafdc5515.create($32));
        })(function() {
            var $33 = $f9bc92cc92266955$var$lmap($7d4cccdf062a2261$export$19db0165690c701a.create);
            return function($34) {
                return $33(v.value1($34));
            };
        }()));
    },
    Profunctor0: function() {
        return $f9bc92cc92266955$export$8693aba30958a33d;
    }
};


// Generated by purs version 0.15.16


// Generated by purs version 0.15.16
var $6312e0f0493654fc$export$32c5facbb64cac7f = function(dict) {
    return dict.unright;
};
var $6312e0f0493654fc$export$b5d72aec2da3ea19 = function(dict) {
    return dict.unleft;
};


// Generated by purs version 0.15.16
var $cada8a38adf1edb6$export$820fe413f6cf1de5 = function(dict) {
    return dict.unsecond;
};
var $cada8a38adf1edb6$export$a329cdab990c51ff = function(dict) {
    return dict.unfirst;
};



var $a7b9ed7c15cf8966$export$2f2cbc902dde0906 = function(x) {
    return x;
};
var $a7b9ed7c15cf8966$export$723210aeb8c6f0f6 = function(dictProfunctor) {
    var dimap = $9be1c75e3223ee2e$export$7c344215185fc3ac(dictProfunctor);
    return {
        dimap: function(f) {
            return function(g) {
                return function(v) {
                    var $43 = dimap(g)(f);
                    return function($44) {
                        return v($43($44));
                    };
                };
            };
        }
    };
};
var $a7b9ed7c15cf8966$export$1a1045dfc0970e6f = function(dictStrong) {
    var first = $65bbf210574f301e$export$43128fadae87b74a(dictStrong);
    var second = $65bbf210574f301e$export$3d3c77ce7df7d30d(dictStrong);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictStrong.Profunctor0());
    return {
        unfirst: function(v) {
            return function($45) {
                return v(first($45));
            };
        },
        unsecond: function(v) {
            return function($46) {
                return v(second($46));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$ae005232e0e57b3 = {
    Coercible0: function() {
        return undefined;
    }
};
var $a7b9ed7c15cf8966$export$d7de09889a8b31b2 = function(dictCostrong) {
    var unfirst = $cada8a38adf1edb6$export$a329cdab990c51ff(dictCostrong);
    var unsecond = $cada8a38adf1edb6$export$820fe413f6cf1de5(dictCostrong);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictCostrong.Profunctor0());
    return {
        first: function(v) {
            return function($47) {
                return v(unfirst($47));
            };
        },
        second: function(v) {
            return function($48) {
                return v(unsecond($48));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$5705537200f3530 = function(dictCochoice) {
    var unleft = $6312e0f0493654fc$export$b5d72aec2da3ea19(dictCochoice);
    var unright = $6312e0f0493654fc$export$32c5facbb64cac7f(dictCochoice);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictCochoice.Profunctor0());
    return {
        left: function(v) {
            return function($49) {
                return v(unleft($49));
            };
        },
        right: function(v) {
            return function($50) {
                return v(unright($50));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};
var $a7b9ed7c15cf8966$export$ce74e260a720e457 = function(dictChoice) {
    var left = $00137f617725882c$export$eabcd2c8791e7bf4(dictChoice);
    var right = $00137f617725882c$export$79ffe56a765070d2(dictChoice);
    var profunctorRe1 = $a7b9ed7c15cf8966$export$723210aeb8c6f0f6(dictChoice.Profunctor0());
    return {
        unleft: function(v) {
            return function($51) {
                return v(left($51));
            };
        },
        unright: function(v) {
            return function($52) {
                return v(right($52));
            };
        },
        Profunctor0: function() {
            return profunctorRe1;
        }
    };
};


// Generated by purs version 0.15.16

var $4412cb41f741288f$export$aa82d568fb2f38da = /* #__PURE__ */ function() {
    function Shop(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Shop.create = function(value0) {
        return function(value1) {
            return new Shop(value0, value1);
        };
    };
    return Shop;
}();
var $4412cb41f741288f$export$fec4dc80195438b9 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $4412cb41f741288f$export$aa82d568fb2f38da(function($31) {
                    return v.value0(f($31));
                }, function(s) {
                    var $32 = v.value1(f(s));
                    return function($33) {
                        return g($32($33));
                    };
                });
            };
        };
    }
};
var $4412cb41f741288f$export$a705c9672fb9f75 = {
    first: function(v) {
        return new $4412cb41f741288f$export$aa82d568fb2f38da(function(v1) {
            return v.value0(v1.value0);
        }, function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value1(v1.value0)(b), v1.value1);
            };
        });
    },
    second: function(v) {
        return new $4412cb41f741288f$export$aa82d568fb2f38da(function(v1) {
            return v.value0(v1.value1);
        }, function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value1(v1.value1)(b));
            };
        });
    },
    Profunctor0: function() {
        return $4412cb41f741288f$export$fec4dc80195438b9;
    }
};


// Generated by purs version 0.15.16




var $dea9e9a4897f9486$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $dea9e9a4897f9486$var$lmap = /* #__PURE__ */ $20615e99b278adf5$export$2ad466be2e2b0196($20615e99b278adf5$export$9b66d4861c364eff);
var $dea9e9a4897f9486$export$a4c5071042bb3941 = /* #__PURE__ */ function() {
    function Stall(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Stall.create = function(value0) {
        return function(value1) {
            return new Stall(value0, value1);
        };
    };
    return Stall;
}();
var $dea9e9a4897f9486$export$cc7fb5dffce8cf27 = {
    dimap: function(f) {
        return function(g) {
            return function(v) {
                return new $dea9e9a4897f9486$export$a4c5071042bb3941(function() {
                    var $64 = $dea9e9a4897f9486$var$map(g);
                    return function($65) {
                        return $64(v.value0(f($65)));
                    };
                }(), function() {
                    var $66 = $dea9e9a4897f9486$var$lmap(g);
                    return function($67) {
                        return $66(v.value1(f($67)));
                    };
                }());
            };
        };
    }
};
var $dea9e9a4897f9486$export$b5b4ef4e571e6800 = {
    first: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0(v1.value0)(b), v1.value1);
            };
        }, function(v1) {
            return $dea9e9a4897f9486$var$lmap(function(t) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(t, v1.value1);
            })(v.value1(v1.value0));
        });
    },
    second: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            return function(b) {
                return new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v.value0(v1.value1)(b));
            };
        }, function(v1) {
            return $dea9e9a4897f9486$var$lmap($71f2e2e9476163f8$export$1908877435b1d5e9.create(v1.value0))(v.value1(v1.value1));
        });
    },
    Profunctor0: function() {
        return $dea9e9a4897f9486$export$cc7fb5dffce8cf27;
    }
};
var $dea9e9a4897f9486$export$86efaf93cc453e83 = {
    map: function(f) {
        return function(v) {
            return new $dea9e9a4897f9486$export$a4c5071042bb3941(function() {
                var $68 = $dea9e9a4897f9486$var$map(f);
                return function($69) {
                    return $68(v.value0($69));
                };
            }(), function() {
                var $70 = $dea9e9a4897f9486$var$lmap(f);
                return function($71) {
                    return $70(v.value1($71));
                };
            }());
        };
    }
};
var $dea9e9a4897f9486$export$3216926ea4acbfa6 = {
    left: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return function(b) {
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0(v1.value0)(b));
            };
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return function(v2) {
                return new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0);
            };
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 36, column 9 - line 38, column 35): " + [
                v1.constructor.name
            ]);
        }, function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $dea9e9a4897f9486$var$lmap($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(v.value1(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0));
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 40, column 9 - line 42, column 36): " + [
                v1.constructor.name
            ]);
        });
    },
    right: function(v) {
        return new $dea9e9a4897f9486$export$a4c5071042bb3941(function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return function(v2) {
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
            };
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return function(b) {
                return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0(v1.value0)(b));
            };
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 47, column 9 - line 49, column 41): " + [
                v1.constructor.name
            ]);
        }, function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $dea9e9a4897f9486$var$lmap($7d4cccdf062a2261$export$19db0165690c701a.create)(v.value1(v1.value0));
            throw new Error("Failed pattern match at Data.Lens.Internal.Stall (line 51, column 9 - line 53, column 38): " + [
                v1.constructor.name
            ]);
        });
    },
    Profunctor0: function() {
        return $dea9e9a4897f9486$export$cc7fb5dffce8cf27;
    }
};


// Generated by purs version 0.15.16





var $333e6139bd8d8d5d$export$b40ff0778ec92ebb = function(x) {
    return x;
};
var $333e6139bd8d8d5d$export$6b99682488d6b082 = {
    dimap: function(v) {
        return function(g) {
            return function(v1) {
                return g(v1);
            };
        };
    }
};
var $333e6139bd8d8d5d$export$a20b385d3e05c24e = {
    unfirst: function(v) {
        return v.value0;
    },
    unsecond: function(v) {
        return v.value1;
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$486a67f830a39b92 = {
    closed: function(v) {
        return $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(v);
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$5fa6ad029e8dcb6e = {
    left: function(v) {
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v);
    },
    right: function(v) {
        return new $7d4cccdf062a2261$export$19db0165690c701a(v);
    },
    Profunctor0: function() {
        return $333e6139bd8d8d5d$export$6b99682488d6b082;
    }
};
var $333e6139bd8d8d5d$export$8e57909c79fa72ff = {
    Coercible0: function() {
        return undefined;
    }
};
var $333e6139bd8d8d5d$export$9f02894590a2f0f7 = {
    map: function(f) {
        return function(m) {
            return f(m);
        };
    }
};
var $333e6139bd8d8d5d$export$419b07851c0b3688 = {
    foldMap: function(dictMonoid) {
        return function(f) {
            return function(v) {
                return f(v);
            };
        };
    },
    foldr: function(f) {
        return function(b) {
            return function(v) {
                return f(v)(b);
            };
        };
    },
    foldl: function(f) {
        return function(b) {
            return function(v) {
                return f(b)(v);
            };
        };
    }
};
var $333e6139bd8d8d5d$export$2defb87457b7d824 = {
    sequence: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(v) {
            return map($333e6139bd8d8d5d$export$b40ff0778ec92ebb)(v);
        };
    },
    traverse: function(dictApplicative) {
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return function(v) {
                return map($333e6139bd8d8d5d$export$b40ff0778ec92ebb)(f(v));
            };
        };
    },
    Functor0: function() {
        return $333e6139bd8d8d5d$export$9f02894590a2f0f7;
    },
    Foldable1: function() {
        return $333e6139bd8d8d5d$export$419b07851c0b3688;
    }
};
var $333e6139bd8d8d5d$export$ecae7ebd109c6538 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(x) {
            return function(y) {
                return eq(x)(y);
            };
        }
    };
};
var $333e6139bd8d8d5d$export$ce07ee061b9e8cbc = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a(dictOrd);
    var eqTagged1 = $333e6139bd8d8d5d$export$ecae7ebd109c6538(dictOrd.Eq0());
    return {
        compare: function(x) {
            return function(y) {
                return compare(x)(y);
            };
        },
        Eq0: function() {
            return eqTagged1;
        }
    };
};
var $333e6139bd8d8d5d$export$cadadebf8f4168cc = {
    eq1: function(dictEq) {
        return $37b880af5f4991bd$export$9663ddc1cf085b32($333e6139bd8d8d5d$export$ecae7ebd109c6538(dictEq));
    }
};
var $333e6139bd8d8d5d$export$185a5532b1c5359b = {
    compare1: function(dictOrd) {
        return $97937c29f879e68e$export$398604a469f7de9a($333e6139bd8d8d5d$export$ce07ee061b9e8cbc(dictOrd));
    },
    Eq10: function() {
        return $333e6139bd8d8d5d$export$cadadebf8f4168cc;
    }
};







var $027ac699fc79e3e6$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $027ac699fc79e3e6$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $027ac699fc79e3e6$var$fanout = /* #__PURE__ */ $65bbf210574f301e$export$296bafc6ffe8d435($5807467a73465f3c$export$3af17640bddf7212)($65bbf210574f301e$export$311dde6ade8133c7);
var $027ac699fc79e3e6$export$c4ddc81c7b2c8d7a = function(l) {
    return $027ac699fc79e3e6$var$unwrap(l($027ac699fc79e3e6$var$identity));
};
var $027ac699fc79e3e6$export$fd3120800da8c9da = function(s) {
    return function(l) {
        return $027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(l)(s);
    };
};
var $027ac699fc79e3e6$export$1f96ae73734a86cc = function(dictMonadState) {
    var gets = $f2d5035ce6148af6$export$49487f6cbb79019d(dictMonadState);
    return function(p) {
        return gets(function(v) {
            return $027ac699fc79e3e6$export$fd3120800da8c9da(v)(p);
        });
    };
};
var $027ac699fc79e3e6$export$2c618a4308a30424 = function(f) {
    return function(p) {
        var $10 = $027ac699fc79e3e6$var$unwrap(p);
        return function($11) {
            return $10(f($11));
        };
    };
};
var $027ac699fc79e3e6$export$76f313e1e2198b73 = function(l) {
    return function(r) {
        return $027ac699fc79e3e6$export$2c618a4308a30424($027ac699fc79e3e6$var$fanout($027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(l))($027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(r)));
    };
};
var $027ac699fc79e3e6$export$3fb48d5d9495fdc4 = function(l) {
    return $027ac699fc79e3e6$var$unwrap(l($027ac699fc79e3e6$var$identity));
};
var $027ac699fc79e3e6$export$2b3b499266fb4c16 = function(dictMonadState) {
    var gets = $f2d5035ce6148af6$export$49487f6cbb79019d(dictMonadState);
    return function(p) {
        return gets($027ac699fc79e3e6$export$3fb48d5d9495fdc4(p));
    };
};
var $027ac699fc79e3e6$export$5dede87c5b7e4f7d = function(g) {
    return $027ac699fc79e3e6$export$2c618a4308a30424($027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(g));
};



// Generated by purs version 0.15.16











var $5b0358e10bf152e0$export$fb4902fd9e525693 = function(l) {
    return l;
};
var $5b0358e10bf152e0$export$adaa4cf7ef1b65be = function(l) {
    return function(b) {
        return $5b0358e10bf152e0$export$fb4902fd9e525693(l)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(b));
    };
};
var $5b0358e10bf152e0$export$bd1981977ac950af = function(p) {
    var $59 = $5b0358e10bf152e0$export$adaa4cf7ef1b65be(p);
    return function($60) {
        return $59($06733ae99ed4f534$export$8a67b48435b5d073.create($60));
    };
};
var $5b0358e10bf152e0$export$4591dae0bb89b7fa = function(dictRing) {
    var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
    return function(p) {
        var $61 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $62 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(sub);
        return function($63) {
            return $61($62($63));
        };
    };
};
var $5b0358e10bf152e0$export$59c558d9dc09baf0 = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return function(p) {
        var $64 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $65 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(mul);
        return function($66) {
            return $64($65($66));
        };
    };
};
var $5b0358e10bf152e0$export$86b6baac93ff82e3 = function(dictMonadState) {
    var $$void = $f4b2eb11fc32ed34$export$490e536ee7389aeb(dictMonadState.Monad0().Bind1().Apply0().Functor0());
    var modify = $f2d5035ce6148af6$export$3ff57735a52b8713(dictMonadState);
    return function(p) {
        return function(f) {
            return $$void(modify($5b0358e10bf152e0$export$fb4902fd9e525693(p)(f)));
        };
    };
};
var $5b0358e10bf152e0$export$bdf21a3648c59b5b = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemiring) {
        var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
        return function(p) {
            var $67 = modifying1(p);
            var $68 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(mul);
            return function($69) {
                return $67($68($69));
            };
        };
    };
};
var $5b0358e10bf152e0$export$af7e4897080700dd = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictRing) {
        var sub = $d061555d3b2c84b2$export$f93b5905241a7cca(dictRing);
        return function(p) {
            var $70 = modifying1(p);
            var $71 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(sub);
            return function($72) {
                return $70($71($72));
            };
        };
    };
};
var $5b0358e10bf152e0$export$7deb1a7d85cbf52a = function(l) {
    return function(f) {
        return l($71f2e2e9476163f8$export$7864d59d01b6d6bf(f));
    };
};
var $5b0358e10bf152e0$export$6ce2128036d9209a = function(dictEuclideanRing) {
    var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
    return function(p) {
        var $73 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $74 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(div);
        return function($75) {
            return $73($74($75));
        };
    };
};
var $5b0358e10bf152e0$export$5cf5a3773c82cb31 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictEuclideanRing) {
        var div = $b0cd729514c2504e$export$159d9494db57879b(dictEuclideanRing);
        return function(p) {
            var $76 = modifying1(p);
            var $77 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(div);
            return function($78) {
                return $76($77($78));
            };
        };
    };
};
var $5b0358e10bf152e0$export$970f645509ec836c = function(dictHeytingAlgebra) {
    var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
    return function(p) {
        var $79 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $80 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(disj);
        return function($81) {
            return $79($80($81));
        };
    };
};
var $5b0358e10bf152e0$export$f9fe8cf3da8b72b8 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictHeytingAlgebra) {
        var disj = $f8fc227945eb179e$export$9bd7ee00e37438db(dictHeytingAlgebra);
        return function(p) {
            var $82 = modifying1(p);
            var $83 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(disj);
            return function($84) {
                return $82($83($84));
            };
        };
    };
};
var $5b0358e10bf152e0$export$7c4dc0be2ad2572f = function(dictHeytingAlgebra) {
    var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
    return function(p) {
        var $85 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $86 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(conj);
        return function($87) {
            return $85($86($87));
        };
    };
};
var $5b0358e10bf152e0$export$1041c8de5afeb06e = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictHeytingAlgebra) {
        var conj = $f8fc227945eb179e$export$fb254c661fe9c0db(dictHeytingAlgebra);
        return function(p) {
            var $88 = modifying1(p);
            var $89 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(conj);
            return function($90) {
                return $88($89($90));
            };
        };
    };
};
var $5b0358e10bf152e0$export$e6e34fd1f2686227 = function(dictMonadState) {
    var $$void = $f4b2eb11fc32ed34$export$490e536ee7389aeb(dictMonadState.Monad0().Bind1().Apply0().Functor0());
    var modify = $f2d5035ce6148af6$export$3ff57735a52b8713(dictMonadState);
    return function(p) {
        return function(b) {
            return $$void(modify($5b0358e10bf152e0$export$adaa4cf7ef1b65be(p)(b)));
        };
    };
};
var $5b0358e10bf152e0$export$49b51df7f48fca22 = function(dictMonadState) {
    var assign1 = $5b0358e10bf152e0$export$e6e34fd1f2686227(dictMonadState);
    return function(p) {
        var $91 = assign1(p);
        return function($92) {
            return $91($06733ae99ed4f534$export$8a67b48435b5d073.create($92));
        };
    };
};
var $5b0358e10bf152e0$export$8a0bf61e09475492 = function(dictSemigroup) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
    return function(p) {
        var $93 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        var $94 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(append);
        return function($95) {
            return $93($94($95));
        };
    };
};
var $5b0358e10bf152e0$export$43d406ede97d8cbb = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return function(p) {
            var $96 = modifying1(p);
            var $97 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(append);
            return function($98) {
                return $96($97($98));
            };
        };
    };
};
var $5b0358e10bf152e0$export$328c930ee4a5b767 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return function(p) {
        var $99 = $5b0358e10bf152e0$export$fb4902fd9e525693(p);
        return function($100) {
            return $99(add($100));
        };
    };
};
var $5b0358e10bf152e0$export$c88597abc83b6ce1 = function(dictMonadState) {
    var modifying1 = $5b0358e10bf152e0$export$86b6baac93ff82e3(dictMonadState);
    return function(dictSemiring) {
        var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
        return function(p) {
            var $101 = modifying1(p);
            return function($102) {
                return $101(add($102));
            };
        };
    };
};









// Generated by purs version 0.15.16
function $ef57d2bf6d374935$export$2230c7466f27d38a(a) {
    return function(b) {
        return a === b;
    };
}



var $871d3d7bcf6be72e$export$4fd25d6ead33df13 = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$50f4602e25613a3e = function(x) {
    return x;
};
var $871d3d7bcf6be72e$export$54d9901699893a6 = $ef57d2bf6d374935$export$2230c7466f27d38a;
var $871d3d7bcf6be72e$export$139829c37543f0b8 = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return {
        eq: function(v) {
            return function(v1) {
                return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1) || eq(v)(v1);
            };
        }
    };
};
var $871d3d7bcf6be72e$export$32e537f465b3365f = {
    eq: function(v) {
        return function(v1) {
            return $871d3d7bcf6be72e$export$54d9901699893a6(v)(v1);
        };
    }
};


var $ed3a75a0cf477875$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $ed3a75a0cf477875$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $ed3a75a0cf477875$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $ed3a75a0cf477875$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $ed3a75a0cf477875$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $ed3a75a0cf477875$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $ed3a75a0cf477875$var$un = /* #__PURE__ */ $4fa4836228a192cc$export$a2a39c9747f0e54a();
var $ed3a75a0cf477875$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $ed3a75a0cf477875$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $ed3a75a0cf477875$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $ed3a75a0cf477875$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $ed3a75a0cf477875$var$discard2 = /* #__PURE__ */ $ed3a75a0cf477875$var$discard($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $ed3a75a0cf477875$export$bc511810eec6ea1d = function(x) {
    return x;
};
var $ed3a75a0cf477875$export$70b4599868a10553 = function(dictMonad) {
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(s) {
        return function(render) {
            return function(update) {
                var go = function(st) {
                    return bind2(render(st))(function() {
                        var $83 = $f57f4b701aa7b66e$export$8a83211c878a3f1f(update)(st);
                        return function($84) {
                            return go($83($84));
                        };
                    }());
                };
                return go(s);
            };
        };
    };
};
var $ed3a75a0cf477875$export$26a2160b96fe4c48 = function(dictMonad) {
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(p) {
        return function(w) {
            return function(a) {
                return bind2(w(a))(function(a$prime) {
                    var $76 = p(a$prime);
                    if ($76) return pure3(a$prime);
                    return $ed3a75a0cf477875$export$26a2160b96fe4c48(dictMonad)(p)(w)(a$prime);
                });
            };
        };
    };
};
var $ed3a75a0cf477875$export$f40fa5b3629284a = function(dictMonad) {
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(p) {
        return function(w) {
            return bind2(w)(function(a) {
                var $77 = p(a);
                if ($77) return pure3(a);
                return $ed3a75a0cf477875$export$f40fa5b3629284a(dictMonad)(p)(w);
            });
        };
    };
};
var $ed3a75a0cf477875$export$ac22f194518f21d1 = function(dictMonoid) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3($fe1781b0b9eaad64$export$4e1ce6d609307a39(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var bind2 = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
        var liftEffect1 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
        var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        return function(axn) {
            var $$yield = function(remoteCb) {
                return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
                    return function __do() {
                        $90327512d8280b8d$export$45b91115a89d6020(function(v) {
                            return $ed3a75a0cf477875$var$append(v)([
                                cb
                            ]);
                        })(remoteCb)();
                        return $90327512d8280b8d$export$45b91115a89d6020($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($871d3d7bcf6be72e$export$54d9901699893a6)(cb))(remoteCb);
                    };
                });
            };
            var render = function(remoteCb) {
                return $ed3a75a0cf477875$var$bind(axn)(function(val) {
                    return liftEffect($ed3a75a0cf477875$var$bind1($e521936ea118867a$export$aafa59e2e03f2942(remoteCb))($ed3a75a0cf477875$var$traverse_(function(cb) {
                        return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(val));
                    })));
                });
            };
            return bind2(liftEffect1($90327512d8280b8d$export$b8cb59497041ffe4([])))(function(remoteCb) {
                return pure3({
                    "yield": $$yield(remoteCb),
                    render: render(remoteCb)
                });
            });
        };
    };
};
var $ed3a75a0cf477875$export$a408be8480d6e66a = {
    Coercible0: function() {
        return undefined;
    }
};
var $ed3a75a0cf477875$export$e48cdaf7d8a32012 = function(w) {
    return $ed3a75a0cf477875$var$un($ed3a75a0cf477875$export$bc511810eec6ea1d)(w).receive;
};
var $ed3a75a0cf477875$export$89db4734f6c919c4 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictPlus) {
        return function(w) {
            return function($85) {
                return liftEffect($ed3a75a0cf477875$var$un($ed3a75a0cf477875$export$bc511810eec6ea1d)(w).send($85));
            };
        };
    };
};
var $ed3a75a0cf477875$export$c29fa35d97c6b95e = function(dictMonoid) {
    var alt = $75e93a4111e80214$export$228be17d80722ab($fe1781b0b9eaad64$export$7341a4054968fa7c(dictMonoid));
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3($fe1781b0b9eaad64$export$4e1ce6d609307a39(dictMonoid));
    return function(wire) {
        return function(f) {
            var go = function(a) {
                return $ed3a75a0cf477875$var$bind(alt($ed3a75a0cf477875$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(f(a)))($ed3a75a0cf477875$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)($ed3a75a0cf477875$export$e48cdaf7d8a32012(wire))))(function(res) {
                    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ed3a75a0cf477875$var$pure1)(go)(res);
                });
            };
            return $ed3a75a0cf477875$var$bind(liftEffect($ed3a75a0cf477875$var$un($ed3a75a0cf477875$export$bc511810eec6ea1d)(wire).value))(function(val) {
                return go(val);
            });
        };
    };
};
var $ed3a75a0cf477875$export$66f5fdc7b1ae0e1 = function(dictAlt) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictAlt.Functor0());
    return function(dictMonadEffect) {
        return function(dictPlus) {
            return function(lens) {
                var lens1 = lens($64b04bb6c92110b4$export$babcd87d8ce55e9e);
                var lens2 = lens($65bbf210574f301e$export$311dde6ade8133c7);
                return function(wire) {
                    var wirerec = $ed3a75a0cf477875$var$un($ed3a75a0cf477875$export$bc511810eec6ea1d)(wire);
                    return {
                        value: $ed3a75a0cf477875$var$map1($027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(lens1))(wirerec.value),
                        send: function(a) {
                            return $ed3a75a0cf477875$var$bind1(wirerec.value)(function() {
                                var $86 = $5b0358e10bf152e0$export$adaa4cf7ef1b65be(lens2)(a);
                                return function($87) {
                                    return wirerec.send($86($87));
                                };
                            }());
                        },
                        receive: map2($027ac699fc79e3e6$export$c4ddc81c7b2c8d7a(lens1))(wirerec.receive)
                    };
                };
            };
        };
    };
};
var $ed3a75a0cf477875$export$c7e78faad39c995c = function(dictMonad) {
    var bind2 = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return function(s) {
        return function(f) {
            return bind2(f(s))(function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $ed3a75a0cf477875$export$c7e78faad39c995c(dictMonad)(v.value0)(f);
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return pure3(v.value0);
                throw new Error("Failed pattern match at Concur.Core.Patterns (line 27, column 25 - line 29, column 20): " + [
                    v.constructor.name
                ]);
            });
        };
    };
};
var $ed3a75a0cf477875$export$3bf5078b16209b91 = function(dictMonoid) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3($fe1781b0b9eaad64$export$4e1ce6d609307a39(dictMonoid));
    return function(ainit) {
        return function(f) {
            return $ed3a75a0cf477875$var$bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4(ainit)))(function(currentVal) {
                return $ed3a75a0cf477875$var$bind(liftEffect($90327512d8280b8d$export$b8cb59497041ffe4($ed3a75a0cf477875$var$pure2(function(v) {
                    if (v instanceof $fe1781b0b9eaad64$export$d2a72f000c4be67b) return $e521936ea118867a$export$68d8715fc104d294(v.value0)(currentVal);
                    return $ed3a75a0cf477875$var$pure($05149ea687d6b460$export$523c0b569236b342);
                }))))(function(remoteCb) {
                    var wire = {
                        value: $e521936ea118867a$export$aafa59e2e03f2942(currentVal),
                        send: function(a) {
                            return $ed3a75a0cf477875$var$bind1($e521936ea118867a$export$aafa59e2e03f2942(remoteCb))($ed3a75a0cf477875$var$traverse_(function(cb) {
                                return cb(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(a));
                            }));
                        },
                        receive: $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
                            return function __do() {
                                $90327512d8280b8d$export$45b91115a89d6020(function(v) {
                                    return $ed3a75a0cf477875$var$append(v)([
                                        cb
                                    ]);
                                })(remoteCb)();
                                return $90327512d8280b8d$export$45b91115a89d6020($396c4c3d9e7fae3c$export$9ea2b6c3fae093d8($871d3d7bcf6be72e$export$54d9901699893a6)(cb))(remoteCb);
                            };
                        })
                    };
                    return f(wire);
                });
            });
        };
    };
};
var $ed3a75a0cf477875$export$4f03a9851291bdd = function(dictMonoid) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3($fe1781b0b9eaad64$export$4e1ce6d609307a39(dictMonoid));
    return function(dictMonadEffect) {
        var Monad0 = dictMonadEffect.Monad0();
        var bind2 = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
        var liftEffect1 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
        var pure3 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
        return function(axn) {
            return function(val) {
                var render = function(ref) {
                    var go = function(v) {
                        return $ed3a75a0cf477875$var$bind(axn(v))(function(v$prime) {
                            return $ed3a75a0cf477875$var$discard2(liftEffect($e521936ea118867a$export$68d8715fc104d294(v$prime)(ref)))(function() {
                                return go(v$prime);
                            });
                        });
                    };
                    return $ed3a75a0cf477875$var$bind(liftEffect($e521936ea118867a$export$aafa59e2e03f2942(ref)))(go);
                };
                return bind2(liftEffect1($90327512d8280b8d$export$b8cb59497041ffe4(val)))(function(ref) {
                    return pure3(render(ref));
                });
            };
        };
    };
};



// Generated by purs version 0.15.16








// Generated by purs version 0.15.16
const $93c729927fdf3160$export$bef1f36f5486a6a3 = function(s) {
    return function() {
        console.log(s);
    };
};
const $93c729927fdf3160$export$c106dd0671a0fc2d = function(s) {
    return function() {
        console.warn(s);
    };
};
const $93c729927fdf3160$export$a3bc9b8ed74fc = function(s) {
    return function() {
        console.error(s);
    };
};
const $93c729927fdf3160$export$a80b3bd66acc52ff = function(s) {
    return function() {
        console.info(s);
    };
};
const $93c729927fdf3160$export$1c9f709888824e05 = function(s) {
    return function() {
        console.debug(s);
    };
};
const $93c729927fdf3160$export$2da9be4cfdb689b1 = function(s) {
    return function() {
        console.time(s);
    };
};
const $93c729927fdf3160$export$1694f226a9241aae = function(s) {
    return function() {
        console.timeLog(s);
    };
};
const $93c729927fdf3160$export$8f2977fb54cb3601 = function(s) {
    return function() {
        console.timeEnd(s);
    };
};
const $93c729927fdf3160$export$42ffd38884aecdac = function() {
    console.clear();
};
const $93c729927fdf3160$export$e5e25fbcc1f7affe = function(s) {
    return function() {
        console.group(s);
    };
};
const $93c729927fdf3160$export$488ef8fb3416a29f = function(s) {
    return function() {
        console.groupCollapsed(s);
    };
};
const $93c729927fdf3160$export$a57f3dfe595273e6 = function() {
    console.groupEnd();
};



var $78386b654cef599e$export$28709abf85ddce1d = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$c106dd0671a0fc2d(show(a));
    };
};
var $78386b654cef599e$export$9f43f5977f8d5609 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$bef1f36f5486a6a3(show(a));
    };
};
var $78386b654cef599e$export$fc9467e2ad369291 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a80b3bd66acc52ff(show(a));
    };
};
var $78386b654cef599e$export$a188e271553f9211 = function(name) {
    return function(inner) {
        return function __do() {
            $93c729927fdf3160$export$e5e25fbcc1f7affe(name)();
            var result = inner();
            $93c729927fdf3160$export$a57f3dfe595273e6();
            return result;
        };
    };
};
var $78386b654cef599e$export$cbd229996ecd7704 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$a3bc9b8ed74fc(show(a));
    };
};
var $78386b654cef599e$export$18fab8ed91d044eb = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(a) {
        return $93c729927fdf3160$export$1c9f709888824e05(show(a));
    };
};




var $3257df7cdef77623$var$toElement = /* #__PURE__ */ $6500c29ba0ac3395$export$8d51e3db1a844094($6500c29ba0ac3395$export$1bf591d4b1bc94be);
var $3257df7cdef77623$var$monoidEffect = /* #__PURE__ */ $6c2f8951ecf9531e$export$2d8226ee4b2722f7($784e1bd3d26d71da$export$852b4040eee6c6ba);
var $3257df7cdef77623$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357(/* #__PURE__ */ $784e1bd3d26d71da$export$192e81b9fe7e4abe($3257df7cdef77623$var$monoidEffect));
var $3257df7cdef77623$var$component = /* #__PURE__ */ $6500c29ba0ac3395$export$d8556a2a8f973135();
var $3257df7cdef77623$var$applySecond = /* #__PURE__ */ $7576d3a958d66ab0$export$3d5d566a030a20fc($fe1781b0b9eaad64$export$d0bf720f69e19cbd);
var $3257df7cdef77623$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $3257df7cdef77623$var$mempty1 = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($3257df7cdef77623$var$monoidEffect);
var $3257df7cdef77623$var$createLeafElement = /* #__PURE__ */ $6500c29ba0ac3395$export$5a5fe77d944fbeed();
var $3257df7cdef77623$export$b3890eb0ae9dca99 = function(st) {
    return $3257df7cdef77623$var$toElement(st.view);
};
var $3257df7cdef77623$export$30d2feb505f9a613 = function(v) {
    return {
        view: v
    };
};
var $3257df7cdef77623$export$b97f2ad8d0b7442d = function(aff) {
    var handler = function(v) {
        return function(v1) {
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v(new $fe1781b0b9eaad64$export$d2a72f000c4be67b(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $93c729927fdf3160$export$bef1f36f5486a6a3("error calling aff");
            throw new Error("Failed pattern match at Concur.React (line 65, column 3 - line 65, column 42): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    return $fe1781b0b9eaad64$export$eddc205e0ec8c15(function(cb) {
        return function __do() {
            var fiber = $edf0339512807bee$export$60f50bfed4143f9d(handler(cb))(aff)();
            return $edf0339512807bee$export$ef62257e6f8a5f8c($3257df7cdef77623$var$mempty)($edf0339512807bee$export$c65b2010df1810d($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("cancelling aff"))(fiber));
        };
    });
};
var $3257df7cdef77623$export$a9fc1d60dec70907 = function(componentName) {
    return function(initialView) {
        return function(onMount) {
            return function(widgetBuilder) {
                return $3257df7cdef77623$var$component(componentName)(function($$this) {
                    return function __do() {
                        var props = $947a65af5aa39c2c$export$75fe5f91d452f94b($$this)();
                        var widget = $3257df7cdef77623$var$applySecond($3257df7cdef77623$export$b97f2ad8d0b7442d($edf0339512807bee$export$1391212d75b2ee65(0.0)))(widgetBuilder(props));
                        $fe1781b0b9eaad64$export$d1c2d6405dcf3619(widget)(function(res) {
                            if (res instanceof $fe1781b0b9eaad64$export$27a5bd065ad55220) return $6500c29ba0ac3395$export$aaf25bf2d74e9515($$this)($3257df7cdef77623$export$30d2feb505f9a613(res.value0));
                            return $93c729927fdf3160$export$bef1f36f5486a6a3("Application exited");
                        })();
                        return {
                            state: $3257df7cdef77623$export$30d2feb505f9a613(initialView),
                            render: $3257df7cdef77623$var$map($3257df7cdef77623$export$b3890eb0ae9dca99)($947a65af5aa39c2c$export$50fdfeece43146fd($$this)),
                            componentDidMount: onMount
                        };
                    };
                });
            };
        };
    };
};
var $3257df7cdef77623$export$4ee2af01c099c6c3 = function(componentName) {
    return function(initialView) {
        return function(widgetBuilder) {
            return $3257df7cdef77623$export$a9fc1d60dec70907(componentName)(initialView)($3257df7cdef77623$var$mempty1)(widgetBuilder);
        };
    };
};
var $3257df7cdef77623$export$6e131e0de1d8ccb4 = function(componentName) {
    return function(initialView) {
        return function(widget) {
            var reactClass = $3257df7cdef77623$export$4ee2af01c099c6c3(componentName)(initialView)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(widget));
            return $3257df7cdef77623$var$createLeafElement(reactClass)({});
        };
    };
};

























// Generated by purs version 0.15.16

var $c3ec47a57216184e$export$71e337785367343c = function(v) {
    return function(v1) {
        if (v) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1);
        if (!v) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Internal.Util (line 5, column 1 - line 5, column 44): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};



// Generated by purs version 0.15.16





var $b5330906fcd65ffd$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b5330906fcd65ffd$export$d558900b1478007d = /* #__PURE__ */ $b5330906fcd65ffd$var$div([
    /* #__PURE__ */ $fc1df90f0e252058$export$2913c0c0b5623090("loading-spinner")
])([
    /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18)("Loading")
]);
var $b5330906fcd65ffd$export$127ae8fff220d3fb = /* #__PURE__ */ $b5330906fcd65ffd$var$div([
    /* #__PURE__ */ $fc1df90f0e252058$export$2913c0c0b5623090("loading-overlay")
])([
    $b5330906fcd65ffd$export$d558900b1478007d
]);


var $7178b396566f5a79$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $7178b396566f5a79$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $7178b396566f5a79$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$e65788c6d4494539));
var $7178b396566f5a79$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $7178b396566f5a79$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7178b396566f5a79$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $7178b396566f5a79$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($7178b396566f5a79$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7178b396566f5a79$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $7178b396566f5a79$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $7178b396566f5a79$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $7178b396566f5a79$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $7178b396566f5a79$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($7178b396566f5a79$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7178b396566f5a79$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($37b880af5f4991bd$export$e65788c6d4494539);
var $7178b396566f5a79$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $7178b396566f5a79$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $7178b396566f5a79$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $7178b396566f5a79$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($7178b396566f5a79$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7178b396566f5a79$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$ff461bf68e7dd332);
var $7178b396566f5a79$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $7178b396566f5a79$var$runGraphQL_ = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$d1b23fba9f6872eb($a40b20519abba0fb$export$fe526d00b95b6f09);
var $7178b396566f5a79$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $7178b396566f5a79$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $7178b396566f5a79$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $7178b396566f5a79$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $7178b396566f5a79$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $7178b396566f5a79$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $7178b396566f5a79$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $7178b396566f5a79$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $7178b396566f5a79$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $7178b396566f5a79$var$sum = /* #__PURE__ */ $4fe7b6acfba7f29f$export$8a63f25cc62965f1($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $7178b396566f5a79$var$voidRight1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $7178b396566f5a79$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $7178b396566f5a79$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $7178b396566f5a79$var$SelLoading = /* #__PURE__ */ function() {
    function SelLoading() {}
    SelLoading.value = new SelLoading();
    return SelLoading;
}();
var $7178b396566f5a79$var$SelError = /* #__PURE__ */ function() {
    function SelError(value0) {
        this.value0 = value0;
    }
    SelError.create = function(value0) {
        return new SelError(value0);
    };
    return SelError;
}();
var $7178b396566f5a79$var$SelOK = /* #__PURE__ */ function() {
    function SelOK() {}
    SelOK.value = new SelOK();
    return SelOK;
}();
var $7178b396566f5a79$var$Up = /* #__PURE__ */ function() {
    function Up() {}
    Up.value = new Up();
    return Up;
}();
var $7178b396566f5a79$var$Down = /* #__PURE__ */ function() {
    function Down() {}
    Down.value = new Down();
    return Down;
}();
var $7178b396566f5a79$var$Absolute = /* #__PURE__ */ function() {
    function Absolute(value0) {
        this.value0 = value0;
    }
    Absolute.create = function(value0) {
        return new Absolute(value0);
    };
    return Absolute;
}();
var $7178b396566f5a79$var$Last = /* #__PURE__ */ function() {
    function Last() {}
    Last.value = new Last();
    return Last;
}();
var $7178b396566f5a79$var$SelectOpt = /* #__PURE__ */ function() {
    function SelectOpt(value0) {
        this.value0 = value0;
    }
    SelectOpt.create = function(value0) {
        return new SelectOpt(value0);
    };
    return SelectOpt;
}();
var $7178b396566f5a79$var$Deselect = /* #__PURE__ */ function() {
    function Deselect() {}
    Deselect.value = new Deselect();
    return Deselect;
}();
var $7178b396566f5a79$var$MoveHighlight = /* #__PURE__ */ function() {
    function MoveHighlight(value0) {
        this.value0 = value0;
    }
    MoveHighlight.create = function(value0) {
        return new MoveHighlight(value0);
    };
    return MoveHighlight;
}();
var $7178b396566f5a79$var$EnterPressed = /* #__PURE__ */ function() {
    function EnterPressed() {}
    EnterPressed.value = new EnterPressed();
    return EnterPressed;
}();
var $7178b396566f5a79$var$ChangeSearch = /* #__PURE__ */ function() {
    function ChangeSearch(value0) {
        this.value0 = value0;
    }
    ChangeSearch.create = function(value0) {
        return new ChangeSearch(value0);
    };
    return ChangeSearch;
}();
var $7178b396566f5a79$var$Expanded = /* #__PURE__ */ function() {
    function Expanded(value0) {
        this.value0 = value0;
    }
    Expanded.create = function(value0) {
        return new Expanded(value0);
    };
    return Expanded;
}();
var $7178b396566f5a79$var$OnBlur = /* #__PURE__ */ function() {
    function OnBlur() {}
    OnBlur.value = new OnBlur();
    return OnBlur;
}();
var $7178b396566f5a79$var$Hovering = /* #__PURE__ */ function() {
    function Hovering(value0) {
        this.value0 = value0;
    }
    Hovering.create = function(value0) {
        return new Hovering(value0);
    };
    return Hovering;
}();
var $7178b396566f5a79$export$5464338b5dfde392 = /* #__PURE__ */ function() {
    function FrontendSearch(value0) {
        this.value0 = value0;
    }
    FrontendSearch.create = function(value0) {
        return new FrontendSearch(value0);
    };
    return FrontendSearch;
}();
var $7178b396566f5a79$export$8210f7ba0d8a3862 = /* #__PURE__ */ function() {
    function BackendSearch(value0) {
        this.value0 = value0;
    }
    BackendSearch.create = function(value0) {
        return new BackendSearch(value0);
    };
    return BackendSearch;
}();
var $7178b396566f5a79$export$3c7793fd2148f206 = /* #__PURE__ */ function() {
    function StaticSearch(value0) {
        this.value0 = value0;
    }
    StaticSearch.create = function(value0) {
        return new StaticSearch(value0);
    };
    return StaticSearch;
}();
var $7178b396566f5a79$var$SelAct = /* #__PURE__ */ function() {
    function SelAct(value0) {
        this.value0 = value0;
    }
    SelAct.create = function(value0) {
        return new SelAct(value0);
    };
    return SelAct;
}();
var $7178b396566f5a79$var$SearchResult = /* #__PURE__ */ function() {
    function SearchResult(value0) {
        this.value0 = value0;
    }
    SearchResult.create = function(value0) {
        return new SearchResult(value0);
    };
    return SearchResult;
}();
var $7178b396566f5a79$export$3c67486d569ff2eb = function(label) {
    return $7178b396566f5a79$var$map(function(opt) {
        return {
            label: label(opt),
            value: opt
        };
    });
};
var $7178b396566f5a79$export$a252dc72673d8d9b = function(label) {
    return function(query) {
        return $7178b396566f5a79$var$map1($7178b396566f5a79$export$3c67486d569ff2eb(label))(query);
    };
};
var $7178b396566f5a79$var$stringMatch = function(v) {
    return function(v1) {
        if (v === "") return 1;
        if ($1a77d6934b592676$export$2344b14b097df817($5b07e36f812dd04b$export$b1ceac3893cbda6b(v))($5b07e36f812dd04b$export$b1ceac3893cbda6b(v1))) return 1;
        return 0;
    };
};
var $7178b396566f5a79$export$168254b22584a577 = function(key) {
    return function(items) {
        return new $7178b396566f5a79$export$3c7793fd2148f206({
            items: items,
            rank: function(s) {
                var $213 = $7178b396566f5a79$var$stringMatch(s);
                return function($214) {
                    return $213(key($214));
                };
            }
        });
    };
};
var $7178b396566f5a79$export$aa7ac00cb2600102 = function(key) {
    return function(query) {
        return new $7178b396566f5a79$export$5464338b5dfde392({
            query: query,
            rank: function(s) {
                var $215 = $7178b396566f5a79$var$stringMatch(s);
                return function($216) {
                    return $215(key($216));
                };
            }
        });
    };
};
var $7178b396566f5a79$export$5a4818cec1656a71 = function(state) {
    return function(opt) {
        return {
            id: state.id,
            searchAff: state.searchAff,
            groupFunc: state.groupFunc,
            config: state.config,
            highlighted: state.highlighted,
            expanded: state.expanded,
            hovering: state.hovering,
            loadNext: state.loadNext,
            options: state.options,
            state: state.state,
            selected: opt,
            search: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function(v1) {
                return v1.label;
            })(opt)
        };
    };
};
var $7178b396566f5a79$export$81e7dc1e8298801b = function(state) {
    return function(searchAff) {
        return {
            id: state.id,
            search: state.search,
            groupFunc: state.groupFunc,
            config: state.config,
            selected: state.selected,
            highlighted: state.highlighted,
            expanded: state.expanded,
            hovering: state.hovering,
            state: state.state,
            options: [],
            searchAff: searchAff,
            loadNext: true
        };
    };
};
var $7178b396566f5a79$export$127d1aaaa65102b1 = function(v) {
    return v.selected;
};
var $7178b396566f5a79$var$renderList = function(v) {
    if (v.state instanceof $7178b396566f5a79$var$SelOK) {
        var listItem = function(idx) {
            return function(opt) {
                var activeClass = function() {
                    var $126 = $7178b396566f5a79$var$eq(new $06733ae99ed4f534$export$8a67b48435b5d073(idx))(v.highlighted) || $7178b396566f5a79$var$eq1(new $06733ae99ed4f534$export$8a67b48435b5d073(opt.label))($7178b396566f5a79$var$map2(function(v1) {
                        return v1.label;
                    })(v.selected));
                    if ($126) return [
                        new $06733ae99ed4f534$export$8a67b48435b5d073("active")
                    ];
                    return [];
                }();
                return $7178b396566f5a79$var$a([
                    $fc1df90f0e252058$export$11c615ce16f87241($7178b396566f5a79$var$append([
                        new $06733ae99ed4f534$export$8a67b48435b5d073("widget-select-option")
                    ])(activeClass)),
                    $fc1df90f0e252058$export$8f51af5840e0602a("javascript:void(0);"),
                    $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$SelectOpt(opt))($fc1df90f0e252058$export$1d5a917feb871989),
                    $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$Hovering(true))($fc1df90f0e252058$export$afc474fdab5e8a8e),
                    $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$Hovering(false))($fc1df90f0e252058$export$65a11040da641544)
                ])([
                    $7178b396566f5a79$var$text(opt.label)
                ]);
            };
        };
        var listGroup = function(v1) {
            return function(v2) {
                if (v2.label === "") return $396c4c3d9e7fae3c$export$8f07ddce13659f50(listItem)(v2.opts);
                if ($7178b396566f5a79$var$length(v.options) < 2) return $396c4c3d9e7fae3c$export$8f07ddce13659f50(listItem)(v2.opts);
                return [
                    $7178b396566f5a79$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-group")
                    ])($7178b396566f5a79$var$append([
                        $7178b396566f5a79$var$div([
                            $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-group-header")
                        ])([
                            $7178b396566f5a79$var$text(v2.label)
                        ])
                    ])($396c4c3d9e7fae3c$export$8f07ddce13659f50(listItem)(v2.opts)))
                ];
            };
        };
        var renderGroups = function(v1) {
            return function(v2) {
                return function(v3) {
                    if (v3.length === 0) return [];
                    var v4 = $396c4c3d9e7fae3c$export$b610b8812bbcded9(v3)(v1);
                    if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7178b396566f5a79$var$append(listGroup(v2)(v4.value0))(renderGroups(v1 + 1 | 0)(v2 + $7178b396566f5a79$var$length(v4.value0.opts) | 0)(v3));
                    if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
                    throw new Error("Failed pattern match at Widgets.BetterSelect (line 494, column 35 - line 496, column 22): " + [
                        v4.constructor.name
                    ]);
                };
            };
        };
        var deselectLabel = $06733ae99ed4f534$export$43db023a260c5e9f($06733ae99ed4f534$export$43db023a260c5e9f($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose"))(v.config.placeholder))(v.config.deselectLabel);
        var deselectOption = function() {
            var activeClass = function() {
                var $134 = $7178b396566f5a79$var$eq(v.highlighted)(new $06733ae99ed4f534$export$8a67b48435b5d073(-1));
                if ($134) return [
                    new $06733ae99ed4f534$export$8a67b48435b5d073("active")
                ];
                return [];
            }();
            return $7178b396566f5a79$var$a([
                $fc1df90f0e252058$export$11c615ce16f87241($7178b396566f5a79$var$append([
                    new $06733ae99ed4f534$export$8a67b48435b5d073("widget-select-option")
                ])(activeClass)),
                $fc1df90f0e252058$export$8f51af5840e0602a("javascript:void(0);"),
                $7178b396566f5a79$var$voidRight($7178b396566f5a79$var$Deselect.value)($fc1df90f0e252058$export$1d5a917feb871989),
                $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$Hovering(true))($fc1df90f0e252058$export$afc474fdab5e8a8e),
                $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$Hovering(false))($fc1df90f0e252058$export$65a11040da641544)
            ])([
                $7178b396566f5a79$var$text(deselectLabel)
            ]);
        }();
        return $7178b396566f5a79$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-dropdown")
        ])($7178b396566f5a79$var$append(function() {
            if (v.config.allowDeselect) return [
                deselectOption
            ];
            return [];
        }())($fc8c1182ec2aefec$export$ee1b3e54f0441b22($396c4c3d9e7fae3c$export$8f07ddce13659f50(listGroup)(v.options))));
    }
    if (v.state instanceof $7178b396566f5a79$var$SelLoading) return $7178b396566f5a79$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-dropdown widget-select-loading")
    ])([
        $b5330906fcd65ffd$export$d558900b1478007d
    ]);
    if (v.state instanceof $7178b396566f5a79$var$SelError) return $7178b396566f5a79$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-dropdown widget-select-error")
    ])([
        $7178b396566f5a79$var$text($54dae5ca6a6cd16d$export$5055e1049c39d225(v.state.value0))
    ]);
    throw new Error("Failed pattern match at Widgets.BetterSelect (line 474, column 1 - line 474, column 65): " + [
        v.constructor.name
    ]);
};
var $7178b396566f5a79$var$renderInput = function(selState) {
    return function(search) {
        var value = function() {
            if (selState.config.editable) return search;
            return $06733ae99ed4f534$export$43db023a260c5e9f(search)($7178b396566f5a79$var$map2(function(v) {
                return v.label;
            })(selState.selected));
        }();
        var keyList = [
            38,
            40,
            13
        ];
        var handleKey = function(v) {
            if (v === 38) return new $7178b396566f5a79$var$MoveHighlight($7178b396566f5a79$var$Up.value);
            if (v === 40) return new $7178b396566f5a79$var$MoveHighlight($7178b396566f5a79$var$Down.value);
            if (v === 13) return $7178b396566f5a79$var$EnterPressed.value;
            return new $7178b396566f5a79$var$MoveHighlight($7178b396566f5a79$var$Up.value);
        };
        var eventKey = function(e) {
            return e.which;
        };
        var classes = [
            new $06733ae99ed4f534$export$8a67b48435b5d073("widget-select-input"),
            new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                var $143 = $06733ae99ed4f534$export$c15bd07a493e1236(selState.selected);
                if ($143) return "selected";
                return "not-selected";
            }())
        ];
        var canHandleKey = function(event) {
            return $7178b396566f5a79$var$elem(event.which)(keyList);
        };
        return $7178b396566f5a79$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090(function() {
                if (selState.config.editable) return "widget-select";
                return "widget-select disabled";
            }())
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($7178b396566f5a79$var$input($7178b396566f5a79$var$append([
                $fc1df90f0e252058$export$11c615ce16f87241(classes),
                $fc1df90f0e252058$export$9c7ae676ac45430a(selState.id),
                $fc1df90f0e252058$export$d88a383e7d5eee04("off"),
                $fc1df90f0e252058$export$2ab9a8f9f1186f14(value),
                $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose"))(selState.config.placeholder))
            ])(function() {
                if (selState.config.editable) return [
                    $7178b396566f5a79$var$map3($7178b396566f5a79$var$map4($7178b396566f5a79$var$ChangeSearch.create)($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512),
                    $7178b396566f5a79$var$map3($7178b396566f5a79$var$map4(handleKey)(eventKey))($fc1df90f0e252058$export$f28dd611770f1573(canHandleKey)($fc1df90f0e252058$export$de8e1b1372cdb41b)),
                    $7178b396566f5a79$var$voidRight($7178b396566f5a79$var$OnBlur.value)($fc1df90f0e252058$export$5e446bc31724fca4),
                    $7178b396566f5a79$var$voidRight(new $7178b396566f5a79$var$Expanded(true))($fc1df90f0e252058$export$ecf9bf35ad97eb74)
                ];
                return [
                    $fc1df90f0e252058$export$683472f6198a076e(true),
                    $fc1df90f0e252058$export$9a625f9de50bf0b7(-1)
                ];
            }()))),
            $c3ec47a57216184e$export$71e337785367343c(selState.config.editable && $06733ae99ed4f534$export$c15bd07a493e1236(selState.selected))($7178b396566f5a79$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-clear-button"),
                $7178b396566f5a79$var$voidRight($7178b396566f5a79$var$Deselect.value)($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $7178b396566f5a79$var$text("clear")
            ]))
        ]));
    };
};
var $7178b396566f5a79$var$render = function(state) {
    return $7178b396566f5a79$var$div([
        $fc1df90f0e252058$export$df61b30b684217c0(state.id + "-wrapper"),
        $fc1df90f0e252058$export$9c7ae676ac45430a(state.id + "-wrapper"),
        $fc1df90f0e252058$export$2913c0c0b5623090("widget-select-container")
    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        new $06733ae99ed4f534$export$8a67b48435b5d073($7178b396566f5a79$var$renderInput(state)(state.search)),
        $c3ec47a57216184e$export$71e337785367343c(state.config.editable && state.expanded)($7178b396566f5a79$var$renderList(state))
    ]));
};
var $7178b396566f5a79$export$681ac624aa06ab03 = function(s) {
    return function(v) {
        return $7178b396566f5a79$var$stringMatch(s)(v.label);
    };
};
var $7178b396566f5a79$export$ec474c92c8f2413d = function(state) {
    return function(opts) {
        return {
            id: state.id,
            search: state.search,
            searchAff: state.searchAff,
            groupFunc: state.groupFunc,
            config: state.config,
            selected: state.selected,
            highlighted: state.highlighted,
            expanded: state.expanded,
            hovering: state.hovering,
            state: state.state,
            options: [
                {
                    label: "",
                    opts: opts
                }
            ],
            loadNext: false
        };
    };
};
var $7178b396566f5a79$var$movePointer = function(v) {
    return function(v1) {
        return function(v2) {
            if (v === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (v1 instanceof $7178b396566f5a79$var$Up && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2.value0 > 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0 - 1 | 0);
            if (v1 instanceof $7178b396566f5a79$var$Up && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v - 1 | 0);
            if (v1 instanceof $7178b396566f5a79$var$Up && v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if (v1 instanceof $7178b396566f5a79$var$Down && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2.value0 < (v - 1 | 0)) return new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0 + 1 | 0);
            if (v1 instanceof $7178b396566f5a79$var$Down && v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if (v1 instanceof $7178b396566f5a79$var$Down && v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if (v1 instanceof $7178b396566f5a79$var$Absolute && v1.value0 > v) return new $06733ae99ed4f534$export$8a67b48435b5d073(v - 1 | 0);
            if (v1 instanceof $7178b396566f5a79$var$Absolute && v1.value0 < 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(0);
            if (v1 instanceof $7178b396566f5a79$var$Absolute) return new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0);
            if (v1 instanceof $7178b396566f5a79$var$Last) return new $06733ae99ed4f534$export$8a67b48435b5d073(v - 1 | 0);
            throw new Error("Failed pattern match at Widgets.BetterSelect (line 246, column 1 - line 246, column 57): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7178b396566f5a79$var$mapSearchResult = function(f) {
    return function(res) {
        var func = function(opt) {
            return {
                label: opt.label,
                value: f(opt.value)
            };
        };
        return $7178b396566f5a79$var$map1($7178b396566f5a79$var$map(func))(res);
    };
};
var $7178b396566f5a79$export$f722688498755b51 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7178b396566f5a79$export$8210f7ba0d8a3862) return new $7178b396566f5a79$export$8210f7ba0d8a3862(function() {
                var $217 = $7178b396566f5a79$var$mapSearchResult(v);
                return function($218) {
                    return $217(v2.value0($218));
                };
            }());
            if (v2 instanceof $7178b396566f5a79$export$5464338b5dfde392) return new $7178b396566f5a79$export$5464338b5dfde392({
                query: $7178b396566f5a79$var$mapSearchResult(v)(v2.value0.query),
                rank: v1
            });
            if (v2 instanceof $7178b396566f5a79$export$3c7793fd2148f206) return new $7178b396566f5a79$export$3c7793fd2148f206({
                items: $7178b396566f5a79$var$map(function(opt) {
                    return {
                        label: opt.label,
                        value: v(opt.value)
                    };
                })(v2.value0.items),
                rank: v1
            });
            throw new Error("Failed pattern match at Widgets.BetterSelect (line 172, column 1 - line 172, column 104): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7178b396566f5a79$export$c0550eae5f8d456b = function(id) {
    return function(searchAff) {
        return function(groupFunc) {
            return function(config) {
                return {
                    id: id,
                    searchAff: searchAff,
                    config: config,
                    groupFunc: groupFunc,
                    options: [],
                    state: $7178b396566f5a79$var$SelOK.value,
                    search: "",
                    selected: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    highlighted: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    loadNext: true,
                    expanded: false,
                    hovering: false
                };
            };
        };
    };
};
var $7178b396566f5a79$export$d967f07ae6c72524 = function(id) {
    return function(searchAff) {
        return function(config) {
            return $7178b396566f5a79$export$c0550eae5f8d456b(id)(searchAff)($06733ae99ed4f534$export$bebe9059409a0d04.value)(config);
        };
    };
};
var $7178b396566f5a79$export$95b406ac9fa822b9 = function(id) {
    return function(options) {
        return $7178b396566f5a79$export$d967f07ae6c72524(id)($7178b396566f5a79$export$168254b22584a577(function(v) {
            return v.label;
        })(options));
    };
};
var $7178b396566f5a79$export$9ce8057dc6b57b48 = function(id) {
    return function(aff) {
        return function(group) {
            return function(config) {
                var v = $7178b396566f5a79$export$d967f07ae6c72524(id)(aff)(config);
                return {
                    id: v.id,
                    search: v.search,
                    searchAff: v.searchAff,
                    config: v.config,
                    selected: v.selected,
                    highlighted: v.highlighted,
                    expanded: v.expanded,
                    hovering: v.hovering,
                    loadNext: v.loadNext,
                    options: v.options,
                    state: v.state,
                    groupFunc: new $06733ae99ed4f534$export$8a67b48435b5d073(group)
                };
            };
        };
    };
};
var $7178b396566f5a79$export$142a4d5d80d395de = function(dictOrd) {
    var eq3 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictOrd.Eq0());
    return function(func) {
        return function(label) {
            return function(opts) {
                var labelGroup = function(grouped) {
                    return {
                        label: label(function(v) {
                            return v.value;
                        }($e39dfcf102cdca3c$export$5fd5031fecdacec3(grouped))),
                        opts: $e39dfcf102cdca3c$export$45b10814cc054894(grouped)
                    };
                };
                return $7178b396566f5a79$var$map(labelGroup)($396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(a1) {
                    return function(b) {
                        return eq3(func(a1.value))(func(b.value));
                    };
                })(opts));
            };
        };
    };
};
var $7178b396566f5a79$var$groupOpts = function(v) {
    return function(v1) {
        if (v.groupFunc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [
            {
                label: "",
                opts: v1
            }
        ];
        if (v.groupFunc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.groupFunc.value0(v1);
        throw new Error("Failed pattern match at Widgets.BetterSelect (line 395, column 1 - line 395, column 83): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $7178b396566f5a79$var$getItem = function(state) {
    return function(idx) {
        return $396c4c3d9e7fae3c$export$b610b8812bbcded9($06733ae99ed4f534$export$43db023a260c5e9f([])($7178b396566f5a79$var$map2(function(v) {
            return v.opts;
        })($396c4c3d9e7fae3c$export$b610b8812bbcded9(state.options)(0))))(idx);
    };
};
var $7178b396566f5a79$var$filterSort = function(rank) {
    var $219 = $7178b396566f5a79$var$sortWith(rank);
    var $220 = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(o) {
        return rank(o) > 0;
    });
    return function($221) {
        return $219($220($221));
    };
};
var $7178b396566f5a79$var$loadSearchAff = function(v) {
    return function(v1) {
        if (v1 instanceof $7178b396566f5a79$export$8210f7ba0d8a3862) return $d2284b2d3e1b6f87$export$8291c2122093ac93($7178b396566f5a79$var$bind($7178b396566f5a79$var$runGraphQL_(v1.value0(v)))(function(result) {
            return $7178b396566f5a79$var$pure({
                result: result,
                searchAff: v1
            });
        }));
        if (v1 instanceof $7178b396566f5a79$export$5464338b5dfde392) return $7178b396566f5a79$var$bind1($7178b396566f5a79$var$runGraphQL(v1.value0.query))(function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7178b396566f5a79$var$loadSearchAff(v)(new $7178b396566f5a79$export$3c7793fd2148f206({
                items: v2.value0,
                rank: v1.value0.rank
            }));
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $7178b396566f5a79$var$pure1(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v2.value0));
            throw new Error("Failed pattern match at Widgets.BetterSelect (line 386, column 78 - line 388, column 32): " + [
                v2.constructor.name
            ]);
        });
        if (v1 instanceof $7178b396566f5a79$export$3c7793fd2148f206) {
            var result = $7178b396566f5a79$var$filterSort(v1.value0.rank(v))(v1.value0.items);
            return $7178b396566f5a79$var$pure1(new $7d4cccdf062a2261$export$19db0165690c701a({
                result: result,
                searchAff: v1
            }));
        }
        throw new Error("Failed pattern match at Widgets.BetterSelect (line 380, column 1 - line 380, column 98): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $7178b396566f5a79$export$3fb6c8f3fe50bc9f = /* #__PURE__ */ function() {
    return new $7178b396566f5a79$export$3c7793fd2148f206({
        items: [],
        rank: function(v) {
            return function(v1) {
                return 0;
            };
        }
    });
}();
var $7178b396566f5a79$export$f52b68eea1d2c257 = /* #__PURE__ */ function() {
    return {
        placeholder: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        deselectLabel: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        allowDeselect: true,
        editable: true
    };
}();
var $7178b396566f5a79$export$660e86cf22853707 = function(id) {
    return function(searchAff) {
        return $7178b396566f5a79$export$d967f07ae6c72524(id)(searchAff)($7178b396566f5a79$export$f52b68eea1d2c257);
    };
};
var $7178b396566f5a79$export$95f56ae4fbe7eea3 = function(id) {
    return function(options) {
        return $7178b396566f5a79$export$95b406ac9fa822b9(id)(options)($7178b396566f5a79$export$f52b68eea1d2c257);
    };
};
var $7178b396566f5a79$var$debounceDelay = 300.0;
var $7178b396566f5a79$var$loadSearch = function(v) {
    if (v.searchAff instanceof $7178b396566f5a79$export$3c7793fd2148f206) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
        config: v.config,
        expanded: v.expanded,
        groupFunc: v.groupFunc,
        highlighted: v.highlighted,
        hovering: v.hovering,
        id: v.id,
        loadNext: v.loadNext,
        search: v.search,
        searchAff: v.searchAff,
        selected: v.selected,
        options: $7178b396566f5a79$var$groupOpts(v)($7178b396566f5a79$var$filterSort(v.searchAff.value0.rank(v.search))(v.searchAff.value0.items)),
        state: $7178b396566f5a79$var$SelOK.value
    }));
    return $7178b396566f5a79$var$bind2($7178b396566f5a79$var$alt($7178b396566f5a79$var$map5($7178b396566f5a79$var$SelAct.create)($7178b396566f5a79$var$render({
        id: v.id,
        search: v.search,
        searchAff: v.searchAff,
        groupFunc: v.groupFunc,
        config: v.config,
        selected: v.selected,
        highlighted: v.highlighted,
        expanded: v.expanded,
        hovering: v.hovering,
        loadNext: v.loadNext,
        options: [],
        state: $7178b396566f5a79$var$SelLoading.value
    })))($7178b396566f5a79$var$map5($7178b396566f5a79$var$SearchResult.create)($3257df7cdef77623$export$b97f2ad8d0b7442d($7178b396566f5a79$var$loadSearchAff(v.search)(v.searchAff)))))(function(act) {
        if (act instanceof $7178b396566f5a79$var$SelAct) return $7178b396566f5a79$var$handleAction(v)(act.value0);
        if (act instanceof $7178b396566f5a79$var$SearchResult && act.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            config: v.config,
            expanded: v.expanded,
            groupFunc: v.groupFunc,
            highlighted: v.highlighted,
            hovering: v.hovering,
            id: v.id,
            loadNext: v.loadNext,
            search: v.search,
            selected: v.selected,
            options: $7178b396566f5a79$var$groupOpts(v)(act.value0.value0.result),
            searchAff: act.value0.value0.searchAff,
            state: $7178b396566f5a79$var$SelOK.value
        }));
        if (act instanceof $7178b396566f5a79$var$SearchResult && act.value0 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            config: v.config,
            expanded: v.expanded,
            groupFunc: v.groupFunc,
            highlighted: v.highlighted,
            hovering: v.hovering,
            id: v.id,
            loadNext: v.loadNext,
            search: v.search,
            searchAff: v.searchAff,
            selected: v.selected,
            options: [],
            state: new $7178b396566f5a79$var$SelError(act.value0.value0)
        }));
        throw new Error("Failed pattern match at Widgets.BetterSelect (line 360, column 5 - line 372, column 18): " + [
            act.constructor.name
        ]);
    });
};
var $7178b396566f5a79$var$handleAction = function(v) {
    return function(v1) {
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$SelectOpt) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$19db0165690c701a({
            config: state.config,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            hovering: state.hovering,
            id: state.id,
            options: state.options,
            searchAff: state.searchAff,
            state: state.state,
            selected: new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0),
            loadNext: true,
            expanded: false,
            search: v1.value0.label
        }));
        var state = v;
        if (!v.config.allowDeselect && v1 instanceof $7178b396566f5a79$var$Deselect) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$19db0165690c701a({
            config: state.config,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            hovering: state.hovering,
            id: state.id,
            options: state.options,
            searchAff: state.searchAff,
            selected: state.selected,
            state: state.state,
            search: "",
            loadNext: true,
            expanded: false
        }));
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$Deselect) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$19db0165690c701a({
            config: state.config,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            hovering: state.hovering,
            id: state.id,
            options: state.options,
            searchAff: state.searchAff,
            state: state.state,
            selected: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            search: "",
            loadNext: true,
            expanded: false
        }));
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$EnterPressed && state.expanded) {
            var v2 = $7178b396566f5a79$var$bindFlipped($7178b396566f5a79$var$getItem(state))(state.highlighted);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7178b396566f5a79$var$handleAction(state)(new $7178b396566f5a79$var$SelectOpt(v2.value0));
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7178b396566f5a79$var$handleAction(state)($7178b396566f5a79$var$Deselect.value);
            throw new Error("Failed pattern match at Widgets.BetterSelect (line 311, column 5 - line 313, column 47): " + [
                v2.constructor.name
            ]);
        }
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$EnterPressed) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            config: state.config,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            hovering: state.hovering,
            id: state.id,
            loadNext: state.loadNext,
            options: state.options,
            search: state.search,
            searchAff: state.searchAff,
            selected: state.selected,
            state: state.state,
            expanded: true
        }));
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$MoveHighlight) {
            var optcount = $7178b396566f5a79$var$sum($7178b396566f5a79$var$map(function($222) {
                return $7178b396566f5a79$var$length(function(v2) {
                    return v2.opts;
                }($222));
            })(state.options));
            var ptr = $7178b396566f5a79$var$movePointer(optcount)(v1.value0)(state.highlighted);
            return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                config: state.config,
                groupFunc: state.groupFunc,
                hovering: state.hovering,
                id: state.id,
                loadNext: state.loadNext,
                options: state.options,
                search: state.search,
                searchAff: state.searchAff,
                selected: state.selected,
                state: state.state,
                highlighted: ptr,
                expanded: true
            }));
        }
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$Expanded) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            config: state.config,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            id: state.id,
            loadNext: state.loadNext,
            options: state.options,
            search: state.search,
            searchAff: state.searchAff,
            selected: state.selected,
            state: state.state,
            expanded: v1.value0,
            hovering: false
        }));
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$OnBlur && state.hovering) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515(state));
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$OnBlur) {
            var search = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function(v2) {
                return v2.label;
            })(state.selected);
            return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                config: state.config,
                groupFunc: state.groupFunc,
                highlighted: state.highlighted,
                id: state.id,
                options: state.options,
                searchAff: state.searchAff,
                selected: state.selected,
                state: state.state,
                expanded: false,
                hovering: false,
                search: search,
                loadNext: true
            }));
        }
        var state = v;
        if (v1 instanceof $7178b396566f5a79$var$Hovering) return $7178b396566f5a79$var$pure2(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            config: state.config,
            expanded: state.expanded,
            groupFunc: state.groupFunc,
            highlighted: state.highlighted,
            id: state.id,
            loadNext: state.loadNext,
            options: state.options,
            search: state.search,
            searchAff: state.searchAff,
            selected: state.selected,
            state: state.state,
            hovering: v1.value0
        }));
        if (v1 instanceof $7178b396566f5a79$var$ChangeSearch) {
            var state = {
                config: v.config,
                expanded: v.expanded,
                groupFunc: v.groupFunc,
                highlighted: v.highlighted,
                hovering: v.hovering,
                id: v.id,
                loadNext: v.loadNext,
                options: v.options,
                searchAff: v.searchAff,
                selected: v.selected,
                state: v.state,
                search: v1.value0
            };
            return $7178b396566f5a79$var$bind2($7178b396566f5a79$var$alt($7178b396566f5a79$var$voidRight1($06733ae99ed4f534$export$bebe9059409a0d04.value)($3257df7cdef77623$export$b97f2ad8d0b7442d($edf0339512807bee$export$1391212d75b2ee65($7178b396566f5a79$var$debounceDelay))))($7178b396566f5a79$var$map5($06733ae99ed4f534$export$8a67b48435b5d073.create)($7178b396566f5a79$var$render(state))))(function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7178b396566f5a79$var$loadSearch({
                    id: state.id,
                    search: state.search,
                    searchAff: state.searchAff,
                    groupFunc: state.groupFunc,
                    config: state.config,
                    selected: state.selected,
                    highlighted: state.highlighted,
                    hovering: state.hovering,
                    options: state.options,
                    state: state.state,
                    loadNext: false,
                    expanded: true
                });
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7178b396566f5a79$var$handleAction(state)(v2.value0);
                throw new Error("Failed pattern match at Widgets.BetterSelect (line 340, column 5 - line 344, column 43): " + [
                    v2.constructor.name
                ]);
            });
        }
        throw new Error("Failed pattern match at Widgets.BetterSelect (line 296, column 1 - line 296, column 99): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $7178b396566f5a79$var$runSelect = function(v) {
    if (!v.config.editable) return $7178b396566f5a79$var$bindFlipped1($7178b396566f5a79$var$handleAction(v))($7178b396566f5a79$var$render(v));
    if (v.loadNext && v.expanded) {
        var search = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function(opt) {
            var $209 = v.search === opt.label;
            if ($209) return "";
            return v.search;
        })($7178b396566f5a79$export$127d1aaaa65102b1(v));
        return $7178b396566f5a79$var$loadSearch({
            id: v.id,
            searchAff: v.searchAff,
            groupFunc: v.groupFunc,
            config: v.config,
            selected: v.selected,
            highlighted: v.highlighted,
            expanded: v.expanded,
            hovering: v.hovering,
            options: v.options,
            state: v.state,
            loadNext: false,
            search: search
        });
    }
    return $7178b396566f5a79$var$bindFlipped1($7178b396566f5a79$var$handleAction(v))($7178b396566f5a79$var$render(v));
};
var $7178b396566f5a79$export$54b124386ef5abe3 = function(state) {
    return $7178b396566f5a79$var$loopState({
        config: state.config,
        groupFunc: state.groupFunc,
        highlighted: state.highlighted,
        hovering: state.hovering,
        id: state.id,
        loadNext: state.loadNext,
        options: state.options,
        search: state.search,
        searchAff: state.searchAff,
        selected: state.selected,
        state: state.state,
        expanded: false
    })($7178b396566f5a79$var$runSelect);
};
var $7178b396566f5a79$export$c4791769f9191c37 = function(id) {
    return function(v) {
        return $7178b396566f5a79$var$map5(function(v1) {
            return {
                config: v1.config,
                expanded: v1.expanded,
                groupFunc: v1.groupFunc,
                highlighted: v1.highlighted,
                hovering: v1.hovering,
                loadNext: v1.loadNext,
                options: v1.options,
                search: v1.search,
                searchAff: v1.searchAff,
                selected: v1.selected,
                state: v1.state,
                id: v.id
            };
        })($7178b396566f5a79$export$54b124386ef5abe3({
            search: v.search,
            searchAff: v.searchAff,
            groupFunc: v.groupFunc,
            config: v.config,
            selected: v.selected,
            highlighted: v.highlighted,
            expanded: v.expanded,
            hovering: v.hovering,
            loadNext: v.loadNext,
            options: v.options,
            state: v.state,
            id: id
        }));
    };
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16










var $0e660be785782a7f$var$coursesIsSymbol = {
    reflectSymbol: function() {
        return "courses";
    }
};
var $0e660be785782a7f$var$modify = /* #__PURE__ */ $15e8567e7c31ba30$export$3ff57735a52b8713($0e660be785782a7f$var$coursesIsSymbol)()();
var $0e660be785782a7f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $0e660be785782a7f$var$type_idIsSymbol = {
    reflectSymbol: function() {
        return "type_id";
    }
};
var $0e660be785782a7f$var$rename = /* #__PURE__ */ $15e8567e7c31ba30$export$7ac989ec0c9c279({
    reflectSymbol: function() {
        return "form";
    }
})($0e660be785782a7f$var$type_idIsSymbol)()()()();
var $0e660be785782a7f$var$allowed_typesIsSymbol = {
    reflectSymbol: function() {
        return "allowed_types";
    }
};
var $0e660be785782a7f$var$rename1 = /* #__PURE__ */ $15e8567e7c31ba30$export$7ac989ec0c9c279({
    reflectSymbol: function() {
        return "types";
    }
})($0e660be785782a7f$var$allowed_typesIsSymbol)()()()();
var $0e660be785782a7f$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $0e660be785782a7f$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $0e660be785782a7f$var$teacher_idIsSymbol = {
    reflectSymbol: function() {
        return "teacher_id";
    }
};
var $0e660be785782a7f$var$hqtMaybe = /* #__PURE__ */ $308f9765feb7633d$export$9040d00d71e77b23($0e660be785782a7f$var$rntyType);
var $0e660be785782a7f$var$encodeJsonMaybe = /* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($0e660be785782a7f$var$encRNTY);
var $0e660be785782a7f$var$student_idIsSymbol = {
    reflectSymbol: function() {
        return "student_id";
    }
};
var $0e660be785782a7f$var$position_idIsSymbol = {
    reflectSymbol: function() {
        return "position_id";
    }
};
var $0e660be785782a7f$var$employer_idIsSymbol = {
    reflectSymbol: function() {
        return "employer_id";
    }
};
var $0e660be785782a7f$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $0e660be785782a7f$var$contact_idIsSymbol = {
    reflectSymbol: function() {
        return "contact_id";
    }
};
var $0e660be785782a7f$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $0e660be785782a7f$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $0e660be785782a7f$var$gDecodeJsonCons2 = /* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $0e660be785782a7f$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $0e660be785782a7f$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $0e660be785782a7f$var$positionsIsSymbol = {
    reflectSymbol: function() {
        return "positions";
    }
};
var $0e660be785782a7f$var$deleted_atIsSymbol = {
    reflectSymbol: function() {
        return "deleted_at";
    }
};
var $0e660be785782a7f$var$contactsIsSymbol = {
    reflectSymbol: function() {
        return "contacts";
    }
};
var $0e660be785782a7f$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $0e660be785782a7f$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $0e660be785782a7f$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $0e660be785782a7f$var$default_last_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_last_name";
    }
};
var $0e660be785782a7f$var$default_first_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_first_name";
    }
};
var $0e660be785782a7f$var$default_emailIsSymbol = {
    reflectSymbol: function() {
        return "default_email";
    }
};
var $0e660be785782a7f$var$signature_fieldsIsSymbol = {
    reflectSymbol: function() {
        return "signature_fields";
    }
};
var $0e660be785782a7f$var$employerIsSymbol = {
    reflectSymbol: function() {
        return "employer";
    }
};
var $0e660be785782a7f$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $0e660be785782a7f$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $0e660be785782a7f$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $0e660be785782a7f$export$316a46c1e34e2e7f = /* #__PURE__ */ function() {
    function CoursesAF() {}
    CoursesAF.value = new CoursesAF();
    return CoursesAF;
}();
var $0e660be785782a7f$export$8ef859202dc67238 = /* #__PURE__ */ function() {
    function StudentAF() {}
    StudentAF.value = new StudentAF();
    return StudentAF;
}();
var $0e660be785782a7f$export$ab5ac231dd3efd00 = /* #__PURE__ */ function() {
    function TeacherAF() {}
    TeacherAF.value = new TeacherAF();
    return TeacherAF;
}();
var $0e660be785782a7f$export$b0e87b3139bc946f = /* #__PURE__ */ function() {
    function EmployerAF() {}
    EmployerAF.value = new EmployerAF();
    return EmployerAF;
}();
var $0e660be785782a7f$export$5a61ed5a76cf6b3d = /* #__PURE__ */ function() {
    function ContactAF() {}
    ContactAF.value = new ContactAF();
    return ContactAF;
}();
var $0e660be785782a7f$export$9cfe350c8b2d28c8 = /* #__PURE__ */ function() {
    function PositionAF() {}
    PositionAF.value = new PositionAF();
    return PositionAF;
}();
var $0e660be785782a7f$export$1342c2bf5b044e57 = /* #__PURE__ */ function() {
    function NowAF() {}
    NowAF.value = new NowAF();
    return NowAF;
}();
var $0e660be785782a7f$export$b56a159182574c04 = function(form) {
    return function(student_id) {
        return {
            form: form,
            student_id: student_id,
            teacher_id: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            employer_id: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            position_id: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            contact_id: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            courses: [],
            types: []
        };
    };
};
var $0e660be785782a7f$export$2095348e9662ba70 = function(v) {
    if (v instanceof $0e660be785782a7f$export$316a46c1e34e2e7f) return "COURSES";
    if (v instanceof $0e660be785782a7f$export$8ef859202dc67238) return "STUDENT";
    if (v instanceof $0e660be785782a7f$export$ab5ac231dd3efd00) return "TEACHER";
    if (v instanceof $0e660be785782a7f$export$b0e87b3139bc946f) return "EMPLOYER";
    if (v instanceof $0e660be785782a7f$export$5a61ed5a76cf6b3d) return "CONTACT";
    if (v instanceof $0e660be785782a7f$export$9cfe350c8b2d28c8) return "POSITION";
    if (v instanceof $0e660be785782a7f$export$1342c2bf5b044e57) return "NOW";
    throw new Error("Failed pattern match at API.Autofill (line 35, column 1 - line 35, column 42): " + [
        v.constructor.name
    ]);
};
var $0e660be785782a7f$export$fd090c531f3b5e62 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("AutofillType");
    }
};
var $0e660be785782a7f$export$f2403200e9d9aaa1 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0e660be785782a7f$export$316a46c1e34e2e7f && y instanceof $0e660be785782a7f$export$316a46c1e34e2e7f) return true;
            if (x instanceof $0e660be785782a7f$export$8ef859202dc67238 && y instanceof $0e660be785782a7f$export$8ef859202dc67238) return true;
            if (x instanceof $0e660be785782a7f$export$ab5ac231dd3efd00 && y instanceof $0e660be785782a7f$export$ab5ac231dd3efd00) return true;
            if (x instanceof $0e660be785782a7f$export$b0e87b3139bc946f && y instanceof $0e660be785782a7f$export$b0e87b3139bc946f) return true;
            if (x instanceof $0e660be785782a7f$export$5a61ed5a76cf6b3d && y instanceof $0e660be785782a7f$export$5a61ed5a76cf6b3d) return true;
            if (x instanceof $0e660be785782a7f$export$9cfe350c8b2d28c8 && y instanceof $0e660be785782a7f$export$9cfe350c8b2d28c8) return true;
            if (x instanceof $0e660be785782a7f$export$1342c2bf5b044e57 && y instanceof $0e660be785782a7f$export$1342c2bf5b044e57) return true;
            return false;
        };
    }
};
var $0e660be785782a7f$export$4bcc3731502007c1 = {
    encodeJson: /* #__PURE__ */ function() {
        var $337 = $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
        return function($338) {
            return $337($0e660be785782a7f$export$2095348e9662ba70($338));
        };
    }()
};
var $0e660be785782a7f$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc)($0e660be785782a7f$var$type_idIsSymbol)($0e660be785782a7f$var$rntyType)($0e660be785782a7f$var$encRNTY)()())($0e660be785782a7f$var$teacher_idIsSymbol)($0e660be785782a7f$var$hqtMaybe)($0e660be785782a7f$var$encodeJsonMaybe)()())($0e660be785782a7f$var$student_idIsSymbol)($0e660be785782a7f$var$rntyType)($0e660be785782a7f$var$encRNTY)()())($0e660be785782a7f$var$position_idIsSymbol)($0e660be785782a7f$var$hqtMaybe)($0e660be785782a7f$var$encodeJsonMaybe)()())($0e660be785782a7f$var$employer_idIsSymbol)($0e660be785782a7f$var$hqtMaybe)($0e660be785782a7f$var$encodeJsonMaybe)()())($0e660be785782a7f$var$coursesIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "AutofillIDInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($0e660be785782a7f$var$encRNTY)(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$b198596427f378ab)($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "index";
    }
})())($0e660be785782a7f$var$idIsSymbol)())())))()())($0e660be785782a7f$var$contact_idIsSymbol)($0e660be785782a7f$var$hqtMaybe)($0e660be785782a7f$var$encodeJsonMaybe)()())($0e660be785782a7f$var$allowed_typesIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($0e660be785782a7f$export$fd090c531f3b5e62))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($0e660be785782a7f$export$4bcc3731502007c1))()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330)($0e660be785782a7f$var$type_idIsSymbol)())($0e660be785782a7f$var$teacher_idIsSymbol)())($0e660be785782a7f$var$student_idIsSymbol)())($0e660be785782a7f$var$position_idIsSymbol)())($0e660be785782a7f$var$employer_idIsSymbol)())($0e660be785782a7f$var$coursesIsSymbol)())($0e660be785782a7f$var$contact_idIsSymbol)())($0e660be785782a7f$var$allowed_typesIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$c2f7b8312539f0ea))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons1(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons2($0e660be785782a7f$var$nameIsSymbol)()())($0e660be785782a7f$var$idIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons1(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons2($0e660be785782a7f$var$labelIsSymbol)()())($0e660be785782a7f$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0e660be785782a7f$var$positionsIsSymbol)()())($0e660be785782a7f$var$idIsSymbol)()())($0e660be785782a7f$var$deleted_atIsSymbol)()())($0e660be785782a7f$var$contactsIsSymbol)()())($0e660be785782a7f$var$companyIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons3(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons3(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons3(/* #__PURE__ */ $0e660be785782a7f$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0e660be785782a7f$var$keyIsSymbol)()())($0e660be785782a7f$var$default_last_nameIsSymbol)()())($0e660be785782a7f$var$default_first_nameIsSymbol)()())($0e660be785782a7f$var$default_emailIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0e660be785782a7f$var$signature_fieldsIsSymbol)()())($0e660be785782a7f$var$employerIsSymbol)()())($0e660be785782a7f$var$dataIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0e660be785782a7f$var$rlhsCons($0e660be785782a7f$var$signature_fieldsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0e660be785782a7f$var$rlhsCons($0e660be785782a7f$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0e660be785782a7f$var$default_last_nameIsSymbol)($0e660be785782a7f$var$maybeShape)()())($0e660be785782a7f$var$default_first_nameIsSymbol)($0e660be785782a7f$var$maybeShape)()())($0e660be785782a7f$var$default_emailIsSymbol)($0e660be785782a7f$var$maybeShape)()())()))()())($0e660be785782a7f$var$employerIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0e660be785782a7f$var$rlhsCons($0e660be785782a7f$var$positionsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0e660be785782a7f$var$rlhsCons($0e660be785782a7f$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0e660be785782a7f$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($0e660be785782a7f$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0e660be785782a7f$var$deleted_atIsSymbol)($0e660be785782a7f$var$maybeShape)()())($0e660be785782a7f$var$contactsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0e660be785782a7f$var$rlhsCons($0e660be785782a7f$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0e660be785782a7f$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($0e660be785782a7f$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($0e660be785782a7f$var$dataIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()));
var $0e660be785782a7f$export$2440762e76d53a8c = function(args) {
    var renameArgs = function() {
        var $339 = $0e660be785782a7f$var$modify($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($0e660be785782a7f$var$map($308f9765feb7633d$export$eb1b128a19ff6c25));
        var $340 = $0e660be785782a7f$var$rename($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        var $341 = $0e660be785782a7f$var$rename1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
        return function($342) {
            return $339($340($341($342)));
        };
    }();
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("AutofillForm")($0e660be785782a7f$var$buildQuery("autofillData")(renameArgs(args)));
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16




















var $b5f6b40b8f63b732$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b5f6b40b8f63b732$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $b5f6b40b8f63b732$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $b5f6b40b8f63b732$var$getField1 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5501dc3a72754845($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $b5f6b40b8f63b732$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $b5f6b40b8f63b732$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b5f6b40b8f63b732$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$fee2d5446387c54f));
var $b5f6b40b8f63b732$var$lastPageIsSymbol = {
    reflectSymbol: function() {
        return "lastPage";
    }
};
var $b5f6b40b8f63b732$var$currentPageIsSymbol = {
    reflectSymbol: function() {
        return "currentPage";
    }
};
var $b5f6b40b8f63b732$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $b5f6b40b8f63b732$var$gDecodeJsonCons(/* #__PURE__ */ $b5f6b40b8f63b732$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($b5f6b40b8f63b732$var$lastPageIsSymbol)()())($b5f6b40b8f63b732$var$currentPageIsSymbol)()())());
var $b5f6b40b8f63b732$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $b5f6b40b8f63b732$var$shapeOf = /* #__PURE__ */ $266cd1b01131a218$export$5b88af1c6457fdfe(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08)($b5f6b40b8f63b732$var$lastPageIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($b5f6b40b8f63b732$var$currentPageIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())());
var $b5f6b40b8f63b732$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $b5f6b40b8f63b732$var$query = /* #__PURE__ */ $42ad8b7b0d01e859$export$2fa187e846a241c4($eb7399d322077fcf$export$35d3004eff90f123);
var $b5f6b40b8f63b732$var$Unpaged = /* #__PURE__ */ function() {
    function Unpaged(value0) {
        this.value0 = value0;
    }
    Unpaged.create = function(value0) {
        return new Unpaged(value0);
    };
    return Unpaged;
}();
var $b5f6b40b8f63b732$var$Page = /* #__PURE__ */ function() {
    function Page(value0) {
        this.value0 = value0;
    }
    Page.create = function(value0) {
        return new Page(value0);
    };
    return Page;
}();
var $b5f6b40b8f63b732$var$withPageNo = function(page) {
    return function(json) {
        var v = $2a035e92dc768ac1$export$697e4a1b90752ce2(json);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $0e031af7428ef07d$export$dbafa4424a806c15($c045ea5df33bba60$export$21a5ca8aa77d35ff("page")($0e031af7428ef07d$export$dbafa4424a806c15($4ab74a20512cef04$export$a0a81dc3380ce7d3(page)))(v.value0));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return json;
        throw new Error("Failed pattern match at API.Pagination (line 182, column 5 - line 184, column 25): " + [
            v.constructor.name
        ]);
    };
};
var $b5f6b40b8f63b732$export$2f7ef8bdb1317d03 = function(dictQueryResult) {
    var queryResultDecode = $a40b20519abba0fb$export$61d61702ea4e9b1f(dictQueryResult);
    var queryResultShape = $a40b20519abba0fb$export$b5fb84ac70caa157(dictQueryResult);
    return {
        queryResultDecode: function(qrc) {
            return function(json) {
                return $b5f6b40b8f63b732$var$bind($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($b5f6b40b8f63b732$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(v) {
                    return $b5f6b40b8f63b732$var$getField(v)("data");
                })))(function(inner) {
                    return $b5f6b40b8f63b732$var$map($b5f6b40b8f63b732$var$Unpaged.create)(queryResultDecode(qrc)(inner));
                });
            };
        },
        queryResultShape: function(v) {
            return [
                new $266cd1b01131a218$export$c1da5d38077527d7("data", queryResultShape($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))
            ];
        },
        queryResultArgs: function(v) {
            return [];
        }
    };
};
var $b5f6b40b8f63b732$export$16f20977ea7eb010 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5)(function(v) {
    return v.value0;
});
var $b5f6b40b8f63b732$export$ef2838c17a0cbfd2 = function(v) {
    return v.value0;
};
var $b5f6b40b8f63b732$export$5b1c922c81430b65 = function(v) {
    return v.value0.number;
};
var $b5f6b40b8f63b732$export$9dc5a492d60176d9 = function(v) {
    return v.value0.lastPage;
};
var $b5f6b40b8f63b732$export$f27fff4bf988e19 = function(v) {
    return v.value0.items;
};
var $b5f6b40b8f63b732$export$bdb1e64f51b774cf = "\x0a    paginatorInfo {\x0a        currentPage\x0a        lastPage\x0a    }\x0a";
var $b5f6b40b8f63b732$var$nameExtractor = function(name) {
    return function(json) {
        return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($b5f6b40b8f63b732$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(obj) {
            return $b5f6b40b8f63b732$var$bind($b5f6b40b8f63b732$var$getField1(obj)("data"))(function(v) {
                return $b5f6b40b8f63b732$var$getField(v)(name);
            });
        }));
    };
};
var $b5f6b40b8f63b732$export$d4e35c1cfc1e7503 = {
    map: function(f) {
        return function(v) {
            return new $b5f6b40b8f63b732$var$Page({
                number: v.value0.number,
                lastPage: v.value0.lastPage,
                query: v.value0.query,
                items: $b5f6b40b8f63b732$var$map1(f)(v.value0.items)
            });
        };
    }
};
var $b5f6b40b8f63b732$export$683fc3535a5e61e0 = function(items) {
    return new $b5f6b40b8f63b732$var$Page({
        items: items,
        number: 3,
        lastPage: 10,
        query: {
            qstr: "",
            vars: $0e031af7428ef07d$export$63ea9a5410ee0cef,
            extract: function(v) {
                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("TEST PAGE -- no query"));
            }
        }
    });
};
var $b5f6b40b8f63b732$var$decodePage_ = function(dictDecodeJson) {
    var decodeJson1 = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91($e2b1be82a5e6d14f$export$81879b02e9646afe(dictDecodeJson));
    return function(pq) {
        return function(json) {
            return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($b5f6b40b8f63b732$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(obj) {
                return $b5f6b40b8f63b732$var$bind($b5f6b40b8f63b732$var$bindFlipped($b5f6b40b8f63b732$var$decodeJson)($b5f6b40b8f63b732$var$getField(obj)("paginatorInfo")))(function(v) {
                    return $b5f6b40b8f63b732$var$bind($b5f6b40b8f63b732$var$bindFlipped(decodeJson1)($b5f6b40b8f63b732$var$getField(obj)("data")))(function(items) {
                        return $b5f6b40b8f63b732$var$pure(new $b5f6b40b8f63b732$var$Page({
                            items: items,
                            number: v.currentPage,
                            lastPage: v.lastPage,
                            query: pq
                        }));
                    });
                });
            }));
        };
    };
};
var $b5f6b40b8f63b732$export$5139894cdc05562a = function(dictDecodeJson) {
    var decodePage_1 = $b5f6b40b8f63b732$var$decodePage_(dictDecodeJson);
    return function(dictHasShape) {
        var shapeOf1 = $266cd1b01131a218$export$5b88af1c6457fdfe(dictHasShape);
        return {
            queryResultDecode: function(v) {
                var pq = {
                    extract: $b5f6b40b8f63b732$var$nameExtractor(v.query.name),
                    qstr: v.qstr,
                    vars: v.vars
                };
                return decodePage_1(pq);
            },
            queryResultShape: function(v) {
                return [
                    new $266cd1b01131a218$export$c1da5d38077527d7("paginatorInfo", $b5f6b40b8f63b732$var$shapeOf($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)),
                    new $266cd1b01131a218$export$c1da5d38077527d7("data", shapeOf1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value))
                ];
            },
            queryResultArgs: function(v) {
                return [
                    new $71f2e2e9476163f8$export$1908877435b1d5e9(new $a40b20519abba0fb$export$a90c0bb0b625769b("page", new $308f9765feb7633d$export$a9668a4ddbf1d475(new $308f9765feb7633d$export$c76991cd6baf9718("Int"))), $0e031af7428ef07d$export$63ea9a5410ee0cef)
                ];
            }
        };
    };
};
var $b5f6b40b8f63b732$var$decodePage = function(dictDecodeJson) {
    var decodePage_1 = $b5f6b40b8f63b732$var$decodePage_(dictDecodeJson);
    return function(pq) {
        return function(json) {
            return $b5f6b40b8f63b732$var$bind(pq.extract(json))(decodePage_1(pq));
        };
    };
};
var $b5f6b40b8f63b732$export$717e366ed41e9c24 = function(dictDecodeJson) {
    var decodePage1 = $b5f6b40b8f63b732$var$decodePage(dictDecodeJson);
    return function(dictEncodeJson) {
        var encodeJson = $eb7399d322077fcf$export$a865279d3b7b5f70(dictEncodeJson);
        return function(extract) {
            return function(qstr) {
                return function(vars$prime) {
                    var vars = encodeJson(vars$prime);
                    var pq = {
                        extract: extract,
                        qstr: qstr,
                        vars: vars
                    };
                    return $b5f6b40b8f63b732$var$map2(function(v) {
                        return $b5f6b40b8f63b732$var$bindFlipped(decodePage1(pq))(v);
                    })($b5f6b40b8f63b732$var$query(qstr)($b5f6b40b8f63b732$var$withPageNo(1)(vars)));
                };
            };
        };
    };
};
var $b5f6b40b8f63b732$export$b78194472fb3c720 = function(dictDecodeJson) {
    var pageQuery$prime1 = $b5f6b40b8f63b732$export$717e366ed41e9c24(dictDecodeJson);
    return function(dictEncodeJson) {
        var pageQuery$prime2 = pageQuery$prime1(dictEncodeJson);
        return function(qname) {
            return pageQuery$prime2($b5f6b40b8f63b732$var$nameExtractor(qname));
        };
    };
};
var $b5f6b40b8f63b732$export$af04929cb32c4bb7 = function(dictDecodeJson) {
    var decodePage1 = $b5f6b40b8f63b732$var$decodePage(dictDecodeJson);
    return function(pageNo) {
        return function(v) {
            return $b5f6b40b8f63b732$var$map2(function(v1) {
                return $b5f6b40b8f63b732$var$bindFlipped(decodePage1(v.value0.query))(v1);
            })($b5f6b40b8f63b732$var$query(v.value0.query.qstr)($b5f6b40b8f63b732$var$withPageNo(pageNo)(v.value0.query.vars)));
        };
    };
};


















var $0226bdcd7123f840$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $0226bdcd7123f840$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $0226bdcd7123f840$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $0226bdcd7123f840$var$position_idIsSymbol = {
    reflectSymbol: function() {
        return "position_id";
    }
};
var $0226bdcd7123f840$var$hqtArray = /* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($308f9765feb7633d$export$f4150079df24c8b9);
var $0226bdcd7123f840$var$encodeJsonArray = /* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($308f9765feb7633d$export$65249653a9a6562);
var $0226bdcd7123f840$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $0226bdcd7123f840$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $0226bdcd7123f840$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $0226bdcd7123f840$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $0226bdcd7123f840$var$sub_categoryIsSymbol = {
    reflectSymbol: function() {
        return "sub_category";
    }
};
var $0226bdcd7123f840$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $0226bdcd7123f840$var$descriptionIsSymbol = {
    reflectSymbol: function() {
        return "description";
    }
};
var $0226bdcd7123f840$var$categoryIsSymbol = {
    reflectSymbol: function() {
        return "category";
    }
};
var $0226bdcd7123f840$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $0226bdcd7123f840$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $0226bdcd7123f840$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$sub_categoryIsSymbol)($0226bdcd7123f840$var$maybeShape)()())($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$descriptionIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$categoryIsSymbol)($0226bdcd7123f840$var$maybeShape)()())();
var $0226bdcd7123f840$var$pageQR = /* #__PURE__ */ $b5f6b40b8f63b732$export$5139894cdc05562a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons2(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0226bdcd7123f840$var$sub_categoryIsSymbol)()())($0226bdcd7123f840$var$idIsSymbol)()())($0226bdcd7123f840$var$descriptionIsSymbol)()())($0226bdcd7123f840$var$categoryIsSymbol)()())())($0226bdcd7123f840$var$recShape);
var $0226bdcd7123f840$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons($0226bdcd7123f840$var$position_idIsSymbol)($0226bdcd7123f840$var$hqtArray)($0226bdcd7123f840$var$encodeJsonArray)()())(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther($0226bdcd7123f840$var$position_idIsSymbol)())())($0226bdcd7123f840$var$pageQR);
var $0226bdcd7123f840$var$typeIsSymbol = {
    reflectSymbol: function() {
        return "type";
    }
};
var $0226bdcd7123f840$var$rltvCons1 = /* #__PURE__ */ $0226bdcd7123f840$var$rltvCons($0226bdcd7123f840$var$typeIsSymbol);
var $0226bdcd7123f840$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $0226bdcd7123f840$var$encodeJsonArray1 = /* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($0226bdcd7123f840$var$encRNTY);
var $0226bdcd7123f840$var$firstIsSymbol = {
    reflectSymbol: function() {
        return "first";
    }
};
var $0226bdcd7123f840$var$rltvfConsOther1 = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther($0226bdcd7123f840$var$typeIsSymbol)());
var $0226bdcd7123f840$var$gDecodeJsonCons3 = /* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $0226bdcd7123f840$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $0226bdcd7123f840$var$buildQuery1 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons1(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "OccupationType";
    }
})))($0226bdcd7123f840$var$encodeJsonArray1)()())($0226bdcd7123f840$var$firstIsSymbol)($308f9765feb7633d$export$6d0edca6525afdd8)($eb7399d322077fcf$export$b198596427f378ab)()())(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther1($0226bdcd7123f840$var$firstIsSymbol)())())(/* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons3($0226bdcd7123f840$var$labelIsSymbol)()())($0226bdcd7123f840$var$idIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))));
var $0226bdcd7123f840$var$occupation_idIsSymbol = {
    reflectSymbol: function() {
        return "occupation_id";
    }
};
var $0226bdcd7123f840$var$buildQuery2 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons($0226bdcd7123f840$var$occupation_idIsSymbol)($0226bdcd7123f840$var$hqtArray)($0226bdcd7123f840$var$encodeJsonArray)()())(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther($0226bdcd7123f840$var$occupation_idIsSymbol)())())($0226bdcd7123f840$var$pageQR);
var $0226bdcd7123f840$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $0226bdcd7123f840$var$whereIsSymbol = {
    reflectSymbol: function() {
        return "where";
    }
};
var $0226bdcd7123f840$var$relationIsSymbol = {
    reflectSymbol: function() {
        return "relation";
    }
};
var $0226bdcd7123f840$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b)($eb7399d322077fcf$export$12b4d820b2ffc726)($0226bdcd7123f840$var$relationIsSymbol)();
var $0226bdcd7123f840$var$HASIsSymbol = {
    reflectSymbol: function() {
        return "HAS";
    }
};
var $0226bdcd7123f840$var$conditionIsSymbol = {
    reflectSymbol: function() {
        return "condition";
    }
};
var $0226bdcd7123f840$var$searchIsSymbol = {
    reflectSymbol: function() {
        return "search";
    }
};
var $0226bdcd7123f840$var$rltvCons2 = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons($0226bdcd7123f840$var$whereIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "QueryEmployersWhereWhereConditions";
    }
}))(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3($0226bdcd7123f840$var$gEncodeJsonCons)())($eb7399d322077fcf$export$12b4d820b2ffc726)($0226bdcd7123f840$var$HASIsSymbol)())())($0226bdcd7123f840$var$gEncodeJsonCons)($0226bdcd7123f840$var$conditionIsSymbol)())())($eb7399d322077fcf$export$12b4d820b2ffc726)($0226bdcd7123f840$var$HASIsSymbol)())()))()())($0226bdcd7123f840$var$searchIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()();
var $0226bdcd7123f840$var$rltvfConsRec = /* #__PURE__ */ $a40b20519abba0fb$export$4db8a34bb8c07ace($a40b20519abba0fb$export$fe891b8934c38330)($0226bdcd7123f840$var$HASIsSymbol)()();
var $0226bdcd7123f840$var$rltvfConsOther2 = /* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther($0226bdcd7123f840$var$relationIsSymbol)();
var $0226bdcd7123f840$var$rltvfConsOther3 = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c($a40b20519abba0fb$export$fe891b8934c38330)($0226bdcd7123f840$var$whereIsSymbol)()()(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsRec(/* #__PURE__ */ $a40b20519abba0fb$export$4db8a34bb8c07ace($0226bdcd7123f840$var$rltvfConsOther2)($0226bdcd7123f840$var$conditionIsSymbol)()()(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsRec($0226bdcd7123f840$var$rltvfConsOther2)))))($0226bdcd7123f840$var$searchIsSymbol)();
var $0226bdcd7123f840$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $0226bdcd7123f840$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $0226bdcd7123f840$var$gDecodeJsonCons4 = /* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons3($0226bdcd7123f840$var$nameIsSymbol)()());
var $0226bdcd7123f840$var$expectationsIsSymbol = {
    reflectSymbol: function() {
        return "expectations";
    }
};
var $0226bdcd7123f840$var$positionsIsSymbol = {
    reflectSymbol: function() {
        return "positions";
    }
};
var $0226bdcd7123f840$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $0226bdcd7123f840$var$rlhsCons1 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()());
var $0226bdcd7123f840$var$unpagedQR = /* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0226bdcd7123f840$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0226bdcd7123f840$var$dataIsSymbol)()())()))(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons4($0226bdcd7123f840$var$idIsSymbol)()())($0226bdcd7123f840$var$expectationsIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($0226bdcd7123f840$var$positionsIsSymbol)()())($0226bdcd7123f840$var$idIsSymbol)()())($0226bdcd7123f840$var$companyIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$positionsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons1($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$expectationsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$dataIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())())()())()))()())($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())));
var $0226bdcd7123f840$var$buildQuery3 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f($0226bdcd7123f840$var$rltvCons2)($0226bdcd7123f840$var$rltvfConsOther3)())($0226bdcd7123f840$var$unpagedQR);
var $0226bdcd7123f840$var$form_idIsSymbol = {
    reflectSymbol: function() {
        return "form_id";
    }
};
var $0226bdcd7123f840$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $0226bdcd7123f840$var$buildQuery4 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($0226bdcd7123f840$var$rltvCons2)($0226bdcd7123f840$var$form_idIsSymbol)($0226bdcd7123f840$var$rntyType)($0226bdcd7123f840$var$encRNTY)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($0226bdcd7123f840$var$rltvfConsOther3)($0226bdcd7123f840$var$form_idIsSymbol)())())($0226bdcd7123f840$var$unpagedQR);
var $0226bdcd7123f840$var$student_idIsSymbol = {
    reflectSymbol: function() {
        return "student_id";
    }
};
var $0226bdcd7123f840$var$group_labelIsSymbol = {
    reflectSymbol: function() {
        return "group_label";
    }
};
var $0226bdcd7123f840$var$rlhsCons2 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $0226bdcd7123f840$var$rlhsCons1($0226bdcd7123f840$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($0226bdcd7123f840$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()();
var $0226bdcd7123f840$var$buildQuery5 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons($0226bdcd7123f840$var$student_idIsSymbol)($0226bdcd7123f840$var$rntyType)($0226bdcd7123f840$var$encRNTY)()())(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther($0226bdcd7123f840$var$student_idIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons1(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons2(/* #__PURE__ */ $0226bdcd7123f840$var$gDecodeJsonCons4($0226bdcd7123f840$var$labelIsSymbol)()())($0226bdcd7123f840$var$idIsSymbol)()())($0226bdcd7123f840$var$group_labelIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($0226bdcd7123f840$var$rlhsCons2)($0226bdcd7123f840$var$group_labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())));
var $0226bdcd7123f840$var$course_idIsSymbol = {
    reflectSymbol: function() {
        return "course_id";
    }
};
var $0226bdcd7123f840$export$af1746a6d1d4ebef = /* #__PURE__ */ function() {
    function Overall() {}
    Overall.value = new Overall();
    return Overall;
}();
var $0226bdcd7123f840$export$f58dccbea7b737e8 = /* #__PURE__ */ function() {
    function Specific() {}
    Specific.value = new Specific();
    return Specific;
}();
var $0226bdcd7123f840$export$79d5a7efb6b41199 = {
    decodeJson: function(json) {
        var v = $2a035e92dc768ac1$export$f84e8e69fd4488a5(json);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "OVERALL") return new $7d4cccdf062a2261$export$19db0165690c701a($0226bdcd7123f840$export$af1746a6d1d4ebef.value);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 === "SPECIFIC") return new $7d4cccdf062a2261$export$19db0165690c701a($0226bdcd7123f840$export$f58dccbea7b737e8.value);
        return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2(json));
    }
};
var $0226bdcd7123f840$export$88b699b872af7a6e = /* #__PURE__ */ function() {
    var filteredPositions = function(emp) {
        return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(pos) {
            return $0226bdcd7123f840$var$length(pos.expectations.data) > 0;
        })(emp.positions);
    };
    var processEmployer = function(emp) {
        return $0226bdcd7123f840$var$map(function(pos) {
            return {
                label: emp.company + (" - " + pos.name),
                value: {
                    id: pos.id
                }
            };
        })(filteredPositions(emp));
    };
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(processEmployer);
}();
var $0226bdcd7123f840$export$1fcceae2e2b360b0 = function(id) {
    return $0226bdcd7123f840$var$buildQuery("expectations")({
        position_id: [
            new $308f9765feb7633d$export$95d18696cb32267f(id)
        ]
    });
};
var $0226bdcd7123f840$export$87e7aa554e97c234 = function(otype$prime) {
    var otype = $308f9765feb7633d$export$eb1b128a19ff6c25(otype$prime);
    return $b5f6b40b8f63b732$export$16f20977ea7eb010($0226bdcd7123f840$var$buildQuery1("occupations")({
        type: [
            otype
        ],
        first: 2147483647
    }));
};
var $0226bdcd7123f840$export$d0125f9363e1a97d = function(otype) {
    return $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
        return v.label;
    })($7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
        return v.label;
    })($0226bdcd7123f840$export$87e7aa554e97c234(otype)));
};
var $0226bdcd7123f840$export$8801cc9b6504019f = function(id) {
    return $0226bdcd7123f840$var$buildQuery2("expectations")({
        occupation_id: [
            new $308f9765feb7633d$export$95d18696cb32267f(id)
        ]
    });
};
var $0226bdcd7123f840$export$a48aa3c5f903cf7c = $0226bdcd7123f840$export$8801cc9b6504019f;
var $0226bdcd7123f840$export$8881ef1a9996dd = function(v) {
    return {
        id: v.id,
        name: v.name,
        label: v.label
    };
};
var $0226bdcd7123f840$export$8b2c6eda8494b10b = /* #__PURE__ */ function() {
    return $266cd1b01131a218$export$55dbabd51ced92f5($266cd1b01131a218$export$5b88af1c6457fdfe($0226bdcd7123f840$var$recShape)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
}();
var $0226bdcd7123f840$export$10f004625337249d = function(v) {
    return {
        id: v.id,
        name: v.name,
        label: v.label,
        group_label: ""
    };
};
var $0226bdcd7123f840$export$cc01e92ef90babd2 = {
    gqlType: function(v) {
        return new $308f9765feb7633d$export$c76991cd6baf9718("ExpectationType");
    }
};
var $0226bdcd7123f840$export$edb59ccba836f118 = {
    encodeJson: function(v) {
        if (v instanceof $0226bdcd7123f840$export$af1746a6d1d4ebef) return $0e031af7428ef07d$export$dbafa4424a806c15("OVERALL");
        if (v instanceof $0226bdcd7123f840$export$f58dccbea7b737e8) return $0e031af7428ef07d$export$dbafa4424a806c15("SPECIFIC");
        throw new Error("Failed pattern match at API.Expectations (line 147, column 1 - line 149, column 50): " + [
            v.constructor.name
        ]);
    }
};
var $0226bdcd7123f840$var$buildQuery6 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $0226bdcd7123f840$var$rltvCons1(/* #__PURE__ */ $308f9765feb7633d$export$9040d00d71e77b23(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($0226bdcd7123f840$export$cc01e92ef90babd2)))(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($0226bdcd7123f840$export$edb59ccba836f118)))()())($0226bdcd7123f840$var$course_idIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($0226bdcd7123f840$var$rntyType))($0226bdcd7123f840$var$encodeJsonArray1)()())(/* #__PURE__ */ $0226bdcd7123f840$var$rltvfConsOther1($0226bdcd7123f840$var$course_idIsSymbol)())())($0226bdcd7123f840$var$pageQR);
var $0226bdcd7123f840$export$50870e9090ea8a39 = /* #__PURE__ */ $308f9765feb7633d$export$eb1b128a19ff6c25({
    HAS: {
        relation: "positions",
        condition: {
            HAS: {
                relation: "expectations"
            }
        }
    }
});
var $0226bdcd7123f840$export$dc7f56f0187a8022 = function(search) {
    return $0226bdcd7123f840$var$map1($0226bdcd7123f840$export$88b699b872af7a6e)($b5f6b40b8f63b732$export$16f20977ea7eb010($0226bdcd7123f840$var$buildQuery3("employers")({
        search: search,
        where: $0226bdcd7123f840$export$50870e9090ea8a39
    })));
};
var $0226bdcd7123f840$export$ace064cf72b3c833 = /* #__PURE__ */ function() {
    return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
        return $0226bdcd7123f840$export$dc7f56f0187a8022(search);
    });
}();
var $0226bdcd7123f840$export$509b45438265c933 = function(form_id) {
    return function(search) {
        return $0226bdcd7123f840$var$map1($0226bdcd7123f840$export$88b699b872af7a6e)($b5f6b40b8f63b732$export$16f20977ea7eb010($0226bdcd7123f840$var$buildQuery4("employers")({
            form_id: form_id,
            search: search,
            where: $0226bdcd7123f840$export$50870e9090ea8a39
        })));
    };
};
var $0226bdcd7123f840$export$805545b03d68a96b = function(docId) {
    return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
        return $0226bdcd7123f840$export$509b45438265c933(docId)(search);
    });
};
var $0226bdcd7123f840$export$9bdd671ea78c9ba9 = function(student_id) {
    return $0226bdcd7123f840$var$buildQuery5("courses")({
        student_id: student_id
    });
};
var $0226bdcd7123f840$export$8ff95a4bad83b9f = function(student) {
    return $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
        return v.label;
    })($7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
        return v.label;
    })($0226bdcd7123f840$export$9bdd671ea78c9ba9(student)));
};
var $0226bdcd7123f840$export$7942e7ab8894ba48 = /* #__PURE__ */ function() {
    return $266cd1b01131a218$export$55dbabd51ced92f5($266cd1b01131a218$export$5b88af1c6457fdfe($266cd1b01131a218$export$5cdfc842db1bd206($0226bdcd7123f840$var$rlhsCons2)())($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
}();
var $0226bdcd7123f840$export$92dfd4e6d3bf8909 = function(types) {
    return function(id) {
        return $0226bdcd7123f840$var$buildQuery6("expectations")({
            course_id: [
                id
            ],
            type: $c3ec47a57216184e$export$71e337785367343c($0226bdcd7123f840$var$length(types) > 0)(types)
        });
    };
};


// Generated by purs version 0.15.16









var $e776f62b9df165a6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $e776f62b9df165a6$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $e776f62b9df165a6$var$student_idIsSymbol = {
    reflectSymbol: function() {
        return "student_id";
    }
};
var $e776f62b9df165a6$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $e776f62b9df165a6$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $e776f62b9df165a6$var$rltvCons1 = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $e776f62b9df165a6$var$rltvCons($e776f62b9df165a6$var$student_idIsSymbol)($e776f62b9df165a6$var$rntyType)($e776f62b9df165a6$var$encRNTY)()());
var $e776f62b9df165a6$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $e776f62b9df165a6$var$form_idIsSymbol = {
    reflectSymbol: function() {
        return "form_id";
    }
};
var $e776f62b9df165a6$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $e776f62b9df165a6$var$rltvfConsOther1 = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $e776f62b9df165a6$var$rltvfConsOther($e776f62b9df165a6$var$student_idIsSymbol)());
var $e776f62b9df165a6$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $e776f62b9df165a6$var$rltvCons1($e776f62b9df165a6$var$idIsSymbol)($e776f62b9df165a6$var$rntyType)($e776f62b9df165a6$var$encRNTY)()())($e776f62b9df165a6$var$form_idIsSymbol)($e776f62b9df165a6$var$rntyType)($e776f62b9df165a6$var$encRNTY)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $e776f62b9df165a6$var$rltvfConsOther1($e776f62b9df165a6$var$idIsSymbol)())($e776f62b9df165a6$var$form_idIsSymbol)())());
var $e776f62b9df165a6$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $e776f62b9df165a6$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $e776f62b9df165a6$var$gDecodeJsonCons2 = /* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $e776f62b9df165a6$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $e776f62b9df165a6$var$positionsIsSymbol = {
    reflectSymbol: function() {
        return "positions";
    }
};
var $e776f62b9df165a6$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons2($e776f62b9df165a6$var$labelIsSymbol)()())($e776f62b9df165a6$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($e776f62b9df165a6$var$positionsIsSymbol)()();
var $e776f62b9df165a6$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $e776f62b9df165a6$var$rlhsCons1 = /* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons($e776f62b9df165a6$var$positionsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons($e776f62b9df165a6$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e776f62b9df165a6$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()();
var $e776f62b9df165a6$var$buildQuery1 = /* #__PURE__ */ $e776f62b9df165a6$var$buildQuery(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($e776f62b9df165a6$var$gDecodeJsonCons3)())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206($e776f62b9df165a6$var$rlhsCons1)()));
var $e776f62b9df165a6$var$searchIsSymbol = {
    reflectSymbol: function() {
        return "search";
    }
};
var $e776f62b9df165a6$var$buildQuery2 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $e776f62b9df165a6$var$rltvCons1($e776f62b9df165a6$var$searchIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()())($e776f62b9df165a6$var$form_idIsSymbol)($e776f62b9df165a6$var$rntyType)($e776f62b9df165a6$var$encRNTY)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $e776f62b9df165a6$var$rltvfConsOther1($e776f62b9df165a6$var$searchIsSymbol)())($e776f62b9df165a6$var$form_idIsSymbol)())());
var $e776f62b9df165a6$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $e776f62b9df165a6$var$buildQuery3 = /* #__PURE__ */ $e776f62b9df165a6$var$buildQuery2(/* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons1(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($e776f62b9df165a6$var$idIsSymbol)()())($e776f62b9df165a6$var$companyIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons($e776f62b9df165a6$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e776f62b9df165a6$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))));
var $e776f62b9df165a6$var$gDecodeJsonCons4 = /* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons($e776f62b9df165a6$var$gDecodeJsonCons3)($e776f62b9df165a6$var$idIsSymbol)()();
var $e776f62b9df165a6$var$rlhsCons2 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($e776f62b9df165a6$var$rlhsCons1)($e776f62b9df165a6$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()());
var $e776f62b9df165a6$var$buildQuery4 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $e776f62b9df165a6$var$rltvCons($e776f62b9df165a6$var$searchIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()())(/* #__PURE__ */ $e776f62b9df165a6$var$rltvfConsOther($e776f62b9df165a6$var$searchIsSymbol)())())(/* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons1($e776f62b9df165a6$var$gDecodeJsonCons4)($e776f62b9df165a6$var$companyIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons2($e776f62b9df165a6$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))));
var $e776f62b9df165a6$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $e776f62b9df165a6$var$gDecodeJsonCons5 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons2($e776f62b9df165a6$var$nameIsSymbol)()())($e776f62b9df165a6$var$idIsSymbol)()())())));
var $e776f62b9df165a6$var$deleted_atIsSymbol = {
    reflectSymbol: function() {
        return "deleted_at";
    }
};
var $e776f62b9df165a6$var$contactsIsSymbol = {
    reflectSymbol: function() {
        return "contacts";
    }
};
var $e776f62b9df165a6$var$arrayShape = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons($e776f62b9df165a6$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e776f62b9df165a6$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())());
var $e776f62b9df165a6$var$buildQuery5 = /* #__PURE__ */ $e776f62b9df165a6$var$buildQuery2(/* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons1(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons5(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))($e776f62b9df165a6$var$gDecodeJsonCons4)($e776f62b9df165a6$var$deleted_atIsSymbol)()())($e776f62b9df165a6$var$contactsIsSymbol)()())($e776f62b9df165a6$var$companyIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons2($e776f62b9df165a6$var$deleted_atIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621))()())($e776f62b9df165a6$var$contactsIsSymbol)($e776f62b9df165a6$var$arrayShape)()())($e776f62b9df165a6$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))));
var $e776f62b9df165a6$var$buildQuery6 = /* #__PURE__ */ $e776f62b9df165a6$var$buildQuery(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e776f62b9df165a6$var$gDecodeJsonCons5($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($e776f62b9df165a6$var$contactsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $e776f62b9df165a6$var$rlhsCons($e776f62b9df165a6$var$contactsIsSymbol)($e776f62b9df165a6$var$arrayShape)()())()));
var $e776f62b9df165a6$var$positionList = function(form_id) {
    return function(student_id) {
        return function(employer) {
            var process = function(v) {
                return v.positions;
            };
            return $a40b20519abba0fb$export$bc1f9bac519c56f6("EmployerPositions")($e776f62b9df165a6$var$map(process)($e776f62b9df165a6$var$buildQuery1("employer")({
                form_id: form_id,
                student_id: student_id,
                id: employer
            })));
        };
    };
};
var $e776f62b9df165a6$export$8f428e086e902ded = function(form) {
    return function(student) {
        return function(employer) {
            return $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
                return v.label;
            })($7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
                return v.label;
            })($e776f62b9df165a6$var$positionList(form)(student)(employer)));
        };
    };
};
var $e776f62b9df165a6$export$7743b1e1d07cdac1 = "id, label";
var $e776f62b9df165a6$export$ef62e8d4627802c3 = function(dictQueryResult) {
    var buildQuery7 = $e776f62b9df165a6$var$buildQuery(dictQueryResult);
    return function(id) {
        return function(form_id) {
            return function(student_id) {
                return $a40b20519abba0fb$export$bc1f9bac519c56f6("GetEmployer")(buildQuery7("employer")({
                    id: id,
                    student_id: student_id,
                    form_id: form_id
                }));
            };
        };
    };
};
var $e776f62b9df165a6$export$128de05462604d14 = function(form_id) {
    return function(student_id) {
        return function(search) {
            return $a40b20519abba0fb$export$bc1f9bac519c56f6("EmployerSearch")($b5f6b40b8f63b732$export$16f20977ea7eb010($e776f62b9df165a6$var$buildQuery3("employers")({
                form_id: form_id,
                student_id: student_id,
                search: search
            })));
        };
    };
};
var $e776f62b9df165a6$export$ab7b60cea5188b81 = function(form) {
    return function(student) {
        return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
            return $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
                return v.company;
            })($e776f62b9df165a6$export$128de05462604d14(form)(student)(search));
        });
    };
};
var $e776f62b9df165a6$var$employerPosSearch = function(search) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("EmployerPositionsSearch")($b5f6b40b8f63b732$export$16f20977ea7eb010($e776f62b9df165a6$var$buildQuery4("employers")({
        search: search
    })));
};
var $e776f62b9df165a6$export$805545b03d68a96b = /* #__PURE__ */ function() {
    return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
        return $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
            return v.company;
        })($e776f62b9df165a6$var$employerPosSearch(search));
    });
}();
var $e776f62b9df165a6$var$employerPosConSearch = function(form_id) {
    return function(student_id) {
        return function(search) {
            return $a40b20519abba0fb$export$bc1f9bac519c56f6("EmployerPositionsContacts")($b5f6b40b8f63b732$export$16f20977ea7eb010($e776f62b9df165a6$var$buildQuery5("employers")({
                form_id: form_id,
                student_id: student_id,
                search: search
            })));
        };
    };
};
var $e776f62b9df165a6$export$58d01f439dbdc886 = function(fid) {
    return function(sid) {
        return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
            return $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
                return v.company;
            })($e776f62b9df165a6$var$employerPosConSearch(fid)(sid)(search));
        });
    };
};
var $e776f62b9df165a6$export$d791cde3983a069e = "id, company";
var $e776f62b9df165a6$var$contactList = function(form_id) {
    return function(student_id) {
        return function(employer) {
            var process = function(v) {
                return v.contacts;
            };
            return $a40b20519abba0fb$export$bc1f9bac519c56f6("EmployerContacts")($e776f62b9df165a6$var$map(process)($e776f62b9df165a6$var$buildQuery6("employer")({
                form_id: form_id,
                student_id: student_id,
                id: employer
            })));
        };
    };
};
var $e776f62b9df165a6$export$ac1bd8a342846243 = function(form) {
    return function(student) {
        return function(employer) {
            return $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
                return v.label;
            })($7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
                return v.name;
            })($e776f62b9df165a6$var$contactList(form)(student)(employer)));
        };
    };
};
var $e776f62b9df165a6$export$d9dc7a16c395e876 = "id, name";
































// Generated by purs version 0.15.16












var $2acecf8dc1456b13$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $2acecf8dc1456b13$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $2acecf8dc1456b13$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $2acecf8dc1456b13$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $2acecf8dc1456b13$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $2acecf8dc1456b13$var$foldM = /* #__PURE__ */ $4fe7b6acfba7f29f$export$7a067f9280ad8af0($4fe7b6acfba7f29f$export$e97014618a7eb593)($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $2acecf8dc1456b13$export$4cb5f64d5a13eb2b = /* #__PURE__ */ function() {
    function ObjectKey(value0) {
        this.value0 = value0;
    }
    ObjectKey.create = function(value0) {
        return new ObjectKey(value0);
    };
    return ObjectKey;
}();
var $2acecf8dc1456b13$export$df9ca5de1fb34275 = /* #__PURE__ */ function() {
    function ArrayIndex(value0) {
        this.value0 = value0;
    }
    ArrayIndex.create = function(value0) {
        return new ArrayIndex(value0);
    };
    return ArrayIndex;
}();
var $2acecf8dc1456b13$export$f67be9d9b0e25d7b = function(v) {
    if ($2a035e92dc768ac1$export$844ec244b1367d54(v)) return $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("String"))($2a035e92dc768ac1$export$f84e8e69fd4488a5(v));
    if ($2a035e92dc768ac1$export$7e4aa119212bc614(v)) return $7d4cccdf062a2261$export$a92e4c44d367d0af(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Number"))($2acecf8dc1456b13$var$map($2acecf8dc1456b13$var$map1($2acecf8dc1456b13$var$show)($8d5664f12212b23e$export$a3fe094919f356fd))($2a035e92dc768ac1$export$a0a81dc3380ce7d3(v)));
    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("String or Number"));
};
var $2acecf8dc1456b13$export$3a60d841d40ccce7 = function(v) {
    if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515($826fbbc6c8d1e9e2$export$f0345d087708be2e(v.value0));
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    throw new Error("Failed pattern match at Internal.JsonUtil (line 29, column 1 - line 29, column 73): " + [
        v.constructor.name
    ]);
};
var $2acecf8dc1456b13$export$a0a4ca47aa42be8b = function(json) {
    var v = $2a035e92dc768ac1$export$697e4a1b90752ce2(json);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Expected object"));
    throw new Error("Failed pattern match at Internal.JsonUtil (line 17, column 21 - line 19, column 53): " + [
        v.constructor.name
    ]);
};
var $2acecf8dc1456b13$export$90eb2bb7ff267a36 = function(json) {
    var v = $2a035e92dc768ac1$export$45b10814cc054894(json);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$168e2d3b16829a("Expected array"));
    throw new Error("Failed pattern match at Internal.JsonUtil (line 24, column 20 - line 26, column 52): " + [
        v.constructor.name
    ]);
};
var $2acecf8dc1456b13$export$8c3e13c45a09f0c1 = function(v) {
    return function(v1) {
        if (v instanceof $2acecf8dc1456b13$export$4cb5f64d5a13eb2b) return $2acecf8dc1456b13$var$bind($2acecf8dc1456b13$export$a0a4ca47aa42be8b(v1))(function(v2) {
            return $2acecf8dc1456b13$var$getField(v2)(v.value0);
        });
        if (v instanceof $2acecf8dc1456b13$export$df9ca5de1fb34275) {
            var err = new $826fbbc6c8d1e9e2$export$d58b23382c8562e(v.value0, $826fbbc6c8d1e9e2$export$d171f9c68f3539d0.value);
            return $2acecf8dc1456b13$var$bind($2acecf8dc1456b13$export$90eb2bb7ff267a36(v1))(function(j) {
                return $7d4cccdf062a2261$export$a92e4c44d367d0af(err)($396c4c3d9e7fae3c$export$b610b8812bbcded9(j)(v.value0));
            });
        }
        throw new Error("Failed pattern match at Internal.JsonUtil (line 39, column 1 - line 39, column 70): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $2acecf8dc1456b13$export$ec1d695c27723c7d = function(path) {
    return function(json) {
        return $2acecf8dc1456b13$var$foldM(function(j) {
            return function(p) {
                return $2acecf8dc1456b13$export$8c3e13c45a09f0c1(p)(j);
            };
        })(json)(path);
    };
};







// Generated by purs version 0.15.16
"use strict";
const $0b581ac4bf89c24e$export$95e51d18384bce0 = function(eid) {
    return function(_, onSuccess) {
        window.addEventListener("closedEmployerModal", function(ev) {
            if (ev.detail.fromCancel) onSuccess(null);
            else onSuccess(ev.detail.clientId.toString());
        });
        Livewire.emit('openModal', 'employers.create-employer', {
            mode: 1,
            clientId: eid
        });
        return function(_a, _b, onCancelled) {
            onCancelled();
        };
    };
};









var $e0dae94260b9d371$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $e0dae94260b9d371$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $e0dae94260b9d371$export$2d6ae09600947940 = function(id) {
    return $e0dae94260b9d371$var$map(function(v) {
        return $e0dae94260b9d371$var$map1($308f9765feb7633d$export$a7f53fa461221c79)(v);
    })($e0dae94260b9d371$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($3257df7cdef77623$export$b97f2ad8d0b7442d($107430d2749bac15$export$2e3eef4f26ade0f7($0b581ac4bf89c24e$export$95e51d18384bce0($0a5aaf95f168428e$export$b187f57ee1822bc5($e0dae94260b9d371$var$map1($308f9765feb7633d$export$a1b0f5347d2470b)(id)))))));
};


// Generated by purs version 0.15.16













var $f388db8e60bd7b97$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $f388db8e60bd7b97$export$ecf6106d7890d9bf = /* #__PURE__ */ function() {
    function FWAutoFill(value0) {
        this.value0 = value0;
    }
    FWAutoFill.create = function(value0) {
        return new FWAutoFill(value0);
    };
    return FWAutoFill;
}();
var $f388db8e60bd7b97$export$35802c6c714ae0 = /* #__PURE__ */ function() {
    function FormWidgetResult(value0) {
        this.value0 = value0;
    }
    FormWidgetResult.create = function(value0) {
        return new FormWidgetResult(value0);
    };
    return FormWidgetResult;
}();
var $f388db8e60bd7b97$export$83925c2318996255 = function(dict) {
    return dict.toWidget;
};
var $f388db8e60bd7b97$export$89aa195e4b27a289 = function(dictFormWidget) {
    return function(dictDecodeJson) {
        var decodeJson = $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(dictDecodeJson);
        return function(v) {
            return function(inner) {
                return function(json) {
                    return $f388db8e60bd7b97$var$bind($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)(decodeJson(json)))(function(val) {
                        return inner(val);
                    });
                };
            };
        };
    };
};
var $f388db8e60bd7b97$export$3a6802af14bf5fa6 = function(dict) {
    return dict.setData;
};
var $f388db8e60bd7b97$export$fc873be648364fa2 = function(v) {
    return function(s) {
        return function(v1) {
            return new $7d4cccdf062a2261$export$19db0165690c701a(s);
        };
    };
};
var $f388db8e60bd7b97$export$c9b8b4835d12ce15 = function(v) {
    return function(v1) {
        return $0e031af7428ef07d$export$63ea9a5410ee0cef;
    };
};
var $f388db8e60bd7b97$export$e132ced8f644a612 = function(dict) {
    return dict.isLeaf;
};
var $f388db8e60bd7b97$export$a5b3020661ae748a = function(account) {
    return function(doc) {
        return {
            parentIds: "",
            curIndex: 0,
            doc: new $06733ae99ed4f534$export$8a67b48435b5d073(doc),
            isAutofilling: false,
            autofillArgs: $0e660be785782a7f$export$b56a159182574c04(doc.formId)(doc.student.id),
            account: account,
            access: $81439e1d9c94314f$export$e3358a95f047f6be
        };
    };
};
var $f388db8e60bd7b97$export$218c8c3169c024d2 = function(dict) {
    return dict.getId;
};
var $f388db8e60bd7b97$export$7a171f172be0782e = function(dict) {
    return dict.getData;
};
var $f388db8e60bd7b97$export$95f6bcb3dd5567b3 = {
    map: function(f) {
        return function(v) {
            return new $f388db8e60bd7b97$export$35802c6c714ae0({
                action: v.value0.action,
                state: f(v.value0.state)
            });
        };
    }
};
var $f388db8e60bd7b97$export$e0d76edcf577b85d = function(state) {
    return new $f388db8e60bd7b97$export$35802c6c714ae0({
        state: state,
        action: $06733ae99ed4f534$export$bebe9059409a0d04.value
    });
};
var $f388db8e60bd7b97$export$a9ba8100218e287d = function(state) {
    return function(act) {
        return new $f388db8e60bd7b97$export$35802c6c714ae0({
            state: state,
            action: new $06733ae99ed4f534$export$8a67b48435b5d073(act)
        });
    };
};
var $f388db8e60bd7b97$export$e47c1863c8ac83c1 = function(dict) {
    return dict.fieldPaths;
};
var $f388db8e60bd7b97$export$20223e4a23036829 = function(v) {
    return function(v1) {
        if (v.parentIds === "") return v1;
        return v.parentIds + ("." + v1);
    };
};
var $f388db8e60bd7b97$export$c7df680a10db757f = function(fc) {
    return function(id) {
        return $81439e1d9c94314f$export$4dcf4ecf95fdafb5(fc.access)($f388db8e60bd7b97$export$20223e4a23036829(fc)(id));
    };
};
var $f388db8e60bd7b97$export$c81c5cb05f170172 = function(v) {
    if (v.cls === "") return "flex flex-wrap col-span-12";
    var $33 = $1a77d6934b592676$export$2344b14b097df817("col-span-")(v.cls);
    if ($33) return "flex flex-wrap " + v.cls;
    return "flex flex-wrap col-span-12 " + v.cls;
};
var $f388db8e60bd7b97$export$6ae8b9028cb9b43c = function(fc) {
    return function(id) {
        return $81439e1d9c94314f$export$7628927e17b1a329(fc.access)($f388db8e60bd7b97$export$20223e4a23036829(fc)(id));
    };
};
var $f388db8e60bd7b97$export$330cf2b9485e792b = function(fc) {
    var $38 = $f388db8e60bd7b97$export$6ae8b9028cb9b43c(fc);
    return function($39) {
        return $81439e1d9c94314f$export$83c457eff4ed3d7f($38($39));
    };
};
var $f388db8e60bd7b97$export$fa08b6e125c129f2 = function(fc) {
    return function(id) {
        if ($f388db8e60bd7b97$export$330cf2b9485e792b(fc)(id)) return [];
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return [
            $fc1df90f0e252058$export$683472f6198a076e(true),
            $fc1df90f0e252058$export$9a625f9de50bf0b7(-1)
        ];
        throw new Error("Failed pattern match at Widgets.Form.Class (line 90, column 1 - line 90, column 76): " + [
            fc.constructor.name,
            id.constructor.name
        ]);
    };
};
var $f388db8e60bd7b97$export$16add92498609946 = function(fc) {
    var $40 = $f388db8e60bd7b97$export$6ae8b9028cb9b43c(fc);
    return function($41) {
        return $81439e1d9c94314f$export$69918eedfc84398($40($41));
    };
};
var $f388db8e60bd7b97$export$5f8bbb7bf801e4b8 = /* #__PURE__ */ function() {
    return {
        parentIds: "",
        curIndex: 0,
        doc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        isAutofilling: false,
        autofillArgs: $0e660be785782a7f$export$b56a159182574c04($308f9765feb7633d$export$f5ab442a98b1cecf)($308f9765feb7633d$export$f5ab442a98b1cecf),
        account: {
            type: $02eacf321b2a2128$export$6f3aad56498a7cb9.value,
            student: $06733ae99ed4f534$export$bebe9059409a0d04.value
        },
        access: $81439e1d9c94314f$export$e3358a95f047f6be
    };
}();
var $f388db8e60bd7b97$export$5a271d199eca9d6f = function(dict) {
    return dict.asField;
};
var $f388db8e60bd7b97$export$94eddf153554b360 = function(fc) {
    return function(id) {
        return {
            curIndex: fc.curIndex,
            isAutofilling: fc.isAutofilling,
            autofillArgs: fc.autofillArgs,
            account: fc.account,
            doc: fc.doc,
            access: fc.access,
            parentIds: $f388db8e60bd7b97$export$20223e4a23036829(fc)(id)
        };
    };
};


var $e594c6d0cea1455d$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $e594c6d0cea1455d$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($e594c6d0cea1455d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $e594c6d0cea1455d$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($e594c6d0cea1455d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $e594c6d0cea1455d$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $e594c6d0cea1455d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $e594c6d0cea1455d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $e594c6d0cea1455d$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $e594c6d0cea1455d$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $e594c6d0cea1455d$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $e594c6d0cea1455d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $e594c6d0cea1455d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $e594c6d0cea1455d$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $e594c6d0cea1455d$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $e594c6d0cea1455d$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $e594c6d0cea1455d$var$groupOptsByKey = /* #__PURE__ */ $7178b396566f5a79$export$142a4d5d80d395de($97937c29f879e68e$export$c5f2758e49b2b86a);
var $e594c6d0cea1455d$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $e594c6d0cea1455d$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $e594c6d0cea1455d$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $e594c6d0cea1455d$var$gDecodeJsonCons2 = /* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $e594c6d0cea1455d$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $e594c6d0cea1455d$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $e594c6d0cea1455d$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $e594c6d0cea1455d$var$positionsIsSymbol = {
    reflectSymbol: function() {
        return "positions";
    }
};
var $e594c6d0cea1455d$var$deleted_atIsSymbol = {
    reflectSymbol: function() {
        return "deleted_at";
    }
};
var $e594c6d0cea1455d$var$contactsIsSymbol = {
    reflectSymbol: function() {
        return "contacts";
    }
};
var $e594c6d0cea1455d$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $e594c6d0cea1455d$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $e594c6d0cea1455d$var$getEmployer = /* #__PURE__ */ $e776f62b9df165a6$export$ef62e8d4627802c3(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons1(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons2($e594c6d0cea1455d$var$nameIsSymbol)()())($e594c6d0cea1455d$var$idIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons1(/* #__PURE__ */ $e594c6d0cea1455d$var$gDecodeJsonCons2($e594c6d0cea1455d$var$labelIsSymbol)()())($e594c6d0cea1455d$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($e594c6d0cea1455d$var$positionsIsSymbol)()())($e594c6d0cea1455d$var$idIsSymbol)()())($e594c6d0cea1455d$var$deleted_atIsSymbol)()())($e594c6d0cea1455d$var$contactsIsSymbol)()())($e594c6d0cea1455d$var$companyIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e594c6d0cea1455d$var$rlhsCons($e594c6d0cea1455d$var$positionsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e594c6d0cea1455d$var$rlhsCons($e594c6d0cea1455d$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e594c6d0cea1455d$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($e594c6d0cea1455d$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e594c6d0cea1455d$var$deleted_atIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621))()())($e594c6d0cea1455d$var$contactsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $e594c6d0cea1455d$var$rlhsCons($e594c6d0cea1455d$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($e594c6d0cea1455d$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($e594c6d0cea1455d$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()));
var $e594c6d0cea1455d$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $e594c6d0cea1455d$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($e594c6d0cea1455d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $e594c6d0cea1455d$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $e594c6d0cea1455d$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $e594c6d0cea1455d$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $e594c6d0cea1455d$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $e594c6d0cea1455d$var$eqRowCons = /* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)();
var $e594c6d0cea1455d$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $e594c6d0cea1455d$var$eqMaybe = /* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($e594c6d0cea1455d$var$eqRNTY);
var $e594c6d0cea1455d$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $e594c6d0cea1455d$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $e594c6d0cea1455d$var$eqRowCons({
    reflectSymbol: function() {
        return "types";
    }
})(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00($0e660be785782a7f$export$f2403200e9d9aaa1)))()({
    reflectSymbol: function() {
        return "teacher_id";
    }
})($e594c6d0cea1455d$var$eqMaybe))()({
    reflectSymbol: function() {
        return "student_id";
    }
})($e594c6d0cea1455d$var$eqRNTY))()({
    reflectSymbol: function() {
        return "position_id";
    }
})($e594c6d0cea1455d$var$eqMaybe))()({
    reflectSymbol: function() {
        return "form";
    }
})($e594c6d0cea1455d$var$eqRNTY))()({
    reflectSymbol: function() {
        return "employer_id";
    }
})($e594c6d0cea1455d$var$eqMaybe))()({
    reflectSymbol: function() {
        return "courses";
    }
})(/* #__PURE__ */ $37b880af5f4991bd$export$159e06dc5ec60b00(/* #__PURE__ */ $e594c6d0cea1455d$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $e594c6d0cea1455d$var$eqRowCons({
    reflectSymbol: function() {
        return "index";
    }
})($37b880af5f4991bd$export$e65788c6d4494539))()($e594c6d0cea1455d$var$idIsSymbol)($e594c6d0cea1455d$var$eqRNTY)))))()({
    reflectSymbol: function() {
        return "contact_id";
    }
})($e594c6d0cea1455d$var$eqMaybe)));
var $e594c6d0cea1455d$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $e594c6d0cea1455d$var$getFieldOptional$prime = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $e594c6d0cea1455d$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $e594c6d0cea1455d$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $e594c6d0cea1455d$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $e594c6d0cea1455d$export$81e248cb574fa30b = /* #__PURE__ */ function() {
    function AutoSelect(value0) {
        this.value0 = value0;
    }
    AutoSelect.create = function(value0) {
        return new AutoSelect(value0);
    };
    return AutoSelect;
}();
var $e594c6d0cea1455d$export$1ad257fc6fc249bb = /* #__PURE__ */ function() {
    function ASNoChange() {}
    ASNoChange.value = new ASNoChange();
    return ASNoChange;
}();
var $e594c6d0cea1455d$export$96a1c3171ac41d8d = /* #__PURE__ */ function() {
    function ASDeselect() {}
    ASDeselect.value = new ASDeselect();
    return ASDeselect;
}();
var $e594c6d0cea1455d$export$2aa9a9a65ce6ca82 = function(x) {
    return x;
};
var $e594c6d0cea1455d$export$c998641cac9a3260 = {
    show: function(v) {
        return "AutoFillSelect " + v.id;
    }
};
var $e594c6d0cea1455d$export$738eeed4ef752b49 = function(fc) {
    return function(state) {
        return function(subsel) {
            var selState = function() {
                var v = $7178b396566f5a79$export$127d1aaaa65102b1(state.select);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7178b396566f5a79$export$81e7dc1e8298801b(subsel.select)(subsel.selAff(fc)(v.value0.value));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7178b396566f5a79$export$81e7dc1e8298801b(subsel.select)($7178b396566f5a79$export$3fb6c8f3fe50bc9f);
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 350, column 16 - line 352, column 61): " + [
                    v.constructor.name
                ]);
            }();
            return $e594c6d0cea1455d$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("search-subform-select-wrapper")
            ])([
                $e594c6d0cea1455d$var$label([
                    $fc1df90f0e252058$export$35d9e1c947946090(state.select.id)
                ])([
                    $e594c6d0cea1455d$var$text(subsel.label)
                ]),
                $e594c6d0cea1455d$var$map(function(v) {
                    return {
                        autoSel: subsel.autoSel,
                        funcs: subsel.funcs,
                        id: subsel.id,
                        label: subsel.label,
                        selAff: subsel.selAff,
                        select: v
                    };
                })($7178b396566f5a79$export$54b124386ef5abe3(selState))
            ]);
        };
    };
};
var $e594c6d0cea1455d$export$685c2690908c38dd = function(fc) {
    return function(state) {
        var selectedId = function(state$prime) {
            return $e594c6d0cea1455d$var$map1($e594c6d0cea1455d$var$map2(state$prime.def.funcs.itemId)(function(v) {
                return v.value;
            }))($7178b396566f5a79$export$127d1aaaa65102b1(state$prime.select));
        };
        var selState = $7178b396566f5a79$export$81e7dc1e8298801b(state.select)(state.def.selAff(fc));
        var handleSubSel = function(idx) {
            return function(sub) {
                return $e594c6d0cea1455d$var$map(function(sub$prime) {
                    return {
                        def: state.def,
                        fillAnyway: state.fillAnyway,
                        id: state.id,
                        select: state.select,
                        subsels: $06733ae99ed4f534$export$43db023a260c5e9f([])($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)(sub$prime)(state.subsels))
                    };
                })($e594c6d0cea1455d$export$738eeed4ef752b49(fc)(state)(sub));
            };
        };
        var applyAutoSel = function(sel) {
            return function(sub) {
                var v = sub.autoSel(fc)(sel);
                if (v instanceof $e594c6d0cea1455d$export$81e248cb574fa30b) return {
                    id: sub.id,
                    label: sub.label,
                    funcs: sub.funcs,
                    selAff: sub.selAff,
                    autoSel: sub.autoSel,
                    select: $7178b396566f5a79$export$5a4818cec1656a71(sub.select)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                        label: sub.funcs.itemLabel(v.value0),
                        value: v.value0
                    }))
                };
                if (v instanceof $e594c6d0cea1455d$export$96a1c3171ac41d8d) return {
                    id: sub.id,
                    label: sub.label,
                    funcs: sub.funcs,
                    selAff: sub.selAff,
                    autoSel: sub.autoSel,
                    select: $7178b396566f5a79$export$5a4818cec1656a71(sub.select)($06733ae99ed4f534$export$bebe9059409a0d04.value)
                };
                if (v instanceof $e594c6d0cea1455d$export$1ad257fc6fc249bb) return sub;
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 326, column 28 - line 331, column 26): " + [
                    v.constructor.name
                ]);
            };
        };
        var maybeApplyAutoSels = function(v) {
            if ($e594c6d0cea1455d$var$eq(selectedId(v))(selectedId(state))) return v;
            var selItem = $e594c6d0cea1455d$var$map1(function(v1) {
                return v1.value;
            })($7178b396566f5a79$export$127d1aaaa65102b1(v.select));
            return {
                def: v.def,
                fillAnyway: v.fillAnyway,
                id: v.id,
                select: v.select,
                subsels: $e594c6d0cea1455d$var$map3(applyAutoSel(selItem))(v.subsels)
            };
        };
        var runButton = function(btn) {
            return $e594c6d0cea1455d$var$bind(btn(fc))(function(ent) {
                var v = $e594c6d0cea1455d$var$map1(function(e) {
                    return {
                        label: state.def.funcs.itemLabel(e),
                        value: e
                    };
                })(ent);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e594c6d0cea1455d$var$pure(maybeApplyAutoSels({
                    id: state.id,
                    subsels: state.subsels,
                    def: state.def,
                    select: $7178b396566f5a79$export$5a4818cec1656a71(state.select)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)),
                    fillAnyway: true
                }));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e594c6d0cea1455d$var$pure(state);
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 336, column 9 - line 339, column 34): " + [
                    v.constructor.name
                ]);
            });
        };
        return $e594c6d0cea1455d$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("autofill-select search-subform-search")
        ])($e594c6d0cea1455d$var$append1([
            $e594c6d0cea1455d$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("search-subform-select-wrapper")
            ])($e594c6d0cea1455d$var$append1([
                $e594c6d0cea1455d$var$label([
                    $fc1df90f0e252058$export$35d9e1c947946090(state.select.id)
                ])([
                    $e594c6d0cea1455d$var$text(state.def.label)
                ]),
                $e594c6d0cea1455d$var$map($e594c6d0cea1455d$var$map2(maybeApplyAutoSels)(function(v) {
                    return {
                        def: state.def,
                        fillAnyway: state.fillAnyway,
                        id: state.id,
                        subsels: state.subsels,
                        select: v
                    };
                }))($7178b396566f5a79$export$54b124386ef5abe3(selState))
            ])(function() {
                if (state.select.config.editable) return $e594c6d0cea1455d$var$map3(runButton)(state.def.buttons($e594c6d0cea1455d$var$map1(function(v) {
                    return v.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(state.select))));
                return [];
            }()))
        ])($396c4c3d9e7fae3c$export$8f07ddce13659f50(handleSubSel)(state.subsels)));
    };
};
var $e594c6d0cea1455d$export$927e6cf0be8667de = function(v) {
    return function(def) {
        return {
            id: v.id,
            select: $7178b396566f5a79$export$c0550eae5f8d456b(v.id + "-af-select")($7178b396566f5a79$export$3fb6c8f3fe50bc9f)(def.groupFunc)({
                deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
                allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
                editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
            }),
            subsels: def.subsels,
            def: def,
            fillAnyway: false
        };
    };
};
var $e594c6d0cea1455d$export$8019c76663461457 = function(init) {
    return $e594c6d0cea1455d$export$927e6cf0be8667de(init)({
        label: $c3328e54cdf5154c$export$5a1a8430df9521e("course-form-course"),
        types: [
            $0e660be785782a7f$export$316a46c1e34e2e7f.value
        ],
        funcs: {
            apply: function(fc) {
                return function(v) {
                    return function(v1) {
                        return {
                            form: v1.form,
                            student_id: v1.student_id,
                            teacher_id: v1.teacher_id,
                            employer_id: v1.employer_id,
                            position_id: v1.position_id,
                            contact_id: v1.contact_id,
                            types: v1.types,
                            courses: [
                                {
                                    index: fc.curIndex,
                                    id: v.id
                                }
                            ]
                        };
                    };
                };
            },
            itemId: function($364) {
                return $308f9765feb7633d$export$a1b0f5347d2470b(function(v) {
                    return v.id;
                }($364));
            },
            itemLabel: function(v) {
                return v.label;
            },
            load: function(fc) {
                return function(id) {
                    return $e594c6d0cea1455d$var$bind1(fc.doc)(function(doc) {
                        return $e594c6d0cea1455d$var$bind1($396c4c3d9e7fae3c$export$71aa6c912b956294(function(c) {
                            return $308f9765feb7633d$export$a1b0f5347d2470b(c.id) === id;
                        })(doc.courses))(function(c) {
                            return $e594c6d0cea1455d$var$pure1($0226bdcd7123f840$export$10f004625337249d(c));
                        });
                    });
                };
            }
        },
        selAff: function(fc) {
            return $0226bdcd7123f840$export$8ff95a4bad83b9f($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v) {
                return v.student.id;
            })(fc.doc));
        },
        groupFunc: new $06733ae99ed4f534$export$8a67b48435b5d073($e594c6d0cea1455d$var$groupOptsByKey(function(v) {
            return v.group_label;
        })(function(v) {
            return v.group_label;
        })),
        subsels: [],
        buttons: function(v) {
            return [];
        }
    });
};
var $e594c6d0cea1455d$export$641374154009aa69 = {
    map: function(v) {
        return function(v1) {
            if (v1 instanceof $e594c6d0cea1455d$export$81e248cb574fa30b) return new $e594c6d0cea1455d$export$81e248cb574fa30b(v(v1.value0));
            if (v1 instanceof $e594c6d0cea1455d$export$96a1c3171ac41d8d) return $e594c6d0cea1455d$export$96a1c3171ac41d8d.value;
            if (v1 instanceof $e594c6d0cea1455d$export$1ad257fc6fc249bb) return $e594c6d0cea1455d$export$1ad257fc6fc249bb.value;
            throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 204, column 1 - line 207, column 34): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    }
};
var $e594c6d0cea1455d$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($e594c6d0cea1455d$export$641374154009aa69);
var $e594c6d0cea1455d$export$dc81ac4588ed4304 = function(v) {
    var selAff = function(fc) {
        return function(a) {
            return $7178b396566f5a79$export$f722688498755b51($ac8b3532514ac019$export$401372c57776dc)($7178b396566f5a79$export$681ac624aa06ab03)(v.selAff(fc)(a));
        };
    };
    var itemLabel = function($365) {
        return v.funcs.itemLabel($365);
    };
    return {
        id: v.id,
        label: v.label,
        select: $7178b396566f5a79$export$d967f07ae6c72524(v.id + "-af-select")($7178b396566f5a79$export$3fb6c8f3fe50bc9f)({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
        }),
        funcs: {
            apply: function(fc) {
                var $366 = v.funcs.apply(fc);
                return function($367) {
                    return $366($367);
                };
            },
            itemId: function($368) {
                return v.funcs.itemId($368);
            },
            itemLabel: itemLabel,
            load: function(fc) {
                var $369 = $e594c6d0cea1455d$var$map1($ac8b3532514ac019$export$401372c57776dc);
                var $370 = v.funcs.load(fc);
                return function($371) {
                    return $369($370($371));
                };
            }
        },
        autoSel: function(fc) {
            var $372 = $e594c6d0cea1455d$var$map5($ac8b3532514ac019$export$401372c57776dc);
            var $373 = v.autoSel(fc);
            return function($374) {
                return $372($373($374));
            };
        },
        selAff: selAff
    };
};
var $e594c6d0cea1455d$export$e93b750aadcbed14 = function(init) {
    var loadEmployer = function(fc) {
        return function(id) {
            var tagctx = function() {
                var $375 = $54dae5ca6a6cd16d$export$2b487ea8ea8b1c9b("AutoFillSelect");
                var $376 = $54dae5ca6a6cd16d$export$226c98f2a504b8e8("while loading added/edited employer info");
                return function($377) {
                    return $375($376($377));
                };
            }();
            return $e594c6d0cea1455d$var$bind($e594c6d0cea1455d$var$map(tagctx)($3257df7cdef77623$export$b97f2ad8d0b7442d($e594c6d0cea1455d$var$runGraphQL($e594c6d0cea1455d$var$getEmployer(id)($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                return v.id;
            })(fc.doc)))($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                return v.student.id;
            })(fc.doc)))))))(function(empM) {
                if (empM instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $e594c6d0cea1455d$var$pure(new $06733ae99ed4f534$export$8a67b48435b5d073(empM.value0));
                if (empM instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $e594c6d0cea1455d$var$bind($e594c6d0cea1455d$var$liftEffect($54dae5ca6a6cd16d$export$b33b857ad1d9900e(empM.value0)))(function() {
                    return $e594c6d0cea1455d$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                });
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 137, column 9 - line 141, column 29): " + [
                    empM.constructor.name
                ]);
            });
        };
    };
    var editBtn = function(fc) {
        return function(emp) {
            var btn = $e594c6d0cea1455d$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn employer-edit-btn"),
                $fc1df90f0e252058$export$1d5a917feb871989
            ])([
                $e594c6d0cea1455d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("edit-employer") + emp.company)
            ]);
            return $e594c6d0cea1455d$var$bind(btn)(function() {
                return $e594c6d0cea1455d$var$bind($e594c6d0cea1455d$var$alt($e0dae94260b9d371$export$2d6ae09600947940(new $06733ae99ed4f534$export$8a67b48435b5d073(emp.id)))($9c13a1c3d948adb8$export$be9e2feb4e35335b(btn)))(function(eid) {
                    if (eid instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return loadEmployer(fc)(eid.value0);
                    if (eid instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e594c6d0cea1455d$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 127, column 9 - line 129, column 36): " + [
                        eid.constructor.name
                    ]);
                });
            });
        };
    };
    var addBtn = function(fc) {
        var btn = $e594c6d0cea1455d$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn employer-add-btn"),
            $fc1df90f0e252058$export$1d5a917feb871989
        ])([
            $e594c6d0cea1455d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("add-employer"))
        ]);
        return $e594c6d0cea1455d$var$bind(btn)(function() {
            return $e594c6d0cea1455d$var$bind($e594c6d0cea1455d$var$alt($e0dae94260b9d371$export$2d6ae09600947940($06733ae99ed4f534$export$bebe9059409a0d04.value))($9c13a1c3d948adb8$export$be9e2feb4e35335b(btn)))(function(eid) {
                if (eid instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return loadEmployer(fc)(eid.value0);
                if (eid instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e594c6d0cea1455d$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 115, column 9 - line 117, column 36): " + [
                    eid.constructor.name
                ]);
            });
        });
    };
    var buttons = function(v) {
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [
            addBtn
        ];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            $c3ec47a57216184e$export$71e337785367343c($06733ae99ed4f534$export$4967676db1b89293(v.value0.deleted_at))(function(fc) {
                return editBtn(fc)(v.value0);
            }),
            new $06733ae99ed4f534$export$8a67b48435b5d073(addBtn)
        ]);
        throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 101, column 5 - line 101, column 77): " + [
            v.constructor.name
        ]);
    };
    return $e594c6d0cea1455d$export$927e6cf0be8667de(init)({
        label: $c3328e54cdf5154c$export$5a1a8430df9521e("employer-form-employer"),
        types: [
            $0e660be785782a7f$export$b0e87b3139bc946f.value,
            $0e660be785782a7f$export$5a61ed5a76cf6b3d.value,
            $0e660be785782a7f$export$9cfe350c8b2d28c8.value
        ],
        funcs: {
            apply: function(v) {
                return function(e) {
                    return function(v1) {
                        return {
                            form: v1.form,
                            student_id: v1.student_id,
                            teacher_id: v1.teacher_id,
                            position_id: v1.position_id,
                            contact_id: v1.contact_id,
                            courses: v1.courses,
                            types: v1.types,
                            employer_id: new $06733ae99ed4f534$export$8a67b48435b5d073(e.id)
                        };
                    };
                };
            },
            itemId: function($378) {
                return $308f9765feb7633d$export$a1b0f5347d2470b(function(v) {
                    return v.id;
                }($378));
            },
            itemLabel: function(v) {
                return v.company;
            },
            load: function(fc) {
                return function(v) {
                    return $e594c6d0cea1455d$var$bindFlipped(function(v1) {
                        return v1.employer;
                    })(fc.doc);
                };
            }
        },
        selAff: function(fc) {
            return $e776f62b9df165a6$export$58d01f439dbdc886($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v) {
                return v.id;
            })(fc.doc))($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v) {
                return v.student.id;
            })(fc.doc));
        },
        groupFunc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        subsels: [
            $e594c6d0cea1455d$export$dc81ac4588ed4304({
                id: "position",
                label: $c3328e54cdf5154c$export$5a1a8430df9521e("position"),
                funcs: {
                    apply: function(v) {
                        return function(p) {
                            return function(v1) {
                                return {
                                    form: v1.form,
                                    student_id: v1.student_id,
                                    teacher_id: v1.teacher_id,
                                    employer_id: v1.employer_id,
                                    contact_id: v1.contact_id,
                                    courses: v1.courses,
                                    types: v1.types,
                                    position_id: new $06733ae99ed4f534$export$8a67b48435b5d073(p.id)
                                };
                            };
                        };
                    },
                    itemId: function($379) {
                        return $308f9765feb7633d$export$a1b0f5347d2470b(function(v) {
                            return v.id;
                        }($379));
                    },
                    itemLabel: function(v) {
                        return v.label;
                    },
                    load: function(fc) {
                        return function(v) {
                            return $e594c6d0cea1455d$var$bindFlipped(function(v1) {
                                return v1.position;
                            })(fc.doc);
                        };
                    }
                },
                selAff: function(fc) {
                    return function(employer) {
                        return $e776f62b9df165a6$export$8f428e086e902ded($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                            return v.id;
                        })(fc.doc)))($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                            return v.student.id;
                        })(fc.doc)))(employer.id);
                    };
                },
                autoSel: function(v) {
                    return function(e) {
                        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($e594c6d0cea1455d$export$96a1c3171ac41d8d.value)($e594c6d0cea1455d$export$81e248cb574fa30b.create)($e594c6d0cea1455d$var$bindFlipped($396c4c3d9e7fae3c$export$5fd5031fecdacec3)($e594c6d0cea1455d$var$map1(function(v1) {
                            return v1.positions;
                        })(e)));
                    };
                }
            }),
            $e594c6d0cea1455d$export$dc81ac4588ed4304({
                id: "contact",
                label: $c3328e54cdf5154c$export$5a1a8430df9521e("employer-contact"),
                funcs: {
                    apply: function(v) {
                        return function(c) {
                            return function(v1) {
                                return {
                                    form: v1.form,
                                    student_id: v1.student_id,
                                    teacher_id: v1.teacher_id,
                                    employer_id: v1.employer_id,
                                    position_id: v1.position_id,
                                    courses: v1.courses,
                                    types: v1.types,
                                    contact_id: new $06733ae99ed4f534$export$8a67b48435b5d073(c.id)
                                };
                            };
                        };
                    },
                    itemId: function($380) {
                        return $308f9765feb7633d$export$a1b0f5347d2470b(function(v) {
                            return v.id;
                        }($380));
                    },
                    itemLabel: function(v) {
                        return v.name;
                    },
                    load: function(fc) {
                        return function(v) {
                            return $e594c6d0cea1455d$var$bindFlipped(function(v1) {
                                return v1.contact;
                            })(fc.doc);
                        };
                    }
                },
                selAff: function(fc) {
                    return function(employer) {
                        return $e776f62b9df165a6$export$ac1bd8a342846243($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                            return v.id;
                        })(fc.doc)))($308f9765feb7633d$export$87708d888b4bc8a6($e594c6d0cea1455d$var$map1(function(v) {
                            return v.student.id;
                        })(fc.doc)))(employer.id);
                    };
                },
                autoSel: function(v) {
                    return function(e) {
                        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($e594c6d0cea1455d$export$96a1c3171ac41d8d.value)($e594c6d0cea1455d$export$81e248cb574fa30b.create)($e594c6d0cea1455d$var$bindFlipped($396c4c3d9e7fae3c$export$5fd5031fecdacec3)($e594c6d0cea1455d$var$map1(function(v1) {
                            return v1.contacts;
                        })(e)));
                    };
                }
            })
        ],
        buttons: buttons
    });
};
var $e594c6d0cea1455d$export$211a98467027e13a = function(fc) {
    return function(state) {
        var noop = function(x) {
            return x;
        };
        var applyTypes = function(v) {
            return {
                form: v.form,
                student_id: v.student_id,
                teacher_id: v.teacher_id,
                employer_id: v.employer_id,
                position_id: v.position_id,
                contact_id: v.contact_id,
                courses: v.courses,
                types: state.def.types
            };
        };
        var applySubSel = function(sub) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(noop)(sub.funcs.apply(fc))($e594c6d0cea1455d$var$map1(function(v) {
                return v.value;
            })($7178b396566f5a79$export$127d1aaaa65102b1(sub.select)));
        };
        var applySubSels = function(af) {
            return $e594c6d0cea1455d$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f(applySubSel))(af)(state.subsels);
        };
        var applyMainSel = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(noop)(state.def.funcs.apply(fc))($e594c6d0cea1455d$var$map1(function(v) {
            return v.value;
        })($7178b396566f5a79$export$127d1aaaa65102b1(state.select)));
        return function($381) {
            return applyTypes(applySubSels(applyMainSel($381)));
        };
    };
};
var $e594c6d0cea1455d$export$445e4a4e646ec2d8 = function(fc) {
    return function(oldState) {
        return $e594c6d0cea1455d$var$bind($e594c6d0cea1455d$export$685c2690908c38dd(fc)(oldState))(function(newState) {
            var oldArgs = $e594c6d0cea1455d$export$211a98467027e13a(fc)(oldState)(fc.autofillArgs);
            var newArgs = $e594c6d0cea1455d$export$211a98467027e13a(fc)(newState)(fc.autofillArgs);
            return $e594c6d0cea1455d$var$pure(function() {
                var $332 = $e594c6d0cea1455d$var$eq2(oldArgs)(newArgs) && !newState.fillAnyway;
                if ($332) return $f388db8e60bd7b97$export$e0d76edcf577b85d(newState);
                return $f388db8e60bd7b97$export$a9ba8100218e287d({
                    id: newState.id,
                    select: newState.select,
                    subsels: newState.subsels,
                    def: newState.def,
                    fillAnyway: false
                })(new $f388db8e60bd7b97$export$ecf6106d7890d9bf(newArgs));
            }());
        });
    };
};
var $e594c6d0cea1455d$export$b4fcb73b806069a8 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var editable = $f388db8e60bd7b97$export$330cf2b9485e792b(fc)(v.id);
            var setEditable = function(sel) {
                return {
                    id: sel.id,
                    search: sel.search,
                    searchAff: sel.searchAff,
                    groupFunc: sel.groupFunc,
                    selected: sel.selected,
                    highlighted: sel.highlighted,
                    expanded: sel.expanded,
                    hovering: sel.hovering,
                    loadNext: sel.loadNext,
                    options: sel.options,
                    state: sel.state,
                    config: {
                        placeholder: sel.config.placeholder,
                        deselectLabel: sel.config.deselectLabel,
                        allowDeselect: sel.config.allowDeselect,
                        editable: editable
                    }
                };
            };
            var editableState = {
                def: v.def,
                fillAnyway: v.fillAnyway,
                id: v.id,
                select: setEditable(v.select),
                subsels: $e594c6d0cea1455d$var$map3(function(sub) {
                    return {
                        autoSel: sub.autoSel,
                        funcs: sub.funcs,
                        id: sub.id,
                        label: sub.label,
                        selAff: sub.selAff,
                        select: setEditable(sub.select)
                    };
                })(v.subsels)
            };
            return $e594c6d0cea1455d$export$445e4a4e646ec2d8(fc)(editableState);
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$43db023a260c5e9f($0e031af7428ef07d$export$63ea9a5410ee0cef)($e594c6d0cea1455d$var$map1($e594c6d0cea1455d$var$map2($e594c6d0cea1455d$var$map2($0e031af7428ef07d$export$dbafa4424a806c15)(v1.def.funcs.itemId))(function(v2) {
                return v2.value;
            }))($7178b396566f5a79$export$127d1aaaa65102b1(v1.select)));
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(v2) {
                if ($2a035e92dc768ac1$export$630801d484da15df(v2)) return new $7d4cccdf062a2261$export$19db0165690c701a(v1);
                var wrapOpt = function(v3) {
                    return function(opt) {
                        return {
                            label: v3.funcs.itemLabel(opt),
                            value: opt
                        };
                    };
                };
                var loadSubSel = function(obj) {
                    return function(sub) {
                        return $e594c6d0cea1455d$var$bind2($e594c6d0cea1455d$var$bind2($e594c6d0cea1455d$var$getFieldOptional$prime(obj)(sub.id + "Id"))(function(v3) {
                            if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e594c6d0cea1455d$var$pure2($06733ae99ed4f534$export$bebe9059409a0d04.value);
                            if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e594c6d0cea1455d$var$map4($06733ae99ed4f534$export$8a67b48435b5d073.create)($2acecf8dc1456b13$export$f67be9d9b0e25d7b(v3.value0));
                            throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 399, column 66 - line 401, column 56): " + [
                                v3.constructor.name
                            ]);
                        }))(function(v3) {
                            var $353 = $e594c6d0cea1455d$var$eq($e594c6d0cea1455d$var$map1($e594c6d0cea1455d$var$map2(sub.funcs.itemId)(function(v4) {
                                return v4.value;
                            }))($7178b396566f5a79$export$127d1aaaa65102b1(sub.select)))(v3);
                            if ($353) return $e594c6d0cea1455d$var$pure2(sub);
                            return $e594c6d0cea1455d$var$pure2({
                                funcs: sub.funcs,
                                id: sub.id,
                                autoSel: sub.autoSel,
                                label: sub.label,
                                selAff: sub.selAff,
                                select: $7178b396566f5a79$export$5a4818cec1656a71(sub.select)($e594c6d0cea1455d$var$map1(wrapOpt(sub))($e594c6d0cea1455d$var$bindFlipped(sub.funcs.load(v))(v3)))
                            });
                        });
                    };
                };
                var loadObj = function(obj) {
                    return $e594c6d0cea1455d$var$bind2($e594c6d0cea1455d$var$bind2($e594c6d0cea1455d$var$getFieldOptional$prime(obj)("id"))(function(v3) {
                        if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $e594c6d0cea1455d$var$pure2($06733ae99ed4f534$export$bebe9059409a0d04.value);
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $e594c6d0cea1455d$var$map4($06733ae99ed4f534$export$8a67b48435b5d073.create)($2acecf8dc1456b13$export$f67be9d9b0e25d7b(v3.value0));
                        throw new Error("Failed pattern match at Widgets.Form.AutoFillSelect (line 383, column 54 - line 385, column 56): " + [
                            v3.constructor.name
                        ]);
                    }))(function(v3) {
                        var oldSel = $7178b396566f5a79$export$127d1aaaa65102b1(v1.select);
                        var mainSel = function() {
                            var $357 = $e594c6d0cea1455d$var$eq($e594c6d0cea1455d$var$map1($e594c6d0cea1455d$var$map2(v1.def.funcs.itemId)(function(v4) {
                                return v4.value;
                            }))(oldSel))(v3);
                            if ($357) return oldSel;
                            return $e594c6d0cea1455d$var$map1(wrapOpt(v1.def))($e594c6d0cea1455d$var$bindFlipped(v1.def.funcs.load(v))(v3));
                        }();
                        return $e594c6d0cea1455d$var$bind2($e594c6d0cea1455d$var$traverse(loadSubSel(obj))(v1.subsels))(function(subsels) {
                            return $e594c6d0cea1455d$var$pure2({
                                id: v1.id,
                                def: v1.def,
                                fillAnyway: v1.fillAnyway,
                                select: $7178b396566f5a79$export$5a4818cec1656a71(v1.select)(mainSel),
                                subsels: subsels
                            });
                        });
                    });
                };
                return $54dae5ca6a6cd16d$export$bc0012033e3e059a(v2)($e594c6d0cea1455d$var$bind2($2acecf8dc1456b13$export$a0a4ca47aa42be8b(v2))(function(obj) {
                    var $358 = $c045ea5df33bba60$export$6a0d13241802fe80("id")(obj);
                    if ($358) return loadObj(obj);
                    return $e594c6d0cea1455d$var$pure2(v1);
                }));
            };
        };
    }
};
var $e594c6d0cea1455d$export$d48d64a2e1742998 = function(v) {
    return $e594c6d0cea1455d$var$map1($e594c6d0cea1455d$var$map2(v.def.funcs.itemId)(function(v1) {
        return v1.value;
    }))($7178b396566f5a79$export$127d1aaaa65102b1(v.select));
};



// Generated by purs version 0.15.16















// Generated by purs version 0.15.16





var $3af393d861aaaf77$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $3af393d861aaaf77$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $3af393d861aaaf77$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $3af393d861aaaf77$var$DynFormWidget = /* #__PURE__ */ function() {
    function DynFormWidget(value0) {
        this.value0 = value0;
    }
    DynFormWidget.create = function(value0) {
        return new DynFormWidget(value0);
    };
    return DynFormWidget;
}();
var $3af393d861aaaf77$export$14679d9abc92670b = {
    show: function(v) {
        return v.value0.show(v);
    }
};
var $3af393d861aaaf77$export$9dbe1a5a7e1995c1 = {
    getId: function(v) {
        return v.value0.getId(v);
    },
    isLeaf: function(v) {
        return v.value0.isLeaf(v);
    },
    asField: function(v) {
        return v.value0.asField(v);
    },
    toWidget: function(fc) {
        return function(v) {
            return v.value0.toWidget(fc)(v);
        };
    },
    getData: function(fc) {
        return function(v) {
            return v.value0.getData(fc)(v);
        };
    },
    setData: function(fc) {
        return function(v) {
            return function(json) {
                return v.value0.setData(fc)(v)(json);
            };
        };
    },
    fieldPaths: function(fc) {
        return function(v) {
            return v.value0.fieldPaths(fc)(v);
        };
    }
};
var $3af393d861aaaf77$var$isLeaf = /* #__PURE__ */ $f388db8e60bd7b97$export$e132ced8f644a612($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $3af393d861aaaf77$export$6ad962f6572282b5 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictFormWidget) {
        var setData = $f388db8e60bd7b97$export$3a6802af14bf5fa6(dictFormWidget);
        var toWidget = $f388db8e60bd7b97$export$83925c2318996255(dictFormWidget);
        var getId = $f388db8e60bd7b97$export$218c8c3169c024d2(dictFormWidget);
        var isLeaf1 = $f388db8e60bd7b97$export$e132ced8f644a612(dictFormWidget);
        var asField = $f388db8e60bd7b97$export$5a271d199eca9d6f(dictFormWidget);
        var getData = $f388db8e60bd7b97$export$7a171f172be0782e(dictFormWidget);
        var fieldPaths = $f388db8e60bd7b97$export$e47c1863c8ac83c1(dictFormWidget);
        return function(widget) {
            var updateDFW = function(v) {
                return function($$new) {
                    return new $3af393d861aaaf77$var$DynFormWidget({
                        getId: v.value0.getId,
                        isLeaf: v.value0.isLeaf,
                        asField: v.value0.asField,
                        toWidget: v.value0.toWidget,
                        getData: v.value0.getData,
                        setData: v.value0.setData,
                        fieldPaths: v.value0.fieldPaths,
                        show: v.value0.show,
                        inner: $$new
                    });
                };
            };
            var fromDFW = function(v) {
                return v.value0.inner;
            };
            var wrappedSetData = function(fc) {
                return function(dfw) {
                    return function(json) {
                        return $3af393d861aaaf77$var$map(updateDFW(dfw))(setData(fc)(fromDFW(dfw))(json));
                    };
                };
            };
            var wrappedToWidget = function(v) {
                return function(v1) {
                    if ($3af393d861aaaf77$var$isLeaf(v1)) return $3af393d861aaaf77$var$map1(function(v2) {
                        return $3af393d861aaaf77$var$map2(updateDFW(v1))(v2);
                    })(toWidget(v)(fromDFW(v1)));
                    return $3af393d861aaaf77$var$map1(function(v2) {
                        return $3af393d861aaaf77$var$map2(updateDFW(v1))(v2);
                    })(toWidget(v)(fromDFW(v1)));
                };
            };
            return new $3af393d861aaaf77$var$DynFormWidget({
                inner: widget,
                getId: function($59) {
                    return getId(fromDFW($59));
                },
                isLeaf: function($60) {
                    return isLeaf1(fromDFW($60));
                },
                asField: function($61) {
                    return asField(fromDFW($61));
                },
                toWidget: wrappedToWidget,
                getData: function(fc) {
                    var $62 = getData(fc);
                    return function($63) {
                        return $62(fromDFW($63));
                    };
                },
                setData: wrappedSetData,
                fieldPaths: function(fc) {
                    var $64 = fieldPaths(fc);
                    return function($65) {
                        return $64(fromDFW($65));
                    };
                },
                show: function($66) {
                    return show(fromDFW($66));
                }
            });
        };
    };
};


// Generated by purs version 0.15.16



















var $227bc4e21b5ff268$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $227bc4e21b5ff268$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $227bc4e21b5ff268$var$getId = /* #__PURE__ */ $f388db8e60bd7b97$export$218c8c3169c024d2($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $227bc4e21b5ff268$var$setData = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $227bc4e21b5ff268$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $227bc4e21b5ff268$var$isLeaf = /* #__PURE__ */ $f388db8e60bd7b97$export$e132ced8f644a612($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $227bc4e21b5ff268$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $227bc4e21b5ff268$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $227bc4e21b5ff268$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $227bc4e21b5ff268$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $227bc4e21b5ff268$var$toWidget = /* #__PURE__ */ $f388db8e60bd7b97$export$83925c2318996255($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $227bc4e21b5ff268$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $227bc4e21b5ff268$var$getData = /* #__PURE__ */ $f388db8e60bd7b97$export$7a171f172be0782e($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $227bc4e21b5ff268$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $227bc4e21b5ff268$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $227bc4e21b5ff268$export$29f26d7e03874a4b = function($copy_v) {
    return function($copy_v1) {
        return function($copy_v2) {
            var $tco_var_v = $copy_v;
            var $tco_var_v1 = $copy_v1;
            var $tco_done = false;
            var $tco_result;
            function $tco_loop(v, v1, v2) {
                if ($227bc4e21b5ff268$var$eq(v2)($0e031af7428ef07d$export$dbafa4424a806c15([]))) {
                    $tco_var_v = v;
                    $tco_var_v1 = v1;
                    $copy_v2 = $0e031af7428ef07d$export$dbafa4424a806c15($03b6b966974423fe$export$6e22c362a0406a2c);
                    return;
                }
                $tco_done = true;
                return $227bc4e21b5ff268$var$bind($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Form/subform expected object."))($2a035e92dc768ac1$export$697e4a1b90752ce2(v2)))(function(obj) {
                    var update = function(w) {
                        var v3 = $c045ea5df33bba60$export$dfc7155ac0343b8($227bc4e21b5ff268$var$getId(w))(obj);
                        if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a(w);
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $2a035e92dc768ac1$export$630801d484da15df(v3.value0)) return new $7d4cccdf062a2261$export$19db0165690c701a(w);
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $54dae5ca6a6cd16d$export$2b487ea8ea8b1c9b($227bc4e21b5ff268$var$getId(w))($54dae5ca6a6cd16d$export$60030d78f255e2a6(new $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c("WidgetMap", v3.value0))($227bc4e21b5ff268$var$setData(v)(w)(v3.value0)));
                        throw new Error("Failed pattern match at Widgets.Form.WidgetMap (line 56, column 20 - line 60, column 36): " + [
                            v3.constructor.name
                        ]);
                    };
                    return $227bc4e21b5ff268$var$traverse(update)(v1);
                });
            }
            while(!$tco_done)$tco_result = $tco_loop($tco_var_v, $tco_var_v1, $copy_v2);
            return $tco_result;
        };
    };
};
var $227bc4e21b5ff268$export$5a3266b2878a24b0 = function(fc) {
    return function(wm) {
        var subWidget = function(i) {
            return function(ws) {
                var v = $f388db8e60bd7b97$export$6ae8b9028cb9b43c(fc)($227bc4e21b5ff268$var$getId(ws));
                if (v instanceof $81439e1d9c94314f$export$22dce776e713bf54 && ($227bc4e21b5ff268$var$isLeaf(ws) || !$f388db8e60bd7b97$export$c7df680a10db757f(fc)($227bc4e21b5ff268$var$getId(ws)))) return $227bc4e21b5ff268$var$voidRight($f388db8e60bd7b97$export$e0d76edcf577b85d(wm))($227bc4e21b5ff268$var$text(""));
                return $227bc4e21b5ff268$var$map(function(v1) {
                    return $227bc4e21b5ff268$var$map1(function(w) {
                        return $06733ae99ed4f534$export$43db023a260c5e9f(wm)($396c4c3d9e7fae3c$export$b6d8713d53419d4c(i)(w)(wm));
                    })(v1);
                })($227bc4e21b5ff268$var$toWidget(fc)(ws));
            };
        };
        return $227bc4e21b5ff268$var$mapWithIndex(subWidget)(wm);
    };
};
var $227bc4e21b5ff268$export$c809b8b516ff0c2b = function(fc) {
    return function(wm) {
        var field = function(f) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($227bc4e21b5ff268$var$getId(f), $227bc4e21b5ff268$var$getData(fc)(f));
        };
        var dataFields = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v) {
            return !$2a035e92dc768ac1$export$630801d484da15df(v.value1);
        })($227bc4e21b5ff268$var$map2(field)(wm));
        return $0e031af7428ef07d$export$dbafa4424a806c15($227bc4e21b5ff268$var$fromFoldable(dataFields));
    };
};


var $7ecd539579e10f1a$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $7ecd539579e10f1a$var$summary = /* #__PURE__ */ $3eadc1b959dd1120$export$9a2dbef7a17e2e58($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $7ecd539579e10f1a$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $7ecd539579e10f1a$var$legend = /* #__PURE__ */ $3eadc1b959dd1120$export$9a9b59e08de24cef($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($c50cfdb0b9e8fa31$export$8f0ac76856b1d87e);
var $7ecd539579e10f1a$var$fieldset = /* #__PURE__ */ $3eadc1b959dd1120$export$a38812d1aa1302d9($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $7ecd539579e10f1a$var$asField = /* #__PURE__ */ $f388db8e60bd7b97$export$5a271d199eca9d6f($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $7ecd539579e10f1a$var$fieldPaths = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $7ecd539579e10f1a$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $7ecd539579e10f1a$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $7ecd539579e10f1a$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $7ecd539579e10f1a$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($7ecd539579e10f1a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7ecd539579e10f1a$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $7ecd539579e10f1a$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "collapsible";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "expanded";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "fields";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "labelClass";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "section";
    }
})($2c6b3d51d10471a7$export$ad55f318773e3cd5))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($3af393d861aaaf77$export$14679d9abc92670b)))($2c6b3d51d10471a7$export$ad55f318773e3cd5))($2c6b3d51d10471a7$export$ad55f318773e3cd5))($2c6b3d51d10471a7$export$e4b6cd05df3043f6)));
var $7ecd539579e10f1a$export$d9ff49f9a2f902e5 = function(x) {
    return x;
};
var $7ecd539579e10f1a$export$cffc86e045008bbf = function(v) {
    return "widget-sub-form " + function() {
        var $80 = $1a77d6934b592676$export$2344b14b097df817("col-span-")(v.cls);
        if ($80) return v.cls;
        var $81 = v.cls === "";
        if ($81) return "col-span-12";
        return "col-span-12 " + (v.cls + function() {
            if (v.section) return " section";
            return "";
        }());
    }();
};
var $7ecd539579e10f1a$export$7080a39a80cbb4f5 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1.collapsible) {
                var maybeLabel = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])(function(l) {
                    return [
                        $7ecd539579e10f1a$var$summary([
                            $fc1df90f0e252058$export$2913c0c0b5623090(v1.labelClass)
                        ])([
                            $7ecd539579e10f1a$var$text(l)
                        ])
                    ];
                })(v1.label);
                return $7ecd539579e10f1a$var$details([
                    $fc1df90f0e252058$export$3ce6949f20cea765(v1.expanded),
                    $fc1df90f0e252058$export$2913c0c0b5623090($7ecd539579e10f1a$export$cffc86e045008bbf(v1)),
                    $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id)),
                    $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id))
                ])($7ecd539579e10f1a$var$append1(maybeLabel)([
                    v2
                ]));
            }
            if (!v1.collapsible) {
                var legend1 = function(l) {
                    return $7ecd539579e10f1a$var$legend([
                        $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id)),
                        $fc1df90f0e252058$export$2913c0c0b5623090(v1.labelClass)
                    ])([
                        $7ecd539579e10f1a$var$text(l)
                    ]);
                };
                var emptyAnchor = $7ecd539579e10f1a$var$a([
                    $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id))
                ])([]);
                var maybeLabel = $7ecd539579e10f1a$var$pure($06733ae99ed4f534$export$f8b8b9ce72e9ccbf(emptyAnchor)(legend1)(v1.label));
                return $7ecd539579e10f1a$var$fieldset([
                    $fc1df90f0e252058$export$2913c0c0b5623090($7ecd539579e10f1a$export$cffc86e045008bbf(v1)),
                    $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id))
                ])($7ecd539579e10f1a$var$append1(maybeLabel)([
                    v2
                ]));
            }
            throw new Error("Failed pattern match at Widgets.Form.SubForm (line 54, column 1 - line 54, column 89): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $7ecd539579e10f1a$export$d2c744cb4fba3cbf = function(v) {
    return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($7ecd539579e10f1a$var$map($7ecd539579e10f1a$var$asField)(v.fields));
};
var $7ecd539579e10f1a$export$82deae0194ea4699 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return false;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$c1da5d38077527d7(v.id, $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($7ecd539579e10f1a$var$map($7ecd539579e10f1a$var$asField)(v.fields))));
    },
    fieldPaths: function(fc) {
        return function(v) {
            var subfc = $f388db8e60bd7b97$export$94eddf153554b360(fc)(v.id);
            return $396c4c3d9e7fae3c$export$c28c8388be0ab31a($7ecd539579e10f1a$var$fieldPaths(subfc))(v.fields);
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var subfc = $f388db8e60bd7b97$export$94eddf153554b360(fc)(v.id);
            var subWidgets = $7ecd539579e10f1a$var$map1(function(f) {
                return $7ecd539579e10f1a$var$map2($7ecd539579e10f1a$var$map3($7ecd539579e10f1a$export$d9ff49f9a2f902e5)(function(v1) {
                    return {
                        cls: v.cls,
                        collapsible: v.collapsible,
                        expanded: v.expanded,
                        id: v.id,
                        label: v.label,
                        labelClass: v.labelClass,
                        section: v.section,
                        fields: v1
                    };
                }))(f);
            })($7ecd539579e10f1a$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("fields-wrapper")
            ])($227bc4e21b5ff268$export$5a3266b2878a24b0(subfc)(v.fields)));
            return $7ecd539579e10f1a$export$7080a39a80cbb4f5(fc)(v)(subWidgets);
        };
    },
    getData: function(fc) {
        return function(v) {
            return $227bc4e21b5ff268$export$c809b8b516ff0c2b(fc)(v.fields);
        };
    },
    setData: function(fc) {
        return function(v) {
            return function($$new) {
                return $7ecd539579e10f1a$var$map4($7ecd539579e10f1a$var$map3($7ecd539579e10f1a$export$d9ff49f9a2f902e5)(function(v1) {
                    return {
                        cls: v.cls,
                        collapsible: v.collapsible,
                        expanded: v.expanded,
                        id: v.id,
                        label: v.label,
                        labelClass: v.labelClass,
                        section: v.section,
                        fields: v1
                    };
                }))($227bc4e21b5ff268$export$29f26d7e03874a4b(fc)(v.fields)($$new));
            };
        };
    }
};
var $7ecd539579e10f1a$export$2b89428e175ed52 = {
    show: function(v) {
        return $7ecd539579e10f1a$var$show(v);
    }
};


var $c1dc5882e052ac14$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c1dc5882e052ac14$var$fieldPaths = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($e594c6d0cea1455d$export$b4fcb73b806069a8);
var $c1dc5882e052ac14$var$fieldPaths1 = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($7ecd539579e10f1a$export$82deae0194ea4699);
var $c1dc5882e052ac14$var$getId = /* #__PURE__ */ $f388db8e60bd7b97$export$218c8c3169c024d2($e594c6d0cea1455d$export$b4fcb73b806069a8);
var $c1dc5882e052ac14$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c1dc5882e052ac14$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $c1dc5882e052ac14$var$toWidget = /* #__PURE__ */ $f388db8e60bd7b97$export$83925c2318996255($e594c6d0cea1455d$export$b4fcb73b806069a8);
var $c1dc5882e052ac14$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c1dc5882e052ac14$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1dc5882e052ac14$var$toWidget1 = /* #__PURE__ */ $f388db8e60bd7b97$export$83925c2318996255($7ecd539579e10f1a$export$82deae0194ea4699);
var $c1dc5882e052ac14$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $c1dc5882e052ac14$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $c1dc5882e052ac14$var$getData = /* #__PURE__ */ $f388db8e60bd7b97$export$7a171f172be0782e($7ecd539579e10f1a$export$82deae0194ea4699);
var $c1dc5882e052ac14$var$fromHomogeneous = /* #__PURE__ */ $c045ea5df33bba60$export$a47a4d0fc4d6b25();
var $c1dc5882e052ac14$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $c1dc5882e052ac14$var$setData = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($7ecd539579e10f1a$export$82deae0194ea4699);
var $c1dc5882e052ac14$var$setData1 = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($e594c6d0cea1455d$export$b4fcb73b806069a8);
var $c1dc5882e052ac14$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $c1dc5882e052ac14$export$e018f5d866f184bb = function(x) {
    return x;
};
var $c1dc5882e052ac14$export$9b4b999b582f0205 = {
    show: function(v) {
        return "AutoFillSubForm";
    }
};
var $c1dc5882e052ac14$export$69f513126da44dd5 = function(afsf) {
    var updateSF = function(v) {
        return {
            id: v.id,
            label: v.label,
            labelClass: v.labelClass,
            section: v.section,
            expanded: v.expanded,
            cls: v.cls,
            fields: v.fields,
            collapsible: true
        };
    };
    return {
        id: afsf.id,
        select: afsf.select,
        subform: updateSF(afsf.subform)
    };
};
var $c1dc5882e052ac14$export$6660c096f6acc06c = function(v) {
    return $c1dc5882e052ac14$export$69f513126da44dd5({
        id: v.id,
        subform: v,
        select: $e594c6d0cea1455d$export$e93b750aadcbed14({
            id: v.id + "-afsf-select"
        })
    });
};
var $c1dc5882e052ac14$export$4411669f1fceaf16 = function(v) {
    return $c1dc5882e052ac14$export$69f513126da44dd5({
        id: v.id,
        subform: v,
        select: $e594c6d0cea1455d$export$8019c76663461457({
            id: v.id + "-afsf-select"
        })
    });
};
var $c1dc5882e052ac14$export$b9d183f421c4bc2f = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return false;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fieldPaths: function(fc) {
        return function(v) {
            var fc$prime = $f388db8e60bd7b97$export$94eddf153554b360(fc)(v.id);
            return $c1dc5882e052ac14$var$append1($c1dc5882e052ac14$var$fieldPaths(fc$prime)(v.select))($c1dc5882e052ac14$var$fieldPaths1(fc$prime)(v.subform));
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var fc$prime = $f388db8e60bd7b97$export$94eddf153554b360(fc)(v.id);
            var searchWidget = function() {
                if ($f388db8e60bd7b97$export$16add92498609946(fc$prime)($c1dc5882e052ac14$var$getId(v.select))) return $c1dc5882e052ac14$var$map($c1dc5882e052ac14$var$map1(function(v1) {
                    return {
                        id: v.id,
                        subform: v.subform,
                        select: v1
                    };
                }))($c1dc5882e052ac14$var$toWidget(fc$prime)(v.select));
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $c1dc5882e052ac14$var$voidRight($f388db8e60bd7b97$export$e0d76edcf577b85d(v))($c1dc5882e052ac14$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("hidden")
                ])([]));
                throw new Error("Failed pattern match at Widgets.Form.AutoFillSubForm (line 72, column 9 - line 75, column 85): ");
            }();
            var bodyWidget = $c1dc5882e052ac14$var$map($c1dc5882e052ac14$var$map1(function(v1) {
                return {
                    id: v.id,
                    select: v.select,
                    subform: v1
                };
            }))($c1dc5882e052ac14$var$toWidget1(fc$prime)(v.subform));
            return $c1dc5882e052ac14$var$map($c1dc5882e052ac14$var$map1($c1dc5882e052ac14$export$e018f5d866f184bb))($c1dc5882e052ac14$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("search-subform"),
                $fc1df90f0e252058$export$df61b30b684217c0(v.id)
            ])([
                $c1dc5882e052ac14$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("search-subform-search")
                ])([
                    searchWidget
                ]),
                $c1dc5882e052ac14$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("search-subform-body")
                ])([
                    bodyWidget
                ])
            ]));
        };
    },
    getData: function(fc) {
        return function(v) {
            var subSelId = function(sstate) {
                return $c1dc5882e052ac14$var$bind($7178b396566f5a79$export$127d1aaaa65102b1(sstate.select))(function(sel) {
                    return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(sstate.id + "Id", $0e031af7428ef07d$export$dbafa4424a806c15(sstate.funcs.itemId(sel.value))));
                });
            };
            var subSelIds = $396c4c3d9e7fae3c$export$e70771d2e7e590a(subSelId)(v.select.subsels);
            var subSelFields = $c1dc5882e052ac14$var$fromFoldable(subSelIds);
            var sfData = $c1dc5882e052ac14$var$getData(fc)(v.subform);
            var mainSelFields = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($03b6b966974423fe$export$6e22c362a0406a2c)(function(id) {
                return $c1dc5882e052ac14$var$fromHomogeneous({
                    id: $0e031af7428ef07d$export$dbafa4424a806c15(id)
                });
            })($e594c6d0cea1455d$export$d48d64a2e1742998(v.select));
            var selJson = $c045ea5df33bba60$export$971dd5b0dfd021b6(mainSelFields)(subSelFields);
            var addIDs = function(json) {
                return $0e031af7428ef07d$export$dbafa4424a806c15($c045ea5df33bba60$export$971dd5b0dfd021b6(json)(selJson));
            };
            var obj = $2a035e92dc768ac1$export$d4dde8795f959ed3(sfData)(addIDs)(sfData);
            return obj;
        };
    },
    setData: function(fc) {
        return function(v) {
            return function(json) {
                return $c1dc5882e052ac14$var$bind1($c1dc5882e052ac14$var$setData(fc)(v.subform)(json))(function(newsf) {
                    return $c1dc5882e052ac14$var$bind1($c1dc5882e052ac14$var$setData1(fc)(v.select)(json))(function(newsel) {
                        return $c1dc5882e052ac14$var$pure({
                            id: v.id,
                            subform: newsf,
                            select: newsel
                        });
                    });
                });
            };
        };
    }
};


// Generated by purs version 0.15.16















var $1bc1b1bbc920ab10$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $1bc1b1bbc920ab10$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $1bc1b1bbc920ab10$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $1bc1b1bbc920ab10$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($1bc1b1bbc920ab10$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $1bc1b1bbc920ab10$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $1bc1b1bbc920ab10$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($1bc1b1bbc920ab10$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $1bc1b1bbc920ab10$export$48513f6b9f8ce62d = function(x) {
    return x;
};
var $1bc1b1bbc920ab10$export$1d9d0fcff8299be5 = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "legacy";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
})($2c6b3d51d10471a7$export$ad55f318773e3cd5))($2c6b3d51d10471a7$export$ad55f318773e3cd5))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $1bc1b1bbc920ab10$export$1702eac557f573c7 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            var fieldClass$prime = function() {
                var $56 = v.cls === "";
                if ($56) return "flex col-span-12 items-center";
                return "flex items-center " + v.cls;
            }();
            return $1bc1b1bbc920ab10$var$map($1bc1b1bbc920ab10$var$map1($1bc1b1bbc920ab10$var$map1($f388db8e60bd7b97$export$e0d76edcf577b85d)($1bc1b1bbc920ab10$export$48513f6b9f8ce62d))(function(v1) {
                return {
                    cls: v.cls,
                    id: v.id,
                    label: v.label,
                    legacy: v.legacy,
                    value: v1
                };
            }))($1bc1b1bbc920ab10$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090(fieldClass$prime)
            ])([
                $fc8e139dfeeff88c$export$b07e517d22efa1ca($1bc1b1bbc920ab10$var$append1([
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))(v.value),
                $1bc1b1bbc920ab10$var$label([
                    $fc1df90f0e252058$export$35d9e1c947946090(id),
                    $fc1df90f0e252058$export$2913c0c0b5623090("mx-3"),
                    $fc1df90f0e252058$export$8331f8c46716f919({
                        "__html": v.label
                    })
                ])([])
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            if (v1.legacy && !v1.value) return $0e031af7428ef07d$export$dbafa4424a806c15("NO");
            if (v1.legacy && v1.value) return $0e031af7428ef07d$export$dbafa4424a806c15("YES");
            return $0e031af7428ef07d$export$dbafa4424a806c15(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(json) {
                var setYesNo = $f388db8e60bd7b97$export$89aa195e4b27a289($1bc1b1bbc920ab10$export$1702eac557f573c7)($e2b1be82a5e6d14f$export$c2f7b8312539f0ea)(v1)(function(val) {
                    var v2 = $2a035e92dc768ac1$export$f84e8e69fd4488a5(val);
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2.value0 === "YES") return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        legacy: v1.legacy,
                        value: true
                    });
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v2.value0 === "NO") return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        legacy: v1.legacy,
                        value: false
                    });
                    return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Invalid checkbox value: " + $0e031af7428ef07d$export$fac44ee5b035f737(val)));
                });
                var setBool = $f388db8e60bd7b97$export$89aa195e4b27a289($1bc1b1bbc920ab10$export$1702eac557f573c7)($e2b1be82a5e6d14f$export$c2f7b8312539f0ea)(v1)(function(val) {
                    var v2 = $2a035e92dc768ac1$export$3c2e6d1b7583eee6(val);
                    if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        legacy: v1.legacy,
                        value: v2.value0
                    });
                    if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Invalid checkbox value: " + $0e031af7428ef07d$export$fac44ee5b035f737(val)));
                    throw new Error("Failed pattern match at Widgets.Form.Checkbox (line 57, column 44 - line 59, column 90): " + [
                        v2.constructor.name
                    ]);
                });
                var $72 = $2a035e92dc768ac1$export$f9ce7b637dfbe238(json);
                if ($72) return setBool(json);
                return setYesNo(json);
            };
        };
    }
};



// Generated by purs version 0.15.16








// Generated by purs version 0.15.16
var $ccd022413a8f6522$var$createDate = function(y, m, d) {
    var date = new Date(Date.UTC(y, m, d));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date;
};
function $ccd022413a8f6522$export$278f2462bca80341(ctor, y, m, d) {
    var date = $ccd022413a8f6522$var$createDate(y, m - 1, d);
    return ctor(date.getUTCFullYear())(date.getUTCMonth() + 1)(date.getUTCDate());
}
function $ccd022413a8f6522$export$ee51fdb63bd93b0d(y, m, d) {
    return $ccd022413a8f6522$var$createDate(y, m - 1, d).getUTCDay();
}
function $ccd022413a8f6522$export$345f31f1ea862984(y1, m1, d1, y2, m2, d2) {
    var dt1 = $ccd022413a8f6522$var$createDate(y1, m1 - 1, d1);
    var dt2 = $ccd022413a8f6522$var$createDate(y2, m2 - 1, d2);
    return dt1.getTime() - dt2.getTime();
}







// Generated by purs version 0.15.16







var $e660aadfc8d8f891$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $e660aadfc8d8f891$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $e660aadfc8d8f891$var$Year = function(x) {
    return x;
};
var $e660aadfc8d8f891$export$7ee64068511a2cf0 = /* #__PURE__ */ function() {
    function Monday() {}
    Monday.value = new Monday();
    return Monday;
}();
var $e660aadfc8d8f891$export$238f9ec8ec28fcac = /* #__PURE__ */ function() {
    function Tuesday() {}
    Tuesday.value = new Tuesday();
    return Tuesday;
}();
var $e660aadfc8d8f891$export$6f4beda448624874 = /* #__PURE__ */ function() {
    function Wednesday() {}
    Wednesday.value = new Wednesday();
    return Wednesday;
}();
var $e660aadfc8d8f891$export$ee7232f0b12ab062 = /* #__PURE__ */ function() {
    function Thursday() {}
    Thursday.value = new Thursday();
    return Thursday;
}();
var $e660aadfc8d8f891$export$bb123522327d81ed = /* #__PURE__ */ function() {
    function Friday() {}
    Friday.value = new Friday();
    return Friday;
}();
var $e660aadfc8d8f891$export$446056e25969c735 = /* #__PURE__ */ function() {
    function Saturday() {}
    Saturday.value = new Saturday();
    return Saturday;
}();
var $e660aadfc8d8f891$export$8c9ac6ac028cebb2 = /* #__PURE__ */ function() {
    function Sunday() {}
    Sunday.value = new Sunday();
    return Sunday;
}();
var $e660aadfc8d8f891$export$abbad8e042a8ca41 = /* #__PURE__ */ function() {
    function January() {}
    January.value = new January();
    return January;
}();
var $e660aadfc8d8f891$export$e047bba63374153d = /* #__PURE__ */ function() {
    function February() {}
    February.value = new February();
    return February;
}();
var $e660aadfc8d8f891$export$ed40a0eacb1c1a7d = /* #__PURE__ */ function() {
    function March() {}
    March.value = new March();
    return March;
}();
var $e660aadfc8d8f891$export$b6e6de8185ac3568 = /* #__PURE__ */ function() {
    function April() {}
    April.value = new April();
    return April;
}();
var $e660aadfc8d8f891$export$50f4a85d6a193e43 = /* #__PURE__ */ function() {
    function May() {}
    May.value = new May();
    return May;
}();
var $e660aadfc8d8f891$export$ce3b81704c71b930 = /* #__PURE__ */ function() {
    function June() {}
    June.value = new June();
    return June;
}();
var $e660aadfc8d8f891$export$c35bbee8dc2d7f43 = /* #__PURE__ */ function() {
    function July() {}
    July.value = new July();
    return July;
}();
var $e660aadfc8d8f891$export$2646d2f8aef985a3 = /* #__PURE__ */ function() {
    function August() {}
    August.value = new August();
    return August;
}();
var $e660aadfc8d8f891$export$e18cdb270c0e647a = /* #__PURE__ */ function() {
    function September() {}
    September.value = new September();
    return September;
}();
var $e660aadfc8d8f891$export$af81d92e3606877a = /* #__PURE__ */ function() {
    function October() {}
    October.value = new October();
    return October;
}();
var $e660aadfc8d8f891$export$f440124e379d2b2 = /* #__PURE__ */ function() {
    function November() {}
    November.value = new November();
    return November;
}();
var $e660aadfc8d8f891$export$2d0bdb7c83ff083d = /* #__PURE__ */ function() {
    function December() {}
    December.value = new December();
    return December;
}();
var $e660aadfc8d8f891$var$Day = function(x) {
    return x;
};
var $e660aadfc8d8f891$export$fceec8b7cf7955e1 = {
    show: function(v) {
        return "(Year " + ($e660aadfc8d8f891$var$show(v) + ")");
    }
};
var $e660aadfc8d8f891$export$dca9d2e6bdb73ac1 = {
    show: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return "Monday";
        if (v instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return "Tuesday";
        if (v instanceof $e660aadfc8d8f891$export$6f4beda448624874) return "Wednesday";
        if (v instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return "Thursday";
        if (v instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return "Friday";
        if (v instanceof $e660aadfc8d8f891$export$446056e25969c735) return "Saturday";
        if (v instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return "Sunday";
        throw new Error("Failed pattern match at Data.Date.Component (line 184, column 1 - line 191, column 25): " + [
            v.constructor.name
        ]);
    }
};
var $e660aadfc8d8f891$export$448238afa9640888 = {
    show: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return "January";
        if (v instanceof $e660aadfc8d8f891$export$e047bba63374153d) return "February";
        if (v instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return "March";
        if (v instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return "April";
        if (v instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return "May";
        if (v instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return "June";
        if (v instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return "July";
        if (v instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return "August";
        if (v instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return "September";
        if (v instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return "October";
        if (v instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return "November";
        if (v instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return "December";
        throw new Error("Failed pattern match at Data.Date.Component (line 101, column 1 - line 113, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $e660aadfc8d8f891$export$4cdce79cadb90595 = {
    show: function(v) {
        return "(Day " + ($e660aadfc8d8f891$var$show(v) + ")");
    }
};
var $e660aadfc8d8f891$export$265bd81dab95f118 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $e660aadfc8d8f891$export$87032c9ef54f957e = $97937c29f879e68e$export$ff461bf68e7dd332;
var $e660aadfc8d8f891$export$a20272c1d8245ff5 = $37b880af5f4991bd$export$e65788c6d4494539;
var $e660aadfc8d8f891$export$4d379f0fc2d943bb = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0 && y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return true;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac && y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return true;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874 && y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return true;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062 && y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return true;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed && y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return true;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735 && y instanceof $e660aadfc8d8f891$export$446056e25969c735) return true;
            if (x instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2 && y instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return true;
            return false;
        };
    }
};
var $e660aadfc8d8f891$export$a765516151070d24 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0 && y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac && y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874 && y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$6f4beda448624874) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062 && y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed && y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735 && y instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$446056e25969c735) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2 && y instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e660aadfc8d8f891$export$4d379f0fc2d943bb;
    }
};
var $e660aadfc8d8f891$export$927de8112dffb3f8 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41 && y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return true;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d && y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return true;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d && y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return true;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568 && y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return true;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43 && y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return true;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930 && y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return true;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43 && y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return true;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3 && y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return true;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a && y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return true;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a && y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return true;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2 && y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return true;
            if (x instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d && y instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return true;
            return false;
        };
    }
};
var $e660aadfc8d8f891$export$98d905cecec08501 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41 && y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d && y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$e047bba63374153d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d && y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568 && y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43 && y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930 && y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43 && y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3 && y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a && y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a && y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2 && y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d && y instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Date.Component (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e660aadfc8d8f891$export$927de8112dffb3f8;
    }
};
var $e660aadfc8d8f891$export$9736822bc4d08a1e = $37b880af5f4991bd$export$e65788c6d4494539;
var $e660aadfc8d8f891$export$bcd3d7e0476c0ec3 = /* #__PURE__ */ function() {
    return {
        bottom: -271820,
        top: 275759,
        Ord0: function() {
            return $e660aadfc8d8f891$export$265bd81dab95f118;
        }
    };
}();
var $e660aadfc8d8f891$export$a8f04630df721b18 = /* #__PURE__ */ function() {
    return {
        bottom: $e660aadfc8d8f891$export$7ee64068511a2cf0.value,
        top: $e660aadfc8d8f891$export$8c9ac6ac028cebb2.value,
        Ord0: function() {
            return $e660aadfc8d8f891$export$a765516151070d24;
        }
    };
}();
var $e660aadfc8d8f891$export$ab1d1b39e9a2bfeb = /* #__PURE__ */ function() {
    return {
        bottom: $e660aadfc8d8f891$export$abbad8e042a8ca41.value,
        top: $e660aadfc8d8f891$export$2d0bdb7c83ff083d.value,
        Ord0: function() {
            return $e660aadfc8d8f891$export$98d905cecec08501;
        }
    };
}();
var $e660aadfc8d8f891$export$2391dde84a7e2cbd = {
    cardinality: 547580,
    toEnum: function(n) {
        if (n >= -271820 && n <= 275759) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 35, column 1 - line 40, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$bcd3d7e0476c0ec3;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumYear(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumYear = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumYear", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $55 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            var $56 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            return function($57) {
                return $55(function(v) {
                    return v + 1 | 0;
                }($56($57)));
            };
        }(),
        pred: function() {
            var $58 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            var $59 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
            return function($60) {
                return $58(function(v) {
                    return v - 1 | 0;
                }($59($60)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$265bd81dab95f118;
        }
    };
});
var $e660aadfc8d8f891$export$71b4ec642fe3649 = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumYear(31);
var $e660aadfc8d8f891$export$f8fb631899e9bc28 = {
    cardinality: 7,
    toEnum: function(v) {
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$7ee64068511a2cf0.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$238f9ec8ec28fcac.value);
        if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$6f4beda448624874.value);
        if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ee7232f0b12ab062.value);
        if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$bb123522327d81ed.value);
        if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$446056e25969c735.value);
        if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$8c9ac6ac028cebb2.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$7ee64068511a2cf0) return 1;
        if (v instanceof $e660aadfc8d8f891$export$238f9ec8ec28fcac) return 2;
        if (v instanceof $e660aadfc8d8f891$export$6f4beda448624874) return 3;
        if (v instanceof $e660aadfc8d8f891$export$ee7232f0b12ab062) return 4;
        if (v instanceof $e660aadfc8d8f891$export$bb123522327d81ed) return 5;
        if (v instanceof $e660aadfc8d8f891$export$446056e25969c735) return 6;
        if (v instanceof $e660aadfc8d8f891$export$8c9ac6ac028cebb2) return 7;
        throw new Error("Failed pattern match at Data.Date.Component (line 175, column 14 - line 182, column 16): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$a8f04630df721b18;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumWeekday(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumWeekday = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumWeekday", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $61 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
            var $62 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$f8fb631899e9bc28);
            return function($63) {
                return $61(function(v) {
                    return v + 1 | 0;
                }($62($63)));
            };
        }(),
        pred: function() {
            var $64 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
            var $65 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$f8fb631899e9bc28);
            return function($66) {
                return $64(function(v) {
                    return v - 1 | 0;
                }($65($66)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$a765516151070d24;
        }
    };
});
var $e660aadfc8d8f891$export$63166656fe259224 = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumWeekday(160);
var $e660aadfc8d8f891$export$e744bc4044126e99 = {
    cardinality: 12,
    toEnum: function(v) {
        if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$abbad8e042a8ca41.value);
        if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$e047bba63374153d.value);
        if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ed40a0eacb1c1a7d.value);
        if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$b6e6de8185ac3568.value);
        if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$50f4a85d6a193e43.value);
        if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$ce3b81704c71b930.value);
        if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$c35bbee8dc2d7f43.value);
        if (v === 8) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$2646d2f8aef985a3.value);
        if (v === 9) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$e18cdb270c0e647a.value);
        if (v === 10) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$af81d92e3606877a.value);
        if (v === 11) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$f440124e379d2b2.value);
        if (v === 12) return new $06733ae99ed4f534$export$8a67b48435b5d073($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fromEnum: function(v) {
        if (v instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return 1;
        if (v instanceof $e660aadfc8d8f891$export$e047bba63374153d) return 2;
        if (v instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return 3;
        if (v instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return 4;
        if (v instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return 5;
        if (v instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return 6;
        if (v instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return 7;
        if (v instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return 8;
        if (v instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return 9;
        if (v instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return 10;
        if (v instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return 11;
        if (v instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return 12;
        throw new Error("Failed pattern match at Data.Date.Component (line 87, column 14 - line 99, column 19): " + [
            v.constructor.name
        ]);
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$ab1d1b39e9a2bfeb;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumMonth(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumMonth = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumMonth", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $67 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
            var $68 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
            return function($69) {
                return $67(function(v) {
                    return v + 1 | 0;
                }($68($69)));
            };
        }(),
        pred: function() {
            var $70 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
            var $71 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
            return function($72) {
                return $70(function(v) {
                    return v - 1 | 0;
                }($71($72)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$98d905cecec08501;
        }
    };
});
var $e660aadfc8d8f891$export$fe5733da28f67bc = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumMonth(67);
var $e660aadfc8d8f891$export$337e475a74d6aff0 = {
    bottom: 1,
    top: 31,
    Ord0: function() {
        return $e660aadfc8d8f891$export$87032c9ef54f957e;
    }
};
var $e660aadfc8d8f891$export$2f59e9c675f625db = {
    cardinality: 31,
    toEnum: function(n) {
        if (n >= 1 && n <= 31) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Date.Component (line 133, column 1 - line 138, column 23): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $e660aadfc8d8f891$export$337e475a74d6aff0;
    },
    Enum1: function() {
        return $e660aadfc8d8f891$var$$lazy_enumDay(0);
    }
};
var $e660aadfc8d8f891$var$$lazy_enumDay = /* #__PURE__ */ $e660aadfc8d8f891$var$$runtime_lazy("enumDay", "Data.Date.Component", function() {
    return {
        succ: function() {
            var $73 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
            var $74 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
            return function($75) {
                return $73(function(v) {
                    return v + 1 | 0;
                }($74($75)));
            };
        }(),
        pred: function() {
            var $76 = $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
            var $77 = $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
            return function($78) {
                return $76(function(v) {
                    return v - 1 | 0;
                }($77($78)));
            };
        }(),
        Ord0: function() {
            return $e660aadfc8d8f891$export$87032c9ef54f957e;
        }
    };
});
var $e660aadfc8d8f891$export$14dd55f5b902975a = /* #__PURE__ */ $e660aadfc8d8f891$var$$lazy_enumDay(129);













var $7577649a7445e8e0$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $7577649a7445e8e0$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $7577649a7445e8e0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$f8fb631899e9bc28);
var $7577649a7445e8e0$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$fceec8b7cf7955e1);
var $7577649a7445e8e0$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$448238afa9640888);
var $7577649a7445e8e0$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($e660aadfc8d8f891$export$4cdce79cadb90595);
var $7577649a7445e8e0$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $7577649a7445e8e0$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $7577649a7445e8e0$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $7577649a7445e8e0$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$a20272c1d8245ff5);
var $7577649a7445e8e0$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$927de8112dffb3f8);
var $7577649a7445e8e0$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($e660aadfc8d8f891$export$9736822bc4d08a1e);
var $7577649a7445e8e0$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$265bd81dab95f118);
var $7577649a7445e8e0$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$98d905cecec08501);
var $7577649a7445e8e0$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($e660aadfc8d8f891$export$87032c9ef54f957e);
var $7577649a7445e8e0$var$succ = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$fe5733da28f67bc);
var $7577649a7445e8e0$var$succ1 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$14dd55f5b902975a);
var $7577649a7445e8e0$var$greaterThan = /* #__PURE__ */ $97937c29f879e68e$export$f517ea36c68d4644(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($e660aadfc8d8f891$export$87032c9ef54f957e));
var $7577649a7445e8e0$var$succ2 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($e660aadfc8d8f891$export$71b4ec642fe3649);
var $7577649a7445e8e0$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $7577649a7445e8e0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7577649a7445e8e0$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $7577649a7445e8e0$var$pred = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$fe5733da28f67bc);
var $7577649a7445e8e0$var$pred1 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$14dd55f5b902975a);
var $7577649a7445e8e0$var$pred2 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($e660aadfc8d8f891$export$71b4ec642fe3649);
var $7577649a7445e8e0$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $7577649a7445e8e0$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $7577649a7445e8e0$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $7577649a7445e8e0$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $7577649a7445e8e0$var$$$Date = /* #__PURE__ */ function() {
    function $$Date(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    $$Date.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new $$Date(value0, value1, value2);
            };
        };
    };
    return $$Date;
}();
var $7577649a7445e8e0$export$31803937850fb2da = function(v) {
    return v.value0;
};
var $7577649a7445e8e0$export$b7f7efbe9ab39b25 = function(v) {
    var n = $ccd022413a8f6522$export$ee51fdb63bd93b0d(v.value0, $7577649a7445e8e0$var$fromEnum(v.value1), v.value2);
    var $86 = n === 0;
    if ($86) return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum(7));
    return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum(n));
};
var $7577649a7445e8e0$export$893a9e6d06ff9c67 = {
    show: function(v) {
        return "(Date " + ($7577649a7445e8e0$var$show(v.value0) + (" " + ($7577649a7445e8e0$var$show1(v.value1) + (" " + ($7577649a7445e8e0$var$show2(v.value2) + ")")))));
    }
};
var $7577649a7445e8e0$export$af5de1609f06c8e6 = function(v) {
    return v.value1;
};
var $7577649a7445e8e0$export$553d7fa8e3805fc0 = function(y) {
    var y$prime = $7577649a7445e8e0$var$fromEnum1(y);
    return $7577649a7445e8e0$var$mod(y$prime)(4) === 0 && ($7577649a7445e8e0$var$mod(y$prime)(400) === 0 || !($7577649a7445e8e0$var$mod(y$prime)(100) === 0));
};
var $7577649a7445e8e0$export$36818250d6c87922 = function(y) {
    return function(m) {
        var unsafeDay = function($154) {
            return $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum1($154));
        };
        if (m instanceof $e660aadfc8d8f891$export$abbad8e042a8ca41) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$e047bba63374153d) {
            if ($7577649a7445e8e0$export$553d7fa8e3805fc0(y)) return unsafeDay(29);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return unsafeDay(28);
        }
        if (m instanceof $e660aadfc8d8f891$export$ed40a0eacb1c1a7d) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$b6e6de8185ac3568) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$50f4a85d6a193e43) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$ce3b81704c71b930) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$c35bbee8dc2d7f43) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$2646d2f8aef985a3) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$e18cdb270c0e647a) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$af81d92e3606877a) return unsafeDay(31);
        if (m instanceof $e660aadfc8d8f891$export$f440124e379d2b2) return unsafeDay(30);
        if (m instanceof $e660aadfc8d8f891$export$2d0bdb7c83ff083d) return unsafeDay(31);
        throw new Error("Failed pattern match at Data.Date (line 127, column 22 - line 141, column 27): " + [
            m.constructor.name
        ]);
    };
};
var $7577649a7445e8e0$export$4eced57d6183c43d = {
    eq: function(x) {
        return function(y) {
            return $7577649a7445e8e0$var$eq1(x.value0)(y.value0) && $7577649a7445e8e0$var$eq2(x.value1)(y.value1) && $7577649a7445e8e0$var$eq3(x.value2)(y.value2);
        };
    }
};
var $7577649a7445e8e0$var$eq4 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($7577649a7445e8e0$export$4eced57d6183c43d);
var $7577649a7445e8e0$export$722593c82468f9f4 = {
    compare: function(x) {
        return function(y) {
            var v = $7577649a7445e8e0$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v1 = $7577649a7445e8e0$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $7577649a7445e8e0$var$compare2(x.value2)(y.value2);
        };
    },
    Eq0: function() {
        return $7577649a7445e8e0$export$4eced57d6183c43d;
    }
};
var $7577649a7445e8e0$export$72e9e4e3053b6c59 = {
    succ: function(v) {
        var sm = $7577649a7445e8e0$var$succ(v.value1);
        var l = $7577649a7445e8e0$export$36818250d6c87922(v.value0)(v.value1);
        var sd = function() {
            var v1 = $7577649a7445e8e0$var$succ1(v.value2);
            var $118 = $7577649a7445e8e0$var$greaterThan(v1)(new $06733ae99ed4f534$export$8a67b48435b5d073(l));
            if ($118) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return v1;
        }();
        var m$prime = function() {
            var $119 = $06733ae99ed4f534$export$4967676db1b89293(sd);
            if ($119) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$abbad8e042a8ca41.value)(sm);
            return v.value1;
        }();
        var y$prime = function() {
            var $120 = $06733ae99ed4f534$export$4967676db1b89293(sd) && $06733ae99ed4f534$export$4967676db1b89293(sm);
            if ($120) return $7577649a7445e8e0$var$succ2(v.value0);
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }();
        var d$prime = function() {
            var $121 = $06733ae99ed4f534$export$4967676db1b89293(sd);
            if ($121) return $7577649a7445e8e0$var$toEnum1(1);
            return sd;
        }();
        return $7577649a7445e8e0$var$apply($7577649a7445e8e0$var$apply($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create)(y$prime))($7577649a7445e8e0$var$pure(m$prime)))(d$prime);
    },
    pred: function(v) {
        var pm = $7577649a7445e8e0$var$pred(v.value1);
        var pd = $7577649a7445e8e0$var$pred1(v.value2);
        var y$prime = function() {
            var $126 = $06733ae99ed4f534$export$4967676db1b89293(pd) && $06733ae99ed4f534$export$4967676db1b89293(pm);
            if ($126) return $7577649a7445e8e0$var$pred2(v.value0);
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
        }();
        var m$prime = function() {
            var $127 = $06733ae99ed4f534$export$4967676db1b89293(pd);
            if ($127) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value)(pm);
            return v.value1;
        }();
        var l = $7577649a7445e8e0$export$36818250d6c87922(v.value0)(m$prime);
        var d$prime = function() {
            var $128 = $06733ae99ed4f534$export$4967676db1b89293(pd);
            if ($128) return new $06733ae99ed4f534$export$8a67b48435b5d073(l);
            return pd;
        }();
        return $7577649a7445e8e0$var$apply($7577649a7445e8e0$var$apply($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create)(y$prime))($7577649a7445e8e0$var$pure(m$prime)))(d$prime);
    },
    Ord0: function() {
        return $7577649a7445e8e0$export$722593c82468f9f4;
    }
};
var $7577649a7445e8e0$var$pred3 = /* #__PURE__ */ $f935a9866e211c00$export$c238ae40a8cccc17($7577649a7445e8e0$export$72e9e4e3053b6c59);
var $7577649a7445e8e0$var$succ3 = /* #__PURE__ */ $f935a9866e211c00$export$61d85e1612867711($7577649a7445e8e0$export$72e9e4e3053b6c59);
var $7577649a7445e8e0$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(v) {
        return function(v1) {
            return toDuration($ccd022413a8f6522$export$345f31f1ea862984(v.value0, $7577649a7445e8e0$var$fromEnum(v.value1), v.value2, v1.value0, $7577649a7445e8e0$var$fromEnum(v1.value1), v1.value2));
        };
    };
};
var $7577649a7445e8e0$export$d2d39d1adcc883a2 = function(v) {
    return v.value2;
};
var $7577649a7445e8e0$export$e352e11a7fa73bba = function(y) {
    return function(m) {
        return function(d) {
            var mkDate = function(y$prime) {
                return function(m$prime) {
                    return function(d$prime) {
                        return new $7577649a7445e8e0$var$$$Date(y$prime, $7577649a7445e8e0$var$fromJust($7577649a7445e8e0$var$toEnum2(m$prime)), d$prime);
                    };
                };
            };
            return $ccd022413a8f6522$export$278f2462bca80341(mkDate, y, $7577649a7445e8e0$var$fromEnum(m), d);
        };
    };
};
var $7577649a7445e8e0$export$4803c954abcb09a = function(y) {
    return function(m) {
        return function(d) {
            var dt = new $7577649a7445e8e0$var$$$Date(y, m, d);
            var $144 = $7577649a7445e8e0$var$eq4($7577649a7445e8e0$export$e352e11a7fa73bba(y)(m)(d))(dt);
            if ($144) return new $06733ae99ed4f534$export$8a67b48435b5d073(dt);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
    };
};
var $7577649a7445e8e0$export$590ef5e04dc36aa5 = /* #__PURE__ */ function() {
    return {
        bottom: new $7577649a7445e8e0$var$$$Date($69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$bcd3d7e0476c0ec3), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$ab1d1b39e9a2bfeb), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($e660aadfc8d8f891$export$337e475a74d6aff0)),
        top: new $7577649a7445e8e0$var$$$Date($69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$bcd3d7e0476c0ec3), $69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$ab1d1b39e9a2bfeb), $69d0e3dbb12088d2$export$1e95b668f3b82d($e660aadfc8d8f891$export$337e475a74d6aff0)),
        Ord0: function() {
            return $7577649a7445e8e0$export$722593c82468f9f4;
        }
    };
}();
var $7577649a7445e8e0$export$2c0e788bcc82013 = function(v) {
    return function(date) {
        var adj = function(v1) {
            return function(v2) {
                if (v1 === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073(v2);
                var j = v1 + $7577649a7445e8e0$var$fromEnum2(v2.value2) | 0;
                var low = j < 1;
                var l = $7577649a7445e8e0$export$36818250d6c87922(v2.value0)(function() {
                    if (low) return $06733ae99ed4f534$export$43db023a260c5e9f($e660aadfc8d8f891$export$2d0bdb7c83ff083d.value)($7577649a7445e8e0$var$pred(v2.value1));
                    return v2.value1;
                }());
                var hi = j > $7577649a7445e8e0$var$fromEnum2(l);
                var i$prime = function() {
                    if (low) return j;
                    if (hi) return (j - $7577649a7445e8e0$var$fromEnum2(l) | 0) - 1 | 0;
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return 0;
                    throw new Error("Failed pattern match at Data.Date (line 101, column 9 - line 103, column 28): ");
                }();
                var dt$prime = function() {
                    if (low) return $7577649a7445e8e0$var$bindFlipped($7577649a7445e8e0$var$pred3)($7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create(v2.value0)(v2.value1))($7577649a7445e8e0$var$toEnum1(1)));
                    if (hi) return $7577649a7445e8e0$var$succ3(new $7577649a7445e8e0$var$$$Date(v2.value0, v2.value1, l));
                    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $7577649a7445e8e0$var$map($7577649a7445e8e0$var$$$Date.create(v2.value0)(v2.value1))($7577649a7445e8e0$var$toEnum1(j));
                    throw new Error("Failed pattern match at Data.Date (line 104, column 9 - line 106, column 48): ");
                }();
                return $7577649a7445e8e0$var$bindFlipped(adj(i$prime))(dt$prime);
            };
        };
        return $7577649a7445e8e0$var$bind($8d5664f12212b23e$export$7bbb4164c9a77bc2(v))($f57f4b701aa7b66e$export$8a83211c878a3f1f(adj)(date));
    };
};



// Generated by purs version 0.15.16
var $209026257f9663e4$var$createUTC = function(y, mo, d, h, m, s, ms) {
    var date = new Date(Date.UTC(y, mo, d, h, m, s, ms));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date.getTime();
};
function $209026257f9663e4$export$345f31f1ea862984(rec1, rec2) {
    var msUTC1 = $209026257f9663e4$var$createUTC(rec1.year, rec1.month - 1, rec1.day, rec1.hour, rec1.minute, rec1.second, rec1.millisecond);
    var msUTC2 = $209026257f9663e4$var$createUTC(rec2.year, rec2.month - 1, rec2.day, rec2.hour, rec2.minute, rec2.second, rec2.millisecond);
    return msUTC1 - msUTC2;
}
function $209026257f9663e4$export$e01c022ccf7c1b57(just) {
    return function(nothing) {
        return function(offset) {
            return function(rec) {
                var msUTC = $209026257f9663e4$var$createUTC(rec.year, rec.month - 1, rec.day, rec.hour, rec.minute, rec.second, rec.millisecond);
                var dt = new Date(msUTC + offset);
                return isNaN(dt.getTime()) ? nothing : just({
                    year: dt.getUTCFullYear(),
                    month: dt.getUTCMonth() + 1,
                    day: dt.getUTCDate(),
                    hour: dt.getUTCHours(),
                    minute: dt.getUTCMinutes(),
                    second: dt.getUTCSeconds(),
                    millisecond: dt.getUTCMilliseconds()
                });
            };
        };
    };
}















// Generated by purs version 0.15.16













// Generated by purs version 0.15.16






var $0b11e4a917ce3a7d$var$$runtime_lazy = function(name, moduleName, init) {
    var state = 0;
    var val;
    return function(lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var $0b11e4a917ce3a7d$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $0b11e4a917ce3a7d$var$Second = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Minute = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Millisecond = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$var$Hour = function(x) {
    return x;
};
var $0b11e4a917ce3a7d$export$ded5f90a35c30d2e = {
    show: function(v) {
        return "(Second " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$59c06e2004fc98a4 = {
    show: function(v) {
        return "(Minute " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$5bcc2f09c21d8c42 = {
    show: function(v) {
        return "(Millisecond " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$737acbed1f5b7f59 = {
    show: function(v) {
        return "(Hour " + ($0b11e4a917ce3a7d$var$show(v) + ")");
    }
};
var $0b11e4a917ce3a7d$export$cda9505f3bbd31a6 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$cbed256bda88f39a = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$9ae204e537c07a49 = $97937c29f879e68e$export$ff461bf68e7dd332;
var $0b11e4a917ce3a7d$export$1d37a2519784e654 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$17f5c7433e4de947 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$10d6cfb0f5850aca = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$a2181cffc8c78aa4 = $37b880af5f4991bd$export$e65788c6d4494539;
var $0b11e4a917ce3a7d$export$14f9cc6a73419a24 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$cda9505f3bbd31a6;
    }
};
var $0b11e4a917ce3a7d$export$2e9ad76d003e68e6 = {
    bottom: 0,
    top: 59,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$cbed256bda88f39a;
    }
};
var $0b11e4a917ce3a7d$export$1bc1fc48769dfdc5 = {
    bottom: 0,
    top: 999,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf;
    }
};
var $0b11e4a917ce3a7d$export$a07dd689fd52f43a = {
    bottom: 0,
    top: 23,
    Ord0: function() {
        return $0b11e4a917ce3a7d$export$9ae204e537c07a49;
    }
};
var $0b11e4a917ce3a7d$export$c9467b6184dd9c81 = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 90, column 1 - line 95, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$14f9cc6a73419a24;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumSecond(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumSecond = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumSecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $36 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            var $37 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            return function($38) {
                return $36(function(v) {
                    return v + 1 | 0;
                }($37($38)));
            };
        }(),
        pred: function() {
            var $39 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            var $40 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
            return function($41) {
                return $39(function(v) {
                    return v - 1 | 0;
                }($40($41)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$cda9505f3bbd31a6;
        }
    };
});
var $0b11e4a917ce3a7d$export$a7beee32098a9d39 = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumSecond(86);
var $0b11e4a917ce3a7d$export$d4e91fe4c2aba62a = {
    cardinality: 60,
    toEnum: function(n) {
        if (n >= 0 && n <= 59) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 61, column 1 - line 66, column 26): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$2e9ad76d003e68e6;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumMinute(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumMinute = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumMinute", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $42 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            var $43 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            return function($44) {
                return $42(function(v) {
                    return v + 1 | 0;
                }($43($44)));
            };
        }(),
        pred: function() {
            var $45 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            var $46 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
            return function($47) {
                return $45(function(v) {
                    return v - 1 | 0;
                }($46($47)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$cbed256bda88f39a;
        }
    };
});
var $0b11e4a917ce3a7d$export$997c451dd6e71518 = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumMinute(57);
var $0b11e4a917ce3a7d$export$4789fa20e673c035 = {
    cardinality: 1000,
    toEnum: function(n) {
        if (n >= 0 && n <= 999) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 120, column 1 - line 125, column 31): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$1bc1fc48769dfdc5;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumMillisecond(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumMillisecond = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumMillisecond", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $48 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
            var $49 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
            return function($50) {
                return $48(function(v) {
                    return v + 1 | 0;
                }($49($50)));
            };
        }(),
        pred: function() {
            var $51 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
            var $52 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
            return function($53) {
                return $51(function(v) {
                    return v - 1 | 0;
                }($52($53)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf;
        }
    };
});
var $0b11e4a917ce3a7d$export$f76f413973d04ccc = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumMillisecond(116);
var $0b11e4a917ce3a7d$export$3e668e9da55710cb = {
    cardinality: 24,
    toEnum: function(n) {
        if (n >= 0 && n <= 23) return new $06733ae99ed4f534$export$8a67b48435b5d073(n);
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        throw new Error("Failed pattern match at Data.Time.Component (line 32, column 1 - line 37, column 24): " + [
            n.constructor.name
        ]);
    },
    fromEnum: function(v) {
        return v;
    },
    Bounded0: function() {
        return $0b11e4a917ce3a7d$export$a07dd689fd52f43a;
    },
    Enum1: function() {
        return $0b11e4a917ce3a7d$var$$lazy_enumHour(0);
    }
};
var $0b11e4a917ce3a7d$var$$lazy_enumHour = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$runtime_lazy("enumHour", "Data.Time.Component", function() {
    return {
        succ: function() {
            var $54 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            var $55 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            return function($56) {
                return $54(function(v) {
                    return v + 1 | 0;
                }($55($56)));
            };
        }(),
        pred: function() {
            var $57 = $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            var $58 = $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
            return function($59) {
                return $57(function(v) {
                    return v - 1 | 0;
                }($58($59)));
            };
        }(),
        Ord0: function() {
            return $0b11e4a917ce3a7d$export$9ae204e537c07a49;
        }
    };
});
var $0b11e4a917ce3a7d$export$dac2f6c805cf929f = /* #__PURE__ */ $0b11e4a917ce3a7d$var$$lazy_enumHour(28);




var $d254595454e6e9b0$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$737acbed1f5b7f59);
var $d254595454e6e9b0$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$59c06e2004fc98a4);
var $d254595454e6e9b0$var$show2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$ded5f90a35c30d2e);
var $d254595454e6e9b0$var$show3 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($0b11e4a917ce3a7d$export$5bcc2f09c21d8c42);
var $d254595454e6e9b0$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $d254595454e6e9b0$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $d254595454e6e9b0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d254595454e6e9b0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $d254595454e6e9b0$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $d254595454e6e9b0$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $d254595454e6e9b0$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $d254595454e6e9b0$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $d254595454e6e9b0$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $d254595454e6e9b0$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $d254595454e6e9b0$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $d254595454e6e9b0$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$a2181cffc8c78aa4);
var $d254595454e6e9b0$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$17f5c7433e4de947);
var $d254595454e6e9b0$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$1d37a2519784e654);
var $d254595454e6e9b0$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($0b11e4a917ce3a7d$export$10d6cfb0f5850aca);
var $d254595454e6e9b0$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$9ae204e537c07a49);
var $d254595454e6e9b0$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$cbed256bda88f39a);
var $d254595454e6e9b0$var$compare2 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$cda9505f3bbd31a6);
var $d254595454e6e9b0$var$compare3 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($0b11e4a917ce3a7d$export$6e4c39aa0b4b11bf);
var $d254595454e6e9b0$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$def67087bd72fdb7);
var $d254595454e6e9b0$var$negateDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$28743521ea1cb8f9($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $d254595454e6e9b0$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $d254595454e6e9b0$var$fromDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$1a0a2c8fdf902748($3c54b6e6d30cc3be$export$93ad8ffd4576e464);
var $d254595454e6e9b0$var$greaterThan = /* #__PURE__ */ $97937c29f879e68e$export$f517ea36c68d4644($3c54b6e6d30cc3be$export$e0a5c04af6395341);
var $d254595454e6e9b0$var$lessThan = /* #__PURE__ */ $97937c29f879e68e$export$9b050841a3a1b328($3c54b6e6d30cc3be$export$e0a5c04af6395341);
var $d254595454e6e9b0$var$append2 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$e8bb798e27d1673b);
var $d254595454e6e9b0$export$680ea196effce5f = /* #__PURE__ */ function() {
    function Time(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    Time.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new Time(value0, value1, value2, value3);
                };
            };
        };
    };
    return Time;
}();
var $d254595454e6e9b0$export$a8b500dc61192962 = {
    show: function(v) {
        return "(Time " + ($d254595454e6e9b0$var$show(v.value0) + (" " + ($d254595454e6e9b0$var$show1(v.value1) + (" " + ($d254595454e6e9b0$var$show2(v.value2) + (" " + ($d254595454e6e9b0$var$show3(v.value3) + ")")))))));
    }
};
var $d254595454e6e9b0$export$6d7f956f1942326e = function(s) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, v.value1, s, v.value3);
    };
};
var $d254595454e6e9b0$export$9488e8f97d913fb3 = function(m) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, m, v.value2, v.value3);
    };
};
var $d254595454e6e9b0$export$694994bc4ee8aa99 = function(ms) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(v.value0, v.value1, v.value2, ms);
    };
};
var $d254595454e6e9b0$export$73c2a04c9ce973a8 = function(h) {
    return function(v) {
        return new $d254595454e6e9b0$export$680ea196effce5f(h, v.value1, v.value2, v.value3);
    };
};
var $d254595454e6e9b0$export$3d3c77ce7df7d30d = function(v) {
    return v.value2;
};
var $d254595454e6e9b0$export$1cacba1045a8e790 = function(v) {
    return v.value1;
};
var $d254595454e6e9b0$export$edc5e5cb87280477 = function(v) {
    return v.value3;
};
var $d254595454e6e9b0$var$millisToTime = function(v) {
    var hours = $9a14cd925227149d$export$a3fe094919f356fd(v / 3600000.0);
    var minutes = $9a14cd925227149d$export$a3fe094919f356fd((v - hours * 3600000.0) / 60000.0);
    var seconds = $9a14cd925227149d$export$a3fe094919f356fd((v - (hours * 3600000.0 + minutes * 60000.0)) / 1000.0);
    var milliseconds = v - (hours * 3600000.0 + minutes * 60000.0 + seconds * 1000.0);
    return $d254595454e6e9b0$var$fromJust($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$apply($d254595454e6e9b0$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($d254595454e6e9b0$var$toEnum($8d5664f12212b23e$export$a3fe094919f356fd(hours))))($d254595454e6e9b0$var$toEnum1($8d5664f12212b23e$export$a3fe094919f356fd(minutes))))($d254595454e6e9b0$var$toEnum2($8d5664f12212b23e$export$a3fe094919f356fd(seconds))))($d254595454e6e9b0$var$toEnum3($8d5664f12212b23e$export$a3fe094919f356fd(milliseconds))));
};
var $d254595454e6e9b0$export$842e383dfc19bc67 = function(v) {
    return v.value0;
};
var $d254595454e6e9b0$var$timeToMillis = function(t) {
    return 3600000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum($d254595454e6e9b0$export$842e383dfc19bc67(t))) + 60000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum1($d254595454e6e9b0$export$1cacba1045a8e790(t))) + 1000.0 * $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum2($d254595454e6e9b0$export$3d3c77ce7df7d30d(t))) + $4ab74a20512cef04$export$a0a81dc3380ce7d3($d254595454e6e9b0$var$fromEnum3($d254595454e6e9b0$export$edc5e5cb87280477(t)));
};
var $d254595454e6e9b0$export$9fe01c5d451d5493 = {
    eq: function(x) {
        return function(y) {
            return $d254595454e6e9b0$var$eq(x.value0)(y.value0) && $d254595454e6e9b0$var$eq1(x.value1)(y.value1) && $d254595454e6e9b0$var$eq2(x.value2)(y.value2) && $d254595454e6e9b0$var$eq3(x.value3)(y.value3);
        };
    }
};
var $d254595454e6e9b0$export$153601f213258a17 = {
    compare: function(x) {
        return function(y) {
            var v = $d254595454e6e9b0$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v1 = $d254595454e6e9b0$var$compare1(x.value1)(y.value1);
            if (v1 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v1 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            var v2 = $d254595454e6e9b0$var$compare2(x.value2)(y.value2);
            if (v2 instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v2 instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $d254595454e6e9b0$var$compare3(x.value3)(y.value3);
        };
    },
    Eq0: function() {
        return $d254595454e6e9b0$export$9fe01c5d451d5493;
    }
};
var $d254595454e6e9b0$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(t1) {
        return function(t2) {
            return toDuration($d254595454e6e9b0$var$append1($d254595454e6e9b0$var$timeToMillis(t1))($d254595454e6e9b0$var$negateDuration($d254595454e6e9b0$var$timeToMillis(t2))));
        };
    };
};
var $d254595454e6e9b0$export$70fbaefa75d69ccd = /* #__PURE__ */ function() {
    return {
        bottom: new $d254595454e6e9b0$export$680ea196effce5f($69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$a07dd689fd52f43a), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$2e9ad76d003e68e6), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$14f9cc6a73419a24), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5)),
        top: new $d254595454e6e9b0$export$680ea196effce5f($69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$a07dd689fd52f43a), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$2e9ad76d003e68e6), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$14f9cc6a73419a24), $69d0e3dbb12088d2$export$1e95b668f3b82d($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5)),
        Ord0: function() {
            return $d254595454e6e9b0$export$153601f213258a17;
        }
    };
}();
var $d254595454e6e9b0$var$maxTime = /* #__PURE__ */ $d254595454e6e9b0$var$timeToMillis(/* #__PURE__ */ $69d0e3dbb12088d2$export$1e95b668f3b82d($d254595454e6e9b0$export$70fbaefa75d69ccd));
var $d254595454e6e9b0$var$minTime = /* #__PURE__ */ $d254595454e6e9b0$var$timeToMillis(/* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($d254595454e6e9b0$export$70fbaefa75d69ccd));
var $d254595454e6e9b0$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration1 = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(t) {
            var tLength = $d254595454e6e9b0$var$timeToMillis(t);
            var d$prime = fromDuration1(d);
            var wholeDays = $9a14cd925227149d$export$a3fe094919f356fd($d254595454e6e9b0$var$unwrap(d$prime) / 8.64e7);
            var msAdjust = $d254595454e6e9b0$var$append1(d$prime)($d254595454e6e9b0$var$negateDuration($d254595454e6e9b0$var$fromDuration(wholeDays)));
            var msAdjusted = $d254595454e6e9b0$var$append1(tLength)(msAdjust);
            var wrap = function() {
                var $157 = $d254595454e6e9b0$var$greaterThan(msAdjusted)($d254595454e6e9b0$var$maxTime);
                if ($157) return 1.0;
                var $158 = $d254595454e6e9b0$var$lessThan(msAdjusted)($d254595454e6e9b0$var$minTime);
                if ($158) return -1;
                return 0.0;
            }();
            return new $71f2e2e9476163f8$export$1908877435b1d5e9($d254595454e6e9b0$var$append2(wholeDays)(wrap), $d254595454e6e9b0$var$millisToTime($d254595454e6e9b0$var$append1(msAdjusted)(8.64e7 * -wrap)));
        };
    };
};




var $18f2b327b2ac3376$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $18f2b327b2ac3376$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $18f2b327b2ac3376$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $18f2b327b2ac3376$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $18f2b327b2ac3376$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $18f2b327b2ac3376$var$fromEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $18f2b327b2ac3376$var$fromEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $18f2b327b2ac3376$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($7577649a7445e8e0$export$893a9e6d06ff9c67);
var $18f2b327b2ac3376$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($d254595454e6e9b0$export$a8b500dc61192962);
var $18f2b327b2ac3376$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($7577649a7445e8e0$export$4eced57d6183c43d);
var $18f2b327b2ac3376$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($d254595454e6e9b0$export$9fe01c5d451d5493);
var $18f2b327b2ac3376$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($7577649a7445e8e0$export$722593c82468f9f4);
var $18f2b327b2ac3376$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($d254595454e6e9b0$export$153601f213258a17);
var $18f2b327b2ac3376$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $18f2b327b2ac3376$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $18f2b327b2ac3376$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $18f2b327b2ac3376$var$join = /* #__PURE__ */ $70cd3177464e7915$export$f7e2c8231c57a8bd($06733ae99ed4f534$export$e5fea5661dee377);
var $18f2b327b2ac3376$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $18f2b327b2ac3376$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $18f2b327b2ac3376$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $18f2b327b2ac3376$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $18f2b327b2ac3376$var$toEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $18f2b327b2ac3376$var$toEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $18f2b327b2ac3376$var$toEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $18f2b327b2ac3376$export$82f9ebd9adeba146 = /* #__PURE__ */ function() {
    function DateTime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DateTime.create = function(value0) {
        return function(value1) {
            return new DateTime(value0, value1);
        };
    };
    return DateTime;
}();
var $18f2b327b2ac3376$var$toRecord = function(v) {
    return {
        year: $18f2b327b2ac3376$var$fromEnum($7577649a7445e8e0$export$31803937850fb2da(v.value0)),
        month: $18f2b327b2ac3376$var$fromEnum1($7577649a7445e8e0$export$af5de1609f06c8e6(v.value0)),
        day: $18f2b327b2ac3376$var$fromEnum2($7577649a7445e8e0$export$d2d39d1adcc883a2(v.value0)),
        hour: $18f2b327b2ac3376$var$fromEnum3($d254595454e6e9b0$export$842e383dfc19bc67(v.value1)),
        minute: $18f2b327b2ac3376$var$fromEnum4($d254595454e6e9b0$export$1cacba1045a8e790(v.value1)),
        second: $18f2b327b2ac3376$var$fromEnum5($d254595454e6e9b0$export$3d3c77ce7df7d30d(v.value1)),
        millisecond: $18f2b327b2ac3376$var$fromEnum6($d254595454e6e9b0$export$edc5e5cb87280477(v.value1))
    };
};
var $18f2b327b2ac3376$export$2da9be4cfdb689b1 = function(v) {
    return v.value1;
};
var $18f2b327b2ac3376$export$a1af12e21b57795a = {
    show: function(v) {
        return "(DateTime " + ($18f2b327b2ac3376$var$show(v.value0) + (" " + ($18f2b327b2ac3376$var$show1(v.value1) + ")")));
    }
};
var $18f2b327b2ac3376$export$1c14df74454c0d0b = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($18f2b327b2ac3376$export$82f9ebd9adeba146.create(v.value0))(f(v.value1));
        };
    };
};
var $18f2b327b2ac3376$export$26fd29b5462b0349 = function(f) {
    return function(v) {
        return new $18f2b327b2ac3376$export$82f9ebd9adeba146(v.value0, f(v.value1));
    };
};
var $18f2b327b2ac3376$export$715dbfedef2473ff = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map1($f57f4b701aa7b66e$export$8a83211c878a3f1f($18f2b327b2ac3376$export$82f9ebd9adeba146.create)(v.value1))(f(v.value0));
        };
    };
};
var $18f2b327b2ac3376$export$fd4b8ebd80749cf = function(f) {
    return function(v) {
        return new $18f2b327b2ac3376$export$82f9ebd9adeba146(f(v.value0), v.value1);
    };
};
var $18f2b327b2ac3376$export$a99463abb2339a45 = {
    eq: function(x) {
        return function(y) {
            return $18f2b327b2ac3376$var$eq(x.value0)(y.value0) && $18f2b327b2ac3376$var$eq1(x.value1)(y.value1);
        };
    }
};
var $18f2b327b2ac3376$export$e2fa58ffd7b3a1ab = {
    compare: function(x) {
        return function(y) {
            var v = $18f2b327b2ac3376$var$compare(x.value0)(y.value0);
            if (v instanceof $5026be88823ef1f4$export$7158f0ceb70f54c7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (v instanceof $5026be88823ef1f4$export$b023c82b48e70453) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            return $18f2b327b2ac3376$var$compare1(x.value1)(y.value1);
        };
    },
    Eq0: function() {
        return $18f2b327b2ac3376$export$a99463abb2339a45;
    }
};
var $18f2b327b2ac3376$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($209026257f9663e4$export$345f31f1ea862984($18f2b327b2ac3376$var$toRecord(dt1), $18f2b327b2ac3376$var$toRecord(dt2)));
        };
    };
};
var $18f2b327b2ac3376$export$324d90190a8b822a = function(v) {
    return v.value0;
};
var $18f2b327b2ac3376$export$d0805f5a2dd21c64 = /* #__PURE__ */ function() {
    return {
        bottom: new $18f2b327b2ac3376$export$82f9ebd9adeba146($69d0e3dbb12088d2$export$40e543e69a8b3fbb($7577649a7445e8e0$export$590ef5e04dc36aa5), $69d0e3dbb12088d2$export$40e543e69a8b3fbb($d254595454e6e9b0$export$70fbaefa75d69ccd)),
        top: new $18f2b327b2ac3376$export$82f9ebd9adeba146($69d0e3dbb12088d2$export$1e95b668f3b82d($7577649a7445e8e0$export$590ef5e04dc36aa5), $69d0e3dbb12088d2$export$1e95b668f3b82d($d254595454e6e9b0$export$70fbaefa75d69ccd)),
        Ord0: function() {
            return $18f2b327b2ac3376$export$e2fa58ffd7b3a1ab;
        }
    };
}();
var $18f2b327b2ac3376$export$2c0e788bcc82013 = function(dictDuration) {
    var fromDuration = $3c54b6e6d30cc3be$export$1a0a2c8fdf902748(dictDuration);
    return function(d) {
        return function(dt) {
            return $18f2b327b2ac3376$var$bind($209026257f9663e4$export$e01c022ccf7c1b57($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value)(fromDuration(d))($18f2b327b2ac3376$var$toRecord(dt)))(function(rec) {
                return $18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($18f2b327b2ac3376$export$82f9ebd9adeba146.create)($18f2b327b2ac3376$var$join($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($7577649a7445e8e0$export$4803c954abcb09a)($18f2b327b2ac3376$var$toEnum(rec.year)))($18f2b327b2ac3376$var$toEnum1(rec.month)))($18f2b327b2ac3376$var$toEnum2(rec.day)))))($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$apply($18f2b327b2ac3376$var$map($d254595454e6e9b0$export$680ea196effce5f.create)($18f2b327b2ac3376$var$toEnum3(rec.hour)))($18f2b327b2ac3376$var$toEnum4(rec.minute)))($18f2b327b2ac3376$var$toEnum5(rec.second)))($18f2b327b2ac3376$var$toEnum6(rec.millisecond)));
            });
        };
    };
};


















// Generated by purs version 0.15.16
"use strict";
const $01ed3dc2b563d4c4$export$8ad2cbe72cb8dbdb = function(data) {
    console.log(data);
};
const $01ed3dc2b563d4c4$export$c2e3216c4fcedd1 = function(msg, data) {
    console.log(msg + ":", data);
};


var $63624941bbb2d460$export$b008ad5cc3ded7bb = function(msg) {
    return function(val) {
        return $01ed3dc2b563d4c4$export$c2e3216c4fcedd1(msg, val);
    };
};
var $63624941bbb2d460$export$2c0e4c94e29279b = function(msg) {
    return function(val) {
        var x = $63624941bbb2d460$export$b008ad5cc3ded7bb(msg)(val);
        return val;
    };
};
var $63624941bbb2d460$export$140d7860bc6d1e6e = function(val) {
    return $01ed3dc2b563d4c4$export$8ad2cbe72cb8dbdb(val);
};
var $63624941bbb2d460$export$7812d84fc3648f5f = function(val) {
    var x = $63624941bbb2d460$export$140d7860bc6d1e6e(val);
    return val;
};




// Generated by purs version 0.15.16







var $13f400606229606c$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $13f400606229606c$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($13f400606229606c$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $13f400606229606c$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $13f400606229606c$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($13f400606229606c$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $13f400606229606c$export$71a1c38ce860d2fe = function($$for) {
    return function(label1) {
        return function(extraProps) {
            return $13f400606229606c$var$label($13f400606229606c$var$append([
                $fc1df90f0e252058$export$35d9e1c947946090($$for),
                $fc1df90f0e252058$export$8331f8c46716f919({
                    "__html": label1
                })
            ])(extraProps))([]);
        };
    };
};
var $13f400606229606c$export$c95f1c97489c23b = function($$for) {
    return function(label1) {
        return $13f400606229606c$export$71a1c38ce860d2fe($$for)(label1)([]);
    };
};
var $13f400606229606c$export$2d1ee3fa3f1ce03 = function(fc) {
    return function(v) {
        return $13f400606229606c$export$c95f1c97489c23b($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id))(v.label);
    };
};
var $13f400606229606c$export$ca470b1dc9d00aa6 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v1.label instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $13f400606229606c$export$71a1c38ce860d2fe($f388db8e60bd7b97$export$20223e4a23036829(v)(v1.id))(v1.label.value0)(v2);
            if (v1.label instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $13f400606229606c$var$div$prime([]);
            throw new Error("Failed pattern match at Widgets.Form.Common (line 44, column 1 - line 44, column 101): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $13f400606229606c$export$b39cccea6dbe96e5 = function(fc) {
    return function(state) {
        return $13f400606229606c$export$ca470b1dc9d00aa6(fc)(state)([]);
    };
};
var $13f400606229606c$export$cc2d6a1959a4b653 = function(fc) {
    return function(v) {
        return function(props) {
            return $13f400606229606c$export$71a1c38ce860d2fe($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id))(v.label)(props);
        };
    };
};


var $288e43cb19fd2375$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $288e43cb19fd2375$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $288e43cb19fd2375$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $288e43cb19fd2375$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $288e43cb19fd2375$var$showRecordFieldsCons = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
});
var $288e43cb19fd2375$var$showRecordFieldsCons1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
});
var $288e43cb19fd2375$var$showRecordFieldsCons2 = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
});
var $288e43cb19fd2375$var$showRecordFieldsConsNil = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
});
var $288e43cb19fd2375$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $288e43cb19fd2375$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $288e43cb19fd2375$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $288e43cb19fd2375$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $288e43cb19fd2375$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($06733ae99ed4f534$export$b203ef4465f15037);
var $288e43cb19fd2375$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $288e43cb19fd2375$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $288e43cb19fd2375$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $288e43cb19fd2375$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $288e43cb19fd2375$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $288e43cb19fd2375$var$toEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $288e43cb19fd2375$var$toEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $288e43cb19fd2375$var$toEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $288e43cb19fd2375$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $288e43cb19fd2375$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $288e43cb19fd2375$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $288e43cb19fd2375$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $288e43cb19fd2375$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $288e43cb19fd2375$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $288e43cb19fd2375$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $288e43cb19fd2375$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $288e43cb19fd2375$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $288e43cb19fd2375$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $288e43cb19fd2375$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $288e43cb19fd2375$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $288e43cb19fd2375$export$183478aa40b5df1 = function(x) {
    return x;
};
var $288e43cb19fd2375$export$7edc06cf1783b30f = function(x) {
    return x;
};
var $288e43cb19fd2375$export$3cdc770bf8b2ed3d = function(n) {
    return function(str) {
        var padlen = n - $3ee2158c14339cc9$export$f24224f1c91d8156(str) | 0;
        var pad = function() {
            if (padlen > 0) return $5b07e36f812dd04b$export$ec1dc8fbeea3467e("")($396c4c3d9e7fae3c$export$606959e7ccb797f0(padlen)("0"));
            return "";
        }();
        return pad + str;
    };
};
var $288e43cb19fd2375$export$a8b500dc61192962 = function(time) {
    return $288e43cb19fd2375$export$3cdc770bf8b2ed3d(2)($288e43cb19fd2375$var$show($288e43cb19fd2375$var$fromEnum($d254595454e6e9b0$export$842e383dfc19bc67(time)))) + (":" + $288e43cb19fd2375$export$3cdc770bf8b2ed3d(2)($288e43cb19fd2375$var$show($288e43cb19fd2375$var$fromEnum1($d254595454e6e9b0$export$1cacba1045a8e790(time)))));
};
var $288e43cb19fd2375$export$3069d8ecec413121 = function(dict) {
    return dict.showGenDate;
};
var $288e43cb19fd2375$export$e9014fcd4be488a9 = /* #__PURE__ */ $288e43cb19fd2375$var$showRecord(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons1(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons2(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsConsNil(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($35e75b0a064776f5$export$b8d60a56343922f7)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $288e43cb19fd2375$export$20f7a753325ed093 = /* #__PURE__ */ $288e43cb19fd2375$var$showRecord(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons1(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsCons2(/* #__PURE__ */ $288e43cb19fd2375$var$showRecordFieldsConsNil(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($7577649a7445e8e0$export$893a9e6d06ff9c67)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $288e43cb19fd2375$export$893a9e6d06ff9c67 = function(date) {
    return $288e43cb19fd2375$export$3cdc770bf8b2ed3d(4)($288e43cb19fd2375$var$show($288e43cb19fd2375$var$fromEnum2($7577649a7445e8e0$export$31803937850fb2da(date)))) + ("-" + ($288e43cb19fd2375$export$3cdc770bf8b2ed3d(2)($288e43cb19fd2375$var$show($288e43cb19fd2375$var$fromEnum3($7577649a7445e8e0$export$af5de1609f06c8e6(date)))) + ("-" + $288e43cb19fd2375$export$3cdc770bf8b2ed3d(2)($288e43cb19fd2375$var$show($288e43cb19fd2375$var$fromEnum4($7577649a7445e8e0$export$d2d39d1adcc883a2(date)))))));
};
var $288e43cb19fd2375$export$a1af12e21b57795a = function(dt) {
    return $288e43cb19fd2375$export$893a9e6d06ff9c67($18f2b327b2ac3376$export$324d90190a8b822a(dt)) + ("T" + $288e43cb19fd2375$export$a8b500dc61192962($18f2b327b2ac3376$export$2da9be4cfdb689b1(dt)));
};
var $288e43cb19fd2375$export$c9698ec7f05a07e1 = function(str) {
    return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$traverse($8d5664f12212b23e$export$3004f64547af360e)($5b07e36f812dd04b$export$65980d18b75784e2(":")(str)))(function(parts) {
        if (parts.length === 2) return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum(parts[0]))(function(hour) {
            return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum1(parts[1]))(function(minute) {
                return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum2(0))(function(second) {
                    return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum3(0))(function(ms) {
                        return $288e43cb19fd2375$var$pure(new $d254595454e6e9b0$export$680ea196effce5f(hour, minute, second, ms));
                    });
                });
            });
        });
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
};
var $288e43cb19fd2375$export$3706dd91d002882a = function(dict) {
    return dict.parseGenDate;
};
var $288e43cb19fd2375$export$6b862160d295c8e = function(str) {
    return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$traverse($8d5664f12212b23e$export$3004f64547af360e)($5b07e36f812dd04b$export$65980d18b75784e2("-")(str)))(function(parts) {
        if (parts.length === 3) return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum4(parts[0]))(function(year) {
            return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum5(parts[1]))(function(month) {
                return $288e43cb19fd2375$var$bind($288e43cb19fd2375$var$toEnum6(parts[2]))(function(day) {
                    return $7577649a7445e8e0$export$4803c954abcb09a(year)(month)(day);
                });
            });
        });
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    });
};
var $288e43cb19fd2375$export$588937bcd60ade55 = function(str) {
    var v = $5b07e36f812dd04b$export$65980d18b75784e2("T")(str);
    if (v.length === 2) return $288e43cb19fd2375$var$bind($288e43cb19fd2375$export$6b862160d295c8e(v[0]))(function(date) {
        return $288e43cb19fd2375$var$bind($288e43cb19fd2375$export$c9698ec7f05a07e1(v[1]))(function(time) {
            return $288e43cb19fd2375$var$pure(new $18f2b327b2ac3376$export$82f9ebd9adeba146(date, time));
        });
    });
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $288e43cb19fd2375$export$e9aa2b3e34fc11ce = function(maybeDateTimeOrJustDateIdk) {
    var v = $5b07e36f812dd04b$export$65980d18b75784e2("T")(maybeDateTimeOrJustDateIdk);
    if (v.length === 2) return $288e43cb19fd2375$export$6b862160d295c8e(v[0]);
    return $288e43cb19fd2375$export$6b862160d295c8e(maybeDateTimeOrJustDateIdk);
};
var $288e43cb19fd2375$export$f80baeb1e986c195 = function(dictGenDate) {
    var parseGenDate1 = $288e43cb19fd2375$export$3706dd91d002882a(dictGenDate);
    return function(v) {
        return function(v1) {
            if ($2a035e92dc768ac1$export$630801d484da15df(v1)) return new $7d4cccdf062a2261$export$19db0165690c701a({
                cls: v.cls,
                id: v.id,
                label: v.label,
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            });
            var v2 = $288e43cb19fd2375$var$bindFlipped(parseGenDate1)($2a035e92dc768ac1$export$f84e8e69fd4488a5(v1));
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a({
                cls: v.cls,
                id: v.id,
                label: v.label,
                value: new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0)
            });
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                var v3 = $63624941bbb2d460$export$140d7860bc6d1e6e("Failed to parse datetime: " + $0e031af7428ef07d$export$fac44ee5b035f737(v1));
                return new $7d4cccdf062a2261$export$19db0165690c701a({
                    cls: v.cls,
                    id: v.id,
                    label: v.label,
                    value: $06733ae99ed4f534$export$bebe9059409a0d04.value
                });
            }
            throw new Error("Failed pattern match at Widgets.Form.Date (line 105, column 5 - line 109, column 47): " + [
                v2.constructor.name
            ]);
        };
    };
};
var $288e43cb19fd2375$export$99376c83d8b68209 = {
    showGenDate: $25dcdcde7533cf1d$export$813805487cd3e191,
    parseGenDate: $35e75b0a064776f5$export$8b724767bfa64e7d
};
var $288e43cb19fd2375$var$genSetData1 = /* #__PURE__ */ $288e43cb19fd2375$export$f80baeb1e986c195($288e43cb19fd2375$export$99376c83d8b68209);
var $288e43cb19fd2375$export$563dbe40048d0ed8 = {
    showGenDate: $288e43cb19fd2375$export$a1af12e21b57795a,
    parseGenDate: $288e43cb19fd2375$export$588937bcd60ade55
};
var $288e43cb19fd2375$export$7aad1130e396765f = {
    showGenDate: $288e43cb19fd2375$export$893a9e6d06ff9c67,
    parseGenDate: $288e43cb19fd2375$export$e9aa2b3e34fc11ce
};
var $288e43cb19fd2375$var$genSetData2 = /* #__PURE__ */ $288e43cb19fd2375$export$f80baeb1e986c195($288e43cb19fd2375$export$7aad1130e396765f);
var $288e43cb19fd2375$export$3601aefa6c27fd31 = function(dictGenDate) {
    var parseGenDate1 = $288e43cb19fd2375$export$3706dd91d002882a(dictGenDate);
    var showGenDate1 = $288e43cb19fd2375$export$3069d8ecec413121(dictGenDate);
    return function(fc) {
        return function(htmlType) {
            return function(state) {
                var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(state.id);
                var handleInput = function(newval) {
                    var v = parseGenDate1(newval);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $288e43cb19fd2375$var$pure1({
                        cls: state.cls,
                        id: state.id,
                        label: state.label,
                        value: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                    });
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $288e43cb19fd2375$var$discard($288e43cb19fd2375$var$liftEffect($93c729927fdf3160$export$bef1f36f5486a6a3("Error parsing date " + newval)))(function() {
                        return $288e43cb19fd2375$var$pure1({
                            cls: state.cls,
                            id: state.id,
                            label: state.label,
                            value: $06733ae99ed4f534$export$bebe9059409a0d04.value
                        });
                    });
                    throw new Error("Failed pattern match at Widgets.Form.Date (line 95, column 13 - line 99, column 53): " + [
                        v.constructor.name
                    ]);
                };
                return $288e43cb19fd2375$var$bindFlipped1(handleInput)($288e43cb19fd2375$var$div([
                    $fc1df90f0e252058$export$df61b30b684217c0(id),
                    $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(state))
                ])([
                    $13f400606229606c$export$cc2d6a1959a4b653(fc)(state)([
                        $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                    ]),
                    $288e43cb19fd2375$var$input($288e43cb19fd2375$var$append1([
                        $fc1df90f0e252058$export$1741e49665a9c8e8(htmlType),
                        $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                        $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                        $fc1df90f0e252058$export$2ab9a8f9f1186f14($06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(showGenDate1)(state.value)),
                        $288e43cb19fd2375$var$map($fc1df90f0e252058$export$b79fd9f386367d78)($fc1df90f0e252058$export$7fbc06d7c1beb512)
                    ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(state.id)))
                ]));
            };
        };
    };
};
var $288e43cb19fd2375$var$dateWidget1 = /* #__PURE__ */ $288e43cb19fd2375$export$3601aefa6c27fd31($288e43cb19fd2375$export$99376c83d8b68209);
var $288e43cb19fd2375$var$dateWidget2 = /* #__PURE__ */ $288e43cb19fd2375$export$3601aefa6c27fd31($288e43cb19fd2375$export$7aad1130e396765f);
var $288e43cb19fd2375$export$73fa222918a29d85 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            return $288e43cb19fd2375$var$map1($288e43cb19fd2375$var$map2($f388db8e60bd7b97$export$e0d76edcf577b85d)($288e43cb19fd2375$export$183478aa40b5df1))($288e43cb19fd2375$var$dateWidget1(fc)("datetime-local")(v));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)(function($147) {
                return $0e031af7428ef07d$export$dbafa4424a806c15($25dcdcde7533cf1d$export$813805487cd3e191($147));
            })(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(json) {
                return $288e43cb19fd2375$var$map3($288e43cb19fd2375$export$183478aa40b5df1)($288e43cb19fd2375$var$genSetData1(v1)(json));
            };
        };
    }
};
var $288e43cb19fd2375$export$e9f4c78d39320de = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            return $288e43cb19fd2375$var$map1($288e43cb19fd2375$var$map2($f388db8e60bd7b97$export$e0d76edcf577b85d)($288e43cb19fd2375$export$7edc06cf1783b30f))($288e43cb19fd2375$var$dateWidget2(fc)("date")(v));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)(function($148) {
                return $0e031af7428ef07d$export$dbafa4424a806c15($288e43cb19fd2375$export$893a9e6d06ff9c67($148));
            })(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(json) {
                return $288e43cb19fd2375$var$map3($288e43cb19fd2375$export$7edc06cf1783b30f)($288e43cb19fd2375$var$genSetData2(v1)(json));
            };
        };
    }
};



// Generated by purs version 0.15.16

































var $38dfaea68b931435$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $38dfaea68b931435$var$intercalate = /* #__PURE__ */ $4fe7b6acfba7f29f$export$739ec22334c44788($4fe7b6acfba7f29f$export$e97014618a7eb593)($784e1bd3d26d71da$export$fc39f3d77fa2e58a);
var $38dfaea68b931435$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $38dfaea68b931435$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($fe1781b0b9eaad64$export$d23735986c0beb69));
var $38dfaea68b931435$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $38dfaea68b931435$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $38dfaea68b931435$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $38dfaea68b931435$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $38dfaea68b931435$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $38dfaea68b931435$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($38dfaea68b931435$var$idIsSymbol)()())($38dfaea68b931435$var$companyIsSymbol)()())();
var $38dfaea68b931435$var$getEmployer = /* #__PURE__ */ $e776f62b9df165a6$export$ef62e8d4627802c3(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379($38dfaea68b931435$var$decodeRecord)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08)($38dfaea68b931435$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38dfaea68b931435$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()));
var $38dfaea68b931435$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($fe1781b0b9eaad64$export$d23735986c0beb69));
var $38dfaea68b931435$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $38dfaea68b931435$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($38dfaea68b931435$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $38dfaea68b931435$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $38dfaea68b931435$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $38dfaea68b931435$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $38dfaea68b931435$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $38dfaea68b931435$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $38dfaea68b931435$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $38dfaea68b931435$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($38dfaea68b931435$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $38dfaea68b931435$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($38dfaea68b931435$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $38dfaea68b931435$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $38dfaea68b931435$var$gEncodeJsonCons1 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b));
var $38dfaea68b931435$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $38dfaea68b931435$var$gEncodeJsonCons2 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons1(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726)($38dfaea68b931435$var$nameIsSymbol)())($38dfaea68b931435$var$idIsSymbol)())()));
var $38dfaea68b931435$var$positionIsSymbol = {
    reflectSymbol: function() {
        return "position";
    }
};
var $38dfaea68b931435$var$employerIsSymbol = {
    reflectSymbol: function() {
        return "employer";
    }
};
var $38dfaea68b931435$var$gEncodeJsonCons3 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons1($eb7399d322077fcf$export$12b4d820b2ffc726)($38dfaea68b931435$var$idIsSymbol)())($38dfaea68b931435$var$companyIsSymbol)())()))(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons2($eb7399d322077fcf$export$12b4d820b2ffc726)($38dfaea68b931435$var$positionIsSymbol)())($38dfaea68b931435$var$employerIsSymbol)();
var $38dfaea68b931435$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3($38dfaea68b931435$var$gEncodeJsonCons3)());
var $38dfaea68b931435$var$contactIsSymbol = {
    reflectSymbol: function() {
        return "contact";
    }
};
var $38dfaea68b931435$var$encodeJson1 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $38dfaea68b931435$var$gEncodeJsonCons2($38dfaea68b931435$var$gEncodeJsonCons3)($38dfaea68b931435$var$contactIsSymbol)())());
var $38dfaea68b931435$var$merge = /* #__PURE__ */ $15e8567e7c31ba30$export$4950aa0f605343fb()();
var $38dfaea68b931435$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons1(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($38dfaea68b931435$var$nameIsSymbol)()())($38dfaea68b931435$var$idIsSymbol)()())()));
var $38dfaea68b931435$var$decodeRecord1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons2(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($38dfaea68b931435$var$decodeRecord))(/* #__PURE__ */ $38dfaea68b931435$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($38dfaea68b931435$var$positionIsSymbol)()())($38dfaea68b931435$var$employerIsSymbol)()())($38dfaea68b931435$var$contactIsSymbol)()())();
var $38dfaea68b931435$export$cef47ae6c9ea3933 = function(x) {
    return x;
};
var $38dfaea68b931435$export$2698d01191a9412c = function(v) {
    return {
        id: v.id,
        name: v.label
    };
};
var $38dfaea68b931435$export$1958952eac17e975 = function(v) {
    return {
        id: v.id,
        name: v.name
    };
};
var $38dfaea68b931435$export$40abf1bc8801220 = {
    show: function(v) {
        return "EmployerSelect " + v.id;
    }
};
var $38dfaea68b931435$export$969bb0591ac6da53 = function(v) {
    return {
        id: v.id,
        cls: v.cls,
        label: v.label,
        employer: $7178b396566f5a79$export$d967f07ae6c72524(v.id + "-employer")($e776f62b9df165a6$export$ab7b60cea5188b81($308f9765feb7633d$export$f5ab442a98b1cecf)($308f9765feb7633d$export$f5ab442a98b1cecf))({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
        }),
        position: $7178b396566f5a79$export$95b406ac9fa822b9(v.id + "-position")([])({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
        }),
        contact: $c3ec47a57216184e$export$71e337785367343c(v.contact)($7178b396566f5a79$export$95b406ac9fa822b9(v.id + "-contact")([])({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
        })),
        loadSelection: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
};
var $38dfaea68b931435$export$efe45683dfe97348 = function(v) {
    return {
        id: v.id,
        label: v.name
    };
};
var $38dfaea68b931435$export$80ded277947ca8d8 = function(v) {
    return {
        id: v.id,
        name: v.name
    };
};
var $38dfaea68b931435$export$7d4e502ec7dc4005 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var studentId = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v1) {
                return v1.student.id;
            })(fc.doc);
            var editable = $f388db8e60bd7b97$export$330cf2b9485e792b(fc)(v.id);
            var setEditable = function(sel) {
                return {
                    id: sel.id,
                    search: sel.search,
                    searchAff: sel.searchAff,
                    groupFunc: sel.groupFunc,
                    selected: sel.selected,
                    highlighted: sel.highlighted,
                    expanded: sel.expanded,
                    hovering: sel.hovering,
                    loadNext: sel.loadNext,
                    options: sel.options,
                    state: sel.state,
                    config: {
                        placeholder: sel.config.placeholder,
                        deselectLabel: sel.config.deselectLabel,
                        allowDeselect: sel.config.allowDeselect,
                        editable: editable
                    }
                };
            };
            var docId = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v1) {
                return v1.id;
            })(fc.doc);
            var renderState = {
                cls: v.cls,
                id: v.id,
                label: v.label,
                loadSelection: v.loadSelection,
                employer: setEditable($7178b396566f5a79$export$81e7dc1e8298801b(v.employer)($e776f62b9df165a6$export$ab7b60cea5188b81(docId)(studentId))),
                position: setEditable(v.position),
                contact: $38dfaea68b931435$var$map(setEditable)(v.contact)
            };
            var employerSelID = $f388db8e60bd7b97$export$20223e4a23036829(fc)(renderState.employer.id);
            var positionSelID = $f388db8e60bd7b97$export$20223e4a23036829(fc)(renderState.position.id);
            var contactSelId = function(contact) {
                return $f388db8e60bd7b97$export$20223e4a23036829(fc)(contact.id);
            };
            var renderSelects = function(currentState) {
                var truncName = function(inp) {
                    var parts = $5b07e36f812dd04b$export$65980d18b75784e2(" ")(inp);
                    var $191 = $fc8c1182ec2aefec$export$f24224f1c91d8156(parts) > 2;
                    if ($191) return $38dfaea68b931435$var$intercalate(" ")(parts) + "...";
                    return inp;
                };
                var setCreatedEmployer = function(id) {
                    return $38dfaea68b931435$var$bindFlipped($54dae5ca6a6cd16d$export$b356868cfa7ebfaf)($d2284b2d3e1b6f87$export$8291c2122093ac93($38dfaea68b931435$var$bind($3257df7cdef77623$export$b97f2ad8d0b7442d($38dfaea68b931435$var$runGraphQL($38dfaea68b931435$var$getEmployer(id)($308f9765feb7633d$export$87708d888b4bc8a6($38dfaea68b931435$var$map(function(v1) {
                        return v1.id;
                    })(fc.doc)))($308f9765feb7633d$export$87708d888b4bc8a6($38dfaea68b931435$var$map(function(v1) {
                        return v1.student.id;
                    })(fc.doc))))))(function(emp) {
                        var item = {
                            label: emp.company,
                            value: emp
                        };
                        return $38dfaea68b931435$var$pure({
                            cls: currentState.cls,
                            id: currentState.id,
                            label: currentState.label,
                            loadSelection: currentState.loadSelection,
                            employer: setEditable($7178b396566f5a79$export$5a4818cec1656a71(currentState.employer)(new $06733ae99ed4f534$export$8a67b48435b5d073(item))),
                            position: setEditable($7178b396566f5a79$export$81e7dc1e8298801b(currentState.position)($e776f62b9df165a6$export$8f428e086e902ded(docId)(studentId)(emp.id))),
                            contact: $f57f4b701aa7b66e$export$8a83211c878a3f1f($38dfaea68b931435$var$map)(currentState.contact)(function(contact) {
                                return setEditable($7178b396566f5a79$export$81e7dc1e8298801b(contact)($e776f62b9df165a6$export$ac1bd8a342846243(docId)(studentId)(emp.id)));
                            })
                        });
                    })));
                };
                var onSelectedEmployer = function(empSel) {
                    return {
                        cls: currentState.cls,
                        id: currentState.id,
                        label: currentState.label,
                        loadSelection: currentState.loadSelection,
                        employer: empSel,
                        position: setEditable($f57f4b701aa7b66e$export$8a83211c878a3f1f($7178b396566f5a79$export$5a4818cec1656a71)($06733ae99ed4f534$export$bebe9059409a0d04.value)($7178b396566f5a79$export$81e7dc1e8298801b(currentState.position)($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($7178b396566f5a79$export$3fb6c8f3fe50bc9f)(function(e) {
                            return $e776f62b9df165a6$export$8f428e086e902ded(docId)(studentId)(e.value.id);
                        })($7178b396566f5a79$export$127d1aaaa65102b1(empSel))))),
                        contact: $f57f4b701aa7b66e$export$8a83211c878a3f1f($38dfaea68b931435$var$map)(currentState.contact)(function(contact) {
                            return setEditable($f57f4b701aa7b66e$export$8a83211c878a3f1f($7178b396566f5a79$export$5a4818cec1656a71)($06733ae99ed4f534$export$bebe9059409a0d04.value)($7178b396566f5a79$export$81e7dc1e8298801b(contact)($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($7178b396566f5a79$export$3fb6c8f3fe50bc9f)(function(e) {
                                return $e776f62b9df165a6$export$ac1bd8a342846243(docId)(studentId)(e.value.id);
                            })($7178b396566f5a79$export$127d1aaaa65102b1(empSel)))));
                        })
                    };
                };
                var editBtn = function(emp) {
                    var btn = $38dfaea68b931435$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn employer-add-btn"),
                        $fc1df90f0e252058$export$1d5a917feb871989
                    ])([
                        $38dfaea68b931435$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("edit-employer") + truncName(emp.company))
                    ]);
                    return $38dfaea68b931435$var$bind1(btn)(function() {
                        return $38dfaea68b931435$var$bind1($38dfaea68b931435$var$alt($e0dae94260b9d371$export$2d6ae09600947940(new $06733ae99ed4f534$export$8a67b48435b5d073(emp.id)))($9c13a1c3d948adb8$export$be9e2feb4e35335b(btn)))(function(eid) {
                            if (eid instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return setCreatedEmployer(eid.value0);
                            if (eid instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $38dfaea68b931435$var$pure1(currentState);
                            throw new Error("Failed pattern match at Widgets.Form.EmployerSelect (line 146, column 17 - line 148, column 49): " + [
                                eid.constructor.name
                            ]);
                        });
                    });
                };
                var canCreateEmployers = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(v1) {
                    return v1.can.create_employers;
                })(fc.doc);
                var addBtn = function() {
                    var btn = $38dfaea68b931435$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn employer-add-btn"),
                        $fc1df90f0e252058$export$1d5a917feb871989
                    ])([
                        $38dfaea68b931435$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("add-employer"))
                    ]);
                    return $38dfaea68b931435$var$bind1(btn)(function() {
                        return $38dfaea68b931435$var$bind1($38dfaea68b931435$var$alt($e0dae94260b9d371$export$2d6ae09600947940($06733ae99ed4f534$export$bebe9059409a0d04.value))($9c13a1c3d948adb8$export$be9e2feb4e35335b(btn)))(function(eid) {
                            if (eid instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return setCreatedEmployer(eid.value0);
                            if (eid instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $38dfaea68b931435$var$pure1(currentState);
                            throw new Error("Failed pattern match at Widgets.Form.EmployerSelect (line 134, column 17 - line 136, column 49): " + [
                                eid.constructor.name
                            ]);
                        });
                    });
                }();
                return $38dfaea68b931435$var$map1($38dfaea68b931435$var$map2($f388db8e60bd7b97$export$e0d76edcf577b85d)($38dfaea68b931435$export$cef47ae6c9ea3933))($38dfaea68b931435$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(currentState)),
                    $fc1df90f0e252058$export$df61b30b684217c0(currentState.id)
                ])([
                    $13f400606229606c$export$2d1ee3fa3f1ce03(fc)(currentState),
                    $38dfaea68b931435$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("search-subform-select-wrapper w-full")
                    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                        new $06733ae99ed4f534$export$8a67b48435b5d073($38dfaea68b931435$var$label([
                            $fc1df90f0e252058$export$35d9e1c947946090(employerSelID)
                        ])([
                            $38dfaea68b931435$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("employer"))
                        ])),
                        new $06733ae99ed4f534$export$8a67b48435b5d073($38dfaea68b931435$var$map1(onSelectedEmployer)($7178b396566f5a79$export$c4791769f9191c37(employerSelID)(currentState.employer))),
                        $c3ec47a57216184e$export$71e337785367343c(editable && canCreateEmployers)($38dfaea68b931435$var$div([
                            $fc1df90f0e252058$export$2913c0c0b5623090("employer-edit-buttons")
                        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                            new $06733ae99ed4f534$export$8a67b48435b5d073(addBtn),
                            $38dfaea68b931435$var$map(editBtn)($38dfaea68b931435$var$map(function(v1) {
                                return v1.value;
                            })($7178b396566f5a79$export$127d1aaaa65102b1(currentState.employer)))
                        ]))),
                        new $06733ae99ed4f534$export$8a67b48435b5d073($38dfaea68b931435$var$label([
                            $fc1df90f0e252058$export$35d9e1c947946090(positionSelID)
                        ])([
                            $38dfaea68b931435$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("position"))
                        ])),
                        new $06733ae99ed4f534$export$8a67b48435b5d073($38dfaea68b931435$var$map1(function(v1) {
                            return {
                                cls: currentState.cls,
                                contact: currentState.contact,
                                employer: currentState.employer,
                                id: currentState.id,
                                label: currentState.label,
                                loadSelection: currentState.loadSelection,
                                position: v1
                            };
                        })($7178b396566f5a79$export$c4791769f9191c37(positionSelID)(currentState.position))),
                        $f57f4b701aa7b66e$export$8a83211c878a3f1f($38dfaea68b931435$var$map)(currentState.contact)(function(contact) {
                            return $38dfaea68b931435$var$label([
                                $fc1df90f0e252058$export$35d9e1c947946090(contactSelId(contact))
                            ])([
                                $38dfaea68b931435$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("contact"))
                            ]);
                        }),
                        $f57f4b701aa7b66e$export$8a83211c878a3f1f($38dfaea68b931435$var$map)(currentState.contact)(function(contact) {
                            return $38dfaea68b931435$var$map1($38dfaea68b931435$var$map2(function(v1) {
                                return {
                                    cls: currentState.cls,
                                    employer: currentState.employer,
                                    id: currentState.id,
                                    label: currentState.label,
                                    loadSelection: currentState.loadSelection,
                                    position: currentState.position,
                                    contact: v1
                                };
                            })($06733ae99ed4f534$export$8a67b48435b5d073.create))($7178b396566f5a79$export$c4791769f9191c37(contactSelId(contact))(contact));
                        })
                    ]))
                ]));
            };
            return renderSelects(renderState);
        };
    },
    getData: function(v) {
        return function(v1) {
            var always = {
                employer: $38dfaea68b931435$var$map(function(e) {
                    return {
                        id: e.value.id,
                        company: e.value.company
                    };
                })($7178b396566f5a79$export$127d1aaaa65102b1(v1.employer)),
                position: $38dfaea68b931435$var$map($38dfaea68b931435$var$map2($38dfaea68b931435$export$2698d01191a9412c)(function(v2) {
                    return v2.value;
                }))($7178b396566f5a79$export$127d1aaaa65102b1(v1.position))
            };
            if (v1.contact instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $38dfaea68b931435$var$encodeJson(always);
            if (v1.contact instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $38dfaea68b931435$var$encodeJson1($38dfaea68b931435$var$merge(always)({
                contact: $38dfaea68b931435$var$map($38dfaea68b931435$var$map2($38dfaea68b931435$export$1958952eac17e975)(function(v2) {
                    return v2.value;
                }))($7178b396566f5a79$export$127d1aaaa65102b1(v1.contact.value0))
            }));
            throw new Error("Failed pattern match at Widgets.Form.EmployerSelect (line 170, column 41 - line 173, column 73): " + [
                v1.contact.constructor.name
            ]);
        };
    },
    setData: function(fc) {
        return function(v) {
            var studentId = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v1) {
                return v1.student.id;
            })(fc.doc);
            var docId = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v1) {
                return v1.id;
            })(fc.doc);
            return $f388db8e60bd7b97$export$89aa195e4b27a289($38dfaea68b931435$export$7d4e502ec7dc4005)($38dfaea68b931435$var$decodeRecord1)(v)(function(v1) {
                return new $7d4cccdf062a2261$export$19db0165690c701a({
                    loadSelection: v.loadSelection,
                    id: v.id,
                    cls: v.cls,
                    label: v.label,
                    employer: $7178b396566f5a79$export$5a4818cec1656a71(v.employer)($38dfaea68b931435$var$map(function(e) {
                        return {
                            label: e.company,
                            value: e
                        };
                    })(v1.employer)),
                    position: $f57f4b701aa7b66e$export$8a83211c878a3f1f($7178b396566f5a79$export$5a4818cec1656a71)($38dfaea68b931435$var$map(function(p) {
                        return {
                            label: p.label,
                            value: p
                        };
                    })($38dfaea68b931435$var$map($38dfaea68b931435$export$efe45683dfe97348)(v1.position)))($7178b396566f5a79$export$81e7dc1e8298801b(v.position)($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($7178b396566f5a79$export$3fb6c8f3fe50bc9f)(function(e) {
                        return $e776f62b9df165a6$export$8f428e086e902ded(docId)(studentId)(e.id);
                    })(v1.employer))),
                    contact: $f57f4b701aa7b66e$export$8a83211c878a3f1f($38dfaea68b931435$var$map)(v.contact)(function(contact) {
                        return $f57f4b701aa7b66e$export$8a83211c878a3f1f($7178b396566f5a79$export$5a4818cec1656a71)($38dfaea68b931435$var$map(function(p) {
                            return {
                                label: p.name,
                                value: p
                            };
                        })($38dfaea68b931435$var$map($38dfaea68b931435$export$80ded277947ca8d8)(v1.contact)))($7178b396566f5a79$export$81e7dc1e8298801b(contact)($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($7178b396566f5a79$export$3fb6c8f3fe50bc9f)(function(e) {
                            return $e776f62b9df165a6$export$ac1bd8a342846243(docId)(studentId)(e.id);
                        })(v1.employer)));
                    })
                });
            });
        };
    }
};


// Generated by purs version 0.15.16


























// Generated by purs version 0.15.16



























// Generated by purs version 0.15.16














var $c1e04b9648c3de60$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $c1e04b9648c3de60$var$div = /* #__PURE__ */ $b0cd729514c2504e$export$159d9494db57879b($b0cd729514c2504e$export$437776face1858ae);
var $c1e04b9648c3de60$var$min = /* #__PURE__ */ $97937c29f879e68e$export$96ec731ed4dcb222($97937c29f879e68e$export$ff461bf68e7dd332);
var $c1e04b9648c3de60$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c1e04b9648c3de60$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $c1e04b9648c3de60$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($c1e04b9648c3de60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1e04b9648c3de60$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($c1e04b9648c3de60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1e04b9648c3de60$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $c1e04b9648c3de60$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $c1e04b9648c3de60$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $c1e04b9648c3de60$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c1e04b9648c3de60$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($37b880af5f4991bd$export$e65788c6d4494539);
var $c1e04b9648c3de60$var$div1 = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($c1e04b9648c3de60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1e04b9648c3de60$var$nearbyNumbers = function(v) {
    return function(v1) {
        return function(v2) {
            if (v > v1) return $396c4c3d9e7fae3c$export$d02631cccf789723(1)(v1);
            var startAt = $c1e04b9648c3de60$var$max(1)(v2 - $c1e04b9648c3de60$var$div(v)(2) | 0);
            var less = function() {
                if (v2 > 1) return $396c4c3d9e7fae3c$export$d02631cccf789723(startAt)(v2 - 1 | 0);
                return [];
            }();
            var endLen = v - (v2 - startAt | 0) | 0;
            var endAt = $c1e04b9648c3de60$var$min(v1)((v2 + endLen | 0) - 1 | 0);
            var more = $396c4c3d9e7fae3c$export$d02631cccf789723(v2)(endAt);
            return $c1e04b9648c3de60$var$append(less)(more);
        };
    };
};
var $c1e04b9648c3de60$export$dbddd5d79461a47c = function(v) {
    if ($b5f6b40b8f63b732$export$9dc5a492d60176d9(v) <= 1) return $c1e04b9648c3de60$var$div$prime([]);
    var pageNo = $b5f6b40b8f63b732$export$5b1c922c81430b65(v);
    var pageLink = function(n) {
        return function(txt) {
            var cls = function() {
                if (n === pageNo) return "btn btn-primary";
                return "btn";
            }();
            return $c1e04b9648c3de60$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090(cls),
                $c1e04b9648c3de60$var$voidRight(n)($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$1741e49665a9c8e8("button")
            ])([
                $c1e04b9648c3de60$var$text(txt)
            ]);
        };
    };
    var pageLinkN = function(n) {
        return pageLink(n)($c1e04b9648c3de60$var$show(n));
    };
    var prevLink = function() {
        if (pageNo > 1) return [
            pageLink(pageNo - 1 | 0)($c3328e54cdf5154c$export$5a1a8430df9521e("prev"))
        ];
        return [];
    }();
    var lastPage = $b5f6b40b8f63b732$export$9dc5a492d60176d9(v);
    var nearNums = $c1e04b9648c3de60$var$nearbyNumbers(10)(lastPage)(pageNo);
    var pageNumLinks = $c1e04b9648c3de60$var$map(pageLinkN)(nearNums);
    var nextLink = function() {
        if (pageNo < lastPage) return [
            pageLink(pageNo + 1 | 0)($c3328e54cdf5154c$export$5a1a8430df9521e("next"))
        ];
        return [];
    }();
    var lastLink = function() {
        if ($c1e04b9648c3de60$var$elem(lastPage)(nearNums)) return [];
        return [
            pageLink(lastPage)("... " + $c1e04b9648c3de60$var$show(lastPage))
        ];
    }();
    var firstLink = function() {
        if ($c1e04b9648c3de60$var$elem(1)(nearNums)) return [];
        return [
            pageLink(1)("1 ...")
        ];
    }();
    return $c1e04b9648c3de60$var$div1([
        $fc1df90f0e252058$export$2913c0c0b5623090("pager btn-group")
    ])($c1e04b9648c3de60$var$append(prevLink)($c1e04b9648c3de60$var$append(firstLink)($c1e04b9648c3de60$var$append(pageNumLinks)($c1e04b9648c3de60$var$append(lastLink)(nextLink)))));
};




// Generated by purs version 0.15.16














var $035405231d3ae317$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $035405231d3ae317$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $035405231d3ae317$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $035405231d3ae317$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $035405231d3ae317$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $035405231d3ae317$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $035405231d3ae317$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $035405231d3ae317$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$var$h1$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$78e024695ac0e4c4($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($035405231d3ae317$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $035405231d3ae317$export$a09a21bd8097e7 = /* #__PURE__ */ function() {
    function ModalClosed() {}
    ModalClosed.value = new ModalClosed();
    return ModalClosed;
}();
var $035405231d3ae317$export$c00f2c00f91f14d5 = /* #__PURE__ */ function() {
    function ModalReturned(value0) {
        this.value0 = value0;
    }
    ModalReturned.create = function(value0) {
        return new ModalReturned(value0);
    };
    return ModalReturned;
}();
var $035405231d3ae317$export$204c43257a011371 = function(outer) {
    return function(inner) {
        return $035405231d3ae317$var$alt($9c13a1c3d948adb8$export$be9e2feb4e35335b(outer))($035405231d3ae317$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal")
        ])([
            inner,
            $035405231d3ae317$var$a([
                $035405231d3ae317$var$voidRight($035405231d3ae317$export$a09a21bd8097e7.value)($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("modal-close")
            ])([
                $035405231d3ae317$var$text("Close")
            ])
        ]));
    };
};
var $035405231d3ae317$export$21159b4378d24276 = function(outer) {
    return function(inner) {
        return $035405231d3ae317$export$204c43257a011371(outer)($035405231d3ae317$var$map($035405231d3ae317$export$c00f2c00f91f14d5.create)(inner));
    };
};
var $035405231d3ae317$export$937ad7a399f5d64 = function(outer) {
    return function(inner) {
        return function(state) {
            return $035405231d3ae317$var$bind($035405231d3ae317$export$204c43257a011371(outer)(inner(state)))(function(ret) {
                if (ret instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $035405231d3ae317$export$937ad7a399f5d64(outer)(inner)(ret.value0);
                if (ret instanceof $035405231d3ae317$export$a09a21bd8097e7) return $035405231d3ae317$var$pure(state);
                throw new Error("Failed pattern match at Widgets.Modal (line 41, column 5 - line 43, column 34): " + [
                    ret.constructor.name
                ]);
            });
        };
    };
};
var $035405231d3ae317$export$b72a0a8a910c4215 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(err) {
        return $035405231d3ae317$var$bind($035405231d3ae317$var$div$prime([
            $035405231d3ae317$var$h1$prime([
                $035405231d3ae317$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("error-occurred"))
            ]),
            $035405231d3ae317$var$p$prime([
                $035405231d3ae317$var$text(show(err))
            ]),
            $035405231d3ae317$var$button([
                $035405231d3ae317$var$voidRight(0)($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $035405231d3ae317$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("ok"))
            ])
        ]))(function() {
            return $035405231d3ae317$var$pure($035405231d3ae317$export$a09a21bd8097e7.value);
        });
    };
};
var $035405231d3ae317$var$errorModalWidget1 = /* #__PURE__ */ $035405231d3ae317$export$b72a0a8a910c4215($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $035405231d3ae317$export$34d1415d60a4cca4 = function(outer) {
    return function(inner) {
        return $035405231d3ae317$var$bind($035405231d3ae317$export$21159b4378d24276(outer)(inner))(function(v) {
            if (v instanceof $035405231d3ae317$export$a09a21bd8097e7) return $035405231d3ae317$var$pure($035405231d3ae317$export$a09a21bd8097e7.value);
            if (v instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && v.value0 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $035405231d3ae317$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(v.value0.value0));
            if (v instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && v.value0 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $035405231d3ae317$export$204c43257a011371(outer)($035405231d3ae317$var$errorModalWidget1(v.value0.value0));
            throw new Error("Failed pattern match at Widgets.Modal (line 53, column 61 - line 56, column 74): " + [
                v.constructor.name
            ]);
        });
    };
};


var $6f8f3e97c4d83891$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $6f8f3e97c4d83891$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $6f8f3e97c4d83891$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6f8f3e97c4d83891$var$selectionCheckbox = /* #__PURE__ */ $f264ceec36a478ad$export$21f1fa92f77cf950($6f8f3e97c4d83891$var$ordRNTY);
var $6f8f3e97c4d83891$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $6f8f3e97c4d83891$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $6f8f3e97c4d83891$var$h2$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$1b9b631f8eb73296($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $6f8f3e97c4d83891$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($91ee3359f6bcea22$export$7090c31be3a1e8ea);
var $6f8f3e97c4d83891$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $6f8f3e97c4d83891$var$h1$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$78e024695ac0e4c4($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $6f8f3e97c4d83891$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $6f8f3e97c4d83891$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $6f8f3e97c4d83891$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $6f8f3e97c4d83891$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $6f8f3e97c4d83891$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $6f8f3e97c4d83891$var$selectAllCheckbox$prime = /* #__PURE__ */ $f264ceec36a478ad$export$1ee36b6d1ce76362($6f8f3e97c4d83891$var$ordRNTY)($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $6f8f3e97c4d83891$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $6f8f3e97c4d83891$var$nav = /* #__PURE__ */ $3eadc1b959dd1120$export$80e4b313e5e6b30d($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($6f8f3e97c4d83891$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6f8f3e97c4d83891$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $6f8f3e97c4d83891$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $6f8f3e97c4d83891$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $6f8f3e97c4d83891$var$ChangeTab = /* #__PURE__ */ function() {
    function ChangeTab(value0) {
        this.value0 = value0;
    }
    ChangeTab.create = function(value0) {
        return new ChangeTab(value0);
    };
    return ChangeTab;
}();
var $6f8f3e97c4d83891$var$CourseChange = /* #__PURE__ */ function() {
    function CourseChange(value0) {
        this.value0 = value0;
    }
    CourseChange.create = function(value0) {
        return new CourseChange(value0);
    };
    return CourseChange;
}();
var $6f8f3e97c4d83891$var$Selection = /* #__PURE__ */ function() {
    function Selection(value0) {
        this.value0 = value0;
    }
    Selection.create = function(value0) {
        return new Selection(value0);
    };
    return Selection;
}();
var $6f8f3e97c4d83891$var$ChangePage = /* #__PURE__ */ function() {
    function ChangePage(value0) {
        this.value0 = value0;
    }
    ChangePage.create = function(value0) {
        return new ChangePage(value0);
    };
    return ChangePage;
}();
var $6f8f3e97c4d83891$var$Done = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $6f8f3e97c4d83891$var$EPAction = /* #__PURE__ */ function() {
    function EPAction(value0) {
        this.value0 = value0;
    }
    EPAction.create = function(value0) {
        return new EPAction(value0);
    };
    return EPAction;
}();
var $6f8f3e97c4d83891$var$LoadResult = /* #__PURE__ */ function() {
    function LoadResult(value0) {
        this.value0 = value0;
    }
    LoadResult.create = function(value0) {
        return new LoadResult(value0);
    };
    return LoadResult;
}();
var $6f8f3e97c4d83891$export$9ec5fd99abbd9d7c = function(state) {
    return $f264ceec36a478ad$export$7693e0a1b9351086(state.selection);
};
var $6f8f3e97c4d83891$export$9eb1f527eadefcb5 = $7178b396566f5a79$export$681ac624aa06ab03;
var $6f8f3e97c4d83891$var$pager = function(page) {
    return $6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$ChangePage.create)($c1e04b9648c3de60$export$dbddd5d79461a47c(page));
};
var $6f8f3e97c4d83891$export$f17704b0c58450aa = function(init) {
    var tab = function(v) {
        return {
            label: v.label,
            query: v.query,
            page: new $7d4cccdf062a2261$export$37c4d04eafdc5515(""),
            select: v.select
        };
    };
    var tabs = $6f8f3e97c4d83891$var$map1(tab)(init.tabs);
    return {
        selection: $f264ceec36a478ad$export$6e22c362a0406a2c,
        tabs: tabs,
        activeTab: 0
    };
};
var $6f8f3e97c4d83891$var$expectationCheck = function(state) {
    return function(exp) {
        return $6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$Selection.create)($6f8f3e97c4d83891$var$selectionCheckbox(exp.id)(exp)($fc8e139dfeeff88c$export$344f17102956e4bc($308f9765feb7633d$export$a1b0f5347d2470b(exp.id))(exp.description))(state.selection));
    };
};
var $6f8f3e97c4d83891$var$exListItem = function(state) {
    return function(exp) {
        return $6f8f3e97c4d83891$var$expectationCheck(state)(exp);
    };
};
var $6f8f3e97c4d83891$var$exSubCategory = function(state) {
    return function(exps) {
        var category = $e39dfcf102cdca3c$export$5fd5031fecdacec3(exps).sub_category;
        return $6f8f3e97c4d83891$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("expectation-category")
        ])($6f8f3e97c4d83891$var$append(function() {
            if (category instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
                $6f8f3e97c4d83891$var$h2$prime([
                    $6f8f3e97c4d83891$var$text(category.value0)
                ])
            ];
            if (category instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
            throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 222, column 6 - line 224, column 22): " + [
                category.constructor.name
            ]);
        }())($6f8f3e97c4d83891$var$map1($6f8f3e97c4d83891$var$exListItem(state))($6f8f3e97c4d83891$var$fromFoldable(exps))));
    };
};
var $6f8f3e97c4d83891$var$exCategory = function(state) {
    return function(exps) {
        var grouped = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(a1) {
            return function(b) {
                return $6f8f3e97c4d83891$var$eq(a1.sub_category)(b.sub_category);
            };
        })($6f8f3e97c4d83891$var$fromFoldable(exps));
        var category = $e39dfcf102cdca3c$export$5fd5031fecdacec3(exps).category;
        return $6f8f3e97c4d83891$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("expectation-category")
        ])($6f8f3e97c4d83891$var$append(function() {
            if (category instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
                $6f8f3e97c4d83891$var$h1$prime([
                    $6f8f3e97c4d83891$var$text(category.value0)
                ])
            ];
            if (category instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
            throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 209, column 6 - line 211, column 22): " + [
                category.constructor.name
            ]);
        }())($6f8f3e97c4d83891$var$map1($6f8f3e97c4d83891$var$exSubCategory(state))(grouped)));
    };
};
var $6f8f3e97c4d83891$var$currentTab = function(state) {
    return $6f8f3e97c4d83891$var$fromJust($396c4c3d9e7fae3c$export$b610b8812bbcded9(state.tabs)(state.activeTab));
};
var $6f8f3e97c4d83891$var$select$prime = function(state) {
    return $6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$CourseChange.create)($7178b396566f5a79$export$54b124386ef5abe3($6f8f3e97c4d83891$var$currentTab(state).select));
};
var $6f8f3e97c4d83891$var$updateTab = function(state) {
    return function(update) {
        return $6f8f3e97c4d83891$var$bind(update($6f8f3e97c4d83891$var$currentTab(state)))(function(newtab) {
            var v = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(state.activeTab)(newtab)(state.tabs);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $6f8f3e97c4d83891$var$pure({
                activeTab: state.activeTab,
                selection: state.selection,
                tabs: v.value0
            });
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6f8f3e97c4d83891$var$discard($6f8f3e97c4d83891$var$liftEffect($93c729927fdf3160$export$bef1f36f5486a6a3("Expectation picker current tab index out of bounds!!")))(function() {
                return $6f8f3e97c4d83891$var$pure(state);
            });
            throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 252, column 5 - line 258, column 22): " + [
                v.constructor.name
            ]);
        });
    };
};
var $6f8f3e97c4d83891$var$handle$prime = function(v) {
    return function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $6f8f3e97c4d83891$var$updateTab(v)(function(tab) {
            return $6f8f3e97c4d83891$var$pure({
                label: tab.label,
                query: tab.query,
                select: tab.select,
                page: new $7d4cccdf062a2261$export$19db0165690c701a(v1.value0)
            });
        });
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $6f8f3e97c4d83891$var$updateTab(v)(function(tab) {
            return $6f8f3e97c4d83891$var$pure({
                label: tab.label,
                query: tab.query,
                select: tab.select,
                page: new $7d4cccdf062a2261$export$37c4d04eafdc5515("Error loading expectations: " + $6f8f3e97c4d83891$var$show(v1.value0))
            });
        });
        throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 146, column 1 - line 148, column 41): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $6f8f3e97c4d83891$var$allCheck = function(page) {
    return function(state) {
        return $6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$Selection.create)($6f8f3e97c4d83891$var$selectAllCheckbox$prime($b5f6b40b8f63b732$export$f27fff4bf988e19(page))($fc8e139dfeeff88c$export$344f17102956e4bc("expectations-select-all")($c3328e54cdf5154c$export$5a1a8430df9521e("select-all")))(state.selection));
    };
};
var $6f8f3e97c4d83891$var$exList = function(page) {
    return function(state) {
        var grouped = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(a1) {
            return function(b) {
                return $6f8f3e97c4d83891$var$eq(a1.category)(b.category);
            };
        })($b5f6b40b8f63b732$export$f27fff4bf988e19(page));
        return $6f8f3e97c4d83891$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("expectation-list")
        ])($6f8f3e97c4d83891$var$append([
            $6f8f3e97c4d83891$var$allCheck(page)(state)
        ])($6f8f3e97c4d83891$var$map1($6f8f3e97c4d83891$var$exCategory(state))(grouped)));
    };
};
var $6f8f3e97c4d83891$var$exDiv = function(v) {
    return function(v1) {
        if (v1.page instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $6f8f3e97c4d83891$var$div$prime([
            $6f8f3e97c4d83891$var$p$prime([
                $6f8f3e97c4d83891$var$text(v1.page.value0)
            ])
        ]);
        if (v1.page instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $6f8f3e97c4d83891$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("expectation-pager")
        ])([
            $6f8f3e97c4d83891$var$exList(v1.page.value0)(v),
            $6f8f3e97c4d83891$var$pager(v1.page.value0)
        ]);
        throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 191, column 1 - line 191, column 108): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $6f8f3e97c4d83891$var$curTabWidget = function(state) {
    return $6f8f3e97c4d83891$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("expectation-picker-body")
    ])([
        $6f8f3e97c4d83891$var$select$prime(state),
        $6f8f3e97c4d83891$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("expectation-pager")
        ])([
            $6f8f3e97c4d83891$var$exDiv(state)($6f8f3e97c4d83891$var$currentTab(state))
        ])
    ]);
};
var $6f8f3e97c4d83891$var$renderWidget = function(state) {
    var tab = function(idx) {
        return function(t) {
            return $6f8f3e97c4d83891$var$a([
                $fc1df90f0e252058$export$2913c0c0b5623090("tab" + function() {
                    var $94 = state.activeTab === idx;
                    if ($94) return " active";
                    return "";
                }()),
                $fc1df90f0e252058$export$8f51af5840e0602a("javascript:void(0);"),
                $6f8f3e97c4d83891$var$voidRight(new $6f8f3e97c4d83891$var$ChangeTab(idx))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $6f8f3e97c4d83891$var$text(t.label)
            ]);
        };
    };
    var tabs = $6f8f3e97c4d83891$var$nav([
        $fc1df90f0e252058$export$2913c0c0b5623090("tabs")
    ])($396c4c3d9e7fae3c$export$8f07ddce13659f50(tab)(state.tabs));
    var doneBtn = $6f8f3e97c4d83891$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("expectation-picker-buttons modal-buttons")
    ])([
        $6f8f3e97c4d83891$var$button([
            $fc1df90f0e252058$export$1741e49665a9c8e8("button"),
            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
            $6f8f3e97c4d83891$var$voidRight($6f8f3e97c4d83891$var$Done.value)($fc1df90f0e252058$export$1d5a917feb871989)
        ])([
            $6f8f3e97c4d83891$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("done"))
        ])
    ]);
    return $6f8f3e97c4d83891$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("expectation-picker modal-grid"),
        $fc1df90f0e252058$export$9c7ae676ac45430a("expectation-picker")
    ])([
        tabs,
        $6f8f3e97c4d83891$var$curTabWidget(state),
        doneBtn
    ]);
};
var $6f8f3e97c4d83891$var$loadPageChange = function(dictDecodeJson) {
    var changePage = $b5f6b40b8f63b732$export$af04929cb32c4bb7(dictDecodeJson);
    return function(state) {
        return function(idx) {
            var v = $6f8f3e97c4d83891$var$currentTab(state).page;
            if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $6f8f3e97c4d83891$var$doLoadAction(dictDecodeJson)(state)(changePage(idx)(v.value0))($6f8f3e97c4d83891$var$handle$prime(state));
            if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(state));
            throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 154, column 28 - line 156, column 41): " + [
                v.constructor.name
            ]);
        };
    };
};
var $6f8f3e97c4d83891$var$loadExpectations = function(dictDecodeJson) {
    return function(state) {
        return function(selected) {
            return $6f8f3e97c4d83891$var$doLoadAction(dictDecodeJson)(state)($6f8f3e97c4d83891$var$currentTab(state).query(selected))($6f8f3e97c4d83891$var$handle$prime(state));
        };
    };
};
var $6f8f3e97c4d83891$var$handleAction = function(dictDecodeJson) {
    return function(v) {
        return function(v1) {
            if (v1 instanceof $6f8f3e97c4d83891$var$ChangeTab && v1.value0 >= 0 && v1.value0 < $fc8c1182ec2aefec$export$f24224f1c91d8156(v.tabs)) {
                var state$prime = {
                    selection: v.selection,
                    tabs: v.tabs,
                    activeTab: v1.value0
                };
                var curTab = $6f8f3e97c4d83891$var$currentTab(state$prime);
                var $100 = $7d4cccdf062a2261$export$a9d71693f0c1a85d(curTab.page);
                if ($100) return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(state$prime));
                var v2 = $7178b396566f5a79$export$127d1aaaa65102b1(curTab.select);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $6f8f3e97c4d83891$var$loadExpectations(dictDecodeJson)(state$prime)(v2.value0.value.id);
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(state$prime));
                throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 104, column 14 - line 106, column 51): " + [
                    v2.constructor.name
                ]);
            }
            if (v1 instanceof $6f8f3e97c4d83891$var$ChangeTab) return $6f8f3e97c4d83891$var$discard($6f8f3e97c4d83891$var$liftEffect($93c729927fdf3160$export$bef1f36f5486a6a3("Warning: tab index out of range: " + $6f8f3e97c4d83891$var$show1(v1.value0))))(function() {
                return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(v));
            });
            if (v1 instanceof $6f8f3e97c4d83891$var$CourseChange) return $6f8f3e97c4d83891$var$bind($6f8f3e97c4d83891$var$updateTab(v)(function(tab) {
                return $6f8f3e97c4d83891$var$pure({
                    label: tab.label,
                    page: tab.page,
                    query: tab.query,
                    select: v1.value0
                });
            }))(function(newstate) {
                var v2 = $7178b396566f5a79$export$127d1aaaa65102b1(v1.value0);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $6f8f3e97c4d83891$var$loadExpectations(dictDecodeJson)(newstate)(v2.value0.value.id);
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5(newstate));
                throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 114, column 5 - line 116, column 49): " + [
                    v2.constructor.name
                ]);
            });
            if (v1 instanceof $6f8f3e97c4d83891$var$ChangePage) return $6f8f3e97c4d83891$var$loadPageChange(dictDecodeJson)(v)(v1.value0);
            if (v1 instanceof $6f8f3e97c4d83891$var$Selection) return $6f8f3e97c4d83891$var$pure(new $035405231d3ae317$export$c00f2c00f91f14d5({
                activeTab: v.activeTab,
                tabs: v.tabs,
                selection: v1.value0
            }));
            if (v1 instanceof $6f8f3e97c4d83891$var$Done) return $6f8f3e97c4d83891$var$pure($035405231d3ae317$export$a09a21bd8097e7.value);
            throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 94, column 1 - line 97, column 55): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
};
var $6f8f3e97c4d83891$var$doLoadAction = function(dictDecodeJson) {
    return function(state) {
        return function(action) {
            return function(handle) {
                return $6f8f3e97c4d83891$var$bind($6f8f3e97c4d83891$var$updateTab(state)(function(tab) {
                    return $6f8f3e97c4d83891$var$pure({
                        label: tab.label,
                        query: tab.query,
                        select: tab.select,
                        page: new $7d4cccdf062a2261$export$37c4d04eafdc5515("Loading...")
                    });
                }))(function(loadState) {
                    return $6f8f3e97c4d83891$var$bind($6f8f3e97c4d83891$var$alt($6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$EPAction.create)($6f8f3e97c4d83891$var$renderWidget(loadState)))($6f8f3e97c4d83891$var$map($6f8f3e97c4d83891$var$LoadResult.create)($3257df7cdef77623$export$b97f2ad8d0b7442d(action))))(function(act) {
                        if (act instanceof $6f8f3e97c4d83891$var$EPAction) return $6f8f3e97c4d83891$var$handleAction(dictDecodeJson)(state)(act.value0);
                        if (act instanceof $6f8f3e97c4d83891$var$LoadResult) return $6f8f3e97c4d83891$var$map($035405231d3ae317$export$c00f2c00f91f14d5.create)(handle(act.value0));
                        throw new Error("Failed pattern match at Widgets.ExpectationPicker (line 138, column 5 - line 140, column 51): " + [
                            act.constructor.name
                        ]);
                    });
                });
            };
        };
    };
};
var $6f8f3e97c4d83891$var$runExpectationPicker = function(dictDecodeJson) {
    var handleAction1 = $6f8f3e97c4d83891$var$handleAction(dictDecodeJson);
    return function(state) {
        return $6f8f3e97c4d83891$var$bindFlipped(handleAction1(state))($6f8f3e97c4d83891$var$renderWidget(state));
    };
};
var $6f8f3e97c4d83891$export$651914c568d035fc = function(dictDecodeJson) {
    return $035405231d3ae317$export$937ad7a399f5d64($6f8f3e97c4d83891$var$div$prime([]))($6f8f3e97c4d83891$var$runExpectationPicker(dictDecodeJson));
};




// Generated by purs version 0.15.16


























var $b19cb68dd93bf4c1$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $b19cb68dd93bf4c1$var$setData = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "entries";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "label";
    }
})($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($3af393d861aaaf77$export$14679d9abc92670b))));
var $b19cb68dd93bf4c1$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $b19cb68dd93bf4c1$var$fieldPaths = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $b19cb68dd93bf4c1$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $b19cb68dd93bf4c1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $b19cb68dd93bf4c1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $b19cb68dd93bf4c1$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $b19cb68dd93bf4c1$var$toWidget = /* #__PURE__ */ $f388db8e60bd7b97$export$83925c2318996255($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$getId = /* #__PURE__ */ $f388db8e60bd7b97$export$218c8c3169c024d2($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$isLeaf = /* #__PURE__ */ $f388db8e60bd7b97$export$e132ced8f644a612($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $b19cb68dd93bf4c1$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $b19cb68dd93bf4c1$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $b19cb68dd93bf4c1$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($b19cb68dd93bf4c1$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b19cb68dd93bf4c1$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($b19cb68dd93bf4c1$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b19cb68dd93bf4c1$var$voidRight1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $b19cb68dd93bf4c1$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $b19cb68dd93bf4c1$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $b19cb68dd93bf4c1$var$h4$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$f9a110730a38820a($b19cb68dd93bf4c1$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b19cb68dd93bf4c1$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($eb7399d322077fcf$export$35d3004eff90f123));
var $b19cb68dd93bf4c1$var$getData = /* #__PURE__ */ $f388db8e60bd7b97$export$7a171f172be0782e($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $b19cb68dd93bf4c1$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $b19cb68dd93bf4c1$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $b19cb68dd93bf4c1$var$getFieldOptional$prime = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$fee2d5446387c54f);
var $b19cb68dd93bf4c1$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $b19cb68dd93bf4c1$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $b19cb68dd93bf4c1$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $b19cb68dd93bf4c1$var$foldM = /* #__PURE__ */ $4fe7b6acfba7f29f$export$7a067f9280ad8af0($4fe7b6acfba7f29f$export$e97014618a7eb593)($7d4cccdf062a2261$export$b3b4ecb28e3a8df3);
var $b19cb68dd93bf4c1$export$65ab4e3c3e72a295 = function(x) {
    return x;
};
var $b19cb68dd93bf4c1$export$18aeebbd4b820fd5 = function(v) {
    return {
        id: v.id,
        label: v.label,
        cls: v.cls,
        entries: [],
        addBtns: [
            {
                label: $c3328e54cdf5154c$export$5a1a8430df9521e("add"),
                newEntries: function(v1) {
                    return $b19cb68dd93bf4c1$var$pure([
                        v.template
                    ]);
                }
            }
        ],
        load: function(fc) {
            return function(json) {
                return $b19cb68dd93bf4c1$var$setData(fc)(v.template)(json);
            };
        },
        loadExist: function(fc) {
            return function(oldw) {
                return function(json) {
                    return $b19cb68dd93bf4c1$var$setData(fc)(oldw)(json);
                };
            };
        }
    };
};
var $b19cb68dd93bf4c1$export$fe5418acfa42da9e = {
    show: function(v) {
        return $b19cb68dd93bf4c1$var$show({
            id: v.id,
            label: v.label,
            entries: v.entries
        });
    }
};
var $b19cb68dd93bf4c1$export$ebe30643573800f8 = function(v) {
    return {
        id: v.id,
        label: v.label,
        addBtns: v.addBtns,
        load: v.load,
        loadExist: v.loadExist,
        cls: v.cls,
        entries: []
    };
};
var $b19cb68dd93bf4c1$export$bc80505b76c642f0 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return false;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fieldPaths: function(fc) {
        return function(v) {
            var entryPaths = function(idx) {
                return function(widget) {
                    var subfc = $f388db8e60bd7b97$export$94eddf153554b360({
                        parentIds: fc.parentIds,
                        isAutofilling: fc.isAutofilling,
                        autofillArgs: fc.autofillArgs,
                        account: fc.account,
                        doc: fc.doc,
                        access: fc.access,
                        curIndex: idx
                    })($b19cb68dd93bf4c1$var$show1(idx));
                    return $b19cb68dd93bf4c1$var$fieldPaths(subfc)(widget);
                };
            };
            return $b19cb68dd93bf4c1$var$append([
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ])($fc8c1182ec2aefec$export$ee1b3e54f0441b22($b19cb68dd93bf4c1$var$mapWithIndex(entryPaths)(v.entries)));
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var updateEntry = function(idx) {
                return function(w) {
                    return $b19cb68dd93bf4c1$var$map(function(v1) {
                        return {
                            addBtns: v.addBtns,
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: v1
                        };
                    })($06733ae99ed4f534$export$43db023a260c5e9f(v.entries))($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)(w)(v.entries));
                };
            };
            var removeEntry = function(idx) {
                return $b19cb68dd93bf4c1$var$map(function(v1) {
                    return {
                        addBtns: v.addBtns,
                        cls: v.cls,
                        id: v.id,
                        label: v.label,
                        load: v.load,
                        loadExist: v.loadExist,
                        entries: v1
                    };
                })($06733ae99ed4f534$export$43db023a260c5e9f(v.entries))($396c4c3d9e7fae3c$export$90f9093465da3136(idx)(v.entries));
            };
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            var canModify = $f388db8e60bd7b97$export$330cf2b9485e792b(fc)(v.id);
            var subWidget = function(idx) {
                return function(w) {
                    var subfc = $f388db8e60bd7b97$export$94eddf153554b360({
                        parentIds: fc.parentIds,
                        isAutofilling: fc.isAutofilling,
                        autofillArgs: fc.autofillArgs,
                        account: fc.account,
                        doc: fc.doc,
                        access: fc.access,
                        curIndex: idx
                    })($b19cb68dd93bf4c1$var$show1(idx));
                    var renderEntry = $b19cb68dd93bf4c1$var$map1(function(v1) {
                        return $b19cb68dd93bf4c1$var$map2(updateEntry(idx))(v1);
                    })($b19cb68dd93bf4c1$var$toWidget(subfc)(w));
                    var v1 = $f388db8e60bd7b97$export$6ae8b9028cb9b43c(subfc)($b19cb68dd93bf4c1$var$getId(w));
                    if (v1 instanceof $81439e1d9c94314f$export$22dce776e713bf54 && ($b19cb68dd93bf4c1$var$isLeaf(w) || !$f388db8e60bd7b97$export$c7df680a10db757f(subfc)($b19cb68dd93bf4c1$var$getId(w)))) return $b19cb68dd93bf4c1$var$voidRight($f388db8e60bd7b97$export$e0d76edcf577b85d(v))($b19cb68dd93bf4c1$var$text(""));
                    return $b19cb68dd93bf4c1$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("list-entry")
                    ])($b19cb68dd93bf4c1$var$append([
                        renderEntry
                    ])(function() {
                        if (canModify) return [
                            $b19cb68dd93bf4c1$var$button([
                                $b19cb68dd93bf4c1$var$voidRight1($f388db8e60bd7b97$export$e0d76edcf577b85d(removeEntry(idx)))($fc1df90f0e252058$export$1d5a917feb871989),
                                $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                                $fc1df90f0e252058$export$1741e49665a9c8e8("button")
                            ])([
                                $b19cb68dd93bf4c1$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("delete"))
                            ])
                        ];
                        return [];
                    }()));
                };
            };
            var subWidgets = $b19cb68dd93bf4c1$var$mapWithIndex(subWidget)(v.entries);
            var addButton = function(v1) {
                return $b19cb68dd93bf4c1$var$bind($b19cb68dd93bf4c1$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn list-add widget-input"),
                    $fc1df90f0e252058$export$1d5a917feb871989,
                    $fc1df90f0e252058$export$1741e49665a9c8e8("button")
                ])([
                    $b19cb68dd93bf4c1$var$text(v1.label)
                ]))(function() {
                    return $b19cb68dd93bf4c1$var$bind(v1.newEntries(fc))(function(ents) {
                        return $b19cb68dd93bf4c1$var$pure({
                            addBtns: v.addBtns,
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: $fc8c1182ec2aefec$export$ee1b3e54f0441b22([
                                v.entries,
                                ents
                            ])
                        });
                    });
                });
            };
            var addButtons = function() {
                if (canModify) return $b19cb68dd93bf4c1$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("list-add-buttons btn-group")
                ])($b19cb68dd93bf4c1$var$map3(addButton)(v.addBtns));
                return $b19cb68dd93bf4c1$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("list-add-buttons btn-group")
                ])([]);
            }();
            var html = $b19cb68dd93bf4c1$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v)),
                $fc1df90f0e252058$export$df61b30b684217c0(id)
            ])([
                $b19cb68dd93bf4c1$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("header")
                ])([
                    $b19cb68dd93bf4c1$var$h4$prime([
                        $b19cb68dd93bf4c1$var$text(v.label)
                    ])
                ]),
                $b19cb68dd93bf4c1$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("list w-full")
                ])(subWidgets),
                $b19cb68dd93bf4c1$var$map1($f388db8e60bd7b97$export$e0d76edcf577b85d)(addButtons)
            ]);
            return $b19cb68dd93bf4c1$var$map1(function(v1) {
                return $b19cb68dd93bf4c1$var$map2($b19cb68dd93bf4c1$export$65ab4e3c3e72a295)(v1);
            })(html);
        };
    },
    getData: function(fc) {
        return function(v) {
            return $b19cb68dd93bf4c1$var$encodeJson($b19cb68dd93bf4c1$var$map3($b19cb68dd93bf4c1$var$getData(fc))(v.entries));
        };
    },
    setData: function(fc) {
        return function(v) {
            return function(json) {
                var entryIndex = function(ejson) {
                    return $b19cb68dd93bf4c1$var$map4($06733ae99ed4f534$export$43db023a260c5e9f(-1))($54dae5ca6a6cd16d$export$bc0012033e3e059a(ejson)($b19cb68dd93bf4c1$var$bind1($2acecf8dc1456b13$export$a0a4ca47aa42be8b(ejson))(function(v1) {
                        return $b19cb68dd93bf4c1$var$getFieldOptional$prime(v1)("_index");
                    })));
                };
                var hasExplicitIndex = function(v1) {
                    if ($2a035e92dc768ac1$export$43bee75e5e14138e(v1)) return false;
                    var v2 = entryIndex(v1);
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v2.value0 >= 0;
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return false;
                    throw new Error("Failed pattern match at Widgets.Form.List (line 190, column 34 - line 192, column 28): " + [
                        v2.constructor.name
                    ]);
                };
                var loadEntry = function($copy_v1) {
                    return function($copy_v2) {
                        var $tco_var_v1 = $copy_v1;
                        var $tco_done = false;
                        var $tco_result;
                        function $tco_loop(v1, v2) {
                            if ($2a035e92dc768ac1$export$43bee75e5e14138e(v2)) {
                                $tco_var_v1 = v1;
                                $copy_v2 = $2a035e92dc768ac1$export$d0304b893d105187;
                                return;
                            }
                            $tco_done = true;
                            return $b19cb68dd93bf4c1$var$bind1(entryIndex(v2))(function(v3) {
                                var v4 = $396c4c3d9e7fae3c$export$b610b8812bbcded9(v1)(v3);
                                if (v4 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $b19cb68dd93bf4c1$var$bind1(v.load(fc)(v2))(function(entry) {
                                    return $b19cb68dd93bf4c1$var$pure1($b19cb68dd93bf4c1$var$append(v1)([
                                        entry
                                    ]));
                                });
                                if (v4 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $b19cb68dd93bf4c1$var$bind1(v.loadExist(fc)(v4.value0)(v2))(function(entry) {
                                    var v5 = $396c4c3d9e7fae3c$export$b6d8713d53419d4c(v3)(entry)(v1);
                                    if (v5 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $b19cb68dd93bf4c1$var$pure1($b19cb68dd93bf4c1$var$append(v1)([
                                        entry
                                    ]));
                                    if (v5 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $b19cb68dd93bf4c1$var$pure1(v5.value0);
                                    throw new Error("Failed pattern match at Widgets.Form.List (line 203, column 21 - line 205, column 49): " + [
                                        v5.constructor.name
                                    ]);
                                });
                                throw new Error("Failed pattern match at Widgets.Form.List (line 197, column 13 - line 205, column 49): " + [
                                    v4.constructor.name
                                ]);
                            });
                        }
                        while(!$tco_done)$tco_result = $tco_loop($tco_var_v1, $copy_v2);
                        return $tco_result;
                    };
                };
                return $b19cb68dd93bf4c1$var$bind1($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($b19cb68dd93bf4c1$var$decodeJson(json)))(function(v1) {
                    var initialEntries = function() {
                        if (fc.isAutofilling) return v.entries;
                        var $138 = $b19cb68dd93bf4c1$var$any(hasExplicitIndex)(v1);
                        if ($138) return v.entries;
                        return [];
                    }();
                    return $b19cb68dd93bf4c1$var$bind1($b19cb68dd93bf4c1$var$foldM(loadEntry)(initialEntries)(v1))(function(entries) {
                        return new $7d4cccdf062a2261$export$19db0165690c701a({
                            id: v.id,
                            label: v.label,
                            cls: v.cls,
                            addBtns: v.addBtns,
                            load: v.load,
                            loadExist: v.loadExist,
                            entries: entries
                        });
                    });
                });
            };
        };
    }
};


// Generated by purs version 0.15.16









var $5ad0c5cefd7afaff$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $5ad0c5cefd7afaff$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $5ad0c5cefd7afaff$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $5ad0c5cefd7afaff$var$p = /* #__PURE__ */ $3eadc1b959dd1120$export$ffb5f4729a158638($5ad0c5cefd7afaff$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $5ad0c5cefd7afaff$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($5ad0c5cefd7afaff$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $5ad0c5cefd7afaff$var$h4$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$f9a110730a38820a($5ad0c5cefd7afaff$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $5ad0c5cefd7afaff$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $5ad0c5cefd7afaff$export$b04be29aa201d4f5 = function(x) {
    return x;
};
var $5ad0c5cefd7afaff$export$942b2219c902021e = function(x) {
    return x;
};
var $5ad0c5cefd7afaff$export$6f4d8ebc6c25c0df = /* #__PURE__ */ $5ad0c5cefd7afaff$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($5ad0c5cefd7afaff$var$idIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "label";
    }
})($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $5ad0c5cefd7afaff$export$5f42f100f752a07c = /* #__PURE__ */ $5ad0c5cefd7afaff$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "err";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($5ad0c5cefd7afaff$var$idIsSymbol)($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($54dae5ca6a6cd16d$export$54aef60b1a6d6353));
var $5ad0c5cefd7afaff$export$26648b7387036154 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fieldPaths: function(v) {
        return function(v1) {
            return [];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            return $5ad0c5cefd7afaff$var$p([
                $fc1df90f0e252058$export$8331f8c46716f919({
                    "__html": v.label
                }),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v)),
                $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)),
                $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id))
            ])([]);
        };
    },
    getData: $f388db8e60bd7b97$export$c9b8b4835d12ce15,
    setData: $f388db8e60bd7b97$export$fc873be648364fa2
};
var $5ad0c5cefd7afaff$export$1b344533d0e9e444 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fieldPaths: function(v) {
        return function(v1) {
            return [];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var errText = "An error occurred while handling widget with ID " + $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            return $5ad0c5cefd7afaff$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-error"),
                $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id))
            ])([
                $5ad0c5cefd7afaff$var$h4$prime([
                    $5ad0c5cefd7afaff$var$text(errText)
                ]),
                $54dae5ca6a6cd16d$export$85beb7f97103a98f(v.err)
            ]);
        };
    },
    getData: $f388db8e60bd7b97$export$c9b8b4835d12ce15,
    setData: $f388db8e60bd7b97$export$fc873be648364fa2
};



var $c9a251dc3aa901f2$var$setData = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($7ecd539579e10f1a$export$82deae0194ea4699);
var $c9a251dc3aa901f2$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $c9a251dc3aa901f2$var$learningIsSymbol = {
    reflectSymbol: function() {
        return "learning";
    }
};
var $c9a251dc3aa901f2$var$expectationIsSymbol = {
    reflectSymbol: function() {
        return "expectation";
    }
};
var $c9a251dc3aa901f2$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c9a251dc3aa901f2$var$gEncodeJsonCons(/* #__PURE__ */ $c9a251dc3aa901f2$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726)($c9a251dc3aa901f2$var$learningIsSymbol)())($c9a251dc3aa901f2$var$expectationIsSymbol)())());
var $c9a251dc3aa901f2$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $c9a251dc3aa901f2$var$wrapFormWidget = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($7ecd539579e10f1a$export$2b89428e175ed52)($7ecd539579e10f1a$export$82deae0194ea4699);
var $c9a251dc3aa901f2$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $c9a251dc3aa901f2$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $c9a251dc3aa901f2$var$wrapFormWidget1 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($5ad0c5cefd7afaff$export$5f42f100f752a07c)($5ad0c5cefd7afaff$export$1b344533d0e9e444);
var $c9a251dc3aa901f2$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $c9a251dc3aa901f2$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $c9a251dc3aa901f2$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $c9a251dc3aa901f2$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c9a251dc3aa901f2$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $c9a251dc3aa901f2$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $c9a251dc3aa901f2$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $c9a251dc3aa901f2$var$expectationPicker = /* #__PURE__ */ $6f8f3e97c4d83891$export$651914c568d035fc(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)({
    reflectSymbol: function() {
        return "sub_category";
    }
})()())($c9a251dc3aa901f2$var$idIsSymbol)()())({
    reflectSymbol: function() {
        return "description";
    }
})()())({
    reflectSymbol: function() {
        return "category";
    }
})()())());
var $c9a251dc3aa901f2$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $c9a251dc3aa901f2$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $c9a251dc3aa901f2$var$textarea = /* #__PURE__ */ $3eadc1b959dd1120$export$a3574df893ffa88d($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c9a251dc3aa901f2$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $c9a251dc3aa901f2$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c9a251dc3aa901f2$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $c9a251dc3aa901f2$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($c9a251dc3aa901f2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c9a251dc3aa901f2$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $c9a251dc3aa901f2$var$decodeJson = /* #__PURE__ */ $e2b1be82a5e6d14f$export$cd9ded616c0cfb91(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons1(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons1(/* #__PURE__ */ $c9a251dc3aa901f2$var$gDecodeJsonCons1($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($c9a251dc3aa901f2$var$learningIsSymbol)()())($c9a251dc3aa901f2$var$idIsSymbol)()())($c9a251dc3aa901f2$var$expectationIsSymbol)()())());
var $c9a251dc3aa901f2$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $c9a251dc3aa901f2$var$wrapFormWidget2 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($b19cb68dd93bf4c1$export$fe5418acfa42da9e)($b19cb68dd93bf4c1$export$bc80505b76c642f0);
var $c9a251dc3aa901f2$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $c9a251dc3aa901f2$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $c9a251dc3aa901f2$export$70b63ebbac8910e6 = function(x) {
    return x;
};
var $c9a251dc3aa901f2$export$a384978f9045e2e6 = function(fc) {
    return function(subform) {
        return function(json) {
            return $c9a251dc3aa901f2$var$setData(fc)(subform)(json);
        };
    };
};
var $c9a251dc3aa901f2$export$a30a6125f2d93a1 = function(fc) {
    return function(subform) {
        return function(v) {
            var v1 = $c9a251dc3aa901f2$export$a384978f9045e2e6(fc)(subform)($c9a251dc3aa901f2$var$encodeJson({
                expectation: v.description,
                learning: ""
            }));
            if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $c9a251dc3aa901f2$var$pure($c9a251dc3aa901f2$var$wrapFormWidget(v1.value0));
            if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                var err$prime = new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$19d787e6e83e848f("while loading chosen expectation into widget"), v1.value0);
                return $c9a251dc3aa901f2$var$bind($c9a251dc3aa901f2$var$liftEffect($54dae5ca6a6cd16d$export$b33b857ad1d9900e(err$prime)))(function() {
                    return $c9a251dc3aa901f2$var$pure($c9a251dc3aa901f2$var$wrapFormWidget1({
                        id: "expectation-error",
                        err: new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Failed to load pre-defined expectation data into the expectation entry. This is likely caused by the subform in the form design not matching the expected layout.")
                    }));
                });
            }
            throw new Error("Failed pattern match at Widgets.Form.Expectations (line 139, column 5 - line 152, column 18): " + [
                v1.constructor.name
            ]);
        };
    };
};
var $c9a251dc3aa901f2$export$9a0457a40f8c4bff = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d($c9a251dc3aa901f2$var$expectationIsSymbol)(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3($c9a251dc3aa901f2$var$learningIsSymbol)($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $c9a251dc3aa901f2$export$81cb2e077a149f3c = function(occ) {
    var toFE = function(v) {
        return {
            id: v.id
        };
    };
    return $7178b396566f5a79$export$f722688498755b51(toFE)($6f8f3e97c4d83891$export$9eb1f527eadefcb5)($0226bdcd7123f840$export$d0125f9363e1a97d(occ));
};
var $c9a251dc3aa901f2$export$4ea4ab4a22ee4f14 = function(fc) {
    var preselectEmployer = function(state) {
        return $7178b396566f5a79$export$5a4818cec1656a71(state)($c9a251dc3aa901f2$var$bind1($c9a251dc3aa901f2$var$bind1(fc.doc)(function(v) {
            return v.employer;
        }))(function(emp) {
            return $c9a251dc3aa901f2$var$bind1($c9a251dc3aa901f2$var$bind1(fc.doc)(function(v) {
                return v.position;
            }))(function(pos) {
                return $c9a251dc3aa901f2$var$pure1({
                    label: emp.company + (" - " + pos.label),
                    value: {
                        id: $308f9765feb7633d$export$a1b0f5347d2470b(pos.id)
                    }
                });
            });
        }));
    };
    var tabs = [
        {
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("expectations-noc"),
            query: function($168) {
                return $c9a251dc3aa901f2$var$runGraphQL($0226bdcd7123f840$export$8801cc9b6504019f($168));
            },
            select: $7178b396566f5a79$export$d967f07ae6c72524("noc")($c9a251dc3aa901f2$export$81cb2e077a149f3c("NOC"))({
                deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
                allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
                editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
            })
        },
        {
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("expectations-employer-tab"),
            query: function($169) {
                return $c9a251dc3aa901f2$var$runGraphQL($0226bdcd7123f840$export$1fcceae2e2b360b0($169));
            },
            select: preselectEmployer($7178b396566f5a79$export$d967f07ae6c72524("employer-pos")($0226bdcd7123f840$export$805545b03d68a96b($308f9765feb7633d$export$87708d888b4bc8a6($c9a251dc3aa901f2$var$map(function(v) {
                return v.id;
            })(fc.doc))))({
                deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
                allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
                editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
            }))
        },
        {
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("expectations-trade"),
            query: function($170) {
                return $c9a251dc3aa901f2$var$runGraphQL($0226bdcd7123f840$export$a48aa3c5f903cf7c($170));
            },
            select: $7178b396566f5a79$export$d967f07ae6c72524("trade")($c9a251dc3aa901f2$export$81cb2e077a149f3c("TRADE"))({
                deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
                allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
                editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
            })
        }
    ];
    var state = $6f8f3e97c4d83891$export$f17704b0c58450aa({
        tabs: tabs
    });
    return $c9a251dc3aa901f2$var$bind($c9a251dc3aa901f2$var$expectationPicker(state))(function(endState) {
        return $c9a251dc3aa901f2$var$pure($6f8f3e97c4d83891$export$9ec5fd99abbd9d7c(endState));
    });
};
var $c9a251dc3aa901f2$export$31ece47c2c71e893 = {
    getId: function(v) {
        return "expectation";
    },
    isLeaf: function(v) {
        return false;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)("expectation"),
                $f388db8e60bd7b97$export$20223e4a23036829(fc)("learning")
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var labelledTextArea = function(id) {
                return function(value) {
                    return function(label1) {
                        if ($f388db8e60bd7b97$export$16add92498609946(fc)(id)) return new $06733ae99ed4f534$export$8a67b48435b5d073($c9a251dc3aa901f2$var$div$prime([
                            $c9a251dc3aa901f2$var$label([
                                $fc1df90f0e252058$export$35d9e1c947946090($f388db8e60bd7b97$export$20223e4a23036829(fc)(id))
                            ])([
                                $c9a251dc3aa901f2$var$text(label1)
                            ]),
                            $c9a251dc3aa901f2$var$textarea($c9a251dc3aa901f2$var$append1([
                                $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                                $fc1df90f0e252058$export$2ab9a8f9f1186f14(value),
                                $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(fc)(id)),
                                $c9a251dc3aa901f2$var$map1($fc1df90f0e252058$export$b79fd9f386367d78)($fc1df90f0e252058$export$7fbc06d7c1beb512)
                            ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(id)))([])
                        ]));
                        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Widgets.Form.Expectations (line 188, column 9 - line 188, column 85): " + [
                            id.constructor.name,
                            value.constructor.name,
                            label1.constructor.name
                        ]);
                    };
                };
            };
            var learningWidget = $c9a251dc3aa901f2$var$map(function(widget) {
                return $c9a251dc3aa901f2$var$map2(function(v1) {
                    return {
                        expectation: v.expectation,
                        learning: v1
                    };
                })(widget);
            })(labelledTextArea("learning")(v.learning)($c3328e54cdf5154c$export$5a1a8430df9521e("learning-demonstration")));
            var expWidget = $c9a251dc3aa901f2$var$map(function(widget) {
                return $c9a251dc3aa901f2$var$map2(function(v1) {
                    return {
                        learning: v.learning,
                        expectation: v1
                    };
                })(widget);
            })(labelledTextArea("expectation")(v.expectation)($c3328e54cdf5154c$export$5a1a8430df9521e("expectation")));
            var body = $c9a251dc3aa901f2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("expectation-body")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                expWidget,
                learningWidget
            ]));
            return $c9a251dc3aa901f2$var$map2($c9a251dc3aa901f2$var$map3($f388db8e60bd7b97$export$e0d76edcf577b85d)($c9a251dc3aa901f2$export$70b63ebbac8910e6))($c9a251dc3aa901f2$var$details([
                $fc1df90f0e252058$export$2913c0c0b5623090("expectation"),
                $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(fc)("expectation-entry")),
                $fc1df90f0e252058$export$9c7ae676ac45430a($f388db8e60bd7b97$export$20223e4a23036829(fc)("expectation-entry")),
                $fc1df90f0e252058$export$3ce6949f20cea765(true)
            ])([
                $c9a251dc3aa901f2$var$summary$prime([
                    $c9a251dc3aa901f2$var$text(v.expectation)
                ]),
                body
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $c9a251dc3aa901f2$var$encodeJson({
                expectation: v1.expectation,
                learning: v1.learning
            });
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(json) {
                return $c9a251dc3aa901f2$var$bind2($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($c9a251dc3aa901f2$var$decodeJson(json)))(function(v2) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        expectation: v2.expectation,
                        learning: v2.learning
                    });
                });
            };
        };
    }
};
var $c9a251dc3aa901f2$export$b6d18be6fee5fadb = function(subform) {
    return function(v) {
        var load = function(fc) {
            return function(json) {
                return $c9a251dc3aa901f2$var$map4($c9a251dc3aa901f2$var$wrapFormWidget)($c9a251dc3aa901f2$export$a384978f9045e2e6(fc)(subform)(json));
            };
        };
        return $c9a251dc3aa901f2$var$wrapFormWidget2($b19cb68dd93bf4c1$export$ebe30643573800f8({
            id: v.id,
            label: v.label,
            cls: v.cls,
            addBtns: [
                {
                    label: $c3328e54cdf5154c$export$5a1a8430df9521e("employer-choose-expectation"),
                    newEntries: function(fc) {
                        return $c9a251dc3aa901f2$var$bind($c9a251dc3aa901f2$var$map2($c9a251dc3aa901f2$var$fromFoldable)($c9a251dc3aa901f2$export$4ea4ab4a22ee4f14(fc)))(function(exps) {
                            return $c9a251dc3aa901f2$var$traverse($c9a251dc3aa901f2$export$a30a6125f2d93a1(fc)(subform))(exps);
                        });
                    }
                },
                {
                    label: $c3328e54cdf5154c$export$5a1a8430df9521e("employer-insert-expectation"),
                    newEntries: function(v1) {
                        return $c9a251dc3aa901f2$var$pure([
                            $c9a251dc3aa901f2$var$wrapFormWidget(subform)
                        ]);
                    }
                }
            ],
            load: load,
            loadExist: function(fc) {
                return function(v1) {
                    return function(json) {
                        return load(fc)(json);
                    };
                };
            }
        }));
    };
};
var $c9a251dc3aa901f2$export$b9f5e0c7b71ce3bd = function(student) {
    var toFE = function(v) {
        return {
            id: $308f9765feb7633d$export$a1b0f5347d2470b(v.id)
        };
    };
    return $7178b396566f5a79$export$f722688498755b51(toFE)($6f8f3e97c4d83891$export$9eb1f527eadefcb5)($0226bdcd7123f840$export$8ff95a4bad83b9f(student));
};
var $c9a251dc3aa901f2$export$a638d6c1c7214561 = function(fc) {
    var select = $7178b396566f5a79$export$d967f07ae6c72524("course")($c9a251dc3aa901f2$export$b9f5e0c7b71ce3bd($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($308f9765feb7633d$export$f5ab442a98b1cecf)(function(v) {
        return v.student.id;
    })(fc.doc)))({
        deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
        allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("select-choose-search"))
    });
    var tabs = [
        {
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("expectations-all-curriculum"),
            query: function() {
                var $171 = $0226bdcd7123f840$export$92dfd4e6d3bf8909([]);
                return function($172) {
                    return $c9a251dc3aa901f2$var$runGraphQL($171($308f9765feb7633d$export$a7f53fa461221c79($172)));
                };
            }(),
            select: select
        },
        {
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("expectations-overall"),
            query: function() {
                var $173 = $0226bdcd7123f840$export$92dfd4e6d3bf8909([
                    $0226bdcd7123f840$export$af1746a6d1d4ebef.value
                ]);
                return function($174) {
                    return $c9a251dc3aa901f2$var$runGraphQL($173($308f9765feb7633d$export$a7f53fa461221c79($174)));
                };
            }(),
            select: select
        }
    ];
    var state = $6f8f3e97c4d83891$export$f17704b0c58450aa({
        tabs: tabs
    });
    return $c9a251dc3aa901f2$var$bind($c9a251dc3aa901f2$var$expectationPicker(state))(function(endState) {
        return $c9a251dc3aa901f2$var$pure($6f8f3e97c4d83891$export$9ec5fd99abbd9d7c(endState));
    });
};
var $c9a251dc3aa901f2$export$f97c0ae6299495bc = function(subform) {
    return function(v) {
        var load = function(fc) {
            return function(json) {
                return $c9a251dc3aa901f2$var$map4($c9a251dc3aa901f2$var$wrapFormWidget)($c9a251dc3aa901f2$export$a384978f9045e2e6(fc)(subform)(json));
            };
        };
        return $c9a251dc3aa901f2$var$wrapFormWidget2($b19cb68dd93bf4c1$export$ebe30643573800f8({
            id: v.id,
            label: v.label,
            cls: v.cls,
            addBtns: [
                {
                    label: $c3328e54cdf5154c$export$5a1a8430df9521e("course-choose-expectation"),
                    newEntries: function(fc) {
                        return $c9a251dc3aa901f2$var$bind($c9a251dc3aa901f2$var$map2($c9a251dc3aa901f2$var$fromFoldable)($c9a251dc3aa901f2$export$a638d6c1c7214561(fc)))(function(exps) {
                            return $c9a251dc3aa901f2$var$traverse($c9a251dc3aa901f2$export$a30a6125f2d93a1(fc)(subform))(exps);
                        });
                    }
                },
                {
                    label: $c3328e54cdf5154c$export$5a1a8430df9521e("course-insert-expectation"),
                    newEntries: function(v1) {
                        return $c9a251dc3aa901f2$var$pure([
                            $c9a251dc3aa901f2$var$wrapFormWidget(subform)
                        ]);
                    }
                }
            ],
            load: load,
            loadExist: function(fc) {
                return function(v1) {
                    return function(json) {
                        return load(fc)(json);
                    };
                };
            }
        }));
    };
};



// Generated by purs version 0.15.16


















var $69c473d702e5e00f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $69c473d702e5e00f$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $69c473d702e5e00f$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $69c473d702e5e00f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $69c473d702e5e00f$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $69c473d702e5e00f$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $69c473d702e5e00f$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $69c473d702e5e00f$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $69c473d702e5e00f$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $69c473d702e5e00f$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $69c473d702e5e00f$var$decodeJsonMaybe = /* #__PURE__ */ $e2b1be82a5e6d14f$export$6c5207b40709ea3b($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11);
var $69c473d702e5e00f$export$6bf0cd3a219bbade = function(x) {
    return x;
};
var $69c473d702e5e00f$export$5316176e0fd7f3d5 = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "placeholder";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "step";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
})(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e5aa470f8f97c3fe)))($2c6b3d51d10471a7$export$e5aa470f8f97c3fe))(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $69c473d702e5e00f$export$ff1066cb9b822be5 = function(v) {
    return $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$export$a3fe094919f356fd(v.step)) === v.step;
};
var $69c473d702e5e00f$export$a85953353e087abc = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var value = function() {
                if ($69c473d702e5e00f$export$ff1066cb9b822be5(v)) return $06733ae99ed4f534$export$43db023a260c5e9f("")($69c473d702e5e00f$var$map(function($74) {
                    return $69c473d702e5e00f$var$show($8d5664f12212b23e$export$a3fe094919f356fd($74));
                })(v.value));
                return $69c473d702e5e00f$var$show1($06733ae99ed4f534$export$43db023a260c5e9f(0.0)(v.value));
            }();
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            var handleInput = function(newval) {
                var v1 = $052de1c85deb22bf$export$3004f64547af360e(newval);
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                    cls: v.cls,
                    id: v.id,
                    label: v.label,
                    placeholder: v.placeholder,
                    step: v.step,
                    value: new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value0)
                };
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                    cls: v.cls,
                    id: v.id,
                    label: v.label,
                    placeholder: v.placeholder,
                    step: v.step,
                    value: $06733ae99ed4f534$export$bebe9059409a0d04.value
                };
                throw new Error("Failed pattern match at Widgets.Form.NumberInput (line 53, column 13 - line 55, column 54): " + [
                    v1.constructor.name
                ]);
            };
            return $69c473d702e5e00f$var$map1($f388db8e60bd7b97$export$e0d76edcf577b85d)($69c473d702e5e00f$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])([
                $13f400606229606c$export$2d1ee3fa3f1ce03(fc)(v),
                $69c473d702e5e00f$var$input($69c473d702e5e00f$var$append([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("number"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f("")(v.placeholder)),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(value),
                    $fc1df90f0e252058$export$35d34bc0ed591a92($69c473d702e5e00f$var$show1(v.step)),
                    $69c473d702e5e00f$var$map2($69c473d702e5e00f$var$map3($69c473d702e5e00f$var$map3($69c473d702e5e00f$export$6bf0cd3a219bbade)(handleInput))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(v2) {
                if ($69c473d702e5e00f$var$eq1(v2)($0e031af7428ef07d$export$dbafa4424a806c15(""))) return new $7d4cccdf062a2261$export$19db0165690c701a(v1);
                return $f388db8e60bd7b97$export$89aa195e4b27a289($69c473d702e5e00f$export$a85953353e087abc)($69c473d702e5e00f$var$decodeJsonMaybe)(v1)(function(val) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        step: v1.step,
                        placeholder: v1.placeholder,
                        value: val
                    });
                })(v2);
            };
        };
    }
};


// Generated by purs version 0.15.16















var $97422168d708f34b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $97422168d708f34b$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $97422168d708f34b$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $97422168d708f34b$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $97422168d708f34b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $97422168d708f34b$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $97422168d708f34b$export$d9c67ff858089902 = function(x) {
    return x;
};
var $97422168d708f34b$export$8186ddc1fa8e29e6 = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "placeholder";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
})($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $97422168d708f34b$export$5f9461193a1d19b8 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            return $97422168d708f34b$var$map($f388db8e60bd7b97$export$e0d76edcf577b85d)($97422168d708f34b$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])([
                $13f400606229606c$export$cc2d6a1959a4b653(fc)(v)([
                    $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                ]),
                $97422168d708f34b$var$input($97422168d708f34b$var$append([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("tel"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$a8ff84c12d48cfa6(id),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.value),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f("")(v.placeholder)),
                    $fc1df90f0e252058$export$24f82734ea047e6f("[0-9]{3}-[0-9]{3}-[0-9]{4}"),
                    $97422168d708f34b$var$map1($97422168d708f34b$var$map2($97422168d708f34b$var$map2($97422168d708f34b$export$d9c67ff858089902)(function(v1) {
                        return {
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            placeholder: v.placeholder,
                            value: v1
                        };
                    }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $0e031af7428ef07d$export$dbafa4424a806c15(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return $f388db8e60bd7b97$export$89aa195e4b27a289($97422168d708f34b$export$5f9461193a1d19b8)($e2b1be82a5e6d14f$export$12808118396f3c8d)(v1)(function(val) {
                return new $7d4cccdf062a2261$export$19db0165690c701a({
                    id: v1.id,
                    label: v1.label,
                    cls: v1.cls,
                    placeholder: v1.placeholder,
                    value: val
                });
            });
        };
    }
};


// Generated by purs version 0.15.16



















var $c7751bfafd6f01fa$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()();
var $c7751bfafd6f01fa$var$showRecordFieldsCons = /* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
});
var $c7751bfafd6f01fa$var$showRecordFieldsConsNil = /* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
});
var $c7751bfafd6f01fa$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $c7751bfafd6f01fa$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $c7751bfafd6f01fa$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($c7751bfafd6f01fa$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c7751bfafd6f01fa$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $c7751bfafd6f01fa$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c7751bfafd6f01fa$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $c7751bfafd6f01fa$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c7751bfafd6f01fa$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $c7751bfafd6f01fa$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($c7751bfafd6f01fa$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c7751bfafd6f01fa$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c7751bfafd6f01fa$var$decodeJsonMaybe = /* #__PURE__ */ $e2b1be82a5e6d14f$export$6c5207b40709ea3b($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $c7751bfafd6f01fa$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $c7751bfafd6f01fa$export$d7b12c4107be0d61 = function(x) {
    return x;
};
var $c7751bfafd6f01fa$export$3d83496e0716088c = /* #__PURE__ */ $c7751bfafd6f01fa$var$showRecord(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $c7751bfafd6f01fa$var$showRecordFieldsCons(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "options";
    }
})(/* #__PURE__ */ $c7751bfafd6f01fa$var$showRecordFieldsConsNil(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225(/* #__PURE__ */ $c7751bfafd6f01fa$var$showRecord(/* #__PURE__ */ $c7751bfafd6f01fa$var$showRecordFieldsCons(/* #__PURE__ */ $c7751bfafd6f01fa$var$showRecordFieldsConsNil($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $c7751bfafd6f01fa$export$77318857f1ba0a87 = function(fc) {
    return function(state) {
        return function(opt) {
            var selected = $c7751bfafd6f01fa$var$eq(state.value)(new $06733ae99ed4f534$export$8a67b48435b5d073(opt.value));
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(state.id) + ("." + opt.value);
            return $c7751bfafd6f01fa$var$div$prime([
                $c7751bfafd6f01fa$var$input($c7751bfafd6f01fa$var$append1([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("radio"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$a8ff84c12d48cfa6(id),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(opt.value),
                    $fc1df90f0e252058$export$b96bb35bc88d6fa(selected),
                    $c7751bfafd6f01fa$var$voidRight(opt.value)($fc1df90f0e252058$export$bd913411069e59d3)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(state.id))),
                $13f400606229606c$export$c95f1c97489c23b(id)(opt.label)
            ]);
        };
    };
};
var $c7751bfafd6f01fa$export$573333f6a7e22334 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            return $c7751bfafd6f01fa$var$map($c7751bfafd6f01fa$var$map1($c7751bfafd6f01fa$var$map1($f388db8e60bd7b97$export$e0d76edcf577b85d)($c7751bfafd6f01fa$export$d7b12c4107be0d61))(function(v1) {
                return {
                    cls: v.cls,
                    id: v.id,
                    label: v.label,
                    options: v.options,
                    value: new $06733ae99ed4f534$export$8a67b48435b5d073(v1)
                };
            }))($c7751bfafd6f01fa$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0($f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])($c7751bfafd6f01fa$var$append1([
                $13f400606229606c$export$2d1ee3fa3f1ce03(fc)(v)
            ])($c7751bfafd6f01fa$var$map2($c7751bfafd6f01fa$export$77318857f1ba0a87(fc)(v))(v.options))));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($0e031af7428ef07d$export$63ea9a5410ee0cef)($0e031af7428ef07d$export$dbafa4424a806c15)(v1.value);
        };
    },
    setData: function(fc) {
        return function(v) {
            return $f388db8e60bd7b97$export$89aa195e4b27a289($c7751bfafd6f01fa$export$573333f6a7e22334)($c7751bfafd6f01fa$var$decodeJsonMaybe)(v)(function(val$prime) {
                if (val$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$19db0165690c701a({
                    id: v.id,
                    label: v.label,
                    cls: v.cls,
                    options: v.options,
                    value: $06733ae99ed4f534$export$bebe9059409a0d04.value
                });
                if (val$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $c7751bfafd6f01fa$var$any(function(opt) {
                    return opt.value === val$prime.value0;
                })(v.options)) return new $7d4cccdf062a2261$export$19db0165690c701a({
                    id: v.id,
                    label: v.label,
                    cls: v.cls,
                    options: v.options,
                    value: new $06733ae99ed4f534$export$8a67b48435b5d073(val$prime.value0)
                });
                if (val$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012(val$prime.value0 + (" is not an option in radio " + $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id))));
                throw new Error("Failed pattern match at Widgets.Form.Radio (line 42, column 9 - line 46, column 106): " + [
                    val$prime.constructor.name
                ]);
            });
        };
    }
};


// Generated by purs version 0.15.16
















var $9ba897e5bccf1b3f$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $9ba897e5bccf1b3f$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $9ba897e5bccf1b3f$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $9ba897e5bccf1b3f$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $9ba897e5bccf1b3f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $9ba897e5bccf1b3f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $9ba897e5bccf1b3f$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9ba897e5bccf1b3f$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $9ba897e5bccf1b3f$export$565f2394d4bdfdbe = function(x) {
    return x;
};
var $9ba897e5bccf1b3f$export$d3723392410533e4 = {
    show: function(v) {
        return "Select " + v.id;
    }
};
var $9ba897e5bccf1b3f$export$9a9efa1948916579 = function(entry) {
    return function(v) {
        var opt = $9ba897e5bccf1b3f$var$bind(entry)(function(json) {
            return $9ba897e5bccf1b3f$var$bind($9ba897e5bccf1b3f$var$find(function(o) {
                return $9ba897e5bccf1b3f$var$eq(o.value)(json);
            })(v.options))(function(option) {
                return $9ba897e5bccf1b3f$var$pure({
                    label: option.label,
                    value: json
                });
            });
        });
        return {
            id: v.id,
            label: v.label,
            cls: v.cls,
            options: v.options,
            placeholder: v.placeholder,
            sel: $7178b396566f5a79$export$5a4818cec1656a71(v.sel)(opt)
        };
    };
};
var $9ba897e5bccf1b3f$export$d25626d1625ac929 = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var state$prime = {
                cls: v.cls,
                id: v.id,
                label: v.label,
                options: v.options,
                placeholder: v.placeholder,
                sel: {
                    expanded: v.sel.expanded,
                    groupFunc: v.sel.groupFunc,
                    highlighted: v.sel.highlighted,
                    hovering: v.sel.hovering,
                    loadNext: v.sel.loadNext,
                    options: v.sel.options,
                    search: v.sel.search,
                    searchAff: v.sel.searchAff,
                    selected: v.sel.selected,
                    state: v.sel.state,
                    id: $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id),
                    config: {
                        allowDeselect: v.sel.config.allowDeselect,
                        deselectLabel: v.sel.config.deselectLabel,
                        placeholder: v.sel.config.placeholder,
                        editable: $f388db8e60bd7b97$export$330cf2b9485e792b(fc)(v.id)
                    }
                }
            };
            return $9ba897e5bccf1b3f$var$map($9ba897e5bccf1b3f$var$map1($9ba897e5bccf1b3f$var$map1($f388db8e60bd7b97$export$e0d76edcf577b85d)($9ba897e5bccf1b3f$export$565f2394d4bdfdbe))(function(v1) {
                return {
                    cls: state$prime.cls,
                    id: state$prime.id,
                    label: state$prime.label,
                    options: state$prime.options,
                    placeholder: state$prime.placeholder,
                    sel: v1
                };
            }))($9ba897e5bccf1b3f$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v)),
                $fc1df90f0e252058$export$df61b30b684217c0(v.id)
            ])([
                $13f400606229606c$export$ca470b1dc9d00aa6(fc)(v)([
                    $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                ]),
                $7178b396566f5a79$export$54b124386ef5abe3(state$prime.sel)
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $06733ae99ed4f534$export$43db023a260c5e9f($0e031af7428ef07d$export$63ea9a5410ee0cef)($9ba897e5bccf1b3f$var$map2(function(v2) {
                return v2.value;
            })($7178b396566f5a79$export$127d1aaaa65102b1(v1.sel)));
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(v2) {
                if ($2a035e92dc768ac1$export$630801d484da15df(v2)) return new $7d4cccdf062a2261$export$19db0165690c701a($9ba897e5bccf1b3f$export$9a9efa1948916579($06733ae99ed4f534$export$bebe9059409a0d04.value)(v1));
                return new $7d4cccdf062a2261$export$19db0165690c701a($9ba897e5bccf1b3f$export$9a9efa1948916579(new $06733ae99ed4f534$export$8a67b48435b5d073(v2))(v1));
            };
        };
    }
};
var $9ba897e5bccf1b3f$export$71821c1eec3657cc = function(v) {
    return $9ba897e5bccf1b3f$export$9a9efa1948916579(v.value)({
        id: v.id,
        label: v.label,
        options: v.options,
        cls: v.cls,
        placeholder: v.placeholder,
        sel: function() {
            var v1 = $7178b396566f5a79$export$95f56ae4fbe7eea3(v.id)(v.options);
            return {
                id: v1.id,
                search: v1.search,
                searchAff: v1.searchAff,
                groupFunc: v1.groupFunc,
                selected: v1.selected,
                highlighted: v1.highlighted,
                expanded: v1.expanded,
                hovering: v1.hovering,
                loadNext: v1.loadNext,
                options: v1.options,
                state: v1.state,
                config: {
                    deselectLabel: v1.config.deselectLabel,
                    allowDeselect: v1.config.allowDeselect,
                    editable: v1.config.editable,
                    placeholder: v.placeholder
                }
            };
        }()
    });
};



// Generated by purs version 0.15.16
// Generated by purs version 0.15.16

// Generated by purs version 0.15.16











// Generated by purs version 0.15.16





















var $aa35c333414e4a9b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $aa35c333414e4a9b$var$query = /* #__PURE__ */ $42ad8b7b0d01e859$export$2fa187e846a241c4(/* #__PURE__ */ $eb7399d322077fcf$export$4acff49b3f5661ea($eb7399d322077fcf$export$35d3004eff90f123));
var $aa35c333414e4a9b$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $aa35c333414e4a9b$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $aa35c333414e4a9b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $aa35c333414e4a9b$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $aa35c333414e4a9b$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5501dc3a72754845($e2b1be82a5e6d14f$export$c2f7b8312539f0ea));
var $aa35c333414e4a9b$var$getField1 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $aa35c333414e4a9b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $aa35c333414e4a9b$export$1c557fe1c55b345 = /* #__PURE__ */ function() {
    function CompQuery(value0) {
        this.value0 = value0;
    }
    CompQuery.create = function(value0) {
        return new CompQuery(value0);
    };
    return CompQuery;
}();
var $aa35c333414e4a9b$export$4a704d457129bae = function(dict) {
    return dict.subQueryVars;
};
var $aa35c333414e4a9b$export$e2dbfb5d71580859 = function(dict) {
    return dict.subQueryShape;
};
var $aa35c333414e4a9b$export$7af2bb1a2461e7b3 = function(dict) {
    return dict.subQueryDecode;
};
var $aa35c333414e4a9b$export$37a0cb4750aac3d2 = function(dict) {
    return dict.subQueryArgs;
};
var $aa35c333414e4a9b$export$a058fecfeca1a6f7 = {
    subQueryVars: function(v) {
        return v.value0.vars;
    },
    subQueryArgs: function(v) {
        return v.value0.args;
    },
    subQueryShape: function(v) {
        return v.value0.shape;
    },
    subQueryDecode: function(v) {
        return v.value0.decode;
    }
};
var $aa35c333414e4a9b$export$e2fac0082c9ecf76 = function(dict) {
    return dict.cqVars;
};
var $aa35c333414e4a9b$export$ad8d9497cab2b80f = function(dict) {
    return dict.cqShape;
};
var $aa35c333414e4a9b$export$d5fe2f8849dae9c5 = {
    cqVars: function(v) {
        return function(v1) {
            return function(v2) {
                return $03b6b966974423fe$export$6e22c362a0406a2c;
            };
        };
    },
    cqArgs: function(v) {
        return function(v1) {
            return function(v2) {
                return [];
            };
        };
    },
    cqShape: function(v) {
        return function(v1) {
            return function(v2) {
                return [];
            };
        };
    },
    cqDecode: function(v) {
        return function(v1) {
            return function(v2) {
                return new $7d4cccdf062a2261$export$19db0165690c701a({});
            };
        };
    }
};
var $aa35c333414e4a9b$export$7a26e05e222ff2dc = {
    getQuery: function(v) {
        return {
            query: $a40b20519abba0fb$export$78b7a7f99b2aea2d(v.value0),
            variables: $0e031af7428ef07d$export$dbafa4424a806c15(v.value0.vars)
        };
    },
    getDecode: function(v) {
        return v.value0.decode;
    }
};
var $aa35c333414e4a9b$var$getDecode = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($aa35c333414e4a9b$export$7a26e05e222ff2dc);
var $aa35c333414e4a9b$export$4b7880dae9bb4312 = {
    runGraphQL: function(v) {
        return $d2284b2d3e1b6f87$export$8291c2122093ac93($aa35c333414e4a9b$var$bind($aa35c333414e4a9b$var$query($a40b20519abba0fb$export$78b7a7f99b2aea2d(v.value0))(v.value0.vars))(function(ret) {
            return $aa35c333414e4a9b$var$except($aa35c333414e4a9b$var$getDecode(v)(ret));
        }));
    }
};
var $aa35c333414e4a9b$export$7d6b6454d56a905c = function(dict) {
    return dict.cqDecode;
};
var $aa35c333414e4a9b$export$58a950d45f164b48 = function(dict) {
    return dict.cqArgs;
};
var $aa35c333414e4a9b$export$4905024c31095330 = function(dictComposeQueries) {
    var cqVars1 = $aa35c333414e4a9b$export$e2fac0082c9ecf76(dictComposeQueries);
    var cqArgs1 = $aa35c333414e4a9b$export$58a950d45f164b48(dictComposeQueries);
    var cqShape1 = $aa35c333414e4a9b$export$ad8d9497cab2b80f(dictComposeQueries);
    var cqDecode1 = $aa35c333414e4a9b$export$7d6b6454d56a905c(dictComposeQueries);
    return function(dictIsSymbol) {
        var get = $15e8567e7c31ba30$export$3988ae62b71be9a3(dictIsSymbol)();
        var $$delete = $15e8567e7c31ba30$export$1822828d790e23ee(dictIsSymbol)()();
        var reflectSymbol = $1f7f00687c3959c5$export$e5ed8a20a1c4d576(dictIsSymbol);
        var insert = $15e8567e7c31ba30$export$21a5ca8aa77d35ff(dictIsSymbol)()();
        return function() {
            return function() {
                return function() {
                    return function() {
                        return function(dictSubQueryable) {
                            var subQueryVars1 = $aa35c333414e4a9b$export$4a704d457129bae(dictSubQueryable);
                            var subQueryArgs1 = $aa35c333414e4a9b$export$37a0cb4750aac3d2(dictSubQueryable);
                            var subQueryShape1 = $aa35c333414e4a9b$export$e2dbfb5d71580859(dictSubQueryable);
                            var subQueryDecode1 = $aa35c333414e4a9b$export$7af2bb1a2461e7b3(dictSubQueryable);
                            return {
                                cqVars: function(v) {
                                    return function(v1) {
                                        return function(q) {
                                            var val = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q);
                                            return $c045ea5df33bba60$export$971dd5b0dfd021b6(subQueryVars1(val))(cqVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q)));
                                        };
                                    };
                                },
                                cqArgs: function(v) {
                                    return function(v1) {
                                        return function(q) {
                                            var renamed = function(a) {
                                                return a;
                                            };
                                            var val = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q);
                                            return $aa35c333414e4a9b$var$append(renamed(subQueryArgs1(val)))(cqArgs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q)));
                                        };
                                    };
                                },
                                cqShape: function(v) {
                                    return function(v1) {
                                        return function(q) {
                                            var val = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q);
                                            var aliased = $266cd1b01131a218$export$f275737dbf8a1686.create(reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
                                            return $aa35c333414e4a9b$var$append($aa35c333414e4a9b$var$map(aliased)(subQueryShape1(val)))(cqShape1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q)));
                                        };
                                    };
                                },
                                cqDecode: function(v) {
                                    return function(q) {
                                        return function(json) {
                                            var name = reflectSymbol($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value);
                                            var val = get($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q);
                                            return $aa35c333414e4a9b$var$bind1(cqDecode1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($$delete($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(q))(json))(function(rest) {
                                                return $aa35c333414e4a9b$var$bind1($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($aa35c333414e4a9b$var$bind1($aa35c333414e4a9b$var$bind1($160716589b57c4ec$export$10fbded63f740d7b(json))(function(v1) {
                                                    return $aa35c333414e4a9b$var$getField(v1)("data");
                                                }))(function(v1) {
                                                    return $aa35c333414e4a9b$var$getField1(v1)(name);
                                                })))(function(inner) {
                                                    return $aa35c333414e4a9b$var$bind1(subQueryDecode1(val)(inner))(function(rval) {
                                                        return $aa35c333414e4a9b$var$pure(insert($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(rval)(rest));
                                                    });
                                                });
                                            });
                                        };
                                    };
                                }
                            };
                        };
                    };
                };
            };
        };
    };
};
var $aa35c333414e4a9b$export$ffb9fd3b6d5630e7 = function() {
    return function(dictComposeQueries) {
        var cqShape1 = $aa35c333414e4a9b$export$ad8d9497cab2b80f(dictComposeQueries);
        var cqVars1 = $aa35c333414e4a9b$export$e2fac0082c9ecf76(dictComposeQueries);
        var cqDecode1 = $aa35c333414e4a9b$export$7d6b6454d56a905c(dictComposeQueries);
        var cqArgs1 = $aa35c333414e4a9b$export$58a950d45f164b48(dictComposeQueries);
        return function(name) {
            return function(queries) {
                var shape = cqShape1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries);
                var vars = cqVars1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries);
                var decode = cqDecode1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries);
                var args = cqArgs1($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value)(queries);
                var query1 = {
                    name: name,
                    args: args,
                    shape: shape,
                    files: [],
                    mutation: false
                };
                return new $aa35c333414e4a9b$export$1c557fe1c55b345($a40b20519abba0fb$export$1e228ef26b273807(query1)(vars)(decode));
            };
        };
    };
};






var $dc9dc2b43b9526de$var$searchIsSymbol = {
    reflectSymbol: function() {
        return "search";
    }
};
var $dc9dc2b43b9526de$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $dc9dc2b43b9526de$var$gDecodeJsonCons1 = /* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $dc9dc2b43b9526de$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $dc9dc2b43b9526de$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $dc9dc2b43b9526de$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))(/* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons1($dc9dc2b43b9526de$var$nameIsSymbol)()())($dc9dc2b43b9526de$var$idIsSymbol)()())();
var $dc9dc2b43b9526de$var$decodeArray = /* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($dc9dc2b43b9526de$var$decodeRecord);
var $dc9dc2b43b9526de$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $dc9dc2b43b9526de$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $dc9dc2b43b9526de$var$rlhsCons($dc9dc2b43b9526de$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($dc9dc2b43b9526de$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $dc9dc2b43b9526de$var$arrayShape = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($dc9dc2b43b9526de$var$recShape);
var $dc9dc2b43b9526de$var$unpagedQR = /* #__PURE__ */ $b5f6b40b8f63b732$export$2f7ef8bdb1317d03(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a($dc9dc2b43b9526de$var$decodeArray)($dc9dc2b43b9526de$var$arrayShape));
var $dc9dc2b43b9526de$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc)($dc9dc2b43b9526de$var$searchIsSymbol)($308f9765feb7633d$export$7fbebe4a88ae10b0)($eb7399d322077fcf$export$188ec67d44674d4b)()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330)($dc9dc2b43b9526de$var$searchIsSymbol)())())($dc9dc2b43b9526de$var$unpagedQR);
var $dc9dc2b43b9526de$var$buildQuery1 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f($a40b20519abba0fb$export$bb525b50bfdf2bbc)($a40b20519abba0fb$export$fe891b8934c38330)());
var $dc9dc2b43b9526de$var$semesterIsSymbol = {
    reflectSymbol: function() {
        return "semester";
    }
};
var $dc9dc2b43b9526de$var$decodeRecord1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons(/* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons1($dc9dc2b43b9526de$var$semesterIsSymbol)()())($dc9dc2b43b9526de$var$nameIsSymbol)()())();
var $dc9dc2b43b9526de$var$recShape1 = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $dc9dc2b43b9526de$var$rlhsCons($dc9dc2b43b9526de$var$semesterIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($dc9dc2b43b9526de$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $dc9dc2b43b9526de$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($dc9dc2b43b9526de$var$decodeRecord));
var $dc9dc2b43b9526de$var$teacherIsSymbol = {
    reflectSymbol: function() {
        return "teacher";
    }
};
var $dc9dc2b43b9526de$var$groupIsSymbol = {
    reflectSymbol: function() {
        return "group";
    }
};
var $dc9dc2b43b9526de$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($dc9dc2b43b9526de$var$recShape);
var $dc9dc2b43b9526de$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $dc9dc2b43b9526de$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $dc9dc2b43b9526de$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b));
var $dc9dc2b43b9526de$var$encodeJson1 = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
var $dc9dc2b43b9526de$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $dc9dc2b43b9526de$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $dc9dc2b43b9526de$var$groupsIsSymbol = {
    reflectSymbol: function() {
        return "groups";
    }
};
var $dc9dc2b43b9526de$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($dc9dc2b43b9526de$var$decodeArray))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($dc9dc2b43b9526de$var$groupsIsSymbol)()())())));
var $dc9dc2b43b9526de$var$teachersIsSymbol = {
    reflectSymbol: function() {
        return "teachers";
    }
};
var $dc9dc2b43b9526de$var$studentsIsSymbol = {
    reflectSymbol: function() {
        return "students";
    }
};
var $dc9dc2b43b9526de$var$arrayShape1 = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $dc9dc2b43b9526de$var$rlhsCons($dc9dc2b43b9526de$var$groupsIsSymbol)($dc9dc2b43b9526de$var$arrayShape)()())());
var $dc9dc2b43b9526de$var$SearchVars = /* #__PURE__ */ function() {
    function SearchVars(value0) {
        this.value0 = value0;
    }
    SearchVars.create = function(value0) {
        return new SearchVars(value0);
    };
    return SearchVars;
}();
var $dc9dc2b43b9526de$export$65b452f689ee411 = function(search) {
    return $b5f6b40b8f63b732$export$16f20977ea7eb010($dc9dc2b43b9526de$var$buildQuery("teachers")({
        search: search
    }));
};
var $dc9dc2b43b9526de$export$4cc3c70d62d7a856 = /* #__PURE__ */ function() {
    return new $7178b396566f5a79$export$8210f7ba0d8a3862(function(search) {
        return $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
            return v.name;
        })($dc9dc2b43b9526de$export$65b452f689ee411(search));
    });
}();
var $dc9dc2b43b9526de$export$385cf44dadb9b5cd = /* #__PURE__ */ $dc9dc2b43b9526de$var$buildQuery1(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($dc9dc2b43b9526de$var$decodeRecord1))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($dc9dc2b43b9526de$var$recShape1)))("semesters")({});
var $dc9dc2b43b9526de$export$930f503bd2cd157b = /* #__PURE__ */ $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
    return v.label;
})(/* #__PURE__ */ $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
    return v.name;
})($dc9dc2b43b9526de$export$385cf44dadb9b5cd));
var $dc9dc2b43b9526de$export$d5dece3cd5170d00 = /* #__PURE__ */ $dc9dc2b43b9526de$var$buildQuery1(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons2(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($dc9dc2b43b9526de$var$decodeRecord1))(/* #__PURE__ */ $dc9dc2b43b9526de$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($dc9dc2b43b9526de$var$teacherIsSymbol)()())($dc9dc2b43b9526de$var$semesterIsSymbol)()())($dc9dc2b43b9526de$var$groupIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $dc9dc2b43b9526de$var$rlhsCons($dc9dc2b43b9526de$var$teacherIsSymbol)($dc9dc2b43b9526de$var$maybeShape)()())($dc9dc2b43b9526de$var$semesterIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($dc9dc2b43b9526de$var$recShape1))()())($dc9dc2b43b9526de$var$groupIsSymbol)($dc9dc2b43b9526de$var$maybeShape)()())()))("defaultSelections")({});
var $dc9dc2b43b9526de$export$1f60fd986f394bce = function(v) {
    return new $dc9dc2b43b9526de$var$SearchVars({
        teacher: v.teacher,
        semester: v.semester,
        search: v.search,
        "class": v["class"]
    });
};
var $dc9dc2b43b9526de$export$da880a72ef7f44b2 = function(q) {
    return $dc9dc2b43b9526de$var$fromFoldable($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        $dc9dc2b43b9526de$var$map(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9("teacher_id", $dc9dc2b43b9526de$var$encodeJson(a));
        })(q.teacher),
        $dc9dc2b43b9526de$var$map(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9("class_id", $dc9dc2b43b9526de$var$encodeJson(a));
        })(q["class"]),
        $dc9dc2b43b9526de$var$map(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9("semester", $dc9dc2b43b9526de$var$encodeJson1(a));
        })(q.semester),
        $dc9dc2b43b9526de$var$map(function(a) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9("search", $dc9dc2b43b9526de$var$encodeJson1(a));
        })(q.search)
    ]));
};
var $dc9dc2b43b9526de$export$c0fc775ee5500e83 = {
    toVars: function(v) {
        return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            $dc9dc2b43b9526de$var$voidRight(new $a40b20519abba0fb$export$a90c0bb0b625769b("teacher_id", new $308f9765feb7633d$export$a9668a4ddbf1d475(new $308f9765feb7633d$export$be01c6bffeb93e87(new $308f9765feb7633d$export$c76991cd6baf9718("ID")))))(v.value0.teacher),
            $dc9dc2b43b9526de$var$voidRight(new $a40b20519abba0fb$export$a90c0bb0b625769b("class_id", new $308f9765feb7633d$export$c76991cd6baf9718("ID")))(v["value0"]["class"]),
            $dc9dc2b43b9526de$var$voidRight(new $a40b20519abba0fb$export$a90c0bb0b625769b("semester", new $308f9765feb7633d$export$c76991cd6baf9718("String")))(v.value0.semester),
            $dc9dc2b43b9526de$var$voidRight(new $a40b20519abba0fb$export$a90c0bb0b625769b("search", new $308f9765feb7633d$export$c76991cd6baf9718("String")))(v.value0.search)
        ]);
    },
    encodeVars: function(v) {
        return $dc9dc2b43b9526de$export$da880a72ef7f44b2(v.value0);
    },
    varFiles: function(v) {
        return [];
    }
};
var $dc9dc2b43b9526de$export$991d1a83fd85aed8 = function($232) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($dc9dc2b43b9526de$export$da880a72ef7f44b2($232));
};
var $dc9dc2b43b9526de$export$69ddb8c90122ad8a = function(q) {
    return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        $dc9dc2b43b9526de$var$voidRight(new $71f2e2e9476163f8$export$1908877435b1d5e9("teacher_id", "[ID!]"))(q.teacher),
        $dc9dc2b43b9526de$var$voidRight(new $71f2e2e9476163f8$export$1908877435b1d5e9("class_id", "ID!"))(q["class"]),
        $dc9dc2b43b9526de$var$voidRight(new $71f2e2e9476163f8$export$1908877435b1d5e9("semester", "String!"))(q.semester),
        $dc9dc2b43b9526de$var$voidRight(new $71f2e2e9476163f8$export$1908877435b1d5e9("search", "String!"))(q.search)
    ]);
};
var $dc9dc2b43b9526de$export$8b0c2f1bf29bc872 = /* #__PURE__ */ function() {
    return {
        teacher: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        semester: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        group: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $dc9dc2b43b9526de$export$8ba11d1b9ad0431b = {
    teachers: [],
    semesters: [],
    classes: [],
    defaults: $dc9dc2b43b9526de$export$8b0c2f1bf29bc872
};
var $dc9dc2b43b9526de$export$c18c3985e5d67c6d = /* #__PURE__ */ function() {
    var groups = $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function(v) {
        return v.groups;
    });
    var process = function(v) {
        return $dc9dc2b43b9526de$var$append(groups(v.teachers))(groups(v.students));
    };
    return $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5)(process)($dc9dc2b43b9526de$var$buildQuery1($a40b20519abba0fb$export$1cde869cdd796379($e2b1be82a5e6d14f$export$b423891985836fe9($dc9dc2b43b9526de$var$gDecodeJsonCons3($dc9dc2b43b9526de$var$gDecodeJsonCons3($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($dc9dc2b43b9526de$var$teachersIsSymbol)()())($dc9dc2b43b9526de$var$studentsIsSymbol)()())())($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($dc9dc2b43b9526de$var$rlhsCons($dc9dc2b43b9526de$var$teachersIsSymbol)($dc9dc2b43b9526de$var$arrayShape1)()())($dc9dc2b43b9526de$var$studentsIsSymbol)($dc9dc2b43b9526de$var$arrayShape1)()())()))("me")({}));
}();
var $dc9dc2b43b9526de$export$49a857040325da19 = /* #__PURE__ */ $aa35c333414e4a9b$export$ffb9fd3b6d5630e7()(/* #__PURE__ */ $aa35c333414e4a9b$export$4905024c31095330(/* #__PURE__ */ $aa35c333414e4a9b$export$4905024c31095330(/* #__PURE__ */ $aa35c333414e4a9b$export$4905024c31095330(/* #__PURE__ */ $aa35c333414e4a9b$export$4905024c31095330($aa35c333414e4a9b$export$d5fe2f8849dae9c5)($dc9dc2b43b9526de$var$teachersIsSymbol)()()()()($aa35c333414e4a9b$export$a058fecfeca1a6f7))({
    reflectSymbol: function() {
        return "semesters";
    }
})()()()()($aa35c333414e4a9b$export$a058fecfeca1a6f7))({
    reflectSymbol: function() {
        return "defaults";
    }
})()()()()($aa35c333414e4a9b$export$a058fecfeca1a6f7))({
    reflectSymbol: function() {
        return "classes";
    }
})()()()()($aa35c333414e4a9b$export$a058fecfeca1a6f7))("SearchData")({
    teachers: /* #__PURE__ */ $b5f6b40b8f63b732$export$16f20977ea7eb010(/* #__PURE__ */ $dc9dc2b43b9526de$var$buildQuery1($dc9dc2b43b9526de$var$unpagedQR)("teachers")({})),
    semesters: $dc9dc2b43b9526de$export$385cf44dadb9b5cd,
    classes: $dc9dc2b43b9526de$export$c18c3985e5d67c6d,
    defaults: $dc9dc2b43b9526de$export$d5dece3cd5170d00
});
var $dc9dc2b43b9526de$export$160b36955a0d614c = /* #__PURE__ */ $7178b396566f5a79$export$aa7ac00cb2600102(function(v) {
    return v.label;
})(/* #__PURE__ */ $7178b396566f5a79$export$a252dc72673d8d9b(function(v) {
    return v.name;
})($dc9dc2b43b9526de$export$c18c3985e5d67c6d));












var $b05aa108190eac05$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $b05aa108190eac05$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $b05aa108190eac05$var$colorIsSymbol = {
    reflectSymbol: function() {
        return "color";
    }
};
var $b05aa108190eac05$var$tagsIsSymbol = {
    reflectSymbol: function() {
        return "tags";
    }
};
var $b05aa108190eac05$var$preferred_nameIsSymbol = {
    reflectSymbol: function() {
        return "preferred_name";
    }
};
var $b05aa108190eac05$var$last_imported_atIsSymbol = {
    reflectSymbol: function() {
        return "last_imported_at";
    }
};
var $b05aa108190eac05$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $b05aa108190eac05$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $b05aa108190eac05$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $b05aa108190eac05$var$gDecodeJsonCons(/* #__PURE__ */ $b05aa108190eac05$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($b05aa108190eac05$var$nameIsSymbol)()())($b05aa108190eac05$var$colorIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($b05aa108190eac05$var$tagsIsSymbol)()())($b05aa108190eac05$var$preferred_nameIsSymbol)()())($b05aa108190eac05$var$nameIsSymbol)()())($b05aa108190eac05$var$last_imported_atIsSymbol)()())($b05aa108190eac05$var$idIsSymbol)()())();
var $b05aa108190eac05$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $b05aa108190eac05$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $b05aa108190eac05$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $b05aa108190eac05$var$rlhsCons($b05aa108190eac05$var$tagsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $b05aa108190eac05$var$rlhsCons($b05aa108190eac05$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($b05aa108190eac05$var$colorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($b05aa108190eac05$var$preferred_nameIsSymbol)($b05aa108190eac05$var$maybeShape)()())($b05aa108190eac05$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($b05aa108190eac05$var$last_imported_atIsSymbol)($b05aa108190eac05$var$maybeShape)()())($b05aa108190eac05$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $b05aa108190eac05$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02($dc9dc2b43b9526de$export$c0fc775ee5500e83)(/* #__PURE__ */ $b5f6b40b8f63b732$export$5139894cdc05562a($b05aa108190eac05$var$decodeRecord)($b05aa108190eac05$var$recShape));
var $b05aa108190eac05$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $b05aa108190eac05$var$buildQuery1 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc)($b05aa108190eac05$var$idIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
}))(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b))()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330)($b05aa108190eac05$var$idIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379($b05aa108190eac05$var$decodeRecord)($b05aa108190eac05$var$recShape));
var $b05aa108190eac05$export$672767f79e173783 = function(v) {
    if (v.last_imported_at instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v;
    if (v.last_imported_at instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
        var tag = {
            name: $c3328e54cdf5154c$export$5a1a8430df9521e("tag-imported"),
            color: "rgb(241, 240, 242)"
        };
        return {
            id: v.id,
            name: v.name,
            preferred_name: v.preferred_name,
            last_imported_at: v.last_imported_at,
            tags: $396c4c3d9e7fae3c$export$8327ebbef2a0ba76(tag)(v.tags)
        };
    }
    throw new Error("Failed pattern match at API.SelStudent (line 57, column 1 - line 57, column 40): " + [
        v.constructor.name
    ]);
};
var $b05aa108190eac05$export$88aef09b2a474163 = function(q) {
    return $b05aa108190eac05$var$buildQuery("students")($dc9dc2b43b9526de$export$1f60fd986f394bce(q));
};
var $b05aa108190eac05$export$587d23a27582cedb = function(account) {
    return function(id) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(s) {
            return $b05aa108190eac05$var$eq(s.id)(id);
        })(account.student);
    };
};
var $b05aa108190eac05$export$4ec774c6c67c391c = function(account) {
    return function(v) {
        return function(simple) {
            return function(paren) {
                if (v.preferred_name instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return simple(v.name);
                if (v.preferred_name instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.preferred_name.value0 === "") return simple(v.name);
                if (v.preferred_name instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $b05aa108190eac05$export$587d23a27582cedb(account)(v.id)) return simple(v.preferred_name.value0);
                if (v.preferred_name instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return paren({
                    legal: v.name,
                    preferred: v.preferred_name.value0
                });
                throw new Error("Failed pattern match at API.SelStudent (line 49, column 66 - line 53, column 58): " + [
                    v.preferred_name.constructor.name
                ]);
            };
        };
    };
};
var $b05aa108190eac05$export$d50a55988135660c = function(account) {
    return function(student) {
        return $b05aa108190eac05$export$4ec774c6c67c391c(account)(student)(function(name) {
            return name;
        })(function(v) {
            return v.legal + (" (" + (v.preferred + ")"));
        });
    };
};
var $b05aa108190eac05$export$ece1be3647e3a6ac = function(id) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("StudentById")($b05aa108190eac05$var$buildQuery1("student")({
        id: id
    }));
};















var $a9fb419bc59bee5b$var$fieldPaths = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($7ecd539579e10f1a$export$82deae0194ea4699);
var $a9fb419bc59bee5b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $a9fb419bc59bee5b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $a9fb419bc59bee5b$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $a9fb419bc59bee5b$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($a9fb419bc59bee5b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a9fb419bc59bee5b$var$h2$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$1b9b631f8eb73296($a9fb419bc59bee5b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a9fb419bc59bee5b$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $a9fb419bc59bee5b$var$toWidget = /* #__PURE__ */ $f388db8e60bd7b97$export$83925c2318996255($7ecd539579e10f1a$export$82deae0194ea4699);
var $a9fb419bc59bee5b$var$getData = /* #__PURE__ */ $f388db8e60bd7b97$export$7a171f172be0782e($7ecd539579e10f1a$export$82deae0194ea4699);
var $a9fb419bc59bee5b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $a9fb419bc59bee5b$var$setData = /* #__PURE__ */ $f388db8e60bd7b97$export$3a6802af14bf5fa6($7ecd539579e10f1a$export$82deae0194ea4699);
var $a9fb419bc59bee5b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $a9fb419bc59bee5b$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($7ecd539579e10f1a$export$2b89428e175ed52);
var $a9fb419bc59bee5b$export$b29794ea55b1711f = /* #__PURE__ */ function() {
    function StudentSubForm(value0) {
        this.value0 = value0;
    }
    StudentSubForm.create = function(value0) {
        return new StudentSubForm(value0);
    };
    return StudentSubForm;
}();
var $a9fb419bc59bee5b$export$7aeedf9e2a191a80 = {
    getId: function(v) {
        return v.value0.id;
    },
    asField: function(v) {
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    },
    isLeaf: function(v) {
        return false;
    },
    fieldPaths: function(fc) {
        return function(v) {
            return $a9fb419bc59bee5b$var$fieldPaths(fc)(v.value0);
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var wrapResult = function(r) {
                return $a9fb419bc59bee5b$var$map($a9fb419bc59bee5b$export$b29794ea55b1711f.create)(r);
            };
            var name = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("NO DOCUMENT SET - STUDENT NAME UNKNOWN")(function() {
                var $43 = $b05aa108190eac05$export$d50a55988135660c(fc.account);
                return function($44) {
                    return $43(function(v1) {
                        return v1.student;
                    }($44));
                };
            }())(fc.doc);
            return $a9fb419bc59bee5b$var$map1(wrapResult)($a9fb419bc59bee5b$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("student-subform")
            ])([
                $a9fb419bc59bee5b$var$h2$prime([
                    $a9fb419bc59bee5b$var$text(name)
                ]),
                $a9fb419bc59bee5b$var$toWidget(fc)(v.value0)
            ]));
        };
    },
    getData: function(fc) {
        return function(v) {
            return $a9fb419bc59bee5b$var$getData(fc)(v.value0);
        };
    },
    setData: function(fc) {
        return function(v) {
            return function(json) {
                return $a9fb419bc59bee5b$var$bind($a9fb419bc59bee5b$var$setData(fc)(v.value0)(json))(function(newsf) {
                    return $a9fb419bc59bee5b$var$pure(new $a9fb419bc59bee5b$export$b29794ea55b1711f(newsf));
                });
            };
        };
    }
};
var $a9fb419bc59bee5b$export$5d6d38a4d18da67f = {
    show: function(v) {
        return $a9fb419bc59bee5b$var$show(v.value0);
    }
};



// Generated by purs version 0.15.16
















var $2fd2989913f99c64$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $2fd2989913f99c64$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $2fd2989913f99c64$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($2fd2989913f99c64$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $2fd2989913f99c64$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $2fd2989913f99c64$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $2fd2989913f99c64$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $2fd2989913f99c64$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $2fd2989913f99c64$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $2fd2989913f99c64$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $2fd2989913f99c64$var$textarea = /* #__PURE__ */ $3eadc1b959dd1120$export$a3574df893ffa88d($2fd2989913f99c64$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $2fd2989913f99c64$var$showRecord = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "placeholder";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
})($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $2fd2989913f99c64$export$c86715117507e8e5 = function(x) {
    return x;
};
var $2fd2989913f99c64$export$f5c9f3c2c4054eec = function(x) {
    return x;
};
var $2fd2989913f99c64$export$9e9b7e1175ea331f = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            return $2fd2989913f99c64$var$map($f388db8e60bd7b97$export$e0d76edcf577b85d)($2fd2989913f99c64$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])([
                $13f400606229606c$export$cc2d6a1959a4b653(fc)(v)([
                    $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                ]),
                $2fd2989913f99c64$var$input($2fd2989913f99c64$var$append([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("text"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.value),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f("")(v.placeholder)),
                    $2fd2989913f99c64$var$map1($2fd2989913f99c64$var$map2($2fd2989913f99c64$var$map2($2fd2989913f99c64$export$c86715117507e8e5)(function(v1) {
                        return {
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            placeholder: v.placeholder,
                            value: v1
                        };
                    }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $0e031af7428ef07d$export$dbafa4424a806c15(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(v2) {
                if ($2a035e92dc768ac1$export$7e4aa119212bc614(v2)) return $f388db8e60bd7b97$export$89aa195e4b27a289($2fd2989913f99c64$export$9e9b7e1175ea331f)($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11)(v1)(function(v3) {
                    var $80 = $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$export$a3fe094919f356fd(v3)) === v3;
                    if ($80) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: $2fd2989913f99c64$var$show($8d5664f12212b23e$export$a3fe094919f356fd(v3))
                    });
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: $2fd2989913f99c64$var$show1(v3)
                    });
                })(v2);
                return $f388db8e60bd7b97$export$89aa195e4b27a289($2fd2989913f99c64$export$9e9b7e1175ea331f)($e2b1be82a5e6d14f$export$12808118396f3c8d)(v1)(function(val) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: val
                    });
                })(v2);
            };
        };
    }
};
var $2fd2989913f99c64$export$92b3581604414b0a = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            return $2fd2989913f99c64$var$map($f388db8e60bd7b97$export$e0d76edcf577b85d)($2fd2989913f99c64$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])([
                $13f400606229606c$export$cc2d6a1959a4b653(fc)(v)([
                    $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                ]),
                $2fd2989913f99c64$var$textarea($2fd2989913f99c64$var$append([
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f("")(v.placeholder)),
                    $2fd2989913f99c64$var$map1($2fd2989913f99c64$var$map2($2fd2989913f99c64$var$map2($2fd2989913f99c64$export$f5c9f3c2c4054eec)(function(v1) {
                        return {
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            placeholder: v.placeholder,
                            value: v1
                        };
                    }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.value)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))([])
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $0e031af7428ef07d$export$dbafa4424a806c15(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return function(v2) {
                if ($2a035e92dc768ac1$export$7e4aa119212bc614(v2)) return $f388db8e60bd7b97$export$89aa195e4b27a289($2fd2989913f99c64$export$92b3581604414b0a)($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11)(v1)(function(v3) {
                    var $93 = $4ab74a20512cef04$export$a0a81dc3380ce7d3($8d5664f12212b23e$export$a3fe094919f356fd(v3)) === v3;
                    if ($93) return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: $2fd2989913f99c64$var$show($8d5664f12212b23e$export$a3fe094919f356fd(v3))
                    });
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: $2fd2989913f99c64$var$show1(v3)
                    });
                })(v2);
                return $f388db8e60bd7b97$export$89aa195e4b27a289($2fd2989913f99c64$export$92b3581604414b0a)($e2b1be82a5e6d14f$export$12808118396f3c8d)(v1)(function(val) {
                    return new $7d4cccdf062a2261$export$19db0165690c701a({
                        id: v1.id,
                        label: v1.label,
                        cls: v1.cls,
                        placeholder: v1.placeholder,
                        value: val
                    });
                })(v2);
            };
        };
    }
};
var $2fd2989913f99c64$export$a77c57f8fa54a627 = $2fd2989913f99c64$var$showRecord;
var $2fd2989913f99c64$export$8777dc55d64e140 = $2fd2989913f99c64$var$showRecord;


// Generated by purs version 0.15.16






var $995df59c0c2f7d8f$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $995df59c0c2f7d8f$export$7fb170f1e457988f = function(v) {
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.signature, {
        first_name: v.first_name,
        last_name: v.last_name,
        email: v.email
    });
};
var $995df59c0c2f7d8f$export$654c292ba8f9410f = function(v) {
    if (v.value0 === "STUDENT_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-student");
    if (v.value0 === "TEACHER_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-teacher");
    if (v.value0 === "EMPLOYER_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-employer");
    if (v.value0 === "PARENT_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-parent");
    if (v.value0 === "PRINCIPAL_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-principal");
    if (v.value0 === "COORDINATOR_SIGNATURE") return $c3328e54cdf5154c$export$5a1a8430df9521e("rel-coordinator");
    return "";
};
var $995df59c0c2f7d8f$export$c9e7e3da0d364b66 = function(v) {
    return {
        key: v.key,
        label: v.label,
        emailLabel: v.emailLabel,
        relationship: v.relationship,
        relationship_label: v.relationship_label,
        can: v.can
    };
};
var $995df59c0c2f7d8f$export$ec1fe12c819d4041 = function(v) {
    return {
        key: v.key,
        label: v.label,
        emailLabel: v.emailLabel,
        relationship: v.relationship,
        relationship_label: $995df59c0c2f7d8f$export$654c292ba8f9410f(v.relationship),
        can: v.can
    };
};
var $995df59c0c2f7d8f$export$969d24321cf24522 = function(v) {
    if (v.signature instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
    return true;
};
var $995df59c0c2f7d8f$export$7e5519fad5fb9a1d = /* #__PURE__ */ function() {
    return $266cd1b01131a218$export$55dbabd51ced92f5($266cd1b01131a218$export$5b88af1c6457fdfe($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($995df59c0c2f7d8f$var$rlhsCons({
        reflectSymbol: function() {
            return "relationship_label";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "relationship";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "label";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "key";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "emailLabel";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "can";
        }
    })($266cd1b01131a218$export$5cdfc842db1bd206($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$3a03965a63c09844($995df59c0c2f7d8f$var$rlhsCons({
        reflectSymbol: function() {
            return "useDefault";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "update";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "saveDefault";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "request";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())({
        reflectSymbol: function() {
            return "create";
        }
    })($266cd1b01131a218$export$eac78e45f453a621)()())())()())())($c6a0478cbb9b5a21$export$accffb5fb4579e0d.value));
}();
var $995df59c0c2f7d8f$export$855946b90c7889b7 = /* #__PURE__ */ function() {
    return {
        first_name: "",
        last_name: "",
        email: "",
        signature: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $995df59c0c2f7d8f$export$93dd1e77e9808eaf = {
    first_name: "",
    last_name: "",
    email: ""
};
var $995df59c0c2f7d8f$export$80a9ba689aa548df = /* #__PURE__ */ function() {
    return new $308f9765feb7633d$export$d64ca3aab0d523a3("EMPLOYER_SIGNATURE");
}();
var $995df59c0c2f7d8f$export$2c46e451e46a8931 = function(v) {
    return function(signature) {
        return {
            first_name: v.first_name,
            last_name: v.last_name,
            email: v.email,
            signature: signature
        };
    };
};
var $995df59c0c2f7d8f$export$cabf611671cbb762 = function(v) {
    if (v.signature instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v.signature instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($995df59c0c2f7d8f$export$2c46e451e46a8931(v)(v.signature.value0));
    throw new Error("Failed pattern match at Widgets.Signature.Types (line 133, column 1 - line 133, column 55): " + [
        v.constructor.name
    ]);
};
var $995df59c0c2f7d8f$export$127d950ca3e7ae1c = function(v) {
    return $995df59c0c2f7d8f$export$2c46e451e46a8931(v)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.signature));
};


var $38eb3af3d662147b$var$inputIsSymbol = {
    reflectSymbol: function() {
        return "input";
    }
};
var $38eb3af3d662147b$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $38eb3af3d662147b$var$form_type_orderIsSymbol = {
    reflectSymbol: function() {
        return "form_type_order";
    }
};
var $38eb3af3d662147b$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc)($38eb3af3d662147b$var$inputIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "UserOptionsInput";
    }
}))(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($38eb3af3d662147b$var$encRNTY))($eb7399d322077fcf$export$12b4d820b2ffc726)($38eb3af3d662147b$var$form_type_orderIsSymbol)())()))()())(/* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c($a40b20519abba0fb$export$fe891b8934c38330)($38eb3af3d662147b$var$inputIsSymbol)()()(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330)($38eb3af3d662147b$var$form_type_orderIsSymbol)()))())($a40b20519abba0fb$export$5bc47822dabd2903);
var $38eb3af3d662147b$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $38eb3af3d662147b$var$selectAll = /* #__PURE__ */ $f264ceec36a478ad$export$90aca4adda6ff0f5($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$var$select = /* #__PURE__ */ $f264ceec36a478ad$export$2e6c959c16ff56b8($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$var$isSelected = /* #__PURE__ */ $f264ceec36a478ad$export$e4d153b3e021fb47($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $38eb3af3d662147b$var$getField = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $38eb3af3d662147b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $38eb3af3d662147b$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($37b880af5f4991bd$export$fa624555ca2acbc8);
var $38eb3af3d662147b$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $38eb3af3d662147b$var$decRNTY = /* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $38eb3af3d662147b$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($38eb3af3d662147b$var$decRNTY));
var $38eb3af3d662147b$var$gDecodeJsonCons2 = /* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $38eb3af3d662147b$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $38eb3af3d662147b$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $38eb3af3d662147b$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $38eb3af3d662147b$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons2($38eb3af3d662147b$var$updateIsSymbol)()())($38eb3af3d662147b$var$deleteIsSymbol)()())($38eb3af3d662147b$var$createIsSymbol)()())();
var $38eb3af3d662147b$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $38eb3af3d662147b$var$useDefaultIsSymbol = {
    reflectSymbol: function() {
        return "useDefault";
    }
};
var $38eb3af3d662147b$var$saveDefaultIsSymbol = {
    reflectSymbol: function() {
        return "saveDefault";
    }
};
var $38eb3af3d662147b$var$requestIsSymbol = {
    reflectSymbol: function() {
        return "request";
    }
};
var $38eb3af3d662147b$var$relationship_labelIsSymbol = {
    reflectSymbol: function() {
        return "relationship_label";
    }
};
var $38eb3af3d662147b$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $38eb3af3d662147b$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $38eb3af3d662147b$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $38eb3af3d662147b$var$emailLabelIsSymbol = {
    reflectSymbol: function() {
        return "emailLabel";
    }
};
var $38eb3af3d662147b$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $38eb3af3d662147b$var$decodeArray = /* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons3(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons3(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons3(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons3(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons3($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($38eb3af3d662147b$var$useDefaultIsSymbol)()())($38eb3af3d662147b$var$updateIsSymbol)()())($38eb3af3d662147b$var$saveDefaultIsSymbol)()())($38eb3af3d662147b$var$requestIsSymbol)()())($38eb3af3d662147b$var$createIsSymbol)()())()))(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons1(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons1(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons2($38eb3af3d662147b$var$relationship_labelIsSymbol)()())($38eb3af3d662147b$var$relationshipIsSymbol)()())($38eb3af3d662147b$var$labelIsSymbol)()())($38eb3af3d662147b$var$keyIsSymbol)()())($38eb3af3d662147b$var$emailLabelIsSymbol)()())($38eb3af3d662147b$var$canIsSymbol)()())());
var $38eb3af3d662147b$var$typeIsSymbol = {
    reflectSymbol: function() {
        return "type";
    }
};
var $38eb3af3d662147b$var$signaturesIsSymbol = {
    reflectSymbol: function() {
        return "signatures";
    }
};
var $38eb3af3d662147b$var$priorityIsSymbol = {
    reflectSymbol: function() {
        return "priority";
    }
};
var $38eb3af3d662147b$var$mutationsIsSymbol = {
    reflectSymbol: function() {
        return "mutations";
    }
};
var $38eb3af3d662147b$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $38eb3af3d662147b$var$bgColorIsSymbol = {
    reflectSymbol: function() {
        return "bgColor";
    }
};
var $38eb3af3d662147b$var$abbrIsSymbol = {
    reflectSymbol: function() {
        return "abbr";
    }
};
var $38eb3af3d662147b$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $38eb3af3d662147b$var$deselect = /* #__PURE__ */ $f264ceec36a478ad$export$5bb86370ea51314a($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$var$decodeForeignObject = /* #__PURE__ */ $e2b1be82a5e6d14f$export$5501dc3a72754845($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $38eb3af3d662147b$var$getField1 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($38eb3af3d662147b$var$decodeForeignObject);
var $38eb3af3d662147b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $38eb3af3d662147b$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $38eb3af3d662147b$var$getFieldOptional$prime = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $38eb3af3d662147b$var$getFieldOptional$prime1 = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$5a21fe33ecda3e76);
var $38eb3af3d662147b$var$fromFoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $38eb3af3d662147b$var$empty = /* #__PURE__ */ $7abe8fbe97ebda87$export$6e22c362a0406a2c($78c799cba34fcb8d$export$55d622505c452dcb);
var $38eb3af3d662147b$var$getField2 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$5a21fe33ecda3e76);
var $38eb3af3d662147b$var$getField3 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $38eb3af3d662147b$var$wrapFormWidget = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($b19cb68dd93bf4c1$export$fe5418acfa42da9e)($b19cb68dd93bf4c1$export$bc80505b76c642f0);
var $38eb3af3d662147b$var$getId = /* #__PURE__ */ $f388db8e60bd7b97$export$218c8c3169c024d2($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $38eb3af3d662147b$var$wrapFormWidget1 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($7ecd539579e10f1a$export$2b89428e175ed52)($7ecd539579e10f1a$export$82deae0194ea4699);
var $38eb3af3d662147b$var$wrapFormWidget2 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($a9fb419bc59bee5b$export$5d6d38a4d18da67f)($a9fb419bc59bee5b$export$7aeedf9e2a191a80);
var $38eb3af3d662147b$var$wrapFormWidget3 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($c1dc5882e052ac14$export$9b4b999b582f0205)($c1dc5882e052ac14$export$b9d183f421c4bc2f);
var $38eb3af3d662147b$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($eb7399d322077fcf$export$188ec67d44674d4b);
var $38eb3af3d662147b$var$decodeJsonMaybe = /* #__PURE__ */ $e2b1be82a5e6d14f$export$6c5207b40709ea3b($e2b1be82a5e6d14f$export$12808118396f3c8d);
var $38eb3af3d662147b$var$getField4 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($38eb3af3d662147b$var$decodeJsonMaybe);
var $38eb3af3d662147b$var$valueIsSymbol = {
    reflectSymbol: function() {
        return "value";
    }
};
var $38eb3af3d662147b$var$getField5 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$c2f7b8312539f0ea))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($38eb3af3d662147b$var$valueIsSymbol)()())($38eb3af3d662147b$var$labelIsSymbol)()())()));
var $38eb3af3d662147b$var$getFieldOptional$prime2 = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$c2f7b8312539f0ea);
var $38eb3af3d662147b$var$wrapFormWidget4 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($9ba897e5bccf1b3f$export$d3723392410533e4)($9ba897e5bccf1b3f$export$d25626d1625ac929);
var $38eb3af3d662147b$var$getFieldOptional$prime3 = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($38eb3af3d662147b$var$decodeForeignObject);
var $38eb3af3d662147b$var$wrapFormWidget5 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($38dfaea68b931435$export$40abf1bc8801220)($38dfaea68b931435$export$7d4e502ec7dc4005);
var $38eb3af3d662147b$var$wrapFormWidget6 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($288e43cb19fd2375$export$20f7a753325ed093)($288e43cb19fd2375$export$e9f4c78d39320de);
var $38eb3af3d662147b$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $38eb3af3d662147b$var$wrapFormWidget7 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($97422168d708f34b$export$8186ddc1fa8e29e6)($97422168d708f34b$export$5f9461193a1d19b8);
var $38eb3af3d662147b$var$getField6 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons2($38eb3af3d662147b$var$valueIsSymbol)()())($38eb3af3d662147b$var$labelIsSymbol)()())()));
var $38eb3af3d662147b$var$wrapFormWidget8 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($c7751bfafd6f01fa$export$3d83496e0716088c)($c7751bfafd6f01fa$export$573333f6a7e22334);
var $38eb3af3d662147b$var$wrapFormWidget9 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($1bc1b1bbc920ab10$export$1d9d0fcff8299be5)($1bc1b1bbc920ab10$export$1702eac557f573c7);
var $38eb3af3d662147b$var$getField7 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11);
var $38eb3af3d662147b$var$getFieldOptional$prime4 = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($e2b1be82a5e6d14f$export$2b11fc8bd46f4a11);
var $38eb3af3d662147b$var$wrapFormWidget10 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($69c473d702e5e00f$export$5316176e0fd7f3d5)($69c473d702e5e00f$export$a85953353e087abc);
var $38eb3af3d662147b$var$wrapFormWidget11 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($5ad0c5cefd7afaff$export$6f4d8ebc6c25c0df)($5ad0c5cefd7afaff$export$26648b7387036154);
var $38eb3af3d662147b$var$wrapFormWidget12 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($2fd2989913f99c64$export$a77c57f8fa54a627)($2fd2989913f99c64$export$9e9b7e1175ea331f);
var $38eb3af3d662147b$var$getFieldOptional$prime5 = /* #__PURE__ */ $cbbc8ce596810eef$export$a752bd756a1ddd62($38eb3af3d662147b$var$decodeJsonMaybe);
var $38eb3af3d662147b$var$wrapFormWidget13 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($2fd2989913f99c64$export$8777dc55d64e140)($2fd2989913f99c64$export$92b3581604414b0a);
var $38eb3af3d662147b$var$wrapFormWidget14 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($288e43cb19fd2375$export$e9014fcd4be488a9)($288e43cb19fd2375$export$73fa222918a29d85);
var $38eb3af3d662147b$var$wrapFormWidget15 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($5ad0c5cefd7afaff$export$5f42f100f752a07c)($5ad0c5cefd7afaff$export$1b344533d0e9e444);
var $38eb3af3d662147b$var$getField8 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($38eb3af3d662147b$var$decRNTY);
var $38eb3af3d662147b$var$getField9 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($e2b1be82a5e6d14f$export$fee2d5446387c54f);
var $38eb3af3d662147b$var$getField10 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($38eb3af3d662147b$var$decodeRecord);
var $38eb3af3d662147b$var$getField11 = /* #__PURE__ */ $cbbc8ce596810eef$export$2c9b3f539cb25b05($38eb3af3d662147b$var$decodeArray);
var $38eb3af3d662147b$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $38eb3af3d662147b$var$gqlQuery = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e55fea976989f772(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($38eb3af3d662147b$var$encRNTY)($eb7399d322077fcf$export$12b4d820b2ffc726)($38eb3af3d662147b$var$idIsSymbol)())());
var $38eb3af3d662147b$var$queryStringParams = /* #__PURE__ */ $42ad8b7b0d01e859$export$a68ddf4221613c1f($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $38eb3af3d662147b$var$areAllSelected = /* #__PURE__ */ $f264ceec36a478ad$export$b52fcdc078a891ae($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$export$b5859dd113079414 = function(ids) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("SetFormOrder")($38eb3af3d662147b$var$buildMutation("setUserOption")({
        input: $308f9765feb7633d$export$eb1b128a19ff6c25({
            form_type_order: ids
        })
    }));
};
var $38eb3af3d662147b$export$e326c404651add30 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFoldable) {
        var selectAll1 = $38eb3af3d662147b$var$selectAll(dictFoldable);
        return function(forms) {
            return function(select1) {
                return function(fpm) {
                    var forms$prime = map1(function(f) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f.id, f);
                    })(forms);
                    return selectAll1(forms$prime)(fpm)(select1);
                };
            };
        };
    };
};
var $38eb3af3d662147b$export$85cd10c12a07379 = function(form) {
    return function(fpm) {
        return $38eb3af3d662147b$var$select(form.id)(form)(fpm);
    };
};
var $38eb3af3d662147b$export$b3f328b498b77673 = function(form) {
    return function(fpm) {
        return $38eb3af3d662147b$var$isSelected(form.id)(fpm);
    };
};
var $38eb3af3d662147b$export$caf4852a1d506c02 = [
    "ID",
    "Hidden"
];
var $38eb3af3d662147b$export$5cdb7d20eeff1121 = function(obj) {
    return $06733ae99ed4f534$export$43db023a260c5e9f(true)($7d4cccdf062a2261$export$3a6c138b8d0f3874($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$bind($160716589b57c4ec$export$10fbded63f740d7b(obj))(function(v) {
        return $38eb3af3d662147b$var$getField(v)("type");
    }))(function(type$prime) {
        return $38eb3af3d662147b$var$pure(!$38eb3af3d662147b$var$elem(type$prime)($38eb3af3d662147b$export$caf4852a1d506c02));
    })));
};
var $38eb3af3d662147b$export$7ab4c2346038327c = /* #__PURE__ */ $f264ceec36a478ad$export$f9f1f4119b3df74($38eb3af3d662147b$var$ordRNTY);
var $38eb3af3d662147b$export$4d6b951c9f4ea02b = function(fields) {
    return "\x0a    id\x0a    type\x0a    abbr\x0a    bgColor\x0a    label\x0a    priority\x0a    signatures { " + ($995df59c0c2f7d8f$export$7e5519fad5fb9a1d + (" }\x0a    mutations {\x0a        create\x0a        update\x0a        delete\x0a    }\x0a    " + (function() {
        if (fields) return "fields";
        return "";
    }() + "\x0a")));
};
var $38eb3af3d662147b$export$7845e2e2018a871a = /* #__PURE__ */ function() {
    return "query { form_types" + ($38eb3af3d662147b$export$4d6b951c9f4ea02b(false) + "}");
}();
var $38eb3af3d662147b$export$a8d7826568b655d2 = /* #__PURE__ */ $a40b20519abba0fb$export$bc1f9bac519c56f6("FormTypeList")(/* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f($a40b20519abba0fb$export$bb525b50bfdf2bbc)($a40b20519abba0fb$export$fe891b8934c38330)())(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons1(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($38eb3af3d662147b$var$decodeRecord))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$fee2d5446387c54f))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($38eb3af3d662147b$var$decodeArray))(/* #__PURE__ */ $38eb3af3d662147b$var$gDecodeJsonCons2($38eb3af3d662147b$var$typeIsSymbol)()())($38eb3af3d662147b$var$signaturesIsSymbol)()())($38eb3af3d662147b$var$priorityIsSymbol)()())($38eb3af3d662147b$var$mutationsIsSymbol)()())($38eb3af3d662147b$var$labelIsSymbol)()())($38eb3af3d662147b$var$idIsSymbol)()())($38eb3af3d662147b$var$bgColorIsSymbol)()())($38eb3af3d662147b$var$abbrIsSymbol)()())()))(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $38eb3af3d662147b$var$rlhsCons($38eb3af3d662147b$var$typeIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$signaturesIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $38eb3af3d662147b$var$rlhsCons($38eb3af3d662147b$var$relationship_labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$emailLabelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $38eb3af3d662147b$var$rlhsCons($38eb3af3d662147b$var$useDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$saveDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$requestIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())()))()())($38eb3af3d662147b$var$priorityIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$mutationsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $38eb3af3d662147b$var$rlhsCons($38eb3af3d662147b$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($38eb3af3d662147b$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$bgColorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($38eb3af3d662147b$var$abbrIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())))("form_types")({}));
var $38eb3af3d662147b$export$8472cf4ca0d7e3d3 = $f264ceec36a478ad$export$6e22c362a0406a2c;
var $38eb3af3d662147b$export$681941b68d7905 = function(form) {
    return function(fpm) {
        return $38eb3af3d662147b$var$deselect(form.id)(fpm);
    };
};
var $38eb3af3d662147b$export$b73b93df8e4ad9b = function(context) {
    return function(json) {
        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(json)("fields"))(function(fields) {
            return $38eb3af3d662147b$var$map($fc8c1182ec2aefec$export$ee1b3e54f0441b22)($38eb3af3d662147b$var$traverse($38eb3af3d662147b$export$3d33a545c31a2dd1(context))($03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create)(fields)));
        });
    };
};
var $38eb3af3d662147b$export$3d33a545c31a2dd1 = function(context) {
    return function(v) {
        var id = function() {
            if (context instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return context.value0 + ("." + v.value0);
            if (context instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v.value0;
            throw new Error("Failed pattern match at API.FormType (line 186, column 10 - line 188, column 23): " + [
                context.constructor.name
            ]);
        }();
        var fromFS = function(v1) {
            return {
                id: id,
                workQueueLabel: v1.workQueueLabel
            };
        };
        var decodeFormSection = $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$bind($160716589b57c4ec$export$10fbded63f740d7b(v.value1))(function(v1) {
            return $38eb3af3d662147b$var$getField1(v1)("value");
        }))(function(value) {
            return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(value)("workQueueLabel"))("No Label"))(function(workQueueLabel) {
                return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime1(value)("section"))(false))(function(section) {
                    return $38eb3af3d662147b$var$pure({
                        value: value,
                        workQueueLabel: workQueueLabel,
                        section: section
                    });
                });
            });
        });
        var checkValidFormSection = function(fs) {
            return fs.section && fs.workQueueLabel !== "No Label";
        };
        var doDecode = $38eb3af3d662147b$var$bind(decodeFormSection)(function(fs) {
            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$b73b93df8e4ad9b(new $06733ae99ed4f534$export$8a67b48435b5d073(id))(fs.value))(function(subforms) {
                var $431 = checkValidFormSection(fs);
                if ($431) return $38eb3af3d662147b$var$pure([
                    $d2553f9ef1953d90$export$24f4fa641021c348(fromFS(fs))($38eb3af3d662147b$var$fromFoldable(subforms))
                ]);
                return $38eb3af3d662147b$var$pure(subforms);
            });
        });
        var matchSectionWidgets = function(v1) {
            if (v1 === "Label") return $38eb3af3d662147b$var$bind(decodeFormSection)(function(fs) {
                var $433 = checkValidFormSection(fs);
                if ($433) return $38eb3af3d662147b$var$pure([
                    $d2553f9ef1953d90$export$24f4fa641021c348(fromFS(fs))($38eb3af3d662147b$var$empty)
                ]);
                return $38eb3af3d662147b$var$pure([]);
            });
            if ($1a77d6934b592676$export$2344b14b097df817("SubForm")(v1)) return doDecode;
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $38eb3af3d662147b$var$pure([]);
            throw new Error("Failed pattern match at API.FormType (line 207, column 5 - line 212, column 25): " + [
                v1.constructor.name
            ]);
        };
        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$bind($160716589b57c4ec$export$10fbded63f740d7b(v.value1))(function(v1) {
            return $38eb3af3d662147b$var$getField(v1)("type");
        }))(function(type$prime) {
            return matchSectionWidgets(type$prime);
        });
    };
};
var $38eb3af3d662147b$export$2878e9683466086c = function(v) {
    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($160716589b57c4ec$export$10fbded63f740d7b(v.value1)))(function(obj) {
        return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField(obj)("type")))(function(type$prime) {
            return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField2(obj)("list")))(function(list) {
                var maybeLabel = $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField3(obj)("value"))($160716589b57c4ec$export$10fbded63f740d7b))(function(v1) {
                    return $38eb3af3d662147b$var$getField(v1)("label");
                });
                var label = function() {
                    if (maybeLabel instanceof $7d4cccdf062a2261$export$19db0165690c701a) return maybeLabel.value0;
                    if (maybeLabel instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "";
                    throw new Error("Failed pattern match at API.FormType (line 264, column 21 - line 266, column 29): " + [
                        maybeLabel.constructor.name
                    ]);
                }();
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$e4a904dfc5a7cde2(v.value0)(obj)(type$prime))(function(widget) {
                    if (list) return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget($b19cb68dd93bf4c1$export$18aeebbd4b820fd5({
                        id: $38eb3af3d662147b$var$getId(widget),
                        label: label,
                        template: widget,
                        cls: ""
                    })));
                    return $38eb3af3d662147b$var$pure(widget);
                });
            });
        });
    });
};
var $38eb3af3d662147b$export$e4a904dfc5a7cde2 = function(v) {
    return function(v1) {
        return function(v2) {
            if ($1a77d6934b592676$export$2344b14b097df817("SubForm")(v2)) return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField1(v1)("value")))(function(v3) {
                return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField2(v3)("section")))(function(section) {
                    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField2(v3)("collapsible")))(function(collapsible) {
                        return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField2(v3)("expanded")))(function(expanded) {
                            return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getFieldOptional$prime(v3)("label")))(function(label) {
                                var defaultLabelClass = function() {
                                    if (section) return "label-section";
                                    return "label-default";
                                }();
                                return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("labelClass"))(defaultLabelClass)))(function(labelClass) {
                                    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))("")))(function(cls) {
                                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$a36aabdeafffe7cb(v3))(function(fields) {
                                            var subform = {
                                                id: v,
                                                label: label,
                                                labelClass: labelClass,
                                                section: section,
                                                collapsible: collapsible,
                                                expanded: expanded,
                                                cls: cls,
                                                fields: fields
                                            };
                                            if (v2 === "SubForm") return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget1(subform));
                                            if (v2 === "StudentSubForm") return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget2(new $a9fb419bc59bee5b$export$b29794ea55b1711f(subform)));
                                            if (v2 === "EmployerSubForm") return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget3($c1dc5882e052ac14$export$6660c096f6acc06c(subform)));
                                            if (v2 === "CourseSubForm") return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget3($c1dc5882e052ac14$export$4411669f1fceaf16(subform)));
                                            return $54dae5ca6a6cd16d$export$15cc39a7848d0e13(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("type", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($38eb3af3d662147b$var$encodeJson(v2)))));
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });
            if ($1a77d6934b592676$export$2344b14b097df817("AutoFillSelect")(v2)) return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(value) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField4(value)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(value)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField5(value)("options"))(function(options) {
                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(value)("placeholder"))(function(placeholder) {
                                return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime2(value)("default"))($0e031af7428ef07d$export$dbafa4424a806c15("")))(function($$default) {
                                    return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget4($9ba897e5bccf1b3f$export$71821c1eec3657cc({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        options: options,
                                        placeholder: placeholder,
                                        value: new $06733ae99ed4f534$export$8a67b48435b5d073($$default)
                                    })));
                                });
                            });
                        });
                    });
                });
            }));
            if ($1a77d6934b592676$export$2344b14b097df817("Expectations")(v2)) return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField1(v1)("value")))(function(v3) {
                return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$getField(v3)("label")))(function(label) {
                    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))("")))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$a36aabdeafffe7cb(v3))(function(fields) {
                            var subform = {
                                id: v + "-entry",
                                label: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                                labelClass: "",
                                section: false,
                                collapsible: false,
                                expanded: true,
                                cls: cls,
                                fields: fields
                            };
                            return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13(function() {
                                if (v2 === "Expectations") return new $7d4cccdf062a2261$export$19db0165690c701a($c9a251dc3aa901f2$export$f97c0ae6299495bc);
                                if (v2 === "CourseExpectations") return new $7d4cccdf062a2261$export$19db0165690c701a($c9a251dc3aa901f2$export$f97c0ae6299495bc);
                                if (v2 === "EmployerExpectations") return new $7d4cccdf062a2261$export$19db0165690c701a($c9a251dc3aa901f2$export$b6d18be6fee5fadb);
                                return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("type", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($38eb3af3d662147b$var$encodeJson(v2))));
                            }()))(function(expectationsWidget) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a(expectationsWidget(subform)({
                                    id: v,
                                    label: label,
                                    cls: cls
                                }));
                            });
                        });
                    });
                });
            });
            if (v2 === "EmployerSelect") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime3(v1)("options"))($03b6b966974423fe$export$6e22c362a0406a2c))(function(options) {
                            return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime1(options)("contact"))(false))(function(contact) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget5($38dfaea68b931435$export$969bb0591ac6da53({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    contact: contact
                                })));
                            });
                        });
                    });
                });
            }));
            if (v2 === "Date") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(function(value) {
                            return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget6({
                                id: v,
                                label: label,
                                cls: cls,
                                value: $38eb3af3d662147b$var$bindFlipped($288e43cb19fd2375$export$6b862160d295c8e)(value)
                            }));
                        });
                    });
                });
            }));
            if (v2 === "Telephone") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("placeholder"))(function(placeholder) {
                            return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(""))(function(value) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget7({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    placeholder: placeholder,
                                    value: value
                                }));
                            });
                        });
                    });
                });
            }));
            if (v2 === "Radio") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField6(v3)("options"))(function(options) {
                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(function(value) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget8({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    options: options,
                                    value: value
                                }));
                            });
                        });
                    });
                });
            }));
            if (v2 === "Checkbox") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime1(v3)("default"))(false))(function(value) {
                            return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget9({
                                id: v,
                                label: label,
                                cls: cls,
                                legacy: $c045ea5df33bba60$export$6a0d13241802fe80("options")(v3),
                                value: value
                            }));
                        });
                    });
                });
            }));
            if (v2 === "Number") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("placeholder"))(function(placeholder) {
                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField7(v3)("step"))(function(step) {
                                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime4(v3)("default"))(function(value) {
                                    return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget10({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        step: step,
                                        placeholder: placeholder,
                                        value: value
                                    }));
                                });
                            });
                        });
                    });
                });
            }));
            if (v2 === "Label") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget11({
                            id: v,
                            label: label,
                            cls: cls
                        }));
                    });
                });
            }));
            if (v2 === "Text") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("placeholder"))(function(placeholder) {
                            return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(""))(function(value) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget12({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    placeholder: placeholder,
                                    value: value
                                }));
                            });
                        });
                    });
                });
            }));
            if (v2 === "Select") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(value) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField4(value)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(value)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField5(value)("options"))(function(options) {
                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(value)("placeholder"))(function(placeholder) {
                                return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime2(value)("default"))($0e031af7428ef07d$export$dbafa4424a806c15("")))(function($$default) {
                                    return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget4($9ba897e5bccf1b3f$export$71821c1eec3657cc({
                                        id: v,
                                        label: label,
                                        cls: cls,
                                        options: options,
                                        placeholder: placeholder,
                                        value: new $06733ae99ed4f534$export$8a67b48435b5d073($$default)
                                    })));
                                });
                            });
                        });
                    });
                });
            }));
            if (v2 === "TextArea") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime5(v3)("placeholder"))($06733ae99ed4f534$export$bebe9059409a0d04.value))(function(placeholder) {
                            return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(""))(function(value) {
                                return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget13({
                                    id: v,
                                    label: label,
                                    cls: cls,
                                    placeholder: placeholder,
                                    value: value
                                }));
                            });
                        });
                    });
                });
            }));
            if (v2 === "DateTime") return $54dae5ca6a6cd16d$export$15cc39a7848d0e13($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField1(v1)("value"))(function(v3) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(v3)("label"))(function(label) {
                    return $38eb3af3d662147b$var$bind($cbbc8ce596810eef$export$29d9133fafbd5114($38eb3af3d662147b$var$getFieldOptional$prime(v3)("class"))(""))(function(cls) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getFieldOptional$prime(v3)("default"))(function(value) {
                            return new $7d4cccdf062a2261$export$19db0165690c701a($38eb3af3d662147b$var$wrapFormWidget14({
                                id: v,
                                label: label,
                                cls: cls,
                                value: $38eb3af3d662147b$var$bindFlipped($35e75b0a064776f5$export$8b724767bfa64e7d)(value)
                            }));
                        });
                    });
                });
            }));
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$ef3eed12d06c0285(new $826fbbc6c8d1e9e2$export$26ae1106fd92d0a8("type", new $826fbbc6c8d1e9e2$export$35fbad60f29e98f2($38eb3af3d662147b$var$encodeJson(v2)))));
        };
    };
};
var $38eb3af3d662147b$export$a36aabdeafffe7cb = function(obj) {
    var handleParseErrors = function(v) {
        return function(v1) {
            return function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v2.value0);
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && $fecd5c800d519006$export$13633b34445fbb34) return $54dae5ca6a6cd16d$export$60030d78f255e2a6(new $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c("form widget " + v, v1))(new $7d4cccdf062a2261$export$37c4d04eafdc5515(v2.value0));
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $38eb3af3d662147b$var$pure($38eb3af3d662147b$var$wrapFormWidget15({
                    id: v,
                    err: v2.value0
                }));
                throw new Error("Failed pattern match at API.FormType (line 242, column 5 - line 246, column 45): " + [
                    v.constructor.name,
                    v1.constructor.name,
                    v2.constructor.name
                ]);
            };
        };
    };
    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$15cc39a7848d0e13($160716589b57c4ec$export$2c9b3f539cb25b05($160716589b57c4ec$export$10fbded63f740d7b)(obj)("fields")))(function(fields) {
        return $38eb3af3d662147b$var$traverse(function(v) {
            return handleParseErrors(v.value0)(v.value1)($38eb3af3d662147b$export$2878e9683466086c(v));
        })($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v) {
            return $38eb3af3d662147b$export$5cdb7d20eeff1121(v.value1);
        })($03b6b966974423fe$export$4b1360bff9337362($71f2e2e9476163f8$export$1908877435b1d5e9.create)(fields)));
    });
};
var $38eb3af3d662147b$export$a9be9b71671682ea = function(json) {
    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($160716589b57c4ec$export$10fbded63f740d7b(json)))(function(obj) {
        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$a36aabdeafffe7cb(obj))(function(fields) {
            return $54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField8(obj)("id"))(function(id) {
                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(obj)("type"))(function(type$prime) {
                    return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(obj)("abbr"))(function(abbr) {
                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(obj)("bgColor"))(function(bgColor) {
                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField(obj)("label"))(function(label) {
                                return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField9(obj)("priority"))(function(priority) {
                                    return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField10(obj)("mutations"))(function(mutations) {
                                        return $38eb3af3d662147b$var$bind($38eb3af3d662147b$var$getField11(obj)("signatures"))(function(signatures) {
                                            return $38eb3af3d662147b$var$bind($38eb3af3d662147b$export$b73b93df8e4ad9b($06733ae99ed4f534$export$bebe9059409a0d04.value)(obj))(function(sections$prime) {
                                                var workQueueLabel = function() {
                                                    var $461 = $38eb3af3d662147b$var$length(signatures) > 0;
                                                    if ($461) return $c3328e54cdf5154c$export$5a1a8430df9521e("preview-and-sign");
                                                    return $c3328e54cdf5154c$export$5a1a8430df9521e("preview");
                                                }();
                                                var sections = $396c4c3d9e7fae3c$export$c40cf5aab899f397(sections$prime)($d2553f9ef1953d90$export$24f4fa641021c348({
                                                    id: "signature-anchor",
                                                    workQueueLabel: workQueueLabel
                                                })($38eb3af3d662147b$var$empty));
                                                return $38eb3af3d662147b$var$pure({
                                                    id: id,
                                                    type: type$prime,
                                                    abbr: abbr,
                                                    bgColor: bgColor,
                                                    label: label,
                                                    priority: priority,
                                                    mutations: mutations,
                                                    fields: fields,
                                                    signatures: signatures,
                                                    sections: sections
                                                });
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            }));
        });
    });
};
var $38eb3af3d662147b$export$69d55760720d6b = function(json) {
    return $38eb3af3d662147b$var$bind($54dae5ca6a6cd16d$export$bc0012033e3e059a(json)($38eb3af3d662147b$var$bind($38eb3af3d662147b$var$bind($160716589b57c4ec$export$10fbded63f740d7b(json))(function(v) {
        return $38eb3af3d662147b$var$getField1(v)("data");
    }))(function(v) {
        return $38eb3af3d662147b$var$getField3(v)("form_type");
    })))(function(obj) {
        return $38eb3af3d662147b$export$a9be9b71671682ea(obj);
    });
};
var $38eb3af3d662147b$export$41e40bb888da6ec6 = function(id) {
    return $38eb3af3d662147b$var$gqlQuery("\x0aquery FormType" + ($38eb3af3d662147b$var$queryStringParams([
        "$id: ID!"
    ]) + (" {\x0a    form_type" + ($38eb3af3d662147b$var$queryStringParams([
        "id: $id"
    ]) + (" {\x0a        " + ($38eb3af3d662147b$export$4d6b951c9f4ea02b(true) + "\x0a    }\x0a}"))))))({
        id: id
    })($38eb3af3d662147b$export$69d55760720d6b);
};
var $38eb3af3d662147b$export$86c17563827efac6 = /* #__PURE__ */ function() {
    var $462 = $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($7c4f9de9dcfa2f59$export$eac5b5550745e6a0);
    return function($463) {
        return $462($38eb3af3d662147b$export$41e40bb888da6ec6($463));
    };
}();
var $38eb3af3d662147b$export$9b21d46ec278cbf3 = function(dictFunctor) {
    var map1 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(dictFoldable) {
        var $464 = $38eb3af3d662147b$var$areAllSelected(dictFoldable);
        var $465 = map1(function(v) {
            return v.id;
        });
        return function($466) {
            return $464($465($466));
        };
    };
};




























// Generated by purs version 0.15.16










var $4e23420f70d37f30$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $4e23420f70d37f30$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $4e23420f70d37f30$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($4e23420f70d37f30$var$ordRNTY);
var $4e23420f70d37f30$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $4e23420f70d37f30$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174()(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)()({
    reflectSymbol: function() {
        return "studentId";
    }
})($4e23420f70d37f30$var$ordRNTY))()({
    reflectSymbol: function() {
        return "formId";
    }
})($4e23420f70d37f30$var$ordRNTY))()({
    reflectSymbol: function() {
        return "documentId";
    }
})(/* #__PURE__ */ $06733ae99ed4f534$export$e35c29f98d259c46($4e23420f70d37f30$var$ordRNTY)));
var $4e23420f70d37f30$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($4e23420f70d37f30$var$ordRecord);
var $4e23420f70d37f30$var$filterKeys = /* #__PURE__ */ $ea3eb84de0acf574$export$151f9a87a7fd5652($4e23420f70d37f30$var$ordRecord);
var $4e23420f70d37f30$var$fromMaybe = /* #__PURE__ */ $cb5fedc2c4837e1c$export$43db023a260c5e9f($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $4e23420f70d37f30$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $4e23420f70d37f30$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $4e23420f70d37f30$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($4e23420f70d37f30$var$ordRNTY);
var $4e23420f70d37f30$var$insert1 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($4e23420f70d37f30$var$ordRecord);
var $4e23420f70d37f30$export$d4d400bf61f93a1 = function(student) {
    return function(docRef) {
        return $4e23420f70d37f30$var$eq(student)(docRef.studentId);
    };
};
var $4e23420f70d37f30$export$65b7d7c0ef4afca5 = function(form) {
    return function(docRef) {
        return $4e23420f70d37f30$var$eq(form)(docRef.formId);
    };
};
var $4e23420f70d37f30$export$bc79aa1aae6bd561 = function(dm) {
    return $ea3eb84de0acf574$export$68c286be0e7e55b7(dm.docs);
};
var $4e23420f70d37f30$export$7110cfa213548a07 = function(id) {
    return function(dm) {
        return $4e23420f70d37f30$var$lookup(id)(dm.docs);
    };
};
var $4e23420f70d37f30$export$d4012922cc3cd5ff = function(dl) {
    return function(dm) {
        return $4e23420f70d37f30$var$bind($4e23420f70d37f30$var$lookup1(dl)(dm.byLookup))(function(id) {
            return $4e23420f70d37f30$export$7110cfa213548a07(id)(dm);
        });
    };
};
var $4e23420f70d37f30$export$b36096da0c641f42 = function(student) {
    return function(form) {
        return function(dm) {
            return {
                docs: dm.docs,
                byLookup: $4e23420f70d37f30$var$filterKeys(function(docRef) {
                    return $4e23420f70d37f30$export$d4d400bf61f93a1(student)(docRef) && $4e23420f70d37f30$export$65b7d7c0ef4afca5(form)(docRef);
                })(dm.byLookup)
            };
        };
    };
};
var $4e23420f70d37f30$export$132b6b830bef5292 = function(student) {
    return function(dm) {
        var doLookup = function(id) {
            return $4e23420f70d37f30$var$lookup(id)(dm.docs);
        };
        return $396c4c3d9e7fae3c$export$c28c8388be0ab31a($4e23420f70d37f30$var$fromMaybe)($4e23420f70d37f30$var$fromFoldable($4e23420f70d37f30$var$map(doLookup)($ea3eb84de0acf574$export$68c286be0e7e55b7($4e23420f70d37f30$var$filterKeys($4e23420f70d37f30$export$d4d400bf61f93a1(student))(dm.byLookup)))));
    };
};
var $4e23420f70d37f30$export$d3cec2e51682fbf1 = {
    docs: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    byLookup: $ea3eb84de0acf574$export$6e22c362a0406a2c
};
var $4e23420f70d37f30$export$7f23b9dcc06ec09b = function(doc) {
    return {
        studentId: doc.student.id,
        formId: doc.formId,
        documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(doc.id)
    };
};
var $4e23420f70d37f30$export$c6cd097b64dd022c = function(doc) {
    return function(dm) {
        return {
            docs: $4e23420f70d37f30$var$insert(doc.id)(doc)(dm.docs),
            byLookup: $4e23420f70d37f30$var$insert1($4e23420f70d37f30$export$7f23b9dcc06ec09b(doc))(doc.id)(dm.byLookup)
        };
    };
};



// Generated by purs version 0.15.16











var $6415e24f7cd3b8e1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $6415e24f7cd3b8e1$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $6415e24f7cd3b8e1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $6415e24f7cd3b8e1$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $6415e24f7cd3b8e1$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($6415e24f7cd3b8e1$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6415e24f7cd3b8e1$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($6415e24f7cd3b8e1$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $6415e24f7cd3b8e1$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $6415e24f7cd3b8e1$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $6415e24f7cd3b8e1$export$2b4e43bb60e6e444 = /* #__PURE__ */ function() {
    return {
        allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-teacher")),
        deselectLabel: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-teacher-all"))
    };
}();
var $6415e24f7cd3b8e1$export$a284db4631b90b87 = /* #__PURE__ */ function() {
    return {
        allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-semester")),
        deselectLabel: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-semester-all"))
    };
}();
var $6415e24f7cd3b8e1$export$1b1982ff31b1b6cd = /* #__PURE__ */ function() {
    var $54 = $6415e24f7cd3b8e1$var$map(function(v) {
        return v.value;
    });
    return function($55) {
        return $54($7178b396566f5a79$export$127d1aaaa65102b1(function(v) {
            return v.teacher;
        }($55)));
    };
}();
var $6415e24f7cd3b8e1$export$647e9ec42ed605 = /* #__PURE__ */ function() {
    var $56 = $6415e24f7cd3b8e1$var$map(function(v) {
        return v.value;
    });
    return function($57) {
        return $56($7178b396566f5a79$export$127d1aaaa65102b1(function(v) {
            return v.semester;
        }($57)));
    };
}();
var $6415e24f7cd3b8e1$export$8ee687b169a7ffa7 = /* #__PURE__ */ function() {
    var $58 = $6415e24f7cd3b8e1$var$map(function(v) {
        return v.value;
    });
    return function($59) {
        return $58($7178b396566f5a79$export$127d1aaaa65102b1(function(v) {
            return v["class"];
        }($59)));
    };
}();
var $6415e24f7cd3b8e1$export$4bb0f1a01491086d = function(state) {
    return {
        teacher: $6415e24f7cd3b8e1$var$map(function(v) {
            return v.id;
        })($6415e24f7cd3b8e1$export$1b1982ff31b1b6cd(state)),
        "class": $6415e24f7cd3b8e1$var$map(function(v) {
            return v.id;
        })($6415e24f7cd3b8e1$export$8ee687b169a7ffa7(state)),
        semester: $6415e24f7cd3b8e1$var$map(function(v) {
            return v.semester;
        })($6415e24f7cd3b8e1$export$647e9ec42ed605(state)),
        search: function() {
            var $40 = state.keyword !== "";
            if ($40) return new $06733ae99ed4f534$export$8a67b48435b5d073(state.keyword);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }()
    };
};
var $6415e24f7cd3b8e1$export$952af3258ed45903 = function(q) {
    return $6415e24f7cd3b8e1$var$input([
        $fc1df90f0e252058$export$1741e49665a9c8e8("text"),
        $fc1df90f0e252058$export$2913c0c0b5623090("form-control search widget-input"),
        $fc1df90f0e252058$export$2ab9a8f9f1186f14(q),
        $6415e24f7cd3b8e1$var$map1($fc1df90f0e252058$export$b79fd9f386367d78)($fc1df90f0e252058$export$7fbc06d7c1beb512),
        $fc1df90f0e252058$export$df61b30b684217c0("search-search-input"),
        $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("search"))
    ]);
};
var $6415e24f7cd3b8e1$export$c227b65ca5911a1 = function(state) {
    return $6415e24f7cd3b8e1$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("search-form")
    ])([
        $6415e24f7cd3b8e1$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("search-selects")
        ])([
            $6415e24f7cd3b8e1$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("teacher-search-wrapper")
            ])([
                $6415e24f7cd3b8e1$var$label([
                    $fc1df90f0e252058$export$2913c0c0b5623090("teacher-search-label"),
                    $fc1df90f0e252058$export$35d9e1c947946090("teacher")
                ])([
                    $6415e24f7cd3b8e1$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("teacher"))
                ]),
                $6415e24f7cd3b8e1$var$map2(function(v) {
                    return {
                        "class": state["class"],
                        keyword: state.keyword,
                        semester: state.semester,
                        teacher: v
                    };
                })($7178b396566f5a79$export$54b124386ef5abe3(state.teacher))
            ]),
            $6415e24f7cd3b8e1$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("semester-search-wrapper")
            ])([
                $6415e24f7cd3b8e1$var$label([
                    $fc1df90f0e252058$export$2913c0c0b5623090("semester-search-label"),
                    $fc1df90f0e252058$export$35d9e1c947946090("semester")
                ])([
                    $6415e24f7cd3b8e1$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("semester"))
                ]),
                $6415e24f7cd3b8e1$var$map2(function(v) {
                    return {
                        "class": state["class"],
                        keyword: state.keyword,
                        teacher: state.teacher,
                        semester: v
                    };
                })($7178b396566f5a79$export$54b124386ef5abe3(state.semester))
            ]),
            $6415e24f7cd3b8e1$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("class-search-wrapper")
            ])([
                $6415e24f7cd3b8e1$var$label([
                    $fc1df90f0e252058$export$2913c0c0b5623090("class-search-label"),
                    $fc1df90f0e252058$export$35d9e1c947946090("class")
                ])([
                    $6415e24f7cd3b8e1$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("class"))
                ]),
                $6415e24f7cd3b8e1$var$map2(function(v) {
                    return {
                        keyword: state.keyword,
                        semester: state.semester,
                        teacher: state.teacher,
                        "class": v
                    };
                })($7178b396566f5a79$export$54b124386ef5abe3(state["class"]))
            ])
        ]),
        $6415e24f7cd3b8e1$var$map2(function(v) {
            return {
                "class": state["class"],
                semester: state.semester,
                teacher: state.teacher,
                keyword: v
            };
        })($6415e24f7cd3b8e1$export$952af3258ed45903(state.keyword))
    ]);
};
var $6415e24f7cd3b8e1$export$2943524994da7a64 = function(v) {
    return $06733ae99ed4f534$export$c15bd07a493e1236($7178b396566f5a79$export$127d1aaaa65102b1(v.teacher)) || $06733ae99ed4f534$export$c15bd07a493e1236($7178b396566f5a79$export$127d1aaaa65102b1(v.semester)) || $06733ae99ed4f534$export$c15bd07a493e1236($7178b396566f5a79$export$127d1aaaa65102b1(v["class"])) || $3ee2158c14339cc9$export$f24224f1c91d8156(v.keyword) > 0;
};
var $6415e24f7cd3b8e1$export$a4d470139b4c323d = /* #__PURE__ */ function() {
    return {
        allowDeselect: $7178b396566f5a79$export$f52b68eea1d2c257.allowDeselect,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-class")),
        deselectLabel: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-class-all"))
    };
}();
var $6415e24f7cd3b8e1$export$5c89bef3d5bb8108 = {
    teacher: /* #__PURE__ */ $7178b396566f5a79$export$d967f07ae6c72524("teacher")($dc9dc2b43b9526de$export$4cc3c70d62d7a856)($6415e24f7cd3b8e1$export$2b4e43bb60e6e444),
    semester: /* #__PURE__ */ $7178b396566f5a79$export$d967f07ae6c72524("semester")($dc9dc2b43b9526de$export$930f503bd2cd157b)($6415e24f7cd3b8e1$export$a284db4631b90b87),
    "class": /* #__PURE__ */ $7178b396566f5a79$export$d967f07ae6c72524("class")($dc9dc2b43b9526de$export$160b36955a0d614c)($6415e24f7cd3b8e1$export$a4d470139b4c323d),
    keyword: ""
};
var $6415e24f7cd3b8e1$export$e8f8fb794a7ce0ae = function(v) {
    var teachers$prime = $7178b396566f5a79$export$3c67486d569ff2eb(function(v1) {
        return v1.name;
    })(v.teachers);
    var semesters$prime = $7178b396566f5a79$export$3c67486d569ff2eb(function(v1) {
        return v1.name;
    })(v.semesters);
    var classes$prime = $7178b396566f5a79$export$3c67486d569ff2eb(function(v1) {
        return v1.name;
    })(v.classes);
    return {
        keyword: $6415e24f7cd3b8e1$export$5c89bef3d5bb8108.keyword,
        teacher: $7178b396566f5a79$export$5a4818cec1656a71($7178b396566f5a79$export$ec474c92c8f2413d($6415e24f7cd3b8e1$export$5c89bef3d5bb8108.teacher)(teachers$prime))($6415e24f7cd3b8e1$var$map(function(v2) {
            return {
                label: v2.name,
                value: v2
            };
        })(v.defaults.teacher)),
        semester: $7178b396566f5a79$export$5a4818cec1656a71($7178b396566f5a79$export$ec474c92c8f2413d($6415e24f7cd3b8e1$export$5c89bef3d5bb8108.semester)(semesters$prime))($6415e24f7cd3b8e1$var$map(function(v2) {
            return {
                label: v2.name,
                value: v2
            };
        })(v.defaults.semester)),
        "class": $7178b396566f5a79$export$5a4818cec1656a71($7178b396566f5a79$export$ec474c92c8f2413d($6415e24f7cd3b8e1$export$5c89bef3d5bb8108["class"])(classes$prime))($6415e24f7cd3b8e1$var$map(function(v2) {
            return {
                label: v2.name,
                value: v2
            };
        })(v.defaults.group))
    };
};


var $740d96ccf08cc464$var$getQuery = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$71eec30d9db46a56($7c4f9de9dcfa2f59$export$48568730318ad8ae);
var $740d96ccf08cc464$var$getQuery1 = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$71eec30d9db46a56($a40b20519abba0fb$export$c6b405b39190b469);
var $740d96ccf08cc464$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $740d96ccf08cc464$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $740d96ccf08cc464$var$multiQuery_ = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$30df5e01129e087c()(/* #__PURE__ */ $7c4f9de9dcfa2f59$export$7cf6fb124ade4099(/* #__PURE__ */ $7c4f9de9dcfa2f59$export$7cf6fb124ade4099($7c4f9de9dcfa2f59$export$936ce2b08175dfd0)({
    reflectSymbol: function() {
        return "searchData";
    }
})()()()()($aa35c333414e4a9b$export$7a26e05e222ff2dc))({
    reflectSymbol: function() {
        return "account";
    }
})()()()()($a40b20519abba0fb$export$c6b405b39190b469));
var $740d96ccf08cc464$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $740d96ccf08cc464$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $740d96ccf08cc464$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $740d96ccf08cc464$var$runGraphQL_ = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$d1b23fba9f6872eb($a40b20519abba0fb$export$fe526d00b95b6f09);
var $740d96ccf08cc464$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $740d96ccf08cc464$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $740d96ccf08cc464$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab($06733ae99ed4f534$export$a22c94fdeac581ff);
var $740d96ccf08cc464$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $740d96ccf08cc464$var$getDecode = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($7c4f9de9dcfa2f59$export$48568730318ad8ae);
var $740d96ccf08cc464$var$getDecode1 = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($a40b20519abba0fb$export$c6b405b39190b469);
var $740d96ccf08cc464$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $740d96ccf08cc464$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $740d96ccf08cc464$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $740d96ccf08cc464$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $740d96ccf08cc464$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$fromFoldable1 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075)($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $740d96ccf08cc464$var$fromFoldable2 = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$fromFoldable3 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $740d96ccf08cc464$var$union = /* #__PURE__ */ $a393155e52307a24$export$971dd5b0dfd021b6($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$member = /* #__PURE__ */ $ea3eb84de0acf574$export$6a0d13241802fe80($740d96ccf08cc464$var$ordRNTY);
var $740d96ccf08cc464$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $740d96ccf08cc464$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $740d96ccf08cc464$var$Step3FormTypeResult = /* #__PURE__ */ function() {
    function Step3FormTypeResult(value0) {
        this.value0 = value0;
    }
    Step3FormTypeResult.create = function(value0) {
        return new Step3FormTypeResult(value0);
    };
    return Step3FormTypeResult;
}();
var $740d96ccf08cc464$var$Step3DocumentResult = /* #__PURE__ */ function() {
    function Step3DocumentResult(value0) {
        this.value0 = value0;
    }
    Step3DocumentResult.create = function(value0) {
        return new Step3DocumentResult(value0);
    };
    return Step3DocumentResult;
}();
var $740d96ccf08cc464$var$Step3FormTypeQuery = /* #__PURE__ */ function() {
    function Step3FormTypeQuery(value0) {
        this.value0 = value0;
    }
    Step3FormTypeQuery.create = function(value0) {
        return new Step3FormTypeQuery(value0);
    };
    return Step3FormTypeQuery;
}();
var $740d96ccf08cc464$var$Step3DocumentQuery = /* #__PURE__ */ function() {
    function Step3DocumentQuery(value0) {
        this.value0 = value0;
    }
    Step3DocumentQuery.create = function(value0) {
        return new Step3DocumentQuery(value0);
    };
    return Step3DocumentQuery;
}();
var $740d96ccf08cc464$var$step3PreloadRequest = function(v) {
    if (v instanceof $740d96ccf08cc464$var$Step3FormTypeQuery) return $740d96ccf08cc464$var$getQuery(v.value0);
    if (v instanceof $740d96ccf08cc464$var$Step3DocumentQuery) return $740d96ccf08cc464$var$getQuery1(v.value0);
    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 204, column 23 - line 206, column 47): " + [
        v.constructor.name
    ]);
};
var $740d96ccf08cc464$var$matchesRecentFormLookup = function(lookup1) {
    return function(recentForm) {
        if (lookup1.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $740d96ccf08cc464$var$eq(recentForm.id)(lookup1.documentId.value0);
        if (lookup1.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $740d96ccf08cc464$var$eq(recentForm.student.id)(lookup1.studentId) && $740d96ccf08cc464$var$eq(recentForm.form_type.id)(lookup1.formId);
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 246, column 45 - line 250, column 56): " + [
            lookup1.documentId.constructor.name
        ]);
    };
};
var $740d96ccf08cc464$var$matchesDocumentLookup = function(lookup1) {
    return function(doc) {
        if (lookup1.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $740d96ccf08cc464$var$eq(doc.id)(lookup1.documentId.value0);
        if (lookup1.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $740d96ccf08cc464$var$eq(doc.student.id)(lookup1.studentId) && $740d96ccf08cc464$var$eq(doc.formId)(lookup1.formId);
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 239, column 36 - line 243, column 43): " + [
            lookup1.documentId.constructor.name
        ]);
    };
};
var $740d96ccf08cc464$export$1a8dbcadbc933b67 = function(state) {
    return function(ui) {
        return function(cache) {
            return $d2284b2d3e1b6f87$export$8291c2122093ac93($740d96ccf08cc464$var$bind($740d96ccf08cc464$var$multiQuery_({
                account: $02eacf321b2a2128$export$e4a393ea5d58ca7a,
                searchData: $dc9dc2b43b9526de$export$49a857040325da19
            }))(function(v) {
                var defTeacher = $740d96ccf08cc464$var$map(function(v1) {
                    return {
                        label: v1.name,
                        value: v1
                    };
                })(v.searchData.defaults.teacher);
                var defSemester = $740d96ccf08cc464$var$map(function(v1) {
                    return {
                        label: v1.name,
                        value: v1
                    };
                })(v.searchData.defaults.semester);
                var ui$prime = {
                    expandedStudents: ui.expandedStudents,
                    teacher: $7178b396566f5a79$export$5a4818cec1656a71(ui.teacher)(defTeacher),
                    semester: $7178b396566f5a79$export$5a4818cec1656a71(ui.semester)(defSemester),
                    search: $6415e24f7cd3b8e1$export$e8f8fb794a7ce0ae(v.searchData)
                };
                return $740d96ccf08cc464$var$pure({
                    state: {
                        currentDoc: state.currentDoc,
                        documents: state.documents,
                        editDocs: state.editDocs,
                        forms: state.forms,
                        students: state.students,
                        teacher: $740d96ccf08cc464$var$map(function(v2) {
                            return v2.value;
                        })($7178b396566f5a79$export$127d1aaaa65102b1(ui$prime.teacher)),
                        semester: $740d96ccf08cc464$var$map(function(v2) {
                            return v2.value;
                        })($7178b396566f5a79$export$127d1aaaa65102b1(ui$prime.semester))
                    },
                    ui: ui$prime,
                    cache: {
                        formCache: cache.formCache,
                        loaded: cache.loaded,
                        account: v.account,
                        defTeacher: defTeacher,
                        defSemester: defSemester,
                        searchData: v.searchData
                    }
                });
            }));
        };
    };
};
var $740d96ccf08cc464$export$7e7c75a767493528 = function(state) {
    return function(ui) {
        return function(cache) {
            if (cache.loaded) return $740d96ccf08cc464$var$pure1(new $7d4cccdf062a2261$export$19db0165690c701a({
                state: state,
                ui: ui,
                cache: cache
            }));
            return $740d96ccf08cc464$export$1a8dbcadbc933b67(state)(ui)(cache);
        };
    };
};
var $740d96ccf08cc464$export$2b433fd4c99efbc7 = function(doc) {
    return function(state) {
        return {
            forms: state.forms,
            students: state.students,
            editDocs: state.editDocs,
            currentDoc: state.currentDoc,
            semester: state.semester,
            teacher: state.teacher,
            documents: $4e23420f70d37f30$export$c6cd097b64dd022c(doc)(state.documents)
        };
    };
};
var $740d96ccf08cc464$export$e0c61fcff97552d3 = function(state) {
    return function(ftype) {
        return function(args) {
            return $740d96ccf08cc464$var$bind($740d96ccf08cc464$var$runGraphQL_($d4a8d5b15f9925c4$export$37330def6e48b4c9(ftype)(args)))(function(doc) {
                var newState = $740d96ccf08cc464$export$2b433fd4c99efbc7(doc)(state);
                return $740d96ccf08cc464$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(newState, doc));
            });
        };
    };
};
var $740d96ccf08cc464$export$7188e7e84cf4c0b3 = /* #__PURE__ */ function() {
    return {
        account: {
            type: $02eacf321b2a2128$export$6f3aad56498a7cb9.value,
            student: $06733ae99ed4f534$export$bebe9059409a0d04.value
        },
        searchData: $dc9dc2b43b9526de$export$8ba11d1b9ad0431b,
        defTeacher: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        defSemester: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        formCache: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        loaded: false
    };
}();
var $740d96ccf08cc464$export$7fa7b5aadee7e69a = function(cache) {
    return function(formId) {
        return $740d96ccf08cc464$var$lookup(formId)(cache.formCache);
    };
};
var $740d96ccf08cc464$export$830c804e8d921bba = function(state) {
    return function(id) {
        return $38eb3af3d662147b$export$7ab4c2346038327c(id)(state.forms);
    };
};
var $740d96ccf08cc464$export$f65ca476c09acec0 = function(state) {
    return function(ftype) {
        return function(docId) {
            return $740d96ccf08cc464$var$bind($740d96ccf08cc464$var$runGraphQL_($d4a8d5b15f9925c4$export$177dade20c6c5e4f(ftype)(docId)))(function(doc) {
                var newState = $740d96ccf08cc464$export$2b433fd4c99efbc7(doc)(state);
                return $740d96ccf08cc464$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(newState, doc));
            });
        };
    };
};
var $740d96ccf08cc464$export$30606e16463b30d9 = function(state) {
    return function(dl) {
        var loadedDocs = $740d96ccf08cc464$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(state.documents));
        if (dl.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4e23420f70d37f30$export$7110cfa213548a07(dl.documentId.value0)(state.documents);
        if (dl.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $740d96ccf08cc464$var$alt($4e23420f70d37f30$export$d4012922cc3cd5ff(dl)(state.documents))($396c4c3d9e7fae3c$export$71aa6c912b956294($740d96ccf08cc464$var$matchesDocumentLookup(dl))(loadedDocs));
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 223, column 5 - line 227, column 97): " + [
            dl.documentId.constructor.name
        ]);
    };
};
var $740d96ccf08cc464$export$b0d0217938b59855 = function(state) {
    return function(lookup1) {
        var recentFormLocked = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function($101) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
                return v.locked_at;
            }($101));
        })($396c4c3d9e7fae3c$export$71aa6c912b956294($740d96ccf08cc464$var$matchesRecentFormLookup(lookup1))(state.editDocs));
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(recentFormLocked)(function($102) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
                return v.locked_at;
            }($102));
        })($740d96ccf08cc464$export$30606e16463b30d9(state)(lookup1));
    };
};
var $740d96ccf08cc464$export$11eb3b5ef9574821 = function(state) {
    return function(id) {
        return $4e23420f70d37f30$export$7110cfa213548a07(id)(state.documents);
    };
};
var $740d96ccf08cc464$var$decodeStep3PreloadQuery = function(query) {
    return function(json) {
        if (query instanceof $740d96ccf08cc464$var$Step3FormTypeQuery) return $740d96ccf08cc464$var$map1($740d96ccf08cc464$var$Step3FormTypeResult.create)($740d96ccf08cc464$var$getDecode(query.value0)(json));
        if (query instanceof $740d96ccf08cc464$var$Step3DocumentQuery) return $740d96ccf08cc464$var$map1($740d96ccf08cc464$var$Step3DocumentResult.create)($740d96ccf08cc464$var$getDecode1(query.value0)(json));
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 209, column 38 - line 213, column 55): " + [
            query.constructor.name
        ]);
    };
};
var $740d96ccf08cc464$var$collectPreloadedStep3Resources = function(acc) {
    return function(v) {
        if (v instanceof $740d96ccf08cc464$var$Step3FormTypeResult) return {
            documents: acc.documents,
            formTypes: $396c4c3d9e7fae3c$export$c40cf5aab899f397(acc.formTypes)(v.value0)
        };
        if (v instanceof $740d96ccf08cc464$var$Step3DocumentResult) return {
            formTypes: acc.formTypes,
            documents: $396c4c3d9e7fae3c$export$c40cf5aab899f397(acc.documents)(v.value0)
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 279, column 38 - line 283, column 55): " + [
            v.constructor.name
        ]);
    };
};
var $740d96ccf08cc464$var$runStep3PreloadQueries = function(queries) {
    if ($396c4c3d9e7fae3c$export$7b1b591b262c240(queries)) return $740d96ccf08cc464$var$pure({
        formTypes: [],
        documents: []
    });
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $740d96ccf08cc464$var$bind($7c4f9de9dcfa2f59$export$7efd4163d8775bbe($740d96ccf08cc464$var$map2($740d96ccf08cc464$var$step3PreloadRequest)(queries)))(function(responses) {
        return $740d96ccf08cc464$var$bind($740d96ccf08cc464$var$except($740d96ccf08cc464$var$sequence($396c4c3d9e7fae3c$export$b634740ce272acb5($740d96ccf08cc464$var$decodeStep3PreloadQuery)(queries)(responses))))(function(decoded) {
            return $740d96ccf08cc464$var$pure($740d96ccf08cc464$var$foldl($740d96ccf08cc464$var$collectPreloadedStep3Resources)({
                formTypes: [],
                documents: []
            })(decoded));
        });
    });
    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 193, column 1 - line 195, column 93): " + [
        queries.constructor.name
    ]);
};
var $740d96ccf08cc464$export$a5bc1fd82f921349 = function(state) {
    return function(cache) {
        return function(maybeFtype) {
            return function(maybeDoc) {
                var seedPreload = function(state$prime) {
                    return function(cache$prime) {
                        return function(maybeFtype$prime) {
                            return function(maybeDoc$prime) {
                                var withFormType = function() {
                                    if (maybeFtype$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return cache$prime;
                                    if (maybeFtype$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                                        account: cache$prime.account,
                                        defSemester: cache$prime.defSemester,
                                        defTeacher: cache$prime.defTeacher,
                                        loaded: cache$prime.loaded,
                                        searchData: cache$prime.searchData,
                                        formCache: $740d96ccf08cc464$var$insert(maybeFtype$prime.value0.id)(maybeFtype$prime.value0)(cache$prime.formCache)
                                    };
                                    throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 164, column 28 - line 166, column 96): " + [
                                        maybeFtype$prime.constructor.name
                                    ]);
                                }();
                                if (maybeDoc$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                                    state: state$prime,
                                    cache: withFormType
                                };
                                if (maybeDoc$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                                    state: $740d96ccf08cc464$export$2b433fd4c99efbc7(maybeDoc$prime.value0)(state$prime),
                                    cache: withFormType
                                };
                                throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 167, column 12 - line 169, column 82): " + [
                                    maybeDoc$prime.constructor.name
                                ]);
                            };
                        };
                    };
                };
                var currentDocumentQuery = function(state$prime) {
                    return function(maybeDoc$prime) {
                        if (maybeDoc$prime instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        if (maybeDoc$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && state$prime.currentDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            var $99 = $06733ae99ed4f534$export$c15bd07a493e1236($740d96ccf08cc464$export$30606e16463b30d9(state$prime)(state$prime.currentDoc.value0));
                            if ($99) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            return $740d96ccf08cc464$var$map(function(recentForm) {
                                return new $740d96ccf08cc464$var$Step3DocumentQuery($d4a8d5b15f9925c4$export$177dade20c6c5e4f(recentForm.form_type)(recentForm.id));
                            })($396c4c3d9e7fae3c$export$71aa6c912b956294($740d96ccf08cc464$var$matchesRecentFormLookup(state$prime.currentDoc.value0))(state$prime.editDocs));
                        }
                        if (maybeDoc$prime instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && state$prime.currentDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Steps.WorkQueue.Cache (line 172, column 45 - line 183, column 20): " + [
                            maybeDoc$prime.constructor.name,
                            state$prime.currentDoc.constructor.name
                        ]);
                    };
                };
                var ftypesSel = $740d96ccf08cc464$var$fromFoldable1($740d96ccf08cc464$var$map3(function(v) {
                    return v.id;
                })($f264ceec36a478ad$export$7693e0a1b9351086(state.forms)));
                var ftypesEdit = $740d96ccf08cc464$var$fromFoldable2($740d96ccf08cc464$var$map2(function(v) {
                    return v.form_type.id;
                })(state.editDocs));
                var seeded = seedPreload(state)(cache)(maybeFtype)(maybeDoc);
                var ftypeIds = $740d96ccf08cc464$var$fromFoldable3($740d96ccf08cc464$var$union(ftypesSel)(ftypesEdit));
                var missingFtypeIds = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(id) {
                    return !$740d96ccf08cc464$var$member(id)(seeded.cache.formCache);
                })(ftypeIds);
                var currentDocQuery = currentDocumentQuery(seeded.state)(maybeDoc);
                var preloadQueries = $740d96ccf08cc464$var$append($740d96ccf08cc464$var$map2(function($103) {
                    return $740d96ccf08cc464$var$Step3FormTypeQuery.create($38eb3af3d662147b$export$41e40bb888da6ec6($103));
                })(missingFtypeIds))($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])(function(query) {
                    return [
                        query
                    ];
                })(currentDocQuery));
                return $740d96ccf08cc464$var$bind($740d96ccf08cc464$var$runStep3PreloadQueries(preloadQueries))(function(preload) {
                    var formCache = $740d96ccf08cc464$var$foldr(function(f) {
                        return function(m) {
                            return $740d96ccf08cc464$var$insert(f.id)(f)(m);
                        };
                    })(seeded.cache.formCache)(preload.formTypes);
                    return $740d96ccf08cc464$var$pure({
                        state: $740d96ccf08cc464$var$foldl($f57f4b701aa7b66e$export$8a83211c878a3f1f($740d96ccf08cc464$export$2b433fd4c99efbc7))(seeded.state)(preload.documents),
                        cache: {
                            account: seeded.cache.account,
                            defSemester: seeded.cache.defSemester,
                            defTeacher: seeded.cache.defTeacher,
                            loaded: seeded.cache.loaded,
                            searchData: seeded.cache.searchData,
                            formCache: formCache
                        }
                    });
                });
            };
        };
    };
};



var $daa993e9fe4182d9$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $daa993e9fe4182d9$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $daa993e9fe4182d9$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $daa993e9fe4182d9$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $daa993e9fe4182d9$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $daa993e9fe4182d9$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($37b880af5f4991bd$export$fa624555ca2acbc8);
var $daa993e9fe4182d9$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $daa993e9fe4182d9$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404(/* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a));
var $daa993e9fe4182d9$var$nub1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404($97937c29f879e68e$export$c5f2758e49b2b86a);
var $daa993e9fe4182d9$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $daa993e9fe4182d9$export$78a3b81d9f3ae6d8 = /* #__PURE__ */ function() {
    function SectionUnspecified() {}
    SectionUnspecified.value = new SectionUnspecified();
    return SectionUnspecified;
}();
var $daa993e9fe4182d9$export$37a45811bf45ea95 = /* #__PURE__ */ function() {
    function SectionClear() {}
    SectionClear.value = new SectionClear();
    return SectionClear;
}();
var $daa993e9fe4182d9$export$28a5869e6b717ab = /* #__PURE__ */ function() {
    function SectionSet(value0) {
        this.value0 = value0;
    }
    SectionSet.create = function(value0) {
        return new SectionSet(value0);
    };
    return SectionSet;
}();
var $daa993e9fe4182d9$export$805d1d5d7685fdfb = function(x) {
    return x;
};
var $daa993e9fe4182d9$export$61045fda02b7f5d8 = /* #__PURE__ */ function() {
    function RHome(value0) {
        this.value0 = value0;
    }
    RHome.create = function(value0) {
        return new RHome(value0);
    };
    return RHome;
}();
var $daa993e9fe4182d9$export$a56647213ddc793 = /* #__PURE__ */ function() {
    function RStep2A(value0) {
        this.value0 = value0;
    }
    RStep2A.create = function(value0) {
        return new RStep2A(value0);
    };
    return RStep2A;
}();
var $daa993e9fe4182d9$export$27668ebed3f7ff2f = /* #__PURE__ */ function() {
    function RStep2B(value0) {
        this.value0 = value0;
    }
    RStep2B.create = function(value0) {
        return new RStep2B(value0);
    };
    return RStep2B;
}();
var $daa993e9fe4182d9$export$6fd638f4ca7cd326 = /* #__PURE__ */ function() {
    function RStep3(value0) {
        this.value0 = value0;
    }
    RStep3.create = function(value0) {
        return new RStep3(value0);
    };
    return RStep3;
}();
var $daa993e9fe4182d9$export$841721583836380d = /* #__PURE__ */ function() {
    function RPreview(value0) {
        this.value0 = value0;
    }
    RPreview.create = function(value0) {
        return new RPreview(value0);
    };
    return RPreview;
}();
var $daa993e9fe4182d9$export$74b04faccbc8c7c1 = /* #__PURE__ */ function() {
    function RTestForm(value0) {
        this.value0 = value0;
    }
    RTestForm.create = function(value0) {
        return new RTestForm(value0);
    };
    return RTestForm;
}();
var $daa993e9fe4182d9$var$step3DocPath = function(path) {
    return $daa993e9fe4182d9$var$bind($1a77d6934b592676$export$71c2a1babd78d286("/step3/")(path))(function(docPart) {
        var $40 = $22d4f8ab6946d33a$export$7b1b591b262c240(docPart) || $1a77d6934b592676$export$2344b14b097df817("/")(docPart);
        if ($40) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return new $06733ae99ed4f534$export$8a67b48435b5d073($308f9765feb7633d$export$a7f53fa461221c79(docPart));
    });
};
var $daa993e9fe4182d9$var$step3ActiveDocId = function(workQ) {
    return $daa993e9fe4182d9$var$bind(workQ.currentDoc)(function(lookup) {
        if (lookup.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(lookup.documentId.value0);
        if (lookup.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $daa993e9fe4182d9$var$map(function(v) {
            return v.id;
        })($740d96ccf08cc464$export$30606e16463b30d9(workQ)(lookup));
        throw new Error("Failed pattern match at App.Route (line 294, column 5 - line 296, column 57): " + [
            lookup.documentId.constructor.name
        ]);
    });
};
var $daa993e9fe4182d9$var$routedParams = [
    "forms",
    "students",
    "docs"
];
var $daa993e9fe4182d9$export$6a8419b6e6434081 = function(v) {
    if (v instanceof $daa993e9fe4182d9$export$61045fda02b7f5d8) return $994495db3cff0a67$export$317e7082611cb548.value;
    if (v instanceof $daa993e9fe4182d9$export$a56647213ddc793) return $994495db3cff0a67$export$d02ce3ec9b5b8f12.value;
    if (v instanceof $daa993e9fe4182d9$export$27668ebed3f7ff2f) return $994495db3cff0a67$export$d80ca78eabef93e4.value;
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $994495db3cff0a67$export$d8ccc25b3be9c9d7.value;
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $994495db3cff0a67$export$db36463848ed68bd(v.value0.activeDoc.value0);
    if (v instanceof $daa993e9fe4182d9$export$841721583836380d) return new $994495db3cff0a67$export$133773870222880f(v.value0.index);
    if (v instanceof $daa993e9fe4182d9$export$74b04faccbc8c7c1) return $994495db3cff0a67$export$e3f45034ca213b36.value;
    throw new Error("Failed pattern match at App.Route (line 105, column 15 - line 112, column 28): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$export$d9c77bcd2adc543c = function(v) {
    if (v instanceof $daa993e9fe4182d9$export$61045fda02b7f5d8) return "Home";
    if (v instanceof $daa993e9fe4182d9$export$a56647213ddc793) return "Step2A";
    if (v instanceof $daa993e9fe4182d9$export$27668ebed3f7ff2f) return "Step2B";
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Step3";
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "Step3:" + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0.activeDoc.value0);
    if (v instanceof $daa993e9fe4182d9$export$841721583836380d) return "Preview:" + $daa993e9fe4182d9$var$show(v.value0.index);
    if (v instanceof $daa993e9fe4182d9$export$74b04faccbc8c7c1) return "TestForm";
    throw new Error("Failed pattern match at App.Route (line 95, column 12 - line 102, column 30): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$export$a77afe655e44fe22 = function(v) {
    if (v instanceof $daa993e9fe4182d9$export$61045fda02b7f5d8) return v.value0.preservedQuery;
    if (v instanceof $daa993e9fe4182d9$export$a56647213ddc793) return v.value0.preservedQuery;
    if (v instanceof $daa993e9fe4182d9$export$27668ebed3f7ff2f) return v.value0.preservedQuery;
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326) return v.value0.preservedQuery;
    if (v instanceof $daa993e9fe4182d9$export$841721583836380d) return v.value0.preservedQuery;
    if (v instanceof $daa993e9fe4182d9$export$74b04faccbc8c7c1) return v.value0;
    throw new Error("Failed pattern match at App.Route (line 115, column 23 - line 121, column 47): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$var$renderHash = function(v) {
    if (v instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return "#" + v.value0;
    if (v instanceof $daa993e9fe4182d9$export$37a45811bf45ea95) return "";
    if (v instanceof $daa993e9fe4182d9$export$78a3b81d9f3ae6d8) return "";
    throw new Error("Failed pattern match at App.Route (line 228, column 14 - line 231, column 29): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$export$6d84eebdb90be73d = /* #__PURE__ */ $06733ae99ed4f534$export$f8b8b9ce72e9ccbf("")(function($140) {
    return $daa993e9fe4182d9$var$renderHash($daa993e9fe4182d9$export$28a5869e6b717ab.create($140));
});
var $daa993e9fe4182d9$var$previewPath = function(path) {
    return $daa993e9fe4182d9$var$bind($1a77d6934b592676$export$71c2a1babd78d286("/preview/")(path))(function(indexPart) {
        return $8d5664f12212b23e$export$3004f64547af360e(indexPart);
    });
};
var $daa993e9fe4182d9$export$b99035e6bd27a173 = function(v) {
    return v;
};
var $daa993e9fe4182d9$var$renderSearch = function(preserved) {
    return function(routedParams$prime) {
        var renderParam = function(v) {
            var v1 = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function($141) {
                return !$22d4f8ab6946d33a$export$7b1b591b262c240($141);
            })(v.value1);
            if (v1.length === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0 + ("=" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e(",")(v1)));
        };
        var routedParts = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($daa993e9fe4182d9$var$map1(renderParam)(routedParams$prime));
        var preservedParts = $daa993e9fe4182d9$export$b99035e6bd27a173(preserved);
        var v = $daa993e9fe4182d9$var$append1(routedParts)(preservedParts);
        if (v.length === 0) return "";
        return "?" + $5b07e36f812dd04b$export$ec1dc8fbeea3467e("&")(v);
    };
};
var $daa993e9fe4182d9$export$11c97f589579967b = function(search) {
    var isRoutedParam = function(part) {
        var v = $5b07e36f812dd04b$export$65980d18b75784e2("=")(part);
        if (v.length === 2) return $daa993e9fe4182d9$var$elem(v[0])($daa993e9fe4182d9$var$routedParams);
        if (v.length === 1) return $daa993e9fe4182d9$var$elem(v[0])($daa993e9fe4182d9$var$routedParams);
        return false;
    };
    var v = $1a77d6934b592676$export$71c2a1babd78d286("?")(search);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function($142) {
        return !isRoutedParam($142);
    })($5b07e36f812dd04b$export$65980d18b75784e2("&")(v.value0));
    throw new Error("Failed pattern match at App.Route (line 130, column 41 - line 132, column 81): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$export$96ba27ab48ad90aa = function(locationState) {
    return function(step) {
        return function(workQ) {
            var selectedStudents = $daa993e9fe4182d9$var$map1(function(v) {
                return v.id;
            })($daa993e9fe4182d9$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(workQ.students)));
            var selectedForms = $daa993e9fe4182d9$var$map1(function(v) {
                return v.id;
            })($daa993e9fe4182d9$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(workQ.forms)));
            var preservedQuery = $daa993e9fe4182d9$export$11c97f589579967b(locationState.search);
            var loadedDocIds = $daa993e9fe4182d9$var$nub($daa993e9fe4182d9$var$map1(function(v) {
                return v.id;
            })($daa993e9fe4182d9$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(workQ.documents))));
            var editDocIds = $daa993e9fe4182d9$var$nub($daa993e9fe4182d9$var$map1(function(v) {
                return v.id;
            })(workQ.editDocs));
            var routeDocIds = $daa993e9fe4182d9$var$nub($daa993e9fe4182d9$var$append1(editDocIds)(loadedDocIds));
            var activeDoc = $daa993e9fe4182d9$var$step3ActiveDocId(workQ);
            if (step instanceof $994495db3cff0a67$export$317e7082611cb548) return new $daa993e9fe4182d9$export$61045fda02b7f5d8({
                preservedQuery: preservedQuery
            });
            if (step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) return new $daa993e9fe4182d9$export$a56647213ddc793({
                preservedQuery: preservedQuery,
                selectedForms: selectedForms
            });
            if (step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) return new $daa993e9fe4182d9$export$27668ebed3f7ff2f({
                preservedQuery: preservedQuery,
                selectedStudents: selectedStudents,
                selectedForms: selectedForms
            });
            if (step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
                preservedQuery: preservedQuery,
                activeDoc: activeDoc,
                docs: routeDocIds,
                section: $daa993e9fe4182d9$export$78a3b81d9f3ae6d8.value
            });
            if (step instanceof $994495db3cff0a67$export$db36463848ed68bd) return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
                preservedQuery: preservedQuery,
                activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(step.value0),
                docs: $daa993e9fe4182d9$var$nub($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(step.value0)(routeDocIds)),
                section: $daa993e9fe4182d9$export$78a3b81d9f3ae6d8.value
            });
            if (step instanceof $994495db3cff0a67$export$133773870222880f) return new $daa993e9fe4182d9$export$841721583836380d({
                index: step.value0,
                preservedQuery: preservedQuery
            });
            if (step instanceof $994495db3cff0a67$export$e3f45034ca213b36) return new $daa993e9fe4182d9$export$74b04faccbc8c7c1(preservedQuery);
            if (step instanceof $994495db3cff0a67$export$ebff56b4c8ba0e39) return new $daa993e9fe4182d9$export$61045fda02b7f5d8({
                preservedQuery: preservedQuery
            });
            throw new Error("Failed pattern match at App.Route (line 207, column 8 - line 215, column 42): " + [
                step.constructor.name
            ]);
        };
    };
};
var $daa993e9fe4182d9$export$2cd79e76fd8960c2 = function(hash) {
    var v = $1a77d6934b592676$export$71c2a1babd78d286("#")(hash);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $22d4f8ab6946d33a$export$7b1b591b262c240(v.value0)) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && $22d4f8ab6946d33a$export$7b1b591b262c240(hash)) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073(hash);
    throw new Error("Failed pattern match at App.Route (line 218, column 25 - line 222, column 25): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$var$parseQueryValues = function(key) {
    return function(search) {
        var splitValues = function(value) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function($143) {
                return !$22d4f8ab6946d33a$export$7b1b591b262c240($143);
            })($daa993e9fe4182d9$var$map1($5b07e36f812dd04b$export$87c2784dc9fc4ab)($5b07e36f812dd04b$export$65980d18b75784e2(",")(value)));
        };
        var extractValue = function(part) {
            var v = $5b07e36f812dd04b$export$65980d18b75784e2("=")(part);
            if (v.length === 2 && v[0] === key) return new $06733ae99ed4f534$export$8a67b48435b5d073(v[1]);
            if (v.length === 1 && v[0] === key) return new $06733ae99ed4f534$export$8a67b48435b5d073("");
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var values = function() {
            var v = $1a77d6934b592676$export$71c2a1babd78d286("?")(search);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($daa993e9fe4182d9$var$map1(extractValue)($5b07e36f812dd04b$export$65980d18b75784e2("&")(v.value0)));
            throw new Error("Failed pattern match at App.Route (line 246, column 14 - line 248, column 83): " + [
                v.constructor.name
            ]);
        }();
        return $daa993e9fe4182d9$var$nub1($396c4c3d9e7fae3c$export$c28c8388be0ab31a(splitValues)(values));
    };
};
var $daa993e9fe4182d9$export$b31cdd5f2716abe9 = /* #__PURE__ */ function() {
    var $144 = $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a7f53fa461221c79);
    var $145 = $daa993e9fe4182d9$var$parseQueryValues("students");
    return function($146) {
        return $144($145($146));
    };
}();
var $daa993e9fe4182d9$export$379cb64fbc67fd28 = /* #__PURE__ */ function() {
    var $147 = $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a7f53fa461221c79);
    var $148 = $daa993e9fe4182d9$var$parseQueryValues("forms");
    return function($149) {
        return $147($148($149));
    };
}();
var $daa993e9fe4182d9$export$586cce1ffe20726e = /* #__PURE__ */ function() {
    var $150 = $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a7f53fa461221c79);
    var $151 = $daa993e9fe4182d9$var$parseQueryValues("docs");
    return function($152) {
        return $150($151($152));
    };
}();
var $daa993e9fe4182d9$export$25ab18eae308f101 = $77724a2c53318d12$export$25ab18eae308f101;
var $daa993e9fe4182d9$var$normalisedPath = function(pathname) {
    var stripped = function() {
        if ($daa993e9fe4182d9$export$25ab18eae308f101 === "") return pathname;
        return $06733ae99ed4f534$export$43db023a260c5e9f(pathname)($1a77d6934b592676$export$71c2a1babd78d286("/" + $daa993e9fe4182d9$export$25ab18eae308f101)(pathname));
    }();
    var $106 = $22d4f8ab6946d33a$export$7b1b591b262c240(stripped);
    if ($106) return "/";
    return stripped;
};
var $daa993e9fe4182d9$export$9bf1c8c94a38f6fb = function(locationState) {
    var students = $daa993e9fe4182d9$export$b31cdd5f2716abe9(locationState.search);
    var section = function() {
        var v = $daa993e9fe4182d9$export$2cd79e76fd8960c2(locationState.hash);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $daa993e9fe4182d9$export$28a5869e6b717ab(v.value0);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $daa993e9fe4182d9$export$37a45811bf45ea95.value;
        throw new Error("Failed pattern match at App.Route (line 154, column 19 - line 156, column 36): " + [
            v.constructor.name
        ]);
    }();
    var preservedQuery = $daa993e9fe4182d9$export$11c97f589579967b(locationState.search);
    var path = $daa993e9fe4182d9$var$normalisedPath(locationState.pathname);
    var forms = $daa993e9fe4182d9$export$379cb64fbc67fd28(locationState.search);
    var docs = $daa993e9fe4182d9$export$586cce1ffe20726e(locationState.search);
    if (path === "/step2") return new $daa993e9fe4182d9$export$a56647213ddc793({
        preservedQuery: preservedQuery,
        selectedForms: forms
    });
    if (path === "/step2b") return new $daa993e9fe4182d9$export$27668ebed3f7ff2f({
        preservedQuery: preservedQuery,
        selectedStudents: students,
        selectedForms: forms
    });
    if (path === "/step3") return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
        preservedQuery: preservedQuery,
        activeDoc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        docs: docs,
        section: section
    });
    if (path === "/test-form") return new $daa993e9fe4182d9$export$74b04faccbc8c7c1(preservedQuery);
    var v = $daa993e9fe4182d9$var$step3DocPath(path);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
        preservedQuery: preservedQuery,
        activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0),
        docs: $daa993e9fe4182d9$var$nub($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(v.value0)(docs)),
        section: section
    });
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
        var v1 = $daa993e9fe4182d9$var$previewPath(path);
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $daa993e9fe4182d9$export$841721583836380d({
            index: v1.value0,
            preservedQuery: preservedQuery
        });
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $daa993e9fe4182d9$export$61045fda02b7f5d8({
            preservedQuery: preservedQuery
        });
        throw new Error("Failed pattern match at App.Route (line 165, column 24 - line 167, column 52): " + [
            v1.constructor.name
        ]);
    }
    throw new Error("Failed pattern match at App.Route (line 163, column 14 - line 167, column 52): " + [
        v.constructor.name
    ]);
};
var $daa993e9fe4182d9$export$9cbcb289502f5191 = /* #__PURE__ */ function() {
    if ($daa993e9fe4182d9$export$25ab18eae308f101 === "") return "";
    return "/" + $daa993e9fe4182d9$export$25ab18eae308f101;
}();
var $daa993e9fe4182d9$var$rootPath = /* #__PURE__ */ function() {
    if ($daa993e9fe4182d9$export$9cbcb289502f5191 === "") return "/";
    return $daa993e9fe4182d9$export$9cbcb289502f5191;
}();
var $daa993e9fe4182d9$export$f6821e37299eed8e = function(v) {
    if (v instanceof $daa993e9fe4182d9$export$61045fda02b7f5d8) return $daa993e9fe4182d9$var$rootPath + ($daa993e9fe4182d9$var$renderSearch(v.value0.preservedQuery)([]) + "");
    if (v instanceof $daa993e9fe4182d9$export$a56647213ddc793) return $daa993e9fe4182d9$export$9cbcb289502f5191 + ("/step2" + ($daa993e9fe4182d9$var$renderSearch(v.value0.preservedQuery)([
        new $71f2e2e9476163f8$export$1908877435b1d5e9("forms", $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a1b0f5347d2470b)(v.value0.selectedForms))
    ]) + ""));
    if (v instanceof $daa993e9fe4182d9$export$27668ebed3f7ff2f) return $daa993e9fe4182d9$export$9cbcb289502f5191 + ("/step2b" + ($daa993e9fe4182d9$var$renderSearch(v.value0.preservedQuery)([
        new $71f2e2e9476163f8$export$1908877435b1d5e9("students", $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a1b0f5347d2470b)(v.value0.selectedStudents)),
        new $71f2e2e9476163f8$export$1908877435b1d5e9("forms", $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a1b0f5347d2470b)(v.value0.selectedForms))
    ]) + ""));
    if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326) {
        var path = function() {
            if (v.value0.activeDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $daa993e9fe4182d9$export$9cbcb289502f5191 + "/step3";
            if (v.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $daa993e9fe4182d9$export$9cbcb289502f5191 + ("/step3/" + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0.activeDoc.value0));
            throw new Error("Failed pattern match at App.Route (line 183, column 20 - line 185, column 70): " + [
                v.value0.activeDoc.constructor.name
            ]);
        }();
        var otherDocs = function() {
            if (v.value0.activeDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $daa993e9fe4182d9$var$nub(v.value0.docs);
            if (v.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v1) {
                return $daa993e9fe4182d9$var$notEq(v1)(v.value0.activeDoc.value0);
            })($daa993e9fe4182d9$var$nub(v.value0.docs));
            throw new Error("Failed pattern match at App.Route (line 186, column 25 - line 188, column 69): " + [
                v.value0.activeDoc.constructor.name
            ]);
        }();
        var params = function() {
            var $130 = $396c4c3d9e7fae3c$export$7b1b591b262c240(otherDocs);
            if ($130) return [];
            return [
                new $71f2e2e9476163f8$export$1908877435b1d5e9("docs", $daa993e9fe4182d9$var$map1($308f9765feb7633d$export$a1b0f5347d2470b)(otherDocs))
            ];
        }();
        return path + ($daa993e9fe4182d9$var$renderSearch(v.value0.preservedQuery)(params) + $daa993e9fe4182d9$var$renderHash(v.value0.section));
    }
    if (v instanceof $daa993e9fe4182d9$export$841721583836380d) return $daa993e9fe4182d9$export$9cbcb289502f5191 + ("/preview/" + ($daa993e9fe4182d9$var$show(v.value0.index) + ($daa993e9fe4182d9$var$renderSearch(v.value0.preservedQuery)([]) + "")));
    if (v instanceof $daa993e9fe4182d9$export$74b04faccbc8c7c1) return $daa993e9fe4182d9$export$9cbcb289502f5191 + ("/test-form" + ($daa993e9fe4182d9$var$renderSearch(v.value0)([]) + ""));
    throw new Error("Failed pattern match at App.Route (line 170, column 12 - line 196, column 74): " + [
        v.constructor.name
    ]);
};


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16










// Generated by purs version 0.15.16
function $98db70b23aa8a6ea$export$f5cdf3809b4587f3(fn) {
    return function() {
        return function(event) {
            return fn(event)();
        };
    };
}
function $98db70b23aa8a6ea$export$d5d038f71f8391de(type) {
    return function(listener) {
        return function(options) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, options);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$3f65cefe8380dbea(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.addEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$8ff9f68337b520c0(type) {
    return function(listener) {
        return function(useCapture) {
            return function(target) {
                return function() {
                    return target.removeEventListener(type, listener, useCapture);
                };
            };
        };
    };
}
function $98db70b23aa8a6ea$export$716a11175c03fb4e(event) {
    return function(target) {
        return function() {
            return target.dispatchEvent(event);
        };
    };
}


// Generated by purs version 0.15.16




// Generated by purs version 0.15.16
const $2603425f82e959df$export$8291e5b88f90ce4 = function() {
    return window;
};


// Generated by purs version 0.15.16


var $d8c91a2be15f75cb$export$212382f8c1a1154e = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$880a60b2adf28011 = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$ede06c734afe650b = function(x) {
    return x;
};
var $d8c91a2be15f75cb$export$95abab3275973ab6 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$c58d7d69adf07268 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$6d81548222f15a9a = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $d8c91a2be15f75cb$export$e2c5e238f46c1980 = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$a0bcd3a016e5808d = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$7e4243c3c9480b2b = {
    Coercible0: function() {
        return undefined;
    }
};
var $d8c91a2be15f75cb$export$24a4aa0a132c9555 = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$b50b66d86c8b8bf = $37b880af5f4991bd$export$fa624555ca2acbc8;
var $d8c91a2be15f75cb$export$10c76280137f9306 = $37b880af5f4991bd$export$fa624555ca2acbc8;


// Generated by purs version 0.15.16
function $50ae04148e431f75$export$44271b4f0c6a3563(a) {
    return function() {
        return a.target;
    };
}
function $50ae04148e431f75$export$1f61c53461aff4a5(target) {
    return function(a) {
        return function() {
            a.target = target;
        };
    };
}
function $50ae04148e431f75$export$24422be91ad4011f(a) {
    return function() {
        return a.download;
    };
}
function $50ae04148e431f75$export$4c9843daef742201(download) {
    return function(a) {
        return function() {
            a.download = download;
        };
    };
}
function $50ae04148e431f75$export$bad408f43b005bc8(a) {
    return function() {
        return a.rel;
    };
}
function $50ae04148e431f75$export$9e86d1af7d63c52c(rel) {
    return function(a) {
        return function() {
            a.rel = rel;
        };
    };
}
function $50ae04148e431f75$export$edb1c8e715f3944e(a) {
    return function() {
        return a.rev;
    };
}
function $50ae04148e431f75$export$671b41179a9f15fb(rev) {
    return function(a) {
        return function() {
            a.rev = rev;
        };
    };
}
function $50ae04148e431f75$export$5884a0b424dd5ef2(a) {
    return function() {
        return a.relList;
    };
}
function $50ae04148e431f75$export$4bf4138386d6b8cc(a) {
    return function() {
        return a.hreflang;
    };
}
function $50ae04148e431f75$export$17b5334c80252e15(hreflang) {
    return function(a) {
        return function() {
            a.hreflang = hreflang;
        };
    };
}
function $50ae04148e431f75$export$d4a6a4db5b31e621(a) {
    return function() {
        return a.type;
    };
}
function $50ae04148e431f75$export$1bf7f05044e9c5cb(type) {
    return function(a) {
        return function() {
            a.type = type;
        };
    };
}
function $50ae04148e431f75$export$6f093cfa640b7166(a) {
    return function() {
        return a.text;
    };
}
function $50ae04148e431f75$export$cbe0d99836e1498f(text) {
    return function(a) {
        return function() {
            a.text = text;
        };
    };
}



// Generated by purs version 0.15.16
function $6d8c9719a60f7848$export$5235d6e581ca586e(nothing, just, name, value) {
    if (typeof window !== "undefined") {
        var ty = window[name];
        if (ty != null && value instanceof ty) return just(value);
    }
    var obj = value;
    while(obj != null){
        var proto = Object.getPrototypeOf(obj);
        var constructorName = proto.constructor.name;
        if (constructorName === name) return just(value);
        else if (constructorName === "Object") return nothing;
        obj = proto;
    }
    return nothing;
}



var $4d89ff275c04492e$export$e3dc45f84eae905c = function(name) {
    return function(value) {
        return $6d8c9719a60f7848$export$5235d6e581ca586e($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, name, value);
    };
};


var $b2b4e127c7797d01$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$9da26c0441db8b03 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b2b4e127c7797d01$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");
var $b2b4e127c7797d01$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAnchorElement");


// Generated by purs version 0.15.16
function $63866c0466b6a770$export$228be17d80722ab(area) {
    return function() {
        return area.alt;
    };
}
function $63866c0466b6a770$export$14a0e7c2e6152665(alt) {
    return function(area) {
        return function() {
            area.alt = alt;
        };
    };
}
function $63866c0466b6a770$export$5bf93b4680474bd(area) {
    return function() {
        return area.coords;
    };
}
function $63866c0466b6a770$export$d03eafa2070fb6d7(coords) {
    return function(area) {
        return function() {
            area.coords = coords;
        };
    };
}
function $63866c0466b6a770$export$98bada23690e67eb(area) {
    return function() {
        return area.shape;
    };
}
function $63866c0466b6a770$export$89565ec41213f41c(shape) {
    return function(area) {
        return function() {
            area.shape = shape;
        };
    };
}
function $63866c0466b6a770$export$44271b4f0c6a3563(area) {
    return function() {
        return area.target;
    };
}
function $63866c0466b6a770$export$1f61c53461aff4a5(target) {
    return function(area) {
        return function() {
            area.target = target;
        };
    };
}
function $63866c0466b6a770$export$24422be91ad4011f(area) {
    return function() {
        return area.download;
    };
}
function $63866c0466b6a770$export$4c9843daef742201(download) {
    return function(area) {
        return function() {
            area.download = download;
        };
    };
}
function $63866c0466b6a770$export$bad408f43b005bc8(area) {
    return function() {
        return area.rel;
    };
}
function $63866c0466b6a770$export$9e86d1af7d63c52c(rel) {
    return function(area) {
        return function() {
            area.rel = rel;
        };
    };
}
function $63866c0466b6a770$export$5884a0b424dd5ef2(area) {
    return function() {
        return area.relList;
    };
}
function $63866c0466b6a770$export$4bf4138386d6b8cc(area) {
    return function() {
        return area.hreflang;
    };
}
function $63866c0466b6a770$export$17b5334c80252e15(hreflang) {
    return function(area) {
        return function() {
            area.hreflang = hreflang;
        };
    };
}
function $63866c0466b6a770$export$d4a6a4db5b31e621(area) {
    return function() {
        return area.type;
    };
}
function $63866c0466b6a770$export$1bf7f05044e9c5cb(type) {
    return function(area) {
        return function() {
            area.type = type;
        };
    };
}




var $c47d991e98d75165$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c47d991e98d75165$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");
var $c47d991e98d75165$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAreaElement");


// Generated by purs version 0.15.16
function $bcd5a412110bec59$export$185802fd694ee1f5() {
    return new Audio();
}
function $bcd5a412110bec59$export$2faa2f53d87c7f7e(url) {
    return function() {
        return new Audio(url);
    };
}




var $9c48a3b1514e7e20$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9c48a3b1514e7e20$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLAudioElement");
var $9c48a3b1514e7e20$export$20f9c2173df486a8 = $bcd5a412110bec59$export$2faa2f53d87c7f7e;


// Generated by purs version 0.15.16


var $28cc3aca3b37f8c1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $28cc3aca3b37f8c1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");
var $28cc3aca3b37f8c1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBRElement");


// Generated by purs version 0.15.16
function $9c737e057094c556$export$8f51af5840e0602a(base) {
    return function() {
        return base.href;
    };
}
function $9c737e057094c556$export$428f6e77b5a5a669(href) {
    return function(base) {
        return function() {
            base.href = href;
        };
    };
}
function $9c737e057094c556$export$44271b4f0c6a3563(base) {
    return function() {
        return base.target;
    };
}
function $9c737e057094c556$export$1f61c53461aff4a5(target) {
    return function(base) {
        return function() {
            base.target = target;
        };
    };
}




var $1f63464ba4e88016$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1f63464ba4e88016$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");
var $1f63464ba4e88016$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBaseElement");


// Generated by purs version 0.15.16


var $9e295ac610849d32$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9e295ac610849d32$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");
var $9e295ac610849d32$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLBodyElement");


// Generated by purs version 0.15.16
function $20a948bbaa0c268a$export$4c47992fc278c9a0(button) {
    return function() {
        return button.autofocus;
    };
}
function $20a948bbaa0c268a$export$db2bbdcbda3d335e(autofocus) {
    return function(button) {
        return function() {
            button.autofocus = autofocus;
        };
    };
}
function $20a948bbaa0c268a$export$683472f6198a076e(button) {
    return function() {
        return button.disabled;
    };
}
function $20a948bbaa0c268a$export$4532d31cef66d703(disabled) {
    return function(button) {
        return function() {
            button.disabled = disabled;
        };
    };
}
function $20a948bbaa0c268a$export$242c63e9758836c2(button) {
    return function() {
        return button.form;
    };
}
function $20a948bbaa0c268a$export$7e4d70bab1b5c4a0(button) {
    return function() {
        return button.formAction;
    };
}
function $20a948bbaa0c268a$export$577bb1d64e4c83b9(formAction) {
    return function(button) {
        return function() {
            button.formAction = formAction;
        };
    };
}
function $20a948bbaa0c268a$export$21f1c8008acfa9c0(button) {
    return function() {
        return button.formEnctype;
    };
}
function $20a948bbaa0c268a$export$346989dcff4ba18b(formEnctype) {
    return function(button) {
        return function() {
            button.formEnctype = formEnctype;
        };
    };
}
function $20a948bbaa0c268a$export$3f1ffee261a00124(button) {
    return function() {
        return button.formMethod;
    };
}
function $20a948bbaa0c268a$export$c38a1a871bb0e145(formMethod) {
    return function(button) {
        return function() {
            button.formMethod = formMethod;
        };
    };
}
function $20a948bbaa0c268a$export$87c857905fcc4a84(button) {
    return function() {
        return button.formNoValidate;
    };
}
function $20a948bbaa0c268a$export$ad9ff32d0af51586(formNoValidate) {
    return function(button) {
        return function() {
            button.formNoValidate = formNoValidate;
        };
    };
}
function $20a948bbaa0c268a$export$497949a0ae76184f(button) {
    return function() {
        return button.formTarget;
    };
}
function $20a948bbaa0c268a$export$4c7e983548149eb5(formTarget) {
    return function(button) {
        return function() {
            button.formTarget = formTarget;
        };
    };
}
function $20a948bbaa0c268a$export$a8ff84c12d48cfa6(button) {
    return function() {
        return button.name;
    };
}
function $20a948bbaa0c268a$export$6cf3d710d3a367e5(name) {
    return function(button) {
        return function() {
            button.name = name;
        };
    };
}
function $20a948bbaa0c268a$export$d4a6a4db5b31e621(button) {
    return function() {
        return button.type;
    };
}
function $20a948bbaa0c268a$export$1bf7f05044e9c5cb(type) {
    return function(button) {
        return function() {
            button.type = type;
        };
    };
}
function $20a948bbaa0c268a$export$2ab9a8f9f1186f14(button) {
    return function() {
        return button.value;
    };
}
function $20a948bbaa0c268a$export$80746c6bc6142fc8(value) {
    return function(button) {
        return function() {
            button.value = value;
        };
    };
}
function $20a948bbaa0c268a$export$5e55a9e709e8e020(button) {
    return function() {
        return button.willValidate;
    };
}
function $20a948bbaa0c268a$export$1bdd3f9a89b22594(button) {
    return function() {
        return button.validity;
    };
}
function $20a948bbaa0c268a$export$6ee4201e37a931e2(button) {
    return function() {
        return button.validationMessage;
    };
}
function $20a948bbaa0c268a$export$50d70f8cedc54453(button) {
    return function() {
        return button.checkValidity();
    };
}
function $20a948bbaa0c268a$export$b962d864c477cc49(button) {
    return function() {
        return button.reportValidity();
    };
}
function $20a948bbaa0c268a$export$6f569cb704992105(value) {
    return function(button) {
        return function() {
            button.setCustomValidity(value);
        };
    };
}
function $20a948bbaa0c268a$export$a238cb463698c900(button) {
    return function() {
        return button.labels;
    };
}







var $c6219700cb28efb6$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c6219700cb28efb6$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLButtonElement");
var $c6219700cb28efb6$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($20a948bbaa0c268a$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $7d547317abc5459f$export$7e3df82ee760448c(canvas) {
    return function() {
        return canvas.width;
    };
}
function $7d547317abc5459f$export$67f48e0594af05d(width) {
    return function(canvas) {
        return function() {
            canvas.width = width;
        };
    };
}
function $7d547317abc5459f$export$ac607276a8fe9f0a(canvas) {
    return function() {
        return canvas.height;
    };
}
function $7d547317abc5459f$export$3f31360357be44e4(height) {
    return function(canvas) {
        return function() {
            canvas.height = height;
        };
    };
}




var $f8ac89c5dd24c0f2$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f8ac89c5dd24c0f2$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");
var $f8ac89c5dd24c0f2$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLCanvasElement");


// Generated by purs version 0.15.16


var $6018dac1d12eb9e0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6018dac1d12eb9e0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");
var $6018dac1d12eb9e0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDListElement");


// Generated by purs version 0.15.16
function $29e81da2666ff0a3$export$2ab9a8f9f1186f14(data) {
    return function() {
        return data.value;
    };
}
function $29e81da2666ff0a3$export$80746c6bc6142fc8(value) {
    return function(data) {
        return function() {
            data.value = value;
        };
    };
}




var $450df947978ac297$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $450df947978ac297$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");
var $450df947978ac297$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataElement");


// Generated by purs version 0.15.16
function $8cebdc995025043e$export$41c562ebe57d11e2(dle) {
    return function() {
        return dle.options;
    };
}




var $e6ed11a356105002$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e6ed11a356105002$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");
var $e6ed11a356105002$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDataListElement");


// Generated by purs version 0.15.16


var $61286eb7c73211a7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $61286eb7c73211a7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");
var $61286eb7c73211a7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDivElement");


// Generated by purs version 0.15.16
function $0e1ad3264aa8b3c4$export$445a11d197c0312(doc) {
    return doc.documentElement;
}
function $0e1ad3264aa8b3c4$export$327008c45899d79e(doc) {
    return doc.head;
}
function $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc) {
    return doc.body;
}
function $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc) {
    return doc.readyState;
}
function $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc) {
    return doc.activeElement;
}
function $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc) {
    return doc.currentScript;
}
function $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc) {
    return doc.referrer;
}
function $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc) {
    return doc.title;
}
function $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(title, doc) {
    doc.title = title;
}







// Generated by purs version 0.15.16


var $99cfc603fe5cc0f7$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 = /* #__PURE__ */ function() {
    function Interactive() {}
    Interactive.value = new Interactive();
    return Interactive;
}();
var $99cfc603fe5cc0f7$export$37474717eef9e2a4 = /* #__PURE__ */ function() {
    function Complete() {}
    Complete.value = new Complete();
    return Complete;
}();
var $99cfc603fe5cc0f7$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "Interactive";
        if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "Complete";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $99cfc603fe5cc0f7$export$c2d084dc44961371 = function(v) {
    if (v instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return "loading";
    if (v instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return "interactive";
    if (v instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return "complete";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 22, column 9 - line 25, column 25): " + [
        v.constructor.name
    ]);
};
var $99cfc603fe5cc0f7$export$98e6a39c04603d36 = function(v) {
    if (v === "loading") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
    if (v === "interactive") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$43d8ad7b9c99dd97.value);
    if (v === "complete") return new $06733ae99ed4f534$export$8a67b48435b5d073($99cfc603fe5cc0f7$export$37474717eef9e2a4.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $99cfc603fe5cc0f7$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return true;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return true;
            return false;
        };
    }
};
var $99cfc603fe5cc0f7$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf && y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97 && y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $99cfc603fe5cc0f7$export$43d8ad7b9c99dd97) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4 && y instanceof $99cfc603fe5cc0f7$export$37474717eef9e2a4) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $99cfc603fe5cc0f7$export$c71e02dcc13f94a6;
    }
};


// Generated by purs version 0.15.16


var $ecd74bf9585b1551$export$3824c08153b44726 = /* #__PURE__ */ function() {
    function Visible() {}
    Visible.value = new Visible();
    return Visible;
}();
var $ecd74bf9585b1551$export$8dc98ba7eadeaa56 = /* #__PURE__ */ function() {
    function Hidden() {}
    Hidden.value = new Hidden();
    return Hidden;
}();
var $ecd74bf9585b1551$export$d2d17f8156d66f42 = {
    show: function(v) {
        if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "Visible";
        if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "Hidden";
        throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 15, column 10 - line 17, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $ecd74bf9585b1551$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ecd74bf9585b1551$export$3824c08153b44726) return "visible";
    if (v instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return "hidden";
    throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 20, column 9 - line 22, column 21): " + [
        v.constructor.name
    ]);
};
var $ecd74bf9585b1551$export$98e6a39c04603d36 = function(v) {
    if (v === "visible") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$3824c08153b44726.value);
    if (v === "hidden") return new $06733ae99ed4f534$export$8a67b48435b5d073($ecd74bf9585b1551$export$8dc98ba7eadeaa56.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ecd74bf9585b1551$export$e4139843c5cdd239 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return true;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return true;
            return false;
        };
    }
};
var $ecd74bf9585b1551$export$712b05ab3ead9d93 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726 && y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ecd74bf9585b1551$export$3824c08153b44726) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56 && y instanceof $ecd74bf9585b1551$export$8dc98ba7eadeaa56) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLDocument.VisibilityState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ecd74bf9585b1551$export$e4139843c5cdd239;
    }
};



var $f6c9290a5db8f197$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $f6c9290a5db8f197$export$3d0d3483832deb8e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $2 = $06733ae99ed4f534$export$43db023a260c5e9f($ecd74bf9585b1551$export$3824c08153b44726.value);
        return function($3) {
            return $2($ecd74bf9585b1551$export$98e6a39c04603d36($3));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$5a15a2f945550a96(doc);
    });
};
var $f6c9290a5db8f197$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$d8d5f203c133934 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$ce0e204f587740c3 = $ac8b3532514ac019$export$401372c57776dc;
var $f6c9290a5db8f197$export$fb184b623420d9be = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$a80dcad378414f77(doc);
    };
};
var $f6c9290a5db8f197$export$420a7f2fd9cad6f6 = function(newTitle) {
    return function(doc) {
        return function() {
            return $0e1ad3264aa8b3c4$export$485b6f1fe8b035f3(newTitle, doc);
        };
    };
};
var $f6c9290a5db8f197$export$a0c6a011d8b20057 = function(doc) {
    return function() {
        return $0e1ad3264aa8b3c4$export$6392ea9cea2135f3(doc);
    };
};
var $f6c9290a5db8f197$export$1ae2b664eea77b7e = function(doc) {
    return $f6c9290a5db8f197$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($99cfc603fe5cc0f7$export$669f6ea7d267feaf.value);
        return function($5) {
            return $4($99cfc603fe5cc0f7$export$98e6a39c04603d36($5));
        };
    }())(function() {
        return $0e1ad3264aa8b3c4$export$4bf8a366db6a678b(doc);
    });
};
var $f6c9290a5db8f197$export$5fd5031fecdacec3 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$327008c45899d79e(doc);
    });
};
var $f6c9290a5db8f197$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$45b532d2a1c7642b = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$cb6b1c55e7404aef = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLDocument");
var $f6c9290a5db8f197$export$170c446b87804fad = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$445a11d197c0312(doc);
    });
};
var $f6c9290a5db8f197$export$7aca2fdfd0625e3a = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$f0905ed0c7a5fd27(doc);
    });
};
var $f6c9290a5db8f197$export$32180ef41b15b513 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$773bb8dac55dfce8(doc);
    });
};
var $f6c9290a5db8f197$export$da980962bd2147a4 = function(doc) {
    return $f6c9290a5db8f197$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
        return $0e1ad3264aa8b3c4$export$6282f43d08fc4121(doc);
    });
};


// Generated by purs version 0.15.16
function $ccf49930316caf57$export$b2a016fb14adc1e4(nothing, just, value) {
    var tag = Object.prototype.toString.call(value);
    if (tag.indexOf("[object HTML") === 0 && tag.indexOf("Element]") === tag.length - 8) return just(value);
    else return nothing;
}
function $ccf49930316caf57$export$fb184b623420d9be(elt) {
    return function() {
        return elt.title;
    };
}
function $ccf49930316caf57$export$420a7f2fd9cad6f6(title) {
    return function(elt) {
        return function() {
            elt.title = title;
        };
    };
}
function $ccf49930316caf57$export$9a771d6906431624(elt) {
    return function() {
        return elt.lang;
    };
}
function $ccf49930316caf57$export$a3665b844fbc095d(lang) {
    return function(elt) {
        return function() {
            elt.lang = lang;
        };
    };
}
function $ccf49930316caf57$export$147ec2801e896265(elt) {
    return function() {
        return elt.dir;
    };
}
function $ccf49930316caf57$export$5d00cbe77a0f4da4(dir) {
    return function(elt) {
        return function() {
            elt.dir = dir;
        };
    };
}
function $ccf49930316caf57$export$73920f18ca706874(elt) {
    return function() {
        return elt.hidden;
    };
}
function $ccf49930316caf57$export$306a681a1fc87013(hidden) {
    return function(elt) {
        return function() {
            elt.hidden = hidden;
        };
    };
}
function $ccf49930316caf57$export$9a625f9de50bf0b7(elt) {
    return function() {
        return elt.tabIndex;
    };
}
function $ccf49930316caf57$export$de72581b19a869cc(tabIndex) {
    return function(elt) {
        return function() {
            elt.tabIndex = tabIndex;
        };
    };
}
function $ccf49930316caf57$export$c746a5152d4ba26c(elt) {
    return function() {
        return elt.draggable;
    };
}
function $ccf49930316caf57$export$b681bd05c45bbdd7(draggable) {
    return function(elt) {
        return function() {
            elt.draggable = draggable;
        };
    };
}
function $ccf49930316caf57$export$d9d317b4285c34e7(elt) {
    return function() {
        return elt.contentEditable;
    };
}
function $ccf49930316caf57$export$91a56ab73e46c5d4(contentEditable) {
    return function(elt) {
        return function() {
            elt.contentEditable = contentEditable;
        };
    };
}
function $ccf49930316caf57$export$3453cc819780f652(elt) {
    return function() {
        return elt.isContentEditable;
    };
}
function $ccf49930316caf57$export$afbe3196582d9f14(elt) {
    return function() {
        return elt.spellcheck;
    };
}
function $ccf49930316caf57$export$f5c89d87509db2c2(spellcheck) {
    return function(elt) {
        return function() {
            elt.spellcheck = spellcheck;
        };
    };
}
function $ccf49930316caf57$export$64ef1bee2b9504c1(elt) {
    return function() {
        return elt.click();
    };
}
function $ccf49930316caf57$export$d7ddd398f22d79ef(elt) {
    return function() {
        return elt.focus();
    };
}
function $ccf49930316caf57$export$2cc7ff91bcacba5e(elt) {
    return function() {
        return elt.blur();
    };
}
function $ccf49930316caf57$export$351f7ed5e1f4cbfb(el) {
    return function() {
        return el.offsetParent;
    };
}
function $ccf49930316caf57$export$9051df5ff5b6ece8(el) {
    return function() {
        return el.offsetTop;
    };
}
function $ccf49930316caf57$export$4ad6bc00a859a01c(el) {
    return function() {
        return el.offsetLeft;
    };
}
function $ccf49930316caf57$export$abda199d6e675d54(el) {
    return function() {
        return el.offsetWidth;
    };
}
function $ccf49930316caf57$export$720e3813341eb9b(el) {
    return function() {
        return el.offsetHeight;
    };
}







var $5ae75883a0b7923c$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5ae75883a0b7923c$export$759f2a42fd33dfde = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($ccf49930316caf57$export$351f7ed5e1f4cbfb($3));
    };
}();
var $5ae75883a0b7923c$export$7039ba397093f069 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$66db07be43ecb0c3 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a7f097b65af8aa04 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$a0a0bf09b44710c9 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$c56654a6d0e3bd48 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};
var $5ae75883a0b7923c$export$31942037104a4a20 = function(x) {
    return $ccf49930316caf57$export$b2a016fb14adc1e4($06733ae99ed4f534$export$bebe9059409a0d04.value, $06733ae99ed4f534$export$8a67b48435b5d073.create, x);
};


// Generated by purs version 0.15.16
function $1de55632ffb04144$export$2e40c9e35e9506f4(embed) {
    return function() {
        return embed.src;
    };
}
function $1de55632ffb04144$export$5771e3a4c80da7df(src) {
    return function(embed) {
        return function() {
            embed.src = src;
        };
    };
}
function $1de55632ffb04144$export$d4a6a4db5b31e621(embed) {
    return function() {
        return embed.type;
    };
}
function $1de55632ffb04144$export$1bf7f05044e9c5cb(type) {
    return function(embed) {
        return function() {
            embed.type = type;
        };
    };
}
function $1de55632ffb04144$export$7e3df82ee760448c(embed) {
    return function() {
        return embed.width;
    };
}
function $1de55632ffb04144$export$67f48e0594af05d(width) {
    return function(embed) {
        return function() {
            embed.width = width;
        };
    };
}
function $1de55632ffb04144$export$ac607276a8fe9f0a(embed) {
    return function() {
        return embed.height;
    };
}
function $1de55632ffb04144$export$3f31360357be44e4(height) {
    return function(embed) {
        return function() {
            embed.height = height;
        };
    };
}




var $6948c2c57b43dc19$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $6948c2c57b43dc19$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");
var $6948c2c57b43dc19$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLEmbedElement");


// Generated by purs version 0.15.16
function $f5ce06e2d4c9fafa$export$683472f6198a076e(fieldset) {
    return function() {
        return fieldset.disabled;
    };
}
function $f5ce06e2d4c9fafa$export$4532d31cef66d703(disabled) {
    return function(fieldset) {
        return function() {
            fieldset.disabled = disabled;
        };
    };
}
function $f5ce06e2d4c9fafa$export$242c63e9758836c2(fieldset) {
    return function() {
        return fieldset.form;
    };
}
function $f5ce06e2d4c9fafa$export$a8ff84c12d48cfa6(fieldset) {
    return function() {
        return fieldset.name;
    };
}
function $f5ce06e2d4c9fafa$export$6cf3d710d3a367e5(name) {
    return function(fieldset) {
        return function() {
            fieldset.name = name;
        };
    };
}
function $f5ce06e2d4c9fafa$export$d4a6a4db5b31e621(fieldset) {
    return function() {
        return fieldset.type;
    };
}
function $f5ce06e2d4c9fafa$export$1bf7f05044e9c5cb(type) {
    return function(fieldset) {
        return function() {
            fieldset.type = type;
        };
    };
}
function $f5ce06e2d4c9fafa$export$5e55a9e709e8e020(fieldset) {
    return function() {
        return fieldset.willValidate;
    };
}
function $f5ce06e2d4c9fafa$export$1bdd3f9a89b22594(fieldset) {
    return function() {
        return fieldset.validity;
    };
}
function $f5ce06e2d4c9fafa$export$6ee4201e37a931e2(fieldset) {
    return function() {
        return fieldset.validationMessage;
    };
}
function $f5ce06e2d4c9fafa$export$50d70f8cedc54453(fieldset) {
    return function() {
        return fieldset.checkValidity();
    };
}
function $f5ce06e2d4c9fafa$export$b962d864c477cc49(fieldset) {
    return function() {
        return fieldset.reportValidity();
    };
}
function $f5ce06e2d4c9fafa$export$6f569cb704992105(value) {
    return function(fieldset) {
        return function() {
            fieldset.setCustomValidity(value);
        };
    };
}







var $b837b4d3f419e563$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b837b4d3f419e563$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFieldSetElement");
var $b837b4d3f419e563$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($f5ce06e2d4c9fafa$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $ea01f93abd44760a$export$7e2eca70ed294fb(form) {
    return function() {
        return form.acceptCharset;
    };
}
function $ea01f93abd44760a$export$9ec8703ca0dc2663(acceptCharset) {
    return function(form) {
        return function() {
            form.acceptCharset = acceptCharset;
        };
    };
}
function $ea01f93abd44760a$export$31eb53bd5b582a97(form) {
    return function() {
        return form.action;
    };
}
function $ea01f93abd44760a$export$a0c65badd8d09883(action) {
    return function(form) {
        return function() {
            form.action = action;
        };
    };
}
function $ea01f93abd44760a$export$485ded5f26ebe08d(form) {
    return function() {
        return form.autocomplete;
    };
}
function $ea01f93abd44760a$export$5fb7c729919301a5(autocomplete) {
    return function(form) {
        return function() {
            form.autocomplete = autocomplete;
        };
    };
}
function $ea01f93abd44760a$export$9fc5d082ec250407(form) {
    return function() {
        return form.enctype;
    };
}
function $ea01f93abd44760a$export$71f7bac871e6ce1b(enctype) {
    return function(form) {
        return function() {
            form.enctype = enctype;
        };
    };
}
function $ea01f93abd44760a$export$d8738670c721d955(form) {
    return function() {
        return form.encoding;
    };
}
function $ea01f93abd44760a$export$11699ce243a224fd(encoding) {
    return function(form) {
        return function() {
            form.encoding = encoding;
        };
    };
}
function $ea01f93abd44760a$export$26f73335cc2e7868(form) {
    return function() {
        return form.method;
    };
}
function $ea01f93abd44760a$export$8c6ecab5174b959(method) {
    return function(form) {
        return function() {
            form.method = method;
        };
    };
}
function $ea01f93abd44760a$export$a8ff84c12d48cfa6(form) {
    return function() {
        return form.name;
    };
}
function $ea01f93abd44760a$export$6cf3d710d3a367e5(name) {
    return function(form) {
        return function() {
            form.name = name;
        };
    };
}
function $ea01f93abd44760a$export$f50297589147f25e(form) {
    return function() {
        return form.noValidate;
    };
}
function $ea01f93abd44760a$export$2271539dcccd0a8a(noValidate) {
    return function(form) {
        return function() {
            form.noValidate = noValidate;
        };
    };
}
function $ea01f93abd44760a$export$44271b4f0c6a3563(form) {
    return function() {
        return form.target;
    };
}
function $ea01f93abd44760a$export$1f61c53461aff4a5(target) {
    return function(form) {
        return function() {
            form.target = target;
        };
    };
}
function $ea01f93abd44760a$export$f24224f1c91d8156(form) {
    return function() {
        return form.length;
    };
}
function $ea01f93abd44760a$export$853c27de4ce0f746(form) {
    return function() {
        form.submit();
    };
}
function $ea01f93abd44760a$export$aad8462122ac592b(form) {
    return function() {
        form.reset();
    };
}
function $ea01f93abd44760a$export$50d70f8cedc54453(form) {
    return function() {
        return form.checkValidity();
    };
}
function $ea01f93abd44760a$export$b962d864c477cc49(form) {
    return function() {
        return form.reportValidity();
    };
}




var $9f3b722473e4bf22$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $9f3b722473e4bf22$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");
var $9f3b722473e4bf22$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLFormElement");


// Generated by purs version 0.15.16


var $3f8a2c745615078e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $3f8a2c745615078e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");
var $3f8a2c745615078e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHRElement");


// Generated by purs version 0.15.16


var $f437286c23d51fb9$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f437286c23d51fb9$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");
var $f437286c23d51fb9$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadElement");


// Generated by purs version 0.15.16


var $a4ab4f8ed836a554$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a4ab4f8ed836a554$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");
var $a4ab4f8ed836a554$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLHeadingElement");


// Generated by purs version 0.15.16
function $966466ed4b666020$export$2e40c9e35e9506f4(iframe) {
    return function() {
        return iframe.src;
    };
}
function $966466ed4b666020$export$5771e3a4c80da7df(src) {
    return function(iframe) {
        return function() {
            iframe.src = src;
        };
    };
}
function $966466ed4b666020$export$7be70892c9d4d10e(iframe) {
    return function() {
        return iframe.srcdoc;
    };
}
function $966466ed4b666020$export$8a11fa357d4cbbc0(srcdoc) {
    return function(iframe) {
        return function() {
            iframe.srcdoc = srcdoc;
        };
    };
}
function $966466ed4b666020$export$a8ff84c12d48cfa6(iframe) {
    return function() {
        return iframe.name;
    };
}
function $966466ed4b666020$export$6cf3d710d3a367e5(name) {
    return function(iframe) {
        return function() {
            iframe.name = name;
        };
    };
}
function $966466ed4b666020$export$7e3df82ee760448c(iframe) {
    return function() {
        return iframe.width;
    };
}
function $966466ed4b666020$export$67f48e0594af05d(width) {
    return function(iframe) {
        return function() {
            iframe.width = width;
        };
    };
}
function $966466ed4b666020$export$ac607276a8fe9f0a(iframe) {
    return function() {
        return iframe.height;
    };
}
function $966466ed4b666020$export$3f31360357be44e4(height) {
    return function(iframe) {
        return function() {
            iframe.height = height;
        };
    };
}
function $966466ed4b666020$export$a51825c89fe24f94(iframe) {
    return function() {
        return iframe.contentDocument;
    };
}
function $966466ed4b666020$export$688aae7b7ac35f92(iframe) {
    return function() {
        return iframe.contentWindow;
    };
}







var $bd620e99ccde661e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $bd620e99ccde661e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $bd620e99ccde661e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLIFrameElement");
var $bd620e99ccde661e$export$6677e9b58554b15d = /* #__PURE__ */ function() {
    var $2 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($966466ed4b666020$export$688aae7b7ac35f92($3));
    };
}();
var $bd620e99ccde661e$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $bd620e99ccde661e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($966466ed4b666020$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.16
function $4fb986a93dbcc125$export$185802fd694ee1f5() {
    return new Image();
}
function $4fb986a93dbcc125$export$11b6d15e47fb61cf(width) {
    return function(height) {
        return function() {
            return new Image(width, height);
        };
    };
}
function $4fb986a93dbcc125$export$228be17d80722ab(image) {
    return function() {
        return image.alt;
    };
}
function $4fb986a93dbcc125$export$14a0e7c2e6152665(alt) {
    return function(image) {
        return function() {
            image.alt = alt;
        };
    };
}
function $4fb986a93dbcc125$export$2e40c9e35e9506f4(image) {
    return function() {
        return image.src;
    };
}
function $4fb986a93dbcc125$export$5771e3a4c80da7df(src) {
    return function(image) {
        return function() {
            image.src = src;
        };
    };
}
function $4fb986a93dbcc125$export$c2507fd1cd56d483(image) {
    return function() {
        return image.srcset;
    };
}
function $4fb986a93dbcc125$export$c95fa5d268267aa4(srcset) {
    return function(image) {
        return function() {
            image.srcset = srcset;
        };
    };
}
function $4fb986a93dbcc125$export$c647cb0ee6e282fe(image) {
    return function() {
        return image.sizes;
    };
}
function $4fb986a93dbcc125$export$2652819f9fe6d59b(sizes) {
    return function(image) {
        return function() {
            image.sizes = sizes;
        };
    };
}
function $4fb986a93dbcc125$export$22e7408040d24cb8(image) {
    return function() {
        return image.currentSrc;
    };
}
function $4fb986a93dbcc125$export$2a95876eedf9defd(image) {
    return image.crossOrigin;
}
function $4fb986a93dbcc125$export$15671bab5b2a825c(crossOrigin, image) {
    image.crossOrigin = crossOrigin;
}
function $4fb986a93dbcc125$export$86f8f9f08863e403(image) {
    return function() {
        return image.useMap;
    };
}
function $4fb986a93dbcc125$export$ab416bdbb887640e(useMap) {
    return function(image) {
        return function() {
            image.useMap = useMap;
        };
    };
}
function $4fb986a93dbcc125$export$5c90113a285f2241(image) {
    return function() {
        return image.isMap;
    };
}
function $4fb986a93dbcc125$export$e634cf4c55ef6324(isMap) {
    return function(image) {
        return function() {
            image.isMap = isMap;
        };
    };
}
function $4fb986a93dbcc125$export$7e3df82ee760448c(image) {
    return function() {
        return image.width;
    };
}
function $4fb986a93dbcc125$export$67f48e0594af05d(width) {
    return function(image) {
        return function() {
            image.width = width;
        };
    };
}
function $4fb986a93dbcc125$export$ac607276a8fe9f0a(image) {
    return function() {
        return image.height;
    };
}
function $4fb986a93dbcc125$export$3f31360357be44e4(height) {
    return function(image) {
        return function() {
            image.height = height;
        };
    };
}
function $4fb986a93dbcc125$export$c32e50dfb9f4ec89(image) {
    return function() {
        return image.naturalWidth;
    };
}
function $4fb986a93dbcc125$export$6a4b566b54dc81c0(image) {
    return function() {
        return image.naturalHeight;
    };
}
function $4fb986a93dbcc125$export$8b29ef2611187a5f(image) {
    return function() {
        return image.referrerPolicy;
    };
}
function $4fb986a93dbcc125$export$c73d54db5b3c6ed4(referrerPolicy) {
    return function(image) {
        return function() {
            image.referrerPolicy = referrerPolicy;
        };
    };
}
function $4fb986a93dbcc125$export$8774eb0dcbbe3146(image) {
    return image.decoding;
}
function $4fb986a93dbcc125$export$533597f26ad51793(decoding, image) {
    image.decoding = decoding;
}
function $4fb986a93dbcc125$export$c1978f45d5c8c1fd(image) {
    return image.loading;
}
function $4fb986a93dbcc125$export$820843123ac3b9d(loading, image) {
    image.loading = loading;
}
function $4fb986a93dbcc125$export$b1bc8081da8c9e77(image) {
    return function() {
        return image.complete;
    };
}









// Generated by purs version 0.15.16


var $ff8d4f0527bf7f56$export$e1bb774e9664e700 = /* #__PURE__ */ function() {
    function Anonymous() {}
    Anonymous.value = new Anonymous();
    return Anonymous;
}();
var $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 = /* #__PURE__ */ function() {
    function UseCredentials() {}
    UseCredentials.value = new UseCredentials();
    return UseCredentials;
}();
var $ff8d4f0527bf7f56$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "Anonymous";
        if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "UseCredentials";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 18, column 10 - line 20, column 39): " + [
            v.constructor.name
        ]);
    }
};
var $ff8d4f0527bf7f56$export$c2d084dc44961371 = function(v) {
    if (v instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return "anonymous";
    if (v instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return "use-credentials";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 30, column 9 - line 32, column 38): " + [
        v.constructor.name
    ]);
};
var $ff8d4f0527bf7f56$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "anonymous") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$e1bb774e9664e700.value);
    if (v === "use-credentials") return new $06733ae99ed4f534$export$8a67b48435b5d073($ff8d4f0527bf7f56$export$bf6fef082af5a2d3.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return true;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return true;
            return false;
        };
    }
};
var $ff8d4f0527bf7f56$export$4877633354812171 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700 && y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $ff8d4f0527bf7f56$export$e1bb774e9664e700) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3 && y instanceof $ff8d4f0527bf7f56$export$bf6fef082af5a2d3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.CORSMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $ff8d4f0527bf7f56$export$8a8a93ce7ed989f9;
    }
};


// Generated by purs version 0.15.16


var $becf597acb9365c5$export$2ae15352e0a80063 = /* #__PURE__ */ function() {
    function Sync() {}
    Sync.value = new Sync();
    return Sync;
}();
var $becf597acb9365c5$export$4d3c597da532240f = /* #__PURE__ */ function() {
    function Async() {}
    Async.value = new Async();
    return Async;
}();
var $becf597acb9365c5$export$6cc2e70440926d44 = /* #__PURE__ */ function() {
    function Auto() {}
    Auto.value = new Auto();
    return Auto;
}();
var $becf597acb9365c5$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "Sync";
        if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "Async";
        if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "Auto";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 19, column 10 - line 22, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $becf597acb9365c5$export$c2d084dc44961371 = function(v) {
    if (v instanceof $becf597acb9365c5$export$2ae15352e0a80063) return "sync";
    if (v instanceof $becf597acb9365c5$export$4d3c597da532240f) return "async";
    if (v instanceof $becf597acb9365c5$export$6cc2e70440926d44) return "auto";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 33, column 9 - line 36, column 17): " + [
        v.constructor.name
    ]);
};
var $becf597acb9365c5$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    if (v === "sync") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$2ae15352e0a80063.value);
    if (v === "async") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$4d3c597da532240f.value);
    if (v === "auto") return new $06733ae99ed4f534$export$8a67b48435b5d073($becf597acb9365c5$export$6cc2e70440926d44.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $becf597acb9365c5$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return true;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return true;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return true;
            return false;
        };
    }
};
var $becf597acb9365c5$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063 && y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$2ae15352e0a80063) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f && y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $becf597acb9365c5$export$4d3c597da532240f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $becf597acb9365c5$export$6cc2e70440926d44 && y instanceof $becf597acb9365c5$export$6cc2e70440926d44) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.DecodingHint (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $becf597acb9365c5$export$e32bcfaf2cb99de5;
    }
};


// Generated by purs version 0.15.16


var $a591d06baacc8fdb$export$a4acc175556f6dbc = /* #__PURE__ */ function() {
    function Eager() {}
    Eager.value = new Eager();
    return Eager;
}();
var $a591d06baacc8fdb$export$b624eff549462981 = /* #__PURE__ */ function() {
    function Lazy() {}
    Lazy.value = new Lazy();
    return Lazy;
}();
var $a591d06baacc8fdb$export$e83dceb76bcd9724 = {
    show: function(v) {
        if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "Eager";
        if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "Lazy";
        throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 18, column 10 - line 20, column 19): " + [
            v.constructor.name
        ]);
    }
};
var $a591d06baacc8fdb$export$c2d084dc44961371 = function(v) {
    if (v instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return "eager";
    if (v instanceof $a591d06baacc8fdb$export$b624eff549462981) return "lazy";
    throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 30, column 9 - line 32, column 17): " + [
        v.constructor.name
    ]);
};
var $a591d06baacc8fdb$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "eager") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
    if (v === "lazy") return new $06733ae99ed4f534$export$8a67b48435b5d073($a591d06baacc8fdb$export$b624eff549462981.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $a591d06baacc8fdb$export$e32bcfaf2cb99de5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return true;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return true;
            return false;
        };
    }
};
var $a591d06baacc8fdb$export$d32ec4886a1d7587 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc && y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a591d06baacc8fdb$export$a4acc175556f6dbc) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a591d06baacc8fdb$export$b624eff549462981 && y instanceof $a591d06baacc8fdb$export$b624eff549462981) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLImageElement.Laziness (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a591d06baacc8fdb$export$e32bcfaf2cb99de5;
    }
};



var $29906668619f3a83$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $29906668619f3a83$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $29906668619f3a83$export$3ac708362c1f96eb = function(laziness) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$820843123ac3b9d)($a591d06baacc8fdb$export$c2d084dc44961371(laziness));
};
var $29906668619f3a83$export$fe0b2eeb59b63d00 = function(hint) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$533597f26ad51793)($becf597acb9365c5$export$c2d084dc44961371(hint));
};
var $29906668619f3a83$export$e7fd69f64f92856 = function(mode) {
    return $28d793bcad7b6401$export$6a301f847372dca1($4fb986a93dbcc125$export$15671bab5b2a825c)($ff8d4f0527bf7f56$export$c2d084dc44961371(mode));
};
var $29906668619f3a83$export$46c1c92549715335 = /* #__PURE__ */ function() {
    var $3 = $29906668619f3a83$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($a591d06baacc8fdb$export$a4acc175556f6dbc.value);
        return function($7) {
            return $6($a591d06baacc8fdb$export$98e6a39c04603d36($7));
        };
    }());
    var $4 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$c1978f45d5c8c1fd);
    return function($5) {
        return $3($4($5));
    };
}();
var $29906668619f3a83$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLImageElement");
var $29906668619f3a83$export$7b9cc1601c0b9c78 = /* #__PURE__ */ function() {
    var $8 = $29906668619f3a83$var$map(function() {
        var $11 = $06733ae99ed4f534$export$43db023a260c5e9f($becf597acb9365c5$export$6cc2e70440926d44.value);
        return function($12) {
            return $11($becf597acb9365c5$export$98e6a39c04603d36($12));
        };
    }());
    var $9 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$8774eb0dcbbe3146);
    return function($10) {
        return $8($9($10));
    };
}();
var $29906668619f3a83$export$c47cb7c63271266e = /* #__PURE__ */ function() {
    var $13 = $29906668619f3a83$var$map($70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377)($ff8d4f0527bf7f56$export$98e6a39c04603d36)($0a5aaf95f168428e$export$1ba013b88f4f21f3));
    var $14 = $28d793bcad7b6401$export$84baa7a1ea5377fd($4fb986a93dbcc125$export$2a95876eedf9defd);
    return function($15) {
        return $13($14($15));
    };
}();
var $29906668619f3a83$export$20f9c2173df486a8 = $4fb986a93dbcc125$export$11b6d15e47fb61cf;


// Generated by purs version 0.15.16
function $22cc4a9f2b8eb096$export$73f57eecff448cc8(input) {
    return function() {
        return input.accept;
    };
}
function $22cc4a9f2b8eb096$export$b20dfae471de8dc1(accept) {
    return function(input) {
        return function() {
            input.accept = accept;
        };
    };
}
function $22cc4a9f2b8eb096$export$228be17d80722ab(input) {
    return function() {
        return input.alt;
    };
}
function $22cc4a9f2b8eb096$export$14a0e7c2e6152665(alt) {
    return function(input) {
        return function() {
            input.alt = alt;
        };
    };
}
function $22cc4a9f2b8eb096$export$485ded5f26ebe08d(input) {
    return function() {
        return input.autocomplete;
    };
}
function $22cc4a9f2b8eb096$export$5fb7c729919301a5(autocomplete) {
    return function(input) {
        return function() {
            input.autocomplete = autocomplete;
        };
    };
}
function $22cc4a9f2b8eb096$export$4c47992fc278c9a0(input) {
    return function() {
        return input.autofocus;
    };
}
function $22cc4a9f2b8eb096$export$db2bbdcbda3d335e(autofocus) {
    return function(input) {
        return function() {
            input.autofocus = autofocus;
        };
    };
}
function $22cc4a9f2b8eb096$export$8f49a7e9e3141ccc(input) {
    return function() {
        return input.defaultChecked;
    };
}
function $22cc4a9f2b8eb096$export$63092561e9c9bec4(defaultChecked) {
    return function(input) {
        return function() {
            input.defaultChecked = defaultChecked;
        };
    };
}
function $22cc4a9f2b8eb096$export$b96bb35bc88d6fa(input) {
    return function() {
        return input.checked;
    };
}
function $22cc4a9f2b8eb096$export$d2270ed72c00a9b2(checked) {
    return function(input) {
        return function() {
            input.checked = checked;
        };
    };
}
function $22cc4a9f2b8eb096$export$9ebb36ddc946da55(input) {
    return function() {
        return input.dirName;
    };
}
function $22cc4a9f2b8eb096$export$e2460e55089b163d(dirName) {
    return function(input) {
        return function() {
            input.dirName = dirName;
        };
    };
}
function $22cc4a9f2b8eb096$export$683472f6198a076e(input) {
    return function() {
        return input.disabled;
    };
}
function $22cc4a9f2b8eb096$export$4532d31cef66d703(disabled) {
    return function(input) {
        return function() {
            input.disabled = disabled;
        };
    };
}
function $22cc4a9f2b8eb096$export$242c63e9758836c2(input) {
    return function() {
        return input.form;
    };
}
function $22cc4a9f2b8eb096$export$92d18e9db2d4e896(input) {
    return function() {
        return input.files;
    };
}
function $22cc4a9f2b8eb096$export$7e4d70bab1b5c4a0(input) {
    return function() {
        return input.formAction;
    };
}
function $22cc4a9f2b8eb096$export$577bb1d64e4c83b9(formAction) {
    return function(input) {
        return function() {
            input.formAction = formAction;
        };
    };
}
function $22cc4a9f2b8eb096$export$21f1c8008acfa9c0(input) {
    return function() {
        return input.formEnctype;
    };
}
function $22cc4a9f2b8eb096$export$346989dcff4ba18b(formEnctype) {
    return function(input) {
        return function() {
            input.formEnctype = formEnctype;
        };
    };
}
function $22cc4a9f2b8eb096$export$3f1ffee261a00124(input) {
    return function() {
        return input.formMethod;
    };
}
function $22cc4a9f2b8eb096$export$c38a1a871bb0e145(formMethod) {
    return function(input) {
        return function() {
            input.formMethod = formMethod;
        };
    };
}
function $22cc4a9f2b8eb096$export$87c857905fcc4a84(input) {
    return function() {
        return input.formNoValidate;
    };
}
function $22cc4a9f2b8eb096$export$ad9ff32d0af51586(formNoValidate) {
    return function(input) {
        return function() {
            input.formNoValidate = formNoValidate;
        };
    };
}
function $22cc4a9f2b8eb096$export$497949a0ae76184f(input) {
    return function() {
        return input.formTarget;
    };
}
function $22cc4a9f2b8eb096$export$4c7e983548149eb5(formTarget) {
    return function(input) {
        return function() {
            input.formTarget = formTarget;
        };
    };
}
function $22cc4a9f2b8eb096$export$ac607276a8fe9f0a(input) {
    return function() {
        return input.height;
    };
}
function $22cc4a9f2b8eb096$export$3f31360357be44e4(height) {
    return function(input) {
        return function() {
            input.height = height;
        };
    };
}
function $22cc4a9f2b8eb096$export$5a1fde3dfe3b3c2a(input) {
    return function() {
        return input.indeterminate;
    };
}
function $22cc4a9f2b8eb096$export$52735f1bbb810b6(indeterminate) {
    return function(input) {
        return function() {
            input.indeterminate = indeterminate;
        };
    };
}
function $22cc4a9f2b8eb096$export$8932efb87fe83757(input) {
    return function() {
        return input.list;
    };
}
function $22cc4a9f2b8eb096$export$8960430cfd85939f(input) {
    return function() {
        return input.max;
    };
}
function $22cc4a9f2b8eb096$export$b03015b7eb8a4a0d(max) {
    return function(input) {
        return function() {
            input.max = max;
        };
    };
}
function $22cc4a9f2b8eb096$export$c9f461152c658a8b(input) {
    return function() {
        return input.maxLength;
    };
}
function $22cc4a9f2b8eb096$export$45077a575ddd961f(maxLength) {
    return function(input) {
        return function() {
            input.maxLength = maxLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$96ec731ed4dcb222(input) {
    return function() {
        return input.min;
    };
}
function $22cc4a9f2b8eb096$export$46d199234e678744(min) {
    return function(input) {
        return function() {
            input.min = min;
        };
    };
}
function $22cc4a9f2b8eb096$export$8fe860a115a1e636(input) {
    return function() {
        return input.minLength;
    };
}
function $22cc4a9f2b8eb096$export$2b867239766ba1e3(minLength) {
    return function(input) {
        return function() {
            input.minLength = minLength;
        };
    };
}
function $22cc4a9f2b8eb096$export$939ddaa3205df08e(input) {
    return function() {
        return input.multiple;
    };
}
function $22cc4a9f2b8eb096$export$be7c7381b31f2269(multiple) {
    return function(input) {
        return function() {
            input.multiple = multiple;
        };
    };
}
function $22cc4a9f2b8eb096$export$a8ff84c12d48cfa6(input) {
    return function() {
        return input.name;
    };
}
function $22cc4a9f2b8eb096$export$6cf3d710d3a367e5(name) {
    return function(input) {
        return function() {
            input.name = name;
        };
    };
}
function $22cc4a9f2b8eb096$export$24f82734ea047e6f(input) {
    return function() {
        return input.pattern;
    };
}
function $22cc4a9f2b8eb096$export$faed90dbedc3b6d5(pattern) {
    return function(input) {
        return function() {
            input.pattern = pattern;
        };
    };
}
function $22cc4a9f2b8eb096$export$c7187bbd1a7a9244(input) {
    return function() {
        return input.placeholder;
    };
}
function $22cc4a9f2b8eb096$export$645bf5697adfa088(placeholder) {
    return function(input) {
        return function() {
            input.placeholder = placeholder;
        };
    };
}
function $22cc4a9f2b8eb096$export$b2cbc93d4da94977(input) {
    return function() {
        return input.readOnly;
    };
}
function $22cc4a9f2b8eb096$export$62311ce54ddfc862(readOnly) {
    return function(input) {
        return function() {
            input.readOnly = readOnly;
        };
    };
}
function $22cc4a9f2b8eb096$export$a7a0278c004aac3f(input) {
    return function() {
        return input.required;
    };
}
function $22cc4a9f2b8eb096$export$47f9362469f346c4(required) {
    return function(input) {
        return function() {
            input.required = required;
        };
    };
}
function $22cc4a9f2b8eb096$export$346677f925de839c(input) {
    return function() {
        return input.size;
    };
}
function $22cc4a9f2b8eb096$export$1c70a6cc12bc0366(size) {
    return function(input) {
        return function() {
            input.size = size;
        };
    };
}
function $22cc4a9f2b8eb096$export$2e40c9e35e9506f4(input) {
    return function() {
        return input.src;
    };
}
function $22cc4a9f2b8eb096$export$5771e3a4c80da7df(src) {
    return function(input) {
        return function() {
            input.src = src;
        };
    };
}
function $22cc4a9f2b8eb096$export$35d34bc0ed591a92(input) {
    return function() {
        return input.step;
    };
}
function $22cc4a9f2b8eb096$export$5305615f76bbd5b5(step) {
    return function(input) {
        return function() {
            input.step = step;
        };
    };
}
function $22cc4a9f2b8eb096$export$d4a6a4db5b31e621(input) {
    return function() {
        return input.type;
    };
}
function $22cc4a9f2b8eb096$export$1bf7f05044e9c5cb(type) {
    return function(input) {
        return function() {
            input.type = type;
        };
    };
}
function $22cc4a9f2b8eb096$export$1a01ae0705bafd37(input) {
    return function() {
        return input.defaultValue;
    };
}
function $22cc4a9f2b8eb096$export$d8becbd7468e206f(defaultValue) {
    return function(input) {
        return function() {
            input.defaultValue = defaultValue;
        };
    };
}
function $22cc4a9f2b8eb096$export$2ab9a8f9f1186f14(input) {
    return function() {
        return input.value;
    };
}
function $22cc4a9f2b8eb096$export$80746c6bc6142fc8(value) {
    return function(input) {
        return function() {
            input.value = value;
        };
    };
}
function $22cc4a9f2b8eb096$export$f0d0381422fe3a76(input) {
    return function() {
        return input.valueAsDate;
    };
}
function $22cc4a9f2b8eb096$export$8dfa787857729211(valueAsDate) {
    return function(input) {
        return function() {
            input.valueAsDate = valueAsDate;
        };
    };
}
function $22cc4a9f2b8eb096$export$3e66e4a199ac841d(input) {
    return function() {
        return input.valueAsNumber;
    };
}
function $22cc4a9f2b8eb096$export$4f64bca7327fe0dc(valueAsNumber) {
    return function(input) {
        return function() {
            input.valueAsNumber = valueAsNumber;
        };
    };
}
function $22cc4a9f2b8eb096$export$7e3df82ee760448c(input) {
    return function() {
        return input.width;
    };
}
function $22cc4a9f2b8eb096$export$67f48e0594af05d(width) {
    return function(input) {
        return function() {
            input.width = width;
        };
    };
}
function $22cc4a9f2b8eb096$export$801b713d5ecf6e3f(n) {
    return function(input) {
        return function() {
            input.stepUp(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$228be912dbc8075f(n) {
    return function(input) {
        return function() {
            input.stepDown(n);
        };
    };
}
function $22cc4a9f2b8eb096$export$5e55a9e709e8e020(input) {
    return function() {
        return input.willValidate;
    };
}
function $22cc4a9f2b8eb096$export$1bdd3f9a89b22594(input) {
    return function() {
        return input.validity;
    };
}
function $22cc4a9f2b8eb096$export$6ee4201e37a931e2(input) {
    return function() {
        return input.validationMessage;
    };
}
function $22cc4a9f2b8eb096$export$50d70f8cedc54453(input) {
    return function() {
        return input.checkValidity();
    };
}
function $22cc4a9f2b8eb096$export$b962d864c477cc49(input) {
    return function() {
        return input.reportValidity();
    };
}
function $22cc4a9f2b8eb096$export$6f569cb704992105(value) {
    return function(input) {
        return function() {
            input.setCustomValidity(value);
        };
    };
}
function $22cc4a9f2b8eb096$export$a238cb463698c900(input) {
    return function() {
        return input.labels;
    };
}
function $22cc4a9f2b8eb096$export$2e6c959c16ff56b8(input) {
    return function() {
        input.select();
    };
}
function $22cc4a9f2b8eb096$export$5e2f617ae845fb63(input) {
    return function() {
        return input.selectionStart;
    };
}
function $22cc4a9f2b8eb096$export$47b9c21811f199bd(selectionStart) {
    return function(input) {
        return function() {
            input.selectionStart = selectionStart;
        };
    };
}
function $22cc4a9f2b8eb096$export$1028be563f1155b2(input) {
    return function() {
        return input.selectionEnd;
    };
}
function $22cc4a9f2b8eb096$export$15d012c6be3c352(selectionEnd) {
    return function(input) {
        return function() {
            input.selectionEnd = selectionEnd;
        };
    };
}
function $22cc4a9f2b8eb096$export$b4e8aad052258154(input) {
    return function() {
        return input.selectionDirection;
    };
}
function $22cc4a9f2b8eb096$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(input) {
        return function() {
            input.selectionDirection = selectionDirection;
        };
    };
}
function $22cc4a9f2b8eb096$export$2add2a46d1c1d557(replacement) {
    return function(input) {
        return function() {
            input.setRangeText(replacement);
        };
    };
}
function $22cc4a9f2b8eb096$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $22cc4a9f2b8eb096$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(input) {
                return function() {
                    input.setSelectionRange(start, end, direction, input);
                };
            };
        };
    };
}






// Generated by purs version 0.15.16


var $c09a3e7cfbb6a57f$export$8163af2a41fbee7 = /* #__PURE__ */ function() {
    function Preserve() {}
    Preserve.value = new Preserve();
    return Preserve;
}();
var $c09a3e7cfbb6a57f$export$ef9b1a59e592288f = /* #__PURE__ */ function() {
    function Select() {}
    Select.value = new Select();
    return Select;
}();
var $c09a3e7cfbb6a57f$export$568b89e600fc77eb = /* #__PURE__ */ function() {
    function Start() {}
    Start.value = new Start();
    return Start;
}();
var $c09a3e7cfbb6a57f$export$290d774e6bd35c9a = /* #__PURE__ */ function() {
    function End() {}
    End.value = new End();
    return End;
}();
var $c09a3e7cfbb6a57f$export$7e20bbef4bce8df9 = {
    show: function(v) {
        if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "Preserve";
        if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "Select";
        if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "Start";
        if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "End";
        throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 17, column 10 - line 21, column 17): " + [
            v.constructor.name
        ]);
    }
};
var $c09a3e7cfbb6a57f$export$c2d084dc44961371 = function(v) {
    if (v instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return "preserve";
    if (v instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return "select";
    if (v instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return "start";
    if (v instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return "end";
    throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 32, column 9 - line 36, column 15): " + [
        v.constructor.name
    ]);
};
var $c09a3e7cfbb6a57f$export$98e6a39c04603d36 = function(v) {
    if (v === "preserve") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$8163af2a41fbee7.value);
    if (v === "select") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$ef9b1a59e592288f.value);
    if (v === "start") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$568b89e600fc77eb.value);
    if (v === "end") return new $06733ae99ed4f534$export$8a67b48435b5d073($c09a3e7cfbb6a57f$export$290d774e6bd35c9a.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return true;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return true;
            return false;
        };
    }
};
var $c09a3e7cfbb6a57f$export$81b0e65721ff4cca = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7 && y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$8163af2a41fbee7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f && y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$ef9b1a59e592288f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb && y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c09a3e7cfbb6a57f$export$568b89e600fc77eb) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a && y instanceof $c09a3e7cfbb6a57f$export$290d774e6bd35c9a) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.SelectionMode (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c09a3e7cfbb6a57f$export$b299fa6c3cca1ee7;
    }
};



var $dbc3cf4ed216a106$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $dbc3cf4ed216a106$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dbc3cf4ed216a106$export$daa292563bc4c5ef = $22cc4a9f2b8eb096$export$801b713d5ecf6e3f;
var $dbc3cf4ed216a106$export$218b3ebffb5cc7e4 = /* #__PURE__ */ $dbc3cf4ed216a106$export$daa292563bc4c5ef(1);
var $dbc3cf4ed216a106$export$6dd86ef1ac84105c = $22cc4a9f2b8eb096$export$228be912dbc8075f;
var $dbc3cf4ed216a106$export$d45ac0df5909f3e5 = /* #__PURE__ */ $dbc3cf4ed216a106$export$6dd86ef1ac84105c(1);
var $dbc3cf4ed216a106$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $22cc4a9f2b8eb096$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $dbc3cf4ed216a106$export$8837f4fc672e936d = /* #__PURE__ */ function() {
    var $2 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($22cc4a9f2b8eb096$export$8932efb87fe83757($3));
    };
}();
var $dbc3cf4ed216a106$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLInputElement");
var $dbc3cf4ed216a106$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $4 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($22cc4a9f2b8eb096$export$242c63e9758836c2($5));
    };
}();
var $dbc3cf4ed216a106$export$3a444357c5f65f65 = /* #__PURE__ */ function() {
    var $6 = $dbc3cf4ed216a106$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($22cc4a9f2b8eb096$export$92d18e9db2d4e896($7));
    };
}();


// Generated by purs version 0.15.16
function $3aa32ab13deeb208$export$4c47992fc278c9a0(keygen) {
    return function() {
        return keygen.autofocus;
    };
}
function $3aa32ab13deeb208$export$db2bbdcbda3d335e(autofocus) {
    return function(keygen) {
        return function() {
            keygen.autofocus = autofocus;
        };
    };
}
function $3aa32ab13deeb208$export$1cb6aab4c63c6c51(keygen) {
    return function() {
        return keygen.challenge;
    };
}
function $3aa32ab13deeb208$export$e4ab94f6a56193a3(challenge) {
    return function(keygen) {
        return function() {
            keygen.challenge = challenge;
        };
    };
}
function $3aa32ab13deeb208$export$683472f6198a076e(keygen) {
    return function() {
        return keygen.disabled;
    };
}
function $3aa32ab13deeb208$export$4532d31cef66d703(disabled) {
    return function(keygen) {
        return function() {
            keygen.disabled = disabled;
        };
    };
}
function $3aa32ab13deeb208$export$242c63e9758836c2(keygen) {
    return function() {
        return keygen.form;
    };
}
function $3aa32ab13deeb208$export$63e1099bcd6b827d(keygen) {
    return function() {
        return keygen.keytype;
    };
}
function $3aa32ab13deeb208$export$d04d7126b9e1b9(keytype) {
    return function(keygen) {
        return function() {
            keygen.keytype = keytype;
        };
    };
}
function $3aa32ab13deeb208$export$a8ff84c12d48cfa6(keygen) {
    return function() {
        return keygen.name;
    };
}
function $3aa32ab13deeb208$export$6cf3d710d3a367e5(name) {
    return function(keygen) {
        return function() {
            keygen.name = name;
        };
    };
}
function $3aa32ab13deeb208$export$d4a6a4db5b31e621(keygen) {
    return function() {
        return keygen.type;
    };
}
function $3aa32ab13deeb208$export$5e55a9e709e8e020(keygen) {
    return function() {
        return keygen.willValidate;
    };
}
function $3aa32ab13deeb208$export$1bdd3f9a89b22594(keygen) {
    return function() {
        return keygen.validity;
    };
}
function $3aa32ab13deeb208$export$6ee4201e37a931e2(keygen) {
    return function() {
        return keygen.validationMessage;
    };
}
function $3aa32ab13deeb208$export$50d70f8cedc54453(keygen) {
    return function() {
        return keygen.checkValidity();
    };
}
function $3aa32ab13deeb208$export$b962d864c477cc49(keygen) {
    return function() {
        return keygen.reportValidity();
    };
}
function $3aa32ab13deeb208$export$6f569cb704992105(value) {
    return function(keygen) {
        return function() {
            keygen.setCustomValidity(value);
        };
    };
}
function $3aa32ab13deeb208$export$a238cb463698c900(keygen) {
    return function() {
        return keygen.labels;
    };
}







var $35aecd379c08dc0f$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $35aecd379c08dc0f$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLKeygenElement");
var $35aecd379c08dc0f$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($3aa32ab13deeb208$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $f247ebfc04032388$export$2ab9a8f9f1186f14(li) {
    return function() {
        return li.value;
    };
}
function $f247ebfc04032388$export$80746c6bc6142fc8(value) {
    return function(li) {
        return function() {
            li.value = value;
        };
    };
}




var $46bf88ea94d3504e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $46bf88ea94d3504e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");
var $46bf88ea94d3504e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLIElement");


// Generated by purs version 0.15.16
function $8772cd4a9c558251$export$242c63e9758836c2(label) {
    return function() {
        return label.form;
    };
}
function $8772cd4a9c558251$export$35d9e1c947946090(label) {
    return function() {
        return label.htmlFor;
    };
}
function $8772cd4a9c558251$export$a6c638cfae205843(htmlFor) {
    return function(label) {
        return function() {
            label.htmlFor = htmlFor;
        };
    };
}
function $8772cd4a9c558251$export$317fb27ad464e186(label) {
    return function() {
        return label.control;
    };
}







var $ba933b3d44ed7c03$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $ba933b3d44ed7c03$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ba933b3d44ed7c03$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLabelElement");
var $ba933b3d44ed7c03$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($8772cd4a9c558251$export$242c63e9758836c2($3));
    };
}();
var $ba933b3d44ed7c03$export$b5cde1de278b4330 = /* #__PURE__ */ function() {
    var $4 = $ba933b3d44ed7c03$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($8772cd4a9c558251$export$317fb27ad464e186($5));
    };
}();


// Generated by purs version 0.15.16
function $5013c6f6daaea1f9$export$242c63e9758836c2(le) {
    return function() {
        return le.form;
    };
}







var $396c0721c94d9624$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $396c0721c94d9624$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLegendElement");
var $396c0721c94d9624$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($5013c6f6daaea1f9$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $00356bd5e80c6412$export$683472f6198a076e(link) {
    return function() {
        return link.disabled;
    };
}
function $00356bd5e80c6412$export$4532d31cef66d703(disabled) {
    return function(link) {
        return function() {
            link.disabled = disabled;
        };
    };
}
function $00356bd5e80c6412$export$8f51af5840e0602a(link) {
    return function() {
        return link.href;
    };
}
function $00356bd5e80c6412$export$428f6e77b5a5a669(href) {
    return function(link) {
        return function() {
            link.href = href;
        };
    };
}
function $00356bd5e80c6412$export$c47cb7c63271266e(link) {
    return function() {
        return link.crossOrigin;
    };
}
function $00356bd5e80c6412$export$e7fd69f64f92856(crossOrigin) {
    return function(link) {
        return function() {
            link.crossOrigin = crossOrigin;
        };
    };
}
function $00356bd5e80c6412$export$bad408f43b005bc8(link) {
    return function() {
        return link.rel;
    };
}
function $00356bd5e80c6412$export$9e86d1af7d63c52c(rel) {
    return function(link) {
        return function() {
            link.rel = rel;
        };
    };
}
function $00356bd5e80c6412$export$edb1c8e715f3944e(link) {
    return function() {
        return link.rev;
    };
}
function $00356bd5e80c6412$export$671b41179a9f15fb(rev) {
    return function(link) {
        return function() {
            link.rev = rev;
        };
    };
}
function $00356bd5e80c6412$export$5884a0b424dd5ef2(link) {
    return function() {
        return link.relList;
    };
}
function $00356bd5e80c6412$export$987d49ffe1b0900f(link) {
    return function() {
        return link.media;
    };
}
function $00356bd5e80c6412$export$5c1855deea651e41(media) {
    return function(link) {
        return function() {
            link.media = media;
        };
    };
}
function $00356bd5e80c6412$export$4bf4138386d6b8cc(link) {
    return function() {
        return link.hreflang;
    };
}
function $00356bd5e80c6412$export$17b5334c80252e15(hreflang) {
    return function(link) {
        return function() {
            link.hreflang = hreflang;
        };
    };
}
function $00356bd5e80c6412$export$d4a6a4db5b31e621(link) {
    return function() {
        return link.type;
    };
}
function $00356bd5e80c6412$export$1bf7f05044e9c5cb(type) {
    return function(link) {
        return function() {
            link.type = type;
        };
    };
}




var $66527c1ba968c066$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $66527c1ba968c066$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");
var $66527c1ba968c066$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLLinkElement");


// Generated by purs version 0.15.16
function $5dbae6eb2b9d7a07$export$a8ff84c12d48cfa6(map) {
    return function() {
        return map.name;
    };
}
function $5dbae6eb2b9d7a07$export$6cf3d710d3a367e5(name) {
    return function(map) {
        return function() {
            map.name = name;
        };
    };
}
function $5dbae6eb2b9d7a07$export$4bdc600e2ccf60d6(map) {
    return function() {
        return map.areas;
    };
}
function $5dbae6eb2b9d7a07$export$6c746a5570b8b35c(map) {
    return function() {
        return map.images;
    };
}




var $55159de58cd7500d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $55159de58cd7500d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");
var $55159de58cd7500d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMapElement");


// Generated by purs version 0.15.16
function $67f0fc7db8c638cb$export$2e40c9e35e9506f4(media) {
    return function() {
        return media.src;
    };
}
function $67f0fc7db8c638cb$export$5771e3a4c80da7df(src) {
    return function(media) {
        return function() {
            media.src = src;
        };
    };
}
function $67f0fc7db8c638cb$export$22e7408040d24cb8(media) {
    return function() {
        return media.currentSrc;
    };
}
function $67f0fc7db8c638cb$export$c47cb7c63271266e(media) {
    return function() {
        return media.crossOrigin;
    };
}
function $67f0fc7db8c638cb$export$e7fd69f64f92856(crossOrigin) {
    return function(media) {
        return function() {
            media.crossOrigin = crossOrigin;
        };
    };
}
function $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(media) {
    return media.networkState;
}
function $67f0fc7db8c638cb$export$513ccb98c53b8039(media) {
    return function() {
        return media.preload;
    };
}
function $67f0fc7db8c638cb$export$f6b3982121e869a(preload) {
    return function(media) {
        return function() {
            media.preload = preload;
        };
    };
}
function $67f0fc7db8c638cb$export$11e63f7b0f3d9900(media) {
    return function() {
        return media.load();
    };
}
function $67f0fc7db8c638cb$export$1a796126c2303a8(type, media) {
    return media.canPlayType(type);
}
function $67f0fc7db8c638cb$export$4bf8a366db6a678b(media) {
    return media.readyState;
}
function $67f0fc7db8c638cb$export$c8243f3943339030(media) {
    return function() {
        return media.seeking;
    };
}
function $67f0fc7db8c638cb$export$283f641d6ed1ac80(media) {
    return function() {
        return media.currentTime;
    };
}
function $67f0fc7db8c638cb$export$428d94eac67f5311(currentTime) {
    return function(media) {
        return function() {
            media.currentTime = currentTime;
        };
    };
}
function $67f0fc7db8c638cb$export$1f34108aa9eb96ab(media) {
    return function() {
        return media.duration;
    };
}
function $67f0fc7db8c638cb$export$3ee8fbdbeceaef0e(media) {
    return function() {
        return media.getStartDate();
    };
}
function $67f0fc7db8c638cb$export$cd215b91700bbebc(media) {
    return function() {
        return media.paused;
    };
}
function $67f0fc7db8c638cb$export$388da195c50bfd17(media) {
    return function() {
        return media.defaultPlaybackRate;
    };
}
function $67f0fc7db8c638cb$export$6fa34934a59a9a1(defaultPlaybackRate) {
    return function(media) {
        return function() {
            media.defaultPlaybackRate = defaultPlaybackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$6d7f3930b8041bc4(media) {
    return function() {
        return media.playbackRate;
    };
}
function $67f0fc7db8c638cb$export$3f48445a0d32edb0(playbackRate) {
    return function(media) {
        return function() {
            media.playbackRate = playbackRate;
        };
    };
}
function $67f0fc7db8c638cb$export$999b7b72c79021f2(media) {
    return function() {
        return media.ended;
    };
}
function $67f0fc7db8c638cb$export$b243096046abd58(media) {
    return function() {
        return media.autoplay;
    };
}
function $67f0fc7db8c638cb$export$7a98ea7b6e6b2d36(autoplay) {
    return function(media) {
        return function() {
            media.autoplay = autoplay;
        };
    };
}
function $67f0fc7db8c638cb$export$f9ef67375ddc185(media) {
    return function() {
        return media.loop;
    };
}
function $67f0fc7db8c638cb$export$cf50c2db8dc11f8e(loop) {
    return function(media) {
        return function() {
            media.loop = loop;
        };
    };
}
function $67f0fc7db8c638cb$export$899fbdb5fa08b653(media) {
    return function() {
        media.play();
    };
}
function $67f0fc7db8c638cb$export$229c72e5fdee233b(media) {
    return function() {
        media.pause();
    };
}
function $67f0fc7db8c638cb$export$2855e964765eac9(media) {
    return function() {
        return media.mediaGroup;
    };
}
function $67f0fc7db8c638cb$export$2c8be4634a501ac1(mediaGroup) {
    return function(media) {
        return function() {
            media.mediaGroup = mediaGroup;
        };
    };
}
function $67f0fc7db8c638cb$export$cc1adf6fb659c762(media) {
    return function() {
        return media.controls;
    };
}
function $67f0fc7db8c638cb$export$891f55ce9f9e8605(controls) {
    return function(media) {
        return function() {
            media.controls = controls;
        };
    };
}
function $67f0fc7db8c638cb$export$7714b48ed08b13f2(media) {
    return function() {
        return media.volume;
    };
}
function $67f0fc7db8c638cb$export$246e658b67178cb0(volume) {
    return function(media) {
        return function() {
            media.volume = volume;
        };
    };
}
function $67f0fc7db8c638cb$export$987a4e3838aef8c6(media) {
    return function() {
        return media.muted;
    };
}
function $67f0fc7db8c638cb$export$a1680ba91cc9be33(muted) {
    return function(media) {
        return function() {
            media.muted = muted;
        };
    };
}
function $67f0fc7db8c638cb$export$4c9bd91015e50a76(media) {
    return function() {
        return media.defaultMuted;
    };
}
function $67f0fc7db8c638cb$export$a203b6be5128443d(defaultMuted) {
    return function(media) {
        return function() {
            media.defaultMuted = defaultMuted;
        };
    };
}







// Generated by purs version 0.15.16


var $0a45d905703115c9$export$fadaed88e803a5ce = /* #__PURE__ */ function() {
    function Unspecified() {}
    Unspecified.value = new Unspecified();
    return Unspecified;
}();
var $0a45d905703115c9$export$ad3bd6e4e1ec5d06 = /* #__PURE__ */ function() {
    function Maybe() {}
    Maybe.value = new Maybe();
    return Maybe;
}();
var $0a45d905703115c9$export$1fa2c133480c0d67 = /* #__PURE__ */ function() {
    function Probably() {}
    Probably.value = new Probably();
    return Probably;
}();
var $0a45d905703115c9$export$639d66421832ff11 = {
    show: function(v) {
        if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "Unspecified";
        if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "Maybe";
        if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "Probably";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 16, column 10 - line 19, column 27): " + [
            v.constructor.name
        ]);
    }
};
var $0a45d905703115c9$export$c2d084dc44961371 = function(v) {
    if (v instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return "";
    if (v instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return "maybe";
    if (v instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return "probably";
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 29, column 9 - line 32, column 25): " + [
        v.constructor.name
    ]);
};
var $0a45d905703115c9$export$98e6a39c04603d36 = function(v) {
    if (v === "") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$fadaed88e803a5ce.value);
    if (v === "maybe") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$ad3bd6e4e1ec5d06.value);
    if (v === "probably") return new $06733ae99ed4f534$export$8a67b48435b5d073($0a45d905703115c9$export$1fa2c133480c0d67.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $0a45d905703115c9$export$34fdecd70907479d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return true;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return true;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return true;
            return false;
        };
    }
};
var $0a45d905703115c9$export$dbc9bfdb74d43b21 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce && y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$fadaed88e803a5ce) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06 && y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $0a45d905703115c9$export$ad3bd6e4e1ec5d06) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $0a45d905703115c9$export$1fa2c133480c0d67 && y instanceof $0a45d905703115c9$export$1fa2c133480c0d67) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.CanPlayType (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $0a45d905703115c9$export$34fdecd70907479d;
    }
};


// Generated by purs version 0.15.16



var $c7b3b04bec1e8e92$export$1f74963c34e8bfec = /* #__PURE__ */ function() {
    function Empty() {}
    Empty.value = new Empty();
    return Empty;
}();
var $c7b3b04bec1e8e92$export$5407f8fd4e62a93 = /* #__PURE__ */ function() {
    function Idle() {}
    Idle.value = new Idle();
    return Idle;
}();
var $c7b3b04bec1e8e92$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $c7b3b04bec1e8e92$export$9f99d34709abd9bc = /* #__PURE__ */ function() {
    function NoSource() {}
    NoSource.value = new NoSource();
    return NoSource;
}();
var $c7b3b04bec1e8e92$var$toEnumNetworkState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$5407f8fd4e62a93.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$669f6ea7d267feaf.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($c7b3b04bec1e8e92$export$9f99d34709abd9bc.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $c7b3b04bec1e8e92$export$6dde42aa2c503bde = {
    show: function(v) {
        if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return "Empty";
        if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return "Idle";
        if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return "NoSource";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 30, column 1 - line 34, column 29): " + [
            v.constructor.name
        ]);
    }
};
var $c7b3b04bec1e8e92$var$fromEnumNetworkState = function(v) {
    if (v instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return 0;
    if (v instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return 1;
    if (v instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return 2;
    if (v instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 47, column 3 - line 51, column 18): " + [
        v.constructor.name
    ]);
};
var $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return true;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return true;
            return false;
        };
    }
};
var $c7b3b04bec1e8e92$export$dd5f9f1c18c12839 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec && y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$1f74963c34e8bfec) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93 && y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$5407f8fd4e62a93) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf && y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $c7b3b04bec1e8e92$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc && y instanceof $c7b3b04bec1e8e92$export$9f99d34709abd9bc) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.NetworkState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $c7b3b04bec1e8e92$export$a2cfa34e78ccc2f5;
    }
};
var $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($c7b3b04bec1e8e92$var$toEnumNetworkState)($c7b3b04bec1e8e92$var$fromEnumNetworkState),
    Ord0: function() {
        return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
    }
};
var $c7b3b04bec1e8e92$export$63a4f766ab578d95 = /* #__PURE__ */ function() {
    return {
        bottom: $c7b3b04bec1e8e92$export$1f74963c34e8bfec.value,
        top: $c7b3b04bec1e8e92$export$9f99d34709abd9bc.value,
        Ord0: function() {
            return $c7b3b04bec1e8e92$export$dd5f9f1c18c12839;
        }
    };
}();
var $c7b3b04bec1e8e92$export$19d342d9da2ba7a3 = {
    cardinality: 4,
    toEnum: $c7b3b04bec1e8e92$var$toEnumNetworkState,
    fromEnum: $c7b3b04bec1e8e92$var$fromEnumNetworkState,
    Bounded0: function() {
        return $c7b3b04bec1e8e92$export$63a4f766ab578d95;
    },
    Enum1: function() {
        return $c7b3b04bec1e8e92$export$e6f607f3cddfb3c1;
    }
};


// Generated by purs version 0.15.16



var $e0710ab4ffdb9869$export$aeb73cf127af2fad = /* #__PURE__ */ function() {
    function HaveNothing() {}
    HaveNothing.value = new HaveNothing();
    return HaveNothing;
}();
var $e0710ab4ffdb9869$export$e96d91cd125cf5ba = /* #__PURE__ */ function() {
    function HaveMetadata() {}
    HaveMetadata.value = new HaveMetadata();
    return HaveMetadata;
}();
var $e0710ab4ffdb9869$export$c416983dd5609b6e = /* #__PURE__ */ function() {
    function HaveCurrentData() {}
    HaveCurrentData.value = new HaveCurrentData();
    return HaveCurrentData;
}();
var $e0710ab4ffdb9869$export$3c862393aec03c72 = /* #__PURE__ */ function() {
    function HaveFutureData() {}
    HaveFutureData.value = new HaveFutureData();
    return HaveFutureData;
}();
var $e0710ab4ffdb9869$export$c0fee25792a80051 = /* #__PURE__ */ function() {
    function HaveEnoughData() {}
    HaveEnoughData.value = new HaveEnoughData();
    return HaveEnoughData;
}();
var $e0710ab4ffdb9869$var$toEnumReadyState = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$e96d91cd125cf5ba.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c416983dd5609b6e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$3c862393aec03c72.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($e0710ab4ffdb9869$export$c0fee25792a80051.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $e0710ab4ffdb9869$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return "HaveNothing";
        if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return "HaveMetadata";
        if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return "HaveCurrentData";
        if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return "HaveFutureData";
        if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return "HaveEnoughData";
        throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 31, column 1 - line 36, column 41): " + [
            v.constructor.name
        ]);
    }
};
var $e0710ab4ffdb9869$var$fromEnumReadyState = function(v) {
    if (v instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return 0;
    if (v instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return 1;
    if (v instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return 2;
    if (v instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return 3;
    if (v instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return 4;
    throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 50, column 3 - line 55, column 24): " + [
        v.constructor.name
    ]);
};
var $e0710ab4ffdb9869$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return true;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return true;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return true;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return true;
            return false;
        };
    }
};
var $e0710ab4ffdb9869$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad && y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$aeb73cf127af2fad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba && y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$e96d91cd125cf5ba) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e && y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$c416983dd5609b6e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72 && y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $e0710ab4ffdb9869$export$3c862393aec03c72) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $e0710ab4ffdb9869$export$c0fee25792a80051 && y instanceof $e0710ab4ffdb9869$export$c0fee25792a80051) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLMediaElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $e0710ab4ffdb9869$export$c71e02dcc13f94a6;
    }
};
var $e0710ab4ffdb9869$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($e0710ab4ffdb9869$var$toEnumReadyState)($e0710ab4ffdb9869$var$fromEnumReadyState),
    Ord0: function() {
        return $e0710ab4ffdb9869$export$6557947d538c3b81;
    }
};
var $e0710ab4ffdb9869$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $e0710ab4ffdb9869$export$aeb73cf127af2fad.value,
        top: $e0710ab4ffdb9869$export$c0fee25792a80051.value,
        Ord0: function() {
            return $e0710ab4ffdb9869$export$6557947d538c3b81;
        }
    };
}();
var $e0710ab4ffdb9869$export$94a641e970e969f9 = {
    cardinality: 5,
    toEnum: $e0710ab4ffdb9869$var$toEnumReadyState,
    fromEnum: $e0710ab4ffdb9869$var$fromEnumReadyState,
    Bounded0: function() {
        return $e0710ab4ffdb9869$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $e0710ab4ffdb9869$export$f705a14e9e99c6f0;
    }
};



var $01a0e25b259ac8ae$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $01a0e25b259ac8ae$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e0710ab4ffdb9869$export$94a641e970e969f9);
var $01a0e25b259ac8ae$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($c7b3b04bec1e8e92$export$19d342d9da2ba7a3);
var $01a0e25b259ac8ae$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $01a0e25b259ac8ae$export$1ae2b664eea77b7e = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $4 = $06733ae99ed4f534$export$43db023a260c5e9f($e0710ab4ffdb9869$export$aeb73cf127af2fad.value);
        return function($5) {
            return $4($01a0e25b259ac8ae$var$toEnum($5));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$4bf8a366db6a678b(el);
    });
};
var $01a0e25b259ac8ae$export$8ee3aa19592dce0d = function(el) {
    return $01a0e25b259ac8ae$var$map(function() {
        var $6 = $06733ae99ed4f534$export$43db023a260c5e9f($c7b3b04bec1e8e92$export$1f74963c34e8bfec.value);
        return function($7) {
            return $6($01a0e25b259ac8ae$var$toEnum1($7));
        };
    }())(function() {
        return $67f0fc7db8c638cb$export$145bdcc6d8d4a53d(el);
    });
};
var $01a0e25b259ac8ae$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMediaElement");
var $01a0e25b259ac8ae$export$2b5874dc653b656c = function(ty) {
    return function(el) {
        return $01a0e25b259ac8ae$var$map(function() {
            var $8 = $06733ae99ed4f534$export$43db023a260c5e9f($0a45d905703115c9$export$fadaed88e803a5ce.value);
            return function($9) {
                return $8($0a45d905703115c9$export$98e6a39c04603d36($9));
            };
        }())(function() {
            return $67f0fc7db8c638cb$export$1a796126c2303a8(ty, el);
        });
    };
};


// Generated by purs version 0.15.16
function $d825508ebfe0ea30$export$a8ff84c12d48cfa6(meta) {
    return function() {
        return meta.name;
    };
}
function $d825508ebfe0ea30$export$6cf3d710d3a367e5(name) {
    return function(meta) {
        return function() {
            meta.name = name;
        };
    };
}
function $d825508ebfe0ea30$export$725a8790b31857c5(meta) {
    return function() {
        return meta.httpEquiv;
    };
}
function $d825508ebfe0ea30$export$253f18aa71ab8120(httpEquiv) {
    return function(meta) {
        return function() {
            meta.httpEquiv = httpEquiv;
        };
    };
}
function $d825508ebfe0ea30$export$a7db06668cad9adb(meta) {
    return function() {
        return meta.content;
    };
}
function $d825508ebfe0ea30$export$431313f2afd011e2(content) {
    return function(meta) {
        return function() {
            meta.content = content;
        };
    };
}




var $2f7018ceaced9755$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $2f7018ceaced9755$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");
var $2f7018ceaced9755$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMetaElement");


// Generated by purs version 0.15.16
function $4054571ff23c1117$export$2ab9a8f9f1186f14(meter) {
    return function() {
        return meter.value;
    };
}
function $4054571ff23c1117$export$80746c6bc6142fc8(value) {
    return function(meter) {
        return function() {
            meter.value = value;
        };
    };
}
function $4054571ff23c1117$export$96ec731ed4dcb222(meter) {
    return function() {
        return meter.min;
    };
}
function $4054571ff23c1117$export$46d199234e678744(min) {
    return function(meter) {
        return function() {
            meter.min = min;
        };
    };
}
function $4054571ff23c1117$export$8960430cfd85939f(meter) {
    return function() {
        return meter.max;
    };
}
function $4054571ff23c1117$export$b03015b7eb8a4a0d(max) {
    return function(meter) {
        return function() {
            meter.max = max;
        };
    };
}
function $4054571ff23c1117$export$e81601c80b4e876e(meter) {
    return function() {
        return meter.low;
    };
}
function $4054571ff23c1117$export$8b78ab0b9863288b(low) {
    return function(meter) {
        return function() {
            meter.low = low;
        };
    };
}
function $4054571ff23c1117$export$7cb505ef3217a5c4(meter) {
    return function() {
        return meter.high;
    };
}
function $4054571ff23c1117$export$f4a8cfe80ee4d275(high) {
    return function(meter) {
        return function() {
            meter.high = high;
        };
    };
}
function $4054571ff23c1117$export$49f2954c623150dd(meter) {
    return function() {
        return meter.optimum;
    };
}
function $4054571ff23c1117$export$47b0039e9987ccc5(optimum) {
    return function(meter) {
        return function() {
            meter.optimum = optimum;
        };
    };
}
function $4054571ff23c1117$export$a238cb463698c900(meter) {
    return function() {
        return meter.labels;
    };
}




var $82f5a476dc04f459$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $82f5a476dc04f459$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");
var $82f5a476dc04f459$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLMeterElement");


// Generated by purs version 0.15.16
function $01bff2db061b962c$export$3035df57df42c31a(mod) {
    return function() {
        return mod.cite;
    };
}
function $01bff2db061b962c$export$86262a2b9f03fae3(cite) {
    return function(mod) {
        return function() {
            mod.cite = cite;
        };
    };
}
function $01bff2db061b962c$export$3a17bddce263fba0(mod) {
    return function() {
        return mod.dateTime;
    };
}
function $01bff2db061b962c$export$3a84b9eda98e95dc(dateTime) {
    return function(mod) {
        return function() {
            mod.dateTime = dateTime;
        };
    };
}




var $498acb025c9c8d86$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $498acb025c9c8d86$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");
var $498acb025c9c8d86$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLModElement");


// Generated by purs version 0.15.16
function $d6916e47721f2e71$export$e2239770db970295(ol) {
    return function() {
        return ol.reversed;
    };
}
function $d6916e47721f2e71$export$9c908e987b6cb694(reversed) {
    return function(ol) {
        return function() {
            ol.reversed = reversed;
        };
    };
}
function $d6916e47721f2e71$export$b3571188c770cc5a(ol) {
    return function() {
        return ol.start;
    };
}
function $d6916e47721f2e71$export$b61b8b027b966010(start) {
    return function(ol) {
        return function() {
            ol.start = start;
        };
    };
}
function $d6916e47721f2e71$export$d4a6a4db5b31e621(ol) {
    return function() {
        return ol.type;
    };
}
function $d6916e47721f2e71$export$1bf7f05044e9c5cb(type) {
    return function(ol) {
        return function() {
            ol.type = type;
        };
    };
}




var $a24ac5c57b03a069$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a24ac5c57b03a069$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");
var $a24ac5c57b03a069$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOListElement");


// Generated by purs version 0.15.16
function $909c91e6774cc50c$export$70ac1efc5b13b551(object) {
    return function() {
        return object.data;
    };
}
function $909c91e6774cc50c$export$3a6802af14bf5fa6(data) {
    return function(object) {
        return function() {
            object.data = data;
        };
    };
}
function $909c91e6774cc50c$export$d4a6a4db5b31e621(object) {
    return function() {
        return object.type;
    };
}
function $909c91e6774cc50c$export$1bf7f05044e9c5cb(type) {
    return function(object) {
        return function() {
            object.type = type;
        };
    };
}
function $909c91e6774cc50c$export$dc0b74bdecf765a4(object) {
    return function() {
        return object.typeMustMatch;
    };
}
function $909c91e6774cc50c$export$a8ff84c12d48cfa6(object) {
    return function() {
        return object.name;
    };
}
function $909c91e6774cc50c$export$6cf3d710d3a367e5(name) {
    return function(object) {
        return function() {
            object.name = name;
        };
    };
}
function $909c91e6774cc50c$export$86f8f9f08863e403(object) {
    return function() {
        return object.useMap;
    };
}
function $909c91e6774cc50c$export$ab416bdbb887640e(useMap) {
    return function(object) {
        return function() {
            object.useMap = useMap;
        };
    };
}
function $909c91e6774cc50c$export$242c63e9758836c2(object) {
    return function() {
        return object.form;
    };
}
function $909c91e6774cc50c$export$7e3df82ee760448c(object) {
    return function() {
        return object.width;
    };
}
function $909c91e6774cc50c$export$67f48e0594af05d(width) {
    return function(object) {
        return function() {
            object.width = width;
        };
    };
}
function $909c91e6774cc50c$export$ac607276a8fe9f0a(object) {
    return function() {
        return object.height;
    };
}
function $909c91e6774cc50c$export$3f31360357be44e4(height) {
    return function(object) {
        return function() {
            object.height = height;
        };
    };
}
function $909c91e6774cc50c$export$a51825c89fe24f94(object) {
    return function() {
        return object.contentDocument;
    };
}
function $909c91e6774cc50c$export$5e55a9e709e8e020(object) {
    return function() {
        return object.willValidate;
    };
}
function $909c91e6774cc50c$export$1bdd3f9a89b22594(object) {
    return function() {
        return object.validity;
    };
}
function $909c91e6774cc50c$export$6ee4201e37a931e2(object) {
    return function() {
        return object.validationMessage;
    };
}
function $909c91e6774cc50c$export$50d70f8cedc54453(object) {
    return function() {
        return object.checkValidity();
    };
}
function $909c91e6774cc50c$export$b962d864c477cc49(object) {
    return function() {
        return object.reportValidity();
    };
}
function $909c91e6774cc50c$export$6f569cb704992105(value) {
    return function(object) {
        return function() {
            object.setCustomValidity(value);
        };
    };
}







var $c9b6ae535f32e637$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $c9b6ae535f32e637$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c9b6ae535f32e637$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLObjectElement");
var $c9b6ae535f32e637$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($909c91e6774cc50c$export$242c63e9758836c2($3));
    };
}();
var $c9b6ae535f32e637$export$a186087d330c547b = /* #__PURE__ */ function() {
    var $4 = $c9b6ae535f32e637$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($909c91e6774cc50c$export$a51825c89fe24f94($5));
    };
}();


// Generated by purs version 0.15.16
function $b75c0419f3dc5c84$export$683472f6198a076e(optgroup) {
    return function() {
        return optgroup.disabled;
    };
}
function $b75c0419f3dc5c84$export$4532d31cef66d703(disabled) {
    return function(optgroup) {
        return function() {
            optgroup.disabled = disabled;
        };
    };
}
function $b75c0419f3dc5c84$export$1237798dc640739a(optgroup) {
    return function() {
        return optgroup.label;
    };
}
function $b75c0419f3dc5c84$export$4f65e594f6031297(label) {
    return function(optgroup) {
        return function() {
            optgroup.label = label;
        };
    };
}




var $c89958870ff6a525$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c89958870ff6a525$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");
var $c89958870ff6a525$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptGroupElement");


// Generated by purs version 0.15.16
function $e580fc0cf2be85d0$export$683472f6198a076e(option) {
    return function() {
        return option.disabled;
    };
}
function $e580fc0cf2be85d0$export$4532d31cef66d703(disabled) {
    return function(option) {
        return function() {
            option.disabled = disabled;
        };
    };
}
function $e580fc0cf2be85d0$export$242c63e9758836c2(option) {
    return function() {
        return option.form;
    };
}
function $e580fc0cf2be85d0$export$1237798dc640739a(option) {
    return function() {
        return option.label;
    };
}
function $e580fc0cf2be85d0$export$4f65e594f6031297(label) {
    return function(option) {
        return function() {
            option.label = label;
        };
    };
}
function $e580fc0cf2be85d0$export$63db087985f790e3(option) {
    return function() {
        return option.defaultSelected;
    };
}
function $e580fc0cf2be85d0$export$83d19b461d3b2ee7(defaultSelected) {
    return function(option) {
        return function() {
            option.defaultSelected = defaultSelected;
        };
    };
}
function $e580fc0cf2be85d0$export$d90250155de6d7e7(option) {
    return function() {
        return option.selected;
    };
}
function $e580fc0cf2be85d0$export$5a4818cec1656a71(selected) {
    return function(option) {
        return function() {
            option.selected = selected;
        };
    };
}
function $e580fc0cf2be85d0$export$2ab9a8f9f1186f14(option) {
    return function() {
        return option.value;
    };
}
function $e580fc0cf2be85d0$export$80746c6bc6142fc8(value) {
    return function(option) {
        return function() {
            option.value = value;
        };
    };
}
function $e580fc0cf2be85d0$export$6f093cfa640b7166(option) {
    return function() {
        return option.text;
    };
}
function $e580fc0cf2be85d0$export$cbe0d99836e1498f(text) {
    return function(option) {
        return function() {
            option.text = text;
        };
    };
}
function $e580fc0cf2be85d0$export$b610b8812bbcded9(option) {
    return function() {
        return option.index;
    };
}







var $18ef343036740bd3$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $18ef343036740bd3$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOptionElement");
var $18ef343036740bd3$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($e580fc0cf2be85d0$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $9bed875784302b3c$export$242c63e9758836c2(output) {
    return function() {
        return output.form;
    };
}
function $9bed875784302b3c$export$a8ff84c12d48cfa6(output) {
    return function() {
        return output.name;
    };
}
function $9bed875784302b3c$export$6cf3d710d3a367e5(name) {
    return function(output) {
        return function() {
            output.name = name;
        };
    };
}
function $9bed875784302b3c$export$d4a6a4db5b31e621(output) {
    return function() {
        return output.type;
    };
}
function $9bed875784302b3c$export$1a01ae0705bafd37(output) {
    return function() {
        return output.defaultValue;
    };
}
function $9bed875784302b3c$export$d8becbd7468e206f(defaultValue) {
    return function(output) {
        return function() {
            output.defaultValue = defaultValue;
        };
    };
}
function $9bed875784302b3c$export$2ab9a8f9f1186f14(output) {
    return function() {
        return output.value;
    };
}
function $9bed875784302b3c$export$80746c6bc6142fc8(value) {
    return function(output) {
        return function() {
            output.value = value;
        };
    };
}
function $9bed875784302b3c$export$5e55a9e709e8e020(output) {
    return function() {
        return output.willValidate;
    };
}
function $9bed875784302b3c$export$1bdd3f9a89b22594(output) {
    return function() {
        return output.validity;
    };
}
function $9bed875784302b3c$export$6ee4201e37a931e2(output) {
    return function() {
        return output.validationMessage;
    };
}
function $9bed875784302b3c$export$50d70f8cedc54453(output) {
    return function() {
        return output.checkValidity();
    };
}
function $9bed875784302b3c$export$b962d864c477cc49(output) {
    return function() {
        return output.reportValidity();
    };
}
function $9bed875784302b3c$export$6f569cb704992105(value) {
    return function(output) {
        return function() {
            output.setCustomValidity(value);
        };
    };
}
function $9bed875784302b3c$export$a238cb463698c900(output) {
    return function() {
        return output.labels;
    };
}







var $77afbd0210834ce4$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $77afbd0210834ce4$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLOutputElement");
var $77afbd0210834ce4$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($9bed875784302b3c$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16


var $caf6f82488ae8096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $caf6f82488ae8096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");
var $caf6f82488ae8096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParagraphElement");


// Generated by purs version 0.15.16
function $1c5afef61dd21eb4$export$a8ff84c12d48cfa6(param) {
    return function() {
        return param.name;
    };
}
function $1c5afef61dd21eb4$export$6cf3d710d3a367e5(name) {
    return function(param) {
        return function() {
            param.name = name;
        };
    };
}
function $1c5afef61dd21eb4$export$2ab9a8f9f1186f14(param) {
    return function() {
        return param.value;
    };
}
function $1c5afef61dd21eb4$export$80746c6bc6142fc8(value) {
    return function(param) {
        return function() {
            param.value = value;
        };
    };
}




var $f98a066659a15f53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f98a066659a15f53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");
var $f98a066659a15f53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLParamElement");


// Generated by purs version 0.15.16


var $84ac7e6146bd7613$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $84ac7e6146bd7613$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");
var $84ac7e6146bd7613$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLPreElement");


// Generated by purs version 0.15.16
function $c65b15421363cde9$export$2ab9a8f9f1186f14(progress) {
    return function() {
        return progress.value;
    };
}
function $c65b15421363cde9$export$80746c6bc6142fc8(value) {
    return function(progress) {
        return function() {
            progress.value = value;
        };
    };
}
function $c65b15421363cde9$export$8960430cfd85939f(progress) {
    return function() {
        return progress.max;
    };
}
function $c65b15421363cde9$export$b03015b7eb8a4a0d(max) {
    return function(progress) {
        return function() {
            progress.max = max;
        };
    };
}
function $c65b15421363cde9$export$5880b8b5730aff45(progress) {
    return function() {
        return progress.position;
    };
}
function $c65b15421363cde9$export$a238cb463698c900(progress) {
    return function() {
        return progress.labels;
    };
}




var $dabdbb18392010de$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $dabdbb18392010de$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");
var $dabdbb18392010de$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLProgressElement");


// Generated by purs version 0.15.16
function $1e6d0af303f227ec$export$3035df57df42c31a(quote) {
    return function() {
        return quote.cite;
    };
}
function $1e6d0af303f227ec$export$86262a2b9f03fae3(cite) {
    return function(quote) {
        return function() {
            quote.cite = cite;
        };
    };
}




var $5d0c2c5071b861d1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $5d0c2c5071b861d1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");
var $5d0c2c5071b861d1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLQuoteElement");


// Generated by purs version 0.15.16
function $4bf6127f0f22b047$export$2e40c9e35e9506f4(script) {
    return function() {
        return script.src;
    };
}
function $4bf6127f0f22b047$export$5771e3a4c80da7df(src) {
    return function(script) {
        return function() {
            script.src = src;
        };
    };
}
function $4bf6127f0f22b047$export$d4a6a4db5b31e621(script) {
    return function() {
        return script.type;
    };
}
function $4bf6127f0f22b047$export$1bf7f05044e9c5cb(type) {
    return function(script) {
        return function() {
            script.type = type;
        };
    };
}
function $4bf6127f0f22b047$export$e4c823724462c3fd(script) {
    return function() {
        return script.charset;
    };
}
function $4bf6127f0f22b047$export$61ed102e375c8bae(charset) {
    return function(script) {
        return function() {
            script.charset = charset;
        };
    };
}
function $4bf6127f0f22b047$export$12af436354f1a4f7(script) {
    return function() {
        return script.async;
    };
}
function $4bf6127f0f22b047$export$8ed1e1e4b75b53c6(async) {
    return function(script) {
        return function() {
            script.async = async;
        };
    };
}
function $4bf6127f0f22b047$export$260e5c0943f31606(script) {
    return function() {
        return script.defer;
    };
}
function $4bf6127f0f22b047$export$d440c7f1383ddd12(defer) {
    return function(script) {
        return function() {
            script.defer = defer;
        };
    };
}
function $4bf6127f0f22b047$export$c47cb7c63271266e(script) {
    return function() {
        return script.crossOrigin;
    };
}
function $4bf6127f0f22b047$export$e7fd69f64f92856(crossOrigin) {
    return function(script) {
        return function() {
            script.crossOrigin = crossOrigin;
        };
    };
}
function $4bf6127f0f22b047$export$6f093cfa640b7166(script) {
    return function() {
        return script.text;
    };
}
function $4bf6127f0f22b047$export$cbe0d99836e1498f(text) {
    return function(script) {
        return function() {
            script.text = text;
        };
    };
}




var $1143394fd0c1cb41$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1143394fd0c1cb41$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");
var $1143394fd0c1cb41$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLScriptElement");


// Generated by purs version 0.15.16
function $4f460bff72193069$export$4c47992fc278c9a0(select) {
    return function() {
        return select.autofocus;
    };
}
function $4f460bff72193069$export$db2bbdcbda3d335e(autofocus) {
    return function(select) {
        return function() {
            select.autofocus = autofocus;
        };
    };
}
function $4f460bff72193069$export$683472f6198a076e(select) {
    return function() {
        return select.disabled;
    };
}
function $4f460bff72193069$export$4532d31cef66d703(disabled) {
    return function(select) {
        return function() {
            select.disabled = disabled;
        };
    };
}
function $4f460bff72193069$export$939ddaa3205df08e(select) {
    return function() {
        return select.multiple;
    };
}
function $4f460bff72193069$export$be7c7381b31f2269(multiple) {
    return function(select) {
        return function() {
            select.multiple = multiple;
        };
    };
}
function $4f460bff72193069$export$242c63e9758836c2(select) {
    return function() {
        return select.form;
    };
}
function $4f460bff72193069$export$a8ff84c12d48cfa6(select) {
    return function() {
        return select.name;
    };
}
function $4f460bff72193069$export$6cf3d710d3a367e5(name) {
    return function(select) {
        return function() {
            select.name = name;
        };
    };
}
function $4f460bff72193069$export$a7a0278c004aac3f(select) {
    return function() {
        return select.required;
    };
}
function $4f460bff72193069$export$47f9362469f346c4(required) {
    return function(select) {
        return function() {
            select.required = required;
        };
    };
}
function $4f460bff72193069$export$346677f925de839c(select) {
    return function() {
        return select.size;
    };
}
function $4f460bff72193069$export$1c70a6cc12bc0366(size) {
    return function(select) {
        return function() {
            select.size = size;
        };
    };
}
function $4f460bff72193069$export$d4a6a4db5b31e621(select) {
    return function() {
        return select.type;
    };
}
function $4f460bff72193069$export$f24224f1c91d8156(select) {
    return function() {
        return select.length;
    };
}
function $4f460bff72193069$export$e37a2cb6f0a9cac9(length) {
    return function(select) {
        return function() {
            select.length = length;
        };
    };
}
function $4f460bff72193069$export$b0ea99e7ae5aed6c(select) {
    return function() {
        return select.selectedOptions;
    };
}
function $4f460bff72193069$export$9ea87e299ff6a368(select) {
    return function() {
        return select.selectedIndex;
    };
}
function $4f460bff72193069$export$940820044e1b4923(selectedIndex) {
    return function(select) {
        return function() {
            select.selectedIndex = selectedIndex;
        };
    };
}
function $4f460bff72193069$export$2ab9a8f9f1186f14(select) {
    return function() {
        return select.value;
    };
}
function $4f460bff72193069$export$80746c6bc6142fc8(value) {
    return function(select) {
        return function() {
            select.value = value;
        };
    };
}
function $4f460bff72193069$export$5e55a9e709e8e020(select) {
    return function() {
        return select.willValidate;
    };
}
function $4f460bff72193069$export$1bdd3f9a89b22594(select) {
    return function() {
        return select.validity;
    };
}
function $4f460bff72193069$export$6ee4201e37a931e2(select) {
    return function() {
        return select.validationMessage;
    };
}
function $4f460bff72193069$export$50d70f8cedc54453(select) {
    return function() {
        return select.checkValidity();
    };
}
function $4f460bff72193069$export$b962d864c477cc49(select) {
    return function() {
        return select.reportValidity();
    };
}
function $4f460bff72193069$export$6f569cb704992105(value) {
    return function(select) {
        return function() {
            select.setCustomValidity(value);
        };
    };
}
function $4f460bff72193069$export$a238cb463698c900(select) {
    return function() {
        return select.labels;
    };
}







var $a54214b82be35498$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $a54214b82be35498$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSelectElement");
var $a54214b82be35498$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($4f460bff72193069$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $30fdbf6c46de325a$export$2e40c9e35e9506f4(source) {
    return function() {
        return source.src;
    };
}
function $30fdbf6c46de325a$export$5771e3a4c80da7df(src) {
    return function(source) {
        return function() {
            source.src = src;
        };
    };
}
function $30fdbf6c46de325a$export$d4a6a4db5b31e621(source) {
    return function() {
        return source.type;
    };
}
function $30fdbf6c46de325a$export$1bf7f05044e9c5cb(type) {
    return function(source) {
        return function() {
            source.type = type;
        };
    };
}
function $30fdbf6c46de325a$export$987d49ffe1b0900f(source) {
    return function() {
        return source.media;
    };
}
function $30fdbf6c46de325a$export$5c1855deea651e41(media) {
    return function(source) {
        return function() {
            source.media = media;
        };
    };
}




var $e84e4cab6b69fa3a$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $e84e4cab6b69fa3a$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");
var $e84e4cab6b69fa3a$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSourceElement");


// Generated by purs version 0.15.16


var $1258819ad56163ca$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $1258819ad56163ca$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");
var $1258819ad56163ca$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLSpanElement");


// Generated by purs version 0.15.16
function $3945cfcc1dd51d92$export$987d49ffe1b0900f(style) {
    return function() {
        return style.media;
    };
}
function $3945cfcc1dd51d92$export$5c1855deea651e41(media) {
    return function(style) {
        return function() {
            style.media = media;
        };
    };
}
function $3945cfcc1dd51d92$export$d4a6a4db5b31e621(style) {
    return function() {
        return style.type;
    };
}
function $3945cfcc1dd51d92$export$1bf7f05044e9c5cb(type) {
    return function(style) {
        return function() {
            style.type = type;
        };
    };
}




var $c2a5f1d09180ba9d$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $c2a5f1d09180ba9d$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");
var $c2a5f1d09180ba9d$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLStyleElement");


// Generated by purs version 0.15.16


var $4d7ca2355751c293$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $4d7ca2355751c293$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");
var $4d7ca2355751c293$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCaptionElement");


// Generated by purs version 0.15.16
function $dd45d132df79042b$export$47be69ffacd0da98(cell) {
    return function() {
        return cell.colSpan;
    };
}
function $dd45d132df79042b$export$41feea65f12f6ad6(colSpan) {
    return function(cell) {
        return function() {
            cell.colSpan = colSpan;
        };
    };
}
function $dd45d132df79042b$export$a5ce0649174d616e(cell) {
    return function() {
        return cell.rowSpan;
    };
}
function $dd45d132df79042b$export$1f37716400d14942(rowSpan) {
    return function(cell) {
        return function() {
            cell.rowSpan = rowSpan;
        };
    };
}
function $dd45d132df79042b$export$b507ffb2fd978043(cell) {
    return function() {
        return cell.cellIndex;
    };
}




var $ca40d224410598c5$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $ca40d224410598c5$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");
var $ca40d224410598c5$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableCellElement");


// Generated by purs version 0.15.16
function $34ac56698048b1d0$export$afc1bfabebaf28a2(col) {
    return function() {
        return col.span;
    };
}
function $34ac56698048b1d0$export$8ab2f2e6ee8ed0a8(span) {
    return function(col) {
        return function() {
            col.span = span;
        };
    };
}




var $298b737852233db7$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $298b737852233db7$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");
var $298b737852233db7$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableColElement");


// Generated by purs version 0.15.16


var $90a91012d61f1bcd$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $90a91012d61f1bcd$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");
var $90a91012d61f1bcd$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableDataCellElement");


// Generated by purs version 0.15.16
function $48dd68dffe0e6e15$export$b815d8b2ae8b8a8f(table) {
    return function() {
        return table.caption;
    };
}
function $48dd68dffe0e6e15$export$c1cd099bccef98fe(caption) {
    return function(table) {
        return function() {
            table.caption = caption;
        };
    };
}
function $48dd68dffe0e6e15$export$690474d079e8aee0(table) {
    return function() {
        return table.createCaption();
    };
}
function $48dd68dffe0e6e15$export$2f169497140e8e8c(table) {
    return function() {
        table.deleteCaption();
    };
}
function $48dd68dffe0e6e15$export$75d2083daf0d4c8(table) {
    return function() {
        return table.tHead;
    };
}
function $48dd68dffe0e6e15$export$accedb93377ebcb2(tHead) {
    return function(table) {
        return function() {
            table.tHead = tHead;
        };
    };
}
function $48dd68dffe0e6e15$export$8e9dedfded1540ee(table) {
    return function() {
        return table.createTHead();
    };
}
function $48dd68dffe0e6e15$export$c28532ed8fc4a976(table) {
    return function() {
        table.deleteTHead();
    };
}
function $48dd68dffe0e6e15$export$6c9b4fbde50fbc0f(table) {
    return function() {
        return table.tFoot;
    };
}
function $48dd68dffe0e6e15$export$10a8938b95fbdb4(tFoot) {
    return function(table) {
        return function() {
            table.tFoot = tFoot;
        };
    };
}
function $48dd68dffe0e6e15$export$ab9f248e0049bb9d(table) {
    return function() {
        return table.createTFoot();
    };
}
function $48dd68dffe0e6e15$export$3c3cb2a6af70fe52(table) {
    return function() {
        table.deleteTFoot();
    };
}
function $48dd68dffe0e6e15$export$c63586cd99d53eee(table) {
    return function() {
        return table.tBodies;
    };
}
function $48dd68dffe0e6e15$export$76a5bd1e5d516e91(table) {
    return function() {
        return table.createTBody();
    };
}
function $48dd68dffe0e6e15$export$2dd197b55cf13440(table) {
    return function() {
        return table.rows;
    };
}
function $48dd68dffe0e6e15$export$281b3c86eeab738f(index) {
    return function(table) {
        return function() {
            return table.insertRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$2ef39e5ffdaff9ed(index) {
    return function(table) {
        return function() {
            table.deleteRow(index);
        };
    };
}
function $48dd68dffe0e6e15$export$1edee58a52776cd9(table) {
    return function() {
        return table.border;
    };
}
function $48dd68dffe0e6e15$export$df6de19f3e6baa52(border) {
    return function(table) {
        return function() {
            table.border = border;
        };
    };
}







var $00106f41ab48b85e$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $00106f41ab48b85e$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $00106f41ab48b85e$export$8ffb9307dee41683 = /* #__PURE__ */ function() {
    var $3 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($4) {
        return $3($48dd68dffe0e6e15$export$75d2083daf0d4c8($4));
    };
}();
var $00106f41ab48b85e$export$4ce044d081650b4 = /* #__PURE__ */ function() {
    var $5 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($48dd68dffe0e6e15$export$6c9b4fbde50fbc0f($6));
    };
}();
var $00106f41ab48b85e$export$73c0abfa2c0e52e4 = function($7) {
    return $48dd68dffe0e6e15$export$accedb93377ebcb2($0a5aaf95f168428e$export$b187f57ee1822bc5($7));
};
var $00106f41ab48b85e$export$1350b3df0623f8d7 = function($8) {
    return $48dd68dffe0e6e15$export$10a8938b95fbdb4($0a5aaf95f168428e$export$b187f57ee1822bc5($8));
};
var $00106f41ab48b85e$export$c972b85f531b9f41 = function($9) {
    return $48dd68dffe0e6e15$export$c1cd099bccef98fe($0a5aaf95f168428e$export$b187f57ee1822bc5($9));
};
var $00106f41ab48b85e$export$6f91cb21ef21b608 = $48dd68dffe0e6e15$export$281b3c86eeab738f;
var $00106f41ab48b85e$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $00106f41ab48b85e$export$6f91cb21ef21b608(-1);
}();
var $00106f41ab48b85e$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableElement");
var $00106f41ab48b85e$export$8e3c2dfdc4f0453d = /* #__PURE__ */ function() {
    var $10 = $00106f41ab48b85e$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($48dd68dffe0e6e15$export$b815d8b2ae8b8a8f($11));
    };
}();


// Generated by purs version 0.15.16
function $d0f5df104e75ba24$export$5cff813ca8e50db9(cell) {
    return function() {
        return cell.scope;
    };
}
function $d0f5df104e75ba24$export$d9e5239df8f952de(scope) {
    return function(cell) {
        return function() {
            cell.scope = scope;
        };
    };
}
function $d0f5df104e75ba24$export$2bcb785951133fe5(cell) {
    return function() {
        return cell.abbr;
    };
}
function $d0f5df104e75ba24$export$4b75111ed99261c8(abbr) {
    return function(cell) {
        return function() {
            cell.abbr = abbr;
        };
    };
}




var $51e7753cdccb5d79$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$619123619593c03d = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $51e7753cdccb5d79$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$7b01868159b235fe = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");
var $51e7753cdccb5d79$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableHeaderCellElement");


// Generated by purs version 0.15.16
function $e090f42f468fa271$export$f6e5b2c929a2f19d(row) {
    return function() {
        return row.rowIndex;
    };
}
function $e090f42f468fa271$export$11d8b50a98496a38(row) {
    return function() {
        return row.sectionRowIndex;
    };
}
function $e090f42f468fa271$export$57ba6370ea0e47f8(row) {
    return function() {
        return row.cells;
    };
}
function $e090f42f468fa271$export$96a7dd0d30a5e7fe(index) {
    return function(row) {
        return function() {
            return row.insertCell(index);
        };
    };
}
function $e090f42f468fa271$export$6e37d353cc5629c9(index) {
    return function(row) {
        return function() {
            row.deleteCell(index);
        };
    };
}




var $633aaa19d7d1d3a1$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $633aaa19d7d1d3a1$export$27b66c5ce67ee025 = $e090f42f468fa271$export$96a7dd0d30a5e7fe;
var $633aaa19d7d1d3a1$export$51965e0a3b80eb5c = /* #__PURE__ */ function() {
    return $633aaa19d7d1d3a1$export$27b66c5ce67ee025(-1);
}();
var $633aaa19d7d1d3a1$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");
var $633aaa19d7d1d3a1$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableRowElement");


// Generated by purs version 0.15.16
function $dba0680894fb8dd0$export$2dd197b55cf13440(section) {
    return function() {
        return section.rows;
    };
}
function $dba0680894fb8dd0$export$281b3c86eeab738f(index) {
    return function(section) {
        return function() {
            return section.insertRow(index);
        };
    };
}
function $dba0680894fb8dd0$export$2ef39e5ffdaff9ed(index) {
    return function(section) {
        return function() {
            section.deleteRow(index);
        };
    };
}




var $53881fd03908fa53$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $53881fd03908fa53$export$6f91cb21ef21b608 = $dba0680894fb8dd0$export$281b3c86eeab738f;
var $53881fd03908fa53$export$5a4e94bbc04b5f2 = /* #__PURE__ */ function() {
    return $53881fd03908fa53$export$6f91cb21ef21b608(-1);
}();
var $53881fd03908fa53$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");
var $53881fd03908fa53$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTableSectionElement");


// Generated by purs version 0.15.16
function $1b3a563b18f6151d$export$a7db06668cad9adb(template) {
    return function() {
        return template.content;
    };
}




var $fee13735939d9bee$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $fee13735939d9bee$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");
var $fee13735939d9bee$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTemplateElement");


// Generated by purs version 0.15.16
function $28c3e08a1c48c9af$export$485ded5f26ebe08d(textarea) {
    return function() {
        return textarea.autocomplete;
    };
}
function $28c3e08a1c48c9af$export$5fb7c729919301a5(autocomplete) {
    return function(textarea) {
        return function() {
            textarea.autocomplete = autocomplete;
        };
    };
}
function $28c3e08a1c48c9af$export$4c47992fc278c9a0(textarea) {
    return function() {
        return textarea.autofocus;
    };
}
function $28c3e08a1c48c9af$export$db2bbdcbda3d335e(autofocus) {
    return function(textarea) {
        return function() {
            textarea.autofocus = autofocus;
        };
    };
}
function $28c3e08a1c48c9af$export$1eebcb1e706ab348(textarea) {
    return function() {
        return textarea.cols;
    };
}
function $28c3e08a1c48c9af$export$3df203352cd8517(cols) {
    return function(textarea) {
        return function() {
            textarea.cols = cols;
        };
    };
}
function $28c3e08a1c48c9af$export$9ebb36ddc946da55(textarea) {
    return function() {
        return textarea.dirName;
    };
}
function $28c3e08a1c48c9af$export$e2460e55089b163d(dirName) {
    return function(textarea) {
        return function() {
            textarea.dirName = dirName;
        };
    };
}
function $28c3e08a1c48c9af$export$683472f6198a076e(textarea) {
    return function() {
        return textarea.disabled;
    };
}
function $28c3e08a1c48c9af$export$4532d31cef66d703(disabled) {
    return function(textarea) {
        return function() {
            textarea.disabled = disabled;
        };
    };
}
function $28c3e08a1c48c9af$export$242c63e9758836c2(textarea) {
    return function() {
        return textarea.form;
    };
}
function $28c3e08a1c48c9af$export$c9f461152c658a8b(textarea) {
    return function() {
        return textarea.maxLength;
    };
}
function $28c3e08a1c48c9af$export$45077a575ddd961f(maxLength) {
    return function(textarea) {
        return function() {
            textarea.maxLength = maxLength;
        };
    };
}
function $28c3e08a1c48c9af$export$8fe860a115a1e636(textarea) {
    return function() {
        return textarea.minLength;
    };
}
function $28c3e08a1c48c9af$export$2b867239766ba1e3(minLength) {
    return function(textarea) {
        return function() {
            textarea.minLength = minLength;
        };
    };
}
function $28c3e08a1c48c9af$export$a8ff84c12d48cfa6(textarea) {
    return function() {
        return textarea.name;
    };
}
function $28c3e08a1c48c9af$export$6cf3d710d3a367e5(name) {
    return function(textarea) {
        return function() {
            textarea.name = name;
        };
    };
}
function $28c3e08a1c48c9af$export$c7187bbd1a7a9244(textarea) {
    return function() {
        return textarea.placeholder;
    };
}
function $28c3e08a1c48c9af$export$645bf5697adfa088(placeholder) {
    return function(textarea) {
        return function() {
            textarea.placeholder = placeholder;
        };
    };
}
function $28c3e08a1c48c9af$export$b2cbc93d4da94977(textarea) {
    return function() {
        return textarea.readOnly;
    };
}
function $28c3e08a1c48c9af$export$62311ce54ddfc862(readOnly) {
    return function(textarea) {
        return function() {
            textarea.readOnly = readOnly;
        };
    };
}
function $28c3e08a1c48c9af$export$a7a0278c004aac3f(textarea) {
    return function() {
        return textarea.required;
    };
}
function $28c3e08a1c48c9af$export$47f9362469f346c4(required) {
    return function(textarea) {
        return function() {
            textarea.required = required;
        };
    };
}
function $28c3e08a1c48c9af$export$2dd197b55cf13440(textarea) {
    return function() {
        return textarea.rows;
    };
}
function $28c3e08a1c48c9af$export$f2d998961118057a(rows) {
    return function(textarea) {
        return function() {
            textarea.rows = rows;
        };
    };
}
function $28c3e08a1c48c9af$export$4997ffc0176396a6(textarea) {
    return function() {
        return textarea.wrap;
    };
}
function $28c3e08a1c48c9af$export$696447b714acda6d(wrap) {
    return function(textarea) {
        return function() {
            textarea.wrap = wrap;
        };
    };
}
function $28c3e08a1c48c9af$export$d4a6a4db5b31e621(textarea) {
    return function() {
        return textarea.type;
    };
}
function $28c3e08a1c48c9af$export$1a01ae0705bafd37(textarea) {
    return function() {
        return textarea.defaultValue;
    };
}
function $28c3e08a1c48c9af$export$d8becbd7468e206f(defaultValue) {
    return function(textarea) {
        return function() {
            textarea.defaultValue = defaultValue;
        };
    };
}
function $28c3e08a1c48c9af$export$2ab9a8f9f1186f14(textarea) {
    return function() {
        return textarea.value;
    };
}
function $28c3e08a1c48c9af$export$80746c6bc6142fc8(value) {
    return function(textarea) {
        return function() {
            textarea.value = value;
        };
    };
}
function $28c3e08a1c48c9af$export$6f846043e306f02c(textarea) {
    return function() {
        return textarea.textLength;
    };
}
function $28c3e08a1c48c9af$export$5e55a9e709e8e020(textarea) {
    return function() {
        return textarea.willValidate;
    };
}
function $28c3e08a1c48c9af$export$1bdd3f9a89b22594(textarea) {
    return function() {
        return textarea.validity;
    };
}
function $28c3e08a1c48c9af$export$6ee4201e37a931e2(textarea) {
    return function() {
        return textarea.validationMessage;
    };
}
function $28c3e08a1c48c9af$export$50d70f8cedc54453(textarea) {
    return function() {
        return textarea.checkValidity();
    };
}
function $28c3e08a1c48c9af$export$b962d864c477cc49(textarea) {
    return function() {
        return textarea.reportValidity();
    };
}
function $28c3e08a1c48c9af$export$6f569cb704992105(value) {
    return function(textarea) {
        return function() {
            textarea.setCustomValidity(value);
        };
    };
}
function $28c3e08a1c48c9af$export$a238cb463698c900(textarea) {
    return function() {
        return textarea.labels;
    };
}
function $28c3e08a1c48c9af$export$2e6c959c16ff56b8(textarea) {
    return function() {
        textarea.select();
    };
}
function $28c3e08a1c48c9af$export$5e2f617ae845fb63(textarea) {
    return function() {
        return textarea.selectionStart;
    };
}
function $28c3e08a1c48c9af$export$47b9c21811f199bd(selectionStart) {
    return function(textarea) {
        return function() {
            textarea.selectionStart = selectionStart;
        };
    };
}
function $28c3e08a1c48c9af$export$1028be563f1155b2(textarea) {
    return function() {
        return textarea.selectionEnd;
    };
}
function $28c3e08a1c48c9af$export$15d012c6be3c352(selectionEnd) {
    return function(textarea) {
        return function() {
            textarea.selectionEnd = selectionEnd;
        };
    };
}
function $28c3e08a1c48c9af$export$b4e8aad052258154(textarea) {
    return function() {
        return textarea.selectionDirection;
    };
}
function $28c3e08a1c48c9af$export$6ac306cb2c51a4e6(selectionDirection) {
    return function(textarea) {
        return function() {
            textarea.selectionDirection = selectionDirection;
        };
    };
}
function $28c3e08a1c48c9af$export$2add2a46d1c1d557(replacement) {
    return function(textarea) {
        return function() {
            textarea.setRangeText(replacement);
        };
    };
}
function $28c3e08a1c48c9af$export$309b5632e9b49193(replacement, start, end, selectionMode, textarea) {
    textarea.setRangeText(replacement, start, end, selectionMode);
}
function $28c3e08a1c48c9af$export$3b045ac5f470d884(start) {
    return function(end) {
        return function(direction) {
            return function(textarea) {
                return function() {
                    textarea.setSelectionRange(start, end, direction);
                };
            };
        };
    };
}








var $514f398dc6a7828b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $514f398dc6a7828b$export$873e7fe8f20f100c = function(rpl) {
    return function(s) {
        return function(e) {
            return function(mode) {
                return function(area) {
                    return function() {
                        return $28c3e08a1c48c9af$export$309b5632e9b49193(rpl, s, e, $c09a3e7cfbb6a57f$export$c2d084dc44961371(mode), area);
                    };
                };
            };
        };
    };
};
var $514f398dc6a7828b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTextAreaElement");
var $514f398dc6a7828b$export$6210fa4921d2a466 = /* #__PURE__ */ function() {
    var $2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($3) {
        return $2($28c3e08a1c48c9af$export$242c63e9758836c2($3));
    };
}();


// Generated by purs version 0.15.16
function $68df52b2f5f30ba7$export$3a17bddce263fba0(time) {
    return function() {
        return time.dateTime;
    };
}
function $68df52b2f5f30ba7$export$3a84b9eda98e95dc(dateTime) {
    return function(time) {
        return function() {
            time.dateTime = dateTime;
        };
    };
}




var $f1291cf94838d52b$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $f1291cf94838d52b$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");
var $f1291cf94838d52b$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTimeElement");


// Generated by purs version 0.15.16
function $a7993cc78206c04b$export$6f093cfa640b7166(title) {
    return function() {
        return title.text;
    };
}
function $a7993cc78206c04b$export$cbe0d99836e1498f(text) {
    return function(title) {
        return function() {
            title.text = text;
        };
    };
}




var $71325cd3e1c1cf85$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $71325cd3e1c1cf85$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");
var $71325cd3e1c1cf85$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTitleElement");


// Generated by purs version 0.15.16
function $2f0649a862aa117b$export$78062f36b16ed2f8(track) {
    return function() {
        return track.kind;
    };
}
function $2f0649a862aa117b$export$8f76af250dd43cf6(kind) {
    return function(track) {
        return function() {
            track.kind = kind;
        };
    };
}
function $2f0649a862aa117b$export$2e40c9e35e9506f4(track) {
    return function() {
        return track.src;
    };
}
function $2f0649a862aa117b$export$5771e3a4c80da7df(src) {
    return function(track) {
        return function() {
            track.src = src;
        };
    };
}
function $2f0649a862aa117b$export$4be5a609db5ad788(track) {
    return function() {
        return track.srclang;
    };
}
function $2f0649a862aa117b$export$5406412834bff708(srclang) {
    return function(track) {
        return function() {
            track.srclang = srclang;
        };
    };
}
function $2f0649a862aa117b$export$1237798dc640739a(track) {
    return function() {
        return track.label;
    };
}
function $2f0649a862aa117b$export$4f65e594f6031297(label) {
    return function(track) {
        return function() {
            track.label = label;
        };
    };
}
// ----------------------------------------------------------------------------
const $2f0649a862aa117b$export$2e2bcd8739ae039 = function(track) {
    return function() {
        return track["default"];
    };
};
function $2f0649a862aa117b$export$d590af038dd015bd(def) {
    return function(track) {
        return function() {
            track["default"] = def;
        };
    };
}
function $2f0649a862aa117b$export$4bf8a366db6a678b(track) {
    return track.readyState;
}







// Generated by purs version 0.15.16



var $436d616104359630$export$57ca7e07b341709d = /* #__PURE__ */ function() {
    function None() {}
    None.value = new None();
    return None;
}();
var $436d616104359630$export$669f6ea7d267feaf = /* #__PURE__ */ function() {
    function Loading() {}
    Loading.value = new Loading();
    return Loading;
}();
var $436d616104359630$export$b6517d5bdd20170e = /* #__PURE__ */ function() {
    function Loaded() {}
    Loaded.value = new Loaded();
    return Loaded;
}();
var $436d616104359630$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $436d616104359630$export$dc807b9f83d61e2e = function(v) {
    if (v === 0) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$57ca7e07b341709d.value);
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$669f6ea7d267feaf.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$b6517d5bdd20170e.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($436d616104359630$export$edf27be85e5f6da0.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $436d616104359630$export$33dd24f3d942b82e = {
    show: function(v) {
        if (v instanceof $436d616104359630$export$57ca7e07b341709d) return "None";
        if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return "Loading";
        if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return "Loaded";
        if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return "Error";
        throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 30, column 1 - line 34, column 23): " + [
            v.constructor.name
        ]);
    }
};
var $436d616104359630$export$9974ae2c28acb3c9 = function(v) {
    if (v instanceof $436d616104359630$export$57ca7e07b341709d) return 0;
    if (v instanceof $436d616104359630$export$669f6ea7d267feaf) return 1;
    if (v instanceof $436d616104359630$export$b6517d5bdd20170e) return 2;
    if (v instanceof $436d616104359630$export$edf27be85e5f6da0) return 3;
    throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 47, column 3 - line 51, column 15): " + [
        v.constructor.name
    ]);
};
var $436d616104359630$export$c71e02dcc13f94a6 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return true;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return true;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return true;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $436d616104359630$export$6557947d538c3b81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $436d616104359630$export$57ca7e07b341709d && y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$57ca7e07b341709d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf && y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$669f6ea7d267feaf) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e && y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $436d616104359630$export$b6517d5bdd20170e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $436d616104359630$export$edf27be85e5f6da0 && y instanceof $436d616104359630$export$edf27be85e5f6da0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Web.HTML.HTMLTrackElement.ReadyState (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $436d616104359630$export$c71e02dcc13f94a6;
    }
};
var $436d616104359630$export$f705a14e9e99c6f0 = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($436d616104359630$export$dc807b9f83d61e2e)($436d616104359630$export$9974ae2c28acb3c9),
    Ord0: function() {
        return $436d616104359630$export$6557947d538c3b81;
    }
};
var $436d616104359630$export$7b40514a91e8387e = /* #__PURE__ */ function() {
    return {
        bottom: $436d616104359630$export$57ca7e07b341709d.value,
        top: $436d616104359630$export$edf27be85e5f6da0.value,
        Ord0: function() {
            return $436d616104359630$export$6557947d538c3b81;
        }
    };
}();
var $436d616104359630$export$94a641e970e969f9 = {
    cardinality: 4,
    toEnum: $436d616104359630$export$dc807b9f83d61e2e,
    fromEnum: $436d616104359630$export$9974ae2c28acb3c9,
    Bounded0: function() {
        return $436d616104359630$export$7b40514a91e8387e;
    },
    Enum1: function() {
        return $436d616104359630$export$f705a14e9e99c6f0;
    }
};



var $057c37bcb2e4f7d0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $057c37bcb2e4f7d0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($436d616104359630$export$94a641e970e969f9);
var $057c37bcb2e4f7d0$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $057c37bcb2e4f7d0$export$1ae2b664eea77b7e = function(el) {
    return $057c37bcb2e4f7d0$var$map(function() {
        var $3 = $06733ae99ed4f534$export$43db023a260c5e9f($436d616104359630$export$57ca7e07b341709d.value);
        return function($4) {
            return $3($057c37bcb2e4f7d0$var$toEnum($4));
        };
    }())(function() {
        return $2f0649a862aa117b$export$4bf8a366db6a678b(el);
    });
};
var $057c37bcb2e4f7d0$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");
var $057c37bcb2e4f7d0$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLTrackElement");


// Generated by purs version 0.15.16


var $de5b01932d221096$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $de5b01932d221096$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");
var $de5b01932d221096$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLUListElement");


// Generated by purs version 0.15.16
// ----------------------------------------------------------------------------
function $61cfdbf50fc824d4$export$7e3df82ee760448c(video) {
    return function() {
        return video.width;
    };
}
function $61cfdbf50fc824d4$export$67f48e0594af05d(width) {
    return function(video) {
        return function() {
            video.width = width;
        };
    };
}
function $61cfdbf50fc824d4$export$ac607276a8fe9f0a(video) {
    return function() {
        return video.height;
    };
}
function $61cfdbf50fc824d4$export$3f31360357be44e4(height) {
    return function(video) {
        return function() {
            video.height = height;
        };
    };
}
function $61cfdbf50fc824d4$export$dbb4894ced044525(video) {
    return function() {
        return video.videoWidth;
    };
}
function $61cfdbf50fc824d4$export$848581bdb4a7943d(video) {
    return function() {
        return video.videoHeight;
    };
}
function $61cfdbf50fc824d4$export$b840e55573b2d2e7(video) {
    return function() {
        return video.poster;
    };
}
function $61cfdbf50fc824d4$export$2c8117e8f5cb8138(poster) {
    return function(video) {
        return function() {
            video.poster = poster;
        };
    };
}




var $7732702ec87f6f21$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$fd26055f9731f4b9 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$3667cdd4f3a5105e = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8d51e3db1a844094 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $7732702ec87f6f21$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$cdb626e247ef0ce5 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$f9471d229cb6cb3f = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$c56654a6d0e3bd48 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");
var $7732702ec87f6f21$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("HTMLVideoElement");


// Generated by purs version 0.15.16
function $75f6ec27f640501f$export$7c341cb16fc91138(history) {
    return function() {
        return history.back();
    };
}
function $75f6ec27f640501f$export$174bb771924e7eb1(history) {
    return function() {
        return history.forward();
    };
}
function $75f6ec27f640501f$export$93bb224d05b3906d(delta) {
    return function(history) {
        return function() {
            return history.go(delta);
        };
    };
}
function $75f6ec27f640501f$export$ba0fd82af7b4fe6e(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.pushState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$e68dd4d2e7e08394(a) {
    return function(docTitle) {
        return function(url) {
            return function(history) {
                return function() {
                    return history.replaceState(a, docTitle, url);
                };
            };
        };
    };
}
function $75f6ec27f640501f$export$ca000e230c0caa3e(history) {
    return function() {
        return history.state;
    };
}



var $c4fd6deeadc2e277$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $c4fd6deeadc2e277$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $c4fd6deeadc2e277$export$61abde59b50deb8e = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$dd5ad0b65cf665da = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$1f333647865369bf = function(x) {
    return x;
};
var $c4fd6deeadc2e277$export$e587774857b65d31 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$2cdd79be0aa3bb07 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$3c3105bc6097b846 = {
    Coercible0: function() {
        return undefined;
    }
};
var $c4fd6deeadc2e277$export$214a01057915d716 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$dbc0939544a3624 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$214a01057915d716;
    }
};
var $c4fd6deeadc2e277$export$28be1498e824b653 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$7c3d39f0cf320c7b = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$28be1498e824b653;
    }
};
var $c4fd6deeadc2e277$export$3e1b8005eb6f3d68 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $c4fd6deeadc2e277$export$4ef0c953a661f864 = {
    compare: function(x) {
        return function(y) {
            return $c4fd6deeadc2e277$var$compare1(x)(y);
        };
    },
    Eq0: function() {
        return $c4fd6deeadc2e277$export$3e1b8005eb6f3d68;
    }
};


// Generated by purs version 0.15.16
function $f8ebc5adafdca7e8$export$d6af199866bfb566(location) {
    return function() {
        return location.hash;
    };
}
function $f8ebc5adafdca7e8$export$42c3f3255a992e7(hash) {
    return function(location) {
        return function() {
            location.hash = hash;
        };
    };
}
function $f8ebc5adafdca7e8$export$5e032988b71f6158(location) {
    return function() {
        return location.host;
    };
}
function $f8ebc5adafdca7e8$export$db0724f89fd14c87(host) {
    return function(location) {
        return function() {
            location.host = host;
        };
    };
}
function $f8ebc5adafdca7e8$export$640106f6dc7d2706(location) {
    return function() {
        return location.hostname;
    };
}
function $f8ebc5adafdca7e8$export$d120c0a46ba2e633(hostname) {
    return function(location) {
        return function() {
            location.hostname = hostname;
        };
    };
}
function $f8ebc5adafdca7e8$export$8f51af5840e0602a(location) {
    return function() {
        return location.href;
    };
}
function $f8ebc5adafdca7e8$export$428f6e77b5a5a669(href) {
    return function(location) {
        return function() {
            location.href = href;
        };
    };
}
function $f8ebc5adafdca7e8$export$f710a83a91838a36(location) {
    return function() {
        return location.origin;
    };
}
function $f8ebc5adafdca7e8$export$717aaa4b4fe61ebd(origin) {
    return function(location) {
        return function() {
            location.origin = origin;
        };
    };
}
function $f8ebc5adafdca7e8$export$7333db99aa99d383(location) {
    return function() {
        return location.pathname;
    };
}
function $f8ebc5adafdca7e8$export$8c7da94d5c72705a(pathname) {
    return function(location) {
        return function() {
            location.pathname = pathname;
        };
    };
}
function $f8ebc5adafdca7e8$export$2433da7bd3cc7af7(location) {
    return function() {
        return location.port;
    };
}
function $f8ebc5adafdca7e8$export$b0effcd3879eb064(port) {
    return function(location) {
        return function() {
            location.port = port;
        };
    };
}
function $f8ebc5adafdca7e8$export$a51d6b395ff4c65a(location) {
    return function() {
        return location.protocol;
    };
}
function $f8ebc5adafdca7e8$export$caabdac475e4f216(protocol) {
    return function(location) {
        return function() {
            location.protocol = protocol;
        };
    };
}
function $f8ebc5adafdca7e8$export$d76128d007d19019(location) {
    return function() {
        return location.search;
    };
}
function $f8ebc5adafdca7e8$export$f96d8961b67fb6df(search) {
    return function(location) {
        return function() {
            location.search = search;
        };
    };
}
function $f8ebc5adafdca7e8$export$e6e34fd1f2686227(url) {
    return function(location) {
        return function() {
            location.assign(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$77ad94ebf1c2b9ed(url) {
    return function(location) {
        return function() {
            location.replace(url);
        };
    };
}
function $f8ebc5adafdca7e8$export$32da5b5043dcd88c(location) {
    return function() {
        location.reload();
    };
}




// Generated by purs version 0.15.16
function $a62c4ef37c9a21b6$export$789c912f57fe164c(navigator) {
    return function() {
        return navigator.language;
    };
}
function $a62c4ef37c9a21b6$export$d0d68bb9ed2c643d(navigator) {
    return function() {
        return navigator.languages;
    };
}
function $a62c4ef37c9a21b6$export$c65ce66152f1cb9d(navigator) {
    return function() {
        return navigator.onLine;
    };
}
function $a62c4ef37c9a21b6$export$722a64dea1b767dc(navigator) {
    return function() {
        return navigator.platform;
    };
}
function $a62c4ef37c9a21b6$export$3dcce53a3755dc8c(navigator) {
    return function() {
        return navigator.userAgent;
    };
}




// Generated by purs version 0.15.16
function $aa35a24624ec08d2$export$5a7bfc01df82fcd1(window) {
    return function() {
        return window.document;
    };
}
function $aa35a24624ec08d2$export$ec7c8efa7f5790ae(window) {
    return function() {
        return window.navigator;
    };
}
function $aa35a24624ec08d2$export$17b07c660794dc13(window) {
    return function() {
        return window.location;
    };
}
function $aa35a24624ec08d2$export$55abd4691b317664(window) {
    return function() {
        return window.history;
    };
}
function $aa35a24624ec08d2$export$d23fbaf1a2e7133c(window) {
    return function() {
        return window.innerWidth;
    };
}
function $aa35a24624ec08d2$export$d3ad305c42af1069(window) {
    return function() {
        return window.innerHeight;
    };
}
function $aa35a24624ec08d2$export$5ea928c9faf85bd3(str) {
    return function(window) {
        return function() {
            window.alert(str);
        };
    };
}
function $aa35a24624ec08d2$export$715f9d76bb8c1fea(str) {
    return function(window) {
        return function() {
            return window.confirm(str);
        };
    };
}
function $aa35a24624ec08d2$export$7290db243fe4f181(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.moveBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$75f1ccd6dc32e80a(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.moveTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$f4b9acba9659afe8(url) {
    return function(name) {
        return function(features) {
            return function(window) {
                return function() {
                    return window.open(url, name, features);
                };
            };
        };
    };
}
function $aa35a24624ec08d2$export$8360e631d277ea4d(window) {
    return function() {
        return window.close();
    };
}
function $aa35a24624ec08d2$export$fc5b8aac72846d1e(window) {
    return function() {
        return window.outerHeight;
    };
}
function $aa35a24624ec08d2$export$e823f88e4111159a(window) {
    return function() {
        return window.outerWidth;
    };
}
function $aa35a24624ec08d2$export$c2d084dc44961371(window) {
    return function() {
        window.print();
    };
}
function $aa35a24624ec08d2$export$ce783d49a08713a7(str) {
    return function(defaultText) {
        return function(window) {
            return function() {
                return window.prompt(str, defaultText);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5f72b7db69802ea0(xDelta) {
    return function(yDelta) {
        return function(window) {
            return function() {
                window.resizeBy(xDelta, yDelta);
            };
        };
    };
}
function $aa35a24624ec08d2$export$663d9c149a16f84d(width) {
    return function(height) {
        return function(window) {
            return function() {
                window.resizeTo(width, height);
            };
        };
    };
}
function $aa35a24624ec08d2$export$daeacaab2dbcebdc(window) {
    return function() {
        return window.screenX;
    };
}
function $aa35a24624ec08d2$export$51b695a8750464db(window) {
    return function() {
        return window.screenY;
    };
}
function $aa35a24624ec08d2$export$209876d7b1ac8f3(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scroll(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$19a39865fecdb343(xCoord) {
    return function(yCoord) {
        return function(window) {
            return function() {
                window.scrollBy(xCoord, yCoord);
            };
        };
    };
}
function $aa35a24624ec08d2$export$5320ec237fcf13b2(window) {
    return function() {
        return window.scrollX;
    };
}
function $aa35a24624ec08d2$export$2dd824eca41ca48d(window) {
    return function() {
        return window.scrollY;
    };
}
function $aa35a24624ec08d2$export$c2ed3351cac403d1(window) {
    return function() {
        return window.localStorage;
    };
}
function $aa35a24624ec08d2$export$f119d83aa936d634(window) {
    return function() {
        return window.sessionStorage;
    };
}
function $aa35a24624ec08d2$export$6cb2c4c0a22909c0(fn) {
    return function(window) {
        return function() {
            return window.requestAnimationFrame(fn);
        };
    };
}
function $aa35a24624ec08d2$export$e00521de187a817a(id) {
    return function(window) {
        return function() {
            return window.cancelAnimationFrame(id);
        };
    };
}
function $aa35a24624ec08d2$export$9288a5d956b3efbe(opts) {
    return function(fn) {
        return function(window) {
            return function() {
                return window.requestIdleCallback(fn, opts);
            };
        };
    };
}
function $aa35a24624ec08d2$export$bf0a62c3939e5933(id) {
    return function(window) {
        return function() {
            return window.cancelIdleCallback(id);
        };
    };
}
function $aa35a24624ec08d2$export$91124bb58bc04465(window) {
    return function() {
        return window.parent;
    };
}
function $aa35a24624ec08d2$export$b161e74f44e020b9(window) {
    return function() {
        return window.opener;
    };
}








var $6b26c9b0fa2d7b7a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $6b26c9b0fa2d7b7a$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $6b26c9b0fa2d7b7a$var$RequestIdleCallbackId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$var$RequestAnimationFrameId = function(x) {
    return x;
};
var $6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $6b26c9b0fa2d7b7a$export$20682ad686515a40 = function(msg) {
    return function(defaultText) {
        return function(window) {
            return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)(defaultText)(window));
        };
    };
};
var $6b26c9b0fa2d7b7a$export$195ba6d62321b933 = function(msg) {
    return function(window) {
        return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$ce783d49a08713a7(msg)("")(window));
    };
};
var $6b26c9b0fa2d7b7a$export$1828d3c48a8aa004 = function(window) {
    return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$b161e74f44e020b9(window));
};
var $6b26c9b0fa2d7b7a$export$3ce6949f20cea765 = function(url$prime) {
    return function(name) {
        return function(features) {
            return function(window) {
                return $6b26c9b0fa2d7b7a$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)($aa35a24624ec08d2$export$f4b9acba9659afe8(url$prime)(name)(features)(window));
            };
        };
    };
};
var $6b26c9b0fa2d7b7a$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Window");
var $6b26c9b0fa2d7b7a$export$5e61711963baf8b7 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$2a5c622a4a2ca36d = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$5e61711963baf8b7;
    }
};
var $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337 = {
    eq: function(x) {
        return function(y) {
            return x === y;
        };
    }
};
var $6b26c9b0fa2d7b7a$export$5ec63fa26beb11f3 = {
    compare: function(x) {
        return function(y) {
            return $6b26c9b0fa2d7b7a$var$compare(x)(y);
        };
    },
    Eq0: function() {
        return $6b26c9b0fa2d7b7a$export$c27c49a6c01c4337;
    }
};




// Generated by purs version 0.15.16
var $bf7e36c88b3944b3$export$a503f83d36739cbc = "hashchange";


// Generated by purs version 0.15.16
var $033348220d254d99$export$debdbaa302c3885c = "popstate";





var $a5971154c27be447$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $a5971154c27be447$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $a5971154c27be447$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $a5971154c27be447$var$for_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$9747ee7caa0b40b1($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $a5971154c27be447$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $a5971154c27be447$export$23981ac8d9cec36 = function(psi) {
    return function(url) {
        return psi.replaceState($c97d2d0f578f81ad$export$9d82982d31d9d171($05149ea687d6b460$export$523c0b569236b342))(url);
    };
};
var $a5971154c27be447$export$c4bc7274b81240ec = function(psi) {
    var $13 = $a5971154c27be447$export$23981ac8d9cec36(psi);
    return function($14) {
        return $13($daa993e9fe4182d9$export$f6821e37299eed8e($14));
    };
};
var $a5971154c27be447$export$5729eead7c8f9eaf = function(v) {
    return v.locationState;
};
var $a5971154c27be447$export$751f361fd4ccee93 = function(psi) {
    return function(url) {
        return psi.pushState($c97d2d0f578f81ad$export$9d82982d31d9d171($05149ea687d6b460$export$523c0b569236b342))(url);
    };
};
var $a5971154c27be447$export$524be3ecf241c3f0 = function(psi) {
    var $15 = $a5971154c27be447$export$751f361fd4ccee93(psi);
    return function($16) {
        return $15($daa993e9fe4182d9$export$f6821e37299eed8e($16));
    };
};
var $a5971154c27be447$var$currentLocationState = function __do() {
    var win = $2603425f82e959df$export$8291e5b88f90ce4();
    var loc = $aa35a24624ec08d2$export$17b07c660794dc13(win)();
    var state = $a5971154c27be447$var$bind($aa35a24624ec08d2$export$55abd4691b317664(win))($75f6ec27f640501f$export$ca000e230c0caa3e)();
    var pathname = $f8ebc5adafdca7e8$export$7333db99aa99d383(loc)();
    var search = $f8ebc5adafdca7e8$export$d76128d007d19019(loc)();
    var hash = $f8ebc5adafdca7e8$export$d6af199866bfb566(loc)();
    var path = pathname + (search + hash);
    return {
        state: state,
        pathname: pathname,
        search: search,
        hash: hash,
        path: path
    };
};
var $a5971154c27be447$export$46891e6a1989f34a = function(callback) {
    return function __do() {
        var activeRef = $90327512d8280b8d$export$b8cb59497041ffe4(true)();
        var listenerRef = $90327512d8280b8d$export$b8cb59497041ffe4($06733ae99ed4f534$export$bebe9059409a0d04.value)();
        var target = $a5971154c27be447$var$map($6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6)($2603425f82e959df$export$8291e5b88f90ce4)();
        var cleanup = function __do() {
            var active = $e521936ea118867a$export$aafa59e2e03f2942(activeRef)();
            return $a5971154c27be447$var$when(active)(function __do() {
                $e521936ea118867a$export$68d8715fc104d294(false)(activeRef)();
                var mbListener = $e521936ea118867a$export$aafa59e2e03f2942(listenerRef)();
                return $a5971154c27be447$var$for_(mbListener)(function(listener) {
                    return function __do() {
                        $98db70b23aa8a6ea$export$8ff9f68337b520c0($033348220d254d99$export$debdbaa302c3885c)(listener)(false)(target)();
                        return $98db70b23aa8a6ea$export$8ff9f68337b520c0($bf7e36c88b3944b3$export$a503f83d36739cbc)(listener)(false)(target)();
                    };
                })();
            })();
        };
        var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(v) {
            return function __do() {
                var active = $e521936ea118867a$export$aafa59e2e03f2942(activeRef)();
                return $a5971154c27be447$var$when(active)(function __do() {
                    cleanup();
                    return $a5971154c27be447$var$bindFlipped(callback)($a5971154c27be447$var$currentLocationState)();
                })();
            };
        })();
        $e521936ea118867a$export$68d8715fc104d294(new $06733ae99ed4f534$export$8a67b48435b5d073(listener))(listenerRef)();
        $98db70b23aa8a6ea$export$3f65cefe8380dbea($033348220d254d99$export$debdbaa302c3885c)(listener)(false)(target)();
        $98db70b23aa8a6ea$export$3f65cefe8380dbea($bf7e36c88b3944b3$export$a503f83d36739cbc)(listener)(false)(target)();
        return cleanup;
    };
};


// Generated by purs version 0.15.16

// Generated by purs version 0.15.16













var $3b789731b0ef5df1$var$toVars = /* #__PURE__ */ $a40b20519abba0fb$export$bed894b7b2c71cb8($dc9dc2b43b9526de$export$c0fc775ee5500e83);
var $3b789731b0ef5df1$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $3b789731b0ef5df1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $3b789731b0ef5df1$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $3b789731b0ef5df1$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70($3b789731b0ef5df1$var$encRNTY);
var $3b789731b0ef5df1$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099));
var $3b789731b0ef5df1$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($3b789731b0ef5df1$var$created_atIsSymbol)()())())));
var $3b789731b0ef5df1$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $3b789731b0ef5df1$var$gDecodeJsonCons3 = /* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $3b789731b0ef5df1$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $3b789731b0ef5df1$var$lockIsSymbol = {
    reflectSymbol: function() {
        return "lock";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons4 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $3b789731b0ef5df1$var$gDecodeJsonCons5 = /* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $3b789731b0ef5df1$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons6 = /* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$nameIsSymbol)()();
var $3b789731b0ef5df1$var$companyIsSymbol = {
    reflectSymbol: function() {
        return "company";
    }
};
var $3b789731b0ef5df1$var$urlIsSymbol = {
    reflectSymbol: function() {
        return "url";
    }
};
var $3b789731b0ef5df1$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons7 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $3b789731b0ef5df1$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $3b789731b0ef5df1$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $3b789731b0ef5df1$var$useDefaultIsSymbol = {
    reflectSymbol: function() {
        return "useDefault";
    }
};
var $3b789731b0ef5df1$var$saveDefaultIsSymbol = {
    reflectSymbol: function() {
        return "saveDefault";
    }
};
var $3b789731b0ef5df1$var$requestIsSymbol = {
    reflectSymbol: function() {
        return "request";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons8 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons3($3b789731b0ef5df1$var$useDefaultIsSymbol)()())($3b789731b0ef5df1$var$updateIsSymbol)()())($3b789731b0ef5df1$var$saveDefaultIsSymbol)()())($3b789731b0ef5df1$var$requestIsSymbol)()())($3b789731b0ef5df1$var$createIsSymbol)()())()));
var $3b789731b0ef5df1$var$relationship_labelIsSymbol = {
    reflectSymbol: function() {
        return "relationship_label";
    }
};
var $3b789731b0ef5df1$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $3b789731b0ef5df1$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $3b789731b0ef5df1$var$emailLabelIsSymbol = {
    reflectSymbol: function() {
        return "emailLabel";
    }
};
var $3b789731b0ef5df1$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $3b789731b0ef5df1$var$typeIsSymbol = {
    reflectSymbol: function() {
        return "type";
    }
};
var $3b789731b0ef5df1$var$signaturesIsSymbol = {
    reflectSymbol: function() {
        return "signatures";
    }
};
var $3b789731b0ef5df1$var$priorityIsSymbol = {
    reflectSymbol: function() {
        return "priority";
    }
};
var $3b789731b0ef5df1$var$mutationsIsSymbol = {
    reflectSymbol: function() {
        return "mutations";
    }
};
var $3b789731b0ef5df1$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $3b789731b0ef5df1$var$bgColorIsSymbol = {
    reflectSymbol: function() {
        return "bgColor";
    }
};
var $3b789731b0ef5df1$var$abbrIsSymbol = {
    reflectSymbol: function() {
        return "abbr";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons9 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $3b789731b0ef5df1$var$gDecodeJsonCons10 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099));
var $3b789731b0ef5df1$var$gDecodeJsonCons11 = /* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $3b789731b0ef5df1$var$default_last_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_last_name";
    }
};
var $3b789731b0ef5df1$var$default_first_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_first_name";
    }
};
var $3b789731b0ef5df1$var$default_emailIsSymbol = {
    reflectSymbol: function() {
        return "default_email";
    }
};
var $3b789731b0ef5df1$var$gDecodeJsonCons12 = /* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons11($3b789731b0ef5df1$var$keyIsSymbol)()();
var $3b789731b0ef5df1$var$colorIsSymbol = {
    reflectSymbol: function() {
        return "color";
    }
};
var $3b789731b0ef5df1$var$tagsIsSymbol = {
    reflectSymbol: function() {
        return "tags";
    }
};
var $3b789731b0ef5df1$var$preferred_nameIsSymbol = {
    reflectSymbol: function() {
        return "preferred_name";
    }
};
var $3b789731b0ef5df1$var$last_imported_atIsSymbol = {
    reflectSymbol: function() {
        return "last_imported_at";
    }
};
var $3b789731b0ef5df1$var$emailIsSymbol = {
    reflectSymbol: function() {
        return "email";
    }
};
var $3b789731b0ef5df1$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $3b789731b0ef5df1$var$verificationsIsSymbol = {
    reflectSymbol: function() {
        return "verifications";
    }
};
var $3b789731b0ef5df1$var$updated_atIsSymbol = {
    reflectSymbol: function() {
        return "updated_at";
    }
};
var $3b789731b0ef5df1$var$subtitleIsSymbol = {
    reflectSymbol: function() {
        return "subtitle";
    }
};
var $3b789731b0ef5df1$var$studentIsSymbol = {
    reflectSymbol: function() {
        return "student";
    }
};
var $3b789731b0ef5df1$var$signature_fieldsIsSymbol = {
    reflectSymbol: function() {
        return "signature_fields";
    }
};
var $3b789731b0ef5df1$var$locked_atIsSymbol = {
    reflectSymbol: function() {
        return "locked_at";
    }
};
var $3b789731b0ef5df1$var$legacy_urlIsSymbol = {
    reflectSymbol: function() {
        return "legacy_url";
    }
};
var $3b789731b0ef5df1$var$form_typeIsSymbol = {
    reflectSymbol: function() {
        return "form_type";
    }
};
var $3b789731b0ef5df1$var$exportsIsSymbol = {
    reflectSymbol: function() {
        return "exports";
    }
};
var $3b789731b0ef5df1$var$employerIsSymbol = {
    reflectSymbol: function() {
        return "employer";
    }
};
var $3b789731b0ef5df1$var$contactIsSymbol = {
    reflectSymbol: function() {
        return "contact";
    }
};
var $3b789731b0ef5df1$var$commentsIsSymbol = {
    reflectSymbol: function() {
        return "comments";
    }
};
var $3b789731b0ef5df1$var$attachmentsIsSymbol = {
    reflectSymbol: function() {
        return "attachments";
    }
};
var $3b789731b0ef5df1$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons2(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons3($3b789731b0ef5df1$var$updateIsSymbol)()())($3b789731b0ef5df1$var$lockIsSymbol)()())()))(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($3b789731b0ef5df1$var$gDecodeJsonCons6)()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$companyIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$urlIsSymbol)()())($3b789731b0ef5df1$var$labelIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$updateIsSymbol)()())($3b789731b0ef5df1$var$deleteIsSymbol)()())($3b789731b0ef5df1$var$createIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$fee2d5446387c54f))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons8(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$relationship_labelIsSymbol)()())($3b789731b0ef5df1$var$relationshipIsSymbol)()())($3b789731b0ef5df1$var$labelIsSymbol)()())($3b789731b0ef5df1$var$keyIsSymbol)()())($3b789731b0ef5df1$var$emailLabelIsSymbol)()())($3b789731b0ef5df1$var$canIsSymbol)()())())))(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons5($3b789731b0ef5df1$var$typeIsSymbol)()())($3b789731b0ef5df1$var$signaturesIsSymbol)()())($3b789731b0ef5df1$var$priorityIsSymbol)()())($3b789731b0ef5df1$var$mutationsIsSymbol)()())($3b789731b0ef5df1$var$labelIsSymbol)()())($3b789731b0ef5df1$var$idIsSymbol)()())($3b789731b0ef5df1$var$bgColorIsSymbol)()())($3b789731b0ef5df1$var$abbrIsSymbol)()())()))(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons10(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons8(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons11($3b789731b0ef5df1$var$relationshipIsSymbol)()())($3b789731b0ef5df1$var$labelIsSymbol)()())($3b789731b0ef5df1$var$keyIsSymbol)()())($3b789731b0ef5df1$var$emailLabelIsSymbol)()())($3b789731b0ef5df1$var$default_last_nameIsSymbol)()())($3b789731b0ef5df1$var$default_first_nameIsSymbol)()())($3b789731b0ef5df1$var$default_emailIsSymbol)()())($3b789731b0ef5df1$var$canIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($3b789731b0ef5df1$var$gDecodeJsonCons12)())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons7(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons10(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4($3b789731b0ef5df1$var$gDecodeJsonCons6)($3b789731b0ef5df1$var$colorIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($3b789731b0ef5df1$var$tagsIsSymbol)()())($3b789731b0ef5df1$var$preferred_nameIsSymbol)()())($3b789731b0ef5df1$var$nameIsSymbol)()())($3b789731b0ef5df1$var$last_imported_atIsSymbol)()())($3b789731b0ef5df1$var$idIsSymbol)()())()))(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $3b789731b0ef5df1$var$gDecodeJsonCons4($3b789731b0ef5df1$var$gDecodeJsonCons12)($3b789731b0ef5df1$var$emailIsSymbol)()())()))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($3b789731b0ef5df1$var$dataIsSymbol)()())($3b789731b0ef5df1$var$created_atIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($3b789731b0ef5df1$var$verificationsIsSymbol)()())($3b789731b0ef5df1$var$updated_atIsSymbol)()())($3b789731b0ef5df1$var$subtitleIsSymbol)()())($3b789731b0ef5df1$var$studentIsSymbol)()())($3b789731b0ef5df1$var$signaturesIsSymbol)()())($3b789731b0ef5df1$var$signature_fieldsIsSymbol)()())($3b789731b0ef5df1$var$locked_atIsSymbol)()())($3b789731b0ef5df1$var$legacy_urlIsSymbol)()())($3b789731b0ef5df1$var$idIsSymbol)()())($3b789731b0ef5df1$var$form_typeIsSymbol)()())($3b789731b0ef5df1$var$exportsIsSymbol)()())($3b789731b0ef5df1$var$employerIsSymbol)()())($3b789731b0ef5df1$var$contactIsSymbol)()())($3b789731b0ef5df1$var$commentsIsSymbol)()())($3b789731b0ef5df1$var$canIsSymbol)()())($3b789731b0ef5df1$var$attachmentsIsSymbol)()())();
var $3b789731b0ef5df1$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $3b789731b0ef5df1$var$rlhsCons1 = /* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()();
var $3b789731b0ef5df1$var$rlhsCons2 = /* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()();
var $3b789731b0ef5df1$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $3b789731b0ef5df1$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$useDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$saveDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$requestIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())();
var $3b789731b0ef5df1$var$rlhsCons3 = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()());
var $3b789731b0ef5df1$var$arrayShape = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())());
var $3b789731b0ef5df1$var$recShape1 = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$verificationsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$dataIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($3b789731b0ef5df1$var$rlhsCons1)($3b789731b0ef5df1$var$emailIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($3b789731b0ef5df1$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($3b789731b0ef5df1$var$updated_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$subtitleIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$studentIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$tagsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($3b789731b0ef5df1$var$rlhsCons2)($3b789731b0ef5df1$var$colorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($3b789731b0ef5df1$var$preferred_nameIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$last_imported_atIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($3b789731b0ef5df1$var$signaturesIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206($3b789731b0ef5df1$var$rlhsCons1)()))()())($3b789731b0ef5df1$var$signature_fieldsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$emailLabelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$default_last_nameIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$default_first_nameIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$default_emailIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$canIsSymbol)($3b789731b0ef5df1$var$recShape)()())()))()())($3b789731b0ef5df1$var$locked_atIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$legacy_urlIsSymbol)($3b789731b0ef5df1$var$maybeShape)()())($3b789731b0ef5df1$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$form_typeIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$typeIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$signaturesIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$relationship_labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$emailLabelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$canIsSymbol)($3b789731b0ef5df1$var$recShape)()())()))()())($3b789731b0ef5df1$var$priorityIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$mutationsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons3($3b789731b0ef5df1$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($3b789731b0ef5df1$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$bgColorIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$abbrIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($3b789731b0ef5df1$var$exportsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$urlIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($3b789731b0ef5df1$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($3b789731b0ef5df1$var$employerIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$companyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($3b789731b0ef5df1$var$contactIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206($3b789731b0ef5df1$var$rlhsCons2)()))()())($3b789731b0ef5df1$var$commentsIsSymbol)($3b789731b0ef5df1$var$arrayShape)()())($3b789731b0ef5df1$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons3($3b789731b0ef5df1$var$lockIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($3b789731b0ef5df1$var$attachmentsIsSymbol)($3b789731b0ef5df1$var$arrayShape)()())();
var $3b789731b0ef5df1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $3b789731b0ef5df1$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $3b789731b0ef5df1$var$idsIsSymbol = {
    reflectSymbol: function() {
        return "ids";
    }
};
var $3b789731b0ef5df1$var$rntyType = /* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
});
var $3b789731b0ef5df1$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $3b789731b0ef5df1$var$formsIsSymbol = {
    reflectSymbol: function() {
        return "forms";
    }
};
var $3b789731b0ef5df1$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $3b789731b0ef5df1$var$rltvCons($3b789731b0ef5df1$var$idsIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b($3b789731b0ef5df1$var$rntyType))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($3b789731b0ef5df1$var$encRNTY))()())(/* #__PURE__ */ $3b789731b0ef5df1$var$rltvfConsOther($3b789731b0ef5df1$var$idsIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($3b789731b0ef5df1$var$decodeRecord)))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($3b789731b0ef5df1$var$formsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $3b789731b0ef5df1$var$rlhsCons($3b789731b0ef5df1$var$formsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($3b789731b0ef5df1$var$recShape1))()())()));
var $3b789731b0ef5df1$var$buildQuery1 = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $3b789731b0ef5df1$var$rltvCons($3b789731b0ef5df1$var$idIsSymbol)($3b789731b0ef5df1$var$rntyType)($3b789731b0ef5df1$var$encRNTY)()())(/* #__PURE__ */ $3b789731b0ef5df1$var$rltvfConsOther($3b789731b0ef5df1$var$idIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379($3b789731b0ef5df1$var$decodeRecord)($3b789731b0ef5df1$var$recShape1));
var $3b789731b0ef5df1$export$8a7daa21c7faa7ff = /* #__PURE__ */ function() {
    function FormSearchQuery(value0) {
        this.value0 = value0;
    }
    FormSearchQuery.create = function(value0) {
        return new FormSearchQuery(value0);
    };
    return FormSearchQuery;
}();
var $3b789731b0ef5df1$export$5a69afe3171d1887 = {
    toVars: function(v) {
        if (v.value0.formIds.length === 0) return $3b789731b0ef5df1$var$toVars($dc9dc2b43b9526de$export$1f60fd986f394bce(v.value0));
        return $3b789731b0ef5df1$var$append($3b789731b0ef5df1$var$toVars($dc9dc2b43b9526de$export$1f60fd986f394bce(v.value0)))([
            new $a40b20519abba0fb$export$a90c0bb0b625769b("type_id", new $308f9765feb7633d$export$be01c6bffeb93e87(new $308f9765feb7633d$export$c76991cd6baf9718("ID")))
        ]);
    },
    encodeVars: function(v) {
        if (v.value0.formIds.length === 0) return $dc9dc2b43b9526de$export$da880a72ef7f44b2(v.value0);
        return $c045ea5df33bba60$export$21a5ca8aa77d35ff("type_id")($0e031af7428ef07d$export$dbafa4424a806c15($3b789731b0ef5df1$var$map($3b789731b0ef5df1$var$encodeJson)(v.value0.formIds)))($dc9dc2b43b9526de$export$da880a72ef7f44b2(v.value0));
    },
    varFiles: function(v) {
        return [];
    }
};
var $3b789731b0ef5df1$export$76fee8bb098f8940 = /* #__PURE__ */ function() {
    var $791 = $a40b20519abba0fb$export$bc1f9bac519c56f6("RecentForms");
    var $792 = $a40b20519abba0fb$export$d7b58f10109feb02($3b789731b0ef5df1$export$5a69afe3171d1887)($b5f6b40b8f63b732$export$5139894cdc05562a($3b789731b0ef5df1$var$decodeRecord)($3b789731b0ef5df1$var$recShape1))("recentForms");
    return function($793) {
        return $791($792($793));
    };
}();
var $3b789731b0ef5df1$export$65b249f9d8a6bd0d = function(ids) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("RecentFormsByIds")($3b789731b0ef5df1$var$map1(function(v) {
        return v.forms;
    })($3b789731b0ef5df1$var$buildQuery("forms")({
        ids: ids
    })));
};
var $3b789731b0ef5df1$export$cfbdcb940628b543 = function(id) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("RecentForm")($3b789731b0ef5df1$var$buildQuery1("form")({
        id: id
    }));
};
var $3b789731b0ef5df1$export$9d79b9e3c5a800f = /* #__PURE__ */ function() {
    return new $3b789731b0ef5df1$export$8a7daa21c7faa7ff({
        teacher: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        semester: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        search: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        "class": $06733ae99ed4f534$export$bebe9059409a0d04.value,
        formIds: []
    });
}();





// Generated by purs version 0.15.16
// Generated by purs version 0.15.16
// Generated by purs version 0.15.16









var $a8c8b5353c92bbbb$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $a8c8b5353c92bbbb$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a8c8b5353c92bbbb$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $a8c8b5353c92bbbb$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404($a8c8b5353c92bbbb$var$ordRNTY);
var $a8c8b5353c92bbbb$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $a8c8b5353c92bbbb$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $a8c8b5353c92bbbb$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($a8c8b5353c92bbbb$var$ordRNTY);
var $a8c8b5353c92bbbb$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $a8c8b5353c92bbbb$export$cc0235c9c614cd69 = /* #__PURE__ */ function() {
    function OperationRunning() {}
    OperationRunning.value = new OperationRunning();
    return OperationRunning;
}();
var $a8c8b5353c92bbbb$export$f2c3aa0c7bb49a61 = /* #__PURE__ */ function() {
    function OperationSucceeded() {}
    OperationSucceeded.value = new OperationSucceeded();
    return OperationSucceeded;
}();
var $a8c8b5353c92bbbb$export$f3190e9d914a857f = /* #__PURE__ */ function() {
    function OperationFailed(value0) {
        this.value0 = value0;
    }
    OperationFailed.create = function(value0) {
        return new OperationFailed(value0);
    };
    return OperationFailed;
}();
var $a8c8b5353c92bbbb$export$37b23006c73e8e8c = /* #__PURE__ */ function() {
    function OperationSuperseded() {}
    OperationSuperseded.value = new OperationSuperseded();
    return OperationSuperseded;
}();
var $a8c8b5353c92bbbb$export$78cbc2329447459a = /* #__PURE__ */ function() {
    function LoadRecentForms() {}
    LoadRecentForms.value = new LoadRecentForms();
    return LoadRecentForms;
}();
var $a8c8b5353c92bbbb$export$db10ae7477abb40b = /* #__PURE__ */ function() {
    function SaveStep1FormOrder() {}
    SaveStep1FormOrder.value = new SaveStep1FormOrder();
    return SaveStep1FormOrder;
}();
var $a8c8b5353c92bbbb$export$4606848e31468bbe = /* #__PURE__ */ function() {
    function CopyRecentForms(value0) {
        this.value0 = value0;
    }
    CopyRecentForms.create = function(value0) {
        return new CopyRecentForms(value0);
    };
    return CopyRecentForms;
}();
var $a8c8b5353c92bbbb$export$ca6f6e5e77298091 = /* #__PURE__ */ function() {
    function DeleteRecentForms(value0) {
        this.value0 = value0;
    }
    DeleteRecentForms.create = function(value0) {
        return new DeleteRecentForms(value0);
    };
    return DeleteRecentForms;
}();
var $a8c8b5353c92bbbb$export$a5b2acadcdb3baa4 = /* #__PURE__ */ function() {
    function ExportRecentForms(value0) {
        this.value0 = value0;
    }
    ExportRecentForms.create = function(value0) {
        return new ExportRecentForms(value0);
    };
    return ExportRecentForms;
}();
var $a8c8b5353c92bbbb$export$eb58b67453807721 = /* #__PURE__ */ function() {
    function RequestRecentFormSignatures(value0) {
        this.value0 = value0;
    }
    RequestRecentFormSignatures.create = function(value0) {
        return new RequestRecentFormSignatures(value0);
    };
    return RequestRecentFormSignatures;
}();
var $a8c8b5353c92bbbb$export$13e5863daa3c5eb1 = /* #__PURE__ */ function() {
    function UpdateRecentForms(value0) {
        this.value0 = value0;
    }
    UpdateRecentForms.create = function(value0) {
        return new UpdateRecentForms(value0);
    };
    return UpdateRecentForms;
}();
var $a8c8b5353c92bbbb$export$a5e6aa3b372c16a0 = /* #__PURE__ */ function() {
    function LoadStep2Students() {}
    LoadStep2Students.value = new LoadStep2Students();
    return LoadStep2Students;
}();
var $a8c8b5353c92bbbb$export$cf485ac8aca10137 = /* #__PURE__ */ function() {
    function LoadStep2FormPicker() {}
    LoadStep2FormPicker.value = new LoadStep2FormPicker();
    return LoadStep2FormPicker;
}();
var $a8c8b5353c92bbbb$export$beefc18c38a3140b = /* #__PURE__ */ function() {
    function ExportStep2Forms() {}
    ExportStep2Forms.value = new ExportStep2Forms();
    return ExportStep2Forms;
}();
var $a8c8b5353c92bbbb$export$db7e779274715f31 = /* #__PURE__ */ function() {
    function LoadStep3FormTypes() {}
    LoadStep3FormTypes.value = new LoadStep3FormTypes();
    return LoadStep3FormTypes;
}();
var $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90 = /* #__PURE__ */ function() {
    function LoadStep3Document(value0) {
        this.value0 = value0;
    }
    LoadStep3Document.create = function(value0) {
        return new LoadStep3Document(value0);
    };
    return LoadStep3Document;
}();
var $a8c8b5353c92bbbb$export$b49857229320d04d = /* #__PURE__ */ function() {
    function SaveStep3Document(value0) {
        this.value0 = value0;
    }
    SaveStep3Document.create = function(value0) {
        return new SaveStep3Document(value0);
    };
    return SaveStep3Document;
}();
var $a8c8b5353c92bbbb$export$790d8b2b1da998c3 = /* #__PURE__ */ function() {
    function AutofillStep3Document(value0) {
        this.value0 = value0;
    }
    AutofillStep3Document.create = function(value0) {
        return new AutofillStep3Document(value0);
    };
    return AutofillStep3Document;
}();
var $a8c8b5353c92bbbb$export$d5cd1cc1db16aadd = /* #__PURE__ */ function() {
    function ToggleStep3DocumentLock(value0) {
        this.value0 = value0;
    }
    ToggleStep3DocumentLock.create = function(value0) {
        return new ToggleStep3DocumentLock(value0);
    };
    return ToggleStep3DocumentLock;
}();
var $a8c8b5353c92bbbb$export$af004f84993afb6b = /* #__PURE__ */ function() {
    function CreateStep3Comment(value0) {
        this.value0 = value0;
    }
    CreateStep3Comment.create = function(value0) {
        return new CreateStep3Comment(value0);
    };
    return CreateStep3Comment;
}();
var $a8c8b5353c92bbbb$export$ffb1f8f95ffeffe4 = /* #__PURE__ */ function() {
    function UpdateStep3Comment(value0) {
        this.value0 = value0;
    }
    UpdateStep3Comment.create = function(value0) {
        return new UpdateStep3Comment(value0);
    };
    return UpdateStep3Comment;
}();
var $a8c8b5353c92bbbb$export$14fc0fe22255f268 = /* #__PURE__ */ function() {
    function DeleteStep3Comment(value0) {
        this.value0 = value0;
    }
    DeleteStep3Comment.create = function(value0) {
        return new DeleteStep3Comment(value0);
    };
    return DeleteStep3Comment;
}();
var $a8c8b5353c92bbbb$export$c3acb5c17ec9e09a = /* #__PURE__ */ function() {
    function CreateStep3Attachment(value0) {
        this.value0 = value0;
    }
    CreateStep3Attachment.create = function(value0) {
        return new CreateStep3Attachment(value0);
    };
    return CreateStep3Attachment;
}();
var $a8c8b5353c92bbbb$export$1275fb4c138da766 = /* #__PURE__ */ function() {
    function DeleteStep3Attachment(value0) {
        this.value0 = value0;
    }
    DeleteStep3Attachment.create = function(value0) {
        return new DeleteStep3Attachment(value0);
    };
    return DeleteStep3Attachment;
}();
var $a8c8b5353c92bbbb$export$e03fcd1abfca724a = /* #__PURE__ */ function() {
    function SignStep3Document(value0) {
        this.value0 = value0;
    }
    SignStep3Document.create = function(value0) {
        return new SignStep3Document(value0);
    };
    return SignStep3Document;
}();
var $a8c8b5353c92bbbb$export$903006ef3f779e68 = /* #__PURE__ */ function() {
    function SignStep3DocumentWithSaved(value0) {
        this.value0 = value0;
    }
    SignStep3DocumentWithSaved.create = function(value0) {
        return new SignStep3DocumentWithSaved(value0);
    };
    return SignStep3DocumentWithSaved;
}();
var $a8c8b5353c92bbbb$export$ef666bef212ffa51 = /* #__PURE__ */ function() {
    function RefreshStep3Signatures(value0) {
        this.value0 = value0;
    }
    RefreshStep3Signatures.create = function(value0) {
        return new RefreshStep3Signatures(value0);
    };
    return RefreshStep3Signatures;
}();
var $a8c8b5353c92bbbb$export$887f8ca70ce7e84e = /* #__PURE__ */ function() {
    function RequestStep3Signatures(value0) {
        this.value0 = value0;
    }
    RequestStep3Signatures.create = function(value0) {
        return new RequestStep3Signatures(value0);
    };
    return RequestStep3Signatures;
}();
var $a8c8b5353c92bbbb$export$58d3d305b67b6d53 = /* #__PURE__ */ function() {
    function BulkToggleDocumentLocks(value0) {
        this.value0 = value0;
    }
    BulkToggleDocumentLocks.create = function(value0) {
        return new BulkToggleDocumentLocks(value0);
    };
    return BulkToggleDocumentLocks;
}();
var $a8c8b5353c92bbbb$export$4e54c8f4f7e7816b = function(x) {
    return x;
};
var $a8c8b5353c92bbbb$export$fe446a0df01fe4d7 = /* #__PURE__ */ function() {
    function Step1GlobalScope() {}
    Step1GlobalScope.value = new Step1GlobalScope();
    return Step1GlobalScope;
}();
var $a8c8b5353c92bbbb$export$f0780570fbaaaac3 = /* #__PURE__ */ function() {
    function Step1RecentFormsScope() {}
    Step1RecentFormsScope.value = new Step1RecentFormsScope();
    return Step1RecentFormsScope;
}();
var $a8c8b5353c92bbbb$export$bd4ea9079614f218 = /* #__PURE__ */ function() {
    function Step1FormOrderScope() {}
    Step1FormOrderScope.value = new Step1FormOrderScope();
    return Step1FormOrderScope;
}();
var $a8c8b5353c92bbbb$export$812d070c95a0506d = /* #__PURE__ */ function() {
    function Step1DocumentMutationScope() {}
    Step1DocumentMutationScope.value = new Step1DocumentMutationScope();
    return Step1DocumentMutationScope;
}();
var $a8c8b5353c92bbbb$export$3fc2b2789a39ace6 = /* #__PURE__ */ function() {
    function Step1ExportScope() {}
    Step1ExportScope.value = new Step1ExportScope();
    return Step1ExportScope;
}();
var $a8c8b5353c92bbbb$export$1580c28f249da2ae = /* #__PURE__ */ function() {
    function Step2GlobalScope() {}
    Step2GlobalScope.value = new Step2GlobalScope();
    return Step2GlobalScope;
}();
var $a8c8b5353c92bbbb$export$d7525e570f2fab63 = /* #__PURE__ */ function() {
    function Step2StudentSelectScope() {}
    Step2StudentSelectScope.value = new Step2StudentSelectScope();
    return Step2StudentSelectScope;
}();
var $a8c8b5353c92bbbb$export$7a1013a450b76540 = /* #__PURE__ */ function() {
    function Step2FormPickerScope() {}
    Step2FormPickerScope.value = new Step2FormPickerScope();
    return Step2FormPickerScope;
}();
var $a8c8b5353c92bbbb$export$87c4c62ae2426f3d = /* #__PURE__ */ function() {
    function Step2ExportScope() {}
    Step2ExportScope.value = new Step2ExportScope();
    return Step2ExportScope;
}();
var $a8c8b5353c92bbbb$export$af93ed79d95822aa = /* #__PURE__ */ function() {
    function Step3GlobalScope() {}
    Step3GlobalScope.value = new Step3GlobalScope();
    return Step3GlobalScope;
}();
var $a8c8b5353c92bbbb$export$322fd23340c8c74b = /* #__PURE__ */ function() {
    function Step3DocumentScope(value0) {
        this.value0 = value0;
    }
    Step3DocumentScope.create = function(value0) {
        return new Step3DocumentScope(value0);
    };
    return Step3DocumentScope;
}();
var $a8c8b5353c92bbbb$export$31af119d3d026c19 = /* #__PURE__ */ function() {
    function TransitionGenerationScope(value0) {
        this.value0 = value0;
    }
    TransitionGenerationScope.create = function(value0) {
        return new TransitionGenerationScope(value0);
    };
    return TransitionGenerationScope;
}();
var $a8c8b5353c92bbbb$export$1957ebfdb7c5296d = $97937c29f879e68e$export$ff461bf68e7dd332;
var $a8c8b5353c92bbbb$export$f721f965d60cf4d0 = function(kind) {
    return function(generation) {
        var step3DocumentMutationScopes = function(docId) {
            return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value,
                new $a8c8b5353c92bbbb$export$322fd23340c8c74b(docId)
            ];
        };
        var baseScopes = function() {
            if (kind instanceof $a8c8b5353c92bbbb$export$78cbc2329447459a) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$f0780570fbaaaac3.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$db10ae7477abb40b) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$bd4ea9079614f218.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$4606848e31468bbe) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$812d070c95a0506d.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$ca6f6e5e77298091) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$812d070c95a0506d.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$a5b2acadcdb3baa4) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$3fc2b2789a39ace6.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$eb58b67453807721) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$812d070c95a0506d.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$13e5863daa3c5eb1) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$812d070c95a0506d.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$a5e6aa3b372c16a0) return [
                $a8c8b5353c92bbbb$export$1580c28f249da2ae.value,
                $a8c8b5353c92bbbb$export$d7525e570f2fab63.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$cf485ac8aca10137) return [
                $a8c8b5353c92bbbb$export$1580c28f249da2ae.value,
                $a8c8b5353c92bbbb$export$7a1013a450b76540.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$beefc18c38a3140b) return [
                $a8c8b5353c92bbbb$export$1580c28f249da2ae.value,
                $a8c8b5353c92bbbb$export$87c4c62ae2426f3d.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$db7e779274715f31) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90 && kind.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90 && kind.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value,
                new $a8c8b5353c92bbbb$export$322fd23340c8c74b(kind.value0.value0)
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$b49857229320d04d) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value,
                new $a8c8b5353c92bbbb$export$322fd23340c8c74b(kind.value0)
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$790d8b2b1da998c3) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value,
                new $a8c8b5353c92bbbb$export$322fd23340c8c74b(kind.value0)
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$d5cd1cc1db16aadd) return [
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value,
                new $a8c8b5353c92bbbb$export$322fd23340c8c74b(kind.value0)
            ];
            if (kind instanceof $a8c8b5353c92bbbb$export$af004f84993afb6b) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$ffb1f8f95ffeffe4) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$14fc0fe22255f268) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$c3acb5c17ec9e09a) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$1275fb4c138da766) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$e03fcd1abfca724a) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$903006ef3f779e68) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$ef666bef212ffa51) return step3DocumentMutationScopes(kind.value0);
            if (kind instanceof $a8c8b5353c92bbbb$export$887f8ca70ce7e84e) return $a8c8b5353c92bbbb$var$append([
                $a8c8b5353c92bbbb$export$af93ed79d95822aa.value
            ])($a8c8b5353c92bbbb$var$map($a8c8b5353c92bbbb$export$322fd23340c8c74b.create)($a8c8b5353c92bbbb$var$nub(kind.value0)));
            if (kind instanceof $a8c8b5353c92bbbb$export$58d3d305b67b6d53) return [
                $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value,
                $a8c8b5353c92bbbb$export$812d070c95a0506d.value
            ];
            throw new Error("Failed pattern match at App.Operation.Types (line 119, column 18 - line 145, column 86): " + [
                kind.constructor.name
            ]);
        }();
        return $a8c8b5353c92bbbb$var$append(baseScopes)($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])(function(gen) {
            return [
                new $a8c8b5353c92bbbb$export$31af119d3d026c19(gen)
            ];
        })(generation));
    };
};
var $a8c8b5353c92bbbb$export$e158d2e5de4809f6 = function(v) {
    if (v instanceof $a8c8b5353c92bbbb$export$78cbc2329447459a) return "Loading recent forms";
    if (v instanceof $a8c8b5353c92bbbb$export$db10ae7477abb40b) return "Saving form order";
    if (v instanceof $a8c8b5353c92bbbb$export$4606848e31468bbe) return "Copying " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$ca6f6e5e77298091) return "Deleting " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$a5b2acadcdb3baa4) return "Exporting " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$eb58b67453807721) return "Requesting signatures for " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$13e5863daa3c5eb1) return "Updating " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$a5e6aa3b372c16a0) return "Loading students";
    if (v instanceof $a8c8b5353c92bbbb$export$cf485ac8aca10137) return "Loading form picker";
    if (v instanceof $a8c8b5353c92bbbb$export$beefc18c38a3140b) return "Exporting selected forms";
    if (v instanceof $a8c8b5353c92bbbb$export$db7e779274715f31) return "Loading form types";
    if (v instanceof $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90 && v.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "Loading form";
    if (v instanceof $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "Loading form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$b49857229320d04d) return "Saving form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$790d8b2b1da998c3) return "Autofilling form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$d5cd1cc1db16aadd) return "Updating lock for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$af004f84993afb6b) return "Creating comment for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$ffb1f8f95ffeffe4) return "Updating comment for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$14fc0fe22255f268) return "Deleting comment for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$c3acb5c17ec9e09a) return "Creating attachment for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$1275fb4c138da766) return "Deleting attachment for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$e03fcd1abfca724a) return "Signing form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$903006ef3f779e68) return "Signing form " + ($308f9765feb7633d$export$a1b0f5347d2470b(v.value0) + " with saved signature");
    if (v instanceof $a8c8b5353c92bbbb$export$ef666bef212ffa51) return "Refreshing signatures for form " + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0);
    if (v instanceof $a8c8b5353c92bbbb$export$887f8ca70ce7e84e) return "Requesting signatures for " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    if (v instanceof $a8c8b5353c92bbbb$export$58d3d305b67b6d53) return "Updating " + ($a8c8b5353c92bbbb$var$show($fc8c1182ec2aefec$export$f24224f1c91d8156(v.value0)) + " forms");
    throw new Error("Failed pattern match at App.Operation.Types (line 87, column 18 - line 113, column 90): " + [
        v.constructor.name
    ]);
};
var $a8c8b5353c92bbbb$export$de3bce3e96d4de58 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7 && y instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3 && y instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218 && y instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d && y instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6 && y instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae && y instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63 && y instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540 && y instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d && y instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa && y instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa) return true;
            if (x instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b && y instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b) return $a8c8b5353c92bbbb$var$eq(x.value0)(y.value0);
            if (x instanceof $a8c8b5353c92bbbb$export$31af119d3d026c19 && y instanceof $a8c8b5353c92bbbb$export$31af119d3d026c19) return x.value0 === y.value0;
            return false;
        };
    }
};
var $a8c8b5353c92bbbb$export$41378796837b3533 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7 && y instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$fe446a0df01fe4d7) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3 && y instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$f0780570fbaaaac3) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218 && y instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$bd4ea9079614f218) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d && y instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$812d070c95a0506d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6 && y instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$3fc2b2789a39ace6) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae && y instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$1580c28f249da2ae) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63 && y instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$d7525e570f2fab63) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540 && y instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$7a1013a450b76540) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d && y instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$87c4c62ae2426f3d) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa && y instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$af93ed79d95822aa) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b && y instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b) return $a8c8b5353c92bbbb$var$compare(x.value0)(y.value0);
            if (x instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $a8c8b5353c92bbbb$export$322fd23340c8c74b) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $a8c8b5353c92bbbb$export$31af119d3d026c19 && y instanceof $a8c8b5353c92bbbb$export$31af119d3d026c19) return $a8c8b5353c92bbbb$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at App.Operation.Types (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $a8c8b5353c92bbbb$export$de3bce3e96d4de58;
    }
};
var $a8c8b5353c92bbbb$export$ddffdcd895d11148 = $37b880af5f4991bd$export$e65788c6d4494539;













var $fb0451ff9e33ce13$var$$$delete = /* #__PURE__ */ $a393155e52307a24$export$1822828d790e23ee($a8c8b5353c92bbbb$export$1957ebfdb7c5296d);
var $fb0451ff9e33ce13$var$update = /* #__PURE__ */ $ea3eb84de0acf574$export$722fbec263ad908a($a8c8b5353c92bbbb$export$41378796837b3533);
var $fb0451ff9e33ce13$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($a8c8b5353c92bbbb$export$ddffdcd895d11148);
var $fb0451ff9e33ce13$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($a8c8b5353c92bbbb$export$1957ebfdb7c5296d);
var $fb0451ff9e33ce13$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $fb0451ff9e33ce13$var$lookup1 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($a8c8b5353c92bbbb$export$41378796837b3533);
var $fb0451ff9e33ce13$var$lookup2 = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$ff461bf68e7dd332);
var $fb0451ff9e33ce13$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $fb0451ff9e33ce13$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($a393155e52307a24$export$fd19c21b7e75dff0);
var $fb0451ff9e33ce13$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($a8c8b5353c92bbbb$export$1957ebfdb7c5296d);
var $fb0451ff9e33ce13$var$insert1 = /* #__PURE__ */ $a393155e52307a24$export$21a5ca8aa77d35ff($a8c8b5353c92bbbb$export$1957ebfdb7c5296d);
var $fb0451ff9e33ce13$var$alter = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($a8c8b5353c92bbbb$export$41378796837b3533);
var $fb0451ff9e33ce13$var$alter1 = /* #__PURE__ */ $ea3eb84de0acf574$export$22a7378e1d3307a4($97937c29f879e68e$export$ff461bf68e7dd332);
var $fb0451ff9e33ce13$var$insert2 = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($a8c8b5353c92bbbb$export$41378796837b3533);
var $fb0451ff9e33ce13$var$max = /* #__PURE__ */ $97937c29f879e68e$export$8960430cfd85939f($97937c29f879e68e$export$ff461bf68e7dd332);
var $fb0451ff9e33ce13$var$unwrapOperationId = function(v) {
    return v;
};
var $fb0451ff9e33ce13$var$removeScopeMembership = function(scope) {
    return function(opId) {
        var update1 = function(ids) {
            var nextIds = $fb0451ff9e33ce13$var$$$delete(opId)(ids);
            var $42 = $a393155e52307a24$export$dd1bc94b04021eeb(nextIds);
            if ($42) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073(nextIds);
        };
        return $fb0451ff9e33ce13$var$update(update1)(scope);
    };
};
var $fb0451ff9e33ce13$var$noteTerminal = function(opId) {
    return function(ids) {
        var $43 = $fb0451ff9e33ce13$var$elem(opId)(ids);
        if ($43) return ids;
        return $396c4c3d9e7fae3c$export$c40cf5aab899f397(ids)(opId);
    };
};
var $fb0451ff9e33ce13$var$nextOperationId = function(store) {
    return store.nextId + 1 | 0;
};
var $fb0451ff9e33ce13$export$c9a071778b2d670f = function(store) {
    var opId = $fb0451ff9e33ce13$var$nextOperationId(store);
    return new $71f2e2e9476163f8$export$1908877435b1d5e9(opId, {
        activeByScope: store.activeByScope,
        byGeneration: store.byGeneration,
        entries: store.entries,
        latestByScope: store.latestByScope,
        recentTerminal: store.recentTerminal,
        nextId: $fb0451ff9e33ce13$var$unwrapOperationId(opId)
    });
};
var $fb0451ff9e33ce13$export$a423c5a668a8bb9d = function(store) {
    return function(opId) {
        return $fb0451ff9e33ce13$var$lookup(opId)(store.entries);
    };
};
var $fb0451ff9e33ce13$export$4b2eb0e7d83e1f5a = function(store) {
    return function(scope) {
        return $fb0451ff9e33ce13$var$bind($fb0451ff9e33ce13$var$lookup1(scope)(store.latestByScope))(function(opId) {
            return $fb0451ff9e33ce13$export$a423c5a668a8bb9d(store)(opId);
        });
    };
};
var $fb0451ff9e33ce13$export$c8d59a32e9dc271d = /* #__PURE__ */ function() {
    var $69 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
    return function($70) {
        return $69($ea3eb84de0acf574$export$68c286be0e7e55b7(function(v) {
            return v.entries;
        }($70)));
    };
}();
var $fb0451ff9e33ce13$export$4595ffb8d5e10637 = function(store) {
    return function(generation) {
        var v = $fb0451ff9e33ce13$var$lookup2(generation)(store.byGeneration);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($fb0451ff9e33ce13$var$map($fb0451ff9e33ce13$export$a423c5a668a8bb9d(store))($fb0451ff9e33ce13$var$fromFoldable(v.value0)));
        throw new Error("Failed pattern match at App.Operation.Store (line 134, column 45 - line 136, column 83): " + [
            v.constructor.name
        ]);
    };
};
var $fb0451ff9e33ce13$export$e2db8f1c2b895a63 = function(store) {
    return function(scope) {
        var v = $fb0451ff9e33ce13$var$lookup1(scope)(store.activeByScope);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return !$a393155e52307a24$export$dd1bc94b04021eeb(v.value0);
        throw new Error("Failed pattern match at App.Operation.Store (line 129, column 29 - line 131, column 38): " + [
            v.constructor.name
        ]);
    };
};
var $fb0451ff9e33ce13$export$6bed92fff59224d8 = function(store) {
    return function(opId) {
        var v = $fb0451ff9e33ce13$export$a423c5a668a8bb9d(store)(opId);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.status instanceof $a8c8b5353c92bbbb$export$cc0235c9c614cd69) return true;
        return false;
    };
};
var $fb0451ff9e33ce13$export$7d44a4637a1173f6 = {
    nextId: 0,
    entries: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    latestByScope: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    activeByScope: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    byGeneration: $ea3eb84de0acf574$export$6e22c362a0406a2c,
    recentTerminal: []
};
var $fb0451ff9e33ce13$var$deactivateEntry = function(entry) {
    return function(store) {
        return {
            nextId: store.nextId,
            entries: store.entries,
            latestByScope: store.latestByScope,
            byGeneration: store.byGeneration,
            recentTerminal: store.recentTerminal,
            activeByScope: $396c4c3d9e7fae3c$export$50ae948ca12cdcbc(function(acc) {
                return function(scope) {
                    return $fb0451ff9e33ce13$var$removeScopeMembership(scope)(entry.id)(acc);
                };
            })(store.activeByScope)(entry.scopes)
        };
    };
};
var $fb0451ff9e33ce13$export$f92ca06486a47b7a = function(opId) {
    return function(store) {
        var v = $fb0451ff9e33ce13$var$lookup(opId)(store.entries);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return store;
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var nextEntry = function() {
                if (v.value0.status instanceof $a8c8b5353c92bbbb$export$f2c3aa0c7bb49a61) return v.value0;
                if (v.value0.status instanceof $a8c8b5353c92bbbb$export$f3190e9d914a857f) return v.value0;
                return {
                    generation: v.value0.generation,
                    id: v.value0.id,
                    kind: v.value0.kind,
                    scopes: v.value0.scopes,
                    status: $a8c8b5353c92bbbb$export$37b23006c73e8e8c.value
                };
            }();
            var baseStore = $fb0451ff9e33ce13$var$deactivateEntry(v.value0)(store);
            return {
                nextId: baseStore.nextId,
                latestByScope: baseStore.latestByScope,
                activeByScope: baseStore.activeByScope,
                byGeneration: baseStore.byGeneration,
                entries: $fb0451ff9e33ce13$var$insert(opId)(nextEntry)(baseStore.entries),
                recentTerminal: $fb0451ff9e33ce13$var$noteTerminal(opId)(baseStore.recentTerminal)
            };
        }
        throw new Error("Failed pattern match at App.Operation.Store (line 102, column 29 - line 113, column 14): " + [
            v.constructor.name
        ]);
    };
};
var $fb0451ff9e33ce13$export$8650904b5e89876a = function(opId) {
    return function(result) {
        return function(store) {
            var v = $fb0451ff9e33ce13$var$lookup(opId)(store.entries);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return store;
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var nextEntry = function() {
                    if (v.value0.status instanceof $a8c8b5353c92bbbb$export$37b23006c73e8e8c) return v.value0;
                    return {
                        generation: v.value0.generation,
                        id: v.value0.id,
                        kind: v.value0.kind,
                        scopes: v.value0.scopes,
                        status: $7d4cccdf062a2261$export$5f5be1bb6cd1fded($a8c8b5353c92bbbb$export$f3190e9d914a857f.create)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($a8c8b5353c92bbbb$export$f2c3aa0c7bb49a61.value))(result)
                    };
                }();
                var baseStore = $fb0451ff9e33ce13$var$deactivateEntry(v.value0)(store);
                return {
                    nextId: baseStore.nextId,
                    latestByScope: baseStore.latestByScope,
                    activeByScope: baseStore.activeByScope,
                    byGeneration: baseStore.byGeneration,
                    entries: $fb0451ff9e33ce13$var$insert(opId)(nextEntry)(baseStore.entries),
                    recentTerminal: $fb0451ff9e33ce13$var$noteTerminal(opId)(baseStore.recentTerminal)
                };
            }
            throw new Error("Failed pattern match at App.Operation.Store (line 89, column 39 - line 99, column 14): " + [
                v.constructor.name
            ]);
        };
    };
};
var $fb0451ff9e33ce13$var$addScopeMembership = function(scope) {
    return function(opId) {
        var update1 = function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073($a393155e52307a24$export$439306a4dcaafbb9(opId));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($fb0451ff9e33ce13$var$insert1(opId)(v.value0));
            throw new Error("Failed pattern match at App.Operation.Store (line 166, column 14 - line 168, column 47): " + [
                v.constructor.name
            ]);
        };
        return $fb0451ff9e33ce13$var$alter(update1)(scope);
    };
};
var $fb0451ff9e33ce13$var$addGenerationMembership = function(generation) {
    return function(opId) {
        var update1 = function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $06733ae99ed4f534$export$8a67b48435b5d073($a393155e52307a24$export$439306a4dcaafbb9(opId));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073($fb0451ff9e33ce13$var$insert1(opId)(v.value0));
            throw new Error("Failed pattern match at App.Operation.Store (line 182, column 14 - line 184, column 47): " + [
                v.constructor.name
            ]);
        };
        return $fb0451ff9e33ce13$var$alter1(update1)(generation);
    };
};
var $fb0451ff9e33ce13$var$activateEntry = function(entry) {
    return function(store) {
        var withLatest = $396c4c3d9e7fae3c$export$50ae948ca12cdcbc(function(acc) {
            return function(scope) {
                return {
                    activeByScope: acc.activeByScope,
                    byGeneration: acc.byGeneration,
                    entries: acc.entries,
                    nextId: acc.nextId,
                    recentTerminal: acc.recentTerminal,
                    latestByScope: $fb0451ff9e33ce13$var$insert2(scope)(entry.id)(acc.latestByScope)
                };
            };
        })(store)(entry.scopes);
        var withActive = $396c4c3d9e7fae3c$export$50ae948ca12cdcbc(function(acc) {
            return function(scope) {
                return {
                    byGeneration: acc.byGeneration,
                    entries: acc.entries,
                    latestByScope: acc.latestByScope,
                    nextId: acc.nextId,
                    recentTerminal: acc.recentTerminal,
                    activeByScope: $fb0451ff9e33ce13$var$addScopeMembership(scope)(entry.id)(acc.activeByScope)
                };
            };
        })(withLatest)(entry.scopes);
        if (entry.generation instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return withActive;
        if (entry.generation instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            nextId: withActive.nextId,
            entries: withActive.entries,
            latestByScope: withActive.latestByScope,
            activeByScope: withActive.activeByScope,
            recentTerminal: withActive.recentTerminal,
            byGeneration: $fb0451ff9e33ce13$var$addGenerationMembership(entry.generation.value0)(entry.id)(withActive.byGeneration)
        };
        throw new Error("Failed pattern match at App.Operation.Store (line 151, column 8 - line 154, column 110): " + [
            entry.generation.constructor.name
        ]);
    };
};
var $fb0451ff9e33ce13$export$60d3f62a64b4c0cf = function(opId) {
    return function(kind) {
        return function(generation) {
            return function(store) {
                var v = $fb0451ff9e33ce13$var$lookup(opId)(store.entries);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                    entries: store.entries,
                    latestByScope: store.latestByScope,
                    activeByScope: store.activeByScope,
                    byGeneration: store.byGeneration,
                    recentTerminal: store.recentTerminal,
                    nextId: $fb0451ff9e33ce13$var$max(store.nextId)($fb0451ff9e33ce13$var$unwrapOperationId(opId))
                };
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                    var entry = {
                        id: opId,
                        kind: kind,
                        scopes: $a8c8b5353c92bbbb$export$f721f965d60cf4d0(kind)(generation),
                        generation: generation,
                        status: $a8c8b5353c92bbbb$export$cc0235c9c614cd69.value
                    };
                    var reserved = {
                        activeByScope: store.activeByScope,
                        byGeneration: store.byGeneration,
                        latestByScope: store.latestByScope,
                        recentTerminal: store.recentTerminal,
                        nextId: $fb0451ff9e33ce13$var$max(store.nextId)($fb0451ff9e33ce13$var$unwrapOperationId(opId)),
                        entries: $fb0451ff9e33ce13$var$insert(opId)(entry)(store.entries)
                    };
                    return $fb0451ff9e33ce13$var$activateEntry(entry)(reserved);
                }
                throw new Error("Failed pattern match at App.Operation.Store (line 62, column 53 - line 79, column 40): " + [
                    v.constructor.name
                ]);
            };
        };
    };
};
var $fb0451ff9e33ce13$export$97e9c35782480a5 = function(kind) {
    return function(generation) {
        return function(store) {
            var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(store);
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $fb0451ff9e33ce13$export$60d3f62a64b4c0cf(v.value0)(kind)(generation)(v.value1));
        };
    };
};






var $80445329d31df9ca$export$6ccb33ca865146ee = /* #__PURE__ */ function() {
    function Step3NotLoaded() {}
    Step3NotLoaded.value = new Step3NotLoaded();
    return Step3NotLoaded;
}();
var $80445329d31df9ca$export$52520e6e1d2bce34 = /* #__PURE__ */ function() {
    function Step3LoadingFormTypes(value0) {
        this.value0 = value0;
    }
    Step3LoadingFormTypes.create = function(value0) {
        return new Step3LoadingFormTypes(value0);
    };
    return Step3LoadingFormTypes;
}();
var $80445329d31df9ca$export$b87e8303844f9049 = /* #__PURE__ */ function() {
    function Step3LoadingInitialState(value0) {
        this.value0 = value0;
    }
    Step3LoadingInitialState.create = function(value0) {
        return new Step3LoadingInitialState(value0);
    };
    return Step3LoadingInitialState;
}();
var $80445329d31df9ca$export$23187e44e30bad72 = /* #__PURE__ */ function() {
    function Step3Ready(value0) {
        this.value0 = value0;
    }
    Step3Ready.create = function(value0) {
        return new Step3Ready(value0);
    };
    return Step3Ready;
}();
var $80445329d31df9ca$export$5a2874dd5397e561 = /* #__PURE__ */ function() {
    function Step2BNotLoaded() {}
    Step2BNotLoaded.value = new Step2BNotLoaded();
    return Step2BNotLoaded;
}();
var $80445329d31df9ca$export$851fbd25481b6c25 = /* #__PURE__ */ function() {
    function Step2BLoading(value0) {
        this.value0 = value0;
    }
    Step2BLoading.create = function(value0) {
        return new Step2BLoading(value0);
    };
    return Step2BLoading;
}();
var $80445329d31df9ca$export$81701a88d512004b = /* #__PURE__ */ function() {
    function Step2BReady(value0) {
        this.value0 = value0;
    }
    Step2BReady.create = function(value0) {
        return new Step2BReady(value0);
    };
    return Step2BReady;
}();
var $80445329d31df9ca$export$d17de998d9231f6f = /* #__PURE__ */ function() {
    function Step2BLoadFailed(value0) {
        this.value0 = value0;
    }
    Step2BLoadFailed.create = function(value0) {
        return new Step2BLoadFailed(value0);
    };
    return Step2BLoadFailed;
}();
var $80445329d31df9ca$export$c4ebf5472a2afaba = /* #__PURE__ */ function() {
    function Step2ANotLoaded() {}
    Step2ANotLoaded.value = new Step2ANotLoaded();
    return Step2ANotLoaded;
}();
var $80445329d31df9ca$export$adf38f4e421177a0 = /* #__PURE__ */ function() {
    function Step2ALoading(value0) {
        this.value0 = value0;
    }
    Step2ALoading.create = function(value0) {
        return new Step2ALoading(value0);
    };
    return Step2ALoading;
}();
var $80445329d31df9ca$export$b6b6ceaf3ddf8f7c = /* #__PURE__ */ function() {
    function Step2AReady(value0) {
        this.value0 = value0;
    }
    Step2AReady.create = function(value0) {
        return new Step2AReady(value0);
    };
    return Step2AReady;
}();
var $80445329d31df9ca$export$10d33c2f80e61d21 = /* #__PURE__ */ function() {
    function Step2ALoadFailed(value0) {
        this.value0 = value0;
    }
    Step2ALoadFailed.create = function(value0) {
        return new Step2ALoadFailed(value0);
    };
    return Step2ALoadFailed;
}();
var $80445329d31df9ca$export$d5867a59558324d9 = /* #__PURE__ */ function() {
    function Step1NotLoaded() {}
    Step1NotLoaded.value = new Step1NotLoaded();
    return Step1NotLoaded;
}();
var $80445329d31df9ca$export$9787b7e6f37d414e = /* #__PURE__ */ function() {
    function Step1Loading(value0) {
        this.value0 = value0;
    }
    Step1Loading.create = function(value0) {
        return new Step1Loading(value0);
    };
    return Step1Loading;
}();
var $80445329d31df9ca$export$3a4efe2ed5897b55 = /* #__PURE__ */ function() {
    function Step1Ready(value0) {
        this.value0 = value0;
    }
    Step1Ready.create = function(value0) {
        return new Step1Ready(value0);
    };
    return Step1Ready;
}();
var $80445329d31df9ca$export$b7b72b4685ba4f49 = /* #__PURE__ */ function() {
    function PushRouteHistory() {}
    PushRouteHistory.value = new PushRouteHistory();
    return PushRouteHistory;
}();
var $80445329d31df9ca$export$c72c14f37d28f60d = /* #__PURE__ */ function() {
    function ReplaceRouteHistory() {}
    ReplaceRouteHistory.value = new ReplaceRouteHistory();
    return ReplaceRouteHistory;
}();
var $80445329d31df9ca$var$step3InitForState = function(state) {
    var currentDoc = function() {
        if (state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return $740d96ccf08cc464$export$11eb3b5ef9574821(state.workQueueState)(state.step.value0);
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    }();
    return {
        doc: currentDoc,
        formType: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        initialAnchor: function() {
            if (state.route instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && state.route.value0.section instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return new $06733ae99ed4f534$export$8a67b48435b5d073(state.route.value0.section.value0);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        }()
    };
};
var $80445329d31df9ca$var$step3SessionForState = function(state) {
    if (state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return new $80445329d31df9ca$export$52520e6e1d2bce34({
        init: $80445329d31df9ca$var$step3InitForState(state),
        opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
    });
    if (state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return new $80445329d31df9ca$export$52520e6e1d2bce34({
        init: $80445329d31df9ca$var$step3InitForState(state),
        opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
    });
    return $80445329d31df9ca$export$6ccb33ca865146ee.value;
};
var $80445329d31df9ca$var$step2BSessionForState = function(state) {
    if (state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) return new $80445329d31df9ca$export$851fbd25481b6c25({
        workQueueState: state.workQueueState,
        workQueueUi: state.workQueueUi,
        workQueueCache: state.workQueueCache,
        opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
    });
    return $80445329d31df9ca$export$5a2874dd5397e561.value;
};
var $80445329d31df9ca$var$step2ASessionForState = function(state) {
    if (state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) return new $80445329d31df9ca$export$adf38f4e421177a0({
        workQueueState: state.workQueueState,
        workQueueCache: state.workQueueCache,
        opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
    });
    return $80445329d31df9ca$export$c4ebf5472a2afaba.value;
};
var $80445329d31df9ca$export$703b497c08aea184 = function(state) {
    return {
        workQueueState: state.workQueueState,
        workQueueUi: state.workQueueUi,
        workQueueCache: state.workQueueCache,
        preselectForms: state.preselectForms
    };
};
var $80445329d31df9ca$var$step1SessionForState = function(previous) {
    return function(nextState) {
        if (nextState.step instanceof $994495db3cff0a67$export$317e7082611cb548) {
            if (previous.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                if (previous.step instanceof $994495db3cff0a67$export$317e7082611cb548) return new $80445329d31df9ca$export$3a4efe2ed5897b55({
                    recentForms: previous.step1.value0.recentForms,
                    selection: previous.step1.value0.selection,
                    formPicker: previous.step1.value0.formPicker,
                    state: previous.step1.value0.state,
                    searchVersion: previous.step1.value0.searchVersion,
                    searchState: nextState.workQueueUi.search
                });
                return new $80445329d31df9ca$export$9787b7e6f37d414e({
                    init: $80445329d31df9ca$export$703b497c08aea184(nextState),
                    opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
                });
            }
            return new $80445329d31df9ca$export$9787b7e6f37d414e({
                init: $80445329d31df9ca$export$703b497c08aea184(nextState),
                opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
            });
        }
        return $80445329d31df9ca$export$d5867a59558324d9.value;
    };
};
var $80445329d31df9ca$export$9229a4a65d5e2788 = function(previous) {
    return function(nextState) {
        return {
            route: nextState.route,
            step: nextState.step,
            workQueueState: nextState.workQueueState,
            workQueueUi: nextState.workQueueUi,
            workQueueCache: nextState.workQueueCache,
            preselectForms: nextState.preselectForms,
            pushStateInterface: nextState.pushStateInterface,
            operations: nextState.operations,
            routeVersion: nextState.routeVersion,
            step1: $80445329d31df9ca$var$step1SessionForState(previous)(nextState),
            step2A: $80445329d31df9ca$var$step2ASessionForState(nextState),
            step2B: $80445329d31df9ca$var$step2BSessionForState(nextState),
            step3: $80445329d31df9ca$var$step3SessionForState(nextState)
        };
    };
};
var $80445329d31df9ca$export$4555711bcdd32da8 = function(step3) {
    return function(state) {
        return {
            route: state.route,
            step: state.step,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            routeVersion: state.routeVersion,
            step3: step3
        };
    };
};
var $80445329d31df9ca$export$3a00184c4304ec2e = function(init) {
    var state = {
        route: init.route,
        step: init.step,
        workQueueState: init.workQueueState,
        workQueueUi: init.workQueueUi,
        workQueueCache: init.workQueueCache,
        preselectForms: init.preselectForms,
        pushStateInterface: init.pushStateInterface,
        operations: $fb0451ff9e33ce13$export$7d44a4637a1173f6,
        step1: $80445329d31df9ca$export$d5867a59558324d9.value,
        step2A: $80445329d31df9ca$export$c4ebf5472a2afaba.value,
        step2B: $80445329d31df9ca$export$5a2874dd5397e561.value,
        step3: $80445329d31df9ca$export$6ccb33ca865146ee.value,
        routeVersion: 0
    };
    return $80445329d31df9ca$export$9229a4a65d5e2788(state)(state);
};
var $80445329d31df9ca$export$86748c9113edb676 = function(step) {
    return function(state) {
        return $80445329d31df9ca$export$9229a4a65d5e2788(state)({
            route: state.route,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step: step
        });
    };
};




























// Generated by purs version 0.15.16













// Generated by purs version 0.15.16


// Generated by purs version 0.15.16

















// Generated by purs version 0.15.16













var $8d9a255c71d1e384$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $8d9a255c71d1e384$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $8d9a255c71d1e384$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$25cda6d3e08b28fe);
var $8d9a255c71d1e384$var$sum = /* #__PURE__ */ $4fe7b6acfba7f29f$export$8a63f25cc62965f1($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8d9a255c71d1e384$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8d9a255c71d1e384$var$product = /* #__PURE__ */ $4fe7b6acfba7f29f$export$dbd0f18357df1ddd($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8d9a255c71d1e384$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8d9a255c71d1e384$var$foldr = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a11cb61c36c4a4cf($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8d9a255c71d1e384$var$fold = /* #__PURE__ */ $4fe7b6acfba7f29f$export$93e2b83da34ff82a($78c799cba34fcb8d$export$92659ee1fc91a075);
var $8d9a255c71d1e384$var$foldMap = /* #__PURE__ */ $4fe7b6acfba7f29f$export$b66cdc0497d8a99a($78c799cba34fcb8d$export$92659ee1fc91a075)($78c799cba34fcb8d$export$14584e231e9c63ca);
var $8d9a255c71d1e384$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($78c799cba34fcb8d$export$99c2ce29c0ead637);
var $8d9a255c71d1e384$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($78c799cba34fcb8d$export$7e49f2fa1ca16fbc);
var $8d9a255c71d1e384$export$59babcbc733451f = function(x) {
    return x;
};
var $8d9a255c71d1e384$export$1443e4f2c4d4b423 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0($78c799cba34fcb8d$export$36831384a74c4427($78c799cba34fcb8d$export$36831384a74c4427(dictShow)));
    return {
        show: function(v) {
            return "(Free " + (show(v) + ")");
        }
    };
};
var $8d9a255c71d1e384$export$623c37849a5e5581 = /* #__PURE__ */ function() {
    return {
        add: function(v) {
            return function(v1) {
                return $8d9a255c71d1e384$var$append1(v)(v1);
            };
        },
        zero: $78c799cba34fcb8d$export$c1bed610ade55e1c.value,
        mul: function(v) {
            return function(v1) {
                return $8d9a255c71d1e384$var$bind(v)(function(xs) {
                    return $8d9a255c71d1e384$var$bind(v1)(function(ys) {
                        return $8d9a255c71d1e384$var$pure($8d9a255c71d1e384$var$append1(xs)(ys));
                    });
                });
            };
        },
        one: $3d4fd987da5242ff$export$439306a4dcaafbb9($78c799cba34fcb8d$export$c1bed610ade55e1c.value)
    };
}();
var $8d9a255c71d1e384$export$82077f6fbf7f5089 = {
    Coercible0: function() {
        return undefined;
    }
};
var $8d9a255c71d1e384$export$a41966e57fa60612 = function(dictSemiring) {
    var sum1 = $8d9a255c71d1e384$var$sum(dictSemiring);
    var product1 = $8d9a255c71d1e384$var$product(dictSemiring);
    return function(f) {
        return function(v) {
            return sum1($8d9a255c71d1e384$var$map(function() {
                var $83 = $8d9a255c71d1e384$var$map(f);
                return function($84) {
                    return product1($83($84));
                };
            }())(v));
        };
    };
};
var $8d9a255c71d1e384$export$10302583f3ce93b5 = {
    map: function(fn) {
        return function(v) {
            return $8d9a255c71d1e384$var$map($8d9a255c71d1e384$var$map(fn))(v);
        };
    }
};
var $8d9a255c71d1e384$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($8d9a255c71d1e384$export$10302583f3ce93b5);
var $8d9a255c71d1e384$export$13e2de3c33d99539 = function(a) {
    return $3d4fd987da5242ff$export$439306a4dcaafbb9($3d4fd987da5242ff$export$439306a4dcaafbb9(a));
};
var $8d9a255c71d1e384$export$86d5c44e91d807d8 = function(dictSemiring) {
    return function(f) {
        return function(a) {
            return f($8d9a255c71d1e384$export$13e2de3c33d99539(a));
        };
    };
};
var $8d9a255c71d1e384$export$7bf6537c73f09eab = {
    foldl: function(fn) {
        return function(accum) {
            return function(v) {
                return $8d9a255c71d1e384$var$foldl($8d9a255c71d1e384$var$foldl(fn))(accum)(v);
            };
        };
    },
    foldr: function(fn) {
        return function(accum) {
            return function(v) {
                return $8d9a255c71d1e384$var$foldr($f57f4b701aa7b66e$export$8a83211c878a3f1f($8d9a255c71d1e384$var$foldr(fn)))(accum)(v);
            };
        };
    },
    foldMap: function(dictMonoid) {
        var fold1 = $8d9a255c71d1e384$var$fold(dictMonoid);
        return function(fn) {
            return function(v) {
                return fold1($8d9a255c71d1e384$var$foldMap($8d9a255c71d1e384$var$map(fn))(v));
            };
        };
    }
};
var $8d9a255c71d1e384$export$816b93e586e4c75c = {
    sequence: function(dictApplicative) {
        var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        var sequence1 = $8d9a255c71d1e384$var$sequence(dictApplicative);
        return function(v) {
            return map2($8d9a255c71d1e384$export$59babcbc733451f)(sequence1($8d9a255c71d1e384$var$map(sequence1)(v)));
        };
    },
    traverse: function(dictApplicative) {
        return function(fn) {
            return function(freeA) {
                return $11d1e86de605dfc6$export$49bb65c2ea163039($8d9a255c71d1e384$export$816b93e586e4c75c)(dictApplicative)($8d9a255c71d1e384$var$map1(fn)(freeA));
            };
        };
    },
    Functor0: function() {
        return $8d9a255c71d1e384$export$10302583f3ce93b5;
    },
    Foldable1: function() {
        return $8d9a255c71d1e384$export$7bf6537c73f09eab;
    }
};
var $8d9a255c71d1e384$export$14742287b71545dd = function(dictEq) {
    var eq = $37b880af5f4991bd$export$9663ddc1cf085b32($78c799cba34fcb8d$export$1ae88a7f3c5f59ef($78c799cba34fcb8d$export$1ae88a7f3c5f59ef(dictEq)));
    return {
        eq: function(v) {
            return function(v1) {
                return eq(v)(v1);
            };
        }
    };
};
var $8d9a255c71d1e384$export$10be470239ca56c7 = function(dictOrd) {
    var compare = $97937c29f879e68e$export$398604a469f7de9a($78c799cba34fcb8d$export$86359cd4476084f8($78c799cba34fcb8d$export$86359cd4476084f8(dictOrd)));
    var eqFree1 = $8d9a255c71d1e384$export$14742287b71545dd(dictOrd.Eq0());
    return {
        compare: function(v) {
            return function(v1) {
                return compare(v)(v1);
            };
        },
        Eq0: function() {
            return eqFree1;
        }
    };
};
var $8d9a255c71d1e384$export$49d58b662d5187e3 = {
    apply: function(v) {
        return function(v1) {
            return $8d9a255c71d1e384$var$bind(v)(function(fns) {
                return $8d9a255c71d1e384$var$bind(v1)(function(xs) {
                    return $8d9a255c71d1e384$var$pure($8d9a255c71d1e384$var$apply(fns)(xs));
                });
            });
        };
    },
    Functor0: function() {
        return $8d9a255c71d1e384$export$10302583f3ce93b5;
    }
};
var $8d9a255c71d1e384$export$18fc289b19ae2882 = {
    pure: $8d9a255c71d1e384$export$13e2de3c33d99539,
    Apply0: function() {
        return $8d9a255c71d1e384$export$49d58b662d5187e3;
    }
};





// Generated by purs version 0.15.16












var $3d4f9f7343e60881$export$e7c866399fa523f5 = function(x) {
    return x;
};
var $3d4f9f7343e60881$export$edb889f0799652d1 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return v1(v2.value0);
            throw new Error("Failed pattern match at Data.Validation.Semiring (line 49, column 1 - line 49, column 84): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $3d4f9f7343e60881$export$9acca84ac9c59e6b = function(v) {
    return v;
};
var $3d4f9f7343e60881$export$8508ed284c174a03 = function(dictShow) {
    var show = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow);
    return function(dictShow1) {
        var show1 = $2c6b3d51d10471a7$export$57bf213be019eeb0(dictShow1);
        return {
            show: function(v) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "invalid (" + (show(v.value0) + ")");
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "pure (" + (show1(v.value0) + ")");
                throw new Error("Failed pattern match at Data.Validation.Semiring (line 82, column 10 - line 84, column 55): " + [
                    v.constructor.name
                ]);
            }
        };
    };
};
var $3d4f9f7343e60881$export$b7cf40c63b127b84 = {
    Coercible0: function() {
        return undefined;
    }
};
var $3d4f9f7343e60881$export$1ea939691cdc45b8 = function(v) {
    if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return true;
    return false;
};
var $3d4f9f7343e60881$export$9f85add0327f687e = function($113) {
    return $3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$37c4d04eafdc5515.create($113));
};
var $3d4f9f7343e60881$export$39e28270ac387311 = $7d4cccdf062a2261$export$f0a413d3d6075601;
var $3d4f9f7343e60881$export$6142c8c48bbe5e92 = {
    foldMap: function(dictMonoid) {
        return $3d4f9f7343e60881$export$edb889f0799652d1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)));
    },
    foldr: function(f) {
        return function(b) {
            return $3d4f9f7343e60881$export$edb889f0799652d1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(b))($f57f4b701aa7b66e$export$8a83211c878a3f1f(f)(b));
        };
    },
    foldl: function(f) {
        return function(b) {
            return $3d4f9f7343e60881$export$edb889f0799652d1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(b))(f(b));
        };
    }
};
var $3d4f9f7343e60881$export$96c937f43e1e0de1 = {
    sequence: function(dictApplicative) {
        return $3d4f9f7343e60881$export$edb889f0799652d1(function() {
            var $114 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
            return function($115) {
                return $114($3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$37c4d04eafdc5515.create($115)));
            };
        }())($f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0())(function($116) {
            return $3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$19db0165690c701a.create($116));
        }));
    },
    traverse: function(dictApplicative) {
        var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
        var map = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
        return function(f) {
            return $3d4f9f7343e60881$export$edb889f0799652d1(function($117) {
                return pure($3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$37c4d04eafdc5515.create($117)));
            })(function() {
                var $118 = map(function($120) {
                    return $3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$19db0165690c701a.create($120));
                });
                return function($119) {
                    return $118(f($119));
                };
            }());
        };
    },
    Functor0: function() {
        return $3d4f9f7343e60881$export$39e28270ac387311;
    },
    Foldable1: function() {
        return $3d4f9f7343e60881$export$6142c8c48bbe5e92;
    }
};
var $3d4f9f7343e60881$export$d054023e5f12a8df = function(dictEq) {
    var eqEither = $7d4cccdf062a2261$export$bde8fea66b0f9f9a(dictEq);
    return function(dictEq1) {
        var eq = $37b880af5f4991bd$export$9663ddc1cf085b32(eqEither(dictEq1));
        return {
            eq: function(x) {
                return function(y) {
                    return eq(x)(y);
                };
            }
        };
    };
};
var $3d4f9f7343e60881$export$af11579d57fce6b9 = function(dictOrd) {
    var ordEither = $7d4cccdf062a2261$export$f105364bfbaa033b(dictOrd);
    var eqV1 = $3d4f9f7343e60881$export$d054023e5f12a8df(dictOrd.Eq0());
    return function(dictOrd1) {
        var compare = $97937c29f879e68e$export$398604a469f7de9a(ordEither(dictOrd1));
        var eqV2 = eqV1(dictOrd1.Eq0());
        return {
            compare: function(x) {
                return function(y) {
                    return compare(x)(y);
                };
            },
            Eq0: function() {
                return eqV2;
            }
        };
    };
};
var $3d4f9f7343e60881$export$503c7ae2b5410550 = function(dictEq) {
    var eqV1 = $3d4f9f7343e60881$export$d054023e5f12a8df(dictEq);
    return {
        eq1: function(dictEq1) {
            return $37b880af5f4991bd$export$9663ddc1cf085b32(eqV1(dictEq1));
        }
    };
};
var $3d4f9f7343e60881$export$2a867bc322bf60c8 = function(dictOrd) {
    var ordV1 = $3d4f9f7343e60881$export$af11579d57fce6b9(dictOrd);
    var eq1V1 = $3d4f9f7343e60881$export$503c7ae2b5410550(dictOrd.Eq0());
    return {
        compare1: function(dictOrd1) {
            return $97937c29f879e68e$export$398604a469f7de9a(ordV1(dictOrd1));
        },
        Eq10: function() {
            return eq1V1;
        }
    };
};
var $3d4f9f7343e60881$export$ca005ab8dff9a255 = $20615e99b278adf5$export$9b66d4861c364eff;
var $3d4f9f7343e60881$export$e8a973aa273ab2db = function(dictSemiring) {
    var mul = $c0e822be92afc4df$export$6e3a27864ab166fe(dictSemiring);
    return {
        apply: function(v) {
            return function(v1) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(mul(v.value0)(v1.value0));
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value0);
                if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v1.value0);
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a && v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0(v1.value0));
                throw new Error("Failed pattern match at Data.Validation.Semiring (line 90, column 1 - line 94, column 54): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return $3d4f9f7343e60881$export$39e28270ac387311;
        }
    };
};
var $3d4f9f7343e60881$export$a15a8020fe80da30 = function(dictSemiring) {
    var lift2 = $7576d3a958d66ab0$export$f016650e64b51e7d($3d4f9f7343e60881$export$e8a973aa273ab2db(dictSemiring));
    return function(dictSemigroup) {
        return {
            append: lift2($d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup))
        };
    };
};
var $3d4f9f7343e60881$export$c95f15a6b1299286 = function(dictSemiring) {
    var applyV1 = $3d4f9f7343e60881$export$e8a973aa273ab2db(dictSemiring);
    return {
        pure: function($121) {
            return $3d4f9f7343e60881$export$e7c866399fa523f5($7d4cccdf062a2261$export$19db0165690c701a.create($121));
        },
        Apply0: function() {
            return applyV1;
        }
    };
};
var $3d4f9f7343e60881$export$2066ca9af472fda2 = function(dictSemiring) {
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($3d4f9f7343e60881$export$c95f15a6b1299286(dictSemiring));
    var semigroupV1 = $3d4f9f7343e60881$export$a15a8020fe80da30(dictSemiring);
    return function(dictMonoid) {
        var semigroupV2 = semigroupV1(dictMonoid.Semigroup0());
        return {
            mempty: pure($784e1bd3d26d71da$export$9a7d64bc1d75357(dictMonoid)),
            Semigroup0: function() {
                return semigroupV2;
            }
        };
    };
};
var $3d4f9f7343e60881$export$9768a9ae43d7f016 = function(v1) {
    return function(f) {
        return $3d4f9f7343e60881$export$edb889f0799652d1($3d4f9f7343e60881$export$9f85add0327f687e)(f)(v1);
    };
};
var $3d4f9f7343e60881$export$abbbfd21fd993e07 = function(dictSemiring) {
    var add = $c0e822be92afc4df$export$e16d8520af44a096(dictSemiring);
    return {
        alt: function(v) {
            return function(v1) {
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(add(v.value0)(v1.value0));
                if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return v1;
                if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
                throw new Error("Failed pattern match at Data.Validation.Semiring (line 105, column 1 - line 108, column 36): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        },
        Functor0: function() {
            return $3d4f9f7343e60881$export$39e28270ac387311;
        }
    };
};
var $3d4f9f7343e60881$export$b31d09ecc42dc174 = function(dictSemiring) {
    var altV1 = $3d4f9f7343e60881$export$abbbfd21fd993e07(dictSemiring);
    return {
        empty: new $7d4cccdf062a2261$export$37c4d04eafdc5515($c0e822be92afc4df$export$7f9972325ebfd559(dictSemiring)),
        Alt0: function() {
            return altV1;
        }
    };
};


// Generated by purs version 0.15.16
var $ee385986770ad916$export$aa40bd58d73d6ca8 = /* #__PURE__ */ function() {
    function UnexpectedPath(value0) {
        this.value0 = value0;
    }
    UnexpectedPath.create = function(value0) {
        return new UnexpectedPath(value0);
    };
    return UnexpectedPath;
}();
var $ee385986770ad916$export$8afb6388b842c00f = /* #__PURE__ */ function() {
    function ExpectedBoolean() {}
    ExpectedBoolean.value = new ExpectedBoolean();
    return ExpectedBoolean;
}();
var $ee385986770ad916$export$b6222c1af299b561 = /* #__PURE__ */ function() {
    function ExpectedEnd() {}
    ExpectedEnd.value = new ExpectedEnd();
    return ExpectedEnd;
}();
var $ee385986770ad916$export$38cade4a58acd615 = /* #__PURE__ */ function() {
    function ExpectedNumber() {}
    ExpectedNumber.value = new ExpectedNumber();
    return ExpectedNumber;
}();
var $ee385986770ad916$export$36b9886977e48a38 = /* #__PURE__ */ function() {
    function ExpectedInt() {}
    ExpectedInt.value = new ExpectedInt();
    return ExpectedInt;
}();
var $ee385986770ad916$export$abd1da3aa921b348 = /* #__PURE__ */ function() {
    function ExpectedString() {}
    ExpectedString.value = new ExpectedString();
    return ExpectedString;
}();
var $ee385986770ad916$export$9c27950c125b3de1 = /* #__PURE__ */ function() {
    function ExpectedQuery() {}
    ExpectedQuery.value = new ExpectedQuery();
    return ExpectedQuery;
}();
var $ee385986770ad916$export$5c5e0cc97ff9a5d7 = /* #__PURE__ */ function() {
    function ExpectedPathPart() {}
    ExpectedPathPart.value = new ExpectedPathPart();
    return ExpectedPathPart;
}();
var $ee385986770ad916$export$be2a1ccb7d01e99b = /* #__PURE__ */ function() {
    function KeyNotFound(value0) {
        this.value0 = value0;
    }
    KeyNotFound.create = function(value0) {
        return new KeyNotFound(value0);
    };
    return KeyNotFound;
}();
var $ee385986770ad916$export$9c5a8101c9b12c00 = /* #__PURE__ */ function() {
    function Fail(value0) {
        this.value0 = value0;
    }
    Fail.create = function(value0) {
        return new Fail(value0);
    };
    return Fail;
}();
var $ee385986770ad916$export$f7596a8ac7763ef7 = function(err) {
    if (err instanceof $ee385986770ad916$export$aa40bd58d73d6ca8) return "expected path part: " + err.value0;
    if (err instanceof $ee385986770ad916$export$be2a1ccb7d01e99b) return "key: " + (err.value0 + " has not found in query part");
    if (err instanceof $ee385986770ad916$export$9c27950c125b3de1) return "expected query - found path";
    if (err instanceof $ee385986770ad916$export$38cade4a58acd615) return "expected number";
    if (err instanceof $ee385986770ad916$export$36b9886977e48a38) return "expected int";
    if (err instanceof $ee385986770ad916$export$8afb6388b842c00f) return "expected boolean";
    if (err instanceof $ee385986770ad916$export$b6222c1af299b561) return "expected end";
    if (err instanceof $ee385986770ad916$export$abd1da3aa921b348) return "expected string var";
    if (err instanceof $ee385986770ad916$export$5c5e0cc97ff9a5d7) return "expected path part, found query";
    if (err instanceof $ee385986770ad916$export$9c5a8101c9b12c00) return "match error: " + err.value0;
    throw new Error("Failed pattern match at Routing.Match.Error (line 19, column 3 - line 29, column 39): " + [
        err.constructor.name
    ]);
};


// Generated by purs version 0.15.16




var $61733d3f976c57bb$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $ea3eb84de0acf574$export$85aac4508ff70b8($37b880af5f4991bd$export$fa624555ca2acbc8)($37b880af5f4991bd$export$fa624555ca2acbc8));
var $61733d3f976c57bb$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$c5f2758e49b2b86a);
var $61733d3f976c57bb$var$compare1 = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a(/* #__PURE__ */ $ea3eb84de0acf574$export$3d0d4caf881d6855($97937c29f879e68e$export$c5f2758e49b2b86a)($97937c29f879e68e$export$c5f2758e49b2b86a));
var $61733d3f976c57bb$export$4b2950bdac9b6ee9 = /* #__PURE__ */ function() {
    function Path(value0) {
        this.value0 = value0;
    }
    Path.create = function(value0) {
        return new Path(value0);
    };
    return Path;
}();
var $61733d3f976c57bb$export$62297b13309008b2 = /* #__PURE__ */ function() {
    function Query(value0) {
        this.value0 = value0;
    }
    Query.create = function(value0) {
        return new Query(value0);
    };
    return Query;
}();
var $61733d3f976c57bb$export$f6429a12a03adfe7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && y instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return x.value0 === y.value0;
            if (x instanceof $61733d3f976c57bb$export$62297b13309008b2 && y instanceof $61733d3f976c57bb$export$62297b13309008b2) return $61733d3f976c57bb$var$eq1(x.value0)(y.value0);
            return false;
        };
    }
};
var $61733d3f976c57bb$export$20dbdb8165e154c2 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && y instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return $61733d3f976c57bb$var$compare(x.value0)(y.value0);
            if (x instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $61733d3f976c57bb$export$62297b13309008b2 && y instanceof $61733d3f976c57bb$export$62297b13309008b2) return $61733d3f976c57bb$var$compare1(x.value0)(y.value0);
            throw new Error("Failed pattern match at Routing.Types (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $61733d3f976c57bb$export$f6429a12a03adfe7;
    }
};


var $501f49fc279ac4f1$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $3d4f9f7343e60881$export$c95f15a6b1299286($8d9a255c71d1e384$export$623c37849a5e5581));
var $501f49fc279ac4f1$var$foldl = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($78c799cba34fcb8d$export$92659ee1fc91a075);
var $501f49fc279ac4f1$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($78c799cba34fcb8d$export$497dcf96eb2383ec);
var $501f49fc279ac4f1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $501f49fc279ac4f1$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $501f49fc279ac4f1$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($78c799cba34fcb8d$export$25cda6d3e08b28fe);
var $501f49fc279ac4f1$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($97937c29f879e68e$export$c5f2758e49b2b86a);
var $501f49fc279ac4f1$var$$$delete = /* #__PURE__ */ $ea3eb84de0acf574$export$1822828d790e23ee($97937c29f879e68e$export$c5f2758e49b2b86a);
var $501f49fc279ac4f1$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($71f2e2e9476163f8$export$19ab04734dcb0ff0);
var $501f49fc279ac4f1$var$mul = /* #__PURE__ */ $c0e822be92afc4df$export$6e3a27864ab166fe($8d9a255c71d1e384$export$623c37849a5e5581);
var $501f49fc279ac4f1$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $501f49fc279ac4f1$var$one = /* #__PURE__ */ $c0e822be92afc4df$export$80bf7733f1207381($8d9a255c71d1e384$export$623c37849a5e5581);
var $501f49fc279ac4f1$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $3d4f9f7343e60881$export$abbbfd21fd993e07($8d9a255c71d1e384$export$623c37849a5e5581));
var $501f49fc279ac4f1$export$f421feb8fad20413 = function(x) {
    return x;
};
var $501f49fc279ac4f1$export$42d51816ce590c93 = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, route.value0.value0));
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$abd1da3aa921b348.value));
};
var $501f49fc279ac4f1$export$ede416caf42b5136 = function(v) {
    return function(route) {
        var foldErrors = function(errs) {
            return new $7d4cccdf062a2261$export$37c4d04eafdc5515($501f49fc279ac4f1$var$foldl(function(b) {
                return function(a) {
                    return a + ("\x0a" + b);
                };
            })("")($501f49fc279ac4f1$var$bind($501f49fc279ac4f1$var$map($3d4fd987da5242ff$export$66c1ae025e96b4bc)($501f49fc279ac4f1$var$unwrap(errs)))(function(es) {
                return $501f49fc279ac4f1$var$pure1($501f49fc279ac4f1$var$foldl(function(b) {
                    return function(a) {
                        return a + (";" + b);
                    };
                })("")($501f49fc279ac4f1$var$map($ee385986770ad916$export$f7596a8ac7763ef7)(es)));
            })));
        };
        return $3d4f9f7343e60881$export$edb889f0799652d1(foldErrors)(function($109) {
            return $7d4cccdf062a2261$export$19db0165690c701a.create($71f2e2e9476163f8$export$6f71268a1666ab58($109));
        })(v(route));
    };
};
var $501f49fc279ac4f1$export$281ad3752a540efe = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$62297b13309008b2) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, route.value0.value0));
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$9c27950c125b3de1.value));
};
var $501f49fc279ac4f1$export$6f7d1d9d04558207 = function(key) {
    return function(route) {
        if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$62297b13309008b2) {
            var v = $501f49fc279ac4f1$var$lookup(key)(route.value0.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539(new $ee385986770ad916$export$be2a1ccb7d01e99b(key)));
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var remainingParams = $501f49fc279ac4f1$var$$$delete(key)(route.value0.value0);
                return $501f49fc279ac4f1$var$pure(function() {
                    var $50 = $ea3eb84de0acf574$export$dd1bc94b04021eeb(remainingParams);
                    if ($50) return new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, v.value0);
                    return new $71f2e2e9476163f8$export$1908877435b1d5e9(new $78c799cba34fcb8d$export$74c44e616647f5c0(new $61733d3f976c57bb$export$62297b13309008b2(remainingParams), route.value1), v.value0);
                }());
            }
            throw new Error("Failed pattern match at Routing.Match (line 118, column 7 - line 125, column 60): " + [
                v.constructor.name
            ]);
        }
        return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$9c27950c125b3de1.value));
    };
};
var $501f49fc279ac4f1$export$b8d194d0901e2187 = function(v) {
    return function(route) {
        return $3d4f9f7343e60881$export$edb889f0799652d1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route, $06733ae99ed4f534$export$bebe9059409a0d04.value))))(function() {
            var $110 = $501f49fc279ac4f1$var$map1($06733ae99ed4f534$export$8a67b48435b5d073.create);
            return function($111) {
                return $501f49fc279ac4f1$var$pure($110($111));
            };
        }())(v(route));
    };
};
var $501f49fc279ac4f1$export$61cc6a0be4938a2a = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) {
        var v = $052de1c85deb22bf$export$3004f64547af360e(route.value0.value0);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && !$9a14cd925227149d$export$c9f5652083b8129d(v.value0)) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, v.value0));
        return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$38cade4a58acd615.value));
    }
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$38cade4a58acd615.value));
};
var $501f49fc279ac4f1$export$68118b6bdf64be9 = {
    Coercible0: function() {
        return undefined;
    }
};
var $501f49fc279ac4f1$export$e3a39501b019bb97 = {
    map: function(fn) {
        return function(v) {
            return function(r) {
                return $3d4f9f7343e60881$export$edb889f0799652d1($3d4f9f7343e60881$export$9f85add0327f687e)(function(v1) {
                    return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, fn(v1.value1)));
                })(v(r));
            };
        };
    }
};
var $501f49fc279ac4f1$export$9f11892b6ffd077e = {
    apply: function(v) {
        return function(v1) {
            var processFnRes = function(v2) {
                return $3d4f9f7343e60881$export$edb889f0799652d1($3d4f9f7343e60881$export$9f85add0327f687e)(function(v3) {
                    return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v3.value0, v2.value1(v3.value1)));
                })(v1(v2.value0));
            };
            var processFnErr = function(r) {
                return function(err) {
                    return $3d4f9f7343e60881$export$9f85add0327f687e($501f49fc279ac4f1$var$mul(err)($3d4f9f7343e60881$export$edb889f0799652d1($501f49fc279ac4f1$var$identity)($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($501f49fc279ac4f1$var$one))(v1(r))));
                };
            };
            return function(r) {
                return $3d4f9f7343e60881$export$edb889f0799652d1(processFnErr(r))(processFnRes)(v(r));
            };
        };
    },
    Functor0: function() {
        return $501f49fc279ac4f1$export$e3a39501b019bb97;
    }
};
var $501f49fc279ac4f1$export$f1ad87b3a0786019 = {
    pure: function(a) {
        return function(r) {
            return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(r, a));
        };
    },
    Apply0: function() {
        return $501f49fc279ac4f1$export$9f11892b6ffd077e;
    }
};
var $501f49fc279ac4f1$export$24fb10e22e6547a3 = {
    alt: function(v) {
        return function(v1) {
            return function(r) {
                return $501f49fc279ac4f1$var$alt(v(r))(v1(r));
            };
        };
    },
    Functor0: function() {
        return $501f49fc279ac4f1$export$e3a39501b019bb97;
    }
};
var $501f49fc279ac4f1$export$90682842644984de = {
    empty: /* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $3d4f9f7343e60881$export$9f85add0327f687e($501f49fc279ac4f1$var$one)),
    Alt0: function() {
        return $501f49fc279ac4f1$export$24fb10e22e6547a3;
    }
};
var $501f49fc279ac4f1$export$562253ec7199b8a0 = {
    Applicative0: function() {
        return $501f49fc279ac4f1$export$f1ad87b3a0786019;
    },
    Plus1: function() {
        return $501f49fc279ac4f1$export$90682842644984de;
    }
};
var $501f49fc279ac4f1$export$f9c0624c04b6af9f = function(input) {
    return function(route) {
        if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && route.value0.value0 === input) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, $05149ea687d6b460$export$523c0b569236b342));
        if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539(new $ee385986770ad916$export$aa40bd58d73d6ca8(input)));
        return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$5c5e0cc97ff9a5d7.value));
    };
};
var $501f49fc279ac4f1$export$e8e78c978b129247 = /* #__PURE__ */ $501f49fc279ac4f1$export$f9c0624c04b6af9f("");
var $501f49fc279ac4f1$export$8837f4fc672e936d = function(v) {
    var go = function(accum) {
        return function(r) {
            return $3d4f9f7343e60881$export$edb889f0799652d1($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(r, $3d4fd987da5242ff$export$66c1ae025e96b4bc(accum)))))(function(v1) {
                return go(new $78c799cba34fcb8d$export$74c44e616647f5c0(v1.value1, accum))(v1.value0);
            })(v(r));
        };
    };
    return go($78c799cba34fcb8d$export$c1bed610ade55e1c.value);
};
var $501f49fc279ac4f1$export$7d260a2a5f8bc19e = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9) {
        var v = $8d5664f12212b23e$export$3004f64547af360e(route.value0.value0);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$36b9886977e48a38.value));
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, v.value0));
        throw new Error("Failed pattern match at Routing.Match (line 85, column 29 - line 87, column 38): " + [
            v.constructor.name
        ]);
    }
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$36b9886977e48a38.value));
};
var $501f49fc279ac4f1$export$2b62a06a9fee979c = function(msg) {
    return function(v) {
        return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539(new $ee385986770ad916$export$9c5a8101c9b12c00(msg)));
    };
};
var $501f49fc279ac4f1$export$bd5df0f255a350f8 = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$c1bed610ade55e1c) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($78c799cba34fcb8d$export$c1bed610ade55e1c.value, $05149ea687d6b460$export$523c0b569236b342));
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$b6222c1af299b561.value));
};
var $501f49fc279ac4f1$export$a9e543435a4060d6 = function(v) {
    var runEither = function(v1) {
        if (v1.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539(new $ee385986770ad916$export$9c5a8101c9b12c00("Nested check failed")));
        if (v1.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, v1.value1.value0));
        throw new Error("Failed pattern match at Routing.Match (line 202, column 5 - line 204, column 39): " + [
            v1.value1.constructor.name
        ]);
    };
    return function(r) {
        return $3d4f9f7343e60881$export$edb889f0799652d1($3d4f9f7343e60881$export$9f85add0327f687e)(runEither)(v(r));
    };
};
var $501f49fc279ac4f1$export$6ce6c9218151d511 = /* #__PURE__ */ $501f49fc279ac4f1$export$a9e543435a4060d6(/* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($501f49fc279ac4f1$export$e3a39501b019bb97)(/* #__PURE__ */ function() {
    var $112 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(new $7d4cccdf062a2261$export$37c4d04eafdc5515("Empty string"))($7d4cccdf062a2261$export$19db0165690c701a.create);
    return function($113) {
        return $112($5505a3400147efbd$export$3004f64547af360e($113));
    };
}())($501f49fc279ac4f1$export$42d51816ce590c93));
var $501f49fc279ac4f1$export$87b259aa03e3d267 = function(route) {
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && route.value0.value0 === "true") return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, true));
    if (route instanceof $78c799cba34fcb8d$export$74c44e616647f5c0 && route.value0 instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && route.value0.value0 === "false") return $501f49fc279ac4f1$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9(route.value1, false));
    return $3d4f9f7343e60881$export$9f85add0327f687e($8d9a255c71d1e384$export$13e2de3c33d99539($ee385986770ad916$export$8afb6388b842c00f.value));
};


// Generated by purs version 0.15.16


















var $8497c11bd60b84da$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $8497c11bd60b84da$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($06733ae99ed4f534$export$e5fea5661dee377);
var $8497c11bd60b84da$var$guard = /* #__PURE__ */ $f1992c51575cdea6$export$864d727b48066337($06733ae99ed4f534$export$92d23d3d8fa78a80);
var $8497c11bd60b84da$var$apply = /* #__PURE__ */ $7576d3a958d66ab0$export$5635d7ef4b8fee1c($06733ae99ed4f534$export$22d9917da16590e7);
var $8497c11bd60b84da$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $8497c11bd60b84da$var$fromFoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($97937c29f879e68e$export$c5f2758e49b2b86a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8497c11bd60b84da$var$traverse = /* #__PURE__ */ $11d1e86de605dfc6$export$df3f009e3d155b20($11d1e86de605dfc6$export$9e4a28683e28e26a)($06733ae99ed4f534$export$b203ef4465f15037);
var $8497c11bd60b84da$var$fromFoldable1 = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8497c11bd60b84da$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($78c799cba34fcb8d$export$11cb7909a85856b);
var $8497c11bd60b84da$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $8497c11bd60b84da$var$fromFoldable2 = /* #__PURE__ */ $3d4fd987da5242ff$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$ff97dbee91e727b6);
var $8497c11bd60b84da$var$parseQueryPart = function(decoder) {
    var part2tuple = function(input) {
        var keyVal = $8497c11bd60b84da$var$map(decoder)($5b07e36f812dd04b$export$65980d18b75784e2("=")(input));
        return $8497c11bd60b84da$var$discard($8497c11bd60b84da$var$guard($fc8c1182ec2aefec$export$f24224f1c91d8156(keyVal) <= 2))(function() {
            return $8497c11bd60b84da$var$apply($8497c11bd60b84da$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create)($396c4c3d9e7fae3c$export$5fd5031fecdacec3(keyVal)))($396c4c3d9e7fae3c$export$b610b8812bbcded9(keyVal)(1));
        });
    };
    var $27 = $8497c11bd60b84da$var$map1($8497c11bd60b84da$var$fromFoldable);
    var $28 = $8497c11bd60b84da$var$traverse(part2tuple);
    var $29 = $5b07e36f812dd04b$export$65980d18b75784e2("&");
    return function($30) {
        return $27($28($29($30)));
    };
};
var $8497c11bd60b84da$export$98e6a39c04603d36 = function(decoder) {
    return function(hash) {
        var pathParts = function(str) {
            var parts = $8497c11bd60b84da$var$fromFoldable1($8497c11bd60b84da$var$map(function($31) {
                return $61733d3f976c57bb$export$4b2950bdac9b6ee9.create(decoder($31));
            })($5b07e36f812dd04b$export$65980d18b75784e2("/")(str)));
            var v = $3d4fd987da5242ff$export$712962e076096ed4(parts);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.last instanceof $61733d3f976c57bb$export$4b2950bdac9b6ee9 && v.value0.last.value0 === "") return v.value0.init;
            return parts;
        };
        var v = $8497c11bd60b84da$var$map1($f57f4b701aa7b66e$export$8a83211c878a3f1f($3ee2158c14339cc9$export$b0d75975ac0be0e1)(hash))($3ee2158c14339cc9$export$305f7d4e9d4624f2("?")(hash));
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $8497c11bd60b84da$var$append(pathParts(v.value0.before))($8497c11bd60b84da$var$map2($61733d3f976c57bb$export$62297b13309008b2.create)($8497c11bd60b84da$var$fromFoldable2($8497c11bd60b84da$var$parseQueryPart(decoder)($3ee2158c14339cc9$export$663103110d94aac9(1)(v.value0.after)))));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pathParts(hash);
        throw new Error("Failed pattern match at Routing.Parser (line 32, column 3 - line 37, column 21): " + [
            v.constructor.name
        ]);
    };
};


var $fc4e9198545bd76a$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $fc4e9198545bd76a$export$accf4b5b93144b2f = function(decoder) {
    return function(matcher) {
        var $2 = $501f49fc279ac4f1$export$ede416caf42b5136(matcher);
        var $3 = $8497c11bd60b84da$export$98e6a39c04603d36(decoder);
        return function($4) {
            return $2($3($4));
        };
    };
};
var $fc4e9198545bd76a$export$4659b591c19bdf3d = /* #__PURE__ */ $fc4e9198545bd76a$export$accf4b5b93144b2f(function($6) {
    return $fc4e9198545bd76a$var$fromJust($f9a555fb76059872$export$8824b4be61b7d619($6));
});


// Generated by purs version 0.15.16
var $3dd939a5ce699801$var$getEffProp = function(name) {
    return function(doc) {
        return function() {
            return doc[name];
        };
    };
};
const $3dd939a5ce699801$export$128fa18b7194ef = $3dd939a5ce699801$var$getEffProp("URL");
const $3dd939a5ce699801$export$34632defb8a69c44 = $3dd939a5ce699801$var$getEffProp("documentURI");
const $3dd939a5ce699801$export$f710a83a91838a36 = $3dd939a5ce699801$var$getEffProp("origin");
const $3dd939a5ce699801$export$995723b54eb391a5 = $3dd939a5ce699801$var$getEffProp("compatMode");
const $3dd939a5ce699801$export$351e53fd81ba2d3d = $3dd939a5ce699801$var$getEffProp("characterSet");
const $3dd939a5ce699801$export$8019223850b8bf78 = $3dd939a5ce699801$var$getEffProp("contentType");
function $3dd939a5ce699801$export$d690d23863a4515c(doc) {
    return doc["doctype"];
}
const $3dd939a5ce699801$export$445a11d197c0312 = $3dd939a5ce699801$var$getEffProp("documentElement");
function $3dd939a5ce699801$export$af941c3c7c3b40f5(localName) {
    return function(doc) {
        return function() {
            return doc.getElementsByTagName(localName);
        };
    };
}
function $3dd939a5ce699801$export$83374683e5723893(ns) {
    return function(localName) {
        return function(doc) {
            return function() {
                return doc.getElementsByTagNameNS(ns, localName);
            };
        };
    };
}
function $3dd939a5ce699801$export$764e2797d3aa1cff(classNames) {
    return function(doc) {
        return function() {
            return doc.getElementsByClassName(classNames);
        };
    };
}
function $3dd939a5ce699801$export$c8a8987d4410bf2d(localName) {
    return function(doc) {
        return function() {
            return doc.createElement(localName);
        };
    };
}
function $3dd939a5ce699801$export$e710f5e851169e29(ns) {
    return function(qualifiedName) {
        return function(doc) {
            return function() {
                return doc.createElementNS(ns, qualifiedName);
            };
        };
    };
}
function $3dd939a5ce699801$export$fb51152cd5328759(doc) {
    return function() {
        return doc.createDocumentFragment();
    };
}
function $3dd939a5ce699801$export$b2ce9ad90858ed7a(data) {
    return function(doc) {
        return function() {
            return doc.createTextNode(data);
        };
    };
}
function $3dd939a5ce699801$export$2a15b079e3f46654(data) {
    return function(doc) {
        return function() {
            return doc.createComment(data);
        };
    };
}
function $3dd939a5ce699801$export$c87d030c2da6ba1c(target) {
    return function(data) {
        return function(doc) {
            return function() {
                return doc.createProcessingInstruction(target, data);
            };
        };
    };
}
function $3dd939a5ce699801$export$ce5e1f6513119f55(node) {
    return function(deep) {
        return function(doc) {
            return function() {
                return doc.importNode(node, deep);
            };
        };
    };
}
function $3dd939a5ce699801$export$53bb1fb6223ba721(node) {
    return function(doc) {
        return function() {
            return doc.adoptNode(node);
        };
    };
}







var $241080e3b918bbae$export$c8b651b897da2de = $ac8b3532514ac019$export$401372c57776dc;
var $241080e3b918bbae$export$d8d5f203c133934 = $ac8b3532514ac019$export$401372c57776dc;
var $241080e3b918bbae$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $241080e3b918bbae$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $241080e3b918bbae$export$5c5bb02a2f64596a = function($2) {
    return $3dd939a5ce699801$export$83374683e5723893($0a5aaf95f168428e$export$b187f57ee1822bc5($2));
};
var $241080e3b918bbae$export$7039ba397093f069 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Document");
var $241080e3b918bbae$export$45b532d2a1c7642b = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Document");
var $241080e3b918bbae$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Document");
var $241080e3b918bbae$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Document");
var $241080e3b918bbae$export$170c446b87804fad = /* #__PURE__ */ function() {
    var $3 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1)($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($4) {
        return $3($3dd939a5ce699801$export$445a11d197c0312($4));
    };
}();
var $241080e3b918bbae$export$3c172dfa1c27da99 = function($5) {
    return $0a5aaf95f168428e$export$1ba013b88f4f21f3($3dd939a5ce699801$export$d690d23863a4515c($5));
};
var $241080e3b918bbae$export$7094a064528c7fee = function($6) {
    return $3dd939a5ce699801$export$e710f5e851169e29($0a5aaf95f168428e$export$b187f57ee1822bc5($6));
};


// Generated by purs version 0.15.16
function $09e65b3c2fdbeeb7$export$dacecbef73d30765(cb) {
    return function() {
        return new MutationObserver(function(mr, mo) {
            return cb(mr)(mo)();
        });
    };
}
function $09e65b3c2fdbeeb7$export$c03f35f93fc93a6b(node) {
    return function(config) {
        return function(mo) {
            return function() {
                return mo.observe(node, config);
            };
        };
    };
}
function $09e65b3c2fdbeeb7$export$37dfea93db2e14ed(mo) {
    return function() {
        return mo.disconnect();
    };
}
function $09e65b3c2fdbeeb7$export$961590ff6fa601cb(mo) {
    return function() {
        return mo.takeRecords();
    };
}


var $9c3ea2a34da718bd$export$d1203567a167490e = function() {
    return $09e65b3c2fdbeeb7$export$c03f35f93fc93a6b;
};


// Generated by purs version 0.15.16
var $9c38b931c8b22574$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
function $9c38b931c8b22574$export$c441300b2d51b958(node) {
    return node.nodeType;
}
function $9c38b931c8b22574$export$860bddf988a8498c(node) {
    return node.nodeName;
}
const $9c38b931c8b22574$export$74061d4f476da680 = $9c38b931c8b22574$var$getEffProp("baseURI");
const $9c38b931c8b22574$export$23cc1b2a9bb6c61a = $9c38b931c8b22574$var$getEffProp("ownerDocument");
const $9c38b931c8b22574$export$72030ded560177b6 = $9c38b931c8b22574$var$getEffProp("parentNode");
const $9c38b931c8b22574$export$e8e77848f4a9ad40 = $9c38b931c8b22574$var$getEffProp("parentElement");
function $9c38b931c8b22574$export$13782f450ac5e09a(node) {
    return function() {
        return node.hasChildNodes();
    };
}
const $9c38b931c8b22574$export$c9fa23d9ff60a2d1 = $9c38b931c8b22574$var$getEffProp("childNodes");
const $9c38b931c8b22574$export$274e0d97326033db = $9c38b931c8b22574$var$getEffProp("firstChild");
const $9c38b931c8b22574$export$951f870fb0fe03c3 = $9c38b931c8b22574$var$getEffProp("lastChild");
const $9c38b931c8b22574$export$e2e6c080f0f2a76d = $9c38b931c8b22574$var$getEffProp("previousSibling");
const $9c38b931c8b22574$export$2eda4366e9b7c29f = $9c38b931c8b22574$var$getEffProp("nextSibling");
const $9c38b931c8b22574$export$d6cd495109f5e655 = $9c38b931c8b22574$var$getEffProp("nodeValue");
function $9c38b931c8b22574$export$df6212ebae08b450(value) {
    return function(node) {
        return function() {
            node.nodeValue = value;
        };
    };
}
const $9c38b931c8b22574$export$e0e0794250e9118f = $9c38b931c8b22574$var$getEffProp("textContent");
function $9c38b931c8b22574$export$94b0296cab6203e(value) {
    return function(node) {
        return function() {
            node.textContent = value;
        };
    };
}
function $9c38b931c8b22574$export$a3295358bff77e(node) {
    return function() {
        node.normalize();
    };
}
function $9c38b931c8b22574$export$9cd59f9826255e47(node) {
    return function() {
        return node.cloneNode(false);
    };
}
function $9c38b931c8b22574$export$b7d58db314e0ac27(node) {
    return function() {
        return node.cloneNode(true);
    };
}
function $9c38b931c8b22574$export$55e9b4d3368d84dd(node1) {
    return function(node2) {
        return function() {
            return node1.isEqualNode(node2);
        };
    };
}
function $9c38b931c8b22574$export$aff35b31398d5fba(node1) {
    return function(node2) {
        return function() {
            return node1.compareDocumentPosition(node2);
        };
    };
}
function $9c38b931c8b22574$export$2344b14b097df817(node1) {
    return function(node2) {
        return function() {
            return node1.contains(node2);
        };
    };
}
function $9c38b931c8b22574$export$b9a4e863f082a036(prefix) {
    return function(node) {
        return function() {
            return node.lookupPrefix(prefix);
        };
    };
}
function $9c38b931c8b22574$export$a79c57bed1c08193(ns) {
    return function(node) {
        return function() {
            return node.lookupNamespaceURI(ns);
        };
    };
}
function $9c38b931c8b22574$export$61f41c073d810e4f(ns) {
    return function(node) {
        return function() {
            return node.isDefaultNamespace(ns);
        };
    };
}
function $9c38b931c8b22574$export$86b68c7dbeb53c22(node1) {
    return function(node2) {
        return function(parent) {
            return function() {
                parent.insertBefore(node1, node2);
            };
        };
    };
}
function $9c38b931c8b22574$export$1b8e57c9ea42f1d2(node) {
    return function(parent) {
        return function() {
            parent.appendChild(node);
        };
    };
}
function $9c38b931c8b22574$export$46f78da0e790aab7(newChild) {
    return function(oldChild) {
        return function(parent) {
            return function() {
                parent.replaceChild(newChild, oldChild);
            };
        };
    };
}
function $9c38b931c8b22574$export$7ae609f7af59e4f7(node) {
    return function(parent) {
        return function() {
            parent.removeChild(node);
        };
    };
}








// Generated by purs version 0.15.16


// Generated by purs version 0.15.16



var $aa7bef674fe53e14$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$ff461bf68e7dd332);
var $aa7bef674fe53e14$export$dc064fe9e59310fd = /* #__PURE__ */ function() {
    function ElementNode() {}
    ElementNode.value = new ElementNode();
    return ElementNode;
}();
var $aa7bef674fe53e14$export$dc88047a888cd46b = /* #__PURE__ */ function() {
    function AttributeNode() {}
    AttributeNode.value = new AttributeNode();
    return AttributeNode;
}();
var $aa7bef674fe53e14$export$f0a25ea3087686aa = /* #__PURE__ */ function() {
    function TextNode() {}
    TextNode.value = new TextNode();
    return TextNode;
}();
var $aa7bef674fe53e14$export$28835d60136fdd55 = /* #__PURE__ */ function() {
    function CDATASectionNode() {}
    CDATASectionNode.value = new CDATASectionNode();
    return CDATASectionNode;
}();
var $aa7bef674fe53e14$export$a4de1a63043e7a6d = /* #__PURE__ */ function() {
    function EntityReferenceNode() {}
    EntityReferenceNode.value = new EntityReferenceNode();
    return EntityReferenceNode;
}();
var $aa7bef674fe53e14$export$34dac3329b92804f = /* #__PURE__ */ function() {
    function EntityNode() {}
    EntityNode.value = new EntityNode();
    return EntityNode;
}();
var $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 = /* #__PURE__ */ function() {
    function ProcessingInstructionNode() {}
    ProcessingInstructionNode.value = new ProcessingInstructionNode();
    return ProcessingInstructionNode;
}();
var $aa7bef674fe53e14$export$dd3132c03c97153e = /* #__PURE__ */ function() {
    function CommentNode() {}
    CommentNode.value = new CommentNode();
    return CommentNode;
}();
var $aa7bef674fe53e14$export$9da34d55490083d8 = /* #__PURE__ */ function() {
    function DocumentNode() {}
    DocumentNode.value = new DocumentNode();
    return DocumentNode;
}();
var $aa7bef674fe53e14$export$c4edab6ab3262a44 = /* #__PURE__ */ function() {
    function DocumentTypeNode() {}
    DocumentTypeNode.value = new DocumentTypeNode();
    return DocumentTypeNode;
}();
var $aa7bef674fe53e14$export$ed75c007fb9b19c0 = /* #__PURE__ */ function() {
    function DocumentFragmentNode() {}
    DocumentFragmentNode.value = new DocumentFragmentNode();
    return DocumentFragmentNode;
}();
var $aa7bef674fe53e14$export$71dc25271abd047 = /* #__PURE__ */ function() {
    function NotationNode() {}
    NotationNode.value = new NotationNode();
    return NotationNode;
}();
var $aa7bef674fe53e14$var$toEnumNodeType = function(v) {
    if (v === 1) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc064fe9e59310fd.value);
    if (v === 2) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dc88047a888cd46b.value);
    if (v === 3) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$f0a25ea3087686aa.value);
    if (v === 4) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$28835d60136fdd55.value);
    if (v === 5) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$a4de1a63043e7a6d.value);
    if (v === 6) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$34dac3329b92804f.value);
    if (v === 7) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$2458c2a2a9d8a0a8.value);
    if (v === 8) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$dd3132c03c97153e.value);
    if (v === 9) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$9da34d55490083d8.value);
    if (v === 10) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$c4edab6ab3262a44.value);
    if (v === 11) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$ed75c007fb9b19c0.value);
    if (v === 12) return new $06733ae99ed4f534$export$8a67b48435b5d073($aa7bef674fe53e14$export$71dc25271abd047.value);
    return $06733ae99ed4f534$export$bebe9059409a0d04.value;
};
var $aa7bef674fe53e14$export$eb0d4895a3e15732 = {
    show: function(v) {
        if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return "ElementNode";
        if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return "AttributeNode";
        if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return "TextNode";
        if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return "CDATASectionNode";
        if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return "EntityReferenceNode";
        if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return "EntityNode";
        if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return "ProcessingInstructionNode";
        if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return "CommentNode";
        if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return "DocumentNode";
        if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return "DocumentTypeNode";
        if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return "DocumentFragmentNode";
        if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return "NotationNode";
        throw new Error("Failed pattern match at Web.DOM.NodeType (line 39, column 1 - line 51, column 37): " + [
            v.constructor.name
        ]);
    }
};
var $aa7bef674fe53e14$var$fromEnumNodeType = function(v) {
    if (v instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return 1;
    if (v instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return 2;
    if (v instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return 3;
    if (v instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return 4;
    if (v instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return 5;
    if (v instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return 6;
    if (v instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return 7;
    if (v instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return 8;
    if (v instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return 9;
    if (v instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return 10;
    if (v instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return 11;
    if (v instanceof $aa7bef674fe53e14$export$71dc25271abd047) return 12;
    throw new Error("Failed pattern match at Web.DOM.NodeType (line 68, column 1 - line 68, column 36): " + [
        v.constructor.name
    ]);
};
var $aa7bef674fe53e14$export$88377e09539feb78 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd && y instanceof $aa7bef674fe53e14$export$dc064fe9e59310fd) return true;
            if (x instanceof $aa7bef674fe53e14$export$dc88047a888cd46b && y instanceof $aa7bef674fe53e14$export$dc88047a888cd46b) return true;
            if (x instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa && y instanceof $aa7bef674fe53e14$export$f0a25ea3087686aa) return true;
            if (x instanceof $aa7bef674fe53e14$export$28835d60136fdd55 && y instanceof $aa7bef674fe53e14$export$28835d60136fdd55) return true;
            if (x instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d && y instanceof $aa7bef674fe53e14$export$a4de1a63043e7a6d) return true;
            if (x instanceof $aa7bef674fe53e14$export$34dac3329b92804f && y instanceof $aa7bef674fe53e14$export$34dac3329b92804f) return true;
            if (x instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8 && y instanceof $aa7bef674fe53e14$export$2458c2a2a9d8a0a8) return true;
            if (x instanceof $aa7bef674fe53e14$export$dd3132c03c97153e && y instanceof $aa7bef674fe53e14$export$dd3132c03c97153e) return true;
            if (x instanceof $aa7bef674fe53e14$export$9da34d55490083d8 && y instanceof $aa7bef674fe53e14$export$9da34d55490083d8) return true;
            if (x instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44 && y instanceof $aa7bef674fe53e14$export$c4edab6ab3262a44) return true;
            if (x instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0 && y instanceof $aa7bef674fe53e14$export$ed75c007fb9b19c0) return true;
            if (x instanceof $aa7bef674fe53e14$export$71dc25271abd047 && y instanceof $aa7bef674fe53e14$export$71dc25271abd047) return true;
            return false;
        };
    }
};
var $aa7bef674fe53e14$export$98741689c6e0b987 = {
    compare: function(x) {
        return function(y) {
            return $aa7bef674fe53e14$var$compare($aa7bef674fe53e14$var$fromEnumNodeType(x))($aa7bef674fe53e14$var$fromEnumNodeType(y));
        };
    },
    Eq0: function() {
        return $aa7bef674fe53e14$export$88377e09539feb78;
    }
};
var $aa7bef674fe53e14$export$61b56a5f9f6230cb = {
    succ: /* #__PURE__ */ $f935a9866e211c00$export$11e799785deb08e4($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    pred: /* #__PURE__ */ $f935a9866e211c00$export$dc42af8461b24233($aa7bef674fe53e14$var$toEnumNodeType)($aa7bef674fe53e14$var$fromEnumNodeType),
    Ord0: function() {
        return $aa7bef674fe53e14$export$98741689c6e0b987;
    }
};
var $aa7bef674fe53e14$export$5879f3f4738185fd = /* #__PURE__ */ function() {
    return {
        bottom: $aa7bef674fe53e14$export$dc064fe9e59310fd.value,
        top: $aa7bef674fe53e14$export$71dc25271abd047.value,
        Ord0: function() {
            return $aa7bef674fe53e14$export$98741689c6e0b987;
        }
    };
}();
var $aa7bef674fe53e14$export$db18e9bcd7fea75b = {
    cardinality: 12,
    toEnum: $aa7bef674fe53e14$var$toEnumNodeType,
    fromEnum: $aa7bef674fe53e14$var$fromEnumNodeType,
    Bounded0: function() {
        return $aa7bef674fe53e14$export$5879f3f4738185fd;
    },
    Enum1: function() {
        return $aa7bef674fe53e14$export$61b56a5f9f6230cb;
    }
};



var $43db1f7c9150eb00$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $43db1f7c9150eb00$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $43db1f7c9150eb00$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($aa7bef674fe53e14$export$db18e9bcd7fea75b);
var $43db1f7c9150eb00$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $43db1f7c9150eb00$export$6c33a601ef71fce7 = /* #__PURE__ */ function() {
    var $4 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($5) {
        return $4($9c38b931c8b22574$export$e2e6c080f0f2a76d($5));
    };
}();
var $43db1f7c9150eb00$export$b54be7ce267a037b = /* #__PURE__ */ function() {
    var $6 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($7) {
        return $6($9c38b931c8b22574$export$72030ded560177b6($7));
    };
}();
var $43db1f7c9150eb00$export$222ab8a52715b4f4 = /* #__PURE__ */ function() {
    var $8 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($9) {
        return $8($9c38b931c8b22574$export$e8e77848f4a9ad40($9));
    };
}();
var $43db1f7c9150eb00$export$512a1115db01100d = /* #__PURE__ */ function() {
    var $10 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($11) {
        return $10($9c38b931c8b22574$export$23cc1b2a9bb6c61a($11));
    };
}();
var $43db1f7c9150eb00$export$63bfedaececbd5f5 = /* #__PURE__ */ function() {
    var $12 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($13) {
        return $12($9c38b931c8b22574$export$d6cd495109f5e655($13));
    };
}();
var $43db1f7c9150eb00$export$4debbe1037afe35e = function() {
    return function($14) {
        return $43db1f7c9150eb00$var$fromJust($43db1f7c9150eb00$var$toEnum($9c38b931c8b22574$export$c441300b2d51b958($14)));
    };
};
var $43db1f7c9150eb00$export$335219007e689d29 = /* #__PURE__ */ function() {
    var $15 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($16) {
        return $15($9c38b931c8b22574$export$2eda4366e9b7c29f($16));
    };
}();
var $43db1f7c9150eb00$export$20ad2ac0440a470d = function(p) {
    var $17 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $18 = $9c38b931c8b22574$export$b9a4e863f082a036(p);
    return function($19) {
        return $17($18($19));
    };
};
var $43db1f7c9150eb00$export$eca9f13e904be86a = function(ns) {
    var $20 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $21 = $9c38b931c8b22574$export$a79c57bed1c08193(ns);
    return function($22) {
        return $20($21($22));
    };
};
var $43db1f7c9150eb00$export$86c2694e50e8251b = /* #__PURE__ */ function() {
    var $23 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($24) {
        return $23($9c38b931c8b22574$export$951f870fb0fe03c3($24));
    };
}();
var $43db1f7c9150eb00$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Node");
var $43db1f7c9150eb00$export$b212a48622cd6ee3 = /* #__PURE__ */ function() {
    var $25 = $43db1f7c9150eb00$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($26) {
        return $25($9c38b931c8b22574$export$274e0d97326033db($26));
    };
}();


// Generated by purs version 0.15.16
function $f679ccbad905ce43$export$2878cc467c8be8fe(offset) {
    return function(t) {
        return function() {
            return t.splitText(offset);
        };
    };
}
function $f679ccbad905ce43$export$fd98afa72f6bc691(t) {
    return function() {
        return t.wholeText;
    };
}




var $b49e59183c291485$export$f8671ec463598929 = $ac8b3532514ac019$export$401372c57776dc;
var $b49e59183c291485$export$83a0de4644f1fbc4 = $ac8b3532514ac019$export$401372c57776dc;
var $b49e59183c291485$export$55c9526d22b9f8e6 = $ac8b3532514ac019$export$401372c57776dc;
var $b49e59183c291485$export$8ff7c34974173077 = $ac8b3532514ac019$export$401372c57776dc;
var $b49e59183c291485$export$301ade9e4dcb7465 = $ac8b3532514ac019$export$401372c57776dc;
var $b49e59183c291485$export$66db07be43ecb0c3 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Text");
var $b49e59183c291485$export$a7f097b65af8aa04 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Text");
var $b49e59183c291485$export$a0a0bf09b44710c9 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Text");
var $b49e59183c291485$export$31942037104a4a20 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Text");
var $b49e59183c291485$export$16450aa27c73b046 = /* #__PURE__ */ $4d89ff275c04492e$export$e3dc45f84eae905c("Text");









var $b12e3a3cf2d07b53$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $b12e3a3cf2d07b53$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $b12e3a3cf2d07b53$var$add = /* #__PURE__ */ $c0e822be92afc4df$export$e16d8520af44a096($c0e822be92afc4df$export$7e80d6910c05bd77);
var $b12e3a3cf2d07b53$var$observe = /* #__PURE__ */ $9c3ea2a34da718bd$export$d1203567a167490e();
var $b12e3a3cf2d07b53$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $b12e3a3cf2d07b53$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a);
var $b12e3a3cf2d07b53$var$traverse_1 = /* #__PURE__ */ $b12e3a3cf2d07b53$var$traverse_($4fe7b6acfba7f29f$export$6a194eaac00c1ff4);
var $b12e3a3cf2d07b53$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $b12e3a3cf2d07b53$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $b12e3a3cf2d07b53$var$traverse_2 = /* #__PURE__ */ $b12e3a3cf2d07b53$var$traverse_($ea3eb84de0acf574$export$4295a0c2ad7aa544);
var $b12e3a3cf2d07b53$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($97937c29f879e68e$export$ff461bf68e7dd332);
var $b12e3a3cf2d07b53$var$$$delete = /* #__PURE__ */ $ea3eb84de0acf574$export$1822828d790e23ee($97937c29f879e68e$export$ff461bf68e7dd332);
var $b12e3a3cf2d07b53$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $b12e3a3cf2d07b53$var$makeImmediate = function(run) {
    return function __do() {
        var document = $b12e3a3cf2d07b53$var$bind($2603425f82e959df$export$8291e5b88f90ce4)(function() {
            var $28 = $b12e3a3cf2d07b53$var$map($f6c9290a5db8f197$export$ce0e204f587740c3);
            return function($29) {
                return $28($aa35a24624ec08d2$export$5a7bfc01df82fcd1($29));
            };
        }())();
        var nextTick = $90327512d8280b8d$export$b8cb59497041ffe4(new $7d4cccdf062a2261$export$19db0165690c701a(0))();
        var obsvNode = $b12e3a3cf2d07b53$var$map($b49e59183c291485$export$83a0de4644f1fbc4)($3dd939a5ce699801$export$b2ce9ad90858ed7a("")(document))();
        var observer = $09e65b3c2fdbeeb7$export$dacecbef73d30765(function(v) {
            return function(v1) {
                return function __do() {
                    $90327512d8280b8d$export$45b91115a89d6020($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function() {
                        var $30 = $b12e3a3cf2d07b53$var$add(1);
                        return function($31) {
                            return $7d4cccdf062a2261$export$19db0165690c701a.create($30($31));
                        };
                    }())($7d4cccdf062a2261$export$19db0165690c701a.create))(nextTick)();
                    return run();
                };
            };
        })();
        $b12e3a3cf2d07b53$var$observe(obsvNode)({
            characterData: true
        })(observer)();
        return $b12e3a3cf2d07b53$var$bind($e521936ea118867a$export$aafa59e2e03f2942(nextTick))($b12e3a3cf2d07b53$var$traverse_1(function(tick) {
            return function __do() {
                $e521936ea118867a$export$68d8715fc104d294(new $7d4cccdf062a2261$export$37c4d04eafdc5515(tick + 1 | 0))(nextTick)();
                return $9c38b931c8b22574$export$df6212ebae08b450($b12e3a3cf2d07b53$var$show(tick))(obsvNode)();
            };
        }));
    };
};
var $b12e3a3cf2d07b53$export$d0a1bc1ffc0b6105 = function __do() {
    var freshRef = $90327512d8280b8d$export$b8cb59497041ffe4(0)();
    var listenersRef = $90327512d8280b8d$export$b8cb59497041ffe4($ea3eb84de0acf574$export$6e22c362a0406a2c)();
    var notify = function(ev) {
        return $b12e3a3cf2d07b53$var$bindFlipped($b12e3a3cf2d07b53$var$traverse_2(function(v) {
            return v(ev);
        }))($e521936ea118867a$export$aafa59e2e03f2942(listenersRef));
    };
    var locationState = function __do() {
        var loc = $b12e3a3cf2d07b53$var$bind($2603425f82e959df$export$8291e5b88f90ce4)($aa35a24624ec08d2$export$17b07c660794dc13)();
        var state = $b12e3a3cf2d07b53$var$bind($b12e3a3cf2d07b53$var$bind($2603425f82e959df$export$8291e5b88f90ce4)($aa35a24624ec08d2$export$55abd4691b317664))($75f6ec27f640501f$export$ca000e230c0caa3e)();
        var pathname = $f8ebc5adafdca7e8$export$7333db99aa99d383(loc)();
        var search = $f8ebc5adafdca7e8$export$d76128d007d19019(loc)();
        var hash = $f8ebc5adafdca7e8$export$d6af199866bfb566(loc)();
        var path = pathname + (search + hash);
        return {
            state: state,
            pathname: pathname,
            search: search,
            hash: hash,
            path: path
        };
    };
    var listen = function(k) {
        return function __do() {
            var fresh = $e521936ea118867a$export$aafa59e2e03f2942(freshRef)();
            $e521936ea118867a$export$68d8715fc104d294(fresh + 1 | 0)(freshRef)();
            $90327512d8280b8d$export$45b91115a89d6020($b12e3a3cf2d07b53$var$insert(fresh)(k))(listenersRef)();
            return $90327512d8280b8d$export$45b91115a89d6020($b12e3a3cf2d07b53$var$$$delete(fresh))(listenersRef);
        };
    };
    var schedule = $b12e3a3cf2d07b53$var$makeImmediate($b12e3a3cf2d07b53$var$bindFlipped(notify)(locationState))();
    var stateFn = function(op) {
        return function(state) {
            return function(path) {
                return function __do() {
                    $b12e3a3cf2d07b53$var$bind($b12e3a3cf2d07b53$var$bind($2603425f82e959df$export$8291e5b88f90ce4)($aa35a24624ec08d2$export$55abd4691b317664))(op(state)("")(path))();
                    return schedule();
                };
            };
        };
    };
    var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(v) {
        return $b12e3a3cf2d07b53$var$bindFlipped(notify)(locationState);
    })();
    $b12e3a3cf2d07b53$var$bind($2603425f82e959df$export$8291e5b88f90ce4)(function() {
        var $32 = $98db70b23aa8a6ea$export$3f65cefe8380dbea($033348220d254d99$export$debdbaa302c3885c)(listener)(false);
        return function($33) {
            return $32($6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6($33));
        };
    }())();
    return {
        pushState: stateFn($75f6ec27f640501f$export$ba0fd82af7b4fe6e),
        replaceState: stateFn($75f6ec27f640501f$export$e68dd4d2e7e08394),
        locationState: locationState,
        listen: listen
    };
};
var $b12e3a3cf2d07b53$export$a50696b2fbaea9e2 = function(cb) {
    return function(init) {
        return function(psi) {
            return function __do() {
                var ref = $b12e3a3cf2d07b53$var$bindFlipped($90327512d8280b8d$export$b8cb59497041ffe4)($b12e3a3cf2d07b53$var$bindFlipped(init)(psi.locationState))();
                return psi.listen(function(loc) {
                    return $b12e3a3cf2d07b53$var$bindFlipped($f57f4b701aa7b66e$export$8a83211c878a3f1f($e521936ea118867a$export$68d8715fc104d294)(ref))($b12e3a3cf2d07b53$var$bindFlipped($f57f4b701aa7b66e$export$8a83211c878a3f1f(cb)(loc))($e521936ea118867a$export$aafa59e2e03f2942(ref)));
                })();
            };
        };
    };
};
var $b12e3a3cf2d07b53$export$51023de0f35df758 = function(cb) {
    return function(init) {
        return $b12e3a3cf2d07b53$export$a50696b2fbaea9e2(function(a) {
            var $34 = cb(a);
            return function($35) {
                return $34(function(v) {
                    return v.path;
                }($35));
            };
        })(function($36) {
            return init(function(v) {
                return v.path;
            }($36));
        });
    };
};
var $b12e3a3cf2d07b53$export$f41446fd2fe3b2c6 = function(dictFoldable) {
    var indexl = $4fe7b6acfba7f29f$export$fe35754984712af1(dictFoldable);
    return function(parser) {
        return function(cb) {
            var go = function(a) {
                var $37 = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($b12e3a3cf2d07b53$var$pure(a))(function(b) {
                    return $b12e3a3cf2d07b53$var$voidRight(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(cb(a)(b));
                });
                var $38 = indexl(0);
                return function($39) {
                    return $37($38(parser($39)));
                };
            };
            return $b12e3a3cf2d07b53$export$51023de0f35df758(go)(go($06733ae99ed4f534$export$bebe9059409a0d04.value));
        };
    };
};
var $b12e3a3cf2d07b53$export$de994efd351b291c = /* #__PURE__ */ function() {
    var $40 = $b12e3a3cf2d07b53$export$f41446fd2fe3b2c6($4fe7b6acfba7f29f$export$6a194eaac00c1ff4);
    return function($41) {
        return $40($fc4e9198545bd76a$export$4659b591c19bdf3d($41));
    };
}();
var $b12e3a3cf2d07b53$export$595447059867920 = /* #__PURE__ */ function() {
    return $b12e3a3cf2d07b53$export$f41446fd2fe3b2c6($4fe7b6acfba7f29f$export$ff97dbee91e727b6)($06733ae99ed4f534$export$8a67b48435b5d073.create);
}();
var $b12e3a3cf2d07b53$export$c2de8e0aab246379 = function(cb) {
    var go = function(a) {
        return function(b) {
            return $b12e3a3cf2d07b53$var$voidRight(new $06733ae99ed4f534$export$8a67b48435b5d073(b))(cb(a)(b));
        };
    };
    return $b12e3a3cf2d07b53$export$a50696b2fbaea9e2(go)(go($06733ae99ed4f534$export$bebe9059409a0d04.value));
};



// Generated by purs version 0.15.16



















var $6be45a9e147fc393$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0(/* #__PURE__ */ $2c6b3d51d10471a7$export$5bda33a3389a7225($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $6be45a9e147fc393$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $6be45a9e147fc393$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $6be45a9e147fc393$var$selectAll$prime = /* #__PURE__ */ $f264ceec36a478ad$export$2f60db41f2af055($6be45a9e147fc393$var$ordRNTY)($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $6be45a9e147fc393$var$isEmpty = /* #__PURE__ */ $f264ceec36a478ad$export$dd1bc94b04021eeb($6be45a9e147fc393$var$ordRNTY);
var $6be45a9e147fc393$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $6be45a9e147fc393$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $6be45a9e147fc393$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $6be45a9e147fc393$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $6be45a9e147fc393$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $6be45a9e147fc393$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $6be45a9e147fc393$var$showFQE = function(v) {
    if (v.form instanceof $7d4cccdf062a2261$export$19db0165690c701a) return "{ student: " + ($308f9765feb7633d$export$a1b0f5347d2470b(v.student) + (", form: " + ($308f9765feb7633d$export$a1b0f5347d2470b(v.form.value0) + " }")));
    if (v.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return "{ student: " + ($308f9765feb7633d$export$a1b0f5347d2470b(v.student) + (", form: " + ($308f9765feb7633d$export$a1b0f5347d2470b(v.form.value0.form_type.id) + " }")));
    throw new Error("Failed pattern match at Steps.WorkQueue.State (line 193, column 1 - line 193, column 36): " + [
        v.constructor.name
    ]);
};
var $6be45a9e147fc393$export$92d7afd85cc34da2 = function(fq) {
    return $6be45a9e147fc393$var$show($6be45a9e147fc393$var$map($6be45a9e147fc393$var$showFQE)(fq));
};
var $6be45a9e147fc393$export$5d30c05d844667b3 = function(workQ) {
    return function(teacher) {
        return function(semester) {
            return {
                forms: workQ.forms,
                students: workQ.students,
                documents: workQ.documents,
                editDocs: workQ.editDocs,
                currentDoc: workQ.currentDoc,
                teacher: teacher,
                semester: new $06733ae99ed4f534$export$8a67b48435b5d073(semester)
            };
        };
    };
};
var $6be45a9e147fc393$export$a871627eddff2fcf = function(workQ) {
    return function(doc) {
        return {
            forms: workQ.forms,
            students: workQ.students,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            semester: workQ.semester,
            teacher: workQ.teacher,
            currentDoc: doc
        };
    };
};
var $6be45a9e147fc393$export$cc02fd03d27c010f = function(defTeacher) {
    return function(defSemester) {
        return function(workQ) {
            return {
                forms: $38eb3af3d662147b$export$8472cf4ca0d7e3d3,
                students: $f264ceec36a478ad$export$6e22c362a0406a2c,
                documents: $4e23420f70d37f30$export$d3cec2e51682fbf1,
                editDocs: [],
                currentDoc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                teacher: defTeacher,
                semester: defSemester
            };
        };
    };
};
var $6be45a9e147fc393$export$e962ca39bc16c888 = function(workQ) {
    return function(students) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            students: $6be45a9e147fc393$var$selectAll$prime(students)(workQ.students)(false)
        };
    };
};
var $6be45a9e147fc393$export$b0442b57b5d77489 = function(v) {
    return ($6be45a9e147fc393$var$isEmpty(v.forms) || $6be45a9e147fc393$var$isEmpty(v.students)) && $fc8c1182ec2aefec$export$f24224f1c91d8156(v.editDocs) <= 0;
};
var $6be45a9e147fc393$export$78ce5202a3b18e96 = /* #__PURE__ */ function() {
    return {
        forms: $38eb3af3d662147b$export$8472cf4ca0d7e3d3,
        students: $f264ceec36a478ad$export$6e22c362a0406a2c,
        documents: $4e23420f70d37f30$export$d3cec2e51682fbf1,
        editDocs: [],
        currentDoc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        teacher: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        semester: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $6be45a9e147fc393$export$db29b8604d4c345d = function(v) {
    return v.teacher;
};
var $6be45a9e147fc393$export$2646a34d1c0c0795 = function(workQ) {
    var err = new $54dae5ca6a6cd16d$export$90a530fd5ef57012("No teacher selected to fill forms for.");
    return $7d4cccdf062a2261$export$a92e4c44d367d0af(err)($6be45a9e147fc393$export$db29b8604d4c345d(workQ));
};
var $6be45a9e147fc393$export$f448a06f822a0992 = function(v) {
    return v.semester;
};
var $6be45a9e147fc393$export$19c82ab5012b22b3 = function(workQ) {
    var err = new $54dae5ca6a6cd16d$export$90a530fd5ef57012("No semester selected to fill forms for.");
    return $7d4cccdf062a2261$export$a92e4c44d367d0af(err)($6be45a9e147fc393$export$f448a06f822a0992(workQ));
};
var $6be45a9e147fc393$export$27beb92d36f92bea = function(workQ) {
    var students = $6be45a9e147fc393$var$fromFoldable($6be45a9e147fc393$var$map1(function(v) {
        return v.id;
    })($f264ceec36a478ad$export$7693e0a1b9351086(workQ.students)));
    var forms = $6be45a9e147fc393$var$fromFoldable($6be45a9e147fc393$var$map1(function(v) {
        return v.id;
    })($f264ceec36a478ad$export$7693e0a1b9351086(workQ.forms)));
    var studentForms = function(student) {
        var docs = $6be45a9e147fc393$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(f) {
            return $6be45a9e147fc393$var$eq(f.student.id)(student);
        })(workQ.editDocs));
        return $6be45a9e147fc393$var$map(function(f) {
            return {
                student: student,
                form: f
            };
        })($6be45a9e147fc393$var$append1(docs)($6be45a9e147fc393$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(forms)));
    };
    return $fc8c1182ec2aefec$export$ee1b3e54f0441b22($6be45a9e147fc393$var$map(studentForms)(students));
};
var $6be45a9e147fc393$export$2a52fb62023dd743 = function(v) {
    return $06733ae99ed4f534$export$c15bd07a493e1236(v.teacher) && $06733ae99ed4f534$export$c15bd07a493e1236(v.semester);
};
var $6be45a9e147fc393$export$fce9b5fa170e923f = function(v) {
    return function(v1) {
        if (v.type instanceof $02eacf321b2a2128$export$ebce5c1c966101a4) return $06733ae99ed4f534$export$c15bd07a493e1236(v1.semester);
        return $6be45a9e147fc393$export$2a52fb62023dd743(v1);
    };
};
var $6be45a9e147fc393$var$fillQueueToCreateReq = function(v) {
    return function(v1) {
        return function(v2) {
            if (v2.form instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $06733ae99ed4f534$export$8a67b48435b5d073({
                student_id: v2.student,
                type_id: v2.form.value0,
                teacher_id: $6be45a9e147fc393$var$map2(function(v3) {
                    return v3.id;
                })(v),
                semester: $6be45a9e147fc393$var$map2(function(v3) {
                    return v3.semester;
                })(v1)
            });
            if (v2.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            throw new Error("Failed pattern match at Steps.WorkQueue.State (line 177, column 1 - line 181, column 31): " + [
                v.constructor.name,
                v1.constructor.name,
                v2.constructor.name
            ]);
        };
    };
};
var $6be45a9e147fc393$export$9b8479ea7cb2aaa7 = function(workQ) {
    return function(docs) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            editDocs: docs,
            students: $6be45a9e147fc393$var$selectAll$prime($6be45a9e147fc393$var$map(function(v1) {
                return v1.student;
            })(docs))(workQ.students)(true)
        };
    };
};
var $6be45a9e147fc393$export$93c34340dccda974 = function(workQ) {
    return function(defTeacher) {
        return function(defSemester) {
            return $6be45a9e147fc393$var$runGraphQL($d4a8d5b15f9925c4$export$95e01943223e1dc($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($6be45a9e147fc393$var$map($6be45a9e147fc393$var$fillQueueToCreateReq(defTeacher)(defSemester))($6be45a9e147fc393$export$27beb92d36f92bea(workQ)))));
        };
    };
};
var $6be45a9e147fc393$export$d40c85e0bbba2bb = function(workQ) {
    return function(students) {
        return {
            forms: workQ.forms,
            documents: workQ.documents,
            editDocs: workQ.editDocs,
            currentDoc: workQ.currentDoc,
            semester: workQ.semester,
            teacher: workQ.teacher,
            students: $6be45a9e147fc393$var$selectAll$prime(students)(workQ.students)(true)
        };
    };
};


// Generated by purs version 0.15.16






var $288f947f09d2f062$export$aec14294028030b8 = /* #__PURE__ */ function() {
    function Expanded() {}
    Expanded.value = new Expanded();
    return Expanded;
}();
var $288f947f09d2f062$export$d47910e24fffa8c2 = /* #__PURE__ */ function() {
    function Collapsed() {}
    Collapsed.value = new Collapsed();
    return Collapsed;
}();
var $288f947f09d2f062$export$9b7fd77b33289379 = function(defTeacher) {
    return function(defSemester) {
        return function(ui) {
            return {
                search: ui.search,
                expandedStudents: $ea3eb84de0acf574$export$6e22c362a0406a2c,
                teacher: $7178b396566f5a79$export$5a4818cec1656a71(ui.teacher)(defTeacher),
                semester: $7178b396566f5a79$export$5a4818cec1656a71(ui.semester)(defSemester)
            };
        };
    };
};
var $288f947f09d2f062$export$4bc0f934ddc418d8 = /* #__PURE__ */ function() {
    var teacherSel = {
        deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-teacher")),
        allowDeselect: false
    };
    var semesterSel = {
        deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
        editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-semester")),
        allowDeselect: false
    };
    return {
        expandedStudents: $ea3eb84de0acf574$export$6e22c362a0406a2c,
        search: $6415e24f7cd3b8e1$export$5c89bef3d5bb8108,
        teacher: $7178b396566f5a79$export$d967f07ae6c72524("teacher")($dc9dc2b43b9526de$export$4cc3c70d62d7a856)(teacherSel),
        semester: $7178b396566f5a79$export$d967f07ae6c72524("semester")($dc9dc2b43b9526de$export$930f503bd2cd157b)(semesterSel)
    };
}();



var $f44e895d82c9aa8d$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $f44e895d82c9aa8d$var$selectAll$prime = /* #__PURE__ */ $f264ceec36a478ad$export$2f60db41f2af055($f44e895d82c9aa8d$var$ordRNTY)($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $f44e895d82c9aa8d$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $f44e895d82c9aa8d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $f44e895d82c9aa8d$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $f44e895d82c9aa8d$var$getQuery = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$71eec30d9db46a56($a40b20519abba0fb$export$c6b405b39190b469);
var $f44e895d82c9aa8d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $f44e895d82c9aa8d$var$sequence = /* #__PURE__ */ $11d1e86de605dfc6$export$49bb65c2ea163039($11d1e86de605dfc6$export$9e4a28683e28e26a)($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $f44e895d82c9aa8d$var$getDecode = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($a40b20519abba0fb$export$c6b405b39190b469);
var $f44e895d82c9aa8d$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $f44e895d82c9aa8d$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($f44e895d82c9aa8d$var$eqRNTY);
var $f44e895d82c9aa8d$var$selectForms = /* #__PURE__ */ $38eb3af3d662147b$export$e326c404651add30($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $f44e895d82c9aa8d$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $f44e895d82c9aa8d$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404($f44e895d82c9aa8d$var$ordRNTY);
var $f44e895d82c9aa8d$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($f44e895d82c9aa8d$var$eqRNTY);
var $f44e895d82c9aa8d$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $f44e895d82c9aa8d$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $f44e895d82c9aa8d$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $f44e895d82c9aa8d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2)($edf0339512807bee$export$b147a380fa8fdc0e);
var $f44e895d82c9aa8d$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $f44e895d82c9aa8d$export$f86f4109e45bff42 = function(locationState) {
    return function(state) {
        return $daa993e9fe4182d9$export$96ba27ab48ad90aa(locationState)(state.step)(state.workQueueState);
    };
};
var $f44e895d82c9aa8d$var$applyStudentSelections = function(workQueue) {
    return function(students) {
        var selected = $f44e895d82c9aa8d$var$selectAll$prime(students)($f264ceec36a478ad$export$6e22c362a0406a2c)(true);
        return {
            forms: workQueue.forms,
            documents: workQueue.documents,
            editDocs: workQueue.editDocs,
            currentDoc: workQueue.currentDoc,
            semester: workQueue.semester,
            teacher: workQueue.teacher,
            students: selected
        };
    };
};
var $f44e895d82c9aa8d$var$hydrateStudentSelections = function(workQueue) {
    return function(studentIds) {
        if ($396c4c3d9e7fae3c$export$7b1b591b262c240(studentIds)) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(workQueue));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
            var queries = $f44e895d82c9aa8d$var$map($b05aa108190eac05$export$ece1be3647e3a6ac)(studentIds);
            return $f44e895d82c9aa8d$var$bind($d2284b2d3e1b6f87$export$8291c2122093ac93($7c4f9de9dcfa2f59$export$7efd4163d8775bbe($f44e895d82c9aa8d$var$map($f44e895d82c9aa8d$var$getQuery)(queries))))(function(batchResult) {
                if (batchResult instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(batchResult.value0));
                if (batchResult instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $f44e895d82c9aa8d$var$pure($f44e895d82c9aa8d$var$map1($f44e895d82c9aa8d$var$applyStudentSelections(workQueue))($f44e895d82c9aa8d$var$sequence($396c4c3d9e7fae3c$export$b634740ce272acb5($f44e895d82c9aa8d$var$getDecode)(queries)(batchResult.value0))));
                throw new Error("Failed pattern match at App.Hydrate (line 157, column 9 - line 160, column 115): " + [
                    batchResult.constructor.name
                ]);
            });
        }
        throw new Error("Failed pattern match at App.Hydrate (line 151, column 1 - line 151, column 106): " + [
            workQueue.constructor.name,
            studentIds.constructor.name
        ]);
    };
};
var $f44e895d82c9aa8d$var$applyFormSelections = function(formIds) {
    return function(workQueue) {
        return function(forms) {
            var selected = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(form) {
                return $f44e895d82c9aa8d$var$elem(form.id)(formIds);
            })(forms);
            var selectedMap = $f44e895d82c9aa8d$var$selectForms(selected)(true)($38eb3af3d662147b$export$8472cf4ca0d7e3d3);
            return {
                students: workQueue.students,
                documents: workQueue.documents,
                editDocs: workQueue.editDocs,
                currentDoc: workQueue.currentDoc,
                semester: workQueue.semester,
                teacher: workQueue.teacher,
                forms: selectedMap
            };
        };
    };
};
var $f44e895d82c9aa8d$var$hydrateFormSelections = function(workQueue) {
    return function(formIds) {
        if ($396c4c3d9e7fae3c$export$7b1b591b262c240(formIds)) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(workQueue));
        if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $f44e895d82c9aa8d$var$bind($f44e895d82c9aa8d$var$runGraphQL($38eb3af3d662147b$export$a8d7826568b655d2))(function(formsResult) {
            return $f44e895d82c9aa8d$var$pure($f44e895d82c9aa8d$var$map1($f44e895d82c9aa8d$var$applyFormSelections(formIds)(workQueue))(formsResult));
        });
        throw new Error("Failed pattern match at App.Hydrate (line 138, column 1 - line 138, column 100): " + [
            workQueue.constructor.name,
            formIds.constructor.name
        ]);
    };
};
var $f44e895d82c9aa8d$export$b7654b4155f1192a = function(v) {
    return function(v1) {
        if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var v2 = $740d96ccf08cc464$export$11eb3b5ef9574821(v1)(v.value0.activeDoc.value0);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                var committed = $6be45a9e147fc393$export$a871627eddff2fcf(v1)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                    formId: v2.value0.formId,
                    studentId: v2.value0.student.id,
                    documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(v2.value0.id)
                }));
                return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $994495db3cff0a67$export$db36463848ed68bd(v.value0.activeDoc.value0), committed)));
            }
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                var requestedDocs = $f44e895d82c9aa8d$var$nub($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(v.value0.activeDoc.value0)(v.value0.docs));
                var existingDocs = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(form) {
                    return $f44e895d82c9aa8d$var$elem(form.id)(requestedDocs);
                })(v1.editDocs);
                var existingIds = $f44e895d82c9aa8d$var$map(function(v3) {
                    return v3.id;
                })(existingDocs);
                var missingDocs = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(doc) {
                    return !$f44e895d82c9aa8d$var$elem(doc)(existingIds);
                })(requestedDocs);
                return $f44e895d82c9aa8d$var$bind(function() {
                    var $51 = $396c4c3d9e7fae3c$export$7b1b591b262c240(missingDocs);
                    if ($51) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a([]));
                    return $f44e895d82c9aa8d$var$runGraphQL($3b789731b0ef5df1$export$65b249f9d8a6bd0d(missingDocs));
                }())(function(fetchResult) {
                    if (fetchResult instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(fetchResult.value0));
                    if (fetchResult instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                        var fetched = $396c4c3d9e7fae3c$export$e70771d2e7e590a(function(requestedId) {
                            return $396c4c3d9e7fae3c$export$71aa6c912b956294(function(form) {
                                return $f44e895d82c9aa8d$var$eq(form.id)(requestedId);
                            })(fetchResult.value0);
                        })(requestedDocs);
                        var combinedDocs = $f44e895d82c9aa8d$var$append(existingDocs)(fetched);
                        var v3 = $396c4c3d9e7fae3c$export$71aa6c912b956294(function(form) {
                            return $f44e895d82c9aa8d$var$eq(form.id)(v.value0.activeDoc.value0);
                        })(combinedDocs);
                        if (v3 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            var workQ = $6be45a9e147fc393$export$9b8479ea7cb2aaa7(v1)(combinedDocs);
                            var current = new $06733ae99ed4f534$export$8a67b48435b5d073({
                                formId: v3.value0.form_type.id,
                                studentId: v3.value0.student.id,
                                documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(v3.value0.id)
                            });
                            var committed = $6be45a9e147fc393$export$a871627eddff2fcf(workQ)(current);
                            return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $994495db3cff0a67$export$db36463848ed68bd(v.value0.activeDoc.value0), committed)));
                        }
                        if (v3 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9($994495db3cff0a67$export$317e7082611cb548.value, v1)));
                        throw new Error("Failed pattern match at App.Hydrate (line 102, column 21 - line 113, column 65): " + [
                            v3.constructor.name
                        ]);
                    }
                    throw new Error("Failed pattern match at App.Hydrate (line 95, column 13 - line 113, column 65): " + [
                        fetchResult.constructor.name
                    ]);
                });
            }
            throw new Error("Failed pattern match at App.Hydrate (line 76, column 5 - line 113, column 65): " + [
                v2.constructor.name
            ]);
        }
        if (v instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && v.value0.activeDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            if ($396c4c3d9e7fae3c$export$7b1b591b262c240($6be45a9e147fc393$export$27beb92d36f92bea(v1))) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9($994495db3cff0a67$export$317e7082611cb548.value, v1)));
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9($994495db3cff0a67$export$d8ccc25b3be9c9d7.value, v1)));
        }
        if (v instanceof $daa993e9fe4182d9$export$a56647213ddc793) return $f44e895d82c9aa8d$var$bind($f44e895d82c9aa8d$var$hydrateFormSelections(v1)(v.value0.selectedForms))(function(result) {
            return $f44e895d82c9aa8d$var$pure($f44e895d82c9aa8d$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create($994495db3cff0a67$export$d02ce3ec9b5b8f12.value))(result));
        });
        if (v instanceof $daa993e9fe4182d9$export$27668ebed3f7ff2f) {
            if ($396c4c3d9e7fae3c$export$7b1b591b262c240(v.value0.selectedStudents)) return $f44e895d82c9aa8d$var$bind($f44e895d82c9aa8d$var$hydrateFormSelections(v1)(v.value0.selectedForms))(function(result) {
                return $f44e895d82c9aa8d$var$pure($f44e895d82c9aa8d$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create($994495db3cff0a67$export$d02ce3ec9b5b8f12.value))(result));
            });
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $f44e895d82c9aa8d$var$bind($f44e895d82c9aa8d$var$hydrateFormSelections(v1)(v.value0.selectedForms))(function(formResult) {
                if (formResult instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(formResult.value0));
                if (formResult instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $f44e895d82c9aa8d$var$bind($f44e895d82c9aa8d$var$hydrateStudentSelections(formResult.value0)(v.value0.selectedStudents))(function(studentResult) {
                    return $f44e895d82c9aa8d$var$pure($f44e895d82c9aa8d$var$map1($71f2e2e9476163f8$export$1908877435b1d5e9.create($994495db3cff0a67$export$d80ca78eabef93e4.value))(studentResult));
                });
                throw new Error("Failed pattern match at App.Hydrate (line 129, column 9 - line 133, column 56): " + [
                    formResult.constructor.name
                ]);
            });
        }
        return $f44e895d82c9aa8d$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $71f2e2e9476163f8$export$1908877435b1d5e9($daa993e9fe4182d9$export$6a8419b6e6434081(v), v1)));
    };
};
var $f44e895d82c9aa8d$export$67d5a1c18c496673 = function(state) {
    return function(locationState) {
        return $d2284b2d3e1b6f87$export$8291c2122093ac93(function() {
            var requestedRoute = $daa993e9fe4182d9$export$9bf1c8c94a38f6fb(locationState);
            return $f44e895d82c9aa8d$var$bind1($f44e895d82c9aa8d$export$b7654b4155f1192a(requestedRoute)(state.workQueueState))(function(v) {
                var nextState0 = {
                    operations: state.operations,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueUi: state.workQueueUi,
                    step: v.value0,
                    workQueueState: v.value1,
                    preselectForms: []
                };
                var nextState = {
                    operations: nextState0.operations,
                    preselectForms: nextState0.preselectForms,
                    pushStateInterface: nextState0.pushStateInterface,
                    routeVersion: nextState0.routeVersion,
                    step: nextState0.step,
                    step1: nextState0.step1,
                    step2A: nextState0.step2A,
                    step2B: nextState0.step2B,
                    step3: nextState0.step3,
                    workQueueCache: nextState0.workQueueCache,
                    workQueueState: nextState0.workQueueState,
                    workQueueUi: nextState0.workQueueUi,
                    route: $f44e895d82c9aa8d$export$f86f4109e45bff42(locationState)(nextState0)
                };
                return $f44e895d82c9aa8d$var$pure1($80445329d31df9ca$export$9229a4a65d5e2788(state)(nextState));
            });
        }());
    };
};
var $f44e895d82c9aa8d$export$6fefe85d0a68ec8c = /* #__PURE__ */ $d2284b2d3e1b6f87$export$8291c2122093ac93(/* #__PURE__ */ $f44e895d82c9aa8d$var$bind1(/* #__PURE__ */ $f44e895d82c9aa8d$var$lift(/* #__PURE__ */ $f44e895d82c9aa8d$var$liftEffect($b12e3a3cf2d07b53$export$d0a1bc1ffc0b6105)))(function(pushStateInterface) {
    return $f44e895d82c9aa8d$var$bind1($f44e895d82c9aa8d$var$lift($f44e895d82c9aa8d$var$liftEffect($a5971154c27be447$export$5729eead7c8f9eaf(pushStateInterface))))(function(locationState) {
        return $f44e895d82c9aa8d$var$bind1($740d96ccf08cc464$export$1a8dbcadbc933b67($6be45a9e147fc393$export$78ce5202a3b18e96)($288f947f09d2f062$export$4bc0f934ddc418d8)($740d96ccf08cc464$export$7188e7e84cf4c0b3))(function(workQueue) {
            var initial = $80445329d31df9ca$export$3a00184c4304ec2e({
                route: new $daa993e9fe4182d9$export$61045fda02b7f5d8({
                    preservedQuery: $daa993e9fe4182d9$export$11c97f589579967b(locationState.search)
                }),
                step: $994495db3cff0a67$export$317e7082611cb548.value,
                workQueueState: workQueue.state,
                workQueueUi: workQueue.ui,
                workQueueCache: workQueue.cache,
                preselectForms: [],
                pushStateInterface: pushStateInterface
            });
            return $f44e895d82c9aa8d$export$67d5a1c18c496673(initial)(locationState);
        });
    });
}));
var $f44e895d82c9aa8d$export$71105691af3c9d50 = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4))($b5330906fcd65ffd$export$d558900b1478007d)(/* #__PURE__ */ $3257df7cdef77623$export$b97f2ad8d0b7442d($f44e895d82c9aa8d$export$6fefe85d0a68ec8c));


// Generated by purs version 0.15.16
var $c9f8fdc31e1f6dad$export$5c8f622845981396 = /* #__PURE__ */ function() {
    function BrowserLocationChanged(value0) {
        this.value0 = value0;
    }
    BrowserLocationChanged.create = function(value0) {
        return new BrowserLocationChanged(value0);
    };
    return BrowserLocationChanged;
}();
var $c9f8fdc31e1f6dad$export$d9d27eb76d4d6392 = /* #__PURE__ */ function() {
    function HydratedLocation(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    HydratedLocation.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new HydratedLocation(value0, value1, value2);
            };
        };
    };
    return HydratedLocation;
}();
var $c9f8fdc31e1f6dad$export$cfd42e9439cb3c03 = /* #__PURE__ */ function() {
    function Step1Msg(value0) {
        this.value0 = value0;
    }
    Step1Msg.create = function(value0) {
        return new Step1Msg(value0);
    };
    return Step1Msg;
}();
var $c9f8fdc31e1f6dad$export$1dc871215656967e = /* #__PURE__ */ function() {
    function Step1SearchDebounced(value0) {
        this.value0 = value0;
    }
    Step1SearchDebounced.create = function(value0) {
        return new Step1SearchDebounced(value0);
    };
    return Step1SearchDebounced;
}();
var $c9f8fdc31e1f6dad$export$49c4478c934a149d = /* #__PURE__ */ function() {
    function Step1InitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1InitialLoaded.create = function(value0) {
        return function(value1) {
            return new Step1InitialLoaded(value0, value1);
        };
    };
    return Step1InitialLoaded;
}();
var $c9f8fdc31e1f6dad$export$1815fbfc550f516c = /* #__PURE__ */ function() {
    function Step1RecentFormsLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1RecentFormsLoaded.create = function(value0) {
        return function(value1) {
            return new Step1RecentFormsLoaded(value0, value1);
        };
    };
    return Step1RecentFormsLoaded;
}();
var $c9f8fdc31e1f6dad$export$186e0f90982d0f3f = /* #__PURE__ */ function() {
    function Step1FormOrderSaved(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1FormOrderSaved.create = function(value0) {
        return function(value1) {
            return new Step1FormOrderSaved(value0, value1);
        };
    };
    return Step1FormOrderSaved;
}();
var $c9f8fdc31e1f6dad$export$72cd3e127cbacdf2 = /* #__PURE__ */ function() {
    function Step1LocksToggled(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1LocksToggled.create = function(value0) {
        return function(value1) {
            return new Step1LocksToggled(value0, value1);
        };
    };
    return Step1LocksToggled;
}();
var $c9f8fdc31e1f6dad$export$170ffc57937e436f = /* #__PURE__ */ function() {
    function Step1DocumentsCopied(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1DocumentsCopied.create = function(value0) {
        return function(value1) {
            return new Step1DocumentsCopied(value0, value1);
        };
    };
    return Step1DocumentsCopied;
}();
var $c9f8fdc31e1f6dad$export$bdf9754cca6d30f9 = /* #__PURE__ */ function() {
    function Step1DocumentsDeleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1DocumentsDeleted.create = function(value0) {
        return function(value1) {
            return new Step1DocumentsDeleted(value0, value1);
        };
    };
    return Step1DocumentsDeleted;
}();
var $c9f8fdc31e1f6dad$export$b8f63b481aa277b7 = /* #__PURE__ */ function() {
    function Step1DocumentsExported(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Step1DocumentsExported.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Step1DocumentsExported(value0, value1, value2);
            };
        };
    };
    return Step1DocumentsExported;
}();
var $c9f8fdc31e1f6dad$export$15cf3a228c822e8b = /* #__PURE__ */ function() {
    function Step1SignaturesRequested(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step1SignaturesRequested.create = function(value0) {
        return function(value1) {
            return new Step1SignaturesRequested(value0, value1);
        };
    };
    return Step1SignaturesRequested;
}();
var $c9f8fdc31e1f6dad$export$c1b4ff70e49ef826 = /* #__PURE__ */ function() {
    function Step1FormsUpdated(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Step1FormsUpdated.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Step1FormsUpdated(value0, value1, value2);
            };
        };
    };
    return Step1FormsUpdated;
}();
var $c9f8fdc31e1f6dad$export$4ee52428d11a0598 = /* #__PURE__ */ function() {
    function Step2AAction(value0) {
        this.value0 = value0;
    }
    Step2AAction.create = function(value0) {
        return new Step2AAction(value0);
    };
    return Step2AAction;
}();
var $c9f8fdc31e1f6dad$export$a64c6b692532acd6 = /* #__PURE__ */ function() {
    function Step2AInitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step2AInitialLoaded.create = function(value0) {
        return function(value1) {
            return new Step2AInitialLoaded(value0, value1);
        };
    };
    return Step2AInitialLoaded;
}();
var $c9f8fdc31e1f6dad$export$6a003360ff9d90ea = /* #__PURE__ */ function() {
    function Step2BAction(value0) {
        this.value0 = value0;
    }
    Step2BAction.create = function(value0) {
        return new Step2BAction(value0);
    };
    return Step2BAction;
}();
var $c9f8fdc31e1f6dad$export$50c82f767474cb3f = /* #__PURE__ */ function() {
    function Step2BLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step2BLoaded.create = function(value0) {
        return function(value1) {
            return new Step2BLoaded(value0, value1);
        };
    };
    return Step2BLoaded;
}();
var $c9f8fdc31e1f6dad$export$385761a6227f1894 = /* #__PURE__ */ function() {
    function Step2FormsExported(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step2FormsExported.create = function(value0) {
        return function(value1) {
            return new Step2FormsExported(value0, value1);
        };
    };
    return Step2FormsExported;
}();
var $c9f8fdc31e1f6dad$export$f626af092893962d = /* #__PURE__ */ function() {
    function Step3Msg(value0) {
        this.value0 = value0;
    }
    Step3Msg.create = function(value0) {
        return new Step3Msg(value0);
    };
    return Step3Msg;
}();
var $c9f8fdc31e1f6dad$export$a03875e05513d0ab = /* #__PURE__ */ function() {
    function Step3DocumentRequestHandled() {}
    Step3DocumentRequestHandled.value = new Step3DocumentRequestHandled();
    return Step3DocumentRequestHandled;
}();
var $c9f8fdc31e1f6dad$export$81c3d75642767bc3 = /* #__PURE__ */ function() {
    function Step3FormTypesLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step3FormTypesLoaded.create = function(value0) {
        return function(value1) {
            return new Step3FormTypesLoaded(value0, value1);
        };
    };
    return Step3FormTypesLoaded;
}();
var $c9f8fdc31e1f6dad$export$def578e25f70cc18 = /* #__PURE__ */ function() {
    function Step3InitialLoaded(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Step3InitialLoaded.create = function(value0) {
        return function(value1) {
            return new Step3InitialLoaded(value0, value1);
        };
    };
    return Step3InitialLoaded;
}();
var $c9f8fdc31e1f6dad$export$4a8caf36b85213e5 = /* #__PURE__ */ function() {
    function OpStarted(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    OpStarted.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new OpStarted(value0, value1, value2);
            };
        };
    };
    return OpStarted;
}();
var $c9f8fdc31e1f6dad$export$98baa1b16ede8cfe = /* #__PURE__ */ function() {
    function OpCompleted(value0) {
        this.value0 = value0;
    }
    OpCompleted.create = function(value0) {
        return new OpCompleted(value0);
    };
    return OpCompleted;
}();
var $c9f8fdc31e1f6dad$export$eafac69673bdfea3 = /* #__PURE__ */ function() {
    function OpFailed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    OpFailed.create = function(value0) {
        return function(value1) {
            return new OpFailed(value0, value1);
        };
    };
    return OpFailed;
}();
var $c9f8fdc31e1f6dad$export$e1f136b69054516 = /* #__PURE__ */ function() {
    function OpSuperseded(value0) {
        this.value0 = value0;
    }
    OpSuperseded.create = function(value0) {
        return new OpSuperseded(value0);
    };
    return OpSuperseded;
}();


// Generated by purs version 0.15.16
// Generated by purs version 0.15.16






var $f16a4b1732666b80$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $f16a4b1732666b80$var$parent_typeIsSymbol = {
    reflectSymbol: function() {
        return "parent_type";
    }
};
var $f16a4b1732666b80$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $f16a4b1732666b80$var$parent_idIsSymbol = {
    reflectSymbol: function() {
        return "parent_id";
    }
};
var $f16a4b1732666b80$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $f16a4b1732666b80$var$fileIsSymbol = {
    reflectSymbol: function() {
        return "file";
    }
};
var $f16a4b1732666b80$var$descriptionIsSymbol = {
    reflectSymbol: function() {
        return "description";
    }
};
var $f16a4b1732666b80$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $f16a4b1732666b80$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $f16a4b1732666b80$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $f16a4b1732666b80$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $f16a4b1732666b80$var$userIsSymbol = {
    reflectSymbol: function() {
        return "user";
    }
};
var $f16a4b1732666b80$var$urlIsSymbol = {
    reflectSymbol: function() {
        return "url";
    }
};
var $f16a4b1732666b80$var$pathIsSymbol = {
    reflectSymbol: function() {
        return "path";
    }
};
var $f16a4b1732666b80$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $f16a4b1732666b80$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $f16a4b1732666b80$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $f16a4b1732666b80$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $f16a4b1732666b80$var$jsonQR = /* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($f16a4b1732666b80$var$deleteIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $f16a4b1732666b80$var$gDecodeJsonCons(/* #__PURE__ */ $f16a4b1732666b80$var$gDecodeJsonCons(/* #__PURE__ */ $f16a4b1732666b80$var$gDecodeJsonCons(/* #__PURE__ */ $f16a4b1732666b80$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $f16a4b1732666b80$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($f16a4b1732666b80$var$nameIsSymbol)()())()))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($f16a4b1732666b80$var$userIsSymbol)()())($f16a4b1732666b80$var$urlIsSymbol)()())($f16a4b1732666b80$var$pathIsSymbol)()())($f16a4b1732666b80$var$idIsSymbol)()())($f16a4b1732666b80$var$descriptionIsSymbol)()())($f16a4b1732666b80$var$created_atIsSymbol)()())($f16a4b1732666b80$var$canIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $f16a4b1732666b80$var$rlhsCons($f16a4b1732666b80$var$userIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $f16a4b1732666b80$var$rlhsCons($f16a4b1732666b80$var$nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($f16a4b1732666b80$var$urlIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($f16a4b1732666b80$var$pathIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($f16a4b1732666b80$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($f16a4b1732666b80$var$descriptionIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($f16a4b1732666b80$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($f16a4b1732666b80$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $f16a4b1732666b80$var$rlhsCons($f16a4b1732666b80$var$deleteIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())());
var $f16a4b1732666b80$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445(/* #__PURE__ */ $f16a4b1732666b80$var$rltvCons($f16a4b1732666b80$var$parent_typeIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "AttachmentParentType";
    }
}))($f16a4b1732666b80$var$encRNTY)()())($f16a4b1732666b80$var$parent_idIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
}))($f16a4b1732666b80$var$encRNTY)()())($f16a4b1732666b80$var$dataIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "AttachmentInput";
    }
}))(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b)(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($a40b20519abba0fb$export$8089d535d93360b6)($eb7399d322077fcf$export$12b4d820b2ffc726)($f16a4b1732666b80$var$fileIsSymbol)())($f16a4b1732666b80$var$descriptionIsSymbol)())()))()())(/* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $f16a4b1732666b80$var$rltvfConsOther($f16a4b1732666b80$var$parent_typeIsSymbol)())($f16a4b1732666b80$var$parent_idIsSymbol)())($f16a4b1732666b80$var$dataIsSymbol)()()(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f4bf89db99b76e5($a40b20519abba0fb$export$fe891b8934c38330)($f16a4b1732666b80$var$fileIsSymbol)())($f16a4b1732666b80$var$descriptionIsSymbol)()))())($f16a4b1732666b80$var$jsonQR);
var $f16a4b1732666b80$var$buildMutation1 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $f16a4b1732666b80$var$rltvCons($f16a4b1732666b80$var$idIsSymbol)($308f9765feb7633d$export$f4150079df24c8b9)($308f9765feb7633d$export$65249653a9a6562)()())(/* #__PURE__ */ $f16a4b1732666b80$var$rltvfConsOther($f16a4b1732666b80$var$idIsSymbol)())())($f16a4b1732666b80$var$jsonQR);
var $f16a4b1732666b80$export$baeba309c80ed796 = /* #__PURE__ */ function() {
    function FormAttachment(value0) {
        this.value0 = value0;
    }
    FormAttachment.create = function(value0) {
        return new FormAttachment(value0);
    };
    return FormAttachment;
}();
var $f16a4b1732666b80$export$b4967a8c70fda682 = function(parent) {
    return function(input) {
        var parent$prime = {
            id: parent.value0,
            type: "FORM"
        };
        return $f16a4b1732666b80$var$buildMutation("createAttachment")({
            parent_id: parent$prime.id,
            parent_type: $308f9765feb7633d$export$eb1b128a19ff6c25(parent$prime.type),
            data: $308f9765feb7633d$export$eb1b128a19ff6c25({
                description: input.description,
                file: $a40b20519abba0fb$export$4a8b657cc4fb4c7f(input.file)
            })
        });
    };
};
var $f16a4b1732666b80$export$9ed76097473092d5 = function(id) {
    return $f16a4b1732666b80$var$buildMutation1("deleteAttachment")({
        id: new $308f9765feb7633d$export$95d18696cb32267f(id)
    });
};








// Generated by purs version 0.15.16








var $8e553923d06fdb06$var$rltvCons = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc);
var $8e553923d06fdb06$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $8e553923d06fdb06$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $8e553923d06fdb06$var$rltvCons1 = /* #__PURE__ */ $8e553923d06fdb06$var$rltvCons($8e553923d06fdb06$var$idIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "ID";
    }
}))($8e553923d06fdb06$var$encRNTY)()();
var $8e553923d06fdb06$var$dataIsSymbol = {
    reflectSymbol: function() {
        return "data";
    }
};
var $8e553923d06fdb06$var$rltvCons2 = /* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($8e553923d06fdb06$var$rltvCons1)($8e553923d06fdb06$var$dataIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "SignFormInput";
    }
}));
var $8e553923d06fdb06$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($8e553923d06fdb06$var$encRNTY);
var $8e553923d06fdb06$var$gEncodeJsonCons1 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$7f2886916ce99188)($eb7399d322077fcf$export$12b4d820b2ffc726);
var $8e553923d06fdb06$var$use_defaultIsSymbol = {
    reflectSymbol: function() {
        return "use_default";
    }
};
var $8e553923d06fdb06$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $8e553923d06fdb06$var$rltvfConsOther = /* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330);
var $8e553923d06fdb06$var$rltvfConsOther1 = /* #__PURE__ */ $8e553923d06fdb06$var$rltvfConsOther($8e553923d06fdb06$var$idIsSymbol)();
var $8e553923d06fdb06$var$rltvfNamedTypeRec = /* #__PURE__ */ $a40b20519abba0fb$export$1dfb011ce07ede8c($8e553923d06fdb06$var$rltvfConsOther1)($8e553923d06fdb06$var$dataIsSymbol)()();
var $8e553923d06fdb06$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $8e553923d06fdb06$var$gDecodeJsonCons1 = /* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $8e553923d06fdb06$var$last_nameIsSymbol = {
    reflectSymbol: function() {
        return "last_name";
    }
};
var $8e553923d06fdb06$var$first_nameIsSymbol = {
    reflectSymbol: function() {
        return "first_name";
    }
};
var $8e553923d06fdb06$var$emailIsSymbol = {
    reflectSymbol: function() {
        return "email";
    }
};
var $8e553923d06fdb06$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099));
var $8e553923d06fdb06$var$gDecodeJsonCons3 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $8e553923d06fdb06$var$urlIsSymbol = {
    reflectSymbol: function() {
        return "url";
    }
};
var $8e553923d06fdb06$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $8e553923d06fdb06$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $8e553923d06fdb06$var$contactIsSymbol = {
    reflectSymbol: function() {
        return "contact";
    }
};
var $8e553923d06fdb06$var$decodeRecord = /* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons1($8e553923d06fdb06$var$last_nameIsSymbol)()())($8e553923d06fdb06$var$first_nameIsSymbol)()())($8e553923d06fdb06$var$emailIsSymbol)()())()))(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons2(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons1($8e553923d06fdb06$var$urlIsSymbol)()())($8e553923d06fdb06$var$relationshipIsSymbol)()())($8e553923d06fdb06$var$keyIsSymbol)()())($8e553923d06fdb06$var$idIsSymbol)()())($8e553923d06fdb06$var$created_atIsSymbol)()())($8e553923d06fdb06$var$contactIsSymbol)()())();
var $8e553923d06fdb06$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $8e553923d06fdb06$var$recShape = /* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$urlIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$contactIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$last_nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$first_nameIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$emailIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())();
var $8e553923d06fdb06$var$jsonQR = /* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379($8e553923d06fdb06$var$decodeRecord)($8e553923d06fdb06$var$recShape);
var $8e553923d06fdb06$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $8e553923d06fdb06$var$rltvCons2(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons1($8e553923d06fdb06$var$use_defaultIsSymbol)())($8e553923d06fdb06$var$keyIsSymbol)())()))()())(/* #__PURE__ */ $8e553923d06fdb06$var$rltvfNamedTypeRec(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $8e553923d06fdb06$var$rltvfConsOther($8e553923d06fdb06$var$use_defaultIsSymbol)())($8e553923d06fdb06$var$keyIsSymbol)()))())($8e553923d06fdb06$var$jsonQR);
var $8e553923d06fdb06$var$gEncodeJsonCons2 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $8e553923d06fdb06$var$save_defaultIsSymbol = {
    reflectSymbol: function() {
        return "save_default";
    }
};
var $8e553923d06fdb06$var$fileIsSymbol = {
    reflectSymbol: function() {
        return "file";
    }
};
var $8e553923d06fdb06$var$buildMutation1 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $8e553923d06fdb06$var$rltvCons2(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons2(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($a40b20519abba0fb$export$8089d535d93360b6)(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons2(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons2(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons1($8e553923d06fdb06$var$save_defaultIsSymbol)())($8e553923d06fdb06$var$last_nameIsSymbol)())($8e553923d06fdb06$var$keyIsSymbol)())($8e553923d06fdb06$var$first_nameIsSymbol)())($8e553923d06fdb06$var$fileIsSymbol)())($8e553923d06fdb06$var$emailIsSymbol)())()))()())(/* #__PURE__ */ $8e553923d06fdb06$var$rltvfNamedTypeRec(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f4bf89db99b76e5(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f(/* #__PURE__ */ $8e553923d06fdb06$var$rltvfConsOther($8e553923d06fdb06$var$save_defaultIsSymbol)())($8e553923d06fdb06$var$last_nameIsSymbol)())($8e553923d06fdb06$var$keyIsSymbol)())($8e553923d06fdb06$var$first_nameIsSymbol)())($8e553923d06fdb06$var$fileIsSymbol)())($8e553923d06fdb06$var$emailIsSymbol)()))())($8e553923d06fdb06$var$jsonQR);
var $8e553923d06fdb06$var$inputIsSymbol = {
    reflectSymbol: function() {
        return "input";
    }
};
var $8e553923d06fdb06$var$commentIsSymbol = {
    reflectSymbol: function() {
        return "comment";
    }
};
var $8e553923d06fdb06$var$gDecodeJsonCons4 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $8e553923d06fdb06$var$gDecodeJsonCons5 = /* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $8e553923d06fdb06$var$linkIsSymbol = {
    reflectSymbol: function() {
        return "link";
    }
};
var $8e553923d06fdb06$var$decodeArray = /* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons2(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons4(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons5($8e553923d06fdb06$var$keyIsSymbol)()())($8e553923d06fdb06$var$emailIsSymbol)()())($8e553923d06fdb06$var$commentIsSymbol)()())()))(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons1($8e553923d06fdb06$var$linkIsSymbol)()())($8e553923d06fdb06$var$idIsSymbol)()())($8e553923d06fdb06$var$dataIsSymbol)()())($8e553923d06fdb06$var$created_atIsSymbol)()())());
var $8e553923d06fdb06$var$maybeShape = /* #__PURE__ */ $266cd1b01131a218$export$b1354530938ec29c($266cd1b01131a218$export$eac78e45f453a621);
var $8e553923d06fdb06$var$arrayShape = /* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$linkIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$dataIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$emailIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$commentIsSymbol)($8e553923d06fdb06$var$maybeShape)()())())()())($8e553923d06fdb06$var$created_atIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())());
var $8e553923d06fdb06$var$buildMutation2 = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $8e553923d06fdb06$var$rltvCons($8e553923d06fdb06$var$inputIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "RequestSignatureInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons2(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons2(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gEncodeJsonCons($eb7399d322077fcf$export$12b4d820b2ffc726)($8e553923d06fdb06$var$keyIsSymbol)())({
    reflectSymbol: function() {
        return "form_id";
    }
})())($8e553923d06fdb06$var$emailIsSymbol)())($8e553923d06fdb06$var$commentIsSymbol)())())))()())(/* #__PURE__ */ $8e553923d06fdb06$var$rltvfConsOther($8e553923d06fdb06$var$inputIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$7f9db571c154f4a($8e553923d06fdb06$var$decodeArray)($8e553923d06fdb06$var$arrayShape));
var $8e553923d06fdb06$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $8e553923d06fdb06$var$gDecodeJsonCons6 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($81439e1d9c94314f$export$7a3501594e39e6ac));
var $8e553923d06fdb06$var$fieldIsSymbol = {
    reflectSymbol: function() {
        return "field";
    }
};
var $8e553923d06fdb06$var$accessIsSymbol = {
    reflectSymbol: function() {
        return "access";
    }
};
var $8e553923d06fdb06$var$fieldsIsSymbol = {
    reflectSymbol: function() {
        return "fields";
    }
};
var $8e553923d06fdb06$var$defaultIsSymbol = {
    reflectSymbol: function() {
        return "default";
    }
};
var $8e553923d06fdb06$var$gDecodeJsonCons7 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $8e553923d06fdb06$var$gDecodeJsonCons8 = /* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $8e553923d06fdb06$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $8e553923d06fdb06$var$lockIsSymbol = {
    reflectSymbol: function() {
        return "lock";
    }
};
var $8e553923d06fdb06$var$useDefaultIsSymbol = {
    reflectSymbol: function() {
        return "useDefault";
    }
};
var $8e553923d06fdb06$var$saveDefaultIsSymbol = {
    reflectSymbol: function() {
        return "saveDefault";
    }
};
var $8e553923d06fdb06$var$requestIsSymbol = {
    reflectSymbol: function() {
        return "request";
    }
};
var $8e553923d06fdb06$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $8e553923d06fdb06$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $8e553923d06fdb06$var$emailLabelIsSymbol = {
    reflectSymbol: function() {
        return "emailLabel";
    }
};
var $8e553923d06fdb06$var$default_last_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_last_name";
    }
};
var $8e553923d06fdb06$var$default_first_nameIsSymbol = {
    reflectSymbol: function() {
        return "default_first_name";
    }
};
var $8e553923d06fdb06$var$default_emailIsSymbol = {
    reflectSymbol: function() {
        return "default_email";
    }
};
var $8e553923d06fdb06$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $8e553923d06fdb06$var$verificationsIsSymbol = {
    reflectSymbol: function() {
        return "verifications";
    }
};
var $8e553923d06fdb06$var$signaturesIsSymbol = {
    reflectSymbol: function() {
        return "signatures";
    }
};
var $8e553923d06fdb06$var$signature_fieldsIsSymbol = {
    reflectSymbol: function() {
        return "signature_fields";
    }
};
var $8e553923d06fdb06$var$locked_atIsSymbol = {
    reflectSymbol: function() {
        return "locked_at";
    }
};
var $8e553923d06fdb06$var$buildQuery = /* #__PURE__ */ $a40b20519abba0fb$export$d7b58f10109feb02(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f($8e553923d06fdb06$var$rltvCons1)($8e553923d06fdb06$var$rltvfConsOther1)())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons6(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons6(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons1($8e553923d06fdb06$var$fieldIsSymbol)()())($8e553923d06fdb06$var$accessIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($8e553923d06fdb06$var$fieldsIsSymbol)()())($8e553923d06fdb06$var$defaultIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons8($8e553923d06fdb06$var$updateIsSymbol)()())($8e553923d06fdb06$var$lockIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons7(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons8($8e553923d06fdb06$var$useDefaultIsSymbol)()())($8e553923d06fdb06$var$updateIsSymbol)()())($8e553923d06fdb06$var$saveDefaultIsSymbol)()())($8e553923d06fdb06$var$requestIsSymbol)()())($8e553923d06fdb06$var$createIsSymbol)()())()))(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons4(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons4(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons4(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons3(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons(/* #__PURE__ */ $8e553923d06fdb06$var$gDecodeJsonCons5($8e553923d06fdb06$var$relationshipIsSymbol)()())($8e553923d06fdb06$var$labelIsSymbol)()())($8e553923d06fdb06$var$keyIsSymbol)()())($8e553923d06fdb06$var$emailLabelIsSymbol)()())($8e553923d06fdb06$var$default_last_nameIsSymbol)()())($8e553923d06fdb06$var$default_first_nameIsSymbol)()())($8e553923d06fdb06$var$default_emailIsSymbol)()())($8e553923d06fdb06$var$canIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe($8e553923d06fdb06$var$decodeRecord)))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($8e553923d06fdb06$var$decodeArray))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($8e553923d06fdb06$var$verificationsIsSymbol)()())($8e553923d06fdb06$var$signaturesIsSymbol)()())($8e553923d06fdb06$var$signature_fieldsIsSymbol)()())($8e553923d06fdb06$var$locked_atIsSymbol)()())($8e553923d06fdb06$var$canIsSymbol)()())($8e553923d06fdb06$var$accessIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$verificationsIsSymbol)($8e553923d06fdb06$var$arrayShape)()())($8e553923d06fdb06$var$signaturesIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5($8e553923d06fdb06$var$recShape))()())($8e553923d06fdb06$var$signature_fieldsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$relationshipIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$labelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$keyIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$emailLabelIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$default_last_nameIsSymbol)($8e553923d06fdb06$var$maybeShape)()())($8e553923d06fdb06$var$default_first_nameIsSymbol)($8e553923d06fdb06$var$maybeShape)()())($8e553923d06fdb06$var$default_emailIsSymbol)($8e553923d06fdb06$var$maybeShape)()())($8e553923d06fdb06$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$useDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$saveDefaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$requestIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$createIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())()))()())($8e553923d06fdb06$var$locked_atIsSymbol)($8e553923d06fdb06$var$maybeShape)()())($8e553923d06fdb06$var$canIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$updateIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$lockIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())($8e553923d06fdb06$var$accessIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$fieldsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844(/* #__PURE__ */ $8e553923d06fdb06$var$rlhsCons($8e553923d06fdb06$var$fieldIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())($8e553923d06fdb06$var$accessIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())($8e553923d06fdb06$var$defaultIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())())()())()));
var $8e553923d06fdb06$export$84246b0ad9ebbb39 = function(docId) {
    return function(v) {
        return $8e553923d06fdb06$var$buildMutation("signForm")({
            id: docId,
            data: $308f9765feb7633d$export$eb1b128a19ff6c25({
                key: v.key,
                use_default: true
            })
        });
    };
};
var $8e553923d06fdb06$export$bc7262e0df8c91e0 = function(docId) {
    return function(v) {
        return function(v1) {
            return function(v2) {
                return $8e553923d06fdb06$var$buildMutation1("signForm")({
                    id: docId,
                    data: $308f9765feb7633d$export$eb1b128a19ff6c25({
                        key: v.key,
                        first_name: v1.first_name,
                        last_name: v1.last_name,
                        email: v1.email,
                        file: $a40b20519abba0fb$export$c0417fbbb4e0f837(v1.signature),
                        save_default: v2.saveDefault
                    })
                });
            };
        };
    };
};
var $8e553923d06fdb06$export$706aee3fd4ab9a03 = function(reqs) {
    var mapReq = function(v) {
        return $308f9765feb7633d$export$eb1b128a19ff6c25({
            form_id: v.docId,
            email: v.email,
            comment: v.comment,
            key: v.key
        });
    };
    return $8e553923d06fdb06$var$buildMutation2("requestSignature")({
        input: $8e553923d06fdb06$var$map(mapReq)(reqs)
    });
};
var $8e553923d06fdb06$export$747fafd1e4d82899 = function(docId) {
    return $a40b20519abba0fb$export$bc1f9bac519c56f6("GetDocument")($8e553923d06fdb06$var$buildQuery("form")({
        id: docId
    }));
};

















// Generated by purs version 0.15.16







































// Generated by purs version 0.15.16






























var $356f5ce902fa042d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $356f5ce902fa042d$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $356f5ce902fa042d$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $356f5ce902fa042d$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($356f5ce902fa042d$var$eqRNTY);
var $356f5ce902fa042d$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $356f5ce902fa042d$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $356f5ce902fa042d$var$li = /* #__PURE__ */ $3eadc1b959dd1120$export$19caeaf7d9d84644($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $356f5ce902fa042d$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $356f5ce902fa042d$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404($356f5ce902fa042d$var$ordRNTY);
var $356f5ce902fa042d$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$span$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$e78712c0da02b27f($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$li$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$819c065a8270721a($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $356f5ce902fa042d$var$ul$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$cc03685c1f5dc816($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$toUnfoldable = /* #__PURE__ */ $3d4fd987da5242ff$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $356f5ce902fa042d$var$ul = /* #__PURE__ */ $3eadc1b959dd1120$export$b5023c870cb34848($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e()(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)()({
    reflectSymbol: function() {
        return "studentId";
    }
})($356f5ce902fa042d$var$eqRNTY))()({
    reflectSymbol: function() {
        return "formId";
    }
})($356f5ce902fa042d$var$eqRNTY))()({
    reflectSymbol: function() {
        return "documentId";
    }
})(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($356f5ce902fa042d$var$eqRNTY))));
var $356f5ce902fa042d$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($356f5ce902fa042d$var$eqRNTY);
var $356f5ce902fa042d$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($356f5ce902fa042d$var$ordRNTY);
var $356f5ce902fa042d$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $356f5ce902fa042d$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$summary = /* #__PURE__ */ $3eadc1b959dd1120$export$9a2dbef7a17e2e58($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($356f5ce902fa042d$var$ordRNTY);
var $356f5ce902fa042d$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $356f5ce902fa042d$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$var$fromFoldable1 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($356f5ce902fa042d$var$ordRNTY)($78c799cba34fcb8d$export$92659ee1fc91a075);
var $356f5ce902fa042d$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $356f5ce902fa042d$var$header = /* #__PURE__ */ $3eadc1b959dd1120$export$38e42c68cf43b5d4($356f5ce902fa042d$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $356f5ce902fa042d$export$a80f920dd4c867c2 = /* #__PURE__ */ function() {
    function UIStateChange(value0) {
        this.value0 = value0;
    }
    UIStateChange.create = function(value0) {
        return new UIStateChange(value0);
    };
    return UIStateChange;
}();
var $356f5ce902fa042d$export$d25f9f533b57ed2 = /* #__PURE__ */ function() {
    function JumpToForm(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    JumpToForm.create = function(value0) {
        return function(value1) {
            return new JumpToForm(value0, value1);
        };
    };
    return JumpToForm;
}();
var $356f5ce902fa042d$var$ExistingDocument = /* #__PURE__ */ function() {
    function ExistingDocument(value0) {
        this.value0 = value0;
    }
    ExistingDocument.create = function(value0) {
        return new ExistingDocument(value0);
    };
    return ExistingDocument;
}();
var $356f5ce902fa042d$var$NewDocument = /* #__PURE__ */ function() {
    function NewDocument(value0) {
        this.value0 = value0;
    }
    NewDocument.create = function(value0) {
        return new NewDocument(value0);
    };
    return NewDocument;
}();
var $356f5ce902fa042d$var$itemLookup = function(student) {
    return function(v) {
        if (v instanceof $356f5ce902fa042d$var$ExistingDocument) return {
            studentId: v.value0.student.id,
            formId: v.value0.form_type.id,
            documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.id)
        };
        if (v instanceof $356f5ce902fa042d$var$NewDocument) return {
            studentId: student.id,
            formId: v.value0.id,
            documentId: $06733ae99ed4f534$export$bebe9059409a0d04.value
        };
        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 259, column 22 - line 269, column 10): " + [
            v.constructor.name
        ]);
    };
};
var $356f5ce902fa042d$var$itemLabel = function(v) {
    if (v instanceof $356f5ce902fa042d$var$ExistingDocument) return v.value0.form_type.label;
    if (v instanceof $356f5ce902fa042d$var$NewDocument) return v.value0.label;
    throw new Error("Failed pattern match at Steps.WorkQueue.View (line 277, column 13 - line 279, column 35): " + [
        v.constructor.name
    ]);
};
var $356f5ce902fa042d$var$itemKey = function(student) {
    return function(v) {
        if (v instanceof $356f5ce902fa042d$var$ExistingDocument) return "existing:" + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0.id);
        if (v instanceof $356f5ce902fa042d$var$NewDocument) return "new:" + ($308f9765feb7633d$export$a1b0f5347d2470b(student.id) + (":" + $308f9765feb7633d$export$a1b0f5347d2470b(v.value0.id)));
        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 282, column 19 - line 284, column 79): " + [
            v.constructor.name
        ]);
    };
};
var $356f5ce902fa042d$var$itemFormId = function(v) {
    if (v instanceof $356f5ce902fa042d$var$ExistingDocument) return v.value0.form_type.id;
    if (v instanceof $356f5ce902fa042d$var$NewDocument) return v.value0.id;
    throw new Error("Failed pattern match at Steps.WorkQueue.View (line 272, column 14 - line 274, column 32): " + [
        v.constructor.name
    ]);
};
var $356f5ce902fa042d$var$renderStudentDetails = function(preservedQuery) {
    return function(state) {
        return function(ui) {
            return function(cache) {
                return function(student) {
                    var studentForms = function() {
                        var newForms = $356f5ce902fa042d$var$map($356f5ce902fa042d$var$NewDocument.create)($356f5ce902fa042d$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(state.forms)));
                        var existingDocs = $356f5ce902fa042d$var$map($356f5ce902fa042d$var$ExistingDocument.create)($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(d) {
                            return $356f5ce902fa042d$var$eq(d.student.id)(student.id);
                        })(state.editDocs));
                        return $356f5ce902fa042d$var$append1(existingDocs)(newForms);
                    }();
                    var renderStudentNoForms = $356f5ce902fa042d$var$li([
                        $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-student no-forms")
                    ])([
                        $356f5ce902fa042d$var$text($b05aa108190eac05$export$d50a55988135660c(cache.account)(student))
                    ]);
                    var renderStudentForm = function(item) {
                        var routeDocIds = $356f5ce902fa042d$var$nub($356f5ce902fa042d$var$append1($356f5ce902fa042d$var$map(function(v) {
                            return v.id;
                        })(state.editDocs))($356f5ce902fa042d$var$map(function(v) {
                            return v.id;
                        })($356f5ce902fa042d$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(state.documents)))));
                        var sectionHref = function(currentItem) {
                            return function(sectionId) {
                                if (currentItem instanceof $356f5ce902fa042d$var$ExistingDocument) return $daa993e9fe4182d9$export$f6821e37299eed8e(new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
                                    preservedQuery: preservedQuery,
                                    activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(currentItem.value0.id),
                                    docs: routeDocIds,
                                    section: new $daa993e9fe4182d9$export$28a5869e6b717ab(sectionId)
                                }));
                                if (currentItem instanceof $356f5ce902fa042d$var$NewDocument) return $daa993e9fe4182d9$export$6d84eebdb90be73d(new $06733ae99ed4f534$export$8a67b48435b5d073(sectionId));
                                throw new Error("Failed pattern match at Steps.WorkQueue.View (line 238, column 45 - line 247, column 54): " + [
                                    currentItem.constructor.name
                                ]);
                            };
                        };
                        var renderFormLabel = function(label) {
                            return function(locked) {
                                return [
                                    $356f5ce902fa042d$var$span([
                                        $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-form-label")
                                    ])($356f5ce902fa042d$var$append1(function() {
                                        if (locked) return [
                                            $356f5ce902fa042d$var$span([
                                                $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-lock-indicator")
                                            ])([])
                                        ];
                                        return [];
                                    }())([
                                        $356f5ce902fa042d$var$span$prime([
                                            $356f5ce902fa042d$var$text(label)
                                        ])
                                    ]))
                                ];
                            };
                        };
                        var lookup1 = $356f5ce902fa042d$var$itemLookup(student)(item);
                        var renderSection = function(tree) {
                            var node = $a7cd7990ff17745a$export$5fd5031fecdacec3(tree);
                            return $356f5ce902fa042d$var$li$prime([
                                $356f5ce902fa042d$var$a([
                                    $356f5ce902fa042d$var$map1($356f5ce902fa042d$export$d25f9f533b57ed2.create({
                                        lookup: lookup1,
                                        section: new $06733ae99ed4f534$export$8a67b48435b5d073(node.id)
                                    }))($fc1df90f0e252058$export$1d5a917feb871989),
                                    $fc1df90f0e252058$export$8f51af5840e0602a(sectionHref(item)(node.id))
                                ])([
                                    $356f5ce902fa042d$var$text(node.workQueueLabel)
                                ]),
                                $356f5ce902fa042d$var$ul$prime($356f5ce902fa042d$var$map(renderSection)($356f5ce902fa042d$var$toUnfoldable($a7cd7990ff17745a$export$c01875f616615628(tree))))
                            ]);
                        };
                        var renderSections = function(form$prime) {
                            return $356f5ce902fa042d$var$ul([
                                $fc1df90f0e252058$export$2913c0c0b5623090("student-form-section")
                            ])($356f5ce902fa042d$var$map(renderSection)(form$prime.sections));
                        };
                        var isLocked = $740d96ccf08cc464$export$b0d0217938b59855(state)(lookup1);
                        var isCurrentWorkQueueItem = function(candidate) {
                            if (state.currentDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                            if (state.currentDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                var $97 = $356f5ce902fa042d$var$eq1(state.currentDoc.value0)(candidate);
                                if ($97) return true;
                                if (state.currentDoc.value0.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$export$4967676db1b89293(candidate.documentId) && !$356f5ce902fa042d$var$elem(state.currentDoc.value0.documentId.value0)($356f5ce902fa042d$var$map(function(v) {
                                    return v.id;
                                })(state.editDocs)) && $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(doc) {
                                    return $356f5ce902fa042d$var$eq(doc.student.id)(candidate.studentId) && $356f5ce902fa042d$var$eq(doc.formId)(candidate.formId);
                                })($740d96ccf08cc464$export$30606e16463b30d9(state)(state.currentDoc.value0));
                                if (state.currentDoc.value0.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                                throw new Error("Failed pattern match at Steps.WorkQueue.View (line 161, column 22 - line 168, column 37): " + [
                                    state.currentDoc.value0.documentId.constructor.name
                                ]);
                            }
                            throw new Error("Failed pattern match at Steps.WorkQueue.View (line 157, column 44 - line 168, column 37): " + [
                                state.currentDoc.constructor.name
                            ]);
                        };
                        var isCurrent = isCurrentWorkQueueItem(lookup1);
                        var existingDocumentHref = function(recentForm) {
                            return $daa993e9fe4182d9$export$f6821e37299eed8e(new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
                                preservedQuery: preservedQuery,
                                activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(recentForm.id),
                                docs: routeDocIds,
                                section: $daa993e9fe4182d9$export$37a45811bf45ea95.value
                            }));
                        };
                        var formAnchor = function(handleJump) {
                            if (item instanceof $356f5ce902fa042d$var$ExistingDocument) return $356f5ce902fa042d$var$a($356f5ce902fa042d$var$append1([
                                $fc1df90f0e252058$export$df61b30b684217c0($356f5ce902fa042d$var$itemKey(student)(item) + (":" + function() {
                                    if (isLocked) return "locked";
                                    return "unlocked";
                                }())),
                                $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-form-link" + function() {
                                    if (isCurrent) return " workqueue-selected";
                                    return "";
                                }()),
                                $fc1df90f0e252058$export$8f51af5840e0602a(existingDocumentHref(item.value0))
                            ])(function() {
                                if (handleJump) return [
                                    $356f5ce902fa042d$var$map1($356f5ce902fa042d$export$d25f9f533b57ed2.create({
                                        lookup: lookup1,
                                        section: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                    }))($fc1df90f0e252058$export$1d5a917feb871989)
                                ];
                                return [];
                            }()))(renderFormLabel($356f5ce902fa042d$var$itemLabel(item))(isLocked));
                            if (item instanceof $356f5ce902fa042d$var$NewDocument) return $356f5ce902fa042d$var$button($356f5ce902fa042d$var$append1([
                                $fc1df90f0e252058$export$df61b30b684217c0($356f5ce902fa042d$var$itemKey(student)(item) + (":" + function() {
                                    if (isLocked) return "locked";
                                    return "unlocked";
                                }())),
                                $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-form-link" + function() {
                                    if (isCurrent) return " workqueue-selected";
                                    return "";
                                }()),
                                $fc1df90f0e252058$export$1741e49665a9c8e8("button")
                            ])(function() {
                                if (handleJump) return [
                                    $356f5ce902fa042d$var$map1($356f5ce902fa042d$export$d25f9f533b57ed2.create({
                                        lookup: lookup1,
                                        section: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                    }))($fc1df90f0e252058$export$1d5a917feb871989)
                                ];
                                return [];
                            }()))(renderFormLabel($356f5ce902fa042d$var$itemLabel(item))(isLocked));
                            throw new Error("Failed pattern match at Steps.WorkQueue.View (line 177, column 33 - line 204, column 64): " + [
                                item.constructor.name
                            ]);
                        };
                        var cachedFormMaybe = $356f5ce902fa042d$var$lookup($356f5ce902fa042d$var$itemFormId(item))(cache.formCache);
                        var liAttrs = $356f5ce902fa042d$var$append1([
                            $fc1df90f0e252058$export$df61b30b684217c0($356f5ce902fa042d$var$itemKey(student)(item))
                        ])(function() {
                            var $110 = $06733ae99ed4f534$export$4967676db1b89293(cachedFormMaybe);
                            if ($110) return [
                                $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-form-no-sections")
                            ];
                            return [];
                        }());
                        return $356f5ce902fa042d$var$li(liAttrs)([
                            function() {
                                if (cachedFormMaybe instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                                    var $112 = $356f5ce902fa042d$var$length(cachedFormMaybe.value0.sections) > 0;
                                    if ($112) return $356f5ce902fa042d$var$details([
                                        $fc1df90f0e252058$export$3ce6949f20cea765(isCurrent)
                                    ])([
                                        $356f5ce902fa042d$var$summary([
                                            $fc1df90f0e252058$export$2913c0c0b5623090("summary-form summary-form-sections")
                                        ])([
                                            formAnchor(true)
                                        ]),
                                        renderSections(cachedFormMaybe.value0)
                                    ]);
                                    return formAnchor(true);
                                }
                                if (cachedFormMaybe instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return formAnchor(true);
                                throw new Error("Failed pattern match at Steps.WorkQueue.View (line 139, column 11 - line 148, column 39): " + [
                                    cachedFormMaybe.constructor.name
                                ]);
                            }()
                        ]);
                    };
                    var renderStudentForms = $356f5ce902fa042d$var$ul([
                        $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-student-forms")
                    ])($356f5ce902fa042d$var$map(renderStudentForm)(studentForms));
                    var openProp = function(v) {
                        if (v) return [
                            $fc1df90f0e252058$export$3ce6949f20cea765(true)
                        ];
                        if (!v) return [];
                        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 134, column 5 - line 134, column 36): " + [
                            v.constructor.name
                        ]);
                    };
                    var isOpen = function() {
                        var v = $356f5ce902fa042d$var$lookup(student.id)(ui.expandedStudents);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $288f947f09d2f062$export$aec14294028030b8) return true;
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0 instanceof $288f947f09d2f062$export$d47910e24fffa8c2) return false;
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(c) {
                            return $356f5ce902fa042d$var$eq(c.studentId)(student.id);
                        })(state.currentDoc);
                        throw new Error("Failed pattern match at Steps.WorkQueue.View (line 129, column 14 - line 132, column 82): " + [
                            v.constructor.name
                        ]);
                    }();
                    var toggleExpanded = $356f5ce902fa042d$var$insert(student.id)(function() {
                        if (isOpen) return $288f947f09d2f062$export$d47910e24fffa8c2.value;
                        return $288f947f09d2f062$export$aec14294028030b8.value;
                    }())(ui.expandedStudents);
                    var renderStudentAndForms = $356f5ce902fa042d$var$li([
                        $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-student")
                    ])([
                        $356f5ce902fa042d$var$details($356f5ce902fa042d$var$append1([
                            $fc1df90f0e252058$export$df61b30b684217c0("student-details-" + ($308f9765feb7633d$export$a1b0f5347d2470b(student.id) + ("-" + function() {
                                if (isOpen) return "open";
                                return "closed";
                            }())))
                        ])(openProp(isOpen)))([
                            $356f5ce902fa042d$var$summary([
                                $356f5ce902fa042d$var$voidRight(new $356f5ce902fa042d$export$a80f920dd4c867c2({
                                    search: ui.search,
                                    teacher: ui.teacher,
                                    semester: ui.semester,
                                    expandedStudents: toggleExpanded
                                }))($fc1df90f0e252058$export$1d5a917feb871989),
                                $fc1df90f0e252058$export$2913c0c0b5623090("summary-student")
                            ])([
                                $356f5ce902fa042d$var$text($b05aa108190eac05$export$d50a55988135660c(cache.account)(student))
                            ]),
                            renderStudentForms
                        ])
                    ]);
                    var $120 = $356f5ce902fa042d$var$length(studentForms) <= 0;
                    if ($120) return renderStudentNoForms;
                    return renderStudentAndForms;
                };
            };
        };
    };
};
var $356f5ce902fa042d$var$renderStudentList = function(preservedQuery) {
    return function(state) {
        return function(ui) {
            return function(cache) {
                return $356f5ce902fa042d$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("workqueue-students")
                ])($356f5ce902fa042d$var$map($356f5ce902fa042d$var$renderStudentDetails(preservedQuery)(state)(ui)(cache))($356f5ce902fa042d$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(state.students))));
            };
        };
    };
};
var $356f5ce902fa042d$export$fa5a12c391dc617d = function(preservedQuery) {
    return function(state) {
        return function(ui) {
            return function(cache) {
                var expansionForAll = function(expansion) {
                    return $356f5ce902fa042d$var$fromFoldable1($356f5ce902fa042d$var$map2(function(student) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(student.id, expansion);
                    })($f264ceec36a478ad$export$7693e0a1b9351086(state.students)));
                };
                var expandBtns = $356f5ce902fa042d$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("expand-collapse-buttons")
                ])([
                    $356f5ce902fa042d$var$button([
                        $356f5ce902fa042d$var$voidRight(new $356f5ce902fa042d$export$a80f920dd4c867c2({
                            search: ui.search,
                            teacher: ui.teacher,
                            semester: ui.semester,
                            expandedStudents: expansionForAll($288f947f09d2f062$export$aec14294028030b8.value)
                        }))($fc1df90f0e252058$export$1d5a917feb871989),
                        $fc1df90f0e252058$export$2913c0c0b5623090("expand-all")
                    ])([
                        $356f5ce902fa042d$var$text("Expand all")
                    ]),
                    $356f5ce902fa042d$var$button([
                        $356f5ce902fa042d$var$voidRight(new $356f5ce902fa042d$export$a80f920dd4c867c2({
                            search: ui.search,
                            teacher: ui.teacher,
                            semester: ui.semester,
                            expandedStudents: expansionForAll($288f947f09d2f062$export$d47910e24fffa8c2.value)
                        }))($fc1df90f0e252058$export$1d5a917feb871989),
                        $fc1df90f0e252058$export$2913c0c0b5623090("collapse-all")
                    ])([
                        $356f5ce902fa042d$var$text("Collapse all")
                    ])
                ]);
                return $356f5ce902fa042d$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("workqueue")
                ])($356f5ce902fa042d$var$append1([
                    $356f5ce902fa042d$var$renderStudentList(preservedQuery)(state)(ui)(cache)
                ])(function() {
                    var $121 = $6be45a9e147fc393$export$b0442b57b5d77489(state);
                    if ($121) return [];
                    return [
                        expandBtns
                    ];
                }()));
            };
        };
    };
};
var $356f5ce902fa042d$export$c63886ee1a09a6cb = /* #__PURE__ */ $356f5ce902fa042d$export$fa5a12c391dc617d(/* #__PURE__ */ $daa993e9fe4182d9$export$11c97f589579967b(""));
var $356f5ce902fa042d$export$b1ee3c35b6a94213 = function(state) {
    return function(ui) {
        return function(cache) {
            return $356f5ce902fa042d$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-container")
            ])([
                $356f5ce902fa042d$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("page-header")
                ])([
                    $356f5ce902fa042d$var$header([
                        $fc1df90f0e252058$export$2913c0c0b5623090("page-heading")
                    ])([
                        $356f5ce902fa042d$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("loading"))
                    ])
                ]),
                $9c13a1c3d948adb8$export$be9e2feb4e35335b($356f5ce902fa042d$export$c63886ee1a09a6cb(state)(ui)(cache)),
                $b5330906fcd65ffd$export$d558900b1478007d
            ]);
        };
    };
};






// Generated by purs version 0.15.16










var $c1518ffd015b44e8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c1518ffd015b44e8$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $c1518ffd015b44e8$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($c1518ffd015b44e8$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1518ffd015b44e8$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($c1518ffd015b44e8$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1518ffd015b44e8$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $c1518ffd015b44e8$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($c1518ffd015b44e8$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c1518ffd015b44e8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $c1518ffd015b44e8$export$ca565b3ecdd6c5ae = function(state) {
    var label = $06733ae99ed4f534$export$43db023a260c5e9f($c3328e54cdf5154c$export$5a1a8430df9521e("none"))($c1518ffd015b44e8$var$map(function(v) {
        return v.label;
    })($7178b396566f5a79$export$127d1aaaa65102b1(state)));
    return $c1518ffd015b44e8$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("hidden-select")
    ])([
        $c1518ffd015b44e8$var$p$prime([
            $c1518ffd015b44e8$var$text(label)
        ])
    ]);
};
var $c1518ffd015b44e8$export$5f43cd3c5edf858b = function(state) {
    var label = $06733ae99ed4f534$export$43db023a260c5e9f($c3328e54cdf5154c$export$5a1a8430df9521e("none"))($c1518ffd015b44e8$var$map(function(v) {
        return v.label;
    })($7178b396566f5a79$export$127d1aaaa65102b1(state)));
    return $c1518ffd015b44e8$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("hidden-select")
    ])([
        $c1518ffd015b44e8$var$p$prime([
            $c1518ffd015b44e8$var$text(label)
        ]),
        $c1518ffd015b44e8$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("hidden-select-edit-button"),
            $fc1df90f0e252058$export$683472f6198a076e(true),
            $fc1df90f0e252058$export$1741e49665a9c8e8("button")
        ])([
            $c1518ffd015b44e8$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("edit"))
        ])
    ]);
};
var $c1518ffd015b44e8$export$d167388450b383cf = function(state) {
    var label = $06733ae99ed4f534$export$43db023a260c5e9f($c3328e54cdf5154c$export$5a1a8430df9521e("none"))($c1518ffd015b44e8$var$map(function(v) {
        return v.label;
    })($7178b396566f5a79$export$127d1aaaa65102b1(state)));
    return $c1518ffd015b44e8$var$bind($c1518ffd015b44e8$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("hidden-select")
    ])([
        $c1518ffd015b44e8$var$p$prime([
            $c1518ffd015b44e8$var$text(label)
        ]),
        $c1518ffd015b44e8$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("hidden-select-edit-button"),
            $fc1df90f0e252058$export$1d5a917feb871989
        ])([
            $c1518ffd015b44e8$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("edit"))
        ])
    ]))(function() {
        return $7178b396566f5a79$export$54b124386ef5abe3(state);
    });
};





var $85206166a57f2888$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $85206166a57f2888$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $85206166a57f2888$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $85206166a57f2888$var$selectAll$prime = /* #__PURE__ */ $f264ceec36a478ad$export$2f60db41f2af055($85206166a57f2888$var$ordRNTY)($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $85206166a57f2888$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $85206166a57f2888$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $85206166a57f2888$var$selectAllCheckbox$prime = /* #__PURE__ */ $f264ceec36a478ad$export$1ee36b6d1ce76362($85206166a57f2888$var$ordRNTY)($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $85206166a57f2888$var$select$prime = /* #__PURE__ */ $f264ceec36a478ad$export$8b371b7a43624610($85206166a57f2888$var$ordRNTY);
var $85206166a57f2888$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $85206166a57f2888$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $85206166a57f2888$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $85206166a57f2888$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $85206166a57f2888$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $85206166a57f2888$var$changePage = /* #__PURE__ */ $b5f6b40b8f63b732$export$af04929cb32c4bb7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099))(/* #__PURE__ */ $85206166a57f2888$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $85206166a57f2888$var$gDecodeJsonCons(/* #__PURE__ */ $85206166a57f2888$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($85206166a57f2888$var$nameIsSymbol)()())({
    reflectSymbol: function() {
        return "color";
    }
})()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)({
    reflectSymbol: function() {
        return "tags";
    }
})()())({
    reflectSymbol: function() {
        return "preferred_name";
    }
})()())($85206166a57f2888$var$nameIsSymbol)()())({
    reflectSymbol: function() {
        return "last_imported_at";
    }
})()())({
    reflectSymbol: function() {
        return "id";
    }
})()())());
var $85206166a57f2888$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $85206166a57f2888$var$selectionCheckbox = /* #__PURE__ */ $f264ceec36a478ad$export$21f1fa92f77cf950($85206166a57f2888$var$ordRNTY);
var $85206166a57f2888$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $85206166a57f2888$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $85206166a57f2888$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $85206166a57f2888$var$section = /* #__PURE__ */ $3eadc1b959dd1120$export$fe2e36411d703b3d($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $85206166a57f2888$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $85206166a57f2888$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $85206166a57f2888$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $85206166a57f2888$var$isSelected1 = /* #__PURE__ */ $f264ceec36a478ad$export$e4d153b3e021fb47($85206166a57f2888$var$ordRNTY);
var $85206166a57f2888$var$deselect1 = /* #__PURE__ */ $f264ceec36a478ad$export$5bb86370ea51314a($85206166a57f2888$var$ordRNTY);
var $85206166a57f2888$var$voidRight1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $85206166a57f2888$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $85206166a57f2888$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $85206166a57f2888$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $85206166a57f2888$var$runGraphQL1 = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($aa35c333414e4a9b$export$4b7880dae9bb4312);
var $85206166a57f2888$var$pure2 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $85206166a57f2888$var$errorModalWidget = /* #__PURE__ */ $035405231d3ae317$export$b72a0a8a910c4215($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $85206166a57f2888$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($02eacf321b2a2128$export$5315b7c1b1d9e384);
var $85206166a57f2888$var$isEmpty = /* #__PURE__ */ $f264ceec36a478ad$export$dd1bc94b04021eeb($85206166a57f2888$var$ordRNTY);
var $85206166a57f2888$var$header = /* #__PURE__ */ $3eadc1b959dd1120$export$38e42c68cf43b5d4($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($85206166a57f2888$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $85206166a57f2888$var$areAllSelected1 = /* #__PURE__ */ $f264ceec36a478ad$export$b52fcdc078a891ae($85206166a57f2888$var$ordRNTY)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $85206166a57f2888$export$ca704cb31d74b6f6 = /* #__PURE__ */ function() {
    function SNormal() {}
    SNormal.value = new SNormal();
    return SNormal;
}();
var $85206166a57f2888$export$cf8a06570d3235e9 = /* #__PURE__ */ function() {
    function SLoading() {}
    SLoading.value = new SLoading();
    return SLoading;
}();
var $85206166a57f2888$export$5cac6887c54fd40d = /* #__PURE__ */ function() {
    function SError(value0) {
        this.value0 = value0;
    }
    SError.create = function(value0) {
        return new SError(value0);
    };
    return SError;
}();
var $85206166a57f2888$export$5737e0a77055e89d = /* #__PURE__ */ function() {
    function StateChange(value0) {
        this.value0 = value0;
    }
    StateChange.create = function(value0) {
        return new StateChange(value0);
    };
    return StateChange;
}();
var $85206166a57f2888$export$90368da438a1001a = /* #__PURE__ */ function() {
    function WorkQA(value0) {
        this.value0 = value0;
    }
    WorkQA.create = function(value0) {
        return new WorkQA(value0);
    };
    return WorkQA;
}();
var $85206166a57f2888$export$8750abbd34e770e0 = /* #__PURE__ */ function() {
    function QueueChanged(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    QueueChanged.create = function(value0) {
        return function(value1) {
            return new QueueChanged(value0, value1);
        };
    };
    return QueueChanged;
}();
var $85206166a57f2888$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $85206166a57f2888$export$848c9b7ead0df967 = /* #__PURE__ */ function() {
    function Cancel() {}
    Cancel.value = new Cancel();
    return Cancel;
}();
var $85206166a57f2888$export$f883e605db67eacf = /* #__PURE__ */ function() {
    function Export() {}
    Export.value = new Export();
    return Export;
}();
var $85206166a57f2888$export$e282f65e34cf731b = /* #__PURE__ */ function() {
    function ChangeSearch(value0) {
        this.value0 = value0;
    }
    ChangeSearch.create = function(value0) {
        return new ChangeSearch(value0);
    };
    return ChangeSearch;
}();
var $85206166a57f2888$export$d6d899291526e2a0 = /* #__PURE__ */ function() {
    function ChangePage(value0) {
        this.value0 = value0;
    }
    ChangePage.create = function(value0) {
        return new ChangePage(value0);
    };
    return ChangePage;
}();
var $85206166a57f2888$export$27f504e7b26f1bd2 = /* #__PURE__ */ function() {
    function QueryResult(value0) {
        this.value0 = value0;
    }
    QueryResult.create = function(value0) {
        return new QueryResult(value0);
    };
    return QueryResult;
}();
var $85206166a57f2888$export$80a9e884c522b8c3 = /* #__PURE__ */ function() {
    function QueryFailed(value0) {
        this.value0 = value0;
    }
    QueryFailed.create = function(value0) {
        return new QueryFailed(value0);
    };
    return QueryFailed;
}();
var $85206166a57f2888$export$91e46f7d7a03a319 = function(page) {
    return function(state) {
        return {
            students: state.students,
            search: state.search,
            status: state.status,
            account: state.account,
            msg: state.msg,
            page: new $06733ae99ed4f534$export$8a67b48435b5d073(page)
        };
    };
};
var $85206166a57f2888$export$4fe590cd92d72f75 = /* #__PURE__ */ function() {
    var $205 = $ea3eb84de0acf574$export$b7d5d9bb9ff52072($85206166a57f2888$var$ordRNTY)($4fe7b6acfba7f29f$export$e97014618a7eb593);
    var $206 = $85206166a57f2888$var$map(function(s) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(s.id, s);
    });
    return function($207) {
        return $205($206($207));
    };
}();
var $85206166a57f2888$export$c1d995f1207bf7bc = function(workQueueState) {
    return function(workQueueUi) {
        return function(teacher) {
            return new $85206166a57f2888$export$8750abbd34e770e0({
                forms: workQueueState.forms,
                students: workQueueState.students,
                documents: workQueueState.documents,
                editDocs: workQueueState.editDocs,
                currentDoc: workQueueState.currentDoc,
                semester: workQueueState.semester,
                teacher: $85206166a57f2888$var$map1(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(teacher))
            }, {
                expandedStudents: workQueueUi.expandedStudents,
                search: workQueueUi.search,
                semester: workQueueUi.semester,
                teacher: teacher
            });
        };
    };
};
var $85206166a57f2888$export$ffb2fc0d0be923d2 = function(workQueueState) {
    return function(workQueueUi) {
        return function(semester) {
            return new $85206166a57f2888$export$8750abbd34e770e0({
                forms: workQueueState.forms,
                students: workQueueState.students,
                documents: workQueueState.documents,
                editDocs: workQueueState.editDocs,
                currentDoc: workQueueState.currentDoc,
                teacher: workQueueState.teacher,
                semester: $85206166a57f2888$var$map1(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(semester))
            }, {
                expandedStudents: workQueueUi.expandedStudents,
                search: workQueueUi.search,
                teacher: workQueueUi.teacher,
                semester: semester
            });
        };
    };
};
var $85206166a57f2888$export$1fdbd323b01c36e4 = function(v) {
    return function(v1) {
        if (v1.page instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            page: v1.page,
            search: v1.search,
            status: v1.status,
            account: v1.account,
            msg: v1.msg,
            students: $85206166a57f2888$var$selectAll$prime($b5f6b40b8f63b732$export$f27fff4bf988e19(v1.page.value0))(v1.students)(v)
        };
        if (v1.page instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v1;
        throw new Error("Failed pattern match at Form.StudentSelect (line 98, column 1 - line 98, column 70): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $85206166a57f2888$export$c536e5a7360f2cb5 = function(val) {
    return $85206166a57f2888$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("student-sel-check")
    ])([
        $fc8e139dfeeff88c$export$344f17102956e4bc("select-all")($c3328e54cdf5154c$export$5a1a8430df9521e("select-all"))(val)
    ]);
};
var $85206166a57f2888$export$700abf7afcd092cb = function(v) {
    if (v.page instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $85206166a57f2888$var$map2(function(v1) {
        return {
            account: v.account,
            msg: v.msg,
            page: v.page,
            search: v.search,
            status: v.status,
            students: v1
        };
    })($85206166a57f2888$var$selectAllCheckbox$prime($b5f6b40b8f63b732$export$f27fff4bf988e19(v.page.value0))($85206166a57f2888$export$c536e5a7360f2cb5)(v.students));
    if (v.page instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $9c13a1c3d948adb8$export$be9e2feb4e35335b($85206166a57f2888$export$c536e5a7360f2cb5(false));
    throw new Error("Failed pattern match at Form.StudentSelect (line 338, column 1 - line 338, column 71): " + [
        v.constructor.name
    ]);
};
var $85206166a57f2888$export$2e6c959c16ff56b8 = function(student) {
    return function(state) {
        return {
            page: state.page,
            search: state.search,
            status: state.status,
            account: state.account,
            msg: state.msg,
            students: $85206166a57f2888$var$select$prime(student)(state.students)
        };
    };
};
var $85206166a57f2888$export$b61e0a56cf0d5dff = function(state) {
    return $85206166a57f2888$var$bind($85206166a57f2888$var$runGraphQL($b05aa108190eac05$export$88aef09b2a474163($6415e24f7cd3b8e1$export$4bb0f1a01491086d(state.search))))(function(result) {
        if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure(new $85206166a57f2888$export$80a9e884c522b8c3(result.value0));
        if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$var$pure(new $85206166a57f2888$export$27f504e7b26f1bd2(result.value0));
        throw new Error("Failed pattern match at Form.StudentSelect (line 290, column 5 - line 292, column 46): " + [
            result.constructor.name
        ]);
    });
};
var $85206166a57f2888$export$a6b2e7152efe85b9 = function(v) {
    return function(v1) {
        if (v.page instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $85206166a57f2888$var$bind($85206166a57f2888$var$changePage(v1)(v.page.value0))(function(result) {
            if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure(new $85206166a57f2888$export$80a9e884c522b8c3(result.value0));
            if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$var$pure(new $85206166a57f2888$export$27f504e7b26f1bd2(result.value0));
            throw new Error("Failed pattern match at Form.StudentSelect (line 297, column 5 - line 299, column 49): " + [
                result.constructor.name
            ]);
        });
        return $85206166a57f2888$var$pure(new $85206166a57f2888$export$80a9e884c522b8c3(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Attempted to change page when no page was loaded.")));
    };
};
var $85206166a57f2888$export$6dafb50cab07c86c = function(v) {
    var renderTag = function(v1) {
        return $85206166a57f2888$var$span([
            $fc1df90f0e252058$export$2913c0c0b5623090("student-tag"),
            $fc1df90f0e252058$export$1d567c320f4763bc({
                backgroundColor: v1.color
            })
        ])([
            $85206166a57f2888$var$text(v1.name)
        ]);
    };
    return $85206166a57f2888$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("student-tags")
    ])($85206166a57f2888$var$map(renderTag)(v.tags));
};
var $85206166a57f2888$export$d7e0e2a2226f05f3 = function(student) {
    return function(state) {
        var name = $b05aa108190eac05$export$d50a55988135660c(state.account)(student);
        return $85206166a57f2888$var$map2(function(v) {
            return {
                account: state.account,
                msg: state.msg,
                page: state.page,
                search: state.search,
                status: state.status,
                students: v
            };
        })($85206166a57f2888$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("student-sel-check")
        ])([
            $85206166a57f2888$var$selectionCheckbox(student.id)(student)($fc8e139dfeeff88c$export$344f17102956e4bc($308f9765feb7633d$export$a1b0f5347d2470b(student.id))(name))(state.students),
            $85206166a57f2888$export$6dafb50cab07c86c($b05aa108190eac05$export$672767f79e173783(student))
        ]));
    };
};
var $85206166a57f2888$export$88a03ce95e104f9d = function(v) {
    if (v.page instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $b5330906fcd65ffd$export$d558900b1478007d;
    if (v.page instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $fc8c1182ec2aefec$export$f24224f1c91d8156($b5f6b40b8f63b732$export$f27fff4bf988e19(v.page.value0)) > 0) {
        var studentChecks = $85206166a57f2888$var$map(function(st) {
            return $85206166a57f2888$export$d7e0e2a2226f05f3(st)(v);
        })($b5f6b40b8f63b732$export$f27fff4bf988e19(v.page.value0));
        var pager = $85206166a57f2888$var$map2($85206166a57f2888$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($85206166a57f2888$export$d6d899291526e2a0.create))($c1e04b9648c3de60$export$dbddd5d79461a47c(v.page.value0));
        var checkboxes = $396c4c3d9e7fae3c$export$8327ebbef2a0ba76($85206166a57f2888$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($85206166a57f2888$export$700abf7afcd092cb(v)))($85206166a57f2888$var$map($85206166a57f2888$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create))(studentChecks));
        return $85206166a57f2888$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("student-select")
        ])($85206166a57f2888$var$append(checkboxes)([
            pager
        ]));
    }
    if ($6415e24f7cd3b8e1$export$2943524994da7a64(v.search)) return $85206166a57f2888$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("student-select")
    ])([
        $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("nothing-here-clearable")),
        $85206166a57f2888$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
            $85206166a57f2888$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(new $85206166a57f2888$export$e282f65e34cf731b($6415e24f7cd3b8e1$export$5c89bef3d5bb8108)))($fc1df90f0e252058$export$1d5a917feb871989)
        ])([
            $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("clear-filters"))
        ])
    ]);
    return $85206166a57f2888$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("student-select")
    ])([
        $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("nothing-here"))
    ]);
};
var $85206166a57f2888$export$f7601ad2277f85b7 = function(state) {
    return $85206166a57f2888$var$section([
        $fc1df90f0e252058$export$2913c0c0b5623090("select-students")
    ])([
        $85206166a57f2888$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-group heading")
        ])([
            $85206166a57f2888$var$map2($85206166a57f2888$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($85206166a57f2888$export$e282f65e34cf731b.create))($6415e24f7cd3b8e1$export$c227b65ca5911a1(state.search)),
            function() {
                if (state.status instanceof $85206166a57f2888$export$ca704cb31d74b6f6) return $85206166a57f2888$export$88a03ce95e104f9d(state);
                if (state.status instanceof $85206166a57f2888$export$cf8a06570d3235e9) return $b5330906fcd65ffd$export$d558900b1478007d;
                if (state.status instanceof $85206166a57f2888$export$5cac6887c54fd40d) return $85206166a57f2888$var$text($85206166a57f2888$var$show(state.status.value0));
                throw new Error("Failed pattern match at Form.StudentSelect (line 307, column 11 - line 310, column 44): " + [
                    state.status.constructor.name
                ]);
            }()
        ])
    ]);
};
var $85206166a57f2888$export$429ee859e6a27934 = function(state) {
    return function(load) {
        return $85206166a57f2888$var$bind1($85206166a57f2888$var$alt($85206166a57f2888$var$map2($7d4cccdf062a2261$export$19db0165690c701a.create)($85206166a57f2888$export$f7601ad2277f85b7({
            page: state.page,
            students: state.students,
            search: state.search,
            account: state.account,
            msg: state.msg,
            status: $85206166a57f2888$export$cf8a06570d3235e9.value
        })))($85206166a57f2888$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($3257df7cdef77623$export$b97f2ad8d0b7442d(load))))(function(res) {
            if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$var$pure1(res.value0);
            if (res instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure1(new $7d4cccdf062a2261$export$19db0165690c701a(res.value0));
            throw new Error("Failed pattern match at Form.StudentSelect (line 281, column 5 - line 283, column 39): " + [
                res.constructor.name
            ]);
        });
    };
};
var $85206166a57f2888$export$3c2268dd2d125457 = function(state) {
    return $85206166a57f2888$export$429ee859e6a27934(state)($85206166a57f2888$export$b61e0a56cf0d5dff(state));
};
var $85206166a57f2888$export$158655ec8e9bb9c1 = function(state) {
    return function(idx) {
        return $85206166a57f2888$export$429ee859e6a27934(state)($85206166a57f2888$export$a6b2e7152efe85b9(state)(idx));
    };
};
var $85206166a57f2888$export$e4d153b3e021fb47 = function(student) {
    return function(state) {
        return $85206166a57f2888$var$isSelected1(student.id)(state.students);
    };
};
var $85206166a57f2888$export$ae764199dd06220 = function(search) {
    return function(sdata) {
        return {
            page: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            students: $f264ceec36a478ad$export$6e22c362a0406a2c,
            search: $06733ae99ed4f534$export$43db023a260c5e9f($6415e24f7cd3b8e1$export$e8f8fb794a7ce0ae(sdata))(search),
            status: $85206166a57f2888$export$ca704cb31d74b6f6.value,
            msg: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            account: {
                type: $02eacf321b2a2128$export$6f3aad56498a7cb9.value,
                student: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }
        };
    };
};
var $85206166a57f2888$export$f6196a6c6bb539b4 = function(workQueueState) {
    return function(workQueueCache) {
        return {
            page: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            students: workQueueState.students,
            search: $6415e24f7cd3b8e1$export$e8f8fb794a7ce0ae({
                teachers: workQueueCache.searchData.teachers,
                semesters: workQueueCache.searchData.semesters,
                classes: workQueueCache.searchData.classes,
                defaults: {
                    semester: workQueueCache.searchData.defaults.semester,
                    teacher: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    group: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }
            }),
            status: $85206166a57f2888$export$ca704cb31d74b6f6.value,
            msg: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            account: workQueueCache.account
        };
    };
};
var $85206166a57f2888$export$5bb86370ea51314a = function(student) {
    return function(state) {
        return {
            page: state.page,
            search: state.search,
            status: state.status,
            account: state.account,
            msg: state.msg,
            students: $85206166a57f2888$var$deselect1(student.id)(state.students)
        };
    };
};
var $85206166a57f2888$export$85cbfd21a78e931c = 300.0;
var $85206166a57f2888$export$6c6c3f4b7541eaf1 = function(v) {
    return function(v1) {
        if (v1 instanceof $85206166a57f2888$export$e282f65e34cf731b) {
            var state = {
                account: v.account,
                msg: v.msg,
                page: v.page,
                status: v.status,
                students: v.students,
                search: v1.value0
            };
            var handleResult = function(v2) {
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$export$6c6c3f4b7541eaf1(state)(v2.value0);
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure1(v2.value0);
                throw new Error("Failed pattern match at Form.StudentSelect (line 246, column 24 - line 248, column 41): " + [
                    v2.constructor.name
                ]);
            };
            return $85206166a57f2888$var$bind1($85206166a57f2888$var$alt($85206166a57f2888$var$voidRight1($06733ae99ed4f534$export$bebe9059409a0d04.value)($3257df7cdef77623$export$b97f2ad8d0b7442d($edf0339512807bee$export$1391212d75b2ee65($85206166a57f2888$export$85cbfd21a78e931c))))($85206166a57f2888$var$map2($06733ae99ed4f534$export$8a67b48435b5d073.create)($85206166a57f2888$export$f7601ad2277f85b7(state))))(function(v2) {
                if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $85206166a57f2888$var$bind1($85206166a57f2888$export$3c2268dd2d125457(state))(handleResult);
                if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return handleResult(v2.value0);
                throw new Error("Failed pattern match at Form.StudentSelect (line 251, column 5 - line 255, column 39): " + [
                    v2.constructor.name
                ]);
            });
        }
        if (v1 instanceof $85206166a57f2888$export$d6d899291526e2a0) return $85206166a57f2888$var$bind1($85206166a57f2888$export$158655ec8e9bb9c1(v)(v1.value0))(function(v2) {
            if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$export$6c6c3f4b7541eaf1(v)(v2.value0);
            if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure1(v2.value0);
            throw new Error("Failed pattern match at Form.StudentSelect (line 256, column 78 - line 258, column 31): " + [
                v2.constructor.name
            ]);
        });
        if (v1 instanceof $85206166a57f2888$export$27f504e7b26f1bd2) return $85206166a57f2888$var$pure1($85206166a57f2888$export$91e46f7d7a03a319(v1.value0)({
            page: v.page,
            students: v.students,
            search: v.search,
            account: v.account,
            msg: v.msg,
            status: $85206166a57f2888$export$ca704cb31d74b6f6.value
        }));
        if (v1 instanceof $85206166a57f2888$export$80a9e884c522b8c3) return $85206166a57f2888$var$bind1($85206166a57f2888$var$liftEffect($54dae5ca6a6cd16d$export$b33b857ad1d9900e(v1.value0)))(function() {
            return $85206166a57f2888$var$pure1({
                account: v.account,
                msg: v.msg,
                page: v.page,
                search: v.search,
                students: v.students,
                status: new $85206166a57f2888$export$5cac6887c54fd40d(v1.value0)
            });
        });
        throw new Error("Failed pattern match at Form.StudentSelect (line 243, column 1 - line 243, column 92): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $85206166a57f2888$export$a2e11d7a8728d1ce = function(state) {
    return $85206166a57f2888$var$bind1($85206166a57f2888$export$f7601ad2277f85b7(state))(function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$pure1(v.value0);
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$export$6c6c3f4b7541eaf1(state)(v.value0);
        throw new Error("Failed pattern match at Form.StudentSelect (line 237, column 59 - line 239, column 40): " + [
            v.constructor.name
        ]);
    });
};
var $85206166a57f2888$export$d6bfe29d59940d16 = function(msg) {
    return function(state) {
        var actionBtns = $85206166a57f2888$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn-group modal-buttons")
        ])([
            $85206166a57f2888$var$button([
                $85206166a57f2888$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($035405231d3ae317$export$a09a21bd8097e7.value))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("btn")
            ])([
                $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
            ]),
            $85206166a57f2888$var$button([
                $85206166a57f2888$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(new $035405231d3ae317$export$c00f2c00f91f14d5(state)))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary")
            ])([
                $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("copy-forms"))
            ])
        ]);
        return $85206166a57f2888$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("student-select-wrapper modal-grid")
        ])([
            $85206166a57f2888$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
            ])([
                $85206166a57f2888$var$text(msg)
            ]),
            $85206166a57f2888$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("modal-body")
            ])([
                $85206166a57f2888$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($85206166a57f2888$export$a2e11d7a8728d1ce(state))
            ]),
            actionBtns
        ]);
    };
};
var $85206166a57f2888$export$b6c9147dc7ec7d53 = function(msg) {
    return function(state) {
        return $85206166a57f2888$var$loopState(state)($85206166a57f2888$export$d6bfe29d59940d16(msg));
    };
};
var $85206166a57f2888$export$679d507248f70d11 = function(outer) {
    return function(msg) {
        return function(search) {
            return $035405231d3ae317$export$204c43257a011371(outer)($85206166a57f2888$var$bind1($85206166a57f2888$var$alt($b5330906fcd65ffd$export$d558900b1478007d)($3257df7cdef77623$export$b97f2ad8d0b7442d($d2284b2d3e1b6f87$export$8291c2122093ac93($85206166a57f2888$var$bind2($85206166a57f2888$var$runGraphQL1($dc9dc2b43b9526de$export$49a857040325da19))(function(sdata) {
                var state = $85206166a57f2888$export$ae764199dd06220(search)(sdata);
                return $85206166a57f2888$var$bind2($85206166a57f2888$var$runGraphQL($b05aa108190eac05$export$88aef09b2a474163($6415e24f7cd3b8e1$export$4bb0f1a01491086d(state.search))))(function(page) {
                    return $85206166a57f2888$var$pure2({
                        account: state.account,
                        msg: state.msg,
                        search: state.search,
                        status: state.status,
                        students: state.students,
                        page: new $06733ae99ed4f534$export$8a67b48435b5d073(page)
                    });
                });
            })))))(function(result) {
                if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $85206166a57f2888$export$b6c9147dc7ec7d53(msg)(result.value0);
                if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $85206166a57f2888$var$errorModalWidget(result.value0);
                throw new Error("Failed pattern match at Form.StudentSelect (line 197, column 5 - line 199, column 41): " + [
                    result.constructor.name
                ]);
            }));
        };
    };
};
var $85206166a57f2888$export$837a457478359c90 = function(workQueueState) {
    return function(workQueueUi) {
        return function(workQueueCache) {
            return function(state) {
                var notBoardAcc = $85206166a57f2888$var$notEq(workQueueCache.account.type)($02eacf321b2a2128$export$ebce5c1c966101a4.value);
                var actionBtns = $85206166a57f2888$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn-group")
                ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn cancel"),
                        $85206166a57f2888$var$voidRight($85206166a57f2888$export$848c9b7ead0df967.value)($fc1df90f0e252058$export$1d5a917feb871989)
                    ])([
                        $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
                    ])),
                    $c3ec47a57216184e$export$71e337785367343c(!$6be45a9e147fc393$export$b0442b57b5d77489(workQueueState))($85206166a57f2888$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn export"),
                        $85206166a57f2888$var$voidRight($85206166a57f2888$export$f883e605db67eacf.value)($fc1df90f0e252058$export$1d5a917feb871989)
                    ])([
                        $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("export-pdf"))
                    ])),
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                        $fc1df90f0e252058$export$683472f6198a076e($85206166a57f2888$var$isEmpty(state.students)),
                        $85206166a57f2888$var$voidRight($85206166a57f2888$export$7fe28cb29e71bf10.value)($fc1df90f0e252058$export$1d5a917feb871989)
                    ])([
                        $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("next"))
                    ]))
                ]));
                return $85206166a57f2888$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("step-container step-2a")
                ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$header([
                        $fc1df90f0e252058$export$2913c0c0b5623090("page-header")
                    ])([
                        $85206166a57f2888$var$h1([
                            $fc1df90f0e252058$export$2913c0c0b5623090("page-heading")
                        ])([
                            $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("select-students"))
                        ]),
                        actionBtns
                    ])),
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$map2($85206166a57f2888$export$90368da438a1001a.create)($356f5ce902fa042d$export$c63886ee1a09a6cb(workQueueState)(workQueueUi)(workQueueCache))),
                    $85206166a57f2888$var$map1(function(msg) {
                        return $85206166a57f2888$var$div([
                            $fc1df90f0e252058$export$2913c0c0b5623090("error")
                        ])([
                            $85206166a57f2888$var$text(msg)
                        ]);
                    })(state.msg),
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("teacher-semester-selections")
                    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                        new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$p$prime([
                            $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("semester-hidden-select"))
                        ])),
                        new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$map2($85206166a57f2888$export$ffb2fc0d0be923d2(workQueueState)(workQueueUi))($c1518ffd015b44e8$export$d167388450b383cf(workQueueUi.semester))),
                        $c3ec47a57216184e$export$71e337785367343c(notBoardAcc)($85206166a57f2888$var$p$prime([
                            $85206166a57f2888$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("teacher-hidden-select"))
                        ])),
                        $c3ec47a57216184e$export$71e337785367343c(notBoardAcc)($85206166a57f2888$var$map2($85206166a57f2888$export$c1d995f1207bf7bc(workQueueState)(workQueueUi))($c1518ffd015b44e8$export$d167388450b383cf(workQueueUi.teacher)))
                    ]))),
                    new $06733ae99ed4f534$export$8a67b48435b5d073($85206166a57f2888$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("step-2a-right")
                    ])([
                        $85206166a57f2888$var$map2($85206166a57f2888$export$5737e0a77055e89d.create)($85206166a57f2888$export$a2e11d7a8728d1ce(state))
                    ]))
                ]));
            };
        };
    };
};
var $85206166a57f2888$export$b52fcdc078a891ae = function(v) {
    if (v.page instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $85206166a57f2888$var$areAllSelected1($85206166a57f2888$var$map(function(v1) {
        return v1.id;
    })($b5f6b40b8f63b732$export$f27fff4bf988e19(v.page.value0)))(v.students);
    return false;
};






// Generated by purs version 0.15.16



































var $812fcffca6747f78$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $812fcffca6747f78$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $812fcffca6747f78$var$areFormsSelected = /* #__PURE__ */ $38eb3af3d662147b$export$9b21d46ec278cbf3($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $812fcffca6747f78$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $812fcffca6747f78$var$selectForms = /* #__PURE__ */ $38eb3af3d662147b$export$e326c404651add30($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $812fcffca6747f78$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $812fcffca6747f78$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $812fcffca6747f78$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$abbr = /* #__PURE__ */ $3eadc1b959dd1120$export$2bcb785951133fe5($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $812fcffca6747f78$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $812fcffca6747f78$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$e65788c6d4494539));
var $812fcffca6747f78$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $812fcffca6747f78$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $812fcffca6747f78$var$mod = /* #__PURE__ */ $b0cd729514c2504e$export$842a2cf37af977e1($b0cd729514c2504e$export$437776face1858ae);
var $812fcffca6747f78$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $812fcffca6747f78$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $812fcffca6747f78$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $812fcffca6747f78$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($a40b20519abba0fb$export$932f43bf867a1b5);
var $812fcffca6747f78$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($02eacf321b2a2128$export$5315b7c1b1d9e384);
var $812fcffca6747f78$var$isEmpty = /* #__PURE__ */ $f264ceec36a478ad$export$dd1bc94b04021eeb(/* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a));
var $812fcffca6747f78$var$header = /* #__PURE__ */ $3eadc1b959dd1120$export$38e42c68cf43b5d4($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($812fcffca6747f78$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $812fcffca6747f78$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $812fcffca6747f78$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $812fcffca6747f78$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $812fcffca6747f78$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $812fcffca6747f78$export$7254cc27399e90bd = /* #__PURE__ */ function() {
    function State(value0) {
        this.value0 = value0;
    }
    State.create = function(value0) {
        return new State(value0);
    };
    return State;
}();
var $812fcffca6747f78$export$444b3ab0cb9aec40 = /* #__PURE__ */ function() {
    function Navigate(value0) {
        this.value0 = value0;
    }
    Navigate.create = function(value0) {
        return new Navigate(value0);
    };
    return Navigate;
}();
var $812fcffca6747f78$export$ca087a5c96095431 = /* #__PURE__ */ function() {
    function WorkQR(value0) {
        this.value0 = value0;
    }
    WorkQR.create = function(value0) {
        return new WorkQR(value0);
    };
    return WorkQR;
}();
var $812fcffca6747f78$export$f883e605db67eacf = /* #__PURE__ */ function() {
    function Export() {}
    Export.value = new Export();
    return Export;
}();
var $812fcffca6747f78$var$withForms = function(state) {
    return function(func) {
        return {
            forms: state.forms,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueState: {
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: state.workQueueState.teacher,
                forms: func(state.workQueueState.forms)
            }
        };
    };
};
var $812fcffca6747f78$var$setTeacherSelect = function(state) {
    return function(teacher) {
        return {
            forms: state.forms,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                search: state.workQueueUi.search,
                semester: state.workQueueUi.semester,
                teacher: teacher
            },
            workQueueState: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: $812fcffca6747f78$var$map(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(teacher))
            }
        };
    };
};
var $812fcffca6747f78$var$setSemesterSelect = function(state) {
    return function(semester) {
        return {
            forms: state.forms,
            workQueueCache: state.workQueueCache,
            reorder: state.reorder,
            movedDownIdx: state.movedDownIdx,
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                search: state.workQueueUi.search,
                teacher: state.workQueueUi.teacher,
                semester: semester
            },
            workQueueState: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                teacher: state.workQueueState.teacher,
                semester: $812fcffca6747f78$var$map(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(semester))
            }
        };
    };
};
var $812fcffca6747f78$export$657a9ae17f440869 = function(fps) {
    return function(reorder) {
        return {
            forms: fps.forms,
            workQueueState: fps.workQueueState,
            workQueueUi: fps.workQueueUi,
            workQueueCache: fps.workQueueCache,
            movedDownIdx: fps.movedDownIdx,
            reorder: reorder
        };
    };
};
var $812fcffca6747f78$var$selectAllFormsCheckbox = function(state) {
    return $812fcffca6747f78$var$bind($fc8e139dfeeff88c$export$fe5109b9fec6786a("form-picker-select-all")("form-picker-select-all")($c3328e54cdf5154c$export$5a1a8430df9521e("select-all"))($812fcffca6747f78$var$areFormsSelected(state.forms)(state.workQueueState.forms)))(function(v) {
        return $812fcffca6747f78$var$pure($812fcffca6747f78$var$withForms(state)($812fcffca6747f78$var$selectForms(state.forms)(v)));
    });
};
var $812fcffca6747f78$var$renderFormCheckboxes = function(state) {
    var update = function(v) {
        return function(v1) {
            if (v1) return $812fcffca6747f78$var$withForms(state)($38eb3af3d662147b$export$85cd10c12a07379(v));
            if (!v1) return $812fcffca6747f78$var$withForms(state)($38eb3af3d662147b$export$681941b68d7905(v));
            throw new Error("Failed pattern match at Steps.FormPicker (line 157, column 9 - line 157, column 61): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    var selectedClass = function(form) {
        var $70 = $38eb3af3d662147b$export$b3f328b498b77673(form)(state.workQueueState.forms);
        if ($70) return " selected";
        return "";
    };
    var formCheckBoxRender = function(form) {
        return $812fcffca6747f78$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("form-type" + selectedClass(form)),
            $fc1df90f0e252058$export$df61b30b684217c0("form-type-" + ($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-container")),
            $fc1df90f0e252058$export$9c7ae676ac45430a("form-type-" + ($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-container"))
        ])([
            $812fcffca6747f78$var$map1(update(form))($fc8e139dfeeff88c$export$b07e517d22efa1ca([
                $fc1df90f0e252058$export$9c7ae676ac45430a("form-" + $308f9765feb7633d$export$a1b0f5347d2470b(form.id)),
                $fc1df90f0e252058$export$2913c0c0b5623090("form-checkbox")
            ])($38eb3af3d662147b$export$b3f328b498b77673(form)(state.workQueueState.forms))),
            $812fcffca6747f78$var$label([
                $fc1df90f0e252058$export$35d9e1c947946090("form-" + $308f9765feb7633d$export$a1b0f5347d2470b(form.id)),
                $fc1df90f0e252058$export$2913c0c0b5623090("form-label")
            ])([
                $812fcffca6747f78$var$abbr([
                    $fc1df90f0e252058$export$2913c0c0b5623090("form-abbr"),
                    $fc1df90f0e252058$export$1d567c320f4763bc({
                        backgroundColor: form.bgColor
                    })
                ])([
                    $812fcffca6747f78$var$text(form.abbr)
                ]),
                $812fcffca6747f78$var$text(form.label)
            ])
        ]);
    };
    return $812fcffca6747f78$var$map2(formCheckBoxRender)(state.forms);
};
var $812fcffca6747f78$var$renderFormArrows = function(state) {
    var wasMovedUp = function(v) {
        if ($812fcffca6747f78$var$eq(new $06733ae99ed4f534$export$8a67b48435b5d073(v + 1 | 0))(state.movedDownIdx)) return true;
        return false;
    };
    var wasMovedDown = function(v) {
        if ($812fcffca6747f78$var$eq(new $06733ae99ed4f534$export$8a67b48435b5d073(v))(state.movedDownIdx)) return true;
        return false;
    };
    var moveDown = function(idx) {
        var update = $812fcffca6747f78$var$bind1($396c4c3d9e7fae3c$export$b610b8812bbcded9(state.forms)(idx))(function($$this) {
            return $812fcffca6747f78$var$bind1($396c4c3d9e7fae3c$export$b610b8812bbcded9(state.forms)(idx + 1 | 0))(function(after) {
                return $812fcffca6747f78$var$bind1($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)(after)(state.forms))($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx + 1 | 0)($$this));
            });
        });
        if (update instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return state;
        if (update instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            reorder: state.reorder,
            workQueueCache: state.workQueueCache,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            forms: update.value0,
            movedDownIdx: new $06733ae99ed4f534$export$8a67b48435b5d073(idx + 1 | 0)
        };
        throw new Error("Failed pattern match at Steps.FormPicker (line 188, column 20 - line 190, column 73): " + [
            update.constructor.name
        ]);
    };
    var formArrowRender = function(idx) {
        return function(form) {
            return $812fcffca6747f78$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("form-type" + (function() {
                    var $75 = wasMovedDown(idx);
                    if ($75) return " moved-down";
                    return "";
                }() + function() {
                    var $76 = wasMovedUp(idx);
                    if ($76) return " moved-up-" + $812fcffca6747f78$var$show($812fcffca6747f78$var$mod(idx)(2));
                    return "";
                }())),
                $fc1df90f0e252058$export$df61b30b684217c0("form-type-" + ($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-container")),
                $fc1df90f0e252058$export$9c7ae676ac45430a("form-type-" + ($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-container"))
            ])([
                $812fcffca6747f78$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("form-arrows")
                ])($812fcffca6747f78$var$append1(function() {
                    var $77 = idx > 0;
                    if ($77) return [
                        $812fcffca6747f78$var$button([
                            $fc1df90f0e252058$export$2913c0c0b5623090("arrow-up"),
                            $812fcffca6747f78$var$voidRight(moveDown(idx - 1 | 0))($fc1df90f0e252058$export$1d5a917feb871989)
                        ])([
                            $812fcffca6747f78$var$span([
                                $fc1df90f0e252058$export$2913c0c0b5623090("arrow-up-icon")
                            ])([]),
                            $812fcffca6747f78$var$span([
                                $fc1df90f0e252058$export$2913c0c0b5623090("sr-only")
                            ])([
                                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("up"))
                            ])
                        ])
                    ];
                    return [
                        $812fcffca6747f78$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("arrow-up-icon-first")
                        ])([])
                    ];
                }())(function() {
                    var $78 = idx < ($812fcffca6747f78$var$length(state.forms) - 1 | 0);
                    if ($78) return [
                        $812fcffca6747f78$var$button([
                            $fc1df90f0e252058$export$2913c0c0b5623090("arrow-down"),
                            $812fcffca6747f78$var$voidRight(moveDown(idx))($fc1df90f0e252058$export$1d5a917feb871989)
                        ])([
                            $812fcffca6747f78$var$span([
                                $fc1df90f0e252058$export$2913c0c0b5623090("arrow-down-icon")
                            ])([]),
                            $812fcffca6747f78$var$span([
                                $fc1df90f0e252058$export$2913c0c0b5623090("sr-only")
                            ])([
                                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("down"))
                            ])
                        ])
                    ];
                    return [
                        $812fcffca6747f78$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("arrow-down-icon-last")
                        ])([])
                    ];
                }())),
                $812fcffca6747f78$var$label([
                    $fc1df90f0e252058$export$2913c0c0b5623090("form-label")
                ])([
                    $812fcffca6747f78$var$abbr([
                        $fc1df90f0e252058$export$2913c0c0b5623090("form-abbr"),
                        $fc1df90f0e252058$export$1d567c320f4763bc({
                            backgroundColor: form.bgColor
                        })
                    ])([
                        $812fcffca6747f78$var$text(form.abbr)
                    ]),
                    $812fcffca6747f78$var$text(form.label)
                ])
            ]);
        };
    };
    return $396c4c3d9e7fae3c$export$8f07ddce13659f50(formArrowRender)(state.forms);
};
var $812fcffca6747f78$export$f2c4fe0b9282f2cc = function(state) {
    var render = function() {
        if (state.reorder) return $812fcffca6747f78$var$renderFormArrows(state);
        return $812fcffca6747f78$var$renderFormCheckboxes(state);
    }();
    return $812fcffca6747f78$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("form-picker")
    ])($396c4c3d9e7fae3c$export$8327ebbef2a0ba76($812fcffca6747f78$var$selectAllFormsCheckbox(state))(render));
};
var $812fcffca6747f78$export$a9575a3aba1d7045 = function(workQueueState) {
    return function(workQueueUi) {
        return function(workQueueCache) {
            return function(v) {
                return {
                    workQueueState: workQueueState,
                    workQueueUi: workQueueUi,
                    workQueueCache: workQueueCache,
                    reorder: false,
                    movedDownIdx: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    forms: v
                };
            };
        };
    };
};
var $812fcffca6747f78$export$60070eb0397470c = function(workQueueState) {
    return function(workQueueUi) {
        return function(workQueueCache) {
            return $812fcffca6747f78$var$map3($812fcffca6747f78$export$a9575a3aba1d7045(workQueueState)(workQueueUi)(workQueueCache))($38eb3af3d662147b$export$a8d7826568b655d2);
        };
    };
};
var $812fcffca6747f78$export$dc64bd12ab749019 = function(fps) {
    return $812fcffca6747f78$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("form-picker-step")
    ])([
        $812fcffca6747f78$export$f2c4fe0b9282f2cc(fps)
    ]);
};
var $812fcffca6747f78$export$9631053f155bbea5 = function(preservedQuery) {
    return function(state) {
        var notBoardAcc = $812fcffca6747f78$var$notEq(state.workQueueCache.account.type)($02eacf321b2a2128$export$ebce5c1c966101a4.value);
        var actionBtns = $812fcffca6747f78$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn-group")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn cancel"),
                $812fcffca6747f78$var$voidRight(new $812fcffca6747f78$export$444b3ab0cb9aec40($994495db3cff0a67$export$635e3e065a143ae6.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
            ])),
            $c3ec47a57216184e$export$71e337785367343c(!$6be45a9e147fc393$export$b0442b57b5d77489(state.workQueueState))($812fcffca6747f78$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn export"),
                $fc1df90f0e252058$export$683472f6198a076e($812fcffca6747f78$var$isEmpty(state.workQueueState.forms) || !$6be45a9e147fc393$export$fce9b5fa170e923f(state.workQueueCache.account)(state.workQueueState)),
                $812fcffca6747f78$var$voidRight($812fcffca6747f78$export$f883e605db67eacf.value)($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("export-pdf"))
            ])),
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                $fc1df90f0e252058$export$683472f6198a076e($812fcffca6747f78$var$isEmpty(state.workQueueState.forms) || !$6be45a9e147fc393$export$fce9b5fa170e923f(state.workQueueCache.account)(state.workQueueState)),
                $812fcffca6747f78$var$voidRight(new $812fcffca6747f78$export$444b3ab0cb9aec40($994495db3cff0a67$export$9807628a98dc6165.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("next"))
            ]))
        ]));
        return $812fcffca6747f78$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("step-container step-2b")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$header([
                $fc1df90f0e252058$export$2913c0c0b5623090("page-header")
            ])([
                $812fcffca6747f78$var$h1([
                    $fc1df90f0e252058$export$2913c0c0b5623090("page-heading")
                ])([
                    $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("select-forms"))
                ]),
                actionBtns
            ])),
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$map1($812fcffca6747f78$export$ca087a5c96095431.create)($356f5ce902fa042d$export$fa5a12c391dc617d(preservedQuery)(state.workQueueState)(state.workQueueUi)(state.workQueueCache))),
            $c3ec47a57216184e$export$71e337785367343c(!$6be45a9e147fc393$export$fce9b5fa170e923f(state.workQueueCache.account)(state.workQueueState))($812fcffca6747f78$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("error")
            ])([
                $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("must-select-teacher-semester"))
            ])),
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("teacher-semester-selections")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$p$prime([
                    $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("semester-hidden-select"))
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$map1($812fcffca6747f78$var$map4($812fcffca6747f78$export$7254cc27399e90bd.create)($812fcffca6747f78$var$setSemesterSelect(state)))($c1518ffd015b44e8$export$d167388450b383cf(state.workQueueUi.semester))),
                $c3ec47a57216184e$export$71e337785367343c(notBoardAcc)($812fcffca6747f78$var$p$prime([
                    $812fcffca6747f78$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("teacher-hidden-select"))
                ])),
                $c3ec47a57216184e$export$71e337785367343c(notBoardAcc)($812fcffca6747f78$var$map1($812fcffca6747f78$var$map4($812fcffca6747f78$export$7254cc27399e90bd.create)($812fcffca6747f78$var$setTeacherSelect(state)))($c1518ffd015b44e8$export$d167388450b383cf(state.workQueueUi.teacher)))
            ]))),
            new $06733ae99ed4f534$export$8a67b48435b5d073($812fcffca6747f78$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-2b-right")
            ])([
                $812fcffca6747f78$var$map1($812fcffca6747f78$export$7254cc27399e90bd.create)($812fcffca6747f78$export$dc64bd12ab749019(state))
            ]))
        ]));
    };
};
var $812fcffca6747f78$export$423512157c50d7d0 = function(fps) {
    return $d2284b2d3e1b6f87$export$8291c2122093ac93($812fcffca6747f78$var$discard($812fcffca6747f78$var$runGraphQL($38eb3af3d662147b$export$b5859dd113079414($812fcffca6747f78$var$map2(function(v) {
        return v.id;
    })(fps.forms))))(function() {
        return $812fcffca6747f78$var$pure1({
            forms: fps.forms,
            movedDownIdx: fps.movedDownIdx,
            workQueueCache: fps.workQueueCache,
            workQueueState: fps.workQueueState,
            workQueueUi: fps.workQueueUi,
            reorder: false
        });
    }));
};
var $812fcffca6747f78$export$98f37a863d1bf955 = /* #__PURE__ */ function() {
    return {
        forms: [],
        reorder: false,
        movedDownIdx: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        workQueueState: $6be45a9e147fc393$export$78ce5202a3b18e96,
        workQueueUi: $288f947f09d2f062$export$4bc0f934ddc418d8,
        workQueueCache: $740d96ccf08cc464$export$7188e7e84cf4c0b3
    };
}();


// Generated by purs version 0.15.16





















var $506e78fa6ac73d88$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $506e78fa6ac73d88$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $506e78fa6ac73d88$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $506e78fa6ac73d88$var$multiQuery_ = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$30df5e01129e087c()(/* #__PURE__ */ $7c4f9de9dcfa2f59$export$7cf6fb124ade4099(/* #__PURE__ */ $7c4f9de9dcfa2f59$export$7cf6fb124ade4099($7c4f9de9dcfa2f59$export$936ce2b08175dfd0)({
    reflectSymbol: function() {
        return "recentForms";
    }
})()()()()($a40b20519abba0fb$export$c6b405b39190b469))({
    reflectSymbol: function() {
        return "forms";
    }
})()()()()($a40b20519abba0fb$export$c6b405b39190b469));
var $506e78fa6ac73d88$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $506e78fa6ac73d88$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($506e78fa6ac73d88$var$eqRNTY);
var $506e78fa6ac73d88$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $506e78fa6ac73d88$var$fromFoldable$prime = /* #__PURE__ */ $f264ceec36a478ad$export$d782b52044d44562(/* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a))($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $506e78fa6ac73d88$var$eqRec = /* #__PURE__ */ $37b880af5f4991bd$export$691c0e424728509e();
var $506e78fa6ac73d88$var$eqRowCons = /* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0($37b880af5f4991bd$export$d12253326f924cb1)();
var $506e78fa6ac73d88$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e(/* #__PURE__ */ $506e78fa6ac73d88$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $506e78fa6ac73d88$var$eqRowCons({
    reflectSymbol: function() {
        return "value";
    }
})(/* #__PURE__ */ $506e78fa6ac73d88$var$eqRec(/* #__PURE__ */ $37b880af5f4991bd$export$730b16b2c839caa0(/* #__PURE__ */ $506e78fa6ac73d88$var$eqRowCons({
    reflectSymbol: function() {
        return "name";
    }
})($37b880af5f4991bd$export$fa624555ca2acbc8))()({
    reflectSymbol: function() {
        return "id";
    }
})($506e78fa6ac73d88$var$eqRNTY))))()({
    reflectSymbol: function() {
        return "label";
    }
})($37b880af5f4991bd$export$fa624555ca2acbc8))));
var $506e78fa6ac73d88$export$df7041158d889e0e = /* #__PURE__ */ function() {
    function RFNormal() {}
    RFNormal.value = new RFNormal();
    return RFNormal;
}();
var $506e78fa6ac73d88$export$29c07d87bcba88bc = /* #__PURE__ */ function() {
    function RFLoading() {}
    RFLoading.value = new RFLoading();
    return RFLoading;
}();
var $506e78fa6ac73d88$export$43ecbc44d94efb05 = /* #__PURE__ */ function() {
    function RFError(value0) {
        this.value0 = value0;
    }
    RFError.create = function(value0) {
        return new RFError(value0);
    };
    return RFError;
}();
var $506e78fa6ac73d88$export$fea330ef6103f535 = function(state) {
    return {
        recentForms: state.recentForms,
        selection: state.selection,
        searchState: state.searchState,
        formPicker: state.formPicker,
        searchVersion: state.searchVersion,
        state: $506e78fa6ac73d88$export$29c07d87bcba88bc.value
    };
};
var $506e78fa6ac73d88$export$b8d0bb2aa0adefe5 = function(err) {
    return function(state) {
        return {
            recentForms: state.recentForms,
            selection: state.selection,
            searchState: state.searchState,
            formPicker: state.formPicker,
            searchVersion: state.searchVersion,
            state: new $506e78fa6ac73d88$export$43ecbc44d94efb05(err)
        };
    };
};
var $506e78fa6ac73d88$export$c1853cad74b031d9 = function(state) {
    return $506e78fa6ac73d88$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(state.selection));
};
var $506e78fa6ac73d88$export$d2afd53f9f0a26b = /* #__PURE__ */ function() {
    var $77 = $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546)(function(v) {
        return v.id;
    });
    return function($78) {
        return $77($506e78fa6ac73d88$export$c1853cad74b031d9($78));
    };
}();
var $506e78fa6ac73d88$export$ce850f65dda80828 = function(state) {
    var v = $6415e24f7cd3b8e1$export$4bb0f1a01491086d(state.searchState);
    return new $3b789731b0ef5df1$export$8a7daa21c7faa7ff({
        teacher: v.teacher,
        semester: v.semester,
        "class": v["class"],
        search: v.search,
        formIds: $506e78fa6ac73d88$var$fromFoldable($506e78fa6ac73d88$var$map(function(v1) {
            return v1.id;
        })($f264ceec36a478ad$export$7693e0a1b9351086(state.formPicker.workQueueState.forms)))
    });
};
var $506e78fa6ac73d88$export$836911d8c4152069 = function(state) {
    if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return {
        recentForms: state.recentForms,
        selection: state.selection,
        searchState: state.searchState,
        formPicker: state.formPicker,
        searchVersion: state.searchVersion,
        state: $506e78fa6ac73d88$export$df7041158d889e0e.value
    };
    return state;
};
var $506e78fa6ac73d88$export$59d150885a1daad3 = /* #__PURE__ */ $b5f6b40b8f63b732$export$683fc3535a5e61e0([]);
var $506e78fa6ac73d88$export$e9046b5a68a171f5 = function(initial) {
    var emptyRecentForms = {
        recentForms: $506e78fa6ac73d88$export$59d150885a1daad3,
        selection: $f264ceec36a478ad$export$6e22c362a0406a2c,
        searchState: $6415e24f7cd3b8e1$export$5c89bef3d5bb8108,
        formPicker: $812fcffca6747f78$export$98f37a863d1bf955,
        state: $506e78fa6ac73d88$export$df7041158d889e0e.value,
        searchVersion: 0
    };
    return $d2284b2d3e1b6f87$export$8291c2122093ac93($506e78fa6ac73d88$var$bind($506e78fa6ac73d88$var$multiQuery_({
        recentForms: $3b789731b0ef5df1$export$76fee8bb098f8940($506e78fa6ac73d88$export$ce850f65dda80828({
            recentForms: emptyRecentForms.recentForms,
            selection: emptyRecentForms.selection,
            formPicker: emptyRecentForms.formPicker,
            state: emptyRecentForms.state,
            searchVersion: emptyRecentForms.searchVersion,
            searchState: initial.workQueueUi.search
        })),
        forms: $38eb3af3d662147b$export$a8d7826568b655d2
    }))(function(v) {
        var formPicker = $812fcffca6747f78$export$a9575a3aba1d7045(initial.workQueueState)(initial.workQueueUi)(initial.workQueueCache)(v.forms);
        var preselect = $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(f) {
            return $506e78fa6ac73d88$var$elem(f.id)(initial.preselectForms);
        })($b5f6b40b8f63b732$export$f27fff4bf988e19(v.recentForms));
        return $506e78fa6ac73d88$var$pure({
            recentForms: v.recentForms,
            selection: $506e78fa6ac73d88$var$fromFoldable$prime(preselect),
            searchState: initial.workQueueUi.search,
            formPicker: formPicker,
            state: $506e78fa6ac73d88$export$df7041158d889e0e.value,
            searchVersion: 0
        });
    }));
};
var $506e78fa6ac73d88$export$2088df704cfb48f3 = function(sstate$prime) {
    return function(state) {
        var sstate = function() {
            var $76 = $506e78fa6ac73d88$var$notEq($7178b396566f5a79$export$127d1aaaa65102b1(state["searchState"]["class"]))($7178b396566f5a79$export$127d1aaaa65102b1(sstate$prime["class"]));
            if ($76) return {
                "class": sstate$prime["class"],
                keyword: sstate$prime.keyword,
                teacher: sstate$prime.teacher,
                semester: $7178b396566f5a79$export$5a4818cec1656a71(sstate$prime.semester)($06733ae99ed4f534$export$bebe9059409a0d04.value)
            };
            return sstate$prime;
        }();
        return {
            recentForms: state.recentForms,
            formPicker: state.formPicker,
            state: state.state,
            searchState: sstate,
            selection: $f264ceec36a478ad$export$6e22c362a0406a2c,
            searchVersion: state.searchVersion + 1 | 0
        };
    };
};
var $506e78fa6ac73d88$export$fa820f6db65b6e5a = function(recentForms) {
    return function(state) {
        return {
            selection: state.selection,
            searchState: state.searchState,
            formPicker: state.formPicker,
            searchVersion: state.searchVersion,
            recentForms: recentForms,
            state: $506e78fa6ac73d88$export$df7041158d889e0e.value
        };
    };
};


// Generated by purs version 0.15.16
















// Generated by purs version 0.15.16























var $87fd40f8c9231b88$var$inputIsSymbol = {
    reflectSymbol: function() {
        return "input";
    }
};
var $87fd40f8c9231b88$var$encRNTY = /* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b);
var $87fd40f8c9231b88$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $87fd40f8c9231b88$var$formsIsSymbol = {
    reflectSymbol: function() {
        return "forms";
    }
};
var $87fd40f8c9231b88$var$rlhsCons = /* #__PURE__ */ $266cd1b01131a218$export$3a03965a63c09844($266cd1b01131a218$export$4ed06b452b0f7d08);
var $87fd40f8c9231b88$var$buildMutation = /* #__PURE__ */ $a40b20519abba0fb$export$5e1e8025a6c9da45(/* #__PURE__ */ $a40b20519abba0fb$export$450e3c8f9eaaa96f(/* #__PURE__ */ $a40b20519abba0fb$export$f23a440a785b445($a40b20519abba0fb$export$bb525b50bfdf2bbc)($87fd40f8c9231b88$var$inputIsSymbol)(/* #__PURE__ */ $308f9765feb7633d$export$7cf8ddfc8d49148b(/* #__PURE__ */ $308f9765feb7633d$export$d421f47a1b0c8424({
    reflectSymbol: function() {
        return "UpdateFormInput";
    }
})))(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($87fd40f8c9231b88$var$encRNTY)(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($eb7399d322077fcf$export$188ec67d44674d4b))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($87fd40f8c9231b88$var$encRNTY))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "teacher_id";
    }
})())({
    reflectSymbol: function() {
        return "semester";
    }
})())({
    reflectSymbol: function() {
        return "form_id";
    }
})())())))()())(/* #__PURE__ */ $a40b20519abba0fb$export$f919171f4a5c574f($a40b20519abba0fb$export$fe891b8934c38330)($87fd40f8c9231b88$var$inputIsSymbol)())())(/* #__PURE__ */ $a40b20519abba0fb$export$1cde869cdd796379(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($87fd40f8c9231b88$var$idIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($87fd40f8c9231b88$var$formsIsSymbol)()())())(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $87fd40f8c9231b88$var$rlhsCons($87fd40f8c9231b88$var$formsIsSymbol)(/* #__PURE__ */ $266cd1b01131a218$export$c6279c3a85890bd5(/* #__PURE__ */ $266cd1b01131a218$export$5cdfc842db1bd206(/* #__PURE__ */ $87fd40f8c9231b88$var$rlhsCons($87fd40f8c9231b88$var$idIsSymbol)($266cd1b01131a218$export$eac78e45f453a621)()())()))()())()));
var $87fd40f8c9231b88$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $87fd40f8c9231b88$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $87fd40f8c9231b88$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $87fd40f8c9231b88$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($87fd40f8c9231b88$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $87fd40f8c9231b88$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($87fd40f8c9231b88$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $87fd40f8c9231b88$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $87fd40f8c9231b88$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $87fd40f8c9231b88$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $87fd40f8c9231b88$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($87fd40f8c9231b88$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $87fd40f8c9231b88$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $87fd40f8c9231b88$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $87fd40f8c9231b88$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $87fd40f8c9231b88$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($87fd40f8c9231b88$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $87fd40f8c9231b88$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $87fd40f8c9231b88$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $87fd40f8c9231b88$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $87fd40f8c9231b88$export$687fad5cef0c511b = function(selection) {
    return function(forms) {
        var teacherInput = function(teacher) {
            return function(f) {
                return $308f9765feb7633d$export$eb1b128a19ff6c25({
                    form_id: f.id,
                    semester: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    teacher_id: new $06733ae99ed4f534$export$8a67b48435b5d073(teacher.id)
                });
            };
        };
        var semesterInput = function(sem) {
            return function(f) {
                return $308f9765feb7633d$export$eb1b128a19ff6c25({
                    form_id: f.id,
                    semester: new $06733ae99ed4f534$export$8a67b48435b5d073(sem.semester),
                    teacher_id: $06733ae99ed4f534$export$bebe9059409a0d04.value
                });
            };
        };
        if (selection instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $a40b20519abba0fb$export$bc1f9bac519c56f6("MassUpdateSemesters")($87fd40f8c9231b88$var$buildMutation("updateForms")({
            input: $87fd40f8c9231b88$var$map(semesterInput(selection.value0))(forms)
        }));
        if (selection instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $a40b20519abba0fb$export$bc1f9bac519c56f6("MassUpdateTeachers")($87fd40f8c9231b88$var$buildMutation("updateForms")({
            input: $87fd40f8c9231b88$var$map(teacherInput(selection.value0))(forms)
        }));
        throw new Error("Failed pattern match at Widgets.UpdateForm (line 67, column 39 - line 71, column 52): " + [
            selection.constructor.name
        ]);
    };
};
var $87fd40f8c9231b88$export$a96afb83a245e19f = function(state$prime) {
    return $87fd40f8c9231b88$var$loopState(state$prime)(function(state) {
        return $87fd40f8c9231b88$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal-col modal-narrow")
        ])([
            $87fd40f8c9231b88$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
            ])([
                $87fd40f8c9231b88$var$text(state.header)
            ]),
            $87fd40f8c9231b88$var$map1($87fd40f8c9231b88$var$map2($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v) {
                return {
                    forms: state.forms,
                    header: state.header,
                    select: v
                };
            }))($7178b396566f5a79$export$54b124386ef5abe3(state.select)),
            $87fd40f8c9231b88$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                $fc1df90f0e252058$export$683472f6198a076e($06733ae99ed4f534$export$4967676db1b89293($7178b396566f5a79$export$127d1aaaa65102b1(state.select))),
                $87fd40f8c9231b88$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(state))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $87fd40f8c9231b88$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("save"))
            ])
        ]);
    });
};
var $87fd40f8c9231b88$export$b5bbbcc541974f2e = function(state) {
    var finalSelection = function(v) {
        if (v instanceof $035405231d3ae317$export$a09a21bd8097e7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        if (v instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $87fd40f8c9231b88$var$map3(function(v1) {
            return v1.value;
        })($7178b396566f5a79$export$127d1aaaa65102b1(v.value0.select));
        throw new Error("Failed pattern match at Widgets.UpdateForm (line 94, column 5 - line 94, column 65): " + [
            v.constructor.name
        ]);
    };
    return $87fd40f8c9231b88$var$bind($87fd40f8c9231b88$var$map1(finalSelection)($035405231d3ae317$export$21159b4378d24276($87fd40f8c9231b88$var$div$prime([]))($87fd40f8c9231b88$export$a96afb83a245e19f(state))))(function(selected) {
        return $87fd40f8c9231b88$var$pure(selected);
    });
};
var $87fd40f8c9231b88$export$79426bf7edbef7ce = function(forms) {
    var count = $87fd40f8c9231b88$var$length(forms);
    return $87fd40f8c9231b88$export$b5bbbcc541974f2e({
        forms: forms,
        header: $c3328e54cdf5154c$export$5a1a8430df9521e("update-semester-for") + (" " + ($87fd40f8c9231b88$var$show(count) + (" " + $c3328e54cdf5154c$export$5a1a8430df9521e("forms")))),
        select: $7178b396566f5a79$export$d967f07ae6c72524("semester")($dc9dc2b43b9526de$export$930f503bd2cd157b)({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-semester")),
            allowDeselect: false
        })
    });
};
var $87fd40f8c9231b88$export$42a90cf60568b9b = function(forms) {
    var count = $87fd40f8c9231b88$var$length(forms);
    return $87fd40f8c9231b88$export$b5bbbcc541974f2e({
        forms: forms,
        header: $c3328e54cdf5154c$export$5a1a8430df9521e("update-teacher-for") + (" " + ($87fd40f8c9231b88$var$show(count) + (" " + $c3328e54cdf5154c$export$5a1a8430df9521e("forms")))),
        select: $7178b396566f5a79$export$d967f07ae6c72524("teacher")($dc9dc2b43b9526de$export$4cc3c70d62d7a856)({
            deselectLabel: $7178b396566f5a79$export$f52b68eea1d2c257.deselectLabel,
            editable: $7178b396566f5a79$export$f52b68eea1d2c257.editable,
            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("search-teacher")),
            allowDeselect: false
        })
    });
};


var $cc65e4880038a74f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $cc65e4880038a74f$var$not = /* #__PURE__ */ $f8fc227945eb179e$export$6003a5f097c73977(/* #__PURE__ */ $f8fc227945eb179e$export$e9ae480d80dfc592($f8fc227945eb179e$export$d7d9283ee84f4c3f));
var $cc65e4880038a74f$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $cc65e4880038a74f$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $cc65e4880038a74f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($b5f6b40b8f63b732$export$d4e35c1cfc1e7503);
var $cc65e4880038a74f$var$fromFoldable$prime = /* #__PURE__ */ $f264ceec36a478ad$export$d782b52044d44562(/* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a))($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $cc65e4880038a74f$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $cc65e4880038a74f$export$4934505d85d8ea04 = /* #__PURE__ */ function() {
    function UpdateSemester() {}
    UpdateSemester.value = new UpdateSemester();
    return UpdateSemester;
}();
var $cc65e4880038a74f$export$a4e49cad429911be = /* #__PURE__ */ function() {
    function UpdateTeacher() {}
    UpdateTeacher.value = new UpdateTeacher();
    return UpdateTeacher;
}();
var $cc65e4880038a74f$export$ddee5dea62089d8d = /* #__PURE__ */ function() {
    function UpdateSemesterSelected(value0) {
        this.value0 = value0;
    }
    UpdateSemesterSelected.create = function(value0) {
        return new UpdateSemesterSelected(value0);
    };
    return UpdateSemesterSelected;
}();
var $cc65e4880038a74f$export$bca2d63a3001f9d6 = /* #__PURE__ */ function() {
    function UpdateTeacherSelected(value0) {
        this.value0 = value0;
    }
    UpdateTeacherSelected.create = function(value0) {
        return new UpdateTeacherSelected(value0);
    };
    return UpdateTeacherSelected;
}();
var $cc65e4880038a74f$export$9cd64935e5cf264c = /* #__PURE__ */ function() {
    function EditDocument(value0) {
        this.value0 = value0;
    }
    EditDocument.create = function(value0) {
        return new EditDocument(value0);
    };
    return EditDocument;
}();
var $cc65e4880038a74f$export$9b7abee7a5a9421c = /* #__PURE__ */ function() {
    function EditDocuments() {}
    EditDocuments.value = new EditDocuments();
    return EditDocuments;
}();
var $cc65e4880038a74f$export$747c16e05a885c2a = /* #__PURE__ */ function() {
    function ToggleDocumentLocks() {}
    ToggleDocumentLocks.value = new ToggleDocumentLocks();
    return ToggleDocumentLocks;
}();
var $cc65e4880038a74f$export$c7d83595be8c07b1 = /* #__PURE__ */ function() {
    function CopyDocuments() {}
    CopyDocuments.value = new CopyDocuments();
    return CopyDocuments;
}();
var $cc65e4880038a74f$export$864b5c5b705745d2 = /* #__PURE__ */ function() {
    function DeleteDocuments() {}
    DeleteDocuments.value = new DeleteDocuments();
    return DeleteDocuments;
}();
var $cc65e4880038a74f$export$482dc0b98af7690c = /* #__PURE__ */ function() {
    function ExportDocuments(value0) {
        this.value0 = value0;
    }
    ExportDocuments.create = function(value0) {
        return new ExportDocuments(value0);
    };
    return ExportDocuments;
}();
var $cc65e4880038a74f$export$efe0b24ea4d5137e = /* #__PURE__ */ function() {
    function RequestSignatures(value0) {
        this.value0 = value0;
    }
    RequestSignatures.create = function(value0) {
        return new RequestSignatures(value0);
    };
    return RequestSignatures;
}();
var $cc65e4880038a74f$export$1d3f1ab8435af5a9 = /* #__PURE__ */ function() {
    function UpdateForms(value0) {
        this.value0 = value0;
    }
    UpdateForms.create = function(value0) {
        return new UpdateForms(value0);
    };
    return UpdateForms;
}();
var $cc65e4880038a74f$export$f9a329ae029c9889 = /* #__PURE__ */ function() {
    function SearchChanged(value0) {
        this.value0 = value0;
    }
    SearchChanged.create = function(value0) {
        return new SearchChanged(value0);
    };
    return SearchChanged;
}();
var $cc65e4880038a74f$export$60db918807a7b577 = /* #__PURE__ */ function() {
    function FormPickerChanged(value0) {
        this.value0 = value0;
    }
    FormPickerChanged.create = function(value0) {
        return new FormPickerChanged(value0);
    };
    return FormPickerChanged;
}();
var $cc65e4880038a74f$export$13ea8ce0e2ccb998 = /* #__PURE__ */ function() {
    function StartFormReorder() {}
    StartFormReorder.value = new StartFormReorder();
    return StartFormReorder;
}();
var $cc65e4880038a74f$export$4474bd630dd3ef5b = /* #__PURE__ */ function() {
    function SaveFormOrder() {}
    SaveFormOrder.value = new SaveFormOrder();
    return SaveFormOrder;
}();
var $cc65e4880038a74f$export$d6d899291526e2a0 = /* #__PURE__ */ function() {
    function ChangePage(value0) {
        this.value0 = value0;
    }
    ChangePage.create = function(value0) {
        return new ChangePage(value0);
    };
    return ChangePage;
}();
var $cc65e4880038a74f$export$67e817d458d93d9f = /* #__PURE__ */ function() {
    function CreateForms() {}
    CreateForms.value = new CreateForms();
    return CreateForms;
}();
var $cc65e4880038a74f$export$1111bee6585f0ea2 = /* #__PURE__ */ function() {
    function StateChanged(value0) {
        this.value0 = value0;
    }
    StateChanged.create = function(value0) {
        return new StateChanged(value0);
    };
    return StateChanged;
}();
var $cc65e4880038a74f$export$a96f88e1928d92fa = /* #__PURE__ */ function() {
    function ViewAction(value0) {
        this.value0 = value0;
    }
    ViewAction.create = function(value0) {
        return new ViewAction(value0);
    };
    return ViewAction;
}();
var $cc65e4880038a74f$export$51b64cdb4a042e2f = /* #__PURE__ */ function() {
    function CopyStudentsSelected(value0) {
        this.value0 = value0;
    }
    CopyStudentsSelected.create = function(value0) {
        return new CopyStudentsSelected(value0);
    };
    return CopyStudentsSelected;
}();
var $cc65e4880038a74f$export$43d85b6b81ad99e0 = /* #__PURE__ */ function() {
    function DeleteConfirmed(value0) {
        this.value0 = value0;
    }
    DeleteConfirmed.create = function(value0) {
        return new DeleteConfirmed(value0);
    };
    return DeleteConfirmed;
}();
var $cc65e4880038a74f$export$7183506d59c388b0 = /* #__PURE__ */ function() {
    function SignatureRequestsSelected(value0) {
        this.value0 = value0;
    }
    SignatureRequestsSelected.create = function(value0) {
        return new SignatureRequestsSelected(value0);
    };
    return SignatureRequestsSelected;
}();
var $cc65e4880038a74f$export$9d697732809bc86 = /* #__PURE__ */ function() {
    function FormsUpdateSelected(value0) {
        this.value0 = value0;
    }
    FormsUpdateSelected.create = function(value0) {
        return new FormsUpdateSelected(value0);
    };
    return FormsUpdateSelected;
}();
var $cc65e4880038a74f$export$57ce4fcebb92740d = function(state) {
    var selected = $506e78fa6ac73d88$export$c1853cad74b031d9(state);
    var locked = $396c4c3d9e7fae3c$export$84bf76cd7afc7469(function($157) {
        return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
            return v.locked_at;
        }($157));
    })(selected);
    var requests = function() {
        if (locked) return $cc65e4880038a74f$var$map(function(form) {
            return {
                form_id: form.id,
                locked: false
            };
        })(selected);
        return $cc65e4880038a74f$var$map(function(form) {
            return {
                form_id: form.id,
                locked: true
            };
        })($396c4c3d9e7fae3c$export$3dea766d36a8935f(function() {
            var $158 = $cc65e4880038a74f$var$not($06733ae99ed4f534$export$c15bd07a493e1236);
            return function($159) {
                return $158(function(v) {
                    return v.locked_at;
                }($159));
            };
        }())(selected));
    }();
    var $37 = $396c4c3d9e7fae3c$export$7b1b591b262c240(selected) || !$396c4c3d9e7fae3c$export$84bf76cd7afc7469(function(form) {
        return form.can.lock;
    })(selected);
    if ($37) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    return new $06733ae99ed4f534$export$8a67b48435b5d073(requests);
};
var $cc65e4880038a74f$export$9fad341ed934648c = function(selection) {
    if (selection instanceof $cc65e4880038a74f$export$ddee5dea62089d8d) return $87fd40f8c9231b88$export$687fad5cef0c511b(new $7d4cccdf062a2261$export$37c4d04eafdc5515(selection.value0));
    if (selection instanceof $cc65e4880038a74f$export$bca2d63a3001f9d6) return $87fd40f8c9231b88$export$687fad5cef0c511b(new $7d4cccdf062a2261$export$19db0165690c701a(selection.value0));
    throw new Error("Failed pattern match at Steps.Step1.Update (line 144, column 36 - line 146, column 73): " + [
        selection.constructor.name
    ]);
};
var $cc65e4880038a74f$export$20413bd7f13c7eb4 = {
    to: function(x) {
        if (x instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$9cd64935e5cf264c(x.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$9b7abee7a5a9421c.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$747c16e05a885c2a.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$c7d83595be8c07b1.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$864b5c5b705745d2.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$482dc0b98af7690c(x.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$efe0b24ea4d5137e(x.value0.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$1d3f1ab8435af5a9(x.value0.value0.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$f9a329ae029c9889(x.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$60db918807a7b577(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$13ea8ce0e2ccb998.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return $cc65e4880038a74f$export$4474bd630dd3ef5b.value;
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$dd5fad028b7772cd) return new $cc65e4880038a74f$export$d6d899291526e2a0(x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0);
        if (x instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6 && x.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0.value0 instanceof $91c996e9c07e3b3f$export$df71ca4577dbdff6) return $cc65e4880038a74f$export$67e817d458d93d9f.value;
        throw new Error("Failed pattern match at Steps.Step1.Update (line 107, column 1 - line 107, column 53): " + [
            x.constructor.name
        ]);
    },
    from: function(x) {
        if (x instanceof $cc65e4880038a74f$export$9cd64935e5cf264c) return new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0);
        if (x instanceof $cc65e4880038a74f$export$9b7abee7a5a9421c) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value));
        if (x instanceof $cc65e4880038a74f$export$747c16e05a885c2a) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)));
        if (x instanceof $cc65e4880038a74f$export$c7d83595be8c07b1) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value))));
        if (x instanceof $cc65e4880038a74f$export$864b5c5b705745d2) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))));
        if (x instanceof $cc65e4880038a74f$export$482dc0b98af7690c) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))))));
        if (x instanceof $cc65e4880038a74f$export$efe0b24ea4d5137e) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)))))));
        if (x instanceof $cc65e4880038a74f$export$1d3f1ab8435af5a9) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))))))));
        if (x instanceof $cc65e4880038a74f$export$f9a329ae029c9889) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)))))))));
        if (x instanceof $cc65e4880038a74f$export$60db918807a7b577) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0))))))))));
        if (x instanceof $cc65e4880038a74f$export$13ea8ce0e2ccb998) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))))))))));
        if (x instanceof $cc65e4880038a74f$export$4474bd630dd3ef5b) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd($91c996e9c07e3b3f$export$928c7f2d618c070b.value))))))))))));
        if (x instanceof $cc65e4880038a74f$export$d6d899291526e2a0) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$dd5fad028b7772cd(x.value0)))))))))))));
        if (x instanceof $cc65e4880038a74f$export$67e817d458d93d9f) return new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6(new $91c996e9c07e3b3f$export$df71ca4577dbdff6($91c996e9c07e3b3f$export$928c7f2d618c070b.value)))))))))))));
        throw new Error("Failed pattern match at Steps.Step1.Update (line 107, column 1 - line 107, column 53): " + [
            x.constructor.name
        ]);
    }
};
var $cc65e4880038a74f$export$8e52f6005dd813ab = function(etype) {
    return $cc65e4880038a74f$var$find(function(rep) {
        return rep.label === etype.id;
    });
};
var $cc65e4880038a74f$export$3c5449791d1f24b2 = function(state) {
    return function(sel) {
        var copyReqs = function(dictFunctor) {
            var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function(dictFoldable) {
                var fromFoldable1 = $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072(dictFoldable);
                return function(students) {
                    return function(docId) {
                        return fromFoldable1(map2(function(s) {
                            return {
                                form_id: docId,
                                student_id: s.id
                            };
                        })(students));
                    };
                };
            };
        };
        return $396c4c3d9e7fae3c$export$c28c8388be0ab31a(function() {
            var $160 = copyReqs($78c799cba34fcb8d$export$40b9e4330ffd17e3)($78c799cba34fcb8d$export$92659ee1fc91a075)($f264ceec36a478ad$export$7693e0a1b9351086(sel));
            return function($161) {
                return $160(function(v) {
                    return v.id;
                }($161));
            };
        }())($506e78fa6ac73d88$export$c1853cad74b031d9(state));
    };
};
var $cc65e4880038a74f$export$c3e5bd4d38a8f2e = function(results) {
    return function(state) {
        var patchDoc = function(results$prime) {
            return function(form) {
                return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(form)(function(result) {
                    return $d4a8d5b15f9925c4$export$b33531c26796487b(result)(form);
                })($cc65e4880038a74f$var$find(function(result) {
                    return $cc65e4880038a74f$var$eq1(result.id)(form.id);
                })(results$prime));
            };
        };
        return {
            searchState: state.searchState,
            formPicker: state.formPicker,
            state: state.state,
            searchVersion: state.searchVersion,
            recentForms: $cc65e4880038a74f$var$map1(patchDoc(results))(state.recentForms),
            selection: $cc65e4880038a74f$var$fromFoldable$prime($cc65e4880038a74f$var$map(patchDoc(results))($cc65e4880038a74f$var$fromFoldable($f264ceec36a478ad$export$7693e0a1b9351086(state.selection))))
        };
    };
};
var $cc65e4880038a74f$export$5d56a4bb5c081171 = function(selection) {
    return function(state) {
        if (selection instanceof $cc65e4880038a74f$export$ddee5dea62089d8d) return $506e78fa6ac73d88$export$2088df704cfb48f3({
            teacher: state.searchState.teacher,
            "class": state["searchState"]["class"],
            keyword: state.searchState.keyword,
            semester: $7178b396566f5a79$export$5a4818cec1656a71(state.searchState.semester)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                label: selection.value0.name,
                value: selection.value0
            }))
        })(state);
        if (selection instanceof $cc65e4880038a74f$export$bca2d63a3001f9d6) return $506e78fa6ac73d88$export$2088df704cfb48f3({
            semester: state.searchState.semester,
            "class": state["searchState"]["class"],
            keyword: state.searchState.keyword,
            teacher: $7178b396566f5a79$export$5a4818cec1656a71(state.searchState.teacher)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                label: selection.value0.name,
                value: selection.value0
            }))
        })(state);
        throw new Error("Failed pattern match at Steps.Step1.Update (line 133, column 45 - line 141, column 18): " + [
            selection.constructor.name
        ]);
    };
};


// Generated by purs version 0.15.16












// Generated by purs version 0.15.16
const $665ad67fbfae39ca$var$debugDiffLimit = 20;
const $665ad67fbfae39ca$var$isObject = function(value) {
    return value !== null && typeof value === "object";
};
const $665ad67fbfae39ca$var$pushDiff = function(diffs, path) {
    if (diffs.length < $665ad67fbfae39ca$var$debugDiffLimit) diffs.push(path === "" ? "$" : path);
};
const $665ad67fbfae39ca$var$diffJson = function(left, right, path, diffs) {
    if (diffs.length >= $665ad67fbfae39ca$var$debugDiffLimit || left === right) return;
    const leftIsArray = Array.isArray(left);
    const rightIsArray = Array.isArray(right);
    if (leftIsArray || rightIsArray) {
        if (!leftIsArray || !rightIsArray) {
            $665ad67fbfae39ca$var$pushDiff(diffs, path);
            return;
        }
        if (left.length !== right.length) $665ad67fbfae39ca$var$pushDiff(diffs, path + ".length");
        const maxLength = Math.max(left.length, right.length);
        for(let index = 0; index < maxLength && diffs.length < $665ad67fbfae39ca$var$debugDiffLimit; index += 1)$665ad67fbfae39ca$var$diffJson(left[index], right[index], `${path}[${index}]`, diffs);
        return;
    }
    if ($665ad67fbfae39ca$var$isObject(left) || $665ad67fbfae39ca$var$isObject(right)) {
        if (!$665ad67fbfae39ca$var$isObject(left) || !$665ad67fbfae39ca$var$isObject(right)) {
            $665ad67fbfae39ca$var$pushDiff(diffs, path);
            return;
        }
        const keys = Array.from(new Set([
            ...Object.keys(left),
            ...Object.keys(right)
        ])).sort();
        for (const key of keys){
            if (diffs.length >= $665ad67fbfae39ca$var$debugDiffLimit) break;
            $665ad67fbfae39ca$var$diffJson(left[key], right[key], path === "" ? key : `${path}.${key}`, diffs);
        }
        return;
    }
    $665ad67fbfae39ca$var$pushDiff(diffs, path);
};
const $665ad67fbfae39ca$export$d87cbe75b68eae9f = function(left) {
    return function(right) {
        const diffs = [];
        $665ad67fbfae39ca$var$diffJson(left, right, "", diffs);
        return diffs;
    };
};





















// Generated by purs version 0.15.16











// Generated by purs version 0.15.16




// Generated by purs version 0.15.16















var $fce7eb63608cf274$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $fce7eb63608cf274$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $fce7eb63608cf274$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $fce7eb63608cf274$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f388db8e60bd7b97$export$95f6bcb3dd5567b3);
var $fce7eb63608cf274$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $fce7eb63608cf274$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $fce7eb63608cf274$var$asField = /* #__PURE__ */ $f388db8e60bd7b97$export$5a271d199eca9d6f($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $fce7eb63608cf274$var$fieldPaths = /* #__PURE__ */ $f388db8e60bd7b97$export$e47c1863c8ac83c1($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $fce7eb63608cf274$export$acf666f77943fd8e = function(fc) {
    return function(json) {
        return function(state) {
            var jsonCtx = new $54dae5ca6a6cd16d$export$b6cbb081e89a6a3c("form data", json);
            return $54dae5ca6a6cd16d$export$226c98f2a504b8e8("loading data into form")($54dae5ca6a6cd16d$export$60030d78f255e2a6(jsonCtx)($fce7eb63608cf274$var$bind($227bc4e21b5ff268$export$29f26d7e03874a4b(fc)(state.fields)(json))(function(fields) {
                return $fce7eb63608cf274$var$pure({
                    access: state.access,
                    id: state.id,
                    label: state.label,
                    fields: fields
                });
            })));
        };
    };
};
var $fce7eb63608cf274$export$6dbd705fbb1240f9 = function(v) {
    return {
        id: v.id,
        label: v.label,
        access: $81439e1d9c94314f$export$e3358a95f047f6be,
        fields: v.fields
    };
};
var $fce7eb63608cf274$export$b776d5862f56b816 = function(v) {
    return {
        id: v.id,
        label: v.label,
        access: $81439e1d9c94314f$export$e3358a95f047f6be,
        fields: []
    };
};
var $fce7eb63608cf274$export$9750270299d2035e = function(fc) {
    return function(state) {
        return $fce7eb63608cf274$var$map(function(v) {
            return $fce7eb63608cf274$var$map1(function(v1) {
                return {
                    access: state.access,
                    id: state.id,
                    label: state.label,
                    fields: v1
                };
            })(v);
        })($fce7eb63608cf274$var$div([
            $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$a1b0f5347d2470b(state.id)),
            $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$a1b0f5347d2470b(state.id))
        ])([
            $fce7eb63608cf274$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-3-form")
            ])($227bc4e21b5ff268$export$5a3266b2878a24b0(fc)(state.fields))
        ]));
    };
};
var $fce7eb63608cf274$export$1ef0edd00f5680d9 = function(state) {
    return $396c4c3d9e7fae3c$export$986c2bbe7a34be0b($fce7eb63608cf274$var$map2($fce7eb63608cf274$var$asField)(state.fields));
};
var $fce7eb63608cf274$export$75582e7163e58bf8 = function(state) {
    return $396c4c3d9e7fae3c$export$c28c8388be0ab31a($fce7eb63608cf274$var$fieldPaths($f388db8e60bd7b97$export$5f8bbb7bf801e4b8))(state.fields);
};
var $fce7eb63608cf274$export$c3f886ccd454773d = function(state) {
    return $227bc4e21b5ff268$export$c809b8b516ff0c2b($f388db8e60bd7b97$export$5f8bbb7bf801e4b8)(state.fields);
};



var $d80c98e0cfb5ecff$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $d80c98e0cfb5ecff$export$f899e8621fb9fc2e = /* #__PURE__ */ function() {
    function EditablePrivileged() {}
    EditablePrivileged.value = new EditablePrivileged();
    return EditablePrivileged;
}();
var $d80c98e0cfb5ecff$export$3382853a93f59725 = /* #__PURE__ */ function() {
    function EditableUnprivileged() {}
    EditableUnprivileged.value = new EditableUnprivileged();
    return EditableUnprivileged;
}();
var $d80c98e0cfb5ecff$export$d7c139d4ebed1869 = /* #__PURE__ */ function() {
    function UneditablePrivileged() {}
    UneditablePrivileged.value = new UneditablePrivileged();
    return UneditablePrivileged;
}();
var $d80c98e0cfb5ecff$export$aa769cc8574b3ea5 = /* #__PURE__ */ function() {
    function UneditableUnprivileged() {}
    UneditableUnprivileged.value = new UneditableUnprivileged();
    return UneditableUnprivileged;
}();
var $d80c98e0cfb5ecff$export$f051c875841ef882 = function(canLock) {
    return function(lockedAt) {
        return function(form) {
            var isMutableField = function(path) {
                return $81439e1d9c94314f$export$83c457eff4ed3d7f($81439e1d9c94314f$export$7628927e17b1a329(form.access)(path));
            };
            var hasEditableFields = $d80c98e0cfb5ecff$var$any(isMutableField)($fce7eb63608cf274$export$75582e7163e58bf8(form));
            var lockedBanner = function() {
                if (lockedAt instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                if (lockedAt instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $06733ae99ed4f534$export$8a67b48435b5d073(function() {
                    if (canLock) {
                        if (hasEditableFields) return $d80c98e0cfb5ecff$export$f899e8621fb9fc2e.value;
                        return $d80c98e0cfb5ecff$export$d7c139d4ebed1869.value;
                    }
                    if (hasEditableFields) return $d80c98e0cfb5ecff$export$3382853a93f59725.value;
                    return $d80c98e0cfb5ecff$export$aa769cc8574b3ea5.value;
                }());
                throw new Error("Failed pattern match at Steps.Step3.Editability (line 33, column 20 - line 42, column 44): " + [
                    lockedAt.constructor.name
                ]);
            }();
            return {
                hasEditableFields: hasEditableFields,
                lockedBanner: lockedBanner
            };
        };
    };
};
var $d80c98e0cfb5ecff$export$21c24179c714a7d = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e && y instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return true;
            if (x instanceof $d80c98e0cfb5ecff$export$3382853a93f59725 && y instanceof $d80c98e0cfb5ecff$export$3382853a93f59725) return true;
            if (x instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869 && y instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return true;
            if (x instanceof $d80c98e0cfb5ecff$export$aa769cc8574b3ea5 && y instanceof $d80c98e0cfb5ecff$export$aa769cc8574b3ea5) return true;
            return false;
        };
    }
};
var $d80c98e0cfb5ecff$export$2c484eb8d3de2474 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e && y instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $d80c98e0cfb5ecff$export$3382853a93f59725 && y instanceof $d80c98e0cfb5ecff$export$3382853a93f59725) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $d80c98e0cfb5ecff$export$3382853a93f59725) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $d80c98e0cfb5ecff$export$3382853a93f59725) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869 && y instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $d80c98e0cfb5ecff$export$aa769cc8574b3ea5 && y instanceof $d80c98e0cfb5ecff$export$aa769cc8574b3ea5) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Steps.Step3.Editability (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $d80c98e0cfb5ecff$export$21c24179c714a7d;
    }
};


// Generated by purs version 0.15.16


var $59a05a7e29977bc8$export$5fc55f6f4f65719f = /* #__PURE__ */ function() {
    function PushStep3History() {}
    PushStep3History.value = new PushStep3History();
    return PushStep3History;
}();
var $59a05a7e29977bc8$export$7bdb1b708831338 = /* #__PURE__ */ function() {
    function ReplaceStep3History() {}
    ReplaceStep3History.value = new ReplaceStep3History();
    return ReplaceStep3History;
}();
var $59a05a7e29977bc8$export$feb5b876e65d414b = function(state) {
    return function(generation) {
        if (state.latest instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return state.latest.value0.generation === generation;
        if (state.latest instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
        throw new Error("Failed pattern match at Steps.Step3.Transition (line 64, column 40 - line 66, column 21): " + [
            state.latest.constructor.name
        ]);
    };
};
var $59a05a7e29977bc8$export$652a4dc1150a2d6 = function(v) {
    return v.latest;
};
var $59a05a7e29977bc8$export$2ad361b4f37e39e9 = function(state) {
    return function(generation) {
        if (state.latest instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && state.latest.value0.generation === generation) return new $71f2e2e9476163f8$export$1908877435b1d5e9(true, {
            nextGeneration: state.nextGeneration,
            active: false,
            latest: $06733ae99ed4f534$export$bebe9059409a0d04.value
        });
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(false, state);
    };
};
var $59a05a7e29977bc8$export$544584b96aebcf5 = function(state) {
    return function(position) {
        return function(anchor) {
            var historyMode = function() {
                if (state.latest instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return state.latest.value0.historyMode;
                if (state.latest instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $59a05a7e29977bc8$export$5fc55f6f4f65719f.value;
                throw new Error("Failed pattern match at Steps.Step3.Transition (line 47, column 23 - line 49, column 40): " + [
                    state.latest.constructor.name
                ]);
            }();
            var generation = state.nextGeneration + 1 | 0;
            var pending = {
                generation: generation,
                position: position,
                anchor: anchor,
                historyMode: historyMode
            };
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(!state.active, {
                active: true,
                latest: new $06733ae99ed4f534$export$8a67b48435b5d073(pending),
                nextGeneration: generation
            });
        };
    };
};
var $59a05a7e29977bc8$export$21bdadac9c425db2 = /* #__PURE__ */ function() {
    return {
        active: false,
        latest: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        nextGeneration: 0
    };
}();





var $004747e47cb4edd5$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $004747e47cb4edd5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $004747e47cb4edd5$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $004747e47cb4edd5$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $004747e47cb4edd5$export$65ca4a46ee1b7c38 = /* #__PURE__ */ function() {
    function CommentCreated(value0) {
        this.value0 = value0;
    }
    CommentCreated.create = function(value0) {
        return new CommentCreated(value0);
    };
    return CommentCreated;
}();
var $004747e47cb4edd5$export$d59dddaa17dd7b8a = /* #__PURE__ */ function() {
    function CommentUpdated(value0) {
        this.value0 = value0;
    }
    CommentUpdated.create = function(value0) {
        return new CommentUpdated(value0);
    };
    return CommentUpdated;
}();
var $004747e47cb4edd5$export$17adc4f7fe1cd3b8 = /* #__PURE__ */ function() {
    function CommentDeleted(value0) {
        this.value0 = value0;
    }
    CommentDeleted.create = function(value0) {
        return new CommentDeleted(value0);
    };
    return CommentDeleted;
}();
var $004747e47cb4edd5$export$f00646e890d6b596 = /* #__PURE__ */ function() {
    function AttachmentCreated(value0) {
        this.value0 = value0;
    }
    AttachmentCreated.create = function(value0) {
        return new AttachmentCreated(value0);
    };
    return AttachmentCreated;
}();
var $004747e47cb4edd5$export$8ba32d49227f419c = /* #__PURE__ */ function() {
    function AttachmentDeleted(value0) {
        this.value0 = value0;
    }
    AttachmentDeleted.create = function(value0) {
        return new AttachmentDeleted(value0);
    };
    return AttachmentDeleted;
}();
var $004747e47cb4edd5$export$8004e50c9b7bd668 = /* #__PURE__ */ function() {
    function SignatureSigned(value0) {
        this.value0 = value0;
    }
    SignatureSigned.create = function(value0) {
        return new SignatureSigned(value0);
    };
    return SignatureSigned;
}();
var $004747e47cb4edd5$export$dbed4d58d2dad4e1 = /* #__PURE__ */ function() {
    function SignatureSignedAndRefreshed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SignatureSignedAndRefreshed.create = function(value0) {
        return function(value1) {
            return new SignatureSignedAndRefreshed(value0, value1);
        };
    };
    return SignatureSignedAndRefreshed;
}();
var $004747e47cb4edd5$export$18586e5d3073eff6 = /* #__PURE__ */ function() {
    function SignatureGroupRefreshed(value0) {
        this.value0 = value0;
    }
    SignatureGroupRefreshed.create = function(value0) {
        return new SignatureGroupRefreshed(value0);
    };
    return SignatureGroupRefreshed;
}();
var $004747e47cb4edd5$export$edafdbf2e37712a7 = /* #__PURE__ */ function() {
    function SignaturesRequested(value0) {
        this.value0 = value0;
    }
    SignaturesRequested.create = function(value0) {
        return new SignaturesRequested(value0);
    };
    return SignaturesRequested;
}();
var $004747e47cb4edd5$export$b217475cf0d7b767 = /* #__PURE__ */ function() {
    function CreateComment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CreateComment.create = function(value0) {
        return function(value1) {
            return new CreateComment(value0, value1);
        };
    };
    return CreateComment;
}();
var $004747e47cb4edd5$export$45f887c8c5fa0732 = /* #__PURE__ */ function() {
    function UpdateComment(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    UpdateComment.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new UpdateComment(value0, value1, value2);
            };
        };
    };
    return UpdateComment;
}();
var $004747e47cb4edd5$export$5ec1b5bc07c6cb4d = /* #__PURE__ */ function() {
    function DeleteComment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DeleteComment.create = function(value0) {
        return function(value1) {
            return new DeleteComment(value0, value1);
        };
    };
    return DeleteComment;
}();
var $004747e47cb4edd5$export$d70fd387bd54d491 = /* #__PURE__ */ function() {
    function CreateAttachment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    CreateAttachment.create = function(value0) {
        return function(value1) {
            return new CreateAttachment(value0, value1);
        };
    };
    return CreateAttachment;
}();
var $004747e47cb4edd5$export$a4c37d342183ceb6 = /* #__PURE__ */ function() {
    function DeleteAttachment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DeleteAttachment.create = function(value0) {
        return function(value1) {
            return new DeleteAttachment(value0, value1);
        };
    };
    return DeleteAttachment;
}();
var $004747e47cb4edd5$export$5d04178ec625702c = /* #__PURE__ */ function() {
    function SignWithCapturedSignature(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    SignWithCapturedSignature.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new SignWithCapturedSignature(value0, value1, value2, value3);
                };
            };
        };
    };
    return SignWithCapturedSignature;
}();
var $004747e47cb4edd5$export$f904c183433cbd62 = /* #__PURE__ */ function() {
    function SignWithSavedSignature(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SignWithSavedSignature.create = function(value0) {
        return function(value1) {
            return new SignWithSavedSignature(value0, value1);
        };
    };
    return SignWithSavedSignature;
}();
var $004747e47cb4edd5$export$5f8c57fd8a0528b5 = /* #__PURE__ */ function() {
    function RefreshSignatureGroup(value0) {
        this.value0 = value0;
    }
    RefreshSignatureGroup.create = function(value0) {
        return new RefreshSignatureGroup(value0);
    };
    return RefreshSignatureGroup;
}();
var $004747e47cb4edd5$export$efe0b24ea4d5137e = /* #__PURE__ */ function() {
    function RequestSignatures(value0) {
        this.value0 = value0;
    }
    RequestSignatures.create = function(value0) {
        return new RequestSignatures(value0);
    };
    return RequestSignatures;
}();
var $004747e47cb4edd5$export$dfd508fe3dcbbd6c = /* #__PURE__ */ function() {
    function JumpIdxF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    JumpIdxF.create = function(value0) {
        return function(value1) {
            return new JumpIdxF(value0, value1);
        };
    };
    return JumpIdxF;
}();
var $004747e47cb4edd5$export$8533e0fafe25e95c = /* #__PURE__ */ function() {
    function JumpF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    JumpF.create = function(value0) {
        return function(value1) {
            return new JumpF(value0, value1);
        };
    };
    return JumpF;
}();
var $004747e47cb4edd5$export$7ede261876d0a33b = /* #__PURE__ */ function() {
    function NextF() {}
    NextF.value = new NextF();
    return NextF;
}();
var $004747e47cb4edd5$export$c4ad6737b29d969c = /* #__PURE__ */ function() {
    function PrevF() {}
    PrevF.value = new PrevF();
    return PrevF;
}();
var $004747e47cb4edd5$export$e3a394a4520b57d = /* #__PURE__ */ function() {
    function CancelF() {}
    CancelF.value = new CancelF();
    return CancelF;
}();
var $004747e47cb4edd5$export$f5fbd132133a04d = /* #__PURE__ */ function() {
    function ExportF(value0) {
        this.value0 = value0;
    }
    ExportF.create = function(value0) {
        return new ExportF(value0);
    };
    return ExportF;
}();
var $004747e47cb4edd5$export$98c157c18e27e4f3 = /* #__PURE__ */ function() {
    function SaveCancelF() {}
    SaveCancelF.value = new SaveCancelF();
    return SaveCancelF;
}();
var $004747e47cb4edd5$export$e685275cfc27c6c5 = /* #__PURE__ */ function() {
    function SaveF() {}
    SaveF.value = new SaveF();
    return SaveF;
}();
var $004747e47cb4edd5$export$e1e34d312d713b51 = /* #__PURE__ */ function() {
    function AutofillF() {}
    AutofillF.value = new AutofillF();
    return AutofillF;
}();
var $004747e47cb4edd5$export$6b3072bafbdce7c = /* #__PURE__ */ function() {
    function ToggleLockF() {}
    ToggleLockF.value = new ToggleLockF();
    return ToggleLockF;
}();
var $004747e47cb4edd5$export$153c58c8dcae1967 = /* #__PURE__ */ function() {
    function StateF(value0) {
        this.value0 = value0;
    }
    StateF.create = function(value0) {
        return new StateF(value0);
    };
    return StateF;
}();
var $004747e47cb4edd5$export$91696afd1b09da8d = /* #__PURE__ */ function() {
    function WorkQueueMetadataF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    WorkQueueMetadataF.create = function(value0) {
        return function(value1) {
            return new WorkQueueMetadataF(value0, value1);
        };
    };
    return WorkQueueMetadataF;
}();
var $004747e47cb4edd5$export$804e7e4188df63ae = /* #__PURE__ */ function() {
    function WorkQF(value0) {
        this.value0 = value0;
    }
    WorkQF.create = function(value0) {
        return new WorkQF(value0);
    };
    return WorkQF;
}();
var $004747e47cb4edd5$export$ce23c5d6d3d89659 = /* #__PURE__ */ function() {
    function ActionF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ActionF.create = function(value0) {
        return function(value1) {
            return new ActionF(value0, value1);
        };
    };
    return ActionF;
}();
var $004747e47cb4edd5$export$9e35bbe1cc73cc01 = /* #__PURE__ */ function() {
    function DocumentMutationF(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DocumentMutationF.create = function(value0) {
        return function(value1) {
            return new DocumentMutationF(value0, value1);
        };
    };
    return DocumentMutationF;
}();
var $004747e47cb4edd5$export$d5948ddb259ca298 = /* #__PURE__ */ function() {
    function ScrollF() {}
    ScrollF.value = new ScrollF();
    return ScrollF;
}();
var $004747e47cb4edd5$var$updateTransition = function(state) {
    return function(idx) {
        return function(section) {
            var v = $59a05a7e29977bc8$export$544584b96aebcf5(state.transitionState)(idx)(section);
            return {
                queue: state.queue,
                position: state.position,
                anchor: state.anchor,
                activeSection: state.activeSection,
                sectionIntent: state.sectionIntent,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                workQueueCache: state.workQueueCache,
                fillState: state.fillState,
                transitionState: v.value1
            };
        };
    };
};
var $004747e47cb4edd5$export$600ab3f29580dc1d = function(v) {
    return function(state) {
        var doc = function() {
            var v1 = $d4a8d5b15f9925c4$export$b33531c26796487b(v)(state.fillState.doc);
            return {
                attachments: v1.attachments,
                can: v1.can,
                comments: v1.comments,
                contact: v1.contact,
                courses: v1.courses,
                created_at: v1.created_at,
                employer: v1.employer,
                exports: v1.exports,
                formId: v1.formId,
                formName: v1.formName,
                id: v1.id,
                json: v1.json,
                locked_at: v1.locked_at,
                mutations: v1.mutations,
                position: v1.position,
                semester: v1.semester,
                signature_fields: v1.signature_fields,
                signatures: v1.signatures,
                student: v1.student,
                teacher: v1.teacher,
                updated_at: v1.updated_at,
                verifications: v1.verifications,
                access: v.access
            };
        }();
        var fillState = {
            attachments: state.fillState.attachments,
            comments: state.fillState.comments,
            preview: state.fillState.preview,
            signatures: state.fillState.signatures,
            doc: doc,
            form: {
                fields: state.fillState.form.fields,
                id: state.fillState.form.id,
                label: state.fillState.form.label,
                access: v.access
            }
        };
        var patchEditDoc = function(editDoc) {
            if ($004747e47cb4edd5$var$eq(editDoc.id)(doc.id)) return $d4a8d5b15f9925c4$export$b33531c26796487b(v)(editDoc);
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return editDoc;
            throw new Error("Failed pattern match at Steps.Step3.Types (line 195, column 5 - line 197, column 30): " + [
                editDoc.constructor.name
            ]);
        };
        var workQueueState$prime = $740d96ccf08cc464$export$2b433fd4c99efbc7(doc)(state.workQueueState);
        var workQueueState = {
            currentDoc: workQueueState$prime.currentDoc,
            documents: workQueueState$prime.documents,
            forms: workQueueState$prime.forms,
            semester: workQueueState$prime.semester,
            students: workQueueState$prime.students,
            teacher: workQueueState$prime.teacher,
            editDocs: $004747e47cb4edd5$var$map(patchEditDoc)(workQueueState$prime.editDocs)
        };
        return {
            queue: state.queue,
            position: state.position,
            anchor: state.anchor,
            activeSection: state.activeSection,
            sectionIntent: state.sectionIntent,
            transitionState: state.transitionState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            fillState: fillState,
            workQueueState: workQueueState
        };
    };
};
var $004747e47cb4edd5$export$a3f5e6a68ce798dd = function(state) {
    return state.position > ($004747e47cb4edd5$var$length(state.queue) - 2 | 0);
};
var $004747e47cb4edd5$export$a2f4038426073961 = function(state) {
    return state.position <= 0;
};
var $004747e47cb4edd5$export$71f9afd025e5af6b = function(lookup) {
    return function(entry) {
        return $004747e47cb4edd5$var$eq(entry.student)(lookup.studentId) && function() {
            if (entry.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && lookup.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $004747e47cb4edd5$var$eq(entry.form.value0.id)(lookup.documentId.value0);
            if (entry.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515 && lookup.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $004747e47cb4edd5$var$eq(entry.form.value0.form_type.id)(lookup.formId);
            if (entry.form instanceof $7d4cccdf062a2261$export$19db0165690c701a && lookup.documentId instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return false;
            if (entry.form instanceof $7d4cccdf062a2261$export$19db0165690c701a && lookup.documentId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $004747e47cb4edd5$var$eq(entry.form.value0)(lookup.formId);
            throw new Error("Failed pattern match at Steps.Step3.Types (line 177, column 42 - line 181, column 57): " + [
                entry.form.constructor.name,
                lookup.documentId.constructor.name
            ]);
        }();
    };
};
var $004747e47cb4edd5$export$43055f49ea9b191 = function(v) {
    return function(maybeDoc) {
        return new $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90($004747e47cb4edd5$var$map1(function(v1) {
            return v1.id;
        })(maybeDoc));
    };
};
var $004747e47cb4edd5$export$7da4e93a98b07b0 = function(state) {
    return $d80c98e0cfb5ecff$export$f051c875841ef882(state.doc.can.lock)(state.doc.locked_at)(state.form);
};
var $004747e47cb4edd5$export$9a86059719a658b0 = function($62) {
    return function(v) {
        return v.hasEditableFields;
    }($004747e47cb4edd5$export$7da4e93a98b07b0($62));
};
var $004747e47cb4edd5$export$5176e9d4c30fcf2b = function(workQueueCache) {
    return function(state) {
        var v = $f388db8e60bd7b97$export$a5b3020661ae748a(workQueueCache.account)(state.doc);
        return {
            parentIds: v.parentIds,
            curIndex: v.curIndex,
            isAutofilling: v.isAutofilling,
            autofillArgs: v.autofillArgs,
            account: v.account,
            doc: v.doc,
            access: state.form.access
        };
    };
};
var $004747e47cb4edd5$var$enqueueLookupTransition = function(state) {
    return function(lookup) {
        return function(section) {
            var v = $396c4c3d9e7fae3c$export$de3a4d4a0d731119($004747e47cb4edd5$export$71f9afd025e5af6b(lookup))(state.queue);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $004747e47cb4edd5$var$updateTransition(state)(v.value0)(section);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return state;
            throw new Error("Failed pattern match at Steps.Step3.Types (line 166, column 48 - line 168, column 21): " + [
                v.constructor.name
            ]);
        };
    };
};
var $004747e47cb4edd5$export$2d9bd4578fa0224c = /* #__PURE__ */ function() {
    return {
        signatures: true,
        sideAndTopBar: true,
        updateUrl: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        onCancel: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        onFinish: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
}();
var $004747e47cb4edd5$export$3a45131c6a577a09 = function(state) {
    return $396c4c3d9e7fae3c$export$b610b8812bbcded9(state.queue)(state.position);
};
var $004747e47cb4edd5$export$1643e1ff55422bba = function(state) {
    var v = $004747e47cb4edd5$export$3a45131c6a577a09(state);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.value0.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.form.value0.id));
    return new $a8c8b5353c92bbbb$export$53a18f1ce6cf1e90($06733ae99ed4f534$export$bebe9059409a0d04.value);
};
var $004747e47cb4edd5$export$93e2410c29660ed1 = function(state) {
    return function(v) {
        if (v instanceof $004747e47cb4edd5$export$804e7e4188df63ae && v.value0 instanceof $356f5ce902fa042d$export$a80f920dd4c867c2) return {
            queue: state.queue,
            position: state.position,
            anchor: state.anchor,
            activeSection: state.activeSection,
            sectionIntent: state.sectionIntent,
            transitionState: state.transitionState,
            workQueueState: state.workQueueState,
            workQueueCache: state.workQueueCache,
            fillState: state.fillState,
            workQueueUi: v.value0.value0
        };
        if (v instanceof $004747e47cb4edd5$export$804e7e4188df63ae && v.value0 instanceof $356f5ce902fa042d$export$d25f9f533b57ed2) return $004747e47cb4edd5$var$enqueueLookupTransition(state)(v.value0.value0.lookup)(v.value0.value0.section);
        if (v instanceof $004747e47cb4edd5$export$8533e0fafe25e95c) return $004747e47cb4edd5$var$enqueueLookupTransition(state)(v.value0)(v.value1);
        if (v instanceof $004747e47cb4edd5$export$dfd508fe3dcbbd6c && v.value0 >= 0 && v.value0 < $004747e47cb4edd5$var$length(state.queue)) return $004747e47cb4edd5$var$updateTransition(state)(v.value0)(v.value1);
        if (v instanceof $004747e47cb4edd5$export$7ede261876d0a33b && !$004747e47cb4edd5$export$a3f5e6a68ce798dd(state)) return $004747e47cb4edd5$var$updateTransition(state)(state.position + 1 | 0)($06733ae99ed4f534$export$bebe9059409a0d04.value);
        if (v instanceof $004747e47cb4edd5$export$c4ad6737b29d969c && state.position > 0) return $004747e47cb4edd5$var$updateTransition(state)(state.position - 1 | 0)($06733ae99ed4f534$export$bebe9059409a0d04.value);
        return state;
    };
};




// Generated by purs version 0.15.16
















// Generated by purs version 0.15.16










var $46bd9e377310b7ba$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $46bd9e377310b7ba$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($46bd9e377310b7ba$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $46bd9e377310b7ba$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($46bd9e377310b7ba$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $46bd9e377310b7ba$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $46bd9e377310b7ba$var$p = /* #__PURE__ */ $3eadc1b959dd1120$export$ffb5f4729a158638($46bd9e377310b7ba$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $46bd9e377310b7ba$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($46bd9e377310b7ba$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $46bd9e377310b7ba$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $46bd9e377310b7ba$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $46bd9e377310b7ba$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $46bd9e377310b7ba$export$4a889a183052e7fa = function(title) {
    return function(primaryButtonText) {
        return function(msg) {
            return $46bd9e377310b7ba$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("confirmation-widget modal-grid")
            ])([
                $46bd9e377310b7ba$var$h1([
                    $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
                ])([
                    $46bd9e377310b7ba$var$text(title)
                ]),
                $46bd9e377310b7ba$var$p([
                    $fc1df90f0e252058$export$2913c0c0b5623090("modal-body")
                ])([
                    $46bd9e377310b7ba$var$text(msg)
                ]),
                $46bd9e377310b7ba$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn-group btn-group-confirmation-dialog modal-buttons")
                ])([
                    $46bd9e377310b7ba$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                        $46bd9e377310b7ba$var$voidRight(false)($fc1df90f0e252058$export$1d5a917feb871989)
                    ])([
                        $46bd9e377310b7ba$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
                    ]),
                    $46bd9e377310b7ba$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                        $46bd9e377310b7ba$var$voidRight(true)($fc1df90f0e252058$export$1d5a917feb871989)
                    ])([
                        $46bd9e377310b7ba$var$text(primaryButtonText)
                    ])
                ])
            ]);
        };
    };
};
var $46bd9e377310b7ba$export$50d8d0e36b3c9ab6 = function(outer) {
    return function(title) {
        return function(primaryButtonText) {
            return function(msg) {
                return $46bd9e377310b7ba$var$bind($035405231d3ae317$export$21159b4378d24276(outer)($46bd9e377310b7ba$export$4a889a183052e7fa(title)(primaryButtonText)(msg)))(function(v) {
                    if (v instanceof $035405231d3ae317$export$a09a21bd8097e7) return $46bd9e377310b7ba$var$pure(false);
                    if (v instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $46bd9e377310b7ba$var$pure(v.value0);
                    throw new Error("Failed pattern match at Widgets.Confirmation (line 11, column 116 - line 13, column 30): " + [
                        v.constructor.name
                    ]);
                });
            };
        };
    };
};


// Generated by purs version 0.15.16
"use strict";
const $86d95ff9dd604c39$export$3b118c8dea28c6b0 = function(id) {
    return function() {
        var upload = document.getElementById(id);
        return upload.files[0];
    };
};




var $67a3c28b4000eb60$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $67a3c28b4000eb60$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $67a3c28b4000eb60$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $67a3c28b4000eb60$var$p = /* #__PURE__ */ $3eadc1b959dd1120$export$ffb5f4729a158638($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $67a3c28b4000eb60$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $67a3c28b4000eb60$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($67a3c28b4000eb60$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $67a3c28b4000eb60$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $67a3c28b4000eb60$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $67a3c28b4000eb60$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $67a3c28b4000eb60$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $67a3c28b4000eb60$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $67a3c28b4000eb60$export$d70fd387bd54d491 = /* #__PURE__ */ function() {
    function CreateAttachment(value0) {
        this.value0 = value0;
    }
    CreateAttachment.create = function(value0) {
        return new CreateAttachment(value0);
    };
    return CreateAttachment;
}();
var $67a3c28b4000eb60$export$79720b9e56216340 = /* #__PURE__ */ function() {
    function RemoveAttachment(value0) {
        this.value0 = value0;
    }
    RemoveAttachment.create = function(value0) {
        return new RemoveAttachment(value0);
    };
    return RemoveAttachment;
}();
var $67a3c28b4000eb60$export$cb0f28399d4f8d9f = /* #__PURE__ */ function() {
    function AttachmentsChanged(value0) {
        this.value0 = value0;
    }
    AttachmentsChanged.create = function(value0) {
        return new AttachmentsChanged(value0);
    };
    return AttachmentsChanged;
}();
var $67a3c28b4000eb60$export$1a210fc06576eae8 = /* #__PURE__ */ function() {
    function AttachmentsRequest(value0) {
        this.value0 = value0;
    }
    AttachmentsRequest.create = function(value0) {
        return new AttachmentsRequest(value0);
    };
    return AttachmentsRequest;
}();
var $67a3c28b4000eb60$export$51de8298d225a4a7 = /* #__PURE__ */ function() {
    function UploadAttachment() {}
    UploadAttachment.value = new UploadAttachment();
    return UploadAttachment;
}();
var $67a3c28b4000eb60$export$a4c37d342183ceb6 = /* #__PURE__ */ function() {
    function DeleteAttachment(value0) {
        this.value0 = value0;
    }
    DeleteAttachment.create = function(value0) {
        return new DeleteAttachment(value0);
    };
    return DeleteAttachment;
}();
var $67a3c28b4000eb60$export$5737e0a77055e89d = /* #__PURE__ */ function() {
    function StateChange(value0) {
        this.value0 = value0;
    }
    StateChange.create = function(value0) {
        return new StateChange(value0);
    };
    return StateChange;
}();
var $67a3c28b4000eb60$export$a834879b99a08a67 = function(state) {
    return state.id + "-attachment-upload";
};
var $67a3c28b4000eb60$export$40705385f6cf8df2 = function(v) {
    return function(att) {
        return $67a3c28b4000eb60$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("attachment")
        ])([
            $67a3c28b4000eb60$var$a([
                $fc1df90f0e252058$export$2913c0c0b5623090("attachment-label"),
                $fc1df90f0e252058$export$8f51af5840e0602a(att.url),
                $fc1df90f0e252058$export$44271b4f0c6a3563("_blank")
            ])([
                $67a3c28b4000eb60$var$text(function() {
                    var $34 = att.description === "";
                    if ($34) return att.path;
                    return att.description;
                }())
            ]),
            $67a3c28b4000eb60$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("attachment-meta")
            ])([
                $67a3c28b4000eb60$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("attachment-by")
                ])([
                    $67a3c28b4000eb60$var$text(att.user.name)
                ]),
                $67a3c28b4000eb60$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("attachment-time")
                ])([
                    $67a3c28b4000eb60$var$text($25dcdcde7533cf1d$export$c12d4497c7cc4368(att.created_at))
                ])
            ]),
            $67a3c28b4000eb60$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("attachment-buttons")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                $c3ec47a57216184e$export$71e337785367343c(att["can"]["delete"])($67a3c28b4000eb60$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("attachment-delete-button btn"),
                    $67a3c28b4000eb60$var$voidRight(new $67a3c28b4000eb60$export$a4c37d342183ceb6(att.id))($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $67a3c28b4000eb60$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("attachment-delete"))
                ]))
            ]))
        ]);
    };
};
var $67a3c28b4000eb60$export$5be9a61f48ea206f = function(v) {
    return {
        id: v.id,
        formId: v.formId,
        attachments: v.attachments,
        description: ""
    };
};
var $67a3c28b4000eb60$export$9e6c368fa6821324 = function(state) {
    return $67a3c28b4000eb60$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("attachment-form")
    ])([
        $67a3c28b4000eb60$var$p([
            $fc1df90f0e252058$export$2913c0c0b5623090("attachment-form-header")
        ])([
            $67a3c28b4000eb60$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("attachment-form"))
        ]),
        $67a3c28b4000eb60$var$input([
            $fc1df90f0e252058$export$1741e49665a9c8e8("file"),
            $fc1df90f0e252058$export$9c7ae676ac45430a($67a3c28b4000eb60$export$a834879b99a08a67(state)),
            $67a3c28b4000eb60$var$voidRight($67a3c28b4000eb60$export$51de8298d225a4a7.value)($fc1df90f0e252058$export$bd913411069e59d3)
        ])
    ]);
};
var $67a3c28b4000eb60$export$c7b2e6b24f42ab4b = function(v) {
    return $67a3c28b4000eb60$var$details([
        $fc1df90f0e252058$export$df61b30b684217c0(v.id),
        $fc1df90f0e252058$export$9c7ae676ac45430a(v.id),
        $fc1df90f0e252058$export$3ce6949f20cea765($67a3c28b4000eb60$var$length(v.attachments) > 0)
    ])([
        $67a3c28b4000eb60$var$summary$prime([
            $67a3c28b4000eb60$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("attachment-section-heading")
            ])([
                $67a3c28b4000eb60$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("attachment-section"))
            ])
        ]),
        $67a3c28b4000eb60$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("attachment-section")
        ])([
            $67a3c28b4000eb60$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("attachment-list")
            ])($67a3c28b4000eb60$var$map($67a3c28b4000eb60$export$40705385f6cf8df2(v))(v.attachments)),
            $67a3c28b4000eb60$export$9e6c368fa6821324(v)
        ])
    ]);
};
var $67a3c28b4000eb60$export$c21553f382a3af0e = function(v) {
    return function(v1) {
        if (v1 instanceof $67a3c28b4000eb60$export$5737e0a77055e89d) return $67a3c28b4000eb60$var$pure(new $67a3c28b4000eb60$export$cb0f28399d4f8d9f(v1.value0));
        if (v1 instanceof $67a3c28b4000eb60$export$a4c37d342183ceb6) return $67a3c28b4000eb60$var$bind($46bd9e377310b7ba$export$50d8d0e36b3c9ab6($67a3c28b4000eb60$export$c7b2e6b24f42ab4b(v))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-attachment-title"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-attachment-primary-button"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-attachment")))(function(conf) {
            if (conf) return $67a3c28b4000eb60$var$pure(new $67a3c28b4000eb60$export$1a210fc06576eae8(new $67a3c28b4000eb60$export$79720b9e56216340(v1.value0)));
            return $67a3c28b4000eb60$var$pure(new $67a3c28b4000eb60$export$cb0f28399d4f8d9f(v));
        });
        if (v1 instanceof $67a3c28b4000eb60$export$51de8298d225a4a7) return $67a3c28b4000eb60$var$bind($67a3c28b4000eb60$var$liftEffect($86d95ff9dd604c39$export$3b118c8dea28c6b0($67a3c28b4000eb60$export$a834879b99a08a67(v))))(function(file) {
            var name = function() {
                var $47 = v.description === "";
                if ($47) return $07a6961825e3071d$export$a8ff84c12d48cfa6(file);
                return v.description;
            }();
            return $67a3c28b4000eb60$var$pure(new $67a3c28b4000eb60$export$1a210fc06576eae8(new $67a3c28b4000eb60$export$d70fd387bd54d491({
                description: name,
                file: file
            })));
        });
        throw new Error("Failed pattern match at Widgets.Attachments (line 49, column 1 - line 49, column 85): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $67a3c28b4000eb60$export$b93ea6ce0cf08c89 = function(state) {
    return $67a3c28b4000eb60$var$bindFlipped($67a3c28b4000eb60$export$c21553f382a3af0e(state))($67a3c28b4000eb60$export$c7b2e6b24f42ab4b(state));
};



// Generated by purs version 0.15.16




















// Generated by purs version 0.15.16

var $acw62 = parcelRequire("acw62");
"use strict";
class $60cdf1dd24461296$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    div = null;
    render() {
        const { children: children, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ...props,
            ref: (ref)=>{
                this.div = ref;
            }
        }, children);
    }
    // Fires a fake `blur` event that concur will pick up on.
    fireBlurEvent() {
        // Oddly just calling the handler function seems to be the best way to
        // do this.
        this.props.onBlur(new FocusEvent("blur"));
    }
    // Called when the user clicks anywhere on the page. Fires the blur event
    // if the click was outside this element.
    onClickAnywhere = (ev)=>{
        if (this.div && !this.div.contains(ev.target)) this.fireBlurEvent();
    };
    componentDidMount() {
        // HACK: For some reason if we register the handler immediately, we
        // receive the click event that opened the dropdown, which counts as
        // outside the dropdown, which closes it. To fix this, we wait a bit
        // and then register the handler.
        setTimeout(()=>{
            // After mounting the component, register a global click handler.
            document.addEventListener("click", this.onClickAnywhere);
        }, 1);
    }
    componentWillUnmount() {
        // Remove the event listener when this gets removed from the page.
        document.removeEventListener("click", this.onClickAnywhere);
    }
}


"use strict";
const $4b945c92fde12449$export$28475bddffe8c2b1 = $60cdf1dd24461296$export$2e2bcd8739ae039;














var $9fec91fabe90d735$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $9fec91fabe90d735$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($9fec91fabe90d735$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9fec91fabe90d735$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $9fec91fabe90d735$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $9fec91fabe90d735$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $9fec91fabe90d735$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $9fec91fabe90d735$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $9fec91fabe90d735$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $9fec91fabe90d735$export$603e33b0019d9a99 = function(v) {
    return $9fec91fabe90d735$var$a([
        $9fec91fabe90d735$var$voidRight(v.value)($fc1df90f0e252058$export$1d5a917feb871989),
        $fc1df90f0e252058$export$2913c0c0b5623090("whitespace-nowrap")
    ])([
        $9fec91fabe90d735$var$text(v.label)
    ]);
};
var $9fec91fabe90d735$export$94b7241ade5089f7 = function(dictShiftMap) {
    var el$prime = $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap);
    return function(dictMultiAlternative) {
        var el$prime1 = el$prime(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546);
        return function(props) {
            return el$prime1(function() {
                var $27 = $6500c29ba0ac3395$export$610acb4e9d1b3217($4b945c92fde12449$export$28475bddffe8c2b1);
                return function($28) {
                    return $27($1ac7a3b24b863c5b$export$3fe23fdec027b2e3($28));
                };
            }())(props);
        };
    };
};
var $9fec91fabe90d735$var$dropdownDiv1 = /* #__PURE__ */ $9fec91fabe90d735$export$94b7241ade5089f7($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5)($9fec91fabe90d735$var$multiAlternativeWidget);
var $9fec91fabe90d735$export$a0da0e2b6ed301a5 = function(widgets) {
    return $9fec91fabe90d735$var$dropdownDiv1([
        $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-menu"),
        $9fec91fabe90d735$var$voidRight($06733ae99ed4f534$export$bebe9059409a0d04.value)($fc1df90f0e252058$export$5e446bc31724fca4)
    ])($9fec91fabe90d735$var$map(function(v) {
        return $9fec91fabe90d735$var$map1($06733ae99ed4f534$export$8a67b48435b5d073.create)(v);
    })(widgets));
};
var $9fec91fabe90d735$export$f40e957e8c490719 = function(items) {
    return $9fec91fabe90d735$export$a0da0e2b6ed301a5($9fec91fabe90d735$var$map($9fec91fabe90d735$export$603e33b0019d9a99)(items));
};
var $9fec91fabe90d735$export$a3681dba3470c8c4 = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($9fec91fabe90d735$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5)([
    /* #__PURE__ */ $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-container")
]);
var $9fec91fabe90d735$export$3a59c1cf55945abf = function(btn) {
    return function(widgets) {
        return $9fec91fabe90d735$var$bind($9fec91fabe90d735$export$a3681dba3470c8c4([
            btn
        ]))(function() {
            return $9fec91fabe90d735$var$bind($9fec91fabe90d735$export$a3681dba3470c8c4([
                $9c13a1c3d948adb8$export$be9e2feb4e35335b(btn),
                $9fec91fabe90d735$export$a0da0e2b6ed301a5(widgets)
            ]))(function(v) {
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9fec91fabe90d735$var$pure(v.value0);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $9fec91fabe90d735$export$3a59c1cf55945abf(btn)(widgets);
                throw new Error("Failed pattern match at Widgets.Dropdown (line 38, column 75 - line 42, column 47): " + [
                    v.constructor.name
                ]);
            });
        });
    };
};
var $9fec91fabe90d735$export$877c9c2e37d22fef = function(btn) {
    return function(items) {
        return $9fec91fabe90d735$export$3a59c1cf55945abf(btn)($9fec91fabe90d735$var$map($9fec91fabe90d735$export$603e33b0019d9a99)(items));
    };
};


var $a225fa54d4056a34$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $a225fa54d4056a34$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$textarea = /* #__PURE__ */ $3eadc1b959dd1120$export$a3574df893ffa88d($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $a225fa54d4056a34$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $a225fa54d4056a34$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $a225fa54d4056a34$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $a225fa54d4056a34$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $a225fa54d4056a34$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $a225fa54d4056a34$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($35e75b0a064776f5$export$841f751694498c54);
var $a225fa54d4056a34$var$br$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$e0b7aa9c55ad07d3($d4ad4a12c540b680$export$5d6626409df85f18);
var $a225fa54d4056a34$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $a225fa54d4056a34$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($a225fa54d4056a34$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $a225fa54d4056a34$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $a225fa54d4056a34$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $a225fa54d4056a34$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $a225fa54d4056a34$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $a225fa54d4056a34$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $a225fa54d4056a34$export$de8544b0b847b68d = /* #__PURE__ */ function() {
    function Posting(value0) {
        this.value0 = value0;
    }
    Posting.create = function(value0) {
        return new Posting(value0);
    };
    return Posting;
}();
var $a225fa54d4056a34$export$9696f3b56ef38c0e = /* #__PURE__ */ function() {
    function Editing(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Editing.create = function(value0) {
        return function(value1) {
            return new Editing(value0, value1);
        };
    };
    return Editing;
}();
var $a225fa54d4056a34$export$b217475cf0d7b767 = /* #__PURE__ */ function() {
    function CreateComment(value0) {
        this.value0 = value0;
    }
    CreateComment.create = function(value0) {
        return new CreateComment(value0);
    };
    return CreateComment;
}();
var $a225fa54d4056a34$export$45f887c8c5fa0732 = /* #__PURE__ */ function() {
    function UpdateComment(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    UpdateComment.create = function(value0) {
        return function(value1) {
            return new UpdateComment(value0, value1);
        };
    };
    return UpdateComment;
}();
var $a225fa54d4056a34$export$3e7441b70abfe107 = /* #__PURE__ */ function() {
    function RemoveComment(value0) {
        this.value0 = value0;
    }
    RemoveComment.create = function(value0) {
        return new RemoveComment(value0);
    };
    return RemoveComment;
}();
var $a225fa54d4056a34$export$f5f2dd33c99a3161 = /* #__PURE__ */ function() {
    function CommentsChanged(value0) {
        this.value0 = value0;
    }
    CommentsChanged.create = function(value0) {
        return new CommentsChanged(value0);
    };
    return CommentsChanged;
}();
var $a225fa54d4056a34$export$5bdd10416d35ee91 = /* #__PURE__ */ function() {
    function CommentsRequest(value0) {
        this.value0 = value0;
    }
    CommentsRequest.create = function(value0) {
        return new CommentsRequest(value0);
    };
    return CommentsRequest;
}();
var $a225fa54d4056a34$export$e46e05cd96bfd3ee = /* #__PURE__ */ function() {
    function PostComment() {}
    PostComment.value = new PostComment();
    return PostComment;
}();
var $a225fa54d4056a34$export$5ec1b5bc07c6cb4d = /* #__PURE__ */ function() {
    function DeleteComment(value0) {
        this.value0 = value0;
    }
    DeleteComment.create = function(value0) {
        return new DeleteComment(value0);
    };
    return DeleteComment;
}();
var $a225fa54d4056a34$export$55ec0e499a2afded = /* #__PURE__ */ function() {
    function EditComment(value0) {
        this.value0 = value0;
    }
    EditComment.create = function(value0) {
        return new EditComment(value0);
    };
    return EditComment;
}();
var $a225fa54d4056a34$export$5ad02451e0181245 = /* #__PURE__ */ function() {
    function StopEditing() {}
    StopEditing.value = new StopEditing();
    return StopEditing;
}();
var $a225fa54d4056a34$export$5737e0a77055e89d = /* #__PURE__ */ function() {
    function StateChange(value0) {
        this.value0 = value0;
    }
    StateChange.create = function(value0) {
        return new StateChange(value0);
    };
    return StateChange;
}();
var $a225fa54d4056a34$export$c1244d45bb25af33 = {
    text: "",
    "public": false
};
var $a225fa54d4056a34$export$dae1c0e759c7812c = function(v) {
    return {
        id: v.id,
        formId: v.formId,
        comments: v.comments,
        can: v.can,
        post: new $a225fa54d4056a34$export$de8544b0b847b68d($a225fa54d4056a34$export$c1244d45bb25af33)
    };
};
var $a225fa54d4056a34$export$285bd1d6c6bdf942 = function(v) {
    var wrapPState = function(p) {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e) return new $a225fa54d4056a34$export$9696f3b56ef38c0e(v.post.value0, p);
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return new $a225fa54d4056a34$export$de8544b0b847b68d(p);
        throw new Error("Failed pattern match at Widgets.Comments (line 172, column 20 - line 174, column 31): " + [
            v.post.constructor.name
        ]);
    };
    var setPublic = function(pub) {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e) return {
            can: v.can,
            comments: v.comments,
            formId: v.formId,
            id: v.id,
            post: new $a225fa54d4056a34$export$9696f3b56ef38c0e(v.post.value0, {
                text: v.post.value1.text,
                "public": pub
            })
        };
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return {
            can: v.can,
            comments: v.comments,
            formId: v.formId,
            id: v.id,
            post: new $a225fa54d4056a34$export$de8544b0b847b68d({
                text: v.post.value0.text,
                "public": pub
            })
        };
        throw new Error("Failed pattern match at Widgets.Comments (line 181, column 21 - line 183, column 67): " + [
            v.post.constructor.name
        ]);
    };
    var post = function() {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e) return v.post.value1;
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return v.post.value0;
        throw new Error("Failed pattern match at Widgets.Comments (line 175, column 12 - line 177, column 23): " + [
            v.post.constructor.name
        ]);
    }();
    var isEditing = function() {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e) return true;
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return false;
        throw new Error("Failed pattern match at Widgets.Comments (line 178, column 17 - line 180, column 27): " + [
            v.post.constructor.name
        ]);
    }();
    var buttonLbl = function() {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e) return "save-comment";
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return "post-comment";
        throw new Error("Failed pattern match at Widgets.Comments (line 184, column 17 - line 186, column 36): " + [
            v.post.constructor.name
        ]);
    }();
    return $a225fa54d4056a34$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("comment-form")
    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$textarea([
            $fc1df90f0e252058$export$df61b30b684217c0(v.id + "_textarea"),
            $fc1df90f0e252058$export$2913c0c0b5623090("comment-form-textarea"),
            $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("comment-form-placeholder")),
            $fc1df90f0e252058$export$2ab9a8f9f1186f14(post.text),
            $a225fa54d4056a34$var$map($a225fa54d4056a34$var$map1($a225fa54d4056a34$var$map1($a225fa54d4056a34$export$5737e0a77055e89d.create)(function(t) {
                return {
                    can: v.can,
                    comments: v.comments,
                    formId: v.formId,
                    id: v.id,
                    post: wrapPState({
                        "public": post["public"],
                        text: t
                    })
                };
            }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512)
        ])([])),
        $c3ec47a57216184e$export$71e337785367343c(v.can.private_comment)($a225fa54d4056a34$var$map2($a225fa54d4056a34$var$map1($a225fa54d4056a34$export$5737e0a77055e89d.create)(setPublic))($fc8e139dfeeff88c$export$344f17102956e4bc("comment-public-check")($c3328e54cdf5154c$export$5a1a8430df9521e("comment-public-check"))(post["public"]))),
        new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("comment-buttons")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn comment-form-post-button"),
                $a225fa54d4056a34$var$voidRight($a225fa54d4056a34$export$e46e05cd96bfd3ee.value)($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $a225fa54d4056a34$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(buttonLbl))
            ])),
            $c3ec47a57216184e$export$71e337785367343c(isEditing)($a225fa54d4056a34$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn comment-form-cancel-button"),
                $a225fa54d4056a34$var$voidRight($a225fa54d4056a34$export$5ad02451e0181245.value)($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $a225fa54d4056a34$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel-edit-comment"))
            ]))
        ])))
    ]));
};
var $a225fa54d4056a34$export$87fc7a01f41973c6 = function(v) {
    return function(v1) {
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e && $a225fa54d4056a34$var$eq(v1.id)(v.post.value0)) return $a225fa54d4056a34$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("comment")
        ])([
            $a225fa54d4056a34$export$285bd1d6c6bdf942(v)
        ]);
        var renderDBtn = $a225fa54d4056a34$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-button"),
            $fc1df90f0e252058$export$1d5a917feb871989
        ])([
            $a225fa54d4056a34$var$text("\u2807")
        ]);
        var maybeDropBtn = function(v2) {
            if (v2.length === 0) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            return new $06733ae99ed4f534$export$8a67b48435b5d073($9fec91fabe90d735$export$877c9c2e37d22fef(renderDBtn)(v2));
        };
        var commentLines = $5b07e36f812dd04b$export$65980d18b75784e2("\x0a")(v1.comment);
        return $a225fa54d4056a34$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("comment")
        ])([
            $a225fa54d4056a34$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("comment-head")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$h1([
                    $fc1df90f0e252058$export$2913c0c0b5623090("comment-poster")
                ])([
                    $a225fa54d4056a34$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("comment-by") + v1.author.name)
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("comment-times")
                ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$text($25dcdcde7533cf1d$export$c12d4497c7cc4368(v1.created_at))),
                    $c3ec47a57216184e$export$71e337785367343c($a225fa54d4056a34$var$notEq(v1.updated_at)(v1.created_at))($a225fa54d4056a34$var$text(" (" + ($c3328e54cdf5154c$export$5a1a8430df9521e("comment-updated-at") + (" " + ($25dcdcde7533cf1d$export$c12d4497c7cc4368(v1.updated_at) + ")")))))
                ]))),
                new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("comment-is-public")
                ])([
                    $a225fa54d4056a34$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(function() {
                        if (v1["public"]) return "comment-public-indicator";
                        return "comment-private-indicator";
                    }()))
                ])),
                maybeDropBtn($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    $c3ec47a57216184e$export$71e337785367343c(v1.can.update)({
                        value: new $a225fa54d4056a34$export$55ec0e499a2afded(v1.id),
                        label: $c3328e54cdf5154c$export$5a1a8430df9521e("edit-comment")
                    }),
                    $c3ec47a57216184e$export$71e337785367343c(v1["can"]["delete"])({
                        value: new $a225fa54d4056a34$export$5ec1b5bc07c6cb4d(v1.id),
                        label: $c3328e54cdf5154c$export$5a1a8430df9521e("delete-comment")
                    })
                ]))
            ])),
            $a225fa54d4056a34$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("comment-body")
            ])($396c4c3d9e7fae3c$export$c28c8388be0ab31a(function(l) {
                return [
                    $a225fa54d4056a34$var$text(l),
                    $a225fa54d4056a34$var$br$prime
                ];
            })(commentLines))
        ]);
    };
};
var $a225fa54d4056a34$export$b377acd07ff1bae = function(v) {
    var isPosting = function() {
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d) return true;
        return false;
    }();
    return $a225fa54d4056a34$var$details([
        $fc1df90f0e252058$export$df61b30b684217c0(v.id),
        $fc1df90f0e252058$export$9c7ae676ac45430a(v.id),
        $fc1df90f0e252058$export$3ce6949f20cea765($a225fa54d4056a34$var$length(v.comments) > 0)
    ])([
        $a225fa54d4056a34$var$summary$prime([
            $a225fa54d4056a34$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("comment-section-heading")
            ])([
                $a225fa54d4056a34$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("comment-section"))
            ])
        ]),
        $a225fa54d4056a34$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("comment-section")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($a225fa54d4056a34$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("comment-section-list")
            ])($a225fa54d4056a34$var$map3($a225fa54d4056a34$export$87fc7a01f41973c6(v))(v.comments))),
            $c3ec47a57216184e$export$71e337785367343c(isPosting && v.can.comment)($a225fa54d4056a34$export$285bd1d6c6bdf942(v))
        ]))
    ]);
};
var $a225fa54d4056a34$export$c21553f382a3af0e = function(v) {
    return function(v1) {
        if (v1 instanceof $a225fa54d4056a34$export$5737e0a77055e89d) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$f5f2dd33c99a3161(v1.value0));
        if (v1 instanceof $a225fa54d4056a34$export$5ad02451e0181245) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$f5f2dd33c99a3161({
            id: v.id,
            formId: v.formId,
            comments: v.comments,
            can: v.can,
            post: new $a225fa54d4056a34$export$de8544b0b847b68d($a225fa54d4056a34$export$c1244d45bb25af33)
        }));
        if (v1 instanceof $a225fa54d4056a34$export$55ec0e499a2afded) {
            var v2 = $a225fa54d4056a34$var$find(function(c) {
                return $a225fa54d4056a34$var$eq(c.id)(v1.value0);
            })(v.comments);
            if (v2 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$f5f2dd33c99a3161({
                id: v.id,
                formId: v.formId,
                comments: v.comments,
                can: v.can,
                post: new $a225fa54d4056a34$export$9696f3b56ef38c0e(v1.value0, {
                    text: v2.value0.comment,
                    "public": v2["value0"]["public"]
                })
            }));
            if (v2 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$f5f2dd33c99a3161(v));
            throw new Error("Failed pattern match at Widgets.Comments (line 67, column 5 - line 69, column 48): " + [
                v2.constructor.name
            ]);
        }
        if (v1 instanceof $a225fa54d4056a34$export$5ec1b5bc07c6cb4d) return $a225fa54d4056a34$var$bind($46bd9e377310b7ba$export$50d8d0e36b3c9ab6($a225fa54d4056a34$export$b377acd07ff1bae(v))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-comment-title"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-comment-primary-button"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-comment")))(function(conf) {
            if (conf) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$5bdd10416d35ee91(new $a225fa54d4056a34$export$3e7441b70abfe107(v1.value0)));
            return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$f5f2dd33c99a3161(v));
        });
        if (v.post instanceof $a225fa54d4056a34$export$de8544b0b847b68d && v1 instanceof $a225fa54d4056a34$export$e46e05cd96bfd3ee) {
            var $$public = function() {
                if (v.can.private_comment) return v["post"]["value0"]["public"];
                return true;
            }();
            return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$5bdd10416d35ee91(new $a225fa54d4056a34$export$b217475cf0d7b767({
                comment: v.post.value0.text,
                "public": $$public
            })));
        }
        if (v.post instanceof $a225fa54d4056a34$export$9696f3b56ef38c0e && v1 instanceof $a225fa54d4056a34$export$e46e05cd96bfd3ee) return $a225fa54d4056a34$var$pure(new $a225fa54d4056a34$export$5bdd10416d35ee91(new $a225fa54d4056a34$export$45f887c8c5fa0732(v.post.value0, {
            comment: v.post.value1.text,
            "public": v["post"]["value1"]["public"]
        })));
        throw new Error("Failed pattern match at Widgets.Comments (line 63, column 1 - line 63, column 76): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $a225fa54d4056a34$export$c62a7fe39465fd55 = function(state) {
    return $a225fa54d4056a34$var$bindFlipped($a225fa54d4056a34$export$c21553f382a3af0e(state))($a225fa54d4056a34$export$b377acd07ff1bae(state));
};




// Generated by purs version 0.15.16











var $47387374ebaf9fda$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $47387374ebaf9fda$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $47387374ebaf9fda$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $47387374ebaf9fda$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($47387374ebaf9fda$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $47387374ebaf9fda$var$iframe = /* #__PURE__ */ $3eadc1b959dd1120$export$8cde213409fd6377($47387374ebaf9fda$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $47387374ebaf9fda$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $47387374ebaf9fda$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $47387374ebaf9fda$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($47387374ebaf9fda$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $47387374ebaf9fda$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($47387374ebaf9fda$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $47387374ebaf9fda$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($47387374ebaf9fda$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $47387374ebaf9fda$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $47387374ebaf9fda$export$345d9be8059b0f20 = function(doc) {
    return {
        loaded: false,
        doc: doc
    };
};
var $47387374ebaf9fda$export$2ab4e20c08edf070 = function(doc) {
    return $47387374ebaf9fda$var$map(function(v) {
        return v.url;
    })($47387374ebaf9fda$var$find(function(r) {
        return r.format === "PDF";
    })(doc.exports));
};
var $47387374ebaf9fda$export$689d160a28800c5d = function(state) {
    var v = $47387374ebaf9fda$export$2ab4e20c08edf070(state.doc);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $47387374ebaf9fda$var$div$prime([
        $47387374ebaf9fda$var$iframe([
            $fc1df90f0e252058$export$2e40c9e35e9506f4(v.value0)
        ])([])
    ]);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $47387374ebaf9fda$var$div$prime([
        $47387374ebaf9fda$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("no-pdf"))
    ]);
    throw new Error("Failed pattern match at Widgets.FormPreview (line 51, column 23 - line 53, column 62): " + [
        v.constructor.name
    ]);
};
var $47387374ebaf9fda$export$65e6ebc64486f6b3 = function(v) {
    if (!v.loaded) return $47387374ebaf9fda$var$bind($47387374ebaf9fda$var$details([
        $fc1df90f0e252058$export$9b74f80012185590,
        $fc1df90f0e252058$export$3ce6949f20cea765(false),
        $fc1df90f0e252058$export$2913c0c0b5623090("form-submission-preview")
    ])([
        $47387374ebaf9fda$var$summary$prime([
            $47387374ebaf9fda$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("preview-heading")
            ])([
                $47387374ebaf9fda$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("preview"))
            ])
        ])
    ]))(function() {
        return $47387374ebaf9fda$var$pure({
            doc: v.doc,
            loaded: true
        });
    });
    return $47387374ebaf9fda$var$details([
        $fc1df90f0e252058$export$3ce6949f20cea765(false),
        $fc1df90f0e252058$export$2913c0c0b5623090("form-submission-preview")
    ])([
        $47387374ebaf9fda$var$summary$prime([
            $47387374ebaf9fda$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("preview-heading")
            ])([
                $47387374ebaf9fda$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("preview"))
            ])
        ]),
        $47387374ebaf9fda$export$689d160a28800c5d(v)
    ]);
};


// Generated by purs version 0.15.16


















// Generated by purs version 0.15.16
"use strict";
function $42276ed6ed15de29$export$6a6ee1cfa4204fb0(txt) {
    return navigator.clipboard.writeText(txt);
}


// Generated by purs version 0.15.16
function $ad03f91db16ac1b9$export$c957ef27a0ebfd4(f) {
    return function() {
        return new Promise(function(success, error) {
            var succF = function(s) {
                return function() {
                    return success(s);
                };
            };
            var failF = function(s) {
                return function() {
                    return error(s);
                };
            };
            // This indicates the aff was wrong?
            try {
                f(succF)(failF)();
            } catch (e) {
                error(e);
            }
        });
    };
}
function $ad03f91db16ac1b9$export$3c1befb4cab9a0b1(promise) {
    return function(errCB) {
        return function(succCB) {
            return function() {
                promise.then(succCB, errCB);
            };
        };
    };
}

















var $de787439b660334b$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $de787439b660334b$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($edf0339512807bee$export$800a937b75981c0e);
var $de787439b660334b$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $de787439b660334b$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $d2284b2d3e1b6f87$export$4cca4d0f6dfbd781($78c799cba34fcb8d$export$a8cfc3dfdfca72cf)($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0));
var $de787439b660334b$var$unsafeReadTagged = /* #__PURE__ */ $c97d2d0f578f81ad$export$6190f2182377b437($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $de787439b660334b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $d2284b2d3e1b6f87$export$d684c62fe584fcfa($50c50d1f444e5fa4$export$dc85e8383eafbd81));
var $de787439b660334b$var$readString = /* #__PURE__ */ $c97d2d0f578f81ad$export$dda73877cb166cd3($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0);
var $de787439b660334b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $de787439b660334b$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $de787439b660334b$export$7122ee73e9eb8a2d = function(customCoerce) {
    return function(p) {
        return $b28443a27438717a$export$49d5975414e0a979(function(cb) {
            return $de787439b660334b$var$voidRight($de787439b660334b$var$mempty)($ad03f91db16ac1b9$export$3c1befb4cab9a0b1(p)(function($14) {
                return cb($7d4cccdf062a2261$export$37c4d04eafdc5515.create(customCoerce($14)))();
            })(function($15) {
                return cb($7d4cccdf062a2261$export$19db0165690c701a.create($15))();
            }));
        });
    };
};
var $de787439b660334b$export$d9918da5f31e82a0 = function(aff) {
    return $ad03f91db16ac1b9$export$c957ef27a0ebfd4(function(succ) {
        return function(err) {
            return $edf0339512807bee$export$ef62257e6f8a5f8c($7d4cccdf062a2261$export$5f5be1bb6cd1fded(err)(succ))(aff);
        };
    });
};
var $de787439b660334b$var$coerce = function(fn) {
    return $7d4cccdf062a2261$export$5f5be1bb6cd1fded(function(v) {
        return $ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Promise failed, couldn't extract JS Error or String");
    })($de787439b660334b$var$identity)($f9f243b94d1fc188$export$a25b8a8a37f2d1cd($de787439b660334b$var$alt($de787439b660334b$var$unsafeReadTagged("Error")(fn))($de787439b660334b$var$map($ad2cf6904bca3ba1$export$a3bc9b8ed74fc)($de787439b660334b$var$readString(fn)))));
};
var $de787439b660334b$export$497ef2ff78b6f4e4 = /* #__PURE__ */ $de787439b660334b$export$7122ee73e9eb8a2d($de787439b660334b$var$coerce);
var $de787439b660334b$export$bc21c4f09b3d3d0a = function(f) {
    return $de787439b660334b$var$bind($de787439b660334b$var$liftEffect(f))($de787439b660334b$export$497ef2ff78b6f4e4);
};


var $ce79b167faae41da$export$bec150f75a9b8f11 = function($1) {
    return $de787439b660334b$export$497ef2ff78b6f4e4($42276ed6ed15de29$export$6a6ee1cfa4204fb0($1));
};








// Generated by purs version 0.15.16























var $17c0a976f7d5153b$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $17c0a976f7d5153b$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $17c0a976f7d5153b$var$form = /* #__PURE__ */ $3eadc1b959dd1120$export$6210fa4921d2a466($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $17c0a976f7d5153b$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $17c0a976f7d5153b$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $17c0a976f7d5153b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $17c0a976f7d5153b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $17c0a976f7d5153b$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$textarea = /* #__PURE__ */ $3eadc1b959dd1120$export$a3574df893ffa88d($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($17c0a976f7d5153b$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $17c0a976f7d5153b$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $17c0a976f7d5153b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $17c0a976f7d5153b$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $17c0a976f7d5153b$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $17c0a976f7d5153b$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $17c0a976f7d5153b$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $17c0a976f7d5153b$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $17c0a976f7d5153b$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $17c0a976f7d5153b$var$all = /* #__PURE__ */ $4fe7b6acfba7f29f$export$84bf76cd7afc7469($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $17c0a976f7d5153b$var$mapWithIndex = /* #__PURE__ */ $334541180b4ef18c$export$8f07ddce13659f50($334541180b4ef18c$export$f10d51ea0aa3da42);
var $17c0a976f7d5153b$export$8662aba10c302783 = /* #__PURE__ */ function() {
    function SaveEmail(value0) {
        this.value0 = value0;
    }
    SaveEmail.create = function(value0) {
        return new SaveEmail(value0);
    };
    return SaveEmail;
}();
var $17c0a976f7d5153b$export$5410dc4fc2fdd666 = /* #__PURE__ */ function() {
    function SaveAndSendEmail(value0) {
        this.value0 = value0;
    }
    SaveAndSendEmail.create = function(value0) {
        return new SaveAndSendEmail(value0);
    };
    return SaveAndSendEmail;
}();
var $17c0a976f7d5153b$export$f5320684aa237cd5 = function(state) {
    return function(field) {
        return $17c0a976f7d5153b$var$loopState(state)(function(v) {
            return $17c0a976f7d5153b$var$form([
                $fc1df90f0e252058$export$2913c0c0b5623090("signature-email-single-form modal-grid"),
                $fc1df90f0e252058$export$31eb53bd5b582a97("javascript:void(0);"),
                $17c0a976f7d5153b$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(new $17c0a976f7d5153b$export$5410dc4fc2fdd666(v)))($fc1df90f0e252058$export$307d29742c654737)
            ])([
                $17c0a976f7d5153b$var$h1([
                    $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
                ])([
                    $17c0a976f7d5153b$var$text(field.emailLabel)
                ]),
                $17c0a976f7d5153b$var$input([
                    $17c0a976f7d5153b$var$map($17c0a976f7d5153b$var$map1($17c0a976f7d5153b$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                        return {
                            comment: v.comment,
                            email: v1
                        };
                    }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.email),
                    $fc1df90f0e252058$export$9c7ae676ac45430a("email-input"),
                    $fc1df90f0e252058$export$1741e49665a9c8e8("email"),
                    $fc1df90f0e252058$export$a7a0278c004aac3f(true),
                    $fc1df90f0e252058$export$d88a383e7d5eee04("email"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("email-address")),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input email-address")
                ]),
                $17c0a976f7d5153b$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("signature-comment-container")
                ])([
                    $17c0a976f7d5153b$var$label([
                        $fc1df90f0e252058$export$35d9e1c947946090("comment-input"),
                        $fc1df90f0e252058$export$2913c0c0b5623090("signature-comment-label")
                    ])([
                        $17c0a976f7d5153b$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("signature-comment"))
                    ]),
                    $17c0a976f7d5153b$var$textarea([
                        $17c0a976f7d5153b$var$map($17c0a976f7d5153b$var$map1($17c0a976f7d5153b$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                            return {
                                email: v.email,
                                comment: v1
                            };
                        }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3),
                        $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.comment),
                        $fc1df90f0e252058$export$9c7ae676ac45430a("comment-input"),
                        $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("signature-comment-placeholder")),
                        $fc1df90f0e252058$export$2913c0c0b5623090("widget-input signature-comment")
                    ])([])
                ]),
                $17c0a976f7d5153b$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn-group btn-group-email-single modal-buttons")
                ])([
                    $17c0a976f7d5153b$var$button([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                        $fc1df90f0e252058$export$1741e49665a9c8e8("submit")
                    ])([
                        $17c0a976f7d5153b$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("send-email"))
                    ])
                ])
            ]);
        });
    };
};
var $17c0a976f7d5153b$export$eba6650f811eae85 = function(initState) {
    return function(docId) {
        return function(field) {
            return $17c0a976f7d5153b$var$bind($17c0a976f7d5153b$export$f5320684aa237cd5(initState)(field))(function(v) {
                if (v instanceof $17c0a976f7d5153b$export$8662aba10c302783) return $17c0a976f7d5153b$var$pure(new $17c0a976f7d5153b$export$8662aba10c302783(v.value0));
                if (v instanceof $17c0a976f7d5153b$export$5410dc4fc2fdd666) return $17c0a976f7d5153b$var$bind($46bd9e377310b7ba$export$4a889a183052e7fa($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-email-title"))($c3328e54cdf5154c$export$5a1a8430df9521e("yes"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-email") + (" " + (v.value0.email + "?"))))(function(conf) {
                    if (conf) return $17c0a976f7d5153b$var$pure(new $17c0a976f7d5153b$export$5410dc4fc2fdd666({
                        docId: docId,
                        email: v.value0.email,
                        comment: v.value0.comment,
                        key: field.key
                    }));
                    return $17c0a976f7d5153b$export$eba6650f811eae85(v.value0)(docId)(field);
                });
                throw new Error("Failed pattern match at Widgets.Signature.Email (line 34, column 84 - line 42, column 53): " + [
                    v.constructor.name
                ]);
            });
        };
    };
};
var $17c0a976f7d5153b$export$4eb37af202de04a6 = function(account) {
    return function(idx) {
        return function(v) {
            var wasSent = $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(d) {
                return $17c0a976f7d5153b$var$any(function(v1) {
                    return $17c0a976f7d5153b$var$eq(v1.data.key)(v.field.key);
                })(d.verifications);
            })(v.doc);
            var sname = function(doc) {
                return $b05aa108190eac05$export$d50a55988135660c(account)(doc.student);
            };
            var sentLbl = function() {
                if (wasSent) return " (" + ($c3328e54cdf5154c$export$5a1a8430df9521e("already-emailed") + ")");
                return "";
            }();
            var label1 = function() {
                if (v.doc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return v.field.emailLabel;
                if (v.doc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return v.doc.value0.form_type.abbr + (" - " + (sname(v.doc.value0) + (" - " + (v.field.emailLabel + sentLbl))));
                throw new Error("Failed pattern match at Widgets.Signature.Email (line 181, column 13 - line 183, column 101): " + [
                    v.doc.constructor.name
                ]);
            }();
            return $17c0a976f7d5153b$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("email-all-row")
            ])([
                $17c0a976f7d5153b$var$input([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("checkbox"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a("checkbox" + $17c0a976f7d5153b$var$show(idx)),
                    $fc1df90f0e252058$export$b96bb35bc88d6fa(v.selected),
                    $17c0a976f7d5153b$var$voidRight({
                        doc: v.doc,
                        email: v.email,
                        field: v.field,
                        selected: !v.selected
                    })($fc1df90f0e252058$export$bd913411069e59d3),
                    $fc1df90f0e252058$export$2913c0c0b5623090("email-all-row-checkbox")
                ]),
                $17c0a976f7d5153b$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("email-wrapper")
                ])([
                    $17c0a976f7d5153b$var$label([
                        $fc1df90f0e252058$export$35d9e1c947946090("checkbox" + $17c0a976f7d5153b$var$show(idx))
                    ])([
                        $17c0a976f7d5153b$var$text(label1)
                    ]),
                    $17c0a976f7d5153b$var$input($17c0a976f7d5153b$var$append1([
                        $fc1df90f0e252058$export$1741e49665a9c8e8("email"),
                        $fc1df90f0e252058$export$a7a0278c004aac3f(v.selected),
                        $fc1df90f0e252058$export$9c7ae676ac45430a("input" + $17c0a976f7d5153b$var$show(idx)),
                        $17c0a976f7d5153b$var$map($17c0a976f7d5153b$var$map1(function(v1) {
                            return {
                                doc: v.doc,
                                field: v.field,
                                selected: v.selected,
                                email: v1
                            };
                        })($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3),
                        $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.email),
                        $fc1df90f0e252058$export$c7187bbd1a7a9244(v.field.emailLabel),
                        $fc1df90f0e252058$export$2913c0c0b5623090("widget-input email-all-row-email")
                    ])(function() {
                        if (v.selected) return [];
                        return [
                            $fc1df90f0e252058$export$683472f6198a076e(true)
                        ];
                    }()))
                ])
            ]);
        };
    };
};
var $17c0a976f7d5153b$export$44fa09fdd18a98dd = function(account) {
    return function(emails) {
        var selectAll = function(v) {
            return $17c0a976f7d5153b$var$map2(function(e) {
                return {
                    doc: e.doc,
                    email: e.email,
                    field: e.field,
                    selected: v
                };
            })(emails);
        };
        var emailRow = function(idx) {
            return function(ent) {
                return $17c0a976f7d5153b$var$map3($17c0a976f7d5153b$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(e) {
                    return $06733ae99ed4f534$export$43db023a260c5e9f(emails)($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)(e)(emails));
                }))($17c0a976f7d5153b$export$4eb37af202de04a6(account)(idx)(ent));
            };
        };
        var allSelected = $17c0a976f7d5153b$var$all(function(v) {
            return v.selected;
        })(emails);
        var selectAllCheck = $17c0a976f7d5153b$var$map3($17c0a976f7d5153b$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(selectAll))($fc8e139dfeeff88c$export$344f17102956e4bc("select-all-emails")($c3328e54cdf5154c$export$5a1a8430df9521e("select-all"))(allSelected));
        var actionBtns = $17c0a976f7d5153b$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn-group btn-group-email-all modal-buttons")
        ])([
            $17c0a976f7d5153b$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                $fc1df90f0e252058$export$1741e49665a9c8e8("submit")
            ])([
                $17c0a976f7d5153b$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("send-email"))
            ])
        ]);
        return $17c0a976f7d5153b$var$form([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-email-all-form modal-grid"),
            $fc1df90f0e252058$export$31eb53bd5b582a97("javascript:void(0);"),
            $17c0a976f7d5153b$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(emails))($fc1df90f0e252058$export$307d29742c654737)
        ])([
            $17c0a976f7d5153b$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
            ])([
                $17c0a976f7d5153b$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures-for"))
            ]),
            $17c0a976f7d5153b$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("email-all-rows")
            ])($17c0a976f7d5153b$var$append1([
                selectAllCheck
            ])($17c0a976f7d5153b$var$mapWithIndex(emailRow)(emails))),
            actionBtns
        ]);
    };
};
var $17c0a976f7d5153b$export$9765b8f6d6f3daab = function(account) {
    return function(emails) {
        return $17c0a976f7d5153b$var$loopState(emails)($17c0a976f7d5153b$export$44fa09fdd18a98dd(account));
    };
};
var $17c0a976f7d5153b$export$759442ad371577a6 = function(account) {
    return function(docId) {
        return function(emails$prime) {
            var toSigReq = function(v) {
                return {
                    docId: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(docId)(function(v1) {
                        return v1.id;
                    })(v.doc),
                    email: v.email,
                    comment: "",
                    key: v.field.key
                };
            };
            return $17c0a976f7d5153b$var$bind($17c0a976f7d5153b$export$9765b8f6d6f3daab(account)(emails$prime))(function(emails) {
                return $17c0a976f7d5153b$var$bind($46bd9e377310b7ba$export$4a889a183052e7fa($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-email-title"))($c3328e54cdf5154c$export$5a1a8430df9521e("yes"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-email-multiple")))(function(conf) {
                    if (conf) return $17c0a976f7d5153b$var$pure($17c0a976f7d5153b$var$map2(toSigReq)($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v) {
                        return v.selected;
                    })(emails)));
                    return $17c0a976f7d5153b$export$759442ad371577a6(account)(docId)(emails);
                });
            });
        };
    };
};


// Generated by purs version 0.15.16



















// Generated by purs version 0.15.16

var $acw62 = parcelRequire("acw62");
var $611c9a2e456cbe77$exports = {};




!function(e, t) {
    $611c9a2e456cbe77$exports = t((parcelRequire("c9Z8w")), (parcelRequire("acw62")), (parcelRequire("9slIK")), (parcelRequire("7G0GL")));
}($611c9a2e456cbe77$exports, function(e, t, n, r) {
    return function(e) {
        function t(r) {
            if (n[r]) return n[r].exports;
            var a = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return e[r].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
        }
        var n = {};
        return t.m = e, t.c = n, t.p = "", t(0);
    }([
        function(e, t, n) {
            "use strict";
            function r(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function a(e, t) {
                var n = {};
                for(var r in e)t.indexOf(r) >= 0 || Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
                return n;
            }
            function o(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function i(e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }
            function u(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var s = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }, c = function() {
                function e(e, t) {
                    for(var n = 0; n < t.length; n++){
                        var r = t[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
                    }
                }
                return function(t, n, r) {
                    return n && e(t.prototype, n), r && e(t, r), t;
                };
            }(), f = n(1), p = r(f), l = n(2), d = r(l), v = n(3), h = r(v), _ = n(4), g = r(_), m = function(e) {
                function t() {
                    var e, n, r, u;
                    o(this, t);
                    for(var s = arguments.length, c = Array(s), f = 0; f < s; f++)c[f] = arguments[f];
                    return n = r = i(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [
                        this
                    ].concat(c))), r._sigPad = null, r._excludeOurProps = function() {
                        var e = r.props, t = (e.canvasProps, e.clearOnResize, a(e, [
                            "canvasProps",
                            "clearOnResize"
                        ]));
                        return t;
                    }, r.getCanvas = function() {
                        return r._canvas;
                    }, r.getTrimmedCanvas = function() {
                        var e = document.createElement("canvas");
                        return e.width = r._canvas.width, e.height = r._canvas.height, e.getContext("2d").drawImage(r._canvas, 0, 0), (0, g.default)(e);
                    }, r.getSignaturePad = function() {
                        return r._sigPad;
                    }, r._checkClearOnResize = function() {
                        r.props.clearOnResize && r._resizeCanvas();
                    }, r._resizeCanvas = function() {
                        var e = r.props.canvasProps || {}, t = e.width, n = e.height;
                        if (!t || !n) {
                            var a = r._canvas, o = Math.max(window.devicePixelRatio || 1, 1);
                            t || (a.width = a.offsetWidth * o), n || (a.height = a.offsetHeight * o), a.getContext("2d").scale(o, o), r.clear();
                        }
                    }, r.on = function() {
                        return window.addEventListener("resize", r._checkClearOnResize), r._sigPad.on();
                    }, r.off = function() {
                        return window.removeEventListener("resize", r._checkClearOnResize), r._sigPad.off();
                    }, r.clear = function() {
                        return r._sigPad.clear();
                    }, r.isEmpty = function() {
                        return r._sigPad.isEmpty();
                    }, r.fromDataURL = function(e, t) {
                        return r._sigPad.fromDataURL(e, t);
                    }, r.toDataURL = function(e, t) {
                        return r._sigPad.toDataURL(e, t);
                    }, r.fromData = function(e) {
                        return r._sigPad.fromData(e);
                    }, r.toData = function() {
                        return r._sigPad.toData();
                    }, u = n, i(r, u);
                }
                return u(t, e), c(t, [
                    {
                        key: "componentDidMount",
                        value: function() {
                            this._sigPad = new h.default(this._canvas, this._excludeOurProps()), this._resizeCanvas(), this.on();
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.off();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            Object.assign(this._sigPad, this._excludeOurProps());
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var e = this, t = this.props.canvasProps;
                            return d.default.createElement("canvas", s({
                                ref: function(t) {
                                    e._canvas = t;
                                }
                            }, t));
                        }
                    }
                ]), t;
            }(l.Component);
            m.propTypes = {
                velocityFilterWeight: p.default.number,
                minWidth: p.default.number,
                maxWidth: p.default.number,
                minDistance: p.default.number,
                dotSize: p.default.oneOfType([
                    p.default.number,
                    p.default.func
                ]),
                penColor: p.default.string,
                throttle: p.default.number,
                onEnd: p.default.func,
                onBegin: p.default.func,
                canvasProps: p.default.object,
                clearOnResize: p.default.bool
            }, m.defaultProps = {
                clearOnResize: !0
            }, t.default = m;
        },
        function(t, n) {
            t.exports = e;
        },
        function(e, n) {
            e.exports = t;
        },
        function(e, t) {
            e.exports = n;
        },
        function(e, t) {
            e.exports = r;
        }
    ]);
});


"use strict";
class $f1e050d09c03a884$export$2e2bcd8739ae039 extends (0, $acw62.Component) {
    sigPad = null;
    render() {
        const { className: className, id: id, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($611c9a2e456cbe77$exports))), {
            penColor: "black",
            ...props,
            ref: (ref)=>{
                this.sigPad = ref;
                if (ref) // The PureScript modal only knows the canvas id. Store the signature
                // pad on the canvas so the Clear button can clear both the pixels and
                // the pad's internal stroke data.
                ref.getCanvas().__signaturePad = ref;
            },
            canvasProps: {
                className: className ? className : "",
                id: id
            },
            clearOnResize: false
        });
    }
    componentDidMount() {
        // If we were given an initial signature to render, draw it on the canvas.
        if (this.props.sigBlob) {
            // Convert the blob into a data URL (base-64 string).
            const dataUrl = URL.createObjectURL(this.props.sigBlob);
            // Draw that on the canvas.
            this.sigPad.fromDataURL(dataUrl);
        }
        window.addEventListener("resize", this.onResize);
    }
    componentWillUnmount() {
        if (this.sigPad) delete this.sigPad.getCanvas().__signaturePad;
        window.removeEventListener("resize", this.onResize);
    }
    onResize = (_)=>{
        $f1e050d09c03a884$var$resizeCanvas(this.sigPad);
    };
}
async function $f1e050d09c03a884$export$37587d94861333b4(canvasId) {
    const canvas = document.getElementById(canvasId);
    return await new Promise((resolve)=>$f1e050d09c03a884$var$cropSignatureCanvas(resolve, canvas));
}
const $f1e050d09c03a884$export$7816765f8a403870 = (canvasId)=>()=>{
        const canvas = document.getElementById(canvasId);
        if (!canvas) return;
        const sigPad = canvas.__signaturePad;
        if (sigPad) {
            sigPad.clear();
            return;
        }
        const context = canvas.getContext("2d");
        if (context) context.clearRect(0, 0, canvas.width, canvas.height);
    };
const $f1e050d09c03a884$export$cecca496aafda008 = (canvasId)=>()=>{
        const canvas = document.getElementById(canvasId);
        return $f1e050d09c03a884$var$countCanvasInkPixels(canvas) > 0;
    };
function $f1e050d09c03a884$var$resizeCanvas(sigPad) {
    const canvas = sigPad.getCanvas();
    if (canvas.offsetWidth != 0 && canvas.offsetHeight != 0) {
        // Get the signature as a list of points.
        const data = sigPad.toData();
        // Do the resize.
        // From example here: https://github.com/szimek/signature_pad#handling-high-dpi-screens
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        // Clear the contents of the pad and re-draw the signature from before.
        sigPad.clear();
        sigPad.fromData(data);
    }
}
function $f1e050d09c03a884$var$countCanvasInkPixels(canvas) {
    if (!canvas) return 0;
    const context = canvas.getContext("2d");
    if (!context || canvas.width <= 0 || canvas.height <= 0) return 0;
    const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
    let inkPixels = 0;
    for(let index = 3; index < imageData.data.length; index += 4)if (imageData.data[index] > 0) inkPixels += 1;
    return inkPixels;
}
function $f1e050d09c03a884$var$cropSignatureCanvas(resolve, canvas) {
    // First duplicate the canvas to not alter the original
    const croppedCanvas = document.createElement("canvas");
    const croppedCtx = croppedCanvas.getContext("2d");
    croppedCanvas.width = canvas.width;
    croppedCanvas.height = canvas.height;
    croppedCtx.drawImage(canvas, 0, 0);
    // Next do the actual cropping
    let w = croppedCanvas.width;
    let h = croppedCanvas.height;
    const pix = {
        x: [],
        y: []
    };
    const imageData = croppedCtx.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
    let x;
    let y;
    let index;
    for(y = 0; y < h; y++)for(x = 0; x < w; x++){
        index = (y * w + x) * 4;
        if (imageData.data[index + 3] > 0) {
            pix.x.push(x);
            pix.y.push(y);
        }
    }
    pix.x.sort(function(a, b) {
        return a - b;
    });
    pix.y.sort(function(a, b) {
        return a - b;
    });
    const n = pix.x.length - 1;
    w = pix.x[n] - pix.x[0];
    h = pix.y[n] - pix.y[0];
    const cut = croppedCtx.getImageData(pix.x[0], pix.y[0], w, h);
    croppedCanvas.width = w;
    croppedCanvas.height = h;
    croppedCtx.putImageData(cut, 0, 0);
    return croppedCanvas.toBlob(resolve, "image/png");
}


"use strict";
const $fb656cfb6d0c95df$export$dc9b94c2f01d5cdc = $f1e050d09c03a884$export$2e2bcd8739ae039;
const $fb656cfb6d0c95df$export$37587d94861333b4 = $f1e050d09c03a884$export$37587d94861333b4;
const $fb656cfb6d0c95df$export$7816765f8a403870 = $f1e050d09c03a884$export$7816765f8a403870;
const $fb656cfb6d0c95df$export$cecca496aafda008 = $f1e050d09c03a884$export$cecca496aafda008;
const $fb656cfb6d0c95df$export$991ad14d6922400d = function(blob) {
    return URL.createObjectURL(blob);
};










var $54afc6c3c16a8b0e$var$img = /* #__PURE__ */ $3eadc1b959dd1120$export$463b44d9bf3628be($d4ad4a12c540b680$export$5d6626409df85f18);
var $54afc6c3c16a8b0e$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $54afc6c3c16a8b0e$export$5a9e55b53c98b40c = function(dictShiftMap) {
    var el$prime = $3eadc1b959dd1120$export$ad9e3aaa79fdf6(dictShiftMap);
    return function(dictMultiAlternative) {
        var el$prime1 = el$prime(dictMultiAlternative)($f4b2eb11fc32ed34$export$2330f868b62ed546);
        return function(props) {
            return el$prime1(function() {
                var $8 = $6500c29ba0ac3395$export$610acb4e9d1b3217($fb656cfb6d0c95df$export$dc9b94c2f01d5cdc);
                return function($9) {
                    return $8($1ac7a3b24b863c5b$export$3fe23fdec027b2e3($9));
                };
            }())(props)([]);
        };
    };
};
var $54afc6c3c16a8b0e$export$66868eac8f3bfe1e = function(props) {
    return function(sig) {
        return $54afc6c3c16a8b0e$var$img($54afc6c3c16a8b0e$var$append(props)([
            $fc1df90f0e252058$export$2e40c9e35e9506f4($fb656cfb6d0c95df$export$991ad14d6922400d(sig))
        ]));
    };
};
var $54afc6c3c16a8b0e$export$ab21f8771cc8d0ad = /* #__PURE__ */ $fc1df90f0e252058$export$d59e470a669dbbf6("sigBlob");
var $54afc6c3c16a8b0e$export$c2325eb3b282a3f9 = function(id) {
    return $de787439b660334b$export$497ef2ff78b6f4e4($fb656cfb6d0c95df$export$37587d94861333b4(id));
};
var $54afc6c3c16a8b0e$export$a1c066623ac679d3 = $fb656cfb6d0c95df$export$7816765f8a403870;
var $54afc6c3c16a8b0e$export$f5f9223cae27076f = $fb656cfb6d0c95df$export$cecca496aafda008;



var $d05245cedf9377b6$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $d05245cedf9377b6$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $d05245cedf9377b6$var$form = /* #__PURE__ */ $3eadc1b959dd1120$export$6210fa4921d2a466($d05245cedf9377b6$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $d05245cedf9377b6$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $d05245cedf9377b6$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($d05245cedf9377b6$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $d05245cedf9377b6$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $d05245cedf9377b6$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($d05245cedf9377b6$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $d05245cedf9377b6$var$signaturePad = /* #__PURE__ */ $54afc6c3c16a8b0e$export$5a9e55b53c98b40c($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5)($d05245cedf9377b6$var$multiAlternativeWidget);
var $d05245cedf9377b6$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $d05245cedf9377b6$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $d05245cedf9377b6$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $d05245cedf9377b6$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $d05245cedf9377b6$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $d05245cedf9377b6$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $d05245cedf9377b6$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $d05245cedf9377b6$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $d05245cedf9377b6$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $d05245cedf9377b6$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $d05245cedf9377b6$export$759de0f0add1b8af = /* #__PURE__ */ function() {
    function SubmitSignature(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SubmitSignature.create = function(value0) {
        return function(value1) {
            return new SubmitSignature(value0, value1);
        };
    };
    return SubmitSignature;
}();
var $d05245cedf9377b6$export$391daf791d30a06b = /* #__PURE__ */ function() {
    function SubmitSavedSignature() {}
    SubmitSavedSignature.value = new SubmitSavedSignature();
    return SubmitSavedSignature;
}();
var $d05245cedf9377b6$export$e3662b85905f38d5 = /* #__PURE__ */ function() {
    function FinishSigning() {}
    FinishSigning.value = new FinishSigning();
    return FinishSigning;
}();
var $d05245cedf9377b6$export$b9cc7f6050006517 = /* #__PURE__ */ function() {
    function ClearSignature() {}
    ClearSignature.value = new ClearSignature();
    return ClearSignature;
}();
var $d05245cedf9377b6$export$47806709fd8ebf15 = /* #__PURE__ */ function() {
    function SignWithSaved() {}
    SignWithSaved.value = new SignWithSaved();
    return SignWithSaved;
}();
var $d05245cedf9377b6$export$4e4f53e9c4c48ef7 = function(v) {
    return v.sig.first_name !== "" && v.sig.last_name !== "" && v.sig.email !== "";
};
var $d05245cedf9377b6$export$8c339efeeeaebf0f = function(v) {
    var maybeMsg = function() {
        if (v.msg instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
            $d05245cedf9377b6$var$text(v.msg.value0)
        ];
        if (v.msg instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        throw new Error("Failed pattern match at Widgets.Signature.Form (line 159, column 16 - line 161, column 22): " + [
            v.msg.constructor.name
        ]);
    }();
    return $d05245cedf9377b6$var$form([
        $fc1df90f0e252058$export$2913c0c0b5623090("signature-form modal-grid")
    ])($d05245cedf9377b6$var$append(function() {
        var $52 = !v.field.can.useDefault;
        if ($52) return [];
        return [
            $d05245cedf9377b6$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn signature-insert-default"),
                $fc1df90f0e252058$export$1741e49665a9c8e8("button"),
                $d05245cedf9377b6$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($d05245cedf9377b6$export$47806709fd8ebf15.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $d05245cedf9377b6$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("sig-form-sign-with-saved"))
            ])
        ];
    }())([
        $d05245cedf9377b6$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-form-pad-container")
        ])([
            $d05245cedf9377b6$var$signaturePad($d05245cedf9377b6$var$append([
                $fc1df90f0e252058$export$2913c0c0b5623090("signature-form-pad-canvas"),
                $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$84864e2081a33895(v.field.key)),
                $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-sigpad")
            ])($06733ae99ed4f534$export$f8b8b9ce72e9ccbf([])(function(blob) {
                return [
                    $54afc6c3c16a8b0e$export$ab21f8771cc8d0ad(blob)
                ];
            })(v.sig.signature))),
            $d05245cedf9377b6$var$button([
                $d05245cedf9377b6$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($d05245cedf9377b6$export$b9cc7f6050006517.value))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("signature-clear btn"),
                $fc1df90f0e252058$export$1741e49665a9c8e8("button")
            ])([
                $d05245cedf9377b6$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("clear-lowercase"))
            ])
        ]),
        $d05245cedf9377b6$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-form-info-container message")
        ])(maybeMsg),
        $d05245cedf9377b6$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-form-info-container")
        ])($d05245cedf9377b6$var$append([
            $d05245cedf9377b6$var$input([
                $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-first-name"),
                $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-first-name"),
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("first-name")),
                $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.sig.first_name),
                $d05245cedf9377b6$var$map($d05245cedf9377b6$var$map1($d05245cedf9377b6$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                    return {
                        field: v.field,
                        formId: v.formId,
                        msg: v.msg,
                        save: v.save,
                        sig: {
                            email: v.sig.email,
                            last_name: v.sig.last_name,
                            signature: v.sig.signature,
                            first_name: v1
                        }
                    };
                }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3)
            ]),
            $d05245cedf9377b6$var$input([
                $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-last-name"),
                $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-last-name"),
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("last-name")),
                $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.sig.last_name),
                $d05245cedf9377b6$var$map($d05245cedf9377b6$var$map1($d05245cedf9377b6$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                    return {
                        field: v.field,
                        formId: v.formId,
                        msg: v.msg,
                        save: v.save,
                        sig: {
                            email: v.sig.email,
                            first_name: v.sig.first_name,
                            signature: v.sig.signature,
                            last_name: v1
                        }
                    };
                }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3)
            ]),
            $d05245cedf9377b6$var$input([
                $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-email"),
                $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-email"),
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                $fc1df90f0e252058$export$d88a383e7d5eee04("email"),
                $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("email")),
                $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.sig.email),
                $d05245cedf9377b6$var$map($d05245cedf9377b6$var$map1($d05245cedf9377b6$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                    return {
                        field: v.field,
                        formId: v.formId,
                        msg: v.msg,
                        save: v.save,
                        sig: {
                            first_name: v.sig.first_name,
                            last_name: v.sig.last_name,
                            signature: v.sig.signature,
                            email: v1
                        }
                    };
                }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3)
            ])
        ])(function() {
            var $53 = !v.field.can.saveDefault;
            if ($53) return [];
            return [
                $d05245cedf9377b6$var$map2($d05245cedf9377b6$var$map1($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                    return {
                        field: v.field,
                        formId: v.formId,
                        msg: v.msg,
                        sig: v.sig,
                        save: v1
                    };
                }))($fc8e139dfeeff88c$export$344f17102956e4bc($308f9765feb7633d$export$84864e2081a33895(v.field.key) + "-savecheck")($c3328e54cdf5154c$export$5a1a8430df9521e("save-signature"))(v.save))
            ];
        }())),
        $d05245cedf9377b6$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal-buttons")
        ])([
            $d05245cedf9377b6$var$button([
                $d05245cedf9377b6$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($d05245cedf9377b6$export$e3662b85905f38d5.value))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                $fc1df90f0e252058$export$1741e49665a9c8e8("button")
            ])([
                $d05245cedf9377b6$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("sign"))
            ])
        ])
    ]));
};
var $d05245cedf9377b6$export$a5e011bf86379fa = function(formId) {
    return function(field) {
        return function(sig) {
            return {
                field: field,
                formId: formId,
                sig: sig,
                msg: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                save: false
            };
        };
    };
};
var $d05245cedf9377b6$export$af13394a2b23e8b0 = function(v) {
    return function(v1) {
        if (v1 instanceof $d05245cedf9377b6$export$e3662b85905f38d5) {
            var $57 = !$d05245cedf9377b6$export$4e4f53e9c4c48ef7(v);
            if ($57) return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                field: v.field,
                formId: v.formId,
                save: v.save,
                sig: v.sig,
                msg: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("signature-form-invalid"))
            }));
            return $d05245cedf9377b6$var$bind($d05245cedf9377b6$var$liftEffect($54afc6c3c16a8b0e$export$f5f9223cae27076f($308f9765feb7633d$export$84864e2081a33895(v.field.key))))(function(hasInk) {
                var $58 = !hasInk;
                if ($58) return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                    field: v.field,
                    formId: v.formId,
                    save: v.save,
                    sig: v.sig,
                    msg: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("signature-form-invalid"))
                }));
                return $d05245cedf9377b6$var$bind($d05245cedf9377b6$var$alt($3257df7cdef77623$export$b97f2ad8d0b7442d($54afc6c3c16a8b0e$export$c2325eb3b282a3f9($308f9765feb7633d$export$84864e2081a33895(v.field.key))))($9c13a1c3d948adb8$export$be9e2feb4e35335b($d05245cedf9377b6$export$8c339efeeeaebf0f(v))))(function(blob) {
                    var sig$prime = $995df59c0c2f7d8f$export$2c46e451e46a8931(v.sig)(blob);
                    var opts = {
                        saveDefault: v.save
                    };
                    return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a(new $d05245cedf9377b6$export$759de0f0add1b8af(sig$prime, opts))));
                });
            });
        }
        if (v1 instanceof $d05245cedf9377b6$export$47806709fd8ebf15) return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(new $7d4cccdf062a2261$export$19db0165690c701a($d05245cedf9377b6$export$391daf791d30a06b.value)));
        if (v1 instanceof $d05245cedf9377b6$export$b9cc7f6050006517) return $d05245cedf9377b6$var$discard($d05245cedf9377b6$var$liftEffect($54afc6c3c16a8b0e$export$a1c066623ac679d3($308f9765feb7633d$export$84864e2081a33895(v.field.key))))(function() {
            return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515({
                field: v.field,
                formId: v.formId,
                msg: v.msg,
                save: v.save,
                sig: {
                    email: v.sig.email,
                    first_name: v.sig.first_name,
                    last_name: v.sig.last_name,
                    signature: $06733ae99ed4f534$export$bebe9059409a0d04.value
                }
            }));
        });
        throw new Error("Failed pattern match at Widgets.Signature.Form (line 72, column 1 - line 72, column 99): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $d05245cedf9377b6$export$697a51f1cbee3661 = function(state) {
    return $d05245cedf9377b6$var$bind($d05245cedf9377b6$export$8c339efeeeaebf0f(state))(function(res) {
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $d05245cedf9377b6$export$af13394a2b23e8b0(state)(res.value0);
        if (res instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $d05245cedf9377b6$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(res.value0));
        throw new Error("Failed pattern match at Widgets.Signature.Form (line 58, column 5 - line 60, column 42): " + [
            res.constructor.name
        ]);
    });
};
var $d05245cedf9377b6$export$7ea7a241c847226d = function(state) {
    return $d05245cedf9377b6$var$loopState(state)($d05245cedf9377b6$export$697a51f1cbee3661);
};




var $9e1209acd51c3c43$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $9e1209acd51c3c43$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($9e1209acd51c3c43$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9e1209acd51c3c43$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $9e1209acd51c3c43$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $9e1209acd51c3c43$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $9e1209acd51c3c43$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $9e1209acd51c3c43$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $9e1209acd51c3c43$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $9e1209acd51c3c43$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($9e1209acd51c3c43$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9e1209acd51c3c43$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($9e1209acd51c3c43$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9e1209acd51c3c43$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($9e1209acd51c3c43$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9e1209acd51c3c43$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $9e1209acd51c3c43$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $9e1209acd51c3c43$var$img = /* #__PURE__ */ $3eadc1b959dd1120$export$463b44d9bf3628be($d4ad4a12c540b680$export$5d6626409df85f18);
var $9e1209acd51c3c43$var$p = /* #__PURE__ */ $3eadc1b959dd1120$export$ffb5f4729a158638($9e1209acd51c3c43$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $9e1209acd51c3c43$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $9e1209acd51c3c43$export$b1fe1f0959298e55 = /* #__PURE__ */ function() {
    function UseCapturedSignature(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    UseCapturedSignature.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new UseCapturedSignature(value0, value1, value2);
            };
        };
    };
    return UseCapturedSignature;
}();
var $9e1209acd51c3c43$export$867457edc5373faa = /* #__PURE__ */ function() {
    function UseSavedSignature(value0) {
        this.value0 = value0;
    }
    UseSavedSignature.create = function(value0) {
        return new UseSavedSignature(value0);
    };
    return UseSavedSignature;
}();
var $9e1209acd51c3c43$export$5a83090ef184a93b = /* #__PURE__ */ function() {
    function SendSignatureRequest(value0) {
        this.value0 = value0;
    }
    SendSignatureRequest.create = function(value0) {
        return new SendSignatureRequest(value0);
    };
    return SendSignatureRequest;
}();
var $9e1209acd51c3c43$export$cd1dacf7883b62fd = /* #__PURE__ */ function() {
    function OpenSigForm() {}
    OpenSigForm.value = new OpenSigForm();
    return OpenSigForm;
}();
var $9e1209acd51c3c43$export$f0e55c0d131a7dd2 = /* #__PURE__ */ function() {
    function OpenEmailForm() {}
    OpenEmailForm.value = new OpenEmailForm();
    return OpenEmailForm;
}();
var $9e1209acd51c3c43$export$47806709fd8ebf15 = /* #__PURE__ */ function() {
    function SignWithSaved() {}
    SignWithSaved.value = new SignWithSaved();
    return SignWithSaved;
}();
var $9e1209acd51c3c43$export$2fbacce6e06896bf = /* #__PURE__ */ function() {
    function LocalSignature(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    LocalSignature.create = function(value0) {
        return function(value1) {
            return new LocalSignature(value0, value1);
        };
    };
    return LocalSignature;
}();
var $9e1209acd51c3c43$export$2d5360fdc96d4c55 = /* #__PURE__ */ function() {
    function RemoteSignature(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RemoteSignature.create = function(value0) {
        return function(value1) {
            return new RemoteSignature(value0, value1);
        };
    };
    return RemoteSignature;
}();
var $9e1209acd51c3c43$export$9032cda97d902511 = /* #__PURE__ */ function() {
    function Emailed(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    Emailed.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new Emailed(value0, value1, value2);
            };
        };
    };
    return Emailed;
}();
var $9e1209acd51c3c43$export$5f16651425e8feee = /* #__PURE__ */ function() {
    function NotSigned() {}
    NotSigned.value = new NotSigned();
    return NotSigned;
}();
var $9e1209acd51c3c43$export$e1545ad466c4b099 = /* #__PURE__ */ function() {
    function SigWidgetChanged(value0) {
        this.value0 = value0;
    }
    SigWidgetChanged.create = function(value0) {
        return new SigWidgetChanged(value0);
    };
    return SigWidgetChanged;
}();
var $9e1209acd51c3c43$export$413cbe71e66f0ed3 = /* #__PURE__ */ function() {
    function SigWidgetMutation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SigWidgetMutation.create = function(value0) {
        return function(value1) {
            return new SigWidgetMutation(value0, value1);
        };
    };
    return SigWidgetMutation;
}();
var $9e1209acd51c3c43$export$bbc28acccf2591b0 = /* #__PURE__ */ function() {
    function AutofillOp() {}
    AutofillOp.value = new AutofillOp();
    return AutofillOp;
}();
var $9e1209acd51c3c43$export$3a989378240d784e = /* #__PURE__ */ function() {
    function AuthoritativeOp() {}
    AuthoritativeOp.value = new AuthoritativeOp();
    return AuthoritativeOp;
}();
var $9e1209acd51c3c43$export$a48cf48e4d948998 = function(v) {
    if (v.signature instanceof $9e1209acd51c3c43$export$2d5360fdc96d4c55) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.signature.value1);
    if (v.signature instanceof $9e1209acd51c3c43$export$2fbacce6e06896bf) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.signature.value1);
    if (v.signature instanceof $9e1209acd51c3c43$export$9032cda97d902511) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    if (v.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Widgets.Signature (line 121, column 1 - line 121, column 48): " + [
        v.constructor.name
    ]);
};
var $9e1209acd51c3c43$export$a6ac87ba061c76af = function(v) {
    if (v.signature instanceof $9e1209acd51c3c43$export$9032cda97d902511) {
        var sentLinkBtn = function(lbl) {
            return $9e1209acd51c3c43$var$a([
                $fc1df90f0e252058$export$1d5a917feb871989,
                $fc1df90f0e252058$export$8f51af5840e0602a("javascript:void(0);"),
                $fc1df90f0e252058$export$2913c0c0b5623090("signature-copy-link")
            ])([
                $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(lbl))
            ]);
        };
        var sentLink = function(lbl) {
            return $9e1209acd51c3c43$var$bind(sentLinkBtn(lbl))(function() {
                return $9e1209acd51c3c43$var$discard($9e1209acd51c3c43$var$alt($3257df7cdef77623$export$b97f2ad8d0b7442d($ce79b167faae41da$export$bec150f75a9b8f11(v.signature.value2)))($9c13a1c3d948adb8$export$be9e2feb4e35335b(sentLinkBtn(lbl))))(function() {
                    return $9e1209acd51c3c43$var$bind($9e1209acd51c3c43$var$alt($9e1209acd51c3c43$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(sentLink("email-sent-link-copied")))($9e1209acd51c3c43$var$discard($3257df7cdef77623$export$b97f2ad8d0b7442d($edf0339512807bee$export$1391212d75b2ee65(5000.0)))(function() {
                        return $9e1209acd51c3c43$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342));
                    })))(function(ret) {
                        if (ret instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $9e1209acd51c3c43$var$pure(ret.value0);
                        if (ret instanceof $7d4cccdf062a2261$export$19db0165690c701a) return sentLink("email-sent-link");
                        throw new Error("Failed pattern match at Widgets.Signature (line 196, column 9 - line 198, column 50): " + [
                            ret.constructor.name
                        ]);
                    });
                });
            });
        };
        return $9e1209acd51c3c43$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("sign-here emailed")
        ])([
            $9e1209acd51c3c43$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("emailed-notice")
            ])([
                $9e1209acd51c3c43$var$div$prime([
                    $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("email-sent-to") + (" " + v.info.email))
                ]),
                $9e1209acd51c3c43$var$div$prime([
                    $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("email-sent-at") + (" " + $35e75b0a064776f5$export$cde3d1388a9feac3(v.signature.value0)))
                ]),
                $9e1209acd51c3c43$var$div$prime([
                    sentLink("email-sent-link")
                ])
            ])
        ]);
    }
    if (v.signature instanceof $9e1209acd51c3c43$export$2fbacce6e06896bf) {
        var name = v.info.first_name + (" " + v.info.last_name);
        return $9e1209acd51c3c43$var$button($9e1209acd51c3c43$var$append1(function() {
            if (v.field.can.update) return [
                $9e1209acd51c3c43$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$cd1dacf7883b62fd.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ];
            return [];
        }())([
            $fc1df90f0e252058$export$2913c0c0b5623090("sign-here signed")
        ]))([
            $54afc6c3c16a8b0e$export$66868eac8f3bfe1e([
                $fc1df90f0e252058$export$228be17d80722ab("Signature of " + name)
            ])(v.signature.value0)
        ]);
    }
    if (v.signature instanceof $9e1209acd51c3c43$export$2d5360fdc96d4c55) {
        var name = v.info.first_name + (" " + v.info.last_name);
        return $9e1209acd51c3c43$var$button($9e1209acd51c3c43$var$append1(function() {
            if (v.field.can.update) return [
                $9e1209acd51c3c43$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$cd1dacf7883b62fd.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ];
            return [];
        }())([
            $fc1df90f0e252058$export$2913c0c0b5623090("sign-here signed")
        ]))([
            $9e1209acd51c3c43$var$img([
                $fc1df90f0e252058$export$228be17d80722ab("Signature of " + name),
                $fc1df90f0e252058$export$2e40c9e35e9506f4(v.signature.value0)
            ])
        ]);
    }
    if (v.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee && !v.field.can.create) return $9e1209acd51c3c43$var$button([
        $fc1df90f0e252058$export$2913c0c0b5623090("sign-here disabled")
    ])([
        $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("no-sign-here"))
    ]);
    if (v.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee && v.field.can.create) return $9e1209acd51c3c43$var$button([
        $9e1209acd51c3c43$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$cd1dacf7883b62fd.value))($fc1df90f0e252058$export$1d5a917feb871989),
        $fc1df90f0e252058$export$2913c0c0b5623090("sign-here")
    ])([
        $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("sign-here"))
    ]);
    throw new Error("Failed pattern match at Widgets.Signature (line 175, column 1 - line 175, column 88): " + [
        v.constructor.name
    ]);
};
var $9e1209acd51c3c43$export$d3ac868ec9ea54fe = function(v) {
    var name = v.info.first_name + (" " + v.info.last_name);
    var v1 = $9e1209acd51c3c43$export$a48cf48e4d948998(v);
    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
        $9e1209acd51c3c43$var$p([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-name")
        ])([
            $9e1209acd51c3c43$var$text(name)
        ]),
        $9e1209acd51c3c43$var$p([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-time")
        ])([
            $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("signed-at") + (" " + $35e75b0a064776f5$export$cde3d1388a9feac3(v1.value0)))
        ])
    ];
    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
    throw new Error("Failed pattern match at Widgets.Signature (line 228, column 62 - line 234, column 18): " + [
        v1.constructor.name
    ]);
};
var $9e1209acd51c3c43$export$7b3e3f7bdfc82bc1 = function(v) {
    if (v.info.email === "" && !v.field.can.request) return $9e1209acd51c3c43$var$div$prime([]);
    if (v.info.email === "") return $9e1209acd51c3c43$var$button([
        $9e1209acd51c3c43$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$f0e55c0d131a7dd2.value))($fc1df90f0e252058$export$1d5a917feb871989),
        $fc1df90f0e252058$export$2913c0c0b5623090("signature-add-email")
    ])([
        $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("signature-add-email"))
    ]);
    var alreadySent = function() {
        if (v.signature instanceof $9e1209acd51c3c43$export$9032cda97d902511) return true;
        return false;
    }();
    var sendText = function() {
        if (alreadySent) return "signature-resend-email";
        return "signature-send-email";
    }();
    return $9e1209acd51c3c43$var$p([
        $fc1df90f0e252058$export$2913c0c0b5623090("signature-email")
    ])([
        $9e1209acd51c3c43$var$text(v.info.email + " "),
        $9e1209acd51c3c43$var$button([
            $9e1209acd51c3c43$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$f0e55c0d131a7dd2.value))($fc1df90f0e252058$export$1d5a917feb871989),
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-add-email")
        ])([
            $9e1209acd51c3c43$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(sendText))
        ])
    ]);
};
var $9e1209acd51c3c43$export$81f50cd03ebf66fe = function(state) {
    return function(result) {
        var comment = $06733ae99ed4f534$export$43db023a260c5e9f("")(result.data.comment);
        return {
            field: state.field,
            docId: state.docId,
            signature: new $9e1209acd51c3c43$export$9032cda97d902511(result.created_at, comment, result.link),
            info: {
                first_name: state.info.first_name,
                last_name: state.info.last_name,
                email: result.data.email
            }
        };
    };
};
var $9e1209acd51c3c43$export$e9b36b4bf07a79e8 = function(state) {
    return function(result) {
        return {
            field: state.field,
            docId: state.docId,
            signature: new $9e1209acd51c3c43$export$2d5360fdc96d4c55(result.url, result.created_at),
            info: {
                first_name: result.contact.first_name,
                last_name: result.contact.last_name,
                email: result.contact.email
            }
        };
    };
};
var $9e1209acd51c3c43$export$968bc416486c1a61 = function(v) {
    return function(v1) {
        return function(v2) {
            if (v instanceof $9e1209acd51c3c43$export$bbc28acccf2591b0 && v1.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee) return {
                field: v1.field,
                docId: v1.docId,
                signature: v1.signature,
                info: {
                    first_name: $06733ae99ed4f534$export$43db023a260c5e9f(v1.info.first_name)(v2.default_first_name),
                    last_name: $06733ae99ed4f534$export$43db023a260c5e9f(v1.info.last_name)(v2.default_last_name),
                    email: $06733ae99ed4f534$export$43db023a260c5e9f(v1.info.email)(v2.default_email)
                }
            };
            if (v instanceof $9e1209acd51c3c43$export$3a989378240d784e && v1.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee) return {
                field: v1.field,
                docId: v1.docId,
                signature: v1.signature,
                info: {
                    first_name: $06733ae99ed4f534$export$43db023a260c5e9f("")(v2.default_first_name),
                    last_name: $06733ae99ed4f534$export$43db023a260c5e9f("")(v2.default_last_name),
                    email: $06733ae99ed4f534$export$43db023a260c5e9f("")(v2.default_email)
                }
            };
            return v1;
        };
    };
};
var $9e1209acd51c3c43$export$6c9f11a9d3b4445b = function(v) {
    if (v.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee) return false;
    return true;
};
var $9e1209acd51c3c43$export$d1dbaa2c21a7e5ac = function(v) {
    if (v.signature instanceof $9e1209acd51c3c43$export$5f16651425e8feee) return false;
    if (v.signature instanceof $9e1209acd51c3c43$export$9032cda97d902511) return false;
    return true;
};
var $9e1209acd51c3c43$export$9d908154ebf0e060 = function(state) {
    var signedOrEmailed = $9e1209acd51c3c43$export$6c9f11a9d3b4445b(state);
    var signed = $9e1209acd51c3c43$export$d1dbaa2c21a7e5ac(state);
    var renderBtn = $9e1209acd51c3c43$var$button([
        $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-button"),
        $fc1df90f0e252058$export$1d5a917feb871989
    ])([
        $9e1209acd51c3c43$var$text("\u2807")
    ]);
    var menu = $396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        $c3ec47a57216184e$export$71e337785367343c(state.field.can.create && !signed)({
            value: new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$cd1dacf7883b62fd.value),
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("sign")
        }),
        $c3ec47a57216184e$export$71e337785367343c(state.field.can.useDefault && !signed)({
            value: new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$47806709fd8ebf15.value),
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("sign-with-saved")
        }),
        $c3ec47a57216184e$export$71e337785367343c(state.field.can.request && !signedOrEmailed)({
            value: new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$f0e55c0d131a7dd2.value),
            label: $c3328e54cdf5154c$export$5a1a8430df9521e("email-to-sign")
        }),
        $c3ec47a57216184e$export$71e337785367343c(state.field.can.request)(function() {
            var $130 = state.info.email === "";
            if ($130) return {
                value: new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$f0e55c0d131a7dd2.value),
                label: $c3328e54cdf5154c$export$5a1a8430df9521e("add-email")
            };
            return {
                value: new $7d4cccdf062a2261$export$19db0165690c701a($9e1209acd51c3c43$export$f0e55c0d131a7dd2.value),
                label: $c3328e54cdf5154c$export$5a1a8430df9521e("edit-email")
            };
        }())
    ]);
    var emptyMenu = $9e1209acd51c3c43$var$length(menu) === 0;
    if (emptyMenu) return $9e1209acd51c3c43$var$div$prime([]);
    return $9fec91fabe90d735$export$877c9c2e37d22fef(renderBtn)(menu);
};
var $9e1209acd51c3c43$export$9364cfcf0b92af26 = function(state) {
    return $9e1209acd51c3c43$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("signature-widget")
    ])($9e1209acd51c3c43$var$append1([
        $9e1209acd51c3c43$export$a6ac87ba061c76af(state),
        $9e1209acd51c3c43$export$9d908154ebf0e060(state),
        $9e1209acd51c3c43$var$p([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-type")
        ])([
            $9e1209acd51c3c43$var$text(state.field.label)
        ])
    ])($9e1209acd51c3c43$var$append1($9e1209acd51c3c43$export$d3ac868ec9ea54fe(state))(function() {
        if (state.field.can.request) return [
            $9e1209acd51c3c43$export$7b3e3f7bdfc82bc1(state)
        ];
        return [];
    }())));
};
var $9e1209acd51c3c43$export$50dce11617ccaacf = function(docId) {
    return function(field) {
        return function(info) {
            return {
                docId: docId,
                field: field,
                info: info,
                signature: $9e1209acd51c3c43$export$5f16651425e8feee.value
            };
        };
    };
};
var $9e1209acd51c3c43$export$abd11f53d504e8e5 = function(v) {
    return function(v1) {
        if (v1 instanceof $9e1209acd51c3c43$export$cd1dacf7883b62fd) {
            var initSig = $995df59c0c2f7d8f$export$2c46e451e46a8931(v.info)($06733ae99ed4f534$export$bebe9059409a0d04.value);
            var sfState = $d05245cedf9377b6$export$a5e011bf86379fa(v.docId)(v.field)(initSig);
            return $9e1209acd51c3c43$var$bind($035405231d3ae317$export$34d1415d60a4cca4($9e1209acd51c3c43$export$9364cfcf0b92af26(v))($d05245cedf9377b6$export$7ea7a241c847226d(sfState)))(function(res) {
                if (res instanceof $035405231d3ae317$export$a09a21bd8097e7) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$e1545ad466c4b099(v));
                if (res instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && res.value0 instanceof $d05245cedf9377b6$export$759de0f0add1b8af) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$413cbe71e66f0ed3(v, new $9e1209acd51c3c43$export$b1fe1f0959298e55(v.field, res.value0.value0, res.value0.value1)));
                if (res instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && res.value0 instanceof $d05245cedf9377b6$export$391daf791d30a06b) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$413cbe71e66f0ed3(v, new $9e1209acd51c3c43$export$867457edc5373faa(v.field)));
                throw new Error("Failed pattern match at Widgets.Signature (line 140, column 5 - line 145, column 75): " + [
                    res.constructor.name
                ]);
            });
        }
        if (v1 instanceof $9e1209acd51c3c43$export$f0e55c0d131a7dd2) {
            var prevComment = function() {
                if (v.signature instanceof $9e1209acd51c3c43$export$9032cda97d902511) return v.signature.value1;
                return "";
            }();
            return $9e1209acd51c3c43$var$bind($035405231d3ae317$export$21159b4378d24276($9e1209acd51c3c43$export$9364cfcf0b92af26(v))($17c0a976f7d5153b$export$eba6650f811eae85({
                email: v.info.email,
                comment: prevComment
            })(v.docId)(v.field)))(function(res) {
                if (res instanceof $035405231d3ae317$export$a09a21bd8097e7) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$e1545ad466c4b099(v));
                if (res instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && res.value0 instanceof $17c0a976f7d5153b$export$8662aba10c302783) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$e1545ad466c4b099({
                    field: v.field,
                    docId: v.docId,
                    signature: v.signature,
                    info: {
                        first_name: v.info.first_name,
                        last_name: v.info.last_name,
                        email: res.value0.value0.email
                    }
                }));
                if (res instanceof $035405231d3ae317$export$c00f2c00f91f14d5 && res.value0 instanceof $17c0a976f7d5153b$export$5410dc4fc2fdd666) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$413cbe71e66f0ed3({
                    field: v.field,
                    docId: v.docId,
                    signature: v.signature,
                    info: {
                        first_name: v.info.first_name,
                        last_name: v.info.last_name,
                        email: res.value0.value0.email
                    }
                }, new $9e1209acd51c3c43$export$5a83090ef184a93b(res.value0.value0)));
                throw new Error("Failed pattern match at Widgets.Signature (line 153, column 5 - line 160, column 111): " + [
                    res.constructor.name
                ]);
            });
        }
        if (v1 instanceof $9e1209acd51c3c43$export$47806709fd8ebf15) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$413cbe71e66f0ed3(v, new $9e1209acd51c3c43$export$867457edc5373faa(v.field)));
        throw new Error("Failed pattern match at Widgets.Signature (line 134, column 1 - line 134, column 83): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $9e1209acd51c3c43$export$a6b0d694c52af37 = function(state) {
    return $9e1209acd51c3c43$var$bind($9e1209acd51c3c43$export$9364cfcf0b92af26(state))(function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $9e1209acd51c3c43$var$pure(new $9e1209acd51c3c43$export$e1545ad466c4b099(v.value0));
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $9e1209acd51c3c43$export$abd11f53d504e8e5(state)(v.value0);
        throw new Error("Failed pattern match at Widgets.Signature (line 130, column 51 - line 132, column 42): " + [
            v.constructor.name
        ]);
    });
};
var $9e1209acd51c3c43$export$711cbd329a1bfae7 = function(docId) {
    return function(field) {
        return $9e1209acd51c3c43$export$50dce11617ccaacf(docId)($995df59c0c2f7d8f$export$c9e7e3da0d364b66(field))($995df59c0c2f7d8f$export$93dd1e77e9808eaf);
    };
};
var $9e1209acd51c3c43$export$92951287777f78c8 = function(docId) {
    return function(field) {
        return $9e1209acd51c3c43$export$50dce11617ccaacf(docId)($995df59c0c2f7d8f$export$ec1fe12c819d4041(field))($995df59c0c2f7d8f$export$93dd1e77e9808eaf);
    };
};


// Generated by purs version 0.15.16






















var $dac1e623683e2554$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $dac1e623683e2554$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8));
var $dac1e623683e2554$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $dac1e623683e2554$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $dac1e623683e2554$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $dac1e623683e2554$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $dac1e623683e2554$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($dac1e623683e2554$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $dac1e623683e2554$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $dac1e623683e2554$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($dac1e623683e2554$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $dac1e623683e2554$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $dac1e623683e2554$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $dac1e623683e2554$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $dac1e623683e2554$export$830e94389988a00a = /* #__PURE__ */ function() {
    function SignatureWidgetRequest(value0) {
        this.value0 = value0;
    }
    SignatureWidgetRequest.create = function(value0) {
        return new SignatureWidgetRequest(value0);
    };
    return SignatureWidgetRequest;
}();
var $dac1e623683e2554$export$36d0c4e205277a37 = /* #__PURE__ */ function() {
    function SignatureEmailRequests(value0) {
        this.value0 = value0;
    }
    SignatureEmailRequests.create = function(value0) {
        return new SignatureEmailRequests(value0);
    };
    return SignatureEmailRequests;
}();
var $dac1e623683e2554$export$c736b0a2b52ee2ae = /* #__PURE__ */ function() {
    function SigGroupChanged(value0) {
        this.value0 = value0;
    }
    SigGroupChanged.create = function(value0) {
        return new SigGroupChanged(value0);
    };
    return SigGroupChanged;
}();
var $dac1e623683e2554$export$b6f0dd2113b2748d = /* #__PURE__ */ function() {
    function SigGroupMutation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SigGroupMutation.create = function(value0) {
        return function(value1) {
            return new SigGroupMutation(value0, value1);
        };
    };
    return SigGroupMutation;
}();
var $dac1e623683e2554$export$9567d5f932f6e448 = /* #__PURE__ */ function() {
    function EmailAll() {}
    EmailAll.value = new EmailAll();
    return EmailAll;
}();
var $dac1e623683e2554$export$cf5a28a3dd28a437 = function(sgs) {
    return function(defs) {
        var findKey = function(arr) {
            return function(key) {
                return $dac1e623683e2554$var$find(function(r) {
                    return $dac1e623683e2554$var$eq(r.key)(key);
                })(arr);
            };
        };
        var updateSig = function(ssig) {
            var v = findKey(defs)(ssig.field.key);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9e1209acd51c3c43$export$968bc416486c1a61($9e1209acd51c3c43$export$bbc28acccf2591b0.value)(ssig)(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return ssig;
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 88, column 22 - line 90, column 24): " + [
                v.constructor.name
            ]);
        };
        return {
            id: sgs.id,
            docId: sgs.docId,
            account: sgs.account,
            sigs: $dac1e623683e2554$var$map(updateSig)(sgs.sigs)
        };
    };
};
var $dac1e623683e2554$export$9ca7b12696105606 = function(state) {
    var sigWidget = function(idx) {
        return function(sig) {
            var newSigs = function(sig$prime) {
                return $06733ae99ed4f534$export$43db023a260c5e9f(state.sigs)($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)(sig$prime)(state.sigs));
            };
            return $dac1e623683e2554$var$bind($9e1209acd51c3c43$export$a6b0d694c52af37(sig))(function(result) {
                if (result instanceof $9e1209acd51c3c43$export$e1545ad466c4b099) return $dac1e623683e2554$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $dac1e623683e2554$export$c736b0a2b52ee2ae({
                    id: state.id,
                    docId: state.docId,
                    account: state.account,
                    sigs: newSigs(result.value0)
                })));
                if (result instanceof $9e1209acd51c3c43$export$413cbe71e66f0ed3) return $dac1e623683e2554$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $dac1e623683e2554$export$b6f0dd2113b2748d({
                    id: state.id,
                    docId: state.docId,
                    account: state.account,
                    sigs: newSigs(result.value0)
                }, new $dac1e623683e2554$export$830e94389988a00a(result.value1))));
                throw new Error("Failed pattern match at Widgets.Signature.Group (line 121, column 9 - line 125, column 112): " + [
                    result.constructor.name
                ]);
            });
        };
    };
    var sigWidgets = $396c4c3d9e7fae3c$export$8f07ddce13659f50(sigWidget)(state.sigs);
    var actionBtns = $dac1e623683e2554$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("btn-group btn-group-email")
    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
        $c3ec47a57216184e$export$71e337785367343c($dac1e623683e2554$var$any(function(v) {
            return v.field.can.request;
        })(state.sigs))($dac1e623683e2554$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("btn email-all"),
            $dac1e623683e2554$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($dac1e623683e2554$export$9567d5f932f6e448.value))($fc1df90f0e252058$export$1d5a917feb871989)
        ])([
            $dac1e623683e2554$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("email-all"))
        ]))
    ]));
    return $dac1e623683e2554$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("signature-group")
    ])($dac1e623683e2554$var$append(sigWidgets)([
        actionBtns
    ]));
};
var $dac1e623683e2554$export$900b744f10716a0e = function(signatureFields) {
    return function(state) {
        var findKey = function(key) {
            return $dac1e623683e2554$var$find(function(field) {
                return $dac1e623683e2554$var$eq(field.key)(key);
            })(signatureFields);
        };
        var refreshSig = function(sig) {
            var v = findKey(sig.field.key);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9e1209acd51c3c43$export$968bc416486c1a61($9e1209acd51c3c43$export$3a989378240d784e.value)({
                info: sig.info,
                docId: sig.docId,
                signature: sig.signature,
                field: $995df59c0c2f7d8f$export$ec1fe12c819d4041(v.value0)
            })(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return sig;
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 146, column 22 - line 148, column 23): " + [
                v.constructor.name
            ]);
        };
        return {
            id: state.id,
            docId: state.docId,
            account: state.account,
            sigs: $dac1e623683e2554$var$map(refreshSig)(state.sigs)
        };
    };
};
var $dac1e623683e2554$export$2e64befa789ea6d2 = function(v) {
    return function(state) {
        var findVerif = function(key) {
            return $dac1e623683e2554$var$find(function(r) {
                return $dac1e623683e2554$var$eq(r.data.key)(key);
            })(v.verifications);
        };
        var findKey = function(arr) {
            return function(key) {
                return $dac1e623683e2554$var$find(function(r) {
                    return $dac1e623683e2554$var$eq(r.key)(key);
                })(arr);
            };
        };
        var loadDefs = function(ssig) {
            var v1 = findKey(v.signature_fields)(ssig.field.key);
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9e1209acd51c3c43$export$968bc416486c1a61($9e1209acd51c3c43$export$3a989378240d784e.value)(ssig)(v1.value0);
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return ssig;
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 76, column 21 - line 78, column 24): " + [
                v1.constructor.name
            ]);
        };
        var loadVerif = function(ssig) {
            var v1 = findVerif(ssig.field.key);
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9e1209acd51c3c43$export$81f50cd03ebf66fe(ssig)(v1.value0);
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return loadDefs(ssig);
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 71, column 22 - line 73, column 33): " + [
                v1.constructor.name
            ]);
        };
        var loadSig = function(ssig) {
            var v1 = findKey(v.signatures)(ssig.field.key);
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $9e1209acd51c3c43$export$e9b36b4bf07a79e8(ssig)(v1.value0);
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return loadVerif(ssig);
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 66, column 20 - line 68, column 34): " + [
                v1.constructor.name
            ]);
        };
        return {
            id: state.id,
            docId: state.docId,
            account: state.account,
            sigs: $dac1e623683e2554$var$map(loadSig)(state.sigs)
        };
    };
};
var $dac1e623683e2554$export$35a6e7afb25974d3 = function(verifications) {
    return $dac1e623683e2554$export$2e64befa789ea6d2({
        signatures: [],
        signature_fields: [],
        verifications: verifications
    });
};
var $dac1e623683e2554$export$d6c482f7add97bee = function(account) {
    return function(id) {
        return function(docId) {
            return function(sigs) {
                return {
                    id: id,
                    docId: docId,
                    sigs: sigs,
                    account: account
                };
            };
        };
    };
};
var $dac1e623683e2554$export$d506f18fc6a4a497 = function(state) {
    return function(v) {
        var toEmailEntry = function(v1) {
            return {
                field: v1.field,
                email: v1.info.email,
                selected: false,
                doc: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
        };
        return $dac1e623683e2554$var$bind($035405231d3ae317$export$21159b4378d24276($dac1e623683e2554$export$9ca7b12696105606(state))($17c0a976f7d5153b$export$759442ad371577a6(state.account)(state.docId)($dac1e623683e2554$var$map(toEmailEntry)($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v1) {
            return v1.field.can.request;
        })(state.sigs)))))(function(res) {
            if (res instanceof $035405231d3ae317$export$a09a21bd8097e7) return $dac1e623683e2554$var$pure(new $dac1e623683e2554$export$c736b0a2b52ee2ae(state));
            if (res instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $dac1e623683e2554$var$pure(new $dac1e623683e2554$export$b6f0dd2113b2748d(state, new $dac1e623683e2554$export$36d0c4e205277a37(res.value0)));
            throw new Error("Failed pattern match at Widgets.Signature.Group (line 103, column 5 - line 105, column 98): " + [
                res.constructor.name
            ]);
        });
    };
};
var $dac1e623683e2554$export$c0507b2ebcc161de = function(state) {
    return $dac1e623683e2554$var$bind($dac1e623683e2554$export$9ca7b12696105606(state))(function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $dac1e623683e2554$var$pure(v.value0);
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $dac1e623683e2554$export$d506f18fc6a4a497(state)(v.value0);
        throw new Error("Failed pattern match at Widgets.Signature.Group (line 95, column 49 - line 97, column 42): " + [
            v.constructor.name
        ]);
    });
};


var $3fccd7b645ad9243$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $3fccd7b645ad9243$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $3fccd7b645ad9243$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $3fccd7b645ad9243$var$runGraphQL_ = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$d1b23fba9f6872eb($a40b20519abba0fb$export$fe526d00b95b6f09);
var $3fccd7b645ad9243$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $3fccd7b645ad9243$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $3fccd7b645ad9243$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $3fccd7b645ad9243$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($3fccd7b645ad9243$var$eqRNTY));
var $3fccd7b645ad9243$var$notEq1 = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $3fccd7b645ad9243$var$notEq2 = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($2a035e92dc768ac1$export$e8f903c542fcf2a5);
var $3fccd7b645ad9243$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $3fccd7b645ad9243$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $3fccd7b645ad9243$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($3fccd7b645ad9243$var$eqRNTY);
var $3fccd7b645ad9243$var$notEq3 = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($02eacf321b2a2128$export$5315b7c1b1d9e384);
var $3fccd7b645ad9243$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88(/* #__PURE__ */ $d2284b2d3e1b6f87$export$d684c62fe584fcfa($edf0339512807bee$export$e8a7d9b8d7dc616a));
var $3fccd7b645ad9243$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $3fccd7b645ad9243$var$syncDocMetadata = function(doc) {
    return function(workQueueState) {
        return function(workQueueUi) {
            var teacherOption = function(teacher) {
                return {
                    label: teacher.name,
                    value: teacher
                };
            };
            var semesterOption = function(semester) {
                return {
                    label: semester.name,
                    value: semester
                };
            };
            return {
                state: $6be45a9e147fc393$export$5d30c05d844667b3(workQueueState)(doc.teacher)(doc.semester),
                ui: {
                    expandedStudents: workQueueUi.expandedStudents,
                    search: workQueueUi.search,
                    teacher: $7178b396566f5a79$export$5a4818cec1656a71(workQueueUi.teacher)($3fccd7b645ad9243$var$map(teacherOption)(doc.teacher)),
                    semester: $7178b396566f5a79$export$5a4818cec1656a71(workQueueUi.semester)(new $06733ae99ed4f534$export$8a67b48435b5d073(semesterOption(doc.semester)))
                }
            };
        };
    };
};
var $3fccd7b645ad9243$export$a740c6baf291518c = function(v) {
    return $d2284b2d3e1b6f87$export$8291c2122093ac93(function() {
        var json = $fce7eb63608cf274$export$c3f886ccd454773d(v.fillState.form);
        return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($6be45a9e147fc393$export$2646a34d1c0c0795(v.workQueueState)))(function(teacher) {
            return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($6be45a9e147fc393$export$19c82ab5012b22b3(v.workQueueState)))(function(semester) {
                return $3fccd7b645ad9243$var$runGraphQL_($d4a8d5b15f9925c4$export$40eade6eb956113a(v.fillState.doc)(json)({
                    teacher: teacher.id,
                    semester: semester.semester
                }));
            });
        });
    }());
};
var $3fccd7b645ad9243$export$5162bbc82053ac50 = function(waitState) {
    return function(loadedState) {
        var workQueueUi = {
            search: loadedState.workQueueUi.search,
            semester: loadedState.workQueueUi.semester,
            teacher: loadedState.workQueueUi.teacher,
            expandedStudents: waitState.workQueueUi.expandedStudents
        };
        return {
            queue: loadedState.queue,
            position: loadedState.position,
            anchor: loadedState.anchor,
            activeSection: loadedState.activeSection,
            sectionIntent: loadedState.sectionIntent,
            workQueueState: loadedState.workQueueState,
            workQueueCache: loadedState.workQueueCache,
            fillState: loadedState.fillState,
            transitionState: waitState.transitionState,
            workQueueUi: workQueueUi
        };
    };
};
var $3fccd7b645ad9243$var$initialQueuePosition = function(workQueueState) {
    return function(queue) {
        if (workQueueState.currentDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return 0;
        if (workQueueState.currentDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $06733ae99ed4f534$export$43db023a260c5e9f(0)($396c4c3d9e7fae3c$export$de3a4d4a0d731119($004747e47cb4edd5$export$71f9afd025e5af6b(workQueueState.currentDoc.value0))(queue));
        throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 122, column 45 - line 124, column 76): " + [
            workQueueState.currentDoc.constructor.name
        ]);
    };
};
var $3fccd7b645ad9243$var$initFormSigs = function(account) {
    return function(ft) {
        return function(doc) {
            var initSig = function(field) {
                return $9e1209acd51c3c43$export$968bc416486c1a61($9e1209acd51c3c43$export$3a989378240d784e.value)($9e1209acd51c3c43$export$92951287777f78c8(doc.id)(field))(field);
            };
            return $dac1e623683e2554$export$d6c482f7add97bee(account)("form-signatures")(doc.id)(function() {
                var $58 = $396c4c3d9e7fae3c$export$7b1b591b262c240(doc.signature_fields);
                if ($58) return $3fccd7b645ad9243$var$map1($9e1209acd51c3c43$export$711cbd329a1bfae7(doc.id))(ft.signatures);
                return $3fccd7b645ad9243$var$map1(initSig)(doc.signature_fields);
            }());
        };
    };
};
var $3fccd7b645ad9243$var$loadFormFillLayout = function(state) {
    return function(fbasic) {
        return function(doc) {
            return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("FormType " + ($308f9765feb7633d$export$a1b0f5347d2470b(fbasic.id) + " wasn't loaded")))($740d96ccf08cc464$export$7fa7b5aadee7e69a(state.workQueueCache)(fbasic.id))))(function(ftype) {
                var form = function() {
                    var v = $fce7eb63608cf274$export$6dbd705fbb1240f9(ftype);
                    return {
                        fields: v.fields,
                        id: v.id,
                        label: v.label,
                        access: doc.access
                    };
                }();
                return $3fccd7b645ad9243$var$pure({
                    form: form,
                    preview: $47387374ebaf9fda$export$345d9be8059b0f20(doc),
                    signatures: $dac1e623683e2554$export$2e64befa789ea6d2(doc)($3fccd7b645ad9243$var$initFormSigs(state.workQueueCache.account)(ftype)(doc)),
                    comments: $a225fa54d4056a34$export$dae1c0e759c7812c({
                        id: "form-comments",
                        formId: doc.id,
                        comments: doc.comments,
                        can: doc.can
                    }),
                    attachments: $67a3c28b4000eb60$export$5be9a61f48ea206f({
                        id: "form-attachments",
                        formId: doc.id,
                        attachments: doc.attachments
                    }),
                    doc: doc
                });
            });
        };
    };
};
var $3fccd7b645ad9243$var$hasUnsavedDocumentChanges = function(state) {
    var teacherUnsavedChanges = function(v) {
        return $3fccd7b645ad9243$var$notEq($3fccd7b645ad9243$var$map(function(v1) {
            return v1.id;
        })(v.workQueueState.teacher))($3fccd7b645ad9243$var$map(function(v1) {
            return v1.id;
        })(v.fillState.doc.teacher));
    };
    var semesterUnsavedChanges = function(v) {
        return $3fccd7b645ad9243$var$notEq1($3fccd7b645ad9243$var$map(function(v1) {
            return v1.semester;
        })(v.workQueueState.semester))(new $06733ae99ed4f534$export$8a67b48435b5d073(v.fillState.doc.semester.semester));
    };
    var teacherChanged = teacherUnsavedChanges(state);
    var semesterChanged = semesterUnsavedChanges(state);
    var nextJson = $fce7eb63608cf274$export$c3f886ccd454773d(state.fillState.form);
    var jsonChanged = $3fccd7b645ad9243$var$notEq2(nextJson)(state.fillState.doc.json);
    var changed = jsonChanged || teacherChanged || semesterChanged;
    return changed;
};
var $3fccd7b645ad9243$export$8403318fe7e37b3c = function(state) {
    return $004747e47cb4edd5$export$9a86059719a658b0(state.fillState) && $3fccd7b645ad9243$var$hasUnsavedDocumentChanges(state);
};
var $3fccd7b645ad9243$var$finaliseFillState = function(state) {
    return function(formCtx) {
        return function(doc) {
            return function(fillState) {
                var normaliseDocument = function(workQueueState) {
                    return function(sourceDoc) {
                        return function(form) {
                            var normalizedDoc = {
                                access: sourceDoc.access,
                                attachments: sourceDoc.attachments,
                                can: sourceDoc.can,
                                comments: sourceDoc.comments,
                                contact: sourceDoc.contact,
                                courses: sourceDoc.courses,
                                created_at: sourceDoc.created_at,
                                employer: sourceDoc.employer,
                                exports: sourceDoc.exports,
                                formId: sourceDoc.formId,
                                formName: sourceDoc.formName,
                                id: sourceDoc.id,
                                locked_at: sourceDoc.locked_at,
                                mutations: sourceDoc.mutations,
                                position: sourceDoc.position,
                                semester: sourceDoc.semester,
                                signature_fields: sourceDoc.signature_fields,
                                signatures: sourceDoc.signatures,
                                student: sourceDoc.student,
                                teacher: sourceDoc.teacher,
                                updated_at: sourceDoc.updated_at,
                                verifications: sourceDoc.verifications,
                                json: $fce7eb63608cf274$export$c3f886ccd454773d(form)
                            };
                            return new $71f2e2e9476163f8$export$1908877435b1d5e9($740d96ccf08cc464$export$2b433fd4c99efbc7(normalizedDoc)(workQueueState), normalizedDoc);
                        };
                    };
                };
                return $3fccd7b645ad9243$var$bind1($fce7eb63608cf274$export$acf666f77943fd8e(formCtx)(doc.json)(fillState.form))(function(form) {
                    var v = normaliseDocument(state.workQueueState)(doc)(form);
                    return $3fccd7b645ad9243$var$pure1({
                        queue: state.queue,
                        position: state.position,
                        anchor: state.anchor,
                        activeSection: state.activeSection,
                        sectionIntent: state.sectionIntent,
                        transitionState: state.transitionState,
                        workQueueState: v.value0,
                        workQueueUi: state.workQueueUi,
                        workQueueCache: state.workQueueCache,
                        fillState: {
                            attachments: fillState.attachments,
                            comments: fillState.comments,
                            preview: fillState.preview,
                            signatures: fillState.signatures,
                            form: form,
                            doc: v.value1
                        }
                    });
                });
            };
        };
    };
};
var $3fccd7b645ad9243$var$loadExistingFillState = function(state) {
    return function(v) {
        return function(workQueueState) {
            return function(maybeDoc) {
                var cachedDoc = $740d96ccf08cc464$export$11eb3b5ef9574821(workQueueState)(v.id);
                return $3fccd7b645ad9243$var$bind(function() {
                    if (maybeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $3fccd7b645ad9243$var$eq(maybeDoc.value0.id)(v.id)) return $3fccd7b645ad9243$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($740d96ccf08cc464$export$2b433fd4c99efbc7(maybeDoc.value0)(workQueueState), maybeDoc.value0));
                    if (cachedDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $3fccd7b645ad9243$var$pure(new $71f2e2e9476163f8$export$1908877435b1d5e9($740d96ccf08cc464$export$2b433fd4c99efbc7(cachedDoc.value0)(workQueueState), cachedDoc.value0));
                    if (cachedDoc instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $740d96ccf08cc464$export$f65ca476c09acec0(workQueueState)(v.form_type)(v.id);
                    throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 205, column 37 - line 208, column 58): " + [
                        maybeDoc.constructor.name,
                        cachedDoc.constructor.name
                    ]);
                }())(function(v1) {
                    var synced = $3fccd7b645ad9243$var$syncDocMetadata(v1.value1)(v1.value0)(state.workQueueUi);
                    var nextBase = function() {
                        var $79 = {};
                        for(var $80 in state)if (({}).hasOwnProperty.call(state, $80)) $79[$80] = state[$80];
                        $79.workQueueState = $6be45a9e147fc393$export$a871627eddff2fcf(synced.state)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                            formId: v.form_type.id,
                            studentId: v1.value1.student.id,
                            documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(v1.value1.id)
                        }));
                        $79.workQueueUi = synced.ui;
                        return $79;
                    }();
                    return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$loadFormFillLayout(nextBase)(v.form_type)(v1.value1))(function(fillState) {
                        var formCtx = $f388db8e60bd7b97$export$a5b3020661ae748a(state.workQueueCache.account)(v1.value1);
                        return $3fccd7b645ad9243$var$except($3fccd7b645ad9243$var$finaliseFillState(nextBase)(formCtx)(v1.value1)(fillState));
                    });
                });
            };
        };
    };
};
var $3fccd7b645ad9243$var$loadPreviousFillState = function(state) {
    return function(doc) {
        return function(formId) {
            return function(workQueueState) {
                return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Unknown formtype " + $308f9765feb7633d$export$a1b0f5347d2470b(formId)))($740d96ccf08cc464$export$830c804e8d921bba(workQueueState)(formId))))(function(ftype) {
                    var synced = $3fccd7b645ad9243$var$syncDocMetadata(doc)(workQueueState)(state.workQueueUi);
                    var nextBase = function() {
                        var $86 = {};
                        for(var $87 in state)if (({}).hasOwnProperty.call(state, $87)) $86[$87] = state[$87];
                        $86.workQueueState = synced.state;
                        $86.workQueueUi = synced.ui;
                        return $86;
                    }();
                    return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$loadFormFillLayout(nextBase)(ftype)(doc))(function(fillState) {
                        var formCtx = $f388db8e60bd7b97$export$a5b3020661ae748a(state.workQueueCache.account)(doc);
                        var currentBase = function() {
                            var $89 = {};
                            for(var $90 in nextBase)if (({}).hasOwnProperty.call(nextBase, $90)) $89[$90] = nextBase[$90];
                            $89.workQueueState = $6be45a9e147fc393$export$a871627eddff2fcf(nextBase.workQueueState)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                                formId: formId,
                                studentId: doc.student.id,
                                documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(doc.id)
                            }));
                            return $89;
                        }();
                        return $3fccd7b645ad9243$var$except($3fccd7b645ad9243$var$finaliseFillState(currentBase)(formCtx)(doc)(fillState));
                    });
                });
            };
        };
    };
};
var $3fccd7b645ad9243$var$createDocFormFillState = function(state) {
    return function(formId) {
        return function(student) {
            return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Unknown formtype " + $308f9765feb7633d$export$a1b0f5347d2470b(formId)))($740d96ccf08cc464$export$830c804e8d921bba(state.workQueueState)(formId))))(function(ftype) {
                return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($6be45a9e147fc393$export$19c82ab5012b22b3(state.workQueueState)))(function(semester) {
                    return $3fccd7b645ad9243$var$bind(function() {
                        var $92 = $3fccd7b645ad9243$var$notEq3(state.workQueueCache.account.type)($02eacf321b2a2128$export$ebce5c1c966101a4.value);
                        if ($92) return $3fccd7b645ad9243$var$map2($06733ae99ed4f534$export$8a67b48435b5d073.create)($3fccd7b645ad9243$var$except($6be45a9e147fc393$export$2646a34d1c0c0795(state.workQueueState)));
                        return $3fccd7b645ad9243$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                    }())(function(teacher) {
                        return $3fccd7b645ad9243$var$bind($740d96ccf08cc464$export$e0c61fcff97552d3(state.workQueueState)(ftype)({
                            student_id: student,
                            semester: semester.semester,
                            teacher_id: $3fccd7b645ad9243$var$map(function(v) {
                                return v.id;
                            })(teacher)
                        }))(function(v) {
                            var nextBase = function() {
                                var $94 = {};
                                for(var $95 in state)if (({}).hasOwnProperty.call(state, $95)) $94[$95] = state[$95];
                                $94.workQueueState = $6be45a9e147fc393$export$a871627eddff2fcf(v.value0)(new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    formId: formId,
                                    studentId: v.value1.student.id,
                                    documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value1.id)
                                }));
                                return $94;
                            }();
                            return $3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$loadFormFillLayout(nextBase)(ftype)(v.value1))(function(fillState) {
                                var formCtx = function() {
                                    var v1 = $f388db8e60bd7b97$export$a5b3020661ae748a(state.workQueueCache.account)(v.value1);
                                    return {
                                        access: v1.access,
                                        account: v1.account,
                                        autofillArgs: v1.autofillArgs,
                                        curIndex: v1.curIndex,
                                        doc: v1.doc,
                                        parentIds: v1.parentIds,
                                        isAutofilling: true
                                    };
                                }();
                                return $3fccd7b645ad9243$var$except($3fccd7b645ad9243$var$finaliseFillState(nextBase)(formCtx)(v.value1)(fillState));
                            });
                        });
                    });
                });
            });
        };
    };
};
var $3fccd7b645ad9243$export$9ab859b086c3e384 = function(state) {
    return function(doc) {
        return $d2284b2d3e1b6f87$export$8291c2122093ac93($3fccd7b645ad9243$var$bind($3fccd7b645ad9243$var$except($7d4cccdf062a2261$export$a92e4c44d367d0af(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Position in fill queue out of bounds. Index: " + ($3fccd7b645ad9243$var$show(state.position) + (" Queue: " + $6be45a9e147fc393$export$92d7afd85cc34da2(state.queue)))))($004747e47cb4edd5$export$3a45131c6a577a09(state))))(function(entry) {
            if (entry.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $3fccd7b645ad9243$var$loadExistingFillState(state)(entry.form.value0)(state.workQueueState)(doc);
            if (entry.form instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                var docRef = {
                    formId: entry.form.value0,
                    studentId: entry.student,
                    documentId: $06733ae99ed4f534$export$bebe9059409a0d04.value
                };
                var v = $740d96ccf08cc464$export$30606e16463b30d9(state.workQueueState)(docRef);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $3fccd7b645ad9243$var$loadPreviousFillState(state)(v.value0)(entry.form.value0)(state.workQueueState);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $3fccd7b645ad9243$var$createDocFormFillState(state)(entry.form.value0)(entry.student);
                throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 117, column 13 - line 119, column 77): " + [
                    v.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at Steps.Step3.FillQueue (line 109, column 5 - line 119, column 77): " + [
                entry.form.constructor.name
            ]);
        }));
    };
};
var $3fccd7b645ad9243$export$baeaf1c6d298f571 = function(workQueueState) {
    return function(workQueueUi) {
        return function(workQueueCache) {
            return function(doc) {
                return function(transitionState) {
                    return function(anchor) {
                        return $d2284b2d3e1b6f87$export$8291c2122093ac93(function() {
                            var queue = $6be45a9e147fc393$export$27beb92d36f92bea(workQueueState);
                            var position = $3fccd7b645ad9243$var$initialQueuePosition(workQueueState)(queue);
                            return $3fccd7b645ad9243$export$9ab859b086c3e384({
                                queue: queue,
                                transitionState: transitionState,
                                workQueueState: workQueueState,
                                workQueueUi: workQueueUi,
                                workQueueCache: workQueueCache,
                                position: position,
                                anchor: anchor,
                                activeSection: anchor,
                                sectionIntent: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($daa993e9fe4182d9$export$37a45811bf45ea95.value)($daa993e9fe4182d9$export$28a5869e6b717ab.create)(anchor)
                            })(doc);
                        }());
                    };
                };
            };
        };
    };
};
var $3fccd7b645ad9243$export$d64c63c4a0e5e8fa = function(state) {
    return function(doc) {
        var workQueueState$prime = $740d96ccf08cc464$export$2b433fd4c99efbc7(doc)(state.workQueueState);
        var formCtx = $f388db8e60bd7b97$export$a5b3020661ae748a(state.workQueueCache.account)(doc);
        var fillState = {
            attachments: state.fillState.attachments,
            comments: state.fillState.comments,
            doc: state.fillState.doc,
            preview: state.fillState.preview,
            signatures: state.fillState.signatures,
            form: {
                fields: state.fillState.form.fields,
                id: state.fillState.form.id,
                label: state.fillState.form.label,
                access: doc.access
            }
        };
        return $3fccd7b645ad9243$var$bind1($3fccd7b645ad9243$var$finaliseFillState({
            queue: state.queue,
            position: state.position,
            anchor: state.anchor,
            activeSection: state.activeSection,
            sectionIntent: state.sectionIntent,
            transitionState: state.transitionState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            fillState: state.fillState,
            workQueueState: workQueueState$prime
        })(formCtx)(doc)(fillState))(function(nextState) {
            return $3fccd7b645ad9243$var$pure1({
                activeSection: nextState.activeSection,
                anchor: nextState.anchor,
                position: nextState.position,
                queue: nextState.queue,
                sectionIntent: nextState.sectionIntent,
                transitionState: nextState.transitionState,
                workQueueCache: nextState.workQueueCache,
                workQueueState: nextState.workQueueState,
                workQueueUi: nextState.workQueueUi,
                fillState: {
                    attachments: nextState.fillState.attachments,
                    comments: nextState.fillState.comments,
                    doc: nextState.fillState.doc,
                    form: nextState.fillState.form,
                    preview: nextState.fillState.preview,
                    signatures: $dac1e623683e2554$export$2e64befa789ea6d2(nextState.fillState.doc)(state.fillState.signatures)
                }
            });
        });
    };
};








var $842627c31b5244a8$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $842627c31b5244a8$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $842627c31b5244a8$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $842627c31b5244a8$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($842627c31b5244a8$var$eqRNTY);
var $842627c31b5244a8$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $842627c31b5244a8$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $842627c31b5244a8$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $842627c31b5244a8$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $842627c31b5244a8$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($842627c31b5244a8$var$eqRNTY);
var $842627c31b5244a8$export$421025fa7512c563 = /* #__PURE__ */ function() {
    function SaveThenCancel() {}
    SaveThenCancel.value = new SaveThenCancel();
    return SaveThenCancel;
}();
var $842627c31b5244a8$export$49f65ba1d6c140c = /* #__PURE__ */ function() {
    function SaveThenFinish() {}
    SaveThenFinish.value = new SaveThenFinish();
    return SaveThenFinish;
}();
var $842627c31b5244a8$export$5f03e7db4c52ef18 = /* #__PURE__ */ function() {
    function SaveThenExport(value0) {
        this.value0 = value0;
    }
    SaveThenExport.create = function(value0) {
        return new SaveThenExport(value0);
    };
    return SaveThenExport;
}();
var $842627c31b5244a8$export$f40f49b6fe1fe9c9 = /* #__PURE__ */ function() {
    function SaveThenLock() {}
    SaveThenLock.value = new SaveThenLock();
    return SaveThenLock;
}();
var $842627c31b5244a8$var$upsertBy = function(dictEq) {
    var eq1 = $37b880af5f4991bd$export$9663ddc1cf085b32(dictEq);
    return function(key) {
        return function(updates) {
            return function(existing) {
                return $842627c31b5244a8$var$append(updates)($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(current) {
                    return !$396c4c3d9e7fae3c$export$4154a199d7d90455(function($$new) {
                        return eq1(key($$new))(key(current));
                    })(updates);
                })(existing));
            };
        };
    };
};
var $842627c31b5244a8$var$upsertBy1 = /* #__PURE__ */ $842627c31b5244a8$var$upsertBy($842627c31b5244a8$var$eqRNTY);
var $842627c31b5244a8$var$updateSignatures = function(updateGroup) {
    return function(updateDoc) {
        return function(fillState) {
            return {
                form: fillState.form,
                comments: fillState.comments,
                attachments: fillState.attachments,
                preview: fillState.preview,
                signatures: updateGroup(fillState.signatures),
                doc: updateDoc(fillState.doc)
            };
        };
    };
};
var $842627c31b5244a8$var$updateComments = function(updateList) {
    return function(nextPost) {
        return function(fillState) {
            var comments = updateList(fillState.comments.comments);
            return {
                form: fillState.form,
                attachments: fillState.attachments,
                preview: fillState.preview,
                signatures: fillState.signatures,
                comments: {
                    id: fillState.comments.id,
                    formId: fillState.comments.formId,
                    can: fillState.comments.can,
                    comments: comments,
                    post: nextPost(fillState.comments)
                },
                doc: {
                    id: fillState.doc.id,
                    student: fillState.doc.student,
                    semester: fillState.doc.semester,
                    teacher: fillState.doc.teacher,
                    signatures: fillState.doc.signatures,
                    verifications: fillState.doc.verifications,
                    updated_at: fillState.doc.updated_at,
                    created_at: fillState.doc.created_at,
                    locked_at: fillState.doc.locked_at,
                    exports: fillState.doc.exports,
                    access: fillState.doc.access,
                    employer: fillState.doc.employer,
                    position: fillState.doc.position,
                    contact: fillState.doc.contact,
                    courses: fillState.doc.courses,
                    attachments: fillState.doc.attachments,
                    can: fillState.doc.can,
                    formId: fillState.doc.formId,
                    formName: fillState.doc.formName,
                    mutations: fillState.doc.mutations,
                    signature_fields: fillState.doc.signature_fields,
                    json: fillState.doc.json,
                    comments: comments
                }
            };
        };
    };
};
var $842627c31b5244a8$var$updateAttachments = function(updateList) {
    return function(fillState) {
        var attachments = updateList(fillState.attachments.attachments);
        return {
            form: fillState.form,
            comments: fillState.comments,
            preview: fillState.preview,
            signatures: fillState.signatures,
            attachments: {
                id: fillState.attachments.id,
                formId: fillState.attachments.formId,
                description: fillState.attachments.description,
                attachments: attachments
            },
            doc: {
                id: fillState.doc.id,
                student: fillState.doc.student,
                semester: fillState.doc.semester,
                teacher: fillState.doc.teacher,
                signatures: fillState.doc.signatures,
                verifications: fillState.doc.verifications,
                updated_at: fillState.doc.updated_at,
                created_at: fillState.doc.created_at,
                locked_at: fillState.doc.locked_at,
                exports: fillState.doc.exports,
                access: fillState.doc.access,
                employer: fillState.doc.employer,
                position: fillState.doc.position,
                contact: fillState.doc.contact,
                courses: fillState.doc.courses,
                can: fillState.doc.can,
                formId: fillState.doc.formId,
                formName: fillState.doc.formName,
                mutations: fillState.doc.mutations,
                comments: fillState.doc.comments,
                signature_fields: fillState.doc.signature_fields,
                json: fillState.doc.json,
                attachments: attachments
            }
        };
    };
};
var $842627c31b5244a8$export$7e2e85b632e93ac2 = function($67) {
    return $3fccd7b645ad9243$export$8403318fe7e37b3c(function(v) {
        return v.editor;
    }($67));
};
var $842627c31b5244a8$export$11c6c29bd74a41f5 = function(target) {
    return function(state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: {
                queue: state.editor.queue,
                transitionState: state.editor.transitionState,
                workQueueState: state.editor.workQueueState,
                workQueueUi: state.editor.workQueueUi,
                workQueueCache: state.editor.workQueueCache,
                fillState: state.editor.fillState,
                position: target.position,
                anchor: target.anchor,
                activeSection: target.anchor,
                sectionIntent: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($daa993e9fe4182d9$export$37a45811bf45ea95.value)($daa993e9fe4182d9$export$28a5869e6b717ab.create)(target.anchor)
            }
        };
    };
};
var $842627c31b5244a8$export$b0652239d9d9ff07 = function(editor) {
    return function(state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: editor
        };
    };
};
var $842627c31b5244a8$export$fa495481368f6a1a = function($68) {
    return $3fccd7b645ad9243$export$a740c6baf291518c(function(v) {
        return v.editor;
    }($68));
};
var $842627c31b5244a8$var$replaceComment = function(comment) {
    return $842627c31b5244a8$var$map(function(current) {
        var $55 = $842627c31b5244a8$var$eq(current.id)(comment.id);
        if ($55) return comment;
        return current;
    });
};
var $842627c31b5244a8$export$a5bc1fd82f921349 = function(workQueueState) {
    return function(workQueueCache) {
        return function(maybeFormType) {
            return function(maybeDoc) {
                return $d2284b2d3e1b6f87$export$8291c2122093ac93($740d96ccf08cc464$export$a5bc1fd82f921349(workQueueState)(workQueueCache)(maybeFormType)(maybeDoc));
            };
        };
    };
};
var $842627c31b5244a8$export$efb563a7c7e3f705 = function(fn) {
    return function(state) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: fn(state.editor)
        };
    };
};
var $842627c31b5244a8$export$1643e1ff55422bba = function($69) {
    return $004747e47cb4edd5$export$1643e1ff55422bba(function(v) {
        return v.editor;
    }($69));
};
var $842627c31b5244a8$export$fba9605fc9710e5b = function(state) {
    return $06733ae99ed4f534$export$c15bd07a493e1236(state.saveOperationId) || $06733ae99ed4f534$export$c15bd07a493e1236(state.loadOperationId) || $06733ae99ed4f534$export$c15bd07a493e1236(state.autofillOperationId) || $06733ae99ed4f534$export$c15bd07a493e1236(state.lockOperationId) || $06733ae99ed4f534$export$c15bd07a493e1236(state.documentMutationOperationId);
};
var $842627c31b5244a8$export$43055f49ea9b191 = $004747e47cb4edd5$export$43055f49ea9b191;
var $842627c31b5244a8$export$9a86059719a658b0 = function($70) {
    return $004747e47cb4edd5$export$9a86059719a658b0(function(v) {
        return v.editor.fillState;
    }($70));
};
var $842627c31b5244a8$export$63a9f2c0693b353b = function(editor) {
    return {
        editor: editor,
        saveOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        loadOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        autofillOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        lockOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        documentMutationOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value,
        pendingPostSave: $06733ae99ed4f534$export$bebe9059409a0d04.value
    };
};
var $842627c31b5244a8$export$9976875180373c4d = function(workQueueState) {
    return function(workQueueUi) {
        return function(workQueueCache) {
            return function(doc) {
                return function(initialAnchor) {
                    return $842627c31b5244a8$var$map1($842627c31b5244a8$var$map2($842627c31b5244a8$export$63a9f2c0693b353b))($3fccd7b645ad9243$export$baeaf1c6d298f571(workQueueState)(workQueueUi)(workQueueCache)(doc)($59a05a7e29977bc8$export$21bdadac9c425db2)(initialAnchor));
                };
            };
        };
    };
};
var $842627c31b5244a8$export$2d9bd4578fa0224c = $004747e47cb4edd5$export$2d9bd4578fa0224c;
var $842627c31b5244a8$var$applySignatureRefresh = function(refresh) {
    return function(fillState) {
        return {
            comments: fillState.comments,
            attachments: fillState.attachments,
            preview: fillState.preview,
            signatures: $dac1e623683e2554$export$2e64befa789ea6d2(refresh)($dac1e623683e2554$export$900b744f10716a0e(refresh.signature_fields)(fillState.signatures)),
            form: {
                id: fillState.form.id,
                label: fillState.form.label,
                fields: fillState.form.fields,
                access: refresh.access
            },
            doc: {
                id: fillState.doc.id,
                student: fillState.doc.student,
                semester: fillState.doc.semester,
                teacher: fillState.doc.teacher,
                updated_at: fillState.doc.updated_at,
                created_at: fillState.doc.created_at,
                exports: fillState.doc.exports,
                employer: fillState.doc.employer,
                position: fillState.doc.position,
                contact: fillState.doc.contact,
                courses: fillState.doc.courses,
                attachments: fillState.doc.attachments,
                formId: fillState.doc.formId,
                formName: fillState.doc.formName,
                mutations: fillState.doc.mutations,
                comments: fillState.doc.comments,
                json: fillState.doc.json,
                signatures: refresh.signatures,
                verifications: refresh.verifications,
                signature_fields: refresh.signature_fields,
                locked_at: refresh.locked_at,
                access: refresh.access,
                can: {
                    comment: fillState.doc.can.comment,
                    private_comment: fillState.doc.can.private_comment,
                    attach: fillState.doc.can.attach,
                    "delete": fillState["doc"]["can"]["delete"],
                    copy: fillState.doc.can.copy,
                    create_employers: fillState.doc.can.create_employers,
                    lock: refresh.can.lock,
                    update: refresh.can.update
                }
            }
        };
    };
};
var $842627c31b5244a8$export$c77057dcb3417a70 = function(state) {
    return function(doc) {
        return $842627c31b5244a8$var$map2(function(editor) {
            return {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                editor: editor,
                saveOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
        })($3fccd7b645ad9243$export$d64c63c4a0e5e8fa(state.editor)(doc));
    };
};
var $842627c31b5244a8$export$3e04bda16fa5665d = function(waitState) {
    return function(loadedState) {
        return {
            saveOperationId: waitState.saveOperationId,
            autofillOperationId: waitState.autofillOperationId,
            lockOperationId: waitState.lockOperationId,
            documentMutationOperationId: waitState.documentMutationOperationId,
            pendingPostSave: waitState.pendingPostSave,
            editor: $3fccd7b645ad9243$export$5162bbc82053ac50(waitState.editor)(loadedState),
            loadOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value
        };
    };
};
var $842627c31b5244a8$export$e14e012eacfcf5b1 = function(current) {
    return function(doc) {
        return $842627c31b5244a8$var$map1($842627c31b5244a8$var$map2($842627c31b5244a8$export$3e04bda16fa5665d(current)))($3fccd7b645ad9243$export$9ab859b086c3e384(current.editor)(doc));
    };
};
var $842627c31b5244a8$var$applyFillStateUpdate = function(fn) {
    return function(state) {
        var fillState = fn(state.editor.fillState);
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: {
                queue: state.editor.queue,
                position: state.editor.position,
                anchor: state.editor.anchor,
                activeSection: state.editor.activeSection,
                sectionIntent: state.editor.sectionIntent,
                transitionState: state.editor.transitionState,
                workQueueUi: state.editor.workQueueUi,
                workQueueCache: state.editor.workQueueCache,
                fillState: fillState,
                workQueueState: $740d96ccf08cc464$export$2b433fd4c99efbc7(fillState.doc)(state.editor.workQueueState)
            }
        };
    };
};
var $842627c31b5244a8$export$ed79dd21d6a2e442 = function(state) {
    return function(result) {
        return $842627c31b5244a8$var$applyFillStateUpdate($842627c31b5244a8$var$applySignatureRefresh(result))({
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: $004747e47cb4edd5$export$600ab3f29580dc1d(result)(state.editor),
            lockOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value
        });
    };
};
var $842627c31b5244a8$export$b062c3817f132aa6 = function(state) {
    return function(res) {
        var formCtx = function() {
            var v = $004747e47cb4edd5$export$5176e9d4c30fcf2b(state.editor.workQueueCache)(state.editor.fillState);
            return {
                access: v.access,
                account: v.account,
                autofillArgs: v.autofillArgs,
                curIndex: v.curIndex,
                doc: v.doc,
                parentIds: v.parentIds,
                isAutofilling: true
            };
        }();
        var newDoc = {
            access: state.editor.fillState.doc.access,
            attachments: state.editor.fillState.doc.attachments,
            can: state.editor.fillState.doc.can,
            comments: state.editor.fillState.doc.comments,
            contact: state.editor.fillState.doc.contact,
            courses: state.editor.fillState.doc.courses,
            created_at: state.editor.fillState.doc.created_at,
            exports: state.editor.fillState.doc.exports,
            formId: state.editor.fillState.doc.formId,
            formName: state.editor.fillState.doc.formName,
            id: state.editor.fillState.doc.id,
            json: state.editor.fillState.doc.json,
            locked_at: state.editor.fillState.doc.locked_at,
            mutations: state.editor.fillState.doc.mutations,
            position: state.editor.fillState.doc.position,
            semester: state.editor.fillState.doc.semester,
            signature_fields: state.editor.fillState.doc.signature_fields,
            signatures: state.editor.fillState.doc.signatures,
            student: state.editor.fillState.doc.student,
            teacher: state.editor.fillState.doc.teacher,
            updated_at: state.editor.fillState.doc.updated_at,
            verifications: state.editor.fillState.doc.verifications,
            employer: res.employer
        };
        return $842627c31b5244a8$var$bind($fce7eb63608cf274$export$acf666f77943fd8e(formCtx)(res.data)(state.editor.fillState.form))(function(newFormState) {
            return $842627c31b5244a8$var$pure({
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    fillState: {
                        attachments: state.editor.fillState.attachments,
                        comments: state.editor.fillState.comments,
                        preview: state.editor.fillState.preview,
                        form: newFormState,
                        doc: newDoc,
                        signatures: $dac1e623683e2554$export$cf5a28a3dd28a437(state.editor.fillState.signatures)(res.signature_fields)
                    }
                },
                autofillOperationId: $06733ae99ed4f534$export$bebe9059409a0d04.value
            });
        });
    };
};
var $842627c31b5244a8$var$appendComment = function(comment) {
    return function(comments) {
        return $842627c31b5244a8$var$append(comments)([
            comment
        ]);
    };
};
var $842627c31b5244a8$var$applyResult = /* #__PURE__ */ function() {
    var keepCommentState = function(state) {
        return state.post;
    };
    return function(v) {
        if (v instanceof $004747e47cb4edd5$export$65ca4a46ee1b7c38) return $842627c31b5244a8$var$updateComments($842627c31b5244a8$var$appendComment(v.value0))(function(v1) {
            return new $a225fa54d4056a34$export$de8544b0b847b68d({
                text: "",
                "public": v["value0"]["public"]
            });
        });
        if (v instanceof $004747e47cb4edd5$export$d59dddaa17dd7b8a) return $842627c31b5244a8$var$updateComments($842627c31b5244a8$var$replaceComment(v.value0))(function(v1) {
            return new $a225fa54d4056a34$export$de8544b0b847b68d({
                text: "",
                "public": v["value0"]["public"]
            });
        });
        if (v instanceof $004747e47cb4edd5$export$17adc4f7fe1cd3b8) return $842627c31b5244a8$var$updateComments($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(comment) {
            return $842627c31b5244a8$var$notEq(comment.id)(v.value0);
        }))(keepCommentState);
        if (v instanceof $004747e47cb4edd5$export$f00646e890d6b596) return $842627c31b5244a8$var$updateAttachments(function(v1) {
            return $842627c31b5244a8$var$append(v1)([
                v.value0
            ]);
        });
        if (v instanceof $004747e47cb4edd5$export$8ba32d49227f419c) return $842627c31b5244a8$var$updateAttachments($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(attachment) {
            return attachment.id !== v.value0;
        }));
        if (v instanceof $004747e47cb4edd5$export$8004e50c9b7bd668) return $842627c31b5244a8$var$updateSignatures($dac1e623683e2554$export$2e64befa789ea6d2({
            signatures: [
                v.value0
            ],
            verifications: [],
            signature_fields: []
        }))(function(doc) {
            return {
                id: doc.id,
                student: doc.student,
                semester: doc.semester,
                teacher: doc.teacher,
                verifications: doc.verifications,
                updated_at: doc.updated_at,
                created_at: doc.created_at,
                locked_at: doc.locked_at,
                exports: doc.exports,
                access: doc.access,
                employer: doc.employer,
                position: doc.position,
                contact: doc.contact,
                courses: doc.courses,
                attachments: doc.attachments,
                can: doc.can,
                formId: doc.formId,
                formName: doc.formName,
                mutations: doc.mutations,
                comments: doc.comments,
                signature_fields: doc.signature_fields,
                json: doc.json,
                signatures: $842627c31b5244a8$var$upsertBy1(function(v2) {
                    return v2.key;
                })([
                    v.value0
                ])(doc.signatures)
            };
        });
        if (v instanceof $004747e47cb4edd5$export$dbed4d58d2dad4e1) {
            var $71 = $842627c31b5244a8$var$updateSignatures($dac1e623683e2554$export$2e64befa789ea6d2({
                signatures: [
                    v.value0
                ],
                verifications: [],
                signature_fields: []
            }))(function(doc) {
                return {
                    id: doc.id,
                    student: doc.student,
                    semester: doc.semester,
                    teacher: doc.teacher,
                    verifications: doc.verifications,
                    updated_at: doc.updated_at,
                    created_at: doc.created_at,
                    locked_at: doc.locked_at,
                    exports: doc.exports,
                    access: doc.access,
                    employer: doc.employer,
                    position: doc.position,
                    contact: doc.contact,
                    courses: doc.courses,
                    attachments: doc.attachments,
                    can: doc.can,
                    formId: doc.formId,
                    formName: doc.formName,
                    mutations: doc.mutations,
                    comments: doc.comments,
                    signature_fields: doc.signature_fields,
                    json: doc.json,
                    signatures: $842627c31b5244a8$var$upsertBy1(function(v2) {
                        return v2.key;
                    })([
                        v.value0
                    ])(doc.signatures)
                };
            });
            var $72 = $842627c31b5244a8$var$applySignatureRefresh(v.value1);
            return function($73) {
                return $71($72($73));
            };
        }
        if (v instanceof $004747e47cb4edd5$export$18586e5d3073eff6) return $842627c31b5244a8$var$applySignatureRefresh(v.value0);
        if (v instanceof $004747e47cb4edd5$export$edafdbf2e37712a7) return $842627c31b5244a8$var$updateSignatures($dac1e623683e2554$export$35a6e7afb25974d3(v.value0))(function(doc) {
            return {
                id: doc.id,
                student: doc.student,
                semester: doc.semester,
                teacher: doc.teacher,
                signatures: doc.signatures,
                updated_at: doc.updated_at,
                created_at: doc.created_at,
                locked_at: doc.locked_at,
                exports: doc.exports,
                access: doc.access,
                employer: doc.employer,
                position: doc.position,
                contact: doc.contact,
                courses: doc.courses,
                attachments: doc.attachments,
                can: doc.can,
                formId: doc.formId,
                formName: doc.formName,
                mutations: doc.mutations,
                comments: doc.comments,
                signature_fields: doc.signature_fields,
                json: doc.json,
                verifications: $842627c31b5244a8$var$upsertBy1(function(v2) {
                    return v2.data.key;
                })(v.value0)(doc.verifications)
            };
        });
        throw new Error("Failed pattern match at Steps.Step3.State (line 193, column 15 - line 226, column 100): " + [
            v.constructor.name
        ]);
    };
}();
var $842627c31b5244a8$export$9dbba87a2d996646 = function(state) {
    return function(result) {
        return $842627c31b5244a8$var$pure($842627c31b5244a8$var$applyFillStateUpdate($842627c31b5244a8$var$applyResult(result))(state));
    };
};



// Generated by purs version 0.15.16




















var $7b9d021f8fc5e8ea$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $7b9d021f8fc5e8ea$var$eqMaybe = /* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($a8c8b5353c92bbbb$export$ddffdcd895d11148);
var $7b9d021f8fc5e8ea$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($7b9d021f8fc5e8ea$var$eqMaybe);
var $7b9d021f8fc5e8ea$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $7b9d021f8fc5e8ea$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $7b9d021f8fc5e8ea$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($7b9d021f8fc5e8ea$var$eqMaybe);
var $7b9d021f8fc5e8ea$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $7b9d021f8fc5e8ea$var$oneOf = /* #__PURE__ */ $4fe7b6acfba7f29f$export$a9a18ae5ba42aeab($4fe7b6acfba7f29f$export$e97014618a7eb593)($06733ae99ed4f534$export$164e6bcbae9cfdd0);
var $7b9d021f8fc5e8ea$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d = /* #__PURE__ */ function() {
    function ViewEvent(value0) {
        this.value0 = value0;
    }
    ViewEvent.create = function(value0) {
        return new ViewEvent(value0);
    };
    return ViewEvent;
}();
var $7b9d021f8fc5e8ea$export$66aa8e949afa1192 = /* #__PURE__ */ function() {
    function ConfirmCancelResult(value0) {
        this.value0 = value0;
    }
    ConfirmCancelResult.create = function(value0) {
        return new ConfirmCancelResult(value0);
    };
    return ConfirmCancelResult;
}();
var $7b9d021f8fc5e8ea$export$b2e6f2c49f73a48f = /* #__PURE__ */ function() {
    function SaveCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    SaveCompleted.create = function(value0) {
        return function(value1) {
            return new SaveCompleted(value0, value1);
        };
    };
    return SaveCompleted;
}();
var $7b9d021f8fc5e8ea$export$b72a7f0a527922d2 = /* #__PURE__ */ function() {
    function LoadCompleted(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    LoadCompleted.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new LoadCompleted(value0, value1, value2);
            };
        };
    };
    return LoadCompleted;
}();
var $7b9d021f8fc5e8ea$export$2e257da2bb680de4 = /* #__PURE__ */ function() {
    function AutofillCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    AutofillCompleted.create = function(value0) {
        return function(value1) {
            return new AutofillCompleted(value0, value1);
        };
    };
    return AutofillCompleted;
}();
var $7b9d021f8fc5e8ea$export$822bcf0db9f14593 = /* #__PURE__ */ function() {
    function LockCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    LockCompleted.create = function(value0) {
        return function(value1) {
            return new LockCompleted(value0, value1);
        };
    };
    return LockCompleted;
}();
var $7b9d021f8fc5e8ea$export$9af9d7135f6f5e08 = /* #__PURE__ */ function() {
    function DocumentMutationCompleted(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    DocumentMutationCompleted.create = function(value0) {
        return function(value1) {
            return new DocumentMutationCompleted(value0, value1);
        };
    };
    return DocumentMutationCompleted;
}();
var $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7 = /* #__PURE__ */ function() {
    function SyncRoute(value0) {
        this.value0 = value0;
    }
    SyncRoute.create = function(value0) {
        return new SyncRoute(value0);
    };
    return SyncRoute;
}();
var $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214 = /* #__PURE__ */ function() {
    function StartSave(value0) {
        this.value0 = value0;
    }
    StartSave.create = function(value0) {
        return new StartSave(value0);
    };
    return StartSave;
}();
var $7b9d021f8fc5e8ea$export$432d51bdca810dfc = /* #__PURE__ */ function() {
    function StartLoad(value0) {
        this.value0 = value0;
    }
    StartLoad.create = function(value0) {
        return new StartLoad(value0);
    };
    return StartLoad;
}();
var $7b9d021f8fc5e8ea$export$93fbe371f495cba9 = /* #__PURE__ */ function() {
    function StartAutofill(value0) {
        this.value0 = value0;
    }
    StartAutofill.create = function(value0) {
        return new StartAutofill(value0);
    };
    return StartAutofill;
}();
var $7b9d021f8fc5e8ea$export$cca72c408b5f0a32 = /* #__PURE__ */ function() {
    function StartToggleLock() {}
    StartToggleLock.value = new StartToggleLock();
    return StartToggleLock;
}();
var $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4 = /* #__PURE__ */ function() {
    function StartDocumentMutation(value0) {
        this.value0 = value0;
    }
    StartDocumentMutation.create = function(value0) {
        return new StartDocumentMutation(value0);
    };
    return StartDocumentMutation;
}();
var $7b9d021f8fc5e8ea$export$feff782b5e0b62d7 = /* #__PURE__ */ function() {
    function ConfirmCancel() {}
    ConfirmCancel.value = new ConfirmCancel();
    return ConfirmCancel;
}();
var $7b9d021f8fc5e8ea$export$88c8c40786b3927b = /* #__PURE__ */ function() {
    function AllowPageUnload() {}
    AllowPageUnload.value = new AllowPageUnload();
    return AllowPageUnload;
}();
var $7b9d021f8fc5e8ea$export$4bb7762331f161c2 = /* #__PURE__ */ function() {
    function BlockPageUnload() {}
    BlockPageUnload.value = new BlockPageUnload();
    return BlockPageUnload;
}();
var $7b9d021f8fc5e8ea$export$96c159224a0db784 = /* #__PURE__ */ function() {
    function OpenExportUrl(value0) {
        this.value0 = value0;
    }
    OpenExportUrl.create = function(value0) {
        return new OpenExportUrl(value0);
    };
    return OpenExportUrl;
}();
var $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40 = /* #__PURE__ */ function() {
    function Navigate(value0) {
        this.value0 = value0;
    }
    Navigate.create = function(value0) {
        return new Navigate(value0);
    };
    return Navigate;
}();
var $7b9d021f8fc5e8ea$export$479877330b97c10b = /* #__PURE__ */ function() {
    function MarkSuperseded(value0) {
        this.value0 = value0;
    }
    MarkSuperseded.create = function(value0) {
        return new MarkSuperseded(value0);
    };
    return MarkSuperseded;
}();
var $7b9d021f8fc5e8ea$var$lookupTransitionTarget = function(lookup) {
    return function(section) {
        return function(state) {
            return $7b9d021f8fc5e8ea$var$map(function(idx) {
                return {
                    idx: idx,
                    section: section
                };
            })($396c4c3d9e7fae3c$export$de3a4d4a0d731119($004747e47cb4edd5$export$71f9afd025e5af6b(lookup))(state.editor.queue));
        };
    };
};
var $7b9d021f8fc5e8ea$var$clearIfMatches = function(opId) {
    return function(current) {
        var $62 = $7b9d021f8fc5e8ea$var$eq(current)(new $06733ae99ed4f534$export$8a67b48435b5d073(opId));
        if ($62) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        return current;
    };
};
var $7b9d021f8fc5e8ea$var$clearLoadOperation = function(opId) {
    return function(state) {
        return {
            editor: state.editor,
            saveOperationId: state.saveOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            loadOperationId: $7b9d021f8fc5e8ea$var$clearIfMatches(opId)(state.loadOperationId)
        };
    };
};
var $7b9d021f8fc5e8ea$var$captureTransitionDuringBusy = function(state) {
    return function(event) {
        return {
            saveOperationId: state.saveOperationId,
            loadOperationId: state.loadOperationId,
            autofillOperationId: state.autofillOperationId,
            lockOperationId: state.lockOperationId,
            documentMutationOperationId: state.documentMutationOperationId,
            pendingPostSave: state.pendingPostSave,
            editor: $004747e47cb4edd5$export$93e2410c29660ed1(state.editor)(event)
        };
    };
};
var $7b9d021f8fc5e8ea$var$continuePendingTransition = function(state) {
    return function(target) {
        return function(prefixCommands) {
            if (target.position === state.editor.position) {
                var nextEditor = {
                    fillState: state.editor.fillState,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    anchor: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                    activeSection: target.anchor,
                    sectionIntent: $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($daa993e9fe4182d9$export$37a45811bf45ea95.value)($daa993e9fe4182d9$export$28a5869e6b717ab.create)(target.anchor)
                };
                var v = $59a05a7e29977bc8$export$2ad361b4f37e39e9(nextEditor.transitionState)(target.generation);
                var settledState = {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    pendingPostSave: state.pendingPostSave,
                    saveOperationId: state.saveOperationId,
                    editor: {
                        activeSection: nextEditor.activeSection,
                        anchor: nextEditor.anchor,
                        fillState: nextEditor.fillState,
                        position: nextEditor.position,
                        queue: nextEditor.queue,
                        sectionIntent: nextEditor.sectionIntent,
                        workQueueCache: nextEditor.workQueueCache,
                        workQueueState: nextEditor.workQueueState,
                        workQueueUi: nextEditor.workQueueUi,
                        transitionState: v.value1
                    }
                };
                var commands = $7b9d021f8fc5e8ea$var$append(prefixCommands)([
                    new $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7(target.historyMode)
                ]);
                if (v.value0) return $7b9d021f8fc5e8ea$var$pure({
                    state: settledState,
                    commands: commands
                });
                return $7b9d021f8fc5e8ea$var$beginPendingTransition(settledState);
            }
            if ($06733ae99ed4f534$export$c15bd07a493e1236(state.saveOperationId) || $06733ae99ed4f534$export$c15bd07a493e1236(state.loadOperationId)) return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: prefixCommands
            });
            if ($842627c31b5244a8$export$7e2e85b632e93ac2(state)) return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: $7b9d021f8fc5e8ea$var$append(prefixCommands)([
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214(new $06733ae99ed4f534$export$8a67b48435b5d073(target.generation))
                ])
            });
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: $7b9d021f8fc5e8ea$var$append(prefixCommands)([
                    new $7b9d021f8fc5e8ea$export$432d51bdca810dfc(target)
                ])
            });
            throw new Error("Failed pattern match at Steps.Step3.Update (line 338, column 1 - line 338, column 114): " + [
                state.constructor.name,
                target.constructor.name,
                prefixCommands.constructor.name
            ]);
        };
    };
};
var $7b9d021f8fc5e8ea$var$beginPendingTransition = function(state) {
    var v = $59a05a7e29977bc8$export$652a4dc1150a2d6(state.editor.transitionState);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7b9d021f8fc5e8ea$var$pure({
        state: state,
        commands: []
    });
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7b9d021f8fc5e8ea$var$continuePendingTransition(state)(v.value0)([]);
    throw new Error("Failed pattern match at Steps.Step3.Update (line 332, column 32 - line 336, column 50): " + [
        v.constructor.name
    ]);
};
var $7b9d021f8fc5e8ea$var$requestTransition = function(v) {
    return function(v1) {
        if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7b9d021f8fc5e8ea$var$pure({
            state: v,
            commands: []
        });
        if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var v2 = $59a05a7e29977bc8$export$544584b96aebcf5(v.editor.transitionState)(v1.value0.idx)(v1.value0.section);
            var queuedState = $842627c31b5244a8$export$efb563a7c7e3f705(function(editor) {
                return {
                    queue: editor.queue,
                    position: editor.position,
                    anchor: editor.anchor,
                    activeSection: editor.activeSection,
                    sectionIntent: editor.sectionIntent,
                    workQueueState: editor.workQueueState,
                    workQueueUi: editor.workQueueUi,
                    workQueueCache: editor.workQueueCache,
                    fillState: editor.fillState,
                    transitionState: v2.value1
                };
            })(v);
            if (v2.value0) return $7b9d021f8fc5e8ea$var$beginPendingTransition(queuedState);
            return $7b9d021f8fc5e8ea$var$pure({
                state: queuedState,
                commands: []
            });
        }
        throw new Error("Failed pattern match at Steps.Step3.Update (line 319, column 1 - line 322, column 40): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $7b9d021f8fc5e8ea$export$722fbec263ad908a = function(state) {
    return function(v) {
        if (v instanceof $7b9d021f8fc5e8ea$export$66aa8e949afa1192) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: function() {
                if (v.value0) return [
                    new $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40($994495db3cff0a67$export$635e3e065a143ae6.value)
                ];
                return [];
            }()
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$b2e6f2c49f73a48f && $7b9d021f8fc5e8ea$var$notEq(state.saveOperationId)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$b2e6f2c49f73a48f) return $7b9d021f8fc5e8ea$var$bind(function() {
            if (v.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value1.value0);
            if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $f57f4b701aa7b66e$export$8a83211c878a3f1f($842627c31b5244a8$export$c77057dcb3417a70)(v.value1.value0)({
                editor: state.editor,
                loadOperationId: state.loadOperationId,
                autofillOperationId: state.autofillOperationId,
                lockOperationId: state.lockOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: $7b9d021f8fc5e8ea$var$clearIfMatches(v.value0)(state.saveOperationId)
            });
            throw new Error("Failed pattern match at Steps.Step3.Update (line 73, column 22 - line 78, column 22): " + [
                v.value1.constructor.name
            ]);
        }())(function(nextState) {
            var afterSaveState = {
                autofillOperationId: nextState.autofillOperationId,
                documentMutationOperationId: nextState.documentMutationOperationId,
                editor: nextState.editor,
                loadOperationId: nextState.loadOperationId,
                lockOperationId: nextState.lockOperationId,
                saveOperationId: nextState.saveOperationId,
                pendingPostSave: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
            var baseCommands = [
                $7b9d021f8fc5e8ea$export$88c8c40786b3927b.value
            ];
            var v1 = $59a05a7e29977bc8$export$652a4dc1150a2d6(afterSaveState.editor.transitionState);
            if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7b9d021f8fc5e8ea$var$continuePendingTransition(afterSaveState)(v1.value0)(baseCommands);
            if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7b9d021f8fc5e8ea$var$pure({
                state: afterSaveState,
                commands: $7b9d021f8fc5e8ea$var$append(baseCommands)(function() {
                    if (nextState.pendingPostSave instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
                    if (nextState.pendingPostSave instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && nextState.pendingPostSave.value0 instanceof $842627c31b5244a8$export$421025fa7512c563) return [
                        new $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40($994495db3cff0a67$export$635e3e065a143ae6.value)
                    ];
                    if (nextState.pendingPostSave instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && nextState.pendingPostSave.value0 instanceof $842627c31b5244a8$export$49f65ba1d6c140c) return [
                        new $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40($994495db3cff0a67$export$9807628a98dc6165.value)
                    ];
                    if (nextState.pendingPostSave instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && nextState.pendingPostSave.value0 instanceof $842627c31b5244a8$export$5f03e7db4c52ef18) return [
                        new $7b9d021f8fc5e8ea$export$96c159224a0db784(nextState.pendingPostSave.value0.value0.url)
                    ];
                    if (nextState.pendingPostSave instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && nextState.pendingPostSave.value0 instanceof $842627c31b5244a8$export$f40f49b6fe1fe9c9) return [
                        $7b9d021f8fc5e8ea$export$cca72c408b5f0a32.value
                    ];
                    throw new Error("Failed pattern match at Steps.Step3.Update (line 87, column 49 - line 92, column 65): " + [
                        nextState.pendingPostSave.constructor.name
                    ]);
                }())
            });
            throw new Error("Failed pattern match at Steps.Step3.Update (line 81, column 9 - line 93, column 22): " + [
                v1.constructor.name
            ]);
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$b72a7f0a527922d2 && $7b9d021f8fc5e8ea$var$notEq(state.loadOperationId)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$b72a7f0a527922d2) {
            var $102 = $59a05a7e29977bc8$export$feb5b876e65d414b(state.editor.transitionState)(v.value1);
            if ($102) {
                if (v.value2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value2.value0);
                if (v.value2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                    var loadedState = $842627c31b5244a8$export$3e04bda16fa5665d($7b9d021f8fc5e8ea$var$clearLoadOperation(v.value0)(state))(v.value2.value0);
                    var v1 = $59a05a7e29977bc8$export$652a4dc1150a2d6(loadedState.editor.transitionState);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        var v2 = $59a05a7e29977bc8$export$2ad361b4f37e39e9(loadedState.editor.transitionState)(v1.value0.generation);
                        var settledState = {
                            autofillOperationId: loadedState.autofillOperationId,
                            documentMutationOperationId: loadedState.documentMutationOperationId,
                            loadOperationId: loadedState.loadOperationId,
                            lockOperationId: loadedState.lockOperationId,
                            pendingPostSave: loadedState.pendingPostSave,
                            saveOperationId: loadedState.saveOperationId,
                            editor: {
                                activeSection: loadedState.editor.activeSection,
                                fillState: loadedState.editor.fillState,
                                position: loadedState.editor.position,
                                queue: loadedState.editor.queue,
                                sectionIntent: loadedState.editor.sectionIntent,
                                workQueueCache: loadedState.editor.workQueueCache,
                                workQueueState: loadedState.editor.workQueueState,
                                workQueueUi: loadedState.editor.workQueueUi,
                                transitionState: v2.value1,
                                anchor: $06733ae99ed4f534$export$bebe9059409a0d04.value
                            }
                        };
                        if (v2.value0) return $7b9d021f8fc5e8ea$var$pure({
                            state: settledState,
                            commands: [
                                new $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7(v1.value0.historyMode)
                            ]
                        });
                        return $7b9d021f8fc5e8ea$var$beginPendingTransition(settledState);
                    }
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $7b9d021f8fc5e8ea$var$pure({
                        state: loadedState,
                        commands: []
                    });
                    throw new Error("Failed pattern match at Steps.Step3.Update (line 105, column 21 - line 121, column 70): " + [
                        v1.constructor.name
                    ]);
                }
                throw new Error("Failed pattern match at Steps.Step3.Update (line 101, column 18 - line 121, column 70): " + [
                    v.value2.constructor.name
                ]);
            }
            return $7b9d021f8fc5e8ea$var$bind($7b9d021f8fc5e8ea$var$beginPendingTransition($7b9d021f8fc5e8ea$var$clearLoadOperation(v.value0)(state)))(function(next) {
                return $7b9d021f8fc5e8ea$var$pure({
                    state: next.state,
                    commands: $7b9d021f8fc5e8ea$var$append([
                        new $7b9d021f8fc5e8ea$export$479877330b97c10b(v.value0)
                    ])(next.commands)
                });
            });
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$2e257da2bb680de4 && $7b9d021f8fc5e8ea$var$notEq(state.autofillOperationId)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$2e257da2bb680de4) return $7b9d021f8fc5e8ea$var$bind(function() {
            if (v.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value1.value0);
            if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $842627c31b5244a8$export$b062c3817f132aa6(state)(v.value1.value0);
            throw new Error("Failed pattern match at Steps.Step3.Update (line 131, column 22 - line 133, column 55): " + [
                v.value1.constructor.name
            ]);
        }())(function(nextState) {
            return $7b9d021f8fc5e8ea$var$pure({
                state: {
                    documentMutationOperationId: nextState.documentMutationOperationId,
                    editor: nextState.editor,
                    loadOperationId: nextState.loadOperationId,
                    lockOperationId: nextState.lockOperationId,
                    pendingPostSave: nextState.pendingPostSave,
                    saveOperationId: nextState.saveOperationId,
                    autofillOperationId: $7b9d021f8fc5e8ea$var$clearIfMatches(v.value0)(nextState.autofillOperationId)
                },
                commands: []
            });
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$822bcf0db9f14593 && $7b9d021f8fc5e8ea$var$notEq(state.lockOperationId)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$822bcf0db9f14593) {
            if (v.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value1.value0);
            if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $7b9d021f8fc5e8ea$var$pure({
                state: $f57f4b701aa7b66e$export$8a83211c878a3f1f($842627c31b5244a8$export$ed79dd21d6a2e442)(v.value1.value0)({
                    editor: state.editor,
                    saveOperationId: state.saveOperationId,
                    loadOperationId: state.loadOperationId,
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    pendingPostSave: state.pendingPostSave,
                    lockOperationId: $7b9d021f8fc5e8ea$var$clearIfMatches(v.value0)(state.lockOperationId)
                }),
                commands: []
            });
            throw new Error("Failed pattern match at Steps.Step3.Update (line 141, column 9 - line 148, column 22): " + [
                v.value1.constructor.name
            ]);
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$9af9d7135f6f5e08 && $7b9d021f8fc5e8ea$var$notEq(state.documentMutationOperationId)(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$9af9d7135f6f5e08) return $7b9d021f8fc5e8ea$var$bind(function() {
            if (v.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(v.value1.value0);
            if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $842627c31b5244a8$export$9dbba87a2d996646(state)(v.value1.value0);
            throw new Error("Failed pattern match at Steps.Step3.Update (line 155, column 22 - line 157, column 96): " + [
                v.value1.constructor.name
            ]);
        }())(function(nextState) {
            var clearedState = {
                autofillOperationId: nextState.autofillOperationId,
                editor: nextState.editor,
                loadOperationId: nextState.loadOperationId,
                lockOperationId: nextState.lockOperationId,
                pendingPostSave: nextState.pendingPostSave,
                saveOperationId: nextState.saveOperationId,
                documentMutationOperationId: $7b9d021f8fc5e8ea$var$clearIfMatches(v.value0)(nextState.documentMutationOperationId)
            };
            if (v.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a && v.value1.value0 instanceof $004747e47cb4edd5$export$8004e50c9b7bd668) return $7b9d021f8fc5e8ea$var$pure({
                state: clearedState,
                commands: [
                    new $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4(new $004747e47cb4edd5$export$5f8c57fd8a0528b5(clearedState.editor.fillState.doc.id))
                ]
            });
            return $7b9d021f8fc5e8ea$var$beginPendingTransition(clearedState);
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && $06733ae99ed4f534$export$c15bd07a493e1236($7b9d021f8fc5e8ea$var$oneOf([
            state.saveOperationId,
            state.loadOperationId,
            state.documentMutationOperationId
        ]))) return $7b9d021f8fc5e8ea$var$pure({
            state: $7b9d021f8fc5e8ea$var$captureTransitionDuringBusy(state)(v.value0),
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && $842627c31b5244a8$export$fba9605fc9710e5b(state)) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$804e7e4188df63ae && v.value0.value0 instanceof $356f5ce902fa042d$export$a80f920dd4c867c2) return $7b9d021f8fc5e8ea$var$pure({
            state: {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    fillState: state.editor.fillState,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: v.value0.value0.value0
                }
            },
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$91696afd1b09da8d) return $7b9d021f8fc5e8ea$var$pure({
            state: {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    fillState: state.editor.fillState,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: v.value0.value0,
                    workQueueUi: v.value0.value1
                }
            },
            commands: [
                $7b9d021f8fc5e8ea$export$4bb7762331f161c2.value
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$804e7e4188df63ae && v.value0.value0 instanceof $356f5ce902fa042d$export$d25f9f533b57ed2) return $7b9d021f8fc5e8ea$var$requestTransition(state)($7b9d021f8fc5e8ea$var$lookupTransitionTarget(v.value0.value0.value0.lookup)(v.value0.value0.value0.section)(state));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$153c58c8dcae1967) return $7b9d021f8fc5e8ea$var$pure({
            state: {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    fillState: v.value0.value0
                }
            },
            commands: [
                $7b9d021f8fc5e8ea$export$4bb7762331f161c2.value
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$8533e0fafe25e95c) return $7b9d021f8fc5e8ea$var$requestTransition(state)($7b9d021f8fc5e8ea$var$lookupTransitionTarget(v.value0.value0)(v.value0.value1)(state));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$dfd508fe3dcbbd6c && (v.value0.value0 < 0 || v.value0.value0 > ($7b9d021f8fc5e8ea$var$length(state.editor.queue) - 1 | 0))) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: []
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$dfd508fe3dcbbd6c) return $7b9d021f8fc5e8ea$var$requestTransition(state)(new $06733ae99ed4f534$export$8a67b48435b5d073({
            idx: v.value0.value0,
            section: v.value0.value1
        }));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$7ede261876d0a33b && $004747e47cb4edd5$export$a3f5e6a68ce798dd(state.editor)) {
            var $162 = $842627c31b5244a8$export$7e2e85b632e93ac2(state);
            if ($162) return $7b9d021f8fc5e8ea$var$pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    editor: state.editor,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    saveOperationId: state.saveOperationId,
                    pendingPostSave: new $06733ae99ed4f534$export$8a67b48435b5d073($842627c31b5244a8$export$49f65ba1d6c140c.value)
                },
                commands: [
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214($06733ae99ed4f534$export$bebe9059409a0d04.value)
                ]
            });
            return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: [
                    new $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40($994495db3cff0a67$export$9807628a98dc6165.value)
                ]
            });
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$7ede261876d0a33b) return $7b9d021f8fc5e8ea$var$requestTransition(state)(new $06733ae99ed4f534$export$8a67b48435b5d073({
            idx: state.editor.position + 1 | 0,
            section: $06733ae99ed4f534$export$bebe9059409a0d04.value
        }));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$c4ad6737b29d969c && state.editor.position <= 0) return $7b9d021f8fc5e8ea$var$requestTransition(state)(new $06733ae99ed4f534$export$8a67b48435b5d073({
            idx: $7b9d021f8fc5e8ea$var$length(state.editor.queue) - 1 | 0,
            section: $06733ae99ed4f534$export$bebe9059409a0d04.value
        }));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$c4ad6737b29d969c) return $7b9d021f8fc5e8ea$var$requestTransition(state)(new $06733ae99ed4f534$export$8a67b48435b5d073({
            idx: state.editor.position - 1 | 0,
            section: $06733ae99ed4f534$export$bebe9059409a0d04.value
        }));
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$e685275cfc27c6c5) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: function() {
                var $167 = $842627c31b5244a8$export$7e2e85b632e93ac2(state);
                if ($167) return [
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214($06733ae99ed4f534$export$bebe9059409a0d04.value)
                ];
                return [];
            }()
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$e3a394a4520b57d) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: [
                $7b9d021f8fc5e8ea$export$feff782b5e0b62d7.value
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$98c157c18e27e4f3) {
            var $170 = $842627c31b5244a8$export$7e2e85b632e93ac2(state);
            if ($170) return $7b9d021f8fc5e8ea$var$pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    editor: state.editor,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    saveOperationId: state.saveOperationId,
                    pendingPostSave: new $06733ae99ed4f534$export$8a67b48435b5d073($842627c31b5244a8$export$421025fa7512c563.value)
                },
                commands: [
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214($06733ae99ed4f534$export$bebe9059409a0d04.value)
                ]
            });
            return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: [
                    new $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40($994495db3cff0a67$export$635e3e065a143ae6.value)
                ]
            });
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$f5fbd132133a04d) {
            var $172 = $842627c31b5244a8$export$7e2e85b632e93ac2(state);
            if ($172) return $7b9d021f8fc5e8ea$var$pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    editor: state.editor,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    saveOperationId: state.saveOperationId,
                    pendingPostSave: new $06733ae99ed4f534$export$8a67b48435b5d073(new $842627c31b5244a8$export$5f03e7db4c52ef18(v.value0.value0))
                },
                commands: [
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214($06733ae99ed4f534$export$bebe9059409a0d04.value)
                ]
            });
            return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: [
                    new $7b9d021f8fc5e8ea$export$96c159224a0db784(v.value0.value0.url)
                ]
            });
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$e1e34d312d713b51) return $7b9d021f8fc5e8ea$var$pure({
            state: state,
            commands: [
                new $7b9d021f8fc5e8ea$export$93fbe371f495cba9($0e660be785782a7f$export$b56a159182574c04(state.editor.fillState.doc.formId)(state.editor.fillState.doc.student.id))
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$6b3072bafbdce7c) {
            var $176 = $06733ae99ed4f534$export$4967676db1b89293(state.editor.fillState.doc.locked_at) && $842627c31b5244a8$export$7e2e85b632e93ac2(state);
            if ($176) return $7b9d021f8fc5e8ea$var$pure({
                state: {
                    autofillOperationId: state.autofillOperationId,
                    documentMutationOperationId: state.documentMutationOperationId,
                    editor: state.editor,
                    loadOperationId: state.loadOperationId,
                    lockOperationId: state.lockOperationId,
                    saveOperationId: state.saveOperationId,
                    pendingPostSave: new $06733ae99ed4f534$export$8a67b48435b5d073($842627c31b5244a8$export$f40f49b6fe1fe9c9.value)
                },
                commands: [
                    new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214($06733ae99ed4f534$export$bebe9059409a0d04.value)
                ]
            });
            return $7b9d021f8fc5e8ea$var$pure({
                state: state,
                commands: [
                    $7b9d021f8fc5e8ea$export$cca72c408b5f0a32.value
                ]
            });
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$ce23c5d6d3d89659) return $7b9d021f8fc5e8ea$var$pure({
            state: {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    fillState: v.value0.value1
                }
            },
            commands: [
                new $7b9d021f8fc5e8ea$export$93fbe371f495cba9(v.value0.value0.value0)
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$9e35bbe1cc73cc01) return $7b9d021f8fc5e8ea$var$pure({
            state: {
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: state.saveOperationId,
                editor: {
                    activeSection: state.editor.activeSection,
                    anchor: state.editor.anchor,
                    position: state.editor.position,
                    queue: state.editor.queue,
                    sectionIntent: state.editor.sectionIntent,
                    transitionState: state.editor.transitionState,
                    workQueueCache: state.editor.workQueueCache,
                    workQueueState: state.editor.workQueueState,
                    workQueueUi: state.editor.workQueueUi,
                    fillState: v.value0.value0
                }
            },
            commands: [
                new $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4(v.value0.value1)
            ]
        });
        if (v instanceof $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d && v.value0 instanceof $004747e47cb4edd5$export$d5948ddb259ca298) return $7b9d021f8fc5e8ea$var$pure({
            state: $842627c31b5244a8$export$efb563a7c7e3f705(function(editor) {
                return {
                    queue: editor.queue,
                    position: editor.position,
                    activeSection: editor.activeSection,
                    sectionIntent: editor.sectionIntent,
                    transitionState: editor.transitionState,
                    workQueueState: editor.workQueueState,
                    workQueueUi: editor.workQueueUi,
                    workQueueCache: editor.workQueueCache,
                    fillState: editor.fillState,
                    anchor: $06733ae99ed4f534$export$bebe9059409a0d04.value
                };
            })(state),
            commands: []
        });
        throw new Error("Failed pattern match at Steps.Step3.Update (line 61, column 16 - line 317, column 14): " + [
            v.constructor.name
        ]);
    };
};
var $7b9d021f8fc5e8ea$export$7cd6553c80cd0e02 = function(state) {
    return function(command) {
        return function(opId) {
            if (command instanceof $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214) return {
                editor: state.editor,
                loadOperationId: state.loadOperationId,
                autofillOperationId: state.autofillOperationId,
                lockOperationId: state.lockOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                pendingPostSave: state.pendingPostSave,
                saveOperationId: new $06733ae99ed4f534$export$8a67b48435b5d073(opId)
            };
            if (command instanceof $7b9d021f8fc5e8ea$export$432d51bdca810dfc) {
                var v = $842627c31b5244a8$export$11c6c29bd74a41f5(command.value0)(state);
                return {
                    editor: v.editor,
                    saveOperationId: v.saveOperationId,
                    autofillOperationId: v.autofillOperationId,
                    lockOperationId: v.lockOperationId,
                    documentMutationOperationId: v.documentMutationOperationId,
                    pendingPostSave: v.pendingPostSave,
                    loadOperationId: new $06733ae99ed4f534$export$8a67b48435b5d073(opId)
                };
            }
            if (command instanceof $7b9d021f8fc5e8ea$export$93fbe371f495cba9) return {
                editor: state.editor,
                saveOperationId: state.saveOperationId,
                loadOperationId: state.loadOperationId,
                lockOperationId: state.lockOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                pendingPostSave: state.pendingPostSave,
                autofillOperationId: new $06733ae99ed4f534$export$8a67b48435b5d073(opId)
            };
            if (command instanceof $7b9d021f8fc5e8ea$export$cca72c408b5f0a32) return {
                editor: state.editor,
                saveOperationId: state.saveOperationId,
                loadOperationId: state.loadOperationId,
                autofillOperationId: state.autofillOperationId,
                documentMutationOperationId: state.documentMutationOperationId,
                pendingPostSave: state.pendingPostSave,
                lockOperationId: new $06733ae99ed4f534$export$8a67b48435b5d073(opId)
            };
            if (command instanceof $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4) return {
                editor: state.editor,
                saveOperationId: state.saveOperationId,
                loadOperationId: state.loadOperationId,
                autofillOperationId: state.autofillOperationId,
                lockOperationId: state.lockOperationId,
                pendingPostSave: state.pendingPostSave,
                documentMutationOperationId: new $06733ae99ed4f534$export$8a67b48435b5d073(opId)
            };
            return state;
        };
    };
};




var $df5131492eb04693$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $df5131492eb04693$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $df5131492eb04693$var$runGraphQL = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e26636bd8a4321dd($a40b20519abba0fb$export$fe526d00b95b6f09);
var $df5131492eb04693$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $df5131492eb04693$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $df5131492eb04693$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $df5131492eb04693$var$gDecodeJsonCons = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($35e75b0a064776f5$export$4fd8c305226c2099));
var $df5131492eb04693$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons1 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)($df5131492eb04693$var$created_atIsSymbol)()())())));
var $df5131492eb04693$var$gDecodeJsonCons2 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$5a21fe33ecda3e76));
var $df5131492eb04693$var$gDecodeJsonCons3 = /* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $df5131492eb04693$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons4 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $df5131492eb04693$var$gDecodeJsonCons5 = /* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $df5131492eb04693$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons6 = /* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5($df5131492eb04693$var$nameIsSymbol)()();
var $df5131492eb04693$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons7 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $308f9765feb7633d$export$3fdd9d25d69a77ef($e2b1be82a5e6d14f$export$12808118396f3c8d)));
var $df5131492eb04693$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons8 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons3({
    reflectSymbol: function() {
        return "useDefault";
    }
})()())($df5131492eb04693$var$updateIsSymbol)()())({
    reflectSymbol: function() {
        return "saveDefault";
    }
})()())({
    reflectSymbol: function() {
        return "request";
    }
})()())($df5131492eb04693$var$createIsSymbol)()())()));
var $df5131492eb04693$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $df5131492eb04693$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $df5131492eb04693$var$emailLabelIsSymbol = {
    reflectSymbol: function() {
        return "emailLabel";
    }
};
var $df5131492eb04693$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $df5131492eb04693$var$signaturesIsSymbol = {
    reflectSymbol: function() {
        return "signatures";
    }
};
var $df5131492eb04693$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $df5131492eb04693$var$gDecodeJsonCons9 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($e2b1be82a5e6d14f$export$12808118396f3c8d));
var $df5131492eb04693$var$gDecodeJsonCons10 = /* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7($35e75b0a064776f5$export$4fd8c305226c2099));
var $df5131492eb04693$var$gDecodeJsonCons11 = /* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac);
var $df5131492eb04693$var$gDecodeJsonCons12 = /* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons11($df5131492eb04693$var$keyIsSymbol)()();
var $df5131492eb04693$var$changePage = /* #__PURE__ */ $b5f6b40b8f63b732$export$af04929cb32c4bb7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons2(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons3($df5131492eb04693$var$updateIsSymbol)()())({
    reflectSymbol: function() {
        return "lock";
    }
})()())()))(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons1(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($df5131492eb04693$var$gDecodeJsonCons6)()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$5be2ed97e7605dc7(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5({
    reflectSymbol: function() {
        return "company";
    }
})()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5({
    reflectSymbol: function() {
        return "url";
    }
})()())($df5131492eb04693$var$labelIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5($df5131492eb04693$var$updateIsSymbol)()())({
    reflectSymbol: function() {
        return "delete";
    }
})()())($df5131492eb04693$var$createIsSymbol)()())()))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f($e2b1be82a5e6d14f$export$fee2d5446387c54f))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons8(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5({
    reflectSymbol: function() {
        return "relationship_label";
    }
})()())($df5131492eb04693$var$relationshipIsSymbol)()())($df5131492eb04693$var$labelIsSymbol)()())($df5131492eb04693$var$keyIsSymbol)()())($df5131492eb04693$var$emailLabelIsSymbol)()())($df5131492eb04693$var$canIsSymbol)()())())))(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons5({
    reflectSymbol: function() {
        return "type";
    }
})()())($df5131492eb04693$var$signaturesIsSymbol)()())({
    reflectSymbol: function() {
        return "priority";
    }
})()())({
    reflectSymbol: function() {
        return "mutations";
    }
})()())($df5131492eb04693$var$labelIsSymbol)()())($df5131492eb04693$var$idIsSymbol)()())({
    reflectSymbol: function() {
        return "bgColor";
    }
})()())({
    reflectSymbol: function() {
        return "abbr";
    }
})()())()))(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons10(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons8(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons11($df5131492eb04693$var$relationshipIsSymbol)()())($df5131492eb04693$var$labelIsSymbol)()())($df5131492eb04693$var$keyIsSymbol)()())($df5131492eb04693$var$emailLabelIsSymbol)()())({
    reflectSymbol: function() {
        return "default_last_name";
    }
})()())({
    reflectSymbol: function() {
        return "default_first_name";
    }
})()())({
    reflectSymbol: function() {
        return "default_email";
    }
})()())($df5131492eb04693$var$canIsSymbol)()())())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9($df5131492eb04693$var$gDecodeJsonCons12)())))(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons7(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons10(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons9(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4($df5131492eb04693$var$gDecodeJsonCons6)({
    reflectSymbol: function() {
        return "color";
    }
})()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)({
    reflectSymbol: function() {
        return "tags";
    }
})()())({
    reflectSymbol: function() {
        return "preferred_name";
    }
})()())($df5131492eb04693$var$nameIsSymbol)()())({
    reflectSymbol: function() {
        return "last_imported_at";
    }
})()())($df5131492eb04693$var$idIsSymbol)()())()))(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$81879b02e9646afe(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons(/* #__PURE__ */ $e2b1be82a5e6d14f$export$44d61a05912ad881(/* #__PURE__ */ $e2b1be82a5e6d14f$export$d94c139f6fec2f7f(/* #__PURE__ */ $e2b1be82a5e6d14f$export$b423891985836fe9(/* #__PURE__ */ $df5131492eb04693$var$gDecodeJsonCons4($df5131492eb04693$var$gDecodeJsonCons12)({
    reflectSymbol: function() {
        return "email";
    }
})()())()))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)({
    reflectSymbol: function() {
        return "data";
    }
})()())($df5131492eb04693$var$created_atIsSymbol)()())())))($e2b1be82a5e6d14f$export$355fe3e8bf1b90ac)({
    reflectSymbol: function() {
        return "verifications";
    }
})()())({
    reflectSymbol: function() {
        return "updated_at";
    }
})()())({
    reflectSymbol: function() {
        return "subtitle";
    }
})()())({
    reflectSymbol: function() {
        return "student";
    }
})()())($df5131492eb04693$var$signaturesIsSymbol)()())({
    reflectSymbol: function() {
        return "signature_fields";
    }
})()())({
    reflectSymbol: function() {
        return "locked_at";
    }
})()())({
    reflectSymbol: function() {
        return "legacy_url";
    }
})()())($df5131492eb04693$var$idIsSymbol)()())({
    reflectSymbol: function() {
        return "form_type";
    }
})()())({
    reflectSymbol: function() {
        return "exports";
    }
})()())({
    reflectSymbol: function() {
        return "employer";
    }
})()())({
    reflectSymbol: function() {
        return "contact";
    }
})()())({
    reflectSymbol: function() {
        return "comments";
    }
})()())($df5131492eb04693$var$canIsSymbol)()())({
    reflectSymbol: function() {
        return "attachments";
    }
})()())());
var $df5131492eb04693$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $df5131492eb04693$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($edf0339512807bee$export$e8a7d9b8d7dc616a);
var $df5131492eb04693$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $df5131492eb04693$var$getQuery = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$71eec30d9db46a56($a40b20519abba0fb$export$c6b405b39190b469);
var $df5131492eb04693$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0(/* #__PURE__ */ $d2284b2d3e1b6f87$export$a8cbc0f84e8b069b($edf0339512807bee$export$b147a380fa8fdc0e));
var $df5131492eb04693$var$except = /* #__PURE__ */ $d2284b2d3e1b6f87$export$67aba9fb222c5e1d($edf0339512807bee$export$9dc0454a98607988);
var $df5131492eb04693$var$getDecode = /* #__PURE__ */ $7c4f9de9dcfa2f59$export$e8c9f8acf899a39c($a40b20519abba0fb$export$c6b405b39190b469);
var $df5131492eb04693$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(/* #__PURE__ */ $d2284b2d3e1b6f87$export$963960a96c103d2f($edf0339512807bee$export$b147a380fa8fdc0e));
var $df5131492eb04693$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $df5131492eb04693$var$operationMessages = function(opId) {
    return function(result) {
        return function(payload) {
            var statusMessage = function() {
                if (result instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return new $c9f8fdc31e1f6dad$export$eafac69673bdfea3(opId, result.value0);
                if (result instanceof $7d4cccdf062a2261$export$19db0165690c701a) return new $c9f8fdc31e1f6dad$export$98baa1b16ede8cfe(opId);
                throw new Error("Failed pattern match at App.Operation.Runner (line 302, column 21 - line 304, column 36): " + [
                    result.constructor.name
                ]);
            }();
            return $df5131492eb04693$var$append(payload)([
                statusMessage
            ]);
        };
    };
};
var $df5131492eb04693$export$15c7e0e202f580a = function(enqueue) {
    return function(opId) {
        return function(kind) {
            return function(args) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($0e660be785782a7f$export$2440762e76d53a8c(args)))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$2e257da2bb680de4(opId, result$prime))
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$8388a4bfb34142b8 = function(enqueue) {
    return function(state) {
        return function(opId) {
            return function(kind) {
                return function(target) {
                    return function __do() {
                        enqueue([
                            new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, new $06733ae99ed4f534$export$8a67b48435b5d073(target.generation))
                        ])();
                        return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind(function() {
                            if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $842627c31b5244a8$export$e14e012eacfcf5b1(state.step3.value0)($06733ae99ed4f534$export$bebe9059409a0d04.value);
                            return $df5131492eb04693$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Step 3 load requested without a ready Step 3 session.")));
                        }())(function(result$prime) {
                            var editorResult = $df5131492eb04693$var$map(function(v) {
                                return v.editor;
                            })(result$prime);
                            return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                                new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$b72a7f0a527922d2(opId, target.generation, editorResult))
                            ])));
                        }))();
                    };
                };
            };
        };
    };
};
var $df5131492eb04693$export$407b1915a30f3f1e = function(enqueue) {
    return function(state) {
        return function(opId) {
            return function(kind) {
                return function(generation) {
                    return function __do() {
                        enqueue([
                            new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, generation)
                        ])();
                        return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind(function() {
                            if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $842627c31b5244a8$export$fa495481368f6a1a(state.step3.value0);
                            return $df5131492eb04693$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Step 3 save requested without a ready Step 3 session.")));
                        }())(function(result$prime) {
                            return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                                new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$b2e6f2c49f73a48f(opId, result$prime))
                            ])));
                        }))();
                    };
                };
            };
        };
    };
};
var $df5131492eb04693$export$77b5ce156dd73a75 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function(requests) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$4606848e31468bbe($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($d4a8d5b15f9925c4$export$4cfd7d1c74860312(requests)))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$170ffc57937e436f(opId, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$526e87cac6dc453c = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$78cbc2329447459a.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$changePage($b5f6b40b8f63b732$export$5b1c922c81430b65(ready.recentForms))(ready.recentForms))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$1815fbfc550f516c(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$af8d10484acdf914 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$ca6f6e5e77298091($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($d4a8d5b15f9925c4$export$957e53c221e2b1cb($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready))))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$bdf9754cca6d30f9(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$75d41def2ff735e0 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function(etype) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$a5b2acadcdb3baa4($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($d4a8d5b15f9925c4$export$ebc98c8dadc7994c($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready))))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$b8f63b481aa277b7(opId, etype, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$22dc772e760f6f14 = function(enqueue) {
    return function(opId) {
        return function(initial) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$78cbc2329447459a.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($506e78fa6ac73d88$export$e9046b5a68a171f5(initial))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$49c4478c934a149d(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$78238cf80a57bff6 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function(idx) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$78cbc2329447459a.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$changePage(idx)(ready.recentForms))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$1815fbfc550f516c(opId, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$7e8d1e05f9d6279f = function(enqueue) {
    return function(opId) {
        return function(requests) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$eb58b67453807721($df5131492eb04693$var$map1(function(v) {
                        return v.docId;
                    })(requests)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($8e553923d06fdb06$export$706aee3fd4ab9a03(requests)))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$15cf3a228c822e8b(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$beb5734a12a5a342 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$db10ae7477abb40b.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($812fcffca6747f78$export$423512157c50d7d0(ready.formPicker))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$186e0f90982d0f3f(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$75546801468fa48b = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$78cbc2329447459a.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($3b789731b0ef5df1$export$76fee8bb098f8940($506e78fa6ac73d88$export$ce850f65dda80828(ready))))(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$1815fbfc550f516c(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$9add7d25b4580357 = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function __do() {
                enqueue([
                    new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$58d3d305b67b6d53($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                ])();
                return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind(function() {
                    var v = $cc65e4880038a74f$export$57ce4fcebb92740d(ready);
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $df5131492eb04693$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Step 1 lock toggle requested without lockable selected documents.")));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $df5131492eb04693$var$runGraphQL($d4a8d5b15f9925c4$export$624bca672a5cb2cb(v.value0));
                    throw new Error("Failed pattern match at App.Operation.Runner (line 102, column 20 - line 104, column 71): " + [
                        v.constructor.name
                    ]);
                }())(function(result$prime) {
                    return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                        new $c9f8fdc31e1f6dad$export$72cd3e127cbacdf2(opId, result$prime)
                    ])));
                }))();
            };
        };
    };
};
var $df5131492eb04693$export$b12e3f35bb8df2cf = function(enqueue) {
    return function(opId) {
        return function(ready) {
            return function(selection) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, new $a8c8b5353c92bbbb$export$13e5863daa3c5eb1($506e78fa6ac73d88$export$d2afd53f9f0a26b(ready)), $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($cc65e4880038a74f$export$9fad341ed934648c(selection)($506e78fa6ac73d88$export$c1853cad74b031d9(ready))))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$c1b4ff70e49ef826(opId, selection, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$45e8be927952ff29 = function(enqueue) {
    return function(opId) {
        return function(workQueueState) {
            return function(workQueueCache) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$a5e6aa3b372c16a0.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d(function() {
                        var selectState = $85206166a57f2888$export$f6196a6c6bb539b4(workQueueState)(workQueueCache);
                        return $df5131492eb04693$var$bind($df5131492eb04693$var$map2($df5131492eb04693$var$map(function(page) {
                            return $85206166a57f2888$export$91e46f7d7a03a319(page)(selectState);
                        }))($df5131492eb04693$var$runGraphQL($b05aa108190eac05$export$88aef09b2a474163($6415e24f7cd3b8e1$export$4bb0f1a01491086d(selectState.search)))))(function(result$prime) {
                            return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                                new $c9f8fdc31e1f6dad$export$a64c6b692532acd6(opId, result$prime)
                            ])));
                        });
                    }())();
                };
            };
        };
    };
};
var $df5131492eb04693$export$a735302d9919706e = function(enqueue) {
    return function(opId) {
        return function(workQueueState) {
            return function(workQueueUi) {
                return function(workQueueCache) {
                    return function __do() {
                        enqueue([
                            new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$cf485ac8aca10137.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                        ])();
                        return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($812fcffca6747f78$export$60070eb0397470c(workQueueState)(workQueueUi)(workQueueCache)))(function(result$prime) {
                            return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                                new $c9f8fdc31e1f6dad$export$50c82f767474cb3f(opId, result$prime)
                            ])));
                        }))();
                    };
                };
            };
        };
    };
};
var $df5131492eb04693$export$65c7d3bda49ecdbd = function(enqueue) {
    return function(opId) {
        return function(workQueueState) {
            return function(workQueueCache) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$beefc18c38a3140b.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($6be45a9e147fc393$export$93c34340dccda974(workQueueState)($df5131492eb04693$var$map3(function(v) {
                        return v.value;
                    })(workQueueCache.defTeacher))($df5131492eb04693$var$map3(function(v) {
                        return v.value;
                    })(workQueueCache.defSemester)))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$385761a6227f1894(opId, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$14a5ca39b7e184ab = function(enqueue) {
    return function(state) {
        return function(opId) {
            return function(init) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, $a8c8b5353c92bbbb$export$db7e779274715f31.value, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($842627c31b5244a8$export$a5bc1fd82f921349(state.workQueueState)(state.workQueueCache)(init.formType)(init.doc))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$81c3d75642767bc3(opId, result$prime)
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$export$7ae1762b6e1f332b = function(enqueue) {
    return function(state) {
        return function(opId) {
            return function(kind) {
                return function(init) {
                    return function __do() {
                        enqueue([
                            new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                        ])();
                        return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($842627c31b5244a8$export$9976875180373c4d(state.workQueueState)(state.workQueueUi)(state.workQueueCache)(init.doc)(init.initialAnchor))(function(result$prime) {
                            return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                                new $c9f8fdc31e1f6dad$export$def578e25f70cc18(opId, result$prime)
                            ])));
                        }))();
                    };
                };
            };
        };
    };
};
var $df5131492eb04693$var$multiResponseAt = function(operation) {
    return function(idx) {
        return function(responses) {
            var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(responses)(idx);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012(operation + " was missing from the batched GraphQL response."));
            throw new Error("Failed pattern match at App.Operation.Runner (line 294, column 43 - line 296, column 99): " + [
                v.constructor.name
            ]);
        };
    };
};
var $df5131492eb04693$var$runSignAndRefresh = function(docId) {
    return function(signQuery) {
        return $d2284b2d3e1b6f87$export$8291c2122093ac93(function() {
            var uploads = $a40b20519abba0fb$export$ce6cc5691dbc7aa5(signQuery);
            var refreshQuery = $8e553923d06fdb06$export$747fafd1e4d82899(docId);
            var queries = [
                $df5131492eb04693$var$getQuery(signQuery),
                $df5131492eb04693$var$getQuery(refreshQuery)
            ];
            return $df5131492eb04693$var$bind1(function() {
                var v = $fc8c1182ec2aefec$export$f24224f1c91d8156(uploads);
                if (v === 0) return $7c4f9de9dcfa2f59$export$7efd4163d8775bbe(queries);
                if (v === 1) {
                    var v1 = $396c4c3d9e7fae3c$export$b610b8812bbcded9(uploads)(0);
                    if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $7c4f9de9dcfa2f59$export$4d82d2d5105d3377(queries)({
                        name: v1.value0.name,
                        file: v1.value0.file,
                        path: "0.variables." + v1.value0.path
                    });
                    if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $df5131492eb04693$var$except(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Expected one signature upload, but none was available.")));
                    throw new Error("Failed pattern match at App.Operation.Runner (line 278, column 14 - line 284, column 101): " + [
                        v1.constructor.name
                    ]);
                }
                return $df5131492eb04693$var$except(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Multiple file uploads are not currently supported")));
            }())(function(responses) {
                return $df5131492eb04693$var$bind1($df5131492eb04693$var$except($df5131492eb04693$var$multiResponseAt("signForm")(0)(responses)))(function(signatureJson) {
                    return $df5131492eb04693$var$bind1($df5131492eb04693$var$except($df5131492eb04693$var$multiResponseAt("GetDocument")(1)(responses)))(function(refreshJson) {
                        return $df5131492eb04693$var$bind1($df5131492eb04693$var$except($df5131492eb04693$var$getDecode(signQuery)(signatureJson)))(function(signature) {
                            return $df5131492eb04693$var$bind1($df5131492eb04693$var$except($df5131492eb04693$var$getDecode(refreshQuery)(refreshJson)))(function(refresh) {
                                return $df5131492eb04693$var$pure1(new $004747e47cb4edd5$export$dbed4d58d2dad4e1(signature, refresh));
                            });
                        });
                    });
                });
            });
        }());
    };
};
var $df5131492eb04693$var$runStep3DocumentMutationRequest = function(v) {
    if (v instanceof $004747e47cb4edd5$export$b217475cf0d7b767) return $df5131492eb04693$var$map2($df5131492eb04693$var$map($004747e47cb4edd5$export$65ca4a46ee1b7c38.create))($df5131492eb04693$var$runGraphQL($468ec44be9fa5236$export$b8fc62ea9b811d23(new $468ec44be9fa5236$export$b0bbdc4308f56a81(v.value0))(v.value1)));
    if (v instanceof $004747e47cb4edd5$export$45f887c8c5fa0732) return $df5131492eb04693$var$map2($df5131492eb04693$var$map($004747e47cb4edd5$export$d59dddaa17dd7b8a.create))($df5131492eb04693$var$runGraphQL($468ec44be9fa5236$export$5a1cd239009d83a6(v.value1)(v.value2)));
    if (v instanceof $004747e47cb4edd5$export$5ec1b5bc07c6cb4d) return $df5131492eb04693$var$map2($df5131492eb04693$var$map(function($448) {
        return $004747e47cb4edd5$export$17adc4f7fe1cd3b8.create(function(v1) {
            return v1.id;
        }($448));
    }))($df5131492eb04693$var$runGraphQL($468ec44be9fa5236$export$2e6e3ad634e3776(v.value1)));
    if (v instanceof $004747e47cb4edd5$export$d70fd387bd54d491) return $df5131492eb04693$var$map2($df5131492eb04693$var$map($004747e47cb4edd5$export$f00646e890d6b596.create))($df5131492eb04693$var$runGraphQL($f16a4b1732666b80$export$b4967a8c70fda682(new $f16a4b1732666b80$export$baeba309c80ed796(v.value0))(v.value1)));
    if (v instanceof $004747e47cb4edd5$export$a4c37d342183ceb6) return $df5131492eb04693$var$map2($df5131492eb04693$var$map(function($449) {
        return $004747e47cb4edd5$export$8ba32d49227f419c.create(function(v1) {
            return v1.id;
        }($449));
    }))($df5131492eb04693$var$runGraphQL($f16a4b1732666b80$export$9ed76097473092d5(v.value1)));
    if (v instanceof $004747e47cb4edd5$export$5d04178ec625702c) return $df5131492eb04693$var$runSignAndRefresh(v.value0)($8e553923d06fdb06$export$bc7262e0df8c91e0(v.value0)(v.value1)(v.value2)(v.value3));
    if (v instanceof $004747e47cb4edd5$export$f904c183433cbd62) return $df5131492eb04693$var$runSignAndRefresh(v.value0)($8e553923d06fdb06$export$84246b0ad9ebbb39(v.value0)(v.value1));
    if (v instanceof $004747e47cb4edd5$export$5f8c57fd8a0528b5) return $df5131492eb04693$var$map2($df5131492eb04693$var$map($004747e47cb4edd5$export$18586e5d3073eff6.create))($df5131492eb04693$var$runGraphQL($8e553923d06fdb06$export$747fafd1e4d82899(v.value0)));
    if (v instanceof $004747e47cb4edd5$export$efe0b24ea4d5137e) return $df5131492eb04693$var$map2($df5131492eb04693$var$map($004747e47cb4edd5$export$edafdbf2e37712a7.create))($df5131492eb04693$var$runGraphQL($8e553923d06fdb06$export$706aee3fd4ab9a03(v.value0)));
    throw new Error("Failed pattern match at App.Operation.Runner (line 239, column 35 - line 265, column 81): " + [
        v.constructor.name
    ]);
};
var $df5131492eb04693$export$b07dedcd037989ef = function(enqueue) {
    return function(opId) {
        return function(kind) {
            return function(request) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind($df5131492eb04693$var$runStep3DocumentMutationRequest(request))(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$9af9d7135f6f5e08(opId, result$prime))
                        ])));
                    }))();
                };
            };
        };
    };
};
var $df5131492eb04693$var$firstLockResult = function(results) {
    var v = $396c4c3d9e7fae3c$export$b610b8812bbcded9(results)(0);
    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $7d4cccdf062a2261$export$19db0165690c701a(v.value0);
    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("ToggleDocumentLocks returned no updated documents."));
    throw new Error("Failed pattern match at App.Operation.Runner (line 307, column 27 - line 309, column 87): " + [
        v.constructor.name
    ]);
};
var $df5131492eb04693$export$9d3b34fa0f7a378 = function(enqueue) {
    return function(state) {
        return function(opId) {
            return function(kind) {
                return function __do() {
                    enqueue([
                        new $c9f8fdc31e1f6dad$export$4a8caf36b85213e5(opId, kind, $06733ae99ed4f534$export$bebe9059409a0d04.value)
                    ])();
                    return $edf0339512807bee$export$c8704a1045ed544d($df5131492eb04693$var$bind(function() {
                        if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) {
                            var requests = [
                                {
                                    form_id: state.step3.value0.editor.fillState.doc.id,
                                    locked: $06733ae99ed4f534$export$4967676db1b89293(state.step3.value0.editor.fillState.doc.locked_at)
                                }
                            ];
                            return $df5131492eb04693$var$bind($df5131492eb04693$var$runGraphQL($d4a8d5b15f9925c4$export$624bca672a5cb2cb(requests)))(function(results) {
                                return $df5131492eb04693$var$pure($df5131492eb04693$var$bind2(results)($df5131492eb04693$var$firstLockResult));
                            });
                        }
                        return $df5131492eb04693$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515(new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Step 3 lock toggle requested without a ready Step 3 session.")));
                    }())(function(result$prime) {
                        return $df5131492eb04693$var$liftEffect(enqueue($df5131492eb04693$var$operationMessages(opId)(result$prime)([
                            new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$822bcf0db9f14593(opId, result$prime))
                        ])));
                    }))();
                };
            };
        };
    };
};







// Generated by purs version 0.15.16
const $f62293a4d87c5870$var$eventName = "ps-step3-form-request-current-doc";
let $f62293a4d87c5870$var$nextListenerId = 0;
let $f62293a4d87c5870$var$activeListenerId = 0;
const $f62293a4d87c5870$export$9c537fd190364f80 = function(doc) {
    return function(onError, onSuccess) {
        const listenerId = $f62293a4d87c5870$var$nextListenerId + 1;
        $f62293a4d87c5870$var$nextListenerId = listenerId;
        $f62293a4d87c5870$var$activeListenerId = listenerId;
        let completed = false;
        let cleanupTimer = undefined;
        const isActiveListener = function() {
            return $f62293a4d87c5870$var$activeListenerId === listenerId;
        };
        const cleanup = function() {
            if (cleanupTimer !== undefined) {
                window.clearTimeout(cleanupTimer);
                cleanupTimer = undefined;
            }
            if (isActiveListener()) $f62293a4d87c5870$var$activeListenerId = 0;
            window.removeEventListener($f62293a4d87c5870$var$eventName, handler);
        };
        const cleanupSoon = function() {
            if (cleanupTimer === undefined) // Keep this listener available until the next browser turn. Several
            // static form widgets can ask for the current document at once, before
            // App.Runtime has installed the replacement listener.
            cleanupTimer = window.setTimeout(cleanup, 0);
        };
        const handler = function(ev) {
            // A newer App.Runtime subscription may be active before this delayed
            // listener is removed. In that case this older listener must stay quiet.
            if (!isActiveListener()) return;
            try {
                if (ev.detail && typeof ev.detail.callback === "function") ev.detail.callback(doc);
                if (!completed) {
                    onSuccess({});
                    completed = true;
                }
                cleanupSoon();
            } catch (err) {
                cleanup();
                if (!completed) {
                    completed = true;
                    onError(err);
                }
            }
        };
        window.addEventListener($f62293a4d87c5870$var$eventName, handler);
        return function(_cancelError, _onCancelerError, onCancelerSuccess) {
            cleanup();
            onCancelerSuccess();
        };
    };
};



var $6902e46d4aa89f92$export$a6670301899fb89c = function(doc) {
    return $107430d2749bac15$export$2e3eef4f26ade0f7($f62293a4d87c5870$export$9c537fd190364f80(doc));
};


// Generated by purs version 0.15.16







































var $4b57a9a20c626e9f$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $4b57a9a20c626e9f$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404($4b57a9a20c626e9f$var$ordRNTY);
var $4b57a9a20c626e9f$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $4b57a9a20c626e9f$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $4b57a9a20c626e9f$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $4b57a9a20c626e9f$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $4b57a9a20c626e9f$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($4b57a9a20c626e9f$var$eqRNTY);
var $4b57a9a20c626e9f$var$elem = /* #__PURE__ */ $396c4c3d9e7fae3c$export$5bf96401662340b7($4b57a9a20c626e9f$var$eqRNTY);
var $4b57a9a20c626e9f$var$eq2 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($a8c8b5353c92bbbb$export$ddffdcd895d11148);
var $4b57a9a20c626e9f$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $4b57a9a20c626e9f$var$isEmpty = /* #__PURE__ */ $f264ceec36a478ad$export$dd1bc94b04021eeb($4b57a9a20c626e9f$var$ordRNTY);
var $4b57a9a20c626e9f$var$eq3 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($02eacf321b2a2128$export$5315b7c1b1d9e384);
var $4b57a9a20c626e9f$var$select$prime = /* #__PURE__ */ $f264ceec36a478ad$export$8b371b7a43624610($4b57a9a20c626e9f$var$ordRNTY);
var $4b57a9a20c626e9f$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($7d4cccdf062a2261$export$400f1ef3f3ec304d);
var $4b57a9a20c626e9f$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($7d4cccdf062a2261$export$3806e10d0c441ac5);
var $4b57a9a20c626e9f$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($7d4cccdf062a2261$export$f0a413d3d6075601);
var $4b57a9a20c626e9f$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $4b57a9a20c626e9f$export$43846ecbea5b4cd7 = /* #__PURE__ */ function() {
    function SyncRoute(value0) {
        this.value0 = value0;
    }
    SyncRoute.create = function(value0) {
        return new SyncRoute(value0);
    };
    return SyncRoute;
}();
var $4b57a9a20c626e9f$export$d1cc75e80b20eeaf = /* #__PURE__ */ function() {
    function HydrateLocation(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    HydrateLocation.create = function(value0) {
        return function(value1) {
            return new HydrateLocation(value0, value1);
        };
    };
    return HydrateLocation;
}();
var $4b57a9a20c626e9f$export$f68485a1a0d25ba8 = /* #__PURE__ */ function() {
    function RunStep1InitialLoad(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1InitialLoad.create = function(value0) {
        return function(value1) {
            return new RunStep1InitialLoad(value0, value1);
        };
    };
    return RunStep1InitialLoad;
}();
var $4b57a9a20c626e9f$export$bfeffc9dfe6adcbc = /* #__PURE__ */ function() {
    function DebounceStep1Search(value0) {
        this.value0 = value0;
    }
    DebounceStep1Search.create = function(value0) {
        return new DebounceStep1Search(value0);
    };
    return DebounceStep1Search;
}();
var $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef = /* #__PURE__ */ function() {
    function RunStep1Search(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1Search.create = function(value0) {
        return function(value1) {
            return new RunStep1Search(value0, value1);
        };
    };
    return RunStep1Search;
}();
var $4b57a9a20c626e9f$export$614ed660100c3639 = /* #__PURE__ */ function() {
    function RunStep1PageChange(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep1PageChange.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep1PageChange(value0, value1, value2);
            };
        };
    };
    return RunStep1PageChange;
}();
var $4b57a9a20c626e9f$export$8c088ed0af29bf8e = /* #__PURE__ */ function() {
    function RunStep1CurrentPageReload(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1CurrentPageReload.create = function(value0) {
        return function(value1) {
            return new RunStep1CurrentPageReload(value0, value1);
        };
    };
    return RunStep1CurrentPageReload;
}();
var $4b57a9a20c626e9f$export$20cb2c62b285cf15 = /* #__PURE__ */ function() {
    function RunStep1SaveFormOrder(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1SaveFormOrder.create = function(value0) {
        return function(value1) {
            return new RunStep1SaveFormOrder(value0, value1);
        };
    };
    return RunStep1SaveFormOrder;
}();
var $4b57a9a20c626e9f$export$9b2b5e8a9dac051e = /* #__PURE__ */ function() {
    function RunStep1ToggleLocks(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1ToggleLocks.create = function(value0) {
        return function(value1) {
            return new RunStep1ToggleLocks(value0, value1);
        };
    };
    return RunStep1ToggleLocks;
}();
var $4b57a9a20c626e9f$export$4f3ced6841ba7e93 = /* #__PURE__ */ function() {
    function RunStep1CopyDocuments(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep1CopyDocuments.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep1CopyDocuments(value0, value1, value2);
            };
        };
    };
    return RunStep1CopyDocuments;
}();
var $4b57a9a20c626e9f$export$b570b6d4d8a37ba = /* #__PURE__ */ function() {
    function RunStep1DeleteDocuments(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1DeleteDocuments.create = function(value0) {
        return function(value1) {
            return new RunStep1DeleteDocuments(value0, value1);
        };
    };
    return RunStep1DeleteDocuments;
}();
var $4b57a9a20c626e9f$export$882828c20d5c370f = /* #__PURE__ */ function() {
    function RunStep1ExportDocuments(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep1ExportDocuments.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep1ExportDocuments(value0, value1, value2);
            };
        };
    };
    return RunStep1ExportDocuments;
}();
var $4b57a9a20c626e9f$export$372d8dcc68f43922 = /* #__PURE__ */ function() {
    function RunStep1RequestSignatures(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep1RequestSignatures.create = function(value0) {
        return function(value1) {
            return new RunStep1RequestSignatures(value0, value1);
        };
    };
    return RunStep1RequestSignatures;
}();
var $4b57a9a20c626e9f$export$f4b18fa9f7b0988c = /* #__PURE__ */ function() {
    function RunStep1UpdateForms(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep1UpdateForms.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep1UpdateForms(value0, value1, value2);
            };
        };
    };
    return RunStep1UpdateForms;
}();
var $4b57a9a20c626e9f$export$a7960d0bb7149c3e = /* #__PURE__ */ function() {
    function RunStep2AInitialLoad(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep2AInitialLoad.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep2AInitialLoad(value0, value1, value2);
            };
        };
    };
    return RunStep2AInitialLoad;
}();
var $4b57a9a20c626e9f$export$909fe2fc390dacb8 = /* #__PURE__ */ function() {
    function RunStep2BLoad(value0, value1, value2, value3) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
        this.value3 = value3;
    }
    RunStep2BLoad.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return function(value3) {
                    return new RunStep2BLoad(value0, value1, value2, value3);
                };
            };
        };
    };
    return RunStep2BLoad;
}();
var $4b57a9a20c626e9f$export$e2233cf4256bed98 = /* #__PURE__ */ function() {
    function RunStep2ExportAll(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep2ExportAll.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep2ExportAll(value0, value1, value2);
            };
        };
    };
    return RunStep2ExportAll;
}();
var $4b57a9a20c626e9f$export$dca8967abeef5459 = /* #__PURE__ */ function() {
    function RunStep3FormTypesLoad(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    RunStep3FormTypesLoad.create = function(value0) {
        return function(value1) {
            return new RunStep3FormTypesLoad(value0, value1);
        };
    };
    return RunStep3FormTypesLoad;
}();
var $4b57a9a20c626e9f$export$3d8d3455249b0f5c = /* #__PURE__ */ function() {
    function RunStep3InitialLoad(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep3InitialLoad.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep3InitialLoad(value0, value1, value2);
            };
        };
    };
    return RunStep3InitialLoad;
}();
var $4b57a9a20c626e9f$export$1f0c59144b57f59f = /* #__PURE__ */ function() {
    function SyncStep3Route(value0) {
        this.value0 = value0;
    }
    SyncStep3Route.create = function(value0) {
        return new SyncStep3Route(value0);
    };
    return SyncStep3Route;
}();
var $4b57a9a20c626e9f$export$94d3e5d9ab92b4f9 = /* #__PURE__ */ function() {
    function ScrollStep3Section(value0) {
        this.value0 = value0;
    }
    ScrollStep3Section.create = function(value0) {
        return new ScrollStep3Section(value0);
    };
    return ScrollStep3Section;
}();
var $4b57a9a20c626e9f$export$c2e797ca28b02c81 = /* #__PURE__ */ function() {
    function SaveStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    SaveStep3.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new SaveStep3(value0, value1, value2);
            };
        };
    };
    return SaveStep3;
}();
var $4b57a9a20c626e9f$export$a5e3e4d00fc363bf = /* #__PURE__ */ function() {
    function LoadStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    LoadStep3.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new LoadStep3(value0, value1, value2);
            };
        };
    };
    return LoadStep3;
}();
var $4b57a9a20c626e9f$export$7540d7178b14245f = /* #__PURE__ */ function() {
    function AutofillStep3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    AutofillStep3.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new AutofillStep3(value0, value1, value2);
            };
        };
    };
    return AutofillStep3;
}();
var $4b57a9a20c626e9f$export$b1d3326fcab09462 = /* #__PURE__ */ function() {
    function ToggleStep3Lock(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    ToggleStep3Lock.create = function(value0) {
        return function(value1) {
            return new ToggleStep3Lock(value0, value1);
        };
    };
    return ToggleStep3Lock;
}();
var $4b57a9a20c626e9f$export$f515a058fe9fca3a = /* #__PURE__ */ function() {
    function RunStep3DocumentMutation(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    RunStep3DocumentMutation.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new RunStep3DocumentMutation(value0, value1, value2);
            };
        };
    };
    return RunStep3DocumentMutation;
}();
var $4b57a9a20c626e9f$export$5cbca665f928318b = /* #__PURE__ */ function() {
    function ConfirmStep3Cancel() {}
    ConfirmStep3Cancel.value = new ConfirmStep3Cancel();
    return ConfirmStep3Cancel;
}();
var $4b57a9a20c626e9f$export$88c8c40786b3927b = /* #__PURE__ */ function() {
    function AllowPageUnload() {}
    AllowPageUnload.value = new AllowPageUnload();
    return AllowPageUnload;
}();
var $4b57a9a20c626e9f$export$4bb7762331f161c2 = /* #__PURE__ */ function() {
    function BlockPageUnload() {}
    BlockPageUnload.value = new BlockPageUnload();
    return BlockPageUnload;
}();
var $4b57a9a20c626e9f$export$96c159224a0db784 = /* #__PURE__ */ function() {
    function OpenExportUrl(value0) {
        this.value0 = value0;
    }
    OpenExportUrl.create = function(value0) {
        return new OpenExportUrl(value0);
    };
    return OpenExportUrl;
}();
var $4b57a9a20c626e9f$export$4aa34530d5f59077 = /* #__PURE__ */ function() {
    function OpenExternalUrl(value0) {
        this.value0 = value0;
    }
    OpenExternalUrl.create = function(value0) {
        return new OpenExternalUrl(value0);
    };
    return OpenExternalUrl;
}();
var $4b57a9a20c626e9f$export$e17713364c5dda32 = /* #__PURE__ */ function() {
    function ReportError(value0) {
        this.value0 = value0;
    }
    ReportError.create = function(value0) {
        return new ReportError(value0);
    };
    return ReportError;
}();
var $4b57a9a20c626e9f$var$syncStep2BState = function(state) {
    return function(ready) {
        return {
            route: state.route,
            step: state.step,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step2B: new $80445329d31df9ca$export$81701a88d512004b(ready),
            workQueueState: ready.workQueueState,
            workQueueUi: ready.workQueueUi,
            workQueueCache: ready.workQueueCache
        };
    };
};
var $4b57a9a20c626e9f$var$syncReadyState = function(state) {
    return function(ready) {
        return {
            route: state.route,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            routeVersion: state.routeVersion,
            workQueueState: ready.editor.workQueueState,
            workQueueUi: ready.editor.workQueueUi,
            workQueueCache: ready.editor.workQueueCache,
            step: new $994495db3cff0a67$export$db36463848ed68bd(ready.editor.fillState.doc.id),
            step3: new $80445329d31df9ca$export$23187e44e30bad72(ready)
        };
    };
};
var $4b57a9a20c626e9f$var$supersededScopesForStep2Operation = function(v) {
    if (v instanceof $a8c8b5353c92bbbb$export$a5e6aa3b372c16a0) return [
        $a8c8b5353c92bbbb$export$d7525e570f2fab63.value
    ];
    if (v instanceof $a8c8b5353c92bbbb$export$cf485ac8aca10137) return [
        $a8c8b5353c92bbbb$export$7a1013a450b76540.value
    ];
    return [];
};
var $4b57a9a20c626e9f$var$supersededScopesForStep1Operation = function(v) {
    if (v instanceof $a8c8b5353c92bbbb$export$78cbc2329447459a) return [
        $a8c8b5353c92bbbb$export$f0780570fbaaaac3.value
    ];
    return [];
};
var $4b57a9a20c626e9f$var$supersedeLatestActiveInScope = function(scope) {
    return function(state) {
        var v = $fb0451ff9e33ce13$export$4b2eb0e7d83e1f5a(state.operations)(scope);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $fb0451ff9e33ce13$export$6bed92fff59224d8(state.operations)(v.value0.id)) return {
            route: state.route,
            step: state.step,
            workQueueState: state.workQueueState,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            operations: $fb0451ff9e33ce13$export$f92ca06486a47b7a(v.value0.id)(state.operations)
        };
        return state;
    };
};
var $4b57a9a20c626e9f$var$step3WorkQueueUi = function(state) {
    if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return state.step3.value0.editor.workQueueUi;
    return state.workQueueUi;
};
var $4b57a9a20c626e9f$var$step3WorkQueueState = function(state) {
    if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return state.step3.value0.editor.workQueueState;
    return state.workQueueState;
};
var $4b57a9a20c626e9f$var$step3WorkQueueDocIds = function(workQueue) {
    return $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$append($4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })(workQueue.editDocs))($4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })($4b57a9a20c626e9f$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(workQueue.documents)))));
};
var $4b57a9a20c626e9f$var$step3WorkQueueCache = function(state) {
    if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return state.step3.value0.editor.workQueueCache;
    return state.workQueueCache;
};
var $4b57a9a20c626e9f$var$step3DocumentMutationOperationKind = function(currentDocId) {
    var requestDocIds = function(requests) {
        var docIds = $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$map(function(v) {
            return v.docId;
        })(requests));
        var $165 = $396c4c3d9e7fae3c$export$7b1b591b262c240(docIds);
        if ($165) return [
            currentDocId
        ];
        return docIds;
    };
    return function(v) {
        if (v instanceof $004747e47cb4edd5$export$b217475cf0d7b767) return new $a8c8b5353c92bbbb$export$af004f84993afb6b(v.value0);
        if (v instanceof $004747e47cb4edd5$export$45f887c8c5fa0732) return new $a8c8b5353c92bbbb$export$ffb1f8f95ffeffe4(v.value0);
        if (v instanceof $004747e47cb4edd5$export$5ec1b5bc07c6cb4d) return new $a8c8b5353c92bbbb$export$14fc0fe22255f268(v.value0);
        if (v instanceof $004747e47cb4edd5$export$d70fd387bd54d491) return new $a8c8b5353c92bbbb$export$c3acb5c17ec9e09a(v.value0);
        if (v instanceof $004747e47cb4edd5$export$a4c37d342183ceb6) return new $a8c8b5353c92bbbb$export$1275fb4c138da766(v.value0);
        if (v instanceof $004747e47cb4edd5$export$5d04178ec625702c) return new $a8c8b5353c92bbbb$export$e03fcd1abfca724a(v.value0);
        if (v instanceof $004747e47cb4edd5$export$f904c183433cbd62) return new $a8c8b5353c92bbbb$export$903006ef3f779e68(v.value0);
        if (v instanceof $004747e47cb4edd5$export$5f8c57fd8a0528b5) return new $a8c8b5353c92bbbb$export$ef666bef212ffa51(v.value0);
        if (v instanceof $004747e47cb4edd5$export$efe0b24ea4d5137e) return new $a8c8b5353c92bbbb$export$887f8ca70ce7e84e(requestDocIds(v.value0));
        throw new Error("Failed pattern match at App.Update (line 1095, column 51 - line 1113, column 56): " + [
            v.constructor.name
        ]);
    };
};
var $4b57a9a20c626e9f$var$step3DocRouteIndex = function(ready) {
    return function(docId) {
        var matchesDoc = function(entry) {
            if (entry.form instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$eq(entry.form.value0.id)(docId);
            if (entry.form instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                var v = $740d96ccf08cc464$export$30606e16463b30d9(ready.editor.workQueueState)({
                    studentId: entry.student,
                    formId: entry.form.value0,
                    documentId: $06733ae99ed4f534$export$bebe9059409a0d04.value
                });
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$eq(v.value0.id)(docId);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
                throw new Error("Failed pattern match at App.Update (line 1315, column 25 - line 1317, column 29): " + [
                    v.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at App.Update (line 1313, column 24 - line 1317, column 29): " + [
                entry.form.constructor.name
            ]);
        };
        return $396c4c3d9e7fae3c$export$de3a4d4a0d731119(matchesDoc)(ready.editor.queue);
    };
};
var $4b57a9a20c626e9f$var$step3DocIds = function(ready) {
    return $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$append($4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })(ready.editor.workQueueState.editDocs))($4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })($4b57a9a20c626e9f$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(ready.editor.workQueueState.documents)))));
};
var $4b57a9a20c626e9f$var$step3RequestedDocIdsMatch = function(ready) {
    return function(requestedDocIds) {
        var expectedDocIds = $4b57a9a20c626e9f$var$step3DocIds(ready);
        var dedupedRequested = $4b57a9a20c626e9f$var$nub(requestedDocIds);
        return $fc8c1182ec2aefec$export$f24224f1c91d8156(dedupedRequested) === $fc8c1182ec2aefec$export$f24224f1c91d8156(expectedDocIds) && $396c4c3d9e7fae3c$export$84bf76cd7afc7469(function(docId) {
            return $4b57a9a20c626e9f$var$elem(docId)(expectedDocIds);
        })(dedupedRequested);
    };
};
var $4b57a9a20c626e9f$var$step2ExportError = function(err) {
    return function(state) {
        if (state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) return {
            state: {
                route: state.route,
                step: state.step,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                workQueueCache: state.workQueueCache,
                preselectForms: state.preselectForms,
                pushStateInterface: state.pushStateInterface,
                operations: state.operations,
                step1: state.step1,
                step2B: state.step2B,
                step3: state.step3,
                routeVersion: state.routeVersion,
                step2A: new $80445329d31df9ca$export$10d33c2f80e61d21(err)
            },
            commands: []
        };
        if (state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) return {
            state: {
                route: state.route,
                step: state.step,
                workQueueState: state.workQueueState,
                workQueueUi: state.workQueueUi,
                workQueueCache: state.workQueueCache,
                preselectForms: state.preselectForms,
                pushStateInterface: state.pushStateInterface,
                operations: state.operations,
                step1: state.step1,
                step2A: state.step2A,
                step3: state.step3,
                routeVersion: state.routeVersion,
                step2B: new $80445329d31df9ca$export$d17de998d9231f6f(err)
            },
            commands: []
        };
        return {
            state: state,
            commands: [
                new $4b57a9a20c626e9f$export$e17713364c5dda32(err)
            ]
        };
    };
};
var $4b57a9a20c626e9f$var$step1BlockingOperationScopes = /* #__PURE__ */ function() {
    return [
        $a8c8b5353c92bbbb$export$812d070c95a0506d.value,
        $a8c8b5353c92bbbb$export$bd4ea9079614f218.value,
        $a8c8b5353c92bbbb$export$3fc2b2789a39ace6.value
    ];
}();
var $4b57a9a20c626e9f$var$startStep3Operation = function(step3Command) {
    return function(_kind) {
        return function(_generation) {
            return function(mkCommand) {
                return function(result) {
                    if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) {
                        var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(result.state.operations);
                        var nextReady = $7b9d021f8fc5e8ea$export$7cd6553c80cd0e02(result.state.step3.value0)(step3Command)(v.value0);
                        var nextState = function() {
                            var v1 = $4b57a9a20c626e9f$var$syncReadyState(result.state)(nextReady);
                            return {
                                preselectForms: v1.preselectForms,
                                pushStateInterface: v1.pushStateInterface,
                                route: v1.route,
                                routeVersion: v1.routeVersion,
                                step: v1.step,
                                step1: v1.step1,
                                step2A: v1.step2A,
                                step2B: v1.step2B,
                                step3: v1.step3,
                                workQueueCache: v1.workQueueCache,
                                workQueueState: v1.workQueueState,
                                workQueueUi: v1.workQueueUi,
                                operations: v.value1
                            };
                        }();
                        return {
                            state: nextState,
                            commands: $4b57a9a20c626e9f$var$append(result.commands)([
                                mkCommand(v.value0)
                            ])
                        };
                    }
                    return result;
                };
            };
        };
    };
};
var $4b57a9a20c626e9f$var$setStep1Ready = function(ready) {
    return function(state) {
        return {
            route: state.route,
            step: state.step,
            workQueueState: state.workQueueState,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            step1: new $80445329d31df9ca$export$3a4efe2ed5897b55(ready),
            workQueueUi: {
                expandedStudents: state.workQueueUi.expandedStudents,
                teacher: state.workQueueUi.teacher,
                semester: state.workQueueUi.semester,
                search: ready.searchState
            }
        };
    };
};
var $4b57a9a20c626e9f$var$step1Error = function(err) {
    return function(state) {
        if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) return {
            state: $4b57a9a20c626e9f$var$setStep1Ready($506e78fa6ac73d88$export$b8d0bb2aa0adefe5(err)(state.step1.value0))(state),
            commands: [
                new $4b57a9a20c626e9f$export$e17713364c5dda32(err)
            ]
        };
        return {
            state: state,
            commands: [
                new $4b57a9a20c626e9f$export$e17713364c5dda32(err)
            ]
        };
    };
};
var $4b57a9a20c626e9f$var$scheduleStep3BootstrapOps = function(result) {
    if (result.state.step3 instanceof $80445329d31df9ca$export$52520e6e1d2bce34 && result.state.step3.value0.opId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
        var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(result.state.operations);
        return {
            state: {
                route: result.state.route,
                step: result.state.step,
                workQueueState: result.state.workQueueState,
                workQueueUi: result.state.workQueueUi,
                workQueueCache: result.state.workQueueCache,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                routeVersion: result.state.routeVersion,
                operations: v.value1,
                step3: new $80445329d31df9ca$export$52520e6e1d2bce34({
                    init: result.state.step3.value0.init,
                    opId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                })
            },
            commands: $4b57a9a20c626e9f$var$append(result.commands)([
                new $4b57a9a20c626e9f$export$dca8967abeef5459(v.value0, result.state.step3.value0.init)
            ])
        };
    }
    if (result.state.step3 instanceof $80445329d31df9ca$export$b87e8303844f9049 && result.state.step3.value0.opId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
        var kind = $842627c31b5244a8$export$43055f49ea9b191(result.state.workQueueState)(result.state.step3.value0.init.doc);
        var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(result.state.operations);
        return {
            state: {
                route: result.state.route,
                step: result.state.step,
                workQueueState: result.state.workQueueState,
                workQueueUi: result.state.workQueueUi,
                workQueueCache: result.state.workQueueCache,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                routeVersion: result.state.routeVersion,
                operations: v.value1,
                step3: new $80445329d31df9ca$export$b87e8303844f9049({
                    init: result.state.step3.value0.init,
                    opId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                })
            },
            commands: $4b57a9a20c626e9f$var$append(result.commands)([
                new $4b57a9a20c626e9f$export$3d8d3455249b0f5c(v.value0, kind, result.state.step3.value0.init)
            ])
        };
    }
    return result;
};
var $4b57a9a20c626e9f$var$missingStep2ExportReportError = /* #__PURE__ */ function() {
    return new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$7a0047718fb8649d("App.Update"), new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$19d787e6e83e848f("exporting selected forms"), new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Expected at least one report for exported forms.")));
}();
var $4b57a9a20c626e9f$var$loadingStep3Route = function(locationState) {
    return function(workQueue) {
        return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
            preservedQuery: $daa993e9fe4182d9$export$11c97f589579967b(locationState.search),
            activeDoc: $06733ae99ed4f534$export$bebe9059409a0d04.value,
            docs: $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$step3WorkQueueDocIds(workQueue)),
            section: $daa993e9fe4182d9$export$37a45811bf45ea95.value
        });
    };
};
var $4b57a9a20c626e9f$var$isStep1RecentFormsReloadMsg = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$f9a329ae029c9889) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$d6d899291526e2a0) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$60db918807a7b577) return !v.value0.value0.reorder;
    return false;
};
var $4b57a9a20c626e9f$var$isStep1Loading = function(step1State) {
    if (step1State.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isStep1GlobalActionMsg = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa) return true;
    if (v instanceof $cc65e4880038a74f$export$51b64cdb4a042e2f && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    if (v instanceof $cc65e4880038a74f$export$43d85b6b81ad99e0 && v.value0) return true;
    if (v instanceof $cc65e4880038a74f$export$7183506d59c388b0 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    if (v instanceof $cc65e4880038a74f$export$9d697732809bc86 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isStep1FormOrderMsg = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$60db918807a7b577) return v.value0.value0.reorder;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$13ea8ce0e2ccb998) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$4474bd630dd3ef5b) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isStep1DocumentMutationMsg = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$747c16e05a885c2a) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$c7d83595be8c07b1) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$864b5c5b705745d2) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$efe0b24ea4d5137e) return true;
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$1d3f1ab8435af5a9) return true;
    if (v instanceof $cc65e4880038a74f$export$51b64cdb4a042e2f && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    if (v instanceof $cc65e4880038a74f$export$43d85b6b81ad99e0 && v.value0) return true;
    if (v instanceof $cc65e4880038a74f$export$7183506d59c388b0 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    if (v instanceof $cc65e4880038a74f$export$9d697732809bc86 && v.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isStep1CreateFormsMsg = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$67e817d458d93d9f) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isLatestOperation = function(scope) {
    return function(opId) {
        return function(state) {
            var v = $fb0451ff9e33ce13$export$4b2eb0e7d83e1f5a(state.operations)(scope);
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$eq2(v.value0.id)(opId);
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return false;
            throw new Error("Failed pattern match at App.Update (line 975, column 38 - line 977, column 21): " + [
                v.constructor.name
            ]);
        };
    };
};
var $4b57a9a20c626e9f$var$isCurrentStep2 = function(v) {
    if (v instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) return true;
    if (v instanceof $994495db3cff0a67$export$d80ca78eabef93e4) return true;
    return false;
};
var $4b57a9a20c626e9f$var$isCurrentOperation = function(scope) {
    return function(opId) {
        return function(state) {
            return $4b57a9a20c626e9f$var$isLatestOperation(scope)(opId)(state) && $fb0451ff9e33ce13$export$6bed92fff59224d8(state.operations)(opId);
        };
    };
};
var $4b57a9a20c626e9f$var$invalidatesStep1SearchDebounce = function(v) {
    if (v instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && v.value0 instanceof $cc65e4880038a74f$export$f9a329ae029c9889) return false;
    return true;
};
var $4b57a9a20c626e9f$var$hasHydrateCommand = /* #__PURE__ */ function() {
    var isHydrate = function(v) {
        if (v instanceof $4b57a9a20c626e9f$export$d1cc75e80b20eeaf) return true;
        return false;
    };
    return $396c4c3d9e7fae3c$export$4154a199d7d90455(isHydrate);
}();
var $4b57a9a20c626e9f$var$exitToHome = function(state) {
    var editedDocumentIds = $4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })(state.workQueueState.editDocs);
    var defTeacher = $4b57a9a20c626e9f$var$map1(function(v) {
        return v.value;
    })(state.workQueueCache.defTeacher);
    var defSemester = $4b57a9a20c626e9f$var$map1(function(v) {
        return v.value;
    })(state.workQueueCache.defSemester);
    var createdDocumentIds = $4b57a9a20c626e9f$var$map(function(v) {
        return v.id;
    })($4b57a9a20c626e9f$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(state.workQueueState.documents)));
    return $80445329d31df9ca$export$86748c9113edb676($994495db3cff0a67$export$317e7082611cb548.value)({
        route: state.route,
        step: state.step,
        workQueueCache: state.workQueueCache,
        pushStateInterface: state.pushStateInterface,
        operations: state.operations,
        step1: state.step1,
        step2A: state.step2A,
        step2B: state.step2B,
        step3: state.step3,
        routeVersion: state.routeVersion,
        workQueueState: $6be45a9e147fc393$export$cc02fd03d27c010f(defTeacher)(defSemester)(state.workQueueState),
        workQueueUi: $288f947f09d2f062$export$9b7fd77b33289379(state.workQueueCache.defTeacher)(state.workQueueCache.defSemester)(state.workQueueUi),
        preselectForms: $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$append(editedDocumentIds)(createdDocumentIds))
    });
};
var $4b57a9a20c626e9f$var$finishStepNavigation = function(state) {
    if (state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) return $80445329d31df9ca$export$86748c9113edb676(function() {
        var $262 = $ea3eb84de0acf574$export$dd1bc94b04021eeb(state.workQueueState.forms.sel);
        if ($262) return $994495db3cff0a67$export$d80ca78eabef93e4.value;
        return $994495db3cff0a67$export$d8ccc25b3be9c9d7.value;
    }())(state);
    if (state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) return $80445329d31df9ca$export$86748c9113edb676(function() {
        var $263 = $4b57a9a20c626e9f$var$isEmpty(state.workQueueState.students);
        if ($263) return $994495db3cff0a67$export$d02ce3ec9b5b8f12.value;
        return $994495db3cff0a67$export$d8ccc25b3be9c9d7.value;
    }())(state);
    if (state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return $4b57a9a20c626e9f$var$exitToHome(state);
    if (state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return $4b57a9a20c626e9f$var$exitToHome(state);
    return state;
};
var $4b57a9a20c626e9f$var$currentRouteForState = function(state) {
    return function(locationState) {
        var loadingRouteFallback = function() {
            if (state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return $4b57a9a20c626e9f$var$loadingStep3Route(locationState)(state.workQueueState);
            return $daa993e9fe4182d9$export$96ba27ab48ad90aa(locationState)(state.step)(state.workQueueState);
        }();
        if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
            preservedQuery: $daa993e9fe4182d9$export$11c97f589579967b(locationState.search),
            activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(state.step3.value0.editor.fillState.doc.id),
            docs: $4b57a9a20c626e9f$var$nub($4b57a9a20c626e9f$var$step3DocIds(state.step3.value0)),
            section: state.step3.value0.editor.sectionIntent
        });
        if (state.step3 instanceof $80445329d31df9ca$export$52520e6e1d2bce34) return loadingRouteFallback;
        if (state.step3 instanceof $80445329d31df9ca$export$b87e8303844f9049) return loadingRouteFallback;
        return $daa993e9fe4182d9$export$96ba27ab48ad90aa(locationState)(state.step)(state.workQueueState);
    };
};
var $4b57a9a20c626e9f$var$browserRouteStep3Result = function(result) {
    var updateTransitionState = function(editor) {
        return {
            activeSection: editor.activeSection,
            anchor: editor.anchor,
            fillState: editor.fillState,
            position: editor.position,
            queue: editor.queue,
            sectionIntent: editor.sectionIntent,
            workQueueCache: editor.workQueueCache,
            workQueueState: editor.workQueueState,
            workQueueUi: editor.workQueueUi,
            transitionState: {
                active: editor.transitionState.active,
                nextGeneration: editor.transitionState.nextGeneration,
                latest: $4b57a9a20c626e9f$var$map1(function(pending) {
                    return {
                        anchor: pending.anchor,
                        generation: pending.generation,
                        position: pending.position,
                        historyMode: $59a05a7e29977bc8$export$7bdb1b708831338.value
                    };
                })(editor.transitionState.latest)
            }
        };
    };
    var updateCommand = function(v) {
        if (v instanceof $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7) return new $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7($59a05a7e29977bc8$export$7bdb1b708831338.value);
        return v;
    };
    return {
        state: $842627c31b5244a8$export$efb563a7c7e3f705(updateTransitionState)(result.state),
        commands: $4b57a9a20c626e9f$var$map(updateCommand)(result.commands)
    };
};
var $4b57a9a20c626e9f$var$applyStep2OperationStartPolicy = function(kind) {
    return function(state) {
        return $396c4c3d9e7fae3c$export$50ae948ca12cdcbc(function(acc) {
            return function(scope) {
                return $4b57a9a20c626e9f$var$supersedeLatestActiveInScope(scope)(acc);
            };
        })(state)($4b57a9a20c626e9f$var$supersededScopesForStep2Operation(kind));
    };
};
var $4b57a9a20c626e9f$var$scheduleStep2BootstrapOps = function(result) {
    if (result.state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12 && $4b57a9a20c626e9f$var$hasHydrateCommand(result.commands)) return result;
    if (result.state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) {
        if (result.state.step2A instanceof $80445329d31df9ca$export$adf38f4e421177a0 && result.state.step2A.value0.opId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            var nextState = $4b57a9a20c626e9f$var$applyStep2OperationStartPolicy($a8c8b5353c92bbbb$export$a5e6aa3b372c16a0.value)(result.state);
            var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step1: nextState.step1,
                    step2B: nextState.step2B,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step2A: new $80445329d31df9ca$export$adf38f4e421177a0({
                        workQueueState: result.state.step2A.value0.workQueueState,
                        workQueueCache: result.state.step2A.value0.workQueueCache,
                        opId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                    })
                },
                commands: $4b57a9a20c626e9f$var$append(result.commands)([
                    new $4b57a9a20c626e9f$export$a7960d0bb7149c3e(v.value0, result.state.step2A.value0.workQueueState, result.state.step2A.value0.workQueueCache)
                ])
            };
        }
        return result;
    }
    if (result.state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4 && $4b57a9a20c626e9f$var$hasHydrateCommand(result.commands)) return result;
    if (result.state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) {
        if (result.state.step2B instanceof $80445329d31df9ca$export$851fbd25481b6c25 && result.state.step2B.value0.opId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            var nextState = $4b57a9a20c626e9f$var$applyStep2OperationStartPolicy($a8c8b5353c92bbbb$export$cf485ac8aca10137.value)(result.state);
            var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step1: nextState.step1,
                    step2A: nextState.step2A,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step2B: new $80445329d31df9ca$export$851fbd25481b6c25({
                        workQueueState: result.state.step2B.value0.workQueueState,
                        workQueueUi: result.state.step2B.value0.workQueueUi,
                        workQueueCache: result.state.step2B.value0.workQueueCache,
                        opId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                    })
                },
                commands: $4b57a9a20c626e9f$var$append(result.commands)([
                    new $4b57a9a20c626e9f$export$909fe2fc390dacb8(v.value0, result.state.step2B.value0.workQueueState, result.state.step2B.value0.workQueueUi, result.state.step2B.value0.workQueueCache)
                ])
            };
        }
        return result;
    }
    return $4b57a9a20c626e9f$var$scheduleStep3BootstrapOps(result);
};
var $4b57a9a20c626e9f$var$startStep2ExportAll = function(result) {
    if ($fb0451ff9e33ce13$export$e2db8f1c2b895a63(result.state.operations)($a8c8b5353c92bbbb$export$87c4c62ae2426f3d.value)) return result;
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
        var nextState = $4b57a9a20c626e9f$var$applyStep2OperationStartPolicy($a8c8b5353c92bbbb$export$beefc18c38a3140b.value)(result.state);
        var v = $fb0451ff9e33ce13$export$97e9c35782480a5($a8c8b5353c92bbbb$export$beefc18c38a3140b.value)($06733ae99ed4f534$export$bebe9059409a0d04.value)(nextState.operations);
        return {
            state: {
                route: nextState.route,
                step: nextState.step,
                workQueueState: nextState.workQueueState,
                workQueueUi: nextState.workQueueUi,
                workQueueCache: nextState.workQueueCache,
                preselectForms: nextState.preselectForms,
                pushStateInterface: nextState.pushStateInterface,
                step1: nextState.step1,
                step2A: nextState.step2A,
                step2B: nextState.step2B,
                step3: nextState.step3,
                routeVersion: nextState.routeVersion,
                operations: v.value1
            },
            commands: $4b57a9a20c626e9f$var$append(result.commands)([
                new $4b57a9a20c626e9f$export$e2233cf4256bed98(v.value0, nextState.workQueueState, nextState.workQueueCache)
            ])
        };
    }
    throw new Error("Failed pattern match at App.Update (line 594, column 1 - line 594, column 52): " + [
        result.constructor.name
    ]);
};
var $4b57a9a20c626e9f$var$applyStep1OperationStartPolicy = function(kind) {
    return function(state) {
        return $396c4c3d9e7fae3c$export$50ae948ca12cdcbc(function(acc) {
            return function(scope) {
                return $4b57a9a20c626e9f$var$supersedeLatestActiveInScope(scope)(acc);
            };
        })(state)($4b57a9a20c626e9f$var$supersededScopesForStep1Operation(kind));
    };
};
var $4b57a9a20c626e9f$var$scheduleBootstrapOps = function(result) {
    if (result.state.step instanceof $994495db3cff0a67$export$317e7082611cb548 && $4b57a9a20c626e9f$var$hasHydrateCommand(result.commands)) return result;
    if (result.state.step instanceof $994495db3cff0a67$export$317e7082611cb548) {
        if (result.state.step1 instanceof $80445329d31df9ca$export$9787b7e6f37d414e && result.state.step1.value0.opId instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
            var nextState = $4b57a9a20c626e9f$var$applyStep1OperationStartPolicy($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(result.state);
            var v = $fb0451ff9e33ce13$export$c9a071778b2d670f(nextState.operations);
            return {
                state: {
                    route: nextState.route,
                    step: nextState.step,
                    workQueueState: nextState.workQueueState,
                    workQueueUi: nextState.workQueueUi,
                    workQueueCache: nextState.workQueueCache,
                    preselectForms: nextState.preselectForms,
                    pushStateInterface: nextState.pushStateInterface,
                    step2A: nextState.step2A,
                    step2B: nextState.step2B,
                    step3: nextState.step3,
                    routeVersion: nextState.routeVersion,
                    operations: v.value1,
                    step1: new $80445329d31df9ca$export$9787b7e6f37d414e({
                        init: result.state.step1.value0.init,
                        opId: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0)
                    })
                },
                commands: $4b57a9a20c626e9f$var$append(result.commands)([
                    new $4b57a9a20c626e9f$export$f68485a1a0d25ba8(v.value0, result.state.step1.value0.init)
                ])
            };
        }
        return $4b57a9a20c626e9f$var$scheduleStep2BootstrapOps(result);
    }
    return $4b57a9a20c626e9f$var$scheduleStep2BootstrapOps(result);
};
var $4b57a9a20c626e9f$export$36aff1fbb4f5dfc6 = function(state) {
    return $4b57a9a20c626e9f$var$scheduleBootstrapOps({
        state: state,
        commands: []
    });
};
var $4b57a9a20c626e9f$var$startStep1Operation = function(kind) {
    return function(mkCommand) {
        return function(prepare) {
            return function(result) {
                if (result.state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                    var nextState = $4b57a9a20c626e9f$var$applyStep1OperationStartPolicy(kind)(result.state);
                    var v = $fb0451ff9e33ce13$export$97e9c35782480a5(kind)($06733ae99ed4f534$export$bebe9059409a0d04.value)(nextState.operations);
                    var nextReady = $506e78fa6ac73d88$export$fea330ef6103f535(prepare(result.state.step1.value0));
                    return {
                        state: $4b57a9a20c626e9f$var$setStep1Ready(nextReady)({
                            route: nextState.route,
                            step: nextState.step,
                            workQueueState: nextState.workQueueState,
                            workQueueUi: nextState.workQueueUi,
                            workQueueCache: nextState.workQueueCache,
                            preselectForms: nextState.preselectForms,
                            pushStateInterface: nextState.pushStateInterface,
                            step1: nextState.step1,
                            step2A: nextState.step2A,
                            step2B: nextState.step2B,
                            step3: nextState.step3,
                            routeVersion: nextState.routeVersion,
                            operations: v.value1
                        }),
                        commands: $4b57a9a20c626e9f$var$append(result.commands)([
                            mkCommand(v.value0)(nextReady)
                        ])
                    };
                }
                return result;
            };
        };
    };
};
var $4b57a9a20c626e9f$var$applyRuntimeNavigation = function(nav) {
    return function(state) {
        if (nav instanceof $994495db3cff0a67$export$9807628a98dc6165) return {
            state: $4b57a9a20c626e9f$var$finishStepNavigation(state),
            shouldSyncRoute: true
        };
        if (nav instanceof $994495db3cff0a67$export$635e3e065a143ae6) return {
            state: $4b57a9a20c626e9f$var$exitToHome(state),
            shouldSyncRoute: true
        };
        if (nav instanceof $994495db3cff0a67$export$d0b167d54f100778) return {
            state: $80445329d31df9ca$export$86748c9113edb676(nav.value0)(state),
            shouldSyncRoute: true
        };
        throw new Error("Failed pattern match at App.Update (line 1165, column 36 - line 1179, column 10): " + [
            nav.constructor.name
        ]);
    };
};
var $4b57a9a20c626e9f$var$appendCommand = function(command) {
    return function(result) {
        return {
            state: result.state,
            commands: $4b57a9a20c626e9f$var$append(result.commands)([
                command
            ])
        };
    };
};
var $4b57a9a20c626e9f$var$allowStep1Message = {
    blockedByLoading: false,
    blockedByScopes: []
};
var $4b57a9a20c626e9f$var$step1MessagePolicy = function(msg) {
    if ($4b57a9a20c626e9f$var$isStep1RecentFormsReloadMsg(msg)) return {
        blockedByLoading: false,
        blockedByScopes: $4b57a9a20c626e9f$var$step1BlockingOperationScopes
    };
    if ($4b57a9a20c626e9f$var$isStep1CreateFormsMsg(msg)) return {
        blockedByLoading: false,
        blockedByScopes: $4b57a9a20c626e9f$var$step1BlockingOperationScopes
    };
    if ($4b57a9a20c626e9f$var$isStep1DocumentMutationMsg(msg)) return {
        blockedByLoading: true,
        blockedByScopes: [
            $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value
        ]
    };
    if ($4b57a9a20c626e9f$var$isStep1FormOrderMsg(msg)) return {
        blockedByLoading: false,
        blockedByScopes: [
            $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value
        ]
    };
    if ($4b57a9a20c626e9f$var$isStep1GlobalActionMsg(msg)) return {
        blockedByLoading: false,
        blockedByScopes: [
            $a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value
        ]
    };
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $4b57a9a20c626e9f$var$allowStep1Message;
    throw new Error("Failed pattern match at App.Update (line 814, column 1 - line 814, column 54): " + [
        msg.constructor.name
    ]);
};
var $4b57a9a20c626e9f$var$shouldBlockStep1Message = function(ready) {
    return function(msg) {
        return function(state) {
            var policy = $4b57a9a20c626e9f$var$step1MessagePolicy(msg);
            return policy.blockedByLoading && $4b57a9a20c626e9f$var$isStep1Loading(ready) || $396c4c3d9e7fae3c$export$4154a199d7d90455($fb0451ff9e33ce13$export$e2db8f1c2b895a63(state.operations))(policy.blockedByScopes);
        };
    };
};
var $4b57a9a20c626e9f$var$advanceRouteVersion = function(state) {
    return {
        route: state.route,
        step: state.step,
        workQueueState: state.workQueueState,
        workQueueUi: state.workQueueUi,
        workQueueCache: state.workQueueCache,
        preselectForms: state.preselectForms,
        pushStateInterface: state.pushStateInterface,
        operations: state.operations,
        step1: state.step1,
        step2A: state.step2A,
        step2B: state.step2B,
        step3: state.step3,
        routeVersion: state.routeVersion + 1 | 0
    };
};
var $4b57a9a20c626e9f$var$appendRouteCommand = function(command) {
    return function(result) {
        return $4b57a9a20c626e9f$var$appendCommand(command)({
            commands: result.commands,
            state: $4b57a9a20c626e9f$var$advanceRouteVersion(result.state)
        });
    };
};
var $4b57a9a20c626e9f$var$applyStep1RuntimeNavigation = function(step) {
    return function(prepare) {
        return function(result) {
            var state = $4b57a9a20c626e9f$var$supersedeLatestActiveInScope($a8c8b5353c92bbbb$export$f0780570fbaaaac3.value)(result.state);
            var nextState = $4b57a9a20c626e9f$var$advanceRouteVersion($80445329d31df9ca$export$86748c9113edb676(step)(prepare(state)));
            return {
                state: nextState,
                commands: $4b57a9a20c626e9f$var$append(result.commands)([
                    new $4b57a9a20c626e9f$export$43846ecbea5b4cd7($80445329d31df9ca$export$b7b72b4685ba4f49.value)
                ])
            };
        };
    };
};
var $4b57a9a20c626e9f$var$applyStep1CreateForms = function(ready) {
    var teacherSelected = $06733ae99ed4f534$export$c15bd07a493e1236(ready.formPicker.workQueueState.teacher);
    var isStudent = $4b57a9a20c626e9f$var$eq3(ready.formPicker.workQueueCache.account.type)($02eacf321b2a2128$export$98e21ef3f6f7703b.value);
    var selectSelf = function(v) {
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && isStudent) return $4b57a9a20c626e9f$var$select$prime(v.value0)(ready.formPicker.workQueueState.students);
        return ready.formPicker.workQueueState.students;
    };
    var formsSelected = !$4b57a9a20c626e9f$var$isEmpty(ready.formPicker.workQueueState.forms);
    var nextStep = function() {
        if (isStudent) {
            var $313 = formsSelected && teacherSelected;
            if ($313) return $994495db3cff0a67$export$d8ccc25b3be9c9d7.value;
            return $994495db3cff0a67$export$d80ca78eabef93e4.value;
        }
        return $994495db3cff0a67$export$d02ce3ec9b5b8f12.value;
    }();
    return $4b57a9a20c626e9f$var$applyStep1RuntimeNavigation(nextStep)(function(state) {
        return {
            route: state.route,
            step: state.step,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: {
                forms: ready.formPicker.workQueueState.forms,
                documents: ready.formPicker.workQueueState.documents,
                editDocs: ready.formPicker.workQueueState.editDocs,
                currentDoc: ready.formPicker.workQueueState.currentDoc,
                semester: ready.formPicker.workQueueState.semester,
                teacher: ready.formPicker.workQueueState.teacher,
                students: selectSelf(ready.formPicker.workQueueCache.account.student)
            },
            workQueueUi: {
                expandedStudents: ready.formPicker.workQueueUi.expandedStudents,
                teacher: ready.formPicker.workQueueUi.teacher,
                semester: ready.formPicker.workQueueUi.semester,
                search: ready.searchState
            },
            workQueueCache: ready.formPicker.workQueueCache
        };
    });
};
var $4b57a9a20c626e9f$var$applyStep1EditDocument = function(doc) {
    var editWorkQueue = function(docs) {
        return function(workQueue) {
            return $6be45a9e147fc393$export$a871627eddff2fcf($6be45a9e147fc393$export$9b8479ea7cb2aaa7(workQueue)(docs))(new $06733ae99ed4f534$export$8a67b48435b5d073({
                formId: doc.form_type.id,
                studentId: doc.student.id,
                documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(doc.id)
            }));
        };
    };
    return $4b57a9a20c626e9f$var$applyStep1RuntimeNavigation($994495db3cff0a67$export$d8ccc25b3be9c9d7.value)(function(state) {
        return {
            route: state.route,
            step: state.step,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: editWorkQueue([
                doc
            ])(state.workQueueState)
        };
    });
};
var $4b57a9a20c626e9f$var$applyStep1EditDocuments = function(ready) {
    var selected = $506e78fa6ac73d88$export$c1853cad74b031d9(ready);
    var current = $4b57a9a20c626e9f$var$map1(function(doc) {
        return {
            formId: doc.form_type.id,
            studentId: doc.student.id,
            documentId: new $06733ae99ed4f534$export$8a67b48435b5d073(doc.id)
        };
    })($396c4c3d9e7fae3c$export$5fd5031fecdacec3(selected));
    return $4b57a9a20c626e9f$var$applyStep1RuntimeNavigation($994495db3cff0a67$export$d8ccc25b3be9c9d7.value)(function(state) {
        return {
            route: state.route,
            step: state.step,
            workQueueUi: state.workQueueUi,
            workQueueCache: state.workQueueCache,
            preselectForms: state.preselectForms,
            pushStateInterface: state.pushStateInterface,
            operations: state.operations,
            step1: state.step1,
            step2A: state.step2A,
            step2B: state.step2B,
            step3: state.step3,
            routeVersion: state.routeVersion,
            workQueueState: $6be45a9e147fc393$export$a871627eddff2fcf($6be45a9e147fc393$export$9b8479ea7cb2aaa7(state.workQueueState)(selected))(current)
        };
    });
};
var $4b57a9a20c626e9f$var$applyStep2Navigation = function(nav) {
    return function(state) {
        return function(result) {
            var transition = $4b57a9a20c626e9f$var$applyRuntimeNavigation(nav)(state);
            var nextState = function() {
                if (transition.shouldSyncRoute) return $4b57a9a20c626e9f$var$advanceRouteVersion(transition.state);
                return transition.state;
            }();
            return {
                state: nextState,
                commands: function() {
                    if (transition.shouldSyncRoute) return $4b57a9a20c626e9f$var$append(result.commands)([
                        new $4b57a9a20c626e9f$export$43846ecbea5b4cd7($80445329d31df9ca$export$b7b72b4685ba4f49.value)
                    ]);
                    return result.commands;
                }()
            };
        };
    };
};
var $4b57a9a20c626e9f$var$applyStep2AAction = function(ready) {
    return function(action) {
        return function(result) {
            if (action instanceof $85206166a57f2888$export$5737e0a77055e89d) {
                var nextState = {
                    operations: result.state.operations,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    route: result.state.route,
                    routeVersion: result.state.routeVersion,
                    step: result.state.step,
                    step1: result.state.step1,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    workQueueCache: result.state.workQueueCache,
                    workQueueUi: result.state.workQueueUi,
                    workQueueState: {
                        currentDoc: result.state.workQueueState.currentDoc,
                        documents: result.state.workQueueState.documents,
                        editDocs: result.state.workQueueState.editDocs,
                        forms: result.state.workQueueState.forms,
                        semester: result.state.workQueueState.semester,
                        teacher: result.state.workQueueState.teacher,
                        students: action.value0.students
                    },
                    step2A: new $80445329d31df9ca$export$b6b6ceaf3ddf8f7c(action.value0)
                };
                return {
                    commands: result.commands,
                    state: nextState
                };
            }
            if (action instanceof $85206166a57f2888$export$90368da438a1001a && action.value0 instanceof $356f5ce902fa042d$export$a80f920dd4c867c2) return {
                commands: result.commands,
                state: {
                    route: result.state.route,
                    step: result.state.step,
                    workQueueState: result.state.workQueueState,
                    workQueueCache: result.state.workQueueCache,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    operations: result.state.operations,
                    step1: result.state.step1,
                    step2A: result.state.step2A,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    routeVersion: result.state.routeVersion,
                    workQueueUi: action.value0.value0
                }
            };
            if (action instanceof $85206166a57f2888$export$90368da438a1001a) return result;
            if (action instanceof $85206166a57f2888$export$8750abbd34e770e0) return {
                commands: result.commands,
                state: {
                    route: result.state.route,
                    step: result.state.step,
                    workQueueCache: result.state.workQueueCache,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    operations: result.state.operations,
                    step1: result.state.step1,
                    step2A: result.state.step2A,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    routeVersion: result.state.routeVersion,
                    workQueueState: action.value0,
                    workQueueUi: action.value1
                }
            };
            if (action instanceof $85206166a57f2888$export$7fe28cb29e71bf10 && $6be45a9e147fc393$export$fce9b5fa170e923f(result.state.workQueueCache.account)(result.state.workQueueState)) return $4b57a9a20c626e9f$var$applyStep2Navigation($994495db3cff0a67$export$9807628a98dc6165.value)(result.state)(result);
            if (action instanceof $85206166a57f2888$export$7fe28cb29e71bf10) return {
                commands: result.commands,
                state: {
                    route: result.state.route,
                    step: result.state.step,
                    workQueueState: result.state.workQueueState,
                    workQueueUi: result.state.workQueueUi,
                    workQueueCache: result.state.workQueueCache,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    operations: result.state.operations,
                    step1: result.state.step1,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    routeVersion: result.state.routeVersion,
                    step2A: new $80445329d31df9ca$export$b6b6ceaf3ddf8f7c({
                        page: ready.page,
                        students: ready.students,
                        search: ready.search,
                        status: ready.status,
                        account: ready.account,
                        msg: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("must-select-teacher-semester"))
                    })
                }
            };
            if (action instanceof $85206166a57f2888$export$848c9b7ead0df967) return $4b57a9a20c626e9f$var$applyStep2Navigation($994495db3cff0a67$export$635e3e065a143ae6.value)(result.state)(result);
            if (action instanceof $85206166a57f2888$export$f883e605db67eacf && $6be45a9e147fc393$export$fce9b5fa170e923f(result.state.workQueueCache.account)(result.state.workQueueState)) return $4b57a9a20c626e9f$var$startStep2ExportAll(result);
            if (action instanceof $85206166a57f2888$export$f883e605db67eacf) return {
                commands: result.commands,
                state: {
                    route: result.state.route,
                    step: result.state.step,
                    workQueueState: result.state.workQueueState,
                    workQueueUi: result.state.workQueueUi,
                    workQueueCache: result.state.workQueueCache,
                    preselectForms: result.state.preselectForms,
                    pushStateInterface: result.state.pushStateInterface,
                    operations: result.state.operations,
                    step1: result.state.step1,
                    step2B: result.state.step2B,
                    step3: result.state.step3,
                    routeVersion: result.state.routeVersion,
                    step2A: new $80445329d31df9ca$export$b6b6ceaf3ddf8f7c({
                        page: ready.page,
                        students: ready.students,
                        search: ready.search,
                        status: ready.status,
                        account: ready.account,
                        msg: new $06733ae99ed4f534$export$8a67b48435b5d073($c3328e54cdf5154c$export$5a1a8430df9521e("must-select-teacher-semester"))
                    })
                }
            };
            throw new Error("Failed pattern match at App.Update (line 513, column 41 - line 543, column 139): " + [
                action.constructor.name
            ]);
        };
    };
};
var $4b57a9a20c626e9f$var$applyStep2BAction = function(ready) {
    return function(action) {
        return function(result) {
            if (action instanceof $812fcffca6747f78$export$7254cc27399e90bd) return {
                commands: result.commands,
                state: $4b57a9a20c626e9f$var$syncStep2BState(result.state)(action.value0)
            };
            if (action instanceof $812fcffca6747f78$export$ca087a5c96095431 && action.value0 instanceof $356f5ce902fa042d$export$a80f920dd4c867c2) return {
                commands: result.commands,
                state: $4b57a9a20c626e9f$var$syncStep2BState(result.state)({
                    forms: ready.forms,
                    workQueueState: ready.workQueueState,
                    workQueueCache: ready.workQueueCache,
                    reorder: ready.reorder,
                    movedDownIdx: ready.movedDownIdx,
                    workQueueUi: action.value0.value0
                })
            };
            if (action instanceof $812fcffca6747f78$export$ca087a5c96095431) return result;
            if (action instanceof $812fcffca6747f78$export$444b3ab0cb9aec40 && action.value0 instanceof $994495db3cff0a67$export$9807628a98dc6165 && !$6be45a9e147fc393$export$fce9b5fa170e923f(ready.workQueueCache.account)(ready.workQueueState)) return result;
            if (action instanceof $812fcffca6747f78$export$444b3ab0cb9aec40) return $4b57a9a20c626e9f$var$applyStep2Navigation(action.value0)($4b57a9a20c626e9f$var$syncStep2BState(result.state)(ready))(result);
            if (action instanceof $812fcffca6747f78$export$f883e605db67eacf && $6be45a9e147fc393$export$fce9b5fa170e923f(ready.workQueueCache.account)(ready.workQueueState)) return $4b57a9a20c626e9f$var$startStep2ExportAll({
                commands: result.commands,
                state: $4b57a9a20c626e9f$var$syncStep2BState(result.state)(ready)
            });
            if (action instanceof $812fcffca6747f78$export$f883e605db67eacf) return result;
            throw new Error("Failed pattern match at App.Update (line 546, column 41 - line 566, column 15): " + [
                action.constructor.name
            ]);
        };
    };
};
var $4b57a9a20c626e9f$var$applyStep3Command = function(result) {
    return function(v) {
        if (v instanceof $7b9d021f8fc5e8ea$export$43846ecbea5b4cd7) return $4b57a9a20c626e9f$var$appendRouteCommand(new $4b57a9a20c626e9f$export$1f0c59144b57f59f(v.value0))(result);
        if (v instanceof $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214) {
            if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $4b57a9a20c626e9f$var$startStep3Operation(new $7b9d021f8fc5e8ea$export$5d70f0c28ff9f214(v.value0))(new $a8c8b5353c92bbbb$export$b49857229320d04d(result.state.step3.value0.editor.fillState.doc.id))(v.value0)(function(opId) {
                return new $4b57a9a20c626e9f$export$c2e797ca28b02c81(opId, new $a8c8b5353c92bbbb$export$b49857229320d04d(result.state.step3.value0.editor.fillState.doc.id), v.value0);
            })(result);
            return result;
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$432d51bdca810dfc) {
            if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) {
                var prepared = $842627c31b5244a8$export$11c6c29bd74a41f5(v.value0)(result.state.step3.value0);
                return $4b57a9a20c626e9f$var$startStep3Operation(new $7b9d021f8fc5e8ea$export$432d51bdca810dfc(v.value0))($842627c31b5244a8$export$1643e1ff55422bba(prepared))(new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.generation))(function(opId) {
                    return new $4b57a9a20c626e9f$export$a5e3e4d00fc363bf(opId, $842627c31b5244a8$export$1643e1ff55422bba(prepared), v.value0);
                })(result);
            }
            return result;
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$93fbe371f495cba9) {
            if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $4b57a9a20c626e9f$var$startStep3Operation(new $7b9d021f8fc5e8ea$export$93fbe371f495cba9(v.value0))(new $a8c8b5353c92bbbb$export$790d8b2b1da998c3(result.state.step3.value0.editor.fillState.doc.id))($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(opId) {
                return new $4b57a9a20c626e9f$export$7540d7178b14245f(opId, new $a8c8b5353c92bbbb$export$790d8b2b1da998c3(result.state.step3.value0.editor.fillState.doc.id), v.value0);
            })(result);
            return result;
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$cca72c408b5f0a32) {
            if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $4b57a9a20c626e9f$var$startStep3Operation($7b9d021f8fc5e8ea$export$cca72c408b5f0a32.value)(new $a8c8b5353c92bbbb$export$d5cd1cc1db16aadd(result.state.step3.value0.editor.fillState.doc.id))($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(opId) {
                return new $4b57a9a20c626e9f$export$b1d3326fcab09462(opId, new $a8c8b5353c92bbbb$export$d5cd1cc1db16aadd(result.state.step3.value0.editor.fillState.doc.id));
            })(result);
            return result;
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4) {
            if (result.state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) {
                var kind = $4b57a9a20c626e9f$var$step3DocumentMutationOperationKind(result.state.step3.value0.editor.fillState.doc.id)(v.value0);
                return $4b57a9a20c626e9f$var$startStep3Operation(new $7b9d021f8fc5e8ea$export$3f06c11ee1d96ef4(v.value0))(kind)($06733ae99ed4f534$export$bebe9059409a0d04.value)(function(opId) {
                    return new $4b57a9a20c626e9f$export$f515a058fe9fca3a(opId, kind, v.value0);
                })(result);
            }
            return result;
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$feff782b5e0b62d7) return $4b57a9a20c626e9f$var$appendCommand($4b57a9a20c626e9f$export$5cbca665f928318b.value)(result);
        if (v instanceof $7b9d021f8fc5e8ea$export$88c8c40786b3927b) return $4b57a9a20c626e9f$var$appendCommand($4b57a9a20c626e9f$export$88c8c40786b3927b.value)(result);
        if (v instanceof $7b9d021f8fc5e8ea$export$4bb7762331f161c2) return $4b57a9a20c626e9f$var$appendCommand($4b57a9a20c626e9f$export$4bb7762331f161c2.value)(result);
        if (v instanceof $7b9d021f8fc5e8ea$export$96c159224a0db784) return $4b57a9a20c626e9f$var$appendCommand(new $4b57a9a20c626e9f$export$96c159224a0db784(v.value0))(result);
        if (v instanceof $7b9d021f8fc5e8ea$export$444b3ab0cb9aec40) {
            var currentState = {
                operations: result.state.operations,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                route: result.state.route,
                routeVersion: result.state.routeVersion,
                step: result.state.step,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                step3: result.state.step3,
                workQueueState: $4b57a9a20c626e9f$var$step3WorkQueueState(result.state),
                workQueueUi: $4b57a9a20c626e9f$var$step3WorkQueueUi(result.state),
                workQueueCache: $4b57a9a20c626e9f$var$step3WorkQueueCache(result.state)
            };
            var transition = $4b57a9a20c626e9f$var$applyRuntimeNavigation(v.value0)(currentState);
            var nextState = function() {
                if (transition.shouldSyncRoute) return $4b57a9a20c626e9f$var$advanceRouteVersion(transition.state);
                return transition.state;
            }();
            return {
                state: nextState,
                commands: function() {
                    if (transition.shouldSyncRoute) return $4b57a9a20c626e9f$var$append(result.commands)([
                        new $4b57a9a20c626e9f$export$43846ecbea5b4cd7($80445329d31df9ca$export$b7b72b4685ba4f49.value)
                    ]);
                    return result.commands;
                }()
            };
        }
        if (v instanceof $7b9d021f8fc5e8ea$export$479877330b97c10b) return {
            commands: result.commands,
            state: {
                route: result.state.route,
                step: result.state.step,
                workQueueState: result.state.workQueueState,
                workQueueUi: result.state.workQueueUi,
                workQueueCache: result.state.workQueueCache,
                preselectForms: result.state.preselectForms,
                pushStateInterface: result.state.pushStateInterface,
                step1: result.state.step1,
                step2A: result.state.step2A,
                step2B: result.state.step2B,
                step3: result.state.step3,
                routeVersion: result.state.routeVersion,
                operations: $fb0451ff9e33ce13$export$f92ca06486a47b7a(v.value0)(result.state.operations)
            }
        };
        throw new Error("Failed pattern match at App.Update (line 1003, column 28 - line 1092, column 109): " + [
            v.constructor.name
        ]);
    };
};
var $4b57a9a20c626e9f$var$applyStep3Commands = /* #__PURE__ */ $4fe7b6acfba7f29f$export$50ae948ca12cdcbc($4fe7b6acfba7f29f$export$e97014618a7eb593)($4b57a9a20c626e9f$var$applyStep3Command);
var $4b57a9a20c626e9f$var$handleReadyStep3BrowserRoute = function(state) {
    return function(requested) {
        if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72 && requested instanceof $daa993e9fe4182d9$export$6fd638f4ca7cd326 && requested.value0.activeDoc instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var sectionAnchor = function(v) {
                if (v instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            };
            var normaliseStep3BrowserSection = function(v) {
                if (v instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return new $daa993e9fe4182d9$export$28a5869e6b717ab(v.value0);
                return $daa993e9fe4182d9$export$37a45811bf45ea95.value;
            };
            var maybeScrollStep3Commands = function(v) {
                if (v instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return [
                    new $4b57a9a20c626e9f$export$94d3e5d9ab92b4f9(v.value0)
                ];
                return [];
            };
            var handleKnownRoute = function(forceRouteReplace) {
                var $359 = $4b57a9a20c626e9f$var$eq(requested.value0.activeDoc.value0)(state.step3.value0.editor.fillState.doc.id);
                if ($359) {
                    var routeCommands = function() {
                        if (forceRouteReplace) return [
                            new $4b57a9a20c626e9f$export$1f0c59144b57f59f($59a05a7e29977bc8$export$7bdb1b708831338.value)
                        ];
                        return [];
                    }();
                    var nextSection = normaliseStep3BrowserSection(requested.value0.section);
                    var nextReady = {
                        autofillOperationId: state.step3.value0.autofillOperationId,
                        documentMutationOperationId: state.step3.value0.documentMutationOperationId,
                        loadOperationId: state.step3.value0.loadOperationId,
                        lockOperationId: state.step3.value0.lockOperationId,
                        pendingPostSave: state.step3.value0.pendingPostSave,
                        saveOperationId: state.step3.value0.saveOperationId,
                        editor: {
                            fillState: state.step3.value0.editor.fillState,
                            position: state.step3.value0.editor.position,
                            queue: state.step3.value0.editor.queue,
                            transitionState: state.step3.value0.editor.transitionState,
                            workQueueCache: state.step3.value0.editor.workQueueCache,
                            workQueueState: state.step3.value0.editor.workQueueState,
                            workQueueUi: state.step3.value0.editor.workQueueUi,
                            anchor: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                            activeSection: sectionAnchor(nextSection),
                            sectionIntent: nextSection
                        }
                    };
                    var $361 = $daa993e9fe4182d9$export$6d84eebdb90be73d(sectionAnchor(nextSection)) === $daa993e9fe4182d9$export$6d84eebdb90be73d(sectionAnchor(state.step3.value0.editor.sectionIntent));
                    if ($361) return $4b57a9a20c626e9f$var$pure(new $06733ae99ed4f534$export$8a67b48435b5d073({
                        state: state,
                        commands: routeCommands
                    }));
                    return $4b57a9a20c626e9f$var$pure(new $06733ae99ed4f534$export$8a67b48435b5d073({
                        state: $4b57a9a20c626e9f$var$syncReadyState(state)(nextReady),
                        commands: $4b57a9a20c626e9f$var$append(maybeScrollStep3Commands(nextSection))(routeCommands)
                    }));
                }
                var v = $4b57a9a20c626e9f$var$step3DocRouteIndex(state.step3.value0)(requested.value0.activeDoc.value0);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$bind($4b57a9a20c626e9f$var$map2($4b57a9a20c626e9f$var$browserRouteStep3Result)($7b9d021f8fc5e8ea$export$722fbec263ad908a(state.step3.value0)(new $7b9d021f8fc5e8ea$export$42eb94e8fee4f26d(new $004747e47cb4edd5$export$dfd508fe3dcbbd6c(v.value0, sectionAnchor(normaliseStep3BrowserSection(requested.value0.section)))))))(function(step3Result) {
                    return $4b57a9a20c626e9f$var$pure(new $06733ae99ed4f534$export$8a67b48435b5d073($4b57a9a20c626e9f$var$applyStep3Commands({
                        state: $4b57a9a20c626e9f$var$syncReadyState(state)(step3Result.state),
                        commands: []
                    })(step3Result.commands)));
                });
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4b57a9a20c626e9f$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                throw new Error("Failed pattern match at App.Update (line 1294, column 22 - line 1305, column 37): " + [
                    v.constructor.name
                ]);
            };
            var requestedDocIds = $4b57a9a20c626e9f$var$nub($396c4c3d9e7fae3c$export$8327ebbef2a0ba76(requested.value0.activeDoc.value0)(requested.value0.docs));
            var $364 = $4b57a9a20c626e9f$var$step3RequestedDocIdsMatch(state.step3.value0)(requestedDocIds);
            if ($364) return handleKnownRoute(false);
            var $365 = $396c4c3d9e7fae3c$export$84bf76cd7afc7469(function(docId$prime) {
                return $4b57a9a20c626e9f$var$elem(docId$prime)($4b57a9a20c626e9f$var$step3DocIds(state.step3.value0));
            })(requestedDocIds);
            if ($365) return handleKnownRoute(true);
            return $4b57a9a20c626e9f$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
        }
        return $4b57a9a20c626e9f$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
    };
};
var $4b57a9a20c626e9f$var$acceptStep1Message = function(ready) {
    return function(msg) {
        return function(result) {
            if ($4b57a9a20c626e9f$var$invalidatesStep1SearchDebounce(msg)) {
                var nextReady = {
                    formPicker: ready.formPicker,
                    recentForms: ready.recentForms,
                    searchState: ready.searchState,
                    selection: ready.selection,
                    state: ready.state,
                    searchVersion: ready.searchVersion + 1 | 0
                };
                return {
                    ready: nextReady,
                    result: {
                        commands: result.commands,
                        state: $4b57a9a20c626e9f$var$setStep1Ready(nextReady)(result.state)
                    }
                };
            }
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) return {
                ready: ready,
                result: result
            };
            throw new Error("Failed pattern match at App.Update (line 777, column 1 - line 781, column 66): " + [
                ready.constructor.name,
                msg.constructor.name,
                result.constructor.name
            ]);
        };
    };
};
var $4b57a9a20c626e9f$var$applyStep1Msg = function(ready0) {
    return function(msg) {
        return function(result0) {
            if ($4b57a9a20c626e9f$var$shouldBlockStep1Message(ready0)(msg)(result0.state)) return result0;
            if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                var accepted = $4b57a9a20c626e9f$var$acceptStep1Message(ready0)(msg)(result0);
                if (msg instanceof $cc65e4880038a74f$export$1111bee6585f0ea2) return {
                    commands: accepted.result.commands,
                    state: $4b57a9a20c626e9f$var$setStep1Ready({
                        recentForms: msg.value0.recentForms,
                        selection: msg.value0.selection,
                        searchState: msg.value0.searchState,
                        formPicker: msg.value0.formPicker,
                        state: msg.value0.state,
                        searchVersion: accepted.ready.searchVersion
                    })(accepted.result.state)
                };
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$f9a329ae029c9889) {
                    var nextState = $4b57a9a20c626e9f$var$supersedeLatestActiveInScope($a8c8b5353c92bbbb$export$f0780570fbaaaac3.value)(accepted.result.state);
                    var nextReady = $506e78fa6ac73d88$export$2088df704cfb48f3(msg.value0.value0)(accepted.ready);
                    return {
                        state: $4b57a9a20c626e9f$var$setStep1Ready(nextReady)(nextState),
                        commands: $4b57a9a20c626e9f$var$append(accepted.result.commands)([
                            new $4b57a9a20c626e9f$export$bfeffc9dfe6adcbc(nextReady.searchVersion)
                        ])
                    };
                }
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$60db918807a7b577 && msg.value0.value0.reorder) return {
                    commands: accepted.result.commands,
                    state: $4b57a9a20c626e9f$var$setStep1Ready({
                        recentForms: accepted.ready.recentForms,
                        selection: accepted.ready.selection,
                        searchState: accepted.ready.searchState,
                        state: accepted.ready.state,
                        searchVersion: accepted.ready.searchVersion,
                        formPicker: msg.value0.value0
                    })(accepted.result.state)
                };
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$60db918807a7b577) return $4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef(opId, nextReady);
                    };
                })(function(st) {
                    return {
                        recentForms: st.recentForms,
                        searchState: st.searchState,
                        state: st.state,
                        searchVersion: st.searchVersion,
                        formPicker: msg.value0.value0,
                        selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                    };
                })(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$13ea8ce0e2ccb998) return {
                    commands: accepted.result.commands,
                    state: $4b57a9a20c626e9f$var$setStep1Ready({
                        recentForms: accepted.ready.recentForms,
                        selection: accepted.ready.selection,
                        searchState: accepted.ready.searchState,
                        state: accepted.ready.state,
                        searchVersion: accepted.ready.searchVersion,
                        formPicker: $812fcffca6747f78$export$657a9ae17f440869(accepted.ready.formPicker)(true)
                    })(accepted.result.state)
                };
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$4474bd630dd3ef5b) return $4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$db10ae7477abb40b.value)(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$20cb2c62b285cf15(opId, nextReady);
                    };
                })(function(st) {
                    return {
                        recentForms: st.recentForms,
                        selection: st.selection,
                        searchState: st.searchState,
                        state: st.state,
                        searchVersion: st.searchVersion,
                        formPicker: {
                            forms: st.formPicker.forms,
                            workQueueState: st.formPicker.workQueueState,
                            workQueueUi: st.formPicker.workQueueUi,
                            workQueueCache: st.formPicker.workQueueCache,
                            reorder: st.formPicker.reorder,
                            movedDownIdx: $06733ae99ed4f534$export$bebe9059409a0d04.value
                        }
                    };
                })(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$d6d899291526e2a0) return $4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$614ed660100c3639(opId, nextReady, msg.value0.value0);
                    };
                })(function(st) {
                    return {
                        recentForms: st.recentForms,
                        searchState: st.searchState,
                        formPicker: st.formPicker,
                        state: st.state,
                        searchVersion: st.searchVersion,
                        selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                    };
                })(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$9cd64935e5cf264c && msg.value0.value0.legacy_url instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$appendCommand(new $4b57a9a20c626e9f$export$4aa34530d5f59077(msg.value0.value0.legacy_url.value0))(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$9cd64935e5cf264c) return $4b57a9a20c626e9f$var$applyStep1EditDocument(msg.value0.value0)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$9b7abee7a5a9421c) return $4b57a9a20c626e9f$var$applyStep1EditDocuments(accepted.ready)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$747c16e05a885c2a) {
                    var v = $cc65e4880038a74f$export$57ce4fcebb92740d(accepted.ready);
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return accepted.result;
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$58d3d305b67b6d53($506e78fa6ac73d88$export$d2afd53f9f0a26b(accepted.ready)))(function(opId) {
                        return function(nextReady) {
                            return new $4b57a9a20c626e9f$export$9b2b5e8a9dac051e(opId, nextReady);
                        };
                    })($4b57a9a20c626e9f$var$identity)(accepted.result);
                    throw new Error("Failed pattern match at App.Update (line 696, column 51 - line 704, column 23): " + [
                        v.constructor.name
                    ]);
                }
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$482dc0b98af7690c) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$a5b2acadcdb3baa4($506e78fa6ac73d88$export$d2afd53f9f0a26b(accepted.ready)))(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$882828c20d5c370f(opId, nextReady, msg.value0.value0);
                    };
                })($4b57a9a20c626e9f$var$identity)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$67e817d458d93d9f) return $4b57a9a20c626e9f$var$applyStep1CreateForms(accepted.ready)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$c7d83595be8c07b1) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$864b5c5b705745d2) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$efe0b24ea4d5137e) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$a96f88e1928d92fa && msg.value0 instanceof $cc65e4880038a74f$export$1d3f1ab8435af5a9) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$51b64cdb4a042e2f && msg.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$51b64cdb4a042e2f && msg.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$4606848e31468bbe($506e78fa6ac73d88$export$d2afd53f9f0a26b(accepted.ready)))(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$4f3ced6841ba7e93(opId, nextReady, $cc65e4880038a74f$export$3c5449791d1f24b2(accepted.ready)(msg.value0.value0));
                    };
                })($4b57a9a20c626e9f$var$identity)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$43d85b6b81ad99e0 && !msg.value0) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$43d85b6b81ad99e0 && msg.value0) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$ca6f6e5e77298091($506e78fa6ac73d88$export$d2afd53f9f0a26b(accepted.ready)))(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$b570b6d4d8a37ba(opId, nextReady);
                    };
                })($4b57a9a20c626e9f$var$identity)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$7183506d59c388b0 && msg.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                    commands: accepted.result.commands,
                    state: $4b57a9a20c626e9f$var$setStep1Ready({
                        recentForms: accepted.ready.recentForms,
                        searchState: accepted.ready.searchState,
                        formPicker: accepted.ready.formPicker,
                        state: accepted.ready.state,
                        searchVersion: accepted.ready.searchVersion,
                        selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                    })(accepted.result.state)
                };
                if (msg instanceof $cc65e4880038a74f$export$7183506d59c388b0 && msg.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$eb58b67453807721($4b57a9a20c626e9f$var$map(function(v) {
                    return v.docId;
                })(msg.value0.value0)))(function(opId) {
                    return function(v) {
                        return new $4b57a9a20c626e9f$export$372d8dcc68f43922(opId, msg.value0.value0);
                    };
                })($4b57a9a20c626e9f$var$identity)(accepted.result);
                if (msg instanceof $cc65e4880038a74f$export$9d697732809bc86 && msg.value0 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return accepted.result;
                if (msg instanceof $cc65e4880038a74f$export$9d697732809bc86 && msg.value0 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$startStep1Operation(new $a8c8b5353c92bbbb$export$13e5863daa3c5eb1($506e78fa6ac73d88$export$d2afd53f9f0a26b(accepted.ready)))(function(opId) {
                    return function(nextReady) {
                        return new $4b57a9a20c626e9f$export$f4b18fa9f7b0988c(opId, nextReady, msg.value0.value0);
                    };
                })($4b57a9a20c626e9f$var$identity)(accepted.result);
                throw new Error("Failed pattern match at App.Update (line 648, column 12 - line 766, column 19): " + [
                    msg.constructor.name
                ]);
            }
            throw new Error("Failed pattern match at App.Update (line 639, column 1 - line 639, column 84): " + [
                ready0.constructor.name,
                msg.constructor.name,
                result0.constructor.name
            ]);
        };
    };
};
var $4b57a9a20c626e9f$export$722fbec263ad908a = function(state) {
    return function(msg) {
        return $4b57a9a20c626e9f$var$map2($4b57a9a20c626e9f$var$scheduleBootstrapOps)(function() {
            if (msg instanceof $c9f8fdc31e1f6dad$export$5c8f622845981396) {
                var requested = $daa993e9fe4182d9$export$9bf1c8c94a38f6fb(msg.value0);
                var nextState = $4b57a9a20c626e9f$var$advanceRouteVersion(state);
                var expected = $4b57a9a20c626e9f$var$currentRouteForState(state)(msg.value0);
                return $4b57a9a20c626e9f$var$bind($4b57a9a20c626e9f$var$handleReadyStep3BrowserRoute(nextState)(requested))(function(handled) {
                    if (handled instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$pure(handled.value0);
                    if (handled instanceof $06733ae99ed4f534$export$bebe9059409a0d04 && $daa993e9fe4182d9$export$f6821e37299eed8e(requested) === $daa993e9fe4182d9$export$f6821e37299eed8e(expected)) return $4b57a9a20c626e9f$var$pure({
                        state: nextState,
                        commands: []
                    });
                    if (handled instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4b57a9a20c626e9f$var$pure({
                        state: nextState,
                        commands: [
                            new $4b57a9a20c626e9f$export$d1cc75e80b20eeaf(nextState.routeVersion, msg.value0)
                        ]
                    });
                    throw new Error("Failed pattern match at App.Update (line 95, column 13 - line 104, column 26): " + [
                        handled.constructor.name
                    ]);
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$d9d27eb76d4d6392) {
                var $424 = msg.value0 !== state.routeVersion;
                if ($424) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                return $4b57a9a20c626e9f$var$bind(msg.value2)(function(nextState) {
                    var requested = $daa993e9fe4182d9$export$9bf1c8c94a38f6fb(msg.value1);
                    var routeCommands = function() {
                        var $425 = $daa993e9fe4182d9$export$f6821e37299eed8e(requested) === $daa993e9fe4182d9$export$f6821e37299eed8e(nextState.route);
                        if ($425) return [];
                        return [
                            new $4b57a9a20c626e9f$export$43846ecbea5b4cd7($80445329d31df9ca$export$c72c14f37d28f60d.value)
                        ];
                    }();
                    return $4b57a9a20c626e9f$var$pure({
                        state: nextState,
                        commands: routeCommands
                    });
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$cfd42e9439cb3c03) {
                if (state.step instanceof $994495db3cff0a67$export$317e7082611cb548) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$applyStep1Msg(state.step1.value0)(msg.value0)({
                        state: state,
                        commands: []
                    }));
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$1dc871215656967e) {
                if (state.step instanceof $994495db3cff0a67$export$317e7082611cb548) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55 && state.step1.value0.searchVersion === msg.value0) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(opId) {
                        return function(nextReady) {
                            return new $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef(opId, nextReady);
                        };
                    })($4b57a9a20c626e9f$var$identity)({
                        state: state,
                        commands: []
                    }));
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$49c4478c934a149d) {
                if (state.step1 instanceof $80445329d31df9ca$export$9787b7e6f37d414e && state.step1.value0.opId instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $4b57a9a20c626e9f$var$eq2(state.step1.value0.opId.value0)(msg.value0)) return $4b57a9a20c626e9f$var$bind(msg.value1)(function(ready) {
                    return $4b57a9a20c626e9f$var$pure({
                        state: $4b57a9a20c626e9f$var$setStep1Ready(ready)({
                            route: state.route,
                            step: state.step,
                            workQueueState: state.workQueueState,
                            workQueueUi: state.workQueueUi,
                            workQueueCache: state.workQueueCache,
                            pushStateInterface: state.pushStateInterface,
                            operations: state.operations,
                            step1: state.step1,
                            step2A: state.step2A,
                            step2B: state.step2B,
                            step3: state.step3,
                            routeVersion: state.routeVersion,
                            preselectForms: []
                        }),
                        commands: []
                    });
                });
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$1815fbfc550f516c) {
                if (!$4b57a9a20c626e9f$var$isCurrentOperation($a8c8b5353c92bbbb$export$f0780570fbaaaac3.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure({
                            state: $4b57a9a20c626e9f$var$setStep1Ready($506e78fa6ac73d88$export$fa820f6db65b6e5a(msg.value1.value0)(state.step1.value0))(state),
                            commands: []
                        });
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 157, column 33 - line 164, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$186e0f90982d0f3f) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$bd4ea9079614f218.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure({
                            state: $4b57a9a20c626e9f$var$setStep1Ready($506e78fa6ac73d88$export$836911d8c4152069({
                                recentForms: state.step1.value0.recentForms,
                                selection: state.step1.value0.selection,
                                searchState: state.step1.value0.searchState,
                                state: state.step1.value0.state,
                                searchVersion: state.step1.value0.searchVersion,
                                formPicker: msg.value1.value0
                            }))(state),
                            commands: []
                        });
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 172, column 33 - line 179, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$72cd3e127cbacdf2) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$812d070c95a0506d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure({
                            state: $4b57a9a20c626e9f$var$setStep1Ready($506e78fa6ac73d88$export$836911d8c4152069($cc65e4880038a74f$export$c3e5bd4d38a8f2e(msg.value1.value0)(state.step1.value0)))(state),
                            commands: []
                        });
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 187, column 33 - line 194, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$170ffc57937e436f) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$812d070c95a0506d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(nextOpId) {
                            return function(nextReady) {
                                return new $4b57a9a20c626e9f$export$614ed660100c3639(nextOpId, nextReady, 0);
                            };
                        })(function(st) {
                            return {
                                recentForms: st.recentForms,
                                searchState: st.searchState,
                                formPicker: st.formPicker,
                                state: st.state,
                                searchVersion: st.searchVersion,
                                selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                            };
                        })({
                            state: state,
                            commands: []
                        }));
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 202, column 29 - line 210, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$bdf9754cca6d30f9) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$812d070c95a0506d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(nextOpId) {
                            return function(nextReady) {
                                return new $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef(nextOpId, nextReady);
                            };
                        })(function(st) {
                            return {
                                recentForms: st.recentForms,
                                searchState: st.searchState,
                                formPicker: st.formPicker,
                                state: st.state,
                                searchVersion: st.searchVersion,
                                selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                            };
                        })({
                            state: state,
                            commands: []
                        }));
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 218, column 29 - line 226, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$b8f63b481aa277b7) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$3fc2b2789a39ace6.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                            var v = $cc65e4880038a74f$export$8e52f6005dd813ab(msg.value1)(msg.value2.value0);
                            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $4b57a9a20c626e9f$var$pure({
                                state: $4b57a9a20c626e9f$var$setStep1Ready($506e78fa6ac73d88$export$836911d8c4152069(state.step1.value0))(state),
                                commands: [
                                    new $4b57a9a20c626e9f$export$96c159224a0db784(v.value0.url)
                                ]
                            });
                            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$7a0047718fb8649d("Steps.Step1"), new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$19d787e6e83e848f("exporting documents"), new $54dae5ca6a6cd16d$export$90a530fd5ef57012("Expected at least one report for exported documents."))))(state));
                            throw new Error("Failed pattern match at App.Update (line 235, column 34 - line 246, column 34): " + [
                                v.constructor.name
                            ]);
                        }
                        if (msg.value2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value2.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 234, column 33 - line 248, column 48): " + [
                            msg.value2.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$15cf3a228c822e8b) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$812d070c95a0506d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(nextOpId) {
                            return function(nextReady) {
                                return new $4b57a9a20c626e9f$export$8c088ed0af29bf8e(nextOpId, nextReady);
                            };
                        })(function(st) {
                            return {
                                recentForms: st.recentForms,
                                searchState: st.searchState,
                                formPicker: st.formPicker,
                                state: st.state,
                                searchVersion: st.searchVersion,
                                selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                            };
                        })({
                            state: state,
                            commands: []
                        }));
                        if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value1.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 256, column 29 - line 264, column 48): " + [
                            msg.value1.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$c1b4ff70e49ef826) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$812d070c95a0506d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) {
                        if (msg.value2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$startStep1Operation($a8c8b5353c92bbbb$export$78cbc2329447459a.value)(function(nextOpId) {
                            return function(nextReady) {
                                return new $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef(nextOpId, nextReady);
                            };
                        })(function(st) {
                            return $cc65e4880038a74f$export$5d56a4bb5c081171(msg.value1)({
                                recentForms: st.recentForms,
                                searchState: st.searchState,
                                formPicker: st.formPicker,
                                state: st.state,
                                searchVersion: st.searchVersion,
                                selection: $f264ceec36a478ad$export$6e22c362a0406a2c
                            });
                        })({
                            state: $4b57a9a20c626e9f$var$setStep1Ready(state.step1.value0)(state),
                            commands: []
                        }));
                        if (msg.value2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step1Error(msg.value2.value0)(state));
                        throw new Error("Failed pattern match at App.Update (line 272, column 33 - line 282, column 48): " + [
                            msg.value2.constructor.name
                        ]);
                    }
                    return $4b57a9a20c626e9f$var$pure({
                        state: state,
                        commands: []
                    });
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$4ee52428d11a0598) {
                if (state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12 && state.step2A instanceof $80445329d31df9ca$export$b6b6ceaf3ddf8f7c) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$applyStep2AAction(state.step2A.value0)(msg.value0)({
                    state: state,
                    commands: []
                }));
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$a64c6b692532acd6) {
                if (state.step2A instanceof $80445329d31df9ca$export$adf38f4e421177a0 && state.step2A.value0.opId instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $4b57a9a20c626e9f$var$eq2(state.step2A.value0.opId.value0)(msg.value0)) {
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure({
                        state: {
                            operations: state.operations,
                            preselectForms: state.preselectForms,
                            pushStateInterface: state.pushStateInterface,
                            route: state.route,
                            routeVersion: state.routeVersion,
                            step: state.step,
                            step1: state.step1,
                            step2B: state.step2B,
                            step3: state.step3,
                            workQueueCache: state.workQueueCache,
                            workQueueUi: state.workQueueUi,
                            step2A: new $80445329d31df9ca$export$b6b6ceaf3ddf8f7c(msg.value1.value0),
                            workQueueState: {
                                currentDoc: state.workQueueState.currentDoc,
                                documents: state.workQueueState.documents,
                                editDocs: state.workQueueState.editDocs,
                                forms: state.workQueueState.forms,
                                semester: state.workQueueState.semester,
                                teacher: state.workQueueState.teacher,
                                students: msg.value1.value0.students
                            }
                        },
                        commands: []
                    });
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure({
                        state: {
                            operations: state.operations,
                            preselectForms: state.preselectForms,
                            pushStateInterface: state.pushStateInterface,
                            route: state.route,
                            routeVersion: state.routeVersion,
                            step: state.step,
                            step1: state.step1,
                            step2B: state.step2B,
                            step3: state.step3,
                            workQueueCache: state.workQueueCache,
                            workQueueState: state.workQueueState,
                            workQueueUi: state.workQueueUi,
                            step2A: new $80445329d31df9ca$export$10d33c2f80e61d21(msg.value1.value0)
                        },
                        commands: []
                    });
                    throw new Error("Failed pattern match at App.Update (line 293, column 75 - line 306, column 22): " + [
                        msg.value1.constructor.name
                    ]);
                }
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$6a003360ff9d90ea) {
                if (state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4 && state.step2B instanceof $80445329d31df9ca$export$81701a88d512004b) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$applyStep2BAction(state.step2B.value0)(msg.value0)({
                    state: state,
                    commands: []
                }));
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$50c82f767474cb3f) {
                if (state.step2B instanceof $80445329d31df9ca$export$851fbd25481b6c25 && state.step2B.value0.opId instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $4b57a9a20c626e9f$var$eq2(state.step2B.value0.opId.value0)(msg.value0)) {
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $4b57a9a20c626e9f$var$pure({
                        state: $4b57a9a20c626e9f$var$syncStep2BState(state)(msg.value1.value0),
                        commands: []
                    });
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure({
                        state: {
                            operations: state.operations,
                            preselectForms: state.preselectForms,
                            pushStateInterface: state.pushStateInterface,
                            route: state.route,
                            routeVersion: state.routeVersion,
                            step: state.step,
                            step1: state.step1,
                            step2A: state.step2A,
                            step3: state.step3,
                            workQueueCache: state.workQueueCache,
                            workQueueState: state.workQueueState,
                            workQueueUi: state.workQueueUi,
                            step2B: new $80445329d31df9ca$export$d17de998d9231f6f(msg.value1.value0)
                        },
                        commands: []
                    });
                    throw new Error("Failed pattern match at App.Update (line 317, column 75 - line 327, column 22): " + [
                        msg.value1.constructor.name
                    ]);
                }
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$385761a6227f1894) {
                if (!$4b57a9a20c626e9f$var$isLatestOperation($a8c8b5353c92bbbb$export$87c4c62ae2426f3d.value)(msg.value0)(state)) return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) {
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) {
                        var v = $396c4c3d9e7fae3c$export$5fd5031fecdacec3(msg.value1.value0);
                        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                            var exportResult = {
                                state: state,
                                commands: [
                                    new $4b57a9a20c626e9f$export$96c159224a0db784(v.value0.url)
                                ]
                            };
                            return $4b57a9a20c626e9f$var$pure(function() {
                                var $531 = $4b57a9a20c626e9f$var$isCurrentStep2(state.step);
                                if ($531) return $4b57a9a20c626e9f$var$applyStep2Navigation($994495db3cff0a67$export$635e3e065a143ae6.value)(state)(exportResult);
                                return exportResult;
                            }());
                        }
                        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step2ExportError($4b57a9a20c626e9f$var$missingStep2ExportReportError)(state));
                        throw new Error("Failed pattern match at App.Update (line 335, column 30 - line 347, column 57): " + [
                            v.constructor.name
                        ]);
                    }
                    if (msg.value1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$step2ExportError(msg.value1.value0)(state));
                    throw new Error("Failed pattern match at App.Update (line 334, column 24 - line 349, column 50): " + [
                        msg.value1.constructor.name
                    ]);
                }
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$81c3d75642767bc3) {
                if (state.step3 instanceof $80445329d31df9ca$export$52520e6e1d2bce34 && state.step3.value0.opId instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $4b57a9a20c626e9f$var$eq2(state.step3.value0.opId.value0)(msg.value0)) return $4b57a9a20c626e9f$var$bind(msg.value1)(function(preload) {
                    var nextState = {
                        operations: state.operations,
                        preselectForms: state.preselectForms,
                        pushStateInterface: state.pushStateInterface,
                        route: state.route,
                        routeVersion: state.routeVersion,
                        step: state.step,
                        step1: state.step1,
                        step2A: state.step2A,
                        step2B: state.step2B,
                        workQueueUi: state.workQueueUi,
                        workQueueState: preload.state,
                        workQueueCache: preload.cache,
                        step3: new $80445329d31df9ca$export$b87e8303844f9049({
                            init: state.step3.value0.init,
                            opId: $06733ae99ed4f534$export$bebe9059409a0d04.value
                        })
                    };
                    return $4b57a9a20c626e9f$var$pure({
                        state: nextState,
                        commands: []
                    });
                });
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$def578e25f70cc18) {
                if (state.step3 instanceof $80445329d31df9ca$export$b87e8303844f9049 && state.step3.value0.opId instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && $4b57a9a20c626e9f$var$eq2(state.step3.value0.opId.value0)(msg.value0)) return $4b57a9a20c626e9f$var$bind(msg.value1)(function(ready) {
                    return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$appendRouteCommand(new $4b57a9a20c626e9f$export$1f0c59144b57f59f($59a05a7e29977bc8$export$7bdb1b708831338.value))({
                        state: $4b57a9a20c626e9f$var$syncReadyState(state)(ready),
                        commands: []
                    }));
                });
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$f626af092893962d) {
                if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $4b57a9a20c626e9f$var$bind($7b9d021f8fc5e8ea$export$722fbec263ad908a(state.step3.value0)(msg.value0))(function(step3Result) {
                    return $4b57a9a20c626e9f$var$pure($4b57a9a20c626e9f$var$applyStep3Commands({
                        state: $4b57a9a20c626e9f$var$syncReadyState(state)(step3Result.state),
                        commands: []
                    })(step3Result.commands));
                });
                return $4b57a9a20c626e9f$var$pure({
                    state: state,
                    commands: []
                });
            }
            if (msg instanceof $c9f8fdc31e1f6dad$export$a03875e05513d0ab) return $4b57a9a20c626e9f$var$pure({
                state: state,
                commands: []
            });
            if (msg instanceof $c9f8fdc31e1f6dad$export$4a8caf36b85213e5) return $4b57a9a20c626e9f$var$pure({
                state: {
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step: state.step,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    operations: $fb0451ff9e33ce13$export$60d3f62a64b4c0cf(msg.value0)(msg.value1)(msg.value2)(state.operations)
                },
                commands: []
            });
            if (msg instanceof $c9f8fdc31e1f6dad$export$98baa1b16ede8cfe) return $4b57a9a20c626e9f$var$pure({
                state: {
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step: state.step,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    operations: $fb0451ff9e33ce13$export$8650904b5e89876a(msg.value0)(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342))(state.operations)
                },
                commands: []
            });
            if (msg instanceof $c9f8fdc31e1f6dad$export$eafac69673bdfea3) return $4b57a9a20c626e9f$var$pure({
                state: {
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step: state.step,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    operations: $fb0451ff9e33ce13$export$8650904b5e89876a(msg.value0)(new $7d4cccdf062a2261$export$37c4d04eafdc5515(msg.value1))(state.operations)
                },
                commands: []
            });
            if (msg instanceof $c9f8fdc31e1f6dad$export$e1f136b69054516) return $4b57a9a20c626e9f$var$pure({
                state: {
                    preselectForms: state.preselectForms,
                    pushStateInterface: state.pushStateInterface,
                    route: state.route,
                    routeVersion: state.routeVersion,
                    step: state.step,
                    step1: state.step1,
                    step2A: state.step2A,
                    step2B: state.step2B,
                    step3: state.step3,
                    workQueueCache: state.workQueueCache,
                    workQueueState: state.workQueueState,
                    workQueueUi: state.workQueueUi,
                    operations: $fb0451ff9e33ce13$export$f92ca06486a47b7a(msg.value0)(state.operations)
                },
                commands: []
            });
            throw new Error("Failed pattern match at App.Update (line 87, column 47 - line 411, column 14): " + [
                msg.constructor.name
            ]);
        }());
    };
};





























// Generated by purs version 0.15.16
"use strict";
const $b4820784a71f3cca$export$302ea87d15e513da = function() {
    window.onbeforeunload = function() {
        return "Are you sure you want to leave this page? Any unsaved changes will be lost.";
    };
};
const $b4820784a71f3cca$export$415f698193575175 = function() {
    window.onbeforeunload = null;
};
const $b4820784a71f3cca$export$72506cc3444837c9 = function() {
    if (window.onbeforeunload == null) return true;
    else return confirm("Are you sure you want to leave this page? Any unsaved changes will be lost.");
};






// Generated by purs version 0.15.16











// Generated by purs version 0.15.16




var $ec52a8164fabd1b2$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $ec52a8164fabd1b2$export$28709abf85ddce1d = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $55 = $78386b654cef599e$export$28709abf85ddce1d(dictShow);
        return function($56) {
            return liftEffect($55($56));
        };
    };
};
var $ec52a8164fabd1b2$export$c106dd0671a0fc2d = function(dictMonadEffect) {
    var $57 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($58) {
        return $57($93c729927fdf3160$export$c106dd0671a0fc2d($58));
    };
};
var $ec52a8164fabd1b2$export$1694f226a9241aae = function(dictMonadEffect) {
    var $59 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($60) {
        return $59($93c729927fdf3160$export$1694f226a9241aae($60));
    };
};
var $ec52a8164fabd1b2$export$8f2977fb54cb3601 = function(dictMonadEffect) {
    var $61 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($62) {
        return $61($93c729927fdf3160$export$8f2977fb54cb3601($62));
    };
};
var $ec52a8164fabd1b2$export$2da9be4cfdb689b1 = function(dictMonadEffect) {
    var $63 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($64) {
        return $63($93c729927fdf3160$export$2da9be4cfdb689b1($64));
    };
};
var $ec52a8164fabd1b2$export$9f43f5977f8d5609 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $65 = $78386b654cef599e$export$9f43f5977f8d5609(dictShow);
        return function($66) {
            return liftEffect($65($66));
        };
    };
};
var $ec52a8164fabd1b2$export$bef1f36f5486a6a3 = function(dictMonadEffect) {
    var $67 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($68) {
        return $67($93c729927fdf3160$export$bef1f36f5486a6a3($68));
    };
};
var $ec52a8164fabd1b2$export$fc9467e2ad369291 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $69 = $78386b654cef599e$export$fc9467e2ad369291(dictShow);
        return function($70) {
            return liftEffect($69($70));
        };
    };
};
var $ec52a8164fabd1b2$export$a80b3bd66acc52ff = function(dictMonadEffect) {
    var $71 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($72) {
        return $71($93c729927fdf3160$export$a80b3bd66acc52ff($72));
    };
};
var $ec52a8164fabd1b2$export$a57f3dfe595273e6 = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$a57f3dfe595273e6);
};
var $ec52a8164fabd1b2$export$488ef8fb3416a29f = function(dictMonadEffect) {
    var $73 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($74) {
        return $73($93c729927fdf3160$export$488ef8fb3416a29f($74));
    };
};
var $ec52a8164fabd1b2$export$e5e25fbcc1f7affe = function(dictMonadEffect) {
    var $75 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($76) {
        return $75($93c729927fdf3160$export$e5e25fbcc1f7affe($76));
    };
};
var $ec52a8164fabd1b2$export$a188e271553f9211 = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var discard1 = $ec52a8164fabd1b2$var$discard(Bind1);
    var group1 = $ec52a8164fabd1b2$export$e5e25fbcc1f7affe(dictMonadEffect);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var groupEnd1 = $ec52a8164fabd1b2$export$a57f3dfe595273e6(dictMonadEffect);
    var pure = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    return function(name) {
        return function(inner) {
            return discard1(group1(name))(function() {
                return bind(inner)(function(result) {
                    return discard1(groupEnd1)(function() {
                        return pure(result);
                    });
                });
            });
        };
    };
};
var $ec52a8164fabd1b2$export$cbd229996ecd7704 = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $77 = $78386b654cef599e$export$cbd229996ecd7704(dictShow);
        return function($78) {
            return liftEffect($77($78));
        };
    };
};
var $ec52a8164fabd1b2$export$a3bc9b8ed74fc = function(dictMonadEffect) {
    var $79 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($80) {
        return $79($93c729927fdf3160$export$a3bc9b8ed74fc($80));
    };
};
var $ec52a8164fabd1b2$export$18fab8ed91d044eb = function(dictMonadEffect) {
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function(dictShow) {
        var $81 = $78386b654cef599e$export$18fab8ed91d044eb(dictShow);
        return function($82) {
            return liftEffect($81($82));
        };
    };
};
var $ec52a8164fabd1b2$export$1c9f709888824e05 = function(dictMonadEffect) {
    var $83 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
    return function($84) {
        return $83($93c729927fdf3160$export$1c9f709888824e05($84));
    };
};
var $ec52a8164fabd1b2$export$42ffd38884aecdac = function(dictMonadEffect) {
    return $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect)($93c729927fdf3160$export$42ffd38884aecdac);
};






var $3ed5ac370c7a6da5$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $3ed5ac370c7a6da5$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $3ed5ac370c7a6da5$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $3ed5ac370c7a6da5$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $3ed5ac370c7a6da5$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $3ed5ac370c7a6da5$var$log = /* #__PURE__ */ $ec52a8164fabd1b2$export$bef1f36f5486a6a3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $3ed5ac370c7a6da5$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $3ed5ac370c7a6da5$export$fe3d1bc8d0d6d190 = function(id) {
    var ignoreAction = function(v) {
        return v.value0.state;
    };
    var displayFormWidget = function(ft) {
        return $3ed5ac370c7a6da5$var$bind($3ed5ac370c7a6da5$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("step-container")
        ])([
            $3ed5ac370c7a6da5$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-preview")
            ])([
                $3ed5ac370c7a6da5$var$map(ignoreAction)($fce7eb63608cf274$export$9750270299d2035e($f388db8e60bd7b97$export$5f8bbb7bf801e4b8)(ft))
            ])
        ]))(function(newft) {
            return displayFormWidget(newft);
        });
    };
    var parseForm = function(v) {
        if (v instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $54dae5ca6a6cd16d$export$e14a5bba978ec5e6(new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$7a0047718fb8649d("Steps.FormPreview.previewWidget"), new $54dae5ca6a6cd16d$export$d66a470e50d9b480(new $54dae5ca6a6cd16d$export$19d787e6e83e848f("parsing FormType from API"), v.value0)));
        if (v instanceof $7d4cccdf062a2261$export$19db0165690c701a) return displayFormWidget($fce7eb63608cf274$export$6dbd705fbb1240f9(v.value0));
        throw new Error("Failed pattern match at Steps.FormPreview (line 38, column 9 - line 41, column 16): " + [
            v.constructor.name
        ]);
    };
    return $3ed5ac370c7a6da5$var$discard($3ed5ac370c7a6da5$var$liftEffect($3ed5ac370c7a6da5$var$log("Previewing form: " + $3ed5ac370c7a6da5$var$show(id))))(function() {
        return $3ed5ac370c7a6da5$var$bind($3257df7cdef77623$export$b97f2ad8d0b7442d($38eb3af3d662147b$export$86c17563827efac6($308f9765feb7633d$export$a7f53fa461221c79($3ed5ac370c7a6da5$var$show(id)))))(function(form) {
            return parseForm(form);
        });
    });
};



// Generated by purs version 0.15.16












































// Generated by purs version 0.15.16






































var $36e1806e81661a53$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $36e1806e81661a53$var$fromFoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($36e1806e81661a53$var$ordRNTY)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $36e1806e81661a53$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $36e1806e81661a53$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $36e1806e81661a53$var$eqRNTY = /* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8);
var $36e1806e81661a53$var$eq = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32($36e1806e81661a53$var$eqRNTY);
var $36e1806e81661a53$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($36e1806e81661a53$var$ordRNTY);
var $36e1806e81661a53$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $36e1806e81661a53$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $36e1806e81661a53$var$loopState = /* #__PURE__ */ $ed3a75a0cf477875$export$c7e78faad39c995c($fe1781b0b9eaad64$export$d23735986c0beb69);
var $36e1806e81661a53$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $36e1806e81661a53$var$form = /* #__PURE__ */ $3eadc1b959dd1120$export$6210fa4921d2a466($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $36e1806e81661a53$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $36e1806e81661a53$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $36e1806e81661a53$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $36e1806e81661a53$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $36e1806e81661a53$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $36e1806e81661a53$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $36e1806e81661a53$var$sortWith1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$c5f2758e49b2b86a);
var $36e1806e81661a53$var$map4 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($ea3eb84de0acf574$export$3930f636962ed944);
var $36e1806e81661a53$var$all = /* #__PURE__ */ $4fe7b6acfba7f29f$export$84bf76cd7afc7469($ea3eb84de0acf574$export$4295a0c2ad7aa544)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $36e1806e81661a53$var$map5 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $36e1806e81661a53$var$table = /* #__PURE__ */ $3eadc1b959dd1120$export$9852986a3ec5f6a0($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$thead$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$30acb79f31ecdd33($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$td$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$37e945cf8445363a($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$tbody$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$d42611f94eedae0c($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$ordRecord = /* #__PURE__ */ $97937c29f879e68e$export$ebb7a7956d139174()(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611(/* #__PURE__ */ $97937c29f879e68e$export$a9b387b18fb85611($97937c29f879e68e$export$927f7db8ecc0069f)()({
    reflectSymbol: function() {
        return "sig";
    }
})($36e1806e81661a53$var$ordRNTY))()({
    reflectSymbol: function() {
        return "doc";
    }
})($36e1806e81661a53$var$ordRNTY));
var $36e1806e81661a53$var$update = /* #__PURE__ */ $ea3eb84de0acf574$export$722fbec263ad908a($36e1806e81661a53$var$ordRecord);
var $36e1806e81661a53$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$tr$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$e31f07a47c038498($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$td = /* #__PURE__ */ $3eadc1b959dd1120$export$2beef8af2014e5c6($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$fromFoldable2 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $36e1806e81661a53$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$details = /* #__PURE__ */ $3eadc1b959dd1120$export$41ee12f6f6f05843($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$summary$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$43870e7484b30e9b($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$abbr = /* #__PURE__ */ $3eadc1b959dd1120$export$2bcb785951133fe5($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$insert = /* #__PURE__ */ $ea3eb84de0acf574$export$21a5ca8aa77d35ff($36e1806e81661a53$var$ordRNTY);
var $36e1806e81661a53$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $36e1806e81661a53$var$map6 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($78c799cba34fcb8d$export$40b9e4330ffd17e3);
var $36e1806e81661a53$var$eq1 = /* #__PURE__ */ $37b880af5f4991bd$export$9663ddc1cf085b32(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($36e1806e81661a53$var$eqRNTY));
var $36e1806e81661a53$var$h1$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$78e024695ac0e4c4($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$b$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$73045757eb41c970($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$map7 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($91ee3359f6bcea22$export$cf42eb1af12f469e);
var $36e1806e81661a53$var$any = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($78c799cba34fcb8d$export$92659ee1fc91a075)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $36e1806e81661a53$var$lookup = /* #__PURE__ */ $ea3eb84de0acf574$export$dfc7155ac0343b8($36e1806e81661a53$var$ordRNTY);
var $36e1806e81661a53$var$any1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$4154a199d7d90455($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $36e1806e81661a53$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $36e1806e81661a53$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $36e1806e81661a53$var$find = /* #__PURE__ */ $4fe7b6acfba7f29f$export$71aa6c912b956294($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $36e1806e81661a53$var$fromFoldable3 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($36e1806e81661a53$var$ordRecord)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $36e1806e81661a53$var$update1 = /* #__PURE__ */ $ea3eb84de0acf574$export$722fbec263ad908a($36e1806e81661a53$var$ordRNTY);
var $36e1806e81661a53$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $36e1806e81661a53$var$textarea = /* #__PURE__ */ $3eadc1b959dd1120$export$a3574df893ffa88d($36e1806e81661a53$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $36e1806e81661a53$var$all1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$84bf76cd7afc7469($4fe7b6acfba7f29f$export$e97014618a7eb593)($f8fc227945eb179e$export$d7d9283ee84f4c3f);
var $36e1806e81661a53$var$union = /* #__PURE__ */ $ea3eb84de0acf574$export$971dd5b0dfd021b6($36e1806e81661a53$var$ordRNTY);
var $36e1806e81661a53$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $36e1806e81661a53$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $36e1806e81661a53$export$6532675f77ddc7c2 = /* #__PURE__ */ function() {
    function EditEmail(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    }
    EditEmail.create = function(value0) {
        return function(value1) {
            return function(value2) {
                return new EditEmail(value0, value1, value2);
            };
        };
    };
    return EditEmail;
}();
var $36e1806e81661a53$export$e0e994291a60669e = /* #__PURE__ */ function() {
    function SendEmails() {}
    SendEmails.value = new SendEmails();
    return SendEmails;
}();
var $36e1806e81661a53$export$bbadff23f5cd28e2 = /* #__PURE__ */ function() {
    function GoBack() {}
    GoBack.value = new GoBack();
    return GoBack;
}();
var $36e1806e81661a53$export$1a3c28c39317e5b6 = /* #__PURE__ */ function() {
    var process = function(f) {
        return new $71f2e2e9476163f8$export$1908877435b1d5e9(f.form.id, f.field.key);
    };
    var $215 = $36e1806e81661a53$var$map(process);
    return function($216) {
        return $36e1806e81661a53$var$fromFoldable($215($216));
    };
}();
var $36e1806e81661a53$export$6041e74c81e9ac05 = function(docs) {
    return function(rel) {
        var unambiguousFields = function(v) {
            if ($36e1806e81661a53$var$length(v) < 2) return $396c4c3d9e7fae3c$export$5fd5031fecdacec3(v);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var matchingKeys = function(form1) {
            return $396c4c3d9e7fae3c$export$3dea766d36a8935f(function(s) {
                return $36e1806e81661a53$var$eq(s.relationship)(rel);
            })(form1.signatures);
        };
        var formTypes = $396c4c3d9e7fae3c$export$45273896c792ff3b(function(a) {
            return function(b) {
                return $36e1806e81661a53$var$eq(a.id)(b.id);
            };
        })($36e1806e81661a53$var$map(function(v) {
            return v.form_type;
        })($36e1806e81661a53$var$sortWith(function(v) {
            return v.form_type.id;
        })(docs)));
        var matched = $36e1806e81661a53$var$map(function(form1) {
            return {
                form: form1,
                fields: matchingKeys(form1)
            };
        })(formTypes);
        var unambiguous = function() {
            var process = function(f) {
                return $36e1806e81661a53$var$map1(function(v) {
                    return {
                        form: f.form,
                        field: v
                    };
                })(unambiguousFields(f.fields));
            };
            return $396c4c3d9e7fae3c$export$e70771d2e7e590a(process)(matched);
        }();
        var targets = $36e1806e81661a53$export$1a3c28c39317e5b6(unambiguous);
        var ambiguousFields = function(v) {
            if ($36e1806e81661a53$var$length(v) > 1) return $e39dfcf102cdca3c$export$571d59b505e6bb4e(v);
            return $06733ae99ed4f534$export$bebe9059409a0d04.value;
        };
        var ambiguous = $396c4c3d9e7fae3c$export$e70771d2e7e590a(function(m) {
            return $36e1806e81661a53$var$map1(function(v) {
                return {
                    form: m.form,
                    fields: v
                };
            })(ambiguousFields(m.fields));
        })(matched);
        var choices = $36e1806e81661a53$var$fromFoldable1($36e1806e81661a53$var$map(function(v) {
            return {
                opts: v.fields,
                rel: rel,
                form: v.form,
                selected: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
        })(ambiguous));
        var $163 = $36e1806e81661a53$var$length(ambiguous) > 0;
        if ($163) return new $7d4cccdf062a2261$export$37c4d04eafdc5515({
            rel: rel,
            choices: choices,
            others: unambiguous
        });
        return new $7d4cccdf062a2261$export$19db0165690c701a(targets);
    };
};
var $36e1806e81661a53$export$3cfd1509666fd9a1 = function(account) {
    return function(entry) {
        return function(initEmail) {
            var runModal = $36e1806e81661a53$var$loopState(initEmail)(function(email) {
                return $36e1806e81661a53$var$form([
                    $fc1df90f0e252058$export$2913c0c0b5623090("signature-email-single-form signature-req-edit-email modal-grid"),
                    $fc1df90f0e252058$export$31eb53bd5b582a97("javascript:void(0);"),
                    $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(email))($fc1df90f0e252058$export$307d29742c654737)
                ])([
                    $36e1806e81661a53$var$h1([
                        $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
                    ])([
                        $36e1806e81661a53$var$text("Edit "),
                        $36e1806e81661a53$var$text(entry.field.emailLabel),
                        $36e1806e81661a53$var$text(" for "),
                        $36e1806e81661a53$var$text($b05aa108190eac05$export$d50a55988135660c(account)(entry.doc.student))
                    ]),
                    $36e1806e81661a53$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("signature-employer-container")
                    ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                        $c3ec47a57216184e$export$71e337785367343c($36e1806e81661a53$var$eq(entry.field.relationship)($995df59c0c2f7d8f$export$80a9ba689aa548df))($36e1806e81661a53$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("signature-employer")
                        ])(function() {
                            if (entry.doc.contact instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return [
                                $36e1806e81661a53$var$text(entry.doc.contact.value0.name),
                                $36e1806e81661a53$var$text(" at "),
                                $36e1806e81661a53$var$text($06733ae99ed4f534$export$f8b8b9ce72e9ccbf("no employer selected")(function(v) {
                                    return v.company;
                                })(entry.doc.employer))
                            ];
                            if (entry.doc.contact instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [
                                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("no-contact-selected"))
                            ];
                            throw new Error("Failed pattern match at Widgets.Signature.Request (line 441, column 17 - line 447, column 84): " + [
                                entry.doc.contact.constructor.name
                            ]);
                        }()))
                    ])),
                    $36e1806e81661a53$var$input([
                        $36e1806e81661a53$var$map2($36e1806e81661a53$var$map3($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3),
                        $fc1df90f0e252058$export$2ab9a8f9f1186f14(email),
                        $fc1df90f0e252058$export$9c7ae676ac45430a("email-input"),
                        $fc1df90f0e252058$export$1741e49665a9c8e8("email"),
                        $fc1df90f0e252058$export$a7a0278c004aac3f(true),
                        $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("email-address")),
                        $fc1df90f0e252058$export$2913c0c0b5623090("widget-input req-email-address")
                    ]),
                    $36e1806e81661a53$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("btn-group btn-group-email-single modal-buttons")
                    ])([
                        $36e1806e81661a53$var$button([
                            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                            $fc1df90f0e252058$export$1741e49665a9c8e8("submit")
                        ])([
                            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("save"))
                        ]),
                        $36e1806e81661a53$var$button([
                            $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                            $fc1df90f0e252058$export$1741e49665a9c8e8("button"),
                            $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(initEmail))($fc1df90f0e252058$export$1d5a917feb871989)
                        ])([
                            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
                        ])
                    ])
                ]);
            });
            return $36e1806e81661a53$var$bind($035405231d3ae317$export$21159b4378d24276($36e1806e81661a53$var$text(""))(runModal))(function(v) {
                if (v instanceof $035405231d3ae317$export$a09a21bd8097e7) return $36e1806e81661a53$var$pure(initEmail);
                if (v instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $36e1806e81661a53$var$pure(v.value0);
                throw new Error("Failed pattern match at Widgets.Signature.Request (line 423, column 77 - line 425, column 38): " + [
                    v.constructor.name
                ]);
            });
        };
    };
};
var $36e1806e81661a53$export$4cfff9f4bf96568c = function(state) {
    return function(group) {
        var sortEntries = $36e1806e81661a53$var$sortWith1(function($217) {
            return $5b07e36f812dd04b$export$b1ceac3893cbda6b(function(v) {
                return v.doc.student.name;
            }($217));
        });
        var groupId = "sig-review-" + $308f9765feb7633d$export$a1b0f5347d2470b(group.form.id);
        var selectAllCheck = function(alreadySent) {
            var matches = function(v) {
                if (alreadySent) return $06733ae99ed4f534$export$c15bd07a493e1236(v.sentAt);
                return $06733ae99ed4f534$export$4967676db1b89293(v.sentAt);
            };
            var id = function() {
                if (alreadySent) return "-sent";
                return "-unsent";
            }();
            var doSelectAll = function(sel) {
                return {
                    form: group.form,
                    sigs: $36e1806e81661a53$var$map4(function(s) {
                        return {
                            sentAt: s.sentAt,
                            email: s.email,
                            doc: s.doc,
                            field: s.field,
                            key: s.key,
                            selected: function() {
                                var $169 = matches(s);
                                if ($169) return sel && $06733ae99ed4f534$export$c15bd07a493e1236(s.email);
                                return s.selected;
                            }()
                        };
                    })(group.sigs)
                };
            };
            var allSelected = $36e1806e81661a53$var$all(function(s) {
                return s.selected || $06733ae99ed4f534$export$4967676db1b89293(s.email) || !matches(s);
            })(group.sigs);
            return $36e1806e81661a53$var$map5($36e1806e81661a53$var$map3($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(doSelectAll))($fc8e139dfeeff88c$export$fe5109b9fec6786a("sig-review-check")(groupId + ("-select-all" + id))($c3328e54cdf5154c$export$5a1a8430df9521e("student"))(allSelected));
        };
        var entryTable = function(sent) {
            return function(selAll) {
                return function(content) {
                    return $36e1806e81661a53$var$table([
                        $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-table")
                    ])([
                        $36e1806e81661a53$var$thead$prime($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                            new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$var$td$prime([
                                $06733ae99ed4f534$export$43db023a260c5e9f($36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("student")))(selAll)
                            ])),
                            $c3ec47a57216184e$export$71e337785367343c($36e1806e81661a53$var$eq(state.rel)($995df59c0c2f7d8f$export$80a9ba689aa548df))($36e1806e81661a53$var$td$prime([
                                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("employer"))
                            ])),
                            $c3ec47a57216184e$export$71e337785367343c(sent)($36e1806e81661a53$var$td$prime([
                                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("sent"))
                            ])),
                            new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$var$td$prime([
                                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("email"))
                            ]))
                        ])),
                        $36e1806e81661a53$var$tbody$prime(content)
                    ]);
                };
            };
        };
        var entryCheck = function(entry) {
            var labelWhen = $36e1806e81661a53$var$map1($25dcdcde7533cf1d$export$c12d4497c7cc4368)(entry.sentAt);
            var labelEmployer = $36e1806e81661a53$var$map1(function(v) {
                return v.name;
            })(entry.doc.contact);
            var labelEmail = $06733ae99ed4f534$export$43db023a260c5e9f("")(entry.email);
            var editBtn = $36e1806e81661a53$var$button([
                $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(new $36e1806e81661a53$export$6532675f77ddc7c2(group.form.id, entry, $06733ae99ed4f534$export$43db023a260c5e9f("")(entry.email))))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("edit-btn")
            ])([
                $36e1806e81661a53$var$span([
                    $fc1df90f0e252058$export$2913c0c0b5623090("image-replace edit-icon")
                ])([]),
                $36e1806e81661a53$var$span([
                    $fc1df90f0e252058$export$2913c0c0b5623090("edit-btn-text")
                ])([
                    $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("edit"))
                ])
            ]);
            var doSelect = function(sel) {
                return {
                    form: group.form,
                    sigs: $36e1806e81661a53$var$update(function(s) {
                        return new $06733ae99ed4f534$export$8a67b48435b5d073({
                            doc: s.doc,
                            email: s.email,
                            field: s.field,
                            key: s.key,
                            sentAt: s.sentAt,
                            selected: sel
                        });
                    })(entry.key)(group.sigs)
                };
            };
            var checkId = groupId + ("-sig-" + ($308f9765feb7633d$export$a1b0f5347d2470b(entry.doc.id) + ("-" + $308f9765feb7633d$export$84864e2081a33895(entry.field.key))));
            var check = $36e1806e81661a53$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-review-check")
            ])([
                $fc8e139dfeeff88c$export$b07e517d22efa1ca([
                    $fc1df90f0e252058$export$9c7ae676ac45430a(checkId),
                    $fc1df90f0e252058$export$683472f6198a076e($06733ae99ed4f534$export$4967676db1b89293(entry.email))
                ])(entry.selected),
                $36e1806e81661a53$var$label([
                    $fc1df90f0e252058$export$35d9e1c947946090(checkId)
                ])([
                    $36e1806e81661a53$var$text($b05aa108190eac05$export$d50a55988135660c(state.account)(entry.doc.student))
                ])
            ]);
            return $36e1806e81661a53$var$tr$prime($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$var$td$prime([
                    $36e1806e81661a53$var$map5($36e1806e81661a53$var$map3($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(doSelect))(check)
                ])),
                $c3ec47a57216184e$export$71e337785367343c($36e1806e81661a53$var$eq(entry.field.relationship)($995df59c0c2f7d8f$export$80a9ba689aa548df))($06733ae99ed4f534$export$f8b8b9ce72e9ccbf($36e1806e81661a53$var$td$prime([]))(function(lbl) {
                    return $36e1806e81661a53$var$td$prime([
                        $36e1806e81661a53$var$text(lbl)
                    ]);
                })(labelEmployer)),
                $36e1806e81661a53$var$map1(function(when) {
                    return $36e1806e81661a53$var$td$prime([
                        $36e1806e81661a53$var$text(when)
                    ]);
                })(labelWhen),
                new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$var$td([
                    $fc1df90f0e252058$export$2913c0c0b5623090("flex flex-row")
                ])([
                    $36e1806e81661a53$var$text(labelEmail),
                    editBtn
                ]))
            ]));
        };
        var allEntries = $36e1806e81661a53$var$fromFoldable2($ea3eb84de0acf574$export$68c286be0e7e55b7(group.sigs));
        var alreadySentEntries = sortEntries($396c4c3d9e7fae3c$export$3dea766d36a8935f(function($218) {
            return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
                return v.sentAt;
            }($218));
        })(allEntries));
        var alreadySentGroup = function() {
            if ($36e1806e81661a53$var$length(alreadySentEntries) <= 0) return $36e1806e81661a53$var$div$prime([]);
            return $36e1806e81661a53$var$details([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-subgroup")
            ])([
                $36e1806e81661a53$var$summary$prime([
                    $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("already-emailed"))
                ]),
                entryTable(true)(new $06733ae99ed4f534$export$8a67b48435b5d073(selectAllCheck(true)))($36e1806e81661a53$var$map(entryCheck)(alreadySentEntries))
            ]);
        }();
        var noEmailEntries = sortEntries($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(e) {
            return $06733ae99ed4f534$export$4967676db1b89293(e.email) && $06733ae99ed4f534$export$4967676db1b89293(e.sentAt);
        })(allEntries));
        var noEmailGroup = function() {
            if ($36e1806e81661a53$var$length(noEmailEntries) <= 0) return $36e1806e81661a53$var$div$prime([]);
            return $36e1806e81661a53$var$details([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-subgroup"),
                $fc1df90f0e252058$export$3ce6949f20cea765(true)
            ])([
                $36e1806e81661a53$var$summary$prime([
                    $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("no-saved-email"))
                ]),
                entryTable(false)($06733ae99ed4f534$export$bebe9059409a0d04.value)($36e1806e81661a53$var$map(entryCheck)(noEmailEntries))
            ]);
        }();
        var sendableEntries = sortEntries($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(e) {
            return $06733ae99ed4f534$export$4967676db1b89293(e.sentAt) && $06733ae99ed4f534$export$c15bd07a493e1236(e.email);
        })(allEntries));
        var sendableGroup = function() {
            if ($36e1806e81661a53$var$length(sendableEntries) <= 0) return $36e1806e81661a53$var$div$prime([]);
            return $36e1806e81661a53$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-subgroup")
            ])([
                entryTable(false)(new $06733ae99ed4f534$export$8a67b48435b5d073(selectAllCheck(false)))($36e1806e81661a53$var$map(entryCheck)(sendableEntries))
            ]);
        }();
        return $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group")
        ])([
            $36e1806e81661a53$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group-header")
            ])([
                $36e1806e81661a53$var$abbr([
                    $fc1df90f0e252058$export$2913c0c0b5623090("form-abbr"),
                    $fc1df90f0e252058$export$1d567c320f4763bc({
                        backgroundColor: group.form.bgColor
                    }),
                    $fc1df90f0e252058$export$fb184b623420d9be(group.form.label)
                ])([
                    $36e1806e81661a53$var$text(group.form.abbr)
                ])
            ]),
            $36e1806e81661a53$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group-select")
            ])([
                sendableGroup,
                noEmailGroup,
                alreadySentGroup
            ])
        ]);
    };
};
var $36e1806e81661a53$export$110c8878ee6425c8 = function(state) {
    var renderGroup = function(group) {
        var updateGroup = function(newGroup) {
            return {
                comment: state.comment,
                rel: state.rel,
                rstate: state.rstate,
                account: state.account,
                groups: $36e1806e81661a53$var$insert(group.form.id)(newGroup)(state.groups)
            };
        };
        return $36e1806e81661a53$var$map5($7d4cccdf062a2261$export$5f5be1bb6cd1fded(function($219) {
            return $7d4cccdf062a2261$export$37c4d04eafdc5515.create(updateGroup($219));
        })(function(a) {
            return new $7d4cccdf062a2261$export$19db0165690c701a(a);
        }))($36e1806e81661a53$export$4cfff9f4bf96568c(state)(group));
    };
    return $36e1806e81661a53$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-review-form")
    ])($36e1806e81661a53$var$append1([
        $36e1806e81661a53$var$h1([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
        ])([
            $36e1806e81661a53$var$text("Select "),
            $36e1806e81661a53$var$text($995df59c0c2f7d8f$export$654c292ba8f9410f(state.rel)),
            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(" signatures to request"))
        ])
    ])($36e1806e81661a53$var$fromFoldable2($36e1806e81661a53$var$map6(renderGroup)($ea3eb84de0acf574$export$68c286be0e7e55b7(state.groups)))));
};
var $36e1806e81661a53$export$c754c101da2ca5a5 = function(group) {
    var radioName = "sig-request-resolve-" + $308f9765feb7633d$export$a1b0f5347d2470b(group.form.id);
    var radio = function(choice) {
        var htmlId = radioName + ("-" + $308f9765feb7633d$export$84864e2081a33895(choice.key));
        return $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-resolve-option")
        ])([
            $36e1806e81661a53$var$input([
                $fc1df90f0e252058$export$1741e49665a9c8e8("radio"),
                $fc1df90f0e252058$export$a8ff84c12d48cfa6(radioName),
                $fc1df90f0e252058$export$9c7ae676ac45430a(htmlId),
                $fc1df90f0e252058$export$b96bb35bc88d6fa($36e1806e81661a53$var$eq1($36e1806e81661a53$var$map1(function(v) {
                    return v.key;
                })(group.selected))(new $06733ae99ed4f534$export$8a67b48435b5d073(choice.key))),
                $36e1806e81661a53$var$voidRight({
                    form: group.form,
                    opts: group.opts,
                    rel: group.rel,
                    selected: new $06733ae99ed4f534$export$8a67b48435b5d073(choice)
                })($fc1df90f0e252058$export$bd913411069e59d3)
            ]),
            $36e1806e81661a53$var$label([
                $fc1df90f0e252058$export$35d9e1c947946090(htmlId)
            ])([
                $36e1806e81661a53$var$text(choice.label)
            ])
        ]);
    };
    return $36e1806e81661a53$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group")
    ])([
        $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group-header")
        ])([
            $36e1806e81661a53$var$abbr([
                $fc1df90f0e252058$export$2913c0c0b5623090("form-abbr"),
                $fc1df90f0e252058$export$1d567c320f4763bc({
                    backgroundColor: group.form.bgColor
                }),
                $fc1df90f0e252058$export$fb184b623420d9be(group.form.label)
            ])([
                $36e1806e81661a53$var$text(group.form.abbr)
            ])
        ]),
        $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-group-select")
        ])([
            $36e1806e81661a53$var$h1$prime([
                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("resolve-signature-for") + " "),
                $36e1806e81661a53$var$b$prime([
                    $36e1806e81661a53$var$text(group.form.label)
                ])
            ]),
            $36e1806e81661a53$var$div$prime($e39dfcf102cdca3c$export$45b10814cc054894($36e1806e81661a53$var$map7(radio)(group.opts)))
        ])
    ]);
};
var $36e1806e81661a53$export$cc09f03c8683027b = function(v) {
    return $9c13a1c3d948adb8$export$be9e2feb4e35335b($36e1806e81661a53$export$c754c101da2ca5a5({
        form: v.form,
        rel: v.field.relationship,
        opts: $e39dfcf102cdca3c$export$439306a4dcaafbb9(v.field),
        selected: new $06733ae99ed4f534$export$8a67b48435b5d073(v.field)
    }));
};
var $36e1806e81661a53$export$37d767e082915a7f = function(state) {
    var renderGroup = function(idx) {
        return function(group) {
            return $36e1806e81661a53$var$map5(function($$new) {
                return {
                    others: state.others,
                    rel: state.rel,
                    choices: $06733ae99ed4f534$export$43db023a260c5e9f(state.choices)($396c4c3d9e7fae3c$export$b6d8713d53419d4c(idx)($$new)(state.choices))
                };
            })($36e1806e81661a53$export$c754c101da2ca5a5(group));
        };
    };
    return $36e1806e81661a53$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("sig-request-resolve-form")
    ])($36e1806e81661a53$var$append1([
        $36e1806e81661a53$var$h1([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal-heading")
        ])([
            $36e1806e81661a53$var$text("Select "),
            $36e1806e81661a53$var$text($995df59c0c2f7d8f$export$654c292ba8f9410f(state.rel)),
            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(" signatures to request"))
        ])
    ])($36e1806e81661a53$var$append1($396c4c3d9e7fae3c$export$8f07ddce13659f50(renderGroup)(state.choices))($36e1806e81661a53$var$map($36e1806e81661a53$export$cc09f03c8683027b)(state.others))));
};
var $36e1806e81661a53$export$c9d94b769c3cab6f = function(group) {
    return $ea3eb84de0acf574$export$dd1bc94b04021eeb(group.sigs);
};
var $36e1806e81661a53$export$dd1bc94b04021eeb = function(v) {
    return $ea3eb84de0acf574$export$dd1bc94b04021eeb(v.groups) || $36e1806e81661a53$var$any($36e1806e81661a53$export$c9d94b769c3cab6f)($ea3eb84de0acf574$export$68c286be0e7e55b7(v.groups));
};
var $36e1806e81661a53$export$74823b3e5014cfce = function(account) {
    return function(rel) {
        return function(docs) {
            return function(targs) {
                var isTargeted = function(ftype) {
                    return function(field) {
                        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf(false)(function(v) {
                            return $36e1806e81661a53$var$eq(v)(field.key);
                        })($36e1806e81661a53$var$lookup(ftype.id)(targs));
                    };
                };
                var isSigned = function(rf) {
                    return function(field) {
                        return $36e1806e81661a53$var$any1(function(s) {
                            return $36e1806e81661a53$var$eq(s.key)(field.key);
                        })(rf.signatures);
                    };
                };
                var grouped = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(a) {
                    return function(b) {
                        return $36e1806e81661a53$var$eq(a.form_type.id)(b.form_type.id);
                    };
                })($36e1806e81661a53$var$sortWith(function(v) {
                    return v.form_type.id;
                })(docs));
                var docEntry = function(v) {
                    return function(v1) {
                        if (isTargeted(v.form_type)(v1) && !isSigned(v)(v1)) {
                            var defEmail = $36e1806e81661a53$var$bindFlipped(function(v2) {
                                return v2.default_email;
                            })($396c4c3d9e7fae3c$export$71aa6c912b956294(function(s) {
                                return $36e1806e81661a53$var$eq(s.key)(v1.key);
                            })(v.signature_fields));
                            var email$prime = function() {
                                var $177 = $36e1806e81661a53$var$notEq(defEmail)(new $06733ae99ed4f534$export$8a67b48435b5d073(""));
                                if ($177) return defEmail;
                                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                            }();
                            var verif = $36e1806e81661a53$var$find(function(v2) {
                                return $36e1806e81661a53$var$eq(v2.data.key)(v1.key);
                            })(v.verifications);
                            var v2 = function() {
                                if (verif instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
                                    email: new $06733ae99ed4f534$export$8a67b48435b5d073(verif.value0.data.email),
                                    sentAt: new $06733ae99ed4f534$export$8a67b48435b5d073(verif.value0.created_at)
                                };
                                if (verif instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
                                    email: email$prime,
                                    sentAt: $06733ae99ed4f534$export$bebe9059409a0d04.value
                                };
                                throw new Error("Failed pattern match at Widgets.Signature.Request (line 183, column 33 - line 185, column 62): " + [
                                    verif.constructor.name
                                ]);
                            }();
                            return new $06733ae99ed4f534$export$8a67b48435b5d073({
                                field: v1,
                                sentAt: v2.sentAt,
                                email: v2.email,
                                selected: $06733ae99ed4f534$export$4967676db1b89293(v2.sentAt) && $06733ae99ed4f534$export$c15bd07a493e1236(v2.email),
                                key: {
                                    doc: v.id,
                                    sig: v1.key
                                },
                                doc: v
                            });
                        }
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    };
                };
                var docEntries = function(doc) {
                    return $36e1806e81661a53$var$map(function(ent) {
                        return new $71f2e2e9476163f8$export$1908877435b1d5e9(ent.key, ent);
                    })($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($36e1806e81661a53$var$map(function(field) {
                        return docEntry(doc)(field);
                    })(doc.form_type.signatures)));
                };
                var group = function(gdocs) {
                    var form1 = $e39dfcf102cdca3c$export$5fd5031fecdacec3(gdocs).form_type;
                    var docEntryList = $396c4c3d9e7fae3c$export$c28c8388be0ab31a(docEntries)($e39dfcf102cdca3c$export$45b10814cc054894(gdocs));
                    return $c3ec47a57216184e$export$71e337785367343c($fc8c1182ec2aefec$export$f24224f1c91d8156(docEntryList) > 0)(new $71f2e2e9476163f8$export$1908877435b1d5e9(form1.id, {
                        form: form1,
                        sigs: $36e1806e81661a53$var$fromFoldable3(docEntryList)
                    }));
                };
                var groups = $36e1806e81661a53$var$fromFoldable($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($36e1806e81661a53$var$map(group)(grouped)));
                return {
                    groups: groups,
                    rel: rel,
                    account: account,
                    comment: "",
                    rstate: $06733ae99ed4f534$export$bebe9059409a0d04.value
                };
            };
        };
    };
};
var $36e1806e81661a53$export$95d5391cd5e60248 = function(state) {
    var mkRequest = function(v) {
        if (v.email instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v.selected) return new $06733ae99ed4f534$export$8a67b48435b5d073({
            docId: v.doc.id,
            key: v.field.key,
            email: v.email.value0,
            comment: state.comment
        });
        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    };
    var groupReqs = function(group) {
        return $3d4fd987da5242ff$export$986c2bbe7a34be0b($36e1806e81661a53$var$map6(mkRequest)($ea3eb84de0acf574$export$68c286be0e7e55b7(group.sigs)));
    };
    return $36e1806e81661a53$var$fromFoldable2($3d4fd987da5242ff$export$c28c8388be0ab31a(groupReqs)($ea3eb84de0acf574$export$68c286be0e7e55b7(state.groups)));
};
var $36e1806e81661a53$export$896810e0cc177ac6 = function(v) {
    var inGroup = function(v1) {
        return $36e1806e81661a53$var$any(function(v2) {
            return v2.selected;
        })($ea3eb84de0acf574$export$68c286be0e7e55b7(v1.sigs));
    };
    return $36e1806e81661a53$var$any(inGroup)($ea3eb84de0acf574$export$68c286be0e7e55b7(v.groups));
};
var $36e1806e81661a53$export$c1882bdcee3df93 = function(v) {
    if ($36e1806e81661a53$export$dd1bc94b04021eeb(v)) return $36e1806e81661a53$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("modal-col")
    ])([
        $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("mt-6")
        ])([
            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("request-all-signed"))
        ])
    ]);
    var handleAction = function(v1) {
        if (v1 instanceof $36e1806e81661a53$export$bbadff23f5cd28e2) return $36e1806e81661a53$var$pure(new $7d4cccdf062a2261$export$37c4d04eafdc5515($05149ea687d6b460$export$523c0b569236b342));
        if (v1 instanceof $36e1806e81661a53$export$e0e994291a60669e) return $36e1806e81661a53$var$pure(new $7d4cccdf062a2261$export$19db0165690c701a(v));
        if (v1 instanceof $36e1806e81661a53$export$6532675f77ddc7c2) return $36e1806e81661a53$var$bind($36e1806e81661a53$export$3cfd1509666fd9a1(v.account)(v1.value1)(v1.value2))(function(email) {
            var newEmail = function() {
                var $192 = email !== "";
                if ($192) return new $06733ae99ed4f534$export$8a67b48435b5d073(email);
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            }();
            var updateEntry = function(v2) {
                return {
                    doc: v2.doc,
                    field: v2.field,
                    key: v2.key,
                    sentAt: v2.sentAt,
                    email: newEmail,
                    selected: $06733ae99ed4f534$export$c15bd07a493e1236(newEmail)
                };
            };
            var updateGroup = function(group) {
                return new $06733ae99ed4f534$export$8a67b48435b5d073({
                    form: group.form,
                    sigs: $36e1806e81661a53$var$update(function($220) {
                        return $06733ae99ed4f534$export$8a67b48435b5d073.create(updateEntry($220));
                    })(v1.value1.key)(group.sigs)
                });
            };
            return $36e1806e81661a53$export$c1882bdcee3df93({
                comment: v.comment,
                rel: v.rel,
                rstate: v.rstate,
                account: v.account,
                groups: $36e1806e81661a53$var$update1(updateGroup)(v1.value0)(v.groups)
            });
        });
        throw new Error("Failed pattern match at Widgets.Signature.Request (line 294, column 5 - line 294, column 81): " + [
            v1.constructor.name
        ]);
    };
    var handle = function(v1) {
        if (v1 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return handleAction(v1.value0);
        if (v1 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $36e1806e81661a53$export$c1882bdcee3df93(v1.value0);
        throw new Error("Failed pattern match at Widgets.Signature.Request (line 290, column 5 - line 290, column 98): " + [
            v1.constructor.name
        ]);
    };
    return $36e1806e81661a53$var$bindFlipped1(handle)($36e1806e81661a53$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("modal-col modal-wide")
    ])([
        $36e1806e81661a53$export$110c8878ee6425c8(v),
        $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("signature-comment-container w-full")
        ])([
            $36e1806e81661a53$var$label([
                $fc1df90f0e252058$export$35d9e1c947946090("comment-input"),
                $fc1df90f0e252058$export$2913c0c0b5623090("signature-comment-label")
            ])([
                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("signature-comment"))
            ]),
            $36e1806e81661a53$var$textarea([
                $36e1806e81661a53$var$map2($36e1806e81661a53$var$map3($36e1806e81661a53$var$map3($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v1) {
                    return {
                        account: v.account,
                        groups: v.groups,
                        rel: v.rel,
                        rstate: v.rstate,
                        comment: v1
                    };
                }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$bd913411069e59d3),
                $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.comment),
                $fc1df90f0e252058$export$9c7ae676ac45430a("comment-input"),
                $fc1df90f0e252058$export$c7187bbd1a7a9244($c3328e54cdf5154c$export$5a1a8430df9521e("signature-comment-placeholder")),
                $fc1df90f0e252058$export$2913c0c0b5623090("widget-input signature-comment")
            ])([])
        ]),
        $36e1806e81661a53$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("modal-buttons")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            $c3ec47a57216184e$export$71e337785367343c($06733ae99ed4f534$export$c15bd07a493e1236(v.rstate))($36e1806e81661a53$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($36e1806e81661a53$export$bbadff23f5cd28e2.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("back"))
            ])),
            new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                $fc1df90f0e252058$export$683472f6198a076e(!$36e1806e81661a53$export$896810e0cc177ac6(v)),
                $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($36e1806e81661a53$export$e0e994291a60669e.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("send-email"))
            ]))
        ]))
    ]));
};
var $36e1806e81661a53$export$2f3d5a3ca18a6974 = function(state) {
    return $36e1806e81661a53$var$all1(function($221) {
        return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
            return v.selected;
        }($221));
    })(state.choices);
};
var $36e1806e81661a53$export$174da77a2dc02ad = function(state) {
    var selected = $36e1806e81661a53$var$fromFoldable($396c4c3d9e7fae3c$export$986c2bbe7a34be0b($36e1806e81661a53$var$map(function(a) {
        return $36e1806e81661a53$var$map1(function() {
            var $222 = $71f2e2e9476163f8$export$1908877435b1d5e9.create(a.form.id);
            return function($223) {
                return $222(function(v) {
                    return v.key;
                }($223));
            };
        }())(a.selected);
    })(state.choices)));
    return $c3ec47a57216184e$export$71e337785367343c($36e1806e81661a53$export$2f3d5a3ca18a6974(state))(selected);
};
var $36e1806e81661a53$export$ce15b7a86ac7cf30 = function(account) {
    return function(docs) {
        return function(rel) {
            var resolveInner = function(state$prime) {
                return $36e1806e81661a53$var$loopState(state$prime)(function(state) {
                    return $36e1806e81661a53$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("modal-col")
                    ])([
                        $36e1806e81661a53$var$map5($7d4cccdf062a2261$export$37c4d04eafdc5515.create)($36e1806e81661a53$export$37d767e082915a7f(state)),
                        $36e1806e81661a53$var$button([
                            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-primary"),
                            $fc1df90f0e252058$export$683472f6198a076e($06733ae99ed4f534$export$4967676db1b89293($36e1806e81661a53$export$174da77a2dc02ad(state))),
                            $36e1806e81661a53$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(state))($fc1df90f0e252058$export$1d5a917feb871989)
                        ])([
                            $36e1806e81661a53$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("next"))
                        ])
                    ]);
                });
            };
            var resolve = function(initState) {
                return $36e1806e81661a53$var$bind(resolveInner(initState))(function(state) {
                    var v = $36e1806e81661a53$export$174da77a2dc02ad(state);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $36e1806e81661a53$var$pure({
                        targets: $36e1806e81661a53$var$union(v.value0)($36e1806e81661a53$export$1a3c28c39317e5b6(state.others)),
                        rstate: new $06733ae99ed4f534$export$8a67b48435b5d073(state)
                    });
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return resolve(state);
                    throw new Error("Failed pattern match at Widgets.Signature.Request (line 79, column 8 - line 82, column 36): " + [
                        v.constructor.name
                    ]);
                });
            };
            var runModal = function(targ) {
                return $36e1806e81661a53$var$bind(function() {
                    if (targ instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $36e1806e81661a53$var$pure({
                        targets: targ.value0,
                        rstate: $06733ae99ed4f534$export$bebe9059409a0d04.value
                    });
                    if (targ instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return resolve(targ.value0);
                    throw new Error("Failed pattern match at Widgets.Signature.Request (line 51, column 32 - line 53, column 48): " + [
                        targ.constructor.name
                    ]);
                }())(function(v) {
                    return review(function() {
                        var v1 = $36e1806e81661a53$export$74823b3e5014cfce(account)(rel)(docs)(v.targets);
                        return {
                            groups: v1.groups,
                            comment: v1.comment,
                            rel: v1.rel,
                            account: v1.account,
                            rstate: v.rstate
                        };
                    }());
                });
            };
            var review = function(initState) {
                return $36e1806e81661a53$var$bind($36e1806e81661a53$export$c1882bdcee3df93(initState))(function(ret) {
                    if (ret instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) {
                        if (initState.rstate instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return runModal(new $7d4cccdf062a2261$export$37c4d04eafdc5515(initState.rstate.value0));
                        if (initState.rstate instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return runModal($36e1806e81661a53$export$6041e74c81e9ac05(docs)(rel));
                        throw new Error("Failed pattern match at Widgets.Signature.Request (line 60, column 23 - line 62, column 61): " + [
                            initState.rstate.constructor.name
                        ]);
                    }
                    if (ret instanceof $7d4cccdf062a2261$export$19db0165690c701a) return confirm(ret.value0);
                    throw new Error("Failed pattern match at Widgets.Signature.Request (line 59, column 9 - line 63, column 41): " + [
                        ret.constructor.name
                    ]);
                });
            };
            var confirm = function(state) {
                return $36e1806e81661a53$var$bind($46bd9e377310b7ba$export$4a889a183052e7fa($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures"))($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures-confirm-btn"))($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures-confirm")))(function(conf) {
                    if (conf) return $36e1806e81661a53$var$pure(state);
                    return review(state);
                });
            };
            return $36e1806e81661a53$var$bind($035405231d3ae317$export$21159b4378d24276($36e1806e81661a53$var$div$prime([]))(runModal($36e1806e81661a53$export$6041e74c81e9ac05(docs)(rel))))(function(ret) {
                if (ret instanceof $035405231d3ae317$export$a09a21bd8097e7) return $36e1806e81661a53$var$pure($06733ae99ed4f534$export$bebe9059409a0d04.value);
                if (ret instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return $36e1806e81661a53$var$discard($36e1806e81661a53$var$liftEffect($93c729927fdf3160$export$bef1f36f5486a6a3($36e1806e81661a53$export$95d5391cd5e60248(ret.value0))))(function() {
                    return $36e1806e81661a53$var$pure(new $06733ae99ed4f534$export$8a67b48435b5d073($36e1806e81661a53$export$95d5391cd5e60248(ret.value0)));
                });
                throw new Error("Failed pattern match at Widgets.Signature.Request (line 44, column 5 - line 48, column 44): " + [
                    ret.constructor.name
                ]);
            });
        };
    };
};



var $b6244736105fafa2$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $b6244736105fafa2$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $b6244736105fafa2$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $b6244736105fafa2$var$abbr = /* #__PURE__ */ $3eadc1b959dd1120$export$2bcb785951133fe5($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $b6244736105fafa2$var$time = /* #__PURE__ */ $3eadc1b959dd1120$export$2da9be4cfdb689b1($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$h3$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$2ca4b4ad910a1231($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$ordRNTY = /* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a);
var $b6244736105fafa2$var$selectionCheckbox$prime = /* #__PURE__ */ $f264ceec36a478ad$export$117af77010ad01dc($b6244736105fafa2$var$ordRNTY);
var $b6244736105fafa2$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($78c799cba34fcb8d$export$92659ee1fc91a075)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $b6244736105fafa2$var$article = /* #__PURE__ */ $3eadc1b959dd1120$export$bba2aacf8566461b($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$label = /* #__PURE__ */ $3eadc1b959dd1120$export$1237798dc640739a($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$3d7cf516d27998a0);
var $b6244736105fafa2$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $b6244736105fafa2$var$map3 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $b6244736105fafa2$var$selectAllCheckbox = /* #__PURE__ */ $f264ceec36a478ad$export$a15ad87874fca069($f4b2eb11fc32ed34$export$2330f868b62ed546)($4fe7b6acfba7f29f$export$e97014618a7eb593)($b6244736105fafa2$var$ordRNTY);
var $b6244736105fafa2$var$fromFoldable = /* #__PURE__ */ $a393155e52307a24$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593)($b6244736105fafa2$var$ordRNTY);
var $b6244736105fafa2$var$intersection = /* #__PURE__ */ $a393155e52307a24$export$bc86dfbf7795668c($b6244736105fafa2$var$ordRNTY);
var $b6244736105fafa2$var$meter = /* #__PURE__ */ $3eadc1b959dd1120$export$82334bbdfcebb57($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $b6244736105fafa2$var$length1 = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $b6244736105fafa2$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $b6244736105fafa2$var$section = /* #__PURE__ */ $3eadc1b959dd1120$export$fe2e36411d703b3d($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$ol = /* #__PURE__ */ $3eadc1b959dd1120$export$b2235297ee22a6fe($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$show1 = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($54dae5ca6a6cd16d$export$54aef60b1a6d6353);
var $b6244736105fafa2$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$fromFoldable1 = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $b6244736105fafa2$var$sortWith = /* #__PURE__ */ $396c4c3d9e7fae3c$export$a9e7d1a6fdcfefde($97937c29f879e68e$export$c5f2758e49b2b86a);
var $b6244736105fafa2$var$fromFoldable2 = /* #__PURE__ */ $ea3eb84de0acf574$export$b7d5d9bb9ff52072($b6244736105fafa2$var$ordRNTY)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $b6244736105fafa2$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $b6244736105fafa2$var$isEmpty = /* #__PURE__ */ $f264ceec36a478ad$export$dd1bc94b04021eeb($b6244736105fafa2$var$ordRNTY);
var $b6244736105fafa2$var$header = /* #__PURE__ */ $3eadc1b959dd1120$export$38e42c68cf43b5d4($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd($02eacf321b2a2128$export$5315b7c1b1d9e384);
var $b6244736105fafa2$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $b6244736105fafa2$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($b6244736105fafa2$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $b6244736105fafa2$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $b6244736105fafa2$export$910517ea574cb41e = function(state) {
    return function(v) {
        if (v instanceof $cc65e4880038a74f$export$4934505d85d8ea04) return $b6244736105fafa2$var$map($b6244736105fafa2$var$map1($cc65e4880038a74f$export$ddee5dea62089d8d.create))($87fd40f8c9231b88$export$79426bf7edbef7ce($506e78fa6ac73d88$export$c1853cad74b031d9(state)));
        if (v instanceof $cc65e4880038a74f$export$a4e49cad429911be) return $b6244736105fafa2$var$map($b6244736105fafa2$var$map1($cc65e4880038a74f$export$bca2d63a3001f9d6.create))($87fd40f8c9231b88$export$42a90cf60568b9b($506e78fa6ac73d88$export$c1853cad74b031d9(state)));
        throw new Error("Failed pattern match at Steps.Step1.View (line 83, column 35 - line 87, column 79): " + [
            v.constructor.name
        ]);
    };
};
var $b6244736105fafa2$export$13a0a11de8c7452d = function(state) {
    var studentFormType = function(form) {
        return $b6244736105fafa2$var$abbr([
            $fc1df90f0e252058$export$fb184b623420d9be(form.form_type.label),
            $fc1df90f0e252058$export$2913c0c0b5623090("form-abbr"),
            $fc1df90f0e252058$export$1d567c320f4763bc({
                backgroundColor: form.form_type.bgColor
            })
        ])([
            $b6244736105fafa2$var$text(form.form_type.abbr)
        ]);
    };
    var studentFormTime = function(form) {
        var v = $35e75b0a064776f5$export$8b724767bfa64e7d(form.updated_at);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $b6244736105fafa2$var$time([
            $fc1df90f0e252058$export$2913c0c0b5623090("time"),
            $fc1df90f0e252058$export$3a17bddce263fba0(form.updated_at)
        ])([
            $b6244736105fafa2$var$text("Failed parsing datetime")
        ]);
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $b6244736105fafa2$var$time([
            $fc1df90f0e252058$export$2913c0c0b5623090("time"),
            $fc1df90f0e252058$export$3a17bddce263fba0(form.updated_at),
            $fc1df90f0e252058$export$fb184b623420d9be($25dcdcde7533cf1d$export$5f2320d02799e74b($25dcdcde7533cf1d$export$bf6e6ac8a7b3ac76)(v.value0))
        ])([
            $b6244736105fafa2$var$text($25dcdcde7533cf1d$export$c12d4497c7cc4368(v.value0))
        ]);
        throw new Error("Failed pattern match at Steps.Step1.View (line 418, column 13 - line 432, column 64): " + [
            v.constructor.name
        ]);
    };
    var studentFormInfo = function(form) {
        return $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("info")
        ])([
            $b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-header")
            ])([
                $b6244736105fafa2$var$h3$prime($b05aa108190eac05$export$4ec774c6c67c391c(state.formPicker.workQueueCache.account)(form.student)(function(name) {
                    return [
                        $b6244736105fafa2$var$text(name)
                    ];
                })(function(v) {
                    return [
                        $b6244736105fafa2$var$text(v.legal),
                        $b6244736105fafa2$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("preferred-name-paren")
                        ])([
                            $b6244736105fafa2$var$text(" (" + (v.preferred + ")"))
                        ])
                    ];
                })),
                $85206166a57f2888$export$6dafb50cab07c86c(form.student)
            ]),
            $b6244736105fafa2$var$text(form.subtitle + (" " + function() {
                var $90 = $06733ae99ed4f534$export$c15bd07a493e1236(form.legacy_url);
                if ($90) return $c3328e54cdf5154c$export$5a1a8430df9521e("legacy-form-label");
                return "";
            }()))
        ]);
    };
    var studentFormCheck = function(form) {
        var props = [
            $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-checkbox")
        ];
        return $b6244736105fafa2$var$map(function(v) {
            return {
                formPicker: state.formPicker,
                recentForms: state.recentForms,
                searchState: state.searchState,
                searchVersion: state.searchVersion,
                state: state.state,
                selection: v
            };
        })($b6244736105fafa2$var$selectionCheckbox$prime(form.id)(form)(props)(state.selection));
    };
    var selectAllCheck = function() {
        var selCount = $b6244736105fafa2$var$length($f264ceec36a478ad$export$7693e0a1b9351086(state.selection));
        var render = function(selected) {
            return $b6244736105fafa2$var$article([
                $fc1df90f0e252058$export$2913c0c0b5623090("student-form select-all")
            ])([
                $fc8e139dfeeff88c$export$b07e517d22efa1ca([
                    $fc1df90f0e252058$export$9c7ae676ac45430a("select-all-checkbox")
                ])(selected),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("info")
                ])([
                    $b6244736105fafa2$var$label([
                        $fc1df90f0e252058$export$35d9e1c947946090("select-all-checkbox")
                    ])([
                        $b6244736105fafa2$var$text(function() {
                            var $91 = selCount > 0;
                            if ($91) return $b6244736105fafa2$var$show(selCount) + $c3328e54cdf5154c$export$5a1a8430df9521e("selected-count");
                            return $c3328e54cdf5154c$export$5a1a8430df9521e("select-all");
                        }())
                    ])
                ])
            ]);
        };
        var formTuples = $b6244736105fafa2$var$map2(function(f) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(f.id, f);
        })($b5f6b40b8f63b732$export$f27fff4bf988e19(state.recentForms));
        return $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(function(v) {
            return {
                formPicker: state.formPicker,
                recentForms: state.recentForms,
                searchState: state.searchState,
                searchVersion: state.searchVersion,
                state: state.state,
                selection: v
            };
        }))($b6244736105fafa2$var$selectAllCheckbox(formTuples)(render)(state.selection));
    }();
    var renderFormIndicators = function(form) {
        var sigKeys = $b6244736105fafa2$var$fromFoldable($b6244736105fafa2$var$map2(function(v) {
            return v.key;
        })(form.signatures));
        var fieldKeys = $b6244736105fafa2$var$fromFoldable($b6244736105fafa2$var$map2(function(v) {
            return v.key;
        })(form.form_type.signatures));
        var signedCount = $a393155e52307a24$export$346677f925de839c($b6244736105fafa2$var$intersection(sigKeys)(fieldKeys));
        var fieldCount = $a393155e52307a24$export$346677f925de839c(fieldKeys);
        var sigCountStr = $b6244736105fafa2$var$show(signedCount) + (" / " + $b6244736105fafa2$var$show(fieldCount));
        var commentCount = $fc8c1182ec2aefec$export$f24224f1c91d8156(form.comments);
        var attachCount = $fc8c1182ec2aefec$export$f24224f1c91d8156(form.attachments);
        return $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-indicators")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            $c3ec47a57216184e$export$71e337785367343c($06733ae99ed4f534$export$c15bd07a493e1236(form.locked_at))($b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form--indicator recent-form-locked tooltip")
            ])([
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("image-replace")
                ])([]),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("tip-content")
                ])([
                    $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("locked"))
                ])
            ])),
            $c3ec47a57216184e$export$71e337785367343c(commentCount > 0)($b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form--indicator recent-form-comments tooltip")
            ])([
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("image-replace")
                ])([]),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("tip-content")
                ])([
                    $b6244736105fafa2$var$text($b6244736105fafa2$var$show(commentCount) + (" " + $c3328e54cdf5154c$export$5a1a8430df9521e("comments")))
                ])
            ])),
            $c3ec47a57216184e$export$71e337785367343c(attachCount > 0)($b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form--indicator recent-form-attachments tooltip")
            ])([
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("image-replace")
                ])([]),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("tip-content")
                ])([
                    $b6244736105fafa2$var$text($b6244736105fafa2$var$show(attachCount) + (" " + $c3328e54cdf5154c$export$5a1a8430df9521e("attachments")))
                ])
            ])),
            $c3ec47a57216184e$export$71e337785367343c(fieldCount > 0)($b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form--indicator recent-form-signatures tooltip")
            ])([
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("image-replace")
                ])([]),
                $b6244736105fafa2$var$meter([
                    $fc1df90f0e252058$export$9c7ae676ac45430a($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-signature-meter"),
                    $fc1df90f0e252058$export$df61b30b684217c0($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-signature-meter"),
                    $fc1df90f0e252058$export$96ec731ed4dcb222($b6244736105fafa2$var$show(0)),
                    $fc1df90f0e252058$export$8960430cfd85939f($b6244736105fafa2$var$show(fieldCount)),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14($b6244736105fafa2$var$show(signedCount))
                ])([
                    $b6244736105fafa2$var$text(sigCountStr)
                ]),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("tip-content")
                ])([
                    $b6244736105fafa2$var$text(sigCountStr + (" " + $c3328e54cdf5154c$export$5a1a8430df9521e("signatures")))
                ])
            ]))
        ]));
    };
    var renderRecentForm = function(form) {
        return $b6244736105fafa2$var$article([
            $fc1df90f0e252058$export$2913c0c0b5623090("student-form"),
            $fc1df90f0e252058$export$df61b30b684217c0("recent-form-" + $308f9765feb7633d$export$a1b0f5347d2470b(form.id))
        ])([
            $b6244736105fafa2$var$label([
                $fc1df90f0e252058$export$35d9e1c947946090($308f9765feb7633d$export$a1b0f5347d2470b(form.id) + "-checkbox")
            ])([
                $b6244736105fafa2$var$map($7d4cccdf062a2261$export$37c4d04eafdc5515.create)(studentFormCheck(form)),
                studentFormType(form)
            ]),
            $b6244736105fafa2$var$div([
                $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a(new $cc65e4880038a74f$export$9cd64935e5cf264c(form)))($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-info-wrapper")
            ])([
                studentFormInfo(form),
                $b6244736105fafa2$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-extra")
                ])([
                    studentFormTime(form),
                    $b6244736105fafa2$var$map($7d4cccdf062a2261$export$19db0165690c701a.create)(renderFormIndicators(form))
                ])
            ])
        ]);
    };
    var listRecentForms = function() {
        if ($b6244736105fafa2$var$length1($b5f6b40b8f63b732$export$f27fff4bf988e19(state.recentForms)) === 0) return [
            $b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-forms-empty"),
                $fc1df90f0e252058$export$8331f8c46716f919({
                    "__html": $c3328e54cdf5154c$export$5a1a8430df9521e("recent-forms-empty")
                })
            ])([])
        ];
        return $b6244736105fafa2$var$append1([
            selectAllCheck
        ])($b6244736105fafa2$var$map2(renderRecentForm)($b5f6b40b8f63b732$export$f27fff4bf988e19(state.recentForms)));
    }();
    return $b6244736105fafa2$var$section([
        $fc1df90f0e252058$export$2913c0c0b5623090("recent-forms"),
        $fc1df90f0e252058$export$df61b30b684217c0("recent-forms-list")
    ])([
        $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-group")
        ])([
            $b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("dropdown")
            ])([])
        ]),
        $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$f9a329ae029c9889.create))($6415e24f7cd3b8e1$export$c227b65ca5911a1(state.searchState)),
        function() {
            if (state.state instanceof $506e78fa6ac73d88$export$df7041158d889e0e) return $b6244736105fafa2$var$ol([
                $fc1df90f0e252058$export$2913c0c0b5623090("recent-form-list")
            ])(listRecentForms);
            if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return $b5330906fcd65ffd$export$d558900b1478007d;
            if (state.state instanceof $506e78fa6ac73d88$export$43ecbc44d94efb05) return $b6244736105fafa2$var$text("Error: " + $b6244736105fafa2$var$show1(state.state.value0));
            throw new Error("Failed pattern match at Steps.Step1.View (line 291, column 7 - line 294, column 54): " + [
                state.state.constructor.name
            ]);
        }(),
        $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$d6d899291526e2a0.create))($c1e04b9648c3de60$export$dbddd5d79461a47c(state.recentForms))
    ]);
};
var $b6244736105fafa2$export$68d83e8e6018fa1f = function(state) {
    var nonUpdatableFormSelected = $396c4c3d9e7fae3c$export$4154a199d7d90455(function($121) {
        return !function(v) {
            return v.can.update;
        }($121);
    })($506e78fa6ac73d88$export$c1853cad74b031d9(state));
    var updateFormsItem = function(action) {
        return function(label1) {
            if (nonUpdatableFormSelected) return $b6244736105fafa2$var$a([
                $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item disabled whitespace-nowrap"),
                $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("update-forms-disabled-reason-lock"))
            ])([
                $b6244736105fafa2$var$text(label1)
            ]);
            return $b6244736105fafa2$var$a([
                $b6244736105fafa2$var$voidRight(action)($fc1df90f0e252058$export$1d5a917feb871989),
                $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item whitespace-nowrap")
            ])([
                $b6244736105fafa2$var$text(label1)
            ]);
        };
    };
    var items = [
        updateFormsItem($cc65e4880038a74f$export$4934505d85d8ea04.value)($c3328e54cdf5154c$export$5a1a8430df9521e("update-semester")),
        updateFormsItem($cc65e4880038a74f$export$a4e49cad429911be.value)($c3328e54cdf5154c$export$5a1a8430df9521e("update-teacher"))
    ];
    var busy = function() {
        if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return true;
        return false;
    }();
    var btn = $b6244736105fafa2$var$button([
        $fc1df90f0e252058$export$2913c0c0b5623090("btn vdots"),
        $fc1df90f0e252058$export$683472f6198a076e(busy),
        $fc1df90f0e252058$export$1d5a917feb871989
    ])([
        $b6244736105fafa2$var$text("\u2807")
    ]);
    return $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$1d3f1ab8435af5a9.create))($9fec91fabe90d735$export$3a59c1cf55945abf(btn)(items));
};
var $b6244736105fafa2$export$f1e27a2fac83e2ad = function(state) {
    var combineExports = function(exps) {
        var id = $e39dfcf102cdca3c$export$5fd5031fecdacec3(exps).label;
        return {
            id: id,
            label: id
        };
    };
    var busy = function() {
        if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return true;
        return false;
    }();
    var btn = $b6244736105fafa2$var$button([
        $fc1df90f0e252058$export$2913c0c0b5623090("export-forms-button btn"),
        $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("export-forms")),
        $fc1df90f0e252058$export$683472f6198a076e(busy),
        $fc1df90f0e252058$export$1d5a917feb871989
    ])([
        $b6244736105fafa2$var$span([
            $fc1df90f0e252058$export$2913c0c0b5623090("export-forms icon")
        ])([])
    ]);
    var allExports = $b6244736105fafa2$var$map2(function(v) {
        return v.exports;
    })($b6244736105fafa2$var$fromFoldable1($f264ceec36a478ad$export$7693e0a1b9351086(state.selection)));
    var groupedExports = $396c4c3d9e7fae3c$export$3f063810d7bf01bd(function(a1) {
        return function(b) {
            return a1.label === b.label;
        };
    })($b6244736105fafa2$var$sortWith(function(v) {
        return v.label;
    })($fc8c1182ec2aefec$export$ee1b3e54f0441b22(allExports)));
    var exports = $b6244736105fafa2$var$map2(combineExports)(groupedExports);
    var items = $b6244736105fafa2$var$map2(function(exp) {
        return {
            label: exp.label,
            value: exp
        };
    })(exports);
    return $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$482dc0b98af7690c.create))($9fec91fabe90d735$export$877c9c2e37d22fef(btn)(items));
};
var $b6244736105fafa2$export$db34029061cffdb9 = function(state) {
    var docRels = function(sigs) {
        return $b6244736105fafa2$var$map2(function(s) {
            return new $71f2e2e9476163f8$export$1908877435b1d5e9(s.relationship, s.relationship_label);
        })($396c4c3d9e7fae3c$export$3dea766d36a8935f(function(v) {
            return v.can.request;
        })(sigs));
    };
    var busy = function() {
        if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return true;
        return false;
    }();
    var btn = $b6244736105fafa2$var$button([
        $fc1df90f0e252058$export$2913c0c0b5623090("request-sigs-button btn"),
        $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures")),
        $fc1df90f0e252058$export$683472f6198a076e(busy),
        $fc1df90f0e252058$export$1d5a917feb871989
    ])([
        $b6244736105fafa2$var$span([
            $fc1df90f0e252058$export$2913c0c0b5623090("request-sigs icon")
        ])([])
    ]);
    var allRels = $b6244736105fafa2$var$fromFoldable2($396c4c3d9e7fae3c$export$c28c8388be0ab31a(function(doc) {
        return docRels(doc.form_type.signatures);
    })($b6244736105fafa2$var$fromFoldable1($f264ceec36a478ad$export$7693e0a1b9351086(state.selection))));
    var items = $b6244736105fafa2$var$map2(function(v) {
        return {
            label: v.value1,
            value: v.value0
        };
    })($b6244736105fafa2$var$toUnfoldable(allRels));
    var $101 = $fc8c1182ec2aefec$export$f24224f1c91d8156(items) > 0;
    if ($101) return $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$efe0b24ea4d5137e.create))($9fec91fabe90d735$export$877c9c2e37d22fef(btn)(items));
    return $9fec91fabe90d735$export$3a59c1cf55945abf(btn)([
        $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item whitespace-nowrap")
        ])([
            $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("request-signatures-no-sigs"))
        ])
    ]);
};
var $b6244736105fafa2$export$8b4d9aa5702dece6 = function(state) {
    var selected = $b6244736105fafa2$var$fromFoldable1($f264ceec36a478ad$export$7693e0a1b9351086(state.selection));
    var formPickerEdit = function() {
        if (state.formPicker.reorder) return $b6244736105fafa2$var$button([
            $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$4474bd630dd3ef5b.value))($fc1df90f0e252058$export$1d5a917feb871989),
            $fc1df90f0e252058$export$2913c0c0b5623090("form-picker-re-order-save button btn")
        ])([
            $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("save"))
        ]);
        return $b6244736105fafa2$var$button([
            $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$13ea8ce0e2ccb998.value))($fc1df90f0e252058$export$1d5a917feb871989),
            $fc1df90f0e252058$export$2913c0c0b5623090("form-picker-re-order button btn")
        ])([
            $b6244736105fafa2$var$span([
                $fc1df90f0e252058$export$2913c0c0b5623090("re-order-icon")
            ])([]),
            $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("re-order"))
        ]);
    }();
    var everyDocumentLocked = $396c4c3d9e7fae3c$export$84bf76cd7afc7469(function($122) {
        return $06733ae99ed4f534$export$c15bd07a493e1236(function(v) {
            return v.locked_at;
        }($122));
    })($b6244736105fafa2$var$fromFoldable1($f264ceec36a478ad$export$7693e0a1b9351086(state.selection)));
    var toggleLocksClass = function() {
        if (everyDocumentLocked) return "unlock";
        return "lock";
    }();
    var toggleLocksLabel = function() {
        if (everyDocumentLocked) return "Unlock";
        return "Lock";
    }();
    var canToggleLocks = !$396c4c3d9e7fae3c$export$7b1b591b262c240(selected) && $396c4c3d9e7fae3c$export$84bf76cd7afc7469(function(form) {
        return form.can.lock;
    })(selected);
    var busy = function() {
        if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) return true;
        return false;
    }();
    var bulkActionsVisible = !$b6244736105fafa2$var$isEmpty(state.selection);
    return $b6244736105fafa2$var$div([
        $fc1df90f0e252058$export$2913c0c0b5623090("step-container step-1")
    ])([
        $b6244736105fafa2$var$header([
            $fc1df90f0e252058$export$2913c0c0b5623090("page-header")
        ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
            new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$var$h1([
                $fc1df90f0e252058$export$2913c0c0b5623090("page-heading")
            ])([
                $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("recent-forms"))
            ])),
            $c3ec47a57216184e$export$71e337785367343c(bulkActionsVisible)($b6244736105fafa2$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("mm-land")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("edit-forms-button btn"),
                    $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("edit-forms")),
                    $fc1df90f0e252058$export$683472f6198a076e(busy),
                    $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$9b7abee7a5a9421c.value))($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $b6244736105fafa2$var$span([
                        $fc1df90f0e252058$export$2913c0c0b5623090("edit-forms icon")
                    ])([])
                ])),
                $c3ec47a57216184e$export$71e337785367343c(canToggleLocks)($b6244736105fafa2$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("toggle-lock-forms-button btn " + (toggleLocksClass + "-button")),
                    $fc1df90f0e252058$export$fb184b623420d9be(toggleLocksLabel),
                    $fc1df90f0e252058$export$683472f6198a076e(busy),
                    $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$747c16e05a885c2a.value))($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $b6244736105fafa2$var$span([
                        $fc1df90f0e252058$export$2913c0c0b5623090("icon " + (toggleLocksClass + "-forms"))
                    ])([])
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("copy-forms-button btn"),
                    $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("copy-forms")),
                    $fc1df90f0e252058$export$683472f6198a076e(busy),
                    $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$c7d83595be8c07b1.value))($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $b6244736105fafa2$var$span([
                        $fc1df90f0e252058$export$2913c0c0b5623090("copy-forms icon")
                    ])([])
                ])),
                $c3ec47a57216184e$export$71e337785367343c($b6244736105fafa2$var$notEq(state.formPicker.workQueueCache.account.type)($02eacf321b2a2128$export$98e21ef3f6f7703b.value))($b6244736105fafa2$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("delete-forms-button btn"),
                    $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("delete-forms")),
                    $fc1df90f0e252058$export$683472f6198a076e(busy),
                    $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$864b5c5b705745d2.value))($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $b6244736105fafa2$var$span([
                        $fc1df90f0e252058$export$2913c0c0b5623090("delete-forms icon")
                    ])([])
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$export$f1e27a2fac83e2ad(state)),
                new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$export$db34029061cffdb9(state)),
                new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$export$68d83e8e6018fa1f(state))
            ]))),
            new $06733ae99ed4f534$export$8a67b48435b5d073($b6244736105fafa2$var$button([
                $fc1df90f0e252058$export$2913c0c0b5623090("create-forms-button btn btn-primary"),
                $b6244736105fafa2$var$voidRight(new $7d4cccdf062a2261$export$19db0165690c701a($cc65e4880038a74f$export$67e817d458d93d9f.value))($fc1df90f0e252058$export$1d5a917feb871989)
            ])([
                $b6244736105fafa2$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("create-forms"))
            ]))
        ])),
        $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("form-picker-container")
        ])([
            formPickerEdit,
            $b6244736105fafa2$var$map($b6244736105fafa2$var$map3($7d4cccdf062a2261$export$19db0165690c701a.create)($cc65e4880038a74f$export$60db918807a7b577.create))($812fcffca6747f78$export$f2c4fe0b9282f2cc(state.formPicker))
        ]),
        $b6244736105fafa2$var$div([
            $fc1df90f0e252058$export$2913c0c0b5623090("step-1-right")
        ])([
            $b6244736105fafa2$export$13a0a11de8c7452d(state)
        ])
    ]);
};
var $b6244736105fafa2$export$b713398312c479b1 = function(state) {
    return $b6244736105fafa2$var$bind($85206166a57f2888$export$679d507248f70d11($b6244736105fafa2$var$div$prime([]))($c3328e54cdf5154c$export$5a1a8430df9521e("copy-forms-select-students"))(new $06733ae99ed4f534$export$8a67b48435b5d073({
        "class": state["searchState"]["class"],
        keyword: state.searchState.keyword,
        semester: state.searchState.semester,
        teacher: $7178b396566f5a79$export$5a4818cec1656a71(state.searchState.teacher)($06733ae99ed4f534$export$bebe9059409a0d04.value)
    })))(function(result) {
        return $b6244736105fafa2$var$pure(function() {
            if (result instanceof $035405231d3ae317$export$a09a21bd8097e7) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            if (result instanceof $035405231d3ae317$export$c00f2c00f91f14d5) return new $06733ae99ed4f534$export$8a67b48435b5d073(result.value0.students);
            throw new Error("Failed pattern match at Steps.Step1.View (line 78, column 10 - line 80, column 53): " + [
                result.constructor.name
            ]);
        }());
    });
};
var $b6244736105fafa2$export$4c7a081759aa8d84 = function(state) {
    var modalActionWhileLoading = function(action) {
        if (state.state instanceof $506e78fa6ac73d88$export$29c07d87bcba88bc) {
            if (action instanceof $cc65e4880038a74f$export$c7d83595be8c07b1) return true;
            if (action instanceof $cc65e4880038a74f$export$864b5c5b705745d2) return true;
            if (action instanceof $cc65e4880038a74f$export$efe0b24ea4d5137e) return true;
            if (action instanceof $cc65e4880038a74f$export$1d3f1ab8435af5a9) return true;
            return false;
        }
        return false;
    };
    return $b6244736105fafa2$var$bind($b6244736105fafa2$export$8b4d9aa5702dece6(state))(function(res) {
        if (res instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $b6244736105fafa2$var$pure(new $cc65e4880038a74f$export$1111bee6585f0ea2(res.value0));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a && modalActionWhileLoading(res.value0)) return $b6244736105fafa2$var$pure(new $cc65e4880038a74f$export$a96f88e1928d92fa(res.value0));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a && res.value0 instanceof $cc65e4880038a74f$export$c7d83595be8c07b1) return $b6244736105fafa2$var$map($cc65e4880038a74f$export$51b64cdb4a042e2f.create)($b6244736105fafa2$export$b713398312c479b1(state));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a && res.value0 instanceof $cc65e4880038a74f$export$864b5c5b705745d2) return $b6244736105fafa2$var$map($cc65e4880038a74f$export$43d85b6b81ad99e0.create)($46bd9e377310b7ba$export$50d8d0e36b3c9ab6($b6244736105fafa2$export$13a0a11de8c7452d(state))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-forms-title"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-forms-primary-button"))($c3328e54cdf5154c$export$5a1a8430df9521e("confirm-delete-forms")));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a && res.value0 instanceof $cc65e4880038a74f$export$efe0b24ea4d5137e) return $b6244736105fafa2$var$map($cc65e4880038a74f$export$7183506d59c388b0.create)($36e1806e81661a53$export$ce15b7a86ac7cf30(state.formPicker.workQueueCache.account)($506e78fa6ac73d88$export$c1853cad74b031d9(state))(res.value0.value0));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a && res.value0 instanceof $cc65e4880038a74f$export$1d3f1ab8435af5a9) return $b6244736105fafa2$var$map($cc65e4880038a74f$export$9d697732809bc86.create)($b6244736105fafa2$export$910517ea574cb41e(state)(res.value0.value0));
        if (res instanceof $7d4cccdf062a2261$export$19db0165690c701a) return $b6244736105fafa2$var$pure(new $cc65e4880038a74f$export$a96f88e1928d92fa(res.value0));
        throw new Error("Failed pattern match at Steps.Step1.View (line 44, column 5 - line 62, column 34): " + [
            res.constructor.name
        ]);
    });
};


// Generated by purs version 0.15.16
"use strict";
var $2348dc3206eed71a$var$scrollTarget = "";
const $2348dc3206eed71a$var$maxScrollAttempts = 10;
const $2348dc3206eed71a$var$scheduleScrollAttempt = function(callback) {
    if (typeof window.requestAnimationFrame === "function") window.requestAnimationFrame(callback);
    else setTimeout(callback, 16);
};
const $2348dc3206eed71a$var$scrollAttempt = function(id, attempt) {
    if ($2348dc3206eed71a$var$scrollTarget !== id) return;
    const elem = document.getElementById(id);
    if (elem) {
        elem.scrollIntoView();
        return;
    }
    if (attempt < $2348dc3206eed71a$var$maxScrollAttempts) $2348dc3206eed71a$var$scheduleScrollAttempt(function() {
        $2348dc3206eed71a$var$scrollAttempt(id, attempt + 1);
    });
};
const $2348dc3206eed71a$export$d0464bdbceaf69a = function(id) {
    $2348dc3206eed71a$var$scrollTarget = id;
    return function() {
        $2348dc3206eed71a$var$scheduleScrollAttempt(function() {
            $2348dc3206eed71a$var$scrollAttempt(id, 0);
        });
    };
};







var $f48dee3ee719f840$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $f48dee3ee719f840$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $f48dee3ee719f840$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $f48dee3ee719f840$export$3eb58eff01759a1d = $2348dc3206eed71a$export$d0464bdbceaf69a;
var $f48dee3ee719f840$export$d4b48864589819ac = function(state) {
    return function(sectionId) {
        return $f48dee3ee719f840$var$discard($f48dee3ee719f840$var$liftEffect($2348dc3206eed71a$export$d0464bdbceaf69a(sectionId)))(function() {
            return $f48dee3ee719f840$var$pure(state);
        });
    };
};





// Generated by purs version 0.15.16















// Generated by purs version 0.15.16






























var $76b90321819b207a$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $76b90321819b207a$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $76b90321819b207a$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $76b90321819b207a$var$span = /* #__PURE__ */ $3eadc1b959dd1120$export$afc1bfabebaf28a2($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $76b90321819b207a$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $76b90321819b207a$var$notEq = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e(/* #__PURE__ */ $308f9765feb7633d$export$b59da214efe27c07($37b880af5f4991bd$export$fa624555ca2acbc8)));
var $76b90321819b207a$var$notEq1 = /* #__PURE__ */ $37b880af5f4991bd$export$5475dfc31a65c2cd(/* #__PURE__ */ $06733ae99ed4f534$export$8f45bb76abf9699e($37b880af5f4991bd$export$fa624555ca2acbc8));
var $76b90321819b207a$var$p$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$3cf7d23e34405d00($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $76b90321819b207a$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $76b90321819b207a$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$length = /* #__PURE__ */ $4fe7b6acfba7f29f$export$f24224f1c91d8156($4fe7b6acfba7f29f$export$e97014618a7eb593)($c0e822be92afc4df$export$7e80d6910c05bd77);
var $76b90321819b207a$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($76b90321819b207a$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $76b90321819b207a$var$sigResultF = function(state) {
    return function(v) {
        if (v instanceof $dac1e623683e2554$export$c736b0a2b52ee2ae) return new $004747e47cb4edd5$export$153c58c8dcae1967({
            form: state.form,
            doc: state.doc,
            comments: state.comments,
            attachments: state.attachments,
            preview: state.preview,
            signatures: v.value0
        });
        if (v instanceof $dac1e623683e2554$export$b6f0dd2113b2748d) return new $004747e47cb4edd5$export$9e35bbe1cc73cc01({
            form: state.form,
            doc: state.doc,
            comments: state.comments,
            attachments: state.attachments,
            preview: state.preview,
            signatures: v.value0
        }, function() {
            if (v.value1 instanceof $dac1e623683e2554$export$830e94389988a00a) {
                if (v.value1.value0 instanceof $9e1209acd51c3c43$export$b1fe1f0959298e55) return new $004747e47cb4edd5$export$5d04178ec625702c(state.doc.id, v.value1.value0.value0, v.value1.value0.value1, v.value1.value0.value2);
                if (v.value1.value0 instanceof $9e1209acd51c3c43$export$867457edc5373faa) return new $004747e47cb4edd5$export$f904c183433cbd62(state.doc.id, v.value1.value0.value0);
                if (v.value1.value0 instanceof $9e1209acd51c3c43$export$5a83090ef184a93b) return new $004747e47cb4edd5$export$efe0b24ea4d5137e([
                    v.value1.value0.value0
                ]);
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 150, column 17 - line 156, column 74): " + [
                    v.value1.value0.constructor.name
                ]);
            }
            if (v.value1 instanceof $dac1e623683e2554$export$36d0c4e205277a37) return new $004747e47cb4edd5$export$efe0b24ea4d5137e(v.value1.value0);
            throw new Error("Failed pattern match at Steps.Step3.FormView (line 148, column 61 - line 158, column 54): " + [
                v.value1.constructor.name
            ]);
        }());
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 144, column 20 - line 158, column 54): " + [
            v.constructor.name
        ]);
    };
};
var $76b90321819b207a$var$setTeacherSelect = function(state) {
    return function(teacher) {
        return {
            ui: {
                expandedStudents: state.workQueueUi.expandedStudents,
                search: state.workQueueUi.search,
                semester: state.workQueueUi.semester,
                teacher: teacher
            },
            state: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                semester: state.workQueueState.semester,
                teacher: $76b90321819b207a$var$map(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(teacher))
            }
        };
    };
};
var $76b90321819b207a$var$setSemesterSelect = function(state) {
    return function(semester) {
        return {
            ui: {
                expandedStudents: state.workQueueUi.expandedStudents,
                search: state.workQueueUi.search,
                teacher: state.workQueueUi.teacher,
                semester: semester
            },
            state: {
                forms: state.workQueueState.forms,
                students: state.workQueueState.students,
                documents: state.workQueueState.documents,
                editDocs: state.workQueueState.editDocs,
                currentDoc: state.workQueueState.currentDoc,
                teacher: state.workQueueState.teacher,
                semester: $76b90321819b207a$var$map(function(v1) {
                    return v1.value;
                })($7178b396566f5a79$export$127d1aaaa65102b1(semester))
            }
        };
    };
};
var $76b90321819b207a$var$renderLockBanner = function(busy) {
    return function(fstate) {
        var bannerShowsUnlock = function(v) {
            if (v instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return true;
            if (v instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return true;
            return false;
        };
        var v = function(v1) {
            return v1.lockedBanner;
        }($004747e47cb4edd5$export$7da4e93a98b07b0(fstate));
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return [];
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
            var msg = $c3328e54cdf5154c$export$5a1a8430df9521e(function() {
                if (v.value0 instanceof $d80c98e0cfb5ecff$export$f899e8621fb9fc2e) return "form-locked-banner-message-mutable";
                if (v.value0 instanceof $d80c98e0cfb5ecff$export$3382853a93f59725) return "form-locked-banner-message-mutable-unprivileged";
                if (v.value0 instanceof $d80c98e0cfb5ecff$export$d7c139d4ebed1869) return "form-locked-banner-message";
                if (v.value0 instanceof $d80c98e0cfb5ecff$export$aa769cc8574b3ea5) return "form-locked-banner-message-unprivileged";
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 196, column 39 - line 200, column 84): " + [
                    v.value0.constructor.name
                ]);
            }());
            return [
                $76b90321819b207a$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("lock-banner")
                ])($76b90321819b207a$var$append([
                    $76b90321819b207a$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("lock-banner-content")
                    ])([
                        $76b90321819b207a$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("lock-banner-icon"),
                            $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("locked"))
                        ])([]),
                        $76b90321819b207a$var$span([
                            $fc1df90f0e252058$export$2913c0c0b5623090("lock-banner-message")
                        ])([
                            $76b90321819b207a$var$text(msg)
                        ])
                    ])
                ])(function() {
                    var $73 = bannerShowsUnlock(v.value0);
                    if ($73) return [
                        $76b90321819b207a$var$button($76b90321819b207a$var$append([
                            $fc1df90f0e252058$export$683472f6198a076e(busy),
                            $fc1df90f0e252058$export$1741e49665a9c8e8("button"),
                            $fc1df90f0e252058$export$2913c0c0b5623090("btn lock-banner-button")
                        ])(function() {
                            if (busy) return [];
                            return [
                                $76b90321819b207a$var$voidRight($004747e47cb4edd5$export$6b3072bafbdce7c.value)($fc1df90f0e252058$export$1d5a917feb871989)
                            ];
                        }()))([
                            $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("unlock"))
                        ])
                    ];
                    return [];
                }()))
            ];
        }
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 192, column 32 - line 222, column 10): " + [
            v.constructor.name
        ]);
    };
};
var $76b90321819b207a$var$previewStateChangeF = function(state) {
    return function(pstate) {
        return new $004747e47cb4edd5$export$153c58c8dcae1967({
            form: state.form,
            doc: state.doc,
            comments: state.comments,
            attachments: state.attachments,
            signatures: state.signatures,
            preview: pstate
        });
    };
};
var $76b90321819b207a$var$metadataStateChangeF = function(previous) {
    return function(next) {
        var metadataChanged = $76b90321819b207a$var$notEq($76b90321819b207a$var$map(function(v) {
            return v.id;
        })(previous.workQueueState.teacher))($76b90321819b207a$var$map(function(v) {
            return v.id;
        })(next.state.teacher)) || $76b90321819b207a$var$notEq1($76b90321819b207a$var$map(function(v) {
            return v.semester;
        })(previous.workQueueState.semester))($76b90321819b207a$var$map(function(v) {
            return v.semester;
        })(next.state.semester));
        if (metadataChanged) return new $004747e47cb4edd5$export$91696afd1b09da8d(next.state, next.ui);
        return new $004747e47cb4edd5$export$804e7e4188df63ae(new $356f5ce902fa042d$export$a80f920dd4c867c2(next.ui));
    };
};
var $76b90321819b207a$var$formResultF = function(v) {
    return function(v1) {
        if (v1.value0.action instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return new $004747e47cb4edd5$export$153c58c8dcae1967({
            doc: v.doc,
            comments: v.comments,
            attachments: v.attachments,
            preview: v.preview,
            signatures: v.signatures,
            form: v1.value0.state
        });
        if (v1.value0.action instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $004747e47cb4edd5$export$ce23c5d6d3d89659(v1.value0.action.value0, {
            doc: v.doc,
            comments: v.comments,
            attachments: v.attachments,
            preview: v.preview,
            signatures: v.signatures,
            form: v1.value0.state
        });
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 110, column 1 - line 110, column 77): " + [
            v.constructor.name,
            v1.constructor.name
        ]);
    };
};
var $76b90321819b207a$var$commentResultF = function(state) {
    return function(v) {
        if (v instanceof $a225fa54d4056a34$export$f5f2dd33c99a3161) return new $004747e47cb4edd5$export$153c58c8dcae1967({
            form: state.form,
            doc: state.doc,
            attachments: state.attachments,
            preview: state.preview,
            signatures: state.signatures,
            comments: v.value0
        });
        if (v instanceof $a225fa54d4056a34$export$5bdd10416d35ee91) return new $004747e47cb4edd5$export$9e35bbe1cc73cc01(state, function() {
            if (v.value0 instanceof $a225fa54d4056a34$export$b217475cf0d7b767) return new $004747e47cb4edd5$export$b217475cf0d7b767(state.doc.id, v.value0.value0);
            if (v.value0 instanceof $a225fa54d4056a34$export$45f887c8c5fa0732) return new $004747e47cb4edd5$export$45f887c8c5fa0732(state.doc.id, v.value0.value0, v.value0.value1);
            if (v.value0 instanceof $a225fa54d4056a34$export$3e7441b70abfe107) return new $004747e47cb4edd5$export$5ec1b5bc07c6cb4d(state.doc.id, v.value0.value0);
            throw new Error("Failed pattern match at Steps.Step3.FormView (line 124, column 35 - line 130, column 64): " + [
                v.value0.constructor.name
            ]);
        }());
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 120, column 24 - line 130, column 64): " + [
            v.constructor.name
        ]);
    };
};
var $76b90321819b207a$var$attachmentResultF = function(state) {
    return function(v) {
        if (v instanceof $67a3c28b4000eb60$export$cb0f28399d4f8d9f) return new $004747e47cb4edd5$export$153c58c8dcae1967({
            form: state.form,
            doc: state.doc,
            comments: state.comments,
            preview: state.preview,
            signatures: state.signatures,
            attachments: v.value0
        });
        if (v instanceof $67a3c28b4000eb60$export$1a210fc06576eae8) return new $004747e47cb4edd5$export$9e35bbe1cc73cc01(state, function() {
            if (v.value0 instanceof $67a3c28b4000eb60$export$d70fd387bd54d491) return new $004747e47cb4edd5$export$d70fd387bd54d491(state.doc.id, v.value0.value0);
            if (v.value0 instanceof $67a3c28b4000eb60$export$79720b9e56216340) return new $004747e47cb4edd5$export$a4c37d342183ceb6(state.doc.id, v.value0.value0);
            throw new Error("Failed pattern match at Steps.Step3.FormView (line 137, column 35 - line 141, column 70): " + [
                v.value0.constructor.name
            ]);
        }());
        throw new Error("Failed pattern match at Steps.Step3.FormView (line 133, column 27 - line 141, column 70): " + [
            v.constructor.name
        ]);
    };
};
var $76b90321819b207a$var$renderFormFillState = function(signatures) {
    return function(busy) {
        return function(state) {
            var formContextForBusy = function() {
                var context = $004747e47cb4edd5$export$5176e9d4c30fcf2b(state.workQueueCache)(state.fillState);
                if (busy) return {
                    account: context.account,
                    autofillArgs: context.autofillArgs,
                    curIndex: context.curIndex,
                    doc: context.doc,
                    isAutofilling: context.isAutofilling,
                    parentIds: context.parentIds,
                    access: {
                        "default": $81439e1d9c94314f$export$3dddd772b5443db6.value,
                        fields: []
                    }
                };
                return context;
            }();
            var semesterTranslation = function() {
                if (state.fillState.doc.can.update) return "semester-hidden-select";
                if ($5089f43af3d55e5d$export$4bed41887d8c5096) return "semester-hidden-select-locked";
                throw new Error("Failed pattern match at Steps.Step3.FormView (line 98, column 5 - line 100, column 54): ");
            }();
            return $76b90321819b207a$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-3-right form-submission relative")
            ])($76b90321819b207a$var$append($76b90321819b207a$var$renderLockBanner(busy)(state.fillState))($76b90321819b207a$var$append(function() {
                var $101 = $6be45a9e147fc393$export$2a52fb62023dd743(state.workQueueState);
                if ($101) return [];
                return [
                    $76b90321819b207a$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("error")
                    ])([
                        $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("must-select-teacher-semester"))
                    ])
                ];
            }())($76b90321819b207a$var$append([
                $76b90321819b207a$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("teacher-semester-selections")
                ])([
                    $76b90321819b207a$var$p$prime([
                        $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e(semesterTranslation))
                    ]),
                    function() {
                        var $102 = busy && state.fillState.doc.can.update;
                        if ($102) return $c1518ffd015b44e8$export$5f43cd3c5edf858b(state.workQueueUi.semester);
                        if (state.fillState.doc.can.update) return $76b90321819b207a$var$map1($76b90321819b207a$var$map2($76b90321819b207a$var$metadataStateChangeF(state))($76b90321819b207a$var$setSemesterSelect(state)))($c1518ffd015b44e8$export$d167388450b383cf(state.workQueueUi.semester));
                        return $c1518ffd015b44e8$export$ca565b3ecdd6c5ae(state.workQueueUi.semester);
                    }(),
                    $76b90321819b207a$var$p$prime([
                        $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("teacher-hidden-select"))
                    ]),
                    function() {
                        var $104 = busy && state.fillState.doc.can.update;
                        if ($104) return $c1518ffd015b44e8$export$5f43cd3c5edf858b(state.workQueueUi.teacher);
                        if (state.fillState.doc.can.update) return $76b90321819b207a$var$map1($76b90321819b207a$var$map2($76b90321819b207a$var$metadataStateChangeF(state))($76b90321819b207a$var$setTeacherSelect(state)))($c1518ffd015b44e8$export$d167388450b383cf(state.workQueueUi.teacher));
                        return $c1518ffd015b44e8$export$ca565b3ecdd6c5ae(state.workQueueUi.teacher);
                    }()
                ]),
                $76b90321819b207a$var$map1($76b90321819b207a$var$formResultF(state.fillState))($fce7eb63608cf274$export$9750270299d2035e(formContextForBusy)(state.fillState.form))
            ])(function() {
                var $106 = !signatures;
                if ($106) return [];
                return $76b90321819b207a$var$append([
                    $76b90321819b207a$var$p$prime([
                        $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("save-before-preview"))
                    ]),
                    $76b90321819b207a$var$a([
                        $fc1df90f0e252058$export$9c7ae676ac45430a("signature-anchor")
                    ])([]),
                    $76b90321819b207a$var$map1($76b90321819b207a$var$previewStateChangeF(state.fillState))($47387374ebaf9fda$export$65e6ebc64486f6b3(state.fillState.preview)),
                    $76b90321819b207a$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("signatures")
                    ])(function() {
                        var $107 = $76b90321819b207a$var$length(state.fillState.signatures.sigs) > 0;
                        if ($107) return [
                            $76b90321819b207a$var$h1([
                                $fc1df90f0e252058$export$2913c0c0b5623090("signatures-heading")
                            ])([
                                $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("sign"))
                            ]),
                            $76b90321819b207a$var$map1($76b90321819b207a$var$sigResultF(state.fillState))($dac1e623683e2554$export$c0507b2ebcc161de(state.fillState.signatures))
                        ];
                        return [];
                    }()),
                    $76b90321819b207a$var$map1($76b90321819b207a$var$commentResultF(state.fillState))($a225fa54d4056a34$export$c62a7fe39465fd55(state.fillState.comments)),
                    $76b90321819b207a$var$map1($76b90321819b207a$var$attachmentResultF(state.fillState))($67a3c28b4000eb60$export$b93ea6ce0cf08c89(state.fillState.attachments)),
                    $76b90321819b207a$var$div([
                        $fc1df90f0e252058$export$2913c0c0b5623090("form-updated-times")
                    ])([
                        $76b90321819b207a$var$p$prime([
                            $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("form-created-at") + (" " + $35e75b0a064776f5$export$cde3d1388a9feac3(state.fillState.doc.created_at)))
                        ]),
                        $76b90321819b207a$var$p$prime([
                            $76b90321819b207a$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("form-updated-at") + (" " + $35e75b0a064776f5$export$cde3d1388a9feac3(state.fillState.doc.updated_at)))
                        ])
                    ])
                ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    function() {
                        if (busy) return new $06733ae99ed4f534$export$8a67b48435b5d073($76b90321819b207a$var$div([
                            $fc1df90f0e252058$export$2913c0c0b5623090("loading-overlay step-3-loading-overlay")
                        ])([
                            $b5330906fcd65ffd$export$d558900b1478007d
                        ]));
                        return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                    }()
                ]));
            }()))));
        };
    };
};
var $76b90321819b207a$export$2abc154e29642458 = function(signatures) {
    return function(busy) {
        return function(state) {
            return $76b90321819b207a$var$renderFormFillState(signatures)(busy)(state);
        };
    };
};








var $ee5accd64b1edbdf$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $ee5accd64b1edbdf$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $ee5accd64b1edbdf$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $ee5accd64b1edbdf$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $ee5accd64b1edbdf$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $ee5accd64b1edbdf$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $ee5accd64b1edbdf$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $ee5accd64b1edbdf$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $ee5accd64b1edbdf$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $ee5accd64b1edbdf$var$a = /* #__PURE__ */ $3eadc1b959dd1120$export$407448d2b89b1813($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$header = /* #__PURE__ */ $3eadc1b959dd1120$export$38e42c68cf43b5d4($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$h1 = /* #__PURE__ */ $3eadc1b959dd1120$export$448e4850cad7c7b0($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$h2 = /* #__PURE__ */ $3eadc1b959dd1120$export$a943aa9a0fca3f0b($ee5accd64b1edbdf$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $ee5accd64b1edbdf$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $ee5accd64b1edbdf$var$renderWorkQueue = function(preservedQuery) {
    return function(state) {
        return $ee5accd64b1edbdf$var$bind($356f5ce902fa042d$export$fa5a12c391dc617d(preservedQuery)(state.editor.workQueueState)(state.editor.workQueueUi)(state.editor.workQueueCache))(function(result) {
            if (result instanceof $356f5ce902fa042d$export$d25f9f533b57ed2) return $ee5accd64b1edbdf$var$discard($ee5accd64b1edbdf$var$liftEffect($dbcf9655740e50d9$export$fa3b29edae795ef4(result.value1)))(function() {
                return $ee5accd64b1edbdf$var$pure(new $004747e47cb4edd5$export$804e7e4188df63ae(result));
            });
            return $ee5accd64b1edbdf$var$pure(new $004747e47cb4edd5$export$804e7e4188df63ae(result));
        });
    };
};
var $ee5accd64b1edbdf$var$renderExportDropdown = function(v) {
    return function(v1) {
        if (v1.editor.fillState.doc.exports.length === 0) return $ee5accd64b1edbdf$var$div$prime([]);
        if (v1.editor.fillState.doc.exports.length === 1) return $ee5accd64b1edbdf$var$button([
            $ee5accd64b1edbdf$var$voidRight(new $004747e47cb4edd5$export$f5fbd132133a04d(v1["editor"]["fillState"]["doc"]["exports"][0]))($fc1df90f0e252058$export$1d5a917feb871989),
            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-export"),
            $fc1df90f0e252058$export$683472f6198a076e(v)
        ])([
            $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("export"))
        ]);
        var mkItem = function($$export) {
            return {
                label: $$export.label,
                value: $$export
            };
        };
        var items = $ee5accd64b1edbdf$var$map(mkItem)(v1.editor.fillState.doc.exports);
        var button1 = $ee5accd64b1edbdf$var$button([
            $fc1df90f0e252058$export$1d5a917feb871989,
            $fc1df90f0e252058$export$683472f6198a076e(v || !$6be45a9e147fc393$export$2a52fb62023dd743(v1.editor.workQueueState)),
            $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-export")
        ])([
            $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("export"))
        ]);
        return $ee5accd64b1edbdf$var$map1($004747e47cb4edd5$export$f5fbd132133a04d.create)($9fec91fabe90d735$export$877c9c2e37d22fef(button1)(items));
    };
};
var $ee5accd64b1edbdf$var$renderHeader = function(busy) {
    return function(state) {
        var lockToggleLabel = function(v) {
            return function(v1) {
                if (v && v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c3328e54cdf5154c$export$5a1a8430df9521e("save-and-lock");
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $c3328e54cdf5154c$export$5a1a8430df9521e("lock");
                if (v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c3328e54cdf5154c$export$5a1a8430df9521e("unlock");
                throw new Error("Failed pattern match at Steps.Step3.View (line 149, column 5 - line 149, column 62): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var lockToggleActionClass = function(v) {
            if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return "lock-document-action";
            if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return "unlock-document-action";
            throw new Error("Failed pattern match at Steps.Step3.View (line 154, column 5 - line 154, column 57): " + [
                v.constructor.name
            ]);
        };
        var lockToggleItem = function() {
            if (state.editor.fillState.doc.can.lock) return [
                $ee5accd64b1edbdf$var$a([
                    function() {
                        if (busy) return $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item disabled whitespace-nowrap");
                        return $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$6b3072bafbdce7c.value)($fc1df90f0e252058$export$1d5a917feb871989);
                    }(),
                    $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item whitespace-nowrap " + (lockToggleActionClass(state.editor.fillState.doc.locked_at) + function() {
                        if (busy) return " disabled";
                        return "";
                    }()))
                ])([
                    $ee5accd64b1edbdf$var$text(lockToggleLabel($842627c31b5244a8$export$7e2e85b632e93ac2(state))(state.editor.fillState.doc.locked_at))
                ])
            ];
            return [];
        }();
        var dropBtn = $ee5accd64b1edbdf$var$button([
            $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-button"),
            $fc1df90f0e252058$export$1d5a917feb871989
        ])([
            $ee5accd64b1edbdf$var$text("\u2807")
        ]);
        var disableSave = busy || !$004747e47cb4edd5$export$9a86059719a658b0(state.editor.fillState) || !$6be45a9e147fc393$export$2a52fb62023dd743(state.editor.workQueueState);
        var disableNext = function() {
            var $56 = $004747e47cb4edd5$export$a3f5e6a68ce798dd(state.editor);
            if ($56) return busy || !$6be45a9e147fc393$export$2a52fb62023dd743(state.editor.workQueueState);
            return !$6be45a9e147fc393$export$2a52fb62023dd743(state.editor.workQueueState);
        }();
        var autofillItem = function() {
            if (busy) return [
                $ee5accd64b1edbdf$var$a([
                    $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item disabled whitespace-nowrap autofill-form-action")
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("autofill-form-button"))
                ])
            ];
            var $58 = $06733ae99ed4f534$export$4967676db1b89293(state.editor.fillState.doc.locked_at);
            if ($58) return [
                $ee5accd64b1edbdf$var$a([
                    $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$e1e34d312d713b51.value)($fc1df90f0e252058$export$1d5a917feb871989),
                    $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item whitespace-nowrap autofill-form-action")
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("autofill-form-button"))
                ])
            ];
            return [
                $ee5accd64b1edbdf$var$a([
                    $fc1df90f0e252058$export$2913c0c0b5623090("dropdown-item disabled whitespace-nowrap autofill-form-action"),
                    $fc1df90f0e252058$export$fb184b623420d9be($c3328e54cdf5154c$export$5a1a8430df9521e("autofill-disabled-reason-lock"))
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("autofill-form-button"))
                ])
            ];
        }();
        return $ee5accd64b1edbdf$var$header([
            $fc1df90f0e252058$export$2913c0c0b5623090("page-header")
        ])([
            $ee5accd64b1edbdf$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("page-headings")
            ])([
                $ee5accd64b1edbdf$var$h1([
                    $fc1df90f0e252058$export$2913c0c0b5623090("page-heading")
                ])([
                    $ee5accd64b1edbdf$var$text($b05aa108190eac05$export$d50a55988135660c(state.editor.workQueueCache.account)(state.editor.fillState.doc.student))
                ]),
                $ee5accd64b1edbdf$var$h2([
                    $fc1df90f0e252058$export$2913c0c0b5623090("page-subheading")
                ])([
                    $ee5accd64b1edbdf$var$text(state.editor.fillState.form.label)
                ])
            ]),
            $ee5accd64b1edbdf$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("btn-group")
            ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                new $06733ae99ed4f534$export$8a67b48435b5d073($ee5accd64b1edbdf$var$button([
                    $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$e3a394a4520b57d.value)($fc1df90f0e252058$export$1d5a917feb871989),
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-cancel"),
                    $fc1df90f0e252058$export$683472f6198a076e(busy)
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("cancel"))
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($ee5accd64b1edbdf$var$renderExportDropdown(busy)(state)),
                new $06733ae99ed4f534$export$8a67b48435b5d073($ee5accd64b1edbdf$var$button([
                    $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$e685275cfc27c6c5.value)($fc1df90f0e252058$export$1d5a917feb871989),
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-save btn-primary"),
                    $fc1df90f0e252058$export$683472f6198a076e(disableSave)
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("save"))
                ])),
                $c3ec47a57216184e$export$71e337785367343c(!$004747e47cb4edd5$export$a2f4038426073961(state.editor))($ee5accd64b1edbdf$var$button([
                    $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$c4ad6737b29d969c.value)($fc1df90f0e252058$export$1d5a917feb871989),
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-previous")
                ])([
                    $ee5accd64b1edbdf$var$text($c3328e54cdf5154c$export$5a1a8430df9521e("prev"))
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($ee5accd64b1edbdf$var$button([
                    $ee5accd64b1edbdf$var$voidRight($004747e47cb4edd5$export$7ede261876d0a33b.value)($fc1df90f0e252058$export$1d5a917feb871989),
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn btn-next btn-primary"),
                    $fc1df90f0e252058$export$683472f6198a076e(disableNext)
                ])([
                    $ee5accd64b1edbdf$var$text(function() {
                        var $59 = $004747e47cb4edd5$export$a3f5e6a68ce798dd(state.editor);
                        if ($59) return $c3328e54cdf5154c$export$5a1a8430df9521e("finish");
                        return $c3328e54cdf5154c$export$5a1a8430df9521e("next");
                    }())
                ])),
                new $06733ae99ed4f534$export$8a67b48435b5d073($9fec91fabe90d735$export$3a59c1cf55945abf(dropBtn)($ee5accd64b1edbdf$var$append1(autofillItem)(lockToggleItem)))
            ]))
        ]);
    };
};
var $ee5accd64b1edbdf$var$renderEditorPane = function(renderOptions) {
    return function(busy) {
        return function(state) {
            return $76b90321819b207a$export$2abc154e29642458(renderOptions.signatures)(busy)(state.editor);
        };
    };
};
var $ee5accd64b1edbdf$export$5decbae53efc29cf = function(renderOptions) {
    return function(preservedQuery) {
        return function(state) {
            var busy = $842627c31b5244a8$export$fba9605fc9710e5b(state);
            return $ee5accd64b1edbdf$var$div([
                $fc1df90f0e252058$export$2913c0c0b5623090("step-3-scroll overflow-y-auto")
            ])([
                $ee5accd64b1edbdf$var$div([
                    $fc1df90f0e252058$export$2913c0c0b5623090("step-container step-3"),
                    $fc1df90f0e252058$export$df61b30b684217c0("step-3-container"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a("step-3-container")
                ])($396c4c3d9e7fae3c$export$986c2bbe7a34be0b([
                    $c3ec47a57216184e$export$71e337785367343c(renderOptions.sideAndTopBar)($ee5accd64b1edbdf$var$renderHeader(busy)(state)),
                    $c3ec47a57216184e$export$71e337785367343c(renderOptions.sideAndTopBar)($ee5accd64b1edbdf$var$renderWorkQueue(preservedQuery)(state)),
                    new $06733ae99ed4f534$export$8a67b48435b5d073($ee5accd64b1edbdf$var$renderEditorPane(renderOptions)(busy)(state))
                ]))
            ]);
        };
    };
};







// Generated by purs version 0.15.16




























// Generated by purs version 0.15.16















var $37ba48106011150d$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $37ba48106011150d$var$div = /* #__PURE__ */ $3eadc1b959dd1120$export$159d9494db57879b(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $37ba48106011150d$var$input = /* #__PURE__ */ $3eadc1b959dd1120$export$b7e3ae3d7c15e42e($d4ad4a12c540b680$export$5d6626409df85f18);
var $37ba48106011150d$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $37ba48106011150d$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fc1df90f0e252058$export$1b20d35107c3eb06);
var $37ba48106011150d$var$map2 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $37ba48106011150d$export$20b1d7061d50817f = function(x) {
    return x;
};
var $37ba48106011150d$export$fb9fc2cd92c1bf4c = /* #__PURE__ */ $2c6b3d51d10471a7$export$28b0be767d2bc2c2()()(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "cls";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "id";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "label";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$70f8f8693d114c9d({
    reflectSymbol: function() {
        return "placeholder";
    }
})(/* #__PURE__ */ $2c6b3d51d10471a7$export$d57593979a3bd7f3({
    reflectSymbol: function() {
        return "value";
    }
})($2c6b3d51d10471a7$export$e4b6cd05df3043f6))(/* #__PURE__ */ $06733ae99ed4f534$export$9b814e760fdd264a($2c6b3d51d10471a7$export$e4b6cd05df3043f6)))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6))($2c6b3d51d10471a7$export$e4b6cd05df3043f6));
var $37ba48106011150d$export$7426ea75dfc0194f = {
    getId: function(v) {
        return v.id;
    },
    isLeaf: function(v) {
        return true;
    },
    asField: function(v) {
        return new $06733ae99ed4f534$export$8a67b48435b5d073(new $266cd1b01131a218$export$3735341669894528(v.id));
    },
    fieldPaths: function(fc) {
        return function(v) {
            return [
                $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id)
            ];
        };
    },
    toWidget: function(fc) {
        return function(v) {
            var id = $f388db8e60bd7b97$export$20223e4a23036829(fc)(v.id);
            return $37ba48106011150d$var$map($f388db8e60bd7b97$export$e0d76edcf577b85d)($37ba48106011150d$var$div([
                $fc1df90f0e252058$export$df61b30b684217c0(id),
                $fc1df90f0e252058$export$2913c0c0b5623090($f388db8e60bd7b97$export$c81c5cb05f170172(v))
            ])([
                $13f400606229606c$export$cc2d6a1959a4b653(fc)(v)([
                    $fc1df90f0e252058$export$2913c0c0b5623090("block w-full")
                ]),
                $37ba48106011150d$var$input($37ba48106011150d$var$append([
                    $fc1df90f0e252058$export$1741e49665a9c8e8("email"),
                    $fc1df90f0e252058$export$9c7ae676ac45430a(id),
                    $fc1df90f0e252058$export$a8ff84c12d48cfa6(id),
                    $fc1df90f0e252058$export$2ab9a8f9f1186f14(v.value),
                    $fc1df90f0e252058$export$2913c0c0b5623090("widget-input"),
                    $fc1df90f0e252058$export$c7187bbd1a7a9244($06733ae99ed4f534$export$43db023a260c5e9f("")(v.placeholder)),
                    $37ba48106011150d$var$map1($37ba48106011150d$var$map2($37ba48106011150d$var$map2($37ba48106011150d$export$20b1d7061d50817f)(function(v1) {
                        return {
                            cls: v.cls,
                            id: v.id,
                            label: v.label,
                            placeholder: v.placeholder,
                            value: v1
                        };
                    }))($fc1df90f0e252058$export$b79fd9f386367d78))($fc1df90f0e252058$export$7fbc06d7c1beb512)
                ])($f388db8e60bd7b97$export$fa08b6e125c129f2(fc)(v.id)))
            ]));
        };
    },
    getData: function(v) {
        return function(v1) {
            return $0e031af7428ef07d$export$dbafa4424a806c15(v1.value);
        };
    },
    setData: function(v) {
        return function(v1) {
            return $f388db8e60bd7b97$export$89aa195e4b27a289($37ba48106011150d$export$7426ea75dfc0194f)($e2b1be82a5e6d14f$export$12808118396f3c8d)(v1)(function(val) {
                return new $7d4cccdf062a2261$export$19db0165690c701a({
                    id: v1.id,
                    label: v1.label,
                    cls: v1.cls,
                    placeholder: v1.placeholder,
                    value: val
                });
            });
        };
    }
};













var $7eb5302f7c7694e0$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $7eb5302f7c7694e0$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($06733ae99ed4f534$export$e5fea5661dee377);
var $7eb5302f7c7694e0$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $7eb5302f7c7694e0$var$toEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $7eb5302f7c7694e0$var$toEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$2f59e9c675f625db);
var $7eb5302f7c7694e0$var$toEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $7eb5302f7c7694e0$var$toEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $7eb5302f7c7694e0$var$toEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $7eb5302f7c7694e0$var$toEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $7eb5302f7c7694e0$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($06733ae99ed4f534$export$b203ef4465f15037);
var $7eb5302f7c7694e0$var$wrapFormWidget = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($5ad0c5cefd7afaff$export$6f4d8ebc6c25c0df)($5ad0c5cefd7afaff$export$26648b7387036154);
var $7eb5302f7c7694e0$var$wrapFormWidget1 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($2fd2989913f99c64$export$a77c57f8fa54a627)($2fd2989913f99c64$export$9e9b7e1175ea331f);
var $7eb5302f7c7694e0$var$wrapFormWidget2 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($3af393d861aaaf77$export$14679d9abc92670b)($3af393d861aaaf77$export$9dbe1a5a7e1995c1);
var $7eb5302f7c7694e0$var$wrapFormWidget3 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($2fd2989913f99c64$export$8777dc55d64e140)($2fd2989913f99c64$export$92b3581604414b0a);
var $7eb5302f7c7694e0$var$wrapFormWidget4 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($b19cb68dd93bf4c1$export$fe5418acfa42da9e)($b19cb68dd93bf4c1$export$bc80505b76c642f0);
var $7eb5302f7c7694e0$var$wrapFormWidget5 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($69c473d702e5e00f$export$5316176e0fd7f3d5)($69c473d702e5e00f$export$a85953353e087abc);
var $7eb5302f7c7694e0$var$wrapFormWidget6 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($288e43cb19fd2375$export$20f7a753325ed093)($288e43cb19fd2375$export$e9f4c78d39320de);
var $7eb5302f7c7694e0$var$wrapFormWidget7 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($288e43cb19fd2375$export$e9014fcd4be488a9)($288e43cb19fd2375$export$73fa222918a29d85);
var $7eb5302f7c7694e0$var$wrapFormWidget8 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($1bc1b1bbc920ab10$export$1d9d0fcff8299be5)($1bc1b1bbc920ab10$export$1702eac557f573c7);
var $7eb5302f7c7694e0$var$wrapFormWidget9 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($c7751bfafd6f01fa$export$3d83496e0716088c)($c7751bfafd6f01fa$export$573333f6a7e22334);
var $7eb5302f7c7694e0$var$wrapFormWidget10 = /* #__PURE__ */ $3af393d861aaaf77$export$6ad962f6572282b5($7ecd539579e10f1a$export$2b89428e175ed52)($7ecd539579e10f1a$export$82deae0194ea4699);
var $7eb5302f7c7694e0$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e)($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $7eb5302f7c7694e0$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $7eb5302f7c7694e0$var$log = /* #__PURE__ */ $ec52a8164fabd1b2$export$bef1f36f5486a6a3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $7eb5302f7c7694e0$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $7eb5302f7c7694e0$var$multiAlternativeWidget = /* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4);
var $7eb5302f7c7694e0$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea($7eb5302f7c7694e0$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7eb5302f7c7694e0$var$button = /* #__PURE__ */ $3eadc1b959dd1120$export$2ba01fb71ed41cb6($7eb5302f7c7694e0$var$multiAlternativeWidget)($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $7eb5302f7c7694e0$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fc1df90f0e252058$export$1b20d35107c3eb06);
var $7eb5302f7c7694e0$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $7eb5302f7c7694e0$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $7eb5302f7c7694e0$export$b820fc49f2736e85 = /* #__PURE__ */ function() {
    function Next(value0) {
        this.value0 = value0;
    }
    Next.create = function(value0) {
        return new Next(value0);
    };
    return Next;
}();
var $7eb5302f7c7694e0$export$fcc683c36751f67a = /* #__PURE__ */ function() {
    function Reset() {}
    Reset.value = new Reset();
    return Reset;
}();
var $7eb5302f7c7694e0$export$f40c6e7dc733ed84 = /* #__PURE__ */ function() {
    function ShowShape() {}
    ShowShape.value = new ShowShape();
    return ShowShape;
}();
var $7eb5302f7c7694e0$export$216f8314a26a271a = /* #__PURE__ */ function() {
    function TestLoad() {}
    TestLoad.value = new TestLoad();
    return TestLoad;
}();
var $7eb5302f7c7694e0$export$f01b4a57670a71ed = /* #__PURE__ */ $7eb5302f7c7694e0$var$fromJust(/* #__PURE__ */ $7eb5302f7c7694e0$var$bind(/* #__PURE__ */ $7eb5302f7c7694e0$var$toEnum(1984))(function(year) {
    return $7eb5302f7c7694e0$var$bind($7eb5302f7c7694e0$var$toEnum1(1))(function(month) {
        return $7eb5302f7c7694e0$var$bind($7eb5302f7c7694e0$var$toEnum2(1))(function(day) {
            return $7577649a7445e8e0$export$4803c954abcb09a(year)(month)(day);
        });
    });
}));
var $7eb5302f7c7694e0$export$8f06766182c8854d = /* #__PURE__ */ $7eb5302f7c7694e0$var$fromJust(/* #__PURE__ */ $7eb5302f7c7694e0$var$bind(/* #__PURE__ */ $7eb5302f7c7694e0$var$toEnum3(8))(function(hour) {
    return $7eb5302f7c7694e0$var$bind($7eb5302f7c7694e0$var$toEnum4(0))(function(minute) {
        return $7eb5302f7c7694e0$var$bind($7eb5302f7c7694e0$var$toEnum5(0))(function(second) {
            return $7eb5302f7c7694e0$var$bind($7eb5302f7c7694e0$var$toEnum6(0))(function(ms) {
                var time = new $d254595454e6e9b0$export$680ea196effce5f(hour, minute, second, ms);
                return $7eb5302f7c7694e0$var$pure(new $18f2b327b2ac3376$export$82f9ebd9adeba146($7eb5302f7c7694e0$export$f01b4a57670a71ed, time));
            });
        });
    });
}));
var $7eb5302f7c7694e0$export$b9a314a6a303ea0a = /* #__PURE__ */ function() {
    return {
        id: $308f9765feb7633d$export$a7f53fa461221c79("test"),
        label: "Test",
        access: $81439e1d9c94314f$export$e3358a95f047f6be,
        fields: [
            $7eb5302f7c7694e0$var$wrapFormWidget({
                id: "header",
                label: "Test:",
                cls: "text-lg"
            }),
            $3af393d861aaaf77$export$6ad962f6572282b5($38dfaea68b931435$export$40abf1bc8801220)($38dfaea68b931435$export$7d4e502ec7dc4005)($38dfaea68b931435$export$969bb0591ac6da53({
                id: "employer-select",
                cls: "",
                label: "Employer select",
                contact: true
            })),
            $3af393d861aaaf77$export$6ad962f6572282b5($a9fb419bc59bee5b$export$5d6d38a4d18da67f)($a9fb419bc59bee5b$export$7aeedf9e2a191a80)(new $a9fb419bc59bee5b$export$b29794ea55b1711f({
                id: "student-subform",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("<b>Student Information</b>"),
                labelClass: "",
                cls: "",
                section: true,
                collapsible: true,
                expanded: true,
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget1({
                        id: "name",
                        label: "Student Name",
                        cls: "",
                        placeholder: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                        value: ""
                    })
                ]
            })),
            $7eb5302f7c7694e0$var$wrapFormWidget({
                id: "misc",
                label: "<h1>Misc</h1>",
                cls: ""
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget1({
                id: "text",
                label: "<b>Test textbox</b>",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                value: "foo"
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget1({
                id: "empty-text",
                label: "Empty textbox",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Empty"),
                value: ""
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget2($c9a251dc3aa901f2$export$f97c0ae6299495bc({
                id: "subform",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("Collapsible sub-form test"),
                labelClass: "",
                section: true,
                collapsible: true,
                expanded: true,
                cls: "",
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget3({
                        id: "expectation",
                        label: "Expectation",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    }),
                    $7eb5302f7c7694e0$var$wrapFormWidget3({
                        id: "learning",
                        label: "Learning",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    })
                ]
            })({
                id: "course-expectations",
                cls: "",
                label: "Course Expectations"
            })),
            $7eb5302f7c7694e0$var$wrapFormWidget2($c9a251dc3aa901f2$export$b6d18be6fee5fadb({
                id: "subform",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("Collapsible sub-form test"),
                labelClass: "",
                section: true,
                collapsible: true,
                expanded: true,
                cls: "",
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget3({
                        id: "expectation",
                        label: "Expectation",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    }),
                    $7eb5302f7c7694e0$var$wrapFormWidget3({
                        id: "learning",
                        label: "Learning",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    })
                ]
            })({
                id: "employer-expectations",
                cls: "",
                label: "Employer Expectations"
            })),
            $7eb5302f7c7694e0$var$wrapFormWidget4($b19cb68dd93bf4c1$export$18aeebbd4b820fd5({
                id: "list",
                label: "List of Textboxes",
                cls: "",
                template: $7eb5302f7c7694e0$var$wrapFormWidget1({
                    id: "list-text",
                    label: "Empty textbox",
                    cls: "",
                    placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Empty"),
                    value: ""
                })
            })),
            $7eb5302f7c7694e0$var$wrapFormWidget3({
                id: "textarea",
                label: "Test text area",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Test"),
                value: "testing"
            }),
            $3af393d861aaaf77$export$6ad962f6572282b5($97422168d708f34b$export$8186ddc1fa8e29e6)($97422168d708f34b$export$5f9461193a1d19b8)({
                id: "phone",
                label: "Test phone input",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Phone number"),
                value: "555-555-5555"
            }),
            $3af393d861aaaf77$export$6ad962f6572282b5($37ba48106011150d$export$fb9fc2cd92c1bf4c)($37ba48106011150d$export$7426ea75dfc0194f)({
                id: "email",
                label: "Test email input",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Email"),
                value: "email@example.com"
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget5({
                id: "int",
                label: "<b>Test int input</b>",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Integer"),
                step: 1.0,
                value: new $06733ae99ed4f534$export$8a67b48435b5d073(42.0)
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget5({
                id: "nint",
                label: "Null int input",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Integer"),
                step: 1.0,
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget5({
                id: "float",
                label: "Test float input",
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Decimal"),
                step: 0.1,
                value: new $06733ae99ed4f534$export$8a67b48435b5d073(3.14)
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget6({
                id: "date",
                label: "Test date input",
                cls: "",
                value: new $06733ae99ed4f534$export$8a67b48435b5d073($7eb5302f7c7694e0$export$f01b4a57670a71ed)
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget6({
                id: "null-date",
                label: "Test date input",
                cls: "",
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget7({
                id: "datetime",
                label: "Test datetime input",
                cls: "",
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget7({
                id: "test_datetime",
                label: "Test datetime input",
                cls: "",
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget8({
                id: "check",
                label: "<b>Test checkbox</b>",
                cls: "",
                legacy: false,
                value: false
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget9({
                id: "radio",
                label: "Test radio",
                cls: "",
                options: [
                    {
                        value: "1",
                        label: "One"
                    },
                    {
                        value: "2",
                        label: "Two"
                    }
                ],
                value: new $06733ae99ed4f534$export$8a67b48435b5d073("1")
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget9({
                id: "radio-null",
                label: "Test radio with nothing selected",
                cls: "",
                options: [
                    {
                        value: "1",
                        label: "One"
                    },
                    {
                        value: "2",
                        label: "Two"
                    }
                ],
                value: $06733ae99ed4f534$export$bebe9059409a0d04.value
            }),
            $3af393d861aaaf77$export$6ad962f6572282b5($9ba897e5bccf1b3f$export$d3723392410533e4)($9ba897e5bccf1b3f$export$d25626d1625ac929)($9ba897e5bccf1b3f$export$71821c1eec3657cc({
                id: "select",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("Test select"),
                cls: "",
                placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder"),
                options: [
                    {
                        value: $0e031af7428ef07d$export$dbafa4424a806c15("1"),
                        label: "Testing a very long label my goodness this is huge totally massive and worst of all no punctuation where we are going we dont need punctuation"
                    },
                    {
                        value: $0e031af7428ef07d$export$dbafa4424a806c15("2"),
                        label: "Two"
                    }
                ],
                value: new $06733ae99ed4f534$export$8a67b48435b5d073($0e031af7428ef07d$export$dbafa4424a806c15("1"))
            })),
            $7eb5302f7c7694e0$var$wrapFormWidget({
                id: "label",
                label: "This is a label.",
                cls: ""
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget({
                id: "label-html",
                label: "This is a label <marquee>with HTML</marquee>.",
                cls: ""
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget({
                id: "label-brokenhtml",
                label: "This HTML is <b>missing a closing tag",
                cls: ""
            }),
            $3af393d861aaaf77$export$6ad962f6572282b5($5ad0c5cefd7afaff$export$5f42f100f752a07c)($5ad0c5cefd7afaff$export$1b344533d0e9e444)({
                id: "test-error",
                err: new $54dae5ca6a6cd16d$export$90a530fd5ef57012("This is a test of the erorr system.")
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget10({
                id: "subform",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("Collapsible sub-form test"),
                labelClass: "",
                section: true,
                collapsible: true,
                expanded: true,
                cls: "",
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget1({
                        id: "subtext",
                        label: "Test textbox",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    }),
                    $7eb5302f7c7694e0$var$wrapFormWidget8({
                        id: "subcheck",
                        label: "Test checkbox",
                        cls: "",
                        legacy: false,
                        value: false
                    })
                ]
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget10({
                id: "nocollapse-subform",
                label: new $06733ae99ed4f534$export$8a67b48435b5d073("Non-collapsible sub-form test"),
                labelClass: "",
                section: true,
                collapsible: false,
                expanded: true,
                cls: "",
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget1({
                        id: "subtext",
                        label: "Test textbox",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    }),
                    $7eb5302f7c7694e0$var$wrapFormWidget8({
                        id: "subcheck",
                        label: "Test checkbox",
                        cls: "",
                        legacy: false,
                        value: false
                    })
                ]
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget10({
                id: "nolabel-subform",
                label: $06733ae99ed4f534$export$bebe9059409a0d04.value,
                labelClass: "",
                section: true,
                collapsible: false,
                expanded: true,
                cls: "",
                fields: [
                    $7eb5302f7c7694e0$var$wrapFormWidget1({
                        id: "subtext",
                        label: "Test textbox in subform with no label",
                        cls: "",
                        placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                        value: ""
                    })
                ]
            }),
            $7eb5302f7c7694e0$var$wrapFormWidget4($b19cb68dd93bf4c1$export$18aeebbd4b820fd5({
                id: "subform-list",
                label: "List of SubForms",
                cls: "",
                template: $7eb5302f7c7694e0$var$wrapFormWidget10({
                    id: "list-subform",
                    label: new $06733ae99ed4f534$export$8a67b48435b5d073("List subform test"),
                    labelClass: "",
                    section: true,
                    collapsible: true,
                    expanded: false,
                    cls: "",
                    fields: [
                        $7eb5302f7c7694e0$var$wrapFormWidget1({
                            id: "subtext",
                            label: "Test textbox",
                            cls: "",
                            placeholder: new $06733ae99ed4f534$export$8a67b48435b5d073("Placeholder Test"),
                            value: ""
                        }),
                        $7eb5302f7c7694e0$var$wrapFormWidget8({
                            id: "subcheck",
                            label: "Test checkbox",
                            cls: "",
                            legacy: false,
                            value: false
                        })
                    ]
                })
            }))
        ]
    };
}();
var $7eb5302f7c7694e0$export$5d305c9f0a1c804d = /* #__PURE__ */ function() {
    var initData = $fce7eb63608cf274$export$c3f886ccd454773d($7eb5302f7c7694e0$export$b9a314a6a303ea0a);
    var run = function(v) {
        return $7eb5302f7c7694e0$var$discard($7eb5302f7c7694e0$var$liftEffect($7eb5302f7c7694e0$var$log($0e031af7428ef07d$export$fac44ee5b035f737($fce7eb63608cf274$export$c3f886ccd454773d(v.formState)))))(function() {
            return $7eb5302f7c7694e0$var$bindFlipped(handle(v))($7eb5302f7c7694e0$var$div$prime([
                $7eb5302f7c7694e0$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                    $7eb5302f7c7694e0$var$voidRight($7eb5302f7c7694e0$export$fcc683c36751f67a.value)($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $7eb5302f7c7694e0$var$text("Reset")
                ]),
                $7eb5302f7c7694e0$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                    $7eb5302f7c7694e0$var$voidRight($7eb5302f7c7694e0$export$f40c6e7dc733ed84.value)($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $7eb5302f7c7694e0$var$text("Print Query Shape")
                ]),
                $7eb5302f7c7694e0$var$button([
                    $fc1df90f0e252058$export$2913c0c0b5623090("btn"),
                    $7eb5302f7c7694e0$var$voidRight($7eb5302f7c7694e0$export$216f8314a26a271a.value)($fc1df90f0e252058$export$1d5a917feb871989)
                ])([
                    $7eb5302f7c7694e0$var$text("Simulate Load")
                ]),
                $7eb5302f7c7694e0$var$map($7eb5302f7c7694e0$export$b820fc49f2736e85.create)($fce7eb63608cf274$export$9750270299d2035e($f388db8e60bd7b97$export$5f8bbb7bf801e4b8)(v.formState))
            ]));
        });
    };
    var handle = function(v) {
        return function(v1) {
            if (v1 instanceof $7eb5302f7c7694e0$export$b820fc49f2736e85) return run({
                formState: v1.value0.value0.state
            });
            if (v1 instanceof $7eb5302f7c7694e0$export$f40c6e7dc733ed84) return $7eb5302f7c7694e0$var$discard($7eb5302f7c7694e0$var$liftEffect($7eb5302f7c7694e0$var$log($266cd1b01131a218$export$debe08b0a131ded($fce7eb63608cf274$export$1ef0edd00f5680d9(v.formState)))))(function() {
                return run(v);
            });
            if (v1 instanceof $7eb5302f7c7694e0$export$fcc683c36751f67a) {
                var v2 = $fce7eb63608cf274$export$acf666f77943fd8e($f388db8e60bd7b97$export$5f8bbb7bf801e4b8)(initData)(v.formState);
                if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return run({
                    formState: v2.value0
                });
                if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $54dae5ca6a6cd16d$export$ee963cafee2c98f(v2.value0);
                throw new Error("Failed pattern match at Widgets.Form.TestForm (line 401, column 9 - line 403, column 42): " + [
                    v2.constructor.name
                ]);
            }
            if (v1 instanceof $7eb5302f7c7694e0$export$216f8314a26a271a) {
                var fdata = $fce7eb63608cf274$export$c3f886ccd454773d(v.formState);
                return $7eb5302f7c7694e0$var$discard($7eb5302f7c7694e0$var$liftEffect($7eb5302f7c7694e0$var$log(fdata)))(function() {
                    var v2 = $fce7eb63608cf274$export$acf666f77943fd8e($f388db8e60bd7b97$export$5f8bbb7bf801e4b8)(fdata)($7eb5302f7c7694e0$export$b9a314a6a303ea0a);
                    if (v2 instanceof $7d4cccdf062a2261$export$19db0165690c701a) return run({
                        formState: v2.value0
                    });
                    if (v2 instanceof $7d4cccdf062a2261$export$37c4d04eafdc5515) return $54dae5ca6a6cd16d$export$ee963cafee2c98f(v2.value0);
                    throw new Error("Failed pattern match at Widgets.Form.TestForm (line 408, column 9 - line 410, column 41): " + [
                        v2.constructor.name
                    ]);
                });
            }
            throw new Error("Failed pattern match at Widgets.Form.TestForm (line 396, column 5 - line 396, column 105): " + [
                v.constructor.name,
                v1.constructor.name
            ]);
        };
    };
    return run({
        formState: $7eb5302f7c7694e0$export$b9a314a6a303ea0a
    });
}();



var $c13f96732740c363$var$nub = /* #__PURE__ */ $396c4c3d9e7fae3c$export$94f4066a75b10404(/* #__PURE__ */ $308f9765feb7633d$export$96ef298e3487e095($97937c29f879e68e$export$c5f2758e49b2b86a));
var $c13f96732740c363$var$append = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($d7bf9817a417d4ae$export$d082f07d0a8e9909);
var $c13f96732740c363$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$2330f868b62ed546);
var $c13f96732740c363$var$fromFoldable = /* #__PURE__ */ $396c4c3d9e7fae3c$export$b7d5d9bb9ff52072($78c799cba34fcb8d$export$92659ee1fc91a075);
var $c13f96732740c363$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $c13f96732740c363$var$bind1 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $c13f96732740c363$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $c13f96732740c363$var$when = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$a55877ca9db47377($6c2f8951ecf9531e$export$89bf999217d3022a);
var $c13f96732740c363$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $c13f96732740c363$var$$$void = /* #__PURE__ */ $f4b2eb11fc32ed34$export$490e536ee7389aeb($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $c13f96732740c363$var$discard2 = /* #__PURE__ */ $c13f96732740c363$var$discard($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $c13f96732740c363$var$liftEffect1 = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3(/* #__PURE__ */ $fe1781b0b9eaad64$export$4e1ce6d609307a39($784e1bd3d26d71da$export$db307f59121ffcc4));
var $c13f96732740c363$var$traverse_ = /* #__PURE__ */ $4fe7b6acfba7f29f$export$33f63ccdb08d8723($6c2f8951ecf9531e$export$89bf999217d3022a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $c13f96732740c363$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($fe1781b0b9eaad64$export$797cc7e2e9848af);
var $c13f96732740c363$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($edf0339512807bee$export$800a937b75981c0e);
var $c13f96732740c363$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c13f96732740c363$var$alt = /* #__PURE__ */ $75e93a4111e80214$export$228be17d80722ab(/* #__PURE__ */ $fe1781b0b9eaad64$export$7341a4054968fa7c($784e1bd3d26d71da$export$db307f59121ffcc4));
var $c13f96732740c363$var$gEncodeJsonCons = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($81439e1d9c94314f$export$b7e2b1272211a360);
var $c13f96732740c363$var$gEncodeJsonCons1 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$188ec67d44674d4b);
var $c13f96732740c363$var$gEncodeJsonCons2 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1($eb7399d322077fcf$export$12b4d820b2ffc726);
var $c13f96732740c363$var$accessIsSymbol = {
    reflectSymbol: function() {
        return "access";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons3 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$7f2886916ce99188);
var $c13f96732740c363$var$gEncodeJsonCons4 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3($eb7399d322077fcf$export$12b4d820b2ffc726);
var $c13f96732740c363$var$deleteIsSymbol = {
    reflectSymbol: function() {
        return "delete";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons5 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($35e75b0a064776f5$export$d3fd8e55e9d4c026);
var $c13f96732740c363$var$nameIsSymbol = {
    reflectSymbol: function() {
        return "name";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons6 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2($c13f96732740c363$var$nameIsSymbol)();
var $c13f96732740c363$var$gEncodeJsonCons7 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3($c13f96732740c363$var$gEncodeJsonCons6)());
var $c13f96732740c363$var$urlIsSymbol = {
    reflectSymbol: function() {
        return "url";
    }
};
var $c13f96732740c363$var$idIsSymbol = {
    reflectSymbol: function() {
        return "id";
    }
};
var $c13f96732740c363$var$created_atIsSymbol = {
    reflectSymbol: function() {
        return "created_at";
    }
};
var $c13f96732740c363$var$canIsSymbol = {
    reflectSymbol: function() {
        return "can";
    }
};
var $c13f96732740c363$var$updateIsSymbol = {
    reflectSymbol: function() {
        return "update";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons8 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons4($c13f96732740c363$var$updateIsSymbol)());
var $c13f96732740c363$var$commentIsSymbol = {
    reflectSymbol: function() {
        return "comment";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons9 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $308f9765feb7633d$export$5acd5bea71910131($eb7399d322077fcf$export$188ec67d44674d4b));
var $c13f96732740c363$var$updated_atIsSymbol = {
    reflectSymbol: function() {
        return "updated_at";
    }
};
var $c13f96732740c363$var$encodeRecord = /* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9($c13f96732740c363$var$gEncodeJsonCons6)($c13f96732740c363$var$idIsSymbol)())();
var $c13f96732740c363$var$gEncodeJsonCons10 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($c13f96732740c363$var$encodeRecord));
var $c13f96732740c363$var$gEncodeJsonCons11 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1($c13f96732740c363$var$gEncodeJsonCons6);
var $c13f96732740c363$var$labelIsSymbol = {
    reflectSymbol: function() {
        return "label";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons12 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($35e75b0a064776f5$export$d3fd8e55e9d4c026));
var $c13f96732740c363$var$encodeRecord1 = /* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2($c13f96732740c363$var$labelIsSymbol)())($c13f96732740c363$var$idIsSymbol)())();
var $c13f96732740c363$var$gEncodeJsonCons13 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2($c13f96732740c363$var$urlIsSymbol)();
var $c13f96732740c363$var$createIsSymbol = {
    reflectSymbol: function() {
        return "create";
    }
};
var $c13f96732740c363$var$semesterIsSymbol = {
    reflectSymbol: function() {
        return "semester";
    }
};
var $c13f96732740c363$var$gEncodeJsonCons14 = /* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($eb7399d322077fcf$export$188ec67d44674d4b));
var $c13f96732740c363$var$gEncodeJsonCons15 = /* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9($eb7399d322077fcf$export$12b4d820b2ffc726);
var $c13f96732740c363$var$relationshipIsSymbol = {
    reflectSymbol: function() {
        return "relationship";
    }
};
var $c13f96732740c363$var$keyIsSymbol = {
    reflectSymbol: function() {
        return "key";
    }
};
var $c13f96732740c363$var$emailIsSymbol = {
    reflectSymbol: function() {
        return "email";
    }
};
var $c13f96732740c363$var$contactIsSymbol = {
    reflectSymbol: function() {
        return "contact";
    }
};
var $c13f96732740c363$var$encodeJson = /* #__PURE__ */ $eb7399d322077fcf$export$a865279d3b7b5f70(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2({
    reflectSymbol: function() {
        return "field";
    }
})())($c13f96732740c363$var$accessIsSymbol)())()))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "fields";
    }
})())({
    reflectSymbol: function() {
        return "default";
    }
})())())(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons4($c13f96732740c363$var$deleteIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons7($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "user";
    }
})())($c13f96732740c363$var$urlIsSymbol)())({
    reflectSymbol: function() {
        return "path";
    }
})())($c13f96732740c363$var$idIsSymbol)())({
    reflectSymbol: function() {
        return "description";
    }
})())($c13f96732740c363$var$created_atIsSymbol)())($c13f96732740c363$var$canIsSymbol)())()))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons8({
    reflectSymbol: function() {
        return "private_comment";
    }
})())({
    reflectSymbol: function() {
        return "lock";
    }
})())($c13f96732740c363$var$deleteIsSymbol)())({
    reflectSymbol: function() {
        return "create_employers";
    }
})())({
    reflectSymbol: function() {
        return "copy";
    }
})())($c13f96732740c363$var$commentIsSymbol)())({
    reflectSymbol: function() {
        return "attach";
    }
})())())(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons7(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons8($c13f96732740c363$var$deleteIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5($eb7399d322077fcf$export$12b4d820b2ffc726)($c13f96732740c363$var$updated_atIsSymbol)())({
    reflectSymbol: function() {
        return "public";
    }
})())($c13f96732740c363$var$idIsSymbol)())($c13f96732740c363$var$created_atIsSymbol)())($c13f96732740c363$var$commentIsSymbol)())($c13f96732740c363$var$canIsSymbol)())({
    reflectSymbol: function() {
        return "author";
    }
})())()))(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons10(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons11($c13f96732740c363$var$labelIsSymbol)())($c13f96732740c363$var$idIsSymbol)())()))(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($c13f96732740c363$var$encodeRecord))(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons12(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51($c13f96732740c363$var$encodeRecord1))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "positions";
    }
})())($c13f96732740c363$var$idIsSymbol)())({
    reflectSymbol: function() {
        return "deleted_at";
    }
})())({
    reflectSymbol: function() {
        return "contacts";
    }
})())({
    reflectSymbol: function() {
        return "company";
    }
})())()))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1($c13f96732740c363$var$gEncodeJsonCons13)($c13f96732740c363$var$labelIsSymbol)())({
    reflectSymbol: function() {
        return "format";
    }
})())()))(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8($eb7399d322077fcf$export$35d3004eff90f123)(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons12(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2($c13f96732740c363$var$updateIsSymbol)())($c13f96732740c363$var$deleteIsSymbol)())($c13f96732740c363$var$createIsSymbol)())())(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7c8b8b15a35b2ba2($c13f96732740c363$var$encodeRecord1))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2($c13f96732740c363$var$semesterIsSymbol)())($c13f96732740c363$var$nameIsSymbol)())())(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons4({
    reflectSymbol: function() {
        return "useDefault";
    }
})())($c13f96732740c363$var$updateIsSymbol)())({
    reflectSymbol: function() {
        return "saveDefault";
    }
})())({
    reflectSymbol: function() {
        return "request";
    }
})())($c13f96732740c363$var$createIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons14(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons14(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons14(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons15($c13f96732740c363$var$relationshipIsSymbol)())($c13f96732740c363$var$labelIsSymbol)())($c13f96732740c363$var$keyIsSymbol)())({
    reflectSymbol: function() {
        return "emailLabel";
    }
})())({
    reflectSymbol: function() {
        return "default_last_name";
    }
})())({
    reflectSymbol: function() {
        return "default_first_name";
    }
})())({
    reflectSymbol: function() {
        return "default_email";
    }
})())($c13f96732740c363$var$canIsSymbol)())()))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2({
    reflectSymbol: function() {
        return "last_name";
    }
})())({
    reflectSymbol: function() {
        return "first_name";
    }
})())($c13f96732740c363$var$emailIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9($c13f96732740c363$var$gEncodeJsonCons13)($c13f96732740c363$var$relationshipIsSymbol)())($c13f96732740c363$var$keyIsSymbol)())($c13f96732740c363$var$idIsSymbol)())($c13f96732740c363$var$created_atIsSymbol)())($c13f96732740c363$var$contactIsSymbol)())()))(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons12(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons14(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons11({
    reflectSymbol: function() {
        return "color";
    }
})())()))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "tags";
    }
})())({
    reflectSymbol: function() {
        return "preferred_name";
    }
})())($c13f96732740c363$var$nameIsSymbol)())({
    reflectSymbol: function() {
        return "last_imported_at";
    }
})())($c13f96732740c363$var$idIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons10(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$7d680688dffcbf51(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons5(/* #__PURE__ */ $eb7399d322077fcf$export$cc2f530f06b3b8c8(/* #__PURE__ */ $eb7399d322077fcf$export$2aa47014064a90c3(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons14(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons1(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons15($c13f96732740c363$var$keyIsSymbol)())($c13f96732740c363$var$emailIsSymbol)())($c13f96732740c363$var$commentIsSymbol)())())(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons9(/* #__PURE__ */ $c13f96732740c363$var$gEncodeJsonCons2({
    reflectSymbol: function() {
        return "link";
    }
})())($c13f96732740c363$var$idIsSymbol)())({
    reflectSymbol: function() {
        return "data";
    }
})())($c13f96732740c363$var$created_atIsSymbol)())()))($eb7399d322077fcf$export$12b4d820b2ffc726)({
    reflectSymbol: function() {
        return "verifications";
    }
})())($c13f96732740c363$var$updated_atIsSymbol)())({
    reflectSymbol: function() {
        return "teacher";
    }
})())({
    reflectSymbol: function() {
        return "student";
    }
})())({
    reflectSymbol: function() {
        return "signatures";
    }
})())({
    reflectSymbol: function() {
        return "signature_fields";
    }
})())($c13f96732740c363$var$semesterIsSymbol)())({
    reflectSymbol: function() {
        return "position";
    }
})())({
    reflectSymbol: function() {
        return "mutations";
    }
})())({
    reflectSymbol: function() {
        return "locked_at";
    }
})())({
    reflectSymbol: function() {
        return "json";
    }
})())($c13f96732740c363$var$idIsSymbol)())({
    reflectSymbol: function() {
        return "formName";
    }
})())({
    reflectSymbol: function() {
        return "formId";
    }
})())({
    reflectSymbol: function() {
        return "exports";
    }
})())({
    reflectSymbol: function() {
        return "employer";
    }
})())($c13f96732740c363$var$created_atIsSymbol)())({
    reflectSymbol: function() {
        return "courses";
    }
})())($c13f96732740c363$var$contactIsSymbol)())({
    reflectSymbol: function() {
        return "comments";
    }
})())($c13f96732740c363$var$canIsSymbol)())({
    reflectSymbol: function() {
        return "attachments";
    }
})())($c13f96732740c363$var$accessIsSymbol)())());
var $c13f96732740c363$var$voidRight = /* #__PURE__ */ $f4b2eb11fc32ed34$export$b818c54ed8d3e90a($fe1781b0b9eaad64$export$b8cebcb08812ae27);
var $c13f96732740c363$var$bind2 = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($fe1781b0b9eaad64$export$5f15f35c03bac00f);
var $c13f96732740c363$var$div$prime = /* #__PURE__ */ $3eadc1b959dd1120$export$889437a23e4d1fea(/* #__PURE__ */ $fe1781b0b9eaad64$export$21a5b9b566490c41($784e1bd3d26d71da$export$db307f59121ffcc4))($fe1781b0b9eaad64$export$c5fde4e7aaeb46c5);
var $c13f96732740c363$var$text = /* #__PURE__ */ $3eadc1b959dd1120$export$6f093cfa640b7166($d4ad4a12c540b680$export$5d6626409df85f18);
var $c13f96732740c363$var$step3RouteForState = function(locationState) {
    return function(ready) {
        var step3DocIds = $c13f96732740c363$var$nub($c13f96732740c363$var$append($c13f96732740c363$var$map(function(v) {
            return v.id;
        })(ready.editor.workQueueState.editDocs))($c13f96732740c363$var$map(function(v) {
            return v.id;
        })($c13f96732740c363$var$fromFoldable($4e23420f70d37f30$export$bc79aa1aae6bd561(ready.editor.workQueueState.documents)))));
        return new $daa993e9fe4182d9$export$6fd638f4ca7cd326({
            preservedQuery: $daa993e9fe4182d9$export$11c97f589579967b(locationState.search),
            activeDoc: new $06733ae99ed4f534$export$8a67b48435b5d073(ready.editor.fillState.doc.id),
            docs: step3DocIds,
            section: ready.editor.sectionIntent
        });
    };
};
var $c13f96732740c363$var$step1SearchDebounceDelay = 300.0;
var $c13f96732740c363$var$enqueue = function(mailbox) {
    return function(msgs) {
        return function __do() {
            var state = $e521936ea118867a$export$aafa59e2e03f2942(mailbox)();
            var v = $396c4c3d9e7fae3c$export$b446f6baa3bb1430($c13f96732740c363$var$append(state.queue)(msgs));
            if (state.waiter instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                $e521936ea118867a$export$68d8715fc104d294({
                    queue: v.value0.tail,
                    waiter: $06733ae99ed4f534$export$bebe9059409a0d04.value
                })(mailbox)();
                return state.waiter.value0.wake(v.value0.head)();
            }
            return $e521936ea118867a$export$68d8715fc104d294({
                waiter: state.waiter,
                queue: $c13f96732740c363$var$append(state.queue)(msgs)
            })(mailbox)();
        };
    };
};
var $c13f96732740c363$var$runCommand = function(mailbox) {
    return function(state) {
        return function(v) {
            if (v instanceof $4b57a9a20c626e9f$export$43846ecbea5b4cd7) return function __do() {
                var locationState = $a5971154c27be447$export$5729eead7c8f9eaf(state.pushStateInterface)();
                var route = $daa993e9fe4182d9$export$96ba27ab48ad90aa(locationState)(state.step)(state.workQueueState);
                $93c729927fdf3160$export$bef1f36f5486a6a3("APP_SYNC_ROUTE " + $daa993e9fe4182d9$export$f6821e37299eed8e(route))();
                if (v.value0 instanceof $80445329d31df9ca$export$b7b72b4685ba4f49) return $a5971154c27be447$export$524be3ecf241c3f0(state.pushStateInterface)(route)();
                if (v.value0 instanceof $80445329d31df9ca$export$c72c14f37d28f60d) return $a5971154c27be447$export$c4bc7274b81240ec(state.pushStateInterface)(route)();
                throw new Error("Failed pattern match at App.Runtime (line 259, column 9 - line 261, column 79): " + [
                    v.value0.constructor.name
                ]);
            };
            if (v instanceof $4b57a9a20c626e9f$export$d1cc75e80b20eeaf) return $edf0339512807bee$export$c8704a1045ed544d($c13f96732740c363$var$bind1($f44e895d82c9aa8d$export$67d5a1c18c496673(state)(v.value1))(function(hydrated) {
                return $c13f96732740c363$var$liftEffect($c13f96732740c363$var$enqueue(mailbox)([
                    new $c9f8fdc31e1f6dad$export$d9d27eb76d4d6392(v.value0, v.value1, hydrated)
                ]));
            }));
            if (v instanceof $4b57a9a20c626e9f$export$f68485a1a0d25ba8) return $df5131492eb04693$export$22dc772e760f6f14($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$bfeffc9dfe6adcbc) return $edf0339512807bee$export$c8704a1045ed544d($c13f96732740c363$var$bind1($edf0339512807bee$export$1391212d75b2ee65($c13f96732740c363$var$step1SearchDebounceDelay))(function() {
                return $c13f96732740c363$var$liftEffect($c13f96732740c363$var$enqueue(mailbox)([
                    new $c9f8fdc31e1f6dad$export$1dc871215656967e(v.value0)
                ]));
            }));
            if (v instanceof $4b57a9a20c626e9f$export$f2cd12f7a0cd7cef) return $df5131492eb04693$export$75546801468fa48b($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$614ed660100c3639) return $df5131492eb04693$export$78238cf80a57bff6($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$8c088ed0af29bf8e) return $df5131492eb04693$export$526e87cac6dc453c($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$20cb2c62b285cf15) return $df5131492eb04693$export$beb5734a12a5a342($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$9b2b5e8a9dac051e) return $df5131492eb04693$export$9add7d25b4580357($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$4f3ced6841ba7e93) return $df5131492eb04693$export$77b5ce156dd73a75($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$b570b6d4d8a37ba) return $df5131492eb04693$export$af8d10484acdf914($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$882828c20d5c370f) return $df5131492eb04693$export$75d41def2ff735e0($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$372d8dcc68f43922) return $df5131492eb04693$export$7e8d1e05f9d6279f($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$f4b18fa9f7b0988c) return $df5131492eb04693$export$b12e3f35bb8df2cf($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$a7960d0bb7149c3e) return $df5131492eb04693$export$45e8be927952ff29($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$909fe2fc390dacb8) return $df5131492eb04693$export$a735302d9919706e($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2)(v.value3);
            if (v instanceof $4b57a9a20c626e9f$export$e2233cf4256bed98) return $df5131492eb04693$export$65c7d3bda49ecdbd($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$dca8967abeef5459) return $df5131492eb04693$export$14a5ca39b7e184ab($c13f96732740c363$var$enqueue(mailbox))(state)(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$3d8d3455249b0f5c) return $df5131492eb04693$export$7ae1762b6e1f332b($c13f96732740c363$var$enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$1f0c59144b57f59f) {
                if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return function __do() {
                    var locationState = $a5971154c27be447$export$5729eead7c8f9eaf(state.pushStateInterface)();
                    var route = $c13f96732740c363$var$step3RouteForState(locationState)(state.step3.value0);
                    var currentUrl = locationState.pathname + (locationState.search + locationState.hash);
                    var nextUrl = $daa993e9fe4182d9$export$f6821e37299eed8e(route);
                    $c13f96732740c363$var$when(nextUrl !== currentUrl)(function() {
                        if (v.value0 instanceof $59a05a7e29977bc8$export$5fc55f6f4f65719f) return $a5971154c27be447$export$524be3ecf241c3f0(state.pushStateInterface)(route);
                        if (v.value0 instanceof $59a05a7e29977bc8$export$7bdb1b708831338) return $a5971154c27be447$export$c4bc7274b81240ec(state.pushStateInterface)(route);
                        throw new Error("Failed pattern match at App.Runtime (line 328, column 17 - line 330, column 87): " + [
                            v.value0.constructor.name
                        ]);
                    }())();
                    if (state.step3.value0.editor.sectionIntent instanceof $daa993e9fe4182d9$export$28a5869e6b717ab) return $f48dee3ee719f840$export$3eb58eff01759a1d(state.step3.value0.editor.sectionIntent.value0)();
                    return $05149ea687d6b460$export$523c0b569236b342;
                };
                return $c13f96732740c363$var$pure($05149ea687d6b460$export$523c0b569236b342);
            }
            if (v instanceof $4b57a9a20c626e9f$export$94d3e5d9ab92b4f9) return $f48dee3ee719f840$export$3eb58eff01759a1d(v.value0);
            if (v instanceof $4b57a9a20c626e9f$export$c2e797ca28b02c81) return $df5131492eb04693$export$407b1915a30f3f1e($c13f96732740c363$var$enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$a5e3e4d00fc363bf) return $df5131492eb04693$export$8388a4bfb34142b8($c13f96732740c363$var$enqueue(mailbox))(state)(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$7540d7178b14245f) return $df5131492eb04693$export$15c7e0e202f580a($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$b1d3326fcab09462) return $df5131492eb04693$export$9d3b34fa0f7a378($c13f96732740c363$var$enqueue(mailbox))(state)(v.value0)(v.value1);
            if (v instanceof $4b57a9a20c626e9f$export$f515a058fe9fca3a) return $df5131492eb04693$export$b07dedcd037989ef($c13f96732740c363$var$enqueue(mailbox))(v.value0)(v.value1)(v.value2);
            if (v instanceof $4b57a9a20c626e9f$export$5cbca665f928318b) return function __do() {
                var confirmed = $b4820784a71f3cca$export$72506cc3444837c9();
                return $c13f96732740c363$var$enqueue(mailbox)([
                    new $c9f8fdc31e1f6dad$export$f626af092893962d(new $7b9d021f8fc5e8ea$export$66aa8e949afa1192(confirmed))
                ])();
            };
            if (v instanceof $4b57a9a20c626e9f$export$88c8c40786b3927b) return $b4820784a71f3cca$export$415f698193575175;
            if (v instanceof $4b57a9a20c626e9f$export$4bb7762331f161c2) return $b4820784a71f3cca$export$302ea87d15e513da;
            if (v instanceof $4b57a9a20c626e9f$export$96c159224a0db784) return function __do() {
                var win = $2603425f82e959df$export$8291e5b88f90ce4();
                return $c13f96732740c363$var$$$void($6b26c9b0fa2d7b7a$export$3ce6949f20cea765(v.value0)("_blank")("")(win))();
            };
            if (v instanceof $4b57a9a20c626e9f$export$4aa34530d5f59077) return function __do() {
                var win = $2603425f82e959df$export$8291e5b88f90ce4();
                return $c13f96732740c363$var$$$void($6b26c9b0fa2d7b7a$export$3ce6949f20cea765(v.value0)("_blank")("")(win))();
            };
            if (v instanceof $4b57a9a20c626e9f$export$e17713364c5dda32) return $c13f96732740c363$var$$$void($54dae5ca6a6cd16d$export$b33b857ad1d9900e(v.value0));
            throw new Error("Failed pattern match at App.Runtime (line 254, column 28 - line 374, column 31): " + [
                v.constructor.name
            ]);
        };
    };
};
var $c13f96732740c363$var$interpretCommands = function(mailbox) {
    return function(result) {
        return $c13f96732740c363$var$discard2($c13f96732740c363$var$liftEffect1($c13f96732740c363$var$traverse_($c13f96732740c363$var$runCommand(mailbox)(result.state))(result.commands)))(function() {
            return $c13f96732740c363$var$pure1(result.state);
        });
    };
};
var $c13f96732740c363$var$dequeue = function(mailbox) {
    var step = function(state) {
        var v = $396c4c3d9e7fae3c$export$b446f6baa3bb1430(state.queue);
        if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return {
            state: state,
            value: $06733ae99ed4f534$export$bebe9059409a0d04.value
        };
        if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return {
            state: {
                waiter: state.waiter,
                queue: v.value0.tail
            },
            value: new $06733ae99ed4f534$export$8a67b48435b5d073(v.value0.head)
        };
        throw new Error("Failed pattern match at App.Runtime (line 407, column 18 - line 416, column 14): " + [
            v.constructor.name
        ]);
    };
    return $90327512d8280b8d$export$4d5401161a900ce1(step)(mailbox);
};
var $c13f96732740c363$var$dequeueIfCurrent = function(epoch) {
    return function(loopId) {
        return function(mailbox) {
            return function __do() {
                var current = $e521936ea118867a$export$aafa59e2e03f2942(epoch)();
                var $595 = current === loopId;
                if ($595) return $c13f96732740c363$var$dequeue(mailbox)();
                return $06733ae99ed4f534$export$bebe9059409a0d04.value;
            };
        };
    };
};
var $c13f96732740c363$var$clearWaiter = function(loopId) {
    return function(mailbox) {
        var clear = function(state) {
            if (state.waiter instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && state.waiter.value0.loopId === loopId) return {
                queue: state.queue,
                waiter: $06733ae99ed4f534$export$bebe9059409a0d04.value
            };
            return state;
        };
        return $90327512d8280b8d$export$45b91115a89d6020(clear)(mailbox);
    };
};
var $c13f96732740c363$var$awaitMailboxMessage = function(epoch) {
    return function(loopId) {
        return function(mailbox) {
            return $3257df7cdef77623$export$b97f2ad8d0b7442d($b28443a27438717a$export$49d5975414e0a979(function(reply) {
                return function __do() {
                    var current = $e521936ea118867a$export$aafa59e2e03f2942(epoch)();
                    var $598 = current !== loopId;
                    if ($598) return $c13f96732740c363$var$mempty;
                    var msgMaybe = $c13f96732740c363$var$dequeue(mailbox)();
                    if (msgMaybe instanceof $06733ae99ed4f534$export$8a67b48435b5d073) {
                        reply(new $7d4cccdf062a2261$export$19db0165690c701a(msgMaybe.value0))();
                        return $c13f96732740c363$var$mempty;
                    }
                    if (msgMaybe instanceof $06733ae99ed4f534$export$bebe9059409a0d04) {
                        var wake = function(msg) {
                            return reply(new $7d4cccdf062a2261$export$19db0165690c701a(msg));
                        };
                        $90327512d8280b8d$export$45b91115a89d6020(function(v) {
                            return {
                                queue: v.queue,
                                waiter: new $06733ae99ed4f534$export$8a67b48435b5d073({
                                    loopId: loopId,
                                    wake: wake
                                })
                            };
                        })(mailbox)();
                        return $edf0339512807bee$export$952106a975f35ae2($c13f96732740c363$var$clearWaiter(loopId)(mailbox));
                    }
                    throw new Error("Failed pattern match at App.Runtime (line 212, column 13 - line 228, column 51): " + [
                        msgMaybe.constructor.name
                    ]);
                };
            }));
        };
    };
};
var $c13f96732740c363$var$awaitLocationChange = function(v) {
    return $b28443a27438717a$export$49d5975414e0a979(function(reply) {
        return function __do() {
            var unlisten = $a5971154c27be447$export$46891e6a1989f34a(function(locationState) {
                return reply(new $7d4cccdf062a2261$export$19db0165690c701a(locationState));
            })();
            return $edf0339512807bee$export$952106a975f35ae2(unlisten);
        };
    });
};
var $c13f96732740c363$var$awaitBrowserLocationChange = function(pushStateInterface) {
    return $c13f96732740c363$var$map1($c9f8fdc31e1f6dad$export$5c8f622845981396.create)($3257df7cdef77623$export$b97f2ad8d0b7442d($c13f96732740c363$var$awaitLocationChange(pushStateInterface)));
};
var $c13f96732740c363$var$nextMsgWidget = function(renderApp) {
    return function(epoch) {
        return function(loopId) {
            return function(mailbox) {
                return function(state) {
                    var baseSources = $c13f96732740c363$var$alt(renderApp(state))($c13f96732740c363$var$alt($c13f96732740c363$var$awaitBrowserLocationChange(state.pushStateInterface))($c13f96732740c363$var$awaitMailboxMessage(epoch)(loopId)(mailbox)));
                    var awaitStep3DocumentRequest = function(ready) {
                        var currentDocJson = $0e031af7428ef07d$export$fac44ee5b035f737($c13f96732740c363$var$encodeJson(ready.editor.fillState.doc));
                        return $c13f96732740c363$var$voidRight($c9f8fdc31e1f6dad$export$a03875e05513d0ab.value)($3257df7cdef77623$export$b97f2ad8d0b7442d($6902e46d4aa89f92$export$a6670301899fb89c(currentDocJson)));
                    };
                    var awaitCurrentLoop = function(widget) {
                        return $c13f96732740c363$var$bind2(widget)(function(msg) {
                            return $c13f96732740c363$var$bind2($c13f96732740c363$var$liftEffect1($e521936ea118867a$export$aafa59e2e03f2942(epoch)))(function(current) {
                                var $601 = current === loopId;
                                if ($601) return $c13f96732740c363$var$pure1(msg);
                                return awaitCurrentLoop(widget);
                            });
                        });
                    };
                    return $c13f96732740c363$var$bind2($c13f96732740c363$var$liftEffect1($c13f96732740c363$var$dequeueIfCurrent(epoch)(loopId)(mailbox)))(function(queued) {
                        if (queued instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return $c13f96732740c363$var$pure1(queued.value0);
                        if (queued instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return awaitCurrentLoop(function() {
                            if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72) return $c13f96732740c363$var$alt(baseSources)(awaitStep3DocumentRequest(state.step3.value0));
                            return baseSources;
                        }());
                        throw new Error("Failed pattern match at App.Runtime (line 88, column 5 - line 97, column 32): " + [
                            queued.constructor.name
                        ]);
                    });
                };
            };
        };
    };
};
var $c13f96732740c363$var$runAppLoop = function(renderApp) {
    return function(epoch) {
        return function(mailbox) {
            return function(rawState) {
                return $c13f96732740c363$var$bind2($c13f96732740c363$var$liftEffect1($90327512d8280b8d$export$3ff57735a52b8713(function(v) {
                    return v + 1 | 0;
                })(epoch)))(function(loopId) {
                    return $c13f96732740c363$var$bind2($c13f96732740c363$var$nextMsgWidget(renderApp)(epoch)(loopId)(mailbox)(rawState))(function(msg) {
                        return $c13f96732740c363$var$bind2($54dae5ca6a6cd16d$export$b356868cfa7ebfaf($4b57a9a20c626e9f$export$722fbec263ad908a(rawState)(msg)))(function(result) {
                            return $c13f96732740c363$var$bind2($c13f96732740c363$var$interpretCommands(mailbox)(result))(function(nextState) {
                                return $c13f96732740c363$var$runAppLoop(renderApp)(epoch)(mailbox)(nextState);
                            });
                        });
                    });
                });
            };
        };
    };
};
var $c13f96732740c363$var$appMessageWidget = function(renderOptions) {
    return function(state) {
        if (state.step instanceof $994495db3cff0a67$export$317e7082611cb548) {
            if (state.step1 instanceof $80445329d31df9ca$export$3a4efe2ed5897b55) return $c13f96732740c363$var$map1($c9f8fdc31e1f6dad$export$cfd42e9439cb3c03.create)($b6244736105fafa2$export$4c7a081759aa8d84(function() {
                var $609 = $fb0451ff9e33ce13$export$e2db8f1c2b895a63(state.operations)($a8c8b5353c92bbbb$export$fe446a0df01fe4d7.value);
                if ($609) return $506e78fa6ac73d88$export$fea330ef6103f535(state.step1.value0);
                return $506e78fa6ac73d88$export$836911d8c4152069(state.step1.value0);
            }()));
            if (state.step1 instanceof $80445329d31df9ca$export$9787b7e6f37d414e) return $b5330906fcd65ffd$export$d558900b1478007d;
            if (state.step1 instanceof $80445329d31df9ca$export$d5867a59558324d9) return $b5330906fcd65ffd$export$d558900b1478007d;
            throw new Error("Failed pattern match at App.Runtime (line 119, column 17 - line 129, column 26): " + [
                state.step1.constructor.name
            ]);
        }
        if (state.step instanceof $994495db3cff0a67$export$d02ce3ec9b5b8f12) {
            if (state.step2A instanceof $80445329d31df9ca$export$b6b6ceaf3ddf8f7c && $fb0451ff9e33ce13$export$e2db8f1c2b895a63(state.operations)($a8c8b5353c92bbbb$export$87c4c62ae2426f3d.value)) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            if (state.step2A instanceof $80445329d31df9ca$export$b6b6ceaf3ddf8f7c) return $c13f96732740c363$var$map1($c9f8fdc31e1f6dad$export$4ee52428d11a0598.create)($85206166a57f2888$export$837a457478359c90(state.workQueueState)(state.workQueueUi)(state.workQueueCache)(state.step2A.value0));
            if (state.step2A instanceof $80445329d31df9ca$export$adf38f4e421177a0) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            if (state.step2A instanceof $80445329d31df9ca$export$10d33c2f80e61d21) return $54dae5ca6a6cd16d$export$e14a5bba978ec5e6(state.step2A.value0);
            if (state.step2A instanceof $80445329d31df9ca$export$c4ebf5472a2afaba) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            throw new Error("Failed pattern match at App.Runtime (line 131, column 18 - line 141, column 88): " + [
                state.step2A.constructor.name
            ]);
        }
        if (state.step instanceof $994495db3cff0a67$export$d80ca78eabef93e4) {
            if (state.step2B instanceof $80445329d31df9ca$export$81701a88d512004b && $fb0451ff9e33ce13$export$e2db8f1c2b895a63(state.operations)($a8c8b5353c92bbbb$export$87c4c62ae2426f3d.value)) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            if (state.step2B instanceof $80445329d31df9ca$export$81701a88d512004b) return $c13f96732740c363$var$map1($c9f8fdc31e1f6dad$export$6a003360ff9d90ea.create)($812fcffca6747f78$export$9631053f155bbea5($daa993e9fe4182d9$export$a77afe655e44fe22(state.route))(state.step2B.value0));
            if (state.step2B instanceof $80445329d31df9ca$export$851fbd25481b6c25) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            if (state.step2B instanceof $80445329d31df9ca$export$d17de998d9231f6f) return $54dae5ca6a6cd16d$export$e14a5bba978ec5e6(state.step2B.value0);
            if (state.step2B instanceof $80445329d31df9ca$export$5a2874dd5397e561) return $356f5ce902fa042d$export$b1ee3c35b6a94213(state.workQueueState)(state.workQueueUi)(state.workQueueCache);
            throw new Error("Failed pattern match at App.Runtime (line 143, column 18 - line 153, column 88): " + [
                state.step2B.constructor.name
            ]);
        }
        if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72 && state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return $c13f96732740c363$var$map1(function($632) {
            return $c9f8fdc31e1f6dad$export$f626af092893962d.create($7b9d021f8fc5e8ea$export$42eb94e8fee4f26d.create($632));
        })($ee5accd64b1edbdf$export$5decbae53efc29cf(renderOptions)($daa993e9fe4182d9$export$a77afe655e44fe22(state.route))(state.step3.value0));
        if (state.step3 instanceof $80445329d31df9ca$export$23187e44e30bad72 && state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return $c13f96732740c363$var$map1(function($633) {
            return $c9f8fdc31e1f6dad$export$f626af092893962d.create($7b9d021f8fc5e8ea$export$42eb94e8fee4f26d.create($633));
        })($ee5accd64b1edbdf$export$5decbae53efc29cf(renderOptions)($daa993e9fe4182d9$export$a77afe655e44fe22(state.route))(state.step3.value0));
        if (state.step3 instanceof $80445329d31df9ca$export$52520e6e1d2bce34 && state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return $b5330906fcd65ffd$export$d558900b1478007d;
        if (state.step3 instanceof $80445329d31df9ca$export$52520e6e1d2bce34 && state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return $b5330906fcd65ffd$export$d558900b1478007d;
        if (state.step3 instanceof $80445329d31df9ca$export$b87e8303844f9049 && state.step instanceof $994495db3cff0a67$export$d8ccc25b3be9c9d7) return $b5330906fcd65ffd$export$d558900b1478007d;
        if (state.step3 instanceof $80445329d31df9ca$export$b87e8303844f9049 && state.step instanceof $994495db3cff0a67$export$db36463848ed68bd) return $b5330906fcd65ffd$export$d558900b1478007d;
        if (state.step instanceof $994495db3cff0a67$export$133773870222880f) return $c13f96732740c363$var$voidRight($c9f8fdc31e1f6dad$export$a03875e05513d0ab.value)($3ed5ac370c7a6da5$export$fe3d1bc8d0d6d190(state.step.value0));
        if (state.step instanceof $994495db3cff0a67$export$e3f45034ca213b36) return $7eb5302f7c7694e0$export$5d305c9f0a1c804d;
        if (state.step instanceof $994495db3cff0a67$export$ebff56b4c8ba0e39) return $c13f96732740c363$var$div$prime([
            $c13f96732740c363$var$text("")
        ]);
        return $b5330906fcd65ffd$export$d558900b1478007d;
    };
};
var $c13f96732740c363$export$987d7d592b828731 = function(renderOptions) {
    return function(initial) {
        return $c13f96732740c363$var$bind2($c13f96732740c363$var$liftEffect1($90327512d8280b8d$export$b8cb59497041ffe4({
            queue: [],
            waiter: $06733ae99ed4f534$export$bebe9059409a0d04.value
        })))(function(mailbox) {
            return $c13f96732740c363$var$bind2($c13f96732740c363$var$liftEffect1($90327512d8280b8d$export$b8cb59497041ffe4(0)))(function(epoch) {
                return $c13f96732740c363$var$bind2($c13f96732740c363$var$interpretCommands(mailbox)($4b57a9a20c626e9f$export$36aff1fbb4f5dfc6(initial)))(function(bootstrapped) {
                    return $c13f96732740c363$var$runAppLoop($c13f96732740c363$var$appMessageWidget(renderOptions))(epoch)(mailbox)(bootstrapped);
                });
            });
        });
    };
};
var $c13f96732740c363$export$82ba02fb2c129065 = /* #__PURE__ */ $c13f96732740c363$var$bind2(/* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($fe1781b0b9eaad64$export$5f15f35c03bac00f)($54dae5ca6a6cd16d$export$b356868cfa7ebfaf)($f44e895d82c9aa8d$export$71105691af3c9d50))(function(initial) {
    return $c13f96732740c363$export$987d7d592b828731($842627c31b5244a8$export$2d9bd4578fa0224c)(initial);
});


// Generated by purs version 0.15.16















// Generated by purs version 0.15.16
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
}

$11492dca620dcaa5$exports = (parcelRequire("3y30c"));


var $f46ed4009cb9c1cd$exports = {};
'use strict';

$f46ed4009cb9c1cd$exports = (parcelRequire("2jGA3"));


function $70e21632fb0992ef$export$d2ea56a8a6a842ec(element, container) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).render(element, container);
}
function $70e21632fb0992ef$export$4024b11ebffa8d94(element, container) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).hydrate(element, container);
}
const $70e21632fb0992ef$export$c9bc05758d415d1f = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).unmountComponentAtNode;
const $70e21632fb0992ef$export$9578ff1eb9981b9d = (0, (/*@__PURE__*/$parcel$interopDefault($11492dca620dcaa5$exports))).findDOMNode;
const $70e21632fb0992ef$export$29a41a0bc75542b8 = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToString;
const $70e21632fb0992ef$export$1936cbf03fdc853a = (0, (/*@__PURE__*/$parcel$interopDefault($f46ed4009cb9c1cd$exports))).renderToStaticMarkup;







var $03e76c90c058b0f1$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $03e76c90c058b0f1$export$502457920280e6be = /* #__PURE__ */ $28d793bcad7b6401$export$84baa7a1ea5377fd($70e21632fb0992ef$export$c9bc05758d415d1f);
var $03e76c90c058b0f1$export$80e7718417253a51 = /* #__PURE__ */ $d587cad88c02b1d0$export$44d12d4204be2f8c($70e21632fb0992ef$export$29a41a0bc75542b8);
var $03e76c90c058b0f1$export$eb3a06aef9e6ee51 = /* #__PURE__ */ $d587cad88c02b1d0$export$44d12d4204be2f8c($70e21632fb0992ef$export$1936cbf03fdc853a);
var $03e76c90c058b0f1$export$b3890eb0ae9dca99 = function(rEl) {
    return function(el) {
        return $03e76c90c058b0f1$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
            return $70e21632fb0992ef$export$d2ea56a8a6a842ec(rEl, el);
        });
    };
};
var $03e76c90c058b0f1$export$fa8d919ba61d84db = function(rEl) {
    return function(el) {
        return $03e76c90c058b0f1$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3)(function() {
            return $70e21632fb0992ef$export$4024b11ebffa8d94(rEl, el);
        });
    };
};
var $03e76c90c058b0f1$export$466bfc07425424d5 = /* #__PURE__ */ $28d793bcad7b6401$export$84baa7a1ea5377fd($70e21632fb0992ef$export$9578ff1eb9981b9d);


// Generated by purs version 0.15.16
var $17a55b211df71f15$var$getEffProp = function(name) {
    return function(node) {
        return function() {
            return node[name];
        };
    };
};
const $17a55b211df71f15$export$bacb5cc5a11aef16 = $17a55b211df71f15$var$getEffProp("children");
const $17a55b211df71f15$export$52f4bb9f897f1dda = $17a55b211df71f15$var$getEffProp("firstElementChild");
const $17a55b211df71f15$export$b58800d9b8f19191 = $17a55b211df71f15$var$getEffProp("lastElementChild");
const $17a55b211df71f15$export$f89766fb54dff747 = $17a55b211df71f15$var$getEffProp("childElementCount");
function $17a55b211df71f15$export$242934abc2863db9(selector) {
    return function(node) {
        return function() {
            return node.querySelector(selector);
        };
    };
}
function $17a55b211df71f15$export$2e83b5c43fb7af7b(selector) {
    return function(node) {
        return function() {
            return node.querySelectorAll(selector);
        };
    };
}







var $77e12228cc269e35$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $77e12228cc269e35$export$fe9de06a57e74a75 = function(x) {
    return x;
};
var $77e12228cc269e35$export$78fb49a702cc1f2 = function(qs) {
    var $2 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    var $3 = $17a55b211df71f15$export$242934abc2863db9(qs);
    return function($4) {
        return $2($3($4));
    };
};
var $77e12228cc269e35$export$52785ae9e93eaaf8 = $97937c29f879e68e$export$c5f2758e49b2b86a;
var $77e12228cc269e35$export$ed55255aef9f10db = {
    Coercible0: function() {
        return undefined;
    }
};
var $77e12228cc269e35$export$80cfcf47c97f2a3 = /* #__PURE__ */ function() {
    var $5 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($6) {
        return $5($17a55b211df71f15$export$b58800d9b8f19191($6));
    };
}();
var $77e12228cc269e35$export$ef511da7c0e45881 = /* #__PURE__ */ function() {
    var $7 = $77e12228cc269e35$var$map($0a5aaf95f168428e$export$1ba013b88f4f21f3);
    return function($8) {
        return $7($17a55b211df71f15$export$52f4bb9f897f1dda($8));
    };
}();
var $77e12228cc269e35$export$d5769763ca9e4d49 = $37b880af5f4991bd$export$fa624555ca2acbc8;




// Generated by purs version 0.15.16
var $98632a8bc67f7e8c$export$117f7ddab482d006 = "unload";
var $98632a8bc67f7e8c$export$e03c1c3201ee8bb7 = "toggle";
var $98632a8bc67f7e8c$export$853c27de4ce0f746 = "submit";
var $98632a8bc67f7e8c$export$ddcffe0146c8f882 = "storage";
var $98632a8bc67f7e8c$export$2e6c959c16ff56b8 = "select";
var $98632a8bc67f7e8c$export$aad8462122ac592b = "reset";
var $98632a8bc67f7e8c$export$1427eba79b2ae340 = "readystatechange";
var $98632a8bc67f7e8c$export$504d7abb21fa8c9 = "progress";
var $98632a8bc67f7e8c$export$9b6706c8686cfc8e = "paste";
var $98632a8bc67f7e8c$export$6dd222fd9e8d7968 = "online";
var $98632a8bc67f7e8c$export$3b16d2a27b22a87a = "offline";
var $98632a8bc67f7e8c$export$a8ecead220dd38a6 = "message";
var $98632a8bc67f7e8c$export$dca0cefb631ec861 = "loadstart";
var $98632a8bc67f7e8c$export$ddc39cda6f909ee1 = "loadend";
var $98632a8bc67f7e8c$export$11e63f7b0f3d9900 = "load";
var $98632a8bc67f7e8c$export$8d5b9ac6cde54772 = "languagechange";
var $98632a8bc67f7e8c$export$9f85add0327f687e = "invalid";
var $98632a8bc67f7e8c$export$b7e3ae3d7c15e42e = "input";
var $98632a8bc67f7e8c$export$d7ddd398f22d79ef = "focus";
var $98632a8bc67f7e8c$export$a3bc9b8ed74fc = "error";
var $98632a8bc67f7e8c$export$ead50553077ff635 = "DOMContentLoaded";
var $98632a8bc67f7e8c$export$af2a99f971a346e6 = "cut";
var $98632a8bc67f7e8c$export$784d13d8ee351f07 = "copy";
var $98632a8bc67f7e8c$export$8360e631d277ea4d = "close";
var $98632a8bc67f7e8c$export$64ef1bee2b9504c1 = "click";
var $98632a8bc67f7e8c$export$d8a7b8f475ec0161 = "change";
var $98632a8bc67f7e8c$export$70b61ad426ddbe54 = "cancel";
var $98632a8bc67f7e8c$export$2cc7ff91bcacba5e = "blur";
var $98632a8bc67f7e8c$export$26ecb34e09d46df7 = "beforescriptexecute";
var $98632a8bc67f7e8c$export$ad2ab82a6fc787c7 = "beforeprint";
var $98632a8bc67f7e8c$export$7af6a91a06bd66bd = "afterscriptexecute";
var $98632a8bc67f7e8c$export$56890049c3283011 = "afterprint";
var $98632a8bc67f7e8c$export$5def58af4fd46132 = "abort";






var $2e240a40d1eec051$var$bind = /* #__PURE__ */ $70cd3177464e7915$export$2385a24977818dd0($edf0339512807bee$export$f885f489dcf38a2d);
var $2e240a40d1eec051$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($edf0339512807bee$export$666a030cecdf96c);
var $2e240a40d1eec051$var$bindFlipped = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $2e240a40d1eec051$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $2e240a40d1eec051$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($edf0339512807bee$export$9dc0454a98607988);
var $2e240a40d1eec051$var$bindFlipped1 = /* #__PURE__ */ $70cd3177464e7915$export$f2077a1c19a006d9($06733ae99ed4f534$export$e5fea5661dee377);
var $2e240a40d1eec051$var$pure1 = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $2e240a40d1eec051$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($6c2f8951ecf9531e$export$91fce01ecf0438e1);
var $2e240a40d1eec051$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $2e240a40d1eec051$var$discard2 = /* #__PURE__ */ $2e240a40d1eec051$var$discard($edf0339512807bee$export$f885f489dcf38a2d);
var $2e240a40d1eec051$var$$$for = /* #__PURE__ */ $11d1e86de605dfc6$export$f89de2e5bf57e5e6($edf0339512807bee$export$9dc0454a98607988)($11d1e86de605dfc6$export$80f6258c17467741);
var $2e240a40d1eec051$var$mempty = /* #__PURE__ */ $784e1bd3d26d71da$export$9a7d64bc1d75357($784e1bd3d26d71da$export$db307f59121ffcc4);
var $2e240a40d1eec051$var$throwError = /* #__PURE__ */ $5dfefa023749ded0$export$8bf7aba4a9e09055($edf0339512807bee$export$37a9b80154c7d256);
var $2e240a40d1eec051$export$895e5c0dd54cd456 = function(query) {
    return $2e240a40d1eec051$var$bind($2e240a40d1eec051$var$liftEffect($2e240a40d1eec051$var$bindFlipped($2e240a40d1eec051$var$composeKleisliFlipped(function() {
        var $20 = $77e12228cc269e35$export$78fb49a702cc1f2(query);
        return function($21) {
            return $20($f6c9290a5db8f197$export$c8b651b897da2de($21));
        };
    }())($aa35a24624ec08d2$export$5a7bfc01df82fcd1))($2603425f82e959df$export$8291e5b88f90ce4)))(function(mel) {
        return $2e240a40d1eec051$var$pure($2e240a40d1eec051$var$bindFlipped1($5ae75883a0b7923c$export$c56654a6d0e3bd48)(mel));
    });
};
var $2e240a40d1eec051$export$9c0227c127662a5d = /* #__PURE__ */ $edf0339512807bee$export$ef62257e6f8a5f8c(/* #__PURE__ */ $7d4cccdf062a2261$export$5f5be1bb6cd1fded($ad2cf6904bca3ba1$export$de0c4a986b439e52)(/* #__PURE__ */ $f57f4b701aa7b66e$export$5b38a098e5a9e7ca(/* #__PURE__ */ $2e240a40d1eec051$var$pure1($05149ea687d6b460$export$523c0b569236b342))));
var $2e240a40d1eec051$export$11dc33decdfc25c9 = /* #__PURE__ */ $b28443a27438717a$export$49d5975414e0a979(function(callback) {
    return function __do() {
        var rs = $2e240a40d1eec051$var$bindFlipped($f6c9290a5db8f197$export$1ae2b664eea77b7e)($2e240a40d1eec051$var$bindFlipped($aa35a24624ec08d2$export$5a7bfc01df82fcd1)($2603425f82e959df$export$8291e5b88f90ce4))();
        if (rs instanceof $99cfc603fe5cc0f7$export$669f6ea7d267feaf) {
            var et = $2e240a40d1eec051$var$map($6b26c9b0fa2d7b7a$export$55c9526d22b9f8e6)($2603425f82e959df$export$8291e5b88f90ce4)();
            var listener = $98db70b23aa8a6ea$export$f5cdf3809b4587f3(function(v) {
                return callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342));
            })();
            $98db70b23aa8a6ea$export$3f65cefe8380dbea($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et)();
            return $edf0339512807bee$export$952106a975f35ae2($98db70b23aa8a6ea$export$8ff9f68337b520c0($98632a8bc67f7e8c$export$ead50553077ff635)(listener)(false)(et));
        }
        callback(new $7d4cccdf062a2261$export$19db0165690c701a($05149ea687d6b460$export$523c0b569236b342))();
        return $edf0339512807bee$export$8deb6e154ce67af6;
    };
});
var $2e240a40d1eec051$export$45bbd13c70e20e52 = function(query) {
    return function(w) {
        return $2e240a40d1eec051$export$9c0227c127662a5d($2e240a40d1eec051$var$discard2($2e240a40d1eec051$export$11dc33decdfc25c9)(function() {
            return $2e240a40d1eec051$var$bind($2e240a40d1eec051$export$895e5c0dd54cd456(query))(function(mroot) {
                return $2e240a40d1eec051$var$$$for(mroot)(function(root) {
                    var rootElement = $5ae75883a0b7923c$export$8d51e3db1a844094(root);
                    return $2e240a40d1eec051$var$liftEffect($03e76c90c058b0f1$export$b3890eb0ae9dca99($3257df7cdef77623$export$6e131e0de1d8ccb4("Concur")($2e240a40d1eec051$var$mempty)(w))(rootElement));
                });
            });
        }));
    };
};
var $2e240a40d1eec051$export$5b2ed9ea3599e5bb = function(elemId) {
    return $2e240a40d1eec051$export$45bbd13c70e20e52(elemId);
};
var $2e240a40d1eec051$export$c928ab20a18b7fa6 = function(elemId) {
    return $2e240a40d1eec051$export$5b2ed9ea3599e5bb("#" + elemId);
};
var $2e240a40d1eec051$export$f79c83a36c9670be = /* #__PURE__ */ $2e240a40d1eec051$var$discard2($2e240a40d1eec051$export$11dc33decdfc25c9)(function() {
    return $2e240a40d1eec051$var$bind($2e240a40d1eec051$export$895e5c0dd54cd456("body"))(function(body) {
        return $06733ae99ed4f534$export$f8b8b9ce72e9ccbf($2e240a40d1eec051$var$throwError($ad2cf6904bca3ba1$export$a3bc9b8ed74fc("Could not find body")))($2e240a40d1eec051$var$pure)(body);
    });
});




// Generated by purs version 0.15.16



// Generated by purs version 0.15.16















var $d30ea600cb89759b$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $d30ea600cb89759b$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($73aa5dd1904ebcb7$export$3780b8670d5f24f8);
var $d30ea600cb89759b$var$identity = /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa);
var $d30ea600cb89759b$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($73aa5dd1904ebcb7$export$28587442a46d4141);
var $d30ea600cb89759b$export$1bffd077443cd981 = /* #__PURE__ */ function() {
    function Yield(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    }
    Yield.create = function(value0) {
        return function(value1) {
            return new Yield(value0, value1);
        };
    };
    return Yield;
}();
var $d30ea600cb89759b$export$38d24f5c1eb0e4c0 = /* #__PURE__ */ function() {
    function Skip(value0) {
        this.value0 = value0;
    }
    Skip.create = function(value0) {
        return new Skip(value0);
    };
    return Skip;
}();
var $d30ea600cb89759b$export$7fe28cb29e71bf10 = /* #__PURE__ */ function() {
    function Done() {}
    Done.value = new Done();
    return Done;
}();
var $d30ea600cb89759b$export$4ae3cbbaa857dd72 = function(x) {
    return x;
};
var $d30ea600cb89759b$export$72a5dac3748973f0 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(v) {
        return pure1(new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(v));
    };
};
var $d30ea600cb89759b$export$860beaf0e87f1a9f = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(v) {
        return map2(function($338) {
            return $d30ea600cb89759b$export$38d24f5c1eb0e4c0.create($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($338)));
        })(v);
    };
};
var $d30ea600cb89759b$export$c48e357c1a89b78d = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    return function(f) {
        return function(z) {
            var g = function(v) {
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0.value1, $99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                    return $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad)(f)(v.value0.value0);
                }));
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 130, column 3 - line 130, column 60): " + [
                    v.constructor.name
                ]);
            };
            return map2(g)(f(z));
        };
    };
};
var $d30ea600cb89759b$export$b446f6baa3bb1430 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return function(v) {
        var g = function(v1) {
            if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(v1.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1))));
            if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad)($99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0));
            if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return pure1($06733ae99ed4f534$export$bebe9059409a0d04.value);
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 195, column 3 - line 195, column 50): " + [
                v1.constructor.name
            ]);
        };
        return bind(v)(g);
    };
};
var $d30ea600cb89759b$export$c01875f616615628 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$6f71268a1666ab58))(uncons1(l));
    };
};
var $d30ea600cb89759b$var$stepMap = function(dictFunctor) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
    return function(f) {
        return function(v) {
            return map2(f)(v);
        };
    };
};
var $d30ea600cb89759b$export$9384c7afe4015e42 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $255 = f(v.value0);
                if ($255) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value1));
                return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$9384c7afe4015e42(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 154, column 3 - line 154, column 68): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$65f513eaf3c582b8 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(b) {
            return function(l) {
                var g = function(v) {
                    var h = function(v1) {
                        if (v1 instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                            var b$prime$prime = f(v.value0)(v1.value0);
                            return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(b$prime$prime, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value1)), v.value0));
                        }
                        if (v1 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(new $71f2e2e9476163f8$export$1908877435b1d5e9(v.value0, $99af8ad7682e39c7$export$4d82290515cd0ddb(v1.value0)), v.value0));
                        if (v1 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
                        throw new Error("Failed pattern match at Control.Monad.List.Trans (line 248, column 5 - line 248, column 78): " + [
                            v1.constructor.name
                        ]);
                    };
                    return map2(h)(v.value1);
                };
                return unfold1(g)(new $71f2e2e9476163f8$export$1908877435b1d5e9(b, l));
            };
        };
    };
};
var $d30ea600cb89759b$export$3466dae21163a3ee = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(h) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981(h, t));
        };
    };
};
var $d30ea600cb89759b$export$68159836694e22c1 = function(dictApplicative) {
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(dictApplicative);
    return function(h) {
        return function(t) {
            return prepend$prime1(h)($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(t)));
        };
    };
};
var $d30ea600cb89759b$export$f2c4f74e8fe88e34 = function(dictApplicative) {
    return $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative)($d30ea600cb89759b$export$7fe28cb29e71bf10.value);
};
var $d30ea600cb89759b$export$439306a4dcaafbb9 = function(dictApplicative) {
    var prepend1 = $d30ea600cb89759b$export$68159836694e22c1(dictApplicative);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(a) {
        return prepend1(a)(nil1);
    };
};
var $d30ea600cb89759b$export$b7df5d561049483a = function(dictApplicative) {
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return nil1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v2.value0, $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$b7df5d561049483a(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 147, column 3 - line 147, column 47): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$e3b52f6f0a4bd72e = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Applicative0);
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var Bind1 = dictMonad.Bind1();
    var Functor0 = Bind1.Apply0().Functor0();
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(Functor0);
    var prepend$prime1 = $d30ea600cb89759b$export$3466dae21163a3ee(Applicative0);
    var wrapEffect1 = $d30ea600cb89759b$export$860beaf0e87f1a9f(Functor0);
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Bind1);
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var g = function(v) {
            return function(v1) {
                if (v1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(nil1);
                if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073 && v1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f(prepend$prime1)($99af8ad7682e39c7$export$260e5c0943f31606(function(v2) {
                    return $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad)(f)(v.value0.value1)(v1.value0.value1);
                })))(f(v.value0.value0)(v1.value0.value0));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 260, column 3 - line 260, column 25): " + [
                    v.constructor.name,
                    v1.constructor.name
                ]);
            };
        };
        var loop = function(fa) {
            return function(fb) {
                return wrapEffect1(bind(uncons1(fa))(function(ua) {
                    return bind(uncons1(fb))(function(ub) {
                        return g(ua)(ub);
                    });
                }));
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$b634740ce272acb5 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var zipWith$prime1 = $d30ea600cb89759b$export$e3b52f6f0a4bd72e(dictMonad);
    return function(f) {
        var g = function(a) {
            return function(b) {
                return pure1(f(a)(b));
            };
        };
        return zipWith$prime1(g);
    };
};
var $d30ea600cb89759b$export$acf0795b499e2d1a = {
    Coercible0: function() {
        return undefined;
    }
};
var $d30ea600cb89759b$export$e70771d2e7e590a = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return $06733ae99ed4f534$export$43db023a260c5e9f($d30ea600cb89759b$export$38d24f5c1eb0e4c0.create)($d30ea600cb89759b$var$map($d30ea600cb89759b$export$1bffd077443cd981.create)(f(v.value0)))($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value1));
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 183, column 3 - line 183, column 72): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$c1a059043cc9c119 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var unfold1 = $d30ea600cb89759b$export$c48e357c1a89b78d(dictMonad);
    return function(f) {
        return function(a) {
            var g = function(x) {
                return pure1(new $06733ae99ed4f534$export$8a67b48435b5d073(new $71f2e2e9476163f8$export$1908877435b1d5e9(f(x), x)));
            };
            return unfold1(g)(a);
        };
    };
};
var $d30ea600cb89759b$export$76d90c956114f2c2 = function(dictMonad) {
    return $d30ea600cb89759b$export$c1a059043cc9c119(dictMonad)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$5fd5031fecdacec3 = function(dictMonad) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictMonad.Bind1().Apply0().Functor0());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(l) {
        return map2($d30ea600cb89759b$var$map($71f2e2e9476163f8$export$9e770fa6ce19a9d6))(uncons1(l));
    };
};
var $d30ea600cb89759b$export$5af6b427ff316359 = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return {
        map: function(f) {
            var g = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(f(v.value0), $d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($f4b2eb11fc32ed34$export$871de8747c9eaa88($d30ea600cb89759b$export$5af6b427ff316359(dictFunctor))(f))(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 280, column 5 - line 280, column 48): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(g);
        }
    };
};
var $d30ea600cb89759b$export$df62323340295157 = function(dictApplicative) {
    var map2 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictApplicative.Apply0().Functor0());
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative);
    return function(fa) {
        return map2($f57f4b701aa7b66e$export$8a83211c878a3f1f($d30ea600cb89759b$export$1bffd077443cd981.create)($99af8ad7682e39c7$export$260e5c0943f31606(function(v) {
            return nil1;
        })))(fa);
    };
};
var $d30ea600cb89759b$export$619131e858bec5bb = {
    lift: function(dictMonad) {
        return $d30ea600cb89759b$export$df62323340295157(dictMonad.Applicative0());
    }
};
var $d30ea600cb89759b$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $d30ea600cb89759b$export$5f62080e6ea5ad16 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))(function(b$prime) {
                        return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                            a: b$prime,
                            b: v.value0.value1
                        }));
                    });
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 221, column 5 - line 221, column 45): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$3120598051129cb3 = function(dictMonadRec) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonadRec.Monad0().Applicative0());
    return $d30ea600cb89759b$export$5f62080e6ea5ad16(dictMonadRec)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$48b115eebb7f3c53 = function(dictMonadRec) {
    var Monad0 = dictMonadRec.Monad0();
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(Monad0.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(Monad0.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(Monad0);
    var tailRecM2 = $f93520de2fa37b44$export$9056a6bb308e8c79(dictMonadRec);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(new $f93520de2fa37b44$export$7fe28cb29e71bf10(b));
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return pure1(new $f93520de2fa37b44$export$550acbd06a1f5a6a({
                        a: f(b)(v.value0.value0),
                        b: v.value0.value1
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 239, column 7 - line 239, column 47): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return tailRecM2(loop);
    };
};
var $d30ea600cb89759b$export$fa87a49fad651048 = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return bind(f(b)(v.value0.value0))($f57f4b701aa7b66e$export$8a83211c878a3f1f(loop)(v.value0.value1));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 212, column 5 - line 212, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$99ac321f734efd9b = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    return $d30ea600cb89759b$export$fa87a49fad651048(dictMonad)(function(v) {
        return function(v1) {
            return pure1($05149ea687d6b460$export$523c0b569236b342);
        };
    })($05149ea687d6b460$export$523c0b569236b342);
};
var $d30ea600cb89759b$export$50ae948ca12cdcbc = function(dictMonad) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    var uncons1 = $d30ea600cb89759b$export$b446f6baa3bb1430(dictMonad);
    return function(f) {
        var loop = function(b) {
            return function(l) {
                var g = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return pure1(b);
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return loop(f(b)(v.value0.value0))(v.value0.value1);
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 229, column 5 - line 229, column 35): " + [
                        v.constructor.name
                    ]);
                };
                return bind(uncons1(l))(g);
            };
        };
        return loop;
    };
};
var $d30ea600cb89759b$export$3dea766d36a8935f = function(dictFunctor) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictFunctor);
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value1);
                var $305 = f(v.value0);
                if ($305) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, s$prime);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) {
                var s$prime = $d30ea600cb89759b$var$map1($d30ea600cb89759b$export$3dea766d36a8935f(dictFunctor)(f))(v.value0);
                return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0(s$prime);
            }
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 176, column 3 - line 176, column 80): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$533af5c8cd6afa16 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(f) {
        var g = function(v) {
            if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                var $310 = f(v.value0);
                if ($310) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value1));
                return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, v.value1);
            }
            if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$533af5c8cd6afa16(dictApplicative)(f))(v.value0));
            if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
            throw new Error("Failed pattern match at Control.Monad.List.Trans (line 169, column 3 - line 169, column 70): " + [
                v.constructor.name
            ]);
        };
        return stepMap1(g);
    };
};
var $d30ea600cb89759b$export$663103110d94aac9 = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(v) {
        return function(v1) {
            if (v === 0) return v1;
            var f = function(v2) {
                if (v2 instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v - 1 | 0))(v2.value1));
                if (v2 instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1($d30ea600cb89759b$export$663103110d94aac9(dictApplicative)(v))(v2.value0));
                if (v2 instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 162, column 3 - line 162, column 44): " + [
                    v2.constructor.name
                ]);
            };
            return stepMap1(f)(v1);
        };
    };
};
var $d30ea600cb89759b$export$8327ebbef2a0ba76 = function(dictApplicative) {
    var pure1 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictApplicative);
    return function(lh) {
        return function(t) {
            return pure1(new $d30ea600cb89759b$export$1bffd077443cd981($99af8ad7682e39c7$export$4d82290515cd0ddb(lh), t));
        };
    };
};
var $d30ea600cb89759b$export$e5d91f6921d97963 = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var singleton1 = $d30ea600cb89759b$export$439306a4dcaafbb9(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    return {
        unfoldr1: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v.value1 instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return singleton1(v.value0);
                    if (v.value1 instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value1.value0));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 294, column 12 - line 296, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        }
    };
};
var $d30ea600cb89759b$export$bbfbcefbf94b996f = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var nil1 = $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0);
    var cons1 = $d30ea600cb89759b$export$8327ebbef2a0ba76(Applicative0);
    var unfoldable1ListT1 = $d30ea600cb89759b$export$e5d91f6921d97963(dictMonad);
    return {
        unfoldr: function(f) {
            return function(b) {
                var go = function(v) {
                    if (v instanceof $06733ae99ed4f534$export$bebe9059409a0d04) return nil1;
                    if (v instanceof $06733ae99ed4f534$export$8a67b48435b5d073) return cons1($d30ea600cb89759b$var$pure(v.value0.value0))($99af8ad7682e39c7$export$260e5c0943f31606(function(v1) {
                        return go(f(v.value0.value1));
                    }));
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 287, column 12 - line 289, column 67): " + [
                        v.constructor.name
                    ]);
                };
                return go(f(b));
            };
        },
        Unfoldable10: function() {
            return unfoldable1ListT1;
        }
    };
};
var $d30ea600cb89759b$export$e65aba2be8e37f8a = function(dictApplicative) {
    return {
        append: $d30ea600cb89759b$var$concat(dictApplicative)
    };
};
var $d30ea600cb89759b$var$concat = function(dictApplicative) {
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictApplicative.Apply0().Functor0());
    return function(x) {
        return function(y) {
            var f = function(v) {
                if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) return new $d30ea600cb89759b$export$1bffd077443cd981(v.value0, $d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value1));
                if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                    return $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative))(v1)(y);
                })(v.value0));
                if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($99af8ad7682e39c7$export$260e5c0943f31606($f57f4b701aa7b66e$export$5b38a098e5a9e7ca(y)));
                throw new Error("Failed pattern match at Control.Monad.List.Trans (line 106, column 3 - line 106, column 43): " + [
                    v.constructor.name
                ]);
            };
            return stepMap1(f)(x);
        };
    };
};
var $d30ea600cb89759b$export$6b8d2264760710b = function(dictApplicative) {
    var semigroupListT1 = $d30ea600cb89759b$export$e65aba2be8e37f8a(dictApplicative);
    return {
        mempty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(dictApplicative),
        Semigroup0: function() {
            return semigroupListT1;
        }
    };
};
var $d30ea600cb89759b$export$986c2bbe7a34be0b = function(dictFunctor) {
    return $d30ea600cb89759b$export$e70771d2e7e590a(dictFunctor)($d30ea600cb89759b$var$identity);
};
var $d30ea600cb89759b$export$204d5ba0706a4088 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
        },
        Bind1: function() {
            return $d30ea600cb89759b$export$871b02513702e0(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$871b02513702e0 = function(dictMonad) {
    var append = $d7bf9817a417d4ae$export$10d8903dec122b9d($d30ea600cb89759b$export$e65aba2be8e37f8a(dictMonad.Applicative0()));
    var stepMap1 = $d30ea600cb89759b$var$stepMap(dictMonad.Bind1().Apply0().Functor0());
    return {
        bind: function(fa) {
            return function(f) {
                var g = function(v) {
                    if (v instanceof $d30ea600cb89759b$export$1bffd077443cd981) {
                        var h = function(s$prime) {
                            return append(f(v.value0))($70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(s$prime)(f));
                        };
                        return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(h)(v.value1));
                    }
                    if (v instanceof $d30ea600cb89759b$export$38d24f5c1eb0e4c0) return new $d30ea600cb89759b$export$38d24f5c1eb0e4c0($d30ea600cb89759b$var$map1(function(v1) {
                        return $70cd3177464e7915$export$2385a24977818dd0($d30ea600cb89759b$export$871b02513702e0(dictMonad))(v1)(f);
                    })(v.value0));
                    if (v instanceof $d30ea600cb89759b$export$7fe28cb29e71bf10) return $d30ea600cb89759b$export$7fe28cb29e71bf10.value;
                    throw new Error("Failed pattern match at Control.Monad.List.Trans (line 306, column 5 - line 308, column 31): " + [
                        v.constructor.name
                    ]);
                };
                return stepMap1(g)(fa);
            };
        },
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$fd7d3bacedac3347 = function(dictMonad) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($d30ea600cb89759b$export$204d5ba0706a4088(dictMonad)),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$cf70c952df59e46e = function(dictMonad) {
    return {
        pure: $d30ea600cb89759b$export$439306a4dcaafbb9(dictMonad.Applicative0()),
        Apply0: function() {
            return $d30ea600cb89759b$export$fd7d3bacedac3347(dictMonad);
        }
    };
};
var $d30ea600cb89759b$export$f00d8368ae31463f = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftEffect: function() {
            var $339 = $d30ea600cb89759b$var$lift(Monad0);
            var $340 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($341) {
                return $339($340($341));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$24d9325f26d68bae = function(dictMonadST) {
    var Monad0 = dictMonadST.Monad0();
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(Monad0);
    return {
        liftST: function() {
            var $342 = $d30ea600cb89759b$var$lift(Monad0);
            var $343 = $dd1bd2cc217b6a6d$export$90556654c9c47d5f(dictMonadST);
            return function($344) {
                return $342($343($344));
            };
        }(),
        Monad0: function() {
            return monadListT1;
        }
    };
};
var $d30ea600cb89759b$export$bf13ffdc6b7113ca = function(dictApplicative) {
    var functorListT1 = $d30ea600cb89759b$export$5af6b427ff316359(dictApplicative.Apply0().Functor0());
    return {
        alt: $d30ea600cb89759b$var$concat(dictApplicative),
        Functor0: function() {
            return functorListT1;
        }
    };
};
var $d30ea600cb89759b$export$82f742a0347e990a = function(dictMonad) {
    var Applicative0 = dictMonad.Applicative0();
    var altListT1 = $d30ea600cb89759b$export$bf13ffdc6b7113ca(Applicative0);
    return {
        empty: $d30ea600cb89759b$export$f2c4f74e8fe88e34(Applicative0),
        Alt0: function() {
            return altListT1;
        }
    };
};
var $d30ea600cb89759b$export$183e8a1c18c60fd3 = function(dictMonad) {
    var applicativeListT1 = $d30ea600cb89759b$export$cf70c952df59e46e(dictMonad);
    var plusListT1 = $d30ea600cb89759b$export$82f742a0347e990a(dictMonad);
    return {
        Applicative0: function() {
            return applicativeListT1;
        },
        Plus1: function() {
            return plusListT1;
        }
    };
};
var $d30ea600cb89759b$export$bb0af79e56ac53fe = function(dictMonad) {
    var monadListT1 = $d30ea600cb89759b$export$204d5ba0706a4088(dictMonad);
    var alternativeListT1 = $d30ea600cb89759b$export$183e8a1c18c60fd3(dictMonad);
    return {
        Monad0: function() {
            return monadListT1;
        },
        Alternative1: function() {
            return alternativeListT1;
        }
    };
};








// Generated by purs version 0.15.16
// global exports
var $77a8e76fdca2c8ca$var$createDate = function(y, m, d, h, mi, s, ms) {
    var date = new Date(Date.UTC(y, m, d, h, mi, s, ms));
    if (y >= 0 && y < 100) date.setUTCFullYear(y);
    return date;
};
var $77a8e76fdca2c8ca$var$createLocalDate = function(y, m, d, h, mi, s, ms) {
    var date = new Date(y, m, d, h, mi, s, ms);
    if (y >= 0 && y < 100) date.setFullYear(y);
    return date;
};
function $77a8e76fdca2c8ca$export$461939dd4422153() {
    return new Date();
}
function $77a8e76fdca2c8ca$export$1ea939691cdc45b8(date) {
    return !isNaN(date.getTime());
}
function $77a8e76fdca2c8ca$export$7675be32eeb73e8c(just) {
    return function(nothing) {
        return function(date) {
            var t = date.getTime();
            return isNaN(t) ? nothing : just(t);
        };
    };
}
function $77a8e76fdca2c8ca$export$b60fc02c90a62c72(instant) {
    return new Date(instant);
}
function $77a8e76fdca2c8ca$export$353d455c4d01fe57(parts) {
    return $77a8e76fdca2c8ca$var$createDate(parts.year, parts.month, parts.day, parts.hour, parts.minute, parts.second, parts.millisecond);
}
function $77a8e76fdca2c8ca$export$db1191b95e017e08(parts) {
    return function() {
        return $77a8e76fdca2c8ca$var$createLocalDate(parts.year, parts.month, parts.day, parts.hour, parts.minute, parts.second, parts.millisecond);
    };
}
function $77a8e76fdca2c8ca$export$d3766d7f77b34054(method, date) {
    return date[method]();
}
function $77a8e76fdca2c8ca$export$c67296b285a74fc3(method, date) {
    return function() {
        return date[method]();
    };
}
function $77a8e76fdca2c8ca$export$98e6a39c04603d36(dateString) {
    return function() {
        return new Date(dateString);
    };
}
function $77a8e76fdca2c8ca$export$acc4b6e687dc563f(time) {
    return new Date(time);
}






// Generated by purs version 0.15.16
var $4261ba653755ead8$var$createDateTime = function(y, m, d, h, mi, s, ms) {
    var dateTime = new Date(Date.UTC(y, m, d, h, mi, s, ms));
    if (y >= 0 && y < 100) dateTime.setUTCFullYear(y);
    return dateTime;
};
function $4261ba653755ead8$export$4ceb5c6f8416b1d0(y, mo, d, h, mi, s, ms) {
    return $4261ba653755ead8$var$createDateTime(y, mo - 1, d, h, mi, s, ms).getTime();
}
function $4261ba653755ead8$export$e7e4adb27c12afea(ctor) {
    return function(instant) {
        var dt = new Date(instant);
        return ctor(dt.getUTCFullYear())(dt.getUTCMonth() + 1)(dt.getUTCDate())(dt.getUTCHours())(dt.getUTCMinutes())(dt.getUTCSeconds())(dt.getUTCMilliseconds());
    };
}














var $0e22ea1e74f8e3e7$var$fromJust = /* #__PURE__ */ $06733ae99ed4f534$export$2506262575dd10a7();
var $0e22ea1e74f8e3e7$var$toEnum = /* #__PURE__ */ $f935a9866e211c00$export$45328c01562fb205($e660aadfc8d8f891$export$e744bc4044126e99);
var $0e22ea1e74f8e3e7$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($3c54b6e6d30cc3be$export$1d3b9b5391a72ae7);
var $0e22ea1e74f8e3e7$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $0e22ea1e74f8e3e7$var$bottom = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$a07dd689fd52f43a);
var $0e22ea1e74f8e3e7$var$bottom1 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$2e9ad76d003e68e6);
var $0e22ea1e74f8e3e7$var$bottom2 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$14f9cc6a73419a24);
var $0e22ea1e74f8e3e7$var$bottom3 = /* #__PURE__ */ $69d0e3dbb12088d2$export$40e543e69a8b3fbb($0b11e4a917ce3a7d$export$1bc1fc48769dfdc5);
var $0e22ea1e74f8e3e7$var$append1 = /* #__PURE__ */ $d7bf9817a417d4ae$export$10d8903dec122b9d($3c54b6e6d30cc3be$export$def67087bd72fdb7);
var $0e22ea1e74f8e3e7$var$negateDuration = /* #__PURE__ */ $3c54b6e6d30cc3be$export$28743521ea1cb8f9($3c54b6e6d30cc3be$export$44304cbc75c995e8);
var $0e22ea1e74f8e3e7$var$Instant = function(x) {
    return x;
};
var $0e22ea1e74f8e3e7$export$d09033f410e6cbd8 = function(v) {
    return v;
};
var $0e22ea1e74f8e3e7$export$c2dea5c02f48568d = /* #__PURE__ */ function() {
    var mkDateTime = function(y) {
        return function(mo) {
            return function(d) {
                return function(h) {
                    return function(mi) {
                        return function(s) {
                            return function(ms) {
                                return new $18f2b327b2ac3376$export$82f9ebd9adeba146($7577649a7445e8e0$export$e352e11a7fa73bba(y)($0e22ea1e74f8e3e7$var$fromJust($0e22ea1e74f8e3e7$var$toEnum(mo)))(d), new $d254595454e6e9b0$export$680ea196effce5f(h, mi, s, ms));
                            };
                        };
                    };
                };
            };
        };
    };
    return $4261ba653755ead8$export$e7e4adb27c12afea(mkDateTime);
}();
var $0e22ea1e74f8e3e7$export$84fb2716d05f64f3 = {
    show: function(v) {
        return "(Instant " + ($0e22ea1e74f8e3e7$var$show(v) + ")");
    }
};
var $0e22ea1e74f8e3e7$export$e2fa58ffd7b3a1ab = $3c54b6e6d30cc3be$export$e0a5c04af6395341;
var $0e22ea1e74f8e3e7$export$6e4cd7a6d73ce13e = function(v) {
    if (v >= -8639977881600000 && v <= 8.639977881599999e15) return new $06733ae99ed4f534$export$8a67b48435b5d073(v);
    if ($5089f43af3d55e5d$export$4bed41887d8c5096) return $06733ae99ed4f534$export$bebe9059409a0d04.value;
    throw new Error("Failed pattern match at Data.DateTime.Instant (line 44, column 1 - line 44, column 41): " + [
        v.constructor.name
    ]);
};
var $0e22ea1e74f8e3e7$export$e141e740b7704cc4 = function(v) {
    return $4261ba653755ead8$export$4ceb5c6f8416b1d0($7577649a7445e8e0$export$31803937850fb2da(v.value0), $0e22ea1e74f8e3e7$var$fromEnum($7577649a7445e8e0$export$af5de1609f06c8e6(v.value0)), $7577649a7445e8e0$export$d2d39d1adcc883a2(v.value0), $d254595454e6e9b0$export$842e383dfc19bc67(v.value1), $d254595454e6e9b0$export$1cacba1045a8e790(v.value1), $d254595454e6e9b0$export$3d3c77ce7df7d30d(v.value1), $d254595454e6e9b0$export$edc5e5cb87280477(v.value1));
};
var $0e22ea1e74f8e3e7$export$e57ff100d91bd4b9 = function(d) {
    return $4261ba653755ead8$export$4ceb5c6f8416b1d0($7577649a7445e8e0$export$31803937850fb2da(d), $0e22ea1e74f8e3e7$var$fromEnum($7577649a7445e8e0$export$af5de1609f06c8e6(d)), $7577649a7445e8e0$export$d2d39d1adcc883a2(d), $0e22ea1e74f8e3e7$var$bottom, $0e22ea1e74f8e3e7$var$bottom1, $0e22ea1e74f8e3e7$var$bottom2, $0e22ea1e74f8e3e7$var$bottom3);
};
var $0e22ea1e74f8e3e7$export$a99463abb2339a45 = $3c54b6e6d30cc3be$export$699cb56941ecf990;
var $0e22ea1e74f8e3e7$export$a37e3c603d7117e5 = function(dictDuration) {
    var toDuration = $3c54b6e6d30cc3be$export$9eabacebe6624782(dictDuration);
    return function(dt1) {
        return function(dt2) {
            return toDuration($0e22ea1e74f8e3e7$var$append1($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(dt1))($0e22ea1e74f8e3e7$var$negateDuration($0e22ea1e74f8e3e7$export$d09033f410e6cbd8(dt2))));
        };
    };
};
var $0e22ea1e74f8e3e7$export$af36687d2b3e6466 = /* #__PURE__ */ function() {
    return {
        bottom: -8639977881600000,
        top: 8.639977881599999e15,
        Ord0: function() {
            return $0e22ea1e74f8e3e7$export$e2fa58ffd7b3a1ab;
        }
    };
}();













var $c18a56c801057a91$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($f4b2eb11fc32ed34$export$11c8d16a3c15d11b);
var $c18a56c801057a91$var$map1 = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($06733ae99ed4f534$export$fdd2427f0e60fd66);
var $c18a56c801057a91$var$show = /* #__PURE__ */ $2c6b3d51d10471a7$export$57bf213be019eeb0($2c6b3d51d10471a7$export$e5aa470f8f97c3fe);
var $c18a56c801057a91$var$fromEnum = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2391dde84a7e2cbd);
var $c18a56c801057a91$var$fromEnum1 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$e744bc4044126e99);
var $c18a56c801057a91$var$fromEnum2 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($e660aadfc8d8f891$export$2f59e9c675f625db);
var $c18a56c801057a91$var$fromEnum3 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$3e668e9da55710cb);
var $c18a56c801057a91$var$fromEnum4 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$d4e91fe4c2aba62a);
var $c18a56c801057a91$var$fromEnum5 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$c9467b6184dd9c81);
var $c18a56c801057a91$var$fromEnum6 = /* #__PURE__ */ $f935a9866e211c00$export$b385cb642735011f($0b11e4a917ce3a7d$export$4789fa20e673c035);
var $c18a56c801057a91$var$compare = /* #__PURE__ */ $97937c29f879e68e$export$398604a469f7de9a($97937c29f879e68e$export$5ed021ff2336715c);
var $c18a56c801057a91$export$f41a557ce4090936 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("toUTCString", dt);
};
var $c18a56c801057a91$export$b489b1fb1454ddcf = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("toTimeString", dt);
};
var $c18a56c801057a91$export$f84e8e69fd4488a5 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("toString", dt);
};
var $c18a56c801057a91$export$74bd20bbe0ff0cee = /* #__PURE__ */ function() {
    return $70cd3177464e7915$export$ea9fbbe247ef8e50($06733ae99ed4f534$export$e5fea5661dee377)(function($21) {
        return $0e22ea1e74f8e3e7$export$6e4cd7a6d73ce13e($3c54b6e6d30cc3be$export$e4eccef8f937a949($21));
    })($77a8e76fdca2c8ca$export$7675be32eeb73e8c($06733ae99ed4f534$export$8a67b48435b5d073.create)($06733ae99ed4f534$export$bebe9059409a0d04.value));
}();
var $c18a56c801057a91$export$dfaaa8705752128f = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("toISOString", dt);
};
var $c18a56c801057a91$export$c2dea5c02f48568d = /* #__PURE__ */ $c18a56c801057a91$var$map(/* #__PURE__ */ $c18a56c801057a91$var$map1($0e22ea1e74f8e3e7$export$c2dea5c02f48568d))($c18a56c801057a91$export$74bd20bbe0ff0cee);
var $c18a56c801057a91$export$b7c4e1545c61edee = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("toDateString", dt);
};
var $c18a56c801057a91$export$e67a095c620b86fe = /* #__PURE__ */ $c18a56c801057a91$var$map(/* #__PURE__ */ $c18a56c801057a91$var$map1($18f2b327b2ac3376$export$324d90190a8b822a))($c18a56c801057a91$export$c2dea5c02f48568d);
var $c18a56c801057a91$export$b53d7f6d40521f58 = /* #__PURE__ */ $c97d2d0f578f81ad$export$6190f2182377b437($50c50d1f444e5fa4$export$9a2f2fd6148bc6d0)("Date");
var $c18a56c801057a91$export$fc39c6ce28d2d2c2 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCSeconds", dt);
};
var $c18a56c801057a91$export$9720dc24d87d9ec3 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCMonth", dt);
};
var $c18a56c801057a91$export$4b24f05abf264b99 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCMinutes", dt);
};
var $c18a56c801057a91$export$3a54e126954c28c3 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCMilliseconds", dt);
};
var $c18a56c801057a91$export$b07408ff07c4fa2b = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCHours", dt);
};
var $c18a56c801057a91$export$45c531626021c019 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCFullYear", dt);
};
var $c18a56c801057a91$export$1e051c0765c8c66f = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCDay", dt);
};
var $c18a56c801057a91$export$d8dced63b9fd5c01 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getUTCDate", dt);
};
var $c18a56c801057a91$export$4c9db454e2785fd9 = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getTimezoneOffset", dt);
};
var $c18a56c801057a91$export$1428f42a7de81803 = function(dt) {
    return $77a8e76fdca2c8ca$export$d3766d7f77b34054("getTime", dt);
};
var $c18a56c801057a91$export$9bc016ce316ab5d2 = {
    show: function(a) {
        return "(fromTime " + ($c18a56c801057a91$var$show($c18a56c801057a91$export$1428f42a7de81803(a)) + ")");
    }
};
var $c18a56c801057a91$export$5e9417507ff28427 = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getSeconds", dt);
};
var $c18a56c801057a91$export$6ce1b5acc29cb53b = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getMonth", dt);
};
var $c18a56c801057a91$export$b7f1bc3ea3ac4145 = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getMinutes", dt);
};
var $c18a56c801057a91$export$b8e4380f312797af = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getMilliseconds", dt);
};
var $c18a56c801057a91$export$257b40f71c07d58f = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getHours", dt);
};
var $c18a56c801057a91$export$bc715fab9217bc6f = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getFullYear", dt);
};
var $c18a56c801057a91$export$1b64bc9c5306ed54 = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getDay", dt);
};
var $c18a56c801057a91$export$aa350b96d91cd94 = function(dt) {
    return $77a8e76fdca2c8ca$export$c67296b285a74fc3("getDate", dt);
};
var $c18a56c801057a91$export$e141e740b7704cc4 = function(v) {
    return $77a8e76fdca2c8ca$export$353d455c4d01fe57({
        year: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum($7577649a7445e8e0$export$31803937850fb2da(v.value0))),
        month: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum1($7577649a7445e8e0$export$af5de1609f06c8e6(v.value0)) - 1 | 0),
        day: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum2($7577649a7445e8e0$export$d2d39d1adcc883a2(v.value0))),
        hour: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum3($d254595454e6e9b0$export$842e383dfc19bc67(v.value1))),
        minute: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum4($d254595454e6e9b0$export$1cacba1045a8e790(v.value1))),
        second: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum5($d254595454e6e9b0$export$3d3c77ce7df7d30d(v.value1))),
        millisecond: $4ab74a20512cef04$export$a0a81dc3380ce7d3($c18a56c801057a91$var$fromEnum6($d254595454e6e9b0$export$edc5e5cb87280477(v.value1)))
    });
};
var $c18a56c801057a91$export$b8b527d0f49df4c6 = {
    eq: function(a) {
        return function(b) {
            return $c18a56c801057a91$export$1428f42a7de81803(a) === $c18a56c801057a91$export$1428f42a7de81803(b);
        };
    }
};
var $c18a56c801057a91$export$6cd3461f0259f6d7 = {
    compare: function(a) {
        return function(b) {
            return $c18a56c801057a91$var$compare($c18a56c801057a91$export$1428f42a7de81803(a))($c18a56c801057a91$export$1428f42a7de81803(b));
        };
    },
    Eq0: function() {
        return $c18a56c801057a91$export$b8b527d0f49df4c6;
    }
};


// Generated by purs version 0.15.16

var $96d5b5825643fb8c$export$78e1bea9036f120f = /* #__PURE__ */ function() {
    function Trace() {}
    Trace.value = new Trace();
    return Trace;
}();
var $96d5b5825643fb8c$export$153e5dc2c098b35c = /* #__PURE__ */ function() {
    function Debug() {}
    Debug.value = new Debug();
    return Debug;
}();
var $96d5b5825643fb8c$export$c4868e4a24d48fad = /* #__PURE__ */ function() {
    function Info() {}
    Info.value = new Info();
    return Info;
}();
var $96d5b5825643fb8c$export$6c2e13f7f67a7c09 = /* #__PURE__ */ function() {
    function Warn() {}
    Warn.value = new Warn();
    return Warn;
}();
var $96d5b5825643fb8c$export$edf27be85e5f6da0 = /* #__PURE__ */ function() {
    function $$Error() {}
    $$Error.value = new $$Error();
    return $$Error;
}();
var $96d5b5825643fb8c$export$c07cc9aa89c372e7 = {
    eq: function(x) {
        return function(y) {
            if (x instanceof $96d5b5825643fb8c$export$78e1bea9036f120f && y instanceof $96d5b5825643fb8c$export$78e1bea9036f120f) return true;
            if (x instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c && y instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c) return true;
            if (x instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad && y instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad) return true;
            if (x instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09 && y instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09) return true;
            if (x instanceof $96d5b5825643fb8c$export$edf27be85e5f6da0 && y instanceof $96d5b5825643fb8c$export$edf27be85e5f6da0) return true;
            return false;
        };
    }
};
var $96d5b5825643fb8c$export$98d2eedcb1788a81 = {
    compare: function(x) {
        return function(y) {
            if (x instanceof $96d5b5825643fb8c$export$78e1bea9036f120f && y instanceof $96d5b5825643fb8c$export$78e1bea9036f120f) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $96d5b5825643fb8c$export$78e1bea9036f120f) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $96d5b5825643fb8c$export$78e1bea9036f120f) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c && y instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad && y instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09 && y instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            if (x instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09) return $5026be88823ef1f4$export$7158f0ceb70f54c7.value;
            if (y instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09) return $5026be88823ef1f4$export$b023c82b48e70453.value;
            if (x instanceof $96d5b5825643fb8c$export$edf27be85e5f6da0 && y instanceof $96d5b5825643fb8c$export$edf27be85e5f6da0) return $5026be88823ef1f4$export$1c0a5d05eb3f6e18.value;
            throw new Error("Failed pattern match at Data.Log.Level (line 0, column 0 - line 0, column 0): " + [
                x.constructor.name,
                y.constructor.name
            ]);
        };
    },
    Eq0: function() {
        return $96d5b5825643fb8c$export$c07cc9aa89c372e7;
    }
};




var $5565aadcfa1492e1$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $5565aadcfa1492e1$var$lift1 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $5565aadcfa1492e1$var$lift2 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $5565aadcfa1492e1$var$lift3 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $5565aadcfa1492e1$var$lift4 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $5565aadcfa1492e1$var$lift5 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $5565aadcfa1492e1$export$bef1f36f5486a6a3 = function(dict) {
    return dict.log;
};
var $5565aadcfa1492e1$var$log$prime = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var bind = $70cd3177464e7915$export$2385a24977818dd0(MonadEffect0.Monad0().Bind1());
    var liftEffect = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(MonadEffect0);
    var log1 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
    return function(level) {
        return function(tags) {
            return function(message) {
                return bind(liftEffect($77a8e76fdca2c8ca$export$461939dd4422153))(function($92) {
                    return log1(function(v) {
                        return {
                            level: level,
                            message: message,
                            tags: tags,
                            timestamp: v
                        };
                    }($92));
                });
            };
        };
    };
};
var $5565aadcfa1492e1$export$357889f174732d38 = function(dictMonadLogger) {
    return $5565aadcfa1492e1$var$log$prime(dictMonadLogger)($96d5b5825643fb8c$export$78e1bea9036f120f.value);
};
var $5565aadcfa1492e1$var$trace$prime = function(dictMonadLogger) {
    return $5565aadcfa1492e1$export$357889f174732d38(dictMonadLogger)($ea3eb84de0acf574$export$6e22c362a0406a2c);
};
var $5565aadcfa1492e1$export$c106dd0671a0fc2d = function(dictMonadLogger) {
    return $5565aadcfa1492e1$var$log$prime(dictMonadLogger)($96d5b5825643fb8c$export$6c2e13f7f67a7c09.value);
};
var $5565aadcfa1492e1$var$warn$prime = function(dictMonadLogger) {
    return $5565aadcfa1492e1$export$c106dd0671a0fc2d(dictMonadLogger)($ea3eb84de0acf574$export$6e22c362a0406a2c);
};
var $5565aadcfa1492e1$export$28bc1fed8bd65c5f = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectContT = $fca560e14229da4e$export$35d988300b9091c9(MonadEffect0);
    return {
        log: function() {
            var $93 = $5565aadcfa1492e1$var$lift(MonadEffect0.Monad0());
            var $94 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($95) {
                return $93($94($95));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $5565aadcfa1492e1$export$8600158331a04d77 = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectExceptT = $d2284b2d3e1b6f87$export$14ff7e4e497a86b1(MonadEffect0);
    return {
        log: function() {
            var $96 = $5565aadcfa1492e1$var$lift1(MonadEffect0.Monad0());
            var $97 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($98) {
                return $96($97($98));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $5565aadcfa1492e1$export$6dc8e98bbcc3f7af = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectListT = $d30ea600cb89759b$export$f00d8368ae31463f(MonadEffect0);
    return {
        log: function() {
            var $99 = $5565aadcfa1492e1$var$lift2(MonadEffect0.Monad0());
            var $100 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($101) {
                return $99($100($101));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $5565aadcfa1492e1$export$a5f0d30b4e3405fd = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectMaybe = $7038ccc2f7f5bbce$export$2f876a9cb1e407d9(MonadEffect0);
    return {
        log: function() {
            var $102 = $5565aadcfa1492e1$var$lift3(MonadEffect0.Monad0());
            var $103 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($104) {
                return $102($103($104));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $5565aadcfa1492e1$export$dc67c97c79dde322 = function(dictMonoid) {
    var lift6 = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid));
    var monadEffectRWS = $712b2df71ce372f8$export$1947b5c08efdf68f(dictMonoid);
    return function(dictMonadLogger) {
        var MonadEffect0 = dictMonadLogger.MonadEffect0();
        var monadEffectRWS1 = monadEffectRWS(MonadEffect0);
        return {
            log: function() {
                var $105 = lift6(MonadEffect0.Monad0());
                var $106 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
                return function($107) {
                    return $105($106($107));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS1;
            }
        };
    };
};
var $5565aadcfa1492e1$export$4833e35a519eb542 = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectReader = $848780da1bf26d9d$export$a554ebf369a3f56d(MonadEffect0);
    return {
        log: function() {
            var $108 = $5565aadcfa1492e1$var$lift4(MonadEffect0.Monad0());
            var $109 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($110) {
                return $108($109($110));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $5565aadcfa1492e1$export$119e1893729bea0d = function(dictMonadLogger) {
    var MonadEffect0 = dictMonadLogger.MonadEffect0();
    var monadEffectState = $e9bda291f4ec10ec$export$cba9856135198781(MonadEffect0);
    return {
        log: function() {
            var $111 = $5565aadcfa1492e1$var$lift5(MonadEffect0.Monad0());
            var $112 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
            return function($113) {
                return $111($112($113));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $5565aadcfa1492e1$export$22582243da22d339 = function(dictMonoid) {
    var lift6 = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid));
    var monadEffectWriter = $d9ef009191ddae40$export$29fece65832b4369(dictMonoid);
    return function(dictMonadLogger) {
        var MonadEffect0 = dictMonadLogger.MonadEffect0();
        var monadEffectWriter1 = monadEffectWriter(MonadEffect0);
        return {
            log: function() {
                var $114 = lift6(MonadEffect0.Monad0());
                var $115 = $5565aadcfa1492e1$export$bef1f36f5486a6a3(dictMonadLogger);
                return function($116) {
                    return $114($115($116));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter1;
            }
        };
    };
};
var $5565aadcfa1492e1$export$a80b3bd66acc52ff = function(dictMonadLogger) {
    return $5565aadcfa1492e1$var$log$prime(dictMonadLogger)($96d5b5825643fb8c$export$c4868e4a24d48fad.value);
};
var $5565aadcfa1492e1$var$info$prime = function(dictMonadLogger) {
    return $5565aadcfa1492e1$export$a80b3bd66acc52ff(dictMonadLogger)($ea3eb84de0acf574$export$6e22c362a0406a2c);
};
var $5565aadcfa1492e1$export$a3bc9b8ed74fc = function(dictMonadLogger) {
    return $5565aadcfa1492e1$var$log$prime(dictMonadLogger)($96d5b5825643fb8c$export$edf27be85e5f6da0.value);
};
var $5565aadcfa1492e1$var$error$prime = function(dictMonadLogger) {
    return $5565aadcfa1492e1$export$a3bc9b8ed74fc(dictMonadLogger)($ea3eb84de0acf574$export$6e22c362a0406a2c);
};
var $5565aadcfa1492e1$export$1c9f709888824e05 = function(dictMonadLogger) {
    return $5565aadcfa1492e1$var$log$prime(dictMonadLogger)($96d5b5825643fb8c$export$153e5dc2c098b35c.value);
};
var $5565aadcfa1492e1$var$debug$prime = function(dictMonadLogger) {
    return $5565aadcfa1492e1$export$1c9f709888824e05(dictMonadLogger)($ea3eb84de0acf574$export$6e22c362a0406a2c);
};


// Generated by purs version 0.15.16












// Generated by purs version 0.15.16











var $b6d6cce78665f23d$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($fca560e14229da4e$export$6a2bb59a0c53ce17);
var $b6d6cce78665f23d$var$lift1 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d2284b2d3e1b6f87$export$fa93accd6d6dc1d2);
var $b6d6cce78665f23d$var$lift2 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($d30ea600cb89759b$export$619131e858bec5bb);
var $b6d6cce78665f23d$var$lift3 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($7038ccc2f7f5bbce$export$84eda9cb75492c36);
var $b6d6cce78665f23d$var$lift4 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($848780da1bf26d9d$export$95510d0cd7e6e7eb);
var $b6d6cce78665f23d$var$lift5 = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($e9bda291f4ec10ec$export$5e0a9e9fea50cb88);
var $b6d6cce78665f23d$export$bd75e69808ef8e57 = {
    liftAff: /* #__PURE__ */ $5be483788e0e6f04$export$f0954fd7d5368655($5be483788e0e6f04$export$7037e3b2ba3bd7aa),
    MonadEffect0: function() {
        return $edf0339512807bee$export$666a030cecdf96c;
    }
};
var $b6d6cce78665f23d$export$37f61af225938e0f = function(dict) {
    return dict.liftAff;
};
var $b6d6cce78665f23d$export$53acd6df2cbe3344 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectContT = $fca560e14229da4e$export$35d988300b9091c9(MonadEffect0);
    return {
        liftAff: function() {
            var $65 = $b6d6cce78665f23d$var$lift(MonadEffect0.Monad0());
            var $66 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($67) {
                return $65($66($67));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectContT;
        }
    };
};
var $b6d6cce78665f23d$export$87a4e9dc50af0c41 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectExceptT = $d2284b2d3e1b6f87$export$14ff7e4e497a86b1(MonadEffect0);
    return {
        liftAff: function() {
            var $68 = $b6d6cce78665f23d$var$lift1(MonadEffect0.Monad0());
            var $69 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($70) {
                return $68($69($70));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectExceptT;
        }
    };
};
var $b6d6cce78665f23d$export$72b48760d563ad73 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectListT = $d30ea600cb89759b$export$f00d8368ae31463f(MonadEffect0);
    return {
        liftAff: function() {
            var $71 = $b6d6cce78665f23d$var$lift2(MonadEffect0.Monad0());
            var $72 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($73) {
                return $71($72($73));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectListT;
        }
    };
};
var $b6d6cce78665f23d$export$7091efe953cca892 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectMaybe = $7038ccc2f7f5bbce$export$2f876a9cb1e407d9(MonadEffect0);
    return {
        liftAff: function() {
            var $74 = $b6d6cce78665f23d$var$lift3(MonadEffect0.Monad0());
            var $75 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($76) {
                return $74($75($76));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectMaybe;
        }
    };
};
var $b6d6cce78665f23d$export$5fd9f999a5266faf = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectRWS = $712b2df71ce372f8$export$1947b5c08efdf68f(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $77 = $384c24655e07f36c$export$590e8b2c435046d9($712b2df71ce372f8$export$1d2bc64ff0e647b4(dictMonoid))(Monad0);
                return function($78) {
                    return $77(liftAff1($78));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectRWS;
            }
        };
    };
};
var $b6d6cce78665f23d$export$fa61c33f24d5bab = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectReader = $848780da1bf26d9d$export$a554ebf369a3f56d(MonadEffect0);
    return {
        liftAff: function() {
            var $79 = $b6d6cce78665f23d$var$lift4(MonadEffect0.Monad0());
            var $80 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($81) {
                return $79($80($81));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectReader;
        }
    };
};
var $b6d6cce78665f23d$export$1c14dadc45d4bfb9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectState = $e9bda291f4ec10ec$export$cba9856135198781(MonadEffect0);
    return {
        liftAff: function() {
            var $82 = $b6d6cce78665f23d$var$lift5(MonadEffect0.Monad0());
            var $83 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($84) {
                return $82($83($84));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectState;
        }
    };
};
var $b6d6cce78665f23d$export$7ad7619eecdb33a9 = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var Monad0 = MonadEffect0.Monad0();
    var liftAff1 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
    return function(dictMonoid) {
        var monadEffectWriter = $d9ef009191ddae40$export$29fece65832b4369(dictMonoid)(MonadEffect0);
        return {
            liftAff: function() {
                var $85 = $384c24655e07f36c$export$590e8b2c435046d9($d9ef009191ddae40$export$6b749a3db2c2aac6(dictMonoid))(Monad0);
                return function($86) {
                    return $85(liftAff1($86));
                };
            }(),
            MonadEffect0: function() {
                return monadEffectWriter;
            }
        };
    };
};



var $6a740352e35fd4e6$var$unwrap = /* #__PURE__ */ $4fa4836228a192cc$export$debb760848ca95a();
var $6a740352e35fd4e6$export$21dd0a9e8a99b009 = function(x) {
    return x;
};
var $6a740352e35fd4e6$var$withLoggerT = function(f) {
    return function(v) {
        return function($76) {
            return v(f($76));
        };
    };
};
var $6a740352e35fd4e6$export$8d9649635fd52268 = function(v) {
    return v;
};
var $6a740352e35fd4e6$export$4082e804ac22341e = {
    Coercible0: function() {
        return undefined;
    }
};
var $6a740352e35fd4e6$export$81df57e4e4b49fb1 = {
    lift: function(dictMonad) {
        return function($77) {
            return $6a740352e35fd4e6$export$21dd0a9e8a99b009($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($77));
        };
    }
};
var $6a740352e35fd4e6$var$lift = /* #__PURE__ */ $384c24655e07f36c$export$590e8b2c435046d9($6a740352e35fd4e6$export$81df57e4e4b49fb1);
var $6a740352e35fd4e6$export$db9cb39a96996684 = function(f) {
    return function(v) {
        return function($78) {
            return f(v($78));
        };
    };
};
var $6a740352e35fd4e6$export$5532edb1e193bce6 = function(dictFunctor) {
    return {
        map: function() {
            var $79 = $f4b2eb11fc32ed34$export$871de8747c9eaa88(dictFunctor);
            return function($80) {
                return $6a740352e35fd4e6$export$db9cb39a96996684($79($80));
            };
        }()
    };
};
var $6a740352e35fd4e6$export$d730281a9ce98432 = function(dictMonad) {
    return {
        Applicative0: function() {
            return $6a740352e35fd4e6$export$5710060667c57a00(dictMonad);
        },
        Bind1: function() {
            return $6a740352e35fd4e6$export$d4628c2c29a7a3d(dictMonad);
        }
    };
};
var $6a740352e35fd4e6$export$d4628c2c29a7a3d = function(dictMonad) {
    var bind = $70cd3177464e7915$export$2385a24977818dd0(dictMonad.Bind1());
    return {
        bind: function(v) {
            return function(f) {
                return function(l) {
                    return bind(v(l))(function($81) {
                        return function(v1) {
                            return v1(l);
                        }($6a740352e35fd4e6$var$unwrap(f($81)));
                    });
                };
            };
        },
        Apply0: function() {
            return $6a740352e35fd4e6$export$949a9fe2d5ffc728(dictMonad);
        }
    };
};
var $6a740352e35fd4e6$export$949a9fe2d5ffc728 = function(dictMonad) {
    var functorLoggerT1 = $6a740352e35fd4e6$export$5532edb1e193bce6(dictMonad.Bind1().Apply0().Functor0());
    return {
        apply: $d3d065da31679be1$export$2f6ca3d3b1f80bf5($6a740352e35fd4e6$export$d730281a9ce98432(dictMonad)),
        Functor0: function() {
            return functorLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$5710060667c57a00 = function(dictMonad) {
    return {
        pure: function() {
            var $82 = $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557(dictMonad.Applicative0());
            return function($83) {
                return $6a740352e35fd4e6$export$21dd0a9e8a99b009($f57f4b701aa7b66e$export$5b38a098e5a9e7ca($82($83)));
            };
        }(),
        Apply0: function() {
            return $6a740352e35fd4e6$export$949a9fe2d5ffc728(dictMonad);
        }
    };
};
var $6a740352e35fd4e6$export$81c5ed52c35631b3 = function(dictMonadAsk) {
    var Monad0 = dictMonadAsk.Monad0();
    var monadLoggerT1 = $6a740352e35fd4e6$export$d730281a9ce98432(Monad0);
    return {
        ask: $6a740352e35fd4e6$var$lift(Monad0)($74738728c27df511$export$1b4aee0b51c3def8(dictMonadAsk)),
        Monad0: function() {
            return monadLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$8f9456ce9f4db0f5 = function(dictMonadReader) {
    var monadAskLoggerT1 = $6a740352e35fd4e6$export$81c5ed52c35631b3(dictMonadReader.MonadAsk0());
    return {
        local: function() {
            var $84 = $74738728c27df511$export$3bf5078b16209b91(dictMonadReader);
            return function($85) {
                return $6a740352e35fd4e6$export$db9cb39a96996684($84($85));
            };
        }(),
        MonadAsk0: function() {
            return monadAskLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$87341d0b6e77a89e = function(dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var monadLoggerT1 = $6a740352e35fd4e6$export$d730281a9ce98432(Monad0);
    return {
        liftEffect: function() {
            var $86 = $6a740352e35fd4e6$var$lift(Monad0);
            var $87 = $f2c9b767d25cfbb9$export$34255e15eb56d2b3(dictMonadEffect);
            return function($88) {
                return $86($87($88));
            };
        }(),
        Monad0: function() {
            return monadLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$db4c685df93ae4bc = function(dictMonadAff) {
    var MonadEffect0 = dictMonadAff.MonadEffect0();
    var monadEffectLoggerT1 = $6a740352e35fd4e6$export$87341d0b6e77a89e(MonadEffect0);
    return {
        liftAff: function() {
            var $89 = $6a740352e35fd4e6$var$lift(MonadEffect0.Monad0());
            var $90 = $b6d6cce78665f23d$export$37f61af225938e0f(dictMonadAff);
            return function($91) {
                return $89($90($91));
            };
        }(),
        MonadEffect0: function() {
            return monadEffectLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$c66b7337f5276bfb = function(dictMonadEffect) {
    var monadEffectLoggerT1 = $6a740352e35fd4e6$export$87341d0b6e77a89e(dictMonadEffect);
    return {
        log: function(message) {
            return function(v) {
                return v(message);
            };
        },
        MonadEffect0: function() {
            return monadEffectLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$38f75b56f2ce6c5d = function(dictMonadRec) {
    var tailRecM = $f93520de2fa37b44$export$c025cfd4cc93300b(dictMonadRec);
    var monadLoggerT1 = $6a740352e35fd4e6$export$d730281a9ce98432(dictMonadRec.Monad0());
    return {
        tailRecM: function(step) {
            return function(a) {
                return function(l) {
                    return tailRecM(function(a$prime) {
                        return $6a740352e35fd4e6$var$unwrap(step(a$prime))(l);
                    })(a);
                };
            };
        },
        Monad0: function() {
            return monadLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$5decdf81e8276f36 = function(dictMonadState) {
    var Monad0 = dictMonadState.Monad0();
    var monadLoggerT1 = $6a740352e35fd4e6$export$d730281a9ce98432(Monad0);
    return {
        state: function() {
            var $92 = $6a740352e35fd4e6$var$lift(Monad0);
            var $93 = $f2d5035ce6148af6$export$ca000e230c0caa3e(dictMonadState);
            return function($94) {
                return $92($93($94));
            };
        }(),
        Monad0: function() {
            return monadLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$9ad9475e50ac0dc0 = function(dictMonadThrow) {
    var Monad0 = dictMonadThrow.Monad0();
    var monadLoggerT1 = $6a740352e35fd4e6$export$d730281a9ce98432(Monad0);
    return {
        throwError: function() {
            var $95 = $6a740352e35fd4e6$var$lift(Monad0);
            var $96 = $5dfefa023749ded0$export$8bf7aba4a9e09055(dictMonadThrow);
            return function($97) {
                return $95($96($97));
            };
        }(),
        Monad0: function() {
            return monadLoggerT1;
        }
    };
};
var $6a740352e35fd4e6$export$cd32d6170df5cc49 = function(dictMonadError) {
    var catchError = $5dfefa023749ded0$export$3dede90624df3ba9(dictMonadError);
    var monadThrowLoggerT1 = $6a740352e35fd4e6$export$9ad9475e50ac0dc0(dictMonadError.MonadThrow0());
    return {
        catchError: function(v) {
            return function(h) {
                return function(l) {
                    return catchError(v(l))(function($98) {
                        return function(v1) {
                            return v1(l);
                        }($6a740352e35fd4e6$var$unwrap(h($98)));
                    });
                };
            };
        },
        MonadThrow0: function() {
            return monadThrowLoggerT1;
        }
    };
};


// Generated by purs version 0.15.16






// Generated by purs version 0.15.16

// Generated by purs version 0.15.16




var $219a0fb476f33a30$export$6f6f12e098819a11 = function(x) {
    return x;
};
var $219a0fb476f33a30$export$3c5e6b006a1d848e = $ea3eb84de0acf574$export$8999febf5cd85b5c;
var $219a0fb476f33a30$export$4e81f95457a4f9c5 = $ea3eb84de0acf574$export$78146089411e393d;
var $219a0fb476f33a30$export$f5ad5bc4482e056b = function(dictShow) {
    var showMap = $ea3eb84de0acf574$export$c448526daa762015(dictShow);
    return function(dictShow1) {
        return showMap(dictShow1);
    };
};
var $219a0fb476f33a30$export$c5313cc0fc33667c = function(dictOrd) {
    var unionWith = $ea3eb84de0acf574$export$ed1b4f34a0e8b0cc(dictOrd);
    return function(dictSemigroup) {
        var append = $d7bf9817a417d4ae$export$10d8903dec122b9d(dictSemigroup);
        return {
            append: function(v) {
                return function(v1) {
                    return unionWith(append)(v)(v1);
                };
            }
        };
    };
};
var $219a0fb476f33a30$export$38a252bff8e0b233 = function(dictOrd) {
    return $ea3eb84de0acf574$export$4c085c510196daa3(dictOrd);
};
var $219a0fb476f33a30$export$4d301b1aaca6e5ee = function(dictOrd) {
    var ordMap = $ea3eb84de0acf574$export$3d0d4caf881d6855(dictOrd);
    return function(dictOrd1) {
        return ordMap(dictOrd1);
    };
};
var $219a0fb476f33a30$export$3a647d35f27c2c21 = function(dictOrd) {
    return $ea3eb84de0acf574$export$e2f3c1862bab1bff(dictOrd);
};
var $219a0fb476f33a30$export$4eb746bad571b4ba = {
    Coercible0: function() {
        return undefined;
    }
};
var $219a0fb476f33a30$export$546d2468bc9efbc6 = function(dictOrd) {
    var semigroupSemigroupMap1 = $219a0fb476f33a30$export$c5313cc0fc33667c(dictOrd);
    return function(dictSemigroup) {
        var semigroupSemigroupMap2 = semigroupSemigroupMap1(dictSemigroup);
        return {
            mempty: $ea3eb84de0acf574$export$6e22c362a0406a2c,
            Semigroup0: function() {
                return semigroupSemigroupMap2;
            }
        };
    };
};
var $219a0fb476f33a30$export$ed97f33186d4b816 = /* #__PURE__ */ function() {
    var $38 = $f4b2eb11fc32ed34$export$490e536ee7389aeb($ea3eb84de0acf574$export$3930f636962ed944);
    return function($39) {
        return $a393155e52307a24$export$d81aa96f14f987cc($38($39));
    };
}();
var $219a0fb476f33a30$export$1096fce6f8157f49 = $ea3eb84de0acf574$export$d7c684e0b3e84e77;
var $219a0fb476f33a30$export$96367dab66c5c370 = $ea3eb84de0acf574$export$3930f636962ed944;
var $219a0fb476f33a30$export$239aaad87589a3f0 = $ea3eb84de0acf574$export$91e1c50dfb7225a6;
var $219a0fb476f33a30$export$732ac04c4dce73f6 = $ea3eb84de0acf574$export$4295a0c2ad7aa544;
var $219a0fb476f33a30$export$884432d781bab8d3 = function(dictEq) {
    var eqMap = $ea3eb84de0acf574$export$85aac4508ff70b8(dictEq);
    return function(dictEq1) {
        return eqMap(dictEq1);
    };
};
var $219a0fb476f33a30$export$64a7582da2ca8e9c = function(dictEq) {
    return $ea3eb84de0acf574$export$e321b34a2787dc8d(dictEq);
};
var $219a0fb476f33a30$export$e9f090025f05634f = function(dictOrd) {
    return $ea3eb84de0acf574$export$886591aa0ffe34d5(dictOrd);
};
var $219a0fb476f33a30$export$bb3d8f5a7f1d9f6a = function(dictOrd) {
    return $ea3eb84de0acf574$export$8952a3dc6f3cd264(dictOrd);
};
var $219a0fb476f33a30$export$fb15286a85c58e76 = function(dictOrd) {
    return $ea3eb84de0acf574$export$9030392ec4d635ff(dictOrd);
};




var $8cbf9b862f2aa7a3$export$2dd0a9ffc85da4a8 = /* #__PURE__ */ function() {
    function StringTag(value0) {
        this.value0 = value0;
    }
    StringTag.create = function(value0) {
        return new StringTag(value0);
    };
    return StringTag;
}();
var $8cbf9b862f2aa7a3$export$ded699a4a0f38850 = /* #__PURE__ */ function() {
    function NumberTag(value0) {
        this.value0 = value0;
    }
    NumberTag.create = function(value0) {
        return new NumberTag(value0);
    };
    return NumberTag;
}();
var $8cbf9b862f2aa7a3$export$7edf6684da798574 = /* #__PURE__ */ function() {
    function IntTag(value0) {
        this.value0 = value0;
    }
    IntTag.create = function(value0) {
        return new IntTag(value0);
    };
    return IntTag;
}();
var $8cbf9b862f2aa7a3$export$51df868abe1e733c = /* #__PURE__ */ function() {
    function BooleanTag(value0) {
        this.value0 = value0;
    }
    BooleanTag.create = function(value0) {
        return new BooleanTag(value0);
    };
    return BooleanTag;
}();
var $8cbf9b862f2aa7a3$export$e5d45c6647e532aa = /* #__PURE__ */ function() {
    function JSDateTag(value0) {
        this.value0 = value0;
    }
    JSDateTag.create = function(value0) {
        return new JSDateTag(value0);
    };
    return JSDateTag;
}();
var $8cbf9b862f2aa7a3$export$f92da219c52a9009 = /* #__PURE__ */ function() {
    function TagSetTag(value0) {
        this.value0 = value0;
    }
    TagSetTag.create = function(value0) {
        return new TagSetTag(value0);
    };
    return TagSetTag;
}();
var $8cbf9b862f2aa7a3$var$mkTagType = function(tagger) {
    return function(name) {
        var $3 = $ea3eb84de0acf574$export$439306a4dcaafbb9(name);
        return function($4) {
            return $3(tagger($4));
        };
    };
};
var $8cbf9b862f2aa7a3$export$bf8ee812b24655d4 = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$ded699a4a0f38850.create);
}();
var $8cbf9b862f2aa7a3$export$2b067c6666111485 = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$2dd0a9ffc85da4a8.create);
}();
var $8cbf9b862f2aa7a3$export$76052b1137c1eb1b = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$f92da219c52a9009.create);
}();
var $8cbf9b862f2aa7a3$export$18c7054ced4297cc = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$e5d45c6647e532aa.create);
}();
var $8cbf9b862f2aa7a3$export$a2d64743e2cbb0d2 = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$7edf6684da798574.create);
}();
var $8cbf9b862f2aa7a3$export$571d59b505e6bb4e = /* #__PURE__ */ $ea3eb84de0acf574$export$30b2db2f7030f6cf($97937c29f879e68e$export$c5f2758e49b2b86a)($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $8cbf9b862f2aa7a3$export$9edaefd43909686f = /* #__PURE__ */ function() {
    return $8cbf9b862f2aa7a3$var$mkTagType($8cbf9b862f2aa7a3$export$51df868abe1e733c.create);
}();





var $123182cde239b632$var$fromFoldable = /* #__PURE__ */ $c045ea5df33bba60$export$b7d5d9bb9ff52072($4fe7b6acfba7f29f$export$e97014618a7eb593);
var $123182cde239b632$var$toUnfoldable = /* #__PURE__ */ $ea3eb84de0acf574$export$823be24f8766da23($cb5fedc2c4837e1c$export$2b90ca20b4b58da5);
var $123182cde239b632$var$map = /* #__PURE__ */ $f4b2eb11fc32ed34$export$871de8747c9eaa88($ea3eb84de0acf574$export$3930f636962ed944);
var $123182cde239b632$var$levelCode = function(v) {
    if (v instanceof $96d5b5825643fb8c$export$78e1bea9036f120f) return 0;
    if (v instanceof $96d5b5825643fb8c$export$153e5dc2c098b35c) return 1;
    if (v instanceof $96d5b5825643fb8c$export$c4868e4a24d48fad) return 2;
    if (v instanceof $96d5b5825643fb8c$export$6c2e13f7f67a7c09) return 3;
    if (v instanceof $96d5b5825643fb8c$export$edf27be85e5f6da0) return 4;
    throw new Error("Failed pattern match at Data.Log.Formatter.JSON (line 58, column 1 - line 58, column 29): " + [
        v.constructor.name
    ]);
};
var $123182cde239b632$var$toJson = function(set) {
    return $0e031af7428ef07d$export$dbafa4424a806c15($123182cde239b632$var$fromFoldable($123182cde239b632$var$jsonify(set)));
};
var $123182cde239b632$var$jsonify = function(set) {
    return $123182cde239b632$var$toUnfoldable($123182cde239b632$var$map($123182cde239b632$var$fieldToJson)(set));
};
var $123182cde239b632$var$fieldToJson = function(v) {
    if (v instanceof $8cbf9b862f2aa7a3$export$2dd0a9ffc85da4a8) return $0e031af7428ef07d$export$dbafa4424a806c15(v.value0);
    if (v instanceof $8cbf9b862f2aa7a3$export$7edf6684da798574) return $0e031af7428ef07d$export$dbafa4424a806c15($4ab74a20512cef04$export$a0a81dc3380ce7d3(v.value0));
    if (v instanceof $8cbf9b862f2aa7a3$export$ded699a4a0f38850) return $0e031af7428ef07d$export$dbafa4424a806c15(v.value0);
    if (v instanceof $8cbf9b862f2aa7a3$export$51df868abe1e733c) return $0e031af7428ef07d$export$dbafa4424a806c15(v.value0);
    if (v instanceof $8cbf9b862f2aa7a3$export$e5d45c6647e532aa) return $0e031af7428ef07d$export$dbafa4424a806c15($c18a56c801057a91$export$1428f42a7de81803(v.value0));
    if (v instanceof $8cbf9b862f2aa7a3$export$f92da219c52a9009) return $123182cde239b632$var$toJson(v.value0);
    throw new Error("Failed pattern match at Data.Log.Formatter.JSON (line 50, column 1 - line 50, column 27): " + [
        v.constructor.name
    ]);
};
var $123182cde239b632$var$buildPayload = function(v) {
    return $8cbf9b862f2aa7a3$export$571d59b505e6bb4e([
        $8cbf9b862f2aa7a3$export$a2d64743e2cbb0d2("level")($123182cde239b632$var$levelCode(v.level)),
        $8cbf9b862f2aa7a3$export$18c7054ced4297cc("ts")(v.timestamp),
        $8cbf9b862f2aa7a3$export$2b067c6666111485("message")(v.message),
        function() {
            var $16 = $ea3eb84de0acf574$export$dd1bc94b04021eeb(v.tags);
            if ($16) return $ea3eb84de0acf574$export$6e22c362a0406a2c;
            return $8cbf9b862f2aa7a3$export$76052b1137c1eb1b("tags")(v.tags);
        }()
    ]);
};
var $123182cde239b632$export$52477cd5b1f76df4 = function($21) {
    return $0e031af7428ef07d$export$fac44ee5b035f737($123182cde239b632$var$toJson($123182cde239b632$var$buildPayload($21)));
};









var $0c07a74dd7e350c8$var$discard = /* #__PURE__ */ $70cd3177464e7915$export$584af591d945b55a($70cd3177464e7915$export$f73711e565ded7e);
var $0c07a74dd7e350c8$var$discard2 = /* #__PURE__ */ $0c07a74dd7e350c8$var$discard(/* #__PURE__ */ $6a740352e35fd4e6$export$d4628c2c29a7a3d($6c2f8951ecf9531e$export$7e900d895707a1af));
var $0c07a74dd7e350c8$var$debug = /* #__PURE__ */ $5565aadcfa1492e1$export$1c9f709888824e05(/* #__PURE__ */ $6a740352e35fd4e6$export$c66b7337f5276bfb($f2c9b767d25cfbb9$export$86a2e24932ca2aa0));
var $0c07a74dd7e350c8$var$composeKleisliFlipped = /* #__PURE__ */ $70cd3177464e7915$export$ea9fbbe247ef8e50($6c2f8951ecf9531e$export$855330f8a2a9f2e8);
var $0c07a74dd7e350c8$var$pure = /* #__PURE__ */ $c50cfdb0b9e8fa31$export$48ec4a2b1cfc6557($6c2f8951ecf9531e$export$89bf999217d3022a);
var $0c07a74dd7e350c8$var$liftEffect = /* #__PURE__ */ $f2c9b767d25cfbb9$export$34255e15eb56d2b3($f2c9b767d25cfbb9$export$86a2e24932ca2aa0);
var $0c07a74dd7e350c8$export$f22da7240b7add18 = function __do() {
    $93c729927fdf3160$export$bef1f36f5486a6a3("Application Started")();
    var envLogger = $0c07a74dd7e350c8$var$discard2($0c07a74dd7e350c8$var$debug($ea3eb84de0acf574$export$6e22c362a0406a2c)("GraphQL endpoint: " + $b8b5a8fce67f6baf$export$afd40dda5f2bcea1))(function() {
        return $0c07a74dd7e350c8$var$discard2($0c07a74dd7e350c8$var$debug($ea3eb84de0acf574$export$6e22c362a0406a2c)("Sentry is " + function() {
            if ($fecd5c800d519006$export$13633b34445fbb34) return "enabled.";
            return "disabled.";
        }()))(function() {
            return $0c07a74dd7e350c8$var$debug($ea3eb84de0acf574$export$6e22c362a0406a2c)("Url prefix is '" + ($daa993e9fe4182d9$export$25ab18eae308f101 + "'"));
        });
    });
    $6a740352e35fd4e6$export$8d9649635fd52268(envLogger)($0c07a74dd7e350c8$var$composeKleisliFlipped($93c729927fdf3160$export$bef1f36f5486a6a3)(function($14) {
        return $0c07a74dd7e350c8$var$pure($123182cde239b632$export$52477cd5b1f76df4($14));
    }))();
    $0c07a74dd7e350c8$var$liftEffect(function() {
        if ($fecd5c800d519006$export$13633b34445fbb34) return $fecd5c800d519006$export$f5ae3c4820871661;
        return $0c07a74dd7e350c8$var$pure($05149ea687d6b460$export$523c0b569236b342);
    }())();
    return $2e240a40d1eec051$export$c928ab20a18b7fa6("forms-spa")($c13f96732740c363$export$82ba02fb2c129065)();
};


// Taken from https://github.com/purescript/spago#get-started-from-scratch-with-parcel-frontend-projects
function $a36ab0995a7faa81$var$main() {
    console.log('Welcome to PureScript');
    $0c07a74dd7e350c8$export$f22da7240b7add18();
}
// HMR setup. For more info see: https://parceljs.org/hmr.html
if (null) null.accept(function() {
    console.log('Reloaded, running main again');
    $a36ab0995a7faa81$var$main();
});
$a36ab0995a7faa81$var$main();


//# sourceMappingURL=static.f51f46b7.js.map
